import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { fetcher } from '../graphql/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string | Date; output: string; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: object; output: object; }
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: { input: string; output: string; }
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: { input: number; output: number; }
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: { input: string | Date; output: string; }
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: { input: number; output: number; }
  /** The `ID` scalar type represents a unique MongoDB identifier in collection. MongoDB by default use 12-byte ObjectId value (https://docs.mongodb.com/manual/reference/bson-types/#objectid). But MongoDB also may accepts string or integer as correct values for _id field. */
  MongoID: { input: any; output: any; }
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: { input: number; output: number; }
  /** Integers that will have a value of 0 or less. */
  NonPositiveInt: { input: number; output: number; }
  /** Integers that will have a value greater than 0. */
  PositiveInt: { input: number; output: number; }
  /** The string representation of JavaScript regexp. You may provide it with flags "/^abc.*\/i" or without flags like "^abc.*". More info about RegExp characters and flags: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions */
  RegExpAsString: { input: string; output: string; }
  /** A field whose value is a Semantic Version: https://semver.org */
  SemVer: { input: `${number}.${number}.${number}`; output: `${number}.${number}.${number}`; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: string; output: string; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: string; output: string; }
  /** Represents NULL values */
  Void: { input: void; output: void; }
};

export type Acceleration = {
  /** ft/s² */
  feetPerSecondSquared: Scalars['Float']['output'];
  /** g */
  gForce: Scalars['Float']['output'];
  metresPerSecondSquared: Scalars['Float']['output'];
};

export type AccelerationInput = {
  /** ft/s² */
  feetPerSecondSquared?: InputMaybe<Scalars['Float']['input']>;
  /** g */
  gForce?: InputMaybe<Scalars['Float']['input']>;
  metresPerSecondSquared?: InputMaybe<Scalars['Float']['input']>;
};

export type AccelerationUnitField = {
  unit: EnumAccelerationUnit;
};

export type ActivateCarDataServiceConfigResult = {
  success: Scalars['Boolean']['output'];
};

export type ActiveConfig = {
  /** Message to display in the client */
  clientMessage?: Maybe<Array<Maybe<ActiveConfigClientMessage>>>;
  /** Declared session of the timing service configuration. */
  declaredSession?: Maybe<Scalars['String']['output']>;
  /** Last message received from the timing service. */
  lastMessage?: Maybe<Scalars['Date']['output']>;
  sessionMatch?: Maybe<Session>;
  /** ID of the session match. */
  sessionMatchID?: Maybe<Scalars['MongoID']['output']>;
  /** Information about the session match. */
  sessionMatchInfo?: Maybe<Scalars['String']['output']>;
  timingServiceConfig?: Maybe<TimingServiceConfig>;
  /** ID of the timing service configuration. */
  timingServiceConfigID: Scalars['MongoID']['output'];
};

export type ActiveConfigClientMessage = {
  /** HEX color for the message */
  color?: Maybe<Scalars['String']['output']>;
  /** Message to display in the client */
  text?: Maybe<Scalars['String']['output']>;
};

export type ActiveConfigClientMessageInput = {
  /** HEX color for the message */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Message to display in the client */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ActiveConfigInput = {
  /** Message to display in the client */
  clientMessage?: InputMaybe<Array<InputMaybe<ActiveConfigClientMessageInput>>>;
  /** Declared session of the timing service configuration. */
  declaredSession?: InputMaybe<Scalars['String']['input']>;
  /** Last message received from the timing service. */
  lastMessage?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the session match. */
  sessionMatchID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Information about the session match. */
  sessionMatchInfo?: InputMaybe<Scalars['String']['input']>;
  /** ID of the timing service configuration. */
  timingServiceConfigID: Scalars['MongoID']['input'];
};

export type AddCommentResult = {
  comment?: Maybe<Comment>;
  recordId: Scalars['MongoID']['output'];
};

export type AddControlTelemetryEndOfLapResult = {
  lapID?: Maybe<Scalars['MongoID']['output']>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddControlTelemetryEndOfRunResult = {
  lapID?: Maybe<Scalars['MongoID']['output']>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddControlTelemetryStartOfDataResult = {
  lapID?: Maybe<Scalars['MongoID']['output']>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddEventContestantResult = {
  success: Scalars['Boolean']['output'];
};

export type AddFlattenedPayloadReturnType = {
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddManyEventContestantsResult = {
  success: Scalars['Boolean']['output'];
};

export type AddTyreSetsToContestantResult = {
  contestant?: Maybe<Contestant>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddTyreSetsToEventContestantResult = {
  changed?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddTyresToContestantResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddTyresToEventContestantResult = {
  changed?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how an acceleration field can be adjusted */
export type AdjustableAcceleration = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumAccelerationUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableAccelerationInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAccelerationUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableAccelerationProperty = {
  adjustableAcceleration?: Maybe<AdjustableAcceleration>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how an angle field can be adjusted */
export type AdjustableAngle = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumAngleUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableAngleInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngleUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableAngleProperty = {
  adjustableAngle?: Maybe<AdjustableAngle>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how an angular complaince field can be adjusted */
export type AdjustableAngularCompliance = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumAngularComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableAngularComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngularComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableAngularComplianceProperty = {
  adjustableAngularCompliance?: Maybe<AdjustableAngularCompliance>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how an angular torque compliance field can be adjusted */
export type AdjustableAngularTorqueCompliance = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumAngularTorqueComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableAngularTorqueComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngularTorqueComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableAngularTorqueComplianceProperty = {
  adjustableAngularTorqueCompliance?: Maybe<AdjustableAngularTorqueCompliance>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableBoolean = {
  defaultValue?: Maybe<Scalars['Boolean']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableBooleanInput = {
  defaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdjustableBooleanProperty = {
  adjustableBoolean?: Maybe<AdjustableBoolean>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a compliance field can be adjusted */
export type AdjustableCompliance = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableComplianceProperty = {
  adjustableCompliance?: Maybe<AdjustableCompliance>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a force field can be adjusted */
export type AdjustableForce = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumForceUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableForceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumForceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableForceProperty = {
  adjustableForce?: Maybe<AdjustableForce>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how an inertia field can be adjusted */
export type AdjustableInertia = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumInertiaUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableInertiaInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumInertiaUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableInertiaProperty = {
  adjustableInertia?: Maybe<AdjustableInertia>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a length field can be adjusted */
export type AdjustableLength = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumLengthUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableLengthInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumLengthUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableLengthProperty = {
  adjustableLength?: Maybe<AdjustableLength>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableLocation = {
  coordinates?: Maybe<AdjustableLocationCoordinates>;
  defaultValue?: Maybe<AdjustableLocationDefaultValue>;
};

export type AdjustableLocationCoordinates = {
  /** Coordinate value x */
  x?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value y */
  y?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value z */
  z?: Maybe<Scalars['Float']['output']>;
};

export type AdjustableLocationCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type AdjustableLocationDefaultValue = {
  /** Coordinate value x */
  x?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value y */
  y?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value z */
  z?: Maybe<Scalars['Float']['output']>;
};

export type AdjustableLocationDefaultValueInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type AdjustableLocationInput = {
  coordinates?: InputMaybe<AdjustableLocationCoordinatesInput>;
  defaultValue?: InputMaybe<AdjustableLocationDefaultValueInput>;
};

export type AdjustableLocationProperty = {
  adjustableLocation?: Maybe<AdjustableLocation>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a mass field can be adjusted */
export type AdjustableMass = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumMassUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableMassInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumMassUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableMassProperty = {
  adjustableMass?: Maybe<AdjustableMass>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a numerical field can be adjusted */
export type AdjustableNumber = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  /** Unit to display values in */
  unit?: Maybe<Scalars['String']['output']>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableNumberInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  /** Unit to display values in */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableNumberProperty = {
  adjustableNumber?: Maybe<AdjustableNumber>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableOrientation = {
  defaultValue?: Maybe<AdjustableOrientationDefaultValue>;
  rotation?: Maybe<AdjustableOrientationRotation>;
};

export type AdjustableOrientationDefaultValue = {
  /** Rotation value I */
  I?: Maybe<Scalars['Float']['output']>;
  /** Rotation value J */
  J?: Maybe<Scalars['Float']['output']>;
  /** Rotation value K */
  K?: Maybe<Scalars['Float']['output']>;
};

export type AdjustableOrientationDefaultValueInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type AdjustableOrientationInput = {
  defaultValue?: InputMaybe<AdjustableOrientationDefaultValueInput>;
  rotation?: InputMaybe<AdjustableOrientationRotationInput>;
};

export type AdjustableOrientationProperty = {
  adjustableOrientation?: Maybe<AdjustableOrientation>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableOrientationRotation = {
  /** Rotation value I */
  I?: Maybe<Scalars['Float']['output']>;
  /** Rotation value J */
  J?: Maybe<Scalars['Float']['output']>;
  /** Rotation value K */
  K?: Maybe<Scalars['Float']['output']>;
};

export type AdjustableOrientationRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

/** Details about how a power field can be adjusted */
export type AdjustablePower = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumPowerUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustablePowerInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumPowerUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustablePowerProperty = {
  adjustablePower?: Maybe<AdjustablePower>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a pressure field can be adjusted */
export type AdjustablePressure = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumPressureUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustablePressureInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumPressureUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustablePressureProperty = {
  adjustablePressure?: Maybe<AdjustablePressure>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableProperty = {
  adjustableAcceleration?: Maybe<AdjustableAcceleration>;
  adjustableAngle?: Maybe<AdjustableAngle>;
  adjustableAngularCompliance?: Maybe<AdjustableAngularCompliance>;
  adjustableAngularTorqueCompliance?: Maybe<AdjustableAngularTorqueCompliance>;
  adjustableBoolean?: Maybe<AdjustableBoolean>;
  adjustableCompliance?: Maybe<AdjustableCompliance>;
  adjustableForce?: Maybe<AdjustableForce>;
  adjustableInertia?: Maybe<AdjustableInertia>;
  adjustableLength?: Maybe<AdjustableLength>;
  adjustableLocation?: Maybe<AdjustableLocation>;
  adjustableMass?: Maybe<AdjustableMass>;
  adjustableNumber?: Maybe<AdjustableNumber>;
  adjustableOrientation?: Maybe<AdjustableOrientation>;
  adjustablePower?: Maybe<AdjustablePower>;
  adjustablePressure?: Maybe<AdjustablePressure>;
  adjustableRatio?: Maybe<AdjustableRatio>;
  adjustableSpringRate?: Maybe<AdjustableSpringRate>;
  adjustableSteeringRackRatio?: Maybe<AdjustableSteeringRackRatio>;
  adjustableString?: Maybe<AdjustableString>;
  adjustableTemperature?: Maybe<AdjustableTemperature>;
  adjustableTorque?: Maybe<AdjustableTorque>;
  adjustableTorsionRate?: Maybe<AdjustableTorsionRate>;
  adjustableVolume?: Maybe<AdjustableVolume>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  type?: Maybe<EnumAdjustablePropertyType>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustablePropertyInput = {
  adjustableAcceleration?: InputMaybe<AdjustableAccelerationInput>;
  adjustableAngle?: InputMaybe<AdjustableAngleInput>;
  adjustableAngularCompliance?: InputMaybe<AdjustableAngularComplianceInput>;
  adjustableAngularTorqueCompliance?: InputMaybe<AdjustableAngularTorqueComplianceInput>;
  adjustableBoolean?: InputMaybe<AdjustableBooleanInput>;
  adjustableCompliance?: InputMaybe<AdjustableComplianceInput>;
  adjustableForce?: InputMaybe<AdjustableForceInput>;
  adjustableInertia?: InputMaybe<AdjustableInertiaInput>;
  adjustableLength?: InputMaybe<AdjustableLengthInput>;
  adjustableLocation?: InputMaybe<AdjustableLocationInput>;
  adjustableMass?: InputMaybe<AdjustableMassInput>;
  adjustableNumber?: InputMaybe<AdjustableNumberInput>;
  adjustableOrientation?: InputMaybe<AdjustableOrientationInput>;
  adjustablePower?: InputMaybe<AdjustablePowerInput>;
  adjustablePressure?: InputMaybe<AdjustablePressureInput>;
  adjustableRatio?: InputMaybe<AdjustableRatioInput>;
  adjustableSpringRate?: InputMaybe<AdjustableSpringRateInput>;
  adjustableSteeringRackRatio?: InputMaybe<AdjustableSteeringRackRatioInput>;
  adjustableString?: InputMaybe<AdjustableStringInput>;
  adjustableTemperature?: InputMaybe<AdjustableTemperatureInput>;
  adjustableTorque?: InputMaybe<AdjustableTorqueInput>;
  adjustableTorsionRate?: InputMaybe<AdjustableTorsionRateInput>;
  adjustableVolume?: InputMaybe<AdjustableVolumeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<EnumAdjustablePropertyType>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Details about how a ratio field can be adjusted */
export type AdjustableRatio = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumRatioUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableRatioInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumRatioUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableRatioProperty = {
  adjustableRatio?: Maybe<AdjustableRatio>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a spring rate field can be adjusted */
export type AdjustableSpringRate = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumSpringRateUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableSpringRateInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpringRateUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableSpringRateProperty = {
  adjustableSpringRate?: Maybe<AdjustableSpringRate>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a steering rack ratio field can be adjusted */
export type AdjustableSteeringRackRatio = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumSteeringRackRatioUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableSteeringRackRatioInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSteeringRackRatioUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableSteeringRackRatioProperty = {
  adjustableSteeringRackRatio?: Maybe<AdjustableSteeringRackRatio>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableString = {
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableStringInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableStringProperty = {
  adjustableString?: Maybe<AdjustableString>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a temperature field can be adjusted */
export type AdjustableTemperature = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumTemperatureUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableTemperatureInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTemperatureUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableTemperatureProperty = {
  adjustableTemperature?: Maybe<AdjustableTemperature>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a torque field can be adjusted */
export type AdjustableTorque = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumTorqueUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableTorqueInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTorqueUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableTorqueProperty = {
  adjustableTorque?: Maybe<AdjustableTorque>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a torsion rate field can be adjusted */
export type AdjustableTorsionRate = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumTorsionRateUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableTorsionRateInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTorsionRateUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableTorsionRateProperty = {
  adjustableTorsionRate?: Maybe<AdjustableTorsionRate>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a volume field can be adjusted */
export type AdjustableVolume = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumVolumeUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableVolumeInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumVolumeUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableVolumeProperty = {
  adjustableVolume?: Maybe<AdjustableVolume>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdvancedAssemblyFilterReturnType = {
  count: Scalars['Int']['output'];
  items?: Maybe<Array<Maybe<BaseAssembly>>>;
  pageInfo?: Maybe<PaginationInfoAssembly>;
};

export type AdvancedPartsFilterReturnType = {
  count: Scalars['Int']['output'];
  items?: Maybe<Array<Maybe<Part>>>;
  pageInfo?: Maybe<PaginationInfo>;
};

export type Aero = {
  /** Number/Position of front flaps */
  NFlapF?: Maybe<Scalars['String']['output']>;
  /** Number/Position of front-left flaps */
  NFlapFL?: Maybe<Scalars['String']['output']>;
  /** Number/Position of front-right flaps */
  NFlapFR?: Maybe<Scalars['String']['output']>;
  /** Number/Position of lower rear flaps */
  NFlapLowerR?: Maybe<Scalars['String']['output']>;
  /** Number/Position of rear flaps */
  NFlapR?: Maybe<Scalars['String']['output']>;
  /** Number/Position of rear-left flaps */
  NFlapRL?: Maybe<Scalars['String']['output']>;
  /** Number/Position of rear-right flaps */
  NFlapRR?: Maybe<Scalars['String']['output']>;
  Z400?: Maybe<Scalars['String']['output']>;
  /** Front flap angle */
  aFlapF?: Maybe<Scalars['Float']['output']>;
  /** Front-left flap angle */
  aFlapFL?: Maybe<Scalars['Float']['output']>;
  /** Front-right flap angle */
  aFlapFR?: Maybe<Scalars['Float']['output']>;
  /** Lower rear flap angle */
  aFlapLowerR?: Maybe<Scalars['Float']['output']>;
  /** Rear flap angle */
  aFlapR?: Maybe<Scalars['Float']['output']>;
  /** Rear-left flap angle */
  aFlapRL?: Maybe<Scalars['Float']['output']>;
  /** Rear-right flap angle */
  aFlapRR?: Maybe<Scalars['Float']['output']>;
  /** Front splitter angle */
  aSplitterF?: Maybe<Scalars['Float']['output']>;
  /** Complete aero package spec */
  aeroPackage?: Maybe<Scalars['String']['output']>;
  floorBB?: Maybe<Scalars['String']['output']>;
  floorGurney?: Maybe<Scalars['String']['output']>;
  floorLeadingEdgeID?: Maybe<Scalars['String']['output']>;
  /** Front flap type */
  frontFlapType?: Maybe<Scalars['String']['output']>;
  frontWheelArch?: Maybe<Scalars['String']['output']>;
  hGurneyF?: Maybe<Scalars['Float']['output']>;
  hGurneyR?: Maybe<Scalars['Float']['output']>;
  /** Splitter height at measurement points */
  hSplitterF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  lowerDrivePlane?: Maybe<Scalars['String']['output']>;
  noseID?: Maybe<Scalars['String']['output']>;
  rearWingGurney?: Maybe<Scalars['String']['output']>;
  splitterID?: Maybe<Scalars['String']['output']>;
  tailGurney?: Maybe<Scalars['String']['output']>;
  tailID?: Maybe<Scalars['String']['output']>;
  upperDrivePlane?: Maybe<Scalars['String']['output']>;
};

export type AeroElement = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  attached?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  positionName?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<AeroElementSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
};

export type AeroElementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  attached?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  positionName?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type AeroElementSpec = AnySpecification & NonChassisSpec & {
  CxT?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  CzF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  CzR?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  _id?: Maybe<Scalars['MongoID']['output']>;
  aeroElementInterpolationMethod?: Maybe<EnumAeroElementInterpolationMethod>;
  aeroElementType?: Maybe<EnumAeroElementType>;
  aeroPackageSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /**
   * Names of sockets that this can be plugged in to.
   * @deprecated
   */
  allowableSockets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attachable?: Maybe<Scalars['Boolean']['output']>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<AeroElementSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  polyCxT?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  polyCzF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  polyCzR?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  positionNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  positions?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** Position of the specification on the car */
  readingsAllowable?: Maybe<Array<EnumReadingLocation>>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AeroInput = {
  /** Number/Position of front flaps */
  NFlapF?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of front-left flaps */
  NFlapFL?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of front-right flaps */
  NFlapFR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of lower rear flaps */
  NFlapLowerR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear flaps */
  NFlapR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear-left flaps */
  NFlapRL?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear-right flaps */
  NFlapRR?: InputMaybe<Scalars['String']['input']>;
  Z400?: InputMaybe<Scalars['String']['input']>;
  /** Front flap angle */
  aFlapF?: InputMaybe<Scalars['Float']['input']>;
  /** Front-left flap angle */
  aFlapFL?: InputMaybe<Scalars['Float']['input']>;
  /** Front-right flap angle */
  aFlapFR?: InputMaybe<Scalars['Float']['input']>;
  /** Lower rear flap angle */
  aFlapLowerR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear flap angle */
  aFlapR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-left flap angle */
  aFlapRL?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-right flap angle */
  aFlapRR?: InputMaybe<Scalars['Float']['input']>;
  /** Front splitter angle */
  aSplitterF?: InputMaybe<Scalars['Float']['input']>;
  /** Complete aero package spec */
  aeroPackage?: InputMaybe<Scalars['String']['input']>;
  floorBB?: InputMaybe<Scalars['String']['input']>;
  floorGurney?: InputMaybe<Scalars['String']['input']>;
  floorLeadingEdgeID?: InputMaybe<Scalars['String']['input']>;
  /** Front flap type */
  frontFlapType?: InputMaybe<Scalars['String']['input']>;
  frontWheelArch?: InputMaybe<Scalars['String']['input']>;
  hGurneyF?: InputMaybe<Scalars['Float']['input']>;
  hGurneyR?: InputMaybe<Scalars['Float']['input']>;
  /** Splitter height at measurement points */
  hSplitterF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lowerDrivePlane?: InputMaybe<Scalars['String']['input']>;
  noseID?: InputMaybe<Scalars['String']['input']>;
  rearWingGurney?: InputMaybe<Scalars['String']['input']>;
  splitterID?: InputMaybe<Scalars['String']['input']>;
  tailGurney?: InputMaybe<Scalars['String']['input']>;
  tailID?: InputMaybe<Scalars['String']['input']>;
  upperDrivePlane?: InputMaybe<Scalars['String']['input']>;
};

export type AeroPackage = {
  aeroElements?: Maybe<Array<Maybe<AeroElement>>>;
  specification?: Maybe<AeroPackageSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
};

export type AeroPackageInput = {
  aeroElements?: InputMaybe<Array<InputMaybe<AeroElementInput>>>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type AeroPackageSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  aeroElementSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  aeroElementSpecs: Array<AeroElementSpec>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<AeroPackageSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Angle = {
  /** ° */
  degrees: Scalars['Float']['output'];
  /** rad */
  radians: Scalars['Float']['output'];
  /** rev */
  revolutions: Scalars['Float']['output'];
};

export type AngleInput = {
  /** ° */
  degrees?: InputMaybe<Scalars['Float']['input']>;
  /** rad */
  radians?: InputMaybe<Scalars['Float']['input']>;
  /** rev */
  revolutions?: InputMaybe<Scalars['Float']['input']>;
};

export type AngleUnitField = {
  unit: EnumAngleUnit;
};

export type AngularAccelerationUnitField = {
  unit: EnumAngularAccelerationUnit;
};

export type AngularComplianceUnitField = {
  unit: EnumAngularComplianceUnit;
};

export type AngularTorqueComplianceUnitField = {
  unit: EnumAngularTorqueComplianceUnit;
};

export type AngularVelocity = {
  /** °/s */
  degreesPerSecond: Scalars['Float']['output'];
  /** rad/s */
  radiansPerSecond: Scalars['Float']['output'];
  /** rpm */
  revolutionsPerMinute: Scalars['Float']['output'];
  /** rev/s */
  revolutionsPerSecond: Scalars['Float']['output'];
};

export type AngularVelocityInput = {
  /** °/s */
  degreesPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** rad/s */
  radiansPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** rpm */
  revolutionsPerMinute?: InputMaybe<Scalars['Float']['input']>;
  /** rev/s */
  revolutionsPerSecond?: InputMaybe<Scalars['Float']['input']>;
};

export type AngularVelocityUnitField = {
  unit: EnumAngularVelocityUnit;
};

export type AntiRollBar = {
  /** kARB specified in this anti roll bar's linked specification. */
  kARB?: Maybe<Scalars['Float']['output']>;
  /** Name specified in this anti roll bar's linked specification. */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Refer to position 1 and position 2 instead */
  position?: Maybe<Scalars['String']['output']>;
  position1?: Maybe<Scalars['String']['output']>;
  position2?: Maybe<Scalars['String']['output']>;
  rockerPosition?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<AntiRollBarSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
};

export type AntiRollBarConfig = {
  /** Anti-roll bar stiffness (use spring rate units) */
  kARB?: Maybe<Scalars['Float']['output']>;
  kinematicsInternalSpec: Array<KinematicsInternalSpec>;
  kinematicsInternalSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** First connection point (should be a chassis socket) */
  position1?: Maybe<Scalars['String']['output']>;
  /** Second connection point (should be a chassis socket) */
  position2?: Maybe<Scalars['String']['output']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  tags: Array<Tag>;
};

export type AntiRollBarConfigInput = {
  /** Anti-roll bar stiffness (use spring rate units) */
  kARB?: InputMaybe<Scalars['Float']['input']>;
  kinematicsInternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** First connection point (should be a chassis socket) */
  position1?: InputMaybe<Scalars['String']['input']>;
  /** Second connection point (should be a chassis socket) */
  position2?: InputMaybe<Scalars['String']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type AntiRollBarInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  position1?: InputMaybe<Scalars['String']['input']>;
  position2?: InputMaybe<Scalars['String']['input']>;
  rockerPosition?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type AntiRollBarSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  antiRollBarConfigs?: Maybe<Array<Maybe<AntiRollBarConfig>>>;
  /** @deprecated Use readingsRequired instead */
  antiRollBarDisplayLocation?: Maybe<EnumAntiRollBarDisplayLocation>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<AntiRollBarSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** Position of the specification on the car */
  readingsAllowable?: Maybe<Array<EnumReadingLocation>>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AnyAssembly = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  assemblyTemplateID?: Maybe<Scalars['MongoID']['output']>;
  /** @deprecated Use userEnumAssemblyTypeID instead */
  assemblyTypeEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetGroupEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetNestLevel?: Maybe<Scalars['Float']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  current?: Maybe<Scalars['Boolean']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  locationID?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  nestedPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  partInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  properties?: Maybe<Scalars['JSON']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  subAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumAssemblyTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type AnyRunSheetStyleBlock = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type AnySpecification = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  name: Scalars['String']['output'];
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  rootSpecificationID: Scalars['MongoID']['output'];
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AnySubAssembly = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  assemblyTemplateID?: Maybe<Scalars['MongoID']['output']>;
  assemblyTypeEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetGroupEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetNestLevel?: Maybe<Scalars['Float']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  current?: Maybe<Scalars['Boolean']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  locationID?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  nestedPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  partInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  properties?: Maybe<Scalars['JSON']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  subAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumAssemblyTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type AnyUserEnum = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
};

export type ApplyLapSequence = {
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ApplyMigrationResult = {
  success: Scalars['Boolean']['output'];
};

export type ApplyPackageItemsResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplyPackageResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Area = {
  /** sq ft */
  squareFeet: Scalars['Float']['output'];
  /** sq in */
  squareInches: Scalars['Float']['output'];
  /** m² */
  squareMetres: Scalars['Float']['output'];
  /** mm² */
  squareMillimetres: Scalars['Float']['output'];
};

export type AreaInput = {
  /** sq ft */
  squareFeet?: InputMaybe<Scalars['Float']['input']>;
  /** sq in */
  squareInches?: InputMaybe<Scalars['Float']['input']>;
  /** m² */
  squareMetres?: InputMaybe<Scalars['Float']['input']>;
  /** mm² */
  squareMillimetres?: InputMaybe<Scalars['Float']['input']>;
};

export type Assembly = ChassisAssembly | SubAssembly;

/** List of items with pagination. */
export type AssemblyPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Assembly>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AssemblyPartIDs = {
  assemblyID: Scalars['MongoID']['output'];
  partIDs: Array<Scalars['MongoID']['output']>;
};

export type AssemblyTemplate = {
  _id: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  requiredAssemblies?: Maybe<Array<Maybe<AssemblyTemplateRequiredAssemblies>>>;
  requiredParts?: Maybe<Array<Maybe<AssemblyTemplateRequiredParts>>>;
};

/** List of items with pagination. */
export type AssemblyTemplatePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<AssemblyTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AssemblyTemplateRequiredAssemblies = {
  userEnumAssemblyTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type AssemblyTemplateRequiredAssembliesInput = {
  userEnumAssemblyTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type AssemblyTemplateRequiredParts = {
  /** Specify where the part type should be added in */
  location?: Maybe<EnumAssemblyTemplateRequiredPartsLocation>;
  userEnumPartTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type AssemblyTemplateRequiredPartsInput = {
  /** Specify where the part type should be added in */
  location?: InputMaybe<EnumAssemblyTemplateRequiredPartsLocation>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type AssignTeamResult = {
  success: Scalars['Boolean']['output'];
};

export const AssignableToTeam = {
  CARSETUP: 'CARSETUP',
  CONTESTANT: 'CONTESTANT',
  PERSON: 'PERSON',
  RUNSHEET: 'RUNSHEET'
} as const;

export type AssignableToTeam = typeof AssignableToTeam[keyof typeof AssignableToTeam];
export type AssignedGear = {
  gear?: Maybe<GearSpec>;
  gearID: Scalars['MongoID']['output'];
  useHeadGear?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignedGearInput = {
  gearID: Scalars['MongoID']['input'];
  useHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AttachedFile = {
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type BaseAssembly = AnyAssembly & {
  _id: Scalars['MongoID']['output'];
  allPartInstanceActive?: Maybe<Scalars['Boolean']['output']>;
  assemblyTemplateID?: Maybe<Scalars['MongoID']['output']>;
  assemblyTypeEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetGroupEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetNestLevel?: Maybe<Scalars['Float']['output']>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  chassisMeasurements?: Maybe<Array<Maybe<ChassisAssemblyMeasurement>>>;
  /** @deprecated User should define chassis parts as custom specs */
  chassisPartID?: Maybe<Scalars['MongoID']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  chassisSpecName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Is this the current version of this assembly, or just a historical snapshot? */
  current?: Maybe<Scalars['Boolean']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  /** Location of this assembly referring to a socket. For example, `frontLeft` or `cockpit`. */
  locationID?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  nestedPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  nestedPartInstances: Array<PartInstance>;
  parentID?: Maybe<Scalars['MongoID']['output']>;
  partInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  partInstances: Array<PartInstance>;
  properties?: Maybe<Scalars['JSON']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  runSheetName?: Maybe<Scalars['String']['output']>;
  subAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingSourceRecords?: Maybe<Array<Maybe<ChassisAssemblyTrackingSourceRecord>>>;
  type: EnumAssemblyType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumAssemblyType?: Maybe<UserEnum>;
  userEnumAssemblyTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type BaseSpecification = AnySpecification & {
  CxT?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  CzF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  CzR?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  FSpringSetup?: Maybe<AdjustableForce>;
  _id: Scalars['MongoID']['output'];
  aCamber?: Maybe<SpecificationACamber>;
  aCaster?: Maybe<SpecificationACamber>;
  aCasterMeasurementGain?: Maybe<Scalars['Float']['output']>;
  aCasterMeasurementOffset?: Maybe<Scalars['Float']['output']>;
  aToe?: Maybe<SpecificationACamber>;
  adjustableProperties?: Maybe<Array<Maybe<AdjustableProperty>>>;
  aeroElementInterpolationMethod?: Maybe<EnumAeroElementInterpolationMethod>;
  aeroElementSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  aeroElementType?: Maybe<EnumAeroElementType>;
  aeroPackageSpecID?: Maybe<Scalars['MongoID']['output']>;
  aeroPackageSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Names of sockets that this can be plugged in to. */
  allowableSockets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  antiRollBarConfigs?: Maybe<Array<Maybe<AntiRollBarConfig>>>;
  antiRollBarDisplayLocation?: Maybe<EnumAntiRollBarDisplayLocation>;
  antiRollBarSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: Maybe<Array<Maybe<AssignedGear>>>;
  attachable?: Maybe<Scalars['Boolean']['output']>;
  axle?: Maybe<EnumAxle>;
  bevelSetSpecID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  bumpRubberReference?: Maybe<EnumKinematicsInternalReference>;
  bumpRubberSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  bumpStopGapMethod?: Maybe<EnumBumpStopGapMethod>;
  calculationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: Maybe<Scalars['String']['output']>;
  chassisMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: Maybe<Scalars['Boolean']['output']>;
  copyReferencePackageID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customSimulationModels?: Maybe<Array<Maybe<SpecificationCustomSimulationModels>>>;
  customSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  customSpecType?: Maybe<Scalars['String']['output']>;
  customTables?: Maybe<Array<Maybe<SpecificationCustomTables>>>;
  damperAdjusters?: Maybe<Array<Maybe<DamperAdjuster>>>;
  damperConfigs?: Maybe<Array<Maybe<DamperConfig>>>;
  damperSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  differentialConfigs?: Maybe<Array<Maybe<DifferentialConfig>>>;
  differentialSpecID?: Maybe<Scalars['MongoID']['output']>;
  drawingNumber?: Maybe<Scalars['String']['output']>;
  dropGearSpecID?: Maybe<Scalars['MongoID']['output']>;
  elasticType?: Maybe<EnumElasticType>;
  forceTable?: Maybe<ForceTable>;
  gearType?: Maybe<EnumGearType>;
  hRide?: Maybe<SpecificationHRide>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  headGearSpecID?: Maybe<Scalars['MongoID']['output']>;
  helperSpringSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** If true, this gear is the head gear of the gear box, applies to standard gears only */
  isHeadGear?: Maybe<Scalars['Boolean']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Spring constant of the elastic element. */
  kSpring?: Maybe<Scalars['Float']['output']>;
  kinematicsExternalModels?: Maybe<Array<Maybe<KinematicsExternalModel>>>;
  kinematicsExternalSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  kinematicsInternalSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  manufacturerID?: Maybe<Scalars['MongoID']['output']>;
  manufacturerReference?: Maybe<Scalars['String']['output']>;
  mass?: Maybe<ChassisMass>;
  massProperties?: Maybe<MassProperties>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: Maybe<ChassisMeasurements>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: Maybe<Array<Maybe<EnumSimModelType>>>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  polyCxT?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  polyCzF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  polyCzR?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  positionNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  positions?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  powerUnits?: Maybe<Array<Maybe<ChassisPowerUnit>>>;
  powertrain?: Maybe<ChassisPowertrain>;
  powertrainLocation?: Maybe<EnumSpecificationPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  rBrakeBias?: Maybe<AdjustableRatio>;
  /** Position of the specification on the car */
  readingsAllowable?: Maybe<Array<Maybe<EnumSpecificationReadingsAllowable>>>;
  readingsRequired?: Maybe<EnumSpecificationReadingsRequired>;
  reboundSpringSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  reference?: Maybe<Scalars['String']['output']>;
  regulationSets?: Maybe<Array<Maybe<RegulationSet>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: Maybe<Scalars['Date']['output']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  setupChangesFilter?: Maybe<SpecificationSetupChangesFilter>;
  setupSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: Maybe<Scalars['MongoID']['output']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: Maybe<Scalars['MongoID']['output']>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  /** Locations/areas that components can be installed in. */
  sockets?: Maybe<Array<Maybe<ChassisSocket>>>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  specificationGroupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  springReference?: Maybe<EnumKinematicsInternalReference>;
  springSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  torsionBarSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingMeasurements: Array<TrackingMeasurement>;
  trackingSourceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  type: EnumSpecificationType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** User-supplied version of this specification. */
  version?: Maybe<Scalars['String']['output']>;
  xBumpRubberRef?: Maybe<Scalars['Float']['output']>;
  xBumpRubberSetup?: Maybe<AdjustableLength>;
  xBumpStopGapDefault?: Maybe<Scalars['Float']['output']>;
  xDamperDroopDefault?: Maybe<Scalars['Float']['output']>;
  xDamperSetupDefault?: Maybe<Scalars['Float']['output']>;
  xDroopStopGapDefault?: Maybe<Scalars['Float']['output']>;
  /** Length of the elastic element under no force */
  xFree?: Maybe<Scalars['Float']['output']>;
  xShaftDroopDefault?: Maybe<Scalars['Float']['output']>;
  xSpringPlatformOffset?: Maybe<Scalars['Float']['output']>;
  xSpringRef?: Maybe<Scalars['Float']['output']>;
  xSpringSetup?: Maybe<AdjustableLength>;
  xToe?: Maybe<SpecificationHRide>;
};

export type BaseTypedUnitFieldInput = {
  type: EnumTypedUnitType;
  unit: EnumPossibleUnit;
};

export type BehaviourConfig = {
  /** Should job list templates be re-used from previous runs when creating new run sheets? */
  carryOverJobList?: Maybe<Scalars['Boolean']['output']>;
  /** If true, the issue block will be ticked to show only the users issues on load. */
  showMyIssuesOnRunSheetDefault?: Maybe<Scalars['Boolean']['output']>;
  /** If true, the job block will be ticked to show only the users jobs on load. */
  showMyJobsOnRunSheetDefault?: Maybe<Scalars['Boolean']['output']>;
  /** The locale to use for time formatting */
  timeLocale?: Maybe<Scalars['String']['output']>;
  /** ORH will use the users timezone selection to format times accordingly */
  timezoneSelect?: Maybe<EnumBehaviourConfigTimezoneSelect>;
};

export type BehaviourConfigInput = {
  /** Should job list templates be re-used from previous runs when creating new run sheets? */
  carryOverJobList?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the issue block will be ticked to show only the users issues on load. */
  showMyIssuesOnRunSheetDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the job block will be ticked to show only the users jobs on load. */
  showMyJobsOnRunSheetDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The locale to use for time formatting */
  timeLocale?: InputMaybe<Scalars['String']['input']>;
  /** ORH will use the users timezone selection to format times accordingly */
  timezoneSelect?: InputMaybe<EnumBehaviourConfigTimezoneSelect>;
};

export type BestValues = {
  _id: Scalars['MongoID']['output'];
  /** Contestant these personal bests belong to, if applicable. */
  contestant?: Maybe<Contestant>;
  /** ID of the contestant these personal bests belong to, if applicable. */
  contestantID?: Maybe<Scalars['MongoID']['output']>;
  /** Driver these personal bests belong to, if applicable. */
  driver?: Maybe<Person>;
  /** ID of the driver these personal bests belong to, if applicable. */
  driverID?: Maybe<Scalars['MongoID']['output']>;
  fastestLap?: Maybe<BestValuesFastestLap>;
  fastestSectors?: Maybe<Array<Maybe<BestValuesFastestSector>>>;
  session?: Maybe<Session>;
  sessionID: Scalars['MongoID']['output'];
};

export type BestValuesFastestLap = {
  /** Lap number within the run sheet for this lap. */
  NLapRun?: Maybe<Scalars['Float']['output']>;
  /** Acronym of the driver that completed this lap. */
  driver?: Maybe<Scalars['String']['output']>;
  /** Run sheet that this lap can be found in. */
  runSheet?: Maybe<RunSheet>;
  /** ID of the run sheet that this lap can be found in. */
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  /** Time the lap was completed in. */
  time?: Maybe<Scalars['Float']['output']>;
};

export type BestValuesFastestLapInput = {
  /** Lap number within the run sheet for this lap. */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Acronym of the driver that completed this lap. */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** ID of the run sheet that this lap can be found in. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time the lap was completed in. */
  time?: InputMaybe<Scalars['Float']['input']>;
};

export type BestValuesFastestSector = {
  /** Lap number within the run sheet for this sector. */
  NLapRun?: Maybe<Scalars['Float']['output']>;
  /** Acronym of the driver that completed this sector. */
  driver?: Maybe<Scalars['String']['output']>;
  /** Run sheet that this sector can be found in. */
  runSheet?: Maybe<RunSheet>;
  /** ID of the run sheet that this sector can be found in. */
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  /** Time the sector was completed in. */
  time?: Maybe<Scalars['Float']['output']>;
};

export type BestValuesFastestSectorInput = {
  /** Lap number within the run sheet for this sector. */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Acronym of the driver that completed this sector. */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** ID of the run sheet that this sector can be found in. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time the sector was completed in. */
  time?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type BestValuesPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<BestValues>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type BlankingBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type BooleanUnitField = {
  unit: EnumUntypedUnit;
};

export type Bop = {
  _id: Scalars['MongoID']['output'];
  bopFile?: Maybe<AttachedFile>;
  carBop?: Maybe<Array<Maybe<BopCarBop>>>;
  name?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Session>;
  sessionBop?: Maybe<BopSessionBop>;
  sessionID: Scalars['MongoID']['output'];
};

export type BopCarBop = {
  EStintMax?: Maybe<Scalars['Float']['output']>;
  PEngineMax?: Maybe<Scalars['Float']['output']>;
  VFuelVolumeCapacityMax?: Maybe<Scalars['Float']['output']>;
  VRefuelVolumeMax?: Maybe<Scalars['Float']['output']>;
  _id?: Maybe<Scalars['MongoID']['output']>;
  aCamberFmax?: Maybe<Scalars['Float']['output']>;
  aCamberFmin?: Maybe<Scalars['Float']['output']>;
  aCamberRmax?: Maybe<Scalars['Float']['output']>;
  aCamberRmin?: Maybe<Scalars['Float']['output']>;
  aRakeMax?: Maybe<Scalars['Float']['output']>;
  aRakeMin?: Maybe<Scalars['Float']['output']>;
  aWingRmax?: Maybe<Scalars['Float']['output']>;
  aWingRmin?: Maybe<Scalars['Float']['output']>;
  carSpec?: Maybe<Scalars['String']['output']>;
  hRideFmin?: Maybe<Scalars['Float']['output']>;
  hRideRmin?: Maybe<Scalars['Float']['output']>;
  highlightColour?: Maybe<Scalars['String']['output']>;
  homologation?: Maybe<Scalars['String']['output']>;
  mCarBallastMin?: Maybe<Scalars['Float']['output']>;
  mCarWeightEmptyMin?: Maybe<Scalars['Float']['output']>;
  mCarWeightTotalMin?: Maybe<Scalars['Float']['output']>;
  mFuelMassCapacityMax?: Maybe<Scalars['Float']['output']>;
  mRefuelMassMax?: Maybe<Scalars['Float']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  modelYear?: Maybe<Scalars['String']['output']>;
  nEngineMax?: Maybe<Scalars['Float']['output']>;
  /** A map rpm vs boost pressure */
  pEngineBoost?: Maybe<Scalars['JSON']['output']>;
  rLambdaMin?: Maybe<Scalars['Float']['output']>;
  rPowerCurveReference?: Maybe<Scalars['Float']['output']>;
  rPowerGainAboveRefVelocity?: Maybe<Scalars['Float']['output']>;
  vCarMax?: Maybe<Scalars['Float']['output']>;
  vPowerCurveBelowRefVelocity?: Maybe<Scalars['Float']['output']>;
  vPowerGainReference?: Maybe<Scalars['Float']['output']>;
  xAirRestrictorMax?: Maybe<Scalars['Float']['output']>;
  xFuelRestrictorMax?: Maybe<Scalars['Float']['output']>;
  xRefuelRestrictorMax?: Maybe<Scalars['Float']['output']>;
  zWingMin?: Maybe<Scalars['Float']['output']>;
};

export type BopCarBopInput = {
  EStintMax?: InputMaybe<Scalars['Float']['input']>;
  PEngineMax?: InputMaybe<Scalars['Float']['input']>;
  VFuelVolumeCapacityMax?: InputMaybe<Scalars['Float']['input']>;
  VRefuelVolumeMax?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  aCamberFmax?: InputMaybe<Scalars['Float']['input']>;
  aCamberFmin?: InputMaybe<Scalars['Float']['input']>;
  aCamberRmax?: InputMaybe<Scalars['Float']['input']>;
  aCamberRmin?: InputMaybe<Scalars['Float']['input']>;
  aRakeMax?: InputMaybe<Scalars['Float']['input']>;
  aRakeMin?: InputMaybe<Scalars['Float']['input']>;
  aWingRmax?: InputMaybe<Scalars['Float']['input']>;
  aWingRmin?: InputMaybe<Scalars['Float']['input']>;
  carSpec?: InputMaybe<Scalars['String']['input']>;
  hRideFmin?: InputMaybe<Scalars['Float']['input']>;
  hRideRmin?: InputMaybe<Scalars['Float']['input']>;
  highlightColour?: InputMaybe<Scalars['String']['input']>;
  homologation?: InputMaybe<Scalars['String']['input']>;
  mCarBallastMin?: InputMaybe<Scalars['Float']['input']>;
  mCarWeightEmptyMin?: InputMaybe<Scalars['Float']['input']>;
  mCarWeightTotalMin?: InputMaybe<Scalars['Float']['input']>;
  mFuelMassCapacityMax?: InputMaybe<Scalars['Float']['input']>;
  mRefuelMassMax?: InputMaybe<Scalars['Float']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['String']['input']>;
  nEngineMax?: InputMaybe<Scalars['Float']['input']>;
  /** A map rpm vs boost pressure */
  pEngineBoost?: InputMaybe<Scalars['JSON']['input']>;
  rLambdaMin?: InputMaybe<Scalars['Float']['input']>;
  rPowerCurveReference?: InputMaybe<Scalars['Float']['input']>;
  rPowerGainAboveRefVelocity?: InputMaybe<Scalars['Float']['input']>;
  vCarMax?: InputMaybe<Scalars['Float']['input']>;
  vPowerCurveBelowRefVelocity?: InputMaybe<Scalars['Float']['input']>;
  vPowerGainReference?: InputMaybe<Scalars['Float']['input']>;
  xAirRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  xFuelRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  xRefuelRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  zWingMin?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type BopPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Bop>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type BopSessionBop = {
  EStintEnergyMax?: Maybe<Scalars['Float']['output']>;
  EStintEnergyRefillRateMax?: Maybe<Scalars['Float']['output']>;
  VRefuelRateMax?: Maybe<Scalars['Float']['output']>;
  _id?: Maybe<Scalars['MongoID']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  mRefuelRateMax?: Maybe<Scalars['Float']['output']>;
  pAmbientSessionOfficial?: Maybe<Scalars['Float']['output']>;
  tyreModel?: Maybe<Scalars['String']['output']>;
  xStintlengthMax?: Maybe<Scalars['Float']['output']>;
};

export type BopSessionBopInput = {
  EStintEnergyMax?: InputMaybe<Scalars['Float']['input']>;
  EStintEnergyRefillRateMax?: InputMaybe<Scalars['Float']['input']>;
  VRefuelRateMax?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  mRefuelRateMax?: InputMaybe<Scalars['Float']['input']>;
  pAmbientSessionOfficial?: InputMaybe<Scalars['Float']['input']>;
  tyreModel?: InputMaybe<Scalars['String']['input']>;
  xStintlengthMax?: InputMaybe<Scalars['Float']['input']>;
};

export type Brake = {
  /** Is brake duct enabled? */
  BBrakeDuctEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Part number of brake discs */
  NBrakeDisc?: Maybe<Scalars['Float']['output']>;
  /** Part number of left pads */
  NPadL?: Maybe<Scalars['Float']['output']>;
  /** Part number of right pads */
  NPadR?: Maybe<Scalars['Float']['output']>;
  /** Brake blanking style (top → bottom, left → right, …) */
  brakeBlankingStyle?: Maybe<Scalars['String']['output']>;
  /** Brake duct specification */
  brakeDuctSpec?: Maybe<Scalars['String']['output']>;
  /** Brake caliper blanking height */
  hBrakeCaliperBlanking?: Maybe<Scalars['Float']['output']>;
  /** Brake disc blanking height */
  hBrakeDiscBlanking?: Maybe<Scalars['Float']['output']>;
  /** Brake caliper blanking ratio */
  rBrakeCaliperBlanking?: Maybe<Scalars['Float']['output']>;
  /** Brake disc blanking ratio */
  rBrakeDiscBlanking?: Maybe<Scalars['Float']['output']>;
};

export type BrakeInput = {
  /** Is brake duct enabled? */
  BBrakeDuctEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Part number of brake discs */
  NBrakeDisc?: InputMaybe<Scalars['Float']['input']>;
  /** Part number of left pads */
  NPadL?: InputMaybe<Scalars['Float']['input']>;
  /** Part number of right pads */
  NPadR?: InputMaybe<Scalars['Float']['input']>;
  /** Brake blanking style (top → bottom, left → right, …) */
  brakeBlankingStyle?: InputMaybe<Scalars['String']['input']>;
  /** Brake duct specification */
  brakeDuctSpec?: InputMaybe<Scalars['String']['input']>;
  /** Brake caliper blanking height */
  hBrakeCaliperBlanking?: InputMaybe<Scalars['Float']['input']>;
  /** Brake disc blanking height */
  hBrakeDiscBlanking?: InputMaybe<Scalars['Float']['input']>;
  /** Brake caliper blanking ratio */
  rBrakeCaliperBlanking?: InputMaybe<Scalars['Float']['input']>;
  /** Brake disc blanking ratio */
  rBrakeDiscBlanking?: InputMaybe<Scalars['Float']['input']>;
};

export type BrakeSystem = {
  BBBSEnabled?: Maybe<Scalars['Boolean']['output']>;
  brakePadFManufacturer?: Maybe<Scalars['String']['output']>;
  brakePadFSpec?: Maybe<Scalars['String']['output']>;
  brakePadRManufacturer?: Maybe<Scalars['String']['output']>;
  brakePadRSpec?: Maybe<Scalars['String']['output']>;
  brakePedalPosition?: Maybe<Scalars['String']['output']>;
  dMasterCylinderF?: Maybe<Scalars['Float']['output']>;
  dMasterCylinderR?: Maybe<Scalars['Float']['output']>;
  kBBSSpring?: Maybe<Scalars['Float']['output']>;
  kKnockOffSpringF?: Maybe<Scalars['Float']['output']>;
  kKnockOffSpringR?: Maybe<Scalars['Float']['output']>;
  masterCylinderFSpec?: Maybe<Scalars['String']['output']>;
  masterCylinderRSpec?: Maybe<Scalars['String']['output']>;
  masterCylinderRodLengthF?: Maybe<Scalars['Float']['output']>;
  masterCylinderRodlengthR?: Maybe<Scalars['Float']['output']>;
  pBrakeBalanceRef?: Maybe<Scalars['Float']['output']>;
  rBrakeF?: Maybe<Scalars['Float']['output']>;
  rBrakePedal?: Maybe<Scalars['Float']['output']>;
  xBBSPreload?: Maybe<Scalars['Float']['output']>;
};

export type BrakeSystemInput = {
  BBBSEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  brakePadFManufacturer?: InputMaybe<Scalars['String']['input']>;
  brakePadFSpec?: InputMaybe<Scalars['String']['input']>;
  brakePadRManufacturer?: InputMaybe<Scalars['String']['input']>;
  brakePadRSpec?: InputMaybe<Scalars['String']['input']>;
  brakePedalPosition?: InputMaybe<Scalars['String']['input']>;
  dMasterCylinderF?: InputMaybe<Scalars['Float']['input']>;
  dMasterCylinderR?: InputMaybe<Scalars['Float']['input']>;
  kBBSSpring?: InputMaybe<Scalars['Float']['input']>;
  kKnockOffSpringF?: InputMaybe<Scalars['Float']['input']>;
  kKnockOffSpringR?: InputMaybe<Scalars['Float']['input']>;
  masterCylinderFSpec?: InputMaybe<Scalars['String']['input']>;
  masterCylinderRSpec?: InputMaybe<Scalars['String']['input']>;
  masterCylinderRodLengthF?: InputMaybe<Scalars['Float']['input']>;
  masterCylinderRodlengthR?: InputMaybe<Scalars['Float']['input']>;
  pBrakeBalanceRef?: InputMaybe<Scalars['Float']['input']>;
  rBrakeF?: InputMaybe<Scalars['Float']['input']>;
  rBrakePedal?: InputMaybe<Scalars['Float']['input']>;
  xBBSPreload?: InputMaybe<Scalars['Float']['input']>;
};

export type BrakesBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  brakeFields?: Maybe<Array<Maybe<EnumBrakeBlockField>>>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** @deprecated Specify EnumBrakeBlockField.POST_RUN_BRAKE_TEMPS in `brakeFields` instead */
  showPostRunBrakeTemps?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Specify EnumBrakeBlockField.PRE_RUN_BRAKE_TEMPS in `brakeFields` instead */
  showPreRunBrakeTemps?: Maybe<Scalars['Boolean']['output']>;
  temperatureUnit?: Maybe<EnumTemperatureUnit>;
  title: Scalars['String']['output'];
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type BuildSheetStyle = {
  _id: Scalars['MongoID']['output'];
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  blocks?: Maybe<Array<Maybe<BuildSheetStyleBlock>>>;
  chassisSpec?: Maybe<ChassisSpec>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['MongoID']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  issue?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  targetEventType?: Maybe<EnumBuildSheetStyleTargetEventType>;
  targetRoles?: Maybe<Array<Maybe<EnumBuildSheetStyleTargetRoles>>>;
  targetUserIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  targetUsers: Array<Person>;
  type: EnumBuildSheetStyleType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type BuildSheetStyleBlock = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The height of the block within the grid */
  h: Scalars['Int']['output'];
  moved?: Maybe<Scalars['Boolean']['output']>;
  resizing?: Maybe<Scalars['Boolean']['output']>;
  static?: Maybe<Scalars['Boolean']['output']>;
  tabs?: Maybe<Array<Maybe<BuildSheetStyleTab>>>;
  /** The width of the block within the grid */
  w: Scalars['Int']['output'];
  /** The x position of the block within the grid */
  x: Scalars['Int']['output'];
  /** The y position of the block within the grid */
  y: Scalars['Int']['output'];
};

export type BuildSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** The height of the block within the grid */
  h: Scalars['Int']['input'];
  moved?: InputMaybe<Scalars['Boolean']['input']>;
  resizing?: InputMaybe<Scalars['Boolean']['input']>;
  static?: InputMaybe<Scalars['Boolean']['input']>;
  tabs?: InputMaybe<Array<InputMaybe<BuildSheetStyleTabInput>>>;
  /** The width of the block within the grid */
  w: Scalars['Int']['input'];
  /** The x position of the block within the grid */
  x: Scalars['Int']['input'];
  /** The y position of the block within the grid */
  y: Scalars['Int']['input'];
};

/** List of items with pagination. */
export type BuildSheetStylePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<BuildSheetStyle>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type BuildSheetStyleTab = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  buildSheetGroupEnum?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetGroupEnumID?: Maybe<Scalars['MongoID']['output']>;
  title: Scalars['String']['output'];
};

export type BuildSheetStyleTabInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetGroupEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  title: Scalars['String']['input'];
};

export type BumpStop = {
  name?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<ElasticSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  xBumpStopGap?: Maybe<Scalars['Float']['output']>;
};

export type BumpStopInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  xBumpStopGap?: InputMaybe<Scalars['Float']['input']>;
};

export type CalculateAllRunEnergiesResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CalculatePartMileageById = {
  mileage?: Maybe<Scalars['Float']['output']>;
  partID?: Maybe<Scalars['MongoID']['output']>;
};

export type CalculateRunEnergyResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Calculation = {
  _id: Scalars['MongoID']['output'];
  /** For the client to display debug information or default return values */
  debugMode?: Maybe<Scalars['Boolean']['output']>;
  displayUnit?: Maybe<EnumDisplayUnit>;
  functionString: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** The name of the parameter or path to a field which this calculation gives as output. */
  parameter: Scalars['String']['output'];
  /** The names of the parameters or paths to fields which this calculation depends on. If any of these change, the calculation should be re-run. */
  trigger: Array<Scalars['String']['output']>;
  type: EnumCalculationType;
  version?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type CalculationPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Calculation>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CanopyConfig = {
  canopyID: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  simVersion: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CanopyCredentials = {
  /** Client ID for the Canopy API */
  clientID?: Maybe<Scalars['String']['output']>;
  /** Client secret for the Canopy API */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** Password for the Canopy API */
  password?: Maybe<Scalars['String']['output']>;
  /** Tenant ID from the Canopy API */
  tenantID?: Maybe<Scalars['String']['output']>;
  /** User ID from the Canopy API */
  userID?: Maybe<Scalars['String']['output']>;
  /** Username for the Canopy API */
  username?: Maybe<Scalars['String']['output']>;
};

export type CanopyCredentialsInput = {
  /** Client ID for the Canopy API */
  clientID?: InputMaybe<Scalars['String']['input']>;
  /** Client secret for the Canopy API */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Password for the Canopy API */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID from the Canopy API */
  tenantID?: InputMaybe<Scalars['String']['input']>;
  /** Username for the Canopy API */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CarCorner = {
  aCamber?: Maybe<Scalars['Float']['output']>;
  aCamberMeasurement?: Maybe<Scalars['Float']['output']>;
  aCaster?: Maybe<Scalars['Float']['output']>;
  aCasterMeasurement?: Maybe<Scalars['Float']['output']>;
  /** @deprecated  */
  aFlap?: Maybe<Scalars['Float']['output']>;
  aToe?: Maybe<Scalars['Float']['output']>;
  aToeMeasurement?: Maybe<Scalars['Float']['output']>;
  /** @deprecated  */
  brake?: Maybe<Brake>;
  bumpStop?: Maybe<BumpStop>;
  damper?: Maybe<Damper>;
  droopStop?: Maybe<DroopStop>;
  externalBumpStop?: Maybe<ExternalBumpStop>;
  hRide?: Maybe<Scalars['Float']['output']>;
  hRideChassis?: Maybe<Scalars['Float']['output']>;
  hRideMeasurement?: Maybe<Scalars['Float']['output']>;
  hRideRegulation?: Maybe<Scalars['Float']['output']>;
  helperSpring?: Maybe<Spring>;
  pTyreTarget?: Maybe<Scalars['Float']['output']>;
  reboundSpring?: Maybe<Spring>;
  spring?: Maybe<Spring>;
  /** @deprecated  */
  suspension?: Maybe<Suspension>;
  xToe?: Maybe<Scalars['Float']['output']>;
  xToeMeasurement?: Maybe<Scalars['Float']['output']>;
};

export type CarCornerInput = {
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aFlap?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<Scalars['Float']['input']>;
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  brake?: InputMaybe<BrakeInput>;
  bumpStop?: InputMaybe<BumpStopInput>;
  damper?: InputMaybe<DamperInput>;
  droopStop?: InputMaybe<DroopStopInput>;
  externalBumpStop?: InputMaybe<ExternalBumpStopInput>;
  hRide?: InputMaybe<Scalars['Float']['input']>;
  hRideChassis?: InputMaybe<Scalars['Float']['input']>;
  hRideMeasurement?: InputMaybe<Scalars['Float']['input']>;
  hRideRegulation?: InputMaybe<Scalars['Float']['input']>;
  helperSpring?: InputMaybe<SpringInput>;
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
  reboundSpring?: InputMaybe<SpringInput>;
  spring?: InputMaybe<SpringInput>;
  suspension?: InputMaybe<SuspensionInput>;
  xToe?: InputMaybe<Scalars['Float']['input']>;
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type CarDataServiceApplicationSettingsConfig = {
  DriverContestantLookup?: Maybe<Scalars['JSON']['output']>;
  FunctionsFolder?: Maybe<Scalars['String']['output']>;
  PitstopTriggers?: Maybe<Array<Maybe<CarDataServicePitstopTrigger>>>;
  ProcessedFolder?: Maybe<Scalars['String']['output']>;
  ResultsFolder?: Maybe<Scalars['String']['output']>;
  RunsheetMatching?: Maybe<EnumCarDataServiceApplicationSettingsConfigRunsheetMatching>;
};

export type CarDataServiceApplicationSettingsConfigInput = {
  DriverContestantLookup?: InputMaybe<Scalars['JSON']['input']>;
  FunctionsFolder?: InputMaybe<Scalars['String']['input']>;
  PitstopTriggers?: InputMaybe<Array<InputMaybe<CarDataServicePitstopTriggerInput>>>;
  ProcessedFolder?: InputMaybe<Scalars['String']['input']>;
  ResultsFolder?: InputMaybe<Scalars['String']['input']>;
  RunsheetMatching?: InputMaybe<EnumCarDataServiceApplicationSettingsConfigRunsheetMatching>;
};

export type CarDataServiceConfig = {
  Kpi?: Maybe<CarDataServiceKpiConfig>;
  ORHCalculationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  ORHCalculations: Array<Calculation>;
  /** Object containing parameter mappings. Format is like: { vCar: [{ "name": "car_speed", "offset": 0, "gain": 3.6 }] } */
  ParameterMap?: Maybe<Scalars['JSON']['output']>;
  PostProcessingConfig?: Maybe<CarDataServicePostProcessingConfig>;
  _id: Scalars['MongoID']['output'];
  /** Is this the currently active config for this race series? Only one is active per race series at any given time. */
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  raceSeries?: Maybe<RaceSeries>;
  raceSeriesID: Scalars['MongoID']['output'];
  version: Scalars['String']['output'];
};

/** List of items with pagination. */
export type CarDataServiceConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CarDataServiceConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CarDataServiceEventConfig = {
  EventDescription?: Maybe<Scalars['String']['output']>;
  EventId: Scalars['MongoID']['output'];
};

export type CarDataServiceEventConfigInput = {
  EventDescription?: InputMaybe<Scalars['String']['input']>;
  EventId: Scalars['MongoID']['input'];
};

export type CarDataServiceKpiConfig = {
  KpiParameters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Preconditions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Use `KpiParameters` instead */
  parameters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Use `Preconditions` instead */
  preconditions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CarDataServiceKpiConfigInput = {
  KpiParameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Preconditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preconditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CarDataServicePitstopTrigger = {
  ParameterId: Scalars['String']['output'];
  Type?: Maybe<EnumCarDataServicePitstopTriggerType>;
  Value: Scalars['Float']['output'];
};

export type CarDataServicePitstopTriggerInput = {
  ParameterId: Scalars['String']['input'];
  Type?: InputMaybe<EnumCarDataServicePitstopTriggerType>;
  Value: Scalars['Float']['input'];
};

export type CarDataServicePostProcessingConfig = {
  ApplicationSettingsConfiguration?: Maybe<CarDataServiceApplicationSettingsConfig>;
  EventConfiguration?: Maybe<CarDataServiceEventConfig>;
  ProcessingEnginesConfiguration?: Maybe<CarDataServiceProcessingEnginesConfig>;
  QueueManagerConfiguration?: Maybe<CarDataServiceQueueManagerConfig>;
  SessionManagerConfiguration?: Maybe<CarDataServiceSessionManagerConfig>;
  SessionTypesConfiguration?: Maybe<CarDataServiceSessionTypesConfig>;
};

export type CarDataServicePostProcessingConfigInput = {
  ApplicationSettingsConfiguration?: InputMaybe<CarDataServiceApplicationSettingsConfigInput>;
  EventConfiguration?: InputMaybe<CarDataServiceEventConfigInput>;
  ProcessingEnginesConfiguration?: InputMaybe<CarDataServiceProcessingEnginesConfigInput>;
  QueueManagerConfiguration?: InputMaybe<CarDataServiceQueueManagerConfigInput>;
  SessionManagerConfiguration?: InputMaybe<CarDataServiceSessionManagerConfigInput>;
  SessionTypesConfiguration?: InputMaybe<CarDataServiceSessionTypesConfigInput>;
};

export type CarDataServiceProcessingEngineConfig = {
  Calculations: Array<Maybe<Scalars['String']['output']>>;
  Exporters?: Maybe<CarDataServiceProcessingEngineConfigExporters>;
  Importer: EnumCarDataServiceProcessingEngineConfigImporter;
  Instances: Scalars['Float']['output'];
  Name: Scalars['String']['output'];
  QueueName: Scalars['String']['output'];
};

export type CarDataServiceProcessingEngineConfigExporters = {
  ATLAS10_EXPORTER?: Maybe<Scalars['JSON']['output']>;
  JSONFILE_EXPORTER?: Maybe<Scalars['JSON']['output']>;
  ONERACEHUB_EXPORTER?: Maybe<Scalars['JSON']['output']>;
  PARQUETFILE_EXPORTER?: Maybe<Scalars['JSON']['output']>;
  WINTAX_EXPORTER?: Maybe<CarDataServiceProcessingEngineConfigExportersWintax_Exporter>;
};

export type CarDataServiceProcessingEngineConfigExportersInput = {
  ATLAS10_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  JSONFILE_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  ONERACEHUB_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  PARQUETFILE_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  WINTAX_EXPORTER?: InputMaybe<CarDataServiceProcessingEngineConfigExportersWintax_ExporterInput>;
};

export type CarDataServiceProcessingEngineConfigExportersWintax_Exporter = {
  /** NAme of paremeter in the parameter map, tracking the distance of current lap. */
  DISTANCE_CHANNEL?: Maybe<Scalars['String']['output']>;
  /** Fuel consumption of the current lap. Could be a KPI like 'sLap.Lap.Max' or a fixed value like '2453.2'. */
  FUEL_CONSUMPTION?: Maybe<Scalars['String']['output']>;
  /** Fuel level of the current lap. Could be a KPI like 'ERESSRaceFIA.Lap.Last' or a fixed value like '90.3'. */
  FUEL_LEVEL?: Maybe<Scalars['String']['output']>;
  /** Effective distance of the current lap. COuld be a KPI like 'ELap.Lap.Integral' or a fixed valued like '10.4'. */
  LAP_DISTANCE?: Maybe<Scalars['String']['output']>;
  /** Contains the folder, where the exported WinTAX files are stored. */
  OUTPUT_PATH?: Maybe<Scalars['String']['output']>;
  SIMULATE_CALLS?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the folder, where the TelDataZtx dll files are stored. */
  TELDATAZTX_PATH?: Maybe<Scalars['String']['output']>;
};

export type CarDataServiceProcessingEngineConfigExportersWintax_ExporterInput = {
  /** NAme of paremeter in the parameter map, tracking the distance of current lap. */
  DISTANCE_CHANNEL?: InputMaybe<Scalars['String']['input']>;
  /** Fuel consumption of the current lap. Could be a KPI like 'sLap.Lap.Max' or a fixed value like '2453.2'. */
  FUEL_CONSUMPTION?: InputMaybe<Scalars['String']['input']>;
  /** Fuel level of the current lap. Could be a KPI like 'ERESSRaceFIA.Lap.Last' or a fixed value like '90.3'. */
  FUEL_LEVEL?: InputMaybe<Scalars['String']['input']>;
  /** Effective distance of the current lap. COuld be a KPI like 'ELap.Lap.Integral' or a fixed valued like '10.4'. */
  LAP_DISTANCE?: InputMaybe<Scalars['String']['input']>;
  /** Contains the folder, where the exported WinTAX files are stored. */
  OUTPUT_PATH?: InputMaybe<Scalars['String']['input']>;
  SIMULATE_CALLS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contains the folder, where the TelDataZtx dll files are stored. */
  TELDATAZTX_PATH?: InputMaybe<Scalars['String']['input']>;
};

export type CarDataServiceProcessingEngineConfigInput = {
  Calculations: Array<InputMaybe<Scalars['String']['input']>>;
  Exporters?: InputMaybe<CarDataServiceProcessingEngineConfigExportersInput>;
  Importer: EnumCarDataServiceProcessingEngineConfigImporter;
  Instances: Scalars['Float']['input'];
  Name: Scalars['String']['input'];
  QueueName: Scalars['String']['input'];
};

export type CarDataServiceProcessingEnginesConfig = {
  ExportersFolder?: Maybe<Scalars['String']['output']>;
  ImportersFolder?: Maybe<Scalars['String']['output']>;
  InternalCalculationsFolder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use ORHCalculationIDs the root of the car data service config instead */
  ORHCalculationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** @deprecated Look at calculations from the root of the car data service config instead */
  ORHCalculations: Array<Calculation>;
  ParameterMapFile?: Maybe<Scalars['String']['output']>;
  ProcessingEngineConfiguration?: Maybe<Array<Maybe<CarDataServiceProcessingEngineConfig>>>;
  UserCalculationsFolder?: Maybe<Scalars['String']['output']>;
};

export type CarDataServiceProcessingEnginesConfigInput = {
  ExportersFolder?: InputMaybe<Scalars['String']['input']>;
  ImportersFolder?: InputMaybe<Scalars['String']['input']>;
  InternalCalculationsFolder?: InputMaybe<Scalars['String']['input']>;
  ORHCalculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  ParameterMapFile?: InputMaybe<Scalars['String']['input']>;
  ProcessingEngineConfiguration?: InputMaybe<Array<InputMaybe<CarDataServiceProcessingEngineConfigInput>>>;
  UserCalculationsFolder?: InputMaybe<Scalars['String']['input']>;
};

export type CarDataServiceQueueDefinition = {
  Name: Scalars['String']['output'];
  SessionType: Scalars['String']['output'];
};

export type CarDataServiceQueueDefinitionInput = {
  Name: Scalars['String']['input'];
  SessionType: Scalars['String']['input'];
};

export type CarDataServiceQueueManagerConfig = {
  Queues?: Maybe<Array<Maybe<CarDataServiceQueueDefinition>>>;
};

export type CarDataServiceQueueManagerConfigInput = {
  Queues?: InputMaybe<Array<InputMaybe<CarDataServiceQueueDefinitionInput>>>;
};

export type CarDataServiceSessionManagerConfig = {
  OffloadFolder: Scalars['String']['output'];
  OffloadSessionTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CarDataServiceSessionManagerConfigInput = {
  OffloadFolder: Scalars['String']['input'];
  OffloadSessionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CarDataServiceSessionTypeConfig = {
  exts: Array<Maybe<Scalars['String']['output']>>;
  folderUpLevel: Scalars['Int']['output'];
  ignoreLiterals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  regExpressions: Array<Maybe<Scalars['String']['output']>>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type CarDataServiceSessionTypeConfigInput = {
  exts: Array<InputMaybe<Scalars['String']['input']>>;
  folderUpLevel: Scalars['Int']['input'];
  ignoreLiterals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  regExpressions: Array<InputMaybe<Scalars['String']['input']>>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type CarDataServiceSessionTypesConfig = {
  SessionTypes?: Maybe<Array<Maybe<CarDataServiceSessionTypeConfig>>>;
};

export type CarDataServiceSessionTypesConfigInput = {
  SessionTypes?: InputMaybe<Array<InputMaybe<CarDataServiceSessionTypeConfigInput>>>;
};

export type CarEnd = {
  aCamber?: Maybe<Scalars['Float']['output']>;
  aCamberMeasurement?: Maybe<Scalars['Float']['output']>;
  aCaster?: Maybe<Scalars['Float']['output']>;
  aCasterMeasurement?: Maybe<Scalars['Float']['output']>;
  aToe?: Maybe<Scalars['Float']['output']>;
  aToeMeasurement?: Maybe<Scalars['Float']['output']>;
  antiRollBar?: Maybe<AntiRollBar>;
  bumpStop?: Maybe<BumpStop>;
  damper?: Maybe<Damper>;
  droopStop?: Maybe<DroopStop>;
  externalBumpStop?: Maybe<ExternalBumpStop>;
  hRide?: Maybe<Scalars['Float']['output']>;
  hRideChassis?: Maybe<Scalars['Float']['output']>;
  /** Point where the mechanic is measuring the ride height */
  hRideMeasurement?: Maybe<Scalars['Float']['output']>;
  /**
   * Baseline pushrod length, steering rack bumpsteer adjust might depend on the rough range of ride heights the car is running in.
   * @deprecated
   */
  hRideRange?: Maybe<Scalars['String']['output']>;
  /** Point where the regulation authority is measuring the ride height */
  hRideRegulation?: Maybe<Scalars['Float']['output']>;
  helperSpring?: Maybe<Spring>;
  /** @deprecated  */
  kinematics?: Maybe<Kinematics>;
  kinematicsExternalSpec?: Maybe<KinematicsExternalSpec>;
  kinematicsExternalSpecID?: Maybe<Scalars['MongoID']['output']>;
  kinematicsInternalSpec?: Maybe<KinematicsInternalSpec>;
  kinematicsInternalSpecID?: Maybe<Scalars['MongoID']['output']>;
  reboundSpring?: Maybe<Spring>;
  spring?: Maybe<Spring>;
  /** @deprecated  */
  thirdElement?: Maybe<ThirdElement>;
  xToe?: Maybe<Scalars['Float']['output']>;
  xToeMeasurement?: Maybe<Scalars['Float']['output']>;
};

export type CarEndInput = {
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<Scalars['Float']['input']>;
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  antiRollBar?: InputMaybe<AntiRollBarInput>;
  bumpStop?: InputMaybe<BumpStopInput>;
  damper?: InputMaybe<DamperInput>;
  droopStop?: InputMaybe<DroopStopInput>;
  externalBumpStop?: InputMaybe<ExternalBumpStopInput>;
  hRide?: InputMaybe<Scalars['Float']['input']>;
  hRideChassis?: InputMaybe<Scalars['Float']['input']>;
  /** Point where the mechanic is measuring the ride height */
  hRideMeasurement?: InputMaybe<Scalars['Float']['input']>;
  /** Baseline pushrod length, steering rack bumpsteer adjust might depend on the rough range of ride heights the car is running in. */
  hRideRange?: InputMaybe<Scalars['String']['input']>;
  /** Point where the regulation authority is measuring the ride height */
  hRideRegulation?: InputMaybe<Scalars['Float']['input']>;
  helperSpring?: InputMaybe<SpringInput>;
  kinematics?: InputMaybe<KinematicsInput>;
  kinematicsExternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  kinematicsInternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  reboundSpring?: InputMaybe<SpringInput>;
  spring?: InputMaybe<SpringInput>;
  thirdElement?: InputMaybe<ThirdElementInput>;
  xToe?: InputMaybe<Scalars['Float']['input']>;
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type CarGpsDataPoint = {
  acronym?: Maybe<Scalars['String']['output']>;
  /** Is this point interpolated, as a result of being missing from the data source? */
  interpolated?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  startNumber?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['Date']['output'];
  /** Type of GPS data point. For example, `"Raw"` */
  type?: Maybe<Scalars['String']['output']>;
};

export type CarGpsDataPointInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  /** Is this point interpolated, as a result of being missing from the data source? */
  interpolated?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
  timestamp: Scalars['Date']['input'];
  /** Type of GPS data point. For example, `"Raw"` */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CarInfo = {
  /** Number of changes */
  NChanges?: Maybe<Scalars['Float']['output']>;
  /** Number of issues */
  NIssue?: Maybe<Scalars['Float']['output']>;
  batteryID?: Maybe<Scalars['String']['output']>;
  chassisID?: Maybe<Scalars['String']['output']>;
  /** A map of custom IDs for this setup. Input syntax is array of key-value (string-string) tuples. */
  customIDs?: Maybe<Scalars['JSON']['output']>;
  driveshaftID?: Maybe<Scalars['String']['output']>;
  engineID?: Maybe<Scalars['String']['output']>;
  gearboxID?: Maybe<Scalars['String']['output']>;
  inverterID?: Maybe<Scalars['String']['output']>;
  setupComments?: Maybe<Scalars['String']['output']>;
  /** Tyre compound for which this setup is intended */
  tyreCompound?: Maybe<Scalars['String']['output']>;
};

export type CarInfoInput = {
  /** Number of changes */
  NChanges?: InputMaybe<Scalars['Float']['input']>;
  /** Number of issues */
  NIssue?: InputMaybe<Scalars['Float']['input']>;
  batteryID?: InputMaybe<Scalars['String']['input']>;
  chassisID?: InputMaybe<Scalars['String']['input']>;
  /** A map of custom IDs for this setup. Input syntax is array of key-value (string-string) tuples. */
  customIDs?: InputMaybe<Scalars['JSON']['input']>;
  driveshaftID?: InputMaybe<Scalars['String']['input']>;
  engineID?: InputMaybe<Scalars['String']['input']>;
  gearboxID?: InputMaybe<Scalars['String']['input']>;
  inverterID?: InputMaybe<Scalars['String']['input']>;
  setupComments?: InputMaybe<Scalars['String']['input']>;
  /** Tyre compound for which this setup is intended */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
};

export type CarMass = {
  comment?: Maybe<Scalars['String']['output']>;
  /** Front-left mass */
  mCarFL?: Maybe<Scalars['Float']['output']>;
  /** Front-right mass */
  mCarFR?: Maybe<Scalars['Float']['output']>;
  /** Rear-left mass */
  mCarRL?: Maybe<Scalars['Float']['output']>;
  /** Rear-right mass */
  mCarRR?: Maybe<Scalars['Float']['output']>;
  /** Sum of FL, FR, RL, and RR */
  mCarTotal?: Maybe<Scalars['Float']['output']>;
  /** Driver mass */
  mDriver?: Maybe<Scalars['Float']['output']>;
  /** Cross ratio ((FR_RL)/total) */
  rCarCross?: Maybe<Scalars['Float']['output']>;
  /** Portion of mass in the front of the car */
  rWeightF?: Maybe<Scalars['Float']['output']>;
  /** Target portion of mass in the front of the car */
  rWeightFTarget?: Maybe<Scalars['Float']['output']>;
};

export type CarMassInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Front-left mass */
  mCarFL?: InputMaybe<Scalars['Float']['input']>;
  /** Front-right mass */
  mCarFR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-left mass */
  mCarRL?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-right mass */
  mCarRR?: InputMaybe<Scalars['Float']['input']>;
  /** Driver mass */
  mDriver?: InputMaybe<Scalars['Float']['input']>;
  /** Target portion of mass in the front of the car */
  rWeightFTarget?: InputMaybe<Scalars['Float']['input']>;
};

export type CarSetup = {
  _id: Scalars['MongoID']['output'];
  aero?: Maybe<Aero>;
  aeroPackage?: Maybe<AeroPackage>;
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  brakeSystem?: Maybe<BrakeSystem>;
  chassis?: Maybe<Chassis>;
  chassisAssembly?: Maybe<ChassisAssembly>;
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  chassisID?: Maybe<Scalars['MongoID']['output']>;
  chassisSpec?: Maybe<ChassisSpec>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  chassisSpecRoot?: Maybe<ChassisSpec>;
  chassisSpecRootID?: Maybe<Scalars['MongoID']['output']>;
  cockpit?: Maybe<Cockpit>;
  /** Contestant specified in this setup's linked run sheet. */
  contestantID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  custom?: Maybe<Scalars['JSON']['output']>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: Maybe<Scalars['JSON']['output']>;
  /** Enable custom simulation payload for this setup. You as a user are responsible to have meaningful data in there. */
  customSimulationPayloadEnabled?: Maybe<Scalars['Boolean']['output']>;
  driver?: Maybe<Person>;
  driverID?: Maybe<Scalars['MongoID']['output']>;
  engineer?: Maybe<Person>;
  engineerID?: Maybe<Scalars['MongoID']['output']>;
  /** Event linked to the session specified in this setup's linked run sheet. */
  eventID?: Maybe<Scalars['MongoID']['output']>;
  /** Flattened hashmap of car setup fields. Keys are associated with the `fieldKey` from setup sheet styles. */
  flattened?: Maybe<Scalars['JSON']['output']>;
  /** Flattened hashmap of car setup fields. Keys are associated with the `fieldKey` from setup sheet styles. Values are simply the values. */
  flattenedValues?: Maybe<Scalars['JSON']['output']>;
  front?: Maybe<CarEnd>;
  frontLeft?: Maybe<CarCorner>;
  frontRight?: Maybe<CarCorner>;
  history: Array<History>;
  historyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  info?: Maybe<CarInfo>;
  intendedForSession?: Maybe<EnumCarSetupIntendedForSession>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedBy?: Maybe<Person>;
  lastModifiedByID?: Maybe<Scalars['MongoID']['output']>;
  /** Map of ballast positions to their masses. Keys are names of the positions and values are the masses. Input syntax is array of key-value tuples, like `mBallasts: [["front", 10], ["rear", 20]]`. */
  mBallasts?: Maybe<Scalars['JSON']['output']>;
  manualEndMileage?: Maybe<Scalars['Float']['output']>;
  manualStartMileage?: Maybe<Scalars['Float']['output']>;
  /** Mass out of garage (with driver in the seat) */
  massOutOfGarage?: Maybe<CarMass>;
  /** Mass at the scales of the regulatory authority */
  massRegulation?: Maybe<CarMass>;
  /** Mass from car setup */
  massSetup?: Maybe<CarMass>;
  /** Mass from regulation scale replica in garage (team's scales) */
  massTeam?: Maybe<CarMass>;
  /** @deprecated Use powertrainFront, powertrainRear, powertrainCentral instead. */
  powertrain?: Maybe<Powertrain>;
  powertrainCentral?: Maybe<Powertrain>;
  powertrainFront?: Maybe<Powertrain>;
  powertrainRear?: Maybe<Powertrain>;
  rear?: Maybe<CarEnd>;
  rearLeft?: Maybe<CarCorner>;
  rearRight?: Maybe<CarCorner>;
  runSheet?: Maybe<RunSheet>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  /** Small info string */
  setupInfo?: Maybe<Scalars['String']['output']>;
  /** Override of setup sheet style, which usually comes from the chassis. */
  setupSheetStyle?: Maybe<EnumCarSetupSetupSheetStyle>;
  steering?: Maybe<Steering>;
  /** Map containing systems config comments. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigComment?: Maybe<Scalars['JSON']['output']>;
  /** Map containing systems config NIssue data. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigNIssues?: Maybe<Scalars['JSON']['output']>;
  /** Map containing systems config values. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigValues?: Maybe<Scalars['JSON']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  team?: Maybe<Team>;
  teamID?: Maybe<Scalars['MongoID']['output']>;
  time?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
  /** @deprecated Use tyre set from a linked run sheet instead. */
  tyreSet?: Maybe<TyreSet>;
  /** @deprecated Use tyre set from a linked run sheet instead. */
  tyreSetID?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  writeHistory?: Maybe<Scalars['Boolean']['output']>;
};

export type CarSetupChanged = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CarSetupInfo = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  setupInfo?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type CarSetupPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CarSetup>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CarTrackPosition = {
  distance?: Maybe<Scalars['Float']['output']>;
  driverTLA?: Maybe<Scalars['String']['output']>;
  onTrack?: Maybe<Scalars['Boolean']['output']>;
  pace?: Maybe<Scalars['Float']['output']>;
  startNumber: Scalars['String']['output'];
};

export type CarTrackPositionInput = {
  distance?: InputMaybe<Scalars['Float']['input']>;
  driverTLA?: InputMaybe<Scalars['String']['input']>;
  onTrack?: InputMaybe<Scalars['Boolean']['input']>;
  pace?: InputMaybe<Scalars['Float']['input']>;
  startNumber: Scalars['String']['input'];
};

export type Chassis = {
  _id: Scalars['MongoID']['output'];
  /** Allowable keys for ballast measurements in car setups that use this chassis. */
  ballastPositions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  currentlyInUse?: Maybe<Scalars['Boolean']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  manufacturerPartID?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier for the chassis */
  reference?: Maybe<Scalars['String']['output']>;
  rootAssemblies: Array<ChassisAssembly>;
  rootAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  rootSpecification?: Maybe<ChassisSpec>;
  rootSpecificationID?: Maybe<Scalars['MongoID']['output']>;
  /**
   * Map of setup sheet fields to available preset values. Keys are like `"front.kSpringF"`, and values are lists of options. Input syntax is array of key-value tuples, like `setupOptions: [["front.kSpringF", [100, 110, 120]]]`.
   * @deprecated Use the new adjustable fields instead
   */
  setupOptions?: Maybe<Scalars['JSON']['output']>;
  setupSheetStyle?: Maybe<EnumChassisSetupSheetStyle>;
  specification?: Maybe<ChassisSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  /** Allowable keys for systems config maps in car setups that use this chassis. */
  systemsConfigFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** Car type */
  type?: Maybe<Scalars['String']['output']>;
};

export type ChassisAssembly = AnyAssembly & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  allPartInstanceActive?: Maybe<Scalars['Boolean']['output']>;
  assemblyTemplateID?: Maybe<Scalars['MongoID']['output']>;
  assemblyTypeEnum?: Maybe<UserEnumAssemblyType>;
  assemblyTypeEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetDisplayLocations: Array<UserEnumBuildSheetGroup>;
  buildSheetGroupEnum?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetGroupEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetNestLevel?: Maybe<Scalars['Float']['output']>;
  carSetup?: Maybe<CarSetup>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  chassisMeasurements?: Maybe<Array<Maybe<ChassisAssemblyMeasurement>>>;
  chassisPartID?: Maybe<Scalars['MongoID']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Is this the current version of this assembly, or just a historical snapshot? */
  current?: Maybe<Scalars['Boolean']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  /** Location of this assembly referring to a socket. For example, `frontLeft` or `cockpit`. */
  locationID?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  nestedPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  nestedPartInstances: Array<PartInstance>;
  partInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  partInstances: Array<PartInstance>;
  properties?: Maybe<Scalars['JSON']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  subAssemblies: Array<SubAssembly>;
  subAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingSourceRecords?: Maybe<Array<Maybe<ChassisAssemblyTrackingSourceRecord>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumAssemblyTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type ChassisAssemblyMeasurement = {
  chassisSpecMeasurement?: Maybe<ChassisMeasurement>;
  chassisSpecMeasurementID?: Maybe<Scalars['MongoID']['output']>;
  location?: Maybe<AdjustableLocation>;
  orientation?: Maybe<AdjustableOrientation>;
};

export type ChassisAssemblyMeasurementInput = {
  chassisSpecMeasurementID?: InputMaybe<Scalars['MongoID']['input']>;
  location?: InputMaybe<AdjustableLocationInput>;
  orientation?: InputMaybe<AdjustableOrientationInput>;
};

export type ChassisAssemblyTrackingSourceRecord = {
  sources?: Maybe<Array<Maybe<ChassisAssemblyTrackingSourceRecordSources>>>;
  trackingSource?: Maybe<TrackingSource>;
  trackingSourceID?: Maybe<Scalars['MongoID']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ChassisAssemblyTrackingSourceRecordInput = {
  sources?: InputMaybe<Array<InputMaybe<ChassisAssemblyTrackingSourceRecordSourcesInput>>>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type ChassisAssemblyTrackingSourceRecordSources = {
  /** priority of this source. Defined on the alias but saved here for efficiency reasons */
  priority?: Maybe<Scalars['Float']['output']>;
  trackingSourceAliasID?: Maybe<Scalars['MongoID']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ChassisAssemblyTrackingSourceRecordSourcesInput = {
  /** priority of this source. Defined on the alias but saved here for efficiency reasons */
  priority?: InputMaybe<Scalars['Float']['input']>;
  trackingSourceAliasID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type ChassisMass = {
  /** Base mass properties of the vehicle */
  base?: Maybe<MassProperties>;
  /** Mass properties of the driver */
  driver?: Maybe<MassProperties>;
  setupEquip?: Maybe<MassProperties>;
};

export type ChassisMassInput = {
  /** Base mass properties of the vehicle */
  base?: InputMaybe<MassPropertiesInput>;
  /** Mass properties of the driver */
  driver?: InputMaybe<MassPropertiesInput>;
  setupEquip?: InputMaybe<MassPropertiesInput>;
};

export type ChassisMeasurement = {
  _id: Scalars['MongoID']['output'];
  chassisSpecID: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** List of items with pagination. */
export type ChassisMeasurementPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ChassisMeasurement>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ChassisMeasurements = {
  /** Default angle unit to display in setup options for this chassis */
  angles?: Maybe<EnumAngleUnit>;
  /** Default angular compliance unit to display in setup options for this chassis */
  angularCompliances?: Maybe<EnumAngularComplianceUnit>;
  /** Default angular torque compliance unit to display in setup options for this chassis */
  angularTorqueCompliances?: Maybe<EnumAngularTorqueComplianceUnit>;
  bumpPlateMeasurementMethod?: Maybe<EnumBumpPlateMeasurementMethod>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefFront?: Maybe<Scalars['Float']['output']>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefRear?: Maybe<Scalars['Float']['output']>;
  /** Default compliance unit to display in setup options for this chassis */
  compliances?: Maybe<EnumComplianceUnit>;
  /** Default force unit to display in setup options for this chassis */
  forces?: Maybe<EnumForceUnit>;
  /** Default inertia unit to display in setup options for this chassis */
  inertias?: Maybe<EnumInertiaUnit>;
  /** If true, positive camber is top leaning in. If false, negative camber is top leaning in. */
  inverseCamber?: Maybe<Scalars['Boolean']['output']>;
  kinematicsExternalReadingsRequired?: Maybe<EnumChassisMeasurementsKinematicsExternalReadingsRequired>;
  kinematicsInternalReadingsRequired?: Maybe<EnumChassisMeasurementsKinematicsInternalReadingsRequired>;
  /** Default length unit to display in setup options for this chassis */
  lengths?: Maybe<EnumLengthUnit>;
  /** Default mass unit to display in setup options for this chassis */
  masses?: Maybe<EnumMassUnit>;
  /** Default power unit to display in setup options for this chassis */
  powers?: Maybe<EnumPowerUnit>;
  /** Default pressure unit to display in setup options for this chassis */
  pressures?: Maybe<EnumPressureUnit>;
  /** Default ratio unit to display in setup options for this chassis */
  ratios?: Maybe<EnumRatioUnit>;
  /** Function to calculate front ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcFront?: Maybe<Scalars['String']['output']>;
  /** Function to calculate rear ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcRear?: Maybe<Scalars['String']['output']>;
  /** Default spring rate unit to display in setup options for this chassis */
  springRates?: Maybe<EnumSpringRateUnit>;
  /** Default steering rack ratio unit to display in setup options for this chassis */
  steeringRackRatios?: Maybe<EnumSteeringRackRatioUnit>;
  /** Default temperature unit to display in setup options for this chassis */
  temperatures?: Maybe<EnumTemperatureUnit>;
  toeMeasurementMethod?: Maybe<EnumToeMeasurementMethod>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefFront?: Maybe<Scalars['Float']['output']>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefRear?: Maybe<Scalars['Float']['output']>;
  /**
   * If true, toe measurement is given as total over axle. If false, toe measurement is per individual wheel.
   * @deprecated
   */
  toeTotal?: Maybe<Scalars['Boolean']['output']>;
  /** Default torque unit to display in setup options for this chassis */
  torques?: Maybe<EnumTorqueUnit>;
  /** Default torsion rate unit to display in setup options for this chassis */
  torsionRates?: Maybe<EnumTorsionRateUnit>;
  /** Default volume unit to display in setup options for this chassis */
  volumes?: Maybe<EnumVolumeUnit>;
  xTrackFront?: Maybe<Scalars['Float']['output']>;
  xTrackRear?: Maybe<Scalars['Float']['output']>;
  /** Wheelbase length in metres */
  xWheelbase?: Maybe<Scalars['Float']['output']>;
};

export type ChassisMeasurementsInput = {
  /** Default angle unit to display in setup options for this chassis */
  angles?: InputMaybe<EnumAngleUnit>;
  /** Default angular compliance unit to display in setup options for this chassis */
  angularCompliances?: InputMaybe<EnumAngularComplianceUnit>;
  /** Default angular torque compliance unit to display in setup options for this chassis */
  angularTorqueCompliances?: InputMaybe<EnumAngularTorqueComplianceUnit>;
  bumpPlateMeasurementMethod?: InputMaybe<EnumBumpPlateMeasurementMethod>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefFront?: InputMaybe<Scalars['Float']['input']>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefRear?: InputMaybe<Scalars['Float']['input']>;
  /** Default compliance unit to display in setup options for this chassis */
  compliances?: InputMaybe<EnumComplianceUnit>;
  /** Default force unit to display in setup options for this chassis */
  forces?: InputMaybe<EnumForceUnit>;
  /** Default inertia unit to display in setup options for this chassis */
  inertias?: InputMaybe<EnumInertiaUnit>;
  /** If true, positive camber is top leaning in. If false, negative camber is top leaning in. */
  inverseCamber?: InputMaybe<Scalars['Boolean']['input']>;
  kinematicsExternalReadingsRequired?: InputMaybe<EnumChassisMeasurementsKinematicsExternalReadingsRequired>;
  kinematicsInternalReadingsRequired?: InputMaybe<EnumChassisMeasurementsKinematicsInternalReadingsRequired>;
  /** Default length unit to display in setup options for this chassis */
  lengths?: InputMaybe<EnumLengthUnit>;
  /** Default mass unit to display in setup options for this chassis */
  masses?: InputMaybe<EnumMassUnit>;
  /** Default power unit to display in setup options for this chassis */
  powers?: InputMaybe<EnumPowerUnit>;
  /** Default pressure unit to display in setup options for this chassis */
  pressures?: InputMaybe<EnumPressureUnit>;
  /** Default ratio unit to display in setup options for this chassis */
  ratios?: InputMaybe<EnumRatioUnit>;
  /** Function to calculate front ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcFront?: InputMaybe<Scalars['String']['input']>;
  /** Function to calculate rear ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcRear?: InputMaybe<Scalars['String']['input']>;
  /** Default spring rate unit to display in setup options for this chassis */
  springRates?: InputMaybe<EnumSpringRateUnit>;
  /** Default steering rack ratio unit to display in setup options for this chassis */
  steeringRackRatios?: InputMaybe<EnumSteeringRackRatioUnit>;
  /** Default temperature unit to display in setup options for this chassis */
  temperatures?: InputMaybe<EnumTemperatureUnit>;
  toeMeasurementMethod?: InputMaybe<EnumToeMeasurementMethod>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefFront?: InputMaybe<Scalars['Float']['input']>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefRear?: InputMaybe<Scalars['Float']['input']>;
  /** If true, toe measurement is given as total over axle. If false, toe measurement is per individual wheel. */
  toeTotal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default torque unit to display in setup options for this chassis */
  torques?: InputMaybe<EnumTorqueUnit>;
  /** Default torsion rate unit to display in setup options for this chassis */
  torsionRates?: InputMaybe<EnumTorsionRateUnit>;
  /** Default volume unit to display in setup options for this chassis */
  volumes?: InputMaybe<EnumVolumeUnit>;
  xTrackFront?: InputMaybe<Scalars['Float']['input']>;
  xTrackRear?: InputMaybe<Scalars['Float']['input']>;
  /** Wheelbase length in metres */
  xWheelbase?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type ChassisPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Chassis>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ChassisPowerUnit = {
  name: Scalars['String']['output'];
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
};

export type ChassisPowerUnitInput = {
  name: Scalars['String']['input'];
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type ChassisPowertrain = {
  bevelSetSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  bevelSetSpecs: Array<GearSpec>;
  differentialSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  differentialSpecs: Array<DifferentialSpec>;
  dropGearSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  dropGearSpecs: Array<GearSpec>;
  gearBoxSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  gearBoxSpecs: Array<GearBoxSpec>;
  gearSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  gearSpecs: Array<GearSpec>;
  layout?: Maybe<EnumPowertrainLayout>;
  /** Number of gears which are expected to be in the gearbox. */
  numGears?: Maybe<Scalars['Float']['output']>;
};

export type ChassisPowertrainInput = {
  bevelSetSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  differentialSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  dropGearSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  gearBoxSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  gearSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  layout?: InputMaybe<EnumPowertrainLayout>;
  /** Number of gears which are expected to be in the gearbox. */
  numGears?: InputMaybe<Scalars['Float']['input']>;
};

export type ChassisSocket = {
  /** Unique name for this socket. */
  name: Scalars['String']['output'];
};

export type ChassisSocketInput = {
  /** Unique name for this socket. */
  name: Scalars['String']['input'];
};

export type ChassisSpec = AnySpecification & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  aeroPackageSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  aeroPackageSpecs: Array<AeroPackageSpec>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  antiRollBarSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  antiRollBarSpecs: Array<AntiRollBarSpec>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** The build sheet styles to use for this chassis spec. */
  buildSheetStyles: Array<BuildSheetStyle>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  bumpRubberSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  bumpRubberSpecs: Array<ElasticSpec>;
  calculationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  calculations: Array<Calculation>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: Maybe<Scalars['String']['output']>;
  chassisMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  chassisMeasurements: Array<ChassisMeasurement>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  copyReferencePackage?: Maybe<Package>;
  copyReferencePackageID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customSimulationModels?: Maybe<Array<Maybe<SpecificationCustomSimulationModels>>>;
  customSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Types of all custom specs associated with this chassis spec */
  customSpecTypes: Array<Scalars['String']['output']>;
  customSpecs: Array<CustomSpec>;
  damperSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  damperSpecs: Array<DamperSpec>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  flattened?: Maybe<Scalars['JSON']['output']>;
  /** The keys of the flattened data. This is useful for determining which fields are available for a given chassis spec. */
  flattenedKeys?: Maybe<Array<Scalars['String']['output']>>;
  helperSpringSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  helperSpringSpecs: Array<ElasticSpec>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<ChassisSpec>;
  kinematicsExternalSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  kinematicsExternalSpecs: Array<KinematicsExternalSpec>;
  kinematicsInternalSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  kinematicsInternalSpecs: Array<KinematicsInternalSpec>;
  mass?: Maybe<ChassisMass>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: Maybe<ChassisMeasurements>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: Maybe<Array<Maybe<EnumSimModelType>>>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyles: Array<SetupSheetStyle>;
  powerUnits?: Maybe<Array<Maybe<ChassisPowerUnit>>>;
  powertrain?: Maybe<ChassisPowertrain>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  rBrakeBias?: Maybe<AdjustableRatio>;
  reboundSpringSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  reboundSpringSpecs: Array<ElasticSpec>;
  regulationSets?: Maybe<Array<Maybe<RegulationSet>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: Maybe<Scalars['Date']['output']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  setupChangesFilter?: Maybe<SpecificationSetupChangesFilter>;
  setupSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** ID of the setup sheet style to use in the simulaiton page for this chassis. */
  setupSheetStyleSimulation?: Maybe<SetupSheetStyle>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: Maybe<Scalars['MongoID']['output']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTable?: Maybe<SetupSheetStyle>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: Maybe<Scalars['MongoID']['output']>;
  /** The setup sheet styles to use for this chassis spec. */
  setupSheetStyles: Array<SetupSheetStyle>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  /** Locations/areas that components can be installed in. */
  sockets?: Maybe<Array<Maybe<ChassisSocket>>>;
  specificationGroupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  specificationGroups: Array<SpecificationGroup>;
  springSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  springSpecs: Array<ElasticSpec>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  torsionBarSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  torsionBarSpecs: Array<ElasticSpec>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingSourceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingSources: Array<TrackingSource>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** User-supplied version of this specification. */
  version?: Maybe<Scalars['String']['output']>;
};

export type ClaimCarSetupResult = {
  success: Scalars['Boolean']['output'];
};

export type ClaimRunSheetResult = {
  success: Scalars['Boolean']['output'];
};

export type ClonePackageResolverResult = {
  recordId: Scalars['MongoID']['output'];
};

export type Cockpit = {
  /** Ratio of the throttle pedal */
  rThrottlePedal?: Maybe<Scalars['Float']['output']>;
  /** Position of the throttle pedal */
  throttlePedalPosition?: Maybe<Scalars['String']['output']>;
};

export type CockpitInput = {
  /** Ratio of the throttle pedal */
  rThrottlePedal?: InputMaybe<Scalars['Float']['input']>;
  /** Position of the throttle pedal */
  throttlePedalPosition?: InputMaybe<Scalars['String']['input']>;
};

export type Comment = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  files: Array<Maybe<AttachedFile>>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CommentBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  field: EnumCommentBlockField;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isAlwaysOpen?: Maybe<Scalars['Boolean']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type CommentInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type ComplianceUnitField = {
  unit: EnumComplianceUnit;
};

export type Contestant = {
  _id: Scalars['MongoID']['output'];
  chassis: Array<Chassis>;
  /** IDs of usable chassis */
  chassisIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Number of the chassis for this contestant. */
  chassisNumber?: Maybe<Scalars['String']['output']>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: Maybe<Scalars['String']['output']>;
  /** Default color to use for this contestant where applicable. */
  color?: Maybe<Scalars['String']['output']>;
  /** Drivers that constitute this contestant */
  driverIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  drivers: Array<Person>;
  /** Is this contestant eligible for points? */
  eligibleForPoints?: Maybe<Scalars['Boolean']['output']>;
  /** Should this contestant be hidden from users? */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Manufacturer>;
  manufacturerID?: Maybe<Scalars['MongoID']['output']>;
  season?: Maybe<Season>;
  /** Season that this contestant is participating in */
  seasonID: Scalars['MongoID']['output'];
  startNumber: Scalars['String']['output'];
  team?: Maybe<Team>;
  teamID?: Maybe<Scalars['MongoID']['output']>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyContestantID?: Maybe<Scalars['String']['output']>;
  /** URI to the audio stream for this contestant in Transcribble. */
  transcribbleAudioURI?: Maybe<Scalars['String']['output']>;
  /** Tyres assigned to this contestant for the season. */
  tyreIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tyre sets assigned to this contestant for the season. */
  tyreSetIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tyreSets: Array<TyreSet>;
  tyres: Array<Tyre>;
};

/** Field to target with this mutation. */
export const ContestantField = {
  /** → `chassisIDs` */
  CHASSIS: 'CHASSIS',
  /** → `driverIDs` */
  DRIVERS: 'DRIVERS'
} as const;

export type ContestantField = typeof ContestantField[keyof typeof ContestantField];
/** List of items with pagination. */
export type ContestantPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Contestant>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CopyAssemblyResult = {
  newAssemblyID?: Maybe<Scalars['MongoID']['output']>;
};

export type CopyEventOverridesInput = {
  /** Density of the fuel */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Number of this event in the season */
  NEventSeason?: InputMaybe<Scalars['Float']['input']>;
  /** Default SoCRequired values to use during this event (assuming single track layout) */
  SoCRequired?: InputMaybe<RunEnergyInput>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Fuel/SoC/Energy consumptions for each track layout in this event. */
  consumptions?: InputMaybe<Array<InputMaybe<LayoutConsumptionInput>>>;
  contestants?: InputMaybe<Array<InputMaybe<EventContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumEventDebriefNotesMode>;
  /** Default energyRequired values to use during this event (assuming single track layout) */
  energyRequired?: InputMaybe<RunEnergyInput>;
  /** Energy sweep information for Formula E */
  energySweep?: InputMaybe<Scalars['JSON']['input']>;
  enumEventType?: InputMaybe<EnumEventEnumEventType>;
  enumEventVenue?: InputMaybe<EnumEventEnumEventVenue>;
  /** e.g. Race, Test, etc. */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Default fuelRequired values to use during this event (assuming single track layout) */
  fuelRequired?: InputMaybe<RunEnergyInput>;
  /** Should the iRacing service populate this event when an unknown event is encountered? */
  iRacingServiceIsNextEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of issues related to this event. */
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Reference laptimes for each track layout in this event. */
  referenceLaptimes?: InputMaybe<Array<InputMaybe<EventReferenceLaptimesInput>>>;
  /** Selected authors for the event report (person reference plus a name snapshot). */
  reportAuthors?: InputMaybe<Array<InputMaybe<EventReportAuthorsInput>>>;
  /** Time of event end in local time */
  tEventEnd?: InputMaybe<Scalars['Date']['input']>;
  tLapAverage?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyEventID?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  trackID?: InputMaybe<Scalars['MongoID']['input']>;
  trackLayoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumEventType>;
  tyreDefaults?: InputMaybe<Array<InputMaybe<EventTyreDefaultsSetInput>>>;
  tyreDefaultsFL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsFR?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsRL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsRR?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetFL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetFR?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetRL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetRR?: InputMaybe<EventTyreDefaultsInput>;
};

export type CreateBackupResult = {
  created: Scalars['String']['output'];
};

export type CreateManyJobInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Float']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  /** The id of the parent job or issue that this task is assigned to */
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyJobPayload = {
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Job>>;
};

export type CreateManyTimeSheetEntryInput = {
  /** Whether a person did work on this day */
  absent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notes about what was done during this time */
  description?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Clock-out time */
  tEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Clock-in time */
  tStart: Scalars['Date']['input'];
};

export type CreateManyTimeSheetEntryPayload = {
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<TimeSheetEntry>>;
};

export type CreateOneAssemblyInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assemblyTemplateID?: InputMaybe<Scalars['MongoID']['input']>;
  assemblyTypeEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetGroupEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetNestLevel?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisMeasurements?: InputMaybe<Array<InputMaybe<ChassisAssemblyMeasurementInput>>>;
  chassisPartID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this the current version of this assembly, or just a historical snapshot? */
  current?: InputMaybe<Scalars['Boolean']['input']>;
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Location of this assembly referring to a socket. For example, `frontLeft` or `cockpit`. */
  locationID?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  subAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceRecords?: InputMaybe<Array<InputMaybe<ChassisAssemblyTrackingSourceRecordInput>>>;
  type?: EnumAssemblyType;
  userEnumAssemblyTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneAssemblyPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Assembly>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneAssemblyTemplateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  requiredAssemblies?: InputMaybe<Array<InputMaybe<AssemblyTemplateRequiredAssembliesInput>>>;
  requiredParts?: InputMaybe<Array<InputMaybe<AssemblyTemplateRequiredPartsInput>>>;
};

export type CreateOneAssemblyTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<AssemblyTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneBestValuesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the contestant these personal bests belong to, if applicable. */
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the driver these personal bests belong to, if applicable. */
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  fastestLap?: InputMaybe<BestValuesFastestLapInput>;
  fastestSectors?: InputMaybe<Array<InputMaybe<BestValuesFastestSectorInput>>>;
  sessionID: Scalars['MongoID']['input'];
};

export type CreateOneBestValuesPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<BestValues>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneBopInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  bopFile?: InputMaybe<Scalars['String']['input']>;
  carBop?: InputMaybe<Array<InputMaybe<BopCarBopInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sessionBop?: InputMaybe<BopSessionBopInput>;
  sessionID: Scalars['MongoID']['input'];
};

export type CreateOneBopPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Bop>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneBuildSheetStyleInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  blocks?: InputMaybe<Array<InputMaybe<BuildSheetStyleBlockInput>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  targetEventType?: InputMaybe<EnumBuildSheetStyleTargetEventType>;
  targetRoles?: InputMaybe<Array<InputMaybe<EnumBuildSheetStyleTargetRoles>>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type: EnumBuildSheetStyleType;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneBuildSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<BuildSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCalculationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** For the client to display debug information or default return values */
  debugMode?: InputMaybe<Scalars['Boolean']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  functionString: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** The name of the parameter or path to a field which this calculation gives as output. */
  parameter: Scalars['String']['input'];
  /** The names of the parameters or paths to fields which this calculation depends on. If any of these change, the calculation should be re-run. */
  trigger: Array<Scalars['String']['input']>;
  type: EnumCalculationType;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneCalculationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Calculation>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCarDataServiceConfigInput = {
  Kpi?: InputMaybe<CarDataServiceKpiConfigInput>;
  ORHCalculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Object containing parameter mappings. Format is like: { vCar: [{ "name": "car_speed", "offset": 0, "gain": 3.6 }] } */
  ParameterMap?: InputMaybe<Scalars['JSON']['input']>;
  PostProcessingConfig?: InputMaybe<CarDataServicePostProcessingConfigInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
  raceSeriesID: Scalars['MongoID']['input'];
};

export type CreateOneCarDataServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CarDataServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCarSetupInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  aero?: InputMaybe<AeroInput>;
  aeroPackage?: InputMaybe<AeroPackageInput>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  brakeSystem?: InputMaybe<BrakeSystemInput>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecRootID?: InputMaybe<Scalars['MongoID']['input']>;
  cockpit?: InputMaybe<CockpitInput>;
  custom?: InputMaybe<Scalars['JSON']['input']>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  /** Enable custom simulation payload for this setup. You as a user are responsible to have meaningful data in there. */
  customSimulationPayloadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  engineerID?: InputMaybe<Scalars['MongoID']['input']>;
  front?: InputMaybe<CarEndInput>;
  frontLeft?: InputMaybe<CarCornerInput>;
  frontRight?: InputMaybe<CarCornerInput>;
  historyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  info?: InputMaybe<CarInfoInput>;
  intendedForSession?: InputMaybe<EnumCarSetupIntendedForSession>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Map of ballast positions to their masses. Keys are names of the positions and values are the masses. Input syntax is array of key-value tuples, like `mBallasts: [["front", 10], ["rear", 20]]`. */
  mBallasts?: InputMaybe<Scalars['JSON']['input']>;
  manualEndMileage?: InputMaybe<Scalars['Float']['input']>;
  manualStartMileage?: InputMaybe<Scalars['Float']['input']>;
  /** Mass out of garage (with driver in the seat) */
  massOutOfGarage?: InputMaybe<CarMassInput>;
  /** Mass at the scales of the regulatory authority */
  massRegulation?: InputMaybe<CarMassInput>;
  /** Mass from car setup */
  massSetup?: InputMaybe<CarMassInput>;
  /** Mass from regulation scale replica in garage (team's scales) */
  massTeam?: InputMaybe<CarMassInput>;
  powertrain?: InputMaybe<PowertrainInput>;
  powertrainCentral?: InputMaybe<PowertrainInput>;
  powertrainFront?: InputMaybe<PowertrainInput>;
  powertrainRear?: InputMaybe<PowertrainInput>;
  rear?: InputMaybe<CarEndInput>;
  rearLeft?: InputMaybe<CarCornerInput>;
  rearRight?: InputMaybe<CarCornerInput>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Small info string */
  setupInfo?: InputMaybe<Scalars['String']['input']>;
  /** Override of setup sheet style, which usually comes from the chassis. */
  setupSheetStyle?: InputMaybe<EnumCarSetupSetupSheetStyle>;
  steering?: InputMaybe<SteeringInput>;
  /** Map containing systems config comments. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigComment?: InputMaybe<Scalars['JSON']['input']>;
  /** Map containing systems config NIssue data. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigNIssues?: InputMaybe<Scalars['JSON']['input']>;
  /** Map containing systems config values. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigValues?: InputMaybe<Scalars['JSON']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
  title: Scalars['String']['input'];
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
  writeHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneCarSetupPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CarSetup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneChassisInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Allowable keys for ballast measurements in car setups that use this chassis. */
  ballastPositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  currentlyInUse?: InputMaybe<Scalars['Boolean']['input']>;
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerPartID?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  /** Unique identifier for the chassis */
  reference?: InputMaybe<Scalars['String']['input']>;
  rootAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Map of setup sheet fields to available preset values. Keys are like `"front.kSpringF"`, and values are lists of options. Input syntax is array of key-value tuples, like `setupOptions: [["front.kSpringF", [100, 110, 120]]]`. */
  setupOptions?: InputMaybe<Scalars['JSON']['input']>;
  setupSheetStyle?: InputMaybe<EnumChassisSetupSheetStyle>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Allowable keys for systems config maps in car setups that use this chassis. */
  systemsConfigFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Car type */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneChassisMeasurementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneChassisMeasurementPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ChassisMeasurement>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneChassisPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Chassis>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneContestantInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of usable chassis */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Number of the chassis for this contestant. */
  chassisNumber?: InputMaybe<Scalars['String']['input']>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** Default color to use for this contestant where applicable. */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Drivers that constitute this contestant */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Is this contestant eligible for points? */
  eligibleForPoints?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this contestant be hidden from users? */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Season that this contestant is participating in */
  seasonID: Scalars['MongoID']['input'];
  startNumber: Scalars['String']['input'];
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyContestantID?: InputMaybe<Scalars['String']['input']>;
  /** URI to the audio stream for this contestant in Transcribble. */
  transcribbleAudioURI?: InputMaybe<Scalars['String']['input']>;
  /** Tyres assigned to this contestant for the season. */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Tyre sets assigned to this contestant for the season. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneContestantPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Contestant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneDepartmentInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateOneDepartmentPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Department>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneDynoConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<DynoConfigColumnsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneDynoConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<DynoConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneEventInput = {
  /** Density of the fuel */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Number of this event in the season */
  NEventSeason?: InputMaybe<Scalars['Float']['input']>;
  /** Default SoCRequired values to use during this event (assuming single track layout) */
  SoCRequired?: InputMaybe<RunEnergyInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Fuel/SoC/Energy consumptions for each track layout in this event. */
  consumptions?: InputMaybe<Array<InputMaybe<LayoutConsumptionInput>>>;
  contestants?: InputMaybe<Array<InputMaybe<EventContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumEventDebriefNotesMode>;
  /** Default energyRequired values to use during this event (assuming single track layout) */
  energyRequired?: InputMaybe<RunEnergyInput>;
  /** Energy sweep information for Formula E */
  energySweep?: InputMaybe<Scalars['JSON']['input']>;
  enumEventType?: InputMaybe<EnumEventEnumEventType>;
  enumEventVenue?: InputMaybe<EnumEventEnumEventVenue>;
  /** e.g. Race, Test, etc. */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Default fuelRequired values to use during this event (assuming single track layout) */
  fuelRequired?: InputMaybe<RunEnergyInput>;
  /** Should the iRacing service populate this event when an unknown event is encountered? */
  iRacingServiceIsNextEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of issues related to this event. */
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name: Scalars['String']['input'];
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Reference laptimes for each track layout in this event. */
  referenceLaptimes?: InputMaybe<Array<InputMaybe<EventReferenceLaptimesInput>>>;
  /** Selected authors for the event report (person reference plus a name snapshot). */
  reportAuthors?: InputMaybe<Array<InputMaybe<EventReportAuthorsInput>>>;
  seasonID: Scalars['MongoID']['input'];
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Time of event end in local time */
  tEventEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of event start in local time */
  tEventStart?: InputMaybe<Scalars['Date']['input']>;
  tLapAverage?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyEventID?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  trackID?: InputMaybe<Scalars['MongoID']['input']>;
  trackLayoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumEventType>;
  tyreDefaults?: InputMaybe<Array<InputMaybe<EventTyreDefaultsSetInput>>>;
  tyreDefaultsFL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsFR?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsRL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsRR?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetFL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetFR?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetRL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetRR?: InputMaybe<EventTyreDefaultsInput>;
};

export type CreateOneEventPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneFlexLayoutConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  globalXAxis?: InputMaybe<FlexLayoutConfigGlobalXAxisInput>;
  intendedFor: EnumFlexLayoutConfigIntendedFor;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration recognised by flexlayout-react */
  model?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** If this is non-empty, only users with one of these roles can see this config. */
  targetRoles?: InputMaybe<Array<EnumPersonRole>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneFlexLayoutConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<FlexLayoutConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneGreeboLogInput = {
  /** Real time car positions on track */
  carPositions?: InputMaybe<Array<InputMaybe<CarTrackPositionInput>>>;
  /** Only specify if this is a greebo log for an entire event */
  eventID?: InputMaybe<Scalars['String']['input']>;
  /** GPS data from Greebo */
  gpsData?: InputMaybe<Array<InputMaybe<CarGpsDataPointInput>>>;
  /** Unprocessed lines from Greebo */
  rawLines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sessionID?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneGreeboLogPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<GreeboLog>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneIssueInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  acknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  acknowledgedByID?: InputMaybe<Scalars['MongoID']['input']>;
  area?: InputMaybe<Scalars['String']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledByID?: InputMaybe<Scalars['MongoID']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedByID?: InputMaybe<Scalars['MongoID']['input']>;
  comments?: InputMaybe<Array<InputMaybe<CommentInput>>>;
  containment?: InputMaybe<Scalars['String']['input']>;
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  createdByID?: InputMaybe<Scalars['MongoID']['input']>;
  departmentID?: InputMaybe<Scalars['MongoID']['input']>;
  description: Scalars['String']['input'];
  descriptionDetails?: InputMaybe<Scalars['String']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  issueStatus?: InputMaybe<EnumIssueIssueStatus>;
  linkedIssueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTagID?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTagLabelSort?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<EnumIssuePriority>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  rootCause?: InputMaybe<Scalars['String']['input']>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  thirdPartyIssueID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneIssuePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Issue>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneJobInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Float']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  /** The id of the parent job or issue that this task is assigned to */
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneJobPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Job>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneLapSequenceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  laps: Array<InputMaybe<LapSequenceLapsInput>>;
  name: Scalars['String']['input'];
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneLapSequencePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<LapSequence>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneLapSequenceTemplateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  laps?: InputMaybe<Array<InputMaybe<LapSequenceTemplateLapsInput>>>;
  name: Scalars['String']['input'];
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneLapSequenceTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<LapSequenceTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneLocationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<GeoLocationInput>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneLocationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Location>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneLogInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  logLevel: EnumLogLogLevel;
  /** A single log from the source service */
  message: Scalars['String']['input'];
  serviceSource: EnumLogServiceSource;
  userID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneLogPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Log>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneManufacturerInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneManufacturerPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Manufacturer>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneOneTimingWeatherServiceConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event IDs to which the weather data should be published. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Weather station's latitude from geolocation */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  logLevel?: InputMaybe<EnumOneTimingWeatherServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weather station's longitude from geolocation */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Name for this set of configuration settings. */
  name?: Scalars['String']['input'];
  /** One Timing server port. */
  timingPort: Scalars['Int']['input'];
  /** One Timing server address. */
  timingURL: Scalars['String']['input'];
  /** Time interval in seconds between two API data updates. */
  updateInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneOneTimingWeatherServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<OneTimingWeatherServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePackageInput = {
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID: Scalars['MongoID']['input'];
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<PackageItemsInput>>>;
  name: Scalars['String']['input'];
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  useAsCopyReference?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOnePackagePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Package>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePartInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Can this very part be used multiple times on a car. For 'virtual parts' or other special applications. Overrides the setting of the specification. */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  eligibleEventTypes?: InputMaybe<EnumPartEligibleEventTypes>;
  /** To be used for dummy parts or at user discretion for special applications. */
  isVirtualPart?: InputMaybe<Scalars['Boolean']['input']>;
  lifetimeMileage?: InputMaybe<Scalars['Float']['input']>;
  locationID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerPartID?: InputMaybe<Scalars['String']['input']>;
  manufacturerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  partStatus?: InputMaybe<PartStatusInput>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  readingLocationOverride?: InputMaybe<Array<InputMaybe<EnumPartReadingLocationOverride>>>;
  reference: Scalars['String']['input'];
  rootAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID: Scalars['MongoID']['input'];
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementHistoryIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOnePartInstanceInput = {
  measurements?: InputMaybe<Array<InputMaybe<PartInstanceMeasurementInput>>>;
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  readingLocation: EnumReadingLocation;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemReferenceDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePartInstancePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PartInstance>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePartPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Part>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePersonInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** 3-letter acronym for drivers */
  acronym?: InputMaybe<Scalars['String']['input']>;
  behaviour?: InputMaybe<BehaviourConfigInput>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  canopyCredentials?: InputMaybe<CanopyCredentialsInput>;
  carUpdateMethod?: InputMaybe<EnumPersonCarUpdateMethod>;
  /** IDs of contestants visible to this person when logged in. */
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultFlexLayoutConfigs?: InputMaybe<DefaultFlexLayoutConfigsInput>;
  defaultRunSheetCompareStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStylePhoneID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultTyreReferenceTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** Default string for tyre set naming, where x=Chassis, i=Info, s=SetNumber, (c=Corner or a=Axle) */
  defaultTyreSetNameFormat?: InputMaybe<Scalars['String']['input']>;
  displayColor?: InputMaybe<Scalars['String']['input']>;
  dynoConfigID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of contestants editable to this person when logged in. */
  editableContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotificationConfig?: InputMaybe<NotificationConfigInput>;
  /** IDs of events visible to this person when logged in. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this user be unable to see KPIs? */
  hideKPIs?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to track his working time? */
  isTimeTracker?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to see, update and approve working times for other users? */
  isTimeTrackerAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequenceTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  localConnections?: InputMaybe<Array<InputMaybe<LocalConnectionInput>>>;
  mileageUnit?: InputMaybe<EnumLengthUnit>;
  name: Scalars['String']['input'];
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  passportPicture?: InputMaybe<Scalars['String']['input']>;
  /** Collection of favourite plot page config IDs. */
  plotPageConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  privateMobile?: InputMaybe<Scalars['Float']['input']>;
  privatePhone?: InputMaybe<Scalars['Float']['input']>;
  role?: InputMaybe<EnumPersonRole>;
  /** Collection of favourite setup overview config IDs. */
  setupOverviewConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  timeTrackerApprovalByPersonID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Collection of personal setup IDs. */
  userSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userSimulationSettings?: InputMaybe<UserSimulationSettingsInput>;
  username: Scalars['String']['input'];
  viewConfig?: InputMaybe<ViewConfigInput>;
  /** IDs of contestants visible to this person when logged in. */
  visibleContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of events visible to this person when logged in. */
  visibleEventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of teams visible to this person when logged in. */
  visibleTeamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  workMobile?: InputMaybe<Scalars['Float']['input']>;
  workPhone?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOnePersonPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Person>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePlotPageConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of columns in the grid. */
  gridCols: Scalars['Int']['input'];
  /** Number of rows in the grid. */
  gridRows: Scalars['Int']['input'];
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  plots: Array<InputMaybe<PlotConfigInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOnePlotPageConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PlotPageConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePointsSystemInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of points for the fastest lap */
  laptimeDriverPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Race position cutoff for drivers eligible for points for the fastest lap. In some race series you need to be in the top 10 to get the bonus point. */
  laptimePositionCutoff?: InputMaybe<Scalars['Float']['input']>;
  /** Array of points for the fastest lap for the teams. In some race series only the driver receives points for fastest lap. */
  laptimeTeamPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name: Scalars['String']['input'];
  /** How much race distance needs to be completed to be eligible for points */
  positionalCompletionMin?: InputMaybe<Scalars['Float']['input']>;
  /** How much race distance in % needs to be completed to be eligible for points */
  positionalCompletionMinRatio?: InputMaybe<Scalars['Float']['input']>;
  /** Array of driver points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalDriverPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Array of team points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalTeamPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sessionType: EnumSessionType;
};

export type CreateOnePointsSystemPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PointsSystem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProjectInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneProjectPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Project>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneQualityCheckActionInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  acknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  acknowledgedByID?: InputMaybe<Scalars['MongoID']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledByID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedByID?: InputMaybe<Scalars['MongoID']['input']>;
  comments?: InputMaybe<Array<InputMaybe<CommentInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdByID?: InputMaybe<Scalars['MongoID']['input']>;
  description: Scalars['String']['input'];
  priority?: InputMaybe<EnumQualityCheckActionPriority>;
  status?: InputMaybe<EnumQualityCheckActionStatus>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneQualityCheckActionPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<QualityCheckAction>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneQualityCheckInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  qualityCheckActionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneQualityCheckPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<QualityCheck>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneRaceSeriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultJobListIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  driversPerCar?: InputMaybe<EnumRaceSeriesDriversPerCar>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  lapTypeConfig?: InputMaybe<RaceSeriesLapTypeConfigInput>;
  name: Scalars['String']['input'];
  seasonIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  sortingIndex?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneRaceSeriesPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<RaceSeries>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneRadioMessageInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time at which the audio message arrived in the queue for transcribing. */
  arrivedInQueueAt?: InputMaybe<Scalars['Date']['input']>;
  /** This is currently a path to a file on the Transcribble server, but it should eventually be a URL to a file in something like an S3 bucket instead. */
  audioPath: Scalars['String']['input'];
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  important?: Scalars['Boolean']['input'];
  /** Length of the audio message in seconds. */
  length?: InputMaybe<Scalars['Float']['input']>;
  sessionID: Scalars['MongoID']['input'];
  /** Time at which the audio message was taken by a transcription service. */
  takenByTranscriberAt?: InputMaybe<Scalars['Date']['input']>;
  /** The text of the message, as transcribed by Transcribble. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Time at which this message began recording audio. */
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  /** Time at which the audio message was finished initial transcribing. */
  transcribedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneRadioMessagePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<RadioMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneReportNotesTemplateInput = {
  pageAppendix?: InputMaybe<ReportNotesTemplatePageAppendixInput>;
  pageOverview?: InputMaybe<ReportNotesTemplatePageOverviewInput>;
  pageParts?: InputMaybe<ReportNotesTemplatePagePartsInput>;
  pageRunPlan?: InputMaybe<ReportNotesTemplatePageRunPlanInput>;
  pageSession?: InputMaybe<ReportNotesTemplatePageSessionInput>;
  title: Scalars['String']['input'];
};

export type CreateOneReportNotesTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ReportNotesTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneReportTemplateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  appendix?: InputMaybe<ReportTemplateAppendixInput>;
  bop?: InputMaybe<ReportTemplateBopInput>;
  carSetup?: InputMaybe<ReportTemplateCarSetupInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** File format based off a filename pattern, e.g. {raceSeries} {season} {event} */
  downloadFilenameFormat?: InputMaybe<Scalars['String']['input']>;
  excludedNoteIDs?: InputMaybe<ReportTemplateExcludedNoteIDsInput>;
  issues?: InputMaybe<ReportTemplateIssuesInput>;
  kpi?: InputMaybe<ReportTemplateKpiInput>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  overview?: InputMaybe<ReportTemplateOverviewInput>;
  parts?: InputMaybe<ReportTemplatePartsInput>;
  reportTitle?: InputMaybe<Scalars['String']['input']>;
  runInfo?: InputMaybe<ReportTemplateRunInfoInput>;
  runPlan?: InputMaybe<ReportTemplateRunPlanInput>;
  sessions?: InputMaybe<ReportTemplateSessionsInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  weather?: InputMaybe<ReportTemplateWeatherInput>;
};

export type CreateOneReportTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ReportTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneRunPlanInput = {
  PUEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Amount of time in seconds to increment SOC by 1% at each rSOC value. Must have same length as `chargeTimeSOCValues`. */
  chargeTimeSOCIncrements?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** rSOC values to associate with each time charge time increment. Must have same length as `chargeTimeSOCIncrements` */
  chargeTimeSOCValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contestantID: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  fuelRequired?: InputMaybe<RunEnergyInput>;
  /** Full tank fuel load */
  mFuelFullTank?: InputMaybe<Scalars['Float']['input']>;
  performanceEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  raceEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  runs: Array<InputMaybe<RunPlanRunInput>>;
  sessionID: Scalars['MongoID']['input'];
  systemEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tLapExpected?: InputMaybe<RunLapTimeInput>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Short comment like dry run plan / wet run plan. */
  title: Scalars['String']['input'];
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneRunPlanPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<RunPlan>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneRunSheetInput = {
  /** Fuel density, if working in volume (overrides `DFuel` from event) */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Run number */
  NRun?: InputMaybe<Scalars['Float']['input']>;
  /** Run number for timing services */
  NRunTiming?: InputMaybe<Scalars['Float']['input']>;
  SoCRequired?: InputMaybe<RunEnergyInput>;
  TCellMaxRunStart?: InputMaybe<Scalars['Float']['input']>;
  /** Volume of fuel added at the start of the run. This field will not be automatically calculated by the API, so should be set along with `tRefuel` and `qRefuel` as their product. */
  VFuelAdded?: InputMaybe<Scalars['Float']['input']>;
  associatedKpiFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brakeComment?: InputMaybe<Scalars['String']['input']>;
  brakeFL?: InputMaybe<RunBrakeInput>;
  brakeFR?: InputMaybe<RunBrakeInput>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  brakeRL?: InputMaybe<RunBrakeInput>;
  brakeRR?: InputMaybe<RunBrakeInput>;
  /** Link to a cloud storage location where raw run data is kept. */
  cloudStorageURL?: InputMaybe<Scalars['String']['input']>;
  /** Fuel/SoC/Energy consumptions for each track layout in this run sheet. Acts as an override for the consumptions from the parent event. */
  consumptions?: InputMaybe<Array<InputMaybe<LayoutConsumptionInput>>>;
  contestantID: Scalars['MongoID']['input'];
  controlsComment?: InputMaybe<Scalars['String']['input']>;
  dashboard?: InputMaybe<DashboardInput>;
  dataServiceFileNameOverride?: InputMaybe<Scalars['String']['input']>;
  dilComments?: InputMaybe<Scalars['String']['input']>;
  driverComments?: InputMaybe<Scalars['String']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Car data service run end time */
  endTimeCDS?: InputMaybe<Scalars['Date']['input']>;
  /** Laptime service run end time */
  endTimeLTS?: InputMaybe<Scalars['Date']['input']>;
  /** Manual run end time (used to override calculation in case run was cut short but don't want to delete the drafted laps */
  endTimeManual?: InputMaybe<Scalars['Date']['input']>;
  energyRequired?: InputMaybe<RunEnergyInput>;
  engineerComments?: InputMaybe<Scalars['String']['input']>;
  engineerID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time by which tyre heating schedule should be finished */
  finishTyreHeatingBy?: InputMaybe<Scalars['Date']['input']>;
  /** Used for fuel calculation. If true, mFuelAdded is treated as the total fuel at run start. */
  fuelDrainedBeforeRun?: InputMaybe<Scalars['Boolean']['input']>;
  fuelRequired?: InputMaybe<RunEnergyInput>;
  historyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  info?: InputMaybe<Scalars['String']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isLockedByLaptimeService?: InputMaybe<Scalars['Boolean']['input']>;
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  jobIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Used to save the file name where the kpi data is retreived from */
  kpiFileName?: InputMaybe<Scalars['String']['input']>;
  kpiStatus?: InputMaybe<EnumRunSheetKpiStatus>;
  kpiUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** `addLap`, `forceAddLap`, `updateLap`, and `removeLap` mutations are preferred unless you want to completely replace the laps with new data. */
  laps?: InputMaybe<Array<InputMaybe<LapInput>>>;
  laptimeThresholds?: InputMaybe<LaptimeThresholdsInput>;
  /** Fuel added at the start of the run */
  mFuelAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel removed from the catch tank after the run */
  mFuelDrainedCatchTank?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel removed from the main tank after the run */
  mFuelDrainedMainTank?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel remaining at the end of the run */
  mFuelRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel used before run start i.e. for pre-run fireup */
  mFuelUsedPreRun?: InputMaybe<Scalars['Float']['input']>;
  nextRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  performanceComments?: InputMaybe<Scalars['String']['input']>;
  prevRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  problemComments?: InputMaybe<Scalars['String']['input']>;
  /** Flow rate when refuelling at the start of the run, in m³/s */
  qRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Energy charged to this value at the start of the run */
  rEnergyAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Energy level at the end of the run */
  rEnergyRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Battery charged to this value at the start of the run */
  rSOCAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Battery state of charge at the end of the run */
  rSOCRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Short comment of the objective of the run */
  runDescription?: InputMaybe<Scalars['String']['input']>;
  /** Map of run KPI fields to their values. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  runKPI?: InputMaybe<Scalars['JSON']['input']>;
  runSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Running time in seconds */
  runTime?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the job list template used for this run */
  selectedJobListTemplateID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  setupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of the simulation results associated with this run. */
  simResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  skidComment?: InputMaybe<Scalars['String']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidMeasurement: [["left", 5], ["marker1", 6]]`. */
  skidMeasurement?: InputMaybe<Scalars['JSON']['input']>;
  skidPlateID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPostRunMeasurements: [["left", 5], ["marker1", 6]]`. */
  skidPostRunMeasurements?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPreRunMeasurements: [["left", 5], ["marker1", 6]]`. */
  skidPreRunMeasurements?: InputMaybe<Scalars['JSON']['input']>;
  startTimeCDS?: InputMaybe<Scalars['Date']['input']>;
  startTimeLTS?: InputMaybe<Scalars['Date']['input']>;
  startTimeManual?: InputMaybe<Scalars['Date']['input']>;
  /** Time at which to start tyre heating schedule */
  startTyreHeatingAt?: InputMaybe<Scalars['Date']['input']>;
  summaryComments?: InputMaybe<Scalars['String']['input']>;
  systemsComments?: InputMaybe<Scalars['String']['input']>;
  /** Time spent refuelling at the start of the run */
  tRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Override for session time remaining (in seconds) */
  tSessionRemainingOverride?: InputMaybe<Scalars['Float']['input']>;
  /** Time spent in garage before run */
  tWaitBeforeRun?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of this run in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyRunID?: InputMaybe<Scalars['String']['input']>;
  /** Should the timing service pretend that this run sheet does not exist? */
  timingServiceShouldIgnore?: InputMaybe<Scalars['Boolean']['input']>;
  tyreComments?: InputMaybe<Scalars['String']['input']>;
  /** The tyre compound used, reported by the timing service. */
  tyreCompoundTiming?: InputMaybe<Scalars['String']['input']>;
  tyreFL?: InputMaybe<RunTyreInput>;
  tyreFR?: InputMaybe<RunTyreInput>;
  tyrePressureSettings?: InputMaybe<TyrePressureSettingsInput>;
  tyreRL?: InputMaybe<RunTyreInput>;
  tyreRR?: InputMaybe<RunTyreInput>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
  weather?: InputMaybe<WeatherDataInput>;
  writeHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneRunSheetPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<RunSheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneRunSheetStyleInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  blocks?: InputMaybe<Array<InputMaybe<GenericRunSheetStyleBlockInput>>>;
  energyType?: InputMaybe<EnumEnergyType>;
  lapFlags?: InputMaybe<LapFlagLabelsInput>;
  name: Scalars['String']['input'];
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneRunSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<RunSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSandboxUnitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  acceleration?: InputMaybe<AccelerationInput>;
  angle?: InputMaybe<AngleInput>;
  angularVelocity?: InputMaybe<AngularVelocityInput>;
  area?: InputMaybe<AreaInput>;
  current?: InputMaybe<CurrentInput>;
  dampingRate?: InputMaybe<DampingRateInput>;
  density?: InputMaybe<DensityInput>;
  energy?: InputMaybe<EnergyInput>;
  force?: InputMaybe<ForceInput>;
  frequency?: InputMaybe<FrequencyInput>;
  length?: InputMaybe<LengthInput>;
  mass?: InputMaybe<MassInput>;
  momentOfInertia?: InputMaybe<MomentOfInertiaInput>;
  power?: InputMaybe<PowerInput>;
  pressure?: InputMaybe<PressureInput>;
  ratio?: InputMaybe<RatioInput>;
  springRate?: InputMaybe<SpringRateInput>;
  temperature?: InputMaybe<TemperatureInput>;
  torque?: InputMaybe<TorqueInput>;
  torsionRate?: InputMaybe<TorsionRateInput>;
  velocity?: InputMaybe<VelocityInput>;
  voltage?: InputMaybe<VoltageInput>;
  volume?: InputMaybe<VolumeInput>;
};

export type CreateOneSandboxUnitsPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SandboxUnits>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSeasonInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Position after which a driver no longer gets points for fastest lap. */
  fastestLapsPositionCutoff?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** Championship points per fastest lap in a session. Example: `[1]` means fastest lap gets 1 point, then second and beyond gets nothing. */
  pointsPerFastestLap?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Whether the fastest lap points are awarded to the team or the driver. */
  pointsPerFastestLapTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Championship points per driver position in a race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPosition?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Championship points per driver position in a sprint race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPositionSprintRace?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Championship points per qualifying rank at an event. Example: `[3, 2, 1]` means first/second/third drivers get 3/2/1 points, then fourth and beyond gets nothing. */
  pointsPerQualifyingRank?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  pointsSystemQualiAlternateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemQualiDefaultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemRaceAlternateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemRaceDefaultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  raceSeriesID: Scalars['MongoID']['input'];
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of all tyres which are owned by the team for this season. */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of all tyre sets which are owned by the team for this season. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneSeasonPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Season>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSessionInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bestValuesID?: InputMaybe<Scalars['MongoID']['input']>;
  bopID?: InputMaybe<Scalars['MongoID']['input']>;
  contestants?: InputMaybe<Array<InputMaybe<SessionContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumSessionDebriefNotesMode>;
  disableForwardPropagation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted driver championship standings during and immediately after this session. */
  driverChampionshipStandings?: InputMaybe<Array<InputMaybe<DriverChampionshipStandingInput>>>;
  eventID: Scalars['MongoID']['input'];
  /** This flag is used to tell the laptime service that this session might span multiple timing sessions. */
  isLinkedSession?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this a timing test session, to be shown only to admin users? */
  isTimingTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted standings of this session, as they were last updated */
  liveStandings?: InputMaybe<Array<InputMaybe<LiveStandingInput>>>;
  /** Greatest lap number processed for live standings. Use to determine if the data is current and up to date. */
  liveStandingsCurrentLap?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** ID of the next session in this event */
  nextSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFRMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRRMinSession?: InputMaybe<Scalars['Float']['input']>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemOverrideIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted driver championship standings from before the start of this session. */
  prevDriverChampionshipStandings?: InputMaybe<Array<InputMaybe<DriverChampionshipStandingInput>>>;
  /** ID of the previous session in this event */
  prevSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** e.g. Test, Practice, Qualifying, Race */
  sessionType?: InputMaybe<EnumSessionType>;
  /** Short name like D1, FP2, etc. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Time of the session end in local time */
  tSessionEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of the session start in local time */
  tSessionStart?: InputMaybe<Scalars['Date']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted team championship standings during and immediately after this session. */
  teamChampionshipStandings?: InputMaybe<Array<InputMaybe<TeamChampionshipStandingInput>>>;
  /** ID of this session in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartySessionID?: InputMaybe<Scalars['String']['input']>;
  /** Seconds until end of session, updated by the timing service very infrequently. Zero if session has already ended. */
  timeRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** ID of this session for Transcribble's legacy API */
  transcribbleSessionID?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOneSessionPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Session>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSetupOverviewConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** WARNING: this field should be deprecated after SI migrations have taken place */
  fields?: InputMaybe<Array<InputMaybe<SetupOverviewConfigFieldInput>>>;
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<InputMaybe<SetupOverviewConfigRowInput>>>;
  title: Scalars['String']['input'];
};

export type CreateOneSetupOverviewConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SetupOverviewConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSetupSheetStyleInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  blocks?: InputMaybe<Array<SetupSheetStyleBlockInput>>;
  /** Chassis specification to use for suggesting field keys. You may need to look for more recent iterations of this spec to get up-to-date field keys. */
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  hideAddPartButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Toggle to show/hide units for the input fields */
  hideUnits?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  targetEventType?: InputMaybe<EnumSetupSheetStyleTargetEventType>;
  targetRoles?: InputMaybe<Array<EnumPersonRole>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type: EnumSetupSheetStyleType;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneSetupSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SetupSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSimRequestInput = {
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  relatedSimResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  requesterSlot?: InputMaybe<EnumSimRequestRequesterSlot>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  simResultID?: InputMaybe<Scalars['MongoID']['input']>;
  simType?: InputMaybe<EnumSimRequestSimType>;
  simulationService?: InputMaybe<EnumSimModelType>;
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: EnumSimResultStatus;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneSimRequestPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SimRequest>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSimResultInput = {
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Array<InputMaybe<SimResultDataInput>>>;
  /** Each data channel is assumed to use this unless it specifies `channelSamplingRate` or `channelTime` */
  defaultChannelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Map containing reference values from car setup. Example: aerobalance in a car manual. Input syntax is array of key-value tuples, like `refValues: [["rAeroBalF", 48.5], ["rLatBalF", 51.4]]`. */
  refValues?: InputMaybe<Scalars['JSON']['input']>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the ORH service used to generate the sim result */
  serviceVersion?: InputMaybe<Scalars['String']['input']>;
  simType?: InputMaybe<EnumSimResultSimType>;
  simulationDriveFileID?: InputMaybe<Scalars['MongoID']['input']>;
  simulationService?: InputMaybe<EnumSimModelType>;
  /** Service which generated this sim result, for example Canopy */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Reference for this sim result, to find it in the simulation service */
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: EnumSimResultStatus;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneSimResultPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SimResult>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSimulationDriveFileInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumSimulationDriveFileStatus>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumTypeID?: InputMaybe<Scalars['MongoID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneSimulationDriveFilePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SimulationDriveFile>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSkidPlateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  initialThickness?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneSkidPlatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SkidPlate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSpecificationGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateOneSpecificationGroupPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SpecificationGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSpecificationInput = {
  CxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  FSpringSetup?: InputMaybe<AdjustableForceInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  aCamber?: InputMaybe<SpecificationACamberInput>;
  aCaster?: InputMaybe<SpecificationACamberInput>;
  aCasterMeasurementGain?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurementOffset?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<SpecificationACamberInput>;
  adjustableProperties?: InputMaybe<Array<InputMaybe<AdjustablePropertyInput>>>;
  aeroElementInterpolationMethod?: InputMaybe<EnumAeroElementInterpolationMethod>;
  aeroElementSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  aeroElementType?: InputMaybe<EnumAeroElementType>;
  aeroPackageSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  aeroPackageSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Names of sockets that this can be plugged in to. */
  allowableSockets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  antiRollBarConfigs?: InputMaybe<Array<InputMaybe<AntiRollBarConfigInput>>>;
  antiRollBarDisplayLocation?: InputMaybe<EnumAntiRollBarDisplayLocation>;
  antiRollBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: InputMaybe<Array<InputMaybe<AssignedGearInput>>>;
  attachable?: InputMaybe<Scalars['Boolean']['input']>;
  axle?: InputMaybe<EnumAxle>;
  bevelSetSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetVisible?: InputMaybe<Scalars['Boolean']['input']>;
  bumpRubberReference?: InputMaybe<EnumKinematicsInternalReference>;
  bumpRubberSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bumpStopGapMethod?: InputMaybe<EnumBumpStopGapMethod>;
  calculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: InputMaybe<Scalars['String']['input']>;
  chassisMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  copyReferencePackageID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customSimulationModels?: InputMaybe<Array<InputMaybe<SpecificationCustomSimulationModelsInput>>>;
  customSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  customSpecType?: InputMaybe<Scalars['String']['input']>;
  customTables?: InputMaybe<Array<InputMaybe<SpecificationCustomTablesInput>>>;
  damperAdjusters?: InputMaybe<Array<InputMaybe<DamperAdjusterInput>>>;
  damperConfigs?: InputMaybe<Array<InputMaybe<DamperConfigInput>>>;
  damperSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  denominator?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  differentialConfigs?: InputMaybe<Array<InputMaybe<DifferentialConfigInput>>>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  drawingNumber?: InputMaybe<Scalars['String']['input']>;
  dropGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  elasticType?: InputMaybe<EnumElasticType>;
  forceTable?: InputMaybe<ForceTableInput>;
  gearType?: InputMaybe<EnumGearType>;
  hRide?: InputMaybe<SpecificationHRideInput>;
  hasToBeInSubAssembly?: InputMaybe<Scalars['Boolean']['input']>;
  headGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  helperSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  initialChassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** If true, this gear is the head gear of the gear box, applies to standard gears only */
  isHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
  /** Spring constant of the elastic element. */
  kSpring?: InputMaybe<Scalars['Float']['input']>;
  kinematicsExternalModels?: InputMaybe<Array<InputMaybe<KinematicsExternalModelInput>>>;
  kinematicsExternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  kinematicsInternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerReference?: InputMaybe<Scalars['String']['input']>;
  mass?: InputMaybe<ChassisMassInput>;
  massProperties?: InputMaybe<MassPropertiesInput>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: InputMaybe<ChassisMeasurementsInput>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  name: Scalars['String']['input'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  numerator?: InputMaybe<Scalars['Float']['input']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  polyCxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  positionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  powerUnits?: InputMaybe<Array<InputMaybe<ChassisPowerUnitInput>>>;
  powertrain?: InputMaybe<ChassisPowertrainInput>;
  powertrainLocation?: InputMaybe<EnumSpecificationPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  rBrakeBias?: InputMaybe<AdjustableRatioInput>;
  /** Position of the specification on the car */
  readingsAllowable?: InputMaybe<Array<InputMaybe<EnumSpecificationReadingsAllowable>>>;
  readingsRequired?: InputMaybe<EnumSpecificationReadingsRequired>;
  reboundSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  regulationSets?: InputMaybe<Array<InputMaybe<RegulationSetInput>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: InputMaybe<Scalars['Boolean']['input']>;
  setupChangesFilter?: InputMaybe<SpecificationSetupChangesFilterInput>;
  setupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  /** Locations/areas that components can be installed in. */
  sockets?: InputMaybe<Array<InputMaybe<ChassisSocketInput>>>;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationGroupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  springReference?: InputMaybe<EnumKinematicsInternalReference>;
  springSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  torsionBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type: EnumSpecificationType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** User-supplied version of this specification. */
  version?: InputMaybe<Scalars['String']['input']>;
  xBumpRubberRef?: InputMaybe<Scalars['Float']['input']>;
  xBumpRubberSetup?: InputMaybe<AdjustableLengthInput>;
  xBumpStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperSetupDefault?: InputMaybe<Scalars['Float']['input']>;
  xDroopStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  /** Length of the elastic element under no force */
  xFree?: InputMaybe<Scalars['Float']['input']>;
  xShaftDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xSpringPlatformOffset?: InputMaybe<Scalars['Float']['input']>;
  xSpringRef?: InputMaybe<Scalars['Float']['input']>;
  xSpringSetup?: InputMaybe<AdjustableLengthInput>;
  xToe?: InputMaybe<SpecificationHRideInput>;
};

export type CreateOneSpecificationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Specification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSsoProviderInput = {
  clientID: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  issuerURL: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateOneSsoProviderPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SsoProvider>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTagInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  tagType?: InputMaybe<EnumTagType>;
};

export type CreateOneTagPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Tag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTeamInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default color to use for this team where applicable. */
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Used only for filtering to limit which teams are displayed in a list. */
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneTeamPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Team>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTemplateJobListInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  jobs: Array<InputMaybe<TemplateJobInput>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  title: Scalars['String']['input'];
};

export type CreateOneTemplateJobListPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TemplateJobList>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTemplateSessionDebriefInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumTemplateSessionDebriefMode>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateOneTemplateSessionDebriefPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TemplateSessionDebrief>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTimeSheetEntryInput = {
  /** Whether a person did work on this day */
  absent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notes about what was done during this time */
  description?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Clock-out time */
  tEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Clock-in time */
  tStart: Scalars['Date']['input'];
};

export type CreateOneTimeSheetEntryPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TimeSheetEntry>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTimingServiceConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Whether the timingServiceConfig should be considered active by the service */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event ID. This finds the correct event by its _id field. */
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Use schedule-based session matching as fallback. */
  fallbackScheduleBasedSessionMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of timed sectors on track. Used as fallback in case timing data does not provide it. */
  fallbackTimedSectorsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Car numbers to follow. */
  followedCarNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Activate live standings to see the driver championship points live. Only working properly if all drivers of a given season are added as contestants. */
  liveStandingsActive?: InputMaybe<Scalars['Boolean']['input']>;
  logLevel?: InputMaybe<EnumTimingServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<EnumTimingServiceConfigMode>;
  /** Name for this set of configuration settings. */
  name: Scalars['String']['input'];
  /** Use string equality to match timing session names in One Racehub. Otherwise default sequence matching is used. */
  strictSessionNameMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** One Timing server port. */
  timingPort?: InputMaybe<Scalars['Int']['input']>;
  /** Race series name to filter on in the timing feed when multiple series are running at an event. */
  timingRaceSeries?: InputMaybe<Scalars['String']['input']>;
  /** One Timing server address. */
  timingURL?: InputMaybe<Scalars['String']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneTimingServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TimingServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  acronym?: InputMaybe<Scalars['String']['input']>;
  /** Track height above sea level. */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  cameras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  geoLocation?: InputMaybe<GeoLocationInput>;
  /** IDs of the available track layouts */
  layoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name: Scalars['String']['input'];
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Storage ID of track picture file in s3. */
  trackPicture?: InputMaybe<Scalars['String']['input']>;
  weatherStations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateOneTrackLayoutInput = {
  ATKModeGain?: InputMaybe<Scalars['Float']['input']>;
  ATKModeLocation?: InputMaybe<Scalars['Float']['input']>;
  ATKModePenalty?: InputMaybe<Scalars['Float']['input']>;
  FCYLapTime?: InputMaybe<Scalars['Float']['input']>;
  /** Full-course yellow probability */
  FCYProbability?: InputMaybe<Scalars['Float']['input']>;
  /** Amount of sectors the timing provides */
  NSectorsTiming?: InputMaybe<Scalars['Float']['input']>;
  SCLapTime?: InputMaybe<Scalars['Float']['input']>;
  /** Safety car probability */
  SCProbability?: InputMaybe<Scalars['Float']['input']>;
  SoCRequired?: InputMaybe<RunEnergyInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  acronym?: InputMaybe<Scalars['String']['input']>;
  bumpiness?: InputMaybe<Scalars['Float']['input']>;
  cameras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code60LapTime?: InputMaybe<Scalars['Float']['input']>;
  crossoverWetToSlick?: InputMaybe<Scalars['Float']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  energyRequired?: InputMaybe<RunEnergyInput>;
  expectedRaceLaps?: InputMaybe<Scalars['Float']['input']>;
  firstLapOffset?: InputMaybe<Scalars['Float']['input']>;
  fuelRequired?: InputMaybe<RunEnergyInput>;
  inLapTime?: InputMaybe<Scalars['Float']['input']>;
  lapLengthCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapLengthRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapZero?: InputMaybe<Scalars['Boolean']['input']>;
  lapsUntilFullRegen?: InputMaybe<Scalars['Float']['input']>;
  mapElevation?: InputMaybe<Scalars['String']['input']>;
  mapEmergencyExits?: InputMaybe<Scalars['String']['input']>;
  mapPitLane?: InputMaybe<Scalars['String']['input']>;
  mapTrack?: InputMaybe<Scalars['String']['input']>;
  mapTrackGPS?: InputMaybe<Scalars['String']['input']>;
  mapTrackLatLonCsv?: InputMaybe<Scalars['String']['input']>;
  mapTrackXyCsv?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Layout */
  name: Scalars['String']['input'];
  outLapTime?: InputMaybe<Scalars['Float']['input']>;
  overtakingThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Whole distance from entry to exit inlcuding approach and leave */
  pitDistance?: InputMaybe<Scalars['Float']['input']>;
  /** Length of pit lane between the pit lane entry and exit loop (used for mileage calculation of pitlane lap types) */
  pitLength?: InputMaybe<Scalars['Float']['input']>;
  pitLoss?: InputMaybe<Scalars['Float']['input']>;
  pitLossDriveThrough?: InputMaybe<Scalars['Float']['input']>;
  /** Indicates whether the pole position is on the left- or right-hand side */
  polePosition?: InputMaybe<EnumTrackLayoutPolePosition>;
  prepLapTime?: InputMaybe<Scalars['Float']['input']>;
  pushLapTime?: InputMaybe<Scalars['Float']['input']>;
  sectorDistance?: InputMaybe<Scalars['Float']['input']>;
  sectorLengths?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Downforce sensitivity (seconds per 10pts) */
  sensDownforce?: InputMaybe<Scalars['Float']['input']>;
  /** Drag sensitivity (seconds per 10pts) */
  sensDrag?: InputMaybe<Scalars['Float']['input']>;
  sensEP?: InputMaybe<Scalars['Float']['input']>;
  /** Energy sensitivity (seconds per 0.1kWh) */
  sensEnergy?: InputMaybe<Scalars['Float']['input']>;
  /** Grip sensitivity (seconds per %) */
  sensGrip?: InputMaybe<Scalars['Float']['input']>;
  /** Mass sensitivity (seconds per 10kg) */
  sensMass?: InputMaybe<Scalars['Float']['input']>;
  /** Power sensitivity */
  sensPower?: InputMaybe<Scalars['Float']['input']>;
  simulationModels?: InputMaybe<Array<InputMaybe<TrackLayoutSimulationModelInput>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackEvolution?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the track this layout belongs to */
  trackID: Scalars['MongoID']['input'];
  trackLayoutType?: InputMaybe<EnumTrackLayoutTrackLayoutType>;
  trackRecordQuali?: InputMaybe<Scalars['Float']['input']>;
  trackRecordRace?: InputMaybe<Scalars['Float']['input']>;
  weatherStations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateOneTrackLayoutPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackLayout>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Track>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  criticalValue?: InputMaybe<Scalars['Float']['input']>;
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** ID of the original version of the specifications to track. */
  rootSpecificationID: Scalars['MongoID']['input'];
  unitType?: InputMaybe<BaseTypedUnitFieldInput>;
  /** Comparison to use when checking if the tracked value is in the warning/critical range. */
  warningDirection?: InputMaybe<EnumTrackableWarningDirection>;
  warningValue?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOneTrackablePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Trackable>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingItemInput = {
  NDecimals?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  arrayElements?: InputMaybe<Scalars['Float']['input']>;
  criticalCumulativeValue?: InputMaybe<Scalars['Float']['input']>;
  criticalValue?: InputMaybe<Scalars['Float']['input']>;
  cumulativeCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  isArray?: InputMaybe<Scalars['Boolean']['input']>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  measurementImage?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  operator?: InputMaybe<EnumTrackingItemOperator>;
  resettable?: InputMaybe<Scalars['Boolean']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
  warningCumulativeValue?: InputMaybe<Scalars['Float']['input']>;
  warningValue?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOneTrackingItemPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingMeasurementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultCoordinates?: InputMaybe<TrackingMeasurementDefaultCoordinatesInput>;
  defaultRotation?: InputMaybe<TrackingMeasurementDefaultRotationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneTrackingMeasurementPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingMeasurement>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingMeasurementRecordInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  coordinates?: InputMaybe<TrackingMeasurementRecordCoordinatesInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  rotation?: InputMaybe<TrackingMeasurementRecordRotationInput>;
  trackingMeasurementID?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneTrackingMeasurementRecordPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingMeasurementRecord>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingRecordGeneralInput = {
  arrayValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date: Scalars['Date']['input'];
  dateResolved?: InputMaybe<Scalars['Date']['input']>;
  forceTable?: InputMaybe<ForceTableInput>;
  location?: InputMaybe<LocationInput>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partID: Scalars['MongoID']['input'];
  qualityCheckID?: InputMaybe<Scalars['MongoID']['input']>;
  recordErrors?: InputMaybe<Scalars['String']['input']>;
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  statusEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumTrackingRecordGeneralType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedByID?: InputMaybe<Scalars['MongoID']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneTrackingRecordGeneralPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingRecordGeneral>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingRecordInput = {
  arrayValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateResolved?: InputMaybe<Scalars['Date']['input']>;
  forceTable?: InputMaybe<ForceTableInput>;
  location?: InputMaybe<LocationInput>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  qualityCheckID?: InputMaybe<Scalars['MongoID']['input']>;
  recordErrors?: InputMaybe<Scalars['String']['input']>;
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  statusEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumTrackingRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedByID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneTrackingRecordOverrideInput = {
  arrayValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cumulativeValue: Scalars['Float']['input'];
  date: Scalars['Date']['input'];
  dateResolved?: InputMaybe<Scalars['Date']['input']>;
  forceTable?: InputMaybe<ForceTableInput>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partID: Scalars['MongoID']['input'];
  recordErrors?: InputMaybe<Scalars['String']['input']>;
  statusEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemID: Scalars['MongoID']['input'];
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumTrackingRecordOverrideType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedByID?: InputMaybe<Scalars['MongoID']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneTrackingRecordOverridePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingRecordOverride>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingRecordPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingRecord>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingRecordValueInput = {
  arrayValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateResolved?: InputMaybe<Scalars['Date']['input']>;
  forceTable?: InputMaybe<ForceTableInput>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partID: Scalars['MongoID']['input'];
  recordErrors?: InputMaybe<Scalars['String']['input']>;
  trackingItemID: Scalars['MongoID']['input'];
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumTrackingRecordValueType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedByID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneTrackingRecordValuePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingRecordValue>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingSourceAliasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  aliasString?: InputMaybe<Scalars['String']['input']>;
  aliasType?: InputMaybe<EnumTrackingSourceAliasAliasType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOneTrackingSourceAliasPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingSourceAlias>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingSourceInput = {
  NDecimals?: InputMaybe<Scalars['Float']['input']>;
  chassisSpecID: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  name: Scalars['String']['input'];
  sourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneTrackingSourcePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingSource>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTyreInput = {
  /** Flag if the tyre is scrapped (no longer available for use). */
  BTyreScrapped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tyre Circumference */
  CTyre?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Arbitrary string to sort or filter by */
  additionalSortProperty?: InputMaybe<Scalars['String']['input']>;
  axle?: InputMaybe<EnumTyreAxle>;
  barcodeManufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Barcode from the regulatory body (e.g. FIA) */
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  barcodeRim?: InputMaybe<Scalars['String']['input']>;
  barcodeTPMS?: InputMaybe<Scalars['String']['input']>;
  batteryTPMS?: InputMaybe<Scalars['String']['input']>;
  compound?: InputMaybe<Scalars['String']['input']>;
  compoundComment?: InputMaybe<Scalars['String']['input']>;
  constructionComment?: InputMaybe<Scalars['String']['input']>;
  constructionSpec?: InputMaybe<Scalars['String']['input']>;
  heatingSchedule?: InputMaybe<Array<InputMaybe<TyreHeatingScheduleEntryInput>>>;
  initialCondition?: InputMaybe<EnumTyreInitialCondition>;
  /** Tyre Spring Rate */
  kTyre?: InputMaybe<Scalars['Float']['input']>;
  mTyre?: InputMaybe<Scalars['Float']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturingDate?: InputMaybe<Scalars['Date']['input']>;
  /** Tyre mold information */
  mold?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Tyre minimum pressure defined by regulation or manufacturer */
  pTyreMinRegulation?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure defined by team (i.e. chief engineer) */
  pTyreMinTeam?: InputMaybe<Scalars['Float']['input']>;
  rimPartID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Initial mileage before use in One Racehub. */
  sRunInitial?: InputMaybe<Scalars['Float']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  wearMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneTyrePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Tyre>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTyreSetInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tyreIDFL?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDFR?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDRL?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDRR?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneTyreSetPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TyreSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTyreWearInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time at which this measurement was made. */
  date?: InputMaybe<Scalars['Date']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreID: Scalars['MongoID']['input'];
  /** Raw wear data formatted however the user chooses, probably from a scanner. */
  wearData?: InputMaybe<Scalars['String']['input']>;
  /** Map of marker names to wear values. Input syntax is array of key-value tuples, like `wearMarkers: [["inner", 0.8], ["1", 0.3]]`. */
  wearMarkers?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateOneTyreWearPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TyreWear>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneUserEnumInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type?: EnumUserEnumType;
};

export type CreateOneUserEnumPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<UserEnum>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneWeatherInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Height above sea level (for air density for example). */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  data: Array<InputMaybe<WeatherDataInput>>;
  /** References to events this weather data was made for, if applicable */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  geoLocation?: InputMaybe<GeoLocationInput>;
  /** User notes for completing a forecast for a race */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Forecast/measurement source (website, weather station, timekeeping, …) */
  source?: InputMaybe<Scalars['String']['input']>;
  /** For predictions, indicates the time at which the prediction was made. For measurements, indicates the time of the first measurement in the array. */
  time?: InputMaybe<Scalars['Date']['input']>;
  /** Prediction, measurement, historical */
  type: EnumWeatherType;
  /** Weather station ID */
  weatherStationID?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneWeatherPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Weather>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneWeatherServiceConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** API Key. Used for Open Weather Map and Wunderground */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** API Secret. Used for Weather Link */
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Password. Currently used for meteomatics */
  password?: InputMaybe<Scalars['String']['input']>;
  refreshInterval: Scalars['Float']['input'];
  requestLocation?: InputMaybe<GeoLocationInput>;
  /** Location or weather station */
  requestType: EnumWeatherServiceConfigRequestType;
  /** Weather client to specify the source where to retrieve the data from. */
  source: EnumWeatherServiceConfigSource;
  type: EnumWeatherServiceConfigType;
  /** Username. Currently used for meteomatics */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Weather Station ID. Used for Weather Underground */
  weatherStationID?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneWeatherServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<WeatherServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateSessionForFullEventInput = {
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bestValuesID?: InputMaybe<Scalars['MongoID']['input']>;
  bopID?: InputMaybe<Scalars['MongoID']['input']>;
  contestants?: InputMaybe<Array<InputMaybe<SessionContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumSessionDebriefNotesMode>;
  disableForwardPropagation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted driver championship standings during and immediately after this session. */
  driverChampionshipStandings?: InputMaybe<Array<InputMaybe<DriverChampionshipStandingInput>>>;
  /** This flag is used to tell the laptime service that this session might span multiple timing sessions. */
  isLinkedSession?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this a timing test session, to be shown only to admin users? */
  isTimingTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted standings of this session, as they were last updated */
  liveStandings?: InputMaybe<Array<InputMaybe<LiveStandingInput>>>;
  /** Greatest lap number processed for live standings. Use to determine if the data is current and up to date. */
  liveStandingsCurrentLap?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** ID of the next session in this event */
  nextSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFRMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRRMinSession?: InputMaybe<Scalars['Float']['input']>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemOverrideIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted driver championship standings from before the start of this session. */
  prevDriverChampionshipStandings?: InputMaybe<Array<InputMaybe<DriverChampionshipStandingInput>>>;
  /** ID of the previous session in this event */
  prevSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** e.g. Test, Practice, Qualifying, Race */
  sessionType?: InputMaybe<EnumSessionType>;
  /** Short name like D1, FP2, etc. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Time of the session end in local time */
  tSessionEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of the session start in local time */
  tSessionStart?: InputMaybe<Scalars['Date']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted team championship standings during and immediately after this session. */
  teamChampionshipStandings?: InputMaybe<Array<InputMaybe<TeamChampionshipStandingInput>>>;
  /** ID of this session in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartySessionID?: InputMaybe<Scalars['String']['input']>;
  /** Seconds until end of session, updated by the timing service very infrequently. Zero if session has already ended. */
  timeRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** ID of this session for Transcribble's legacy API */
  transcribbleSessionID?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTyreRecordInput = {
  /** Flag if the tyre is scrapped (no longer available for use). */
  BTyreScrapped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tyre Circumference */
  CTyre?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Arbitrary string to sort or filter by */
  additionalSortProperty?: InputMaybe<Scalars['String']['input']>;
  axle?: InputMaybe<EnumTyreAxle>;
  barcodeManufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Barcode from the regulatory body (e.g. FIA) */
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  barcodeRim?: InputMaybe<Scalars['String']['input']>;
  barcodeTPMS?: InputMaybe<Scalars['String']['input']>;
  batteryTPMS?: InputMaybe<Scalars['String']['input']>;
  compound?: InputMaybe<Scalars['String']['input']>;
  compoundComment?: InputMaybe<Scalars['String']['input']>;
  constructionComment?: InputMaybe<Scalars['String']['input']>;
  constructionSpec?: InputMaybe<Scalars['String']['input']>;
  heatingSchedule?: InputMaybe<Array<InputMaybe<TyreHeatingScheduleEntryInput>>>;
  initialCondition?: InputMaybe<EnumTyreInitialCondition>;
  /** Tyre Spring Rate */
  kTyre?: InputMaybe<Scalars['Float']['input']>;
  mTyre?: InputMaybe<Scalars['Float']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturingDate?: InputMaybe<Scalars['Date']['input']>;
  /** Tyre mold information */
  mold?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Tyre minimum pressure defined by regulation or manufacturer */
  pTyreMinRegulation?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure defined by team (i.e. chief engineer) */
  pTyreMinTeam?: InputMaybe<Scalars['Float']['input']>;
  rimPartID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Initial mileage before use in One Racehub. */
  sRunInitial?: InputMaybe<Scalars['Float']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** Wear measurement to store for this tyre, as `[["inner", 0.8], ["1", 0.3]]`. */
  wearMarkers?: InputMaybe<Scalars['JSON']['input']>;
  wearMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateTyreSetRecordInput = {
  tyreFL?: InputMaybe<CreateTyreRecordInput>;
  tyreFR?: InputMaybe<CreateTyreRecordInput>;
  tyreRL?: InputMaybe<CreateTyreRecordInput>;
  tyreRR?: InputMaybe<CreateTyreRecordInput>;
  tyreSetComment?: InputMaybe<Scalars['String']['input']>;
  tyreSetName?: InputMaybe<Scalars['String']['input']>;
  tyreSetNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTyresForContestantResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
  tyreIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tyreSetIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type CreatedChassisAssembly = {
  newChassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  newChassisAssemblyName?: Maybe<Scalars['String']['output']>;
  newChassisAssemblyReference?: Maybe<Scalars['String']['output']>;
};

export type CreatedPartInstancesResult = {
  createdPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type CreatedSetup = {
  newSetupID?: Maybe<Scalars['MongoID']['output']>;
};

export type Current = {
  /** A */
  amps: Scalars['Float']['output'];
  /** mA */
  milliamps: Scalars['Float']['output'];
};

export type CurrentInput = {
  /** A */
  amps?: InputMaybe<Scalars['Float']['input']>;
  /** mA */
  milliamps?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  adjustableProperties?: Maybe<Array<Maybe<SomeAdjustableProperty>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /**
   * Names of sockets that this can be plugged in to.
   * @deprecated
   */
  allowableSockets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpec?: Maybe<Specification>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customSpecType?: Maybe<Scalars['String']['output']>;
  customTables?: Maybe<Array<Maybe<SpecificationCustomTables>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  drawingNumber?: Maybe<Scalars['String']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<CustomSpec>;
  manufacturer: Array<Maybe<Manufacturer>>;
  manufacturerID?: Maybe<Scalars['MongoID']['output']>;
  manufacturerReference?: Maybe<Scalars['String']['output']>;
  massProperties?: Maybe<MassProperties>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  readingsRequired?: Maybe<EnumCustomSpecReadingsRequired>;
  reference?: Maybe<Scalars['String']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingMeasurements: Array<TrackingMeasurement>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Damper = {
  NDamperBumpDO?: Maybe<Scalars['Float']['output']>;
  NDamperBumpDY?: Maybe<Scalars['Float']['output']>;
  NDamperBumpHS?: Maybe<Scalars['Float']['output']>;
  NDamperBumpIP?: Maybe<Scalars['Float']['output']>;
  NDamperBumpLS?: Maybe<Scalars['Float']['output']>;
  NDamperReboundDO?: Maybe<Scalars['Float']['output']>;
  NDamperReboundDY?: Maybe<Scalars['Float']['output']>;
  NDamperReboundHS?: Maybe<Scalars['Float']['output']>;
  NDamperReboundIP?: Maybe<Scalars['Float']['output']>;
  NDamperReboundLS?: Maybe<Scalars['Float']['output']>;
  adjusters?: Maybe<Array<Maybe<DamperAdjusters>>>;
  /** Name of the damper config to use for simulation */
  configName?: Maybe<Scalars['String']['output']>;
  gasPressure?: Maybe<Scalars['Float']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use specificationID instead */
  spec?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<DamperSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  valvingBumpSpec?: Maybe<Scalars['String']['output']>;
  valvingReboundSpec?: Maybe<Scalars['String']['output']>;
  xDamperMax?: Maybe<Scalars['Float']['output']>;
};

export type DamperAdjuster = {
  /** Maximum setting, if using min/max/step */
  maxSetting?: Maybe<Scalars['Float']['output']>;
  /** Minimum setting, if using min/max/step */
  minSetting?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  settingNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  settings?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Increment to suggest values in, if using min/max/step */
  step?: Maybe<Scalars['Float']['output']>;
};

export type DamperAdjusterInput = {
  /** Maximum setting, if using min/max/step */
  maxSetting?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum setting, if using min/max/step */
  minSetting?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  settingNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Increment to suggest values in, if using min/max/step */
  step?: InputMaybe<Scalars['Float']['input']>;
};

export type DamperAdjusters = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  settingName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type DamperAdjustersInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settingName?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type DamperConfig = {
  forceTable?: Maybe<ForceTable>;
  name: Scalars['String']['output'];
  /** Define which damper clicks are associated with this setting */
  settings?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  simulationModels?: Maybe<Scalars['JSON']['output']>;
};

export type DamperConfigInput = {
  forceTable?: InputMaybe<ForceTableInput>;
  name: Scalars['String']['input'];
  /** Define which damper clicks are associated with this setting */
  settings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type DamperInput = {
  NDamperBumpDO?: InputMaybe<Scalars['Float']['input']>;
  NDamperBumpDY?: InputMaybe<Scalars['Float']['input']>;
  NDamperBumpHS?: InputMaybe<Scalars['Float']['input']>;
  NDamperBumpIP?: InputMaybe<Scalars['Float']['input']>;
  NDamperBumpLS?: InputMaybe<Scalars['Float']['input']>;
  NDamperReboundDO?: InputMaybe<Scalars['Float']['input']>;
  NDamperReboundDY?: InputMaybe<Scalars['Float']['input']>;
  NDamperReboundHS?: InputMaybe<Scalars['Float']['input']>;
  NDamperReboundIP?: InputMaybe<Scalars['Float']['input']>;
  NDamperReboundLS?: InputMaybe<Scalars['Float']['input']>;
  adjusters?: InputMaybe<Array<InputMaybe<DamperAdjustersInput>>>;
  /** Name of the damper config to use for simulation */
  configName?: InputMaybe<Scalars['String']['input']>;
  gasPressure?: InputMaybe<Scalars['Float']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  spec?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  valvingBumpSpec?: InputMaybe<Scalars['String']['input']>;
  valvingReboundSpec?: InputMaybe<Scalars['String']['input']>;
  xDamperMax?: InputMaybe<Scalars['Float']['input']>;
};

export type DamperSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /**
   * Names of sockets that this can be plugged in to.
   * @deprecated
   */
  allowableSockets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  damperAdjusters?: Maybe<Array<Maybe<DamperAdjuster>>>;
  damperConfigs?: Maybe<Array<Maybe<DamperConfig>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<DamperSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** Position of the specification on the car */
  readingsAllowable?: Maybe<Array<EnumReadingLocation>>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  xDamperDroopDefault?: Maybe<Scalars['Float']['output']>;
  xShaftDroopDefault?: Maybe<Scalars['Float']['output']>;
};

export type DampingRate = {
  /** Nms/m */
  newtonSecondsPerMetre: Scalars['Float']['output'];
  /** Nms/mm */
  newtonSecondsPerMillimetre: Scalars['Float']['output'];
  /** lbf·s/in */
  poundForceSecondsPerInch: Scalars['Float']['output'];
};

export type DampingRateInput = {
  /** Nms/m */
  newtonSecondsPerMetre?: InputMaybe<Scalars['Float']['input']>;
  /** Nms/mm */
  newtonSecondsPerMillimetre?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·s/in */
  poundForceSecondsPerInch?: InputMaybe<Scalars['Float']['input']>;
};

export type Dashboard = {
  /** Dashboard reading of fuel remaining at the end of the run */
  mFuelRunEnd?: Maybe<Scalars['Float']['output']>;
  /** Dashboard reading of fuel amount at the start of the run */
  mFuelRunStart?: Maybe<Scalars['Float']['output']>;
};

export type DashboardInput = {
  /** Dashboard reading of fuel remaining at the end of the run */
  mFuelRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Dashboard reading of fuel amount at the start of the run */
  mFuelRunStart?: InputMaybe<Scalars['Float']['input']>;
};

export type DataCheckResolverReturnType = {
  message?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DefaultFlexLayoutConfigs = {
  BOP?: Maybe<Scalars['MongoID']['output']>;
  KPI?: Maybe<Scalars['MongoID']['output']>;
  REPORT?: Maybe<Scalars['MongoID']['output']>;
  RUNSHEET?: Maybe<Scalars['MongoID']['output']>;
  SETUPOVERVIEW?: Maybe<Scalars['MongoID']['output']>;
  SETUPSANDBOX?: Maybe<Scalars['MongoID']['output']>;
  SETUPSHEET?: Maybe<Scalars['MongoID']['output']>;
  SIMULATION?: Maybe<Scalars['MongoID']['output']>;
};

export type DefaultFlexLayoutConfigsInput = {
  BOP?: InputMaybe<Scalars['MongoID']['input']>;
  KPI?: InputMaybe<Scalars['MongoID']['input']>;
  REPORT?: InputMaybe<Scalars['MongoID']['input']>;
  RUNSHEET?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPOVERVIEW?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPSANDBOX?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPSHEET?: InputMaybe<Scalars['MongoID']['input']>;
  SIMULATION?: InputMaybe<Scalars['MongoID']['input']>;
};

export type Density = {
  /** kg/m³ */
  kilogramsPerCubicMetre: Scalars['Float']['output'];
  /** kg/L */
  kilogramsPerLitre: Scalars['Float']['output'];
  /** lb/ft³ */
  poundsPerCubicFoot: Scalars['Float']['output'];
};

export type DensityInput = {
  /** kg/m³ */
  kilogramsPerCubicMetre?: InputMaybe<Scalars['Float']['input']>;
  /** kg/L */
  kilogramsPerLitre?: InputMaybe<Scalars['Float']['input']>;
  /** lb/ft³ */
  poundsPerCubicFoot?: InputMaybe<Scalars['Float']['input']>;
};

export type Department = {
  _id: Scalars['MongoID']['output'];
  name: Scalars['String']['output'];
};

/** List of items with pagination. */
export type DepartmentPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Department>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type DifferentialConfig = {
  /** Is this differential config allowed to be selected in new car setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  frictionFaces?: Maybe<Scalars['String']['output']>;
  maxPreloadForce?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  rampAccel?: Maybe<Scalars['Float']['output']>;
  rampDecel?: Maybe<Scalars['Float']['output']>;
  simulationModels?: Maybe<Scalars['JSON']['output']>;
};

export type DifferentialConfigInput = {
  /** Is this differential config allowed to be selected in new car setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  frictionFaces?: InputMaybe<Scalars['String']['input']>;
  maxPreloadForce?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  rampAccel?: InputMaybe<Scalars['Float']['input']>;
  rampDecel?: InputMaybe<Scalars['Float']['input']>;
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type DifferentialSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  differentialConfigs?: Maybe<Array<Maybe<DifferentialConfig>>>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<DifferentialSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  powertrainLocation?: Maybe<EnumSpecificationPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DoubleCommentBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  field1: Scalars['String']['output'];
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  field2: Scalars['String']['output'];
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  isAlwaysOpen?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  label1: Scalars['String']['output'];
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  label2: Scalars['String']['output'];
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  rows?: Maybe<Scalars['Float']['output']>;
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  title: Scalars['String']['output'];
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type DriverChampionshipStanding = {
  acronym?: Maybe<Scalars['String']['output']>;
  contestantID?: Maybe<Scalars['MongoID']['output']>;
  driver?: Maybe<Person>;
  driverID?: Maybe<Scalars['MongoID']['output']>;
  points: Scalars['Int']['output'];
  /** Historical race finish positions of this driver in this season. Null values represent DNFs. Should only be used for pre-session standings data. */
  prevRacePositions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: Maybe<Scalars['Int']['output']>;
  startNumber?: Maybe<Scalars['String']['output']>;
};

export type DriverChampionshipStandingInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  points: Scalars['Int']['input'];
  /** Historical race finish positions of this driver in this season. Null values represent DNFs. Should only be used for pre-session standings data. */
  prevRacePositions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: InputMaybe<Scalars['Int']['input']>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DriverTiming = {
  bestLapTime?: Maybe<Scalars['Float']['output']>;
  bestLapTimeInLapNum?: Maybe<Scalars['Int']['output']>;
  contestant?: Maybe<Contestant>;
  contestantID: Scalars['String']['output'];
  currentLapNum?: Maybe<Scalars['Int']['output']>;
  currentLapTime?: Maybe<Scalars['Float']['output']>;
  currentSectorTimings: Array<DriverTimingSectorTiming>;
  /** @deprecated Use `currentLapNum` instead. */
  currentlapNum?: Maybe<Scalars['Int']['output']>;
  differenceToLastLapTime?: Maybe<Scalars['Float']['output']>;
  gapToDriverAhead?: Maybe<Scalars['Float']['output']>;
  gapToDriverAheadChange: Scalars['Float']['output'];
  gapToDriverAheadInClass?: Maybe<Scalars['Float']['output']>;
  gapToDriverAheadInClassChange: Scalars['Float']['output'];
  gapToFirstDriver?: Maybe<Scalars['Float']['output']>;
  gapToFirstDriverChange: Scalars['Float']['output'];
  gapToFirstDriverInClass?: Maybe<Scalars['Float']['output']>;
  gapToFirstDriverInClassChange: Scalars['Float']['output'];
  isBestSessionLapTime: Scalars['Boolean']['output'];
  isOwnBestLapTime: Scalars['Boolean']['output'];
  pitThroughCount: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  positionInClass: Scalars['Int']['output'];
  speedTrapSpeed?: Maybe<Scalars['Float']['output']>;
  startNumber: Scalars['String']['output'];
  tyres?: Maybe<Scalars['String']['output']>;
};

export type DriverTimingSectorTiming = {
  isOwnBest: Scalars['Boolean']['output'];
  isSessionBest: Scalars['Boolean']['output'];
  lapNum: Scalars['Int']['output'];
  speed?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

export type DroopStop = {
  name?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<ElasticSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  xDroopStopGap?: Maybe<Scalars['Float']['output']>;
};

export type DroopStopInput = {
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  xDroopStopGap?: InputMaybe<Scalars['Float']['input']>;
};

export type DynoConfig = {
  _id: Scalars['MongoID']['output'];
  columns?: Maybe<Array<Maybe<DynoConfigColumns>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DynoConfigColumns = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** runSheet.tyreSetID, setup.mCar, etc. */
  fieldKey?: Maybe<Scalars['String']['output']>;
  /** Tyre, Weight, etc. */
  header?: Maybe<Scalars['String']['output']>;
};

export type DynoConfigColumnsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** runSheet.tyreSetID, setup.mCar, etc. */
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  /** Tyre, Weight, etc. */
  header?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type DynoConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<DynoConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ElasticSpec = AnySpecification & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /**
   * Names of sockets that this can be plugged in to.
   * @deprecated
   */
  allowableSockets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  elasticType?: Maybe<EnumElasticType>;
  forceTable?: Maybe<ForceTable>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<ElasticSpec>;
  /** Spring constant of the elastic element. */
  kSpring?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** Position of the specification on the car */
  readingsAllowable?: Maybe<Array<EnumReadingLocation>>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  xBumpStopGapDefault?: Maybe<Scalars['Float']['output']>;
  xDamperSetupDefault?: Maybe<Scalars['Float']['output']>;
  xDroopStopGapDefault?: Maybe<Scalars['Float']['output']>;
  /** Length of the elastic element under no force */
  xFree?: Maybe<Scalars['Float']['output']>;
};

export type Energy = {
  /** J */
  joules: Scalars['Float']['output'];
  /** kJ */
  kilojoules: Scalars['Float']['output'];
  /** kWh */
  kilowattHours: Scalars['Float']['output'];
  /** MJ */
  megajoules: Scalars['Float']['output'];
  /** Wh */
  wattHours: Scalars['Float']['output'];
};

export type EnergyInput = {
  /** J */
  joules?: InputMaybe<Scalars['Float']['input']>;
  /** kJ */
  kilojoules?: InputMaybe<Scalars['Float']['input']>;
  /** kWh */
  kilowattHours?: InputMaybe<Scalars['Float']['input']>;
  /** MJ */
  megajoules?: InputMaybe<Scalars['Float']['input']>;
  /** Wh */
  wattHours?: InputMaybe<Scalars['Float']['input']>;
};

export type EnergyUnitField = {
  unit: EnumEnergyUnit;
};

export const EnumAccelerationUnit = {
  FEET_PER_SECOND_SQUARED: 'FEET_PER_SECOND_SQUARED',
  GFORCE: 'GFORCE',
  METRES_PER_SECOND_SQUARED: 'METRES_PER_SECOND_SQUARED'
} as const;

export type EnumAccelerationUnit = typeof EnumAccelerationUnit[keyof typeof EnumAccelerationUnit];
export const EnumAdjustablePropertyType = {
  ACCELERATION: 'ACCELERATION',
  ANGLE: 'ANGLE',
  ANGULAR_COMPLIANCE: 'ANGULAR_COMPLIANCE',
  ANGULAR_TORQUE_COMPLIANCE: 'ANGULAR_TORQUE_COMPLIANCE',
  BOOLEAN: 'BOOLEAN',
  COMPLIANCE: 'COMPLIANCE',
  FORCE: 'FORCE',
  INERTIA: 'INERTIA',
  LENGTH: 'LENGTH',
  LOCATION: 'LOCATION',
  MASS: 'MASS',
  NUMBER: 'NUMBER',
  ORIENTATION: 'ORIENTATION',
  POWER: 'POWER',
  PRESSURE: 'PRESSURE',
  RATIO: 'RATIO',
  SPRING_RATE: 'SPRING_RATE',
  STEERING_RACK_RATIO: 'STEERING_RACK_RATIO',
  STRING: 'STRING',
  TEMPERATURE: 'TEMPERATURE',
  TORQUE: 'TORQUE',
  TORSION_RATE: 'TORSION_RATE',
  VOLUME: 'VOLUME'
} as const;

export type EnumAdjustablePropertyType = typeof EnumAdjustablePropertyType[keyof typeof EnumAdjustablePropertyType];
export const EnumAeroElementInterpolationMethod = {
  AFLAP: 'AFLAP',
  CLOSEST: 'CLOSEST',
  LINEAR: 'LINEAR',
  NONE: 'NONE',
  POLYNOMIAL: 'POLYNOMIAL',
  SPLINE: 'SPLINE'
} as const;

export type EnumAeroElementInterpolationMethod = typeof EnumAeroElementInterpolationMethod[keyof typeof EnumAeroElementInterpolationMethod];
export const EnumAeroElementType = {
  INTERPOLATE: 'INTERPOLATE',
  POLYNOMIAL: 'POLYNOMIAL',
  STRICT: 'STRICT'
} as const;

export type EnumAeroElementType = typeof EnumAeroElementType[keyof typeof EnumAeroElementType];
export const EnumAngleUnit = {
  DEGREES: 'DEGREES',
  MINUTES: 'MINUTES',
  RADIANS: 'RADIANS'
} as const;

export type EnumAngleUnit = typeof EnumAngleUnit[keyof typeof EnumAngleUnit];
export const EnumAngularAccelerationUnit = {
  DEGREES_PER_SECOND_SQUARED: 'DEGREES_PER_SECOND_SQUARED',
  RADIANS_PER_SECOND_SQUARED: 'RADIANS_PER_SECOND_SQUARED'
} as const;

export type EnumAngularAccelerationUnit = typeof EnumAngularAccelerationUnit[keyof typeof EnumAngularAccelerationUnit];
export const EnumAngularComplianceUnit = {
  DEGREES_PER_POUND: 'DEGREES_PER_POUND',
  RADIANS_PER_NEWTON: 'RADIANS_PER_NEWTON'
} as const;

export type EnumAngularComplianceUnit = typeof EnumAngularComplianceUnit[keyof typeof EnumAngularComplianceUnit];
export const EnumAngularTorqueComplianceUnit = {
  DEGREES_PER_FOOT_POUND: 'DEGREES_PER_FOOT_POUND',
  RADIANS_PER_NEWTON_METRE: 'RADIANS_PER_NEWTON_METRE'
} as const;

export type EnumAngularTorqueComplianceUnit = typeof EnumAngularTorqueComplianceUnit[keyof typeof EnumAngularTorqueComplianceUnit];
export const EnumAngularVelocityUnit = {
  DEGREES_PER_SECOND: 'DEGREES_PER_SECOND',
  RADIANS_PER_SECOND: 'RADIANS_PER_SECOND'
} as const;

export type EnumAngularVelocityUnit = typeof EnumAngularVelocityUnit[keyof typeof EnumAngularVelocityUnit];
export const EnumAntiRollBarDisplayLocation = {
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumAntiRollBarDisplayLocation = typeof EnumAntiRollBarDisplayLocation[keyof typeof EnumAntiRollBarDisplayLocation];
/** Specify where the part type should be added in */
export const EnumAssemblyTemplateRequiredPartsLocation = {
  CENTER: 'CENTER',
  ENGINE_IN: 'ENGINE_IN',
  ENGINE_OUT: 'ENGINE_OUT',
  FRONT: 'FRONT',
  FRONT_LEFT: 'FRONT_LEFT',
  FRONT_LEFT_FORWARD: 'FRONT_LEFT_FORWARD',
  FRONT_LEFT_INNER: 'FRONT_LEFT_INNER',
  FRONT_LEFT_LCA_FWD: 'FRONT_LEFT_LCA_FWD',
  FRONT_LEFT_LCA_RWD: 'FRONT_LEFT_LCA_RWD',
  FRONT_LEFT_LOWER: 'FRONT_LEFT_LOWER',
  FRONT_LEFT_OUTER: 'FRONT_LEFT_OUTER',
  FRONT_LEFT_PUSHROD: 'FRONT_LEFT_PUSHROD',
  FRONT_LEFT_REARWARD: 'FRONT_LEFT_REARWARD',
  FRONT_LEFT_TIEROD: 'FRONT_LEFT_TIEROD',
  FRONT_LEFT_UCA_FWD: 'FRONT_LEFT_UCA_FWD',
  FRONT_LEFT_UCA_RWD: 'FRONT_LEFT_UCA_RWD',
  FRONT_LEFT_UPPER: 'FRONT_LEFT_UPPER',
  FRONT_PRIMARY: 'FRONT_PRIMARY',
  FRONT_RIGHT: 'FRONT_RIGHT',
  FRONT_RIGHT_FORWARD: 'FRONT_RIGHT_FORWARD',
  FRONT_RIGHT_INNER: 'FRONT_RIGHT_INNER',
  FRONT_RIGHT_LCA_FWD: 'FRONT_RIGHT_LCA_FWD',
  FRONT_RIGHT_LCA_RWD: 'FRONT_RIGHT_LCA_RWD',
  FRONT_RIGHT_LOWER: 'FRONT_RIGHT_LOWER',
  FRONT_RIGHT_OUTER: 'FRONT_RIGHT_OUTER',
  FRONT_RIGHT_PUSHROD: 'FRONT_RIGHT_PUSHROD',
  FRONT_RIGHT_REARWARD: 'FRONT_RIGHT_REARWARD',
  FRONT_RIGHT_TIEROD: 'FRONT_RIGHT_TIEROD',
  FRONT_RIGHT_UCA_FWD: 'FRONT_RIGHT_UCA_FWD',
  FRONT_RIGHT_UCA_RWD: 'FRONT_RIGHT_UCA_RWD',
  FRONT_RIGHT_UPPER: 'FRONT_RIGHT_UPPER',
  FRONT_SECONDARY: 'FRONT_SECONDARY',
  GBX_IN: 'GBX_IN',
  GBX_OUT: 'GBX_OUT',
  INPUT: 'INPUT',
  LEFT: 'LEFT',
  MGU_IN: 'MGU_IN',
  MGU_OUT: 'MGU_OUT',
  OUTPUT: 'OUTPUT',
  PRIMARY: 'PRIMARY',
  REAR: 'REAR',
  REAR_LEFT: 'REAR_LEFT',
  REAR_LEFT_FORWARD: 'REAR_LEFT_FORWARD',
  REAR_LEFT_INNER: 'REAR_LEFT_INNER',
  REAR_LEFT_LCA_FWD: 'REAR_LEFT_LCA_FWD',
  REAR_LEFT_LCA_RWD: 'REAR_LEFT_LCA_RWD',
  REAR_LEFT_LOWER: 'REAR_LEFT_LOWER',
  REAR_LEFT_OUTER: 'REAR_LEFT_OUTER',
  REAR_LEFT_PUSHROD: 'REAR_LEFT_PUSHROD',
  REAR_LEFT_REARWARD: 'REAR_LEFT_REARWARD',
  REAR_LEFT_TIEROD: 'REAR_LEFT_TIEROD',
  REAR_LEFT_UCA_FWD: 'REAR_LEFT_UCA_FWD',
  REAR_LEFT_UCA_RWD: 'REAR_LEFT_UCA_RWD',
  REAR_LEFT_UPPER: 'REAR_LEFT_UPPER',
  REAR_PRIMARY: 'REAR_PRIMARY',
  REAR_RIGHT: 'REAR_RIGHT',
  REAR_RIGHT_FORWARD: 'REAR_RIGHT_FORWARD',
  REAR_RIGHT_INNER: 'REAR_RIGHT_INNER',
  REAR_RIGHT_LCA_FWD: 'REAR_RIGHT_LCA_FWD',
  REAR_RIGHT_LCA_RWD: 'REAR_RIGHT_LCA_RWD',
  REAR_RIGHT_LOWER: 'REAR_RIGHT_LOWER',
  REAR_RIGHT_OUTER: 'REAR_RIGHT_OUTER',
  REAR_RIGHT_PUSHROD: 'REAR_RIGHT_PUSHROD',
  REAR_RIGHT_REARWARD: 'REAR_RIGHT_REARWARD',
  REAR_RIGHT_TIEROD: 'REAR_RIGHT_TIEROD',
  REAR_RIGHT_UCA_FWD: 'REAR_RIGHT_UCA_FWD',
  REAR_RIGHT_UCA_RWD: 'REAR_RIGHT_UCA_RWD',
  REAR_RIGHT_UPPER: 'REAR_RIGHT_UPPER',
  REAR_SECONDARY: 'REAR_SECONDARY',
  RIGHT: 'RIGHT',
  SECONDARY: 'SECONDARY',
  SINGLE: 'SINGLE',
  STEERING_COLUMN: 'STEERING_COLUMN',
  STEERING_RACK: 'STEERING_RACK',
  STEERING_SHAFT: 'STEERING_SHAFT'
} as const;

export type EnumAssemblyTemplateRequiredPartsLocation = typeof EnumAssemblyTemplateRequiredPartsLocation[keyof typeof EnumAssemblyTemplateRequiredPartsLocation];
export const EnumAssemblyType = {
  CHASSIS: 'CHASSIS',
  SUB_ASSEMBLY: 'SUB_ASSEMBLY'
} as const;

export type EnumAssemblyType = typeof EnumAssemblyType[keyof typeof EnumAssemblyType];
export const EnumAxle = {
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumAxle = typeof EnumAxle[keyof typeof EnumAxle];
/** ORH will use the users timezone selection to format times accordingly */
export const EnumBehaviourConfigTimezoneSelect = {
  LAPTOP: 'LAPTOP',
  TRACK: 'TRACK',
  UTC: 'UTC'
} as const;

export type EnumBehaviourConfigTimezoneSelect = typeof EnumBehaviourConfigTimezoneSelect[keyof typeof EnumBehaviourConfigTimezoneSelect];
export const EnumBrakeBlockField = {
  POST_RUN_BRAKE_TEMPS: 'POST_RUN_BRAKE_TEMPS',
  POST_RUN_THICKNESS: 'POST_RUN_THICKNESS',
  PRE_RUN_BRAKE_TEMPS: 'PRE_RUN_BRAKE_TEMPS',
  PRE_RUN_THICKNESS: 'PRE_RUN_THICKNESS'
} as const;

export type EnumBrakeBlockField = typeof EnumBrakeBlockField[keyof typeof EnumBrakeBlockField];
export const EnumBuildSheetStyleTargetEventType = {
  AEROTEST: 'AEROTEST',
  ANY: 'ANY',
  OVAL: 'OVAL',
  ROADCOURSE: 'ROADCOURSE'
} as const;

export type EnumBuildSheetStyleTargetEventType = typeof EnumBuildSheetStyleTargetEventType[keyof typeof EnumBuildSheetStyleTargetEventType];
export const EnumBuildSheetStyleTargetRoles = {
  ADMIN: 'ADMIN',
  CAR_ENGINEER: 'CAR_ENGINEER',
  CHIEF_ENGINEER: 'CHIEF_ENGINEER',
  DRIVER: 'DRIVER',
  FAULT_ADMIN: 'FAULT_ADMIN',
  MANAGEMENT: 'MANAGEMENT',
  MECHANIC: 'MECHANIC',
  READ_ONLY: 'READ_ONLY',
  SETUP_REVIEWER: 'SETUP_REVIEWER',
  TYRE_ENGINEER: 'TYRE_ENGINEER',
  WORKSHOP_MANAGEMENT: 'WORKSHOP_MANAGEMENT'
} as const;

export type EnumBuildSheetStyleTargetRoles = typeof EnumBuildSheetStyleTargetRoles[keyof typeof EnumBuildSheetStyleTargetRoles];
export const EnumBuildSheetStyleType = {
  FULL: 'FULL',
  MINI: 'MINI',
  SIMULATION: 'SIMULATION'
} as const;

export type EnumBuildSheetStyleType = typeof EnumBuildSheetStyleType[keyof typeof EnumBuildSheetStyleType];
export const EnumBumpPlateMeasurementMethod = {
  ANGLE: 'ANGLE',
  BOTH: 'BOTH',
  LENGTH: 'LENGTH'
} as const;

export type EnumBumpPlateMeasurementMethod = typeof EnumBumpPlateMeasurementMethod[keyof typeof EnumBumpPlateMeasurementMethod];
export const EnumBumpStopGapMethod = {
  GAP_TO_BASE: 'GAP_TO_BASE',
  GAP_TO_TOP: 'GAP_TO_TOP',
  PACKER_STACK: 'PACKER_STACK'
} as const;

export type EnumBumpStopGapMethod = typeof EnumBumpStopGapMethod[keyof typeof EnumBumpStopGapMethod];
export const EnumCalculationType = {
  CAR_SETUP: 'CAR_SETUP',
  DATA_SERVICE: 'DATA_SERVICE',
  KPI: 'KPI',
  LAP: 'LAP',
  RUN_SHEET: 'RUN_SHEET'
} as const;

export type EnumCalculationType = typeof EnumCalculationType[keyof typeof EnumCalculationType];
export const EnumCanopyConfigType = {
  CAR: 'CAR',
  TRACK: 'TRACK',
  WEATHER: 'WEATHER'
} as const;

export type EnumCanopyConfigType = typeof EnumCanopyConfigType[keyof typeof EnumCanopyConfigType];
export const EnumCarDataServiceApplicationSettingsConfigRunsheetMatching = {
  DATA_INGEST: 'DATA_INGEST',
  RUNNUMBER: 'RUNNUMBER',
  STANDARD: 'STANDARD',
  TIMESTAMP: 'TIMESTAMP'
} as const;

export type EnumCarDataServiceApplicationSettingsConfigRunsheetMatching = typeof EnumCarDataServiceApplicationSettingsConfigRunsheetMatching[keyof typeof EnumCarDataServiceApplicationSettingsConfigRunsheetMatching];
export const EnumCarDataServicePitstopTriggerType = {
  EDGE: 'EDGE',
  VALUE: 'VALUE'
} as const;

export type EnumCarDataServicePitstopTriggerType = typeof EnumCarDataServicePitstopTriggerType[keyof typeof EnumCarDataServicePitstopTriggerType];
export const EnumCarDataServiceProcessingEngineConfigImporter = {
  AIM_IMPORTER: 'AIM_IMPORTER',
  ATLAS10_IMPORTER: 'ATLAS10_IMPORTER',
  ATLAS10_NOSSV_IMPORTER: 'ATLAS10_NOSSV_IMPORTER',
  ATLAS_IMPORTER: 'ATLAS_IMPORTER',
  DARAB_IMPORTER: 'DARAB_IMPORTER',
  PITOOLBOX_IMPORTER: 'PITOOLBOX_IMPORTER',
  SERVOTEST_IMPORTER: 'SERVOTEST_IMPORTER',
  TXT_IMPORTER: 'TXT_IMPORTER',
  WINTAX_IMPORTER: 'WINTAX_IMPORTER'
} as const;

export type EnumCarDataServiceProcessingEngineConfigImporter = typeof EnumCarDataServiceProcessingEngineConfigImporter[keyof typeof EnumCarDataServiceProcessingEngineConfigImporter];
export const EnumCarSetupIntendedForSession = {
  Aerotest: 'Aerotest',
  Custom: 'Custom',
  Dyno: 'Dyno',
  Free_Practice: 'Free_Practice',
  Pre_Event: 'Pre_Event',
  Qualifying: 'Qualifying',
  Race: 'Race',
  Simulation: 'Simulation',
  Test: 'Test'
} as const;

export type EnumCarSetupIntendedForSession = typeof EnumCarSetupIntendedForSession[keyof typeof EnumCarSetupIntendedForSession];
/** Override of setup sheet style, which usually comes from the chassis. */
export const EnumCarSetupSetupSheetStyle = {
  AMGGT3C190: 'AMGGT3C190',
  AMGGT3C190HRT: 'AMGGT3C190HRT',
  AMGGT4C190: 'AMGGT4C190',
  F218_2018: 'F218_2018',
  F218_2020: 'F218_2020',
  F319: 'F319',
  FLEX: 'FLEX',
  GDRIVE_ORECA_LMP2: 'GDRIVE_ORECA_LMP2',
  MBFES07: 'MBFES07',
  MCLAREN_FES09: 'MCLAREN_FES09',
  MCLAREN_XE: 'MCLAREN_XE',
  PHMT318: 'PHMT318',
  PHMT421: 'PHMT421',
  TATUUS_T318: 'TATUUS_T318',
  TATUUS_T421: 'TATUUS_T421'
} as const;

export type EnumCarSetupSetupSheetStyle = typeof EnumCarSetupSetupSheetStyle[keyof typeof EnumCarSetupSetupSheetStyle];
export const EnumChassisMeasurementsKinematicsExternalReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumChassisMeasurementsKinematicsExternalReadingsRequired = typeof EnumChassisMeasurementsKinematicsExternalReadingsRequired[keyof typeof EnumChassisMeasurementsKinematicsExternalReadingsRequired];
export const EnumChassisMeasurementsKinematicsInternalReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumChassisMeasurementsKinematicsInternalReadingsRequired = typeof EnumChassisMeasurementsKinematicsInternalReadingsRequired[keyof typeof EnumChassisMeasurementsKinematicsInternalReadingsRequired];
export const EnumChassisSetupSheetStyle = {
  AMGGT3C190: 'AMGGT3C190',
  AMGGT3C190HRT: 'AMGGT3C190HRT',
  AMGGT4C190: 'AMGGT4C190',
  F218_2018: 'F218_2018',
  F218_2020: 'F218_2020',
  F319: 'F319',
  FLEX: 'FLEX',
  GDRIVE_ORECA_LMP2: 'GDRIVE_ORECA_LMP2',
  MBFES07: 'MBFES07',
  MCLAREN_FES09: 'MCLAREN_FES09',
  MCLAREN_XE: 'MCLAREN_XE',
  PHMT318: 'PHMT318',
  PHMT421: 'PHMT421',
  TATUUS_T318: 'TATUUS_T318',
  TATUUS_T421: 'TATUUS_T421'
} as const;

export type EnumChassisSetupSheetStyle = typeof EnumChassisSetupSheetStyle[keyof typeof EnumChassisSetupSheetStyle];
export const EnumCommentBlockField = {
  brakeComment: 'brakeComment',
  controlsComment: 'controlsComment',
  dilComments: 'dilComments',
  driverComments: 'driverComments',
  engineerComments: 'engineerComments',
  performanceComments: 'performanceComments',
  problemComments: 'problemComments',
  runDescription: 'runDescription',
  skidComment: 'skidComment',
  summaryComments: 'summaryComments',
  systemsComments: 'systemsComments',
  tyreComments: 'tyreComments'
} as const;

export type EnumCommentBlockField = typeof EnumCommentBlockField[keyof typeof EnumCommentBlockField];
export const EnumComplianceUnit = {
  INCHES_PER_POUND_FORCE: 'INCHES_PER_POUND_FORCE',
  METRES_PER_NEWTON: 'METRES_PER_NEWTON',
  MILLIMETRES_PER_NEWTON: 'MILLIMETRES_PER_NEWTON'
} as const;

export type EnumComplianceUnit = typeof EnumComplianceUnit[keyof typeof EnumComplianceUnit];
export const EnumCustomSpecReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumCustomSpecReadingsRequired = typeof EnumCustomSpecReadingsRequired[keyof typeof EnumCustomSpecReadingsRequired];
export const EnumDataCheck = {
  ASSEMBLY_IDS_NULL: 'ASSEMBLY_IDS_NULL'
} as const;

export type EnumDataCheck = typeof EnumDataCheck[keyof typeof EnumDataCheck];
export const EnumDisplayUnit = {
  BAR: 'BAR',
  CELSIUS: 'CELSIUS',
  CENTIMETRES: 'CENTIMETRES',
  DAYS: 'DAYS',
  DEGREES: 'DEGREES',
  DEGREES_PER_FOOT_POUND: 'DEGREES_PER_FOOT_POUND',
  DEGREES_PER_INCHES: 'DEGREES_PER_INCHES',
  DEGREES_PER_MILLIMETRES: 'DEGREES_PER_MILLIMETRES',
  DEGREES_PER_POUND: 'DEGREES_PER_POUND',
  DEGREES_PER_SECOND: 'DEGREES_PER_SECOND',
  DEGREES_PER_SECOND_SQUARED: 'DEGREES_PER_SECOND_SQUARED',
  FAHRENHEIT: 'FAHRENHEIT',
  FEET: 'FEET',
  FEET_PER_SECOND: 'FEET_PER_SECOND',
  FEET_PER_SECOND_SQUARED: 'FEET_PER_SECOND_SQUARED',
  GALLONS: 'GALLONS',
  GFORCE: 'GFORCE',
  GRAMS: 'GRAMS',
  HORSEPOWER_MECHANICAL: 'HORSEPOWER_MECHANICAL',
  HOURS: 'HOURS',
  INCHES: 'INCHES',
  INCHES_OF_MERCURY: 'INCHES_OF_MERCURY',
  INCHES_PER_POUND_FORCE: 'INCHES_PER_POUND_FORCE',
  JOULES: 'JOULES',
  KELVIN: 'KELVIN',
  KILOGRAMS: 'KILOGRAMS',
  KILOGRAM_METRES_SQUARED: 'KILOGRAM_METRES_SQUARED',
  KILOJOULES: 'KILOJOULES',
  KILOMETRES: 'KILOMETRES',
  KILOMETRES_PER_HOUR: 'KILOMETRES_PER_HOUR',
  KILOPASCALS: 'KILOPASCALS',
  KILOWATTS: 'KILOWATTS',
  KILOWATT_HOURS: 'KILOWATT_HOURS',
  LITRES: 'LITRES',
  METRES: 'METRES',
  METRES_CUBED: 'METRES_CUBED',
  METRES_PER_NEWTON: 'METRES_PER_NEWTON',
  METRES_PER_SECOND: 'METRES_PER_SECOND',
  METRES_PER_SECOND_SQUARED: 'METRES_PER_SECOND_SQUARED',
  MICROMETRES: 'MICROMETRES',
  MILES: 'MILES',
  MILES_PER_HOUR: 'MILES_PER_HOUR',
  MILLIBAR: 'MILLIBAR',
  MILLIGRAMS: 'MILLIGRAMS',
  MILLILITRES: 'MILLILITRES',
  MILLIMETRES: 'MILLIMETRES',
  MILLIMETRES_PER_NEWTON: 'MILLIMETRES_PER_NEWTON',
  MILLISECONDS: 'MILLISECONDS',
  MINUTES: 'MINUTES',
  NEWTONS: 'NEWTONS',
  NEWTONS_PER_METRE: 'NEWTONS_PER_METRE',
  NEWTONS_PER_MILLIMETRE: 'NEWTONS_PER_MILLIMETRE',
  NEWTON_METRES: 'NEWTON_METRES',
  NEWTON_METRES_PER_DEGREE: 'NEWTON_METRES_PER_DEGREE',
  NEWTON_METRES_PER_RADIAN: 'NEWTON_METRES_PER_RADIAN',
  NEWTON_MILLIMETRES: 'NEWTON_MILLIMETRES',
  NONE: 'NONE',
  NUMBER: 'NUMBER',
  OUNCES: 'OUNCES',
  PASCALS: 'PASCALS',
  PERCENT: 'PERCENT',
  POUNDS: 'POUNDS',
  POUNDS_FEET_PER_DEGREE: 'POUNDS_FEET_PER_DEGREE',
  POUNDS_FEET_PER_RADIAN: 'POUNDS_FEET_PER_RADIAN',
  POUNDS_FORCE: 'POUNDS_FORCE',
  POUNDS_INCHES_PER_DEGREE: 'POUNDS_INCHES_PER_DEGREE',
  POUNDS_INCHES_PER_RADIAN: 'POUNDS_INCHES_PER_RADIAN',
  POUNDS_PER_INCH: 'POUNDS_PER_INCH',
  POUND_FOOT_ENERGY: 'POUND_FOOT_ENERGY',
  POUND_FOOT_SECONDS_SQUARED: 'POUND_FOOT_SECONDS_SQUARED',
  POUND_FORCE_FEET: 'POUND_FORCE_FEET',
  POUND_FORCE_INCHES: 'POUND_FORCE_INCHES',
  PSI: 'PSI',
  RADIANS: 'RADIANS',
  RADIANS_PER_NEWTON: 'RADIANS_PER_NEWTON',
  RADIANS_PER_NEWTON_METRE: 'RADIANS_PER_NEWTON_METRE',
  RADIANS_PER_SECOND: 'RADIANS_PER_SECOND',
  RADIANS_PER_SECOND_SQUARED: 'RADIANS_PER_SECOND_SQUARED',
  RATIO: 'RATIO',
  SECONDS: 'SECONDS',
  STRING: 'STRING',
  THOU: 'THOU',
  WATTS: 'WATTS'
} as const;

export type EnumDisplayUnit = typeof EnumDisplayUnit[keyof typeof EnumDisplayUnit];
export const EnumElasticType = {
  BUMP_RUBBER: 'BUMP_RUBBER',
  HELPER_SPRING: 'HELPER_SPRING',
  REBOUND_SPRING: 'REBOUND_SPRING',
  SPRING: 'SPRING',
  TORSION_BAR: 'TORSION_BAR'
} as const;

export type EnumElasticType = typeof EnumElasticType[keyof typeof EnumElasticType];
export const EnumEnergyType = {
  COMBUSTION: 'COMBUSTION',
  ELECTRIC: 'ELECTRIC'
} as const;

export type EnumEnergyType = typeof EnumEnergyType[keyof typeof EnumEnergyType];
export const EnumEnergyUnit = {
  JOULES: 'JOULES',
  KILOJOULES: 'KILOJOULES',
  KILOWATT_HOURS: 'KILOWATT_HOURS',
  POUND_FOOT_ENERGY: 'POUND_FOOT_ENERGY'
} as const;

export type EnumEnergyUnit = typeof EnumEnergyUnit[keyof typeof EnumEnergyUnit];
export const EnumEventDebriefNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumEventDebriefNotesMode = typeof EnumEventDebriefNotesMode[keyof typeof EnumEventDebriefNotesMode];
export const EnumEventEnumEventType = {
  AERO: 'AERO',
  DYNO: 'DYNO',
  MEDIA: 'MEDIA',
  OTHER: 'OTHER',
  RACE: 'RACE',
  SIMULATOR: 'SIMULATOR',
  TEST: 'TEST'
} as const;

export type EnumEventEnumEventType = typeof EnumEventEnumEventType[keyof typeof EnumEventEnumEventType];
export const EnumEventEnumEventVenue = {
  DIRT: 'DIRT',
  DYNO: 'DYNO',
  OTHER: 'OTHER',
  OVAL: 'OVAL',
  TRACK: 'TRACK'
} as const;

export type EnumEventEnumEventVenue = typeof EnumEventEnumEventVenue[keyof typeof EnumEventEnumEventVenue];
export const EnumEventReferenceLaptimesCalculationMethod = {
  RATIO: 'RATIO',
  TIME: 'TIME'
} as const;

export type EnumEventReferenceLaptimesCalculationMethod = typeof EnumEventReferenceLaptimesCalculationMethod[keyof typeof EnumEventReferenceLaptimesCalculationMethod];
export const EnumEventType = {
  AERO: 'AERO',
  DYNO: 'DYNO',
  MEDIA: 'MEDIA',
  OTHER: 'OTHER',
  RACE: 'RACE',
  SIMULATOR: 'SIMULATOR',
  TEST: 'TEST'
} as const;

export type EnumEventType = typeof EnumEventType[keyof typeof EnumEventType];
export const EnumFlexLayoutConfigGlobalXAxisType = {
  DATA: 'DATA',
  TIME: 'TIME'
} as const;

export type EnumFlexLayoutConfigGlobalXAxisType = typeof EnumFlexLayoutConfigGlobalXAxisType[keyof typeof EnumFlexLayoutConfigGlobalXAxisType];
export const EnumFlexLayoutConfigIntendedFor = {
  BOP: 'BOP',
  KPI: 'KPI',
  REPORT: 'REPORT',
  RUNSHEET: 'RUNSHEET',
  SETUPOVERVIEW: 'SETUPOVERVIEW',
  SETUPSANDBOX: 'SETUPSANDBOX',
  SETUPSHEET: 'SETUPSHEET',
  SIMULATION: 'SIMULATION'
} as const;

export type EnumFlexLayoutConfigIntendedFor = typeof EnumFlexLayoutConfigIntendedFor[keyof typeof EnumFlexLayoutConfigIntendedFor];
export const EnumForceUnit = {
  NEWTONS: 'NEWTONS',
  POUNDS_FORCE: 'POUNDS_FORCE'
} as const;

export type EnumForceUnit = typeof EnumForceUnit[keyof typeof EnumForceUnit];
export const EnumFuelColumn = {
  ENERGY_TYPE: 'ENERGY_TYPE',
  EXTENDED_CONSUMPTION: 'EXTENDED_CONSUMPTION',
  FUEL_DENSITY: 'FUEL_DENSITY'
} as const;

export type EnumFuelColumn = typeof EnumFuelColumn[keyof typeof EnumFuelColumn];
export const EnumGearType = {
  BEVEL_SET: 'BEVEL_SET',
  DROP_GEAR: 'DROP_GEAR',
  STANDARD: 'STANDARD'
} as const;

export type EnumGearType = typeof EnumGearType[keyof typeof EnumGearType];
export const EnumGenericRunSheetStyleBlockEnergyFieldOrder = {
  ATTACK: 'ATTACK',
  COOL: 'COOL',
  FCY: 'FCY',
  IN: 'IN',
  OUT: 'OUT',
  OUTIN: 'OUTIN',
  PITLANE: 'PITLANE',
  PREP: 'PREP',
  PUSH: 'PUSH',
  QUALI: 'QUALI',
  SAFETYCAR: 'SAFETYCAR',
  SHAKEDOWN: 'SHAKEDOWN',
  SLOW: 'SLOW',
  TARGET: 'TARGET',
  TOGRID: 'TOGRID',
  TOPADDOCK: 'TOPADDOCK',
  TOPITS: 'TOPITS',
  UNFINISHED: 'UNFINISHED'
} as const;

export type EnumGenericRunSheetStyleBlockEnergyFieldOrder = typeof EnumGenericRunSheetStyleBlockEnergyFieldOrder[keyof typeof EnumGenericRunSheetStyleBlockEnergyFieldOrder];
export const EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField = {
  ATTACK: 'ATTACK',
  COOL: 'COOL',
  FCY: 'FCY',
  GREEN: 'GREEN',
  IN: 'IN',
  NOTGREEN: 'NOTGREEN',
  OUT: 'OUT',
  OUTIN: 'OUTIN',
  PITLANE: 'PITLANE',
  PREP: 'PREP',
  PUSH: 'PUSH',
  QUALI: 'QUALI',
  SAFETYCAR: 'SAFETYCAR',
  SHAKEDOWN: 'SHAKEDOWN',
  SLOW: 'SLOW',
  TARGET: 'TARGET',
  TOGRID: 'TOGRID',
  TOPADDOCK: 'TOPADDOCK',
  TOPITS: 'TOPITS',
  UNFINISHED: 'UNFINISHED'
} as const;

export type EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField = typeof EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField[keyof typeof EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField];
export const EnumGenericRunSheetStyleBlockType = {
  BLANKING: 'BLANKING',
  BRAKES: 'BRAKES',
  COMMENT: 'COMMENT',
  DOUBLE_COMMENT: 'DOUBLE_COMMENT',
  FUEL: 'FUEL',
  ISSUE: 'ISSUE',
  JOB_LIST: 'JOB_LIST',
  LAP_TABLE: 'LAP_TABLE',
  LAP_TIME_THRESHOLDS: 'LAP_TIME_THRESHOLDS',
  LAP_TYPE_COUNT: 'LAP_TYPE_COUNT',
  MINI_JOBLIST: 'MINI_JOBLIST',
  POST_RUN_MEASUREMENT: 'POST_RUN_MEASUREMENT',
  RUN_KPI_TABLE: 'RUN_KPI_TABLE',
  SETUP_CHANGES: 'SETUP_CHANGES',
  SETUP_SHEET: 'SETUP_SHEET',
  TYRE_TABLE: 'TYRE_TABLE',
  WEATHER_BOX: 'WEATHER_BOX'
} as const;

export type EnumGenericRunSheetStyleBlockType = typeof EnumGenericRunSheetStyleBlockType[keyof typeof EnumGenericRunSheetStyleBlockType];
/** Only "Point" is supported */
export const EnumGeoLocationType = {
  Point: 'Point'
} as const;

export type EnumGeoLocationType = typeof EnumGeoLocationType[keyof typeof EnumGeoLocationType];
export const EnumHistoryType = {
  CARSETUP: 'CARSETUP',
  RUNSHEET: 'RUNSHEET'
} as const;

export type EnumHistoryType = typeof EnumHistoryType[keyof typeof EnumHistoryType];
export const EnumInertiaUnit = {
  KILOGRAM_METRES_SQUARED: 'KILOGRAM_METRES_SQUARED',
  POUND_FOOT_SECONDS_SQUARED: 'POUND_FOOT_SECONDS_SQUARED'
} as const;

export type EnumInertiaUnit = typeof EnumInertiaUnit[keyof typeof EnumInertiaUnit];
export const EnumIssueIssueStatus = {
  CLOSED: 'CLOSED',
  CLOSURE_REQUESTED: 'CLOSURE_REQUESTED',
  CONTAINED_BY_DESIGN: 'CONTAINED_BY_DESIGN',
  CONTAINED_BY_OPERATIONS: 'CONTAINED_BY_OPERATIONS',
  CONTAINED_BY_PROCESS: 'CONTAINED_BY_PROCESS',
  OPEN: 'OPEN',
  RESPONSIBLE_ASSIGNED: 'RESPONSIBLE_ASSIGNED'
} as const;

export type EnumIssueIssueStatus = typeof EnumIssueIssueStatus[keyof typeof EnumIssueIssueStatus];
export const EnumIssuePriority = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  MAXIMUM: 'MAXIMUM',
  MEDIUM: 'MEDIUM',
  NONE: 'NONE',
  PRIO1_MAXIMUM: 'PRIO1_MAXIMUM',
  PRIO2_HIGH: 'PRIO2_HIGH',
  PRIO3_MEDIUM: 'PRIO3_MEDIUM',
  PRIO4_LOW: 'PRIO4_LOW',
  PRIO5_NONE: 'PRIO5_NONE'
} as const;

export type EnumIssuePriority = typeof EnumIssuePriority[keyof typeof EnumIssuePriority];
export const EnumIssueQueryIssueStatus = {
  CLOSED: 'CLOSED',
  CLOSURE_REQUESTED: 'CLOSURE_REQUESTED',
  CONTAINED_BY_DESIGN: 'CONTAINED_BY_DESIGN',
  CONTAINED_BY_OPERATIONS: 'CONTAINED_BY_OPERATIONS',
  CONTAINED_BY_PROCESS: 'CONTAINED_BY_PROCESS',
  OPEN: 'OPEN',
  RESPONSIBLE_ASSIGNED: 'RESPONSIBLE_ASSIGNED'
} as const;

export type EnumIssueQueryIssueStatus = typeof EnumIssueQueryIssueStatus[keyof typeof EnumIssueQueryIssueStatus];
export const EnumIssueQueryPriority = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  MAXIMUM: 'MAXIMUM',
  MEDIUM: 'MEDIUM',
  NONE: 'NONE',
  PRIO1_MAXIMUM: 'PRIO1_MAXIMUM',
  PRIO2_HIGH: 'PRIO2_HIGH',
  PRIO3_MEDIUM: 'PRIO3_MEDIUM',
  PRIO4_LOW: 'PRIO4_LOW',
  PRIO5_NONE: 'PRIO5_NONE'
} as const;

export type EnumIssueQueryPriority = typeof EnumIssueQueryPriority[keyof typeof EnumIssueQueryPriority];
export const EnumJobPriority = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  MAXIMUM: 'MAXIMUM',
  MEDIUM: 'MEDIUM',
  NONE: 'NONE',
  PRIO1_MAXIMUM: 'PRIO1_MAXIMUM',
  PRIO2_HIGH: 'PRIO2_HIGH',
  PRIO3_MEDIUM: 'PRIO3_MEDIUM',
  PRIO4_LOW: 'PRIO4_LOW',
  PRIO5_NONE: 'PRIO5_NONE'
} as const;

export type EnumJobPriority = typeof EnumJobPriority[keyof typeof EnumJobPriority];
/** If job is intended as a sub-task then it either belongs to an Issue or a Job. This field prevents making unnecesary database calls when assigning the sub-tasks' ID to it's parent */
export const EnumJobTarget = {
  ISSUE: 'ISSUE',
  JOB: 'JOB',
  JOB_SUBTASK: 'JOB_SUBTASK'
} as const;

export type EnumJobTarget = typeof EnumJobTarget[keyof typeof EnumJobTarget];
export const EnumKinematicsInternalReference = {
  DROOP: 'DROOP',
  FORCE: 'FORCE',
  REF: 'REF',
  STATIC: 'STATIC'
} as const;

export type EnumKinematicsInternalReference = typeof EnumKinematicsInternalReference[keyof typeof EnumKinematicsInternalReference];
export const EnumLapColumnField = {
  DAYTIME: 'DAYTIME',
  DRIVER_CALLOUT: 'DRIVER_CALLOUT',
  DRIVER_CALLOUT2: 'DRIVER_CALLOUT2',
  ENERGY_CONSUMPTION_LAP: 'ENERGY_CONSUMPTION_LAP',
  ENERGY_LAP_DATA: 'ENERGY_LAP_DATA',
  ENERGY_LAP_END: 'ENERGY_LAP_END',
  ENERGY_LAP_END_DATA: 'ENERGY_LAP_END_DATA',
  ENERGY_LAP_START: 'ENERGY_LAP_START',
  ENERGY_REMAINING_PUSH_LAP: 'ENERGY_REMAINING_PUSH_LAP',
  FUEL_CONSUMPTION_LAP: 'FUEL_CONSUMPTION_LAP',
  FUEL_LAP_DATA: 'FUEL_LAP_DATA',
  FUEL_LAP_END: 'FUEL_LAP_END',
  FUEL_LAP_END_DATA: 'FUEL_LAP_END_DATA',
  FUEL_LAP_START: 'FUEL_LAP_START',
  FUEL_REMAINING_PUSH_LAP: 'FUEL_REMAINING_PUSH_LAP',
  FUEL_VOLUME_CONSUMPTION_LAP: 'FUEL_VOLUME_CONSUMPTION_LAP',
  FUEL_VOLUME_LAP_END: 'FUEL_VOLUME_LAP_END',
  FUEL_VOLUME_LAP_START: 'FUEL_VOLUME_LAP_START',
  FUEL_VOLUME_REMAINING_PUSH_LAP: 'FUEL_VOLUME_REMAINING_PUSH_LAP',
  LAPCOMMENT: 'LAPCOMMENT',
  LAPCOMMENTSYSTEMS: 'LAPCOMMENTSYSTEMS',
  LAPKPI: 'LAPKPI',
  LAPTIME: 'LAPTIME',
  LAPTYPE: 'LAPTYPE',
  NLAPRUN: 'NLAPRUN',
  NLAPSESSION: 'NLAPSESSION',
  NLAPSTINT: 'NLAPSTINT',
  POSITION: 'POSITION',
  POWER_MODE: 'POWER_MODE',
  RACECONTROLMESSAGE: 'RACECONTROLMESSAGE',
  SECTORSPEEDS: 'SECTORSPEEDS',
  SECTORTIMES: 'SECTORTIMES',
  SESSION_TIME_REMAINING: 'SESSION_TIME_REMAINING',
  SOC_CONSUMPTION_LAP: 'SOC_CONSUMPTION_LAP',
  SOC_LAP_DATA: 'SOC_LAP_DATA',
  SOC_LAP_END: 'SOC_LAP_END',
  SOC_LAP_END_DATA: 'SOC_LAP_END_DATA',
  SOC_LAP_START: 'SOC_LAP_START',
  SOC_REMAINING_PUSH_LAP: 'SOC_REMAINING_PUSH_LAP',
  TCELL: 'TCELL',
  TOPSPEED: 'TOPSPEED',
  TRACK_LAYOUT: 'TRACK_LAYOUT',
  TYRECOMPOUND: 'TYRECOMPOUND'
} as const;

export type EnumLapColumnField = typeof EnumLapColumnField[keyof typeof EnumLapColumnField];
/** Source of the lap data */
export const EnumLapDataSource = {
  CAR_DATA_SERVICE: 'CAR_DATA_SERVICE',
  LAPTIME_SERVICE: 'LAPTIME_SERVICE',
  MANUAL: 'MANUAL'
} as const;

export type EnumLapDataSource = typeof EnumLapDataSource[keyof typeof EnumLapDataSource];
export const EnumLapDataSourceType = {
  CAR_DATA_SERVICE: 'CAR_DATA_SERVICE',
  LAPTIME_SERVICE: 'LAPTIME_SERVICE',
  MANUAL: 'MANUAL'
} as const;

export type EnumLapDataSourceType = typeof EnumLapDataSourceType[keyof typeof EnumLapDataSourceType];
export const EnumLapSequenceLapsLapType = {
  ATTACK: 'ATTACK',
  COOL: 'COOL',
  FCY: 'FCY',
  IN: 'IN',
  OUT: 'OUT',
  OUTIN: 'OUTIN',
  PITLANE: 'PITLANE',
  PREP: 'PREP',
  PUSH: 'PUSH',
  QUALI: 'QUALI',
  SAFETYCAR: 'SAFETYCAR',
  SHAKEDOWN: 'SHAKEDOWN',
  SLOW: 'SLOW',
  TARGET: 'TARGET',
  TOGRID: 'TOGRID',
  TOPADDOCK: 'TOPADDOCK',
  TOPITS: 'TOPITS',
  UNFINISHED: 'UNFINISHED'
} as const;

export type EnumLapSequenceLapsLapType = typeof EnumLapSequenceLapsLapType[keyof typeof EnumLapSequenceLapsLapType];
export const EnumLapSequenceTemplateLapsLapType = {
  ATTACK_LAP: 'ATTACK_LAP',
  GARAGE: 'GARAGE',
  PREP_LAP: 'PREP_LAP',
  PUSH: 'PUSH',
  QUALI: 'QUALI',
  SLOW_LAP: 'SLOW_LAP',
  TARGET_LAP: 'TARGET_LAP',
  WAIT: 'WAIT'
} as const;

export type EnumLapSequenceTemplateLapsLapType = typeof EnumLapSequenceTemplateLapsLapType[keyof typeof EnumLapSequenceTemplateLapsLapType];
export const EnumLapType = {
  ATTACK: 'ATTACK',
  COOL: 'COOL',
  FCY: 'FCY',
  IN: 'IN',
  OUT: 'OUT',
  OUTIN: 'OUTIN',
  PITLANE: 'PITLANE',
  PREP: 'PREP',
  PUSH: 'PUSH',
  QUALI: 'QUALI',
  SAFETYCAR: 'SAFETYCAR',
  SHAKEDOWN: 'SHAKEDOWN',
  SLOW: 'SLOW',
  TARGET: 'TARGET',
  TOGRID: 'TOGRID',
  TOPADDOCK: 'TOPADDOCK',
  TOPITS: 'TOPITS',
  UNFINISHED: 'UNFINISHED'
} as const;

export type EnumLapType = typeof EnumLapType[keyof typeof EnumLapType];
export const EnumLengthUnit = {
  CENTIMETRES: 'CENTIMETRES',
  FEET: 'FEET',
  INCHES: 'INCHES',
  KILOMETRES: 'KILOMETRES',
  METRES: 'METRES',
  MICROMETRES: 'MICROMETRES',
  MILES: 'MILES',
  MILLIMETRES: 'MILLIMETRES',
  THOU: 'THOU'
} as const;

export type EnumLengthUnit = typeof EnumLengthUnit[keyof typeof EnumLengthUnit];
export const EnumLineStyle = {
  DASHED: 'DASHED',
  DASH_DOT: 'DASH_DOT',
  DOTTED: 'DOTTED',
  NONE: 'NONE',
  SOLID: 'SOLID'
} as const;

export type EnumLineStyle = typeof EnumLineStyle[keyof typeof EnumLineStyle];
export const EnumLiveStandingCurrentLocation = {
  PIT: 'PIT',
  TRACK: 'TRACK'
} as const;

export type EnumLiveStandingCurrentLocation = typeof EnumLiveStandingCurrentLocation[keyof typeof EnumLiveStandingCurrentLocation];
export const EnumLocalConnectionDataMapping = {
  Flat: 'Flat',
  Standard: 'Standard'
} as const;

export type EnumLocalConnectionDataMapping = typeof EnumLocalConnectionDataMapping[keyof typeof EnumLocalConnectionDataMapping];
export const EnumLogLevel = {
  CRITICAL: 'CRITICAL',
  DEBUG: 'DEBUG',
  ERROR: 'ERROR',
  INFO: 'INFO',
  WARNING: 'WARNING'
} as const;

export type EnumLogLevel = typeof EnumLogLevel[keyof typeof EnumLogLevel];
export const EnumLogLogLevel = {
  CRITICAL: 'CRITICAL',
  DEBUG: 'DEBUG',
  ERROR: 'ERROR',
  INFO: 'INFO',
  WARNING: 'WARNING'
} as const;

export type EnumLogLogLevel = typeof EnumLogLogLevel[keyof typeof EnumLogLogLevel];
export const EnumLogServiceSource = {
  CANOPY: 'CANOPY',
  CUSTOM_SIMULATION: 'CUSTOM_SIMULATION',
  TIMING: 'TIMING',
  WEATHER_STATION: 'WEATHER_STATION'
} as const;

export type EnumLogServiceSource = typeof EnumLogServiceSource[keyof typeof EnumLogServiceSource];
export const EnumMarkerStyle = {
  CIRCLE: 'CIRCLE',
  DIAMOND: 'DIAMOND',
  HEXAGON: 'HEXAGON',
  NONE: 'NONE',
  PENTAGON: 'PENTAGON',
  SQUARE: 'SQUARE',
  TRIANGLE: 'TRIANGLE',
  X_MARK: 'X_MARK'
} as const;

export type EnumMarkerStyle = typeof EnumMarkerStyle[keyof typeof EnumMarkerStyle];
export const EnumMassUnit = {
  GRAMS: 'GRAMS',
  KILOGRAMS: 'KILOGRAMS',
  MILLIGRAMS: 'MILLIGRAMS',
  OUNCES: 'OUNCES',
  POUNDS: 'POUNDS'
} as const;

export type EnumMassUnit = typeof EnumMassUnit[keyof typeof EnumMassUnit];
export const EnumMeCarUpdateMethod = {
  FORWARD_PROPAGATE: 'FORWARD_PROPAGATE',
  STANDARD: 'STANDARD'
} as const;

export type EnumMeCarUpdateMethod = typeof EnumMeCarUpdateMethod[keyof typeof EnumMeCarUpdateMethod];
export const EnumMigration = {
  carSetupMissingTitle: 'carSetupMissingTitle',
  eventContestantsDedup: 'eventContestantsDedup',
  issuePriority: 'issuePriority',
  lapPitOutAndInTimeStamps: 'lapPitOutAndInTimeStamps',
  lapSessionID: 'lapSessionID',
  lapsToCollection: 'lapsToCollection',
  manualMileageCustomToCarSetup: 'manualMileageCustomToCarSetup',
  readingsAllowableDamperElasticSpec: 'readingsAllowableDamperElasticSpec',
  rootSpecificationID: 'rootSpecificationID',
  runDistanceTrackingItemsCumulativeCalculation: 'runDistanceTrackingItemsCumulativeCalculation',
  runSheetAndLapTimeStamps: 'runSheetAndLapTimeStamps',
  sessionTypeToEnum: 'sessionTypeToEnum',
  setupSheetStyleTabs: 'setupSheetStyleTabs',
  setupTimingServiceStatus: 'setupTimingServiceStatus',
  teamsToTeamIDsOnPart: 'teamsToTeamIDsOnPart',
  trackingSourcesAndItems: 'trackingSourcesAndItems',
  trackingUpdate202506: 'trackingUpdate202506'
} as const;

export type EnumMigration = typeof EnumMigration[keyof typeof EnumMigration];
export const EnumOneTimingWeatherServiceConfigLogLevel = {
  CRITICAL: 'CRITICAL',
  DEBUG: 'DEBUG',
  ERROR: 'ERROR',
  INFO: 'INFO',
  NOTSET: 'NOTSET',
  WARNING: 'WARNING'
} as const;

export type EnumOneTimingWeatherServiceConfigLogLevel = typeof EnumOneTimingWeatherServiceConfigLogLevel[keyof typeof EnumOneTimingWeatherServiceConfigLogLevel];
export const EnumPackageMethod = {
  DELTA: 'DELTA',
  VALUE: 'VALUE'
} as const;

export type EnumPackageMethod = typeof EnumPackageMethod[keyof typeof EnumPackageMethod];
export const EnumPartEligibleEventTypes = {
  AERO: 'AERO',
  ALL: 'ALL',
  DYNO: 'DYNO',
  MEDIA: 'MEDIA',
  OTHER: 'OTHER',
  RACE: 'RACE',
  SIMULATOR: 'SIMULATOR',
  TEST: 'TEST'
} as const;

export type EnumPartEligibleEventTypes = typeof EnumPartEligibleEventTypes[keyof typeof EnumPartEligibleEventTypes];
export const EnumPartReadingLocationOverride = {
  CENTER: 'CENTER',
  ENGINE_IN: 'ENGINE_IN',
  ENGINE_OUT: 'ENGINE_OUT',
  FRONT: 'FRONT',
  FRONT_LEFT: 'FRONT_LEFT',
  FRONT_LEFT_FORWARD: 'FRONT_LEFT_FORWARD',
  FRONT_LEFT_INNER: 'FRONT_LEFT_INNER',
  FRONT_LEFT_LCA_FWD: 'FRONT_LEFT_LCA_FWD',
  FRONT_LEFT_LCA_RWD: 'FRONT_LEFT_LCA_RWD',
  FRONT_LEFT_LOWER: 'FRONT_LEFT_LOWER',
  FRONT_LEFT_OUTER: 'FRONT_LEFT_OUTER',
  FRONT_LEFT_PUSHROD: 'FRONT_LEFT_PUSHROD',
  FRONT_LEFT_REARWARD: 'FRONT_LEFT_REARWARD',
  FRONT_LEFT_TIEROD: 'FRONT_LEFT_TIEROD',
  FRONT_LEFT_UCA_FWD: 'FRONT_LEFT_UCA_FWD',
  FRONT_LEFT_UCA_RWD: 'FRONT_LEFT_UCA_RWD',
  FRONT_LEFT_UPPER: 'FRONT_LEFT_UPPER',
  FRONT_PRIMARY: 'FRONT_PRIMARY',
  FRONT_RIGHT: 'FRONT_RIGHT',
  FRONT_RIGHT_FORWARD: 'FRONT_RIGHT_FORWARD',
  FRONT_RIGHT_INNER: 'FRONT_RIGHT_INNER',
  FRONT_RIGHT_LCA_FWD: 'FRONT_RIGHT_LCA_FWD',
  FRONT_RIGHT_LCA_RWD: 'FRONT_RIGHT_LCA_RWD',
  FRONT_RIGHT_LOWER: 'FRONT_RIGHT_LOWER',
  FRONT_RIGHT_OUTER: 'FRONT_RIGHT_OUTER',
  FRONT_RIGHT_PUSHROD: 'FRONT_RIGHT_PUSHROD',
  FRONT_RIGHT_REARWARD: 'FRONT_RIGHT_REARWARD',
  FRONT_RIGHT_TIEROD: 'FRONT_RIGHT_TIEROD',
  FRONT_RIGHT_UCA_FWD: 'FRONT_RIGHT_UCA_FWD',
  FRONT_RIGHT_UCA_RWD: 'FRONT_RIGHT_UCA_RWD',
  FRONT_RIGHT_UPPER: 'FRONT_RIGHT_UPPER',
  FRONT_SECONDARY: 'FRONT_SECONDARY',
  GBX_IN: 'GBX_IN',
  GBX_OUT: 'GBX_OUT',
  INPUT: 'INPUT',
  LEFT: 'LEFT',
  MGU_IN: 'MGU_IN',
  MGU_OUT: 'MGU_OUT',
  OUTPUT: 'OUTPUT',
  PRIMARY: 'PRIMARY',
  REAR: 'REAR',
  REAR_LEFT: 'REAR_LEFT',
  REAR_LEFT_FORWARD: 'REAR_LEFT_FORWARD',
  REAR_LEFT_INNER: 'REAR_LEFT_INNER',
  REAR_LEFT_LCA_FWD: 'REAR_LEFT_LCA_FWD',
  REAR_LEFT_LCA_RWD: 'REAR_LEFT_LCA_RWD',
  REAR_LEFT_LOWER: 'REAR_LEFT_LOWER',
  REAR_LEFT_OUTER: 'REAR_LEFT_OUTER',
  REAR_LEFT_PUSHROD: 'REAR_LEFT_PUSHROD',
  REAR_LEFT_REARWARD: 'REAR_LEFT_REARWARD',
  REAR_LEFT_TIEROD: 'REAR_LEFT_TIEROD',
  REAR_LEFT_UCA_FWD: 'REAR_LEFT_UCA_FWD',
  REAR_LEFT_UCA_RWD: 'REAR_LEFT_UCA_RWD',
  REAR_LEFT_UPPER: 'REAR_LEFT_UPPER',
  REAR_PRIMARY: 'REAR_PRIMARY',
  REAR_RIGHT: 'REAR_RIGHT',
  REAR_RIGHT_FORWARD: 'REAR_RIGHT_FORWARD',
  REAR_RIGHT_INNER: 'REAR_RIGHT_INNER',
  REAR_RIGHT_LCA_FWD: 'REAR_RIGHT_LCA_FWD',
  REAR_RIGHT_LCA_RWD: 'REAR_RIGHT_LCA_RWD',
  REAR_RIGHT_LOWER: 'REAR_RIGHT_LOWER',
  REAR_RIGHT_OUTER: 'REAR_RIGHT_OUTER',
  REAR_RIGHT_PUSHROD: 'REAR_RIGHT_PUSHROD',
  REAR_RIGHT_REARWARD: 'REAR_RIGHT_REARWARD',
  REAR_RIGHT_TIEROD: 'REAR_RIGHT_TIEROD',
  REAR_RIGHT_UCA_FWD: 'REAR_RIGHT_UCA_FWD',
  REAR_RIGHT_UCA_RWD: 'REAR_RIGHT_UCA_RWD',
  REAR_RIGHT_UPPER: 'REAR_RIGHT_UPPER',
  REAR_SECONDARY: 'REAR_SECONDARY',
  RIGHT: 'RIGHT',
  SECONDARY: 'SECONDARY',
  SINGLE: 'SINGLE',
  STEERING_COLUMN: 'STEERING_COLUMN',
  STEERING_RACK: 'STEERING_RACK',
  STEERING_SHAFT: 'STEERING_SHAFT'
} as const;

export type EnumPartReadingLocationOverride = typeof EnumPartReadingLocationOverride[keyof typeof EnumPartReadingLocationOverride];
export const EnumPersonCarUpdateMethod = {
  FORWARD_PROPAGATE: 'FORWARD_PROPAGATE',
  STANDARD: 'STANDARD'
} as const;

export type EnumPersonCarUpdateMethod = typeof EnumPersonCarUpdateMethod[keyof typeof EnumPersonCarUpdateMethod];
export const EnumPersonMileageUnit = {
  CENTIMETRES: 'CENTIMETRES',
  FEET: 'FEET',
  INCHES: 'INCHES',
  KILOMETRES: 'KILOMETRES',
  METRES: 'METRES',
  MICROMETRES: 'MICROMETRES',
  MILES: 'MILES',
  MILLIMETRES: 'MILLIMETRES',
  THOU: 'THOU'
} as const;

export type EnumPersonMileageUnit = typeof EnumPersonMileageUnit[keyof typeof EnumPersonMileageUnit];
export const EnumPersonRole = {
  ADMIN: 'ADMIN',
  CAR_ENGINEER: 'CAR_ENGINEER',
  CHIEF_ENGINEER: 'CHIEF_ENGINEER',
  DRIVER: 'DRIVER',
  FAULT_ADMIN: 'FAULT_ADMIN',
  MANAGEMENT: 'MANAGEMENT',
  MECHANIC: 'MECHANIC',
  READ_ONLY: 'READ_ONLY',
  SETUP_REVIEWER: 'SETUP_REVIEWER',
  TYRE_ENGINEER: 'TYRE_ENGINEER',
  WORKSHOP_MANAGEMENT: 'WORKSHOP_MANAGEMENT'
} as const;

export type EnumPersonRole = typeof EnumPersonRole[keyof typeof EnumPersonRole];
export const EnumPlotConfigXAxisType = {
  NUMBER: 'NUMBER',
  TIME: 'TIME'
} as const;

export type EnumPlotConfigXAxisType = typeof EnumPlotConfigXAxisType[keyof typeof EnumPlotConfigXAxisType];
export const EnumPossibleUnit = {
  BAR: 'BAR',
  CELSIUS: 'CELSIUS',
  CENTIMETRES: 'CENTIMETRES',
  DAYS: 'DAYS',
  DEGREES: 'DEGREES',
  DEGREES_PER_FOOT_POUND: 'DEGREES_PER_FOOT_POUND',
  DEGREES_PER_INCHES: 'DEGREES_PER_INCHES',
  DEGREES_PER_MILLIMETRES: 'DEGREES_PER_MILLIMETRES',
  DEGREES_PER_POUND: 'DEGREES_PER_POUND',
  DEGREES_PER_SECOND: 'DEGREES_PER_SECOND',
  DEGREES_PER_SECOND_SQUARED: 'DEGREES_PER_SECOND_SQUARED',
  FAHRENHEIT: 'FAHRENHEIT',
  FEET: 'FEET',
  FEET_PER_SECOND: 'FEET_PER_SECOND',
  FEET_PER_SECOND_SQUARED: 'FEET_PER_SECOND_SQUARED',
  GALLONS: 'GALLONS',
  GFORCE: 'GFORCE',
  GRAMS: 'GRAMS',
  HORSEPOWER_MECHANICAL: 'HORSEPOWER_MECHANICAL',
  HOURS: 'HOURS',
  INCHES: 'INCHES',
  INCHES_OF_MERCURY: 'INCHES_OF_MERCURY',
  INCHES_PER_POUND_FORCE: 'INCHES_PER_POUND_FORCE',
  JOULES: 'JOULES',
  KELVIN: 'KELVIN',
  KILOGRAMS: 'KILOGRAMS',
  KILOGRAM_METRES_SQUARED: 'KILOGRAM_METRES_SQUARED',
  KILOJOULES: 'KILOJOULES',
  KILOMETRES: 'KILOMETRES',
  KILOMETRES_PER_HOUR: 'KILOMETRES_PER_HOUR',
  KILOPASCALS: 'KILOPASCALS',
  KILOWATTS: 'KILOWATTS',
  KILOWATT_HOURS: 'KILOWATT_HOURS',
  LITRES: 'LITRES',
  METRES: 'METRES',
  METRES_CUBED: 'METRES_CUBED',
  METRES_PER_NEWTON: 'METRES_PER_NEWTON',
  METRES_PER_SECOND: 'METRES_PER_SECOND',
  METRES_PER_SECOND_SQUARED: 'METRES_PER_SECOND_SQUARED',
  MICROMETRES: 'MICROMETRES',
  MILES: 'MILES',
  MILES_PER_HOUR: 'MILES_PER_HOUR',
  MILLIBAR: 'MILLIBAR',
  MILLIGRAMS: 'MILLIGRAMS',
  MILLILITRES: 'MILLILITRES',
  MILLIMETRES: 'MILLIMETRES',
  MILLIMETRES_PER_NEWTON: 'MILLIMETRES_PER_NEWTON',
  MILLISECONDS: 'MILLISECONDS',
  MINUTES: 'MINUTES',
  NEWTONS: 'NEWTONS',
  NEWTONS_PER_METRE: 'NEWTONS_PER_METRE',
  NEWTONS_PER_MILLIMETRE: 'NEWTONS_PER_MILLIMETRE',
  NEWTON_METRES: 'NEWTON_METRES',
  NEWTON_METRES_PER_DEGREE: 'NEWTON_METRES_PER_DEGREE',
  NEWTON_METRES_PER_RADIAN: 'NEWTON_METRES_PER_RADIAN',
  NEWTON_MILLIMETRES: 'NEWTON_MILLIMETRES',
  NONE: 'NONE',
  NUMBER: 'NUMBER',
  OUNCES: 'OUNCES',
  PASCALS: 'PASCALS',
  PERCENT: 'PERCENT',
  POUNDS: 'POUNDS',
  POUNDS_FEET_PER_DEGREE: 'POUNDS_FEET_PER_DEGREE',
  POUNDS_FEET_PER_RADIAN: 'POUNDS_FEET_PER_RADIAN',
  POUNDS_FORCE: 'POUNDS_FORCE',
  POUNDS_INCHES_PER_DEGREE: 'POUNDS_INCHES_PER_DEGREE',
  POUNDS_INCHES_PER_RADIAN: 'POUNDS_INCHES_PER_RADIAN',
  POUNDS_PER_INCH: 'POUNDS_PER_INCH',
  POUND_FOOT_ENERGY: 'POUND_FOOT_ENERGY',
  POUND_FOOT_SECONDS_SQUARED: 'POUND_FOOT_SECONDS_SQUARED',
  POUND_FORCE_FEET: 'POUND_FORCE_FEET',
  POUND_FORCE_INCHES: 'POUND_FORCE_INCHES',
  PSI: 'PSI',
  RADIANS: 'RADIANS',
  RADIANS_PER_NEWTON: 'RADIANS_PER_NEWTON',
  RADIANS_PER_NEWTON_METRE: 'RADIANS_PER_NEWTON_METRE',
  RADIANS_PER_SECOND: 'RADIANS_PER_SECOND',
  RADIANS_PER_SECOND_SQUARED: 'RADIANS_PER_SECOND_SQUARED',
  RATIO: 'RATIO',
  SECONDS: 'SECONDS',
  STRING: 'STRING',
  THOU: 'THOU',
  WATTS: 'WATTS'
} as const;

export type EnumPossibleUnit = typeof EnumPossibleUnit[keyof typeof EnumPossibleUnit];
export const EnumPowerUnit = {
  HORSEPOWER_MECHANICAL: 'HORSEPOWER_MECHANICAL',
  KILOWATTS: 'KILOWATTS',
  WATTS: 'WATTS'
} as const;

export type EnumPowerUnit = typeof EnumPowerUnit[keyof typeof EnumPowerUnit];
export const EnumPowertrainLayout = {
  F4: 'F4',
  FF: 'FF',
  FR: 'FR',
  M4: 'M4',
  MR: 'MR',
  R4: 'R4',
  RR: 'RR'
} as const;

export type EnumPowertrainLayout = typeof EnumPowertrainLayout[keyof typeof EnumPowertrainLayout];
export const EnumPressureOption = {
  PARC_FERME_EXPECTED: 'PARC_FERME_EXPECTED',
  POST_RUN: 'POST_RUN',
  POST_RUN_BLEED: 'POST_RUN_BLEED',
  SET_DOWN: 'SET_DOWN'
} as const;

export type EnumPressureOption = typeof EnumPressureOption[keyof typeof EnumPressureOption];
export const EnumPressureUnit = {
  BAR: 'BAR',
  INCHES_OF_MERCURY: 'INCHES_OF_MERCURY',
  KILOPASCALS: 'KILOPASCALS',
  MILLIBAR: 'MILLIBAR',
  PASCALS: 'PASCALS',
  PSI: 'PSI'
} as const;

export type EnumPressureUnit = typeof EnumPressureUnit[keyof typeof EnumPressureUnit];
export const EnumQualityCheckActionPriority = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  MAXIMUM: 'MAXIMUM',
  MEDIUM: 'MEDIUM',
  NONE: 'NONE',
  PRIO1_MAXIMUM: 'PRIO1_MAXIMUM',
  PRIO2_HIGH: 'PRIO2_HIGH',
  PRIO3_MEDIUM: 'PRIO3_MEDIUM',
  PRIO4_LOW: 'PRIO4_LOW',
  PRIO5_NONE: 'PRIO5_NONE'
} as const;

export type EnumQualityCheckActionPriority = typeof EnumQualityCheckActionPriority[keyof typeof EnumQualityCheckActionPriority];
export const EnumQualityCheckActionStatus = {
  COMPLETE: 'COMPLETE',
  ONGOING: 'ONGOING',
  TODO: 'TODO'
} as const;

export type EnumQualityCheckActionStatus = typeof EnumQualityCheckActionStatus[keyof typeof EnumQualityCheckActionStatus];
export const EnumRaceSeriesDriversPerCar = {
  multiple: 'multiple',
  single: 'single'
} as const;

export type EnumRaceSeriesDriversPerCar = typeof EnumRaceSeriesDriversPerCar[keyof typeof EnumRaceSeriesDriversPerCar];
export const EnumRatioUnit = {
  PERCENT: 'PERCENT',
  RATIO: 'RATIO'
} as const;

export type EnumRatioUnit = typeof EnumRatioUnit[keyof typeof EnumRatioUnit];
export const EnumReadingLocation = {
  CENTER: 'CENTER',
  ENGINE_IN: 'ENGINE_IN',
  ENGINE_OUT: 'ENGINE_OUT',
  FRONT: 'FRONT',
  FRONT_LEFT: 'FRONT_LEFT',
  FRONT_LEFT_FORWARD: 'FRONT_LEFT_FORWARD',
  FRONT_LEFT_INNER: 'FRONT_LEFT_INNER',
  FRONT_LEFT_LCA_FWD: 'FRONT_LEFT_LCA_FWD',
  FRONT_LEFT_LCA_RWD: 'FRONT_LEFT_LCA_RWD',
  FRONT_LEFT_LOWER: 'FRONT_LEFT_LOWER',
  FRONT_LEFT_OUTER: 'FRONT_LEFT_OUTER',
  FRONT_LEFT_PUSHROD: 'FRONT_LEFT_PUSHROD',
  FRONT_LEFT_REARWARD: 'FRONT_LEFT_REARWARD',
  FRONT_LEFT_TIEROD: 'FRONT_LEFT_TIEROD',
  FRONT_LEFT_UCA_FWD: 'FRONT_LEFT_UCA_FWD',
  FRONT_LEFT_UCA_RWD: 'FRONT_LEFT_UCA_RWD',
  FRONT_LEFT_UPPER: 'FRONT_LEFT_UPPER',
  FRONT_PRIMARY: 'FRONT_PRIMARY',
  FRONT_RIGHT: 'FRONT_RIGHT',
  FRONT_RIGHT_FORWARD: 'FRONT_RIGHT_FORWARD',
  FRONT_RIGHT_INNER: 'FRONT_RIGHT_INNER',
  FRONT_RIGHT_LCA_FWD: 'FRONT_RIGHT_LCA_FWD',
  FRONT_RIGHT_LCA_RWD: 'FRONT_RIGHT_LCA_RWD',
  FRONT_RIGHT_LOWER: 'FRONT_RIGHT_LOWER',
  FRONT_RIGHT_OUTER: 'FRONT_RIGHT_OUTER',
  FRONT_RIGHT_PUSHROD: 'FRONT_RIGHT_PUSHROD',
  FRONT_RIGHT_REARWARD: 'FRONT_RIGHT_REARWARD',
  FRONT_RIGHT_TIEROD: 'FRONT_RIGHT_TIEROD',
  FRONT_RIGHT_UCA_FWD: 'FRONT_RIGHT_UCA_FWD',
  FRONT_RIGHT_UCA_RWD: 'FRONT_RIGHT_UCA_RWD',
  FRONT_RIGHT_UPPER: 'FRONT_RIGHT_UPPER',
  FRONT_SECONDARY: 'FRONT_SECONDARY',
  GBX_IN: 'GBX_IN',
  GBX_OUT: 'GBX_OUT',
  INPUT: 'INPUT',
  LEFT: 'LEFT',
  MGU_IN: 'MGU_IN',
  MGU_OUT: 'MGU_OUT',
  OUTPUT: 'OUTPUT',
  PRIMARY: 'PRIMARY',
  REAR: 'REAR',
  REAR_LEFT: 'REAR_LEFT',
  REAR_LEFT_FORWARD: 'REAR_LEFT_FORWARD',
  REAR_LEFT_INNER: 'REAR_LEFT_INNER',
  REAR_LEFT_LCA_FWD: 'REAR_LEFT_LCA_FWD',
  REAR_LEFT_LCA_RWD: 'REAR_LEFT_LCA_RWD',
  REAR_LEFT_LOWER: 'REAR_LEFT_LOWER',
  REAR_LEFT_OUTER: 'REAR_LEFT_OUTER',
  REAR_LEFT_PUSHROD: 'REAR_LEFT_PUSHROD',
  REAR_LEFT_REARWARD: 'REAR_LEFT_REARWARD',
  REAR_LEFT_TIEROD: 'REAR_LEFT_TIEROD',
  REAR_LEFT_UCA_FWD: 'REAR_LEFT_UCA_FWD',
  REAR_LEFT_UCA_RWD: 'REAR_LEFT_UCA_RWD',
  REAR_LEFT_UPPER: 'REAR_LEFT_UPPER',
  REAR_PRIMARY: 'REAR_PRIMARY',
  REAR_RIGHT: 'REAR_RIGHT',
  REAR_RIGHT_FORWARD: 'REAR_RIGHT_FORWARD',
  REAR_RIGHT_INNER: 'REAR_RIGHT_INNER',
  REAR_RIGHT_LCA_FWD: 'REAR_RIGHT_LCA_FWD',
  REAR_RIGHT_LCA_RWD: 'REAR_RIGHT_LCA_RWD',
  REAR_RIGHT_LOWER: 'REAR_RIGHT_LOWER',
  REAR_RIGHT_OUTER: 'REAR_RIGHT_OUTER',
  REAR_RIGHT_PUSHROD: 'REAR_RIGHT_PUSHROD',
  REAR_RIGHT_REARWARD: 'REAR_RIGHT_REARWARD',
  REAR_RIGHT_TIEROD: 'REAR_RIGHT_TIEROD',
  REAR_RIGHT_UCA_FWD: 'REAR_RIGHT_UCA_FWD',
  REAR_RIGHT_UCA_RWD: 'REAR_RIGHT_UCA_RWD',
  REAR_RIGHT_UPPER: 'REAR_RIGHT_UPPER',
  REAR_SECONDARY: 'REAR_SECONDARY',
  RIGHT: 'RIGHT',
  SECONDARY: 'SECONDARY',
  SINGLE: 'SINGLE',
  STEERING_COLUMN: 'STEERING_COLUMN',
  STEERING_RACK: 'STEERING_RACK',
  STEERING_SHAFT: 'STEERING_SHAFT'
} as const;

export type EnumReadingLocation = typeof EnumReadingLocation[keyof typeof EnumReadingLocation];
export const EnumReportNotePageAppendixNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotePageAppendixNotesMode = typeof EnumReportNotePageAppendixNotesMode[keyof typeof EnumReportNotePageAppendixNotesMode];
export const EnumReportNotePageOverviewNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotePageOverviewNotesMode = typeof EnumReportNotePageOverviewNotesMode[keyof typeof EnumReportNotePageOverviewNotesMode];
export const EnumReportNotePagePartsNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotePagePartsNotesMode = typeof EnumReportNotePagePartsNotesMode[keyof typeof EnumReportNotePagePartsNotesMode];
export const EnumReportNotePageRunPlanNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotePageRunPlanNotesMode = typeof EnumReportNotePageRunPlanNotesMode[keyof typeof EnumReportNotePageRunPlanNotesMode];
export const EnumReportNotePageSessionNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotePageSessionNotesMode = typeof EnumReportNotePageSessionNotesMode[keyof typeof EnumReportNotePageSessionNotesMode];
export const EnumReportNotesTemplatePageAppendixNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotesTemplatePageAppendixNotesMode = typeof EnumReportNotesTemplatePageAppendixNotesMode[keyof typeof EnumReportNotesTemplatePageAppendixNotesMode];
export const EnumReportNotesTemplatePageOverviewNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotesTemplatePageOverviewNotesMode = typeof EnumReportNotesTemplatePageOverviewNotesMode[keyof typeof EnumReportNotesTemplatePageOverviewNotesMode];
export const EnumReportNotesTemplatePagePartsNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotesTemplatePagePartsNotesMode = typeof EnumReportNotesTemplatePagePartsNotesMode[keyof typeof EnumReportNotesTemplatePagePartsNotesMode];
export const EnumReportNotesTemplatePageRunPlanNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotesTemplatePageRunPlanNotesMode = typeof EnumReportNotesTemplatePageRunPlanNotesMode[keyof typeof EnumReportNotesTemplatePageRunPlanNotesMode];
export const EnumReportNotesTemplatePageSessionNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotesTemplatePageSessionNotesMode = typeof EnumReportNotesTemplatePageSessionNotesMode[keyof typeof EnumReportNotesTemplatePageSessionNotesMode];
export const EnumReportPage = {
  pageAppendix: 'pageAppendix',
  pageOverview: 'pageOverview',
  pageParts: 'pageParts',
  pageRunPlan: 'pageRunPlan',
  pageSession: 'pageSession'
} as const;

export type EnumReportPage = typeof EnumReportPage[keyof typeof EnumReportPage];
export const EnumReportTemplateIssuesColumnsField = {
  area: 'area',
  assignees: 'assignees',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  department: 'department',
  description: 'description',
  descriptionDetails: 'descriptionDetails',
  issueStatus: 'issueStatus',
  number: 'number',
  priority: 'priority',
  tags: 'tags',
  teams: 'teams',
  updatedAt: 'updatedAt'
} as const;

export type EnumReportTemplateIssuesColumnsField = typeof EnumReportTemplateIssuesColumnsField[keyof typeof EnumReportTemplateIssuesColumnsField];
export const EnumReportTemplateIssuesGroupBy = {
  area: 'area',
  cat: 'cat',
  createdBy: 'createdBy',
  customer: 'customer',
  department: 'department',
  responsible: 'responsible',
  status: 'status',
  tags: 'tags'
} as const;

export type EnumReportTemplateIssuesGroupBy = typeof EnumReportTemplateIssuesGroupBy[keyof typeof EnumReportTemplateIssuesGroupBy];
export const EnumReportTemplateRunInfoColumnsField = {
  NRunData: 'NRunData',
  NRunTiming: 'NRunTiming',
  TAmbient: 'TAmbient',
  TTrack: 'TTrack',
  brakeComment: 'brakeComment',
  controlsComment: 'controlsComment',
  dilComments: 'dilComments',
  driverAcronym: 'driverAcronym',
  driverComments: 'driverComments',
  endTime: 'endTime',
  engineerComments: 'engineerComments',
  fastestLap: 'fastestLap',
  info: 'info',
  lapcount: 'lapcount',
  mFuelRunStart: 'mFuelRunStart',
  mileage: 'mileage',
  problemComments: 'problemComments',
  runDescription: 'runDescription',
  skidComment: 'skidComment',
  startNumber: 'startNumber',
  startTime: 'startTime',
  systemsComments: 'systemsComments',
  tyreComments: 'tyreComments',
  tyreSetName: 'tyreSetName'
} as const;

export type EnumReportTemplateRunInfoColumnsField = typeof EnumReportTemplateRunInfoColumnsField[keyof typeof EnumReportTemplateRunInfoColumnsField];
export const EnumRunEnergyField = {
  ATTACK: 'ATTACK',
  COOL: 'COOL',
  FCY: 'FCY',
  IN: 'IN',
  OUT: 'OUT',
  OUTIN: 'OUTIN',
  PITLANE: 'PITLANE',
  PREP: 'PREP',
  PUSH: 'PUSH',
  QUALI: 'QUALI',
  SAFETYCAR: 'SAFETYCAR',
  SHAKEDOWN: 'SHAKEDOWN',
  SLOW: 'SLOW',
  TARGET: 'TARGET',
  TOGRID: 'TOGRID',
  TOPADDOCK: 'TOPADDOCK',
  TOPITS: 'TOPITS',
  UNFINISHED: 'UNFINISHED'
} as const;

export type EnumRunEnergyField = typeof EnumRunEnergyField[keyof typeof EnumRunEnergyField];
export const EnumRunPlanRunPriority = {
  PRIO1_MAXIMUM: 'PRIO1_MAXIMUM',
  PRIO2_HIGH: 'PRIO2_HIGH',
  PRIO3_MEDIUM: 'PRIO3_MEDIUM',
  PRIO4_LOW: 'PRIO4_LOW',
  PRIO5_NONE: 'PRIO5_NONE'
} as const;

export type EnumRunPlanRunPriority = typeof EnumRunPlanRunPriority[keyof typeof EnumRunPlanRunPriority];
export const EnumRunSheetKpiStatus = {
  AUGMENTATION: 'AUGMENTATION',
  DATA: 'DATA',
  VTAG: 'VTAG'
} as const;

export type EnumRunSheetKpiStatus = typeof EnumRunSheetKpiStatus[keyof typeof EnumRunSheetKpiStatus];
export const EnumRunSheetStyleBlockStyle = {
  F2: 'F2',
  FE: 'FE',
  GT: 'GT',
  LMP2: 'LMP2',
  WSERIES: 'WSERIES'
} as const;

export type EnumRunSheetStyleBlockStyle = typeof EnumRunSheetStyleBlockStyle[keyof typeof EnumRunSheetStyleBlockStyle];
export const EnumServerSettingsSimulationColoringMethod = {
  INHERIT_FROM_RUN: 'INHERIT_FROM_RUN',
  OWN_PALETTE: 'OWN_PALETTE'
} as const;

export type EnumServerSettingsSimulationColoringMethod = typeof EnumServerSettingsSimulationColoringMethod[keyof typeof EnumServerSettingsSimulationColoringMethod];
export const EnumSessionDebriefNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumSessionDebriefNotesMode = typeof EnumSessionDebriefNotesMode[keyof typeof EnumSessionDebriefNotesMode];
export const EnumSessionType = {
  DiL: 'DiL',
  EventSchedule: 'EventSchedule',
  ExternalMeeting: 'ExternalMeeting',
  FreePractice: 'FreePractice',
  Info: 'Info',
  InternalMeeting: 'InternalMeeting',
  ParcFerme: 'ParcFerme',
  Qualifying: 'Qualifying',
  Race: 'Race',
  SessionNotification: 'SessionNotification',
  Setup: 'Setup',
  Simulation: 'Simulation',
  Team: 'Team',
  Test: 'Test',
  VirtualMeeting: 'VirtualMeeting'
} as const;

export type EnumSessionType = typeof EnumSessionType[keyof typeof EnumSessionType];
export const EnumSetupSheetStyleItemType = {
  CHECKBOX: 'CHECKBOX',
  INPUT: 'INPUT',
  LABEL: 'LABEL',
  READONLY_FIELD: 'READONLY_FIELD',
  SELECT: 'SELECT',
  SPACER: 'SPACER'
} as const;

export type EnumSetupSheetStyleItemType = typeof EnumSetupSheetStyleItemType[keyof typeof EnumSetupSheetStyleItemType];
export const EnumSetupSheetStyleTabType = {
  CHASSIS_MEASUREMENT: 'CHASSIS_MEASUREMENT',
  CUSTOM: 'CUSTOM',
  MASS: 'MASS',
  MILEAGE: 'MILEAGE',
  XE_CALCULATIONS: 'XE_CALCULATIONS'
} as const;

export type EnumSetupSheetStyleTabType = typeof EnumSetupSheetStyleTabType[keyof typeof EnumSetupSheetStyleTabType];
export const EnumSetupSheetStyleTargetEventType = {
  AEROTEST: 'AEROTEST',
  ANY: 'ANY',
  OVAL: 'OVAL',
  ROADCOURSE: 'ROADCOURSE'
} as const;

export type EnumSetupSheetStyleTargetEventType = typeof EnumSetupSheetStyleTargetEventType[keyof typeof EnumSetupSheetStyleTargetEventType];
export const EnumSetupSheetStyleType = {
  FULL: 'FULL',
  MINI: 'MINI',
  SIMULATION: 'SIMULATION'
} as const;

export type EnumSetupSheetStyleType = typeof EnumSetupSheetStyleType[keyof typeof EnumSetupSheetStyleType];
export const EnumSimModelType = {
  CANOPY: 'CANOPY',
  CHASSIS_SIM: 'CHASSIS_SIM',
  CUSTOM: 'CUSTOM'
} as const;

export type EnumSimModelType = typeof EnumSimModelType[keyof typeof EnumSimModelType];
export const EnumSimRequestRequesterSlot = {
  RUN01_06: 'RUN01_06',
  SETUP01_02: 'SETUP01_02'
} as const;

export type EnumSimRequestRequesterSlot = typeof EnumSimRequestRequesterSlot[keyof typeof EnumSimRequestRequesterSlot];
export const EnumSimRequestSimType = {
  CAR_MODEL_POST: 'CAR_MODEL_POST',
  DATA_REPLAY: 'DATA_REPLAY',
  DEVELOPMENT: 'DEVELOPMENT',
  DYNAMIC_LAP: 'DYNAMIC_LAP',
  EIGHT_POST: 'EIGHT_POST',
  KINEMATICS: 'KINEMATICS',
  KNC: 'KNC',
  MODEL_REQUEST: 'MODEL_REQUEST',
  QUASI_STATIC_LAP: 'QUASI_STATIC_LAP',
  SETUP: 'SETUP',
  STEADY_STATE_LATERAL: 'STEADY_STATE_LATERAL',
  STEADY_STATE_STRAIGHT_LINE: 'STEADY_STATE_STRAIGHT_LINE'
} as const;

export type EnumSimRequestSimType = typeof EnumSimRequestSimType[keyof typeof EnumSimRequestSimType];
export const EnumSimResultDataInterpolationMethod = {
  HOLD_PREVIOUS: 'HOLD_PREVIOUS',
  LINEAR: 'LINEAR',
  NEAREST: 'NEAREST',
  NONE: 'NONE'
} as const;

export type EnumSimResultDataInterpolationMethod = typeof EnumSimResultDataInterpolationMethod[keyof typeof EnumSimResultDataInterpolationMethod];
export const EnumSimResultSimType = {
  CAR_MODEL_POST: 'CAR_MODEL_POST',
  DATA_REPLAY: 'DATA_REPLAY',
  DEVELOPMENT: 'DEVELOPMENT',
  DYNAMIC_LAP: 'DYNAMIC_LAP',
  EIGHT_POST: 'EIGHT_POST',
  KINEMATICS: 'KINEMATICS',
  KNC: 'KNC',
  MODEL_REQUEST: 'MODEL_REQUEST',
  QUASI_STATIC_LAP: 'QUASI_STATIC_LAP',
  SETUP: 'SETUP',
  STEADY_STATE_LATERAL: 'STEADY_STATE_LATERAL',
  STEADY_STATE_STRAIGHT_LINE: 'STEADY_STATE_STRAIGHT_LINE'
} as const;

export type EnumSimResultSimType = typeof EnumSimResultSimType[keyof typeof EnumSimResultSimType];
export const EnumSimResultStatus = {
  COMPLETE: 'COMPLETE',
  DRAFT: 'DRAFT',
  FAILED: 'FAILED',
  QUEUED: 'QUEUED',
  RUNNING: 'RUNNING'
} as const;

export type EnumSimResultStatus = typeof EnumSimResultStatus[keyof typeof EnumSimResultStatus];
export const EnumSimulationDriveFileStatus = {
  ARCHIVED: 'ARCHIVED',
  DRAFT: 'DRAFT',
  RELEASED: 'RELEASED'
} as const;

export type EnumSimulationDriveFileStatus = typeof EnumSimulationDriveFileStatus[keyof typeof EnumSimulationDriveFileStatus];
export const EnumSpecificationACamberReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumSpecificationACamberReadingsRequired = typeof EnumSpecificationACamberReadingsRequired[keyof typeof EnumSpecificationACamberReadingsRequired];
export const EnumSpecificationACamberUnit = {
  DEGREES: 'DEGREES',
  MINUTES: 'MINUTES',
  RADIANS: 'RADIANS'
} as const;

export type EnumSpecificationACamberUnit = typeof EnumSpecificationACamberUnit[keyof typeof EnumSpecificationACamberUnit];
export const EnumSpecificationAdminAeroElementInterpolationMethod = {
  AFLAP: 'AFLAP',
  CLOSEST: 'CLOSEST',
  LINEAR: 'LINEAR',
  NONE: 'NONE',
  POLYNOMIAL: 'POLYNOMIAL',
  SPLINE: 'SPLINE'
} as const;

export type EnumSpecificationAdminAeroElementInterpolationMethod = typeof EnumSpecificationAdminAeroElementInterpolationMethod[keyof typeof EnumSpecificationAdminAeroElementInterpolationMethod];
export const EnumSpecificationAdminAeroElementType = {
  INTERPOLATE: 'INTERPOLATE',
  POLYNOMIAL: 'POLYNOMIAL',
  STRICT: 'STRICT'
} as const;

export type EnumSpecificationAdminAeroElementType = typeof EnumSpecificationAdminAeroElementType[keyof typeof EnumSpecificationAdminAeroElementType];
export const EnumSpecificationAdminAntiRollBarDisplayLocation = {
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumSpecificationAdminAntiRollBarDisplayLocation = typeof EnumSpecificationAdminAntiRollBarDisplayLocation[keyof typeof EnumSpecificationAdminAntiRollBarDisplayLocation];
export const EnumSpecificationAdminAxle = {
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumSpecificationAdminAxle = typeof EnumSpecificationAdminAxle[keyof typeof EnumSpecificationAdminAxle];
export const EnumSpecificationAdminBumpRubberReference = {
  DROOP: 'DROOP',
  FORCE: 'FORCE',
  REF: 'REF',
  STATIC: 'STATIC'
} as const;

export type EnumSpecificationAdminBumpRubberReference = typeof EnumSpecificationAdminBumpRubberReference[keyof typeof EnumSpecificationAdminBumpRubberReference];
export const EnumSpecificationAdminBumpStopGapMethod = {
  GAP_TO_BASE: 'GAP_TO_BASE',
  GAP_TO_TOP: 'GAP_TO_TOP',
  PACKER_STACK: 'PACKER_STACK'
} as const;

export type EnumSpecificationAdminBumpStopGapMethod = typeof EnumSpecificationAdminBumpStopGapMethod[keyof typeof EnumSpecificationAdminBumpStopGapMethod];
export const EnumSpecificationAdminElasticType = {
  BUMP_RUBBER: 'BUMP_RUBBER',
  HELPER_SPRING: 'HELPER_SPRING',
  REBOUND_SPRING: 'REBOUND_SPRING',
  SPRING: 'SPRING',
  TORSION_BAR: 'TORSION_BAR'
} as const;

export type EnumSpecificationAdminElasticType = typeof EnumSpecificationAdminElasticType[keyof typeof EnumSpecificationAdminElasticType];
export const EnumSpecificationAdminGearType = {
  BEVEL_SET: 'BEVEL_SET',
  DROP_GEAR: 'DROP_GEAR',
  STANDARD: 'STANDARD'
} as const;

export type EnumSpecificationAdminGearType = typeof EnumSpecificationAdminGearType[keyof typeof EnumSpecificationAdminGearType];
export const EnumSpecificationAdminModelTypes = {
  CANOPY: 'CANOPY',
  CHASSIS_SIM: 'CHASSIS_SIM',
  CUSTOM: 'CUSTOM'
} as const;

export type EnumSpecificationAdminModelTypes = typeof EnumSpecificationAdminModelTypes[keyof typeof EnumSpecificationAdminModelTypes];
export const EnumSpecificationAdminPowertrainLocation = {
  CENTRAL: 'CENTRAL',
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumSpecificationAdminPowertrainLocation = typeof EnumSpecificationAdminPowertrainLocation[keyof typeof EnumSpecificationAdminPowertrainLocation];
export const EnumSpecificationAdminReadingsAllowable = {
  FRONT: 'FRONT',
  FRONT_LEFT: 'FRONT_LEFT',
  FRONT_LEFT_LCA_FWD: 'FRONT_LEFT_LCA_FWD',
  FRONT_LEFT_LCA_RWD: 'FRONT_LEFT_LCA_RWD',
  FRONT_LEFT_UCA_FWD: 'FRONT_LEFT_UCA_FWD',
  FRONT_LEFT_UCA_RWD: 'FRONT_LEFT_UCA_RWD',
  FRONT_RIGHT: 'FRONT_RIGHT',
  FRONT_RIGHT_LCA_FWD: 'FRONT_RIGHT_LCA_FWD',
  FRONT_RIGHT_LCA_RWD: 'FRONT_RIGHT_LCA_RWD',
  FRONT_RIGHT_UCA_FWD: 'FRONT_RIGHT_UCA_FWD',
  FRONT_RIGHT_UCA_RWD: 'FRONT_RIGHT_UCA_RWD',
  LEFT: 'LEFT',
  REAR: 'REAR',
  REAR_LEFT: 'REAR_LEFT',
  REAR_LEFT_LCA_FWD: 'REAR_LEFT_LCA_FWD',
  REAR_LEFT_LCA_RWD: 'REAR_LEFT_LCA_RWD',
  REAR_LEFT_UCA_FWD: 'REAR_LEFT_UCA_FWD',
  REAR_LEFT_UCA_RWD: 'REAR_LEFT_UCA_RWD',
  REAR_RIGHT: 'REAR_RIGHT',
  REAR_RIGHT_LCA_FWD: 'REAR_RIGHT_LCA_FWD',
  REAR_RIGHT_LCA_RWD: 'REAR_RIGHT_LCA_RWD',
  REAR_RIGHT_UCA_FWD: 'REAR_RIGHT_UCA_FWD',
  REAR_RIGHT_UCA_RWD: 'REAR_RIGHT_UCA_RWD',
  RIGHT: 'RIGHT',
  SINGLE: 'SINGLE'
} as const;

export type EnumSpecificationAdminReadingsAllowable = typeof EnumSpecificationAdminReadingsAllowable[keyof typeof EnumSpecificationAdminReadingsAllowable];
export const EnumSpecificationAdminReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumSpecificationAdminReadingsRequired = typeof EnumSpecificationAdminReadingsRequired[keyof typeof EnumSpecificationAdminReadingsRequired];
export const EnumSpecificationAdminSpringReference = {
  DROOP: 'DROOP',
  FORCE: 'FORCE',
  REF: 'REF',
  STATIC: 'STATIC'
} as const;

export type EnumSpecificationAdminSpringReference = typeof EnumSpecificationAdminSpringReference[keyof typeof EnumSpecificationAdminSpringReference];
export const EnumSpecificationAdminType = {
  AERO_ELEMENT: 'AERO_ELEMENT',
  AERO_PACKAGE: 'AERO_PACKAGE',
  ANTI_ROLL_BAR: 'ANTI_ROLL_BAR',
  CHASSIS: 'CHASSIS',
  CUSTOM: 'CUSTOM',
  DAMPER: 'DAMPER',
  DIFFERENTIAL: 'DIFFERENTIAL',
  ELASTIC: 'ELASTIC',
  GEAR: 'GEAR',
  GEAR_BOX: 'GEAR_BOX',
  KINEMATICS_EXTERNAL: 'KINEMATICS_EXTERNAL',
  KINEMATICS_INTERNAL: 'KINEMATICS_INTERNAL'
} as const;

export type EnumSpecificationAdminType = typeof EnumSpecificationAdminType[keyof typeof EnumSpecificationAdminType];
export const EnumSpecificationCustomSimulationModelsDataMapping = {
  Flat: 'Flat',
  Standard: 'Standard'
} as const;

export type EnumSpecificationCustomSimulationModelsDataMapping = typeof EnumSpecificationCustomSimulationModelsDataMapping[keyof typeof EnumSpecificationCustomSimulationModelsDataMapping];
export const EnumSpecificationHRideReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumSpecificationHRideReadingsRequired = typeof EnumSpecificationHRideReadingsRequired[keyof typeof EnumSpecificationHRideReadingsRequired];
export const EnumSpecificationHRideUnit = {
  CENTIMETRES: 'CENTIMETRES',
  FEET: 'FEET',
  INCHES: 'INCHES',
  KILOMETRES: 'KILOMETRES',
  METRES: 'METRES',
  MICROMETRES: 'MICROMETRES',
  MILES: 'MILES',
  MILLIMETRES: 'MILLIMETRES',
  THOU: 'THOU'
} as const;

export type EnumSpecificationHRideUnit = typeof EnumSpecificationHRideUnit[keyof typeof EnumSpecificationHRideUnit];
export const EnumSpecificationPowertrainLocation = {
  CENTRAL: 'CENTRAL',
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumSpecificationPowertrainLocation = typeof EnumSpecificationPowertrainLocation[keyof typeof EnumSpecificationPowertrainLocation];
export const EnumSpecificationReadingsAllowable = {
  FRONT: 'FRONT',
  FRONT_LEFT: 'FRONT_LEFT',
  FRONT_LEFT_LCA_FWD: 'FRONT_LEFT_LCA_FWD',
  FRONT_LEFT_LCA_RWD: 'FRONT_LEFT_LCA_RWD',
  FRONT_LEFT_UCA_FWD: 'FRONT_LEFT_UCA_FWD',
  FRONT_LEFT_UCA_RWD: 'FRONT_LEFT_UCA_RWD',
  FRONT_RIGHT: 'FRONT_RIGHT',
  FRONT_RIGHT_LCA_FWD: 'FRONT_RIGHT_LCA_FWD',
  FRONT_RIGHT_LCA_RWD: 'FRONT_RIGHT_LCA_RWD',
  FRONT_RIGHT_UCA_FWD: 'FRONT_RIGHT_UCA_FWD',
  FRONT_RIGHT_UCA_RWD: 'FRONT_RIGHT_UCA_RWD',
  LEFT: 'LEFT',
  REAR: 'REAR',
  REAR_LEFT: 'REAR_LEFT',
  REAR_LEFT_LCA_FWD: 'REAR_LEFT_LCA_FWD',
  REAR_LEFT_LCA_RWD: 'REAR_LEFT_LCA_RWD',
  REAR_LEFT_UCA_FWD: 'REAR_LEFT_UCA_FWD',
  REAR_LEFT_UCA_RWD: 'REAR_LEFT_UCA_RWD',
  REAR_RIGHT: 'REAR_RIGHT',
  REAR_RIGHT_LCA_FWD: 'REAR_RIGHT_LCA_FWD',
  REAR_RIGHT_LCA_RWD: 'REAR_RIGHT_LCA_RWD',
  REAR_RIGHT_UCA_FWD: 'REAR_RIGHT_UCA_FWD',
  REAR_RIGHT_UCA_RWD: 'REAR_RIGHT_UCA_RWD',
  RIGHT: 'RIGHT',
  SINGLE: 'SINGLE'
} as const;

export type EnumSpecificationReadingsAllowable = typeof EnumSpecificationReadingsAllowable[keyof typeof EnumSpecificationReadingsAllowable];
export const EnumSpecificationReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumSpecificationReadingsRequired = typeof EnumSpecificationReadingsRequired[keyof typeof EnumSpecificationReadingsRequired];
export const EnumSpecificationType = {
  AERO_ELEMENT: 'AERO_ELEMENT',
  AERO_PACKAGE: 'AERO_PACKAGE',
  ANTI_ROLL_BAR: 'ANTI_ROLL_BAR',
  CHASSIS: 'CHASSIS',
  CUSTOM: 'CUSTOM',
  DAMPER: 'DAMPER',
  DIFFERENTIAL: 'DIFFERENTIAL',
  ELASTIC: 'ELASTIC',
  GEAR: 'GEAR',
  GEAR_BOX: 'GEAR_BOX',
  KINEMATICS_EXTERNAL: 'KINEMATICS_EXTERNAL',
  KINEMATICS_INTERNAL: 'KINEMATICS_INTERNAL'
} as const;

export type EnumSpecificationType = typeof EnumSpecificationType[keyof typeof EnumSpecificationType];
export const EnumSpringRateUnit = {
  NEWTONS_PER_METRE: 'NEWTONS_PER_METRE',
  NEWTONS_PER_MILLIMETRE: 'NEWTONS_PER_MILLIMETRE',
  POUNDS_PER_INCH: 'POUNDS_PER_INCH'
} as const;

export type EnumSpringRateUnit = typeof EnumSpringRateUnit[keyof typeof EnumSpringRateUnit];
export const EnumSteeringRackRatioUnit = {
  DEGREES_PER_INCHES: 'DEGREES_PER_INCHES',
  DEGREES_PER_MILLIMETRES: 'DEGREES_PER_MILLIMETRES'
} as const;

export type EnumSteeringRackRatioUnit = typeof EnumSteeringRackRatioUnit[keyof typeof EnumSteeringRackRatioUnit];
export const EnumTagType = {
  ASSEMBLY: 'ASSEMBLY',
  CALCULATION: 'CALCULATION',
  CAR_SETUP: 'CAR_SETUP',
  CHASSIS: 'CHASSIS',
  GLOBAL: 'GLOBAL',
  ISSUE: 'ISSUE',
  JOB: 'JOB',
  LAP: 'LAP',
  PART: 'PART',
  PROJECT: 'PROJECT',
  RUN_SHEET: 'RUN_SHEET',
  SIM_RESULT: 'SIM_RESULT',
  TRACK: 'TRACK'
} as const;

export type EnumTagType = typeof EnumTagType[keyof typeof EnumTagType];
export const EnumTemperatureOption = {
  PARC_FERME_EXPECTED: 'PARC_FERME_EXPECTED',
  POST_RUN: 'POST_RUN',
  POST_RUN_BLEED: 'POST_RUN_BLEED',
  SET_DOWN: 'SET_DOWN'
} as const;

export type EnumTemperatureOption = typeof EnumTemperatureOption[keyof typeof EnumTemperatureOption];
export const EnumTemperatureUnit = {
  CELSIUS: 'CELSIUS',
  FAHRENHEIT: 'FAHRENHEIT',
  KELVIN: 'KELVIN'
} as const;

export type EnumTemperatureUnit = typeof EnumTemperatureUnit[keyof typeof EnumTemperatureUnit];
export const EnumTemplateSessionDebriefMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumTemplateSessionDebriefMode = typeof EnumTemplateSessionDebriefMode[keyof typeof EnumTemplateSessionDebriefMode];
export const EnumTimeUnit = {
  DAYS: 'DAYS',
  HOURS: 'HOURS',
  MILLISECONDS: 'MILLISECONDS',
  SECONDS: 'SECONDS'
} as const;

export type EnumTimeUnit = typeof EnumTimeUnit[keyof typeof EnumTimeUnit];
export const EnumTimingServiceConfigLogLevel = {
  CRITICAL: 'CRITICAL',
  DEBUG: 'DEBUG',
  ERROR: 'ERROR',
  INFO: 'INFO',
  NOTSET: 'NOTSET',
  WARNING: 'WARNING'
} as const;

export type EnumTimingServiceConfigLogLevel = typeof EnumTimingServiceConfigLogLevel[keyof typeof EnumTimingServiceConfigLogLevel];
export const EnumTimingServiceConfigMode = {
  MILEAGE: 'MILEAGE',
  OFFICIAL: 'OFFICIAL'
} as const;

export type EnumTimingServiceConfigMode = typeof EnumTimingServiceConfigMode[keyof typeof EnumTimingServiceConfigMode];
export const EnumToeMeasurementMethod = {
  ANGLE: 'ANGLE',
  BOTH: 'BOTH',
  LENGTH: 'LENGTH'
} as const;

export type EnumToeMeasurementMethod = typeof EnumToeMeasurementMethod[keyof typeof EnumToeMeasurementMethod];
export const EnumTorqueUnit = {
  NEWTON_METRES: 'NEWTON_METRES',
  NEWTON_MILLIMETRES: 'NEWTON_MILLIMETRES',
  POUND_FORCE_FEET: 'POUND_FORCE_FEET',
  POUND_FORCE_INCHES: 'POUND_FORCE_INCHES'
} as const;

export type EnumTorqueUnit = typeof EnumTorqueUnit[keyof typeof EnumTorqueUnit];
export const EnumTorsionRateUnit = {
  NEWTON_METRES_PER_DEGREE: 'NEWTON_METRES_PER_DEGREE',
  NEWTON_METRES_PER_RADIAN: 'NEWTON_METRES_PER_RADIAN',
  POUNDS_FEET_PER_DEGREE: 'POUNDS_FEET_PER_DEGREE',
  POUNDS_FEET_PER_RADIAN: 'POUNDS_FEET_PER_RADIAN',
  POUNDS_INCHES_PER_DEGREE: 'POUNDS_INCHES_PER_DEGREE',
  POUNDS_INCHES_PER_RADIAN: 'POUNDS_INCHES_PER_RADIAN'
} as const;

export type EnumTorsionRateUnit = typeof EnumTorsionRateUnit[keyof typeof EnumTorsionRateUnit];
/** Indicates whether the pole position is on the left- or right-hand side */
export const EnumTrackLayoutPolePosition = {
  LHS: 'LHS',
  RHS: 'RHS'
} as const;

export type EnumTrackLayoutPolePosition = typeof EnumTrackLayoutPolePosition[keyof typeof EnumTrackLayoutPolePosition];
export const EnumTrackLayoutTrackLayoutType = {
  DIRT: 'DIRT',
  OVAL: 'OVAL',
  TRACK: 'TRACK'
} as const;

export type EnumTrackLayoutTrackLayoutType = typeof EnumTrackLayoutTrackLayoutType[keyof typeof EnumTrackLayoutTrackLayoutType];
export const EnumTrackStateFlag = {
  CHEQUERED: 'CHEQUERED',
  GREEN: 'GREEN',
  PARTIAL_YELLOW: 'PARTIAL_YELLOW',
  RED: 'RED',
  YELLOW: 'YELLOW'
} as const;

export type EnumTrackStateFlag = typeof EnumTrackStateFlag[keyof typeof EnumTrackStateFlag];
export const EnumTrackableWarningDirection = {
  GREATER_THAN: 'GREATER_THAN',
  LESS_THAN: 'LESS_THAN'
} as const;

export type EnumTrackableWarningDirection = typeof EnumTrackableWarningDirection[keyof typeof EnumTrackableWarningDirection];
export const EnumTrackingItemOperator = {
  EQUAL: 'EQUAL',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL'
} as const;

export type EnumTrackingItemOperator = typeof EnumTrackingItemOperator[keyof typeof EnumTrackingItemOperator];
export const EnumTrackingRecordGeneralType = {
  GENERAL: 'GENERAL',
  OVERRIDE: 'OVERRIDE',
  VALUE: 'VALUE'
} as const;

export type EnumTrackingRecordGeneralType = typeof EnumTrackingRecordGeneralType[keyof typeof EnumTrackingRecordGeneralType];
export const EnumTrackingRecordOverrideType = {
  GENERAL: 'GENERAL',
  OVERRIDE: 'OVERRIDE',
  VALUE: 'VALUE'
} as const;

export type EnumTrackingRecordOverrideType = typeof EnumTrackingRecordOverrideType[keyof typeof EnumTrackingRecordOverrideType];
export const EnumTrackingRecordType = {
  GENERAL: 'GENERAL',
  OVERRIDE: 'OVERRIDE',
  VALUE: 'VALUE'
} as const;

export type EnumTrackingRecordType = typeof EnumTrackingRecordType[keyof typeof EnumTrackingRecordType];
export const EnumTrackingRecordValueType = {
  GENERAL: 'GENERAL',
  OVERRIDE: 'OVERRIDE',
  VALUE: 'VALUE'
} as const;

export type EnumTrackingRecordValueType = typeof EnumTrackingRecordValueType[keyof typeof EnumTrackingRecordValueType];
export const EnumTrackingSourceAliasAliasType = {
  CarDataKPI: 'CarDataKPI',
  Manual: 'Manual',
  RunDistance: 'RunDistance',
  RunTime: 'RunTime'
} as const;

export type EnumTrackingSourceAliasAliasType = typeof EnumTrackingSourceAliasAliasType[keyof typeof EnumTrackingSourceAliasAliasType];
export const EnumTypedUnitType = {
  ACCELERATION: 'ACCELERATION',
  ANGLE: 'ANGLE',
  ANGULAR_ACCELERATION: 'ANGULAR_ACCELERATION',
  ANGULAR_COMPLIANCE: 'ANGULAR_COMPLIANCE',
  ANGULAR_TORQUE_COMPLIANCE: 'ANGULAR_TORQUE_COMPLIANCE',
  ANGULAR_VELOCITY: 'ANGULAR_VELOCITY',
  COMPLIANCE: 'COMPLIANCE',
  ENERGY: 'ENERGY',
  FORCE: 'FORCE',
  INERTIA: 'INERTIA',
  LENGTH: 'LENGTH',
  MASS: 'MASS',
  NUMBER: 'NUMBER',
  POWER: 'POWER',
  PRESSURE: 'PRESSURE',
  RATIO: 'RATIO',
  SPRING_RATE: 'SPRING_RATE',
  STEERING_RACK_RATIO: 'STEERING_RACK_RATIO',
  STRING: 'STRING',
  TEMPERATURE: 'TEMPERATURE',
  TIME: 'TIME',
  TORQUE: 'TORQUE',
  TORSION_RATE: 'TORSION_RATE',
  VELOCITY: 'VELOCITY',
  VOLUME: 'VOLUME'
} as const;

export type EnumTypedUnitType = typeof EnumTypedUnitType[keyof typeof EnumTypedUnitType];
export const EnumTyreAxle = {
  BOTH: 'BOTH',
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumTyreAxle = typeof EnumTyreAxle[keyof typeof EnumTyreAxle];
export const EnumTyreInitialCondition = {
  NEW: 'NEW',
  SCRUBBED: 'SCRUBBED',
  USED: 'USED'
} as const;

export type EnumTyreInitialCondition = typeof EnumTyreInitialCondition[keyof typeof EnumTyreInitialCondition];
export const EnumTyreTableField = {
  H_TYRE_TREAD: 'H_TYRE_TREAD',
  H_TYRE_WEAR: 'H_TYRE_WEAR',
  PRE_RUN_MILEAGE: 'PRE_RUN_MILEAGE',
  P_TYRE: 'P_TYRE',
  P_TYRE_BUILD: 'P_TYRE_BUILD',
  P_TYRE_MINIMUM: 'P_TYRE_MINIMUM',
  P_TYRE_POST_RUN: 'P_TYRE_POST_RUN',
  P_TYRE_POST_RUN_BLEED: 'P_TYRE_POST_RUN_BLEED',
  P_TYRE_PRE_RUN_BLEED: 'P_TYRE_PRE_RUN_BLEED',
  P_TYRE_REFERENCE: 'P_TYRE_REFERENCE',
  P_TYRE_SET_DOWN: 'P_TYRE_SET_DOWN',
  P_TYRE_START_RUN: 'P_TYRE_START_RUN',
  P_TYRE_TARGET: 'P_TYRE_TARGET',
  TYRE_SELECTOR: 'TYRE_SELECTOR',
  TYRE_SET_SELECTOR: 'TYRE_SET_SELECTOR',
  TYRE_STAGGER: 'TYRE_STAGGER',
  T_AIR_REFERENCE: 'T_AIR_REFERENCE',
  T_TRACK_REFERENCE: 'T_TRACK_REFERENCE',
  T_TYRE: 'T_TYRE',
  T_TYRE_PARC_FERME_EXPECTED: 'T_TYRE_PARC_FERME_EXPECTED',
  T_TYRE_POST_RUN: 'T_TYRE_POST_RUN',
  T_TYRE_POST_RUN_BLEED: 'T_TYRE_POST_RUN_BLEED',
  T_TYRE_REFERENCE: 'T_TYRE_REFERENCE',
  T_TYRE_SET_DOWN: 'T_TYRE_SET_DOWN',
  T_TYRE_SURFACE: 'T_TYRE_SURFACE'
} as const;

export type EnumTyreTableField = typeof EnumTyreTableField[keyof typeof EnumTyreTableField];
export const EnumUnitSystem = {
  IMPERIAL: 'IMPERIAL',
  METRIC: 'METRIC'
} as const;

export type EnumUnitSystem = typeof EnumUnitSystem[keyof typeof EnumUnitSystem];
export const EnumUntypedUnit = {
  NONE: 'NONE',
  NUMBER: 'NUMBER',
  STRING: 'STRING'
} as const;

export type EnumUntypedUnit = typeof EnumUntypedUnit[keyof typeof EnumUntypedUnit];
export const EnumUserEnumAssemblyTypeType = {
  USER_ENUM_ASSEMBLY_TYPE: 'USER_ENUM_ASSEMBLY_TYPE'
} as const;

export type EnumUserEnumAssemblyTypeType = typeof EnumUserEnumAssemblyTypeType[keyof typeof EnumUserEnumAssemblyTypeType];
export const EnumUserEnumBuildSheetGroupType = {
  USER_ENUM_BUILDSHEET_GROUP: 'USER_ENUM_BUILDSHEET_GROUP'
} as const;

export type EnumUserEnumBuildSheetGroupType = typeof EnumUserEnumBuildSheetGroupType[keyof typeof EnumUserEnumBuildSheetGroupType];
export const EnumUserEnumPartStatusType = {
  USER_ENUM_PART_STATUS: 'USER_ENUM_PART_STATUS'
} as const;

export type EnumUserEnumPartStatusType = typeof EnumUserEnumPartStatusType[keyof typeof EnumUserEnumPartStatusType];
export const EnumUserEnumPartTypeType = {
  USER_ENUM_PART_TYPE: 'USER_ENUM_PART_TYPE'
} as const;

export type EnumUserEnumPartTypeType = typeof EnumUserEnumPartTypeType[keyof typeof EnumUserEnumPartTypeType];
export const EnumUserEnumRunPlannerActionItemType = {
  USER_ENUM_RUN_PLANNER_ACTION_ITEM: 'USER_ENUM_RUN_PLANNER_ACTION_ITEM'
} as const;

export type EnumUserEnumRunPlannerActionItemType = typeof EnumUserEnumRunPlannerActionItemType[keyof typeof EnumUserEnumRunPlannerActionItemType];
export const EnumUserEnumSimulationDriveFileTypeType = {
  USER_ENUM_SIMULATION_DRIVE_FILE_TYPE: 'USER_ENUM_SIMULATION_DRIVE_FILE_TYPE'
} as const;

export type EnumUserEnumSimulationDriveFileTypeType = typeof EnumUserEnumSimulationDriveFileTypeType[keyof typeof EnumUserEnumSimulationDriveFileTypeType];
export const EnumUserEnumTrackingSeverityType = {
  USER_ENUM_TRACKING_SEVERITY: 'USER_ENUM_TRACKING_SEVERITY'
} as const;

export type EnumUserEnumTrackingSeverityType = typeof EnumUserEnumTrackingSeverityType[keyof typeof EnumUserEnumTrackingSeverityType];
export const EnumUserEnumType = {
  USER_ENUM_ASSEMBLY_TYPE: 'USER_ENUM_ASSEMBLY_TYPE',
  USER_ENUM_BUILDSHEET_GROUP: 'USER_ENUM_BUILDSHEET_GROUP',
  USER_ENUM_PART_STATUS: 'USER_ENUM_PART_STATUS',
  USER_ENUM_PART_TYPE: 'USER_ENUM_PART_TYPE',
  USER_ENUM_RUN_PLANNER_ACTION_ITEM: 'USER_ENUM_RUN_PLANNER_ACTION_ITEM',
  USER_ENUM_SIMULATION_DRIVE_FILE_TYPE: 'USER_ENUM_SIMULATION_DRIVE_FILE_TYPE',
  USER_ENUM_TRACKING_SEVERITY: 'USER_ENUM_TRACKING_SEVERITY'
} as const;

export type EnumUserEnumType = typeof EnumUserEnumType[keyof typeof EnumUserEnumType];
export const EnumVelocityUnit = {
  FEET_PER_SECOND: 'FEET_PER_SECOND',
  KILOMETRES_PER_HOUR: 'KILOMETRES_PER_HOUR',
  METRES_PER_SECOND: 'METRES_PER_SECOND',
  MILES_PER_HOUR: 'MILES_PER_HOUR'
} as const;

export type EnumVelocityUnit = typeof EnumVelocityUnit[keyof typeof EnumVelocityUnit];
export const EnumVolumeUnit = {
  GALLONS: 'GALLONS',
  LITRES: 'LITRES',
  METRES_CUBED: 'METRES_CUBED',
  MILLILITRES: 'MILLILITRES'
} as const;

export type EnumVolumeUnit = typeof EnumVolumeUnit[keyof typeof EnumVolumeUnit];
export const EnumWeatherBlockField = {
  AIR_DENSITY: 'AIR_DENSITY',
  AMBIENT_CONDITION: 'AMBIENT_CONDITION',
  HUMIDITY: 'HUMIDITY',
  PRESSURE: 'PRESSURE',
  TRACK_CONDITION: 'TRACK_CONDITION',
  T_AMBIENT: 'T_AMBIENT',
  T_AMBIENT_OFFICIAL: 'T_AMBIENT_OFFICIAL',
  T_TRACK: 'T_TRACK',
  T_TRACK_OFFICIAL: 'T_TRACK_OFFICIAL'
} as const;

export type EnumWeatherBlockField = typeof EnumWeatherBlockField[keyof typeof EnumWeatherBlockField];
/** Location or weather station */
export const EnumWeatherServiceConfigRequestType = {
  LOCATION: 'LOCATION',
  WEATHER_STATION: 'WEATHER_STATION'
} as const;

export type EnumWeatherServiceConfigRequestType = typeof EnumWeatherServiceConfigRequestType[keyof typeof EnumWeatherServiceConfigRequestType];
/** Weather client to specify the source where to retrieve the data from. */
export const EnumWeatherServiceConfigSource = {
  METEOMATICS: 'METEOMATICS',
  ONE_TIMING: 'ONE_TIMING',
  OPEN_WEATHER_MAP: 'OPEN_WEATHER_MAP',
  TOMORROW_IO: 'TOMORROW_IO',
  WEATHER_LINK: 'WEATHER_LINK',
  WEATHER_UNDERGROUND: 'WEATHER_UNDERGROUND'
} as const;

export type EnumWeatherServiceConfigSource = typeof EnumWeatherServiceConfigSource[keyof typeof EnumWeatherServiceConfigSource];
export const EnumWeatherServiceConfigType = {
  HISTORICAL: 'HISTORICAL',
  MEASUREMENT: 'MEASUREMENT',
  PREDICTION: 'PREDICTION'
} as const;

export type EnumWeatherServiceConfigType = typeof EnumWeatherServiceConfigType[keyof typeof EnumWeatherServiceConfigType];
export const EnumWeatherSources = {
  METEOMATICS: 'METEOMATICS',
  ONE_TIMING: 'ONE_TIMING',
  OPEN_WEATHER_MAP: 'OPEN_WEATHER_MAP',
  TOMORROW_IO: 'TOMORROW_IO',
  WEATHER_LINK: 'WEATHER_LINK',
  WEATHER_UNDERGROUND: 'WEATHER_UNDERGROUND'
} as const;

export type EnumWeatherSources = typeof EnumWeatherSources[keyof typeof EnumWeatherSources];
export const EnumWeatherType = {
  HISTORICAL: 'HISTORICAL',
  MEASUREMENT: 'MEASUREMENT',
  PREDICTION: 'PREDICTION'
} as const;

export type EnumWeatherType = typeof EnumWeatherType[keyof typeof EnumWeatherType];
export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  /** Density of the fuel */
  DFuel?: Maybe<Scalars['Float']['output']>;
  /** Number of this event in the season */
  NEventSeason?: Maybe<Scalars['Float']['output']>;
  /**
   * Default SoCRequired values to use during this event (assuming single track layout)
   * @deprecated Specify SoC required in the consumptions array instead.
   */
  SoCRequired?: Maybe<RunEnergy>;
  _id: Scalars['MongoID']['output'];
  assignedSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignedSetups: Array<CarSetup>;
  /** Fuel/SoC/Energy consumptions for each track layout in this event. */
  consumptions?: Maybe<Array<Maybe<LayoutConsumption>>>;
  contestants?: Maybe<Array<Maybe<EventContestants>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: Maybe<Scalars['JSON']['output']>;
  debriefNotes?: Maybe<Scalars['String']['output']>;
  debriefNotesMode?: Maybe<EnumEventDebriefNotesMode>;
  /**
   * Default energyRequired values to use during this event (assuming single track layout)
   * @deprecated Specify energy required in the consumptions array instead.
   */
  energyRequired?: Maybe<RunEnergy>;
  /** Energy sweep information for Formula E */
  energySweep?: Maybe<Scalars['JSON']['output']>;
  enumEventType?: Maybe<EnumEventEnumEventType>;
  enumEventVenue?: Maybe<EnumEventEnumEventVenue>;
  /**
   * e.g. Race, Test, etc.
   * @deprecated Use enum field `type` instead.
   */
  eventType?: Maybe<Scalars['String']['output']>;
  /**
   * Default fuelRequired values to use during this event (assuming single track layout)
   * @deprecated Specify fuel required in the consumptions array instead.
   */
  fuelRequired?: Maybe<RunEnergy>;
  /** Should the iRacing service populate this event when an unknown event is encountered? */
  iRacingServiceIsNextEvent?: Maybe<Scalars['Boolean']['output']>;
  /** IDs of issues related to this event. */
  issueIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  issues: Array<Issue>;
  name: Scalars['String']['output'];
  participantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  participants: Array<Person>;
  /** Reference laptimes for each track layout in this event. */
  referenceLaptimes?: Maybe<Array<Maybe<EventReferenceLaptimes>>>;
  /** Selected authors for the event report (person reference plus a name snapshot). */
  reportAuthors?: Maybe<Array<Maybe<EventReportAuthors>>>;
  season?: Maybe<Season>;
  seasonID: Scalars['MongoID']['output'];
  sessionIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  sessions: Array<Session>;
  /** Time of event end in local time */
  tEventEnd?: Maybe<Scalars['Date']['output']>;
  /** Time of event start in local time */
  tEventStart?: Maybe<Scalars['Date']['output']>;
  tLapAverage?: Maybe<Scalars['Float']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyEventID?: Maybe<Scalars['String']['output']>;
  /** @deprecated Access time zone from this event's track instead. */
  timeZone?: Maybe<Scalars['String']['output']>;
  track?: Maybe<Track>;
  trackID?: Maybe<Scalars['MongoID']['output']>;
  trackLayoutIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackLayouts: Array<TrackLayout>;
  /** @deprecated Use enumEventVenue instead. */
  type?: Maybe<EnumEventType>;
  tyreDefaults?: Maybe<Array<Maybe<EventTyreDefaultsSet>>>;
  /** @deprecated Use the tyreDefaults array instead. */
  tyreDefaultsFL?: Maybe<EventTyreDefaults>;
  /** @deprecated Use the tyreDefaults array instead. */
  tyreDefaultsFR?: Maybe<EventTyreDefaults>;
  /** @deprecated Use the tyreDefaults array instead. */
  tyreDefaultsRL?: Maybe<EventTyreDefaults>;
  /** @deprecated Use the tyreDefaults array instead. */
  tyreDefaultsRR?: Maybe<EventTyreDefaults>;
  /** @deprecated Use a wet tyre type in the tyreDefaults array instead. */
  tyreDefaultsWetFL?: Maybe<EventTyreDefaults>;
  /** @deprecated Use a wet tyre type in the tyreDefaults array instead. */
  tyreDefaultsWetFR?: Maybe<EventTyreDefaults>;
  /** @deprecated Use a wet tyre type in the tyreDefaults array instead. */
  tyreDefaultsWetRL?: Maybe<EventTyreDefaults>;
  /** @deprecated Use a wet tyre type in the tyreDefaults array instead. */
  tyreDefaultsWetRR?: Maybe<EventTyreDefaults>;
  /** IDs of weather documents linked to this event */
  weatherIDs: Array<Scalars['MongoID']['output']>;
  /** Weather documents linked to this event. */
  weathers: Array<Weather>;
};

/** Field to target with this mutation. */
export const EventContestantField = {
  /** → `chassisIDs` */
  CHASSIS: 'CHASSIS',
  /** → `driverIDs` */
  DRIVERS: 'DRIVERS'
} as const;

export type EventContestantField = typeof EventContestantField[keyof typeof EventContestantField];
export type EventContestantTyres = {
  tyreIDs: Array<Scalars['MongoID']['output']>;
  tyreSetIDs: Array<Scalars['MongoID']['output']>;
  tyreSets: Array<TyreSet>;
  tyres: Array<Tyre>;
};

export type EventContestants = {
  _id: Scalars['MongoID']['output'];
  /** Chassis used, if different for this event. */
  chassis: Array<Chassis>;
  /** IDs of chassis used, if different for this event. */
  chassisIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: Maybe<Scalars['String']['output']>;
  /** IDs of drivers of this car, if different for this event. */
  driverIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Drivers of this car, if different for this event. */
  drivers: Array<Person>;
  /** IDs of tyres allocated to this contestant for this event (like during races where only tyres handed out at this very race are permitted). */
  tyreIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** IDs of tyre sets allocated to this contestant for this event. */
  tyreSetIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tyre sets allocated to this contestant for this event. */
  tyreSets: Array<TyreSet>;
  /** Tyres allocated to this contestant for this event (like during races where only tyres handed out at this very race are permitted). */
  tyres: Array<Tyre>;
};

export type EventContestantsInput = {
  _id: Scalars['MongoID']['input'];
  /** IDs of chassis used, if different for this event. */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** IDs of drivers of this car, if different for this event. */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of tyres allocated to this contestant for this event (like during races where only tyres handed out at this very race are permitted). */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of tyre sets allocated to this contestant for this event. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** List of items with pagination. */
export type EventPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Event>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type EventReferenceLaptimes = {
  /** Reference Laptime for ATTACK lap */
  ATTACK?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for COOL lap */
  COOL?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for FCY lap */
  FCY?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for IN lap */
  IN?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for OUT lap */
  OUT?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for OUTIN lap */
  OUTIN?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for PITLANE lap */
  PITLANE?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for PREP lap */
  PREP?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for PUSH lap */
  PUSH?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for QUALI lap */
  QUALI?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for SAFETYCAR lap */
  SAFETYCAR?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for SHAKEDOWN lap */
  SHAKEDOWN?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for SLOW lap */
  SLOW?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for TARGET lap */
  TARGET?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for TOGRID lap */
  TOGRID?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for TOPADDOCK lap */
  TOPADDOCK?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for TOPITS lap */
  TOPITS?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for UNFINISHED lap */
  UNFINISHED?: Maybe<Scalars['Float']['output']>;
  calculationMethod?: Maybe<EnumEventReferenceLaptimesCalculationMethod>;
  /** Reference Laptime when using the calculation method "RATIO" */
  referenceLaptime?: Maybe<Scalars['Float']['output']>;
  trackLayoutID: Scalars['MongoID']['output'];
};

export type EventReferenceLaptimesInput = {
  /** Reference Laptime for ATTACK lap */
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for COOL lap */
  COOL?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for FCY lap */
  FCY?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for IN lap */
  IN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for OUT lap */
  OUT?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for OUTIN lap */
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PITLANE lap */
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PREP lap */
  PREP?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PUSH lap */
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for QUALI lap */
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SAFETYCAR lap */
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SHAKEDOWN lap */
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SLOW lap */
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TARGET lap */
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOGRID lap */
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOPADDOCK lap */
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOPITS lap */
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for UNFINISHED lap */
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
  calculationMethod?: InputMaybe<EnumEventReferenceLaptimesCalculationMethod>;
  /** Reference Laptime when using the calculation method "RATIO" */
  referenceLaptime?: InputMaybe<Scalars['Float']['input']>;
  trackLayoutID: Scalars['MongoID']['input'];
};

export type EventReportAuthors = {
  name?: Maybe<Scalars['String']['output']>;
  personID?: Maybe<Scalars['MongoID']['output']>;
};

export type EventReportAuthorsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
};

/** Suggested defaults for various tyre variables, intended for setup sheets and run sheets to pull from during this event. */
export type EventTyreDefaults = {
  /** Suggested bare minimum tyre pressure for this event. */
  pTyreMin?: Maybe<Scalars['Float']['output']>;
  /**
   * Suggested minimum pressure at the start of a run for this event.
   * @deprecated Use pTyreStartRun instead
   */
  pTyreMinStartRun?: Maybe<Scalars['Float']['output']>;
  /** Suggested pressure at the start of a run for this event. */
  pTyreStartRun?: Maybe<Scalars['Float']['output']>;
  /** Suggested tyre pressure target for this event. */
  pTyreTarget?: Maybe<Scalars['Float']['output']>;
};

export type EventTyreDefaultsInput = {
  /** Suggested bare minimum tyre pressure for this event. */
  pTyreMin?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested minimum pressure at the start of a run for this event. */
  pTyreMinStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested pressure at the start of a run for this event. */
  pTyreStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested tyre pressure target for this event. */
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
};

export type EventTyreDefaultsSet = {
  frontLeft?: Maybe<EventTyreDefaults>;
  frontRight?: Maybe<EventTyreDefaults>;
  rearLeft?: Maybe<EventTyreDefaults>;
  rearRight?: Maybe<EventTyreDefaults>;
  /** Which compound should these defaults be applied on? */
  tyreCompound?: Maybe<Scalars['String']['output']>;
  /** Which tyre type should these defaults be applied on? */
  tyreType?: Maybe<Scalars['String']['output']>;
};

export type EventTyreDefaultsSetInput = {
  frontLeft?: InputMaybe<EventTyreDefaultsInput>;
  frontRight?: InputMaybe<EventTyreDefaultsInput>;
  rearLeft?: InputMaybe<EventTyreDefaultsInput>;
  rearRight?: InputMaybe<EventTyreDefaultsInput>;
  /** Which compound should these defaults be applied on? */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
  /** Which tyre type should these defaults be applied on? */
  tyreType?: InputMaybe<Scalars['String']['input']>;
};

export type EventTyrePressureSettings = {
  TRimReference?: Maybe<Scalars['Float']['output']>;
  TTrackReference?: Maybe<Scalars['Float']['output']>;
  rColdToHotTeam?: Maybe<Scalars['Float']['output']>;
  rRimTempRegulation?: Maybe<Scalars['Float']['output']>;
  rRimTempTeam?: Maybe<Scalars['Float']['output']>;
  rTrackTempLongRun?: Maybe<Scalars['Float']['output']>;
  rTrackTempShortRun?: Maybe<Scalars['Float']['output']>;
};

export type EventTyrePressureSettingsInput = {
  TRimReference?: InputMaybe<Scalars['Float']['input']>;
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
  rColdToHotTeam?: InputMaybe<Scalars['Float']['input']>;
  rRimTempRegulation?: InputMaybe<Scalars['Float']['input']>;
  rRimTempTeam?: InputMaybe<Scalars['Float']['input']>;
  rTrackTempLongRun?: InputMaybe<Scalars['Float']['input']>;
  rTrackTempShortRun?: InputMaybe<Scalars['Float']['input']>;
};

export type ExternalBumpStop = {
  name?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<ElasticSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  xExternalBumpStopGap?: Maybe<Scalars['Float']['output']>;
};

export type ExternalBumpStopInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  xExternalBumpStopGap?: InputMaybe<Scalars['Float']['input']>;
};

export type FailedConfig = {
  /** Error message for the failed configuration. */
  message?: Maybe<Scalars['String']['output']>;
  timingServiceConfig?: Maybe<TimingServiceConfig>;
  /** ID of the timing service configuration. */
  timingServiceConfigID: Scalars['MongoID']['output'];
};

export type FailedConfigInput = {
  /** Error message for the failed configuration. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** ID of the timing service configuration. */
  timingServiceConfigID: Scalars['MongoID']['input'];
};

export type FilterFindManyAccelerationInput = {
  /** ft/s² */
  feetPerSecondSquared?: InputMaybe<Scalars['Float']['input']>;
  /** g */
  gForce?: InputMaybe<Scalars['Float']['input']>;
  metresPerSecondSquared?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAdjustableAccelerationInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAccelerationUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableAngleInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngleUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableAngularComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngularComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableAngularTorqueComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngularTorqueComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableBooleanInput = {
  defaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyAdjustableComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableForceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumForceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableInertiaInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumInertiaUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableLengthInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumLengthUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableLocationCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAdjustableLocationDefaultValueInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAdjustableLocationInput = {
  coordinates?: InputMaybe<FilterFindManyAdjustableLocationCoordinatesInput>;
  defaultValue?: InputMaybe<FilterFindManyAdjustableLocationDefaultValueInput>;
};

export type FilterFindManyAdjustableMassInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumMassUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableNumberInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  /** Unit to display values in */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableOrientationDefaultValueInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAdjustableOrientationInput = {
  defaultValue?: InputMaybe<FilterFindManyAdjustableOrientationDefaultValueInput>;
  rotation?: InputMaybe<FilterFindManyAdjustableOrientationRotationInput>;
};

export type FilterFindManyAdjustableOrientationRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAdjustablePowerInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumPowerUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustablePressureInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumPressureUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustablePropertyInput = {
  adjustableAcceleration?: InputMaybe<FilterFindManyAdjustableAccelerationInput>;
  adjustableAngle?: InputMaybe<FilterFindManyAdjustableAngleInput>;
  adjustableAngularCompliance?: InputMaybe<FilterFindManyAdjustableAngularComplianceInput>;
  adjustableAngularTorqueCompliance?: InputMaybe<FilterFindManyAdjustableAngularTorqueComplianceInput>;
  adjustableBoolean?: InputMaybe<FilterFindManyAdjustableBooleanInput>;
  adjustableCompliance?: InputMaybe<FilterFindManyAdjustableComplianceInput>;
  adjustableForce?: InputMaybe<FilterFindManyAdjustableForceInput>;
  adjustableInertia?: InputMaybe<FilterFindManyAdjustableInertiaInput>;
  adjustableLength?: InputMaybe<FilterFindManyAdjustableLengthInput>;
  adjustableLocation?: InputMaybe<FilterFindManyAdjustableLocationInput>;
  adjustableMass?: InputMaybe<FilterFindManyAdjustableMassInput>;
  adjustableNumber?: InputMaybe<FilterFindManyAdjustableNumberInput>;
  adjustableOrientation?: InputMaybe<FilterFindManyAdjustableOrientationInput>;
  adjustablePower?: InputMaybe<FilterFindManyAdjustablePowerInput>;
  adjustablePressure?: InputMaybe<FilterFindManyAdjustablePressureInput>;
  adjustableRatio?: InputMaybe<FilterFindManyAdjustableRatioInput>;
  adjustableSpringRate?: InputMaybe<FilterFindManyAdjustableSpringRateInput>;
  adjustableSteeringRackRatio?: InputMaybe<FilterFindManyAdjustableSteeringRackRatioInput>;
  adjustableString?: InputMaybe<FilterFindManyAdjustableStringInput>;
  adjustableTemperature?: InputMaybe<FilterFindManyAdjustableTemperatureInput>;
  adjustableTorque?: InputMaybe<FilterFindManyAdjustableTorqueInput>;
  adjustableTorsionRate?: InputMaybe<FilterFindManyAdjustableTorsionRateInput>;
  adjustableVolume?: InputMaybe<FilterFindManyAdjustableVolumeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAdjustablePropertyType>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyAdjustableRatioInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumRatioUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableSpringRateInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpringRateUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableSteeringRackRatioInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSteeringRackRatioUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableStringInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableTemperatureInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTemperatureUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableTorqueInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTorqueUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableTorsionRateInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTorsionRateUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableVolumeInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumVolumeUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAeroElementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  attached?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  positionName?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyAeroInput = {
  /** Number/Position of front flaps */
  NFlapF?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of front-left flaps */
  NFlapFL?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of front-right flaps */
  NFlapFR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of lower rear flaps */
  NFlapLowerR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear flaps */
  NFlapR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear-left flaps */
  NFlapRL?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear-right flaps */
  NFlapRR?: InputMaybe<Scalars['String']['input']>;
  Z400?: InputMaybe<Scalars['String']['input']>;
  /** Front flap angle */
  aFlapF?: InputMaybe<Scalars['Float']['input']>;
  /** Front-left flap angle */
  aFlapFL?: InputMaybe<Scalars['Float']['input']>;
  /** Front-right flap angle */
  aFlapFR?: InputMaybe<Scalars['Float']['input']>;
  /** Lower rear flap angle */
  aFlapLowerR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear flap angle */
  aFlapR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-left flap angle */
  aFlapRL?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-right flap angle */
  aFlapRR?: InputMaybe<Scalars['Float']['input']>;
  /** Front splitter angle */
  aSplitterF?: InputMaybe<Scalars['Float']['input']>;
  /** Complete aero package spec */
  aeroPackage?: InputMaybe<Scalars['String']['input']>;
  floorBB?: InputMaybe<Scalars['String']['input']>;
  floorGurney?: InputMaybe<Scalars['String']['input']>;
  floorLeadingEdgeID?: InputMaybe<Scalars['String']['input']>;
  /** Front flap type */
  frontFlapType?: InputMaybe<Scalars['String']['input']>;
  frontWheelArch?: InputMaybe<Scalars['String']['input']>;
  hGurneyF?: InputMaybe<Scalars['Float']['input']>;
  hGurneyR?: InputMaybe<Scalars['Float']['input']>;
  /** Splitter height at measurement points */
  hSplitterF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lowerDrivePlane?: InputMaybe<Scalars['String']['input']>;
  noseID?: InputMaybe<Scalars['String']['input']>;
  rearWingGurney?: InputMaybe<Scalars['String']['input']>;
  splitterID?: InputMaybe<Scalars['String']['input']>;
  tailGurney?: InputMaybe<Scalars['String']['input']>;
  tailID?: InputMaybe<Scalars['String']['input']>;
  upperDrivePlane?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyAeroPackageInput = {
  aeroElements?: InputMaybe<Array<InputMaybe<FilterFindManyAeroElementInput>>>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyAngleInput = {
  /** ° */
  degrees?: InputMaybe<Scalars['Float']['input']>;
  /** rad */
  radians?: InputMaybe<Scalars['Float']['input']>;
  /** rev */
  revolutions?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAngularVelocityInput = {
  /** °/s */
  degreesPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** rad/s */
  radiansPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** rpm */
  revolutionsPerMinute?: InputMaybe<Scalars['Float']['input']>;
  /** rev/s */
  revolutionsPerSecond?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAntiRollBarConfigInput = {
  /** Anti-roll bar stiffness (use spring rate units) */
  kARB?: InputMaybe<Scalars['Float']['input']>;
  kinematicsInternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** First connection point (should be a chassis socket) */
  position1?: InputMaybe<Scalars['String']['input']>;
  /** Second connection point (should be a chassis socket) */
  position2?: InputMaybe<Scalars['String']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyAreaInput = {
  /** sq ft */
  squareFeet?: InputMaybe<Scalars['Float']['input']>;
  /** sq in */
  squareInches?: InputMaybe<Scalars['Float']['input']>;
  /** m² */
  squareMetres?: InputMaybe<Scalars['Float']['input']>;
  /** mm² */
  squareMillimetres?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAssemblyCarSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssemblyChassisPartIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssemblyChassisSpecIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssemblyCurrentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyAssemblyDecommissionedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyAssemblyInput = {
  AND?: InputMaybe<Array<FilterFindManyAssemblyInput>>;
  OR?: InputMaybe<Array<FilterFindManyAssemblyInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAssemblyOperatorsInput>;
  assemblyTemplateID?: InputMaybe<Scalars['MongoID']['input']>;
  assemblyTypeEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetGroupEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetNestLevel?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisMeasurements?: InputMaybe<Array<InputMaybe<FilterFindManyChassisAssemblyMeasurementInput>>>;
  chassisPartID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this the current version of this assembly, or just a historical snapshot? */
  current?: InputMaybe<Scalars['Boolean']['input']>;
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Location of this assembly referring to a socket. For example, `frontLeft` or `cockpit`. */
  locationID?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  subAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceRecords?: InputMaybe<Array<InputMaybe<FilterFindManyChassisAssemblyTrackingSourceRecordInput>>>;
  type?: InputMaybe<EnumAssemblyType>;
  userEnumAssemblyTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyAssemblyLocationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssemblyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAssemblyOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAssembly_IdOperatorsInput>;
  carSetupID?: InputMaybe<FilterFindManyAssemblyCarSetupIdOperatorsInput>;
  chassisPartID?: InputMaybe<FilterFindManyAssemblyChassisPartIdOperatorsInput>;
  chassisSpecID?: InputMaybe<FilterFindManyAssemblyChassisSpecIdOperatorsInput>;
  current?: InputMaybe<FilterFindManyAssemblyCurrentOperatorsInput>;
  decommissioned?: InputMaybe<FilterFindManyAssemblyDecommissionedOperatorsInput>;
  locationID?: InputMaybe<FilterFindManyAssemblyLocationIdOperatorsInput>;
  name?: InputMaybe<FilterFindManyAssemblyNameOperatorsInput>;
  parentID?: InputMaybe<FilterFindManyAssemblyParentIdOperatorsInput>;
  reference?: InputMaybe<FilterFindManyAssemblyReferenceOperatorsInput>;
  type?: InputMaybe<FilterFindManyAssemblyTypeOperatorsInput>;
};

export type FilterFindManyAssemblyParentIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssemblyReferenceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyAssemblyTemplateInput = {
  AND?: InputMaybe<Array<FilterFindManyAssemblyTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindManyAssemblyTemplateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAssemblyTemplateOperatorsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredAssemblies?: InputMaybe<Array<InputMaybe<FilterFindManyAssemblyTemplateRequiredAssembliesInput>>>;
  requiredParts?: InputMaybe<Array<InputMaybe<FilterFindManyAssemblyTemplateRequiredPartsInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAssemblyTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAssemblyTemplate_IdOperatorsInput>;
};

export type FilterFindManyAssemblyTemplateRequiredAssembliesInput = {
  userEnumAssemblyTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyAssemblyTemplateRequiredPartsInput = {
  /** Specify where the part type should be added in */
  location?: InputMaybe<EnumAssemblyTemplateRequiredPartsLocation>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyAssemblyTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssemblyTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumAssemblyType>;
  gte?: InputMaybe<EnumAssemblyType>;
  in?: InputMaybe<Array<InputMaybe<EnumAssemblyType>>>;
  lt?: InputMaybe<EnumAssemblyType>;
  lte?: InputMaybe<EnumAssemblyType>;
  ne?: InputMaybe<EnumAssemblyType>;
  nin?: InputMaybe<Array<InputMaybe<EnumAssemblyType>>>;
};

export type FilterFindManyAssembly_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssignedGearInput = {
  gearID?: InputMaybe<Scalars['MongoID']['input']>;
  useHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyBaseTypedUnitFieldInput = {
  type?: InputMaybe<EnumTypedUnitType>;
  unit?: InputMaybe<EnumPossibleUnit>;
};

export type FilterFindManyBehaviourConfigInput = {
  /** Should job list templates be re-used from previous runs when creating new run sheets? */
  carryOverJobList?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the issue block will be ticked to show only the users issues on load. */
  showMyIssuesOnRunSheetDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the job block will be ticked to show only the users jobs on load. */
  showMyJobsOnRunSheetDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The locale to use for time formatting */
  timeLocale?: InputMaybe<Scalars['String']['input']>;
  /** ORH will use the users timezone selection to format times accordingly */
  timezoneSelect?: InputMaybe<EnumBehaviourConfigTimezoneSelect>;
};

export type FilterFindManyBestValuesContestantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBestValuesDriverIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBestValuesFastestLapInput = {
  /** Lap number within the run sheet for this lap. */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Acronym of the driver that completed this lap. */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** ID of the run sheet that this lap can be found in. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time the lap was completed in. */
  time?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyBestValuesFastestSectorInput = {
  /** Lap number within the run sheet for this sector. */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Acronym of the driver that completed this sector. */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** ID of the run sheet that this sector can be found in. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time the sector was completed in. */
  time?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyBestValuesInput = {
  AND?: InputMaybe<Array<FilterFindManyBestValuesInput>>;
  OR?: InputMaybe<Array<FilterFindManyBestValuesInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBestValuesOperatorsInput>;
  /** ID of the contestant these personal bests belong to, if applicable. */
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the driver these personal bests belong to, if applicable. */
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  fastestLap?: InputMaybe<FilterFindManyBestValuesFastestLapInput>;
  fastestSectors?: InputMaybe<Array<InputMaybe<FilterFindManyBestValuesFastestSectorInput>>>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBestValuesOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBestValues_IdOperatorsInput>;
  contestantID?: InputMaybe<FilterFindManyBestValuesContestantIdOperatorsInput>;
  driverID?: InputMaybe<FilterFindManyBestValuesDriverIdOperatorsInput>;
  sessionID?: InputMaybe<FilterFindManyBestValuesSessionIdOperatorsInput>;
};

export type FilterFindManyBestValuesSessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBestValues_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBopCarBopInput = {
  EStintMax?: InputMaybe<Scalars['Float']['input']>;
  PEngineMax?: InputMaybe<Scalars['Float']['input']>;
  VFuelVolumeCapacityMax?: InputMaybe<Scalars['Float']['input']>;
  VRefuelVolumeMax?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  aCamberFmax?: InputMaybe<Scalars['Float']['input']>;
  aCamberFmin?: InputMaybe<Scalars['Float']['input']>;
  aCamberRmax?: InputMaybe<Scalars['Float']['input']>;
  aCamberRmin?: InputMaybe<Scalars['Float']['input']>;
  aRakeMax?: InputMaybe<Scalars['Float']['input']>;
  aRakeMin?: InputMaybe<Scalars['Float']['input']>;
  aWingRmax?: InputMaybe<Scalars['Float']['input']>;
  aWingRmin?: InputMaybe<Scalars['Float']['input']>;
  carSpec?: InputMaybe<Scalars['String']['input']>;
  hRideFmin?: InputMaybe<Scalars['Float']['input']>;
  hRideRmin?: InputMaybe<Scalars['Float']['input']>;
  highlightColour?: InputMaybe<Scalars['String']['input']>;
  homologation?: InputMaybe<Scalars['String']['input']>;
  mCarBallastMin?: InputMaybe<Scalars['Float']['input']>;
  mCarWeightEmptyMin?: InputMaybe<Scalars['Float']['input']>;
  mCarWeightTotalMin?: InputMaybe<Scalars['Float']['input']>;
  mFuelMassCapacityMax?: InputMaybe<Scalars['Float']['input']>;
  mRefuelMassMax?: InputMaybe<Scalars['Float']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['String']['input']>;
  nEngineMax?: InputMaybe<Scalars['Float']['input']>;
  /** A map rpm vs boost pressure */
  pEngineBoost?: InputMaybe<Scalars['JSON']['input']>;
  rLambdaMin?: InputMaybe<Scalars['Float']['input']>;
  rPowerCurveReference?: InputMaybe<Scalars['Float']['input']>;
  rPowerGainAboveRefVelocity?: InputMaybe<Scalars['Float']['input']>;
  vCarMax?: InputMaybe<Scalars['Float']['input']>;
  vPowerCurveBelowRefVelocity?: InputMaybe<Scalars['Float']['input']>;
  vPowerGainReference?: InputMaybe<Scalars['Float']['input']>;
  xAirRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  xFuelRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  xRefuelRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  zWingMin?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyBopInput = {
  AND?: InputMaybe<Array<FilterFindManyBopInput>>;
  OR?: InputMaybe<Array<FilterFindManyBopInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBopOperatorsInput>;
  bopFile?: InputMaybe<Scalars['String']['input']>;
  carBop?: InputMaybe<Array<InputMaybe<FilterFindManyBopCarBopInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sessionBop?: InputMaybe<FilterFindManyBopSessionBopInput>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyBopNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBopOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBop_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyBopNameOperatorsInput>;
  sessionID?: InputMaybe<FilterFindManyBopSessionIdOperatorsInput>;
};

export type FilterFindManyBopSessionBopInput = {
  EStintEnergyMax?: InputMaybe<Scalars['Float']['input']>;
  EStintEnergyRefillRateMax?: InputMaybe<Scalars['Float']['input']>;
  VRefuelRateMax?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  mRefuelRateMax?: InputMaybe<Scalars['Float']['input']>;
  pAmbientSessionOfficial?: InputMaybe<Scalars['Float']['input']>;
  tyreModel?: InputMaybe<Scalars['String']['input']>;
  xStintlengthMax?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyBopSessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBop_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBrakeSystemInput = {
  BBBSEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  brakePadFManufacturer?: InputMaybe<Scalars['String']['input']>;
  brakePadFSpec?: InputMaybe<Scalars['String']['input']>;
  brakePadRManufacturer?: InputMaybe<Scalars['String']['input']>;
  brakePadRSpec?: InputMaybe<Scalars['String']['input']>;
  brakePedalPosition?: InputMaybe<Scalars['String']['input']>;
  dMasterCylinderF?: InputMaybe<Scalars['Float']['input']>;
  dMasterCylinderR?: InputMaybe<Scalars['Float']['input']>;
  kBBSSpring?: InputMaybe<Scalars['Float']['input']>;
  kKnockOffSpringF?: InputMaybe<Scalars['Float']['input']>;
  kKnockOffSpringR?: InputMaybe<Scalars['Float']['input']>;
  masterCylinderFSpec?: InputMaybe<Scalars['String']['input']>;
  masterCylinderRSpec?: InputMaybe<Scalars['String']['input']>;
  masterCylinderRodLengthF?: InputMaybe<Scalars['Float']['input']>;
  masterCylinderRodlengthR?: InputMaybe<Scalars['Float']['input']>;
  pBrakeBalanceRef?: InputMaybe<Scalars['Float']['input']>;
  rBrakeF?: InputMaybe<Scalars['Float']['input']>;
  rBrakePedal?: InputMaybe<Scalars['Float']['input']>;
  xBBSPreload?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyBuildSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** The height of the block within the grid */
  h?: InputMaybe<Scalars['Int']['input']>;
  moved?: InputMaybe<Scalars['Boolean']['input']>;
  resizing?: InputMaybe<Scalars['Boolean']['input']>;
  static?: InputMaybe<Scalars['Boolean']['input']>;
  tabs?: InputMaybe<Array<InputMaybe<FilterFindManyBuildSheetStyleTabInput>>>;
  /** The width of the block within the grid */
  w?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterFindManyBuildSheetStyleInput = {
  AND?: InputMaybe<Array<FilterFindManyBuildSheetStyleInput>>;
  OR?: InputMaybe<Array<FilterFindManyBuildSheetStyleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBuildSheetStyleOperatorsInput>;
  blocks?: InputMaybe<Array<InputMaybe<FilterFindManyBuildSheetStyleBlockInput>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  targetEventType?: InputMaybe<EnumBuildSheetStyleTargetEventType>;
  targetRoles?: InputMaybe<Array<InputMaybe<EnumBuildSheetStyleTargetRoles>>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumBuildSheetStyleType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBuildSheetStyleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBuildSheetStyle_IdOperatorsInput>;
};

export type FilterFindManyBuildSheetStyleTabInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetGroupEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyBuildSheetStyle_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCalculationInput = {
  AND?: InputMaybe<Array<FilterFindManyCalculationInput>>;
  OR?: InputMaybe<Array<FilterFindManyCalculationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCalculationOperatorsInput>;
  /** For the client to display debug information or default return values */
  debugMode?: InputMaybe<Scalars['Boolean']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  functionString?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The name of the parameter or path to a field which this calculation gives as output. */
  parameter?: InputMaybe<Scalars['String']['input']>;
  /** The names of the parameters or paths to fields which this calculation depends on. If any of these change, the calculation should be re-run. */
  trigger?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumCalculationType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCalculationNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCalculationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCalculation_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyCalculationNameOperatorsInput>;
};

export type FilterFindManyCalculation_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCanopyCredentialsInput = {
  /** Client ID for the Canopy API */
  clientID?: InputMaybe<Scalars['String']['input']>;
  /** Client secret for the Canopy API */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Password for the Canopy API */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID from the Canopy API */
  tenantID?: InputMaybe<Scalars['String']['input']>;
  /** Username for the Canopy API */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarCornerInput = {
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aFlap?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<Scalars['Float']['input']>;
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  brake?: InputMaybe<BrakeInput>;
  bumpStop?: InputMaybe<BumpStopInput>;
  damper?: InputMaybe<DamperInput>;
  droopStop?: InputMaybe<DroopStopInput>;
  externalBumpStop?: InputMaybe<ExternalBumpStopInput>;
  hRide?: InputMaybe<Scalars['Float']['input']>;
  hRideChassis?: InputMaybe<Scalars['Float']['input']>;
  hRideMeasurement?: InputMaybe<Scalars['Float']['input']>;
  hRideRegulation?: InputMaybe<Scalars['Float']['input']>;
  helperSpring?: InputMaybe<SpringInput>;
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
  reboundSpring?: InputMaybe<SpringInput>;
  spring?: InputMaybe<SpringInput>;
  suspension?: InputMaybe<SuspensionInput>;
  xToe?: InputMaybe<Scalars['Float']['input']>;
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCarDataServiceApplicationSettingsConfigInput = {
  DriverContestantLookup?: InputMaybe<Scalars['JSON']['input']>;
  FunctionsFolder?: InputMaybe<Scalars['String']['input']>;
  PitstopTriggers?: InputMaybe<Array<InputMaybe<FilterFindManyCarDataServicePitstopTriggerInput>>>;
  ProcessedFolder?: InputMaybe<Scalars['String']['input']>;
  ResultsFolder?: InputMaybe<Scalars['String']['input']>;
  RunsheetMatching?: InputMaybe<EnumCarDataServiceApplicationSettingsConfigRunsheetMatching>;
};

export type FilterFindManyCarDataServiceConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyCarDataServiceConfigInput>>;
  Kpi?: InputMaybe<FilterFindManyCarDataServiceKpiConfigInput>;
  OR?: InputMaybe<Array<FilterFindManyCarDataServiceConfigInput>>;
  ORHCalculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Object containing parameter mappings. Format is like: { vCar: [{ "name": "car_speed", "offset": 0, "gain": 3.6 }] } */
  ParameterMap?: InputMaybe<Scalars['JSON']['input']>;
  PostProcessingConfig?: InputMaybe<FilterFindManyCarDataServicePostProcessingConfigInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCarDataServiceConfigOperatorsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCarDataServiceConfigNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCarDataServiceConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCarDataServiceConfig_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyCarDataServiceConfigNameOperatorsInput>;
  raceSeriesID?: InputMaybe<FilterFindManyCarDataServiceConfigRaceSeriesIdOperatorsInput>;
};

export type FilterFindManyCarDataServiceConfigRaceSeriesIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarDataServiceConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarDataServiceEventConfigInput = {
  EventDescription?: InputMaybe<Scalars['String']['input']>;
  EventId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCarDataServiceKpiConfigInput = {
  KpiParameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Preconditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preconditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyCarDataServicePitstopTriggerInput = {
  ParameterId?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<EnumCarDataServicePitstopTriggerType>;
  Value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCarDataServicePostProcessingConfigInput = {
  ApplicationSettingsConfiguration?: InputMaybe<FilterFindManyCarDataServiceApplicationSettingsConfigInput>;
  EventConfiguration?: InputMaybe<FilterFindManyCarDataServiceEventConfigInput>;
  ProcessingEnginesConfiguration?: InputMaybe<FilterFindManyCarDataServiceProcessingEnginesConfigInput>;
  QueueManagerConfiguration?: InputMaybe<FilterFindManyCarDataServiceQueueManagerConfigInput>;
  SessionManagerConfiguration?: InputMaybe<FilterFindManyCarDataServiceSessionManagerConfigInput>;
  SessionTypesConfiguration?: InputMaybe<FilterFindManyCarDataServiceSessionTypesConfigInput>;
};

export type FilterFindManyCarDataServiceProcessingEngineConfigExportersInput = {
  ATLAS10_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  JSONFILE_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  ONERACEHUB_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  PARQUETFILE_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  WINTAX_EXPORTER?: InputMaybe<FilterFindManyCarDataServiceProcessingEngineConfigExportersWintax_ExporterInput>;
};

export type FilterFindManyCarDataServiceProcessingEngineConfigExportersWintax_ExporterInput = {
  /** NAme of paremeter in the parameter map, tracking the distance of current lap. */
  DISTANCE_CHANNEL?: InputMaybe<Scalars['String']['input']>;
  /** Fuel consumption of the current lap. Could be a KPI like 'sLap.Lap.Max' or a fixed value like '2453.2'. */
  FUEL_CONSUMPTION?: InputMaybe<Scalars['String']['input']>;
  /** Fuel level of the current lap. Could be a KPI like 'ERESSRaceFIA.Lap.Last' or a fixed value like '90.3'. */
  FUEL_LEVEL?: InputMaybe<Scalars['String']['input']>;
  /** Effective distance of the current lap. COuld be a KPI like 'ELap.Lap.Integral' or a fixed valued like '10.4'. */
  LAP_DISTANCE?: InputMaybe<Scalars['String']['input']>;
  /** Contains the folder, where the exported WinTAX files are stored. */
  OUTPUT_PATH?: InputMaybe<Scalars['String']['input']>;
  SIMULATE_CALLS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contains the folder, where the TelDataZtx dll files are stored. */
  TELDATAZTX_PATH?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarDataServiceProcessingEngineConfigInput = {
  Calculations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Exporters?: InputMaybe<FilterFindManyCarDataServiceProcessingEngineConfigExportersInput>;
  Importer?: InputMaybe<EnumCarDataServiceProcessingEngineConfigImporter>;
  Instances?: InputMaybe<Scalars['Float']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  QueueName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarDataServiceProcessingEnginesConfigInput = {
  ExportersFolder?: InputMaybe<Scalars['String']['input']>;
  ImportersFolder?: InputMaybe<Scalars['String']['input']>;
  InternalCalculationsFolder?: InputMaybe<Scalars['String']['input']>;
  ORHCalculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  ParameterMapFile?: InputMaybe<Scalars['String']['input']>;
  ProcessingEngineConfiguration?: InputMaybe<Array<InputMaybe<FilterFindManyCarDataServiceProcessingEngineConfigInput>>>;
  UserCalculationsFolder?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarDataServiceQueueDefinitionInput = {
  Name?: InputMaybe<Scalars['String']['input']>;
  SessionType?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarDataServiceQueueManagerConfigInput = {
  Queues?: InputMaybe<Array<InputMaybe<FilterFindManyCarDataServiceQueueDefinitionInput>>>;
};

export type FilterFindManyCarDataServiceSessionManagerConfigInput = {
  OffloadFolder?: InputMaybe<Scalars['String']['input']>;
  OffloadSessionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyCarDataServiceSessionTypeConfigInput = {
  exts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  folderUpLevel?: InputMaybe<Scalars['Int']['input']>;
  ignoreLiterals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  regExpressions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarDataServiceSessionTypesConfigInput = {
  SessionTypes?: InputMaybe<Array<InputMaybe<FilterFindManyCarDataServiceSessionTypeConfigInput>>>;
};

export type FilterFindManyCarEndInput = {
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<Scalars['Float']['input']>;
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  antiRollBar?: InputMaybe<AntiRollBarInput>;
  bumpStop?: InputMaybe<BumpStopInput>;
  damper?: InputMaybe<DamperInput>;
  droopStop?: InputMaybe<DroopStopInput>;
  externalBumpStop?: InputMaybe<ExternalBumpStopInput>;
  hRide?: InputMaybe<Scalars['Float']['input']>;
  hRideChassis?: InputMaybe<Scalars['Float']['input']>;
  /** Point where the mechanic is measuring the ride height */
  hRideMeasurement?: InputMaybe<Scalars['Float']['input']>;
  /** Baseline pushrod length, steering rack bumpsteer adjust might depend on the rough range of ride heights the car is running in. */
  hRideRange?: InputMaybe<Scalars['String']['input']>;
  /** Point where the regulation authority is measuring the ride height */
  hRideRegulation?: InputMaybe<Scalars['Float']['input']>;
  helperSpring?: InputMaybe<SpringInput>;
  kinematics?: InputMaybe<KinematicsInput>;
  kinematicsExternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  kinematicsInternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  reboundSpring?: InputMaybe<SpringInput>;
  spring?: InputMaybe<SpringInput>;
  thirdElement?: InputMaybe<ThirdElementInput>;
  xToe?: InputMaybe<Scalars['Float']['input']>;
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCarInfoInput = {
  /** Number of changes */
  NChanges?: InputMaybe<Scalars['Float']['input']>;
  /** Number of issues */
  NIssue?: InputMaybe<Scalars['Float']['input']>;
  batteryID?: InputMaybe<Scalars['String']['input']>;
  chassisID?: InputMaybe<Scalars['String']['input']>;
  /** A map of custom IDs for this setup. Input syntax is array of key-value (string-string) tuples. */
  customIDs?: InputMaybe<Scalars['JSON']['input']>;
  driveshaftID?: InputMaybe<Scalars['String']['input']>;
  engineID?: InputMaybe<Scalars['String']['input']>;
  gearboxID?: InputMaybe<Scalars['String']['input']>;
  inverterID?: InputMaybe<Scalars['String']['input']>;
  setupComments?: InputMaybe<Scalars['String']['input']>;
  /** Tyre compound for which this setup is intended */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarMassInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Front-left mass */
  mCarFL?: InputMaybe<Scalars['Float']['input']>;
  /** Front-right mass */
  mCarFR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-left mass */
  mCarRL?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-right mass */
  mCarRR?: InputMaybe<Scalars['Float']['input']>;
  /** Driver mass */
  mDriver?: InputMaybe<Scalars['Float']['input']>;
  /** Target portion of mass in the front of the car */
  rWeightFTarget?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCarSetupAuthorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupChassisAssemblyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupChassisIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupChassisSpecIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupChassisSpecRootIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupDriverIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupEngineerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupInput = {
  AND?: InputMaybe<Array<FilterFindManyCarSetupInput>>;
  OR?: InputMaybe<Array<FilterFindManyCarSetupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCarSetupOperatorsInput>;
  aero?: InputMaybe<FilterFindManyAeroInput>;
  aeroPackage?: InputMaybe<FilterFindManyAeroPackageInput>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  brakeSystem?: InputMaybe<FilterFindManyBrakeSystemInput>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecRootID?: InputMaybe<Scalars['MongoID']['input']>;
  cockpit?: InputMaybe<FilterFindManyCockpitInput>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  custom?: InputMaybe<Scalars['JSON']['input']>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  /** Enable custom simulation payload for this setup. You as a user are responsible to have meaningful data in there. */
  customSimulationPayloadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  engineerID?: InputMaybe<Scalars['MongoID']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  flattened?: InputMaybe<Scalars['JSON']['input']>;
  front?: InputMaybe<FilterFindManyCarEndInput>;
  frontLeft?: InputMaybe<FilterFindManyCarCornerInput>;
  frontRight?: InputMaybe<FilterFindManyCarCornerInput>;
  historyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  info?: InputMaybe<FilterFindManyCarInfoInput>;
  intendedForSession?: InputMaybe<EnumCarSetupIntendedForSession>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Map of ballast positions to their masses. Keys are names of the positions and values are the masses. Input syntax is array of key-value tuples, like `mBallasts: [["front", 10], ["rear", 20]]`. */
  mBallasts?: InputMaybe<Scalars['JSON']['input']>;
  manualEndMileage?: InputMaybe<Scalars['Float']['input']>;
  manualStartMileage?: InputMaybe<Scalars['Float']['input']>;
  /** Mass out of garage (with driver in the seat) */
  massOutOfGarage?: InputMaybe<FilterFindManyCarMassInput>;
  /** Mass at the scales of the regulatory authority */
  massRegulation?: InputMaybe<FilterFindManyCarMassInput>;
  /** Mass from car setup */
  massSetup?: InputMaybe<FilterFindManyCarMassInput>;
  /** Mass from regulation scale replica in garage (team's scales) */
  massTeam?: InputMaybe<FilterFindManyCarMassInput>;
  powertrain?: InputMaybe<FilterFindManyPowertrainInput>;
  powertrainCentral?: InputMaybe<FilterFindManyPowertrainInput>;
  powertrainFront?: InputMaybe<FilterFindManyPowertrainInput>;
  powertrainRear?: InputMaybe<FilterFindManyPowertrainInput>;
  rear?: InputMaybe<FilterFindManyCarEndInput>;
  rearLeft?: InputMaybe<FilterFindManyCarCornerInput>;
  rearRight?: InputMaybe<FilterFindManyCarCornerInput>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Small info string */
  setupInfo?: InputMaybe<Scalars['String']['input']>;
  /** Override of setup sheet style, which usually comes from the chassis. */
  setupSheetStyle?: InputMaybe<EnumCarSetupSetupSheetStyle>;
  steering?: InputMaybe<FilterFindManySteeringInput>;
  /** Map containing systems config comments. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigComment?: InputMaybe<Scalars['JSON']['input']>;
  /** Map containing systems config NIssue data. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigNIssues?: InputMaybe<Scalars['JSON']['input']>;
  /** Map containing systems config values. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigValues?: InputMaybe<Scalars['JSON']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
  writeHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCarSetupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCarSetup_IdOperatorsInput>;
  authorID?: InputMaybe<FilterFindManyCarSetupAuthorIdOperatorsInput>;
  chassisAssemblyID?: InputMaybe<FilterFindManyCarSetupChassisAssemblyIdOperatorsInput>;
  chassisID?: InputMaybe<FilterFindManyCarSetupChassisIdOperatorsInput>;
  chassisSpecID?: InputMaybe<FilterFindManyCarSetupChassisSpecIdOperatorsInput>;
  chassisSpecRootID?: InputMaybe<FilterFindManyCarSetupChassisSpecRootIdOperatorsInput>;
  driverID?: InputMaybe<FilterFindManyCarSetupDriverIdOperatorsInput>;
  engineerID?: InputMaybe<FilterFindManyCarSetupEngineerIdOperatorsInput>;
  runSheetID?: InputMaybe<FilterFindManyCarSetupRunSheetIdOperatorsInput>;
  teamID?: InputMaybe<FilterFindManyCarSetupTeamIdOperatorsInput>;
  time?: InputMaybe<FilterFindManyCarSetupTimeOperatorsInput>;
  title?: InputMaybe<FilterFindManyCarSetupTitleOperatorsInput>;
  tyreSetID?: InputMaybe<FilterFindManyCarSetupTyreSetIdOperatorsInput>;
};

export type FilterFindManyCarSetupRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupTeamIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyCarSetupTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyCarSetupTyreSetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyChassisAssemblyMeasurementInput = {
  chassisSpecMeasurementID?: InputMaybe<Scalars['MongoID']['input']>;
  location?: InputMaybe<FilterFindManyAdjustableLocationInput>;
  orientation?: InputMaybe<FilterFindManyAdjustableOrientationInput>;
};

export type FilterFindManyChassisAssemblyTrackingSourceRecordInput = {
  sources?: InputMaybe<Array<InputMaybe<FilterFindManyChassisAssemblyTrackingSourceRecordSourcesInput>>>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyChassisAssemblyTrackingSourceRecordSourcesInput = {
  /** priority of this source. Defined on the alias but saved here for efficiency reasons */
  priority?: InputMaybe<Scalars['Float']['input']>;
  trackingSourceAliasID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyChassisInput = {
  AND?: InputMaybe<Array<FilterFindManyChassisInput>>;
  OR?: InputMaybe<Array<FilterFindManyChassisInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyChassisOperatorsInput>;
  /** Allowable keys for ballast measurements in car setups that use this chassis. */
  ballastPositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  currentlyInUse?: InputMaybe<Scalars['Boolean']['input']>;
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerPartID?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  /** Unique identifier for the chassis */
  reference?: InputMaybe<Scalars['String']['input']>;
  rootAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Map of setup sheet fields to available preset values. Keys are like `"front.kSpringF"`, and values are lists of options. Input syntax is array of key-value tuples, like `setupOptions: [["front.kSpringF", [100, 110, 120]]]`. */
  setupOptions?: InputMaybe<Scalars['JSON']['input']>;
  setupSheetStyle?: InputMaybe<EnumChassisSetupSheetStyle>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Allowable keys for systems config maps in car setups that use this chassis. */
  systemsConfigFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Car type */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyChassisManufacturerPartIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyChassisMassInput = {
  /** Base mass properties of the vehicle */
  base?: InputMaybe<FilterFindManyMassPropertiesInput>;
  /** Mass properties of the driver */
  driver?: InputMaybe<FilterFindManyMassPropertiesInput>;
  setupEquip?: InputMaybe<FilterFindManyMassPropertiesInput>;
};

export type FilterFindManyChassisMeasurementInput = {
  AND?: InputMaybe<Array<FilterFindManyChassisMeasurementInput>>;
  OR?: InputMaybe<Array<FilterFindManyChassisMeasurementInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyChassisMeasurementOperatorsInput>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyChassisMeasurementOperatorsInput = {
  _id?: InputMaybe<FilterFindManyChassisMeasurement_IdOperatorsInput>;
};

export type FilterFindManyChassisMeasurement_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyChassisMeasurementsInput = {
  /** Default angle unit to display in setup options for this chassis */
  angles?: InputMaybe<EnumAngleUnit>;
  /** Default angular compliance unit to display in setup options for this chassis */
  angularCompliances?: InputMaybe<EnumAngularComplianceUnit>;
  /** Default angular torque compliance unit to display in setup options for this chassis */
  angularTorqueCompliances?: InputMaybe<EnumAngularTorqueComplianceUnit>;
  bumpPlateMeasurementMethod?: InputMaybe<EnumBumpPlateMeasurementMethod>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefFront?: InputMaybe<Scalars['Float']['input']>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefRear?: InputMaybe<Scalars['Float']['input']>;
  /** Default compliance unit to display in setup options for this chassis */
  compliances?: InputMaybe<EnumComplianceUnit>;
  /** Default force unit to display in setup options for this chassis */
  forces?: InputMaybe<EnumForceUnit>;
  /** Default inertia unit to display in setup options for this chassis */
  inertias?: InputMaybe<EnumInertiaUnit>;
  /** If true, positive camber is top leaning in. If false, negative camber is top leaning in. */
  inverseCamber?: InputMaybe<Scalars['Boolean']['input']>;
  kinematicsExternalReadingsRequired?: InputMaybe<EnumChassisMeasurementsKinematicsExternalReadingsRequired>;
  kinematicsInternalReadingsRequired?: InputMaybe<EnumChassisMeasurementsKinematicsInternalReadingsRequired>;
  /** Default length unit to display in setup options for this chassis */
  lengths?: InputMaybe<EnumLengthUnit>;
  /** Default mass unit to display in setup options for this chassis */
  masses?: InputMaybe<EnumMassUnit>;
  /** Default power unit to display in setup options for this chassis */
  powers?: InputMaybe<EnumPowerUnit>;
  /** Default pressure unit to display in setup options for this chassis */
  pressures?: InputMaybe<EnumPressureUnit>;
  /** Default ratio unit to display in setup options for this chassis */
  ratios?: InputMaybe<EnumRatioUnit>;
  /** Function to calculate front ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcFront?: InputMaybe<Scalars['String']['input']>;
  /** Function to calculate rear ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcRear?: InputMaybe<Scalars['String']['input']>;
  /** Default spring rate unit to display in setup options for this chassis */
  springRates?: InputMaybe<EnumSpringRateUnit>;
  /** Default steering rack ratio unit to display in setup options for this chassis */
  steeringRackRatios?: InputMaybe<EnumSteeringRackRatioUnit>;
  /** Default temperature unit to display in setup options for this chassis */
  temperatures?: InputMaybe<EnumTemperatureUnit>;
  toeMeasurementMethod?: InputMaybe<EnumToeMeasurementMethod>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefFront?: InputMaybe<Scalars['Float']['input']>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefRear?: InputMaybe<Scalars['Float']['input']>;
  /** If true, toe measurement is given as total over axle. If false, toe measurement is per individual wheel. */
  toeTotal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default torque unit to display in setup options for this chassis */
  torques?: InputMaybe<EnumTorqueUnit>;
  /** Default torsion rate unit to display in setup options for this chassis */
  torsionRates?: InputMaybe<EnumTorsionRateUnit>;
  /** Default volume unit to display in setup options for this chassis */
  volumes?: InputMaybe<EnumVolumeUnit>;
  xTrackFront?: InputMaybe<Scalars['Float']['input']>;
  xTrackRear?: InputMaybe<Scalars['Float']['input']>;
  /** Wheelbase length in metres */
  xWheelbase?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyChassisOperatorsInput = {
  _id?: InputMaybe<FilterFindManyChassis_IdOperatorsInput>;
  manufacturerPartID?: InputMaybe<FilterFindManyChassisManufacturerPartIdOperatorsInput>;
  setupSheetStyle?: InputMaybe<FilterFindManyChassisSetupSheetStyleOperatorsInput>;
  specificationID?: InputMaybe<FilterFindManyChassisSpecificationIdOperatorsInput>;
  type?: InputMaybe<FilterFindManyChassisTypeOperatorsInput>;
};

export type FilterFindManyChassisPowerUnitInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyChassisPowertrainInput = {
  bevelSetSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  differentialSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  dropGearSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  gearBoxSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  gearSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  layout?: InputMaybe<EnumPowertrainLayout>;
  /** Number of gears which are expected to be in the gearbox. */
  numGears?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyChassisSetupSheetStyleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumChassisSetupSheetStyle>;
  gte?: InputMaybe<EnumChassisSetupSheetStyle>;
  in?: InputMaybe<Array<InputMaybe<EnumChassisSetupSheetStyle>>>;
  lt?: InputMaybe<EnumChassisSetupSheetStyle>;
  lte?: InputMaybe<EnumChassisSetupSheetStyle>;
  ne?: InputMaybe<EnumChassisSetupSheetStyle>;
  nin?: InputMaybe<Array<InputMaybe<EnumChassisSetupSheetStyle>>>;
};

export type FilterFindManyChassisSocketInput = {
  /** Unique name for this socket. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyChassisSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyChassisTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyChassis_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCockpitInput = {
  /** Ratio of the throttle pedal */
  rThrottlePedal?: InputMaybe<Scalars['Float']['input']>;
  /** Position of the throttle pedal */
  throttlePedalPosition?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCommentInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyContestantChassisNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyContestantClassOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyContestantEligibleForPointsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyContestantHiddenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyContestantInput = {
  AND?: InputMaybe<Array<FilterFindManyContestantInput>>;
  OR?: InputMaybe<Array<FilterFindManyContestantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyContestantOperatorsInput>;
  /** IDs of usable chassis */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Number of the chassis for this contestant. */
  chassisNumber?: InputMaybe<Scalars['String']['input']>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** Default color to use for this contestant where applicable. */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Drivers that constitute this contestant */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Is this contestant eligible for points? */
  eligibleForPoints?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this contestant be hidden from users? */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Season that this contestant is participating in */
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyContestantID?: InputMaybe<Scalars['String']['input']>;
  /** URI to the audio stream for this contestant in Transcribble. */
  transcribbleAudioURI?: InputMaybe<Scalars['String']['input']>;
  /** Tyres assigned to this contestant for the season. */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Tyre sets assigned to this contestant for the season. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyContestantOperatorsInput = {
  _id?: InputMaybe<FilterFindManyContestant_IdOperatorsInput>;
  chassisNumber?: InputMaybe<FilterFindManyContestantChassisNumberOperatorsInput>;
  class?: InputMaybe<FilterFindManyContestantClassOperatorsInput>;
  eligibleForPoints?: InputMaybe<FilterFindManyContestantEligibleForPointsOperatorsInput>;
  hidden?: InputMaybe<FilterFindManyContestantHiddenOperatorsInput>;
  seasonID?: InputMaybe<FilterFindManyContestantSeasonIdOperatorsInput>;
  startNumber?: InputMaybe<FilterFindManyContestantStartNumberOperatorsInput>;
  teamID?: InputMaybe<FilterFindManyContestantTeamIdOperatorsInput>;
  thirdPartyContestantID?: InputMaybe<FilterFindManyContestantThirdPartyContestantIdOperatorsInput>;
};

export type FilterFindManyContestantSeasonIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyContestantStartNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyContestantTeamIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyContestantThirdPartyContestantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyContestant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCurrentInput = {
  /** A */
  amps?: InputMaybe<Scalars['Float']['input']>;
  /** mA */
  milliamps?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDamperAdjusterInput = {
  /** Maximum setting, if using min/max/step */
  maxSetting?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum setting, if using min/max/step */
  minSetting?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settingNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Increment to suggest values in, if using min/max/step */
  step?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDamperConfigInput = {
  forceTable?: InputMaybe<FilterFindManyForceTableInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Define which damper clicks are associated with this setting */
  settings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyDampingRateInput = {
  /** Nms/m */
  newtonSecondsPerMetre?: InputMaybe<Scalars['Float']['input']>;
  /** Nms/mm */
  newtonSecondsPerMillimetre?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·s/in */
  poundForceSecondsPerInch?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDashboardInput = {
  /** Dashboard reading of fuel remaining at the end of the run */
  mFuelRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Dashboard reading of fuel amount at the start of the run */
  mFuelRunStart?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDefaultFlexLayoutConfigsInput = {
  BOP?: InputMaybe<Scalars['MongoID']['input']>;
  KPI?: InputMaybe<Scalars['MongoID']['input']>;
  REPORT?: InputMaybe<Scalars['MongoID']['input']>;
  RUNSHEET?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPOVERVIEW?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPSANDBOX?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPSHEET?: InputMaybe<Scalars['MongoID']['input']>;
  SIMULATION?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyDensityInput = {
  /** kg/m³ */
  kilogramsPerCubicMetre?: InputMaybe<Scalars['Float']['input']>;
  /** kg/L */
  kilogramsPerLitre?: InputMaybe<Scalars['Float']['input']>;
  /** lb/ft³ */
  poundsPerCubicFoot?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDepartmentInput = {
  AND?: InputMaybe<Array<FilterFindManyDepartmentInput>>;
  OR?: InputMaybe<Array<FilterFindManyDepartmentInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDepartmentOperatorsInput>;
  /** Search in a radius around a coordinates point. */
  geoNear?: InputMaybe<GeoNear>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDepartmentNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDepartmentOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDepartment_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyDepartmentNameOperatorsInput>;
};

export type FilterFindManyDepartment_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDifferentialConfigInput = {
  /** Is this differential config allowed to be selected in new car setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  frictionFaces?: InputMaybe<Scalars['String']['input']>;
  maxPreloadForce?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rampAccel?: InputMaybe<Scalars['Float']['input']>;
  rampDecel?: InputMaybe<Scalars['Float']['input']>;
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyDriverChampionshipStandingInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  points: Scalars['Int']['input'];
  /** Historical race finish positions of this driver in this season. Null values represent DNFs. Should only be used for pre-session standings data. */
  prevRacePositions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: InputMaybe<Scalars['Int']['input']>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDynoConfigColumnsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** runSheet.tyreSetID, setup.mCar, etc. */
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  /** Tyre, Weight, etc. */
  header?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDynoConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyDynoConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyDynoConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDynoConfigOperatorsInput>;
  columns?: InputMaybe<Array<InputMaybe<FilterFindManyDynoConfigColumnsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDynoConfigNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDynoConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDynoConfig_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyDynoConfigNameOperatorsInput>;
};

export type FilterFindManyDynoConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyEnergyInput = {
  /** J */
  joules?: InputMaybe<Scalars['Float']['input']>;
  /** kJ */
  kilojoules?: InputMaybe<Scalars['Float']['input']>;
  /** kWh */
  kilowattHours?: InputMaybe<Scalars['Float']['input']>;
  /** MJ */
  megajoules?: InputMaybe<Scalars['Float']['input']>;
  /** Wh */
  wattHours?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyEventContestantsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of chassis used, if different for this event. */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** IDs of drivers of this car, if different for this event. */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of tyres allocated to this contestant for this event (like during races where only tyres handed out at this very race are permitted). */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of tyre sets allocated to this contestant for this event. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyEventInput = {
  AND?: InputMaybe<Array<FilterFindManyEventInput>>;
  /** Density of the fuel */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Number of this event in the season */
  NEventSeason?: InputMaybe<Scalars['Float']['input']>;
  OR?: InputMaybe<Array<FilterFindManyEventInput>>;
  /** Default SoCRequired values to use during this event (assuming single track layout) */
  SoCRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyEventOperatorsInput>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Fuel/SoC/Energy consumptions for each track layout in this event. */
  consumptions?: InputMaybe<Array<InputMaybe<FilterFindManyLayoutConsumptionInput>>>;
  contestants?: InputMaybe<Array<InputMaybe<FilterFindManyEventContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumEventDebriefNotesMode>;
  /** Default energyRequired values to use during this event (assuming single track layout) */
  energyRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  /** Energy sweep information for Formula E */
  energySweep?: InputMaybe<Scalars['JSON']['input']>;
  enumEventType?: InputMaybe<EnumEventEnumEventType>;
  enumEventVenue?: InputMaybe<EnumEventEnumEventVenue>;
  /** e.g. Race, Test, etc. */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Default fuelRequired values to use during this event (assuming single track layout) */
  fuelRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  /** Should the iRacing service populate this event when an unknown event is encountered? */
  iRacingServiceIsNextEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of issues related to this event. */
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Reference laptimes for each track layout in this event. */
  referenceLaptimes?: InputMaybe<Array<InputMaybe<FilterFindManyEventReferenceLaptimesInput>>>;
  /** Selected authors for the event report (person reference plus a name snapshot). */
  reportAuthors?: InputMaybe<Array<InputMaybe<FilterFindManyEventReportAuthorsInput>>>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Time of event end in local time */
  tEventEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of event start in local time */
  tEventStart?: InputMaybe<Scalars['Date']['input']>;
  tLapAverage?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyEventID?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  trackID?: InputMaybe<Scalars['MongoID']['input']>;
  trackLayoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumEventType>;
  tyreDefaults?: InputMaybe<Array<InputMaybe<FilterFindManyEventTyreDefaultsSetInput>>>;
  tyreDefaultsFL?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsFR?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsRL?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsRR?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsWetFL?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsWetFR?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsWetRL?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsWetRR?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
};

export type FilterFindManyEventNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyEventOperatorsInput = {
  _id?: InputMaybe<FilterFindManyEvent_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyEventNameOperatorsInput>;
  seasonID?: InputMaybe<FilterFindManyEventSeasonIdOperatorsInput>;
  tEventEnd?: InputMaybe<FilterFindManyEventTEventEndOperatorsInput>;
  tEventStart?: InputMaybe<FilterFindManyEventTEventStartOperatorsInput>;
  tLapAverage?: InputMaybe<FilterFindManyEventTLapAverageOperatorsInput>;
  thirdPartyEventID?: InputMaybe<FilterFindManyEventThirdPartyEventIdOperatorsInput>;
  trackID?: InputMaybe<FilterFindManyEventTrackIdOperatorsInput>;
};

export type FilterFindManyEventReferenceLaptimesInput = {
  /** Reference Laptime for ATTACK lap */
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for COOL lap */
  COOL?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for FCY lap */
  FCY?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for IN lap */
  IN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for OUT lap */
  OUT?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for OUTIN lap */
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PITLANE lap */
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PREP lap */
  PREP?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PUSH lap */
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for QUALI lap */
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SAFETYCAR lap */
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SHAKEDOWN lap */
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SLOW lap */
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TARGET lap */
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOGRID lap */
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOPADDOCK lap */
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOPITS lap */
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for UNFINISHED lap */
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
  calculationMethod?: InputMaybe<EnumEventReferenceLaptimesCalculationMethod>;
  /** Reference Laptime when using the calculation method "RATIO" */
  referenceLaptime?: InputMaybe<Scalars['Float']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyEventReportAuthorsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyEventSeasonIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyEventTEventEndOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyEventTEventStartOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyEventTLapAverageOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyEventThirdPartyEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyEventTrackIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyEventTyreDefaultsInput = {
  /** Suggested bare minimum tyre pressure for this event. */
  pTyreMin?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested minimum pressure at the start of a run for this event. */
  pTyreMinStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested pressure at the start of a run for this event. */
  pTyreStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested tyre pressure target for this event. */
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyEventTyreDefaultsSetInput = {
  frontLeft?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  frontRight?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  rearLeft?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  rearRight?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  /** Which compound should these defaults be applied on? */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
  /** Which tyre type should these defaults be applied on? */
  tyreType?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyFlexLayoutConfigGlobalXAxisInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  gain?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumFlexLayoutConfigGlobalXAxisType>;
};

export type FilterFindManyFlexLayoutConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyFlexLayoutConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyFlexLayoutConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyFlexLayoutConfigOperatorsInput>;
  globalXAxis?: InputMaybe<FilterFindManyFlexLayoutConfigGlobalXAxisInput>;
  intendedFor?: InputMaybe<EnumFlexLayoutConfigIntendedFor>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration recognised by flexlayout-react */
  model?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** If this is non-empty, only users with one of these roles can see this config. */
  targetRoles?: InputMaybe<Array<EnumPersonRole>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyFlexLayoutConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyFlexLayoutConfig_IdOperatorsInput>;
};

export type FilterFindManyFlexLayoutConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyForceInput = {
  /** N */
  newtons?: InputMaybe<Scalars['Float']['input']>;
  /** lbf */
  poundsForce?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyForceTableInput = {
  /** Acceleration (ddx) values */
  acceleration?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F1 */
  dampingForce?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F0 */
  force?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F2 */
  inertanceForce?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Velocity (dx) values */
  velocity?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Displacement values */
  x?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  xMax?: InputMaybe<Scalars['Float']['input']>;
  xMin?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyFrequencyInput = {
  /** Hz */
  hertz?: InputMaybe<Scalars['Float']['input']>;
  /** kHz */
  kilohertz?: InputMaybe<Scalars['Float']['input']>;
  /** MHz */
  megahertz?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyGenericRunSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  blockBackgroundColour?: InputMaybe<Scalars['String']['input']>;
  brakeFields?: InputMaybe<Array<InputMaybe<EnumBrakeBlockField>>>;
  /** A map of colorable things to colors */
  colorMap?: InputMaybe<Scalars['JSON']['input']>;
  defaultOpenState?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order in which to display visible run energy fields. */
  energyFieldOrder?: InputMaybe<Array<InputMaybe<EnumGenericRunSheetStyleBlockEnergyFieldOrder>>>;
  /** Source of the lap end energy value */
  energyLapEndSource?: InputMaybe<Scalars['String']['input']>;
  energyType?: InputMaybe<EnumEnergyType>;
  field?: InputMaybe<Scalars['String']['input']>;
  /** Field name for first comment box in a double comment block. */
  field1?: InputMaybe<Scalars['String']['input']>;
  /** Field name for second comment box in a double comment block. */
  field2?: InputMaybe<Scalars['String']['input']>;
  fuelColumns?: InputMaybe<Array<EnumFuelColumn>>;
  fuelFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The height of the block within the grid */
  height?: InputMaybe<Scalars['Int']['input']>;
  isAlwaysOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isShownWhenFolded?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Label on first comment box in a double comment block. */
  label1?: InputMaybe<Scalars['String']['input']>;
  /** Label on second comment box in a double comment block. */
  label2?: InputMaybe<Scalars['String']['input']>;
  /** Ordered columns to show in the lap table */
  lapColumns?: InputMaybe<Array<InputMaybe<FilterFindManyLapColumnInput>>>;
  lapCountBlockFieldOrder?: InputMaybe<Array<InputMaybe<FilterFindManyGenericRunSheetStyleBlockLapCountBlockFieldOrderInput>>>;
  lapFlags?: InputMaybe<FilterFindManyLapFlagLabelsInput>;
  /** Names of lapKPI fields to show */
  lapKPIs?: InputMaybe<Array<InputMaybe<FilterFindManyGenericRunSheetStyleBlockLapKpIsInput>>>;
  manualLapInputByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  mileageUnit?: InputMaybe<EnumLengthUnit>;
  pressureUnit?: InputMaybe<EnumPressureUnit>;
  rows?: InputMaybe<Scalars['Float']['input']>;
  /** Order in which to display visible run energy fields. */
  runEnergyFieldOrder?: InputMaybe<Array<EnumRunEnergyField>>;
  runEnergyFields?: InputMaybe<FilterFindManyRunEnergyFieldLabelsInput>;
  runKPIRows?: InputMaybe<Array<InputMaybe<FilterFindManyRunKpiTableRowInput>>>;
  runKPITable?: InputMaybe<Array<InputMaybe<FilterFindManyGenericRunSheetStyleBlockRunKpiTableInput>>>;
  setupSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Defines the visibility of the ambient and track condition in the weather block */
  showAmbientAndTrackCondition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the extended combustion consumption fields. */
  showExtendedConsumptionFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the fuel density input box. */
  showFuelDensityInput?: InputMaybe<Scalars['Boolean']['input']>;
  showGetPreviousRunPostPressureButton?: InputMaybe<Scalars['Boolean']['input']>;
  showGetRecommendationButton?: InputMaybe<Scalars['Boolean']['input']>;
  showLapTypeColors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the maximum amount of laps per consumption for a given fuel load fields. */
  showMaxLapsPerConsumptionFields?: InputMaybe<Scalars['Boolean']['input']>;
  showMinimumPressures?: InputMaybe<Scalars['Boolean']['input']>;
  showOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  showPostRunBrakeTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showPreRunBrakeTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showSurfaceTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showTargetPressures?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreReferencePressure?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreSelector?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreSetSelector?: InputMaybe<Scalars['Boolean']['input']>;
  staggerSettings?: InputMaybe<FilterFindManyGenericRunSheetStyleBlockStaggerSettingsInput>;
  standardTyrePressureBox?: InputMaybe<FilterFindManyGenericRunSheetStyleBlockStandardTyrePressureBoxInput>;
  standardTyreTempBox?: InputMaybe<FilterFindManyGenericRunSheetStyleBlockStandardTyreTempBoxInput>;
  style?: InputMaybe<EnumRunSheetStyleBlockStyle>;
  temperatureUnit?: InputMaybe<EnumTemperatureUnit>;
  title?: InputMaybe<Scalars['String']['input']>;
  treadDepthUnit?: InputMaybe<EnumLengthUnit>;
  type?: InputMaybe<EnumGenericRunSheetStyleBlockType>;
  tyreTableRows?: InputMaybe<Array<InputMaybe<FilterFindManyTyreTableBlockRowInput>>>;
  /** Number of tread depth measurements to allow. Use `0` or `null` to hide the input. */
  tyreTreadDepthMeasurements?: InputMaybe<Scalars['Int']['input']>;
  unitSystem?: InputMaybe<EnumUnitSystem>;
  velocityUnit?: InputMaybe<EnumVelocityUnit>;
  /** Ordered weather block fields to show */
  weatherFieldOrder?: InputMaybe<Array<EnumWeatherBlockField>>;
  /** The width of the block within the grid */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterFindManyGenericRunSheetStyleBlockLapCountBlockFieldOrderInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  field?: InputMaybe<EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField>;
  show?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyGenericRunSheetStyleBlockLapKpIsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<FilterFindManyValueLimitInput>;
  upperLimit?: InputMaybe<FilterFindManyValueLimitInput>;
};

export type FilterFindManyGenericRunSheetStyleBlockRunKpiTableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  defaultEditable?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<InputMaybe<FilterFindManyGenericRunSheetStyleBlockRunKpiTableRowsInput>>>;
};

export type FilterFindManyGenericRunSheetStyleBlockRunKpiTableRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FilterFindManyRunKpiTableRowFieldInput>>>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyGenericRunSheetStyleBlockStaggerSettingsInput = {
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumLengthUnit>;
};

export type FilterFindManyGenericRunSheetStyleBlockStandardTyrePressureBoxInput = {
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<EnumPressureOption>>>;
  unit?: InputMaybe<EnumPressureUnit>;
};

export type FilterFindManyGenericRunSheetStyleBlockStandardTyreTempBoxInput = {
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<EnumTemperatureOption>>>;
  unit?: InputMaybe<EnumTemperatureUnit>;
};

export type FilterFindManyGeoLocationInput = {
  /** [longitude, latitude] in decimal degrees */
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Only "Point" is supported */
  type?: InputMaybe<EnumGeoLocationType>;
};

export type FilterFindManyIssueQueryAcknowledgedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryAcknowledgedByIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryAreaOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryAssigneeIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryCancelledAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryCancelledByIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryCarSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryClosedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryClosedByIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryCommentsAuthorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryCommentsCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryCommentsOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIssueQueryComments_IdOperatorsInput>;
  authorID?: InputMaybe<FilterFindManyIssueQueryCommentsAuthorIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyIssueQueryCommentsCreatedAtOperatorsInput>;
  text?: InputMaybe<FilterFindManyIssueQueryCommentsTextOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyIssueQueryCommentsUpdatedAtOperatorsInput>;
};

export type FilterFindManyIssueQueryCommentsTextOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryCommentsUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryComments_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryContainmentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryContestantIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryCreatedByIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryDepartmentIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryDescriptionDetailsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyIssueQueryInput = {
  AND?: InputMaybe<Array<FilterFindManyIssueQueryInput>>;
  OR?: InputMaybe<Array<FilterFindManyIssueQueryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIssueQueryOperatorsInput>;
  acknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  acknowledgedByID?: InputMaybe<Scalars['MongoID']['input']>;
  area?: InputMaybe<Scalars['String']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledByID?: InputMaybe<Scalars['MongoID']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedByID?: InputMaybe<Scalars['MongoID']['input']>;
  comments?: InputMaybe<Array<InputMaybe<FilterFindManyCommentInput>>>;
  containment?: InputMaybe<Scalars['String']['input']>;
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdByID?: InputMaybe<Scalars['MongoID']['input']>;
  departmentID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDetails?: InputMaybe<Scalars['String']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  issueStatus?: InputMaybe<EnumIssueQueryIssueStatus>;
  linkedIssueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTagID?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTagLabelSort?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<EnumIssueQueryPriority>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  rootCause?: InputMaybe<Scalars['String']['input']>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  thirdPartyIssueID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyIssueQueryIssueStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumIssueQueryIssueStatus>;
  gte?: InputMaybe<EnumIssueQueryIssueStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumIssueQueryIssueStatus>>>;
  lt?: InputMaybe<EnumIssueQueryIssueStatus>;
  lte?: InputMaybe<EnumIssueQueryIssueStatus>;
  ne?: InputMaybe<EnumIssueQueryIssueStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumIssueQueryIssueStatus>>>;
};

export type FilterFindManyIssueQueryLinkedIssueIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIssueQueryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIssueQuery_IdOperatorsInput>;
  acknowledgedAt?: InputMaybe<FilterFindManyIssueQueryAcknowledgedAtOperatorsInput>;
  acknowledgedByID?: InputMaybe<FilterFindManyIssueQueryAcknowledgedByIdOperatorsInput>;
  area?: InputMaybe<FilterFindManyIssueQueryAreaOperatorsInput>;
  assigneeIDs?: InputMaybe<FilterFindManyIssueQueryAssigneeIDsOperatorsInput>;
  cancelledAt?: InputMaybe<FilterFindManyIssueQueryCancelledAtOperatorsInput>;
  cancelledByID?: InputMaybe<FilterFindManyIssueQueryCancelledByIdOperatorsInput>;
  carSetupID?: InputMaybe<FilterFindManyIssueQueryCarSetupIdOperatorsInput>;
  category?: InputMaybe<FilterFindManyIssueQueryCategoryOperatorsInput>;
  closedAt?: InputMaybe<FilterFindManyIssueQueryClosedAtOperatorsInput>;
  closedByID?: InputMaybe<FilterFindManyIssueQueryClosedByIdOperatorsInput>;
  comments?: InputMaybe<FilterFindManyIssueQueryCommentsOperatorsInput>;
  containment?: InputMaybe<FilterFindManyIssueQueryContainmentOperatorsInput>;
  contestantIDs?: InputMaybe<FilterFindManyIssueQueryContestantIDsOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyIssueQueryCreatedAtOperatorsInput>;
  createdByID?: InputMaybe<FilterFindManyIssueQueryCreatedByIdOperatorsInput>;
  departmentID?: InputMaybe<FilterFindManyIssueQueryDepartmentIdOperatorsInput>;
  description?: InputMaybe<FilterFindManyIssueQueryDescriptionOperatorsInput>;
  descriptionDetails?: InputMaybe<FilterFindManyIssueQueryDescriptionDetailsOperatorsInput>;
  eventID?: InputMaybe<FilterFindManyIssueQueryEventIdOperatorsInput>;
  index?: InputMaybe<FilterFindManyIssueQueryIndexOperatorsInput>;
  issueStatus?: InputMaybe<FilterFindManyIssueQueryIssueStatusOperatorsInput>;
  linkedIssueIDs?: InputMaybe<FilterFindManyIssueQueryLinkedIssueIDsOperatorsInput>;
  number?: InputMaybe<FilterFindManyIssueQueryNumberOperatorsInput>;
  partID?: InputMaybe<FilterFindManyIssueQueryPartIdOperatorsInput>;
  primaryTagID?: InputMaybe<FilterFindManyIssueQueryPrimaryTagIdOperatorsInput>;
  primaryTagLabelSort?: InputMaybe<FilterFindManyIssueQueryPrimaryTagLabelSortOperatorsInput>;
  priority?: InputMaybe<FilterFindManyIssueQueryPriorityOperatorsInput>;
  raceSeriesID?: InputMaybe<FilterFindManyIssueQueryRaceSeriesIdOperatorsInput>;
  rootCause?: InputMaybe<FilterFindManyIssueQueryRootCauseOperatorsInput>;
  runSheetID?: InputMaybe<FilterFindManyIssueQueryRunSheetIdOperatorsInput>;
  seasonID?: InputMaybe<FilterFindManyIssueQuerySeasonIdOperatorsInput>;
  sessionID?: InputMaybe<FilterFindManyIssueQuerySessionIdOperatorsInput>;
  subTaskIDs?: InputMaybe<FilterFindManyIssueQuerySubTaskIDsOperatorsInput>;
  tagIDs?: InputMaybe<FilterFindManyIssueQueryTagIDsOperatorsInput>;
  targetDate?: InputMaybe<FilterFindManyIssueQueryTargetDateOperatorsInput>;
  teamIDs?: InputMaybe<FilterFindManyIssueQueryTeamIDsOperatorsInput>;
  thirdPartyIssueID?: InputMaybe<FilterFindManyIssueQueryThirdPartyIssueIdOperatorsInput>;
  timeInfo?: InputMaybe<FilterFindManyIssueQueryTimeInfoOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyIssueQueryUpdatedAtOperatorsInput>;
};

export type FilterFindManyIssueQueryPartIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryPrimaryTagIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryPrimaryTagLabelSortOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryPriorityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumIssueQueryPriority>;
  gte?: InputMaybe<EnumIssueQueryPriority>;
  in?: InputMaybe<Array<InputMaybe<EnumIssueQueryPriority>>>;
  lt?: InputMaybe<EnumIssueQueryPriority>;
  lte?: InputMaybe<EnumIssueQueryPriority>;
  ne?: InputMaybe<EnumIssueQueryPriority>;
  nin?: InputMaybe<Array<InputMaybe<EnumIssueQueryPriority>>>;
};

export type FilterFindManyIssueQueryRaceSeriesIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryRootCauseOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQuerySeasonIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQuerySessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQuerySubTaskIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryTagIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryTargetDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryTeamIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryThirdPartyIssueIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryTimeInfoOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQuery_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyJobAssigneeIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyJobCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyJobDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyJobIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyJobInput = {
  AND?: InputMaybe<Array<FilterFindManyJobInput>>;
  OR?: InputMaybe<Array<FilterFindManyJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyJobOperatorsInput>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  /** The id of the parent job or issue that this task is assigned to */
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyJobNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyJobOperatorsInput = {
  _id?: InputMaybe<FilterFindManyJob_IdOperatorsInput>;
  assigneeIDs?: InputMaybe<FilterFindManyJobAssigneeIDsOperatorsInput>;
  category?: InputMaybe<FilterFindManyJobCategoryOperatorsInput>;
  description?: InputMaybe<FilterFindManyJobDescriptionOperatorsInput>;
  index?: InputMaybe<FilterFindManyJobIndexOperatorsInput>;
  number?: InputMaybe<FilterFindManyJobNumberOperatorsInput>;
  parentID?: InputMaybe<FilterFindManyJobParentIdOperatorsInput>;
  priority?: InputMaybe<FilterFindManyJobPriorityOperatorsInput>;
  runSheetID?: InputMaybe<FilterFindManyJobRunSheetIdOperatorsInput>;
};

export type FilterFindManyJobParentIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyJobPriorityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumJobPriority>;
  gte?: InputMaybe<EnumJobPriority>;
  in?: InputMaybe<Array<InputMaybe<EnumJobPriority>>>;
  lt?: InputMaybe<EnumJobPriority>;
  lte?: InputMaybe<EnumJobPriority>;
  ne?: InputMaybe<EnumJobPriority>;
  nin?: InputMaybe<Array<InputMaybe<EnumJobPriority>>>;
};

export type FilterFindManyJobRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyKinematicsExternalModelInput = {
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  uprightPosition?: InputMaybe<Scalars['Float']['input']>;
  uprightPositionName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLapColumnInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<EnumLapColumnField>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<FilterFindManyValueLimitInput>;
  upperLimit?: InputMaybe<FilterFindManyValueLimitInput>;
};

export type FilterFindManyLapDataInput = {
  /** Was DRS used in this lap? */
  BDRSUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this laptime slow and should be excluded from average calculation? */
  BLapIsSlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Received a Track Limit Warning from Race Control */
  BTrackLimitWarning?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cell temperature */
  TCell?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Coded message from driver */
  driverCallout?: InputMaybe<Scalars['String']['input']>;
  /** Coded message from driver */
  driverCallout2?: InputMaybe<Scalars['String']['input']>;
  /** Map of kpi fields to their values for analysis. Input syntax is array of tuples, like `kpi: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  kpi?: InputMaybe<Scalars['JSON']['input']>;
  lapType?: InputMaybe<Scalars['String']['input']>;
  /** Fuel mass consumption in this lap */
  mFuelConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel mass remaining at the end of this lap. */
  mFuelLapEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: InputMaybe<Scalars['Float']['input']>;
  /** Energy comsumption in this lap (kWh) */
  rEnergyConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Energy remaining (kWh)  at the end of this lap. */
  rEnergyLapEnd?: InputMaybe<Scalars['Float']['input']>;
  /** SoC comsumption in this lap (%) */
  rSOCConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** SOC (%) remaining at the end of this lap. */
  rSOCLapEnd?: InputMaybe<Scalars['Float']['input']>;
  raceControlMessage?: InputMaybe<Scalars['String']['input']>;
  /** Source of the lap data */
  source?: InputMaybe<EnumLapDataSource>;
  /** Time at which this lap was completed. */
  tDay?: InputMaybe<Scalars['Date']['input']>;
  /** If this is an IN lap, indicates when the driver crossed the pit entry line. */
  tDayPitIn?: InputMaybe<Scalars['Date']['input']>;
  /** If this is an OUT lap, indicates when the driver crossed the pit exit line. */
  tDayPitOut?: InputMaybe<Scalars['Date']['input']>;
  /** Time of day of each sector. */
  tDaySectors?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** Time spent in pits if the lap started from the pit lane. */
  tInPit?: InputMaybe<Scalars['Float']['input']>;
  /** Laptime */
  tLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Sectore times. */
  tSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tSessionRemainingLapStart?: InputMaybe<Scalars['Float']['input']>;
  trackStates?: InputMaybe<Array<InputMaybe<FilterFindManyTrackStateInput>>>;
  /** Tyre compound information */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
  /** Official topspeed measurement */
  vCarLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Official speed measurements per sector */
  vCarSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** Lap flag field labels mapped to their display names. Null or unset fields are not displayed. */
export type FilterFindManyLapFlagLabelsInput = {
  ATTACK?: InputMaybe<Scalars['String']['input']>;
  COOL?: InputMaybe<Scalars['String']['input']>;
  FCY?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Scalars['String']['input']>;
  OUT?: InputMaybe<Scalars['String']['input']>;
  OUTIN?: InputMaybe<Scalars['String']['input']>;
  PITLANE?: InputMaybe<Scalars['String']['input']>;
  PREP?: InputMaybe<Scalars['String']['input']>;
  PUSH?: InputMaybe<Scalars['String']['input']>;
  QUALI?: InputMaybe<Scalars['String']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['String']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['String']['input']>;
  SLOW?: InputMaybe<Scalars['String']['input']>;
  TARGET?: InputMaybe<Scalars['String']['input']>;
  TOGRID?: InputMaybe<Scalars['String']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['String']['input']>;
  TOPITS?: InputMaybe<Scalars['String']['input']>;
  UNFINISHED?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLapInput = {
  /** Was DRS used in this lap? */
  BDRSUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this laptime slow? */
  BLapIsSlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this an IN lap? */
  BPitIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this an OUT lap? */
  BPitOut?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lap number in run from timing */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in run from car data */
  NLapRunCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in run from manual mode */
  NLapRunManual?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in session from timing */
  NLapSession?: InputMaybe<Scalars['Int']['input']>;
  /** Lap number in session from car data */
  NLapSessionCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in session from manual mode */
  NLapSessionManual?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from timing */
  NLapStint?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from car data */
  NLapStintCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from manual mode */
  NLapStintManual?: InputMaybe<Scalars['Float']['input']>;
  /** Cell temperature */
  TCell?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Array<InputMaybe<FilterFindManyLapDataInput>>>;
  /** Amount of energy (fuel/battery) at the start of this lap. */
  energyLapStart?: InputMaybe<Scalars['Float']['input']>;
  /** Energy or fuel remaining */
  energyRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** Energy or fuel remaining as data input (e.g. from telemetry) */
  energyRemainingData?: InputMaybe<Scalars['Float']['input']>;
  fuelConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Comments made by the driver */
  lapComment?: InputMaybe<Scalars['String']['input']>;
  /** Systems info generated during the lap */
  lapCommentSystems?: InputMaybe<Scalars['String']['input']>;
  /** Map of lap KPI fields to their values for car-data-related analysis. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  lapKPI?: InputMaybe<Scalars['JSON']['input']>;
  lapType?: InputMaybe<Scalars['String']['input']>;
  laptimeServiceHash?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: InputMaybe<Scalars['Float']['input']>;
  rEnergyConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  rSOCConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  raceControlMessage?: InputMaybe<Scalars['String']['input']>;
  /** The run sheet this lap belongs to. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time at which this lap was completed. */
  tDay?: InputMaybe<Scalars['Date']['input']>;
  /** Time of day of each sector, provided by a timing service. */
  tDaySectors?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** Laptime where input directly by a user. */
  tLapManual?: InputMaybe<Scalars['Float']['input']>;
  /** Laptime */
  tLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Sectore times given manually by a user. */
  tSectorsManual?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Sector times as given by an alternative official source. */
  tSectorsOfficial?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Sector times as given by a timing service. */
  tSectorsTiming?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Map of timing KPI fields to their values for timing-related analysis. Input syntax is array of tuples, like `timingKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  timingKPI?: InputMaybe<Scalars['JSON']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  trackStates?: InputMaybe<Array<InputMaybe<FilterFindManyTrackStateInput>>>;
  /** Tyre compound information from timing stream */
  tyreCompoundTiming?: InputMaybe<Scalars['String']['input']>;
  /** Official topspeed measurement */
  vCarLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Official speed measurements per sector */
  vCarSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyLapSequenceInput = {
  AND?: InputMaybe<Array<FilterFindManyLapSequenceInput>>;
  OR?: InputMaybe<Array<FilterFindManyLapSequenceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLapSequenceOperatorsInput>;
  laps?: InputMaybe<Array<InputMaybe<FilterFindManyLapSequenceLapsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyLapSequenceLapsInput = {
  NLap?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lapType?: InputMaybe<EnumLapSequenceLapsLapType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLapSequenceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLapSequence_IdOperatorsInput>;
};

export type FilterFindManyLapSequenceTemplateInput = {
  AND?: InputMaybe<Array<FilterFindManyLapSequenceTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindManyLapSequenceTemplateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLapSequenceTemplateOperatorsInput>;
  laps?: InputMaybe<Array<InputMaybe<FilterFindManyLapSequenceTemplateLapsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyLapSequenceTemplateLapsInput = {
  /** Lap number in sequence */
  NLap?: InputMaybe<Scalars['Float']['input']>;
  lapType?: InputMaybe<EnumLapSequenceTemplateLapsLapType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLapSequenceTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLapSequenceTemplate_IdOperatorsInput>;
};

export type FilterFindManyLapSequenceTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLapSequence_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** Collection of tuples defining bounds to automatically classify laps. Does not apply to in/out/race control lap types. Comparisons are to be made with `<` or `>=` at aligning bounds. Minimum value is 0 and maximum value is 1000000. */
export type FilterFindManyLaptimeThresholdsInput = {
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as cool. */
  cool?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as prep. */
  prep?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as push. */
  push?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as slow. */
  slow?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as target. */
  target?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FilterFindManyLayoutConsumptionInput = {
  SoCRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  energyRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  fuelRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyLengthInput = {
  /** cm */
  centimetres?: InputMaybe<Scalars['Float']['input']>;
  /** ft */
  feet?: InputMaybe<Scalars['Float']['input']>;
  /** in */
  inches?: InputMaybe<Scalars['Float']['input']>;
  /** km */
  kilometres?: InputMaybe<Scalars['Float']['input']>;
  /** m */
  metres?: InputMaybe<Scalars['Float']['input']>;
  /** μm */
  micrometres?: InputMaybe<Scalars['Float']['input']>;
  /** mi */
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** mm */
  millimetres?: InputMaybe<Scalars['Float']['input']>;
  /** thou */
  thou?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyLiveStandingInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  currentLocation?: InputMaybe<EnumLiveStandingCurrentLocation>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  fastestLap?: InputMaybe<FilterFindManyBestValuesFastestLapInput>;
  fastestSectors?: InputMaybe<Array<InputMaybe<FilterFindManyBestValuesFastestSectorInput>>>;
  /** Does this driver have the fastest lap in the session? Only one driver should have this true at a time. */
  hasFastestLap?: InputMaybe<Scalars['Boolean']['input']>;
  lapsCompleted?: InputMaybe<Scalars['Int']['input']>;
  /** 1-indexed rank of this driver with respect to the rest of the grid */
  position?: InputMaybe<Scalars['Int']['input']>;
  postRacePenalty?: InputMaybe<FilterFindManyLiveStandingPostRacePenaltyInput>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLiveStandingPostRacePenaltyInput = {
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  totalTimePenalty?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyLocalConnectionInput = {
  dataMapping?: InputMaybe<EnumLocalConnectionDataMapping>;
  endPoint?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  outputFolder?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Float']['input']>;
  useSSL?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyLocationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<FilterFindManyGeoLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLogInput = {
  AND?: InputMaybe<Array<FilterFindManyLogInput>>;
  OR?: InputMaybe<Array<FilterFindManyLogInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLogOperatorsInput>;
  logLevel?: InputMaybe<EnumLogLogLevel>;
  /** A single log from the source service */
  message?: InputMaybe<Scalars['String']['input']>;
  serviceSource?: InputMaybe<EnumLogServiceSource>;
  userID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyLogLogLevelOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumLogLogLevel>;
  gte?: InputMaybe<EnumLogLogLevel>;
  in?: InputMaybe<Array<InputMaybe<EnumLogLogLevel>>>;
  lt?: InputMaybe<EnumLogLogLevel>;
  lte?: InputMaybe<EnumLogLogLevel>;
  ne?: InputMaybe<EnumLogLogLevel>;
  nin?: InputMaybe<Array<InputMaybe<EnumLogLogLevel>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLogOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLog_IdOperatorsInput>;
  logLevel?: InputMaybe<FilterFindManyLogLogLevelOperatorsInput>;
  serviceSource?: InputMaybe<FilterFindManyLogServiceSourceOperatorsInput>;
  userID?: InputMaybe<FilterFindManyLogUserIdOperatorsInput>;
};

export type FilterFindManyLogServiceSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumLogServiceSource>;
  gte?: InputMaybe<EnumLogServiceSource>;
  in?: InputMaybe<Array<InputMaybe<EnumLogServiceSource>>>;
  lt?: InputMaybe<EnumLogServiceSource>;
  lte?: InputMaybe<EnumLogServiceSource>;
  ne?: InputMaybe<EnumLogServiceSource>;
  nin?: InputMaybe<Array<InputMaybe<EnumLogServiceSource>>>;
};

export type FilterFindManyLogUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyManufacturerInput = {
  AND?: InputMaybe<Array<FilterFindManyManufacturerInput>>;
  OR?: InputMaybe<Array<FilterFindManyManufacturerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyManufacturerOperatorsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyManufacturerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyManufacturerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyManufacturer_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyManufacturerNameOperatorsInput>;
};

export type FilterFindManyManufacturer_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMassInput = {
  /** g */
  grams?: InputMaybe<Scalars['Float']['input']>;
  /** kg */
  kilograms?: InputMaybe<Scalars['Float']['input']>;
  /** mg */
  milligrams?: InputMaybe<Scalars['Float']['input']>;
  /** oz */
  ounces?: InputMaybe<Scalars['Float']['input']>;
  /** lb */
  pounds?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyMassPropertiesInput = {
  COGx?: InputMaybe<Scalars['Float']['input']>;
  COGy?: InputMaybe<Scalars['Float']['input']>;
  COGz?: InputMaybe<Scalars['Float']['input']>;
  Ixx?: InputMaybe<Scalars['Float']['input']>;
  Iyy?: InputMaybe<Scalars['Float']['input']>;
  Izz?: InputMaybe<Scalars['Float']['input']>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  /** Allowable mass range, for when a set mass value doesn't apply */
  massRange?: InputMaybe<AdjustableMassInput>;
};

export type FilterFindManyMomentOfInertiaInput = {
  /** kgm² */
  kilogramMetresSquared?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/s² */
  poundForceFeetSecondSquared?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyNotificationConfigInput = {
  faultAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  faultCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  faultStatusChanged?: InputMaybe<Scalars['Boolean']['input']>;
  jobAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  jobCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  jobStatusChanged?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyOneTimingWeatherServiceConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyOneTimingWeatherServiceConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyOneTimingWeatherServiceConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOneTimingWeatherServiceConfigOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event IDs to which the weather data should be published. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Weather station's latitude from geolocation */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  logLevel?: InputMaybe<EnumOneTimingWeatherServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weather station's longitude from geolocation */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Name for this set of configuration settings. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** One Timing server port. */
  timingPort?: InputMaybe<Scalars['Int']['input']>;
  /** One Timing server address. */
  timingURL?: InputMaybe<Scalars['String']['input']>;
  /** Time interval in seconds between two API data updates. */
  updateInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyOneTimingWeatherServiceConfigNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOneTimingWeatherServiceConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOneTimingWeatherServiceConfig_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyOneTimingWeatherServiceConfigNameOperatorsInput>;
};

export type FilterFindManyOneTimingWeatherServiceConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPackageAuthorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPackageInput = {
  AND?: InputMaybe<Array<FilterFindManyPackageInput>>;
  OR?: InputMaybe<Array<FilterFindManyPackageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPackageOperatorsInput>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<FilterFindManyPackageItemsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  useAsCopyReference?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyPackageItemsInput = {
  /** 'setup.front.hRide' or 'spec.specID.adjustables.adjIndex.LOCATION' */
  path?: InputMaybe<Scalars['String']['input']>;
  /** string | number | null (also can 'delete' certain things from a setup) */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPackageOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPackage_IdOperatorsInput>;
  authorID?: InputMaybe<FilterFindManyPackageAuthorIdOperatorsInput>;
};

export type FilterFindManyPackage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPartEligibleEventTypesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumPartEligibleEventTypes>;
  gte?: InputMaybe<EnumPartEligibleEventTypes>;
  in?: InputMaybe<Array<InputMaybe<EnumPartEligibleEventTypes>>>;
  lt?: InputMaybe<EnumPartEligibleEventTypes>;
  lte?: InputMaybe<EnumPartEligibleEventTypes>;
  ne?: InputMaybe<EnumPartEligibleEventTypes>;
  nin?: InputMaybe<Array<InputMaybe<EnumPartEligibleEventTypes>>>;
};

export type FilterFindManyPartInput = {
  AND?: InputMaybe<Array<FilterFindManyPartInput>>;
  OR?: InputMaybe<Array<FilterFindManyPartInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPartOperatorsInput>;
  /** Can this very part be used multiple times on a car. For 'virtual parts' or other special applications. Overrides the setting of the specification. */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  eligibleEventTypes?: InputMaybe<EnumPartEligibleEventTypes>;
  /** To be used for dummy parts or at user discretion for special applications. */
  isVirtualPart?: InputMaybe<Scalars['Boolean']['input']>;
  lifetimeMileage?: InputMaybe<Scalars['Float']['input']>;
  locationID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerPartID?: InputMaybe<Scalars['String']['input']>;
  manufacturerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  partStatus?: InputMaybe<FilterFindManyPartStatusInput>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  readingLocationOverride?: InputMaybe<Array<InputMaybe<EnumPartReadingLocationOverride>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  rootAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementHistoryIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyPartInstanceInput = {
  AND?: InputMaybe<Array<FilterFindManyPartInstanceInput>>;
  OR?: InputMaybe<Array<FilterFindManyPartInstanceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPartInstanceOperatorsInput>;
  measurements?: InputMaybe<Array<InputMaybe<FilterFindManyPartInstanceMeasurementInput>>>;
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  readingLocation?: InputMaybe<EnumReadingLocation>;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemReferenceDate?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyPartInstanceMeasurementCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyPartInstanceMeasurementInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<FilterFindManyPartInstanceMeasurementCoordinatesInput>;
  floatValue?: InputMaybe<Scalars['Float']['input']>;
  idx?: InputMaybe<Scalars['Float']['input']>;
  rotation?: InputMaybe<FilterFindManyPartInstanceMeasurementRotationInput>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyPartInstanceMeasurementRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPartInstanceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPartInstance_IdOperatorsInput>;
  specificationID?: InputMaybe<FilterFindManyPartInstanceSpecificationIdOperatorsInput>;
};

export type FilterFindManyPartInstanceSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartInstance_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartLifetimeMileageOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyPartManufacturerPartIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPartManufacturerSerialNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPartOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPart_IdOperatorsInput>;
  description?: InputMaybe<FilterFindManyPartDescriptionOperatorsInput>;
  eligibleEventTypes?: InputMaybe<FilterFindManyPartEligibleEventTypesOperatorsInput>;
  lifetimeMileage?: InputMaybe<FilterFindManyPartLifetimeMileageOperatorsInput>;
  manufacturerPartID?: InputMaybe<FilterFindManyPartManufacturerPartIdOperatorsInput>;
  manufacturerSerialNumber?: InputMaybe<FilterFindManyPartManufacturerSerialNumberOperatorsInput>;
  partNumber?: InputMaybe<FilterFindManyPartPartNumberOperatorsInput>;
  reference?: InputMaybe<FilterFindManyPartReferenceOperatorsInput>;
  rootSpecificationID?: InputMaybe<FilterFindManyPartRootSpecificationIdOperatorsInput>;
  specificationID?: InputMaybe<FilterFindManyPartSpecificationIdOperatorsInput>;
  teamID?: InputMaybe<FilterFindManyPartTeamIdOperatorsInput>;
  teamIDs?: InputMaybe<FilterFindManyPartTeamIDsOperatorsInput>;
  userEnumPartTypeID?: InputMaybe<FilterFindManyPartUserEnumPartTypeIdOperatorsInput>;
};

export type FilterFindManyPartPartNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPartReferenceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPartRootSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartStatusInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  statusComment?: InputMaybe<Scalars['String']['input']>;
  userEnumPartStatusID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyPartTeamIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartTeamIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartUserEnumPartTypeIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPart_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPersonAcronymOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPersonBirthdayOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyPersonEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPersonInput = {
  AND?: InputMaybe<Array<FilterFindManyPersonInput>>;
  OR?: InputMaybe<Array<FilterFindManyPersonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPersonOperatorsInput>;
  /** 3-letter acronym for drivers */
  acronym?: InputMaybe<Scalars['String']['input']>;
  behaviour?: InputMaybe<FilterFindManyBehaviourConfigInput>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  canopyCredentials?: InputMaybe<FilterFindManyCanopyCredentialsInput>;
  carUpdateMethod?: InputMaybe<EnumPersonCarUpdateMethod>;
  /** IDs of contestants visible to this person when logged in. */
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultFlexLayoutConfigs?: InputMaybe<FilterFindManyDefaultFlexLayoutConfigsInput>;
  defaultRunSheetCompareStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStylePhoneID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultTyreReferenceTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** Default string for tyre set naming, where x=Chassis, i=Info, s=SetNumber, (c=Corner or a=Axle) */
  defaultTyreSetNameFormat?: InputMaybe<Scalars['String']['input']>;
  displayColor?: InputMaybe<Scalars['String']['input']>;
  dynoConfigID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of contestants editable to this person when logged in. */
  editableContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotificationConfig?: InputMaybe<FilterFindManyNotificationConfigInput>;
  /** IDs of events visible to this person when logged in. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this user be unable to see KPIs? */
  hideKPIs?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to track his working time? */
  isTimeTracker?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to see, update and approve working times for other users? */
  isTimeTrackerAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequenceTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  localConnections?: InputMaybe<Array<InputMaybe<FilterFindManyLocalConnectionInput>>>;
  mileageUnit?: InputMaybe<EnumPersonMileageUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  passportPicture?: InputMaybe<Scalars['String']['input']>;
  /** Collection of favourite plot page config IDs. */
  plotPageConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  privateMobile?: InputMaybe<Scalars['Float']['input']>;
  privatePhone?: InputMaybe<Scalars['Float']['input']>;
  role?: InputMaybe<EnumPersonRole>;
  /** Collection of favourite setup overview config IDs. */
  setupOverviewConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  timeTrackerApprovalByPersonID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Collection of personal setup IDs. */
  userSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userSimulationSettings?: InputMaybe<FilterFindManyUserSimulationSettingsInput>;
  username?: InputMaybe<Scalars['String']['input']>;
  viewConfig?: InputMaybe<FilterFindManyViewConfigInput>;
  /** IDs of contestants visible to this person when logged in. */
  visibleContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of events visible to this person when logged in. */
  visibleEventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of teams visible to this person when logged in. */
  visibleTeamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  workMobile?: InputMaybe<Scalars['Float']['input']>;
  workPhone?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyPersonIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyPersonNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPersonOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPerson_IdOperatorsInput>;
  acronym?: InputMaybe<FilterFindManyPersonAcronymOperatorsInput>;
  birthday?: InputMaybe<FilterFindManyPersonBirthdayOperatorsInput>;
  email?: InputMaybe<FilterFindManyPersonEmailOperatorsInput>;
  isActive?: InputMaybe<FilterFindManyPersonIsActiveOperatorsInput>;
  name?: InputMaybe<FilterFindManyPersonNameOperatorsInput>;
  role?: InputMaybe<FilterFindManyPersonRoleOperatorsInput>;
  teamID?: InputMaybe<FilterFindManyPersonTeamIdOperatorsInput>;
  timeTrackerApprovalByPersonID?: InputMaybe<FilterFindManyPersonTimeTrackerApprovalByPersonIdOperatorsInput>;
  username?: InputMaybe<FilterFindManyPersonUsernameOperatorsInput>;
};

export type FilterFindManyPersonRoleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumPersonRole>;
  gte?: InputMaybe<EnumPersonRole>;
  in?: InputMaybe<Array<InputMaybe<EnumPersonRole>>>;
  lt?: InputMaybe<EnumPersonRole>;
  lte?: InputMaybe<EnumPersonRole>;
  ne?: InputMaybe<EnumPersonRole>;
  nin?: InputMaybe<Array<InputMaybe<EnumPersonRole>>>;
};

export type FilterFindManyPersonTeamIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPersonTimeTrackerApprovalByPersonIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPersonUsernameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPerson_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPlotConfigInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  xAxisType?: InputMaybe<EnumPlotConfigXAxisType>;
  xDataSource?: InputMaybe<Scalars['String']['input']>;
  xLabel?: InputMaybe<Scalars['String']['input']>;
  /** Object containing at least `label`, and optionally `color`, `lineStyle` (from `EnumLineStyle`), and `marker` (from `EnumMarkerType`) properties */
  yData?: InputMaybe<Scalars['JSON']['input']>;
  yDataSource?: InputMaybe<Scalars['String']['input']>;
  yLabel?: InputMaybe<Scalars['String']['input']>;
  yLines?: InputMaybe<Array<InputMaybe<FilterFindManyPlotConfigLineInput>>>;
};

export type FilterFindManyPlotConfigLineInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<EnumLineStyle>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyPlotPageConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyPlotPageConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlotPageConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlotPageConfigOperatorsInput>;
  /** Number of columns in the grid. */
  gridCols?: InputMaybe<Scalars['Int']['input']>;
  /** Number of rows in the grid. */
  gridRows?: InputMaybe<Scalars['Int']['input']>;
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  plots?: InputMaybe<Array<InputMaybe<FilterFindManyPlotConfigInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlotPageConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlotPageConfig_IdOperatorsInput>;
  title?: InputMaybe<FilterFindManyPlotPageConfigTitleOperatorsInput>;
};

export type FilterFindManyPlotPageConfigTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPlotPageConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPointsSystemInput = {
  AND?: InputMaybe<Array<FilterFindManyPointsSystemInput>>;
  OR?: InputMaybe<Array<FilterFindManyPointsSystemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPointsSystemOperatorsInput>;
  /** Array of points for the fastest lap */
  laptimeDriverPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Race position cutoff for drivers eligible for points for the fastest lap. In some race series you need to be in the top 10 to get the bonus point. */
  laptimePositionCutoff?: InputMaybe<Scalars['Float']['input']>;
  /** Array of points for the fastest lap for the teams. In some race series only the driver receives points for fastest lap. */
  laptimeTeamPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** How much race distance needs to be completed to be eligible for points */
  positionalCompletionMin?: InputMaybe<Scalars['Float']['input']>;
  /** How much race distance in % needs to be completed to be eligible for points */
  positionalCompletionMinRatio?: InputMaybe<Scalars['Float']['input']>;
  /** Array of driver points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalDriverPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Array of team points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalTeamPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sessionType?: InputMaybe<EnumSessionType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPointsSystemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPointsSystem_IdOperatorsInput>;
};

export type FilterFindManyPointsSystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPowerInput = {
  /** 1hp = 745.6998715822702W */
  horsepowerMechanical?: InputMaybe<Scalars['Float']['input']>;
  /** kW */
  kilowatts?: InputMaybe<Scalars['Float']['input']>;
  /** W */
  watts?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyPowertrainInput = {
  MDiffPreloadCold?: InputMaybe<Scalars['Float']['input']>;
  MDiffPreloadHot?: InputMaybe<Scalars['Float']['input']>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are arbitrary numbers. Input syntax is array of key-value tuples, like `NEngineBlanking: [["left", 5], ["right", 9]]`. */
  NEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  NFrictionFaces?: InputMaybe<Scalars['Float']['input']>;
  PPowerLevel?: InputMaybe<Scalars['Float']['input']>;
  aDiffRampCoast?: InputMaybe<Scalars['Float']['input']>;
  aDiffRampDrive?: InputMaybe<Scalars['Float']['input']>;
  bevelSet?: InputMaybe<PowertrainGearInput>;
  /** Map of blanking fields with values. Keys are strings like `gearboxRadiatorTapes` or `hRESSBlanking`, and values are strings describing the blanking details. Input syntax is array of key-value tuples, like `blanking: [["gearboxRadiatorTapes", "5"]]`. */
  blanking?: InputMaybe<Scalars['JSON']['input']>;
  clutch?: InputMaybe<Scalars['String']['input']>;
  clutchCylinder?: InputMaybe<Scalars['String']['input']>;
  dAirRestrictor?: InputMaybe<Scalars['Float']['input']>;
  /** Name of the selected configuration from the spec. */
  differentialConfigName?: InputMaybe<Scalars['String']['input']>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  dropGear?: InputMaybe<PowertrainGearInput>;
  /** Map of extra engine blanking measurement fields to their values. Input syntax is array of key-value tuples, like `engineBlankingComments: [["louvres", "NONE"], ["other", true]]`. */
  engineBlankingDetails?: InputMaybe<Scalars['JSON']['input']>;
  frictionFaces?: InputMaybe<Scalars['String']['input']>;
  gearboxGridType?: InputMaybe<Scalars['String']['input']>;
  gears?: InputMaybe<Array<InputMaybe<PowertrainStandardGearInput>>>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hEngineBlanking: [["left", 0.003], ["right", 0.004]]`. */
  hEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hGearboxBlanking: [["left", 0.003], ["right", 0.004]]`. */
  hGearboxBlanking?: InputMaybe<Scalars['JSON']['input']>;
  rBevelSet?: InputMaybe<Scalars['Float']['input']>;
  rDropGear?: InputMaybe<Scalars['Float']['input']>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rEngineBlanking: [["left", 0.05], ["right", 0.06]]`. */
  rEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gears to their ratios. Keys are strings like `"1"` or `"R"`, and values are ratios. Input syntax is array of key-value tuples, like `rGearRatios: [["R", 0.8], ["1", 0.3]]`. */
  rGearRatios?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rGearboxBlanking: [["left", 0.05], ["right", 0.06]]`. */
  rGearboxBlanking?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyPressureInput = {
  /** bar */
  bar?: InputMaybe<Scalars['Float']['input']>;
  /** inHg */
  inchesOfMercury?: InputMaybe<Scalars['Float']['input']>;
  /** kPa */
  kilopascals?: InputMaybe<Scalars['Float']['input']>;
  /** mbar */
  millibar?: InputMaybe<Scalars['Float']['input']>;
  /** Pa */
  pascals?: InputMaybe<Scalars['Float']['input']>;
  /** psi */
  psi?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProjectInput = {
  AND?: InputMaybe<Array<FilterFindManyProjectInput>>;
  OR?: InputMaybe<Array<FilterFindManyProjectInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProjectOperatorsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProjectOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProject_IdOperatorsInput>;
};

export type FilterFindManyProject_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyQualityCheckActionAssigneeIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyQualityCheckActionCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyQualityCheckActionDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyQualityCheckActionInput = {
  AND?: InputMaybe<Array<FilterFindManyQualityCheckActionInput>>;
  OR?: InputMaybe<Array<FilterFindManyQualityCheckActionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyQualityCheckActionOperatorsInput>;
  acknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  acknowledgedByID?: InputMaybe<Scalars['MongoID']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledByID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedByID?: InputMaybe<Scalars['MongoID']['input']>;
  comments?: InputMaybe<Array<InputMaybe<FilterFindManyCommentInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdByID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<EnumQualityCheckActionPriority>;
  status?: InputMaybe<EnumQualityCheckActionStatus>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyQualityCheckActionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyQualityCheckAction_IdOperatorsInput>;
  assigneeIDs?: InputMaybe<FilterFindManyQualityCheckActionAssigneeIDsOperatorsInput>;
  category?: InputMaybe<FilterFindManyQualityCheckActionCategoryOperatorsInput>;
  description?: InputMaybe<FilterFindManyQualityCheckActionDescriptionOperatorsInput>;
  priority?: InputMaybe<FilterFindManyQualityCheckActionPriorityOperatorsInput>;
};

export type FilterFindManyQualityCheckActionPriorityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumQualityCheckActionPriority>;
  gte?: InputMaybe<EnumQualityCheckActionPriority>;
  in?: InputMaybe<Array<InputMaybe<EnumQualityCheckActionPriority>>>;
  lt?: InputMaybe<EnumQualityCheckActionPriority>;
  lte?: InputMaybe<EnumQualityCheckActionPriority>;
  ne?: InputMaybe<EnumQualityCheckActionPriority>;
  nin?: InputMaybe<Array<InputMaybe<EnumQualityCheckActionPriority>>>;
};

export type FilterFindManyQualityCheckAction_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyQualityCheckInput = {
  AND?: InputMaybe<Array<FilterFindManyQualityCheckInput>>;
  OR?: InputMaybe<Array<FilterFindManyQualityCheckInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyQualityCheckOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  qualityCheckActionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyQualityCheckOperatorsInput = {
  _id?: InputMaybe<FilterFindManyQualityCheck_IdOperatorsInput>;
};

export type FilterFindManyQualityCheck_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRaceSeriesInput = {
  AND?: InputMaybe<Array<FilterFindManyRaceSeriesInput>>;
  OR?: InputMaybe<Array<FilterFindManyRaceSeriesInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRaceSeriesOperatorsInput>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultJobListIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  driversPerCar?: InputMaybe<EnumRaceSeriesDriversPerCar>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  lapTypeConfig?: InputMaybe<FilterFindManyRaceSeriesLapTypeConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  seasonIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  sortingIndex?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRaceSeriesLapTypeConfigInput = {
  ATTACK?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  COOL?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  FCY?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  IN?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  OUT?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  OUTIN?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  PITLANE?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  PREP?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  PUSH?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  QUALI?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  SAFETYCAR?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  SHAKEDOWN?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  SLOW?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  TARGET?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  TOGRID?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  TOPADDOCK?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  TOPITS?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  UNFINISHED?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
};

export type FilterFindManyRaceSeriesLapTypeEntryInput = {
  displayString: Scalars['String']['input'];
  lapTypeColor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type FilterFindManyRaceSeriesNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRaceSeriesOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRaceSeries_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyRaceSeriesNameOperatorsInput>;
};

export type FilterFindManyRaceSeries_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRadioMessageContestantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRadioMessageDriverIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRadioMessageInput = {
  AND?: InputMaybe<Array<FilterFindManyRadioMessageInput>>;
  OR?: InputMaybe<Array<FilterFindManyRadioMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRadioMessageOperatorsInput>;
  /** Time at which the audio message arrived in the queue for transcribing. */
  arrivedInQueueAt?: InputMaybe<Scalars['Date']['input']>;
  /** This is currently a path to a file on the Transcribble server, but it should eventually be a URL to a file in something like an S3 bucket instead. */
  audioPath?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  /** Length of the audio message in seconds. */
  length?: InputMaybe<Scalars['Float']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time at which the audio message was taken by a transcription service. */
  takenByTranscriberAt?: InputMaybe<Scalars['Date']['input']>;
  /** The text of the message, as transcribed by Transcribble. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Time at which this message began recording audio. */
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  /** Time at which the audio message was finished initial transcribing. */
  transcribedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRadioMessageOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRadioMessage_IdOperatorsInput>;
  contestantID?: InputMaybe<FilterFindManyRadioMessageContestantIdOperatorsInput>;
  driverID?: InputMaybe<FilterFindManyRadioMessageDriverIdOperatorsInput>;
  sessionID?: InputMaybe<FilterFindManyRadioMessageSessionIdOperatorsInput>;
};

export type FilterFindManyRadioMessageSessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRadioMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRatioInput = {
  /** % */
  percent?: InputMaybe<Scalars['Float']['input']>;
  /** 0 = 0%, 1 = 100%, 1.5 = 150% */
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyRegulationSetInput = {
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  hRideFrontMin?: InputMaybe<Scalars['Float']['input']>;
  hRideRearMin?: InputMaybe<Scalars['Float']['input']>;
  massDistRunningMax?: InputMaybe<Scalars['Float']['input']>;
  massDistRunningMin?: InputMaybe<Scalars['Float']['input']>;
  massDistStaticMax?: InputMaybe<Scalars['Float']['input']>;
  massDistStaticMin?: InputMaybe<Scalars['Float']['input']>;
  massMin?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportNotesTemplateInput = {
  AND?: InputMaybe<Array<FilterFindManyReportNotesTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindManyReportNotesTemplateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyReportNotesTemplateOperatorsInput>;
  pageAppendix?: InputMaybe<FilterFindManyReportNotesTemplatePageAppendixInput>;
  pageOverview?: InputMaybe<FilterFindManyReportNotesTemplatePageOverviewInput>;
  pageParts?: InputMaybe<FilterFindManyReportNotesTemplatePagePartsInput>;
  pageRunPlan?: InputMaybe<FilterFindManyReportNotesTemplatePageRunPlanInput>;
  pageSession?: InputMaybe<FilterFindManyReportNotesTemplatePageSessionInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyReportNotesTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyReportNotesTemplate_IdOperatorsInput>;
  title?: InputMaybe<FilterFindManyReportNotesTemplateTitleOperatorsInput>;
};

export type FilterFindManyReportNotesTemplatePageAppendixInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindManyReportNotesTemplatePageAppendixNotesInput>>>;
};

export type FilterFindManyReportNotesTemplatePageAppendixNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageAppendixNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportNotesTemplatePageOverviewInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindManyReportNotesTemplatePageOverviewNotesInput>>>;
};

export type FilterFindManyReportNotesTemplatePageOverviewNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageOverviewNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportNotesTemplatePagePartsInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindManyReportNotesTemplatePagePartsNotesInput>>>;
};

export type FilterFindManyReportNotesTemplatePagePartsNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePagePartsNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportNotesTemplatePageRunPlanInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindManyReportNotesTemplatePageRunPlanNotesInput>>>;
};

export type FilterFindManyReportNotesTemplatePageRunPlanNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageRunPlanNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportNotesTemplatePageSessionInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindManyReportNotesTemplatePageSessionNotesInput>>>;
};

export type FilterFindManyReportNotesTemplatePageSessionNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageSessionNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportNotesTemplateTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyReportNotesTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyReportTemplateAppendixInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyReportTemplateBopInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bopFileOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  layout?: InputMaybe<Scalars['JSON']['input']>;
  /** Either { source: 'current-event' } or { source: 'explicit', sessionIds: string[] } */
  selectedSessions?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyReportTemplateCarSetupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyReportTemplateExcludedNoteIDsInput = {
  pageAppendix?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageOverview?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageParts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageRunPlan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageSession?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyReportTemplateInput = {
  AND?: InputMaybe<Array<FilterFindManyReportTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindManyReportTemplateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyReportTemplateOperatorsInput>;
  appendix?: InputMaybe<FilterFindManyReportTemplateAppendixInput>;
  bop?: InputMaybe<FilterFindManyReportTemplateBopInput>;
  carSetup?: InputMaybe<FilterFindManyReportTemplateCarSetupInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** File format based off a filename pattern, e.g. {raceSeries} {season} {event} */
  downloadFilenameFormat?: InputMaybe<Scalars['String']['input']>;
  excludedNoteIDs?: InputMaybe<FilterFindManyReportTemplateExcludedNoteIDsInput>;
  issues?: InputMaybe<FilterFindManyReportTemplateIssuesInput>;
  kpi?: InputMaybe<FilterFindManyReportTemplateKpiInput>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overview?: InputMaybe<FilterFindManyReportTemplateOverviewInput>;
  parts?: InputMaybe<FilterFindManyReportTemplatePartsInput>;
  reportTitle?: InputMaybe<Scalars['String']['input']>;
  runInfo?: InputMaybe<FilterFindManyReportTemplateRunInfoInput>;
  runPlan?: InputMaybe<FilterFindManyReportTemplateRunPlanInput>;
  sessions?: InputMaybe<FilterFindManyReportTemplateSessionsInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  weather?: InputMaybe<FilterFindManyReportTemplateWeatherInput>;
};

export type FilterFindManyReportTemplateIssuesColumnsInput = {
  field?: InputMaybe<EnumReportTemplateIssuesColumnsField>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportTemplateIssuesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<FilterFindManyReportTemplateIssuesColumnsInput>>>;
  groupBy?: InputMaybe<EnumReportTemplateIssuesGroupBy>;
};

export type FilterFindManyReportTemplateKpiInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  layout?: InputMaybe<Scalars['JSON']['input']>;
  showSessionLines?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyReportTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyReportTemplate_IdOperatorsInput>;
};

export type FilterFindManyReportTemplateOverviewInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  showFuelConsumption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyReportTemplatePartsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  groupPartsByChassisAssemblyName?: InputMaybe<Scalars['Boolean']['input']>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  tableColumns?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type FilterFindManyReportTemplateRunInfoColumnsInput = {
  field?: InputMaybe<EnumReportTemplateRunInfoColumnsField>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportTemplateRunInfoInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<FilterFindManyReportTemplateRunInfoColumnsInput>>>;
};

export type FilterFindManyReportTemplateRunPlanInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyReportTemplateSessionsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  displayedTimeZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  showTimingOverview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyReportTemplateWeatherInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  splitDataByDays?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyReportTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunBrakeInput = {
  /** Brake temperature after the run */
  TBrakePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Brake temperature before the run */
  TBrakePreRun?: InputMaybe<Scalars['Float']['input']>;
  hBrakeDiscPreRun?: InputMaybe<Scalars['Float']['input']>;
  /** Format is `Record<string, number>`, e.g. `{ "1FL": 1.2, "2": 1.3 }` */
  thicknessMeasurements?: InputMaybe<Scalars['JSON']['input']>;
};

/** Run energy field labels mapped to their display names. Null or unset fields are not displayed. */
export type FilterFindManyRunEnergyFieldLabelsInput = {
  ATTACK?: InputMaybe<Scalars['String']['input']>;
  COOL?: InputMaybe<Scalars['String']['input']>;
  FCY?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Scalars['String']['input']>;
  OUT?: InputMaybe<Scalars['String']['input']>;
  OUTIN?: InputMaybe<Scalars['String']['input']>;
  PITLANE?: InputMaybe<Scalars['String']['input']>;
  PREP?: InputMaybe<Scalars['String']['input']>;
  PUSH?: InputMaybe<Scalars['String']['input']>;
  QUALI?: InputMaybe<Scalars['String']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['String']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['String']['input']>;
  SLOW?: InputMaybe<Scalars['String']['input']>;
  TARGET?: InputMaybe<Scalars['String']['input']>;
  TOGRID?: InputMaybe<Scalars['String']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['String']['input']>;
  TOPITS?: InputMaybe<Scalars['String']['input']>;
  UNFINISHED?: InputMaybe<Scalars['String']['input']>;
  attackLap?: InputMaybe<Scalars['String']['input']>;
  coolLap?: InputMaybe<Scalars['String']['input']>;
  fullCourseYellowLap?: InputMaybe<Scalars['String']['input']>;
  inLap?: InputMaybe<Scalars['String']['input']>;
  outInLap?: InputMaybe<Scalars['String']['input']>;
  outLap?: InputMaybe<Scalars['String']['input']>;
  pitlaneLap?: InputMaybe<Scalars['String']['input']>;
  prepLap?: InputMaybe<Scalars['String']['input']>;
  pushLap?: InputMaybe<Scalars['String']['input']>;
  qualiLap?: InputMaybe<Scalars['String']['input']>;
  safetyCarLap?: InputMaybe<Scalars['String']['input']>;
  shakedownLap?: InputMaybe<Scalars['String']['input']>;
  slowLap?: InputMaybe<Scalars['String']['input']>;
  targetLap?: InputMaybe<Scalars['String']['input']>;
  toGridLap?: InputMaybe<Scalars['String']['input']>;
  toPitsLap?: InputMaybe<Scalars['String']['input']>;
  unfinishedLap?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyRunEnergyInput = {
  /** Fuel/Energy/SoC required for ATTACK Lap */
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for COOL Lap */
  COOL?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for FCY Lap */
  FCY?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for IN Lap */
  IN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for OUT Lap */
  OUT?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for OUTIN Lap */
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PITLANE Lap */
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PREP Lap */
  PREP?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PUSH Lap */
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for QUALI Lap */
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SAFETYCAR Lap */
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SHAKEDOWN Lap */
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SLOW Lap */
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TARGET Lap */
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOGRID Lap */
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOPADDOCK Lap */
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOPITS Lap */
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for UNFINISHED Lap */
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an attack mode lap */
  attackLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a cooldown lap */
  coolLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a full course yellow lap */
  fullCourseYellowLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an in lap */
  inLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an out-in lap */
  outInLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an out lap */
  outLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a pitlane lap */
  pitlaneLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a preparation/warmup lap */
  prepLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a push lap */
  pushLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a qualifying lap */
  qualiLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a safety car lap */
  safetyCarLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a shakedown lap */
  shakedownLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a slow lap */
  slowLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an target lap */
  targetLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a to-grid lap */
  toGridLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a to-pits lap */
  toPitsLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an unfinished lap */
  unfinishedLap?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyRunKpiTableRowFieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<FilterFindManyValueLimitInput>;
  unit?: InputMaybe<EnumDisplayUnit>;
  upperLimit?: InputMaybe<FilterFindManyValueLimitInput>;
};

export type FilterFindManyRunKpiTableRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell, an array of two numbers for a double cell, and so on. */
  gain?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Field names to try pull data from in `runKPI`, like `"vMax"`. Use an array of one key for a single cell, an array of two keys for a double cell, and so on. */
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<FilterFindManyValueLimitInput>;
  /** Text to put as a unit for values. */
  unit?: InputMaybe<Scalars['String']['input']>;
  upperLimit?: InputMaybe<FilterFindManyValueLimitInput>;
};

export type FilterFindManyRunLapTimeInput = {
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  COOL?: InputMaybe<Scalars['Float']['input']>;
  FCY?: InputMaybe<Scalars['Float']['input']>;
  IN?: InputMaybe<Scalars['Float']['input']>;
  OUT?: InputMaybe<Scalars['Float']['input']>;
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  PREP?: InputMaybe<Scalars['Float']['input']>;
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyRunPlanContestantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunPlanInput = {
  AND?: InputMaybe<Array<FilterFindManyRunPlanInput>>;
  OR?: InputMaybe<Array<FilterFindManyRunPlanInput>>;
  PUEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRunPlanOperatorsInput>;
  /** Amount of time in seconds to increment SOC by 1% at each rSOC value. Must have same length as `chargeTimeSOCValues`. */
  chargeTimeSOCIncrements?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** rSOC values to associate with each time charge time increment. Must have same length as `chargeTimeSOCIncrements` */
  chargeTimeSOCValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  fuelRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  /** Full tank fuel load */
  mFuelFullTank?: InputMaybe<Scalars['Float']['input']>;
  performanceEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  raceEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  runs?: InputMaybe<Array<InputMaybe<FilterFindManyRunPlanRunInput>>>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  systemEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tLapExpected?: InputMaybe<FilterFindManyRunLapTimeInput>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Short comment like dry run plan / wet run plan. */
  title?: InputMaybe<Scalars['String']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRunPlanOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRunPlan_IdOperatorsInput>;
  contestantID?: InputMaybe<FilterFindManyRunPlanContestantIdOperatorsInput>;
  sessionID?: InputMaybe<FilterFindManyRunPlanSessionIdOperatorsInput>;
};

export type FilterFindManyRunPlanRunActionItemsPreRunInput = {
  _id: Scalars['MongoID']['input'];
  name: Scalars['String']['input'];
};

export type FilterFindManyRunPlanRunInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  actionItemsPostRun?: InputMaybe<Array<InputMaybe<FilterFindManyRunPlanRunActionItemsPreRunInput>>>;
  actionItemsPreRun?: InputMaybe<Array<InputMaybe<FilterFindManyRunPlanRunActionItemsPreRunInput>>>;
  /** Background color for the run in run plan view. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** e.g. Baseline Run, Option A, … */
  description?: InputMaybe<Scalars['String']['input']>;
  /** True if fuel was drained before the run. */
  fuelDrainedBeforeRun?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequence?: InputMaybe<Array<InputMaybe<FilterFindManyLapSequenceLapsInput>>>;
  /** Amount of fuel to be refilled at the end of this run. */
  mFuelRefuel?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<EnumRunPlanRunPriority>;
  /** Things you need to remember to tell the driver. */
  reminder?: InputMaybe<Scalars['String']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  selectedDriverID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Setup changes anticipated. */
  setupChanges?: InputMaybe<Scalars['String']['input']>;
  /** Amount of time for refuelling at the end of this run. */
  tFuelRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Time to wait before starting the run. */
  tWaitBeforeRun?: InputMaybe<Scalars['Float']['input']>;
  tyreFLID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreFRID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreRLID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreRRID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyRunPlanSessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunPlan_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetContestantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetDriverIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetEndTimeCdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyRunSheetEndTimeLtsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyRunSheetEndTimeManualOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyRunSheetEngineerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetInput = {
  AND?: InputMaybe<Array<FilterFindManyRunSheetInput>>;
  /** Fuel density, if working in volume (overrides `DFuel` from event) */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Run number */
  NRun?: InputMaybe<Scalars['Float']['input']>;
  /** Run number for timing services */
  NRunTiming?: InputMaybe<Scalars['Float']['input']>;
  OR?: InputMaybe<Array<FilterFindManyRunSheetInput>>;
  SoCRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  TCellMaxRunStart?: InputMaybe<Scalars['Float']['input']>;
  /** Volume of fuel added at the start of the run. This field will not be automatically calculated by the API, so should be set along with `tRefuel` and `qRefuel` as their product. */
  VFuelAdded?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRunSheetOperatorsInput>;
  associatedKpiFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brakeComment?: InputMaybe<Scalars['String']['input']>;
  brakeFL?: InputMaybe<FilterFindManyRunBrakeInput>;
  brakeFR?: InputMaybe<FilterFindManyRunBrakeInput>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  brakeRL?: InputMaybe<FilterFindManyRunBrakeInput>;
  brakeRR?: InputMaybe<FilterFindManyRunBrakeInput>;
  /** Link to a cloud storage location where raw run data is kept. */
  cloudStorageURL?: InputMaybe<Scalars['String']['input']>;
  /** Fuel/SoC/Energy consumptions for each track layout in this run sheet. Acts as an override for the consumptions from the parent event. */
  consumptions?: InputMaybe<Array<InputMaybe<FilterFindManyLayoutConsumptionInput>>>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  controlsComment?: InputMaybe<Scalars['String']['input']>;
  dashboard?: InputMaybe<FilterFindManyDashboardInput>;
  dataServiceFileNameOverride?: InputMaybe<Scalars['String']['input']>;
  dilComments?: InputMaybe<Scalars['String']['input']>;
  driverComments?: InputMaybe<Scalars['String']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Car data service run end time */
  endTimeCDS?: InputMaybe<Scalars['Date']['input']>;
  /** Laptime service run end time */
  endTimeLTS?: InputMaybe<Scalars['Date']['input']>;
  /** Manual run end time (used to override calculation in case run was cut short but don't want to delete the drafted laps */
  endTimeManual?: InputMaybe<Scalars['Date']['input']>;
  energyRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  engineerComments?: InputMaybe<Scalars['String']['input']>;
  engineerID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time by which tyre heating schedule should be finished */
  finishTyreHeatingBy?: InputMaybe<Scalars['Date']['input']>;
  /** Used for fuel calculation. If true, mFuelAdded is treated as the total fuel at run start. */
  fuelDrainedBeforeRun?: InputMaybe<Scalars['Boolean']['input']>;
  fuelRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  historyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  info?: InputMaybe<Scalars['String']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isLockedByLaptimeService?: InputMaybe<Scalars['Boolean']['input']>;
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  jobIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Used to save the file name where the kpi data is retreived from */
  kpiFileName?: InputMaybe<Scalars['String']['input']>;
  kpiStatus?: InputMaybe<EnumRunSheetKpiStatus>;
  kpiUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** `addLap`, `forceAddLap`, `updateLap`, and `removeLap` mutations are preferred unless you want to completely replace the laps with new data. */
  laps?: InputMaybe<Array<InputMaybe<FilterFindManyLapInput>>>;
  laptimeThresholds?: InputMaybe<FilterFindManyLaptimeThresholdsInput>;
  /** Fuel added at the start of the run */
  mFuelAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel removed from the catch tank after the run */
  mFuelDrainedCatchTank?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel removed from the main tank after the run */
  mFuelDrainedMainTank?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel remaining at the end of the run */
  mFuelRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel used before run start i.e. for pre-run fireup */
  mFuelUsedPreRun?: InputMaybe<Scalars['Float']['input']>;
  nextRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  performanceComments?: InputMaybe<Scalars['String']['input']>;
  prevRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  problemComments?: InputMaybe<Scalars['String']['input']>;
  /** Flow rate when refuelling at the start of the run, in m³/s */
  qRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Energy charged to this value at the start of the run */
  rEnergyAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Energy level at the end of the run */
  rEnergyRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Battery charged to this value at the start of the run */
  rSOCAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Battery state of charge at the end of the run */
  rSOCRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Short comment of the objective of the run */
  runDescription?: InputMaybe<Scalars['String']['input']>;
  /** Map of run KPI fields to their values. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  runKPI?: InputMaybe<Scalars['JSON']['input']>;
  runSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Running time in seconds */
  runTime?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the job list template used for this run */
  selectedJobListTemplateID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  setupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of the simulation results associated with this run. */
  simResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  skidComment?: InputMaybe<Scalars['String']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidMeasurement: [["left", 5], ["marker1", 6]]`. */
  skidMeasurement?: InputMaybe<Scalars['JSON']['input']>;
  skidPlateID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPostRunMeasurements: [["left", 5], ["marker1", 6]]`. */
  skidPostRunMeasurements?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPreRunMeasurements: [["left", 5], ["marker1", 6]]`. */
  skidPreRunMeasurements?: InputMaybe<Scalars['JSON']['input']>;
  startTimeCDS?: InputMaybe<Scalars['Date']['input']>;
  startTimeLTS?: InputMaybe<Scalars['Date']['input']>;
  startTimeManual?: InputMaybe<Scalars['Date']['input']>;
  /** Time at which to start tyre heating schedule */
  startTyreHeatingAt?: InputMaybe<Scalars['Date']['input']>;
  summaryComments?: InputMaybe<Scalars['String']['input']>;
  systemsComments?: InputMaybe<Scalars['String']['input']>;
  /** Time spent refuelling at the start of the run */
  tRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Override for session time remaining (in seconds) */
  tSessionRemainingOverride?: InputMaybe<Scalars['Float']['input']>;
  /** Time spent in garage before run */
  tWaitBeforeRun?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of this run in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyRunID?: InputMaybe<Scalars['String']['input']>;
  /** Should the timing service pretend that this run sheet does not exist? */
  timingServiceShouldIgnore?: InputMaybe<Scalars['Boolean']['input']>;
  tyreComments?: InputMaybe<Scalars['String']['input']>;
  /** The tyre compound used, reported by the timing service. */
  tyreCompoundTiming?: InputMaybe<Scalars['String']['input']>;
  tyreFL?: InputMaybe<FilterFindManyRunTyreInput>;
  tyreFR?: InputMaybe<FilterFindManyRunTyreInput>;
  tyrePressureSettings?: InputMaybe<FilterFindManyTyrePressureSettingsInput>;
  tyreRL?: InputMaybe<FilterFindManyRunTyreInput>;
  tyreRR?: InputMaybe<FilterFindManyRunTyreInput>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
  weather?: InputMaybe<FilterFindManyWeatherDataInput>;
  writeHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyRunSheetNRunOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyRunSheetNRunTimingOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyRunSheetNextRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRunSheetOperatorsInput = {
  NRun?: InputMaybe<FilterFindManyRunSheetNRunOperatorsInput>;
  NRunTiming?: InputMaybe<FilterFindManyRunSheetNRunTimingOperatorsInput>;
  _id?: InputMaybe<FilterFindManyRunSheet_IdOperatorsInput>;
  contestantID?: InputMaybe<FilterFindManyRunSheetContestantIdOperatorsInput>;
  driverID?: InputMaybe<FilterFindManyRunSheetDriverIdOperatorsInput>;
  endTimeCDS?: InputMaybe<FilterFindManyRunSheetEndTimeCdsOperatorsInput>;
  endTimeLTS?: InputMaybe<FilterFindManyRunSheetEndTimeLtsOperatorsInput>;
  endTimeManual?: InputMaybe<FilterFindManyRunSheetEndTimeManualOperatorsInput>;
  engineerID?: InputMaybe<FilterFindManyRunSheetEngineerIdOperatorsInput>;
  nextRunSheetID?: InputMaybe<FilterFindManyRunSheetNextRunSheetIdOperatorsInput>;
  prevRunSheetID?: InputMaybe<FilterFindManyRunSheetPrevRunSheetIdOperatorsInput>;
  runSheetStyleID?: InputMaybe<FilterFindManyRunSheetRunSheetStyleIdOperatorsInput>;
  sessionID?: InputMaybe<FilterFindManyRunSheetSessionIdOperatorsInput>;
  setupID?: InputMaybe<FilterFindManyRunSheetSetupIdOperatorsInput>;
  simResultIDs?: InputMaybe<FilterFindManyRunSheetSimResultIDsOperatorsInput>;
  startTimeCDS?: InputMaybe<FilterFindManyRunSheetStartTimeCdsOperatorsInput>;
  startTimeLTS?: InputMaybe<FilterFindManyRunSheetStartTimeLtsOperatorsInput>;
  startTimeManual?: InputMaybe<FilterFindManyRunSheetStartTimeManualOperatorsInput>;
  teamID?: InputMaybe<FilterFindManyRunSheetTeamIdOperatorsInput>;
  thirdPartyRunID?: InputMaybe<FilterFindManyRunSheetThirdPartyRunIdOperatorsInput>;
  tyreCompoundTiming?: InputMaybe<FilterFindManyRunSheetTyreCompoundTimingOperatorsInput>;
  tyreSetID?: InputMaybe<FilterFindManyRunSheetTyreSetIdOperatorsInput>;
};

export type FilterFindManyRunSheetPrevRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetRunSheetStyleIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetSessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetSimResultIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetStartTimeCdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyRunSheetStartTimeLtsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyRunSheetStartTimeManualOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyRunSheetStyleInput = {
  AND?: InputMaybe<Array<FilterFindManyRunSheetStyleInput>>;
  OR?: InputMaybe<Array<FilterFindManyRunSheetStyleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRunSheetStyleOperatorsInput>;
  blocks?: InputMaybe<Array<InputMaybe<FilterFindManyGenericRunSheetStyleBlockInput>>>;
  energyType?: InputMaybe<EnumEnergyType>;
  lapFlags?: InputMaybe<FilterFindManyLapFlagLabelsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetStyleNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRunSheetStyleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRunSheetStyle_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyRunSheetStyleNameOperatorsInput>;
};

export type FilterFindManyRunSheetStyle_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetTeamIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetThirdPartyRunIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyRunSheetTyreCompoundTimingOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyRunSheetTyreSetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunTyreInput = {
  /** Track reference temperature at which the reference pressure is given */
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre temperature */
  TTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Expected tyre temperature in parc ferme */
  TTyreParcFermeExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre temperature */
  TTyrePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure bleed at temperature */
  TTyrePostRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Pre-run tyre pressure bleed at temperature */
  TTyrePreRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre reference temperature at which the reference pressure is given */
  TTyreReference?: InputMaybe<Scalars['Float']['input']>;
  /** Set down tyre temperature (e.g. in the evening with cold tyre) */
  TTyreSetdown?: InputMaybe<Scalars['Float']['input']>;
  /** Array of manual surface temperature measurements */
  TTyreSurface?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Array of manual tyre tread depth measurements */
  hTyreTread?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Tyre pressure */
  pTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure at the start of the run */
  pTyreMinStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure */
  pTyrePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure bleed */
  pTyrePostRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Pre-run tyre pressure bleed */
  pTyrePreRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre reference pressure */
  pTyreReference?: InputMaybe<Scalars['Float']['input']>;
  /** Set down tyre pressure (e.g. in the evening with cold tyre) */
  pTyreSetDown?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre pressure at the start of the run */
  pTyreStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Target tyre pressure during running */
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
  tyreID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManySandboxUnitsInput = {
  AND?: InputMaybe<Array<FilterFindManySandboxUnitsInput>>;
  OR?: InputMaybe<Array<FilterFindManySandboxUnitsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySandboxUnitsOperatorsInput>;
  acceleration?: InputMaybe<FilterFindManyAccelerationInput>;
  angle?: InputMaybe<FilterFindManyAngleInput>;
  angularVelocity?: InputMaybe<FilterFindManyAngularVelocityInput>;
  area?: InputMaybe<FilterFindManyAreaInput>;
  current?: InputMaybe<FilterFindManyCurrentInput>;
  dampingRate?: InputMaybe<FilterFindManyDampingRateInput>;
  density?: InputMaybe<FilterFindManyDensityInput>;
  energy?: InputMaybe<FilterFindManyEnergyInput>;
  force?: InputMaybe<FilterFindManyForceInput>;
  frequency?: InputMaybe<FilterFindManyFrequencyInput>;
  length?: InputMaybe<FilterFindManyLengthInput>;
  mass?: InputMaybe<FilterFindManyMassInput>;
  momentOfInertia?: InputMaybe<FilterFindManyMomentOfInertiaInput>;
  power?: InputMaybe<FilterFindManyPowerInput>;
  pressure?: InputMaybe<FilterFindManyPressureInput>;
  ratio?: InputMaybe<FilterFindManyRatioInput>;
  springRate?: InputMaybe<FilterFindManySpringRateInput>;
  temperature?: InputMaybe<FilterFindManyTemperatureInput>;
  torque?: InputMaybe<FilterFindManyTorqueInput>;
  torsionRate?: InputMaybe<FilterFindManyTorsionRateInput>;
  velocity?: InputMaybe<FilterFindManyVelocityInput>;
  voltage?: InputMaybe<FilterFindManyVoltageInput>;
  volume?: InputMaybe<FilterFindManyVolumeInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySandboxUnitsOperatorsInput = {
  _id?: InputMaybe<FilterFindManySandboxUnits_IdOperatorsInput>;
};

export type FilterFindManySandboxUnits_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySeasonInput = {
  AND?: InputMaybe<Array<FilterFindManySeasonInput>>;
  OR?: InputMaybe<Array<FilterFindManySeasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySeasonOperatorsInput>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Position after which a driver no longer gets points for fastest lap. */
  fastestLapsPositionCutoff?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Championship points per fastest lap in a session. Example: `[1]` means fastest lap gets 1 point, then second and beyond gets nothing. */
  pointsPerFastestLap?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Whether the fastest lap points are awarded to the team or the driver. */
  pointsPerFastestLapTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Championship points per driver position in a race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPosition?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Championship points per driver position in a sprint race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPositionSprintRace?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Championship points per qualifying rank at an event. Example: `[3, 2, 1]` means first/second/third drivers get 3/2/1 points, then fourth and beyond gets nothing. */
  pointsPerQualifyingRank?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  pointsSystemQualiAlternateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemQualiDefaultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemRaceAlternateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemRaceDefaultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of all tyres which are owned by the team for this season. */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of all tyre sets which are owned by the team for this season. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySeasonNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySeasonOperatorsInput = {
  _id?: InputMaybe<FilterFindManySeason_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManySeasonNameOperatorsInput>;
  raceSeriesID?: InputMaybe<FilterFindManySeasonRaceSeriesIdOperatorsInput>;
};

export type FilterFindManySeasonRaceSeriesIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySeason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySessionContestantsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of the chassis used, if different for this session. */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** IDs of drivers of this car, if different for this session. */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySessionEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySessionInput = {
  AND?: InputMaybe<Array<FilterFindManySessionInput>>;
  OR?: InputMaybe<Array<FilterFindManySessionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySessionOperatorsInput>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bestValuesID?: InputMaybe<Scalars['MongoID']['input']>;
  bopID?: InputMaybe<Scalars['MongoID']['input']>;
  contestants?: InputMaybe<Array<InputMaybe<FilterFindManySessionContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumSessionDebriefNotesMode>;
  disableForwardPropagation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted driver championship standings during and immediately after this session. */
  driverChampionshipStandings?: InputMaybe<Array<InputMaybe<FilterFindManyDriverChampionshipStandingInput>>>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  /** This flag is used to tell the laptime service that this session might span multiple timing sessions. */
  isLinkedSession?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this a timing test session, to be shown only to admin users? */
  isTimingTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted standings of this session, as they were last updated */
  liveStandings?: InputMaybe<Array<InputMaybe<FilterFindManyLiveStandingInput>>>;
  /** Greatest lap number processed for live standings. Use to determine if the data is current and up to date. */
  liveStandingsCurrentLap?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the next session in this event */
  nextSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFRMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRRMinSession?: InputMaybe<Scalars['Float']['input']>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemOverrideIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted driver championship standings from before the start of this session. */
  prevDriverChampionshipStandings?: InputMaybe<Array<InputMaybe<FilterFindManyDriverChampionshipStandingInput>>>;
  /** ID of the previous session in this event */
  prevSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** e.g. Test, Practice, Qualifying, Race */
  sessionType?: InputMaybe<EnumSessionType>;
  /** Short name like D1, FP2, etc. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Time of the session end in local time */
  tSessionEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of the session start in local time */
  tSessionStart?: InputMaybe<Scalars['Date']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted team championship standings during and immediately after this session. */
  teamChampionshipStandings?: InputMaybe<Array<InputMaybe<FilterFindManyTeamChampionshipStandingInput>>>;
  /** ID of this session in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartySessionID?: InputMaybe<Scalars['String']['input']>;
  /** Seconds until end of session, updated by the timing service very infrequently. Zero if session has already ended. */
  timeRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** ID of this session for Transcribble's legacy API */
  transcribbleSessionID?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterFindManySessionNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySessionOperatorsInput = {
  _id?: InputMaybe<FilterFindManySession_IdOperatorsInput>;
  eventID?: InputMaybe<FilterFindManySessionEventIdOperatorsInput>;
  name?: InputMaybe<FilterFindManySessionNameOperatorsInput>;
  shortName?: InputMaybe<FilterFindManySessionShortNameOperatorsInput>;
  tSessionEnd?: InputMaybe<FilterFindManySessionTSessionEndOperatorsInput>;
  tSessionStart?: InputMaybe<FilterFindManySessionTSessionStartOperatorsInput>;
  thirdPartySessionID?: InputMaybe<FilterFindManySessionThirdPartySessionIdOperatorsInput>;
  transcribbleSessionID?: InputMaybe<FilterFindManySessionTranscribbleSessionIdOperatorsInput>;
};

export type FilterFindManySessionShortNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySessionTSessionEndOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManySessionTSessionStartOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManySessionThirdPartySessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySessionTranscribbleSessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type FilterFindManySession_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySetupOverviewConfigFieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell and an array of two numbers for a double cell. */
  gain?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Field names to pull data from in the car setup, like `"frontLeft.hRide"`. Use an array of one key for a single cell, and an array of two keys for a double cell. */
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Suffix to show as a unit for values. */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManySetupOverviewConfigInput = {
  AND?: InputMaybe<Array<FilterFindManySetupOverviewConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManySetupOverviewConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySetupOverviewConfigOperatorsInput>;
  /** WARNING: this field should be deprecated after SI migrations have taken place */
  fields?: InputMaybe<Array<InputMaybe<FilterFindManySetupOverviewConfigFieldInput>>>;
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<InputMaybe<FilterFindManySetupOverviewConfigRowInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySetupOverviewConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManySetupOverviewConfig_IdOperatorsInput>;
  title?: InputMaybe<FilterFindManySetupOverviewConfigTitleOperatorsInput>;
};

export type FilterFindManySetupOverviewConfigRowElementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Path of field in car setup, e.g. aero.aFlapF */
  field?: InputMaybe<Scalars['String']['input']>;
  /** Gain to apply to the value. */
  gain?: InputMaybe<Scalars['Float']['input']>;
  /** Suffix to put as a unit for values. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<FilterFindManyBaseTypedUnitFieldInput>;
};

export type FilterFindManySetupOverviewConfigRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  elements?: InputMaybe<Array<InputMaybe<FilterFindManySetupOverviewConfigRowElementInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManySetupOverviewConfigTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySetupOverviewConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySetupSheetGroupInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Array<FilterFindManySetupSheetStyleRowInput>>;
};

export type FilterFindManySetupSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** The height of the block within the grid */
  height?: InputMaybe<Scalars['Int']['input']>;
  tabs?: InputMaybe<Array<FilterFindManySetupSheetStyleTabInput>>;
  /** The width of the block within the grid */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterFindManySetupSheetStyleInput = {
  AND?: InputMaybe<Array<FilterFindManySetupSheetStyleInput>>;
  OR?: InputMaybe<Array<FilterFindManySetupSheetStyleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySetupSheetStyleOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  blocks?: InputMaybe<Array<FilterFindManySetupSheetStyleBlockInput>>;
  /** Chassis specification to use for suggesting field keys. You may need to look for more recent iterations of this spec to get up-to-date field keys. */
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  hideAddPartButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Toggle to show/hide units for the input fields */
  hideUnits?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  targetEventType?: InputMaybe<EnumSetupSheetStyleTargetEventType>;
  targetRoles?: InputMaybe<Array<EnumPersonRole>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumSetupSheetStyleType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySetupSheetStyleOperatorsInput = {
  _id?: InputMaybe<FilterFindManySetupSheetStyle_IdOperatorsInput>;
};

export type FilterFindManySetupSheetStyleRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  items: Array<SetupSheetStyleItemInput>;
};

export type FilterFindManySetupSheetStyleTabInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  groups?: InputMaybe<Array<FilterFindManySetupSheetGroupInput>>;
  massConfig?: InputMaybe<FilterFindManySetupSheetStyleTabMassConfigInput>;
  mileageConfig?: InputMaybe<FilterFindManySetupSheetStyleTabMileageConfigInput>;
  rows?: InputMaybe<Array<FilterFindManySetupSheetStyleRowInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumSetupSheetStyleTabType>;
};

export type FilterFindManySetupSheetStyleTabMassConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  massOption?: InputMaybe<Scalars['String']['input']>;
  showMinWeightFromSpec?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManySetupSheetStyleTabMileageConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  showManualInput?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManySetupSheetStyle_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestCarSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestInput = {
  AND?: InputMaybe<Array<FilterFindManySimRequestInput>>;
  OR?: InputMaybe<Array<FilterFindManySimRequestInput>>;
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySimRequestOperatorsInput>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  relatedSimResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  requesterSlot?: InputMaybe<EnumSimRequestRequesterSlot>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  simResultID?: InputMaybe<Scalars['MongoID']['input']>;
  simType?: InputMaybe<EnumSimRequestSimType>;
  simulationService?: InputMaybe<EnumSimModelType>;
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySimRequestOperatorsInput = {
  _id?: InputMaybe<FilterFindManySimRequest_IdOperatorsInput>;
  carSetupID?: InputMaybe<FilterFindManySimRequestCarSetupIdOperatorsInput>;
  requesterID?: InputMaybe<FilterFindManySimRequestRequesterIdOperatorsInput>;
  runSheetID?: InputMaybe<FilterFindManySimRequestRunSheetIdOperatorsInput>;
  simResultID?: InputMaybe<FilterFindManySimRequestSimResultIdOperatorsInput>;
  simType?: InputMaybe<FilterFindManySimRequestSimTypeOperatorsInput>;
  simulationService?: InputMaybe<FilterFindManySimRequestSimulationServiceOperatorsInput>;
  specificationID?: InputMaybe<FilterFindManySimRequestSpecificationIdOperatorsInput>;
  trackLayoutID?: InputMaybe<FilterFindManySimRequestTrackLayoutIdOperatorsInput>;
  version?: InputMaybe<FilterFindManySimRequestVersionOperatorsInput>;
};

export type FilterFindManySimRequestRequesterIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestSimResultIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestSimTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimRequestSimType>;
  gte?: InputMaybe<EnumSimRequestSimType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimRequestSimType>>>;
  lt?: InputMaybe<EnumSimRequestSimType>;
  lte?: InputMaybe<EnumSimRequestSimType>;
  ne?: InputMaybe<EnumSimRequestSimType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimRequestSimType>>>;
};

export type FilterFindManySimRequestSimulationServiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimModelType>;
  gte?: InputMaybe<EnumSimModelType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  lt?: InputMaybe<EnumSimModelType>;
  lte?: InputMaybe<EnumSimModelType>;
  ne?: InputMaybe<EnumSimModelType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
};

export type FilterFindManySimRequestSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestTrackLayoutIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySimRequest_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimResultCarSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimResultDataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  /** Sampling rate of the channel in Hz, if overriding `defaultChannelTime` without `channelTime` */
  channelSamplingRate?: InputMaybe<Scalars['Float']['input']>;
  /** Use this to override `defaultChannelTime` */
  channelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Actual channel data values */
  channelValue?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  interpolationMethod?: InputMaybe<EnumSimResultDataInterpolationMethod>;
  /** Should values in this channel be treated as timestamps? */
  isTimeChannel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display unit of channel values (e.g. m/s) */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManySimResultInput = {
  AND?: InputMaybe<Array<FilterFindManySimResultInput>>;
  OR?: InputMaybe<Array<FilterFindManySimResultInput>>;
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySimResultOperatorsInput>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Array<InputMaybe<FilterFindManySimResultDataInput>>>;
  /** Each data channel is assumed to use this unless it specifies `channelSamplingRate` or `channelTime` */
  defaultChannelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Map containing reference values from car setup. Example: aerobalance in a car manual. Input syntax is array of key-value tuples, like `refValues: [["rAeroBalF", 48.5], ["rLatBalF", 51.4]]`. */
  refValues?: InputMaybe<Scalars['JSON']['input']>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the ORH service used to generate the sim result */
  serviceVersion?: InputMaybe<Scalars['String']['input']>;
  simType?: InputMaybe<EnumSimResultSimType>;
  simulationDriveFileID?: InputMaybe<Scalars['MongoID']['input']>;
  simulationService?: InputMaybe<EnumSimModelType>;
  /** Service which generated this sim result, for example Canopy */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Reference for this sim result, to find it in the simulation service */
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySimResultOperatorsInput = {
  _id?: InputMaybe<FilterFindManySimResult_IdOperatorsInput>;
  carSetupID?: InputMaybe<FilterFindManySimResultCarSetupIdOperatorsInput>;
  requesterID?: InputMaybe<FilterFindManySimResultRequesterIdOperatorsInput>;
  runSheetID?: InputMaybe<FilterFindManySimResultRunSheetIdOperatorsInput>;
  serviceVersion?: InputMaybe<FilterFindManySimResultServiceVersionOperatorsInput>;
  simType?: InputMaybe<FilterFindManySimResultSimTypeOperatorsInput>;
  simulationService?: InputMaybe<FilterFindManySimResultSimulationServiceOperatorsInput>;
  source?: InputMaybe<FilterFindManySimResultSourceOperatorsInput>;
  sourceReferenceID?: InputMaybe<FilterFindManySimResultSourceReferenceIdOperatorsInput>;
  specificationID?: InputMaybe<FilterFindManySimResultSpecificationIdOperatorsInput>;
  trackLayoutID?: InputMaybe<FilterFindManySimResultTrackLayoutIdOperatorsInput>;
  version?: InputMaybe<FilterFindManySimResultVersionOperatorsInput>;
};

export type FilterFindManySimResultRequesterIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimResultRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimResultServiceVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySimResultSimTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimResultSimType>;
  gte?: InputMaybe<EnumSimResultSimType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimResultSimType>>>;
  lt?: InputMaybe<EnumSimResultSimType>;
  lte?: InputMaybe<EnumSimResultSimType>;
  ne?: InputMaybe<EnumSimResultSimType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimResultSimType>>>;
};

export type FilterFindManySimResultSimulationServiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimModelType>;
  gte?: InputMaybe<EnumSimModelType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  lt?: InputMaybe<EnumSimModelType>;
  lte?: InputMaybe<EnumSimModelType>;
  ne?: InputMaybe<EnumSimModelType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
};

export type FilterFindManySimResultSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySimResultSourceReferenceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySimResultSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimResultTrackLayoutIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimResultVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySimResult_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimulationDriveFileInput = {
  AND?: InputMaybe<Array<FilterFindManySimulationDriveFileInput>>;
  OR?: InputMaybe<Array<FilterFindManySimulationDriveFileInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySimulationDriveFileOperatorsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumSimulationDriveFileStatus>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumTypeID?: InputMaybe<Scalars['MongoID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySimulationDriveFileOperatorsInput = {
  _id?: InputMaybe<FilterFindManySimulationDriveFile_IdOperatorsInput>;
  status?: InputMaybe<FilterFindManySimulationDriveFileStatusOperatorsInput>;
  userEnumTypeID?: InputMaybe<FilterFindManySimulationDriveFileUserEnumTypeIdOperatorsInput>;
};

export type FilterFindManySimulationDriveFileStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimulationDriveFileStatus>;
  gte?: InputMaybe<EnumSimulationDriveFileStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumSimulationDriveFileStatus>>>;
  lt?: InputMaybe<EnumSimulationDriveFileStatus>;
  lte?: InputMaybe<EnumSimulationDriveFileStatus>;
  ne?: InputMaybe<EnumSimulationDriveFileStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimulationDriveFileStatus>>>;
};

export type FilterFindManySimulationDriveFileUserEnumTypeIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimulationDriveFile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySkidPlateBarcodeRegulationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySkidPlateInitialThicknessOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManySkidPlateInput = {
  AND?: InputMaybe<Array<FilterFindManySkidPlateInput>>;
  OR?: InputMaybe<Array<FilterFindManySkidPlateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySkidPlateOperatorsInput>;
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  initialThickness?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySkidPlateNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySkidPlateOperatorsInput = {
  _id?: InputMaybe<FilterFindManySkidPlate_IdOperatorsInput>;
  barcodeRegulation?: InputMaybe<FilterFindManySkidPlateBarcodeRegulationOperatorsInput>;
  initialThickness?: InputMaybe<FilterFindManySkidPlateInitialThicknessOperatorsInput>;
  name?: InputMaybe<FilterFindManySkidPlateNameOperatorsInput>;
};

export type FilterFindManySkidPlate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySpecificationACamberInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  readingsRequired?: InputMaybe<EnumSpecificationACamberReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpecificationACamberUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManySpecificationAllowableParentSpecIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySpecificationCanopyVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySpecificationChassisSpecIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySpecificationCustomSimulationModelsInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  dataMapping?: InputMaybe<EnumSpecificationCustomSimulationModelsDataMapping>;
  endPoint?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serverPort?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManySpecificationCustomTablesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<FilterFindManyTableInput>;
};

export type FilterFindManySpecificationHRideInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  readingsRequired?: InputMaybe<EnumSpecificationHRideReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpecificationHRideUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManySpecificationInput = {
  AND?: InputMaybe<Array<FilterFindManySpecificationInput>>;
  CxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  FSpringSetup?: InputMaybe<FilterFindManyAdjustableForceInput>;
  OR?: InputMaybe<Array<FilterFindManySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySpecificationOperatorsInput>;
  aCamber?: InputMaybe<FilterFindManySpecificationACamberInput>;
  aCaster?: InputMaybe<FilterFindManySpecificationACamberInput>;
  aCasterMeasurementGain?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurementOffset?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<FilterFindManySpecificationACamberInput>;
  adjustableProperties?: InputMaybe<Array<InputMaybe<FilterFindManyAdjustablePropertyInput>>>;
  aeroElementInterpolationMethod?: InputMaybe<EnumAeroElementInterpolationMethod>;
  aeroElementSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  aeroElementType?: InputMaybe<EnumAeroElementType>;
  aeroPackageSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  aeroPackageSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Names of sockets that this can be plugged in to. */
  allowableSockets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  antiRollBarConfigs?: InputMaybe<Array<InputMaybe<FilterFindManyAntiRollBarConfigInput>>>;
  antiRollBarDisplayLocation?: InputMaybe<EnumAntiRollBarDisplayLocation>;
  antiRollBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: InputMaybe<Array<InputMaybe<FilterFindManyAssignedGearInput>>>;
  attachable?: InputMaybe<Scalars['Boolean']['input']>;
  axle?: InputMaybe<EnumAxle>;
  bevelSetSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetVisible?: InputMaybe<Scalars['Boolean']['input']>;
  bumpRubberReference?: InputMaybe<EnumKinematicsInternalReference>;
  bumpRubberSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bumpStopGapMethod?: InputMaybe<EnumBumpStopGapMethod>;
  calculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: InputMaybe<Scalars['String']['input']>;
  chassisMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  copyReferencePackageID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customSimulationModels?: InputMaybe<Array<InputMaybe<FilterFindManySpecificationCustomSimulationModelsInput>>>;
  customSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  customSpecType?: InputMaybe<Scalars['String']['input']>;
  customTables?: InputMaybe<Array<InputMaybe<FilterFindManySpecificationCustomTablesInput>>>;
  damperAdjusters?: InputMaybe<Array<InputMaybe<FilterFindManyDamperAdjusterInput>>>;
  damperConfigs?: InputMaybe<Array<InputMaybe<FilterFindManyDamperConfigInput>>>;
  damperSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  denominator?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  differentialConfigs?: InputMaybe<Array<InputMaybe<FilterFindManyDifferentialConfigInput>>>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  drawingNumber?: InputMaybe<Scalars['String']['input']>;
  dropGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  elasticType?: InputMaybe<EnumElasticType>;
  forceTable?: InputMaybe<FilterFindManyForceTableInput>;
  gearType?: InputMaybe<EnumGearType>;
  hRide?: InputMaybe<FilterFindManySpecificationHRideInput>;
  hasToBeInSubAssembly?: InputMaybe<Scalars['Boolean']['input']>;
  headGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  helperSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  initialChassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** If true, this gear is the head gear of the gear box, applies to standard gears only */
  isHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
  /** Spring constant of the elastic element. */
  kSpring?: InputMaybe<Scalars['Float']['input']>;
  kinematicsExternalModels?: InputMaybe<Array<InputMaybe<FilterFindManyKinematicsExternalModelInput>>>;
  kinematicsExternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  kinematicsInternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerReference?: InputMaybe<Scalars['String']['input']>;
  mass?: InputMaybe<FilterFindManyChassisMassInput>;
  massProperties?: InputMaybe<FilterFindManyMassPropertiesInput>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: InputMaybe<FilterFindManyChassisMeasurementsInput>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  numerator?: InputMaybe<Scalars['Float']['input']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  polyCxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  positionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  powerUnits?: InputMaybe<Array<InputMaybe<FilterFindManyChassisPowerUnitInput>>>;
  powertrain?: InputMaybe<FilterFindManyChassisPowertrainInput>;
  powertrainLocation?: InputMaybe<EnumSpecificationPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  rBrakeBias?: InputMaybe<FilterFindManyAdjustableRatioInput>;
  /** Position of the specification on the car */
  readingsAllowable?: InputMaybe<Array<InputMaybe<EnumSpecificationReadingsAllowable>>>;
  readingsRequired?: InputMaybe<EnumSpecificationReadingsRequired>;
  reboundSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  regulationSets?: InputMaybe<Array<InputMaybe<FilterFindManyRegulationSetInput>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: InputMaybe<Scalars['Boolean']['input']>;
  setupChangesFilter?: InputMaybe<FilterFindManySpecificationSetupChangesFilterInput>;
  setupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  /** Locations/areas that components can be installed in. */
  sockets?: InputMaybe<Array<InputMaybe<FilterFindManyChassisSocketInput>>>;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationGroupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  springReference?: InputMaybe<EnumKinematicsInternalReference>;
  springSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  torsionBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumSpecificationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** User-supplied version of this specification. */
  version?: InputMaybe<Scalars['String']['input']>;
  xBumpRubberRef?: InputMaybe<Scalars['Float']['input']>;
  xBumpRubberSetup?: InputMaybe<FilterFindManyAdjustableLengthInput>;
  xBumpStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperSetupDefault?: InputMaybe<Scalars['Float']['input']>;
  xDroopStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  /** Length of the elastic element under no force */
  xFree?: InputMaybe<Scalars['Float']['input']>;
  xShaftDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xSpringPlatformOffset?: InputMaybe<Scalars['Float']['input']>;
  xSpringRef?: InputMaybe<Scalars['Float']['input']>;
  xSpringSetup?: InputMaybe<FilterFindManyAdjustableLengthInput>;
  xToe?: InputMaybe<FilterFindManySpecificationHRideInput>;
};

export type FilterFindManySpecificationNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySpecificationNextIterationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManySpecification_IdOperatorsInput>;
  allowableParentSpecIDs?: InputMaybe<FilterFindManySpecificationAllowableParentSpecIDsOperatorsInput>;
  canopyVersion?: InputMaybe<FilterFindManySpecificationCanopyVersionOperatorsInput>;
  chassisSpecID?: InputMaybe<FilterFindManySpecificationChassisSpecIdOperatorsInput>;
  name?: InputMaybe<FilterFindManySpecificationNameOperatorsInput>;
  nextIterationID?: InputMaybe<FilterFindManySpecificationNextIterationIdOperatorsInput>;
  prevIterationID?: InputMaybe<FilterFindManySpecificationPrevIterationIdOperatorsInput>;
  specificationGroupIDs?: InputMaybe<FilterFindManySpecificationSpecificationGroupIDsOperatorsInput>;
  version?: InputMaybe<FilterFindManySpecificationVersionOperatorsInput>;
};

export type FilterFindManySpecificationPrevIterationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySpecificationSetupChangesFilterInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of setup fields to hide */
  blackListFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** List of setup fields to show */
  whiteListFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManySpecificationSpecificationGroupIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySpecificationVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySpringRateInput = {
  /** N/m */
  newtonsPerMetre?: InputMaybe<Scalars['Float']['input']>;
  /** N/mm */
  newtonsPerMillimetre?: InputMaybe<Scalars['Float']['input']>;
  /** lb/in */
  poundsPerInch?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManySsoProviderInput = {
  AND?: InputMaybe<Array<FilterFindManySsoProviderInput>>;
  OR?: InputMaybe<Array<FilterFindManySsoProviderInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySsoProviderOperatorsInput>;
  clientID?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  issuerURL?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManySsoProviderNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySsoProviderOperatorsInput = {
  _id?: InputMaybe<FilterFindManySsoProvider_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManySsoProviderNameOperatorsInput>;
};

export type FilterFindManySsoProvider_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySteeringInput = {
  rSteerF?: InputMaybe<Scalars['Float']['input']>;
  steeringArm?: InputMaybe<Scalars['String']['input']>;
  steeringPinion?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyTableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  columnNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  columnValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Table data in 1d vector. It's up to the consumer to reshape appropriately. OneRacehub internally uses row chunks. */
  data?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  decimals?: InputMaybe<Scalars['Float']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  rowNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sliceNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sliceValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTagInput = {
  AND?: InputMaybe<Array<FilterFindManyTagInput>>;
  OR?: InputMaybe<Array<FilterFindManyTagInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTagOperatorsInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<EnumTagType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTagOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTag_IdOperatorsInput>;
};

export type FilterFindManyTag_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTeamChampionshipStandingInput = {
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  points?: InputMaybe<Scalars['Int']['input']>;
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: InputMaybe<Scalars['Int']['input']>;
  teamDrivers?: InputMaybe<Array<InputMaybe<FilterFindManyDriverChampionshipStandingInput>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyTeamInput = {
  AND?: InputMaybe<Array<FilterFindManyTeamInput>>;
  OR?: InputMaybe<Array<FilterFindManyTeamInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTeamOperatorsInput>;
  /** Default color to use for this team where applicable. */
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Used only for filtering to limit which teams are displayed in a list. */
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTeamNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTeamOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTeam_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyTeamNameOperatorsInput>;
  raceSeriesID?: InputMaybe<FilterFindManyTeamRaceSeriesIdOperatorsInput>;
  shortName?: InputMaybe<FilterFindManyTeamShortNameOperatorsInput>;
};

export type FilterFindManyTeamRaceSeriesIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTeamShortNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTeam_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTemperatureInput = {
  /** °C */
  celsius?: InputMaybe<Scalars['Float']['input']>;
  /** °F */
  fahrenheit?: InputMaybe<Scalars['Float']['input']>;
  /** °K */
  kelvin?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTemplateJobInput = {
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
};

export type FilterFindManyTemplateJobListIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyTemplateJobListInput = {
  AND?: InputMaybe<Array<FilterFindManyTemplateJobListInput>>;
  OR?: InputMaybe<Array<FilterFindManyTemplateJobListInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTemplateJobListOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  jobs?: InputMaybe<Array<InputMaybe<FilterFindManyTemplateJobInput>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTemplateJobListOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTemplateJobList_IdOperatorsInput>;
  index?: InputMaybe<FilterFindManyTemplateJobListIndexOperatorsInput>;
  title?: InputMaybe<FilterFindManyTemplateJobListTitleOperatorsInput>;
};

export type FilterFindManyTemplateJobListTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTemplateJobList_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTemplateSessionDebriefInput = {
  AND?: InputMaybe<Array<FilterFindManyTemplateSessionDebriefInput>>;
  OR?: InputMaybe<Array<FilterFindManyTemplateSessionDebriefInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTemplateSessionDebriefOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumTemplateSessionDebriefMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTemplateSessionDebriefOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTemplateSessionDebrief_IdOperatorsInput>;
};

export type FilterFindManyTemplateSessionDebrief_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTimeSheetEntryInput = {
  AND?: InputMaybe<Array<FilterFindManyTimeSheetEntryInput>>;
  OR?: InputMaybe<Array<FilterFindManyTimeSheetEntryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTimeSheetEntryOperatorsInput>;
  /** Whether a person did work on this day */
  absent?: InputMaybe<Scalars['Boolean']['input']>;
  approvedAt?: InputMaybe<Scalars['Date']['input']>;
  approvedByID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Notes about what was done during this time */
  description?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Clock-out time */
  tEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Clock-in time */
  tStart?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTimeSheetEntryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTimeSheetEntry_IdOperatorsInput>;
  projectID?: InputMaybe<FilterFindManyTimeSheetEntryProjectIdOperatorsInput>;
  tEnd?: InputMaybe<FilterFindManyTimeSheetEntryTEndOperatorsInput>;
  tStart?: InputMaybe<FilterFindManyTimeSheetEntryTStartOperatorsInput>;
};

export type FilterFindManyTimeSheetEntryProjectIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTimeSheetEntryTEndOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyTimeSheetEntryTStartOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyTimeSheetEntry_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTimingServiceConfigEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTimingServiceConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyTimingServiceConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyTimingServiceConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTimingServiceConfigOperatorsInput>;
  /** Whether the timingServiceConfig should be considered active by the service */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event ID. This finds the correct event by its _id field. */
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Use schedule-based session matching as fallback. */
  fallbackScheduleBasedSessionMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of timed sectors on track. Used as fallback in case timing data does not provide it. */
  fallbackTimedSectorsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Car numbers to follow. */
  followedCarNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Activate live standings to see the driver championship points live. Only working properly if all drivers of a given season are added as contestants. */
  liveStandingsActive?: InputMaybe<Scalars['Boolean']['input']>;
  logLevel?: InputMaybe<EnumTimingServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<EnumTimingServiceConfigMode>;
  /** Name for this set of configuration settings. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Use string equality to match timing session names in One Racehub. Otherwise default sequence matching is used. */
  strictSessionNameMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** One Timing server port. */
  timingPort?: InputMaybe<Scalars['Int']['input']>;
  /** Race series name to filter on in the timing feed when multiple series are running at an event. */
  timingRaceSeries?: InputMaybe<Scalars['String']['input']>;
  /** One Timing server address. */
  timingURL?: InputMaybe<Scalars['String']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyTimingServiceConfigNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTimingServiceConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTimingServiceConfig_IdOperatorsInput>;
  eventID?: InputMaybe<FilterFindManyTimingServiceConfigEventIdOperatorsInput>;
  name?: InputMaybe<FilterFindManyTimingServiceConfigNameOperatorsInput>;
};

export type FilterFindManyTimingServiceConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTorqueInput = {
  /** Nm */
  newtonMetres?: InputMaybe<Scalars['Float']['input']>;
  /** Nmm */
  newtonMillimetres?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft */
  poundForceFeet?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·in */
  poundForceInches?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTorsionRateInput = {
  /** Nm/° */
  newtonMetresPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** Nm/rad */
  newtonMetresPerRadian?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/° */
  poundForceFeetPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/rad */
  poundForceFeetPerRadian?: InputMaybe<Scalars['Float']['input']>;
  /** lbf-in/° */
  poundForceInchesPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** lbf-in/rad */
  poundForceInchesPerRadian?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTrackAcronymOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTrackInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackOperatorsInput>;
  acronym?: InputMaybe<Scalars['String']['input']>;
  /** Track height above sea level. */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  cameras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  geoLocation?: InputMaybe<FilterFindManyGeoLocationInput>;
  /** Search in a radius around a coordinates point. */
  geoNear?: InputMaybe<GeoNear>;
  /** IDs of the available track layouts */
  layoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Storage ID of track picture file in s3. */
  trackPicture?: InputMaybe<Scalars['String']['input']>;
  weatherStations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyTrackLayoutAcronymOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTrackLayoutInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackLayoutInput>>;
  ATKModeGain?: InputMaybe<Scalars['Float']['input']>;
  ATKModeLocation?: InputMaybe<Scalars['Float']['input']>;
  ATKModePenalty?: InputMaybe<Scalars['Float']['input']>;
  FCYLapTime?: InputMaybe<Scalars['Float']['input']>;
  /** Full-course yellow probability */
  FCYProbability?: InputMaybe<Scalars['Float']['input']>;
  /** Amount of sectors the timing provides */
  NSectorsTiming?: InputMaybe<Scalars['Float']['input']>;
  OR?: InputMaybe<Array<FilterFindManyTrackLayoutInput>>;
  SCLapTime?: InputMaybe<Scalars['Float']['input']>;
  /** Safety car probability */
  SCProbability?: InputMaybe<Scalars['Float']['input']>;
  SoCRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackLayoutOperatorsInput>;
  acronym?: InputMaybe<Scalars['String']['input']>;
  bumpiness?: InputMaybe<Scalars['Float']['input']>;
  cameras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code60LapTime?: InputMaybe<Scalars['Float']['input']>;
  crossoverWetToSlick?: InputMaybe<Scalars['Float']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  energyRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  expectedRaceLaps?: InputMaybe<Scalars['Float']['input']>;
  firstLapOffset?: InputMaybe<Scalars['Float']['input']>;
  fuelRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  inLapTime?: InputMaybe<Scalars['Float']['input']>;
  lapLengthCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapLengthRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapZero?: InputMaybe<Scalars['Boolean']['input']>;
  lapsUntilFullRegen?: InputMaybe<Scalars['Float']['input']>;
  mapElevation?: InputMaybe<Scalars['String']['input']>;
  mapEmergencyExits?: InputMaybe<Scalars['String']['input']>;
  mapPitLane?: InputMaybe<Scalars['String']['input']>;
  mapTrack?: InputMaybe<Scalars['String']['input']>;
  mapTrackGPS?: InputMaybe<Scalars['String']['input']>;
  mapTrackLatLonCsv?: InputMaybe<Scalars['String']['input']>;
  mapTrackXyCsv?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Layout */
  name?: InputMaybe<Scalars['String']['input']>;
  outLapTime?: InputMaybe<Scalars['Float']['input']>;
  overtakingThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Whole distance from entry to exit inlcuding approach and leave */
  pitDistance?: InputMaybe<Scalars['Float']['input']>;
  /** Length of pit lane between the pit lane entry and exit loop (used for mileage calculation of pitlane lap types) */
  pitLength?: InputMaybe<Scalars['Float']['input']>;
  pitLoss?: InputMaybe<Scalars['Float']['input']>;
  pitLossDriveThrough?: InputMaybe<Scalars['Float']['input']>;
  /** Indicates whether the pole position is on the left- or right-hand side */
  polePosition?: InputMaybe<EnumTrackLayoutPolePosition>;
  prepLapTime?: InputMaybe<Scalars['Float']['input']>;
  pushLapTime?: InputMaybe<Scalars['Float']['input']>;
  sectorDistance?: InputMaybe<Scalars['Float']['input']>;
  sectorLengths?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Downforce sensitivity (seconds per 10pts) */
  sensDownforce?: InputMaybe<Scalars['Float']['input']>;
  /** Drag sensitivity (seconds per 10pts) */
  sensDrag?: InputMaybe<Scalars['Float']['input']>;
  sensEP?: InputMaybe<Scalars['Float']['input']>;
  /** Energy sensitivity (seconds per 0.1kWh) */
  sensEnergy?: InputMaybe<Scalars['Float']['input']>;
  /** Grip sensitivity (seconds per %) */
  sensGrip?: InputMaybe<Scalars['Float']['input']>;
  /** Mass sensitivity (seconds per 10kg) */
  sensMass?: InputMaybe<Scalars['Float']['input']>;
  /** Power sensitivity */
  sensPower?: InputMaybe<Scalars['Float']['input']>;
  simulationModels?: InputMaybe<Array<InputMaybe<FilterFindManyTrackLayoutSimulationModelInput>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackEvolution?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the track this layout belongs to */
  trackID?: InputMaybe<Scalars['MongoID']['input']>;
  trackLayoutType?: InputMaybe<EnumTrackLayoutTrackLayoutType>;
  trackRecordQuali?: InputMaybe<Scalars['Float']['input']>;
  trackRecordRace?: InputMaybe<Scalars['Float']['input']>;
  weatherStations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyTrackLayoutLapLengthOfficialOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackLayoutOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackLayout_IdOperatorsInput>;
  acronym?: InputMaybe<FilterFindManyTrackLayoutAcronymOperatorsInput>;
  lapLengthOfficial?: InputMaybe<FilterFindManyTrackLayoutLapLengthOfficialOperatorsInput>;
  trackID?: InputMaybe<FilterFindManyTrackLayoutTrackIdOperatorsInput>;
};

export type FilterFindManyTrackLayoutSimulationModelInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  canopyID?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<EnumSimModelType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyTrackLayoutTrackIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackLayout_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrack_IdOperatorsInput>;
  acronym?: InputMaybe<FilterFindManyTrackAcronymOperatorsInput>;
  name?: InputMaybe<FilterFindManyTrackNameOperatorsInput>;
};

export type FilterFindManyTrackStateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  flag?: InputMaybe<EnumTrackStateFlag>;
  message?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyTrack_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackableInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackableInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackableInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackableOperatorsInput>;
  criticalValue?: InputMaybe<Scalars['Float']['input']>;
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the original version of the specifications to track. */
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  unitType?: InputMaybe<FilterFindManyBaseTypedUnitFieldInput>;
  /** Comparison to use when checking if the tracked value is in the warning/critical range. */
  warningDirection?: InputMaybe<EnumTrackableWarningDirection>;
  warningValue?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTrackableNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackableOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackable_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyTrackableNameOperatorsInput>;
  rootSpecificationID?: InputMaybe<FilterFindManyTrackableRootSpecificationIdOperatorsInput>;
};

export type FilterFindManyTrackableRootSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackable_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingItemInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingItemInput>>;
  NDecimals?: InputMaybe<Scalars['Float']['input']>;
  OR?: InputMaybe<Array<FilterFindManyTrackingItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingItemOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  arrayElements?: InputMaybe<Scalars['Float']['input']>;
  criticalCumulativeValue?: InputMaybe<Scalars['Float']['input']>;
  criticalValue?: InputMaybe<Scalars['Float']['input']>;
  cumulativeCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  isArray?: InputMaybe<Scalars['Boolean']['input']>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  measurementImage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<EnumTrackingItemOperator>;
  resettable?: InputMaybe<Scalars['Boolean']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
  warningCumulativeValue?: InputMaybe<Scalars['Float']['input']>;
  warningValue?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingItemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackingItem_IdOperatorsInput>;
};

export type FilterFindManyTrackingItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingMeasurementDefaultCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTrackingMeasurementDefaultRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTrackingMeasurementInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingMeasurementInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackingMeasurementInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingMeasurementOperatorsInput>;
  defaultCoordinates?: InputMaybe<FilterFindManyTrackingMeasurementDefaultCoordinatesInput>;
  defaultRotation?: InputMaybe<FilterFindManyTrackingMeasurementDefaultRotationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingMeasurementOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackingMeasurement_IdOperatorsInput>;
};

export type FilterFindManyTrackingMeasurementRecordCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTrackingMeasurementRecordInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingMeasurementRecordInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackingMeasurementRecordInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingMeasurementRecordOperatorsInput>;
  assemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  coordinates?: InputMaybe<FilterFindManyTrackingMeasurementRecordCoordinatesInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  rotation?: InputMaybe<FilterFindManyTrackingMeasurementRecordRotationInput>;
  trackingMeasurementID?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingMeasurementRecordOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackingMeasurementRecord_IdOperatorsInput>;
};

export type FilterFindManyTrackingMeasurementRecordRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTrackingMeasurementRecord_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingMeasurement_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingRecordInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingRecordInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackingRecordInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingRecordOperatorsInput>;
  arrayValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateResolved?: InputMaybe<Scalars['Date']['input']>;
  forceTable?: InputMaybe<FilterFindManyForceTableInput>;
  location?: InputMaybe<FilterFindManyLocationInput>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  qualityCheckID?: InputMaybe<Scalars['MongoID']['input']>;
  recordErrors?: InputMaybe<Scalars['String']['input']>;
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  statusEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumTrackingRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedByID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingRecordOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackingRecord_IdOperatorsInput>;
  partID?: InputMaybe<FilterFindManyTrackingRecordPartIdOperatorsInput>;
};

export type FilterFindManyTrackingRecordPartIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingRecord_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingSourceAliasInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingSourceAliasInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackingSourceAliasInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingSourceAliasOperatorsInput>;
  aliasString?: InputMaybe<Scalars['String']['input']>;
  aliasType?: InputMaybe<EnumTrackingSourceAliasAliasType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingSourceAliasOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackingSourceAlias_IdOperatorsInput>;
};

export type FilterFindManyTrackingSourceAlias_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingSourceInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingSourceInput>>;
  NDecimals?: InputMaybe<Scalars['Float']['input']>;
  OR?: InputMaybe<Array<FilterFindManyTrackingSourceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingSourceOperatorsInput>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingSourceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackingSource_IdOperatorsInput>;
};

export type FilterFindManyTrackingSource_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreAdditionalSortPropertyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreBarcodeManufacturerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreBarcodeRegulationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreBarcodeRimOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreBarcodeTpmsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreBatteryTpmsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreCompoundOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreHeatingScheduleEntryInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTyreInput = {
  AND?: InputMaybe<Array<FilterFindManyTyreInput>>;
  /** Flag if the tyre is scrapped (no longer available for use). */
  BTyreScrapped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tyre Circumference */
  CTyre?: InputMaybe<Scalars['Float']['input']>;
  OR?: InputMaybe<Array<FilterFindManyTyreInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTyreOperatorsInput>;
  /** Arbitrary string to sort or filter by */
  additionalSortProperty?: InputMaybe<Scalars['String']['input']>;
  axle?: InputMaybe<EnumTyreAxle>;
  barcodeManufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Barcode from the regulatory body (e.g. FIA) */
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  barcodeRim?: InputMaybe<Scalars['String']['input']>;
  barcodeTPMS?: InputMaybe<Scalars['String']['input']>;
  batteryTPMS?: InputMaybe<Scalars['String']['input']>;
  compound?: InputMaybe<Scalars['String']['input']>;
  compoundComment?: InputMaybe<Scalars['String']['input']>;
  constructionComment?: InputMaybe<Scalars['String']['input']>;
  constructionSpec?: InputMaybe<Scalars['String']['input']>;
  heatingSchedule?: InputMaybe<Array<InputMaybe<FilterFindManyTyreHeatingScheduleEntryInput>>>;
  initialCondition?: InputMaybe<EnumTyreInitialCondition>;
  /** Tyre Spring Rate */
  kTyre?: InputMaybe<Scalars['Float']['input']>;
  mTyre?: InputMaybe<Scalars['Float']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturingDate?: InputMaybe<Scalars['Date']['input']>;
  /** Tyre mold information */
  mold?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Tyre minimum pressure defined by regulation or manufacturer */
  pTyreMinRegulation?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure defined by team (i.e. chief engineer) */
  pTyreMinTeam?: InputMaybe<Scalars['Float']['input']>;
  rimPartID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Initial mileage before use in One Racehub. */
  sRunInitial?: InputMaybe<Scalars['Float']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  wearMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreMTyreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyTyreManufacturerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTyreOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTyre_IdOperatorsInput>;
  additionalSortProperty?: InputMaybe<FilterFindManyTyreAdditionalSortPropertyOperatorsInput>;
  barcodeManufacturer?: InputMaybe<FilterFindManyTyreBarcodeManufacturerOperatorsInput>;
  barcodeRegulation?: InputMaybe<FilterFindManyTyreBarcodeRegulationOperatorsInput>;
  barcodeRim?: InputMaybe<FilterFindManyTyreBarcodeRimOperatorsInput>;
  barcodeTPMS?: InputMaybe<FilterFindManyTyreBarcodeTpmsOperatorsInput>;
  batteryTPMS?: InputMaybe<FilterFindManyTyreBatteryTpmsOperatorsInput>;
  compound?: InputMaybe<FilterFindManyTyreCompoundOperatorsInput>;
  mTyre?: InputMaybe<FilterFindManyTyreMTyreOperatorsInput>;
  manufacturer?: InputMaybe<FilterFindManyTyreManufacturerOperatorsInput>;
  name?: InputMaybe<FilterFindManyTyreNameOperatorsInput>;
  seasonID?: InputMaybe<FilterFindManyTyreSeasonIdOperatorsInput>;
  type?: InputMaybe<FilterFindManyTyreTypeOperatorsInput>;
};

export type FilterFindManyTyrePressureSettingsInput = {
  TAirReference?: InputMaybe<Scalars['Float']['input']>;
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTyreSeasonIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreSetInput = {
  AND?: InputMaybe<Array<FilterFindManyTyreSetInput>>;
  OR?: InputMaybe<Array<FilterFindManyTyreSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTyreSetOperatorsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Hide fully scrapped tyre sets from a paginated tyre set query. */
  hideScrapped?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tyreIDFL?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDFR?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDRL?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDRR?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyTyreSetNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreSetNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTyreSetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTyreSet_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyTyreSetNameOperatorsInput>;
  number?: InputMaybe<FilterFindManyTyreSetNumberOperatorsInput>;
  tyreIDFL?: InputMaybe<FilterFindManyTyreSetTyreIdflOperatorsInput>;
  tyreIDFR?: InputMaybe<FilterFindManyTyreSetTyreIdfrOperatorsInput>;
  tyreIDRL?: InputMaybe<FilterFindManyTyreSetTyreIdrlOperatorsInput>;
  tyreIDRR?: InputMaybe<FilterFindManyTyreSetTyreIdrrOperatorsInput>;
};

export type FilterFindManyTyreSetTyreIdflOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreSetTyreIdfrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreSetTyreIdrlOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreSetTyreIdrrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreTableBlockRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<EnumTyreTableField>;
  highlightChanges?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<FilterFindManyValueLimitInput>;
  upperLimit?: InputMaybe<FilterFindManyValueLimitInput>;
};

export type FilterFindManyTyreTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreWearDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyTyreWearInput = {
  AND?: InputMaybe<Array<FilterFindManyTyreWearInput>>;
  OR?: InputMaybe<Array<FilterFindManyTyreWearInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTyreWearOperatorsInput>;
  /** Time at which this measurement was made. */
  date?: InputMaybe<Scalars['Date']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Raw wear data formatted however the user chooses, probably from a scanner. */
  wearData?: InputMaybe<Scalars['String']['input']>;
  /** Map of marker names to wear values. Input syntax is array of key-value tuples, like `wearMarkers: [["inner", 0.8], ["1", 0.3]]`. */
  wearMarkers?: InputMaybe<Scalars['JSON']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTyreWearOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTyreWear_IdOperatorsInput>;
  date?: InputMaybe<FilterFindManyTyreWearDateOperatorsInput>;
  tyreID?: InputMaybe<FilterFindManyTyreWearTyreIdOperatorsInput>;
};

export type FilterFindManyTyreWearTyreIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreWear_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyre_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserEnumActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyUserEnumInput = {
  AND?: InputMaybe<Array<FilterFindManyUserEnumInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserEnumInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserEnumOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserEnumType>;
};

export type FilterFindManyUserEnumNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserEnumOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUserEnum_IdOperatorsInput>;
  active?: InputMaybe<FilterFindManyUserEnumActiveOperatorsInput>;
  name?: InputMaybe<FilterFindManyUserEnumNameOperatorsInput>;
  type?: InputMaybe<FilterFindManyUserEnumTypeOperatorsInput>;
};

export type FilterFindManyUserEnumTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserEnumType>;
  gte?: InputMaybe<EnumUserEnumType>;
  in?: InputMaybe<Array<InputMaybe<EnumUserEnumType>>>;
  lt?: InputMaybe<EnumUserEnumType>;
  lte?: InputMaybe<EnumUserEnumType>;
  ne?: InputMaybe<EnumUserEnumType>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserEnumType>>>;
};

export type FilterFindManyUserEnum_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserSimulationSettingsInput = {
  TAmbientPreferred?: InputMaybe<Scalars['Float']['input']>;
  pAmbientPreferred?: InputMaybe<Scalars['Float']['input']>;
  rHumidityPreferred?: InputMaybe<Scalars['Float']['input']>;
  /** User defined run sim slot colours, index corresponds to run slot number. */
  runSimSlotColours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** User defined setup sim slot colours, index corresponds to setup slot number. */
  setupSimSlotColours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** IDs of the two user defined setups */
  userDefinedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyValueLimitInput = {
  /** Background color to use if the value goes beyond this limit. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Text color to use if the value goes beyond this limit. */
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyVelocityInput = {
  /** ft/s */
  feetPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** kph */
  kilometresPerHour?: InputMaybe<Scalars['Float']['input']>;
  /** m/s */
  metresPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** mph */
  milesPerHour?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyViewConfigInput = {
  /** Should tyre mileages be highlighted according to `yellowTyreMileageThreshold` and `redTyreMileageThreshold`? */
  highlightTyreMileages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted red instead of yellow. */
  redTyreMileageThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Should the user see runsheet via scrolling or via tabs? */
  showRunSheetsAsTabs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted yellow instead of green. */
  yellowTyreMileageThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyVoltageInput = {
  /** mV */
  millivolts?: InputMaybe<Scalars['Float']['input']>;
  /** V */
  volts?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyVolumeInput = {
  /** cm³ */
  cubicCentimetres?: InputMaybe<Scalars['Float']['input']>;
  /** ft³ */
  cubicFeet?: InputMaybe<Scalars['Float']['input']>;
  /** in³ */
  cubicInches?: InputMaybe<Scalars['Float']['input']>;
  /** m³ */
  cubicMetres?: InputMaybe<Scalars['Float']['input']>;
  /** gal (US fluid) */
  gallonsUS?: InputMaybe<Scalars['Float']['input']>;
  /** L */
  litres?: InputMaybe<Scalars['Float']['input']>;
  /** mL */
  millilitres?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyWeatherDataInput = {
  /** Air temperature (mean in historical data) */
  TAir?: InputMaybe<Scalars['Float']['input']>;
  /** Predicted air temperature for given session. E.g. for tyre pressure calculation */
  TAirExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum air temperature (for use in historical data) */
  TAirMax?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum air temperature (for use in historical data) */
  TAirMin?: InputMaybe<Scalars['Float']['input']>;
  /** Air temperature from official sources (e.g. FIA) */
  TAirOfficial?: InputMaybe<Scalars['Float']['input']>;
  /** Ambient temperature */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Temperature to which air must be cooled to become saturated with water vapor */
  TDewPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Weather station internal temperature */
  TInternal?: InputMaybe<Scalars['Float']['input']>;
  /** Track temperature */
  TTrack?: InputMaybe<Scalars['Float']['input']>;
  /** Expected track temperature. E.g. for tyre pressure calculation */
  TTrackExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Track temperature from official sources (e.g. FIA) */
  TTrackOfficial?: InputMaybe<Scalars['Float']['input']>;
  /** Wind chill factor */
  TWindChill?: InputMaybe<Scalars['Float']['input']>;
  /** Weather station battery voltage */
  VBattery?: InputMaybe<Scalars['Float']['input']>;
  /** Wind direction in radians (0 = North, π/2 = East, π = South, 3π/2 = West) */
  aWind?: InputMaybe<Scalars['Float']['input']>;
  /** Main wind direction during the saving interval */
  aWindMain?: InputMaybe<Scalars['Float']['input']>;
  /** Verbal describing ambient condition like cloudy, sunny, overcast, miserable, … */
  ambientCondition?: InputMaybe<Scalars['String']['input']>;
  globalRadiation?: InputMaybe<Scalars['Float']['input']>;
  /** Ambient pressure */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Humidity ratio */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Amount of rain in m³/m² (so m) */
  rainIntensity?: InputMaybe<Scalars['Float']['input']>;
  /** Rain chance as a ratio */
  rainProbability?: InputMaybe<Scalars['Float']['input']>;
  /** Time stamp for this datum */
  time?: InputMaybe<Scalars['Date']['input']>;
  /** Verbal describing track condition like dry, damp, … */
  trackCondition?: InputMaybe<Scalars['String']['input']>;
  /** Wind velocity */
  vWind?: InputMaybe<Scalars['Float']['input']>;
  /** Average wind velocity */
  vWindAverage?: InputMaybe<Scalars['Float']['input']>;
  /** Peak wind velocity */
  vWindPeak?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyWeatherEventIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyWeatherInput = {
  AND?: InputMaybe<Array<FilterFindManyWeatherInput>>;
  OR?: InputMaybe<Array<FilterFindManyWeatherInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyWeatherOperatorsInput>;
  /** Height above sea level (for air density for example). */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  data?: InputMaybe<Array<InputMaybe<FilterFindManyWeatherDataInput>>>;
  /** References to events this weather data was made for, if applicable */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  geoLocation?: InputMaybe<FilterFindManyGeoLocationInput>;
  /** Search in a radius around a coordinates point. */
  geoNear?: InputMaybe<GeoNear>;
  /** User notes for completing a forecast for a race */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Forecast/measurement source (website, weather station, timekeeping, …) */
  source?: InputMaybe<Scalars['String']['input']>;
  /** For predictions, indicates the time at which the prediction was made. For measurements, indicates the time of the first measurement in the array. */
  time?: InputMaybe<Scalars['Date']['input']>;
  /** Prediction, measurement, historical */
  type?: InputMaybe<EnumWeatherType>;
  /** Weather station ID */
  weatherStationID?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyWeatherOperatorsInput = {
  _id?: InputMaybe<FilterFindManyWeather_IdOperatorsInput>;
  eventIDs?: InputMaybe<FilterFindManyWeatherEventIDsOperatorsInput>;
  source?: InputMaybe<FilterFindManyWeatherSourceOperatorsInput>;
  time?: InputMaybe<FilterFindManyWeatherTimeOperatorsInput>;
  type?: InputMaybe<FilterFindManyWeatherTypeOperatorsInput>;
};

export type FilterFindManyWeatherServiceConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyWeatherServiceConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyWeatherServiceConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyWeatherServiceConfigOperatorsInput>;
  /** API Key. Used for Open Weather Map and Wunderground */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** API Secret. Used for Weather Link */
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Password. Currently used for meteomatics */
  password?: InputMaybe<Scalars['String']['input']>;
  refreshInterval?: InputMaybe<Scalars['Float']['input']>;
  requestLocation?: InputMaybe<FilterFindManyGeoLocationInput>;
  /** Location or weather station */
  requestType?: InputMaybe<EnumWeatherServiceConfigRequestType>;
  /** Weather client to specify the source where to retrieve the data from. */
  source?: InputMaybe<EnumWeatherServiceConfigSource>;
  type?: InputMaybe<EnumWeatherServiceConfigType>;
  /** Username. Currently used for meteomatics */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Weather Station ID. Used for Weather Underground */
  weatherStationID?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyWeatherServiceConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyWeatherServiceConfig_IdOperatorsInput>;
  type?: InputMaybe<FilterFindManyWeatherServiceConfigTypeOperatorsInput>;
};

export type FilterFindManyWeatherServiceConfigTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumWeatherServiceConfigType>;
  gte?: InputMaybe<EnumWeatherServiceConfigType>;
  in?: InputMaybe<Array<InputMaybe<EnumWeatherServiceConfigType>>>;
  lt?: InputMaybe<EnumWeatherServiceConfigType>;
  lte?: InputMaybe<EnumWeatherServiceConfigType>;
  ne?: InputMaybe<EnumWeatherServiceConfigType>;
  nin?: InputMaybe<Array<InputMaybe<EnumWeatherServiceConfigType>>>;
};

export type FilterFindManyWeatherServiceConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyWeatherSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyWeatherTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyWeatherTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumWeatherType>;
  gte?: InputMaybe<EnumWeatherType>;
  in?: InputMaybe<Array<InputMaybe<EnumWeatherType>>>;
  lt?: InputMaybe<EnumWeatherType>;
  lte?: InputMaybe<EnumWeatherType>;
  ne?: InputMaybe<EnumWeatherType>;
  nin?: InputMaybe<Array<InputMaybe<EnumWeatherType>>>;
};

export type FilterFindManyWeather_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneReportNoteEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneReportNoteInput = {
  AND?: InputMaybe<Array<FilterFindOneReportNoteInput>>;
  OR?: InputMaybe<Array<FilterFindOneReportNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneReportNoteOperatorsInput>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  pageAppendix?: InputMaybe<FilterFindOneReportNotePageAppendixInput>;
  pageOverview?: InputMaybe<FilterFindOneReportNotePageOverviewInput>;
  pageParts?: InputMaybe<FilterFindOneReportNotePagePartsInput>;
  pageRunPlan?: InputMaybe<FilterFindOneReportNotePageRunPlanInput>;
  pageSession?: InputMaybe<FilterFindOneReportNotePageSessionInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneReportNoteOperatorsInput = {
  _id?: InputMaybe<FilterFindOneReportNote_IdOperatorsInput>;
  eventID?: InputMaybe<FilterFindOneReportNoteEventIdOperatorsInput>;
};

export type FilterFindOneReportNotePageAppendixInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindOneReportNotePageAppendixNotesInput>>>;
};

export type FilterFindOneReportNotePageAppendixNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotePageAppendixNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneReportNotePageOverviewInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindOneReportNotePageOverviewNotesInput>>>;
};

export type FilterFindOneReportNotePageOverviewNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotePageOverviewNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneReportNotePagePartsInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindOneReportNotePagePartsNotesInput>>>;
};

export type FilterFindOneReportNotePagePartsNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotePagePartsNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneReportNotePageRunPlanInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindOneReportNotePageRunPlanNotesInput>>>;
};

export type FilterFindOneReportNotePageRunPlanNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotePageRunPlanNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneReportNotePageSessionInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindOneReportNotePageSessionNotesInput>>>;
};

export type FilterFindOneReportNotePageSessionNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotePageSessionNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneReportNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestCarSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestInput = {
  AND?: InputMaybe<Array<FilterRemoveManySimRequestInput>>;
  OR?: InputMaybe<Array<FilterRemoveManySimRequestInput>>;
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterRemoveManySimRequestOperatorsInput>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  relatedSimResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  requesterSlot?: InputMaybe<EnumSimRequestRequesterSlot>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  simResultID?: InputMaybe<Scalars['MongoID']['input']>;
  simType?: InputMaybe<EnumSimRequestSimType>;
  simulationService?: InputMaybe<EnumSimModelType>;
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterRemoveManySimRequestOperatorsInput = {
  _id?: InputMaybe<FilterRemoveManySimRequest_IdOperatorsInput>;
  carSetupID?: InputMaybe<FilterRemoveManySimRequestCarSetupIdOperatorsInput>;
  requesterID?: InputMaybe<FilterRemoveManySimRequestRequesterIdOperatorsInput>;
  runSheetID?: InputMaybe<FilterRemoveManySimRequestRunSheetIdOperatorsInput>;
  simResultID?: InputMaybe<FilterRemoveManySimRequestSimResultIdOperatorsInput>;
  simType?: InputMaybe<FilterRemoveManySimRequestSimTypeOperatorsInput>;
  simulationService?: InputMaybe<FilterRemoveManySimRequestSimulationServiceOperatorsInput>;
  specificationID?: InputMaybe<FilterRemoveManySimRequestSpecificationIdOperatorsInput>;
  trackLayoutID?: InputMaybe<FilterRemoveManySimRequestTrackLayoutIdOperatorsInput>;
  version?: InputMaybe<FilterRemoveManySimRequestVersionOperatorsInput>;
};

export type FilterRemoveManySimRequestRequesterIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestSimResultIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestSimTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimRequestSimType>;
  gte?: InputMaybe<EnumSimRequestSimType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimRequestSimType>>>;
  lt?: InputMaybe<EnumSimRequestSimType>;
  lte?: InputMaybe<EnumSimRequestSimType>;
  ne?: InputMaybe<EnumSimRequestSimType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimRequestSimType>>>;
};

export type FilterRemoveManySimRequestSimulationServiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimModelType>;
  gte?: InputMaybe<EnumSimModelType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  lt?: InputMaybe<EnumSimModelType>;
  lte?: InputMaybe<EnumSimModelType>;
  ne?: InputMaybe<EnumSimModelType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
};

export type FilterRemoveManySimRequestSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestTrackLayoutIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterRemoveManySimRequest_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimResultCarSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimResultDataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  /** Sampling rate of the channel in Hz, if overriding `defaultChannelTime` without `channelTime` */
  channelSamplingRate?: InputMaybe<Scalars['Float']['input']>;
  /** Use this to override `defaultChannelTime` */
  channelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Actual channel data values */
  channelValue?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  interpolationMethod?: InputMaybe<EnumSimResultDataInterpolationMethod>;
  /** Should values in this channel be treated as timestamps? */
  isTimeChannel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display unit of channel values (e.g. m/s) */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterRemoveManySimResultInput = {
  AND?: InputMaybe<Array<FilterRemoveManySimResultInput>>;
  OR?: InputMaybe<Array<FilterRemoveManySimResultInput>>;
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterRemoveManySimResultOperatorsInput>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Array<InputMaybe<FilterRemoveManySimResultDataInput>>>;
  /** Each data channel is assumed to use this unless it specifies `channelSamplingRate` or `channelTime` */
  defaultChannelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Map containing reference values from car setup. Example: aerobalance in a car manual. Input syntax is array of key-value tuples, like `refValues: [["rAeroBalF", 48.5], ["rLatBalF", 51.4]]`. */
  refValues?: InputMaybe<Scalars['JSON']['input']>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the ORH service used to generate the sim result */
  serviceVersion?: InputMaybe<Scalars['String']['input']>;
  simType?: InputMaybe<EnumSimResultSimType>;
  simulationDriveFileID?: InputMaybe<Scalars['MongoID']['input']>;
  simulationService?: InputMaybe<EnumSimModelType>;
  /** Service which generated this sim result, for example Canopy */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Reference for this sim result, to find it in the simulation service */
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterRemoveManySimResultOperatorsInput = {
  _id?: InputMaybe<FilterRemoveManySimResult_IdOperatorsInput>;
  carSetupID?: InputMaybe<FilterRemoveManySimResultCarSetupIdOperatorsInput>;
  requesterID?: InputMaybe<FilterRemoveManySimResultRequesterIdOperatorsInput>;
  runSheetID?: InputMaybe<FilterRemoveManySimResultRunSheetIdOperatorsInput>;
  serviceVersion?: InputMaybe<FilterRemoveManySimResultServiceVersionOperatorsInput>;
  simType?: InputMaybe<FilterRemoveManySimResultSimTypeOperatorsInput>;
  simulationService?: InputMaybe<FilterRemoveManySimResultSimulationServiceOperatorsInput>;
  source?: InputMaybe<FilterRemoveManySimResultSourceOperatorsInput>;
  sourceReferenceID?: InputMaybe<FilterRemoveManySimResultSourceReferenceIdOperatorsInput>;
  specificationID?: InputMaybe<FilterRemoveManySimResultSpecificationIdOperatorsInput>;
  trackLayoutID?: InputMaybe<FilterRemoveManySimResultTrackLayoutIdOperatorsInput>;
  version?: InputMaybe<FilterRemoveManySimResultVersionOperatorsInput>;
};

export type FilterRemoveManySimResultRequesterIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimResultRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimResultServiceVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterRemoveManySimResultSimTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimResultSimType>;
  gte?: InputMaybe<EnumSimResultSimType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimResultSimType>>>;
  lt?: InputMaybe<EnumSimResultSimType>;
  lte?: InputMaybe<EnumSimResultSimType>;
  ne?: InputMaybe<EnumSimResultSimType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimResultSimType>>>;
};

export type FilterRemoveManySimResultSimulationServiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimModelType>;
  gte?: InputMaybe<EnumSimModelType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  lt?: InputMaybe<EnumSimModelType>;
  lte?: InputMaybe<EnumSimModelType>;
  ne?: InputMaybe<EnumSimModelType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
};

export type FilterRemoveManySimResultSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterRemoveManySimResultSourceReferenceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterRemoveManySimResultSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimResultTrackLayoutIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimResultVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterRemoveManySimResult_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FixAssemblyTracking = {
  deletedCount: Scalars['Int']['output'];
  insertedRecords: Array<TrackingRecord>;
};

export type FixPartInstanceArrayResult = {
  success?: Maybe<Scalars['MongoID']['output']>;
};

export type FixPartInstancesByPartId = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FixPartTrackingHistory = {
  removedRecords?: Maybe<Scalars['Int']['output']>;
};

export type FixTrackingForAssemblyParts = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FlexLayoutConfig = {
  _id: Scalars['MongoID']['output'];
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  globalXAxis?: Maybe<FlexLayoutConfigGlobalXAxis>;
  intendedFor: EnumFlexLayoutConfigIntendedFor;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  /** JSON configuration recognised by flexlayout-react */
  model?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  /** If this is non-empty, only users with one of these roles can see this config. */
  targetRoles?: Maybe<Array<EnumPersonRole>>;
  targetUserIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  targetUsers?: Maybe<Person>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type FlexLayoutConfigGlobalXAxis = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  gain?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offset?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<EnumFlexLayoutConfigGlobalXAxisType>;
};

export type FlexLayoutConfigGlobalXAxisInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  gain?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumFlexLayoutConfigGlobalXAxisType>;
};

/** List of items with pagination. */
export type FlexLayoutConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<FlexLayoutConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Force = {
  /** N */
  newtons: Scalars['Float']['output'];
  /** lbf */
  poundsForce: Scalars['Float']['output'];
};

export type ForceInput = {
  /** N */
  newtons?: InputMaybe<Scalars['Float']['input']>;
  /** lbf */
  poundsForce?: InputMaybe<Scalars['Float']['input']>;
};

export type ForceTable = {
  /** Acceleration (ddx) values */
  acceleration?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Also known as F1 */
  dampingForce?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Also known as F0 */
  force?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Also known as F2 */
  inertanceForce?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Velocity (dx) values */
  velocity?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Displacement values */
  x?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  xMax?: Maybe<Scalars['Float']['output']>;
  xMin?: Maybe<Scalars['Float']['output']>;
};

export type ForceTableInput = {
  /** Acceleration (ddx) values */
  acceleration?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F1 */
  dampingForce?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F0 */
  force?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F2 */
  inertanceForce?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Velocity (dx) values */
  velocity?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Displacement values */
  x?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  xMax?: InputMaybe<Scalars['Float']['input']>;
  xMin?: InputMaybe<Scalars['Float']['input']>;
};

export type ForceUnitField = {
  unit: EnumForceUnit;
};

export type ForgotPasswordResult = {
  result: Scalars['String']['output'];
};

export type ForwardUpsertPartInstanceResult = {
  updatedPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type Frequency = {
  /** Hz */
  hertz: Scalars['Float']['output'];
  /** kHz */
  kilohertz: Scalars['Float']['output'];
  /** MHz */
  megahertz: Scalars['Float']['output'];
};

export type FrequencyInput = {
  /** Hz */
  hertz?: InputMaybe<Scalars['Float']['input']>;
  /** kHz */
  kilohertz?: InputMaybe<Scalars['Float']['input']>;
  /** MHz */
  megahertz?: InputMaybe<Scalars['Float']['input']>;
};

export type FuelBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Specify EnumFuelColumn.ENERGY_TYPE in `fuelColumns` instead */
  energyType?: Maybe<EnumEnergyType>;
  fuelColumns?: Maybe<Array<EnumFuelColumn>>;
  /** @deprecated Use runEnergyFields instead */
  fuelFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** Order in which to display visible run energy fields. */
  runEnergyFieldOrder?: Maybe<Array<EnumRunEnergyField>>;
  runEnergyFields?: Maybe<RunEnergyFieldLabels>;
  /**
   * Show the extended combustion consumption fields.
   * @deprecated Specify EnumFuelColumn.EXTENDED_CONSUMPTION in `fuelColumns` instead.
   */
  showExtendedConsumptionFields?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Show the fuel density input box.
   * @deprecated Specify EnumFuelColumn.FUEL_DENSITY in `fuelColumns` instead.
   */
  showFuelDensityInput?: Maybe<Scalars['Boolean']['output']>;
  /** Show the maximum amount of laps per consumption for a given fuel load fields. */
  showMaxLapsPerConsumptionFields?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use other fields to style the block instead */
  style?: Maybe<EnumRunSheetStyleBlockStyle>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type GearBoxSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: Maybe<Array<Maybe<AssignedGear>>>;
  bevelSetSpec?: Maybe<GearSpec>;
  bevelSetSpecID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  differentialSpec?: Maybe<DifferentialSpec>;
  differentialSpecID?: Maybe<Scalars['MongoID']['output']>;
  dropGearSpec?: Maybe<GearSpec>;
  dropGearSpecID?: Maybe<Scalars['MongoID']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  headGearSpec?: Maybe<GearSpec>;
  headGearSpecID?: Maybe<Scalars['MongoID']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<GearBoxSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type GearSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  denominator: Scalars['Float']['output'];
  gearType?: Maybe<EnumGearType>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /**
   * If true, this gear is the head gear of the gear box, applies to standard gears only
   * @deprecated Use `useHeadGear` boolean inside a GearBox instead.
   */
  isHeadGear?: Maybe<Scalars['Boolean']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<GearSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  numerator: Scalars['Float']['output'];
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type GenericRunSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  blockBackgroundColour?: InputMaybe<Scalars['String']['input']>;
  brakeFields?: InputMaybe<Array<InputMaybe<EnumBrakeBlockField>>>;
  /** A map of colorable things to colors */
  colorMap?: InputMaybe<Scalars['JSON']['input']>;
  defaultOpenState?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order in which to display visible run energy fields. */
  energyFieldOrder?: InputMaybe<Array<InputMaybe<EnumGenericRunSheetStyleBlockEnergyFieldOrder>>>;
  /** Source of the lap end energy value */
  energyLapEndSource?: InputMaybe<Scalars['String']['input']>;
  energyType?: InputMaybe<EnumEnergyType>;
  field?: InputMaybe<Scalars['String']['input']>;
  /** Field name for first comment box in a double comment block. */
  field1?: InputMaybe<Scalars['String']['input']>;
  /** Field name for second comment box in a double comment block. */
  field2?: InputMaybe<Scalars['String']['input']>;
  fuelColumns?: InputMaybe<Array<EnumFuelColumn>>;
  fuelFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The height of the block within the grid */
  height?: InputMaybe<Scalars['Int']['input']>;
  isAlwaysOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isShownWhenFolded?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Label on first comment box in a double comment block. */
  label1?: InputMaybe<Scalars['String']['input']>;
  /** Label on second comment box in a double comment block. */
  label2?: InputMaybe<Scalars['String']['input']>;
  /** Ordered columns to show in the lap table */
  lapColumns?: InputMaybe<Array<InputMaybe<LapColumnInput>>>;
  lapCountBlockFieldOrder?: InputMaybe<Array<InputMaybe<GenericRunSheetStyleBlockLapCountBlockFieldOrderInput>>>;
  lapFlags?: InputMaybe<LapFlagLabelsInput>;
  /** Names of lapKPI fields to show */
  lapKPIs?: InputMaybe<Array<InputMaybe<GenericRunSheetStyleBlockLapKpIsInput>>>;
  manualLapInputByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  mileageUnit?: InputMaybe<EnumLengthUnit>;
  pressureUnit?: InputMaybe<EnumPressureUnit>;
  rows?: InputMaybe<Scalars['Float']['input']>;
  /** Order in which to display visible run energy fields. */
  runEnergyFieldOrder?: InputMaybe<Array<EnumRunEnergyField>>;
  runEnergyFields?: InputMaybe<RunEnergyFieldLabelsInput>;
  runKPIRows?: InputMaybe<Array<InputMaybe<RunKpiTableRowInput>>>;
  runKPITable?: InputMaybe<Array<InputMaybe<GenericRunSheetStyleBlockRunKpiTableInput>>>;
  setupSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Defines the visibility of the ambient and track condition in the weather block */
  showAmbientAndTrackCondition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the extended combustion consumption fields. */
  showExtendedConsumptionFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the fuel density input box. */
  showFuelDensityInput?: InputMaybe<Scalars['Boolean']['input']>;
  showGetPreviousRunPostPressureButton?: InputMaybe<Scalars['Boolean']['input']>;
  showGetRecommendationButton?: InputMaybe<Scalars['Boolean']['input']>;
  showLapTypeColors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the maximum amount of laps per consumption for a given fuel load fields. */
  showMaxLapsPerConsumptionFields?: InputMaybe<Scalars['Boolean']['input']>;
  showMinimumPressures?: InputMaybe<Scalars['Boolean']['input']>;
  showOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  showPostRunBrakeTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showPreRunBrakeTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showSurfaceTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showTargetPressures?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreReferencePressure?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreSelector?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreSetSelector?: InputMaybe<Scalars['Boolean']['input']>;
  staggerSettings?: InputMaybe<GenericRunSheetStyleBlockStaggerSettingsInput>;
  standardTyrePressureBox?: InputMaybe<GenericRunSheetStyleBlockStandardTyrePressureBoxInput>;
  standardTyreTempBox?: InputMaybe<GenericRunSheetStyleBlockStandardTyreTempBoxInput>;
  style?: InputMaybe<EnumRunSheetStyleBlockStyle>;
  temperatureUnit?: InputMaybe<EnumTemperatureUnit>;
  title?: InputMaybe<Scalars['String']['input']>;
  treadDepthUnit?: InputMaybe<EnumLengthUnit>;
  type: EnumGenericRunSheetStyleBlockType;
  tyreTableRows?: InputMaybe<Array<InputMaybe<TyreTableBlockRowInput>>>;
  /** Number of tread depth measurements to allow. Use `0` or `null` to hide the input. */
  tyreTreadDepthMeasurements?: InputMaybe<Scalars['Int']['input']>;
  unitSystem?: InputMaybe<EnumUnitSystem>;
  velocityUnit?: InputMaybe<EnumVelocityUnit>;
  /** Ordered weather block fields to show */
  weatherFieldOrder?: InputMaybe<Array<EnumWeatherBlockField>>;
  /** The width of the block within the grid */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type GenericRunSheetStyleBlockLapCountBlockFieldOrder = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  field?: Maybe<EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField>;
  show?: Maybe<Scalars['Boolean']['output']>;
};

export type GenericRunSheetStyleBlockLapCountBlockFieldOrderInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  field?: InputMaybe<EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField>;
  show?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenericRunSheetStyleBlockLapKpIs = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  lowerLimit?: Maybe<ValueLimit>;
  upperLimit?: Maybe<ValueLimit>;
};

export type GenericRunSheetStyleBlockLapKpIsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<ValueLimitInput>;
  upperLimit?: InputMaybe<ValueLimitInput>;
};

export type GenericRunSheetStyleBlockRunKpiTable = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Default background color for the cell/s. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  defaultEditable?: Maybe<Scalars['Boolean']['output']>;
  rows?: Maybe<Array<Maybe<GenericRunSheetStyleBlockRunKpiTableRows>>>;
};

export type GenericRunSheetStyleBlockRunKpiTableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  defaultEditable?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<InputMaybe<GenericRunSheetStyleBlockRunKpiTableRowsInput>>>;
};

export type GenericRunSheetStyleBlockRunKpiTableRows = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Default background color for the cell/s. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<RunKpiTableRowField>>>;
  label?: Maybe<Scalars['String']['output']>;
};

export type GenericRunSheetStyleBlockRunKpiTableRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<RunKpiTableRowFieldInput>>>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type GenericRunSheetStyleBlockStaggerSettingsInput = {
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumLengthUnit>;
};

export type GenericRunSheetStyleBlockStandardTyrePressureBoxInput = {
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<EnumPressureOption>>>;
  unit?: InputMaybe<EnumPressureUnit>;
};

export type GenericRunSheetStyleBlockStandardTyreTempBoxInput = {
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<EnumTemperatureOption>>>;
  unit?: InputMaybe<EnumTemperatureUnit>;
};

export type GeoLocation = {
  /** [longitude, latitude] in decimal degrees */
  coordinates: Array<Maybe<Scalars['Float']['output']>>;
  /** Only "Point" is supported */
  type: EnumGeoLocationType;
};

export type GeoLocationInput = {
  /** [longitude, latitude] in decimal degrees */
  coordinates: Array<InputMaybe<Scalars['Float']['input']>>;
  /** Only "Point" is supported */
  type: EnumGeoLocationType;
};

export type GeoNear = {
  /** Latitude of the coordinates to search near. */
  lat: Scalars['Float']['input'];
  /** Longitude of the coordinates to search near. */
  long: Scalars['Float']['input'];
  /** Radius around the given coordinates in kilometres. */
  radius: Scalars['Float']['input'];
};

export type GreeboLog = {
  _id: Scalars['MongoID']['output'];
  /** Real time car positions on track */
  carPositions?: Maybe<Array<Maybe<CarTrackPosition>>>;
  /** Only specify if this is a greebo log for an entire event */
  eventID?: Maybe<Scalars['String']['output']>;
  /** GPS data from Greebo */
  gpsData?: Maybe<Array<Maybe<CarGpsDataPoint>>>;
  /** Unprocessed lines from Greebo */
  rawLines?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sessionID?: Maybe<Scalars['String']['output']>;
};

export type History = {
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<EnumHistoryType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<Person>;
  userID?: Maybe<Scalars['MongoID']['output']>;
  valuesChanged?: Maybe<Array<Maybe<HistoryValuesChanged>>>;
};

export type HistoryValuesChanged = {
  field?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type IncrementRunSheetPayload = {
  isNewRunSheet?: Maybe<Scalars['Boolean']['output']>;
  runSheet: RunSheet;
};

export type IncrementSpecificationResult = {
  existingSpec?: Maybe<NonChassisSpecificationUnion>;
  iteratedSpec?: Maybe<NonChassisSpecificationUnion>;
};

export type InertiaUnitField = {
  unit: EnumInertiaUnit;
};

export type InsertRunPayload = {
  message?: Maybe<Scalars['String']['output']>;
  newRunSheetID?: Maybe<Scalars['MongoID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Issue = {
  _id: Scalars['MongoID']['output'];
  acknowledgedAt?: Maybe<Scalars['Date']['output']>;
  acknowledgedByID?: Maybe<Scalars['MongoID']['output']>;
  area?: Maybe<Scalars['String']['output']>;
  assigneeIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  cancelledByID?: Maybe<Scalars['MongoID']['output']>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['Date']['output']>;
  closedByID?: Maybe<Scalars['MongoID']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  containment?: Maybe<Scalars['String']['output']>;
  contestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdByID?: Maybe<Scalars['MongoID']['output']>;
  departmentID?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  descriptionDetails?: Maybe<Scalars['String']['output']>;
  eventID?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  issueStatus?: Maybe<EnumIssueIssueStatus>;
  linkedIssueIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  number?: Maybe<Scalars['String']['output']>;
  part?: Maybe<Part>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  primaryTagID?: Maybe<Scalars['MongoID']['output']>;
  primaryTagLabelSort?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<EnumIssuePriority>;
  raceSeriesID?: Maybe<Scalars['MongoID']['output']>;
  rootCause?: Maybe<Scalars['String']['output']>;
  /** ID of run sheet associated with this job */
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  seasonID?: Maybe<Scalars['MongoID']['output']>;
  sessionID?: Maybe<Scalars['MongoID']['output']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: Maybe<Scalars['Date']['output']>;
  teamIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  thirdPartyIssueID?: Maybe<Scalars['MongoID']['output']>;
  /** Reference to a car data timestamp */
  timeInfo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export const IssueAction = {
  CLOSE: 'CLOSE',
  REOPEN: 'REOPEN'
} as const;

export type IssueAction = typeof IssueAction[keyof typeof IssueAction];
export type IssueBlock = {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type IssueQuery = {
  _id: Scalars['MongoID']['output'];
  acknowledgedAt?: Maybe<Scalars['Date']['output']>;
  acknowledgedBy?: Maybe<Person>;
  acknowledgedByID?: Maybe<Scalars['MongoID']['output']>;
  area?: Maybe<Scalars['String']['output']>;
  assigneeIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignees: Array<Person>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  cancelledBy?: Maybe<Person>;
  cancelledByID?: Maybe<Scalars['MongoID']['output']>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['Date']['output']>;
  closedBy?: Maybe<Person>;
  closedByID?: Maybe<Scalars['MongoID']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  containment?: Maybe<Scalars['String']['output']>;
  contestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  contestants: Array<Contestant>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Person>;
  createdByID?: Maybe<Scalars['MongoID']['output']>;
  department?: Maybe<Department>;
  departmentID?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  descriptionDetails?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  issueStatus?: Maybe<EnumIssueQueryIssueStatus>;
  linkedIssueIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  number?: Maybe<Scalars['String']['output']>;
  oneWordStatus: IssueStatus;
  partID?: Maybe<Scalars['MongoID']['output']>;
  primaryTagID?: Maybe<Scalars['MongoID']['output']>;
  primaryTagLabelSort?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<EnumIssueQueryPriority>;
  raceSeries?: Maybe<RaceSeries>;
  raceSeriesID?: Maybe<Scalars['MongoID']['output']>;
  rootCause?: Maybe<Scalars['String']['output']>;
  runSheet?: Maybe<RunSheet>;
  /** ID of run sheet associated with this job */
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  season?: Maybe<Season>;
  seasonID?: Maybe<Scalars['MongoID']['output']>;
  session?: Maybe<Session>;
  sessionID?: Maybe<Scalars['MongoID']['output']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  subTasks: Array<Job>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** Date by which the issue should be resolved */
  targetDate?: Maybe<Scalars['Date']['output']>;
  teamIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  teams: Array<Team>;
  thirdPartyIssueID?: Maybe<Scalars['MongoID']['output']>;
  /** Reference to a car data timestamp */
  timeInfo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type IssueQueryPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<IssueQuery>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export const IssueStatus = {
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  CANCELLED: 'CANCELLED',
  CLOSED: 'CLOSED',
  OPEN: 'OPEN'
} as const;

export type IssueStatus = typeof IssueStatus[keyof typeof IssueStatus];
export type Job = {
  _id: Scalars['MongoID']['output'];
  acknowledgedAt?: Maybe<Scalars['Date']['output']>;
  acknowledgedBy?: Maybe<Person>;
  acknowledgedByID?: Maybe<Scalars['MongoID']['output']>;
  assigneeIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignees: Array<Person>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  cancelledBy?: Maybe<Person>;
  cancelledByID?: Maybe<Scalars['MongoID']['output']>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['Date']['output']>;
  closedBy?: Maybe<Person>;
  closedByID?: Maybe<Scalars['MongoID']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Person>;
  createdByID?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  oneWordStatus: JobStatus;
  /** The id of the parent job or issue that this task is assigned to */
  parentID?: Maybe<Scalars['MongoID']['output']>;
  /** Parent issue that this task is assigned to */
  parentIssue?: Maybe<Issue>;
  /** Parent job or issue that this task is assigned to */
  parentJob?: Maybe<Job>;
  priority?: Maybe<EnumJobPriority>;
  /** Run sheet associated with this job */
  runSheet?: Maybe<RunSheet>;
  /** ID of run sheet associated with this job */
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  subTasks: Array<Job>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  /** Date by which the issue should be resolved */
  targetDate?: Maybe<Scalars['Date']['output']>;
  /** Reference to a car data timestamp */
  timeInfo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export const JobAction = {
  ACKNOWLEDGE: 'ACKNOWLEDGE',
  CANCEL: 'CANCEL',
  CLOSE: 'CLOSE',
  REINSTATE: 'REINSTATE',
  REOPEN: 'REOPEN',
  UNACKNOWLEDGE: 'UNACKNOWLEDGE'
} as const;

export type JobAction = typeof JobAction[keyof typeof JobAction];
export type JobListBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

/** List of items with pagination. */
export type JobPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Job>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export const JobStatus = {
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  CANCELLED: 'CANCELLED',
  CLOSED: 'CLOSED',
  OPEN: 'OPEN'
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];
export type Kinematics = {
  /** Polynomial motion ratio. Limit to 5th order. */
  motionRatioPoly?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Map of damper travel (xDamper) to wheel travel (wWheel) in metres. Input syntax is array of key-value tuples, like `motionRatioTable: [["0", 0], ["0.001", 0.0005], ["0.002", 0.001]]`. */
  motionRatioTable?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type KinematicsExternalModel = {
  aCaster?: Maybe<Scalars['Float']['output']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  uprightPosition?: Maybe<Scalars['Float']['output']>;
  uprightPositionName?: Maybe<Scalars['String']['output']>;
};

export type KinematicsExternalModelInput = {
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  uprightPosition?: InputMaybe<Scalars['Float']['input']>;
  uprightPositionName?: InputMaybe<Scalars['String']['input']>;
};

export type KinematicsExternalSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  aCamber?: Maybe<SpecificationACamber>;
  aCaster?: Maybe<SpecificationACamber>;
  aCasterMeasurementGain?: Maybe<Scalars['Float']['output']>;
  aCasterMeasurementOffset?: Maybe<Scalars['Float']['output']>;
  aToe?: Maybe<SpecificationACamber>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  axle?: Maybe<EnumAxle>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hRide?: Maybe<SpecificationHRide>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<KinematicsExternalSpec>;
  kinematicsExternalModels?: Maybe<Array<Maybe<KinematicsExternalModel>>>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  xToe?: Maybe<SpecificationHRide>;
};

export type KinematicsInput = {
  /** Polynomial motion ratio. Limit to 5th order. */
  motionRatioPoly?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Map of damper travel (xDamper) to wheel travel (wWheel) in metres. Input syntax is array of key-value tuples, like `motionRatioTable: [["0", 0], ["0.001", 0.0005], ["0.002", 0.001]]`. */
  motionRatioTable?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type KinematicsInternalSpec = AnySpecification & NonChassisSpec & {
  FSpringSetup?: Maybe<AdjustableForce>;
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  axle?: Maybe<EnumAxle>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  bumpRubberReference?: Maybe<EnumKinematicsInternalReference>;
  bumpStopGapMethod?: Maybe<EnumBumpStopGapMethod>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<KinematicsInternalSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  springReference?: Maybe<EnumKinematicsInternalReference>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  xBumpRubberRef?: Maybe<Scalars['Float']['output']>;
  xBumpRubberSetup?: Maybe<AdjustableLength>;
  xDamperDroopDefault?: Maybe<Scalars['Float']['output']>;
  xSpringPlatformOffset?: Maybe<Scalars['Float']['output']>;
  xSpringRef?: Maybe<Scalars['Float']['output']>;
  xSpringSetup?: Maybe<AdjustableLength>;
};

export type Lap = {
  /**
   * Was DRS used in this lap?
   * @deprecated Use `data` instead.
   */
  BDRSUsed?: Maybe<Scalars['Boolean']['output']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: Maybe<Scalars['Boolean']['output']>;
  /** Is this laptime slow? */
  BLapIsSlow?: Maybe<Scalars['Boolean']['output']>;
  /** Is this an IN lap? */
  BPitIn: Scalars['Boolean']['output'];
  /** Is this an OUT lap? */
  BPitOut: Scalars['Boolean']['output'];
  /** Lap number in run from timing */
  NLapRun: Scalars['Float']['output'];
  /** Lap number in run from car data */
  NLapRunCarData?: Maybe<Scalars['Float']['output']>;
  /** Lap number in run from manual mode */
  NLapRunManual?: Maybe<Scalars['Float']['output']>;
  /** Lap number in session from timing */
  NLapSession?: Maybe<Scalars['Int']['output']>;
  /** Lap number in session from car data */
  NLapSessionCarData?: Maybe<Scalars['Float']['output']>;
  /** Lap number in session from manual mode */
  NLapSessionManual?: Maybe<Scalars['Float']['output']>;
  /** Lap number in stint from timing */
  NLapStint?: Maybe<Scalars['Float']['output']>;
  /** Lap number in stint from car data */
  NLapStintCarData?: Maybe<Scalars['Float']['output']>;
  /** Lap number in stint from manual mode */
  NLapStintManual?: Maybe<Scalars['Float']['output']>;
  /**
   * Cell temperature
   * @deprecated Use `data` instead.
   */
  TCell?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  /** The contestant this lap belongs to. */
  contestantID: Scalars['MongoID']['output'];
  data?: Maybe<Array<Maybe<LapData>>>;
  /**
   * Amount of energy (fuel/battery) at the start of this lap.
   * @deprecated Use `data` instead.
   */
  energyLapStart?: Maybe<Scalars['Float']['output']>;
  /**
   * Energy or fuel remaining
   * @deprecated Use `data` instead.
   */
  energyRemaining?: Maybe<Scalars['Float']['output']>;
  /**
   * Energy or fuel remaining as data input (e.g. from telemetry)
   * @deprecated Use `data` instead.
   */
  energyRemainingData?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use mFuelConsumptionThisLap instead. */
  fuelConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** Comments made by the driver */
  lapComment?: Maybe<Scalars['String']['output']>;
  /** Systems info generated during the lap */
  lapCommentSystems?: Maybe<Scalars['String']['output']>;
  /**
   * Map of lap KPI fields to their values for car-data-related analysis. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data.
   * @deprecated Use `data` instead.
   */
  lapKPI?: Maybe<Scalars['JSON']['output']>;
  lapType?: Maybe<EnumLapType>;
  laptimeServiceHash?: Maybe<Scalars['String']['output']>;
  /** Resolved fuel consumption for this lap MANUAL >> DATA */
  mFuelConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** Resolved fuel load at lap end MANUAL >> DATA */
  mFuelLapEnd?: Maybe<Scalars['Float']['output']>;
  /**
   * Fuel mass remaining at the start of this lap.
   * @deprecated Use `data` instead.
   */
  mFuelLapStart?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  /**
   * Highest power mode used this lap (for electric vehicles).
   * @deprecated Use `data` instead.
   */
  powerMode?: Maybe<Scalars['Float']['output']>;
  /** Resolved energy consumption for this lap MANUAL >> DATA (negative = charge) */
  rEnergyConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** Resolved total energy used at lap end MANUAL >> DATA */
  rEnergyLapEnd?: Maybe<Scalars['Float']['output']>;
  /**
   * Energy remaining at the start of this lap.
   * @deprecated Use `data` instead.
   */
  rEnergyLapStart?: Maybe<Scalars['Float']['output']>;
  /** Resolved state of charge consumption for this lap MANUAL >> DATA (negative = charge) */
  rSOCConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** Resolved state of charge at lap end MANUAL >> DATA */
  rSOCLapEnd?: Maybe<Scalars['Float']['output']>;
  /**
   * SOC remaining at the start of this lap.
   * @deprecated Use `data` instead.
   */
  rSOCLapStart?: Maybe<Scalars['Float']['output']>;
  raceControlMessage?: Maybe<Scalars['String']['output']>;
  /** The run sheet this lap belongs to. */
  runSheetID: Scalars['MongoID']['output'];
  /** The session this lap belongs to. */
  sessionID: Scalars['MongoID']['output'];
  /** Resolved daytime. Either from Timing or calculated from runsheet start time and laptimes up to this point in time */
  tDay?: Maybe<Scalars['Date']['output']>;
  /**
   * If this is an IN lap, indicates when the driver crossed the pit entry line.
   * @deprecated Use `data` instead.
   */
  tDayPitIn?: Maybe<Scalars['Date']['output']>;
  /**
   * If this is an OUT lap, indicates when the driver crossed the pit exit line.
   * @deprecated Use `data` instead.
   */
  tDayPitOut?: Maybe<Scalars['Date']['output']>;
  /**
   * Time of day of each sector, provided by a timing service.
   * @deprecated Use `data` instead.
   */
  tDaySectors?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  /** Laptime where input directly by a user. */
  tLapManual?: Maybe<Scalars['Float']['output']>;
  /** Laptime */
  tLapMax?: Maybe<Scalars['Float']['output']>;
  /**
   * Sectore times given manually by a user.
   * @deprecated Use `data` instead.
   */
  tSectorsManual?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /**
   * Sector times as given by an alternative official source.
   * @deprecated Use `data` instead.
   */
  tSectorsOfficial?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /**
   * Sector times as given by a timing service.
   * @deprecated Use `data` instead.
   */
  tSectorsTiming?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  /**
   * Map of timing KPI fields to their values for timing-related analysis. Input syntax is array of tuples, like `timingKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data.
   * @deprecated Use `data` instead.
   */
  timingKPI?: Maybe<Scalars['JSON']['output']>;
  trackLayout?: Maybe<TrackLayout>;
  trackLayoutID?: Maybe<Scalars['MongoID']['output']>;
  /** @deprecated Use `data` instead. */
  trackStates?: Maybe<Array<Maybe<TrackState>>>;
  /**
   * Tyre compound information from timing stream
   * @deprecated Use `data` instead.
   */
  tyreCompoundTiming?: Maybe<Scalars['String']['output']>;
  /**
   * Official topspeed measurement
   * @deprecated Use `data` instead.
   */
  vCarLapMax?: Maybe<Scalars['Float']['output']>;
  /**
   * Official speed measurements per sector
   * @deprecated Use `data` instead.
   */
  vCarSectors?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};


export type LapLapKpiArgs = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type LapTimingKpiArgs = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LapColumn = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  field: EnumLapColumnField;
  label?: Maybe<Scalars['String']['output']>;
  lowerLimit?: Maybe<ValueLimit>;
  upperLimit?: Maybe<ValueLimit>;
};

export type LapColumnInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field: EnumLapColumnField;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<ValueLimitInput>;
  upperLimit?: InputMaybe<ValueLimitInput>;
};

export type LapData = {
  /** Was DRS used in this lap? */
  BDRSUsed?: Maybe<Scalars['Boolean']['output']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: Maybe<Scalars['Boolean']['output']>;
  /** Is this laptime slow and should be excluded from average calculation? */
  BLapIsSlow?: Maybe<Scalars['Boolean']['output']>;
  /** Received a Track Limit Warning from Race Control */
  BTrackLimitWarning?: Maybe<Scalars['Boolean']['output']>;
  /** Cell temperature */
  TCell?: Maybe<Scalars['Float']['output']>;
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Coded message from driver */
  driverCallout?: Maybe<Scalars['String']['output']>;
  /** Coded message from driver */
  driverCallout2?: Maybe<Scalars['String']['output']>;
  /** Map of kpi fields to their values for analysis. Input syntax is array of tuples, like `kpi: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  kpi?: Maybe<Scalars['JSON']['output']>;
  lapType?: Maybe<EnumLapType>;
  /** Fuel mass consumption in this lap */
  mFuelConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel mass remaining at the end of this lap. */
  mFuelLapEnd?: Maybe<Scalars['Float']['output']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: Maybe<Scalars['Float']['output']>;
  /** Energy comsumption in this lap (kWh) */
  rEnergyConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** Energy remaining (kWh)  at the end of this lap. */
  rEnergyLapEnd?: Maybe<Scalars['Float']['output']>;
  /** SoC comsumption in this lap (%) */
  rSOCConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** SOC (%) remaining at the end of this lap. */
  rSOCLapEnd?: Maybe<Scalars['Float']['output']>;
  raceControlMessage?: Maybe<Scalars['String']['output']>;
  /** Source of the lap data */
  source: EnumLapDataSource;
  /** Time at which this lap was completed. */
  tDay?: Maybe<Scalars['Date']['output']>;
  /** If this is an IN lap, indicates when the driver crossed the pit entry line. */
  tDayPitIn?: Maybe<Scalars['Date']['output']>;
  /** If this is an OUT lap, indicates when the driver crossed the pit exit line. */
  tDayPitOut?: Maybe<Scalars['Date']['output']>;
  /** Time of day of each sector. */
  tDaySectors?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  /** Time spent in pits if the lap started from the pit lane. */
  tInPit?: Maybe<Scalars['Float']['output']>;
  /** Laptime */
  tLapMax?: Maybe<Scalars['Float']['output']>;
  /** Sectore times. */
  tSectors?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  tSessionRemainingLapStart?: Maybe<Scalars['Float']['output']>;
  trackStates?: Maybe<Array<Maybe<TrackState>>>;
  /** Tyre compound information */
  tyreCompound?: Maybe<Scalars['String']['output']>;
  /** Official topspeed measurement */
  vCarLapMax?: Maybe<Scalars['Float']['output']>;
  /** Official speed measurements per sector */
  vCarSectors?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type LapDataInput = {
  /** Was DRS used in this lap? */
  BDRSUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this laptime slow and should be excluded from average calculation? */
  BLapIsSlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Received a Track Limit Warning from Race Control */
  BTrackLimitWarning?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cell temperature */
  TCell?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Coded message from driver */
  driverCallout?: InputMaybe<Scalars['String']['input']>;
  /** Coded message from driver */
  driverCallout2?: InputMaybe<Scalars['String']['input']>;
  /** Map of kpi fields to their values for analysis. Input syntax is array of tuples, like `kpi: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  kpi?: InputMaybe<Scalars['JSON']['input']>;
  lapType?: InputMaybe<Scalars['String']['input']>;
  /** Fuel mass consumption in this lap */
  mFuelConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel mass remaining at the end of this lap. */
  mFuelLapEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: InputMaybe<Scalars['Float']['input']>;
  /** Energy comsumption in this lap (kWh) */
  rEnergyConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Energy remaining (kWh)  at the end of this lap. */
  rEnergyLapEnd?: InputMaybe<Scalars['Float']['input']>;
  /** SoC comsumption in this lap (%) */
  rSOCConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** SOC (%) remaining at the end of this lap. */
  rSOCLapEnd?: InputMaybe<Scalars['Float']['input']>;
  raceControlMessage?: InputMaybe<Scalars['String']['input']>;
  /** Source of the lap data */
  source: EnumLapDataSource;
  /** Time at which this lap was completed. */
  tDay?: InputMaybe<Scalars['Date']['input']>;
  /** If this is an IN lap, indicates when the driver crossed the pit entry line. */
  tDayPitIn?: InputMaybe<Scalars['Date']['input']>;
  /** If this is an OUT lap, indicates when the driver crossed the pit exit line. */
  tDayPitOut?: InputMaybe<Scalars['Date']['input']>;
  /** Time of day of each sector. */
  tDaySectors?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** Time spent in pits if the lap started from the pit lane. */
  tInPit?: InputMaybe<Scalars['Float']['input']>;
  /** Laptime */
  tLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Sectore times. */
  tSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tSessionRemainingLapStart?: InputMaybe<Scalars['Float']['input']>;
  trackStates?: InputMaybe<Array<InputMaybe<TrackStateInput>>>;
  /** Tyre compound information */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
  /** Official topspeed measurement */
  vCarLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Official speed measurements per sector */
  vCarSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** Lap flag field labels mapped to their display names. Null or unset fields are not displayed. */
export type LapFlagLabels = {
  ATTACK?: Maybe<Scalars['String']['output']>;
  COOL?: Maybe<Scalars['String']['output']>;
  FCY?: Maybe<Scalars['String']['output']>;
  IN?: Maybe<Scalars['String']['output']>;
  OUT?: Maybe<Scalars['String']['output']>;
  OUTIN?: Maybe<Scalars['String']['output']>;
  PITLANE?: Maybe<Scalars['String']['output']>;
  PREP?: Maybe<Scalars['String']['output']>;
  PUSH?: Maybe<Scalars['String']['output']>;
  QUALI?: Maybe<Scalars['String']['output']>;
  SAFETYCAR?: Maybe<Scalars['String']['output']>;
  SHAKEDOWN?: Maybe<Scalars['String']['output']>;
  SLOW?: Maybe<Scalars['String']['output']>;
  TARGET?: Maybe<Scalars['String']['output']>;
  TOGRID?: Maybe<Scalars['String']['output']>;
  TOPADDOCK?: Maybe<Scalars['String']['output']>;
  TOPITS?: Maybe<Scalars['String']['output']>;
  UNFINISHED?: Maybe<Scalars['String']['output']>;
};

/** Lap flag field labels mapped to their display names. Null or unset fields are not displayed. */
export type LapFlagLabelsInput = {
  ATTACK?: InputMaybe<Scalars['String']['input']>;
  COOL?: InputMaybe<Scalars['String']['input']>;
  FCY?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Scalars['String']['input']>;
  OUT?: InputMaybe<Scalars['String']['input']>;
  OUTIN?: InputMaybe<Scalars['String']['input']>;
  PITLANE?: InputMaybe<Scalars['String']['input']>;
  PREP?: InputMaybe<Scalars['String']['input']>;
  PUSH?: InputMaybe<Scalars['String']['input']>;
  QUALI?: InputMaybe<Scalars['String']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['String']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['String']['input']>;
  SLOW?: InputMaybe<Scalars['String']['input']>;
  TARGET?: InputMaybe<Scalars['String']['input']>;
  TOGRID?: InputMaybe<Scalars['String']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['String']['input']>;
  TOPITS?: InputMaybe<Scalars['String']['input']>;
  UNFINISHED?: InputMaybe<Scalars['String']['input']>;
};

export type LapInput = {
  /** Was DRS used in this lap? */
  BDRSUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this laptime slow? */
  BLapIsSlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this an IN lap? */
  BPitIn: Scalars['Boolean']['input'];
  /** Is this an OUT lap? */
  BPitOut: Scalars['Boolean']['input'];
  /** Lap number in run from timing */
  NLapRun: Scalars['Float']['input'];
  /** Lap number in run from car data */
  NLapRunCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in run from manual mode */
  NLapRunManual?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in session from timing */
  NLapSession?: InputMaybe<Scalars['Int']['input']>;
  /** Lap number in session from car data */
  NLapSessionCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in session from manual mode */
  NLapSessionManual?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from timing */
  NLapStint?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from car data */
  NLapStintCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from manual mode */
  NLapStintManual?: InputMaybe<Scalars['Float']['input']>;
  /** Cell temperature */
  TCell?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Array<InputMaybe<LapDataInput>>>;
  /** Amount of energy (fuel/battery) at the start of this lap. */
  energyLapStart?: InputMaybe<Scalars['Float']['input']>;
  /** Energy or fuel remaining */
  energyRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** Energy or fuel remaining as data input (e.g. from telemetry) */
  energyRemainingData?: InputMaybe<Scalars['Float']['input']>;
  fuelConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Comments made by the driver */
  lapComment?: InputMaybe<Scalars['String']['input']>;
  /** Systems info generated during the lap */
  lapCommentSystems?: InputMaybe<Scalars['String']['input']>;
  /** Map of lap KPI fields to their values for car-data-related analysis. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  lapKPI?: InputMaybe<Scalars['JSON']['input']>;
  lapType?: InputMaybe<Scalars['String']['input']>;
  laptimeServiceHash?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: InputMaybe<Scalars['Float']['input']>;
  rEnergyConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  rSOCConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  raceControlMessage?: InputMaybe<Scalars['String']['input']>;
  /** The run sheet this lap belongs to. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time at which this lap was completed. */
  tDay?: InputMaybe<Scalars['Date']['input']>;
  /** Time of day of each sector, provided by a timing service. */
  tDaySectors?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** Laptime where input directly by a user. */
  tLapManual?: InputMaybe<Scalars['Float']['input']>;
  /** Laptime */
  tLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Sectore times given manually by a user. */
  tSectorsManual?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Sector times as given by an alternative official source. */
  tSectorsOfficial?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Sector times as given by a timing service. */
  tSectorsTiming?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Map of timing KPI fields to their values for timing-related analysis. Input syntax is array of tuples, like `timingKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  timingKPI?: InputMaybe<Scalars['JSON']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  trackStates?: InputMaybe<Array<InputMaybe<TrackStateInput>>>;
  /** Tyre compound information from timing stream */
  tyreCompoundTiming?: InputMaybe<Scalars['String']['input']>;
  /** Official topspeed measurement */
  vCarLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Official speed measurements per sector */
  vCarSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** List of items with pagination. */
export type LapPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Lap>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type LapSequence = {
  _id: Scalars['MongoID']['output'];
  laps: Array<Maybe<LapSequenceLaps>>;
  name: Scalars['String']['output'];
  raceSeriesID?: Maybe<Scalars['MongoID']['output']>;
};

export type LapSequenceLaps = {
  NLap: Scalars['Float']['output'];
  _id?: Maybe<Scalars['MongoID']['output']>;
  lapType: EnumLapSequenceLapsLapType;
};

export type LapSequenceLapsInput = {
  NLap: Scalars['Float']['input'];
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lapType: EnumLapSequenceLapsLapType;
};

/** List of items with pagination. */
export type LapSequencePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<LapSequence>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type LapSequenceTemplate = {
  _id: Scalars['MongoID']['output'];
  laps?: Maybe<Array<Maybe<LapSequenceTemplateLaps>>>;
  name: Scalars['String']['output'];
  raceSeriesID?: Maybe<Scalars['MongoID']['output']>;
};

export type LapSequenceTemplateLaps = {
  /** Lap number in sequence */
  NLap: Scalars['Float']['output'];
  lapType: EnumLapSequenceTemplateLapsLapType;
};

export type LapSequenceTemplateLapsInput = {
  /** Lap number in sequence */
  NLap: Scalars['Float']['input'];
  lapType: EnumLapSequenceTemplateLapsLapType;
};

/** List of items with pagination. */
export type LapSequenceTemplatePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<LapSequenceTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type LapTableBlock = {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** Source of the lap end energy value */
  energyLapEndSource?: Maybe<Scalars['String']['output']>;
  /** @deprecated Specify energy type at the root of the run sheet style instead. */
  energyType?: Maybe<EnumEnergyType>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** Ordered columns to show in the lap table */
  lapColumns?: Maybe<Array<Maybe<LapColumn>>>;
  /** @deprecated Use `lapFlags` at the root of the run sheet style instead. */
  lapFlags?: Maybe<LapFlagLabels>;
  /** Names of lapKPI fields to show */
  lapKPIs?: Maybe<Array<Maybe<GenericRunSheetStyleBlockLapKpIs>>>;
  manualLapInputByDefault?: Maybe<Scalars['Boolean']['output']>;
  showLapTypeColors?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use other fields to style the block instead */
  style?: Maybe<EnumRunSheetStyleBlockStyle>;
  velocityUnit?: Maybe<EnumVelocityUnit>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type LapTimeThresholdsBlock = {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type LapTypeCountBlock = {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  lapCountBlockFieldOrder?: Maybe<Array<Maybe<GenericRunSheetStyleBlockLapCountBlockFieldOrder>>>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

/** Collection of tuples defining bounds to automatically classify laps. Does not apply to in/out/race control lap types. Comparisons are to be made with `<` or `>=` at aligning bounds. Minimum value is 0 and maximum value is 1000000. */
export type LaptimeThresholds = {
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as cool. */
  cool?: Maybe<Array<Scalars['Float']['output']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as prep. */
  prep?: Maybe<Array<Scalars['Float']['output']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as push. */
  push?: Maybe<Array<Scalars['Float']['output']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as slow. */
  slow?: Maybe<Array<Scalars['Float']['output']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as target. */
  target?: Maybe<Array<Scalars['Float']['output']>>;
};

/** Collection of tuples defining bounds to automatically classify laps. Does not apply to in/out/race control lap types. Comparisons are to be made with `<` or `>=` at aligning bounds. Minimum value is 0 and maximum value is 1000000. */
export type LaptimeThresholdsInput = {
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as cool. */
  cool?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as prep. */
  prep?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as push. */
  push?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as slow. */
  slow?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as target. */
  target?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type LayoutConsumption = {
  SoCRequired?: Maybe<RunEnergy>;
  energyRequired?: Maybe<RunEnergy>;
  fuelRequired?: Maybe<RunEnergy>;
  trackLayout?: Maybe<TrackLayout>;
  trackLayoutID: Scalars['MongoID']['output'];
};

export type LayoutConsumptionInput = {
  SoCRequired?: InputMaybe<RunEnergyInput>;
  energyRequired?: InputMaybe<RunEnergyInput>;
  fuelRequired?: InputMaybe<RunEnergyInput>;
  trackLayoutID: Scalars['MongoID']['input'];
};

export type Length = {
  /** cm */
  centimetres: Scalars['Float']['output'];
  /** ft */
  feet: Scalars['Float']['output'];
  /** in */
  inches: Scalars['Float']['output'];
  /** km */
  kilometres: Scalars['Float']['output'];
  /** m */
  metres: Scalars['Float']['output'];
  /** μm */
  micrometres: Scalars['Float']['output'];
  /** mi */
  miles: Scalars['Float']['output'];
  /** mm */
  millimetres: Scalars['Float']['output'];
  /** thou */
  thou: Scalars['Float']['output'];
};

export type LengthInput = {
  /** cm */
  centimetres?: InputMaybe<Scalars['Float']['input']>;
  /** ft */
  feet?: InputMaybe<Scalars['Float']['input']>;
  /** in */
  inches?: InputMaybe<Scalars['Float']['input']>;
  /** km */
  kilometres?: InputMaybe<Scalars['Float']['input']>;
  /** m */
  metres?: InputMaybe<Scalars['Float']['input']>;
  /** μm */
  micrometres?: InputMaybe<Scalars['Float']['input']>;
  /** mi */
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** mm */
  millimetres?: InputMaybe<Scalars['Float']['input']>;
  /** thou */
  thou?: InputMaybe<Scalars['Float']['input']>;
};

export type LengthUnitField = {
  unit: EnumLengthUnit;
};

export type LicenseFeatures = {
  dyno: Scalars['Boolean']['output'];
  lightVersion: Scalars['Boolean']['output'];
  /** Should this server be configured for hybrid cloud deployment? */
  moveServer: Scalars['Boolean']['output'];
  /** Can data still be accessed if license has expired? */
  readOnlyAfterLicenseExpiry: Scalars['Boolean']['output'];
  sevenPost: Scalars['Boolean']['output'];
  /** Can the car data service be used? */
  simulation: Scalars['Boolean']['output'];
  /** Should team access control be enforced? */
  teams: Scalars['Boolean']['output'];
  tyreSetStatistics: Scalars['Boolean']['output'];
};

export type LicenseOptions = {
  services: LicenseServices;
  setupSheetStyles: Array<EnumChassisSetupSheetStyle>;
};

export type LicenseProperties = {
  customer?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  expired: Scalars['Boolean']['output'];
  features: LicenseFeatures;
  options: LicenseOptions;
  valid: Scalars['Boolean']['output'];
};

export type LicenseServices = {
  carData: Scalars['Boolean']['output'];
  chassisSimulation: Scalars['Boolean']['output'];
  oneTimingWeather: Scalars['Boolean']['output'];
  timing: Scalars['Boolean']['output'];
  weather: Scalars['Boolean']['output'];
};

export type LinkTrackingItemsToSpecification = {
  danglingTrackingItems?: Maybe<Scalars['Int']['output']>;
  updatedRecords?: Maybe<Scalars['Int']['output']>;
};

export type LinkTrackingSourcesToChassisSpecs = {
  danglingTrackingItems?: Maybe<Scalars['Int']['output']>;
  updatedRecords?: Maybe<Scalars['Int']['output']>;
};

export type LiveStanding = {
  acronym?: Maybe<Scalars['String']['output']>;
  contestantID?: Maybe<Scalars['MongoID']['output']>;
  currentLocation?: Maybe<EnumLiveStandingCurrentLocation>;
  driverID?: Maybe<Scalars['MongoID']['output']>;
  fastestLap?: Maybe<BestValuesFastestLap>;
  fastestSectors?: Maybe<Array<Maybe<BestValuesFastestSector>>>;
  /** Does this driver have the fastest lap in the session? Only one driver should have this true at a time. */
  hasFastestLap?: Maybe<Scalars['Boolean']['output']>;
  lapsCompleted?: Maybe<Scalars['Int']['output']>;
  /** 1-indexed rank of this driver with respect to the rest of the grid */
  position: Scalars['Int']['output'];
  postRacePenalty?: Maybe<LiveStandingPostRacePenalty>;
  startNumber?: Maybe<Scalars['String']['output']>;
};

export type LiveStandingInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  currentLocation?: InputMaybe<EnumLiveStandingCurrentLocation>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  fastestLap?: InputMaybe<BestValuesFastestLapInput>;
  fastestSectors?: InputMaybe<Array<InputMaybe<BestValuesFastestSectorInput>>>;
  /** Does this driver have the fastest lap in the session? Only one driver should have this true at a time. */
  hasFastestLap?: InputMaybe<Scalars['Boolean']['input']>;
  lapsCompleted?: InputMaybe<Scalars['Int']['input']>;
  /** 1-indexed rank of this driver with respect to the rest of the grid */
  position: Scalars['Int']['input'];
  postRacePenalty?: InputMaybe<LiveStandingPostRacePenaltyInput>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
};

export type LiveStandingPostRacePenalty = {
  contestantID: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  totalTimePenalty?: Maybe<Scalars['Float']['output']>;
};

export type LiveStandingPostRacePenaltyInput = {
  contestantID: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  totalTimePenalty?: InputMaybe<Scalars['Float']['input']>;
};

export type LiveStandingsStartResult = {
  success: Scalars['Boolean']['output'];
};

export type LiveStandingsStopResult = {
  success: Scalars['Boolean']['output'];
};

export type LocalConnection = {
  dataMapping?: Maybe<EnumLocalConnectionDataMapping>;
  endPoint?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  outputFolder?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  useSSL?: Maybe<Scalars['Boolean']['output']>;
};

export type LocalConnectionInput = {
  dataMapping?: InputMaybe<EnumLocalConnectionDataMapping>;
  endPoint?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  outputFolder?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Float']['input']>;
  useSSL?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Location = {
  _id: Scalars['MongoID']['output'];
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  geoLocation?: Maybe<GeoLocation>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type LocationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<GeoLocationInput>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type LocationPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Location>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type LocationUnitField = {
  unit: EnumUntypedUnit;
};

export type Log = {
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  logLevel?: Maybe<EnumLogLevel>;
  /** A single log from the source service */
  message: Scalars['String']['output'];
  serviceSource?: Maybe<EnumLogServiceSource>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<Person>;
  userID?: Maybe<Scalars['MongoID']['output']>;
};

/** List of items with pagination. */
export type LogPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Log>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type LoginToken = {
  token: Scalars['String']['output'];
};

export type Manufacturer = {
  _id: Scalars['MongoID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
};

/** List of items with pagination. */
export type ManufacturerPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Manufacturer>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type MapTrackLatLon = {
  coordinates: Array<TrackXyCoordinate>;
  keyValueData: Array<TrackKeyValueEntry>;
  labels: Array<TrackLabel>;
  latLonCoordinates: Array<TrackLatLonCoordinate>;
  sectorPositions: Array<Scalars['Float']['output']>;
  svg: TrackSvg;
  warnings: Array<Scalars['String']['output']>;
};

export type MapTrackXy = {
  coordinates: Array<TrackXyCoordinate>;
  keyValueData: Array<TrackKeyValueEntry>;
  labels: Array<TrackLabel>;
  sectorPositions: Array<Scalars['Float']['output']>;
  svg: TrackSvg;
  warnings: Array<Scalars['String']['output']>;
};

export type Mass = {
  /** g */
  grams: Scalars['Float']['output'];
  /** kg */
  kilograms: Scalars['Float']['output'];
  /** mg */
  milligrams: Scalars['Float']['output'];
  /** oz */
  ounces: Scalars['Float']['output'];
  /** lb */
  pounds: Scalars['Float']['output'];
};

export type MassInput = {
  /** g */
  grams?: InputMaybe<Scalars['Float']['input']>;
  /** kg */
  kilograms?: InputMaybe<Scalars['Float']['input']>;
  /** mg */
  milligrams?: InputMaybe<Scalars['Float']['input']>;
  /** oz */
  ounces?: InputMaybe<Scalars['Float']['input']>;
  /** lb */
  pounds?: InputMaybe<Scalars['Float']['input']>;
};

export type MassProperties = {
  COGx?: Maybe<Scalars['Float']['output']>;
  COGy?: Maybe<Scalars['Float']['output']>;
  COGz?: Maybe<Scalars['Float']['output']>;
  Ixx?: Maybe<Scalars['Float']['output']>;
  Iyy?: Maybe<Scalars['Float']['output']>;
  Izz?: Maybe<Scalars['Float']['output']>;
  mass?: Maybe<Scalars['Float']['output']>;
  /** Allowable mass range, for when a set mass value doesn't apply */
  massRange?: Maybe<AdjustableMass>;
};

export type MassPropertiesInput = {
  COGx?: InputMaybe<Scalars['Float']['input']>;
  COGy?: InputMaybe<Scalars['Float']['input']>;
  COGz?: InputMaybe<Scalars['Float']['input']>;
  Ixx?: InputMaybe<Scalars['Float']['input']>;
  Iyy?: InputMaybe<Scalars['Float']['input']>;
  Izz?: InputMaybe<Scalars['Float']['input']>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  /** Allowable mass range, for when a set mass value doesn't apply */
  massRange?: InputMaybe<AdjustableMassInput>;
};

export type MassUnitField = {
  unit: EnumMassUnit;
};

export type Migrations = {
  carSetupMissingTitle: Scalars['Boolean']['output'];
  /** Date when this deployment was first ever booted. This should help with understanding how old certain data might be. */
  deployedAt?: Maybe<Scalars['Date']['output']>;
  eventContestantsDedup: Scalars['Boolean']['output'];
  /** @deprecated  */
  everythingToSI: Scalars['Boolean']['output'];
  issuePriority: Scalars['Boolean']['output'];
  lapPitOutAndInTimeStamps: Scalars['Boolean']['output'];
  lapSessionID?: Maybe<Scalars['Boolean']['output']>;
  lapsToCollection: Scalars['Boolean']['output'];
  manualMileageCustomToCarSetup: Scalars['Boolean']['output'];
  rootSpecificationID: Scalars['Boolean']['output'];
  runSheetAndLapTimeStamps: Scalars['Boolean']['output'];
  sessionTypeToEnum: Scalars['Boolean']['output'];
  setupSheetStyleTabs: Scalars['Boolean']['output'];
  setupTimingServiceStatus: Scalars['Boolean']['output'];
  teamsToTeamIDsOnPart: Scalars['Boolean']['output'];
  trackingSourcesAndItems: Scalars['Boolean']['output'];
  trackingUpdate202506: Scalars['Boolean']['output'];
  /** @deprecated  */
  tyreBlockPressuresToSI: Scalars['Boolean']['output'];
  /** Date when any migration was last updated. */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MigrationsInput = {
  carSetupMissingTitle?: InputMaybe<Scalars['Boolean']['input']>;
  eventContestantsDedup?: InputMaybe<Scalars['Boolean']['input']>;
  everythingToSI?: InputMaybe<Scalars['Boolean']['input']>;
  issuePriority?: InputMaybe<Scalars['Boolean']['input']>;
  lapPitOutAndInTimeStamps?: InputMaybe<Scalars['Boolean']['input']>;
  lapSessionID?: InputMaybe<Scalars['Boolean']['input']>;
  lapsToCollection?: InputMaybe<Scalars['Boolean']['input']>;
  manualMileageCustomToCarSetup?: InputMaybe<Scalars['Boolean']['input']>;
  rootSpecificationID?: InputMaybe<Scalars['Boolean']['input']>;
  runSheetAndLapTimeStamps?: InputMaybe<Scalars['Boolean']['input']>;
  sessionTypeToEnum?: InputMaybe<Scalars['Boolean']['input']>;
  setupSheetStyleTabs?: InputMaybe<Scalars['Boolean']['input']>;
  setupTimingServiceStatus?: InputMaybe<Scalars['Boolean']['input']>;
  teamsToTeamIDsOnPart?: InputMaybe<Scalars['Boolean']['input']>;
  trackingSourcesAndItems?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUpdate202506?: InputMaybe<Scalars['Boolean']['input']>;
  tyreBlockPressuresToSI?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MileageAtRunStart = {
  endMileage?: Maybe<Scalars['Float']['output']>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  startMileage?: Maybe<Scalars['Float']['output']>;
};

export type MiniJobListBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type MomentOfInertia = {
  /** kgm² */
  kilogramMetresSquared: Scalars['Float']['output'];
  /** lbf·ft/s² */
  poundForceFeetSecondSquared: Scalars['Float']['output'];
};

export type MomentOfInertiaInput = {
  /** kgm² */
  kilogramMetresSquared?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/s² */
  poundForceFeetSecondSquared?: InputMaybe<Scalars['Float']['input']>;
};

export type MongoError = ErrorInterface & {
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']['output']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  /** Activate a car data service configuration for its race series. This action deactivates the currently active one for the race series. */
  activateCarDataServiceConfig?: Maybe<ActivateCarDataServiceConfigResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addAssembly?: Maybe<CreateOneAssemblyPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addAssemblyTemplate?: Maybe<CreateOneAssemblyTemplatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addBestValues?: Maybe<CreateOneBestValuesPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addBop?: Maybe<CreateOneBopPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addBuildSheetStyle?: Maybe<CreateOneBuildSheetStylePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addCalculation?: Maybe<CreateOneCalculationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addCarDataServiceConfig?: Maybe<CreateOneCarDataServiceConfigPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addCarSetup?: Maybe<CreateOneCarSetupPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addChassis?: Maybe<CreateOneChassisPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addChassisMeasurement?: Maybe<CreateOneChassisMeasurementPayload>;
  addComment?: Maybe<AddCommentResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addContestant?: Maybe<CreateOneContestantPayload>;
  /** Add data from control telemetry. This is the mutation for the 'end of lap' scenario. */
  addControlTelemetryEndOfLap?: Maybe<AddControlTelemetryEndOfLapResult>;
  /** Add data from control telemetry. This is the mutation for the 'end of run' scenario. */
  addControlTelemetryEndOfRun?: Maybe<AddControlTelemetryEndOfRunResult>;
  /** Add data from control telemetry. This is the mutation for the 'start of' scenario. */
  addControlTelemetryStartOfData?: Maybe<AddControlTelemetryStartOfDataResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addDepartment?: Maybe<CreateOneDepartmentPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addDynoConfig?: Maybe<CreateOneDynoConfigPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addEvent?: Maybe<CreateOneEventPayload>;
  /** Add a contestant to an event. */
  addEventContestant?: Maybe<AddEventContestantResult>;
  /** Add flattened simulation payload to car setup and part instances */
  addFlattenedSimulationPayload?: Maybe<AddFlattenedPayloadReturnType>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addFlexLayoutConfig?: Maybe<CreateOneFlexLayoutConfigPayload>;
  /** Create an event with sessions */
  addFullEvent?: Maybe<Event>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addGreeboLog?: Maybe<CreateOneGreeboLogPayload>;
  addHistoricalWeather?: Maybe<Weather>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addIssue?: Maybe<CreateOneIssuePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addJob?: Maybe<CreateOneJobPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  addJobsMany?: Maybe<CreateManyJobPayload>;
  /** Add a lap to a run sheet. Duplicate `NLapRun` or `tDay` values are not allowed; use `forceAddLap` if you must override this behaviour */
  addLap?: Maybe<RunSheet>;
  addLapByService?: Maybe<RunSheet>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addLapSequence?: Maybe<CreateOneLapSequencePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addLapSequenceTemplate?: Maybe<CreateOneLapSequenceTemplatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addLocation?: Maybe<CreateOneLocationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addLog?: Maybe<CreateOneLogPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addManufacturer?: Maybe<CreateOneManufacturerPayload>;
  /** Add contestant(s) to an event. */
  addManyEventContestants?: Maybe<AddManyEventContestantsResult>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  addManyTimeSheetEntries?: Maybe<CreateManyTimeSheetEntryPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addOneTimingWeatherServiceConfig?: Maybe<CreateOneOneTimingWeatherServiceConfigPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPackage?: Maybe<CreateOnePackagePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPart?: Maybe<CreateOnePartPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPartInstance?: Maybe<CreateOnePartInstancePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPartInstanceForCopyAssembly?: Maybe<CreateOnePartInstancePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPerson?: Maybe<CreateOnePersonPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPlotPageConfig?: Maybe<CreateOnePlotPageConfigPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPointsSystem?: Maybe<CreateOnePointsSystemPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addProject?: Maybe<CreateOneProjectPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addQualityCheck?: Maybe<CreateOneQualityCheckPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addQualityCheckAction?: Maybe<CreateOneQualityCheckActionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addRaceSeries?: Maybe<CreateOneRaceSeriesPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addRadioMessage?: Maybe<CreateOneRadioMessagePayload>;
  /** Add a note to a page on the report */
  addReportNote?: Maybe<ReportNote>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addReportNotesTemplate?: Maybe<CreateOneReportNotesTemplatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addReportTemplate?: Maybe<CreateOneReportTemplatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addRunPlan?: Maybe<CreateOneRunPlanPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addRunSheet?: Maybe<CreateOneRunSheetPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addRunSheetStyle?: Maybe<CreateOneRunSheetStylePayload>;
  /** Add a run to an existing run plan. */
  addRunToRunPlan?: Maybe<RunPlan>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSeason?: Maybe<CreateOneSeasonPayload>;
  addSector?: Maybe<RunSheet>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSession?: Maybe<CreateOneSessionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSessionDebriefTemplate?: Maybe<CreateOneTemplateSessionDebriefPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSetupOverviewConfig?: Maybe<CreateOneSetupOverviewConfigPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSetupSheetStyle?: Maybe<CreateOneSetupSheetStylePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSimRequest?: Maybe<CreateOneSimRequestPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSimResult?: Maybe<CreateOneSimResultPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSimulationDriveFile?: Maybe<CreateOneSimulationDriveFilePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSkidPlate?: Maybe<CreateOneSkidPlatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSpecification?: Maybe<CreateOneSpecificationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSpecificationGroup?: Maybe<CreateOneSpecificationGroupPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSsoProvider?: Maybe<CreateOneSsoProviderPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTag?: Maybe<CreateOneTagPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTeam?: Maybe<CreateOneTeamPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTemplateJobList?: Maybe<CreateOneTemplateJobListPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTestUser?: Maybe<CreateOnePersonPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTimeSheetEntry?: Maybe<CreateOneTimeSheetEntryPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTimingServiceConfig?: Maybe<CreateOneTimingServiceConfigPayload>;
  /** Append to an array of IDs on a contestant. */
  addToContestant?: Maybe<Contestant>;
  /** Append to an array of IDs within an event's `contestants` array. The contestant is added to the event if not already present there. */
  addToEventContestant?: Maybe<Event>;
  /** Append to an array of IDs within a session's `contestants` array. The contestant is added to the session if not already present there. */
  addToSessionContestant?: Maybe<Session>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrack?: Maybe<CreateOneTrackPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackLayout?: Maybe<CreateOneTrackLayoutPayload>;
  addTrackState?: Maybe<RunSheet>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackable?: Maybe<CreateOneTrackablePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingItem?: Maybe<CreateOneTrackingItemPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingMeasurement?: Maybe<CreateOneTrackingMeasurementPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingMeasurementRecord?: Maybe<CreateOneTrackingMeasurementRecordPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingRecord?: Maybe<CreateOneTrackingRecordPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingRecordGeneral?: Maybe<CreateOneTrackingRecordGeneralPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingRecordOverride?: Maybe<CreateOneTrackingRecordOverridePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingRecordValue?: Maybe<CreateOneTrackingRecordValuePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingSource?: Maybe<CreateOneTrackingSourcePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingSourceAlias?: Maybe<CreateOneTrackingSourceAliasPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTyre?: Maybe<CreateOneTyrePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTyreSet?: Maybe<CreateOneTyreSetPayload>;
  /** Add / assign tyre set to contestant */
  addTyreSetsToContestant?: Maybe<AddTyreSetsToContestantResult>;
  /** Add / assign tyre set to event contestant */
  addTyreSetsToEventContestant?: Maybe<AddTyreSetsToEventContestantResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTyreWear?: Maybe<CreateOneTyreWearPayload>;
  /** Add / assign tyres to contestant */
  addTyresToContestant?: Maybe<AddTyresToContestantResult>;
  /** Add / assign tyres to event contestant */
  addTyresToEventContestant?: Maybe<AddTyresToEventContestantResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addUserEnum?: Maybe<CreateOneUserEnumPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addWeather?: Maybe<CreateOneWeatherPayload>;
  addWeatherFromSource?: Maybe<Weather>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addWeatherServiceConfig?: Maybe<CreateOneWeatherServiceConfigPayload>;
  addvCarSector?: Maybe<RunSheet>;
  appendWeather?: Maybe<Weather>;
  /** Add a lap sequence to a runsheet */
  applyLapSequence?: Maybe<ApplyLapSequence>;
  /** Apply a migration on demand. */
  applyMigration?: Maybe<ApplyMigrationResult>;
  applyPackage?: Maybe<ApplyPackageResult>;
  applyPackageItems?: Maybe<ApplyPackageItemsResult>;
  approveTimeSheetEntries?: Maybe<Scalars['Boolean']['output']>;
  approveTimeSheetEntry?: Maybe<TimeSheetEntry>;
  /** Assign something to any team. */
  assignTeam?: Maybe<AssignTeamResult>;
  /** Forcibly calculate all run sheet mileages */
  calculateAllMileages: Scalars['Boolean']['output'];
  /** Calculate run energy (fuel/energy/SOC) for all run sheets */
  calculateAllRunEnergies?: Maybe<CalculateAllRunEnergiesResult>;
  /** Forcibly calculate selected run sheet mileages */
  calculateMileagesByRunSheetIDs: Scalars['Boolean']['output'];
  /** Calculate run energy (fuel/energy/SOC) for a run sheet and its subsequent runsheets */
  calculateRunEnergy?: Maybe<CalculateRunEnergyResult>;
  /** Claim a car setup for your team, preventing write access for anyone from other teams. */
  claimCarSetup?: Maybe<ClaimCarSetupResult>;
  /** Claim a run sheet (and any connected run sheets) for your team, preventing write access for anyone from other teams. */
  claimRunSheet?: Maybe<ClaimRunSheetResult>;
  /** Clone an existing package */
  clonePackage?: Maybe<ClonePackageResolverResult>;
  /** Clone a run plan */
  cloneRunPlan?: Maybe<RunPlan>;
  /** Copy an assembly and its subassemblies to new documents */
  copyAssembly?: Maybe<CopyAssemblyResult>;
  /** Create a new car setup using an existing one as a starting point. */
  copyCarSetup?: Maybe<CreatedSetup>;
  /** Create a new chassis assembly using the source chassis assembly's values, and link it to the destination car setup. */
  copyChassisAssembly?: Maybe<CreatedChassisAssembly>;
  /** Use an existing event as a template for creating a new one. Child sessions are partially re-created, with end times calculated based on offsets from the source event. */
  copyEvent?: Maybe<Event>;
  /** Create a database backup. Returns the name of the backup. You may specify a name to attach to the end of the auto-generated text. */
  createBackup?: Maybe<CreateBackupResult>;
  /** Creates go look at assembly records for a given chassis assembly. It will update all related parts */
  createGoLookAtAssemblyRecord?: Maybe<Scalars['Boolean']['output']>;
  createPackage?: Maybe<Package>;
  /** Create tyres and assign them to a contestant in one call. `tyres` are created on their own, `sets` are created as four tyres grouped into a TyreSet. With an `eventID` everything is assigned to that event's contestant, without one to the season contestant. */
  createTyresForContestant?: Maybe<CreateTyresForContestantResult>;
  /** Runs data checks */
  dataCheck?: Maybe<DataCheckResolverReturnType>;
  /** Copy notes from an RNT into an event's ReportNote, replacing content on the selected pages */
  draftNotesFromTemplate?: Maybe<ReportNote>;
  /** Updates linked run sheets with data from the run plan (driver, tyres, fuel, laps) */
  draftRunSheets?: Maybe<RunPlan>;
  /** Creates go look at assembly records for a given chassis assembly and removes all previous tracking records with this chassis assemblyID */
  fixAssemblyTracking?: Maybe<FixAssemblyTracking>;
  /** Fixes part instance and nested part instance id arrays on chassis assembly */
  fixPartInstanceArrays?: Maybe<FixPartInstanceArrayResult>;
  /** Check and reset part instances and tracking records */
  fixPartInstancesResolver?: Maybe<FixPartInstancesByPartId>;
  /** Clean part tracking history. Remove tracking history entries for inactive tracking items and dead assemblies */
  fixPartTrackingHistory?: Maybe<FixPartTrackingHistory>;
  /** Run the clean part tracking history function for a full assembly */
  fixTrackingForAssemblyParts?: Maybe<FixTrackingForAssemblyParts>;
  /** Add a lap to a run sheet, allowing any `NLapRun` and `tDay` value. If a lap with that `NLapRun` exists, it and all following laps will have their `NLapRun` incremented. */
  forceAddLap?: Maybe<RunSheet>;
  /** Send an email with a password reset link to the requested account, if it exists. */
  forgotPassword?: Maybe<ForgotPasswordResult>;
  forwardAddPartInstance?: Maybe<CreatedPartInstancesResult>;
  /** Update a car setup value to all future runs in a session, until the original value is different from the baseline value of the car setup provided.Field input must be provided in dot notation ("title" or "frontLeft.hRide") */
  forwardUpdateCarSetup?: Maybe<UpdateCarSetupResult>;
  forwardUpsertPartInstance?: Maybe<ForwardUpsertPartInstanceResult>;
  greeboLogPushGPSData?: Maybe<GreeboLog>;
  greeboLogPushRawLines?: Maybe<GreeboLog>;
  greeboLogUpdateCarPositions?: Maybe<GreeboLog>;
  /** Create a new runsheet using the source runsheet as a reference. Copies many values, increments `NRun`(`Timing`), and calculates energy/fuel available based on energy/fuel required. Use `record` to specify any overrides. */
  incrementRunSheet?: Maybe<IncrementRunSheetPayload>;
  /** Create a new car setup using the source runsheet's linked setup's values, and link it to the destination runsheet. */
  incrementSetupSheet?: Maybe<CreatedSetup>;
  incrementSpecification?: Maybe<IncrementSpecificationResult>;
  /** Insert a new lap lap before another */
  insertLap?: Maybe<Lap>;
  insertRun?: Maybe<InsertRunPayload>;
  /** Insert a run into an existing run plan. */
  insertRunInRunPlan?: Maybe<RunPlan>;
  insertRunIntoSession?: Maybe<InsertRunPayload>;
  /** Re-establishes broken links between tracking items and specifications */
  linkTrackingItemsToSpecification?: Maybe<LinkTrackingItemsToSpecification>;
  /** Re-establishes broken links between tracking items and specifications */
  linkTrackingSourcesToChassisSpecs?: Maybe<LinkTrackingSourcesToChassisSpecs>;
  liveStandingsStart?: Maybe<LiveStandingsStartResult>;
  liveStandingsStop?: Maybe<LiveStandingsStopResult>;
  login?: Maybe<LoginToken>;
  /** Perform an action on a issue as the logged in user. */
  manageIssue: Issue;
  /** Perform an action on a job as the logged in user. */
  manageJob: Job;
  oneTimingWeatherServiceConfigure?: Maybe<TimingConfigureResult>;
  oneTimingWeatherServiceStart?: Maybe<OneTimingWeatherServiceStartResult>;
  oneTimingWeatherServiceStop?: Maybe<OneTimingWeatherServiceStopResult>;
  /** Calculate part lifetime mileage by its ID */
  recalculatePartMileageByIDResolver?: Maybe<CalculatePartMileageById>;
  /** Regenerate part tracking history. Remove tracking history entries for inactive tracking items and dead assemblies */
  regeneratePartTrackingHistory?: Maybe<RegeneratePartTrackingHistory>;
  releaseChassisSpec?: Maybe<ReleaseChassisSpecResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeAssembly?: Maybe<RemoveByIdAssemblyPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeAssemblyTemplate?: Maybe<RemoveByIdAssemblyTemplatePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeBestValues?: Maybe<RemoveByIdBestValuesPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeBop?: Maybe<RemoveByIdBopPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeBuildSheetStyle?: Maybe<RemoveByIdBuildSheetStylePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeCalculation?: Maybe<RemoveByIdCalculationPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeCarDataServiceConfig?: Maybe<RemoveByIdCarDataServiceConfigPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeCarSetup?: Maybe<RemoveByIdCarSetupPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeChassis?: Maybe<RemoveByIdChassisPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeChassisMeasurement?: Maybe<RemoveByIdChassisMeasurementPayload>;
  removeComment?: Maybe<RemoveCommentResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeContestant?: Maybe<RemoveByIdContestantPayload>;
  /** Removes tracking records from the DB with trackingItemID: null and trackingSourceID: null */
  removeDeadTrackingRecords?: Maybe<RemoveDeadTrackingRecords>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeDepartment?: Maybe<RemoveByIdDepartmentPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeDynoConfig?: Maybe<RemoveByIdDynoConfigPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeEvent?: Maybe<RemoveByIdEventPayload>;
  /** Remove a contestant from an event. */
  removeEventContestant?: Maybe<RemoveEventContestantResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeFlexLayoutConfig?: Maybe<RemoveByIdFlexLayoutConfigPayload>;
  /** Pop from an array of IDs on a contestant. */
  removeFromContestant?: Maybe<Contestant>;
  /** Pop from an array of IDs within an event's `contestants` array. */
  removeFromEventContestant?: Maybe<Event>;
  /** Pop from an array of IDs within an session's `contestants` array. */
  removeFromSessionContestant?: Maybe<Session>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeIssue?: Maybe<RemoveByIdIssuePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeJob?: Maybe<RemoveByIdJobPayload>;
  /** Remove a lap from a run sheet. If it's not the final lap, laps that come after it will have their `NLapRun` adjusted to suit. */
  removeLap?: Maybe<RunSheet>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeLapByID?: Maybe<RemoveByIdLapPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeLapByIDByService?: Maybe<RemoveByIdLapPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeLapSequence?: Maybe<RemoveByIdLapSequencePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeLapSequenceTemplate?: Maybe<RemoveByIdLapSequenceTemplatePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeLocation?: Maybe<RemoveByIdLocationPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeManufacturer?: Maybe<RemoveByIdManufacturerPayload>;
  /** Remove many contestants from an event. */
  removeManyEventContestants?: Maybe<RemoveManyEventContestantsResult>;
  /** Remove many jobs by _id or runSheetID. */
  removeManyJobs?: Maybe<RemoveManyJobsResult>;
  /** Remove many documents without returning them: Use Query.remove mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  removeManySimRequests?: Maybe<RemoveManySimRequestPayload>;
  /** Remove many documents without returning them: Use Query.remove mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  removeManySimResults?: Maybe<RemoveManySimResultPayload>;
  /** Remove many timesheet entries by _id */
  removeManyTimeSheetEntries?: Maybe<RemoveManyTimeSheetEntriesResult>;
  /** Remove many tyreSets by _id */
  removeManyTyreSets?: Maybe<RemoveManyTyreSetsResult>;
  /** Remove many tyres by _id */
  removeManyTyres?: Maybe<RemoveManyTyresResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeOneTimingWeatherServiceConfig?: Maybe<RemoveByIdOneTimingWeatherServiceConfigPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removePackage?: Maybe<RemoveByIdPackagePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removePart?: Maybe<RemoveByIdPartPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removePartInstance?: Maybe<RemoveByIdPartInstancePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removePerson?: Maybe<RemoveByIdPersonPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removePlotPageConfig?: Maybe<RemoveByIdPlotPageConfigPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removePointsSystem?: Maybe<RemoveByIdPointsSystemPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeProject?: Maybe<RemoveByIdProjectPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeQualityCheck?: Maybe<RemoveByIdQualityCheckPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeQualityCheckAction?: Maybe<RemoveByIdQualityCheckActionPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeRaceSeries?: Maybe<RemoveByIdRaceSeriesPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeRadioMessage?: Maybe<RemoveByIdRadioMessagePayload>;
  /** Remove a note from a report page */
  removeReportNote?: Maybe<ReportNote>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeReportNotesTemplate?: Maybe<RemoveByIdReportNotesTemplatePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeReportTemplate?: Maybe<RemoveByIdReportTemplatePayload>;
  /** Remove a planned run from an existing run plan. */
  removeRunFromRunPlan?: Maybe<RunPlan>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeRunPlan?: Maybe<RemoveByIdRunPlanPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeRunSheet?: Maybe<RemoveByIdRunSheetPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeRunSheetStyle?: Maybe<RemoveByIdRunSheetStylePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSeason?: Maybe<RemoveByIdSeasonPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSession?: Maybe<RemoveByIdSessionPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSessionDebriefTemplate?: Maybe<RemoveByIdTemplateSessionDebriefPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSetupOverviewConfig?: Maybe<RemoveByIdSetupOverviewConfigPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSetupSheetStyle?: Maybe<RemoveByIdSetupSheetStylePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSimRequest?: Maybe<RemoveByIdSimRequestPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSimResult?: Maybe<RemoveByIdSimResultPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSimulationDriveFile?: Maybe<RemoveByIdSimulationDriveFilePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSkidPlate?: Maybe<RemoveByIdSkidPlatePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSpecification?: Maybe<RemoveByIdSpecificationPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSpecificationGroup?: Maybe<RemoveByIdSpecificationGroupPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSsoProvider?: Maybe<RemoveByIdSsoProviderPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTag?: Maybe<RemoveByIdTagPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTeam?: Maybe<RemoveByIdTeamPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTemplateJobList?: Maybe<RemoveByIdTemplateJobListPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTimeSheetEntry?: Maybe<RemoveByIdTimeSheetEntryPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTimingServiceConfig?: Maybe<RemoveByIdTimingServiceConfigPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrack?: Maybe<RemoveByIdTrackPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackLayout?: Maybe<RemoveByIdTrackLayoutPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackable?: Maybe<RemoveByIdTrackablePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackingItem?: Maybe<RemoveByIdTrackingItemPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackingMeasurement?: Maybe<RemoveByIdTrackingMeasurementPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackingMeasurementRecord?: Maybe<RemoveByIdTrackingMeasurementRecordPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackingRecord?: Maybe<RemoveByIdTrackingRecordPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackingSource?: Maybe<RemoveByIdTrackingSourcePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackingSourceAlias?: Maybe<RemoveByIdTrackingSourceAliasPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTyre?: Maybe<RemoveByIdTyrePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTyreSet?: Maybe<RemoveByIdTyreSetPayload>;
  /** Remove assigned tyre set from contestant */
  removeTyreSetsFromContestant?: Maybe<RemoveTyreSetsFromContestantResult>;
  /** Remove assigned tyre set from event contestant */
  removeTyreSetsFromEventContestant?: Maybe<RemoveTyreSetsFromEventContestantResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTyreWear?: Maybe<RemoveByIdTyreWearPayload>;
  /** Remove assigned tyres from contestant */
  removeTyresFromContestant?: Maybe<RemoveTyresFromContestantResult>;
  /** Remove assigned tyres from event contestant */
  removeTyresFromEventContestant?: Maybe<RemoveTyreFromEventContestantResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeUserEnum?: Maybe<RemoveByIdUserEnumPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeWeather?: Maybe<RemoveByIdWeatherPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeWeatherServiceConfig?: Maybe<RemoveByIdWeatherServiceConfigPayload>;
  renameSpecification?: Maybe<RenameSpecificationResult>;
  /** Reorder run plan runs */
  reorderRunPlanRuns?: Maybe<RunPlan>;
  resetPassword?: Maybe<ResetPasswordResult>;
  resetTyrePressureSheet?: Maybe<ResetTyrePressureSheetResult>;
  /** Restore a database backup by name. A backup will automatically be created before restoring. */
  restoreBackup?: Maybe<RestoreBackupResult>;
  sandbox?: Maybe<SandboxMutations>;
  /** Scrap many tyres by _id */
  scrapManyTyres?: Maybe<ScrapManyTyresResult>;
  /** Reset a password with a link obtained from using the "Forgot your password?" button. */
  selfResetPassword?: Maybe<SelfResetPasswordResult>;
  setAllTimingServiceConfigsInactive?: Maybe<SetAllTimingServiceConfigsInactive>;
  setPassword?: Maybe<SetPasswordResult>;
  /** Split a run sheet into two */
  splitRunSheet?: Maybe<RunSheet>;
  swapPartInstance?: Maybe<SwapPartInstanceResult>;
  unapproveTimeSheetEntries?: Maybe<Scalars['Boolean']['output']>;
  unapproveTimeSheetEntry?: Maybe<TimeSheetEntry>;
  /** Revoke team ownership for a car setup. */
  unclaimCarSetup?: Maybe<UnclaimCarSetupResult>;
  /** Revoke team ownership of a run sheet (and any connected run sheets). */
  unclaimRunSheet?: Maybe<UnclaimRunSheetResult>;
  unreleaseChassisSpec?: Maybe<ChassisSpec>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateAssembly?: Maybe<UpdateByIdAssemblyPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateAssemblyTemplate?: Maybe<UpdateByIdAssemblyTemplatePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateBestValues?: Maybe<UpdateByIdBestValuesPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateBop?: Maybe<UpdateByIdBopPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateBuildSheetStyle?: Maybe<UpdateByIdBuildSheetStylePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateCalculation?: Maybe<UpdateByIdCalculationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateCarDataServiceConfig?: Maybe<UpdateByIdCarDataServiceConfigPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateCarSetup?: Maybe<UpdateByIdCarSetupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateChassis?: Maybe<UpdateByIdChassisPayload>;
  /** Recalculate all tracking items for given chassis assembly. Update all parts within that assembly. */
  updateChassisAssemblyTracking?: Maybe<Scalars['JSON']['output']>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateChassisMeasurement?: Maybe<UpdateByIdChassisMeasurementPayload>;
  /** Update the chassisSpecVersion on all car setups that have a chassisAssemblyID set to their respective latest versions. */
  updateChassisSpecVersionOnCarSetups?: Maybe<UpdatedChassisSpecVersionOnCarSetups>;
  updateComment?: Maybe<UpdateCommentResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateContestant?: Maybe<UpdateByIdContestantPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateDepartment?: Maybe<UpdateByIdDepartmentPayload>;
  /** Update the drivers of a contestant in an event. */
  updateDriversInEventContestant?: Maybe<Event>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateDynoConfig?: Maybe<UpdateByIdDynoConfigPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateEvent?: Maybe<UpdateByIdEventPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateFlexLayoutConfig?: Maybe<UpdateByIdFlexLayoutConfigPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateIssue?: Maybe<UpdateByIdIssuePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateJob?: Maybe<UpdateByIdJobPayload>;
  updateLap?: Maybe<RunSheet>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateLapByID?: Maybe<UpdateByIdLapPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateLapByIDByService?: Maybe<UpdateByIdLapPayload>;
  updateLapDataByID?: Maybe<Lap>;
  updateLapInSession?: Maybe<Lap>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateLapSequence?: Maybe<UpdateByIdLapSequencePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateLapSequenceTemplate?: Maybe<UpdateByIdLapSequenceTemplatePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateLocation?: Maybe<UpdateByIdLocationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateLog?: Maybe<UpdateByIdLogPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  updateLogByID?: Maybe<RemoveByIdLogPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateManufacturer?: Maybe<UpdateByIdManufacturerPayload>;
  /** Update fields on the currently logged in user. */
  updateMe?: Maybe<UpdateByIdPersonPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateMigrations?: Maybe<UpdateMigrationsResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateOneTimingWeatherServiceConfig?: Maybe<UpdateByIdOneTimingWeatherServiceConfigPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updatePackage?: Maybe<UpdateByIdPackagePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updatePart?: Maybe<UpdateByIdPartPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updatePartInstance?: Maybe<UpdateByIdPartInstancePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updatePerson?: Maybe<UpdateByIdPersonPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updatePlotPageConfig?: Maybe<UpdateByIdPlotPageConfigPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updatePointsSystem?: Maybe<UpdateByIdPointsSystemPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateProject?: Maybe<UpdateByIdProjectPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateQualityCheck?: Maybe<UpdateByIdQualityCheckPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateQualityCheckAction?: Maybe<UpdateByIdQualityCheckActionPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateRaceSeries?: Maybe<UpdateByIdRaceSeriesPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateRadioMessage?: Maybe<UpdateByIdRadioMessagePayload>;
  /** Update an existing note on a report */
  updateReportNote?: Maybe<ReportNote>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateReportTemplate?: Maybe<UpdateByIdReportTemplatePayload>;
  /** Update a planned run in an existing run plan. */
  updateRunInRunPlan?: Maybe<RunPlan>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateRunPlan?: Maybe<UpdateByIdRunPlanPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateRunSheet?: Maybe<UpdateByIdRunSheetPayload>;
  /** Updates the lap KPI of a given runsheet for all laps.Laps withing the run are matched by NLapRun.Example: laps: [{NLapRun: 1, lapKPI: [['one',{min: 1, max:2}],['ten',{min:11, max:12}]]}]  */
  updateRunSheetLapKPI?: Maybe<UpdateRunSheetLapKpiPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateRunSheetStyle?: Maybe<UpdateByIdRunSheetStylePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSeason?: Maybe<UpdateByIdSeasonPayload>;
  updateServerSettings?: Maybe<UpdateServerSettingsResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSession?: Maybe<UpdateByIdSessionPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSessionDebriefTemplate?: Maybe<UpdateByIdTemplateSessionDebriefPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSetupOverviewConfig?: Maybe<UpdateByIdSetupOverviewConfigPayload>;
  updateSetupSheetLayoutChassisSpec?: Maybe<UpdateSetupSheetLayoutChassisSpecResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSetupSheetStyle?: Maybe<UpdateByIdSetupSheetStylePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSimRequest?: Maybe<UpdateByIdSimRequestPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSimResult?: Maybe<UpdateByIdSimResultPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSimulationDriveFile?: Maybe<UpdateByIdSimulationDriveFilePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSkidPlate?: Maybe<UpdateByIdSkidPlatePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSpecification?: Maybe<UpdateByIdSpecificationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSpecificationAdmin?: Maybe<UpdateByIdSpecificationAdminPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSpecificationGroup?: Maybe<UpdateByIdSpecificationGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTag?: Maybe<UpdateByIdTagPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTeam?: Maybe<UpdateByIdTeamPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTemplateJobList?: Maybe<UpdateByIdTemplateJobListPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTimeSheetEntry?: Maybe<UpdateByIdTimeSheetEntryPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTimingServiceConfig?: Maybe<UpdateByIdTimingServiceConfigPayload>;
  updateTimingServiceStatus?: Maybe<UpdateTimingStatusResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrack?: Maybe<UpdateByIdTrackPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackLayout?: Maybe<UpdateByIdTrackLayoutPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackable?: Maybe<UpdateByIdTrackablePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackingItem?: Maybe<UpdateByIdTrackingItemPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackingMeasurement?: Maybe<UpdateByIdTrackingMeasurementPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackingMeasurementRecord?: Maybe<UpdateByIdTrackingMeasurementRecordPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackingRecord?: Maybe<UpdateByIdTrackingRecordPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackingSource?: Maybe<UpdateByIdTrackingSourcePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackingSourceAlias?: Maybe<UpdateByIdTrackingSourceAliasPayload>;
  /** Updates the value for a given tracking source source inside a chassis assembly. (e.g. manual mileage entry) */
  updateTrackingSourceSourceValueInAssembly?: Maybe<UpdateTrackingSourceSourceValueInAssemblyResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTyre?: Maybe<UpdateByIdTyrePayload>;
  updateTyrePressureSheet: TyrePressureSheet;
  updateTyrePressureSheetData: TyrePressureSheet;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTyreSet?: Maybe<UpdateByIdTyreSetPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTyreWear?: Maybe<UpdateByIdTyreWearPayload>;
  /** Update all tyres within a set */
  updateTyresInSet?: Maybe<UpdateTyresInSetResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateUserEnum?: Maybe<UpdateByIdUserEnumPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateWeather?: Maybe<UpdateByIdWeatherPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateWeatherServiceConfig?: Maybe<UpdateByIdWeatherServiceConfigPayload>;
  /** Deletes an existing BOP with a new BOP, useful to update/create bop and not have to deal with the existing BOP */
  upsertBop?: Maybe<Bop>;
  /** Add set of partIDs and locations to 'assemble' a full car */
  upsertCarBuild?: Maybe<UpsertCarBuildResult>;
  upsertPartInstance?: Maybe<PartInstanceUpdateResult>;
};


export type MutationActivateCarDataServiceConfigArgs = {
  carDataServiceConfigID: Scalars['MongoID']['input'];
};


export type MutationAddAssemblyArgs = {
  record: CreateOneAssemblyInput;
};


export type MutationAddAssemblyTemplateArgs = {
  record: CreateOneAssemblyTemplateInput;
};


export type MutationAddBestValuesArgs = {
  record: CreateOneBestValuesInput;
};


export type MutationAddBopArgs = {
  record: CreateOneBopInput;
};


export type MutationAddBuildSheetStyleArgs = {
  record: CreateOneBuildSheetStyleInput;
};


export type MutationAddCalculationArgs = {
  record: CreateOneCalculationInput;
};


export type MutationAddCarDataServiceConfigArgs = {
  record: CreateOneCarDataServiceConfigInput;
};


export type MutationAddCarSetupArgs = {
  record: CreateOneCarSetupInput;
};


export type MutationAddChassisArgs = {
  record: CreateOneChassisInput;
};


export type MutationAddChassisMeasurementArgs = {
  record: CreateOneChassisMeasurementInput;
};


export type MutationAddCommentArgs = {
  subjectID: Scalars['MongoID']['input'];
  target?: InputMaybe<EnumJobTarget>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddContestantArgs = {
  record: CreateOneContestantInput;
};


export type MutationAddControlTelemetryEndOfLapArgs = {
  NLap: Scalars['Float']['input'];
  NRun: Scalars['Float']['input'];
  contestantID: Scalars['MongoID']['input'];
  lapKPI?: InputMaybe<Scalars['JSON']['input']>;
  runKPI?: InputMaybe<Scalars['JSON']['input']>;
  tLapMax: Scalars['Float']['input'];
  timestamp: Scalars['Date']['input'];
};


export type MutationAddControlTelemetryEndOfRunArgs = {
  NLap: Scalars['Float']['input'];
  NRun: Scalars['Float']['input'];
  contestantID: Scalars['MongoID']['input'];
  lapKPI?: InputMaybe<Scalars['JSON']['input']>;
  runKPI?: InputMaybe<Scalars['JSON']['input']>;
  tLapMax: Scalars['Float']['input'];
  timestamp: Scalars['Date']['input'];
};


export type MutationAddControlTelemetryStartOfDataArgs = {
  NLap: Scalars['Float']['input'];
  NRun: Scalars['Float']['input'];
  contestantID: Scalars['MongoID']['input'];
  lapKPI?: InputMaybe<Scalars['JSON']['input']>;
  runKPI?: InputMaybe<Scalars['JSON']['input']>;
  tLapMax: Scalars['Float']['input'];
  timestamp: Scalars['Date']['input'];
};


export type MutationAddDepartmentArgs = {
  record: CreateOneDepartmentInput;
};


export type MutationAddDynoConfigArgs = {
  record: CreateOneDynoConfigInput;
};


export type MutationAddEventArgs = {
  record: CreateOneEventInput;
};


export type MutationAddEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
};


export type MutationAddFlattenedSimulationPayloadArgs = {
  carSetupID: Scalars['MongoID']['input'];
  record?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationAddFlexLayoutConfigArgs = {
  record: CreateOneFlexLayoutConfigInput;
};


export type MutationAddFullEventArgs = {
  eventRecord: CreateOneEventInput;
  sessions?: InputMaybe<Array<CreateSessionForFullEventInput>>;
};


export type MutationAddGreeboLogArgs = {
  record: CreateOneGreeboLogInput;
};


export type MutationAddHistoricalWeatherArgs = {
  weatherServiceConfigID: Scalars['MongoID']['input'];
};


export type MutationAddIssueArgs = {
  record: CreateOneIssueInput;
};


export type MutationAddJobArgs = {
  record: CreateOneJobInput;
  target?: InputMaybe<EnumJobTarget>;
};


export type MutationAddJobsManyArgs = {
  records: Array<CreateManyJobInput>;
};


export type MutationAddLapArgs = {
  lap: LapInput;
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationAddLapByServiceArgs = {
  newLapData: LapDataInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
  previousLapID?: InputMaybe<Scalars['MongoID']['input']>;
  referenceLapID?: InputMaybe<Scalars['MongoID']['input']>;
  runNo?: InputMaybe<Scalars['Int']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  sourceType: EnumLapDataSourceType;
};


export type MutationAddLapSequenceArgs = {
  record: CreateOneLapSequenceInput;
};


export type MutationAddLapSequenceTemplateArgs = {
  record: CreateOneLapSequenceTemplateInput;
};


export type MutationAddLocationArgs = {
  record: CreateOneLocationInput;
};


export type MutationAddLogArgs = {
  record: CreateOneLogInput;
};


export type MutationAddManufacturerArgs = {
  record: CreateOneManufacturerInput;
};


export type MutationAddManyEventContestantsArgs = {
  contestantIDs: Array<Scalars['MongoID']['input']>;
  eventID: Scalars['MongoID']['input'];
};


export type MutationAddManyTimeSheetEntriesArgs = {
  records: Array<CreateManyTimeSheetEntryInput>;
};


export type MutationAddOneTimingWeatherServiceConfigArgs = {
  record: CreateOneOneTimingWeatherServiceConfigInput;
};


export type MutationAddPackageArgs = {
  record: CreateOnePackageInput;
};


export type MutationAddPartArgs = {
  record: CreateOnePartInput;
};


export type MutationAddPartInstanceArgs = {
  record: CreateOnePartInstanceInput;
};


export type MutationAddPartInstanceForCopyAssemblyArgs = {
  record: CreateOnePartInstanceInput;
};


export type MutationAddPersonArgs = {
  record: CreateOnePersonInput;
};


export type MutationAddPlotPageConfigArgs = {
  record: CreateOnePlotPageConfigInput;
};


export type MutationAddPointsSystemArgs = {
  record: CreateOnePointsSystemInput;
};


export type MutationAddProjectArgs = {
  record: CreateOneProjectInput;
};


export type MutationAddQualityCheckArgs = {
  record: CreateOneQualityCheckInput;
};


export type MutationAddQualityCheckActionArgs = {
  record: CreateOneQualityCheckActionInput;
};


export type MutationAddRaceSeriesArgs = {
  record: CreateOneRaceSeriesInput;
};


export type MutationAddRadioMessageArgs = {
  record: CreateOneRadioMessageInput;
};


export type MutationAddReportNoteArgs = {
  eventID: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  page: EnumReportPage;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddReportNotesTemplateArgs = {
  record: CreateOneReportNotesTemplateInput;
};


export type MutationAddReportTemplateArgs = {
  record: CreateOneReportTemplateInput;
};


export type MutationAddRunPlanArgs = {
  record: CreateOneRunPlanInput;
};


export type MutationAddRunSheetArgs = {
  record: CreateOneRunSheetInput;
};


export type MutationAddRunSheetStyleArgs = {
  record: CreateOneRunSheetStyleInput;
};


export type MutationAddRunToRunPlanArgs = {
  runPlanID: Scalars['MongoID']['input'];
  runs: Array<InputMaybe<RunPlanRunInput>>;
};


export type MutationAddSeasonArgs = {
  record: CreateOneSeasonInput;
};


export type MutationAddSectorArgs = {
  NLapRun: Scalars['Int']['input'];
  runSheetID: Scalars['MongoID']['input'];
  sectorTime?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationAddSessionArgs = {
  record: CreateOneSessionInput;
};


export type MutationAddSessionDebriefTemplateArgs = {
  record: CreateOneTemplateSessionDebriefInput;
};


export type MutationAddSetupOverviewConfigArgs = {
  record: CreateOneSetupOverviewConfigInput;
};


export type MutationAddSetupSheetStyleArgs = {
  record: CreateOneSetupSheetStyleInput;
};


export type MutationAddSimRequestArgs = {
  record: CreateOneSimRequestInput;
};


export type MutationAddSimResultArgs = {
  record: CreateOneSimResultInput;
};


export type MutationAddSimulationDriveFileArgs = {
  record: CreateOneSimulationDriveFileInput;
};


export type MutationAddSkidPlateArgs = {
  record: CreateOneSkidPlateInput;
};


export type MutationAddSpecificationArgs = {
  record: CreateOneSpecificationInput;
};


export type MutationAddSpecificationGroupArgs = {
  chassisSpecID: Scalars['MongoID']['input'];
  record: CreateOneSpecificationGroupInput;
};


export type MutationAddSsoProviderArgs = {
  record: CreateOneSsoProviderInput;
};


export type MutationAddTagArgs = {
  record: CreateOneTagInput;
};


export type MutationAddTeamArgs = {
  record: CreateOneTeamInput;
};


export type MutationAddTemplateJobListArgs = {
  record: CreateOneTemplateJobListInput;
};


export type MutationAddTestUserArgs = {
  record: CreateOnePersonInput;
};


export type MutationAddTimeSheetEntryArgs = {
  record: CreateOneTimeSheetEntryInput;
};


export type MutationAddTimingServiceConfigArgs = {
  record: CreateOneTimingServiceConfigInput;
};


export type MutationAddToContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  target: ContestantField;
  toAdd: Scalars['MongoID']['input'];
};


export type MutationAddToEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  target: EventContestantField;
  toAdd: Scalars['MongoID']['input'];
};


export type MutationAddToSessionContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionID: Scalars['MongoID']['input'];
  target: SessionContestantField;
  toAdd: Scalars['MongoID']['input'];
};


export type MutationAddTrackArgs = {
  record: CreateOneTrackInput;
};


export type MutationAddTrackLayoutArgs = {
  record: CreateOneTrackLayoutInput;
};


export type MutationAddTrackStateArgs = {
  NLapRun: Scalars['Int']['input'];
  runSheetID: Scalars['MongoID']['input'];
  trackState?: InputMaybe<TrackStateInput>;
};


export type MutationAddTrackableArgs = {
  record: CreateOneTrackableInput;
};


export type MutationAddTrackingItemArgs = {
  record: CreateOneTrackingItemInput;
};


export type MutationAddTrackingMeasurementArgs = {
  record: CreateOneTrackingMeasurementInput;
};


export type MutationAddTrackingMeasurementRecordArgs = {
  record: CreateOneTrackingMeasurementRecordInput;
};


export type MutationAddTrackingRecordArgs = {
  record: CreateOneTrackingRecordInput;
};


export type MutationAddTrackingRecordGeneralArgs = {
  record: CreateOneTrackingRecordGeneralInput;
};


export type MutationAddTrackingRecordOverrideArgs = {
  record: CreateOneTrackingRecordOverrideInput;
};


export type MutationAddTrackingRecordValueArgs = {
  record: CreateOneTrackingRecordValueInput;
};


export type MutationAddTrackingSourceArgs = {
  record: CreateOneTrackingSourceInput;
};


export type MutationAddTrackingSourceAliasArgs = {
  record: CreateOneTrackingSourceAliasInput;
};


export type MutationAddTyreArgs = {
  record: CreateOneTyreInput;
};


export type MutationAddTyreSetArgs = {
  record: CreateOneTyreSetInput;
};


export type MutationAddTyreSetsToContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationAddTyreSetsToEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationAddTyreWearArgs = {
  record: CreateOneTyreWearInput;
};


export type MutationAddTyresToContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  tyreIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationAddTyresToEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  tyreIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationAddUserEnumArgs = {
  record: CreateOneUserEnumInput;
};


export type MutationAddWeatherArgs = {
  record: CreateOneWeatherInput;
};


export type MutationAddWeatherFromSourceArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  source: EnumWeatherSources;
  type?: InputMaybe<EnumWeatherType>;
  weatherID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationAddWeatherServiceConfigArgs = {
  record: CreateOneWeatherServiceConfigInput;
};


export type MutationAddvCarSectorArgs = {
  NLapRun: Scalars['Int']['input'];
  runSheetID: Scalars['MongoID']['input'];
  vCar?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationAppendWeatherArgs = {
  data: WeatherDataInput;
  weatherID: Scalars['MongoID']['input'];
};


export type MutationApplyLapSequenceArgs = {
  lapCount?: InputMaybe<Scalars['Int']['input']>;
  lapSequenceID?: InputMaybe<Scalars['MongoID']['input']>;
  lapTime?: InputMaybe<Scalars['Float']['input']>;
  lapType?: InputMaybe<EnumLapType>;
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationApplyMigrationArgs = {
  migration: EnumMigration;
};


export type MutationApplyPackageArgs = {
  carSetupIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  packageID: Scalars['MongoID']['input'];
};


export type MutationApplyPackageItemsArgs = {
  carSetupIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  packageItems?: InputMaybe<Array<InputMaybe<UpdateByIdPackageItemsInput>>>;
};


export type MutationApproveTimeSheetEntriesArgs = {
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  tStartAfter: Scalars['Date']['input'];
  tStartBefore: Scalars['Date']['input'];
};


export type MutationApproveTimeSheetEntryArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationAssignTeamArgs = {
  objectID: Scalars['MongoID']['input'];
  teamID: Scalars['MongoID']['input'];
  type: AssignableToTeam;
};


export type MutationCalculateMileagesByRunSheetIDsArgs = {
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  runSheetIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationCalculateRunEnergyArgs = {
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationClaimCarSetupArgs = {
  carSetupID: Scalars['MongoID']['input'];
};


export type MutationClaimRunSheetArgs = {
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationClonePackageArgs = {
  name: Scalars['String']['input'];
  packageID: Scalars['MongoID']['input'];
};


export type MutationCloneRunPlanArgs = {
  contestantID: Scalars['MongoID']['input'];
  runPlanID: Scalars['MongoID']['input'];
  sessionID: Scalars['MongoID']['input'];
};


export type MutationCopyAssemblyArgs = {
  assemblyToCopyID: Scalars['MongoID']['input'];
  dummyPart?: InputMaybe<Scalars['Boolean']['input']>;
  newRootAssemblyName?: InputMaybe<Scalars['String']['input']>;
  newRootReference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCopyCarSetupArgs = {
  newAuthorID?: InputMaybe<Scalars['MongoID']['input']>;
  newTitle?: InputMaybe<Scalars['String']['input']>;
  sourceSetupID: Scalars['MongoID']['input'];
  targetRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationCopyChassisAssemblyArgs = {
  chassisAssemblyID: Scalars['MongoID']['input'];
  newCarSetupID: Scalars['MongoID']['input'];
};


export type MutationCopyEventArgs = {
  calculateSessionTimes?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  overrides?: InputMaybe<CopyEventOverridesInput>;
  sourceEventID: Scalars['MongoID']['input'];
  tEventStart: Scalars['Date']['input'];
  targetSeasonID: Scalars['MongoID']['input'];
};


export type MutationCreateBackupArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  omitMetadata?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateGoLookAtAssemblyRecordArgs = {
  chassisAssemblyID: Scalars['MongoID']['input'];
};


export type MutationCreatePackageArgs = {
  baselineSetupID: Scalars['MongoID']['input'];
  candidateSetupID: Scalars['MongoID']['input'];
  copyReferencePackageID?: InputMaybe<Scalars['MongoID']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  method?: InputMaybe<EnumPackageMethod>;
  name: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  useAsCopyReference?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateTyresForContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  sets?: InputMaybe<Array<CreateTyreSetRecordInput>>;
  tyres?: InputMaybe<Array<CreateTyreRecordInput>>;
};


export type MutationDataCheckArgs = {
  actions?: InputMaybe<Array<InputMaybe<EnumDataCheck>>>;
  writeData: Scalars['Boolean']['input'];
};


export type MutationDraftNotesFromTemplateArgs = {
  eventID: Scalars['String']['input'];
  notesTemplateId: Scalars['MongoID']['input'];
  pages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDraftRunSheetsArgs = {
  runPlanID: Scalars['MongoID']['input'];
  runSheetIDS?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type MutationFixAssemblyTrackingArgs = {
  chassisAssemblyIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationFixPartInstanceArraysArgs = {
  assemblyID: Scalars['MongoID']['input'];
};


export type MutationFixPartInstancesResolverArgs = {
  partIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationFixPartTrackingHistoryArgs = {
  partID: Scalars['MongoID']['input'];
};


export type MutationFixTrackingForAssemblyPartsArgs = {
  chassisAssemblyID: Scalars['MongoID']['input'];
};


export type MutationForceAddLapArgs = {
  lap: LapInput;
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationForgotPasswordArgs = {
  clientRoot?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};


export type MutationForwardAddPartInstanceArgs = {
  chassisAssemblyID: Scalars['MongoID']['input'];
  partID: Scalars['MongoID']['input'];
  readingLocation?: InputMaybe<EnumReadingLocation>;
  sessionID: Scalars['MongoID']['input'];
};


export type MutationForwardUpdateCarSetupArgs = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  carSetupID: Scalars['MongoID']['input'];
  field: Scalars['String']['input'];
  stringValue?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationForwardUpsertPartInstanceArgs = {
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  measurementIndex?: InputMaybe<Scalars['Int']['input']>;
  measurements?: InputMaybe<PartInstanceMeasurementInput>;
  newPartID?: InputMaybe<Scalars['MongoID']['input']>;
  readingLocation: EnumReadingLocation;
  specificationID: Scalars['MongoID']['input'];
  trackingItemReferenceDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationGreeboLogPushGpsDataArgs = {
  data: Array<CarGpsDataPointInput>;
  eventID?: InputMaybe<Scalars['String']['input']>;
  sessionID?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGreeboLogPushRawLinesArgs = {
  eventID?: InputMaybe<Scalars['String']['input']>;
  lines: Array<Scalars['String']['input']>;
  sessionID?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGreeboLogUpdateCarPositionsArgs = {
  carPositions: Array<CarTrackPositionInput>;
  eventID?: InputMaybe<Scalars['String']['input']>;
  sessionID?: InputMaybe<Scalars['String']['input']>;
};


export type MutationIncrementRunSheetArgs = {
  prevRunSheetID: Scalars['MongoID']['input'];
  record?: InputMaybe<UpdateByIdRunSheetInput>;
};


export type MutationIncrementSetupSheetArgs = {
  destRunSheetID: Scalars['MongoID']['input'];
  sourceRunSheetID: Scalars['MongoID']['input'];
};


export type MutationIncrementSpecificationArgs = {
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID: Scalars['MongoID']['input'];
};


export type MutationInsertLapArgs = {
  lapToInsertBeforeID: Scalars['MongoID']['input'];
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationInsertRunArgs = {
  copyCarSetup?: InputMaybe<Scalars['Boolean']['input']>;
  insertAfterRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  insertBeforeRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  sourceRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  sourceSetupID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationInsertRunInRunPlanArgs = {
  NRun: Scalars['Int']['input'];
  run: RunPlanRunInput;
  runPlanID: Scalars['MongoID']['input'];
};


export type MutationInsertRunIntoSessionArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionID: Scalars['MongoID']['input'];
  sourceRunSheetID: Scalars['MongoID']['input'];
};


export type MutationLiveStandingsStartArgs = {
  configID: Scalars['MongoID']['input'];
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationManageIssueArgs = {
  action: IssueAction;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedBy?: InputMaybe<Scalars['MongoID']['input']>;
  issueID: Scalars['MongoID']['input'];
};


export type MutationManageJobArgs = {
  action: JobAction;
  jobID: Scalars['MongoID']['input'];
  target?: InputMaybe<EnumJobTarget>;
};


export type MutationOneTimingWeatherServiceConfigureArgs = {
  config: OneTimingWeatherServiceConfigInput;
};


export type MutationOneTimingWeatherServiceStartArgs = {
  configID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationRecalculatePartMileageByIdResolverArgs = {
  partID: Scalars['MongoID']['input'];
};


export type MutationRegeneratePartTrackingHistoryArgs = {
  partIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationReleaseChassisSpecArgs = {
  chassisSpecID: Scalars['MongoID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveAssemblyArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveAssemblyTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveBestValuesArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveBopArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveBuildSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveCalculationArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveCarDataServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveCarSetupArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveChassisArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveChassisMeasurementArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveCommentArgs = {
  commentID: Scalars['MongoID']['input'];
  subjectID: Scalars['MongoID']['input'];
  target?: InputMaybe<EnumJobTarget>;
};


export type MutationRemoveContestantArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveDepartmentArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveDynoConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveEventArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
};


export type MutationRemoveFlexLayoutConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveFromContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  target: ContestantField;
  toRemove: Scalars['MongoID']['input'];
};


export type MutationRemoveFromEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  target: EventContestantField;
  toRemove: Scalars['MongoID']['input'];
};


export type MutationRemoveFromSessionContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionID: Scalars['MongoID']['input'];
  target: SessionContestantField;
  toRemove: Scalars['MongoID']['input'];
};


export type MutationRemoveIssueArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveJobArgs = {
  _id: Scalars['MongoID']['input'];
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  target?: InputMaybe<EnumJobTarget>;
};


export type MutationRemoveLapArgs = {
  NLapRun: Scalars['Int']['input'];
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationRemoveLapByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveLapByIdByServiceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveLapSequenceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveLapSequenceTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveLocationArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveManufacturerArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveManyEventContestantsArgs = {
  contestantIDs: Array<Scalars['MongoID']['input']>;
  eventID: Scalars['MongoID']['input'];
};


export type MutationRemoveManyJobsArgs = {
  jobIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationRemoveManySimRequestsArgs = {
  filter: FilterRemoveManySimRequestInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveManySimResultsArgs = {
  filter: FilterRemoveManySimResultInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveManyTimeSheetEntriesArgs = {
  timeSheetEntryIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type MutationRemoveManyTyreSetsArgs = {
  tyreSetIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type MutationRemoveManyTyresArgs = {
  tyreIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type MutationRemoveOneTimingWeatherServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemovePackageArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemovePartArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemovePartInstanceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemovePersonArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemovePlotPageConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemovePointsSystemArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveProjectArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveQualityCheckArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveQualityCheckActionArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveRaceSeriesArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveRadioMessageArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveReportNoteArgs = {
  eventID: Scalars['String']['input'];
  noteID: Scalars['String']['input'];
  page: EnumReportPage;
};


export type MutationRemoveReportNotesTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveReportTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveRunFromRunPlanArgs = {
  NRun: Scalars['Int']['input'];
  runPlanID: Scalars['MongoID']['input'];
};


export type MutationRemoveRunPlanArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveRunSheetArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveRunSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSeasonArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSessionArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSessionDebriefTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSetupOverviewConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSetupSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSimRequestArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSimResultArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSimulationDriveFileArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSkidPlateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSpecificationArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSpecificationGroupArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSsoProviderArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTagArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTeamArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTemplateJobListArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTimeSheetEntryArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTimingServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackLayoutArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackableArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackingItemArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackingMeasurementArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackingMeasurementRecordArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackingRecordArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackingSourceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackingSourceAliasArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTyreArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTyreSetArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTyreSetsFromContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationRemoveTyreSetsFromEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationRemoveTyreWearArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTyresFromContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  tyreIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationRemoveTyresFromEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  tyreIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationRemoveUserEnumArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveWeatherArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveWeatherServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRenameSpecificationArgs = {
  name: Scalars['String']['input'];
  specificationID: Scalars['MongoID']['input'];
};


export type MutationReorderRunPlanRunsArgs = {
  newNRunOrder?: InputMaybe<Array<Scalars['Int']['input']>>;
  runPlanID: Scalars['MongoID']['input'];
};


export type MutationResetPasswordArgs = {
  username: Scalars['String']['input'];
};


export type MutationResetTyrePressureSheetArgs = {
  tyrePressureSheetID: Scalars['MongoID']['input'];
};


export type MutationRestoreBackupArgs = {
  name: Scalars['String']['input'];
  skipSafetyBackup?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationScrapManyTyresArgs = {
  tyreIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type MutationSelfResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationSplitRunSheetArgs = {
  lapID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationSwapPartInstanceArgs = {
  parentID: Scalars['MongoID']['input'];
  partID: Scalars['MongoID']['input'];
  readingLocation?: InputMaybe<EnumReadingLocation>;
  specificationID: Scalars['MongoID']['input'];
};


export type MutationUnapproveTimeSheetEntriesArgs = {
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  tStartAfter: Scalars['Date']['input'];
  tStartBefore: Scalars['Date']['input'];
};


export type MutationUnapproveTimeSheetEntryArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationUnclaimCarSetupArgs = {
  carSetupID: Scalars['MongoID']['input'];
};


export type MutationUnclaimRunSheetArgs = {
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationUnreleaseChassisSpecArgs = {
  chassisSpecID: Scalars['MongoID']['input'];
};


export type MutationUpdateAssemblyArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdAssemblyInput;
};


export type MutationUpdateAssemblyTemplateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdAssemblyTemplateInput;
};


export type MutationUpdateBestValuesArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdBestValuesInput;
};


export type MutationUpdateBopArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdBopInput;
};


export type MutationUpdateBuildSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdBuildSheetStyleInput;
};


export type MutationUpdateCalculationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCalculationInput;
};


export type MutationUpdateCarDataServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCarDataServiceConfigInput;
};


export type MutationUpdateCarSetupArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCarSetupInput;
};


export type MutationUpdateChassisArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdChassisInput;
};


export type MutationUpdateChassisAssemblyTrackingArgs = {
  chassisAssemblyID: Scalars['MongoID']['input'];
};


export type MutationUpdateChassisMeasurementArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdChassisMeasurementInput;
};


export type MutationUpdateChassisSpecVersionOnCarSetupsArgs = {
  rootSpecificationID: Scalars['MongoID']['input'];
  timeRangeEnd?: InputMaybe<Scalars['Date']['input']>;
  timeRangeStart?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationUpdateCommentArgs = {
  commentID: Scalars['MongoID']['input'];
  subjectID: Scalars['MongoID']['input'];
  target?: InputMaybe<EnumJobTarget>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateContestantArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdContestantInput;
};


export type MutationUpdateDepartmentArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdDepartmentInput;
};


export type MutationUpdateDriversInEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  driverIDs: Array<Scalars['MongoID']['input']>;
  eventID: Scalars['MongoID']['input'];
};


export type MutationUpdateDynoConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdDynoConfigInput;
};


export type MutationUpdateEventArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdEventInput;
};


export type MutationUpdateFlexLayoutConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdFlexLayoutConfigInput;
};


export type MutationUpdateIssueArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdIssueInput;
};


export type MutationUpdateJobArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdJobInput;
  target?: InputMaybe<EnumJobTarget>;
};


export type MutationUpdateLapArgs = {
  NLapRun: Scalars['Int']['input'];
  lap: UpdateByIdLapInput;
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationUpdateLapByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLapInput;
};


export type MutationUpdateLapByIdByServiceArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLapInput;
};


export type MutationUpdateLapDataByIdArgs = {
  _id: Scalars['MongoID']['input'];
  data?: InputMaybe<UpdateByIdLapDataInput>;
  source: EnumLapDataSource;
};


export type MutationUpdateLapInSessionArgs = {
  NLapSession: Scalars['Int']['input'];
  contestantID: Scalars['MongoID']['input'];
  lap: UpdateByIdLapInput;
  sessionID: Scalars['MongoID']['input'];
};


export type MutationUpdateLapSequenceArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLapSequenceInput;
};


export type MutationUpdateLapSequenceTemplateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLapSequenceTemplateInput;
};


export type MutationUpdateLocationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLocationInput;
};


export type MutationUpdateLogArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLogInput;
};


export type MutationUpdateLogByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationUpdateManufacturerArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdManufacturerInput;
};


export type MutationUpdateMeArgs = {
  record: UpdateMeInput;
};


export type MutationUpdateMigrationsArgs = {
  record: MigrationsInput;
};


export type MutationUpdateOneTimingWeatherServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdOneTimingWeatherServiceConfigInput;
};


export type MutationUpdatePackageArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPackageInput;
};


export type MutationUpdatePartArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPartInput;
};


export type MutationUpdatePartInstanceArgs = {
  _id: Scalars['MongoID']['input'];
  doNotTriggerCarSetupUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  record: UpdateByIdPartInstanceInput;
};


export type MutationUpdatePersonArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPersonInput;
};


export type MutationUpdatePlotPageConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPlotPageConfigInput;
};


export type MutationUpdatePointsSystemArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPointsSystemInput;
};


export type MutationUpdateProjectArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProjectInput;
};


export type MutationUpdateQualityCheckArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdQualityCheckInput;
};


export type MutationUpdateQualityCheckActionArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdQualityCheckActionInput;
};


export type MutationUpdateRaceSeriesArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdRaceSeriesInput;
};


export type MutationUpdateRadioMessageArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdRadioMessageInput;
};


export type MutationUpdateReportNoteArgs = {
  eventID: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  noteID: Scalars['String']['input'];
  page: EnumReportPage;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateReportTemplateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdReportTemplateInput;
};


export type MutationUpdateRunInRunPlanArgs = {
  NRun: Scalars['Int']['input'];
  runPlanID: Scalars['MongoID']['input'];
  updatedFields: UpdateByIdRunPlanRunInput;
};


export type MutationUpdateRunPlanArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdRunPlanInput;
};


export type MutationUpdateRunSheetArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdRunSheetInput;
};


export type MutationUpdateRunSheetLapKpiArgs = {
  laps?: InputMaybe<Array<UpdateByIdLapInput>>;
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationUpdateRunSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdRunSheetStyleInput;
};


export type MutationUpdateSeasonArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSeasonInput;
};


export type MutationUpdateServerSettingsArgs = {
  serverSettings: ServerSettingsInput;
};


export type MutationUpdateSessionArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSessionInput;
};


export type MutationUpdateSessionDebriefTemplateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTemplateSessionDebriefInput;
};


export type MutationUpdateSetupOverviewConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSetupOverviewConfigInput;
};


export type MutationUpdateSetupSheetLayoutChassisSpecArgs = {
  chassisSpecID: Scalars['MongoID']['input'];
  setupSheetLayoutID: Scalars['MongoID']['input'];
};


export type MutationUpdateSetupSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSetupSheetStyleInput;
};


export type MutationUpdateSimRequestArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSimRequestInput;
};


export type MutationUpdateSimResultArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSimResultInput;
};


export type MutationUpdateSimulationDriveFileArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSimulationDriveFileInput;
};


export type MutationUpdateSkidPlateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSkidPlateInput;
};


export type MutationUpdateSpecificationArgs = {
  _id: Scalars['MongoID']['input'];
  confirmUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  currentChassisSpecID: Scalars['MongoID']['input'];
  record: UpdateByIdSpecificationInput;
};


export type MutationUpdateSpecificationAdminArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSpecificationAdminInput;
};


export type MutationUpdateSpecificationGroupArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSpecificationGroupInput;
};


export type MutationUpdateTagArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTagInput;
};


export type MutationUpdateTeamArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTeamInput;
};


export type MutationUpdateTemplateJobListArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTemplateJobListInput;
};


export type MutationUpdateTimeSheetEntryArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTimeSheetEntryInput;
};


export type MutationUpdateTimingServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTimingServiceConfigInput;
};


export type MutationUpdateTimingServiceStatusArgs = {
  timingServiceStatus: TimingServiceStatusInput;
};


export type MutationUpdateTrackArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackInput;
};


export type MutationUpdateTrackLayoutArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackLayoutInput;
};


export type MutationUpdateTrackableArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackableInput;
};


export type MutationUpdateTrackingItemArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingItemInput;
};


export type MutationUpdateTrackingMeasurementArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingMeasurementInput;
};


export type MutationUpdateTrackingMeasurementRecordArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingMeasurementRecordInput;
};


export type MutationUpdateTrackingRecordArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingRecordInput;
};


export type MutationUpdateTrackingSourceArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingSourceInput;
};


export type MutationUpdateTrackingSourceAliasArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingSourceAliasInput;
};


export type MutationUpdateTrackingSourceSourceValueInAssemblyArgs = {
  assemblyID: Scalars['MongoID']['input'];
  trackingSourceAliasID: Scalars['MongoID']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateTyreArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTyreInput;
};


export type MutationUpdateTyrePressureSheetArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  record: TyrePressureSheetInput;
};


export type MutationUpdateTyrePressureSheetDataArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  record: TyreSetupDataInput;
  sessionID: Scalars['MongoID']['input'];
  tyreSetID: Scalars['MongoID']['input'];
};


export type MutationUpdateTyreSetArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTyreSetInput;
};


export type MutationUpdateTyreWearArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTyreWearInput;
};


export type MutationUpdateTyresInSetArgs = {
  record: UpdateByIdTyreInput;
  tyreSetID: Scalars['MongoID']['input'];
};


export type MutationUpdateUserEnumArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdUserEnumInput;
};


export type MutationUpdateWeatherArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdWeatherInput;
};


export type MutationUpdateWeatherServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdWeatherServiceConfigInput;
};


export type MutationUpsertBopArgs = {
  bopID?: InputMaybe<Scalars['MongoID']['input']>;
  record: CreateOneBopInput;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationUpsertCarBuildArgs = {
  NRun: Scalars['Float']['input'];
  contestantID: Scalars['MongoID']['input'];
  parts?: InputMaybe<Scalars['JSON']['input']>;
  timestamp: Scalars['Date']['input'];
};


export type MutationUpsertPartInstanceArgs = {
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  measurementIndex: Scalars['Int']['input'];
  measurements?: InputMaybe<PartInstanceMeasurementInput>;
  parentID: Scalars['MongoID']['input'];
  readingLocation: EnumReadingLocation;
  specificationID: Scalars['MongoID']['input'];
};

export type NonChassisSpec = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
};

export type NonChassisSpecificationUnion = AeroElementSpec | AeroPackageSpec | AntiRollBarSpec | CustomSpec | DamperSpec | DifferentialSpec | ElasticSpec | GearBoxSpec | GearSpec | KinematicsExternalSpec | KinematicsInternalSpec;

export type NotificationConfig = {
  faultAssigned?: Maybe<Scalars['Boolean']['output']>;
  faultCommentedOn?: Maybe<Scalars['Boolean']['output']>;
  faultStatusChanged?: Maybe<Scalars['Boolean']['output']>;
  jobAssigned?: Maybe<Scalars['Boolean']['output']>;
  jobCommentedOn?: Maybe<Scalars['Boolean']['output']>;
  jobStatusChanged?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationConfigInput = {
  faultAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  faultCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  faultStatusChanged?: InputMaybe<Scalars['Boolean']['input']>;
  jobAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  jobCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  jobStatusChanged?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberUnitField = {
  unit: EnumUntypedUnit;
};

export type OneTimingWeatherServiceConfig = {
  _id: Scalars['MongoID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** API event IDs to which the weather data should be published. */
  eventIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Weather station's latitude from geolocation */
  latitude?: Maybe<Scalars['Float']['output']>;
  logLevel?: Maybe<EnumOneTimingWeatherServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: Maybe<Scalars['Boolean']['output']>;
  /** Weather station's longitude from geolocation */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Name for this set of configuration settings. */
  name: Scalars['String']['output'];
  /** One Timing server port. */
  timingPort: Scalars['Int']['output'];
  /** One Timing server address. */
  timingURL: Scalars['String']['output'];
  /** Time interval in seconds between two API data updates. */
  updateInterval?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: Maybe<Scalars['Boolean']['output']>;
};

export type OneTimingWeatherServiceConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event IDs to which the weather data should be published. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Weather station's latitude from geolocation */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  logLevel?: InputMaybe<EnumOneTimingWeatherServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weather station's longitude from geolocation */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Name for this set of configuration settings. */
  name: Scalars['String']['input'];
  /** One Timing server port. */
  timingPort: Scalars['Int']['input'];
  /** One Timing server address. */
  timingURL: Scalars['String']['input'];
  /** Time interval in seconds between two API data updates. */
  updateInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

/** List of items with pagination. */
export type OneTimingWeatherServiceConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<OneTimingWeatherServiceConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type OneTimingWeatherServiceStartResult = {
  success: Scalars['Boolean']['output'];
};

export const OneTimingWeatherServiceStatus = {
  /** Stopped due to error. See log for details. */
  ERROR: 'ERROR',
  /** Stopped due to end of event. */
  FINISHED: 'FINISHED',
  /** Ready to receive a start command. */
  READY: 'READY',
  /** Watching and acting on timing data. */
  RUNNING: 'RUNNING',
  /** Stopped by user. */
  STOPPED: 'STOPPED'
} as const;

export type OneTimingWeatherServiceStatus = typeof OneTimingWeatherServiceStatus[keyof typeof OneTimingWeatherServiceStatus];
export type OneTimingWeatherServiceStopResult = {
  success: Scalars['Boolean']['output'];
};

export type OrientationUnitField = {
  unit: EnumUntypedUnit;
};

export type Package = {
  _id: Scalars['MongoID']['output'];
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  chassisSpec?: Maybe<ChassisSpec>;
  chassisSpecID: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['MongoID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<PackageItems>>>;
  name: Scalars['String']['output'];
  teamIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  teams: Array<Team>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  useAsCopyReference?: Maybe<Scalars['Boolean']['output']>;
};

export type PackageItems = {
  /** 'setup.front.hRide' or 'spec.specID.adjustables.adjIndex.LOCATION' */
  path?: Maybe<Scalars['String']['output']>;
  /** string | number | null (also can 'delete' certain things from a setup) */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type PackageItemsInput = {
  /** 'setup.front.hRide' or 'spec.specID.adjustables.adjIndex.LOCATION' */
  path?: InputMaybe<Scalars['String']['input']>;
  /** string | number | null (also can 'delete' certain things from a setup) */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** List of items with pagination. */
export type PackagePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Package>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PaginationInfo = {
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  perPage?: Maybe<Scalars['Int']['output']>;
};

export type PaginationInfoAssembly = {
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
};

export type Part = {
  _id: Scalars['MongoID']['output'];
  chassisSpecName?: Maybe<Scalars['String']['output']>;
  /** Can this very part be used multiple times on a car. For 'virtual parts' or other special applications. Overrides the setting of the specification. */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentlyInUse?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  eligibleEventTypes?: Maybe<EnumPartEligibleEventTypes>;
  /** To be used for dummy parts or at user discretion for special applications. */
  isVirtualPart?: Maybe<Scalars['Boolean']['output']>;
  lifetimeMileage?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Location>;
  locationID?: Maybe<Scalars['MongoID']['output']>;
  manufacturer?: Maybe<Manufacturer>;
  manufacturerID?: Maybe<Scalars['MongoID']['output']>;
  manufacturerPartID?: Maybe<Scalars['String']['output']>;
  manufacturerSerialNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  partNumber?: Maybe<Scalars['String']['output']>;
  partStatus?: Maybe<PartStatus>;
  properties?: Maybe<Scalars['JSON']['output']>;
  readingLocationOverride?: Maybe<Array<Maybe<EnumPartReadingLocationOverride>>>;
  reference: Scalars['String']['output'];
  rootAssemblies: Array<Assembly>;
  rootAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  rootSpecification?: Maybe<Specification>;
  rootSpecificationID?: Maybe<Scalars['MongoID']['output']>;
  specification?: Maybe<BaseSpecification>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  team?: Maybe<Team>;
  /** @deprecated Use teamIDs */
  teamID?: Maybe<Scalars['MongoID']['output']>;
  teamIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  teams: Array<Team>;
  /** Tracking */
  tracking?: Maybe<Array<Maybe<TrackingEntry>>>;
  trackingHistory: Array<TrackingRecord>;
  trackingHistoryFullAndSnapshot?: Maybe<PartReturnTrackingHistoryFullandSnapshot>;
  trackingHistoryIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingMeasurementHistory: Array<TrackingMeasurementRecord>;
  trackingMeasurementHistoryIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumPartType?: Maybe<UserEnumPartType>;
  userEnumPartTypeID?: Maybe<Scalars['MongoID']['output']>;
};


export type PartTrackingArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  historyFromDate?: InputMaybe<Scalars['Date']['input']>;
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingItemNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PartInEvent = {
  part?: Maybe<Part>;
  runDistance?: Maybe<Scalars['Float']['output']>;
  runs?: Maybe<Array<Maybe<PartInEventRun>>>;
  serviceMileage?: Maybe<Scalars['Float']['output']>;
};

export type PartInEventRun = {
  assemblyID?: Maybe<Scalars['String']['output']>;
  assemblyName?: Maybe<Scalars['String']['output']>;
  carSetupID?: Maybe<Scalars['String']['output']>;
  carSetupTitle?: Maybe<Scalars['String']['output']>;
  contestantID?: Maybe<Scalars['String']['output']>;
  mileage?: Maybe<Scalars['Float']['output']>;
  runID?: Maybe<Scalars['String']['output']>;
  runName?: Maybe<Scalars['String']['output']>;
  runTime?: Maybe<Scalars['Float']['output']>;
};

export type PartInstance = {
  _id: Scalars['MongoID']['output'];
  measurements?: Maybe<Array<Maybe<PartInstanceMeasurement>>>;
  parent?: Maybe<Assembly>;
  parentID?: Maybe<Scalars['MongoID']['output']>;
  part?: Maybe<Part>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  readingLocation?: Maybe<EnumReadingLocation>;
  specification?: Maybe<Specification>;
  specificationGroup?: Maybe<Specification>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  superParentID?: Maybe<Scalars['MongoID']['output']>;
  trackingItemReferenceDate?: Maybe<Scalars['Date']['output']>;
};

export type PartInstanceMeasurement = {
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  coordinates?: Maybe<PartInstanceMeasurementCoordinates>;
  floatValue?: Maybe<Scalars['Float']['output']>;
  idx?: Maybe<Scalars['Float']['output']>;
  rotation?: Maybe<PartInstanceMeasurementRotation>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the fields `floatValue`, `stringValue`, or `booleanValue` instead. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PartInstanceMeasurementCoordinates = {
  /** Coordinate value x */
  x?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value y */
  y?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value z */
  z?: Maybe<Scalars['Float']['output']>;
};

export type PartInstanceMeasurementCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type PartInstanceMeasurementInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<PartInstanceMeasurementCoordinatesInput>;
  floatValue?: InputMaybe<Scalars['Float']['input']>;
  idx?: InputMaybe<Scalars['Float']['input']>;
  rotation?: InputMaybe<PartInstanceMeasurementRotationInput>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type PartInstanceMeasurementRotation = {
  /** Rotation value I */
  I?: Maybe<Scalars['Float']['output']>;
  /** Rotation value J */
  J?: Maybe<Scalars['Float']['output']>;
  /** Rotation value K */
  K?: Maybe<Scalars['Float']['output']>;
};

export type PartInstanceMeasurementRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type PartInstancePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PartInstance>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PartInstanceUpdateResult = {
  error?: Maybe<ErrorInterface>;
  record?: Maybe<PartInstance>;
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

/** List of items with pagination. */
export type PartPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Part>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PartReturnTrackingHistoryFullandSnapshot = {
  trackingHistoryFull?: Maybe<Array<Maybe<PartTrackingHistoryFullandSnapshot>>>;
  trackingSnapshot?: Maybe<Array<Maybe<PartTrackingHistoryFullandSnapshot>>>;
};

export type PartStatus = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  statusComment?: Maybe<Scalars['String']['output']>;
  userEnumPartStatus?: Maybe<UserEnumPartStatus>;
  userEnumPartStatusID?: Maybe<Scalars['MongoID']['output']>;
  userEnumPartStatusName?: Maybe<Scalars['String']['output']>;
};

export type PartStatusInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  statusComment?: InputMaybe<Scalars['String']['input']>;
  userEnumPartStatusID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type PartTrackingHistoryFullandSnapshot = {
  active?: Maybe<Scalars['Boolean']['output']>;
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cumulativeValue?: Maybe<Scalars['Float']['output']>;
  dateResolved?: Maybe<Scalars['Date']['output']>;
  limitCritical?: Maybe<Scalars['Boolean']['output']>;
  limitWarning?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<GeoLocation>;
  mass?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  qualityCheckID?: Maybe<Scalars['MongoID']['output']>;
  recordErrors?: Maybe<Scalars['String']['output']>;
  reset?: Maybe<Scalars['Boolean']['output']>;
  statusEnumID?: Maybe<Scalars['MongoID']['output']>;
  trackingItem?: Maybe<TrackingItem>;
  trackingItemID?: Maybe<Scalars['MongoID']['output']>;
  trackingRecordID?: Maybe<Scalars['MongoID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumPartStatusName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type PartsInEventResult = {
  count: Scalars['Int']['output'];
  items?: Maybe<Array<Maybe<PartInEvent>>>;
  pageInfo?: Maybe<PaginationInfo>;
};

export type Person = {
  _id: Scalars['MongoID']['output'];
  /** 3-letter acronym for drivers */
  acronym?: Maybe<Scalars['String']['output']>;
  behaviour?: Maybe<BehaviourConfig>;
  birthday?: Maybe<Scalars['Date']['output']>;
  canopyCredentials?: Maybe<CanopyCredentials>;
  carUpdateMethod?: Maybe<EnumPersonCarUpdateMethod>;
  /**
   * IDs of contestants visible to this person when logged in.
   * @deprecated Use `visibleContestantIDs` instead
   */
  contestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /**
   * Contestants visible to this person when logged in.
   * @deprecated Use `visibleContestants` instead
   */
  contestants: Array<Contestant>;
  defaultFlexLayoutConfigs?: Maybe<DefaultFlexLayoutConfigs>;
  defaultRunSheetCompareStyle?: Maybe<RunSheetStyle>;
  defaultRunSheetCompareStyleID?: Maybe<Scalars['MongoID']['output']>;
  defaultRunSheetStyle?: Maybe<RunSheetStyle>;
  defaultRunSheetStyleID?: Maybe<Scalars['MongoID']['output']>;
  defaultRunSheetStylePhone?: Maybe<RunSheetStyle>;
  defaultRunSheetStylePhoneID?: Maybe<Scalars['MongoID']['output']>;
  defaultTyreReferenceTemperature?: Maybe<Scalars['Float']['output']>;
  /** Default string for tyre set naming, where x=Chassis, i=Info, s=SetNumber, (c=Corner or a=Axle) */
  defaultTyreSetNameFormat?: Maybe<Scalars['String']['output']>;
  displayColor?: Maybe<Scalars['String']['output']>;
  dynoConfig?: Maybe<DynoConfig>;
  dynoConfigID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of contestants editable to this person when logged in. */
  editableContestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  email?: Maybe<Scalars['String']['output']>;
  emailNotificationConfig?: Maybe<NotificationConfig>;
  /**
   * IDs of events visible to this person when logged in.
   * @deprecated Use `visibleEventIDs` instead
   */
  eventIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /**
   * Events visible to this person when logged in.
   * @deprecated Use `visibleEvents` instead
   */
  events: Array<Event>;
  /** Should this user be unable to see KPIs? */
  hideKPIs?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Should this user be able to track his working time? */
  isTimeTracker?: Maybe<Scalars['Boolean']['output']>;
  /** Should this user be able to see, update and approve working times for other users? */
  isTimeTrackerAdmin?: Maybe<Scalars['Boolean']['output']>;
  lapSequenceTemplateIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  lapSequenceTemplates: Array<LapSequenceTemplate>;
  localConnections?: Maybe<Array<Maybe<LocalConnection>>>;
  mileageUnit?: Maybe<EnumLengthUnit>;
  name: Scalars['String']['output'];
  passportNumber?: Maybe<Scalars['String']['output']>;
  passportPicture?: Maybe<Scalars['String']['output']>;
  /** Collection of favourite plot page config IDs. */
  plotPageConfigIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Collection of favourite plot page configs. */
  plotPageConfigs: Array<PlotPageConfig>;
  privateMobile?: Maybe<Scalars['Float']['output']>;
  privatePhone?: Maybe<Scalars['Float']['output']>;
  role?: Maybe<EnumPersonRole>;
  /** Collection of favourite setup overview config IDs. */
  setupOverviewConfigIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  team?: Maybe<Team>;
  teamID?: Maybe<Scalars['MongoID']['output']>;
  timeApprovees: Array<Person>;
  timeSheetEntries?: Maybe<Array<Maybe<TimeSheetEntry>>>;
  timeTrackerApprovalByPersonID?: Maybe<Scalars['MongoID']['output']>;
  /** Collection of personal setup IDs. */
  userSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Collection of personal setups. */
  userSetups: Array<CarSetup>;
  userSimulationSettings?: Maybe<UserSimulationSettings>;
  username: Scalars['String']['output'];
  viewConfig?: Maybe<ViewConfig>;
  /** IDs of contestants visible to this person when logged in. */
  visibleContestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Contestants visible to this person when logged in. */
  visibleContestants: Array<Contestant>;
  /** IDs of events visible to this person when logged in. */
  visibleEventIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Events visible to this person when logged in. */
  visibleEvents: Array<Event>;
  /** IDs of teams visible to this person when logged in. */
  visibleTeamIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  workMobile?: Maybe<Scalars['Float']['output']>;
  workPhone?: Maybe<Scalars['Float']['output']>;
};


export type PersonTimeApproveesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPersonInput>;
};


export type PersonTimeSheetEntriesArgs = {
  tStartAfter: Scalars['Date']['input'];
  tStartBefore: Scalars['Date']['input'];
};

/** List of items with pagination. */
export type PersonPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Person>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlotConfig = {
  index: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  xAxisType: EnumPlotConfigXAxisType;
  xDataSource: Scalars['String']['output'];
  xLabel: Scalars['String']['output'];
  /** Object containing at least `label`, and optionally `color`, `lineStyle` (from `EnumLineStyle`), and `marker` (from `EnumMarkerType`) properties */
  yData: Scalars['JSON']['output'];
  /** @deprecated Use as a key in `yData` instead. */
  yDataSource?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use as a value in `yData` instead. */
  yLabel?: Maybe<Scalars['String']['output']>;
  yLines?: Maybe<Array<Maybe<PlotConfigLine>>>;
};

export type PlotConfigInput = {
  index: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  xAxisType: EnumPlotConfigXAxisType;
  xDataSource: Scalars['String']['input'];
  xLabel: Scalars['String']['input'];
  /** Object containing at least `label`, and optionally `color`, `lineStyle` (from `EnumLineStyle`), and `marker` (from `EnumMarkerType`) properties */
  yData: Scalars['JSON']['input'];
  yDataSource?: InputMaybe<Scalars['String']['input']>;
  yLabel?: InputMaybe<Scalars['String']['input']>;
  yLines?: InputMaybe<Array<InputMaybe<PlotConfigLineInput>>>;
};

export type PlotConfigLine = {
  color?: Maybe<Scalars['String']['output']>;
  style?: Maybe<EnumLineStyle>;
  value: Scalars['Float']['output'];
};

export type PlotConfigLineInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<EnumLineStyle>;
  value: Scalars['Float']['input'];
};

export type PlotPageConfig = {
  _id: Scalars['MongoID']['output'];
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  /** Number of columns in the grid. */
  gridCols: Scalars['Int']['output'];
  /** Number of rows in the grid. */
  gridRows: Scalars['Int']['output'];
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  plots: Array<Maybe<PlotConfig>>;
  title?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type PlotPageConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PlotPageConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PointsSystem = {
  _id: Scalars['MongoID']['output'];
  /** Array of points for the fastest lap */
  laptimeDriverPoints?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Race position cutoff for drivers eligible for points for the fastest lap. In some race series you need to be in the top 10 to get the bonus point. */
  laptimePositionCutoff?: Maybe<Scalars['Float']['output']>;
  /** Array of points for the fastest lap for the teams. In some race series only the driver receives points for fastest lap. */
  laptimeTeamPoints?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  name: Scalars['String']['output'];
  /** How much race distance needs to be completed to be eligible for points */
  positionalCompletionMin?: Maybe<Scalars['Float']['output']>;
  /** How much race distance in % needs to be completed to be eligible for points */
  positionalCompletionMinRatio?: Maybe<Scalars['Float']['output']>;
  /** Array of driver points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalDriverPoints?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Array of team points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalTeamPoints?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  sessionType?: Maybe<EnumSessionType>;
};

/** List of items with pagination. */
export type PointsSystemPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PointsSystem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PostRunMeasurementBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  style?: Maybe<EnumRunSheetStyleBlockStyle>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type Power = {
  /** 1hp = 745.6998715822702W */
  horsepowerMechanical: Scalars['Float']['output'];
  /** kW */
  kilowatts: Scalars['Float']['output'];
  /** W */
  watts: Scalars['Float']['output'];
};

export type PowerInput = {
  /** 1hp = 745.6998715822702W */
  horsepowerMechanical?: InputMaybe<Scalars['Float']['input']>;
  /** kW */
  kilowatts?: InputMaybe<Scalars['Float']['input']>;
  /** W */
  watts?: InputMaybe<Scalars['Float']['input']>;
};

export type PowerUnitField = {
  unit: EnumPowerUnit;
};

export type Powertrain = {
  MDiffPreloadCold?: Maybe<Scalars['Float']['output']>;
  MDiffPreloadHot?: Maybe<Scalars['Float']['output']>;
  /**
   * Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are arbitrary numbers. Input syntax is array of key-value tuples, like `NEngineBlanking: [["left", 5], ["right", 9]]`.
   * @deprecated Use blanking field instead.
   */
  NEngineBlanking?: Maybe<Scalars['JSON']['output']>;
  NFrictionFaces?: Maybe<Scalars['Float']['output']>;
  PPowerLevel?: Maybe<Scalars['Float']['output']>;
  aDiffRampCoast?: Maybe<Scalars['Float']['output']>;
  aDiffRampDrive?: Maybe<Scalars['Float']['output']>;
  bevelSet?: Maybe<PowertrainGear>;
  /** Map of blanking fields with values. Keys are strings like `gearboxRadiatorTapes` or `hRESSBlanking`, and values are strings describing the blanking details. Input syntax is array of key-value tuples, like `blanking: [["gearboxRadiatorTapes", "5"]]`. */
  blanking?: Maybe<Scalars['JSON']['output']>;
  clutch?: Maybe<Scalars['String']['output']>;
  clutchCylinder?: Maybe<Scalars['String']['output']>;
  dAirRestrictor?: Maybe<Scalars['Float']['output']>;
  /** Name of the selected configuration from the spec. */
  differentialConfigName?: Maybe<Scalars['String']['output']>;
  differentialSpec?: Maybe<DifferentialSpec>;
  differentialSpecID?: Maybe<Scalars['MongoID']['output']>;
  dropGear?: Maybe<PowertrainGear>;
  /**
   * Map of extra engine blanking measurement fields to their values. Input syntax is array of key-value tuples, like `engineBlankingComments: [["louvres", "NONE"], ["other", true]]`.
   * @deprecated Use blanking field instead.
   */
  engineBlankingDetails?: Maybe<Scalars['JSON']['output']>;
  frictionFaces?: Maybe<Scalars['String']['output']>;
  gearboxGridType?: Maybe<Scalars['String']['output']>;
  gears?: Maybe<Array<Maybe<PowertrainStandardGear>>>;
  /**
   * Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hEngineBlanking: [["left", 0.003], ["right", 0.004]]`.
   * @deprecated Use blanking field instead.
   */
  hEngineBlanking?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hGearboxBlanking: [["left", 0.003], ["right", 0.004]]`.
   * @deprecated Use blanking field instead.
   */
  hGearboxBlanking?: Maybe<Scalars['JSON']['output']>;
  rBevelSet?: Maybe<Scalars['Float']['output']>;
  rDropGear?: Maybe<Scalars['Float']['output']>;
  /**
   * Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rEngineBlanking: [["left", 0.05], ["right", 0.06]]`.
   * @deprecated Use blanking field instead.
   */
  rEngineBlanking?: Maybe<Scalars['JSON']['output']>;
  /** Map of gears to their ratios. Keys are strings like `"1"` or `"R"`, and values are ratios. Input syntax is array of key-value tuples, like `rGearRatios: [["R", 0.8], ["1", 0.3]]`. */
  rGearRatios?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rGearboxBlanking: [["left", 0.05], ["right", 0.06]]`.
   * @deprecated Use blanking field instead.
   */
  rGearboxBlanking?: Maybe<Scalars['JSON']['output']>;
};

export type PowertrainGear = {
  specification?: Maybe<GearSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
};

export type PowertrainGearInput = {
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type PowertrainInput = {
  MDiffPreloadCold?: InputMaybe<Scalars['Float']['input']>;
  MDiffPreloadHot?: InputMaybe<Scalars['Float']['input']>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are arbitrary numbers. Input syntax is array of key-value tuples, like `NEngineBlanking: [["left", 5], ["right", 9]]`. */
  NEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  NFrictionFaces?: InputMaybe<Scalars['Float']['input']>;
  PPowerLevel?: InputMaybe<Scalars['Float']['input']>;
  aDiffRampCoast?: InputMaybe<Scalars['Float']['input']>;
  aDiffRampDrive?: InputMaybe<Scalars['Float']['input']>;
  bevelSet?: InputMaybe<PowertrainGearInput>;
  /** Map of blanking fields with values. Keys are strings like `gearboxRadiatorTapes` or `hRESSBlanking`, and values are strings describing the blanking details. Input syntax is array of key-value tuples, like `blanking: [["gearboxRadiatorTapes", "5"]]`. */
  blanking?: InputMaybe<Scalars['JSON']['input']>;
  clutch?: InputMaybe<Scalars['String']['input']>;
  clutchCylinder?: InputMaybe<Scalars['String']['input']>;
  dAirRestrictor?: InputMaybe<Scalars['Float']['input']>;
  /** Name of the selected configuration from the spec. */
  differentialConfigName?: InputMaybe<Scalars['String']['input']>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  dropGear?: InputMaybe<PowertrainGearInput>;
  /** Map of extra engine blanking measurement fields to their values. Input syntax is array of key-value tuples, like `engineBlankingComments: [["louvres", "NONE"], ["other", true]]`. */
  engineBlankingDetails?: InputMaybe<Scalars['JSON']['input']>;
  frictionFaces?: InputMaybe<Scalars['String']['input']>;
  gearboxGridType?: InputMaybe<Scalars['String']['input']>;
  gears?: InputMaybe<Array<InputMaybe<PowertrainStandardGearInput>>>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hEngineBlanking: [["left", 0.003], ["right", 0.004]]`. */
  hEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hGearboxBlanking: [["left", 0.003], ["right", 0.004]]`. */
  hGearboxBlanking?: InputMaybe<Scalars['JSON']['input']>;
  rBevelSet?: InputMaybe<Scalars['Float']['input']>;
  rDropGear?: InputMaybe<Scalars['Float']['input']>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rEngineBlanking: [["left", 0.05], ["right", 0.06]]`. */
  rEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gears to their ratios. Keys are strings like `"1"` or `"R"`, and values are ratios. Input syntax is array of key-value tuples, like `rGearRatios: [["R", 0.8], ["1", 0.3]]`. */
  rGearRatios?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rGearboxBlanking: [["left", 0.05], ["right", 0.06]]`. */
  rGearboxBlanking?: InputMaybe<Scalars['JSON']['input']>;
};

export type PowertrainStandardGear = {
  /** e.g. "R", "1", "2", etc. */
  gearNumber: Scalars['String']['output'];
  specification?: Maybe<GearSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
};

export type PowertrainStandardGearInput = {
  /** e.g. "R", "1", "2", etc. */
  gearNumber: Scalars['String']['input'];
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type Pressure = {
  /** bar */
  bar: Scalars['Float']['output'];
  /** inHg */
  inchesOfMercury: Scalars['Float']['output'];
  /** kPa */
  kilopascals: Scalars['Float']['output'];
  /** mbar */
  millibar: Scalars['Float']['output'];
  /** Pa */
  pascals: Scalars['Float']['output'];
  /** psi */
  psi: Scalars['Float']['output'];
};

export type PressureInput = {
  /** bar */
  bar?: InputMaybe<Scalars['Float']['input']>;
  /** inHg */
  inchesOfMercury?: InputMaybe<Scalars['Float']['input']>;
  /** kPa */
  kilopascals?: InputMaybe<Scalars['Float']['input']>;
  /** mbar */
  millibar?: InputMaybe<Scalars['Float']['input']>;
  /** Pa */
  pascals?: InputMaybe<Scalars['Float']['input']>;
  /** psi */
  psi?: InputMaybe<Scalars['Float']['input']>;
};

export type PressureUnitField = {
  unit: EnumPressureUnit;
};

export type Project = {
  _id: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Run sheet associated with this job */
  tags?: Maybe<Tag>;
};

/** List of items with pagination. */
export type ProjectPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Project>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type QualityCheck = {
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  qualityCheckActionIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  qualityCheckActions: Array<QualityCheckAction>;
  status?: Maybe<Scalars['String']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type QualityCheckAction = {
  _id: Scalars['MongoID']['output'];
  acknowledgedAt?: Maybe<Scalars['Date']['output']>;
  acknowledgedBy?: Maybe<Person>;
  acknowledgedByID?: Maybe<Scalars['MongoID']['output']>;
  assigneeIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignees: Array<Person>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  cancelledBy?: Maybe<Person>;
  cancelledByID?: Maybe<Scalars['MongoID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['Date']['output']>;
  closedBy?: Maybe<Person>;
  closedByID?: Maybe<Scalars['MongoID']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Person>;
  createdByID?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  priority?: Maybe<EnumQualityCheckActionPriority>;
  status?: Maybe<EnumQualityCheckActionStatus>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type QualityCheckActionPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<QualityCheckAction>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type QualityCheckPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<QualityCheck>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Query = {
  activeCarDataServiceConfig?: Maybe<CarDataServiceConfig>;
  assemblies?: Maybe<AssemblyPagination>;
  /** Returns assemblies that has all associated parts active if allPartInstancesActive is true, otherwise returns all assemblies. With pagination, default perPage is 24 */
  assembliesAdvancedFilter?: Maybe<AdvancedAssemblyFilterReturnType>;
  assembly?: Maybe<Assembly>;
  /** Part ids of all nested part instances per assembly, resolved with two batched lean queries instead of expanding every part instance through GraphQL. */
  assemblyPartIDs: Array<AssemblyPartIDs>;
  assemblyTemplate?: Maybe<AssemblyTemplate>;
  assemblyTemplates?: Maybe<AssemblyTemplatePagination>;
  bestValues?: Maybe<BestValues>;
  bestValuesAll?: Maybe<BestValuesPagination>;
  bestValuesFallback?: Maybe<BestValues>;
  bop?: Maybe<Bop>;
  bops?: Maybe<BopPagination>;
  buildSheetStyle?: Maybe<BuildSheetStyle>;
  buildSheetStyles?: Maybe<BuildSheetStylePagination>;
  calculation?: Maybe<Calculation>;
  calculations?: Maybe<CalculationPagination>;
  carDataServiceConfig?: Maybe<CarDataServiceConfig>;
  carDataServiceConfigs?: Maybe<CarDataServiceConfigPagination>;
  carSetup?: Maybe<CarSetup>;
  carSetups?: Maybe<CarSetupPagination>;
  carSetupsMany: Array<CarSetup>;
  chassis?: Maybe<Chassis>;
  chassisAll?: Maybe<ChassisPagination>;
  chassisMeasurement?: Maybe<ChassisMeasurement>;
  chassisMeasurements?: Maybe<ChassisMeasurementPagination>;
  /** Use this to compare two chassis specs and see if there are changes between them */
  compareChassisSpecs: Scalars['Boolean']['output'];
  contestant?: Maybe<Contestant>;
  contestants?: Maybe<ContestantPagination>;
  /** Get a list of backup names currently stored on this server */
  databaseBackups: Array<Scalars['String']['output']>;
  department?: Maybe<Department>;
  departments?: Maybe<DepartmentPagination>;
  dynoConfig?: Maybe<DynoConfig>;
  dynoConfigs?: Maybe<DynoConfigPagination>;
  event?: Maybe<Event>;
  /** Query tyres for an event contestant. */
  eventContestantTyres?: Maybe<EventContestantTyres>;
  events?: Maybe<EventPagination>;
  findCanopyConfigs: Array<CanopyConfig>;
  /** Get a flattened car setup for simulation, including custom simulation payload. */
  flattenedSetupForSimulation?: Maybe<Scalars['JSON']['output']>;
  flexLayoutConfig?: Maybe<FlexLayoutConfig>;
  flexLayoutConfigs?: Maybe<FlexLayoutConfigPagination>;
  /** Generate an issue number from selected race series and season */
  generateIssueNumber: Issue;
  greeboLog?: Maybe<GreeboLog>;
  issue?: Maybe<IssueQuery>;
  issues?: Maybe<IssueQueryPagination>;
  job?: Maybe<Job>;
  jobs?: Maybe<JobPagination>;
  lap?: Maybe<Lap>;
  lapSequence?: Maybe<LapSequence>;
  lapSequenceTemplate?: Maybe<LapSequenceTemplate>;
  lapSequenceTemplates?: Maybe<LapSequenceTemplatePagination>;
  lapSequences?: Maybe<LapSequencePagination>;
  laps?: Maybe<LapPagination>;
  lapsMany: Array<Lap>;
  license: LicenseProperties;
  location?: Maybe<Location>;
  locations?: Maybe<LocationPagination>;
  log?: Maybe<Log>;
  logs?: Maybe<LogPagination>;
  manufacturer?: Maybe<Manufacturer>;
  manufacturers?: Maybe<ManufacturerPagination>;
  migrations?: Maybe<Migrations>;
  /** Query the config that the OneTiming weather service will use when started. */
  oneTimingWeatherServiceCheckConfig?: Maybe<OneTimingWeatherServiceConfig>;
  oneTimingWeatherServiceConfig?: Maybe<OneTimingWeatherServiceConfig>;
  oneTimingWeatherServiceConfigs?: Maybe<OneTimingWeatherServiceConfigPagination>;
  /** Get the most recent lines from the One Timing weather service logs. */
  oneTimingWeatherServiceLogs?: Maybe<Scalars['String']['output']>;
  oneTimingWeatherServiceStatus: OneTimingWeatherServiceStatus;
  /** Order runsheets for forward propagation */
  orderRunSheetsForForwardPropagation?: Maybe<Scalars['JSON']['output']>;
  package?: Maybe<Package>;
  packages?: Maybe<PackagePagination>;
  part?: Maybe<Part>;
  partInstance?: Maybe<PartInstance>;
  partInstances?: Maybe<PartInstancePagination>;
  /** Get full tracking history and snapshot for a part */
  partReturnTrackingHistoryFullandSnapshot?: Maybe<PartReturnTrackingHistoryFullandSnapshot>;
  /** Get full tracking history and snapshot for a part */
  partTracking: Array<Maybe<TrackingEntry>>;
  parts?: Maybe<PartPagination>;
  /** Get parts by specification type with pagination, default perPage is 24 */
  partsAdvancedFilter?: Maybe<AdvancedPartsFilterReturnType>;
  /** Get parts by chassis specification */
  partsForChassisSpec?: Maybe<AdvancedPartsFilterReturnType>;
  /** Get parts in event. Accepts eventId and searches through all the run sheets and setups to return all the partIDs used in this event */
  partsInEvent?: Maybe<PartsInEventResult>;
  people?: Maybe<PersonPagination>;
  person?: Maybe<Person>;
  plotPageConfig?: Maybe<PlotPageConfig>;
  plotPageConfigs?: Maybe<PlotPageConfigPagination>;
  pointsSystem?: Maybe<PointsSystem>;
  pointsSystems?: Maybe<PointsSystemPagination>;
  project?: Maybe<Project>;
  projects?: Maybe<ProjectPagination>;
  qualityCheck?: Maybe<QualityCheck>;
  qualityCheckAction?: Maybe<QualityCheckAction>;
  qualityChecks?: Maybe<QualityCheckPagination>;
  qualityChecksAction?: Maybe<QualityCheckActionPagination>;
  raceSeries?: Maybe<RaceSeries>;
  raceSeriesAll?: Maybe<RaceSeriesPagination>;
  radioMessage?: Maybe<RadioMessage>;
  radioMessages?: Maybe<RadioMessagePagination>;
  reportNotes?: Maybe<ReportNote>;
  reportNotesTemplates: Array<ReportNotesTemplate>;
  reportTemplate?: Maybe<ReportTemplate>;
  reportTemplates?: Maybe<ReportTemplatePagination>;
  requiredClientVersion: Scalars['SemVer']['output'];
  runPlan?: Maybe<RunPlan>;
  runPlans?: Maybe<RunPlanPagination>;
  runSheet?: Maybe<RunSheet>;
  runSheetStyle?: Maybe<RunSheetStyle>;
  runSheetStyles?: Maybe<RunSheetStylePagination>;
  runSheets?: Maybe<RunSheetPagination>;
  /** Get run sheets by associated KPI files */
  runSheetsByAssociatedKPIFiles?: Maybe<Array<Maybe<RunSheet>>>;
  runSheetsMany: Array<RunSheet>;
  sandbox?: Maybe<SandboxQueries>;
  season?: Maybe<Season>;
  seasons?: Maybe<SeasonPagination>;
  serverSettings?: Maybe<ServerSettings>;
  session?: Maybe<Session>;
  sessionDebrief?: Maybe<TemplateSessionDebrief>;
  sessionDebriefs?: Maybe<TemplateSessionDebriefPagination>;
  sessions?: Maybe<SessionPagination>;
  setupOverviewConfig?: Maybe<SetupOverviewConfig>;
  setupOverviewConfigs?: Maybe<SetupOverviewConfigPagination>;
  setupSheetStyle?: Maybe<SetupSheetStyle>;
  setupSheetStyles?: Maybe<SetupSheetStylePagination>;
  simRequest?: Maybe<SimRequest>;
  simRequests?: Maybe<SimRequestPagination>;
  simResult?: Maybe<SimResult>;
  simResults?: Maybe<SimResultPagination>;
  simulationDriveFile?: Maybe<SimulationDriveFile>;
  simulationDriveFiles?: Maybe<SimulationDriveFilePagination>;
  skidPlate?: Maybe<SkidPlate>;
  skidPlates?: Maybe<SkidPlatePagination>;
  specification?: Maybe<Specification>;
  specificationBase?: Maybe<BaseSpecification>;
  specificationGroup?: Maybe<SpecificationGroup>;
  specifications?: Maybe<SpecificationPagination>;
  ssoProvider?: Maybe<SsoProvider>;
  ssoProviders: Array<SsoProvider>;
  tag?: Maybe<Tag>;
  tags?: Maybe<TagPagination>;
  team?: Maybe<Team>;
  teams?: Maybe<TeamPagination>;
  templateJobList?: Maybe<TemplateJobList>;
  templateJobLists?: Maybe<TemplateJobListPagination>;
  timeSheetEntries?: Maybe<TimeSheetEntryPagination>;
  timeSheetEntry?: Maybe<TimeSheetEntry>;
  timingServiceConfig?: Maybe<TimingServiceConfig>;
  timingServiceConfigs?: Maybe<TimingServiceConfigPagination>;
  timingServiceStatus?: Maybe<TimingServiceStatus>;
  track?: Maybe<Track>;
  trackLayout?: Maybe<TrackLayout>;
  trackLayouts?: Maybe<TrackLayoutPagination>;
  trackable?: Maybe<Trackable>;
  trackables?: Maybe<TrackablePagination>;
  trackingItem?: Maybe<TrackingItem>;
  /** Distinct tracking item names for all parts used in the run sheets of the given sessions. Walks run sheets -> setups -> chassis assemblies -> part instances -> parts -> specifications with lean, batched queries instead of resolving per-part tracking histories. */
  trackingItemNamesForSessions: Array<Scalars['String']['output']>;
  trackingItems?: Maybe<TrackingItemPagination>;
  trackingMeasurement?: Maybe<TrackingMeasurement>;
  trackingMeasurementRecord?: Maybe<TrackingMeasurementRecord>;
  trackingMeasurementRecords?: Maybe<TrackingMeasurementRecordPagination>;
  trackingMeasurements?: Maybe<TrackingMeasurementPagination>;
  trackingRecord?: Maybe<TrackingRecord>;
  trackingRecords?: Maybe<TrackingRecordPagination>;
  trackingSource?: Maybe<TrackingSource>;
  trackingSourceAlias?: Maybe<TrackingSourceAlias>;
  trackingSourceAliases?: Maybe<TrackingSourceAliasPagination>;
  trackingSources?: Maybe<TrackingSourcePagination>;
  tracks?: Maybe<TrackPagination>;
  tyre?: Maybe<Tyre>;
  tyreMileageAtSessionStart?: Maybe<TyreMileageAtSessionStart>;
  tyreMileageGraph?: Maybe<TyreMileageGraph>;
  tyrePressureSheet: TyrePressureSheet;
  tyreSet?: Maybe<TyreSet>;
  tyreSets?: Maybe<TyreSetPagination>;
  tyreWear?: Maybe<TyreWear>;
  tyreWears?: Maybe<TyreWearPagination>;
  tyres?: Maybe<TyrePagination>;
  userEnum?: Maybe<UserEnum>;
  userEnums?: Maybe<UserEnumPagination>;
  version: Scalars['SemVer']['output'];
  weather?: Maybe<Weather>;
  weatherAll?: Maybe<WeatherPagination>;
  weatherServiceConfig?: Maybe<WeatherServiceConfig>;
  weatherServiceConfigs?: Maybe<WeatherServiceConfigPagination>;
  whoami: TokenClaims;
};


export type QueryActiveCarDataServiceConfigArgs = {
  raceSeriesID: Scalars['MongoID']['input'];
};


export type QueryAssembliesArgs = {
  filter?: InputMaybe<FilterFindManyAssemblyInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssemblyInput>;
};


export type QueryAssembliesAdvancedFilterArgs = {
  allPartInstancesActive?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FilterFindManyAssemblyInput>;
  hideAssembliesUsedInRunSheets?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssemblyInput>;
};


export type QueryAssemblyArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryAssemblyPartIDsArgs = {
  assemblyIDs: Array<Scalars['MongoID']['input']>;
};


export type QueryAssemblyTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryAssemblyTemplatesArgs = {
  filter?: InputMaybe<FilterFindManyAssemblyTemplateInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssemblyTemplateInput>;
};


export type QueryBestValuesArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryBestValuesAllArgs = {
  filter?: InputMaybe<FilterFindManyBestValuesInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyBestValuesInput>;
};


export type QueryBestValuesFallbackArgs = {
  contestantID?: InputMaybe<Scalars['String']['input']>;
  driverID?: InputMaybe<Scalars['String']['input']>;
  sessionID: Scalars['String']['input'];
};


export type QueryBopArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryBopsArgs = {
  filter?: InputMaybe<FilterFindManyBopInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyBopInput>;
};


export type QueryBuildSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryBuildSheetStylesArgs = {
  filter?: InputMaybe<FilterFindManyBuildSheetStyleInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyBuildSheetStyleInput>;
};


export type QueryCalculationArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCalculationsArgs = {
  filter?: InputMaybe<FilterFindManyCalculationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCalculationInput>;
};


export type QueryCarDataServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCarDataServiceConfigsArgs = {
  filter?: InputMaybe<FilterFindManyCarDataServiceConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCarDataServiceConfigInput>;
};


export type QueryCarSetupArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCarSetupsArgs = {
  filter?: InputMaybe<FilterFindManyCarSetupInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCarSetupInput>;
};


export type QueryCarSetupsManyArgs = {
  filter?: InputMaybe<FilterFindManyCarSetupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCarSetupInput>;
};


export type QueryChassisArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryChassisAllArgs = {
  filter?: InputMaybe<FilterFindManyChassisInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChassisInput>;
};


export type QueryChassisMeasurementArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryChassisMeasurementsArgs = {
  filter?: InputMaybe<FilterFindManyChassisMeasurementInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChassisMeasurementInput>;
};


export type QueryCompareChassisSpecsArgs = {
  chassisSpecID: Scalars['MongoID']['input'];
  chassisSpecToCompareID: Scalars['MongoID']['input'];
};


export type QueryContestantArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryContestantsArgs = {
  filter?: InputMaybe<FilterFindManyContestantInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyContestantInput>;
};


export type QueryDepartmentArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryDepartmentsArgs = {
  filter?: InputMaybe<FilterFindManyDepartmentInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDepartmentInput>;
};


export type QueryDynoConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryDynoConfigsArgs = {
  filter?: InputMaybe<FilterFindManyDynoConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDynoConfigInput>;
};


export type QueryEventArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryEventContestantTyresArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
};


export type QueryEventsArgs = {
  filter?: InputMaybe<FilterFindManyEventInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyEventInput>;
};


export type QueryFindCanopyConfigsArgs = {
  configType: EnumCanopyConfigType;
  nameFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFlattenedSetupForSimulationArgs = {
  carSetupID: Scalars['MongoID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  outputFolder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFlexLayoutConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryFlexLayoutConfigsArgs = {
  filter?: InputMaybe<FilterFindManyFlexLayoutConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyFlexLayoutConfigInput>;
};


export type QueryGenerateIssueNumberArgs = {
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryGreeboLogArgs = {
  eventID?: InputMaybe<Scalars['String']['input']>;
  sessionID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIssueArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryIssuesArgs = {
  filter?: InputMaybe<FilterFindManyIssueQueryInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIssueQueryInput>;
};


export type QueryJobArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryJobsArgs = {
  filter?: InputMaybe<FilterFindManyJobInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyJobInput>;
};


export type QueryLapArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLapSequenceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLapSequenceTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLapSequenceTemplatesArgs = {
  filter?: InputMaybe<FilterFindManyLapSequenceTemplateInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLapSequenceTemplateInput>;
};


export type QueryLapSequencesArgs = {
  filter?: InputMaybe<FilterFindManyLapSequenceInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLapSequenceInput>;
};


export type QueryLapsArgs = {
  filter?: InputMaybe<FilterFindManyLapInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLapInput>;
};


export type QueryLapsManyArgs = {
  filter?: InputMaybe<FilterFindManyLapInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLapInput>;
};


export type QueryLocationArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLocationsArgs = {
  filter?: InputMaybe<FilterFindManyLocationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLocationInput>;
};


export type QueryLogArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLogsArgs = {
  filter?: InputMaybe<FilterFindManyLogInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLogInput>;
};


export type QueryManufacturerArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryManufacturersArgs = {
  filter?: InputMaybe<FilterFindManyManufacturerInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyManufacturerInput>;
};


export type QueryOneTimingWeatherServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryOneTimingWeatherServiceConfigsArgs = {
  filter?: InputMaybe<FilterFindManyOneTimingWeatherServiceConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyOneTimingWeatherServiceConfigInput>;
};


export type QueryOneTimingWeatherServiceLogsArgs = {
  numLines?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderRunSheetsForForwardPropagationArgs = {
  runSheetID: Scalars['MongoID']['input'];
};


export type QueryPackageArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPackagesArgs = {
  filter?: InputMaybe<FilterFindManyPackageInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPackageInput>;
};


export type QueryPartArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPartInstanceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPartInstancesArgs = {
  filter?: InputMaybe<FilterFindManyPartInstanceInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPartInstanceInput>;
};


export type QueryPartReturnTrackingHistoryFullandSnapshotArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  partID: Scalars['MongoID']['input'];
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};


export type QueryPartTrackingArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  partID: Scalars['MongoID']['input'];
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};


export type QueryPartsArgs = {
  filter?: InputMaybe<FilterFindManyPartInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPartInput>;
};


export type QueryPartsAdvancedFilterArgs = {
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eligibleEventTypes?: InputMaybe<Array<InputMaybe<EnumPartEligibleEventTypes>>>;
  filter?: InputMaybe<FilterFindManyPartInput>;
  hideDummyParts?: InputMaybe<Scalars['Boolean']['input']>;
  locationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  manufacturerIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  manufacturerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  mileageMax?: InputMaybe<Scalars['Float']['input']>;
  mileageMin?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  partReference?: InputMaybe<Scalars['String']['input']>;
  partType?: InputMaybe<Scalars['MongoID']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  sort?: InputMaybe<SortFindManyPartInput>;
  specName?: InputMaybe<Scalars['String']['input']>;
  specTypes?: InputMaybe<Array<InputMaybe<EnumSpecificationType>>>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumPartStatusActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPartsForChassisSpecArgs = {
  chassisSpecID: Scalars['MongoID']['input'];
  filter?: InputMaybe<FilterFindManyPartInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partActive?: InputMaybe<Scalars['Boolean']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortFindManyPartInput>;
  specName?: InputMaybe<Scalars['String']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumPartStatusID?: InputMaybe<Scalars['MongoID']['input']>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryPartsInEventArgs = {
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  eventID: Scalars['MongoID']['input'];
};


export type QueryPeopleArgs = {
  filter?: InputMaybe<FilterFindManyPersonInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPersonInput>;
};


export type QueryPersonArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPlotPageConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPlotPageConfigsArgs = {
  filter?: InputMaybe<FilterFindManyPlotPageConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPlotPageConfigInput>;
};


export type QueryPointsSystemArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPointsSystemsArgs = {
  filter?: InputMaybe<FilterFindManyPointsSystemInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPointsSystemInput>;
};


export type QueryProjectArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProjectsArgs = {
  filter?: InputMaybe<FilterFindManyProjectInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProjectInput>;
};


export type QueryQualityCheckArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryQualityCheckActionArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryQualityChecksArgs = {
  filter?: InputMaybe<FilterFindManyQualityCheckInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyQualityCheckInput>;
};


export type QueryQualityChecksActionArgs = {
  filter?: InputMaybe<FilterFindManyQualityCheckActionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyQualityCheckActionInput>;
};


export type QueryRaceSeriesArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryRaceSeriesAllArgs = {
  filter?: InputMaybe<FilterFindManyRaceSeriesInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRaceSeriesInput>;
};


export type QueryRadioMessageArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryRadioMessagesArgs = {
  filter?: InputMaybe<FilterFindManyRadioMessageInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRadioMessageInput>;
};


export type QueryReportNotesArgs = {
  eventID: Scalars['MongoID']['input'];
  filter?: InputMaybe<FilterFindOneReportNoteInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneReportNoteInput>;
};


export type QueryReportNotesTemplatesArgs = {
  filter?: InputMaybe<FilterFindManyReportNotesTemplateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyReportNotesTemplateInput>;
};


export type QueryReportTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryReportTemplatesArgs = {
  filter?: InputMaybe<FilterFindManyReportTemplateInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyReportTemplateInput>;
};


export type QueryRunPlanArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryRunPlansArgs = {
  filter?: InputMaybe<FilterFindManyRunPlanInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRunPlanInput>;
};


export type QueryRunSheetArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryRunSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryRunSheetStylesArgs = {
  filter?: InputMaybe<FilterFindManyRunSheetStyleInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRunSheetStyleInput>;
};


export type QueryRunSheetsArgs = {
  filter?: InputMaybe<FilterFindManyRunSheetInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRunSheetInput>;
};


export type QueryRunSheetsByAssociatedKpiFilesArgs = {
  kpiFileNames: Array<Scalars['String']['input']>;
};


export type QueryRunSheetsManyArgs = {
  filter?: InputMaybe<FilterFindManyRunSheetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRunSheetInput>;
};


export type QuerySeasonArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySeasonsArgs = {
  filter?: InputMaybe<FilterFindManySeasonInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySeasonInput>;
};


export type QuerySessionArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySessionDebriefArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySessionDebriefsArgs = {
  filter?: InputMaybe<FilterFindManyTemplateSessionDebriefInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTemplateSessionDebriefInput>;
};


export type QuerySessionsArgs = {
  filter?: InputMaybe<FilterFindManySessionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySessionInput>;
};


export type QuerySetupOverviewConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySetupOverviewConfigsArgs = {
  filter?: InputMaybe<FilterFindManySetupOverviewConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySetupOverviewConfigInput>;
};


export type QuerySetupSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySetupSheetStylesArgs = {
  filter?: InputMaybe<FilterFindManySetupSheetStyleInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySetupSheetStyleInput>;
};


export type QuerySimRequestArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySimRequestsArgs = {
  filter?: InputMaybe<FilterFindManySimRequestInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySimRequestInput>;
};


export type QuerySimResultArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySimResultsArgs = {
  filter?: InputMaybe<FilterFindManySimResultInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySimResultInput>;
};


export type QuerySimulationDriveFileArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySimulationDriveFilesArgs = {
  filter?: InputMaybe<FilterFindManySimulationDriveFileInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySimulationDriveFileInput>;
};


export type QuerySkidPlateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySkidPlatesArgs = {
  filter?: InputMaybe<FilterFindManySkidPlateInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySkidPlateInput>;
};


export type QuerySpecificationArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySpecificationBaseArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySpecificationGroupArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySpecificationsArgs = {
  filter?: InputMaybe<FilterFindManySpecificationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySpecificationInput>;
};


export type QuerySsoProviderArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySsoProvidersArgs = {
  filter?: InputMaybe<FilterFindManySsoProviderInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySsoProviderInput>;
};


export type QueryTagArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTagsArgs = {
  filter?: InputMaybe<FilterFindManyTagInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTagInput>;
};


export type QueryTeamArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTeamsArgs = {
  filter?: InputMaybe<FilterFindManyTeamInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTeamInput>;
};


export type QueryTemplateJobListArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTemplateJobListsArgs = {
  filter?: InputMaybe<FilterFindManyTemplateJobListInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTemplateJobListInput>;
};


export type QueryTimeSheetEntriesArgs = {
  filter?: InputMaybe<FilterFindManyTimeSheetEntryInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTimeSheetEntryInput>;
};


export type QueryTimeSheetEntryArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTimingServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTimingServiceConfigsArgs = {
  filter?: InputMaybe<FilterFindManyTimingServiceConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTimingServiceConfigInput>;
};


export type QueryTrackArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackLayoutArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackLayoutsArgs = {
  filter?: InputMaybe<FilterFindManyTrackLayoutInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackLayoutInput>;
};


export type QueryTrackableArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackablesArgs = {
  filter?: InputMaybe<FilterFindManyTrackableInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackableInput>;
};


export type QueryTrackingItemArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackingItemNamesForSessionsArgs = {
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type QueryTrackingItemsArgs = {
  filter?: InputMaybe<FilterFindManyTrackingItemInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackingItemInput>;
};


export type QueryTrackingMeasurementArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackingMeasurementRecordArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackingMeasurementRecordsArgs = {
  filter?: InputMaybe<FilterFindManyTrackingMeasurementRecordInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackingMeasurementRecordInput>;
};


export type QueryTrackingMeasurementsArgs = {
  filter?: InputMaybe<FilterFindManyTrackingMeasurementInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackingMeasurementInput>;
};


export type QueryTrackingRecordArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackingRecordsArgs = {
  filter?: InputMaybe<FilterFindManyTrackingRecordInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackingRecordInput>;
};


export type QueryTrackingSourceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackingSourceAliasArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackingSourceAliasesArgs = {
  filter?: InputMaybe<FilterFindManyTrackingSourceAliasInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackingSourceAliasInput>;
};


export type QueryTrackingSourcesArgs = {
  filter?: InputMaybe<FilterFindManyTrackingSourceInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackingSourceInput>;
};


export type QueryTracksArgs = {
  filter?: InputMaybe<FilterFindManyTrackInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackInput>;
};


export type QueryTyreArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTyreMileageAtSessionStartArgs = {
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};


export type QueryTyreMileageGraphArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
};


export type QueryTyrePressureSheetArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
};


export type QueryTyreSetArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTyreSetsArgs = {
  filter?: InputMaybe<FilterFindManyTyreSetInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTyreSetInput>;
};


export type QueryTyreWearArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTyreWearsArgs = {
  filter?: InputMaybe<FilterFindManyTyreWearInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTyreWearInput>;
};


export type QueryTyresArgs = {
  filter?: InputMaybe<FilterFindManyTyreInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTyreInput>;
};


export type QueryUserEnumArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryUserEnumsArgs = {
  filter?: InputMaybe<FilterFindManyUserEnumInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserEnumInput>;
};


export type QueryWeatherArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryWeatherAllArgs = {
  filter?: InputMaybe<FilterFindManyWeatherInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWeatherInput>;
};


export type QueryWeatherServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryWeatherServiceConfigsArgs = {
  filter?: InputMaybe<FilterFindManyWeatherServiceConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWeatherServiceConfigInput>;
};

export type RaceSeries = {
  _id: Scalars['MongoID']['output'];
  assignedSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignedSetups: Array<CarSetup>;
  defaultJobListIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  defaultJobLists: Array<TemplateJobList>;
  defaultRunSheetStyle?: Maybe<RunSheetStyle>;
  defaultRunSheetStyleID?: Maybe<Scalars['MongoID']['output']>;
  driversPerCar?: Maybe<EnumRaceSeriesDriversPerCar>;
  groupName?: Maybe<Scalars['String']['output']>;
  lapTypeConfig?: Maybe<RaceSeriesLapTypeConfig>;
  name: Scalars['String']['output'];
  seasonIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  seasons: Array<Season>;
  shortName?: Maybe<Scalars['String']['output']>;
  sortingIndex?: Maybe<Scalars['Float']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
};

export type RaceSeriesLapTypeConfig = {
  ATTACK?: Maybe<RaceSeriesLapTypeEntry>;
  COOL?: Maybe<RaceSeriesLapTypeEntry>;
  FCY?: Maybe<RaceSeriesLapTypeEntry>;
  IN?: Maybe<RaceSeriesLapTypeEntry>;
  OUT?: Maybe<RaceSeriesLapTypeEntry>;
  OUTIN?: Maybe<RaceSeriesLapTypeEntry>;
  PITLANE?: Maybe<RaceSeriesLapTypeEntry>;
  PREP?: Maybe<RaceSeriesLapTypeEntry>;
  PUSH?: Maybe<RaceSeriesLapTypeEntry>;
  QUALI?: Maybe<RaceSeriesLapTypeEntry>;
  SAFETYCAR?: Maybe<RaceSeriesLapTypeEntry>;
  SHAKEDOWN?: Maybe<RaceSeriesLapTypeEntry>;
  SLOW?: Maybe<RaceSeriesLapTypeEntry>;
  TARGET?: Maybe<RaceSeriesLapTypeEntry>;
  TOGRID?: Maybe<RaceSeriesLapTypeEntry>;
  TOPADDOCK?: Maybe<RaceSeriesLapTypeEntry>;
  TOPITS?: Maybe<RaceSeriesLapTypeEntry>;
  UNFINISHED?: Maybe<RaceSeriesLapTypeEntry>;
};

export type RaceSeriesLapTypeConfigInput = {
  ATTACK?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  COOL?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  FCY?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  IN?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  OUT?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  OUTIN?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  PITLANE?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  PREP?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  PUSH?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  QUALI?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  SAFETYCAR?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  SHAKEDOWN?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  SLOW?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  TARGET?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  TOGRID?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  TOPADDOCK?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  TOPITS?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  UNFINISHED?: InputMaybe<RaceSeriesLapTypeEntryInput>;
};

export type RaceSeriesLapTypeEntry = {
  displayString: Scalars['String']['output'];
  lapTypeColor?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type RaceSeriesLapTypeEntryInput = {
  displayString: Scalars['String']['input'];
  lapTypeColor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** List of items with pagination. */
export type RaceSeriesPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<RaceSeries>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type RadioMessage = {
  _id: Scalars['MongoID']['output'];
  /** Time at which the audio message arrived in the queue for transcribing. */
  arrivedInQueueAt?: Maybe<Scalars['Date']['output']>;
  /** This is currently a path to a file on the Transcribble server, but it should eventually be a URL to a file in something like an S3 bucket instead. */
  audioPath: Scalars['String']['output'];
  contestant?: Maybe<Contestant>;
  contestantID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  driver?: Maybe<Person>;
  driverID?: Maybe<Scalars['MongoID']['output']>;
  important: Scalars['Boolean']['output'];
  /** Length of the audio message in seconds. */
  length?: Maybe<Scalars['Float']['output']>;
  session?: Maybe<Session>;
  sessionID: Scalars['MongoID']['output'];
  /** Time at which the audio message was taken by a transcription service. */
  takenByTranscriberAt?: Maybe<Scalars['Date']['output']>;
  /** The text of the message, as transcribed by Transcribble. */
  text?: Maybe<Scalars['String']['output']>;
  /** Time at which this message began recording audio. */
  timestamp?: Maybe<Scalars['Date']['output']>;
  transcribed: Scalars['Boolean']['output'];
  /** Time at which the audio message was finished initial transcribing. */
  transcribedAt?: Maybe<Scalars['Date']['output']>;
  transcriptionEdited: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type RadioMessagePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<RadioMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Ratio = {
  /** % */
  percent: Scalars['Float']['output'];
  /** 0 = 0%, 1 = 100%, 1.5 = 150% */
  ratio: Scalars['Float']['output'];
};

export type RatioInput = {
  /** % */
  percent?: InputMaybe<Scalars['Float']['input']>;
  /** 0 = 0%, 1 = 100%, 1.5 = 150% */
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type RatioUnitField = {
  unit: EnumRatioUnit;
};

export type RegeneratePartTrackingHistory = {
  updatedRecords?: Maybe<Scalars['Int']['output']>;
};

export type RegulationSet = {
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hRideFrontMin?: Maybe<Scalars['Float']['output']>;
  hRideRearMin?: Maybe<Scalars['Float']['output']>;
  massDistRunningMax?: Maybe<Scalars['Float']['output']>;
  massDistRunningMin?: Maybe<Scalars['Float']['output']>;
  massDistStaticMax?: Maybe<Scalars['Float']['output']>;
  massDistStaticMin?: Maybe<Scalars['Float']['output']>;
  massMin?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type RegulationSetInput = {
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  hRideFrontMin?: InputMaybe<Scalars['Float']['input']>;
  hRideRearMin?: InputMaybe<Scalars['Float']['input']>;
  massDistRunningMax?: InputMaybe<Scalars['Float']['input']>;
  massDistRunningMin?: InputMaybe<Scalars['Float']['input']>;
  massDistStaticMax?: InputMaybe<Scalars['Float']['input']>;
  massDistStaticMin?: InputMaybe<Scalars['Float']['input']>;
  massMin?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type ReleaseChassisSpecResult = {
  iteratedChassisSpec?: Maybe<ChassisSpec>;
  releasedChassisSpec?: Maybe<ChassisSpec>;
};

export type RemoveByIdAssemblyPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Assembly>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdAssemblyTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<AssemblyTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdBestValuesPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<BestValues>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdBopPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Bop>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdBuildSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<BuildSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdCalculationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Calculation>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdCarDataServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<CarDataServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdCarSetupPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<CarSetup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdChassisMeasurementPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<ChassisMeasurement>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdChassisPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Chassis>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdContestantPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Contestant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdDepartmentPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Department>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdDynoConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<DynoConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdEventPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdFlexLayoutConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<FlexLayoutConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdIssuePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Issue>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdJobPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Job>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdLapPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Lap>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdLapSequencePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<LapSequence>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdLapSequenceTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<LapSequenceTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdLocationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Location>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdLogPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Log>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdManufacturerPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Manufacturer>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdOneTimingWeatherServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<OneTimingWeatherServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdPackagePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Package>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdPartInstancePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<PartInstance>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdPartPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Part>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdPersonPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Person>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdPlotPageConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<PlotPageConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdPointsSystemPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<PointsSystem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdProjectPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Project>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdQualityCheckActionPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<QualityCheckAction>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdQualityCheckPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<QualityCheck>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdRaceSeriesPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<RaceSeries>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdRadioMessagePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<RadioMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdReportNotesTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<ReportNotesTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdReportTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<ReportTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdRunPlanPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<RunPlan>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdRunSheetPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<RunSheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdRunSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<RunSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSandboxUnitsPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SandboxUnits>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSeasonPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Season>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSessionPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Session>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSetupOverviewConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SetupOverviewConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSetupSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SetupSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSimRequestPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SimRequest>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSimResultPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SimResult>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSimulationDriveFilePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SimulationDriveFile>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSkidPlatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SkidPlate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSpecificationGroupPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SpecificationGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSpecificationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Specification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSsoProviderPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SsoProvider>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTagPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Tag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTeamPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Team>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTemplateJobListPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TemplateJobList>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTemplateSessionDebriefPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TemplateSessionDebrief>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTimeSheetEntryPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TimeSheetEntry>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTimingServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TimingServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackLayoutPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackLayout>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Track>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackablePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Trackable>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackingItemPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackingItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackingMeasurementPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackingMeasurement>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackingMeasurementRecordPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackingMeasurementRecord>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackingRecordPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackingRecord>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackingSourceAliasPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackingSourceAlias>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackingSourcePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackingSource>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTyrePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Tyre>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTyreSetPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TyreSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTyreWearPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TyreWear>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdUserEnumPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<UserEnum>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdWeatherPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Weather>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdWeatherServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<WeatherServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveCommentResult = {
  comment?: Maybe<Comment>;
  recordId: Scalars['MongoID']['output'];
};

export type RemoveDeadTrackingRecords = {
  deadRecords?: Maybe<Scalars['Int']['output']>;
  deletedCount?: Maybe<Scalars['Int']['output']>;
  invalidAssemblies?: Maybe<Scalars['Int']['output']>;
  invalidChassisAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveEventContestantResult = {
  success: Scalars['Boolean']['output'];
};

export type RemoveManyEventContestantsResult = {
  success: Scalars['Boolean']['output'];
};

export type RemoveManyJobsResult = {
  deletedCount: Scalars['Int']['output'];
};

export type RemoveManySimRequestPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type RemoveManySimResultPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type RemoveManyTimeSheetEntriesResult = {
  deletedCount: Scalars['Int']['output'];
};

export type RemoveManyTyreSetsResult = {
  deletedCount: Scalars['Int']['output'];
};

export type RemoveManyTyresResult = {
  deletedCount: Scalars['Int']['output'];
};

export type RemoveTyreFromEventContestantResult = {
  changed?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveTyreSetsFromContestantResult = {
  contestant?: Maybe<Contestant>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveTyreSetsFromEventContestantResult = {
  changed?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveTyresFromContestantResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemovedRunSheet = {
  _id?: Maybe<Scalars['MongoID']['output']>;
};

export type RenameSpecificationResult = {
  success: Scalars['Boolean']['output'];
};

export type ReportNote = {
  _id: Scalars['MongoID']['output'];
  eventID?: Maybe<Scalars['MongoID']['output']>;
  pageAppendix?: Maybe<ReportNotePageAppendix>;
  pageOverview?: Maybe<ReportNotePageOverview>;
  pageParts?: Maybe<ReportNotePageParts>;
  pageRunPlan?: Maybe<ReportNotePageRunPlan>;
  pageSession?: Maybe<ReportNotePageSession>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotePageAppendix = {
  notes?: Maybe<Array<Maybe<ReportNotePageAppendixNotes>>>;
};

export type ReportNotePageAppendixNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotePageAppendixNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotePageOverview = {
  notes?: Maybe<Array<Maybe<ReportNotePageOverviewNotes>>>;
};

export type ReportNotePageOverviewNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotePageOverviewNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotePageParts = {
  notes?: Maybe<Array<Maybe<ReportNotePagePartsNotes>>>;
};

export type ReportNotePagePartsNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotePagePartsNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotePageRunPlan = {
  notes?: Maybe<Array<Maybe<ReportNotePageRunPlanNotes>>>;
};

export type ReportNotePageRunPlanNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotePageRunPlanNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotePageSession = {
  notes?: Maybe<Array<Maybe<ReportNotePageSessionNotes>>>;
};

export type ReportNotePageSessionNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotePageSessionNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotesTemplate = {
  _id: Scalars['MongoID']['output'];
  pageAppendix?: Maybe<ReportNotesTemplatePageAppendix>;
  pageOverview?: Maybe<ReportNotesTemplatePageOverview>;
  pageParts?: Maybe<ReportNotesTemplatePageParts>;
  pageRunPlan?: Maybe<ReportNotesTemplatePageRunPlan>;
  pageSession?: Maybe<ReportNotesTemplatePageSession>;
  title: Scalars['String']['output'];
};

export type ReportNotesTemplatePageAppendix = {
  notes?: Maybe<Array<Maybe<ReportNotesTemplatePageAppendixNotes>>>;
};

export type ReportNotesTemplatePageAppendixInput = {
  notes?: InputMaybe<Array<InputMaybe<ReportNotesTemplatePageAppendixNotesInput>>>;
};

export type ReportNotesTemplatePageAppendixNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotesTemplatePageAppendixNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotesTemplatePageAppendixNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageAppendixNotesMode>;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportNotesTemplatePageOverview = {
  notes?: Maybe<Array<Maybe<ReportNotesTemplatePageOverviewNotes>>>;
};

export type ReportNotesTemplatePageOverviewInput = {
  notes?: InputMaybe<Array<InputMaybe<ReportNotesTemplatePageOverviewNotesInput>>>;
};

export type ReportNotesTemplatePageOverviewNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotesTemplatePageOverviewNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotesTemplatePageOverviewNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageOverviewNotesMode>;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportNotesTemplatePageParts = {
  notes?: Maybe<Array<Maybe<ReportNotesTemplatePagePartsNotes>>>;
};

export type ReportNotesTemplatePagePartsInput = {
  notes?: InputMaybe<Array<InputMaybe<ReportNotesTemplatePagePartsNotesInput>>>;
};

export type ReportNotesTemplatePagePartsNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotesTemplatePagePartsNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotesTemplatePagePartsNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePagePartsNotesMode>;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportNotesTemplatePageRunPlan = {
  notes?: Maybe<Array<Maybe<ReportNotesTemplatePageRunPlanNotes>>>;
};

export type ReportNotesTemplatePageRunPlanInput = {
  notes?: InputMaybe<Array<InputMaybe<ReportNotesTemplatePageRunPlanNotesInput>>>;
};

export type ReportNotesTemplatePageRunPlanNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotesTemplatePageRunPlanNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotesTemplatePageRunPlanNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageRunPlanNotesMode>;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportNotesTemplatePageSession = {
  notes?: Maybe<Array<Maybe<ReportNotesTemplatePageSessionNotes>>>;
};

export type ReportNotesTemplatePageSessionInput = {
  notes?: InputMaybe<Array<InputMaybe<ReportNotesTemplatePageSessionNotesInput>>>;
};

export type ReportNotesTemplatePageSessionNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotesTemplatePageSessionNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotesTemplatePageSessionNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageSessionNotesMode>;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTemplate = {
  _id: Scalars['MongoID']['output'];
  appendix?: Maybe<ReportTemplateAppendix>;
  bop?: Maybe<ReportTemplateBop>;
  carSetup?: Maybe<ReportTemplateCarSetup>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** File format based off a filename pattern, e.g. {raceSeries} {season} {event} */
  downloadFilenameFormat?: Maybe<Scalars['String']['output']>;
  excludedNoteIDs?: Maybe<ReportTemplateExcludedNoteIDs>;
  issues?: Maybe<ReportTemplateIssues>;
  kpi?: Maybe<ReportTemplateKpi>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  overview?: Maybe<ReportTemplateOverview>;
  parts?: Maybe<ReportTemplateParts>;
  reportTitle?: Maybe<Scalars['String']['output']>;
  runInfo?: Maybe<ReportTemplateRunInfo>;
  runPlan?: Maybe<ReportTemplateRunPlan>;
  sessions?: Maybe<ReportTemplateSessions>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weather?: Maybe<ReportTemplateWeather>;
};

export type ReportTemplateAppendix = {
  active?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportTemplateAppendixInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportTemplateBop = {
  active?: Maybe<Scalars['Boolean']['output']>;
  bopFileOnly?: Maybe<Scalars['Boolean']['output']>;
  /** JSON configuration or zod? */
  layout?: Maybe<Scalars['JSON']['output']>;
  /** Either { source: 'current-event' } or { source: 'explicit', sessionIds: string[] } */
  selectedSessions?: Maybe<Scalars['JSON']['output']>;
};

export type ReportTemplateBopInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bopFileOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  layout?: InputMaybe<Scalars['JSON']['input']>;
  /** Either { source: 'current-event' } or { source: 'explicit', sessionIds: string[] } */
  selectedSessions?: InputMaybe<Scalars['JSON']['input']>;
};

export type ReportTemplateCarSetup = {
  active?: Maybe<Scalars['Boolean']['output']>;
  /** JSON configuration or zod? */
  tableConfig?: Maybe<Scalars['JSON']['output']>;
};

export type ReportTemplateCarSetupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ReportTemplateExcludedNoteIDs = {
  pageAppendix?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pageOverview?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pageParts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pageRunPlan?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pageSession?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ReportTemplateExcludedNoteIDsInput = {
  pageAppendix?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageOverview?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageParts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageRunPlan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageSession?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReportTemplateIssues = {
  active?: Maybe<Scalars['Boolean']['output']>;
  columns?: Maybe<Array<Maybe<ReportTemplateIssuesColumns>>>;
  groupBy?: Maybe<EnumReportTemplateIssuesGroupBy>;
};

export type ReportTemplateIssuesColumns = {
  field: EnumReportTemplateIssuesColumnsField;
  label?: Maybe<Scalars['String']['output']>;
};

export type ReportTemplateIssuesColumnsInput = {
  field: EnumReportTemplateIssuesColumnsField;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTemplateIssuesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ReportTemplateIssuesColumnsInput>>>;
  groupBy?: InputMaybe<EnumReportTemplateIssuesGroupBy>;
};

export type ReportTemplateKpi = {
  active?: Maybe<Scalars['Boolean']['output']>;
  /** JSON configuration or zod? */
  layout?: Maybe<Scalars['JSON']['output']>;
  showSessionLines?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportTemplateKpiInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  layout?: InputMaybe<Scalars['JSON']['input']>;
  showSessionLines?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportTemplateOverview = {
  active?: Maybe<Scalars['Boolean']['output']>;
  noteTitle?: Maybe<Scalars['String']['output']>;
  showFuelConsumption?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportTemplateOverviewInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  showFuelConsumption?: InputMaybe<Scalars['Boolean']['input']>;
};

/** List of items with pagination. */
export type ReportTemplatePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ReportTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ReportTemplateParts = {
  active?: Maybe<Scalars['Boolean']['output']>;
  groupPartsByChassisAssemblyName?: Maybe<Scalars['Boolean']['output']>;
  noteTitle?: Maybe<Scalars['String']['output']>;
  tableColumns?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
};

export type ReportTemplatePartsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  groupPartsByChassisAssemblyName?: InputMaybe<Scalars['Boolean']['input']>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  tableColumns?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type ReportTemplateRunInfo = {
  active?: Maybe<Scalars['Boolean']['output']>;
  columns?: Maybe<Array<Maybe<ReportTemplateRunInfoColumns>>>;
};

export type ReportTemplateRunInfoColumns = {
  field: EnumReportTemplateRunInfoColumnsField;
  label?: Maybe<Scalars['String']['output']>;
};

export type ReportTemplateRunInfoColumnsInput = {
  field: EnumReportTemplateRunInfoColumnsField;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTemplateRunInfoInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ReportTemplateRunInfoColumnsInput>>>;
};

export type ReportTemplateRunPlan = {
  active?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportTemplateRunPlanInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportTemplateSessions = {
  active?: Maybe<Scalars['Boolean']['output']>;
  displayedTimeZones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  noteTitle?: Maybe<Scalars['String']['output']>;
  showTimingOverview?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportTemplateSessionsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  displayedTimeZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  showTimingOverview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportTemplateWeather = {
  active?: Maybe<Scalars['Boolean']['output']>;
  splitDataByDays?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportTemplateWeatherInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  splitDataByDays?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResetPasswordResult = {
  password: Scalars['String']['output'];
};

export type ResetTyrePressureSheetResult = {
  success: Scalars['Boolean']['output'];
};

export type RestoreBackupResult = {
  success: Scalars['Boolean']['output'];
};

export type RunBrake = {
  /** Brake temperature after the run */
  TBrakePostRun?: Maybe<Scalars['Float']['output']>;
  /** Brake temperature before the run */
  TBrakePreRun?: Maybe<Scalars['Float']['output']>;
  hBrakeDiscPreRun?: Maybe<Scalars['Float']['output']>;
  /** Format is `Record<string, number>`, e.g. `{ "1FL": 1.2, "2": 1.3 }` */
  thicknessMeasurements?: Maybe<Scalars['JSON']['output']>;
};

export type RunBrakeInput = {
  /** Brake temperature after the run */
  TBrakePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Brake temperature before the run */
  TBrakePreRun?: InputMaybe<Scalars['Float']['input']>;
  hBrakeDiscPreRun?: InputMaybe<Scalars['Float']['input']>;
  /** Format is `Record<string, number>`, e.g. `{ "1FL": 1.2, "2": 1.3 }` */
  thicknessMeasurements?: InputMaybe<Scalars['JSON']['input']>;
};

export type RunEnergy = {
  /** Fuel/Energy/SoC required for ATTACK Lap */
  ATTACK?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for COOL Lap */
  COOL?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for FCY Lap */
  FCY?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for IN Lap */
  IN?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for OUT Lap */
  OUT?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for OUTIN Lap */
  OUTIN?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for PITLANE Lap */
  PITLANE?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for PREP Lap */
  PREP?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for PUSH Lap */
  PUSH?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for QUALI Lap */
  QUALI?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for SAFETYCAR Lap */
  SAFETYCAR?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for SHAKEDOWN Lap */
  SHAKEDOWN?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for SLOW Lap */
  SLOW?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for TARGET Lap */
  TARGET?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for TOGRID Lap */
  TOGRID?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for TOPADDOCK Lap */
  TOPADDOCK?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for TOPITS Lap */
  TOPITS?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for UNFINISHED Lap */
  UNFINISHED?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for an attack mode lap */
  attackLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a cooldown lap */
  coolLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a full course yellow lap */
  fullCourseYellowLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for an in lap */
  inLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for an out-in lap */
  outInLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for an out lap */
  outLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a pitlane lap */
  pitlaneLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a preparation/warmup lap */
  prepLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a push lap */
  pushLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a qualifying lap */
  qualiLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a safety car lap */
  safetyCarLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a shakedown lap */
  shakedownLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a slow lap */
  slowLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for an target lap */
  targetLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a to-grid lap */
  toGridLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a to-pits lap */
  toPitsLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for an unfinished lap */
  unfinishedLap?: Maybe<Scalars['Float']['output']>;
};

/** Run energy field labels mapped to their display names. Null or unset fields are not displayed. */
export type RunEnergyFieldLabels = {
  ATTACK?: Maybe<Scalars['String']['output']>;
  COOL?: Maybe<Scalars['String']['output']>;
  FCY?: Maybe<Scalars['String']['output']>;
  IN?: Maybe<Scalars['String']['output']>;
  OUT?: Maybe<Scalars['String']['output']>;
  OUTIN?: Maybe<Scalars['String']['output']>;
  PITLANE?: Maybe<Scalars['String']['output']>;
  PREP?: Maybe<Scalars['String']['output']>;
  PUSH?: Maybe<Scalars['String']['output']>;
  QUALI?: Maybe<Scalars['String']['output']>;
  SAFETYCAR?: Maybe<Scalars['String']['output']>;
  SHAKEDOWN?: Maybe<Scalars['String']['output']>;
  SLOW?: Maybe<Scalars['String']['output']>;
  TARGET?: Maybe<Scalars['String']['output']>;
  TOGRID?: Maybe<Scalars['String']['output']>;
  TOPADDOCK?: Maybe<Scalars['String']['output']>;
  TOPITS?: Maybe<Scalars['String']['output']>;
  UNFINISHED?: Maybe<Scalars['String']['output']>;
  attackLap?: Maybe<Scalars['String']['output']>;
  coolLap?: Maybe<Scalars['String']['output']>;
  fullCourseYellowLap?: Maybe<Scalars['String']['output']>;
  inLap?: Maybe<Scalars['String']['output']>;
  outInLap?: Maybe<Scalars['String']['output']>;
  outLap?: Maybe<Scalars['String']['output']>;
  pitlaneLap?: Maybe<Scalars['String']['output']>;
  prepLap?: Maybe<Scalars['String']['output']>;
  pushLap?: Maybe<Scalars['String']['output']>;
  qualiLap?: Maybe<Scalars['String']['output']>;
  safetyCarLap?: Maybe<Scalars['String']['output']>;
  shakedownLap?: Maybe<Scalars['String']['output']>;
  slowLap?: Maybe<Scalars['String']['output']>;
  targetLap?: Maybe<Scalars['String']['output']>;
  toGridLap?: Maybe<Scalars['String']['output']>;
  toPitsLap?: Maybe<Scalars['String']['output']>;
  unfinishedLap?: Maybe<Scalars['String']['output']>;
};

/** Run energy field labels mapped to their display names. Null or unset fields are not displayed. */
export type RunEnergyFieldLabelsInput = {
  ATTACK?: InputMaybe<Scalars['String']['input']>;
  COOL?: InputMaybe<Scalars['String']['input']>;
  FCY?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Scalars['String']['input']>;
  OUT?: InputMaybe<Scalars['String']['input']>;
  OUTIN?: InputMaybe<Scalars['String']['input']>;
  PITLANE?: InputMaybe<Scalars['String']['input']>;
  PREP?: InputMaybe<Scalars['String']['input']>;
  PUSH?: InputMaybe<Scalars['String']['input']>;
  QUALI?: InputMaybe<Scalars['String']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['String']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['String']['input']>;
  SLOW?: InputMaybe<Scalars['String']['input']>;
  TARGET?: InputMaybe<Scalars['String']['input']>;
  TOGRID?: InputMaybe<Scalars['String']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['String']['input']>;
  TOPITS?: InputMaybe<Scalars['String']['input']>;
  UNFINISHED?: InputMaybe<Scalars['String']['input']>;
  attackLap?: InputMaybe<Scalars['String']['input']>;
  coolLap?: InputMaybe<Scalars['String']['input']>;
  fullCourseYellowLap?: InputMaybe<Scalars['String']['input']>;
  inLap?: InputMaybe<Scalars['String']['input']>;
  outInLap?: InputMaybe<Scalars['String']['input']>;
  outLap?: InputMaybe<Scalars['String']['input']>;
  pitlaneLap?: InputMaybe<Scalars['String']['input']>;
  prepLap?: InputMaybe<Scalars['String']['input']>;
  pushLap?: InputMaybe<Scalars['String']['input']>;
  qualiLap?: InputMaybe<Scalars['String']['input']>;
  safetyCarLap?: InputMaybe<Scalars['String']['input']>;
  shakedownLap?: InputMaybe<Scalars['String']['input']>;
  slowLap?: InputMaybe<Scalars['String']['input']>;
  targetLap?: InputMaybe<Scalars['String']['input']>;
  toGridLap?: InputMaybe<Scalars['String']['input']>;
  toPitsLap?: InputMaybe<Scalars['String']['input']>;
  unfinishedLap?: InputMaybe<Scalars['String']['input']>;
};

export type RunEnergyInput = {
  /** Fuel/Energy/SoC required for ATTACK Lap */
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for COOL Lap */
  COOL?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for FCY Lap */
  FCY?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for IN Lap */
  IN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for OUT Lap */
  OUT?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for OUTIN Lap */
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PITLANE Lap */
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PREP Lap */
  PREP?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PUSH Lap */
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for QUALI Lap */
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SAFETYCAR Lap */
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SHAKEDOWN Lap */
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SLOW Lap */
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TARGET Lap */
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOGRID Lap */
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOPADDOCK Lap */
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOPITS Lap */
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for UNFINISHED Lap */
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an attack mode lap */
  attackLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a cooldown lap */
  coolLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a full course yellow lap */
  fullCourseYellowLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an in lap */
  inLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an out-in lap */
  outInLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an out lap */
  outLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a pitlane lap */
  pitlaneLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a preparation/warmup lap */
  prepLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a push lap */
  pushLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a qualifying lap */
  qualiLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a safety car lap */
  safetyCarLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a shakedown lap */
  shakedownLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a slow lap */
  slowLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an target lap */
  targetLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a to-grid lap */
  toGridLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a to-pits lap */
  toPitsLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an unfinished lap */
  unfinishedLap?: InputMaybe<Scalars['Float']['input']>;
};

export type RunKpiTableBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  runKPIRows?: Maybe<Array<Maybe<RunKpiTableRow>>>;
  runKPITable?: Maybe<Array<Maybe<GenericRunSheetStyleBlockRunKpiTable>>>;
  /** @deprecated Use other fields to style the block instead */
  style?: Maybe<EnumRunSheetStyleBlockStyle>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type RunKpiTableRow = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Default background color for the cell/s. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Number of decimal places to display. */
  decimals?: Maybe<Scalars['Int']['output']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell, an array of two numbers for a double cell, and so on. */
  gain?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Field names to try pull data from in `runKPI`, like `"vMax"`. Use an array of one key for a single cell, an array of two keys for a double cell, and so on. */
  keys: Array<Maybe<Scalars['String']['output']>>;
  label: Scalars['String']['output'];
  lowerLimit?: Maybe<ValueLimit>;
  /** Text to put as a unit for values. */
  unit?: Maybe<Scalars['String']['output']>;
  upperLimit?: Maybe<ValueLimit>;
};

export type RunKpiTableRowField = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Default background color for the cell/s. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Number of decimal places to display. */
  decimals?: Maybe<Scalars['Float']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lowerLimit?: Maybe<ValueLimit>;
  unit?: Maybe<EnumDisplayUnit>;
  upperLimit?: Maybe<ValueLimit>;
};

export type RunKpiTableRowFieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<ValueLimitInput>;
  unit?: InputMaybe<EnumDisplayUnit>;
  upperLimit?: InputMaybe<ValueLimitInput>;
};

export type RunKpiTableRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell, an array of two numbers for a double cell, and so on. */
  gain?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Field names to try pull data from in `runKPI`, like `"vMax"`. Use an array of one key for a single cell, an array of two keys for a double cell, and so on. */
  keys: Array<InputMaybe<Scalars['String']['input']>>;
  label: Scalars['String']['input'];
  lowerLimit?: InputMaybe<ValueLimitInput>;
  /** Text to put as a unit for values. */
  unit?: InputMaybe<Scalars['String']['input']>;
  upperLimit?: InputMaybe<ValueLimitInput>;
};

export type RunLapTime = {
  ATTACK?: Maybe<Scalars['Float']['output']>;
  COOL?: Maybe<Scalars['Float']['output']>;
  FCY?: Maybe<Scalars['Float']['output']>;
  IN?: Maybe<Scalars['Float']['output']>;
  OUT?: Maybe<Scalars['Float']['output']>;
  OUTIN?: Maybe<Scalars['Float']['output']>;
  PITLANE?: Maybe<Scalars['Float']['output']>;
  PREP?: Maybe<Scalars['Float']['output']>;
  PUSH?: Maybe<Scalars['Float']['output']>;
  QUALI?: Maybe<Scalars['Float']['output']>;
  SAFETYCAR?: Maybe<Scalars['Float']['output']>;
  SHAKEDOWN?: Maybe<Scalars['Float']['output']>;
  SLOW?: Maybe<Scalars['Float']['output']>;
  TARGET?: Maybe<Scalars['Float']['output']>;
  TOGRID?: Maybe<Scalars['Float']['output']>;
  TOPADDOCK?: Maybe<Scalars['Float']['output']>;
  TOPITS?: Maybe<Scalars['Float']['output']>;
  UNFINISHED?: Maybe<Scalars['Float']['output']>;
};

export type RunLapTimeInput = {
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  COOL?: InputMaybe<Scalars['Float']['input']>;
  FCY?: InputMaybe<Scalars['Float']['input']>;
  IN?: InputMaybe<Scalars['Float']['input']>;
  OUT?: InputMaybe<Scalars['Float']['input']>;
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  PREP?: InputMaybe<Scalars['Float']['input']>;
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
};

export type RunPlan = {
  PUEngineerIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  PUEngineers: Array<Person>;
  _id: Scalars['MongoID']['output'];
  /** Amount of time in seconds to increment SOC by 1% at each rSOC value. Must have same length as `chargeTimeSOCValues`. */
  chargeTimeSOCIncrements?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** rSOC values to associate with each time charge time increment. Must have same length as `chargeTimeSOCIncrements` */
  chargeTimeSOCValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  contestant?: Maybe<Contestant>;
  contestantID: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  fuelRequired?: Maybe<RunEnergy>;
  /** Full tank fuel load */
  mFuelFullTank?: Maybe<Scalars['Float']['output']>;
  performanceEngineerIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  performanceEngineers: Array<Person>;
  raceEngineerIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  raceEngineers: Array<Person>;
  runs: Array<Maybe<RunPlanRun>>;
  session?: Maybe<Session>;
  sessionID: Scalars['MongoID']['output'];
  systemEngineerIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  systemEngineers: Array<Person>;
  tLapExpected?: Maybe<RunLapTime>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  /** Short comment like dry run plan / wet run plan. */
  title: Scalars['String']['output'];
  trackLayout?: Maybe<TrackLayout>;
  trackLayoutID?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type RunPlanLap = {
  NLap: Scalars['Int']['output'];
  _id?: Maybe<Scalars['MongoID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** Custom fields for the lap; must be of form `Record<string, any>`. */
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Generic energy expected at lap start, with type depending on the energy type of the run plan. */
  energyLapStart?: Maybe<Scalars['Float']['output']>;
  tDayLapStart?: Maybe<Scalars['Date']['output']>;
  tyreSet?: Maybe<TyreSet>;
  tyreSetID?: Maybe<Scalars['MongoID']['output']>;
};

/** List of items with pagination. */
export type RunPlanPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<RunPlan>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type RunPlanRun = {
  /**
   * Number of fireups planned.
   * @deprecated This field is deprecated - use actionItemsPreRun instead
   */
  NFireups?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of push laps planned in attack mode power.
   * @deprecated This field is deprecated. Use lap sequence instead
   */
  NLapsAttackPower?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of prep laps planned.
   * @deprecated This field is deprecated. Use lap sequence instead
   */
  NLapsPrep?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of push laps planned in standard power.
   * @deprecated This field is deprecated. Use lap sequence instead
   */
  NLapsPush?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of push laps planned in qualifying power.
   * @deprecated This field is deprecated. Use lap sequence instead
   */
  NLapsQualiPower?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of slow laps planned.
   * @deprecated This field is deprecated. Use lap sequence instead
   */
  NLapsSlow?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of target laps planned.
   * @deprecated This field is deprecated. Use lap sequence instead
   */
  NLapsTarget?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of pitstops planned.
   * @deprecated This field is deprecated - use actionItemsPreRun instead
   */
  NPitstops?: Maybe<Scalars['Float']['output']>;
  /** Run number */
  NRun: Scalars['Float']['output'];
  /**
   * Number of starts planned.
   * @deprecated This field is deprecated - use actionItemsPreRun instead
   */
  NStarts?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  actionItemsPostRun?: Maybe<Array<Maybe<RunPlanRunActionItemsPreRun>>>;
  actionItemsPreRun?: Maybe<Array<Maybe<RunPlanRunActionItemsPreRun>>>;
  /** Background color for the run in run plan view. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** e.g. Baseline Run, Option A, … */
  description?: Maybe<Scalars['String']['output']>;
  /** True if fuel was drained before the run. */
  fuelDrainedBeforeRun?: Maybe<Scalars['Boolean']['output']>;
  lapSequence?: Maybe<Array<Maybe<LapSequenceLaps>>>;
  /** @deprecated This field is deprecated. Use lap sequence instead */
  laps?: Maybe<Array<Maybe<RunPlanLap>>>;
  /** Amount of fuel to be refilled at the end of this run. */
  mFuelRefuel?: Maybe<Scalars['Float']['output']>;
  /**
   * Fuel at run's end.
   * @deprecated This field is deprecated - it should be calculated from lap type consumptions set in the run plan or event
   */
  mFuelRunEnd?: Maybe<Scalars['Float']['output']>;
  /**
   * Fuel at the start of the run.
   * @deprecated This field is deprecated - it should be calculated from mFuelRefuel, fuelDrainedBeforeRun and the previous runs
   */
  mFuelRunStart?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<RunPlanRunPriority>;
  /** Things you need to remember to tell the driver. */
  reminder?: Maybe<Scalars['String']['output']>;
  runSheet?: Maybe<RunSheet>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  selectedDriver?: Maybe<Person>;
  selectedDriverID?: Maybe<Scalars['MongoID']['output']>;
  /** Setup changes anticipated. */
  setupChanges?: Maybe<Scalars['String']['output']>;
  /** Amount of time for refuelling at the end of this run. */
  tFuelRefuel?: Maybe<Scalars['Float']['output']>;
  /**
   * Time in garage which is planned for setup changes, fuel, charging, etc.
   * @deprecated This field is deprecated. Only wait before should be used
   */
  tGarageTurnaround?: Maybe<Scalars['Float']['output']>;
  /**
   * Time of day when run end is planned - dynamic by lap numbers and lap times.
   * @deprecated This field is deprecated. It should be calculated from the lap sequence and lap times
   */
  tRunEnd?: Maybe<Scalars['Date']['output']>;
  /**
   * Time of day when run start is planned.
   * @deprecated This field is deprecated. It should be calculated from the previous run or session start and waiting time
   */
  tRunStart?: Maybe<Scalars['Date']['output']>;
  /** Time to wait before starting the run. */
  tWaitBeforeRun?: Maybe<Scalars['Float']['output']>;
  tyreFL?: Maybe<Tyre>;
  tyreFLID?: Maybe<Scalars['MongoID']['output']>;
  tyreFR?: Maybe<Tyre>;
  tyreFRID?: Maybe<Scalars['MongoID']['output']>;
  tyreRL?: Maybe<Tyre>;
  tyreRLID?: Maybe<Scalars['MongoID']['output']>;
  tyreRR?: Maybe<Tyre>;
  tyreRRID?: Maybe<Scalars['MongoID']['output']>;
  tyreSet?: Maybe<TyreSet>;
  tyreSetID?: Maybe<Scalars['MongoID']['output']>;
};

export type RunPlanRunActionItemsPreRun = {
  _id: Scalars['MongoID']['output'];
  name: Scalars['String']['output'];
};

export type RunPlanRunActionItemsPreRunInput = {
  _id: Scalars['MongoID']['input'];
  name: Scalars['String']['input'];
};

export type RunPlanRunInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  actionItemsPostRun?: InputMaybe<Array<InputMaybe<RunPlanRunActionItemsPreRunInput>>>;
  actionItemsPreRun?: InputMaybe<Array<InputMaybe<RunPlanRunActionItemsPreRunInput>>>;
  /** Background color for the run in run plan view. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** e.g. Baseline Run, Option A, … */
  description?: InputMaybe<Scalars['String']['input']>;
  /** True if fuel was drained before the run. */
  fuelDrainedBeforeRun?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequence?: InputMaybe<Array<InputMaybe<LapSequenceLapsInput>>>;
  /** Amount of fuel to be refilled at the end of this run. */
  mFuelRefuel?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<EnumRunPlanRunPriority>;
  /** Things you need to remember to tell the driver. */
  reminder?: InputMaybe<Scalars['String']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  selectedDriverID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Setup changes anticipated. */
  setupChanges?: InputMaybe<Scalars['String']['input']>;
  /** Amount of time for refuelling at the end of this run. */
  tFuelRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Time to wait before starting the run. */
  tWaitBeforeRun?: InputMaybe<Scalars['Float']['input']>;
  tyreFLID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreFRID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreRLID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreRRID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
};

export const RunPlanRunPriority = {
  PRIO1_MAXIMUM: 'PRIO1_MAXIMUM',
  PRIO2_HIGH: 'PRIO2_HIGH',
  PRIO3_MEDIUM: 'PRIO3_MEDIUM',
  PRIO4_LOW: 'PRIO4_LOW',
  PRIO5_NONE: 'PRIO5_NONE'
} as const;

export type RunPlanRunPriority = typeof RunPlanRunPriority[keyof typeof RunPlanRunPriority];
export type RunSheet = {
  /** Fuel density, if working in volume (overrides `DFuel` from event) */
  DFuel?: Maybe<Scalars['Float']['output']>;
  /** Run number */
  NRun?: Maybe<Scalars['Float']['output']>;
  /** Run number for timing services */
  NRunTiming?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Specify SoC required in event.consumptions instead */
  SoCRequired?: Maybe<RunEnergy>;
  TCellMaxRunStart?: Maybe<Scalars['Float']['output']>;
  /** Volume of fuel added at the start of the run. This field will not be automatically calculated by the API, so should be set along with `tRefuel` and `qRefuel` as their product. */
  VFuelAdded?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  associatedKpiFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brakeComment?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use parts and tracking items instead */
  brakeFL?: Maybe<RunBrake>;
  /** @deprecated Use parts and tracking items instead */
  brakeFR?: Maybe<RunBrake>;
  /**
   * Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFL: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use brakePreRunMeasurementsFL or brakePostRunMeasurementsFL
   */
  brakeMeasurementsFL?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFR: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use brakePreRunMeasurementsFR or brakePostRunMeasurementsFR
   */
  brakeMeasurementsFR?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRL: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use brakePreRunMeasurementsRL or brakePostRunMeasurementsRL
   */
  brakeMeasurementsRL?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRR: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use brakePreRunMeasurementsRR or brakePostRunMeasurementsRR
   */
  brakeMeasurementsRR?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFL: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePostRunMeasurementsFL?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFR: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePostRunMeasurementsFR?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRL: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePostRunMeasurementsRL?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRR: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePostRunMeasurementsRR?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFL: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePreRunMeasurementsFL?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFR: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePreRunMeasurementsFR?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRL: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePreRunMeasurementsRL?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRR: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePreRunMeasurementsRR?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Use parts and tracking items instead */
  brakeRL?: Maybe<RunBrake>;
  /** @deprecated Use parts and tracking items instead */
  brakeRR?: Maybe<RunBrake>;
  /** Chassis assembly derived from the linked setup */
  chassisAssembly?: Maybe<ChassisAssembly>;
  /** Chassis assembly ID derived from the linked setup */
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  /** Link to a cloud storage location where raw run data is kept. */
  cloudStorageURL?: Maybe<Scalars['String']['output']>;
  /** Fuel/SoC/Energy consumptions for each track layout in this run sheet. Acts as an override for the consumptions from the parent event. */
  consumptions?: Maybe<Array<Maybe<LayoutConsumption>>>;
  contestant?: Maybe<Contestant>;
  contestantID: Scalars['MongoID']['output'];
  controlsComment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dashboard?: Maybe<Dashboard>;
  dataServiceFileNameOverride?: Maybe<Scalars['String']['output']>;
  dilComments?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<Person>;
  driverComments?: Maybe<Scalars['String']['output']>;
  driverID?: Maybe<Scalars['MongoID']['output']>;
  /** Resolved end time. Order: end time from laptime service, end time from manual, calculated end time via start time and laptimes */
  endTime?: Maybe<Scalars['Date']['output']>;
  /** Car data service run end time */
  endTimeCDS?: Maybe<Scalars['Date']['output']>;
  /** Laptime service run end time */
  endTimeLTS?: Maybe<Scalars['Date']['output']>;
  /** Manual run end time (used to override calculation in case run was cut short but don't want to delete the drafted laps */
  endTimeManual?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Specify energy required in event.consumptions instead */
  energyRequired?: Maybe<RunEnergy>;
  engineer?: Maybe<Person>;
  engineerComments?: Maybe<Scalars['String']['output']>;
  engineerID?: Maybe<Scalars['MongoID']['output']>;
  fastestLap?: Maybe<Scalars['Float']['output']>;
  /** Time by which tyre heating schedule should be finished */
  finishTyreHeatingBy?: Maybe<Scalars['Date']['output']>;
  /** Used for fuel calculation. If true, mFuelAdded is treated as the total fuel at run start. */
  fuelDrainedBeforeRun?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Specify fuel required in event.consumptions instead */
  fuelRequired?: Maybe<RunEnergy>;
  /** Resolved garage time. Laptime service timestamps */
  garageTime?: Maybe<Scalars['Float']['output']>;
  history: Array<History>;
  historyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  info?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isLockedByLaptimeService?: Maybe<Scalars['Boolean']['output']>;
  issueIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  jobIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  jobs: Array<Job>;
  /** Used to save the file name where the kpi data is retreived from */
  kpiFileName?: Maybe<Scalars['String']['output']>;
  kpiStatus?: Maybe<EnumRunSheetKpiStatus>;
  kpiUpdatedAt?: Maybe<Scalars['Date']['output']>;
  lapCount: Scalars['Int']['output'];
  lapIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  laps: Array<Lap>;
  laptimeThresholds?: Maybe<LaptimeThresholds>;
  lastModifiedBy?: Maybe<Person>;
  lastModifiedByID?: Maybe<Scalars['MongoID']['output']>;
  /** Fuel added at the start of the run */
  mFuelAdded?: Maybe<Scalars['Float']['output']>;
  /** Fuel removed from the catch tank after the run */
  mFuelDrainedCatchTank?: Maybe<Scalars['Float']['output']>;
  /** Fuel removed from the main tank after the run */
  mFuelDrainedMainTank?: Maybe<Scalars['Float']['output']>;
  /** Fuel remaining at the end of the run */
  mFuelRunEnd?: Maybe<Scalars['Float']['output']>;
  /** Fuel remaining at the start of the run */
  mFuelRunStart?: Maybe<Scalars['Float']['output']>;
  /** Fuel used before run start i.e. for pre-run fireup */
  mFuelUsedPreRun?: Maybe<Scalars['Float']['output']>;
  /** Calculated mileage of the run. */
  mileage?: Maybe<Scalars['Float']['output']>;
  nextRunSheetID?: Maybe<Scalars['MongoID']['output']>;
  performanceComments?: Maybe<Scalars['String']['output']>;
  prevRunSheetID?: Maybe<Scalars['MongoID']['output']>;
  problemComments?: Maybe<Scalars['String']['output']>;
  /** Flow rate when refuelling at the start of the run, in m³/s */
  qRefuel?: Maybe<Scalars['Float']['output']>;
  /** Energy charged to this value at the start of the run */
  rEnergyAdded?: Maybe<Scalars['Float']['output']>;
  /** Energy level at the end of the run */
  rEnergyRunEnd?: Maybe<Scalars['Float']['output']>;
  /** Energy level at the start of the run => calculated */
  rEnergyRunStart?: Maybe<Scalars['Float']['output']>;
  /** Battery charged to this value at the start of the run */
  rSOCAdded?: Maybe<Scalars['Float']['output']>;
  /** Battery state of charge at the end of the run */
  rSOCRunEnd?: Maybe<Scalars['Float']['output']>;
  /** Battery state of charge at the start of the run */
  rSOCRunStart?: Maybe<Scalars['Float']['output']>;
  /** Short comment of the objective of the run */
  runDescription?: Maybe<Scalars['String']['output']>;
  /** Map of run KPI fields to their values. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  runKPI?: Maybe<Scalars['JSON']['output']>;
  runSheetStyle?: Maybe<RunSheetStyle>;
  runSheetStyleID?: Maybe<Scalars['MongoID']['output']>;
  /** Running time in seconds */
  runTime?: Maybe<Scalars['Float']['output']>;
  /** ID of the job list template used for this run */
  selectedJobListTemplateID?: Maybe<Scalars['MongoID']['output']>;
  session?: Maybe<Session>;
  sessionID?: Maybe<Scalars['MongoID']['output']>;
  setup?: Maybe<CarSetup>;
  setupID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of the simulation results associated with this run. */
  simResultIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  simResults: Array<SimResult>;
  skidComment?: Maybe<Scalars['String']['output']>;
  /**
   * Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidMeasurement: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use skidPreRunMeasurements or skidPostRunMeasurements
   */
  skidMeasurement?: Maybe<Scalars['JSON']['output']>;
  skidPlate?: Maybe<SkidPlate>;
  /** @deprecated Use parts and tracking items instead */
  skidPlateID?: Maybe<Scalars['MongoID']['output']>;
  /**
   * Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPostRunMeasurements: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  skidPostRunMeasurements?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPreRunMeasurements: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  skidPreRunMeasurements?: Maybe<Scalars['JSON']['output']>;
  /** Resolved start time. Start time from Laptime service has priority over manual */
  startTime?: Maybe<Scalars['Date']['output']>;
  startTimeCDS?: Maybe<Scalars['Date']['output']>;
  startTimeLTS?: Maybe<Scalars['Date']['output']>;
  startTimeManual?: Maybe<Scalars['Date']['output']>;
  /** Time at which to start tyre heating schedule */
  startTyreHeatingAt?: Maybe<Scalars['Date']['output']>;
  summaryComments?: Maybe<Scalars['String']['output']>;
  systemsComments?: Maybe<Scalars['String']['output']>;
  /** Time spent in garage after run */
  tGarageTurnaround?: Maybe<Scalars['Float']['output']>;
  /** Time spent refuelling at the start of the run */
  tRefuel?: Maybe<Scalars['Float']['output']>;
  /** Override for session time remaining (in seconds) */
  tSessionRemainingOverride?: Maybe<Scalars['Float']['output']>;
  /** Session time remaining at the start of the run (in seconds). Resolved from previous runs if needed */
  tSessionRemainingStartRun?: Maybe<Scalars['Float']['output']>;
  /** Time spent in garage before run */
  tWaitBeforeRun?: Maybe<Scalars['Float']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  team?: Maybe<Team>;
  teamID?: Maybe<Scalars['MongoID']['output']>;
  /** ID of this run in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyRunID?: Maybe<Scalars['String']['output']>;
  /** Should the timing service pretend that this run sheet does not exist? */
  timingServiceShouldIgnore?: Maybe<Scalars['Boolean']['output']>;
  tyreComments?: Maybe<Scalars['String']['output']>;
  /** The tyre compound used, reported by the timing service. */
  tyreCompoundTiming?: Maybe<Scalars['String']['output']>;
  tyreFL?: Maybe<RunTyre>;
  tyreFR?: Maybe<RunTyre>;
  tyrePressureSettings?: Maybe<TyrePressureSettings>;
  tyreRL?: Maybe<RunTyre>;
  tyreRR?: Maybe<RunTyre>;
  tyreSet?: Maybe<TyreSet>;
  tyreSetID?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weather?: Maybe<WeatherData>;
  writeHistory?: Maybe<Scalars['Boolean']['output']>;
};


export type RunSheetRunKpiArgs = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RunSheetInfo = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  info?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type RunSheetPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<RunSheet>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type RunSheetStyle = {
  _id: Scalars['MongoID']['output'];
  blocks?: Maybe<Array<Maybe<RunSheetStyleBlock>>>;
  energyType?: Maybe<EnumEnergyType>;
  lapFlags?: Maybe<LapFlagLabels>;
  name: Scalars['String']['output'];
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
};

export type RunSheetStyleBlock = BlankingBlock | BrakesBlock | CommentBlock | DoubleCommentBlock | FuelBlock | IssueBlock | JobListBlock | LapTableBlock | LapTimeThresholdsBlock | LapTypeCountBlock | MiniJobListBlock | PostRunMeasurementBlock | RunKpiTableBlock | SetupChangesBlock | SetupSheetBlock | TyreTableBlock | WeatherBoxBlock;

/** List of items with pagination. */
export type RunSheetStylePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<RunSheetStyle>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type RunTyre = {
  /**
   * Track reference temperature at which the reference pressure is given
   * @deprecated Use tyrePressureSettings.TTrackReference instead
   */
  TTrackReference?: Maybe<Scalars['Float']['output']>;
  /** Tyre temperature */
  TTyre?: Maybe<Scalars['Float']['output']>;
  /** Expected tyre temperature in parc ferme */
  TTyreParcFermeExpected?: Maybe<Scalars['Float']['output']>;
  /** Post-run tyre temperature */
  TTyrePostRun?: Maybe<Scalars['Float']['output']>;
  /** Post-run tyre pressure bleed at temperature */
  TTyrePostRunBleed?: Maybe<Scalars['Float']['output']>;
  /** Pre-run tyre pressure bleed at temperature */
  TTyrePreRunBleed?: Maybe<Scalars['Float']['output']>;
  /** Tyre reference temperature at which the reference pressure is given */
  TTyreReference?: Maybe<Scalars['Float']['output']>;
  /** Set down tyre temperature (e.g. in the evening with cold tyre) */
  TTyreSetdown?: Maybe<Scalars['Float']['output']>;
  /** Array of manual surface temperature measurements */
  TTyreSurface?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Array of manual tyre tread depth measurements */
  hTyreTread?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Calculated mileage from all previous run sheets */
  mileagePreRun?: Maybe<Scalars['Float']['output']>;
  /** Tyre pressure */
  pTyre?: Maybe<Scalars['Float']['output']>;
  /**
   * Tyre minimum pressure at the start of the run
   * @deprecated Use pTyreStartRun instead
   */
  pTyreMinStartRun?: Maybe<Scalars['Float']['output']>;
  /** Post-run tyre pressure */
  pTyrePostRun?: Maybe<Scalars['Float']['output']>;
  /** Post-run tyre pressure bleed */
  pTyrePostRunBleed?: Maybe<Scalars['Float']['output']>;
  /** Pre-run tyre pressure bleed */
  pTyrePreRunBleed?: Maybe<Scalars['Float']['output']>;
  /** Tyre reference pressure */
  pTyreReference?: Maybe<Scalars['Float']['output']>;
  /** Set down tyre pressure (e.g. in the evening with cold tyre) */
  pTyreSetDown?: Maybe<Scalars['Float']['output']>;
  /** Tyre pressure at the start of the run */
  pTyreStartRun?: Maybe<Scalars['Float']['output']>;
  /** Target tyre pressure during running */
  pTyreTarget?: Maybe<Scalars['Float']['output']>;
  tyre?: Maybe<Tyre>;
  tyreID?: Maybe<Scalars['MongoID']['output']>;
};

export type RunTyreInput = {
  /** Track reference temperature at which the reference pressure is given */
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre temperature */
  TTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Expected tyre temperature in parc ferme */
  TTyreParcFermeExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre temperature */
  TTyrePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure bleed at temperature */
  TTyrePostRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Pre-run tyre pressure bleed at temperature */
  TTyrePreRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre reference temperature at which the reference pressure is given */
  TTyreReference?: InputMaybe<Scalars['Float']['input']>;
  /** Set down tyre temperature (e.g. in the evening with cold tyre) */
  TTyreSetdown?: InputMaybe<Scalars['Float']['input']>;
  /** Array of manual surface temperature measurements */
  TTyreSurface?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Array of manual tyre tread depth measurements */
  hTyreTread?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Tyre pressure */
  pTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure at the start of the run */
  pTyreMinStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure */
  pTyrePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure bleed */
  pTyrePostRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Pre-run tyre pressure bleed */
  pTyrePreRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre reference pressure */
  pTyreReference?: InputMaybe<Scalars['Float']['input']>;
  /** Set down tyre pressure (e.g. in the evening with cold tyre) */
  pTyreSetDown?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre pressure at the start of the run */
  pTyreStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Target tyre pressure during running */
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
  tyreID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type RuntimeError = ErrorInterface & {
  /** Runtime error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type SandboxMutations = {
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addUnit?: Maybe<CreateOneSandboxUnitsPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeUnit?: Maybe<RemoveByIdSandboxUnitsPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateUnit?: Maybe<UpdateByIdSandboxUnitsPayload>;
};


export type SandboxMutationsAddUnitArgs = {
  record: CreateOneSandboxUnitsInput;
};


export type SandboxMutationsRemoveUnitArgs = {
  _id: Scalars['MongoID']['input'];
};


export type SandboxMutationsUpdateUnitArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSandboxUnitsInput;
};

export type SandboxQueries = {
  unit?: Maybe<SandboxUnits>;
  units?: Maybe<SandboxUnitsPagination>;
};


export type SandboxQueriesUnitArgs = {
  _id: Scalars['MongoID']['input'];
};


export type SandboxQueriesUnitsArgs = {
  filter?: InputMaybe<FilterFindManySandboxUnitsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySandboxUnitsInput>;
};

export type SandboxUnits = {
  _id: Scalars['MongoID']['output'];
  acceleration?: Maybe<Acceleration>;
  angle?: Maybe<Angle>;
  angularVelocity?: Maybe<AngularVelocity>;
  area?: Maybe<Area>;
  current?: Maybe<Current>;
  dampingRate?: Maybe<DampingRate>;
  density?: Maybe<Density>;
  energy?: Maybe<Energy>;
  force?: Maybe<Force>;
  frequency?: Maybe<Frequency>;
  length?: Maybe<Length>;
  mass?: Maybe<Mass>;
  momentOfInertia?: Maybe<MomentOfInertia>;
  power?: Maybe<Power>;
  pressure?: Maybe<Pressure>;
  ratio?: Maybe<Ratio>;
  springRate?: Maybe<SpringRate>;
  temperature?: Maybe<Temperature>;
  torque?: Maybe<Torque>;
  torsionRate?: Maybe<TorsionRate>;
  velocity?: Maybe<Velocity>;
  voltage?: Maybe<Voltage>;
  volume?: Maybe<Volume>;
};

/** List of items with pagination. */
export type SandboxUnitsPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SandboxUnits>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ScrapManyTyresResult = {
  updatedCount: Scalars['Int']['output'];
};

export type Season = {
  _id: Scalars['MongoID']['output'];
  assignedSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignedSetups: Array<CarSetup>;
  contestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  contestants: Array<Contestant>;
  /** The most recent session that has awarded points, within this season. Currently selected purely based on the existence of driver championship standings data, not reliant on live standings data.  */
  currentPointsSession?: Maybe<Session>;
  /** The most recent or currently active session within this season. Currently selected purely based on the existence of live standings data, but may be made more intelligent in future. */
  currentSession?: Maybe<Session>;
  eventIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  events: Array<Event>;
  /** Position after which a driver no longer gets points for fastest lap. */
  fastestLapsPositionCutoff?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Championship points per fastest lap in a session. Example: `[1]` means fastest lap gets 1 point, then second and beyond gets nothing. */
  pointsPerFastestLap?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Whether the fastest lap points are awarded to the team or the driver. */
  pointsPerFastestLapTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Championship points per driver position in a race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPosition?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Championship points per driver position in a sprint race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPositionSprintRace?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Championship points per qualifying rank at an event. Example: `[3, 2, 1]` means first/second/third drivers get 3/2/1 points, then fourth and beyond gets nothing. */
  pointsPerQualifyingRank?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  pointsSystemQualiAlternateIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  pointsSystemQualiAlternates: Array<PointsSystem>;
  pointsSystemQualiDefaultIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  pointsSystemQualiDefaults: Array<PointsSystem>;
  pointsSystemRaceAlternateIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  pointsSystemRaceAlternates: Array<PointsSystem>;
  pointsSystemRaceDefaultIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  pointsSystemRaceDefaults: Array<PointsSystem>;
  raceSeries?: Maybe<RaceSeries>;
  raceSeriesID: Scalars['MongoID']['output'];
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** IDs of all tyres which are owned by the team for this season. */
  tyreIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** IDs of all tyre sets which are owned by the team for this season. */
  tyreSetIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tyreSets: Array<TyreSet>;
  tyres: Array<Tyre>;
};

/** List of items with pagination. */
export type SeasonPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Season>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SelfResetPasswordResult = {
  success: Scalars['Boolean']['output'];
};

export type ServerSettings = {
  _id: Scalars['MongoID']['output'];
  copyAssembly?: Maybe<ServerSettingsCopyAssembly>;
  simulationColoring?: Maybe<ServerSettingsSimulationColoring>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ServerSettingsCopyAssembly = {
  copyInactiveParts?: Maybe<Scalars['Boolean']['output']>;
};

export type ServerSettingsCopyAssemblyInput = {
  copyInactiveParts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServerSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  copyAssembly?: InputMaybe<ServerSettingsCopyAssemblyInput>;
  simulationColoring?: InputMaybe<ServerSettingsSimulationColoringInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ServerSettingsSimulationColoring = {
  method?: Maybe<EnumServerSettingsSimulationColoringMethod>;
};

export type ServerSettingsSimulationColoringInput = {
  method?: InputMaybe<EnumServerSettingsSimulationColoringMethod>;
};

export type Session = {
  _id: Scalars['MongoID']['output'];
  assignedSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignedSetups: Array<CarSetup>;
  bestValues?: Maybe<BestValues>;
  bestValuesID?: Maybe<Scalars['MongoID']['output']>;
  bop?: Maybe<Bop>;
  bopID?: Maybe<Scalars['MongoID']['output']>;
  contestants?: Maybe<Array<Maybe<SessionContestants>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: Maybe<Scalars['JSON']['output']>;
  debriefNotes?: Maybe<Scalars['String']['output']>;
  debriefNotesMode?: Maybe<EnumSessionDebriefNotesMode>;
  disableForwardPropagation?: Maybe<Scalars['Boolean']['output']>;
  /** Sorted driver championship standings during and immediately after this session. */
  driverChampionshipStandings?: Maybe<Array<Maybe<DriverChampionshipStanding>>>;
  /** Driver Timings resolved from runsheets */
  driverTimings: Array<DriverTiming>;
  event?: Maybe<Event>;
  eventID: Scalars['MongoID']['output'];
  /** This flag is used to tell the laptime service that this session might span multiple timing sessions. */
  isLinkedSession?: Maybe<Scalars['Boolean']['output']>;
  /** Is this a timing test session, to be shown only to admin users? */
  isTimingTest?: Maybe<Scalars['Boolean']['output']>;
  /** Sorted standings of this session, as they were last updated */
  liveStandings?: Maybe<Array<Maybe<LiveStanding>>>;
  /** Greatest lap number processed for live standings. Use to determine if the data is current and up to date. */
  liveStandingsCurrentLap?: Maybe<Scalars['Float']['output']>;
  /** Time of last update of `liveStandings` and `driverChampionshipStandings` */
  liveStandingsUpdatedAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  /** ID of the next session in this event */
  nextSessionID?: Maybe<Scalars['MongoID']['output']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFLMinSession?: Maybe<Scalars['Float']['output']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFRMinSession?: Maybe<Scalars['Float']['output']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRLMinSession?: Maybe<Scalars['Float']['output']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRRMinSession?: Maybe<Scalars['Float']['output']>;
  participantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  participants: Array<Person>;
  pointsSystemOverrideIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  pointsSystemOverrides: Array<PointsSystem>;
  /** Sorted driver championship standings from before the start of this session. */
  prevDriverChampionshipStandings?: Maybe<Array<Maybe<DriverChampionshipStanding>>>;
  /** ID of the previous session in this event */
  prevSessionID?: Maybe<Scalars['MongoID']['output']>;
  /** e.g. Test, Practice, Qualifying, Race */
  sessionType?: Maybe<EnumSessionType>;
  /** Short name like D1, FP2, etc. */
  shortName?: Maybe<Scalars['String']['output']>;
  /** Time of the session end in local time */
  tSessionEnd?: Maybe<Scalars['Date']['output']>;
  /** Time of the session start in local time */
  tSessionStart?: Maybe<Scalars['Date']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** Sorted team championship standings during and immediately after this session. */
  teamChampionshipStandings?: Maybe<Array<Maybe<TeamChampionshipStanding>>>;
  /** ID of this session in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartySessionID?: Maybe<Scalars['String']['output']>;
  /** Seconds until end of session, updated by the timing service very infrequently. Zero if session has already ended. */
  timeRemaining?: Maybe<Scalars['Float']['output']>;
  /** Time of last update of `timeRemaining` (automatically updated). */
  timeRemainingUpdatedAt?: Maybe<Scalars['Date']['output']>;
  /** ID of this session for Transcribble's legacy API */
  transcribbleSessionID?: Maybe<Scalars['Int']['output']>;
};


export type SessionDriverTimingsArgs = {
  filterByCarClasses?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Field to target with this mutation. */
export const SessionContestantField = {
  /** → `chassisIDs` */
  CHASSIS: 'CHASSIS',
  /** → `driverIDs` */
  DRIVERS: 'DRIVERS'
} as const;

export type SessionContestantField = typeof SessionContestantField[keyof typeof SessionContestantField];
export type SessionContestants = {
  _id: Scalars['MongoID']['output'];
  /** Chassis used, if different for this session. */
  chassis: Array<Chassis>;
  /** IDs of the chassis used, if different for this session. */
  chassisIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: Maybe<Scalars['String']['output']>;
  /** IDs of drivers of this car, if different for this session. */
  driverIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Drivers of this car, if different for this session. */
  drivers: Array<Person>;
};

export type SessionContestantsInput = {
  _id: Scalars['MongoID']['input'];
  /** IDs of the chassis used, if different for this session. */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** IDs of drivers of this car, if different for this session. */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** List of items with pagination. */
export type SessionPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Session>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SetAllTimingServiceConfigsInactive = {
  modifiedCount?: Maybe<Scalars['Int']['output']>;
};

export type SetPasswordResult = {
  success: Scalars['Boolean']['output'];
};

export type SetupChangesBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type SetupOverviewConfig = {
  _id: Scalars['MongoID']['output'];
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  /** WARNING: this field should be deprecated after SI migrations have taken place */
  fields?: Maybe<Array<Maybe<SetupOverviewConfigField>>>;
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  rows?: Maybe<Array<Maybe<SetupOverviewConfigRow>>>;
  title: Scalars['String']['output'];
};

export type SetupOverviewConfigField = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Number of decimal places to display. */
  decimals?: Maybe<Scalars['Int']['output']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell and an array of two numbers for a double cell. */
  gain?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Field names to pull data from in the car setup, like `"frontLeft.hRide"`. Use an array of one key for a single cell, and an array of two keys for a double cell. */
  keys: Array<Maybe<Scalars['String']['output']>>;
  label: Scalars['String']['output'];
  /** Suffix to show as a unit for values. */
  unit?: Maybe<Scalars['String']['output']>;
};

export type SetupOverviewConfigFieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell and an array of two numbers for a double cell. */
  gain?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Field names to pull data from in the car setup, like `"frontLeft.hRide"`. Use an array of one key for a single cell, and an array of two keys for a double cell. */
  keys: Array<InputMaybe<Scalars['String']['input']>>;
  label: Scalars['String']['input'];
  /** Suffix to show as a unit for values. */
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type SetupOverviewConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SetupOverviewConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SetupOverviewConfigRow = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  elements?: Maybe<Array<Maybe<SetupOverviewConfigRowElement>>>;
  title: Scalars['String']['output'];
};

export type SetupOverviewConfigRowElement = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Number of decimal places to display. */
  decimals?: Maybe<Scalars['Int']['output']>;
  /** Path of field in car setup, e.g. aero.aFlapF */
  field: Scalars['String']['output'];
  /** Gain to apply to the value. */
  gain?: Maybe<Scalars['Float']['output']>;
  /** Suffix to put as a unit for values. */
  suffix?: Maybe<Scalars['String']['output']>;
  unitType: TypedUnitField;
};

export type SetupOverviewConfigRowElementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Path of field in car setup, e.g. aero.aFlapF */
  field: Scalars['String']['input'];
  /** Gain to apply to the value. */
  gain?: InputMaybe<Scalars['Float']['input']>;
  /** Suffix to put as a unit for values. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  unitType: BaseTypedUnitFieldInput;
};

export type SetupOverviewConfigRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  elements?: InputMaybe<Array<InputMaybe<SetupOverviewConfigRowElementInput>>>;
  title: Scalars['String']['input'];
};

export type SetupSheetBlock = {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  setupSheetStyle?: Maybe<SetupSheetStyle>;
  setupSheetStyleID?: Maybe<Scalars['MongoID']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type SetupSheetGroup = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  rows: Array<SetupSheetStyleRow>;
};

export type SetupSheetGroupInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  rows: Array<SetupSheetStyleRowInput>;
};

export type SetupSheetStyle = {
  _id: Scalars['MongoID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  blocks: Array<SetupSheetStyleBlock>;
  /** Chassis specification to use for suggesting field keys. You may need to look for more recent iterations of this spec to get up-to-date field keys. */
  chassisSpec?: Maybe<ChassisSpec>;
  /** Chassis specification to use for suggesting field keys. You may need to look for more recent iterations of this spec to get up-to-date field keys. */
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  hideAddPartButton?: Maybe<Scalars['Boolean']['output']>;
  /** Toggle to show/hide units for the input fields */
  hideUnits?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  targetEventType?: Maybe<EnumSetupSheetStyleTargetEventType>;
  targetRoles?: Maybe<Array<EnumPersonRole>>;
  targetUserIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  targetUsers: Array<Person>;
  type: EnumSetupSheetStyleType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SetupSheetStyleBlock = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The height of the block within the grid */
  height: Scalars['Int']['output'];
  tabs: Array<SetupSheetStyleTab>;
  /** The width of the block within the grid */
  width: Scalars['Int']['output'];
  /** The x position of the block within the grid */
  x: Scalars['Int']['output'];
  /** The y position of the block within the grid */
  y: Scalars['Int']['output'];
};

export type SetupSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** The height of the block within the grid */
  height: Scalars['Int']['input'];
  tabs?: InputMaybe<Array<SetupSheetStyleTabInput>>;
  /** The width of the block within the grid */
  width: Scalars['Int']['input'];
  /** The x position of the block within the grid */
  x: Scalars['Int']['input'];
  /** The y position of the block within the grid */
  y: Scalars['Int']['input'];
};

export type SetupSheetStyleItem = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  alignment?: Maybe<Scalars['String']['output']>;
  /** Background color for this item; overrides the setting from the parent block. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  colSpan?: Maybe<Scalars['Int']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  fieldKey?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** Use an inclusive OR of this flag with the `readOnly` field in flattened car setup data. */
  readOnly: Scalars['Boolean']['output'];
  /** If this is non-empty, only users with one of these roles can edit the value of this field. */
  restrictedToRoles: Array<EnumPersonRole>;
  type: EnumSetupSheetStyleItemType;
  /** Portion of the containing row to take up. Takes precedence over colSpan if defined. */
  widthRatio?: Maybe<Scalars['Float']['output']>;
};

export type SetupSheetStyleItemInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  /** Background color for this item; overrides the setting from the parent block. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  colSpan?: InputMaybe<Scalars['Int']['input']>;
  decimals?: InputMaybe<Scalars['Float']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Use an inclusive OR of this flag with the `readOnly` field in flattened car setup data. */
  readOnly?: Scalars['Boolean']['input'];
  /** If this is non-empty, only users with one of these roles can edit the value of this field. */
  restrictedToRoles?: Array<EnumPersonRole>;
  type: EnumSetupSheetStyleItemType;
  /** Portion of the containing row to take up. Takes precedence over colSpan if defined. */
  widthRatio?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type SetupSheetStylePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SetupSheetStyle>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SetupSheetStyleRow = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  items: Array<SetupSheetStyleItem>;
};

export type SetupSheetStyleRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  items: Array<SetupSheetStyleItemInput>;
};

export type SetupSheetStyleTab = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  groups: Array<SetupSheetGroup>;
  massConfig?: Maybe<SetupSheetStyleTabMassConfig>;
  mileageConfig?: Maybe<SetupSheetStyleTabMileageConfig>;
  rows: Array<SetupSheetStyleRow>;
  title: Scalars['String']['output'];
  type?: Maybe<EnumSetupSheetStyleTabType>;
};

export type SetupSheetStyleTabInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  groups?: InputMaybe<Array<SetupSheetGroupInput>>;
  massConfig?: InputMaybe<SetupSheetStyleTabMassConfigInput>;
  mileageConfig?: InputMaybe<SetupSheetStyleTabMileageConfigInput>;
  rows?: InputMaybe<Array<SetupSheetStyleRowInput>>;
  title: Scalars['String']['input'];
  type?: InputMaybe<EnumSetupSheetStyleTabType>;
};

export type SetupSheetStyleTabMassConfig = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  massOption?: Maybe<Scalars['String']['output']>;
  showMinWeightFromSpec?: Maybe<Scalars['Boolean']['output']>;
};

export type SetupSheetStyleTabMassConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  massOption?: InputMaybe<Scalars['String']['input']>;
  showMinWeightFromSpec?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetupSheetStyleTabMileageConfig = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  showManualInput?: Maybe<Scalars['Boolean']['output']>;
};

export type SetupSheetStyleTabMileageConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  showManualInput?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SimRequest = {
  /** Ambient temperature in °K */
  TAmbient?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  carSetup?: Maybe<CarSetup>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Ambient pressure in Pa */
  pAmbient?: Maybe<Scalars['Float']['output']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: Maybe<Scalars['Float']['output']>;
  relatedSimResultIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  requester?: Maybe<Person>;
  requesterID?: Maybe<Scalars['MongoID']['output']>;
  requesterSlot?: Maybe<EnumSimRequestRequesterSlot>;
  runSheet?: Maybe<RunSheet>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  simResult?: Maybe<SimResult>;
  simResultID?: Maybe<Scalars['MongoID']['output']>;
  simType?: Maybe<EnumSimRequestSimType>;
  simulationService?: Maybe<EnumSimModelType>;
  sourceReferenceID?: Maybe<Scalars['String']['output']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  status?: Maybe<EnumSimResultStatus>;
  trackLayout?: Maybe<TrackLayout>;
  trackLayoutID?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Version of the third-party service used to generate the sim result */
  version?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type SimRequestPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SimRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SimResult = {
  /** Ambient temperature in °K */
  TAmbient?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  carSetup?: Maybe<CarSetup>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  /** When the car setup was last modified at time of request. Used to ensure that the sim result is up to date when it is retrieved. */
  carSetupModifiedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  data?: Maybe<Array<Maybe<SimResultData>>>;
  /** Each data channel is assumed to use this unless it specifies `channelSamplingRate` or `channelTime` */
  defaultChannelTime?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Has the car setup changed since this request/result was created? Returns null if unknown or not applicable. */
  isCarSetupChanged?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Ambient pressure in Pa */
  pAmbient?: Maybe<Scalars['Float']['output']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: Maybe<Scalars['Float']['output']>;
  /** Map containing reference values from car setup. Example: aerobalance in a car manual. Input syntax is array of key-value tuples, like `refValues: [["rAeroBalF", 48.5], ["rLatBalF", 51.4]]`. */
  refValues?: Maybe<Scalars['JSON']['output']>;
  requester?: Maybe<Person>;
  requesterID?: Maybe<Scalars['MongoID']['output']>;
  runSheet?: Maybe<RunSheet>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  /** Version of the ORH service used to generate the sim result */
  serviceVersion?: Maybe<Scalars['String']['output']>;
  simType?: Maybe<EnumSimResultSimType>;
  simulationDriveFile?: Maybe<SimulationDriveFile>;
  simulationDriveFileID?: Maybe<Scalars['MongoID']['output']>;
  simulationService?: Maybe<EnumSimModelType>;
  /** Service which generated this sim result, for example Canopy */
  source?: Maybe<Scalars['String']['output']>;
  /** Reference for this sim result, to find it in the simulation service */
  sourceReferenceID?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<Specification>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  status?: Maybe<EnumSimResultStatus>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackLayout?: Maybe<TrackLayout>;
  trackLayoutID?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Version of the third-party service used to generate the sim result */
  version?: Maybe<Scalars['String']['output']>;
};

export type SimResultData = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  /** Sampling rate of the channel in Hz, if overriding `defaultChannelTime` without `channelTime` */
  channelSamplingRate?: Maybe<Scalars['Float']['output']>;
  /** Use this to override `defaultChannelTime` */
  channelTime?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Actual channel data values */
  channelValue?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  interpolationMethod?: Maybe<EnumSimResultDataInterpolationMethod>;
  /** Should values in this channel be treated as timestamps? */
  isTimeChannel?: Maybe<Scalars['Boolean']['output']>;
  /** Display unit of channel values (e.g. m/s) */
  unit?: Maybe<Scalars['String']['output']>;
};

export type SimResultDataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  /** Sampling rate of the channel in Hz, if overriding `defaultChannelTime` without `channelTime` */
  channelSamplingRate?: InputMaybe<Scalars['Float']['input']>;
  /** Use this to override `defaultChannelTime` */
  channelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Actual channel data values */
  channelValue?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  interpolationMethod?: InputMaybe<EnumSimResultDataInterpolationMethod>;
  /** Should values in this channel be treated as timestamps? */
  isTimeChannel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display unit of channel values (e.g. m/s) */
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type SimResultPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SimResult>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SimulationDriveFile = {
  _id: Scalars['MongoID']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EnumSimulationDriveFileStatus>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  userEnumType?: Maybe<UserEnum>;
  userEnumTypeID?: Maybe<Scalars['MongoID']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type SimulationDriveFilePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SimulationDriveFile>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SingleTyreMileageAtSessionStart = {
  sessions?: Maybe<Array<Maybe<TyreMileageAtSessionStartData>>>;
  tyreID?: Maybe<Scalars['MongoID']['output']>;
};

export type SkidPlate = {
  _id: Scalars['MongoID']['output'];
  barcodeRegulation?: Maybe<Scalars['String']['output']>;
  initialThickness?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
};

/** List of items with pagination. */
export type SkidPlatePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SkidPlate>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SomeAdjustableProperty = AdjustableAccelerationProperty | AdjustableAngleProperty | AdjustableAngularComplianceProperty | AdjustableAngularTorqueComplianceProperty | AdjustableBooleanProperty | AdjustableComplianceProperty | AdjustableForceProperty | AdjustableInertiaProperty | AdjustableLengthProperty | AdjustableLocationProperty | AdjustableMassProperty | AdjustableNumberProperty | AdjustableOrientationProperty | AdjustablePowerProperty | AdjustablePressureProperty | AdjustableRatioProperty | AdjustableSpringRateProperty | AdjustableSteeringRackRatioProperty | AdjustableStringProperty | AdjustableTemperatureProperty | AdjustableTorqueProperty | AdjustableTorsionRateProperty | AdjustableVolumeProperty;

export const SortFindManyAssemblyInput = {
  CARSETUPID_ASC: 'CARSETUPID_ASC',
  CARSETUPID_DESC: 'CARSETUPID_DESC',
  CHASSISPARTID_ASC: 'CHASSISPARTID_ASC',
  CHASSISPARTID_DESC: 'CHASSISPARTID_DESC',
  CHASSISSPECID_ASC: 'CHASSISSPECID_ASC',
  CHASSISSPECID_DESC: 'CHASSISSPECID_DESC',
  CREATEDAT_ASC: 'CREATEDAT_ASC',
  CREATEDAT_DESC: 'CREATEDAT_DESC',
  CURRENT_ASC: 'CURRENT_ASC',
  CURRENT_DESC: 'CURRENT_DESC',
  DECOMMISSIONED_ASC: 'DECOMMISSIONED_ASC',
  DECOMMISSIONED_DESC: 'DECOMMISSIONED_DESC',
  LOCATIONID_ASC: 'LOCATIONID_ASC',
  LOCATIONID_DESC: 'LOCATIONID_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  NESTEDPARTINSTANCEIDS_ASC: 'NESTEDPARTINSTANCEIDS_ASC',
  NESTEDPARTINSTANCEIDS_DESC: 'NESTEDPARTINSTANCEIDS_DESC',
  PARENTID_ASC: 'PARENTID_ASC',
  PARENTID_DESC: 'PARENTID_DESC',
  PARTINSTANCEIDS_ASC: 'PARTINSTANCEIDS_ASC',
  PARTINSTANCEIDS_DESC: 'PARTINSTANCEIDS_DESC',
  REFERENCE_ASC: 'REFERENCE_ASC',
  REFERENCE_DESC: 'REFERENCE_DESC',
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyAssemblyInput = typeof SortFindManyAssemblyInput[keyof typeof SortFindManyAssemblyInput];
export const SortFindManyAssemblyTemplateInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyAssemblyTemplateInput = typeof SortFindManyAssemblyTemplateInput[keyof typeof SortFindManyAssemblyTemplateInput];
export const SortFindManyBestValuesInput = {
  CONTESTANTID_ASC: 'CONTESTANTID_ASC',
  CONTESTANTID_DESC: 'CONTESTANTID_DESC',
  DRIVERID_ASC: 'DRIVERID_ASC',
  DRIVERID_DESC: 'DRIVERID_DESC',
  SESSIONID_ASC: 'SESSIONID_ASC',
  SESSIONID_DESC: 'SESSIONID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyBestValuesInput = typeof SortFindManyBestValuesInput[keyof typeof SortFindManyBestValuesInput];
export const SortFindManyBopInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  SESSIONID_ASC: 'SESSIONID_ASC',
  SESSIONID_DESC: 'SESSIONID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyBopInput = typeof SortFindManyBopInput[keyof typeof SortFindManyBopInput];
export const SortFindManyBuildSheetStyleInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyBuildSheetStyleInput = typeof SortFindManyBuildSheetStyleInput[keyof typeof SortFindManyBuildSheetStyleInput];
export const SortFindManyCalculationInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyCalculationInput = typeof SortFindManyCalculationInput[keyof typeof SortFindManyCalculationInput];
export const SortFindManyCarDataServiceConfigInput = {
  ACTIVE_ASC: 'ACTIVE_ASC',
  ACTIVE_DESC: 'ACTIVE_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  RACESERIESID_ASC: 'RACESERIESID_ASC',
  RACESERIESID_DESC: 'RACESERIESID_DESC',
  VERSION_ASC: 'VERSION_ASC',
  VERSION_DESC: 'VERSION_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyCarDataServiceConfigInput = typeof SortFindManyCarDataServiceConfigInput[keyof typeof SortFindManyCarDataServiceConfigInput];
export const SortFindManyCarSetupInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  CHASSISASSEMBLYID_ASC: 'CHASSISASSEMBLYID_ASC',
  CHASSISASSEMBLYID_DESC: 'CHASSISASSEMBLYID_DESC',
  CHASSISID_ASC: 'CHASSISID_ASC',
  CHASSISID_DESC: 'CHASSISID_DESC',
  CHASSISSPECID_ASC: 'CHASSISSPECID_ASC',
  CHASSISSPECID_DESC: 'CHASSISSPECID_DESC',
  CHASSISSPECROOTID_ASC: 'CHASSISSPECROOTID_ASC',
  CHASSISSPECROOTID_DESC: 'CHASSISSPECROOTID_DESC',
  DRIVERID_ASC: 'DRIVERID_ASC',
  DRIVERID_DESC: 'DRIVERID_DESC',
  ENGINEERID_ASC: 'ENGINEERID_ASC',
  ENGINEERID_DESC: 'ENGINEERID_DESC',
  RUNSHEETID_ASC: 'RUNSHEETID_ASC',
  RUNSHEETID_DESC: 'RUNSHEETID_DESC',
  TEAMID_ASC: 'TEAMID_ASC',
  TEAMID_DESC: 'TEAMID_DESC',
  TIME_ASC: 'TIME_ASC',
  TIME_DESC: 'TIME_DESC',
  TITLE_ASC: 'TITLE_ASC',
  TITLE_DESC: 'TITLE_DESC',
  TYRESETID_ASC: 'TYRESETID_ASC',
  TYRESETID_DESC: 'TYRESETID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyCarSetupInput = typeof SortFindManyCarSetupInput[keyof typeof SortFindManyCarSetupInput];
export const SortFindManyChassisInput = {
  MANUFACTURERPARTID_ASC: 'MANUFACTURERPARTID_ASC',
  MANUFACTURERPARTID_DESC: 'MANUFACTURERPARTID_DESC',
  ROOTSPECIFICATIONID_ASC: 'ROOTSPECIFICATIONID_ASC',
  ROOTSPECIFICATIONID_DESC: 'ROOTSPECIFICATIONID_DESC',
  SETUPSHEETSTYLE_ASC: 'SETUPSHEETSTYLE_ASC',
  SETUPSHEETSTYLE_DESC: 'SETUPSHEETSTYLE_DESC',
  SPECIFICATIONID_ASC: 'SPECIFICATIONID_ASC',
  SPECIFICATIONID_DESC: 'SPECIFICATIONID_DESC',
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyChassisInput = typeof SortFindManyChassisInput[keyof typeof SortFindManyChassisInput];
export const SortFindManyChassisMeasurementInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyChassisMeasurementInput = typeof SortFindManyChassisMeasurementInput[keyof typeof SortFindManyChassisMeasurementInput];
export const SortFindManyContestantInput = {
  CHASSISNUMBER_ASC: 'CHASSISNUMBER_ASC',
  CHASSISNUMBER_DESC: 'CHASSISNUMBER_DESC',
  CLASS_ASC: 'CLASS_ASC',
  CLASS_DESC: 'CLASS_DESC',
  ELIGIBLEFORPOINTS_ASC: 'ELIGIBLEFORPOINTS_ASC',
  ELIGIBLEFORPOINTS_DESC: 'ELIGIBLEFORPOINTS_DESC',
  HIDDEN_ASC: 'HIDDEN_ASC',
  HIDDEN_DESC: 'HIDDEN_DESC',
  SEASONID_ASC: 'SEASONID_ASC',
  SEASONID_DESC: 'SEASONID_DESC',
  SEASONID__STARTNUMBER_ASC: 'SEASONID__STARTNUMBER_ASC',
  SEASONID__STARTNUMBER_DESC: 'SEASONID__STARTNUMBER_DESC',
  STARTNUMBER_ASC: 'STARTNUMBER_ASC',
  STARTNUMBER_DESC: 'STARTNUMBER_DESC',
  TEAMID_ASC: 'TEAMID_ASC',
  TEAMID_DESC: 'TEAMID_DESC',
  THIRDPARTYCONTESTANTID_ASC: 'THIRDPARTYCONTESTANTID_ASC',
  THIRDPARTYCONTESTANTID_DESC: 'THIRDPARTYCONTESTANTID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyContestantInput = typeof SortFindManyContestantInput[keyof typeof SortFindManyContestantInput];
export const SortFindManyDepartmentInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyDepartmentInput = typeof SortFindManyDepartmentInput[keyof typeof SortFindManyDepartmentInput];
export const SortFindManyDynoConfigInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyDynoConfigInput = typeof SortFindManyDynoConfigInput[keyof typeof SortFindManyDynoConfigInput];
export const SortFindManyEventInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  SEASONID_ASC: 'SEASONID_ASC',
  SEASONID_DESC: 'SEASONID_DESC',
  TEVENTEND_ASC: 'TEVENTEND_ASC',
  TEVENTEND_DESC: 'TEVENTEND_DESC',
  TEVENTSTART_ASC: 'TEVENTSTART_ASC',
  TEVENTSTART_DESC: 'TEVENTSTART_DESC',
  THIRDPARTYEVENTID_ASC: 'THIRDPARTYEVENTID_ASC',
  THIRDPARTYEVENTID_DESC: 'THIRDPARTYEVENTID_DESC',
  TLAPAVERAGE_ASC: 'TLAPAVERAGE_ASC',
  TLAPAVERAGE_DESC: 'TLAPAVERAGE_DESC',
  TRACKID_ASC: 'TRACKID_ASC',
  TRACKID_DESC: 'TRACKID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyEventInput = typeof SortFindManyEventInput[keyof typeof SortFindManyEventInput];
export const SortFindManyFlexLayoutConfigInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyFlexLayoutConfigInput = typeof SortFindManyFlexLayoutConfigInput[keyof typeof SortFindManyFlexLayoutConfigInput];
export const SortFindManyIssueQueryInput = {
  AREA_ASC: 'AREA_ASC',
  AREA_DESC: 'AREA_DESC',
  ASSIGNEEIDS_ASC: 'ASSIGNEEIDS_ASC',
  ASSIGNEEIDS_DESC: 'ASSIGNEEIDS_DESC',
  CATEGORY_ASC: 'CATEGORY_ASC',
  CATEGORY_DESC: 'CATEGORY_DESC',
  CREATEDAT_ASC: 'CREATEDAT_ASC',
  CREATEDAT_DESC: 'CREATEDAT_DESC',
  CREATED_BY_NAME_ASC: 'CREATED_BY_NAME_ASC',
  CREATED_BY_NAME_DESC: 'CREATED_BY_NAME_DESC',
  DEPARTMENT_NAME_ASC: 'DEPARTMENT_NAME_ASC',
  DEPARTMENT_NAME_DESC: 'DEPARTMENT_NAME_DESC',
  DESCRIPTION_ASC: 'DESCRIPTION_ASC',
  DESCRIPTION_DESC: 'DESCRIPTION_DESC',
  INDEX_ASC: 'INDEX_ASC',
  INDEX_DESC: 'INDEX_DESC',
  ISSUESTATUS_ASC: 'ISSUESTATUS_ASC',
  ISSUESTATUS_DESC: 'ISSUESTATUS_DESC',
  NUMBER_ASC: 'NUMBER_ASC',
  NUMBER_DESC: 'NUMBER_DESC',
  PRIMARYTAGID_ASC: 'PRIMARYTAGID_ASC',
  PRIMARYTAGID_DESC: 'PRIMARYTAGID_DESC',
  PRIMARYTAGLABELSORT_ASC: 'PRIMARYTAGLABELSORT_ASC',
  PRIMARYTAGLABELSORT_DESC: 'PRIMARYTAGLABELSORT_DESC',
  PRIMARY_ASSIGNEE_NAME_ASC: 'PRIMARY_ASSIGNEE_NAME_ASC',
  PRIMARY_ASSIGNEE_NAME_DESC: 'PRIMARY_ASSIGNEE_NAME_DESC',
  PRIMARY_TAG_LABEL_ASC: 'PRIMARY_TAG_LABEL_ASC',
  PRIMARY_TAG_LABEL_DESC: 'PRIMARY_TAG_LABEL_DESC',
  PRIMARY_TEAM_NAME_ASC: 'PRIMARY_TEAM_NAME_ASC',
  PRIMARY_TEAM_NAME_DESC: 'PRIMARY_TEAM_NAME_DESC',
  PRIORITY_ASC: 'PRIORITY_ASC',
  PRIORITY_DESC: 'PRIORITY_DESC',
  RUNSHEETID_ASC: 'RUNSHEETID_ASC',
  RUNSHEETID_DESC: 'RUNSHEETID_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyIssueQueryInput = typeof SortFindManyIssueQueryInput[keyof typeof SortFindManyIssueQueryInput];
export const SortFindManyJobInput = {
  ASSIGNEEIDS_ASC: 'ASSIGNEEIDS_ASC',
  ASSIGNEEIDS_DESC: 'ASSIGNEEIDS_DESC',
  CATEGORY_ASC: 'CATEGORY_ASC',
  CATEGORY_DESC: 'CATEGORY_DESC',
  DESCRIPTION_ASC: 'DESCRIPTION_ASC',
  DESCRIPTION_DESC: 'DESCRIPTION_DESC',
  INDEX_ASC: 'INDEX_ASC',
  INDEX_DESC: 'INDEX_DESC',
  NUMBER_ASC: 'NUMBER_ASC',
  NUMBER_DESC: 'NUMBER_DESC',
  PARENTID_ASC: 'PARENTID_ASC',
  PARENTID_DESC: 'PARENTID_DESC',
  PRIORITY_ASC: 'PRIORITY_ASC',
  PRIORITY_DESC: 'PRIORITY_DESC',
  RUNSHEETID_ASC: 'RUNSHEETID_ASC',
  RUNSHEETID_DESC: 'RUNSHEETID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyJobInput = typeof SortFindManyJobInput[keyof typeof SortFindManyJobInput];
export const SortFindManyLapInput = {
  BLAPCANCELLED_ASC: 'BLAPCANCELLED_ASC',
  BLAPCANCELLED_DESC: 'BLAPCANCELLED_DESC',
  BLAPISSLOW_ASC: 'BLAPISSLOW_ASC',
  BLAPISSLOW_DESC: 'BLAPISSLOW_DESC',
  BPITIN_ASC: 'BPITIN_ASC',
  BPITIN_DESC: 'BPITIN_DESC',
  BPITOUT_ASC: 'BPITOUT_ASC',
  BPITOUT_DESC: 'BPITOUT_DESC',
  CONTESTANTID_ASC: 'CONTESTANTID_ASC',
  CONTESTANTID_DESC: 'CONTESTANTID_DESC',
  NLAPRUNCARDATA_ASC: 'NLAPRUNCARDATA_ASC',
  NLAPRUNCARDATA_DESC: 'NLAPRUNCARDATA_DESC',
  NLAPRUNMANUAL_ASC: 'NLAPRUNMANUAL_ASC',
  NLAPRUNMANUAL_DESC: 'NLAPRUNMANUAL_DESC',
  NLAPRUN_ASC: 'NLAPRUN_ASC',
  NLAPRUN_DESC: 'NLAPRUN_DESC',
  NLAPSESSIONCARDATA_ASC: 'NLAPSESSIONCARDATA_ASC',
  NLAPSESSIONCARDATA_DESC: 'NLAPSESSIONCARDATA_DESC',
  NLAPSESSIONMANUAL_ASC: 'NLAPSESSIONMANUAL_ASC',
  NLAPSESSIONMANUAL_DESC: 'NLAPSESSIONMANUAL_DESC',
  NLAPSESSION_ASC: 'NLAPSESSION_ASC',
  NLAPSESSION_DESC: 'NLAPSESSION_DESC',
  NLAPSTINTCARDATA_ASC: 'NLAPSTINTCARDATA_ASC',
  NLAPSTINTCARDATA_DESC: 'NLAPSTINTCARDATA_DESC',
  NLAPSTINTMANUAL_ASC: 'NLAPSTINTMANUAL_ASC',
  NLAPSTINTMANUAL_DESC: 'NLAPSTINTMANUAL_DESC',
  NLAPSTINT_ASC: 'NLAPSTINT_ASC',
  NLAPSTINT_DESC: 'NLAPSTINT_DESC',
  RUNSHEETID_ASC: 'RUNSHEETID_ASC',
  RUNSHEETID_DESC: 'RUNSHEETID_DESC',
  SESSIONID_ASC: 'SESSIONID_ASC',
  SESSIONID_DESC: 'SESSIONID_DESC',
  TDAY_ASC: 'TDAY_ASC',
  TDAY_DESC: 'TDAY_DESC',
  TLAPMANUAL_ASC: 'TLAPMANUAL_ASC',
  TLAPMANUAL_DESC: 'TLAPMANUAL_DESC',
  TLAPMAX_ASC: 'TLAPMAX_ASC',
  TLAPMAX_DESC: 'TLAPMAX_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyLapInput = typeof SortFindManyLapInput[keyof typeof SortFindManyLapInput];
export const SortFindManyLapSequenceInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyLapSequenceInput = typeof SortFindManyLapSequenceInput[keyof typeof SortFindManyLapSequenceInput];
export const SortFindManyLapSequenceTemplateInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyLapSequenceTemplateInput = typeof SortFindManyLapSequenceTemplateInput[keyof typeof SortFindManyLapSequenceTemplateInput];
export const SortFindManyLocationInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyLocationInput = typeof SortFindManyLocationInput[keyof typeof SortFindManyLocationInput];
export const SortFindManyLogInput = {
  CREATEDAT_ASC: 'CREATEDAT_ASC',
  CREATEDAT_DESC: 'CREATEDAT_DESC',
  LOGLEVEL_ASC: 'LOGLEVEL_ASC',
  LOGLEVEL_DESC: 'LOGLEVEL_DESC',
  SERVICESOURCE_ASC: 'SERVICESOURCE_ASC',
  SERVICESOURCE_DESC: 'SERVICESOURCE_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  USERID_ASC: 'USERID_ASC',
  USERID_DESC: 'USERID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyLogInput = typeof SortFindManyLogInput[keyof typeof SortFindManyLogInput];
export const SortFindManyManufacturerInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyManufacturerInput = typeof SortFindManyManufacturerInput[keyof typeof SortFindManyManufacturerInput];
export const SortFindManyOneTimingWeatherServiceConfigInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyOneTimingWeatherServiceConfigInput = typeof SortFindManyOneTimingWeatherServiceConfigInput[keyof typeof SortFindManyOneTimingWeatherServiceConfigInput];
export const SortFindManyPackageInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyPackageInput = typeof SortFindManyPackageInput[keyof typeof SortFindManyPackageInput];
export const SortFindManyPartInput = {
  CREATEDAT_ASC: 'CREATEDAT_ASC',
  CREATEDAT_DESC: 'CREATEDAT_DESC',
  DESCRIPTION_ASC: 'DESCRIPTION_ASC',
  DESCRIPTION_DESC: 'DESCRIPTION_DESC',
  ELIGIBLEEVENTTYPES_ASC: 'ELIGIBLEEVENTTYPES_ASC',
  ELIGIBLEEVENTTYPES_DESC: 'ELIGIBLEEVENTTYPES_DESC',
  LIFETIMEMILEAGE_ASC: 'LIFETIMEMILEAGE_ASC',
  LIFETIMEMILEAGE_DESC: 'LIFETIMEMILEAGE_DESC',
  LOCATION_NAME_ASC: 'LOCATION_NAME_ASC',
  LOCATION_NAME_DESC: 'LOCATION_NAME_DESC',
  MANUFACTURERPARTID_ASC: 'MANUFACTURERPARTID_ASC',
  MANUFACTURERPARTID_DESC: 'MANUFACTURERPARTID_DESC',
  MANUFACTURERSERIALNUMBER_ASC: 'MANUFACTURERSERIALNUMBER_ASC',
  MANUFACTURERSERIALNUMBER_DESC: 'MANUFACTURERSERIALNUMBER_DESC',
  MANUFACTURER_NAME_ASC: 'MANUFACTURER_NAME_ASC',
  MANUFACTURER_NAME_DESC: 'MANUFACTURER_NAME_DESC',
  PARTNUMBER_ASC: 'PARTNUMBER_ASC',
  PARTNUMBER_DESC: 'PARTNUMBER_DESC',
  REFERENCE_ASC: 'REFERENCE_ASC',
  REFERENCE_DESC: 'REFERENCE_DESC',
  REFERENCE__ROOTSPECIFICATIONID_ASC: 'REFERENCE__ROOTSPECIFICATIONID_ASC',
  REFERENCE__ROOTSPECIFICATIONID_DESC: 'REFERENCE__ROOTSPECIFICATIONID_DESC',
  ROOTSPECIFICATIONID_ASC: 'ROOTSPECIFICATIONID_ASC',
  ROOTSPECIFICATIONID_DESC: 'ROOTSPECIFICATIONID_DESC',
  SPECIFICATIONID_ASC: 'SPECIFICATIONID_ASC',
  SPECIFICATIONID_DESC: 'SPECIFICATIONID_DESC',
  TEAMIDS_ASC: 'TEAMIDS_ASC',
  TEAMIDS_DESC: 'TEAMIDS_DESC',
  TEAMID_ASC: 'TEAMID_ASC',
  TEAMID_DESC: 'TEAMID_DESC',
  TEAM_NAME_ASC: 'TEAM_NAME_ASC',
  TEAM_NAME_DESC: 'TEAM_NAME_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  USERENUMPARTTYPEID_ASC: 'USERENUMPARTTYPEID_ASC',
  USERENUMPARTTYPEID_DESC: 'USERENUMPARTTYPEID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyPartInput = typeof SortFindManyPartInput[keyof typeof SortFindManyPartInput];
export const SortFindManyPartInstanceInput = {
  SPECIFICATIONID_ASC: 'SPECIFICATIONID_ASC',
  SPECIFICATIONID_DESC: 'SPECIFICATIONID_DESC',
  SUPERPARENTID_ASC: 'SUPERPARENTID_ASC',
  SUPERPARENTID_DESC: 'SUPERPARENTID_DESC',
  SUPERPARENTID__SPECIFICATIONID_ASC: 'SUPERPARENTID__SPECIFICATIONID_ASC',
  SUPERPARENTID__SPECIFICATIONID_DESC: 'SUPERPARENTID__SPECIFICATIONID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyPartInstanceInput = typeof SortFindManyPartInstanceInput[keyof typeof SortFindManyPartInstanceInput];
export const SortFindManyPersonInput = {
  ACRONYM_ASC: 'ACRONYM_ASC',
  ACRONYM_DESC: 'ACRONYM_DESC',
  BIRTHDAY_ASC: 'BIRTHDAY_ASC',
  BIRTHDAY_DESC: 'BIRTHDAY_DESC',
  EMAIL_ASC: 'EMAIL_ASC',
  EMAIL_DESC: 'EMAIL_DESC',
  ISACTIVE_ASC: 'ISACTIVE_ASC',
  ISACTIVE_DESC: 'ISACTIVE_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  ROLE_ASC: 'ROLE_ASC',
  ROLE_DESC: 'ROLE_DESC',
  TEAMID_ASC: 'TEAMID_ASC',
  TEAMID_DESC: 'TEAMID_DESC',
  TIMETRACKERAPPROVALBYPERSONID_ASC: 'TIMETRACKERAPPROVALBYPERSONID_ASC',
  TIMETRACKERAPPROVALBYPERSONID_DESC: 'TIMETRACKERAPPROVALBYPERSONID_DESC',
  USERNAME_ASC: 'USERNAME_ASC',
  USERNAME_DESC: 'USERNAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyPersonInput = typeof SortFindManyPersonInput[keyof typeof SortFindManyPersonInput];
export const SortFindManyPlotPageConfigInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  TITLE_ASC: 'TITLE_ASC',
  TITLE_DESC: 'TITLE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyPlotPageConfigInput = typeof SortFindManyPlotPageConfigInput[keyof typeof SortFindManyPlotPageConfigInput];
export const SortFindManyPointsSystemInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyPointsSystemInput = typeof SortFindManyPointsSystemInput[keyof typeof SortFindManyPointsSystemInput];
export const SortFindManyProjectInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyProjectInput = typeof SortFindManyProjectInput[keyof typeof SortFindManyProjectInput];
export const SortFindManyQualityCheckActionInput = {
  ASSIGNEEIDS_ASC: 'ASSIGNEEIDS_ASC',
  ASSIGNEEIDS_DESC: 'ASSIGNEEIDS_DESC',
  CATEGORY_ASC: 'CATEGORY_ASC',
  CATEGORY_DESC: 'CATEGORY_DESC',
  DESCRIPTION_ASC: 'DESCRIPTION_ASC',
  DESCRIPTION_DESC: 'DESCRIPTION_DESC',
  PRIORITY_ASC: 'PRIORITY_ASC',
  PRIORITY_DESC: 'PRIORITY_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyQualityCheckActionInput = typeof SortFindManyQualityCheckActionInput[keyof typeof SortFindManyQualityCheckActionInput];
export const SortFindManyQualityCheckInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyQualityCheckInput = typeof SortFindManyQualityCheckInput[keyof typeof SortFindManyQualityCheckInput];
export const SortFindManyRaceSeriesInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyRaceSeriesInput = typeof SortFindManyRaceSeriesInput[keyof typeof SortFindManyRaceSeriesInput];
export const SortFindManyRadioMessageInput = {
  CONTESTANTID_ASC: 'CONTESTANTID_ASC',
  CONTESTANTID_DESC: 'CONTESTANTID_DESC',
  DRIVERID_ASC: 'DRIVERID_ASC',
  DRIVERID_DESC: 'DRIVERID_DESC',
  SESSIONID_ASC: 'SESSIONID_ASC',
  SESSIONID_DESC: 'SESSIONID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyRadioMessageInput = typeof SortFindManyRadioMessageInput[keyof typeof SortFindManyRadioMessageInput];
export const SortFindManyReportNotesTemplateInput = {
  TITLE_ASC: 'TITLE_ASC',
  TITLE_DESC: 'TITLE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyReportNotesTemplateInput = typeof SortFindManyReportNotesTemplateInput[keyof typeof SortFindManyReportNotesTemplateInput];
export const SortFindManyReportTemplateInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyReportTemplateInput = typeof SortFindManyReportTemplateInput[keyof typeof SortFindManyReportTemplateInput];
export const SortFindManyRunPlanInput = {
  CONTESTANTID_ASC: 'CONTESTANTID_ASC',
  CONTESTANTID_DESC: 'CONTESTANTID_DESC',
  SESSIONID_ASC: 'SESSIONID_ASC',
  SESSIONID_DESC: 'SESSIONID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyRunPlanInput = typeof SortFindManyRunPlanInput[keyof typeof SortFindManyRunPlanInput];
export const SortFindManyRunSheetInput = {
  CONTESTANTID_ASC: 'CONTESTANTID_ASC',
  CONTESTANTID_DESC: 'CONTESTANTID_DESC',
  DRIVERID_ASC: 'DRIVERID_ASC',
  DRIVERID_DESC: 'DRIVERID_DESC',
  ENDTIMECDS_ASC: 'ENDTIMECDS_ASC',
  ENDTIMECDS_DESC: 'ENDTIMECDS_DESC',
  ENDTIMELTS_ASC: 'ENDTIMELTS_ASC',
  ENDTIMELTS_DESC: 'ENDTIMELTS_DESC',
  ENDTIMEMANUAL_ASC: 'ENDTIMEMANUAL_ASC',
  ENDTIMEMANUAL_DESC: 'ENDTIMEMANUAL_DESC',
  ENGINEERID_ASC: 'ENGINEERID_ASC',
  ENGINEERID_DESC: 'ENGINEERID_DESC',
  NEXTRUNSHEETID_ASC: 'NEXTRUNSHEETID_ASC',
  NEXTRUNSHEETID_DESC: 'NEXTRUNSHEETID_DESC',
  NRUNTIMING_ASC: 'NRUNTIMING_ASC',
  NRUNTIMING_DESC: 'NRUNTIMING_DESC',
  NRUN_ASC: 'NRUN_ASC',
  NRUN_DESC: 'NRUN_DESC',
  PREVRUNSHEETID_ASC: 'PREVRUNSHEETID_ASC',
  PREVRUNSHEETID_DESC: 'PREVRUNSHEETID_DESC',
  RUNSHEETSTYLEID_ASC: 'RUNSHEETSTYLEID_ASC',
  RUNSHEETSTYLEID_DESC: 'RUNSHEETSTYLEID_DESC',
  SESSIONID_ASC: 'SESSIONID_ASC',
  SESSIONID_DESC: 'SESSIONID_DESC',
  SETUPID_ASC: 'SETUPID_ASC',
  SETUPID_DESC: 'SETUPID_DESC',
  SIMRESULTIDS_ASC: 'SIMRESULTIDS_ASC',
  SIMRESULTIDS_DESC: 'SIMRESULTIDS_DESC',
  STARTTIMECDS_ASC: 'STARTTIMECDS_ASC',
  STARTTIMECDS_DESC: 'STARTTIMECDS_DESC',
  STARTTIMELTS_ASC: 'STARTTIMELTS_ASC',
  STARTTIMELTS_DESC: 'STARTTIMELTS_DESC',
  STARTTIMEMANUAL_ASC: 'STARTTIMEMANUAL_ASC',
  STARTTIMEMANUAL_DESC: 'STARTTIMEMANUAL_DESC',
  TEAMID_ASC: 'TEAMID_ASC',
  TEAMID_DESC: 'TEAMID_DESC',
  THIRDPARTYRUNID_ASC: 'THIRDPARTYRUNID_ASC',
  THIRDPARTYRUNID_DESC: 'THIRDPARTYRUNID_DESC',
  TYRECOMPOUNDTIMING_ASC: 'TYRECOMPOUNDTIMING_ASC',
  TYRECOMPOUNDTIMING_DESC: 'TYRECOMPOUNDTIMING_DESC',
  TYRESETID_ASC: 'TYRESETID_ASC',
  TYRESETID_DESC: 'TYRESETID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyRunSheetInput = typeof SortFindManyRunSheetInput[keyof typeof SortFindManyRunSheetInput];
export const SortFindManyRunSheetStyleInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyRunSheetStyleInput = typeof SortFindManyRunSheetStyleInput[keyof typeof SortFindManyRunSheetStyleInput];
export const SortFindManySandboxUnitsInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySandboxUnitsInput = typeof SortFindManySandboxUnitsInput[keyof typeof SortFindManySandboxUnitsInput];
export const SortFindManySeasonInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  RACESERIESID_ASC: 'RACESERIESID_ASC',
  RACESERIESID_DESC: 'RACESERIESID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySeasonInput = typeof SortFindManySeasonInput[keyof typeof SortFindManySeasonInput];
export const SortFindManySessionInput = {
  EVENTID_ASC: 'EVENTID_ASC',
  EVENTID_DESC: 'EVENTID_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  SHORTNAME_ASC: 'SHORTNAME_ASC',
  SHORTNAME_DESC: 'SHORTNAME_DESC',
  THIRDPARTYSESSIONID_ASC: 'THIRDPARTYSESSIONID_ASC',
  THIRDPARTYSESSIONID_DESC: 'THIRDPARTYSESSIONID_DESC',
  TRANSCRIBBLESESSIONID_ASC: 'TRANSCRIBBLESESSIONID_ASC',
  TRANSCRIBBLESESSIONID_DESC: 'TRANSCRIBBLESESSIONID_DESC',
  TSESSIONEND_ASC: 'TSESSIONEND_ASC',
  TSESSIONEND_DESC: 'TSESSIONEND_DESC',
  TSESSIONSTART_ASC: 'TSESSIONSTART_ASC',
  TSESSIONSTART_DESC: 'TSESSIONSTART_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySessionInput = typeof SortFindManySessionInput[keyof typeof SortFindManySessionInput];
export const SortFindManySetupOverviewConfigInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  TITLE_ASC: 'TITLE_ASC',
  TITLE_DESC: 'TITLE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySetupOverviewConfigInput = typeof SortFindManySetupOverviewConfigInput[keyof typeof SortFindManySetupOverviewConfigInput];
export const SortFindManySetupSheetStyleInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySetupSheetStyleInput = typeof SortFindManySetupSheetStyleInput[keyof typeof SortFindManySetupSheetStyleInput];
export const SortFindManySimRequestInput = {
  CARSETUPID_ASC: 'CARSETUPID_ASC',
  CARSETUPID_DESC: 'CARSETUPID_DESC',
  CREATEDAT_ASC: 'CREATEDAT_ASC',
  CREATEDAT_DESC: 'CREATEDAT_DESC',
  REQUESTERID_ASC: 'REQUESTERID_ASC',
  REQUESTERID_DESC: 'REQUESTERID_DESC',
  RUNSHEETID_ASC: 'RUNSHEETID_ASC',
  RUNSHEETID_DESC: 'RUNSHEETID_DESC',
  SIMRESULTID_ASC: 'SIMRESULTID_ASC',
  SIMRESULTID_DESC: 'SIMRESULTID_DESC',
  SIMTYPE_ASC: 'SIMTYPE_ASC',
  SIMTYPE_DESC: 'SIMTYPE_DESC',
  SIMULATIONSERVICE_ASC: 'SIMULATIONSERVICE_ASC',
  SIMULATIONSERVICE_DESC: 'SIMULATIONSERVICE_DESC',
  SPECIFICATIONID_ASC: 'SPECIFICATIONID_ASC',
  SPECIFICATIONID_DESC: 'SPECIFICATIONID_DESC',
  TRACKLAYOUTID_ASC: 'TRACKLAYOUTID_ASC',
  TRACKLAYOUTID_DESC: 'TRACKLAYOUTID_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  VERSION_ASC: 'VERSION_ASC',
  VERSION_DESC: 'VERSION_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySimRequestInput = typeof SortFindManySimRequestInput[keyof typeof SortFindManySimRequestInput];
export const SortFindManySimResultInput = {
  CARSETUPID_ASC: 'CARSETUPID_ASC',
  CARSETUPID_DESC: 'CARSETUPID_DESC',
  CREATEDAT_ASC: 'CREATEDAT_ASC',
  CREATEDAT_DESC: 'CREATEDAT_DESC',
  REQUESTERID_ASC: 'REQUESTERID_ASC',
  REQUESTERID_DESC: 'REQUESTERID_DESC',
  RUNSHEETID_ASC: 'RUNSHEETID_ASC',
  RUNSHEETID_DESC: 'RUNSHEETID_DESC',
  SERVICEVERSION_ASC: 'SERVICEVERSION_ASC',
  SERVICEVERSION_DESC: 'SERVICEVERSION_DESC',
  SIMTYPE_ASC: 'SIMTYPE_ASC',
  SIMTYPE_DESC: 'SIMTYPE_DESC',
  SIMULATIONSERVICE_ASC: 'SIMULATIONSERVICE_ASC',
  SIMULATIONSERVICE_DESC: 'SIMULATIONSERVICE_DESC',
  SOURCEREFERENCEID_ASC: 'SOURCEREFERENCEID_ASC',
  SOURCEREFERENCEID_DESC: 'SOURCEREFERENCEID_DESC',
  SOURCE_ASC: 'SOURCE_ASC',
  SOURCE_DESC: 'SOURCE_DESC',
  SPECIFICATIONID_ASC: 'SPECIFICATIONID_ASC',
  SPECIFICATIONID_DESC: 'SPECIFICATIONID_DESC',
  TRACKLAYOUTID_ASC: 'TRACKLAYOUTID_ASC',
  TRACKLAYOUTID_DESC: 'TRACKLAYOUTID_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  VERSION_ASC: 'VERSION_ASC',
  VERSION_DESC: 'VERSION_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySimResultInput = typeof SortFindManySimResultInput[keyof typeof SortFindManySimResultInput];
export const SortFindManySimulationDriveFileInput = {
  STATUS_ASC: 'STATUS_ASC',
  STATUS_DESC: 'STATUS_DESC',
  USERENUMTYPEID_ASC: 'USERENUMTYPEID_ASC',
  USERENUMTYPEID_DESC: 'USERENUMTYPEID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySimulationDriveFileInput = typeof SortFindManySimulationDriveFileInput[keyof typeof SortFindManySimulationDriveFileInput];
export const SortFindManySkidPlateInput = {
  BARCODEREGULATION_ASC: 'BARCODEREGULATION_ASC',
  BARCODEREGULATION_DESC: 'BARCODEREGULATION_DESC',
  INITIALTHICKNESS_ASC: 'INITIALTHICKNESS_ASC',
  INITIALTHICKNESS_DESC: 'INITIALTHICKNESS_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySkidPlateInput = typeof SortFindManySkidPlateInput[keyof typeof SortFindManySkidPlateInput];
export const SortFindManySpecificationInput = {
  ALLOWABLEPARENTSPECIDS_ASC: 'ALLOWABLEPARENTSPECIDS_ASC',
  ALLOWABLEPARENTSPECIDS_DESC: 'ALLOWABLEPARENTSPECIDS_DESC',
  CANOPYVERSION_ASC: 'CANOPYVERSION_ASC',
  CANOPYVERSION_DESC: 'CANOPYVERSION_DESC',
  CHASSISSPECID_ASC: 'CHASSISSPECID_ASC',
  CHASSISSPECID_DESC: 'CHASSISSPECID_DESC',
  ITERATIONIDS_ASC: 'ITERATIONIDS_ASC',
  ITERATIONIDS_DESC: 'ITERATIONIDS_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  NEXTITERATIONID_ASC: 'NEXTITERATIONID_ASC',
  NEXTITERATIONID_DESC: 'NEXTITERATIONID_DESC',
  PREVITERATIONID_ASC: 'PREVITERATIONID_ASC',
  PREVITERATIONID_DESC: 'PREVITERATIONID_DESC',
  ROOTSPECIFICATIONID_ASC: 'ROOTSPECIFICATIONID_ASC',
  ROOTSPECIFICATIONID_DESC: 'ROOTSPECIFICATIONID_DESC',
  SPECIFICATIONGROUPIDS_ASC: 'SPECIFICATIONGROUPIDS_ASC',
  SPECIFICATIONGROUPIDS_DESC: 'SPECIFICATIONGROUPIDS_DESC',
  VERSION_ASC: 'VERSION_ASC',
  VERSION_DESC: 'VERSION_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySpecificationInput = typeof SortFindManySpecificationInput[keyof typeof SortFindManySpecificationInput];
export const SortFindManySsoProviderInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySsoProviderInput = typeof SortFindManySsoProviderInput[keyof typeof SortFindManySsoProviderInput];
export const SortFindManyTagInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTagInput = typeof SortFindManyTagInput[keyof typeof SortFindManyTagInput];
export const SortFindManyTeamInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  RACESERIESID_ASC: 'RACESERIESID_ASC',
  RACESERIESID_DESC: 'RACESERIESID_DESC',
  SHORTNAME_ASC: 'SHORTNAME_ASC',
  SHORTNAME_DESC: 'SHORTNAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTeamInput = typeof SortFindManyTeamInput[keyof typeof SortFindManyTeamInput];
export const SortFindManyTemplateJobListInput = {
  INDEX_ASC: 'INDEX_ASC',
  INDEX_DESC: 'INDEX_DESC',
  TITLE_ASC: 'TITLE_ASC',
  TITLE_DESC: 'TITLE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTemplateJobListInput = typeof SortFindManyTemplateJobListInput[keyof typeof SortFindManyTemplateJobListInput];
export const SortFindManyTemplateSessionDebriefInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTemplateSessionDebriefInput = typeof SortFindManyTemplateSessionDebriefInput[keyof typeof SortFindManyTemplateSessionDebriefInput];
export const SortFindManyTimeSheetEntryInput = {
  PROJECTID_ASC: 'PROJECTID_ASC',
  PROJECTID_DESC: 'PROJECTID_DESC',
  TEND_ASC: 'TEND_ASC',
  TEND_DESC: 'TEND_DESC',
  TSTART_ASC: 'TSTART_ASC',
  TSTART_DESC: 'TSTART_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTimeSheetEntryInput = typeof SortFindManyTimeSheetEntryInput[keyof typeof SortFindManyTimeSheetEntryInput];
export const SortFindManyTimingServiceConfigInput = {
  EVENTID_ASC: 'EVENTID_ASC',
  EVENTID_DESC: 'EVENTID_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTimingServiceConfigInput = typeof SortFindManyTimingServiceConfigInput[keyof typeof SortFindManyTimingServiceConfigInput];
export const SortFindManyTrackInput = {
  ACRONYM_ASC: 'ACRONYM_ASC',
  ACRONYM_DESC: 'ACRONYM_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackInput = typeof SortFindManyTrackInput[keyof typeof SortFindManyTrackInput];
export const SortFindManyTrackLayoutInput = {
  ACRONYM_ASC: 'ACRONYM_ASC',
  ACRONYM_DESC: 'ACRONYM_DESC',
  LAPLENGTHOFFICIAL_ASC: 'LAPLENGTHOFFICIAL_ASC',
  LAPLENGTHOFFICIAL_DESC: 'LAPLENGTHOFFICIAL_DESC',
  TRACKID_ASC: 'TRACKID_ASC',
  TRACKID_DESC: 'TRACKID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackLayoutInput = typeof SortFindManyTrackLayoutInput[keyof typeof SortFindManyTrackLayoutInput];
export const SortFindManyTrackableInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  ROOTSPECIFICATIONID_ASC: 'ROOTSPECIFICATIONID_ASC',
  ROOTSPECIFICATIONID_DESC: 'ROOTSPECIFICATIONID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackableInput = typeof SortFindManyTrackableInput[keyof typeof SortFindManyTrackableInput];
export const SortFindManyTrackingItemInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackingItemInput = typeof SortFindManyTrackingItemInput[keyof typeof SortFindManyTrackingItemInput];
export const SortFindManyTrackingMeasurementInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackingMeasurementInput = typeof SortFindManyTrackingMeasurementInput[keyof typeof SortFindManyTrackingMeasurementInput];
export const SortFindManyTrackingMeasurementRecordInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackingMeasurementRecordInput = typeof SortFindManyTrackingMeasurementRecordInput[keyof typeof SortFindManyTrackingMeasurementRecordInput];
export const SortFindManyTrackingRecordInput = {
  PARTID_ASC: 'PARTID_ASC',
  PARTID_DESC: 'PARTID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackingRecordInput = typeof SortFindManyTrackingRecordInput[keyof typeof SortFindManyTrackingRecordInput];
export const SortFindManyTrackingSourceAliasInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackingSourceAliasInput = typeof SortFindManyTrackingSourceAliasInput[keyof typeof SortFindManyTrackingSourceAliasInput];
export const SortFindManyTrackingSourceInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackingSourceInput = typeof SortFindManyTrackingSourceInput[keyof typeof SortFindManyTrackingSourceInput];
export const SortFindManyTyreInput = {
  ADDITIONALSORTPROPERTY_ASC: 'ADDITIONALSORTPROPERTY_ASC',
  ADDITIONALSORTPROPERTY_DESC: 'ADDITIONALSORTPROPERTY_DESC',
  BARCODEMANUFACTURER_ASC: 'BARCODEMANUFACTURER_ASC',
  BARCODEMANUFACTURER_DESC: 'BARCODEMANUFACTURER_DESC',
  BARCODEREGULATION_ASC: 'BARCODEREGULATION_ASC',
  BARCODEREGULATION_DESC: 'BARCODEREGULATION_DESC',
  BARCODERIM_ASC: 'BARCODERIM_ASC',
  BARCODERIM_DESC: 'BARCODERIM_DESC',
  BARCODETPMS_ASC: 'BARCODETPMS_ASC',
  BARCODETPMS_DESC: 'BARCODETPMS_DESC',
  BATTERYTPMS_ASC: 'BATTERYTPMS_ASC',
  BATTERYTPMS_DESC: 'BATTERYTPMS_DESC',
  COMPOUND_ASC: 'COMPOUND_ASC',
  COMPOUND_DESC: 'COMPOUND_DESC',
  MANUFACTURER_ASC: 'MANUFACTURER_ASC',
  MANUFACTURER_DESC: 'MANUFACTURER_DESC',
  MTYRE_ASC: 'MTYRE_ASC',
  MTYRE_DESC: 'MTYRE_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  SEASONID_ASC: 'SEASONID_ASC',
  SEASONID_DESC: 'SEASONID_DESC',
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTyreInput = typeof SortFindManyTyreInput[keyof typeof SortFindManyTyreInput];
export const SortFindManyTyreSetInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  NUMBER_ASC: 'NUMBER_ASC',
  NUMBER_DESC: 'NUMBER_DESC',
  TYREIDFL_ASC: 'TYREIDFL_ASC',
  TYREIDFL_DESC: 'TYREIDFL_DESC',
  TYREIDFR_ASC: 'TYREIDFR_ASC',
  TYREIDFR_DESC: 'TYREIDFR_DESC',
  TYREIDRL_ASC: 'TYREIDRL_ASC',
  TYREIDRL_DESC: 'TYREIDRL_DESC',
  TYREIDRR_ASC: 'TYREIDRR_ASC',
  TYREIDRR_DESC: 'TYREIDRR_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTyreSetInput = typeof SortFindManyTyreSetInput[keyof typeof SortFindManyTyreSetInput];
export const SortFindManyTyreWearInput = {
  DATE_ASC: 'DATE_ASC',
  DATE_DESC: 'DATE_DESC',
  TYREID_ASC: 'TYREID_ASC',
  TYREID_DESC: 'TYREID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTyreWearInput = typeof SortFindManyTyreWearInput[keyof typeof SortFindManyTyreWearInput];
export const SortFindManyUserEnumInput = {
  ACTIVE_ASC: 'ACTIVE_ASC',
  ACTIVE_DESC: 'ACTIVE_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyUserEnumInput = typeof SortFindManyUserEnumInput[keyof typeof SortFindManyUserEnumInput];
export const SortFindManyWeatherInput = {
  EVENTIDS_ASC: 'EVENTIDS_ASC',
  EVENTIDS_DESC: 'EVENTIDS_DESC',
  SOURCE_ASC: 'SOURCE_ASC',
  SOURCE_DESC: 'SOURCE_DESC',
  TIME_ASC: 'TIME_ASC',
  TIME_DESC: 'TIME_DESC',
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyWeatherInput = typeof SortFindManyWeatherInput[keyof typeof SortFindManyWeatherInput];
export const SortFindManyWeatherServiceConfigInput = {
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyWeatherServiceConfigInput = typeof SortFindManyWeatherServiceConfigInput[keyof typeof SortFindManyWeatherServiceConfigInput];
export const SortFindOneReportNoteInput = {
  EVENTID_ASC: 'EVENTID_ASC',
  EVENTID_DESC: 'EVENTID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindOneReportNoteInput = typeof SortFindOneReportNoteInput[keyof typeof SortFindOneReportNoteInput];
export type Specification = AeroElementSpec | AeroPackageSpec | AntiRollBarSpec | ChassisSpec | CustomSpec | DamperSpec | DifferentialSpec | ElasticSpec | GearBoxSpec | GearSpec | KinematicsExternalSpec | KinematicsInternalSpec;

export type SpecificationACamber = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  readingsRequired?: Maybe<EnumSpecificationACamberReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumSpecificationACamberUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type SpecificationACamberInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  readingsRequired?: InputMaybe<EnumSpecificationACamberReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpecificationACamberUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type SpecificationAdmin = {
  CxT?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  CzF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  CzR?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  FSpringSetup?: Maybe<AdjustableForce>;
  _id: Scalars['MongoID']['output'];
  aCamber?: Maybe<SpecificationACamber>;
  aCaster?: Maybe<SpecificationACamber>;
  aCasterMeasurementGain?: Maybe<Scalars['Float']['output']>;
  aCasterMeasurementOffset?: Maybe<Scalars['Float']['output']>;
  aToe?: Maybe<SpecificationACamber>;
  adjustableProperties?: Maybe<Array<Maybe<AdjustableProperty>>>;
  aeroElementInterpolationMethod?: Maybe<EnumSpecificationAdminAeroElementInterpolationMethod>;
  aeroElementSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  aeroElementType?: Maybe<EnumSpecificationAdminAeroElementType>;
  aeroPackageSpecID?: Maybe<Scalars['MongoID']['output']>;
  aeroPackageSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Names of sockets that this can be plugged in to. */
  allowableSockets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  antiRollBarConfigs?: Maybe<Array<Maybe<AntiRollBarConfig>>>;
  antiRollBarDisplayLocation?: Maybe<EnumSpecificationAdminAntiRollBarDisplayLocation>;
  antiRollBarSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: Maybe<Array<Maybe<AssignedGear>>>;
  attachable?: Maybe<Scalars['Boolean']['output']>;
  axle?: Maybe<EnumSpecificationAdminAxle>;
  bevelSetSpecID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  bumpRubberReference?: Maybe<EnumSpecificationAdminBumpRubberReference>;
  bumpRubberSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  bumpStopGapMethod?: Maybe<EnumSpecificationAdminBumpStopGapMethod>;
  calculationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: Maybe<Scalars['String']['output']>;
  chassisMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: Maybe<Scalars['Boolean']['output']>;
  copyReferencePackageID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customSimulationModels?: Maybe<Array<Maybe<SpecificationCustomSimulationModels>>>;
  customSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  customSpecType?: Maybe<Scalars['String']['output']>;
  customTables?: Maybe<Array<Maybe<SpecificationCustomTables>>>;
  damperAdjusters?: Maybe<Array<Maybe<DamperAdjuster>>>;
  damperConfigs?: Maybe<Array<Maybe<DamperConfig>>>;
  damperSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  differentialConfigs?: Maybe<Array<Maybe<DifferentialConfig>>>;
  differentialSpecID?: Maybe<Scalars['MongoID']['output']>;
  drawingNumber?: Maybe<Scalars['String']['output']>;
  dropGearSpecID?: Maybe<Scalars['MongoID']['output']>;
  elasticType?: Maybe<EnumSpecificationAdminElasticType>;
  forceTable?: Maybe<ForceTable>;
  gearType?: Maybe<EnumSpecificationAdminGearType>;
  hRide?: Maybe<SpecificationHRide>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  headGearSpecID?: Maybe<Scalars['MongoID']['output']>;
  helperSpringSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** If true, this gear is the head gear of the gear box, applies to standard gears only */
  isHeadGear?: Maybe<Scalars['Boolean']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Spring constant of the elastic element. */
  kSpring?: Maybe<Scalars['Float']['output']>;
  kinematicsExternalModels?: Maybe<Array<Maybe<KinematicsExternalModel>>>;
  kinematicsExternalSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  kinematicsInternalSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  manufacturerID?: Maybe<Scalars['MongoID']['output']>;
  manufacturerReference?: Maybe<Scalars['String']['output']>;
  mass?: Maybe<ChassisMass>;
  massProperties?: Maybe<MassProperties>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: Maybe<ChassisMeasurements>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: Maybe<Array<Maybe<EnumSpecificationAdminModelTypes>>>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  polyCxT?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  polyCzF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  polyCzR?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  positionNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  positions?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  powerUnits?: Maybe<Array<Maybe<ChassisPowerUnit>>>;
  powertrain?: Maybe<ChassisPowertrain>;
  powertrainLocation?: Maybe<EnumSpecificationAdminPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  rBrakeBias?: Maybe<AdjustableRatio>;
  /** Position of the specification on the car */
  readingsAllowable?: Maybe<Array<Maybe<EnumSpecificationAdminReadingsAllowable>>>;
  readingsRequired?: Maybe<EnumSpecificationAdminReadingsRequired>;
  reboundSpringSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  reference?: Maybe<Scalars['String']['output']>;
  regulationSets?: Maybe<Array<Maybe<RegulationSet>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: Maybe<Scalars['Date']['output']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  setupChangesFilter?: Maybe<SpecificationSetupChangesFilter>;
  setupSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: Maybe<Scalars['MongoID']['output']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: Maybe<Scalars['MongoID']['output']>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  /** Locations/areas that components can be installed in. */
  sockets?: Maybe<Array<Maybe<ChassisSocket>>>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  specificationGroupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  springReference?: Maybe<EnumSpecificationAdminSpringReference>;
  springSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  torsionBarSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingSourceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  type: EnumSpecificationAdminType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** User-supplied version of this specification. */
  version?: Maybe<Scalars['String']['output']>;
  xBumpRubberRef?: Maybe<Scalars['Float']['output']>;
  xBumpRubberSetup?: Maybe<AdjustableLength>;
  xBumpStopGapDefault?: Maybe<Scalars['Float']['output']>;
  xDamperDroopDefault?: Maybe<Scalars['Float']['output']>;
  xDamperSetupDefault?: Maybe<Scalars['Float']['output']>;
  xDroopStopGapDefault?: Maybe<Scalars['Float']['output']>;
  /** Length of the elastic element under no force */
  xFree?: Maybe<Scalars['Float']['output']>;
  xShaftDroopDefault?: Maybe<Scalars['Float']['output']>;
  xSpringPlatformOffset?: Maybe<Scalars['Float']['output']>;
  xSpringRef?: Maybe<Scalars['Float']['output']>;
  xSpringSetup?: Maybe<AdjustableLength>;
  xToe?: Maybe<SpecificationHRide>;
};

export type SpecificationCustomSimulationModels = {
  data?: Maybe<Scalars['JSON']['output']>;
  dataMapping?: Maybe<EnumSpecificationCustomSimulationModelsDataMapping>;
  endPoint?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  serverPort?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SpecificationCustomSimulationModelsInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  dataMapping?: InputMaybe<EnumSpecificationCustomSimulationModelsDataMapping>;
  endPoint?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  serverPort?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type SpecificationCustomTables = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Table>;
};

export type SpecificationCustomTablesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<TableInput>;
};

export type SpecificationGroup = {
  _id: Scalars['MongoID']['output'];
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  specificationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  specifications: Array<BaseSpecification>;
};

export type SpecificationHRide = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  readingsRequired?: Maybe<EnumSpecificationHRideReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumSpecificationHRideUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type SpecificationHRideInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  readingsRequired?: InputMaybe<EnumSpecificationHRideReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpecificationHRideUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** List of items with pagination. */
export type SpecificationPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Specification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SpecificationSetupChangesFilter = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** List of setup fields to hide */
  blackListFilter?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of setup fields to show */
  whiteListFilter?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SpecificationSetupChangesFilterInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of setup fields to hide */
  blackListFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** List of setup fields to show */
  whiteListFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Spring = {
  /**
   * Diameter of the spring/torsion bar
   * @deprecated
   */
  dSpring?: Maybe<Scalars['Float']['output']>;
  /**
   * Helper spring constant (SI)
   * @deprecated
   */
  kHelperSpring?: Maybe<Scalars['Float']['output']>;
  /**
   * Helper spring constant (imperial)
   * @deprecated
   */
  kHelperSpringLbsIn?: Maybe<Scalars['Float']['output']>;
  /**
   * Spring constant (SI) - N/m (take care of motion ratio)
   * @deprecated
   */
  kSpring?: Maybe<Scalars['Float']['output']>;
  /**
   * Spring constant (imperial)
   * @deprecated
   */
  kSpringLbsIn?: Maybe<Scalars['Float']['output']>;
  specification?: Maybe<ElasticSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  /**
   * Map of spring travel (xSpring) in mm to spring force (FSpring) in N. Input syntax is array of key-value tuples, like `springForceTable: [["0", 0], ["0.5", 0.1], ["1", 0.2]]`.
   * @deprecated
   */
  springForceTable?: Maybe<Scalars['JSON']['output']>;
  /** Transition gap for double coil spring setups */
  xSecondSpringTransition?: Maybe<Scalars['Float']['output']>;
  /** Spring preload (mm) */
  xSpringPreload?: Maybe<Scalars['Float']['output']>;
};

export type SpringInput = {
  /** Diameter of the spring/torsion bar */
  dSpring?: InputMaybe<Scalars['Float']['input']>;
  /** Helper spring constant (SI) */
  kHelperSpring?: InputMaybe<Scalars['Float']['input']>;
  /** Helper spring constant (imperial) */
  kHelperSpringLbsIn?: InputMaybe<Scalars['Float']['input']>;
  /** Spring constant (SI) - N/m (take care of motion ratio) */
  kSpring?: InputMaybe<Scalars['Float']['input']>;
  /** Spring constant (imperial) */
  kSpringLbsIn?: InputMaybe<Scalars['Float']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Map of spring travel (xSpring) in mm to spring force (FSpring) in N. Input syntax is array of key-value tuples, like `springForceTable: [["0", 0], ["0.5", 0.1], ["1", 0.2]]`. */
  springForceTable?: InputMaybe<Scalars['JSON']['input']>;
  /** Transition gap for double coil spring setups */
  xSecondSpringTransition?: InputMaybe<Scalars['Float']['input']>;
  /** Spring preload (mm) */
  xSpringPreload?: InputMaybe<Scalars['Float']['input']>;
};

export type SpringRate = {
  /** N/m */
  newtonsPerMetre: Scalars['Float']['output'];
  /** N/mm */
  newtonsPerMillimetre: Scalars['Float']['output'];
  /** lb/in */
  poundsPerInch: Scalars['Float']['output'];
};

export type SpringRateInput = {
  /** N/m */
  newtonsPerMetre?: InputMaybe<Scalars['Float']['input']>;
  /** N/mm */
  newtonsPerMillimetre: Scalars['Float']['input'];
  /** lb/in */
  poundsPerInch?: InputMaybe<Scalars['Float']['input']>;
};

export type SpringRateUnitField = {
  unit: EnumSpringRateUnit;
};

export type SsoProvider = {
  _id: Scalars['MongoID']['output'];
  clientID: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  issuerURL: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Steering = {
  rSteerF?: Maybe<Scalars['Float']['output']>;
  steeringArm?: Maybe<Scalars['String']['output']>;
  steeringPinion?: Maybe<Scalars['String']['output']>;
};

export type SteeringInput = {
  rSteerF?: InputMaybe<Scalars['Float']['input']>;
  steeringArm?: InputMaybe<Scalars['String']['input']>;
  steeringPinion?: InputMaybe<Scalars['String']['input']>;
};

export type SteeringRackRatioUnitField = {
  unit: EnumSteeringRackRatioUnit;
};

export type StringUnitField = {
  unit: EnumUntypedUnit;
};

export type SubAssembly = AnyAssembly & AnySubAssembly & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  allPartInstanceActive?: Maybe<Scalars['Boolean']['output']>;
  assemblyTemplateID?: Maybe<Scalars['MongoID']['output']>;
  assemblyTypeEnum?: Maybe<UserEnumAssemblyType>;
  assemblyTypeEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetDisplayLocations: Array<UserEnumBuildSheetGroup>;
  buildSheetGroupEnum?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetGroupEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetNestLevel?: Maybe<Scalars['Float']['output']>;
  carSetup?: Maybe<CarSetup>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Is this the current version of this assembly, or just a historical snapshot? */
  current?: Maybe<Scalars['Boolean']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  /** Location of this assembly referring to a socket. For example, `frontLeft` or `cockpit`. */
  locationID?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  nestedPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  nestedPartInstances: Array<PartInstance>;
  parentID?: Maybe<Scalars['MongoID']['output']>;
  partInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  partInstances: Array<PartInstance>;
  properties?: Maybe<Scalars['JSON']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  subAssemblies: Array<SubAssembly>;
  subAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  superParentName?: Maybe<Scalars['String']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumAssemblyTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type Subscription = {
  assemblyAdded?: Maybe<BaseAssembly>;
  assemblyRemoved?: Maybe<BaseAssembly>;
  assemblyUpdated?: Maybe<BaseAssembly>;
  /** If contestantID or driverID are not supplied, this will *only* watch for overall bests. */
  bestValuesAdded?: Maybe<BestValues>;
  bestValuesUpdated?: Maybe<BestValues>;
  carSetupChangedInSessions?: Maybe<CarSetupChanged>;
  carSetupInfoInSessionsUpdated?: Maybe<CarSetupInfo>;
  carSetupRemoved?: Maybe<CarSetup>;
  carSetupUpdated?: Maybe<CarSetup>;
  eventUpdated?: Maybe<Event>;
  greeboLogCarPositions: Array<CarTrackPosition>;
  greeboLogGPSData: Array<CarGpsDataPoint>;
  greeboLogRawLines: Array<Scalars['String']['output']>;
  jobAdded?: Maybe<Job>;
  jobRemoved?: Maybe<Job>;
  jobUpdated?: Maybe<Job>;
  logAdded?: Maybe<Log>;
  oneTimingWeatherServiceConfigAdded?: Maybe<OneTimingWeatherServiceConfig>;
  oneTimingWeatherServiceConfigRemoved?: Maybe<OneTimingWeatherServiceConfig>;
  oneTimingWeatherServiceConfigUpdated?: Maybe<OneTimingWeatherServiceConfig>;
  partAdded?: Maybe<Part>;
  partInstanceAdded?: Maybe<PartInstance>;
  partInstanceRemoved?: Maybe<PartInstance>;
  partInstanceUpdated?: Maybe<PartInstance>;
  partRemoved?: Maybe<Part>;
  partUpdated?: Maybe<Part>;
  reportNoteUpdated?: Maybe<ReportNote>;
  runPlanAdded?: Maybe<RunPlan>;
  runPlanRemoved?: Maybe<RunPlan>;
  runPlanUpdated?: Maybe<RunPlan>;
  runSheetAdded?: Maybe<RunSheet>;
  runSheetInSessionsAdded?: Maybe<RunSheet>;
  runSheetInSessionsRemoved?: Maybe<RemovedRunSheet>;
  runSheetInSessionsUpdated?: Maybe<RunSheet>;
  runSheetInfoInSessionsUpdated?: Maybe<RunSheetInfo>;
  runSheetRemoved?: Maybe<RemovedRunSheet>;
  runSheetUpdated?: Maybe<RunSheet>;
  sessionUpdated?: Maybe<Session>;
  simRequestAdded?: Maybe<SimRequest>;
  simRequestRemoved?: Maybe<SimRequest>;
  simRequestUpdated?: Maybe<SimRequest>;
  simResultAdded?: Maybe<SimResult>;
  simResultRemoved?: Maybe<SimResult>;
  simResultUpdated?: Maybe<SimResult>;
  timingServiceConfigAdded?: Maybe<TimingServiceConfig>;
  timingServiceConfigRemoved?: Maybe<TimingServiceConfig>;
  timingServiceConfigUpdated?: Maybe<TimingServiceConfig>;
  timingServiceStatusUpdated?: Maybe<TimingServiceStatus>;
  timingsUpdated: Array<DriverTiming>;
  weatherAdded?: Maybe<Weather>;
  weatherRemoved?: Maybe<Weather>;
  weatherServiceConfigUpdated?: Maybe<WeatherServiceConfig>;
  weatherUpdated?: Maybe<Weather>;
};


export type SubscriptionAssemblyAddedArgs = {
  assemblyID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionAssemblyRemovedArgs = {
  assemblyID: Scalars['MongoID']['input'];
};


export type SubscriptionAssemblyUpdatedArgs = {
  assemblyID: Scalars['MongoID']['input'];
};


export type SubscriptionBestValuesAddedArgs = {
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID: Scalars['MongoID']['input'];
};


export type SubscriptionBestValuesUpdatedArgs = {
  bestValuesID: Scalars['MongoID']['input'];
};


export type SubscriptionCarSetupChangedInSessionsArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type SubscriptionCarSetupInfoInSessionsUpdatedArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type SubscriptionCarSetupRemovedArgs = {
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionCarSetupUpdatedArgs = {
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionEventUpdatedArgs = {
  eventID: Scalars['MongoID']['input'];
};


export type SubscriptionGreeboLogCarPositionsArgs = {
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionGreeboLogGpsDataArgs = {
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionGreeboLogRawLinesArgs = {
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionJobAddedArgs = {
  assigneeID?: InputMaybe<Scalars['MongoID']['input']>;
  jobID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionJobRemovedArgs = {
  assigneeID?: InputMaybe<Scalars['MongoID']['input']>;
  jobID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionJobUpdatedArgs = {
  assigneeID?: InputMaybe<Scalars['MongoID']['input']>;
  jobID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionLogAddedArgs = {
  serviceSource?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOneTimingWeatherServiceConfigRemovedArgs = {
  weatherServiceConfigID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionOneTimingWeatherServiceConfigUpdatedArgs = {
  weatherServiceConfigID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionPartAddedArgs = {
  partID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionPartInstanceAddedArgs = {
  partInstanceID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionPartInstanceRemovedArgs = {
  partInstanceID: Scalars['MongoID']['input'];
};


export type SubscriptionPartInstanceUpdatedArgs = {
  partInstanceID: Scalars['MongoID']['input'];
};


export type SubscriptionPartRemovedArgs = {
  partID: Scalars['MongoID']['input'];
};


export type SubscriptionPartUpdatedArgs = {
  partID: Scalars['MongoID']['input'];
};


export type SubscriptionReportNoteUpdatedArgs = {
  eventID: Scalars['MongoID']['input'];
};


export type SubscriptionRunPlanUpdatedArgs = {
  runPlanID: Scalars['MongoID']['input'];
};


export type SubscriptionRunSheetAddedArgs = {
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionRunSheetInSessionsAddedArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type SubscriptionRunSheetInSessionsRemovedArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type SubscriptionRunSheetInSessionsUpdatedArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type SubscriptionRunSheetInfoInSessionsUpdatedArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type SubscriptionRunSheetRemovedArgs = {
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionRunSheetUpdatedArgs = {
  runSheetID: Scalars['MongoID']['input'];
};


export type SubscriptionSessionUpdatedArgs = {
  sessionID: Scalars['MongoID']['input'];
};


export type SubscriptionSimRequestAddedArgs = {
  simRequestID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionSimRequestRemovedArgs = {
  simRequestID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionSimRequestUpdatedArgs = {
  simRequestID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
};


export type SubscriptionSimResultRemovedArgs = {
  simResultID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionSimResultUpdatedArgs = {
  simResultID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
};


export type SubscriptionTimingServiceConfigRemovedArgs = {
  timingServiceConfigID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionTimingServiceConfigUpdatedArgs = {
  timingServiceConfigID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionTimingServiceStatusUpdatedArgs = {
  timingServiceStatusID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionTimingsUpdatedArgs = {
  sessionID: Scalars['MongoID']['input'];
};


export type SubscriptionWeatherServiceConfigUpdatedArgs = {
  weatherServiceConfigID: Scalars['MongoID']['input'];
};


export type SubscriptionWeatherUpdatedArgs = {
  weatherID: Scalars['MongoID']['input'];
};

export type Suspension = {
  /** Camber angle */
  aCamber?: Maybe<Scalars['Float']['output']>;
  /** Camber angle measurement in radians (if `aCamber` should be used as a target) */
  aCamberMeasurement?: Maybe<Scalars['Float']['output']>;
  /** Camber shim angle */
  aCamberShim?: Maybe<Scalars['Float']['output']>;
  /** Caster angle */
  aCaster?: Maybe<Scalars['Float']['output']>;
  /** Caster angle measurement (if direct measurement isn't possible or aCaster should be used as a target) */
  aCasterMeasurement?: Maybe<Scalars['Float']['output']>;
  /** Caster option */
  aCasterOption?: Maybe<Scalars['String']['output']>;
  /** Toe angle */
  aToe?: Maybe<Scalars['Float']['output']>;
  /** Toe angle measurement in radians (if `aToe` should be used as a target) */
  aToeMeasurement?: Maybe<Scalars['Float']['output']>;
  hBumpStopPacker?: Maybe<Scalars['Float']['output']>;
  hBumpStopStack?: Maybe<Scalars['Float']['output']>;
  /** Camber shim height */
  hCamberShim?: Maybe<Scalars['Float']['output']>;
  /** Push rod shim height */
  hPushRodShim?: Maybe<Scalars['Float']['output']>;
  /** Toe link sleeve height to adjust vertical position */
  hToeLinkSleeveBottom?: Maybe<Scalars['Float']['output']>;
  /** Toe link sleeve height to adjust vertical position */
  hToeLinkSleeveTop?: Maybe<Scalars['Float']['output']>;
  /** Toe shim height */
  hToeShim?: Maybe<Scalars['Float']['output']>;
  /** Pushrod-on-upright bracket */
  prouBracket?: Maybe<Scalars['String']['output']>;
  /** Pushrod-on-upright position */
  prouPosition?: Maybe<Scalars['String']['output']>;
  xBumpStopGap?: Maybe<Scalars['Float']['output']>;
  /** Camber angle measurement in metres (if direct angle measurement isn't possible) */
  xCamberMeasurement?: Maybe<Scalars['Float']['output']>;
  xDroopStopGap?: Maybe<Scalars['Float']['output']>;
  /** Toe as measured in metres */
  xToe?: Maybe<Scalars['Float']['output']>;
  /** Toe angle measurement in metres (if direct angle measurement isn't possible) */
  xToeMeasurement?: Maybe<Scalars['Float']['output']>;
};

export type SuspensionInput = {
  /** Camber angle */
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  /** Camber angle measurement in radians (if `aCamber` should be used as a target) */
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  /** Camber shim angle */
  aCamberShim?: InputMaybe<Scalars['Float']['input']>;
  /** Caster angle */
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  /** Caster angle measurement (if direct measurement isn't possible or aCaster should be used as a target) */
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  /** Caster option */
  aCasterOption?: InputMaybe<Scalars['String']['input']>;
  /** Toe angle */
  aToe?: InputMaybe<Scalars['Float']['input']>;
  /** Toe angle measurement in radians (if `aToe` should be used as a target) */
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  hBumpStopPacker?: InputMaybe<Scalars['Float']['input']>;
  hBumpStopStack?: InputMaybe<Scalars['Float']['input']>;
  /** Camber shim height */
  hCamberShim?: InputMaybe<Scalars['Float']['input']>;
  /** Push rod shim height */
  hPushRodShim?: InputMaybe<Scalars['Float']['input']>;
  /** Toe link sleeve height to adjust vertical position */
  hToeLinkSleeveBottom?: InputMaybe<Scalars['Float']['input']>;
  /** Toe link sleeve height to adjust vertical position */
  hToeLinkSleeveTop?: InputMaybe<Scalars['Float']['input']>;
  /** Toe shim height */
  hToeShim?: InputMaybe<Scalars['Float']['input']>;
  /** Pushrod-on-upright bracket */
  prouBracket?: InputMaybe<Scalars['String']['input']>;
  /** Pushrod-on-upright position */
  prouPosition?: InputMaybe<Scalars['String']['input']>;
  xBumpStopGap?: InputMaybe<Scalars['Float']['input']>;
  /** Camber angle measurement in metres (if direct angle measurement isn't possible) */
  xCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  xDroopStopGap?: InputMaybe<Scalars['Float']['input']>;
  /** Toe as measured in metres */
  xToe?: InputMaybe<Scalars['Float']['input']>;
  /** Toe angle measurement in metres (if direct angle measurement isn't possible) */
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type SwapPartInstanceResult = {
  newPartInstanceID: Scalars['MongoID']['output'];
};

export type Table = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  columnNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  columnValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Table data in 1d vector. It's up to the consumer to reshape appropriately. OneRacehub internally uses row chunks. */
  data: Array<Maybe<Scalars['Float']['output']>>;
  decimals?: Maybe<Scalars['Float']['output']>;
  depth?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  rowNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sliceNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sliceValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  width: Scalars['Float']['output'];
};

export type TableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  columnNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  columnValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Table data in 1d vector. It's up to the consumer to reshape appropriately. OneRacehub internally uses row chunks. */
  data: Array<InputMaybe<Scalars['Float']['input']>>;
  decimals?: InputMaybe<Scalars['Float']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  rowNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sliceNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sliceValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  width: Scalars['Float']['input'];
};

export type Tag = {
  _id: Scalars['MongoID']['output'];
  color?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  tagType?: Maybe<EnumTagType>;
};

/** List of items with pagination. */
export type TagPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Tag>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Team = {
  _id: Scalars['MongoID']['output'];
  /** Default color to use for this team where applicable. */
  color?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  raceSeries?: Maybe<RaceSeries>;
  /** Used only for filtering to limit which teams are displayed in a list. */
  raceSeriesID?: Maybe<Scalars['MongoID']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
};

export type TeamChampionshipStanding = {
  contestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  contestants: Array<Contestant>;
  points: Scalars['Int']['output'];
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: Maybe<Scalars['Int']['output']>;
  team?: Maybe<Team>;
  teamDrivers?: Maybe<Array<Maybe<DriverChampionshipStanding>>>;
  teamID: Scalars['MongoID']['output'];
};

export type TeamChampionshipStandingInput = {
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  points: Scalars['Int']['input'];
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: InputMaybe<Scalars['Int']['input']>;
  teamDrivers?: InputMaybe<Array<InputMaybe<DriverChampionshipStandingInput>>>;
  teamID: Scalars['MongoID']['input'];
};

/** List of items with pagination. */
export type TeamPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Team>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Temperature = {
  /** °C */
  celsius: Scalars['Float']['output'];
  /** °F */
  fahrenheit: Scalars['Float']['output'];
  /** °K */
  kelvin: Scalars['Float']['output'];
};

export type TemperatureInput = {
  /** °C */
  celsius?: InputMaybe<Scalars['Float']['input']>;
  /** °F */
  fahrenheit?: InputMaybe<Scalars['Float']['input']>;
  /** °K */
  kelvin?: InputMaybe<Scalars['Float']['input']>;
};

export type TemperatureUnitField = {
  unit: EnumTemperatureUnit;
};

export type TemplateJob = {
  assigneeIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignees: Array<Person>;
  category?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<EnumJobPriority>;
};

export type TemplateJobInput = {
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
};

export type TemplateJobList = {
  _id: Scalars['MongoID']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  jobs: Array<Maybe<TemplateJob>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  title: Scalars['String']['output'];
};

/** List of items with pagination. */
export type TemplateJobListPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TemplateJobList>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TemplateSessionDebrief = {
  _id: Scalars['MongoID']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumTemplateSessionDebriefMode>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** List of items with pagination. */
export type TemplateSessionDebriefPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TemplateSessionDebrief>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ThirdElement = {
  bumpStop?: Maybe<ThirdElementBumpStop>;
  hBumpStopPacker?: Maybe<Scalars['Float']['output']>;
  /** Helper spring constant (SI) */
  kHelperSpring?: Maybe<Scalars['Float']['output']>;
  /** Helper spring constant (imperial) */
  kHelperSpringLbsIn?: Maybe<Scalars['Float']['output']>;
  /** Spring constant (SI) */
  kSpring?: Maybe<Scalars['Float']['output']>;
  /** Spring constant (imperial) */
  kSpringLbsIn?: Maybe<Scalars['Float']['output']>;
  xBumpStopGap?: Maybe<Scalars['Float']['output']>;
  /** Spring preload (mm) */
  xSpringPreload?: Maybe<Scalars['Float']['output']>;
};

export type ThirdElementBumpStop = {
  name?: Maybe<Scalars['String']['output']>;
};

export type ThirdElementBumpStopInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ThirdElementInput = {
  bumpStop?: InputMaybe<ThirdElementBumpStopInput>;
  hBumpStopPacker?: InputMaybe<Scalars['Float']['input']>;
  /** Helper spring constant (SI) */
  kHelperSpring?: InputMaybe<Scalars['Float']['input']>;
  /** Helper spring constant (imperial) */
  kHelperSpringLbsIn?: InputMaybe<Scalars['Float']['input']>;
  /** Spring constant (SI) */
  kSpring?: InputMaybe<Scalars['Float']['input']>;
  /** Spring constant (imperial) */
  kSpringLbsIn?: InputMaybe<Scalars['Float']['input']>;
  xBumpStopGap?: InputMaybe<Scalars['Float']['input']>;
  /** Spring preload (mm) */
  xSpringPreload?: InputMaybe<Scalars['Float']['input']>;
};

export type TimeSheetEntry = {
  _id: Scalars['MongoID']['output'];
  /** Whether a person did work on this day */
  absent?: Maybe<Scalars['Boolean']['output']>;
  approvedAt?: Maybe<Scalars['Date']['output']>;
  approvedBy?: Maybe<Person>;
  approvedByID?: Maybe<Scalars['MongoID']['output']>;
  /** Notes about what was done during this time */
  description?: Maybe<Scalars['String']['output']>;
  person?: Maybe<Person>;
  personID: Scalars['MongoID']['output'];
  project?: Maybe<Project>;
  projectID?: Maybe<Scalars['MongoID']['output']>;
  /** Clock-out time */
  tEnd?: Maybe<Scalars['Date']['output']>;
  /** Clock-in time */
  tStart: Scalars['Date']['output'];
};

/** List of items with pagination. */
export type TimeSheetEntryPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TimeSheetEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TimeUnitField = {
  unit: EnumTimeUnit;
};

export type TimingConfigureResult = {
  success: Scalars['Boolean']['output'];
};

export type TimingServiceConfig = {
  _id: Scalars['MongoID']['output'];
  /** Whether the timingServiceConfig should be considered active by the service */
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** API event ID. This finds the correct event by its _id field. */
  eventID?: Maybe<Scalars['MongoID']['output']>;
  /** Use schedule-based session matching as fallback. */
  fallbackScheduleBasedSessionMatching?: Maybe<Scalars['Boolean']['output']>;
  /** Number of timed sectors on track. Used as fallback in case timing data does not provide it. */
  fallbackTimedSectorsCount?: Maybe<Scalars['Int']['output']>;
  /** Car numbers to follow. */
  followedCarNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Activate live standings to see the driver championship points live. Only working properly if all drivers of a given season are added as contestants. */
  liveStandingsActive?: Maybe<Scalars['Boolean']['output']>;
  logLevel?: Maybe<EnumTimingServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: Maybe<Scalars['Boolean']['output']>;
  mode?: Maybe<EnumTimingServiceConfigMode>;
  /** Name for this set of configuration settings. */
  name: Scalars['String']['output'];
  /** Use string equality to match timing session names in One Racehub. Otherwise default sequence matching is used. */
  strictSessionNameMatching?: Maybe<Scalars['Boolean']['output']>;
  /** One Timing server port. */
  timingPort?: Maybe<Scalars['Int']['output']>;
  /** Race series name to filter on in the timing feed when multiple series are running at an event. */
  timingRaceSeries?: Maybe<Scalars['String']['output']>;
  /** One Timing server address. */
  timingURL?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: Maybe<Scalars['Boolean']['output']>;
};

/** List of items with pagination. */
export type TimingServiceConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TimingServiceConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TimingServiceStatus = {
  _id: Scalars['MongoID']['output'];
  /** List of active timing service configurations. */
  activeConfigs?: Maybe<Array<Maybe<ActiveConfig>>>;
  /** List of failed timing service configurations. */
  failedConfigs?: Maybe<Array<Maybe<FailedConfig>>>;
};

export type TimingServiceStatusInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of active timing service configurations. */
  activeConfigs?: InputMaybe<Array<InputMaybe<ActiveConfigInput>>>;
  /** List of failed timing service configurations. */
  failedConfigs?: InputMaybe<Array<InputMaybe<FailedConfigInput>>>;
};

export type TokenClaims = {
  /** Query JWT claims, giving an error if the token is invalid. */
  claims: Scalars['JSON']['output'];
  /** The currently authenticated person. */
  person: Person;
};

export type Torque = {
  /** Nm */
  newtonMetres: Scalars['Float']['output'];
  /** Nmm */
  newtonMillimetres: Scalars['Float']['output'];
  /** lbf·ft */
  poundForceFeet: Scalars['Float']['output'];
  /** lbf·in */
  poundForceInches: Scalars['Float']['output'];
};

export type TorqueInput = {
  /** Nm */
  newtonMetres?: InputMaybe<Scalars['Float']['input']>;
  /** Nmm */
  newtonMillimetres?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft */
  poundForceFeet?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·in */
  poundForceInches?: InputMaybe<Scalars['Float']['input']>;
};

export type TorqueUnitField = {
  unit: EnumTorqueUnit;
};

export type TorsionRate = {
  /** Nm/° */
  newtonMetresPerDegree: Scalars['Float']['output'];
  /** Nm/rad */
  newtonMetresPerRadian: Scalars['Float']['output'];
  /** lbf·ft/° */
  poundForceFeetPerDegree: Scalars['Float']['output'];
  /** lbf·ft/rad */
  poundForceFeetPerRadian: Scalars['Float']['output'];
  /** lbf-in/° */
  poundForceInchesPerDegree: Scalars['Float']['output'];
  /** lbf-in/rad */
  poundForceInchesPerRadian: Scalars['Float']['output'];
};

export type TorsionRateInput = {
  /** Nm/° */
  newtonMetresPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** Nm/rad */
  newtonMetresPerRadian?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/° */
  poundForceFeetPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/rad */
  poundForceFeetPerRadian?: InputMaybe<Scalars['Float']['input']>;
  /** lbf-in/° */
  poundForceInchesPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** lbf-in/rad */
  poundForceInchesPerRadian?: InputMaybe<Scalars['Float']['input']>;
};

export type TorsionRateUnitField = {
  unit: EnumTorsionRateUnit;
};

export type Track = {
  _id: Scalars['MongoID']['output'];
  acronym?: Maybe<Scalars['String']['output']>;
  /** Track height above sea level. */
  altitude?: Maybe<Scalars['Float']['output']>;
  cameras?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  geoLocation?: Maybe<GeoLocation>;
  /** IDs of the available track layouts */
  layoutIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Available track layouts */
  layouts: Array<TrackLayout>;
  name: Scalars['String']['output'];
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: Maybe<Scalars['String']['output']>;
  trackPicture?: Maybe<AttachedFile>;
  weatherStations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TrackKeyValueEntry = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TrackLabel = {
  alignment: TrackLabelAlignment;
  name: Scalars['String']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export const TrackLabelAlignment = {
  Bottom: 'Bottom',
  BottomLeft: 'BottomLeft',
  BottomRight: 'BottomRight',
  Centered: 'Centered',
  Left: 'Left',
  Right: 'Right',
  Top: 'Top',
  TopLeft: 'TopLeft',
  TopRight: 'TopRight'
} as const;

export type TrackLabelAlignment = typeof TrackLabelAlignment[keyof typeof TrackLabelAlignment];
export type TrackLatLonCoordinate = {
  distance: Scalars['Float']['output'];
  lat: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
  time: Scalars['Float']['output'];
};

export type TrackLayout = {
  ATKModeGain?: Maybe<Scalars['Float']['output']>;
  ATKModeLocation?: Maybe<Scalars['Float']['output']>;
  ATKModePenalty?: Maybe<Scalars['Float']['output']>;
  FCYLapTime?: Maybe<Scalars['Float']['output']>;
  /** Full-course yellow probability */
  FCYProbability?: Maybe<Scalars['Float']['output']>;
  /** Amount of sectors the timing provides */
  NSectorsTiming?: Maybe<Scalars['Float']['output']>;
  SCLapTime?: Maybe<Scalars['Float']['output']>;
  /** Safety car probability */
  SCProbability?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Specify SoC required in event.consumptions instead. */
  SoCRequired?: Maybe<RunEnergy>;
  _id: Scalars['MongoID']['output'];
  acronym?: Maybe<Scalars['String']['output']>;
  bumpiness?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Specify cameras on the parent track object instead. */
  cameras?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code60LapTime?: Maybe<Scalars['Float']['output']>;
  crossoverWetToSlick?: Maybe<Scalars['Float']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  /** @deprecated Specify energy required in event.consumptions instead. */
  energyRequired?: Maybe<RunEnergy>;
  expectedRaceLaps?: Maybe<Scalars['Float']['output']>;
  firstLapOffset?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Specify fuel required in event.consumptions instead. */
  fuelRequired?: Maybe<RunEnergy>;
  inLapTime?: Maybe<Scalars['Float']['output']>;
  lapLengthCarData?: Maybe<Scalars['Float']['output']>;
  lapLengthInLapCarData?: Maybe<Scalars['Float']['output']>;
  lapLengthInLapOfficial?: Maybe<Scalars['Float']['output']>;
  lapLengthInLapRoulette?: Maybe<Scalars['Float']['output']>;
  lapLengthOfficial?: Maybe<Scalars['Float']['output']>;
  lapLengthOutLapCarData?: Maybe<Scalars['Float']['output']>;
  lapLengthOutLapOfficial?: Maybe<Scalars['Float']['output']>;
  lapLengthOutLapRoulette?: Maybe<Scalars['Float']['output']>;
  lapLengthRoulette?: Maybe<Scalars['Float']['output']>;
  lapZero?: Maybe<Scalars['Boolean']['output']>;
  lapsUntilFullRegen?: Maybe<Scalars['Float']['output']>;
  mapElevation?: Maybe<Scalars['String']['output']>;
  mapEmergencyExits?: Maybe<Scalars['String']['output']>;
  mapPitLane?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `mapTrackXyCsv` instead */
  mapTrack?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `mapTrackLatLonCsv` instead */
  mapTrackGPS?: Maybe<Scalars['String']['output']>;
  mapTrackLatLon?: Maybe<MapTrackLatLon>;
  mapTrackLatLonCsv?: Maybe<Scalars['String']['output']>;
  mapTrackXy?: Maybe<MapTrackXy>;
  mapTrackXyCsv?: Maybe<Scalars['String']['output']>;
  /** Name of the Layout */
  name: Scalars['String']['output'];
  outLapTime?: Maybe<Scalars['Float']['output']>;
  overtakingThreshold?: Maybe<Scalars['Float']['output']>;
  /** Whole distance from entry to exit inlcuding approach and leave */
  pitDistance?: Maybe<Scalars['Float']['output']>;
  /** Length of pit lane between the pit lane entry and exit loop (used for mileage calculation of pitlane lap types) */
  pitLength?: Maybe<Scalars['Float']['output']>;
  pitLoss?: Maybe<Scalars['Float']['output']>;
  pitLossDriveThrough?: Maybe<Scalars['Float']['output']>;
  /** Indicates whether the pole position is on the left- or right-hand side */
  polePosition?: Maybe<EnumTrackLayoutPolePosition>;
  prepLapTime?: Maybe<Scalars['Float']['output']>;
  pushLapTime?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use sectorLengths field instead. */
  sectorDistance?: Maybe<Scalars['Float']['output']>;
  sectorLengths?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Downforce sensitivity (seconds per 10pts) */
  sensDownforce?: Maybe<Scalars['Float']['output']>;
  /** Drag sensitivity (seconds per 10pts) */
  sensDrag?: Maybe<Scalars['Float']['output']>;
  sensEP?: Maybe<Scalars['Float']['output']>;
  /** Energy sensitivity (seconds per 0.1kWh) */
  sensEnergy?: Maybe<Scalars['Float']['output']>;
  /** Grip sensitivity (seconds per %) */
  sensGrip?: Maybe<Scalars['Float']['output']>;
  /** Mass sensitivity (seconds per 10kg) */
  sensMass?: Maybe<Scalars['Float']['output']>;
  /** Power sensitivity */
  sensPower?: Maybe<Scalars['Float']['output']>;
  simulationModels?: Maybe<Array<Maybe<TrackLayoutSimulationModel>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  track?: Maybe<Track>;
  trackEvolution?: Maybe<Scalars['Float']['output']>;
  /** ID of the track this layout belongs to */
  trackID: Scalars['MongoID']['output'];
  trackLayoutType?: Maybe<EnumTrackLayoutTrackLayoutType>;
  trackRecordQuali?: Maybe<Scalars['Float']['output']>;
  trackRecordRace?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Specify weatherStations on the parent track object instead. */
  weatherStations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** List of items with pagination. */
export type TrackLayoutPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackLayout>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackLayoutSimulationModel = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  canopyID?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  provider: EnumSimModelType;
  version?: Maybe<Scalars['String']['output']>;
};

export type TrackLayoutSimulationModelInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  canopyID?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  provider: EnumSimModelType;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type TrackPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Track>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackState = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  flag?: Maybe<EnumTrackStateFlag>;
  message?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
};

export type TrackStateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  flag?: InputMaybe<EnumTrackStateFlag>;
  message?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type TrackSvg = {
  height: Scalars['Float']['output'];
  svgPath: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type TrackXyCoordinate = {
  distance: Scalars['Float']['output'];
  time: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type Trackable = {
  _id: Scalars['MongoID']['output'];
  criticalValue?: Maybe<Scalars['Float']['output']>;
  defaultValue?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** ID of the original version of the specifications to track. */
  rootSpecificationID: Scalars['MongoID']['output'];
  unitType?: Maybe<TypedUnitField>;
  /** Comparison to use when checking if the tracked value is in the warning/critical range. */
  warningDirection?: Maybe<EnumTrackableWarningDirection>;
  warningValue?: Maybe<Scalars['Float']['output']>;
};

/** List of items with pagination. */
export type TrackablePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Trackable>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackingEntry = {
  history: Array<TrackingRecord>;
  snapshot?: Maybe<TrackingRecord>;
  trackingItem?: Maybe<TrackingItem>;
  trackingItemID: Scalars['MongoID']['output'];
};

export type TrackingItem = {
  NDecimals?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  arrayElements?: Maybe<Scalars['Float']['output']>;
  criticalCumulativeValue?: Maybe<Scalars['Float']['output']>;
  criticalValue?: Maybe<Scalars['Float']['output']>;
  cumulativeCalculation?: Maybe<Scalars['Boolean']['output']>;
  defaultValue?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayUnit?: Maybe<EnumDisplayUnit>;
  isArray?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  measurementImage?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  operator?: Maybe<EnumTrackingItemOperator>;
  resettable?: Maybe<Scalars['Boolean']['output']>;
  specification?: Maybe<BaseSpecification>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  trackingSource?: Maybe<TrackingSource>;
  trackingSourceID?: Maybe<Scalars['MongoID']['output']>;
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
  warningCumulativeValue?: Maybe<Scalars['Float']['output']>;
  warningValue?: Maybe<Scalars['Float']['output']>;
};

/** List of items with pagination. */
export type TrackingItemPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackingItem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackingMeasurement = {
  _id: Scalars['MongoID']['output'];
  defaultCoordinates?: Maybe<TrackingMeasurementDefaultCoordinates>;
  defaultRotation?: Maybe<TrackingMeasurementDefaultRotation>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  specification?: Maybe<BaseSpecification>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type TrackingMeasurementDefaultCoordinates = {
  /** Coordinate value x */
  x?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value y */
  y?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value z */
  z?: Maybe<Scalars['Float']['output']>;
};

export type TrackingMeasurementDefaultCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackingMeasurementDefaultRotation = {
  /** Rotation value I */
  I?: Maybe<Scalars['Float']['output']>;
  /** Rotation value J */
  J?: Maybe<Scalars['Float']['output']>;
  /** Rotation value K */
  K?: Maybe<Scalars['Float']['output']>;
};

export type TrackingMeasurementDefaultRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type TrackingMeasurementPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackingMeasurement>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackingMeasurementRecord = {
  _id: Scalars['MongoID']['output'];
  assembly?: Maybe<ChassisAssembly>;
  assemblyID?: Maybe<Scalars['MongoID']['output']>;
  coordinates?: Maybe<TrackingMeasurementRecordCoordinates>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  part?: Maybe<Part>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  rotation?: Maybe<TrackingMeasurementRecordRotation>;
  trackingMeasurement?: Maybe<TrackingMeasurement>;
  trackingMeasurementID?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TrackingMeasurementRecordCoordinates = {
  /** Coordinate value x */
  x?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value y */
  y?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value z */
  z?: Maybe<Scalars['Float']['output']>;
};

export type TrackingMeasurementRecordCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type TrackingMeasurementRecordPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackingMeasurementRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackingMeasurementRecordRotation = {
  /** Rotation value I */
  I?: Maybe<Scalars['Float']['output']>;
  /** Rotation value J */
  J?: Maybe<Scalars['Float']['output']>;
  /** Rotation value K */
  K?: Maybe<Scalars['Float']['output']>;
};

export type TrackingMeasurementRecordRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackingRecord = {
  _id: Scalars['MongoID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  arrayValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  chassisAssembly?: Maybe<ChassisAssembly>;
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cumulativeValue?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  dateResolved?: Maybe<Scalars['Date']['output']>;
  forceTable?: Maybe<ForceTable>;
  limitCritical?: Maybe<Scalars['Boolean']['output']>;
  limitWarning?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  mass?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  part?: Maybe<Part>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  qualityCheckID?: Maybe<Scalars['MongoID']['output']>;
  recordErrors?: Maybe<Scalars['String']['output']>;
  reset?: Maybe<Scalars['Boolean']['output']>;
  statusEnum?: Maybe<UserEnumPartStatus>;
  statusEnumID?: Maybe<Scalars['MongoID']['output']>;
  trackingItem?: Maybe<TrackingItem>;
  trackingItemID?: Maybe<Scalars['MongoID']['output']>;
  trackingSource?: Maybe<TrackingSource>;
  trackingSourceID?: Maybe<Scalars['MongoID']['output']>;
  type?: Maybe<EnumTrackingRecordType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedByID?: Maybe<Scalars['MongoID']['output']>;
  userEnumPartStatusName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type TrackingRecordGeneral = {
  _id: Scalars['MongoID']['output'];
  arrayValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cumulativeValue?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  dateResolved?: Maybe<Scalars['Date']['output']>;
  forceTable?: Maybe<ForceTable>;
  location?: Maybe<Location>;
  mass?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  qualityCheckID?: Maybe<Scalars['MongoID']['output']>;
  recordErrors?: Maybe<Scalars['String']['output']>;
  reset?: Maybe<Scalars['Boolean']['output']>;
  statusEnumID?: Maybe<Scalars['MongoID']['output']>;
  trackingItemID?: Maybe<Scalars['MongoID']['output']>;
  trackingSourceID?: Maybe<Scalars['MongoID']['output']>;
  type?: Maybe<EnumTrackingRecordGeneralType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedByID?: Maybe<Scalars['MongoID']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type TrackingRecordOverride = {
  _id: Scalars['MongoID']['output'];
  arrayValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cumulativeValue?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  dateResolved?: Maybe<Scalars['Date']['output']>;
  forceTable?: Maybe<ForceTable>;
  location?: Maybe<Location>;
  mass?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  qualityCheckID?: Maybe<Scalars['MongoID']['output']>;
  recordErrors?: Maybe<Scalars['String']['output']>;
  reset?: Maybe<Scalars['Boolean']['output']>;
  statusEnumID?: Maybe<Scalars['MongoID']['output']>;
  trackingItemID?: Maybe<Scalars['MongoID']['output']>;
  trackingSourceID?: Maybe<Scalars['MongoID']['output']>;
  type?: Maybe<EnumTrackingRecordOverrideType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedByID?: Maybe<Scalars['MongoID']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type TrackingRecordPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackingRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackingRecordValue = {
  _id: Scalars['MongoID']['output'];
  arrayValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cumulativeValue?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  dateResolved?: Maybe<Scalars['Date']['output']>;
  forceTable?: Maybe<ForceTable>;
  location?: Maybe<Location>;
  mass?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  qualityCheckID?: Maybe<Scalars['MongoID']['output']>;
  recordErrors?: Maybe<Scalars['String']['output']>;
  reset?: Maybe<Scalars['Boolean']['output']>;
  statusEnumID?: Maybe<Scalars['MongoID']['output']>;
  trackingItemID?: Maybe<Scalars['MongoID']['output']>;
  trackingSourceID?: Maybe<Scalars['MongoID']['output']>;
  type?: Maybe<EnumTrackingRecordValueType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedByID?: Maybe<Scalars['MongoID']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type TrackingSource = {
  NDecimals?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  chassisSpecID: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayUnit?: Maybe<EnumDisplayUnit>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  sourceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  sources: Array<TrackingSourceAlias>;
};

export type TrackingSourceAlias = {
  _id: Scalars['MongoID']['output'];
  aliasString?: Maybe<Scalars['String']['output']>;
  aliasType?: Maybe<EnumTrackingSourceAliasAliasType>;
  description?: Maybe<Scalars['String']['output']>;
  displayUnit?: Maybe<EnumDisplayUnit>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** List of items with pagination. */
export type TrackingSourceAliasPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackingSourceAlias>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type TrackingSourcePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackingSource>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TypedUnitField = AccelerationUnitField | AngleUnitField | AngularAccelerationUnitField | AngularComplianceUnitField | AngularTorqueComplianceUnitField | AngularVelocityUnitField | BooleanUnitField | ComplianceUnitField | EnergyUnitField | ForceUnitField | InertiaUnitField | LengthUnitField | LocationUnitField | MassUnitField | NumberUnitField | OrientationUnitField | PowerUnitField | PressureUnitField | RatioUnitField | SpringRateUnitField | SteeringRackRatioUnitField | StringUnitField | TemperatureUnitField | TimeUnitField | TorqueUnitField | TorsionRateUnitField | VelocityUnitField | VolumeUnitField;

export type Tyre = {
  /** Flag if the tyre is scrapped (no longer available for use). */
  BTyreScrapped?: Maybe<Scalars['Boolean']['output']>;
  /** Tyre Circumference */
  CTyre?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  /** Arbitrary string to sort or filter by */
  additionalSortProperty?: Maybe<Scalars['String']['output']>;
  axle?: Maybe<EnumTyreAxle>;
  barcodeManufacturer?: Maybe<Scalars['String']['output']>;
  /** Barcode from the regulatory body (e.g. FIA) */
  barcodeRegulation?: Maybe<Scalars['String']['output']>;
  barcodeRim?: Maybe<Scalars['String']['output']>;
  barcodeTPMS?: Maybe<Scalars['String']['output']>;
  batteryTPMS?: Maybe<Scalars['String']['output']>;
  compound?: Maybe<Scalars['String']['output']>;
  compoundComment?: Maybe<Scalars['String']['output']>;
  constructionComment?: Maybe<Scalars['String']['output']>;
  constructionSpec?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  heatingSchedule?: Maybe<Array<Maybe<TyreHeatingScheduleEntry>>>;
  initialCondition?: Maybe<EnumTyreInitialCondition>;
  /** Tyre Spring Rate */
  kTyre?: Maybe<Scalars['Float']['output']>;
  mTyre?: Maybe<Scalars['Float']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturingDate?: Maybe<Scalars['Date']['output']>;
  /** Calculate total mileage */
  mileage?: Maybe<Scalars['Float']['output']>;
  /** Tyre mold information */
  mold?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Tyre minimum pressure defined by regulation or manufacturer */
  pTyreMinRegulation?: Maybe<Scalars['Float']['output']>;
  /** Tyre minimum pressure defined by team (i.e. chief engineer) */
  pTyreMinTeam?: Maybe<Scalars['Float']['output']>;
  rimPart?: Maybe<Part>;
  rimPartID?: Maybe<Scalars['MongoID']['output']>;
  /** Initial mileage before use in One Racehub. */
  sRunInitial?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Season>;
  seasonID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  wearMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  wearMeasurements: Array<TyreWear>;
};

export type TyreHeatingScheduleEntry = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  duration: Scalars['Float']['output'];
  temperature: Scalars['Float']['output'];
};

export type TyreHeatingScheduleEntryInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  duration: Scalars['Float']['input'];
  temperature: Scalars['Float']['input'];
};

export type TyreMileageAtSessionStart = {
  tyreMileages?: Maybe<Array<Maybe<SingleTyreMileageAtSessionStart>>>;
  tyreSetMileages?: Maybe<Array<Maybe<TyreSetMileageAtSessionStart>>>;
};

export type TyreMileageAtSessionStartData = {
  endMileage?: Maybe<Scalars['Float']['output']>;
  runs?: Maybe<Array<Maybe<MileageAtRunStart>>>;
  sessionID?: Maybe<Scalars['MongoID']['output']>;
  startMileage?: Maybe<Scalars['Float']['output']>;
};

export type TyreMileageGraph = {
  eventMileages?: Maybe<TyreMileageGraphEventMileages>;
  fullMileages?: Maybe<TyreMileageGraphFullMileages>;
};

export type TyreMileageGraphEventMileageItem = {
  _id: Scalars['MongoID']['output'];
  eventEndMileage: Scalars['Float']['output'];
  eventStartMileage: Scalars['Float']['output'];
  eventTotalMileage: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  runMileages?: Maybe<Array<Maybe<TyreMileageGraphEventMileageItemRunMileageItem>>>;
  sessionMileages?: Maybe<Array<Maybe<TyreMileageGraphEventMileageItemSessionMileageItem>>>;
};

export type TyreMileageGraphEventMileageItemRunMileageItem = {
  NRun: Scalars['Int']['output'];
  NRunConsecutive: Scalars['Int']['output'];
  NRunTiming: Scalars['String']['output'];
  endMileage: Scalars['Float']['output'];
  runMileage: Scalars['Float']['output'];
  runSheetID: Scalars['MongoID']['output'];
  sessionID: Scalars['MongoID']['output'];
  startMileage: Scalars['Float']['output'];
};

export type TyreMileageGraphEventMileageItemSessionMileageItem = {
  endMileage: Scalars['Float']['output'];
  sessionID: Scalars['MongoID']['output'];
  startMileage: Scalars['Float']['output'];
  totalMileage: Scalars['Float']['output'];
};

export type TyreMileageGraphEventMileages = {
  tyreSets?: Maybe<Array<Maybe<TyreMileageGraphEventMileageItem>>>;
  tyres?: Maybe<Array<Maybe<TyreMileageGraphEventMileageItem>>>;
};

export type TyreMileageGraphFullMileageItem = {
  _id: Scalars['MongoID']['output'];
  mileages?: Maybe<Array<Maybe<TyreMileageGraphFullMileageItemMileageItem>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TyreMileageGraphFullMileageItemMileageItem = {
  endMileage: Scalars['Float']['output'];
  runMileage: Scalars['Float']['output'];
  runSheetID: Scalars['MongoID']['output'];
  startMileage: Scalars['Float']['output'];
};

export type TyreMileageGraphFullMileages = {
  tyreSets?: Maybe<Array<Maybe<TyreMileageGraphFullMileageItem>>>;
  tyres?: Maybe<Array<Maybe<TyreMileageGraphFullMileageItem>>>;
};

/** List of items with pagination. */
export type TyrePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Tyre>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TyrePressureSettings = {
  TAirReference?: Maybe<Scalars['Float']['output']>;
  TTrackReference?: Maybe<Scalars['Float']['output']>;
};

export type TyrePressureSettingsInput = {
  TAirReference?: InputMaybe<Scalars['Float']['input']>;
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
};

export type TyrePressureSheet = {
  _id: Scalars['MongoID']['output'];
  contestant?: Maybe<Contestant>;
  contestantID?: Maybe<Scalars['MongoID']['output']>;
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['MongoID']['output']>;
  pressureUnit?: Maybe<EnumPressureUnit>;
  sessions?: Maybe<Array<Maybe<TyrePressureSheetSession>>>;
  temperatureUnit?: Maybe<EnumTemperatureUnit>;
  tyrePressureSettings: EventTyrePressureSettings;
};

export type TyrePressureSheetInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  pressureUnit?: InputMaybe<EnumPressureUnit>;
  temperatureUnit?: InputMaybe<EnumTemperatureUnit>;
  tyrePressureSettings?: InputMaybe<EventTyrePressureSettingsInput>;
};

export type TyrePressureSheetSession = {
  session?: Maybe<Session>;
  sessionID: Scalars['MongoID']['output'];
  tyreSetupData: Array<TyreSetupData>;
};

export type TyreSet = {
  _id: Scalars['MongoID']['output'];
  assignment?: Maybe<TyreSetAssignment>;
  comment?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** Mileage of the highest-mileage corner in the set, in metres. The four tyres run together, so the worst corner governs the set - this is a maximum, not a sum. */
  totalMileage?: Maybe<Scalars['Float']['output']>;
  tyreFL?: Maybe<Tyre>;
  tyreFR?: Maybe<Tyre>;
  tyreIDFL?: Maybe<Scalars['MongoID']['output']>;
  tyreIDFR?: Maybe<Scalars['MongoID']['output']>;
  tyreIDRL?: Maybe<Scalars['MongoID']['output']>;
  tyreIDRR?: Maybe<Scalars['MongoID']['output']>;
  tyreRL?: Maybe<Tyre>;
  tyreRR?: Maybe<Tyre>;
};

export type TyreSetAssignment = {
  eventContestants: Array<Contestant>;
  events: Array<Event>;
  seasonContestants: Array<Contestant>;
  seasons: Array<Season>;
};

export type TyreSetMileageAtSessionStart = {
  sessions?: Maybe<Array<Maybe<TyreMileageAtSessionStartData>>>;
  tyreSetID?: Maybe<Scalars['MongoID']['output']>;
};

/** List of items with pagination. */
export type TyreSetPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TyreSet>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TyreSetupData = {
  TAirRegulation?: Maybe<Scalars['Float']['output']>;
  TRimParcFermeExpected?: Maybe<Scalars['Float']['output']>;
  TRimSetdown: TyreValues;
  TRimSetup: TyreValues;
  TTrackExpected?: Maybe<Scalars['Float']['output']>;
  TTrackRegulation?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  pTyreMinimum: TyreValues;
  pTyreReference: TyreValues;
  pTyreSetdown: TyreValues;
  pTyreSetup: TyreValues;
  pTyreTarget: TyreValues;
  rTrackTemperature?: Maybe<Scalars['Float']['output']>;
  selected: Scalars['Boolean']['output'];
  tyreSet?: Maybe<TyreSet>;
  tyreSetID: Scalars['MongoID']['output'];
};

export type TyreSetupDataInput = {
  TAirRegulation?: InputMaybe<Scalars['Float']['input']>;
  TRimParcFermeExpected?: InputMaybe<Scalars['Float']['input']>;
  TRimSetdown?: InputMaybe<TyreValuesInput>;
  TRimSetup?: InputMaybe<TyreValuesInput>;
  TTrackExpected?: InputMaybe<Scalars['Float']['input']>;
  TTrackRegulation?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  pTyreMinimum?: InputMaybe<TyreValuesInput>;
  pTyreReference?: InputMaybe<TyreValuesInput>;
  pTyreSetdown?: InputMaybe<TyreValuesInput>;
  pTyreSetup?: InputMaybe<TyreValuesInput>;
  pTyreTarget?: InputMaybe<TyreValuesInput>;
  rTrackTemperature?: InputMaybe<Scalars['Float']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type TyreTableBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  mileageUnit?: Maybe<EnumLengthUnit>;
  pressureUnit?: Maybe<EnumPressureUnit>;
  showGetPreviousRunPostPressureButton?: Maybe<Scalars['Boolean']['output']>;
  showGetRecommendationButton?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  showMinimumPressures?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  showSurfaceTemps?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  showTargetPressures?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  showTyreReferencePressure?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  showTyreSelector?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  showTyreSetSelector?: Maybe<Scalars['Boolean']['output']>;
  staggerSettings?: Maybe<TyreTableBlockStaggerSettings>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  standardTyrePressureBox?: Maybe<TyreTableBlockStandardTyrePressureBox>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  standardTyreTempBox?: Maybe<TyreTableBlockStandardTyreTempBox>;
  /** @deprecated Use other fields to style the block instead */
  style?: Maybe<EnumRunSheetStyleBlockStyle>;
  temperatureUnit?: Maybe<EnumTemperatureUnit>;
  treadDepthUnit?: Maybe<EnumLengthUnit>;
  tyreTableRows?: Maybe<Array<Maybe<TyreTableBlockRow>>>;
  /** Number of tread depth measurements to allow. Use `0` or `null` to hide the input. */
  tyreTreadDepthMeasurements?: Maybe<Scalars['Int']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type TyreTableBlockRow = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  field?: Maybe<EnumTyreTableField>;
  highlightChanges?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lowerLimit?: Maybe<ValueLimit>;
  upperLimit?: Maybe<ValueLimit>;
};

export type TyreTableBlockRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<EnumTyreTableField>;
  highlightChanges?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<ValueLimitInput>;
  upperLimit?: InputMaybe<ValueLimitInput>;
};

export type TyreTableBlockStaggerSettings = {
  /** Number of decimal places to display. */
  decimals?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumLengthUnit>;
};

export type TyreTableBlockStandardTyrePressureBox = {
  decimalPlaces?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<EnumPressureOption>>>;
  unit?: Maybe<EnumPressureUnit>;
};

export type TyreTableBlockStandardTyreTempBox = {
  decimalPlaces?: Maybe<Scalars['Float']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<EnumTemperatureOption>>>;
  unit?: Maybe<EnumTemperatureUnit>;
};

export type TyreValues = {
  FL?: Maybe<Scalars['Float']['output']>;
  FR?: Maybe<Scalars['Float']['output']>;
  RL?: Maybe<Scalars['Float']['output']>;
  RR?: Maybe<Scalars['Float']['output']>;
};

export type TyreValuesInput = {
  FL?: InputMaybe<Scalars['Float']['input']>;
  FR?: InputMaybe<Scalars['Float']['input']>;
  RL?: InputMaybe<Scalars['Float']['input']>;
  RR?: InputMaybe<Scalars['Float']['input']>;
};

export type TyreWear = {
  _id: Scalars['MongoID']['output'];
  /** Time at which this measurement was made. */
  date?: Maybe<Scalars['Date']['output']>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  tyre?: Maybe<Tyre>;
  tyreID: Scalars['MongoID']['output'];
  /** Raw wear data formatted however the user chooses, probably from a scanner. */
  wearData?: Maybe<Scalars['String']['output']>;
  /** Map of marker names to wear values. Input syntax is array of key-value tuples, like `wearMarkers: [["inner", 0.8], ["1", 0.3]]`. */
  wearMarkers?: Maybe<Scalars['JSON']['output']>;
};

/** List of items with pagination. */
export type TyreWearPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TyreWear>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type UnclaimCarSetupResult = {
  success: Scalars['Boolean']['output'];
};

export type UnclaimRunSheetResult = {
  success: Scalars['Boolean']['output'];
};

export type UpdateByIdAccelerationInput = {
  /** ft/s² */
  feetPerSecondSquared?: InputMaybe<Scalars['Float']['input']>;
  /** g */
  gForce?: InputMaybe<Scalars['Float']['input']>;
  metresPerSecondSquared?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAdjustableAccelerationInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAccelerationUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableAngleInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngleUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableAngularComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngularComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableAngularTorqueComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngularTorqueComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableBooleanInput = {
  defaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdAdjustableComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableForceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumForceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableInertiaInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumInertiaUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableLengthInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumLengthUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableLocationCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAdjustableLocationDefaultValueInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAdjustableLocationInput = {
  coordinates?: InputMaybe<UpdateByIdAdjustableLocationCoordinatesInput>;
  defaultValue?: InputMaybe<UpdateByIdAdjustableLocationDefaultValueInput>;
};

export type UpdateByIdAdjustableMassInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumMassUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableNumberInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  /** Unit to display values in */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableOrientationDefaultValueInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAdjustableOrientationInput = {
  defaultValue?: InputMaybe<UpdateByIdAdjustableOrientationDefaultValueInput>;
  rotation?: InputMaybe<UpdateByIdAdjustableOrientationRotationInput>;
};

export type UpdateByIdAdjustableOrientationRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAdjustablePowerInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumPowerUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustablePressureInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumPressureUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustablePropertyInput = {
  adjustableAcceleration?: InputMaybe<UpdateByIdAdjustableAccelerationInput>;
  adjustableAngle?: InputMaybe<UpdateByIdAdjustableAngleInput>;
  adjustableAngularCompliance?: InputMaybe<UpdateByIdAdjustableAngularComplianceInput>;
  adjustableAngularTorqueCompliance?: InputMaybe<UpdateByIdAdjustableAngularTorqueComplianceInput>;
  adjustableBoolean?: InputMaybe<UpdateByIdAdjustableBooleanInput>;
  adjustableCompliance?: InputMaybe<UpdateByIdAdjustableComplianceInput>;
  adjustableForce?: InputMaybe<UpdateByIdAdjustableForceInput>;
  adjustableInertia?: InputMaybe<UpdateByIdAdjustableInertiaInput>;
  adjustableLength?: InputMaybe<UpdateByIdAdjustableLengthInput>;
  adjustableLocation?: InputMaybe<UpdateByIdAdjustableLocationInput>;
  adjustableMass?: InputMaybe<UpdateByIdAdjustableMassInput>;
  adjustableNumber?: InputMaybe<UpdateByIdAdjustableNumberInput>;
  adjustableOrientation?: InputMaybe<UpdateByIdAdjustableOrientationInput>;
  adjustablePower?: InputMaybe<UpdateByIdAdjustablePowerInput>;
  adjustablePressure?: InputMaybe<UpdateByIdAdjustablePressureInput>;
  adjustableRatio?: InputMaybe<UpdateByIdAdjustableRatioInput>;
  adjustableSpringRate?: InputMaybe<UpdateByIdAdjustableSpringRateInput>;
  adjustableSteeringRackRatio?: InputMaybe<UpdateByIdAdjustableSteeringRackRatioInput>;
  adjustableString?: InputMaybe<UpdateByIdAdjustableStringInput>;
  adjustableTemperature?: InputMaybe<UpdateByIdAdjustableTemperatureInput>;
  adjustableTorque?: InputMaybe<UpdateByIdAdjustableTorqueInput>;
  adjustableTorsionRate?: InputMaybe<UpdateByIdAdjustableTorsionRateInput>;
  adjustableVolume?: InputMaybe<UpdateByIdAdjustableVolumeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAdjustablePropertyType>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdAdjustableRatioInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumRatioUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableSpringRateInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpringRateUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableSteeringRackRatioInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSteeringRackRatioUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableStringInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableTemperatureInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTemperatureUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableTorqueInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTorqueUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableTorsionRateInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTorsionRateUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableVolumeInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumVolumeUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAeroElementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  attached?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  positionName?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdAeroInput = {
  /** Number/Position of front flaps */
  NFlapF?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of front-left flaps */
  NFlapFL?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of front-right flaps */
  NFlapFR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of lower rear flaps */
  NFlapLowerR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear flaps */
  NFlapR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear-left flaps */
  NFlapRL?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear-right flaps */
  NFlapRR?: InputMaybe<Scalars['String']['input']>;
  Z400?: InputMaybe<Scalars['String']['input']>;
  /** Front flap angle */
  aFlapF?: InputMaybe<Scalars['Float']['input']>;
  /** Front-left flap angle */
  aFlapFL?: InputMaybe<Scalars['Float']['input']>;
  /** Front-right flap angle */
  aFlapFR?: InputMaybe<Scalars['Float']['input']>;
  /** Lower rear flap angle */
  aFlapLowerR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear flap angle */
  aFlapR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-left flap angle */
  aFlapRL?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-right flap angle */
  aFlapRR?: InputMaybe<Scalars['Float']['input']>;
  /** Front splitter angle */
  aSplitterF?: InputMaybe<Scalars['Float']['input']>;
  /** Complete aero package spec */
  aeroPackage?: InputMaybe<Scalars['String']['input']>;
  floorBB?: InputMaybe<Scalars['String']['input']>;
  floorGurney?: InputMaybe<Scalars['String']['input']>;
  floorLeadingEdgeID?: InputMaybe<Scalars['String']['input']>;
  /** Front flap type */
  frontFlapType?: InputMaybe<Scalars['String']['input']>;
  frontWheelArch?: InputMaybe<Scalars['String']['input']>;
  hGurneyF?: InputMaybe<Scalars['Float']['input']>;
  hGurneyR?: InputMaybe<Scalars['Float']['input']>;
  /** Splitter height at measurement points */
  hSplitterF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lowerDrivePlane?: InputMaybe<Scalars['String']['input']>;
  noseID?: InputMaybe<Scalars['String']['input']>;
  rearWingGurney?: InputMaybe<Scalars['String']['input']>;
  splitterID?: InputMaybe<Scalars['String']['input']>;
  tailGurney?: InputMaybe<Scalars['String']['input']>;
  tailID?: InputMaybe<Scalars['String']['input']>;
  upperDrivePlane?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdAeroPackageInput = {
  aeroElements?: InputMaybe<Array<InputMaybe<UpdateByIdAeroElementInput>>>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdAngleInput = {
  /** ° */
  degrees?: InputMaybe<Scalars['Float']['input']>;
  /** rad */
  radians?: InputMaybe<Scalars['Float']['input']>;
  /** rev */
  revolutions?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAngularVelocityInput = {
  /** °/s */
  degreesPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** rad/s */
  radiansPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** rpm */
  revolutionsPerMinute?: InputMaybe<Scalars['Float']['input']>;
  /** rev/s */
  revolutionsPerSecond?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAntiRollBarConfigInput = {
  /** Anti-roll bar stiffness (use spring rate units) */
  kARB?: InputMaybe<Scalars['Float']['input']>;
  kinematicsInternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** First connection point (should be a chassis socket) */
  position1?: InputMaybe<Scalars['String']['input']>;
  /** Second connection point (should be a chassis socket) */
  position2?: InputMaybe<Scalars['String']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdAreaInput = {
  /** sq ft */
  squareFeet?: InputMaybe<Scalars['Float']['input']>;
  /** sq in */
  squareInches?: InputMaybe<Scalars['Float']['input']>;
  /** m² */
  squareMetres?: InputMaybe<Scalars['Float']['input']>;
  /** mm² */
  squareMillimetres?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAssemblyInput = {
  assemblyTemplateID?: InputMaybe<Scalars['MongoID']['input']>;
  assemblyTypeEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetGroupEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetNestLevel?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisMeasurements?: InputMaybe<Array<InputMaybe<UpdateByIdChassisAssemblyMeasurementInput>>>;
  chassisPartID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this the current version of this assembly, or just a historical snapshot? */
  current?: InputMaybe<Scalars['Boolean']['input']>;
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Location of this assembly referring to a socket. For example, `frontLeft` or `cockpit`. */
  locationID?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  subAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceRecords?: InputMaybe<Array<InputMaybe<UpdateByIdChassisAssemblyTrackingSourceRecordInput>>>;
  type?: InputMaybe<EnumAssemblyType>;
  userEnumAssemblyTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdAssemblyPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Assembly>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdAssemblyTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredAssemblies?: InputMaybe<Array<InputMaybe<UpdateByIdAssemblyTemplateRequiredAssembliesInput>>>;
  requiredParts?: InputMaybe<Array<InputMaybe<UpdateByIdAssemblyTemplateRequiredPartsInput>>>;
};

export type UpdateByIdAssemblyTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<AssemblyTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdAssemblyTemplateRequiredAssembliesInput = {
  userEnumAssemblyTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdAssemblyTemplateRequiredPartsInput = {
  /** Specify where the part type should be added in */
  location?: InputMaybe<EnumAssemblyTemplateRequiredPartsLocation>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdAssignedGearInput = {
  gearID?: InputMaybe<Scalars['MongoID']['input']>;
  useHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdBaseTypedUnitFieldInput = {
  type?: InputMaybe<EnumTypedUnitType>;
  unit?: InputMaybe<EnumPossibleUnit>;
};

export type UpdateByIdBehaviourConfigInput = {
  /** Should job list templates be re-used from previous runs when creating new run sheets? */
  carryOverJobList?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the issue block will be ticked to show only the users issues on load. */
  showMyIssuesOnRunSheetDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the job block will be ticked to show only the users jobs on load. */
  showMyJobsOnRunSheetDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The locale to use for time formatting */
  timeLocale?: InputMaybe<Scalars['String']['input']>;
  /** ORH will use the users timezone selection to format times accordingly */
  timezoneSelect?: InputMaybe<EnumBehaviourConfigTimezoneSelect>;
};

export type UpdateByIdBestValuesFastestLapInput = {
  /** Lap number within the run sheet for this lap. */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Acronym of the driver that completed this lap. */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** ID of the run sheet that this lap can be found in. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time the lap was completed in. */
  time?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdBestValuesFastestSectorInput = {
  /** Lap number within the run sheet for this sector. */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Acronym of the driver that completed this sector. */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** ID of the run sheet that this sector can be found in. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time the sector was completed in. */
  time?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdBestValuesInput = {
  /** ID of the contestant these personal bests belong to, if applicable. */
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the driver these personal bests belong to, if applicable. */
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  fastestLap?: InputMaybe<UpdateByIdBestValuesFastestLapInput>;
  fastestSectors?: InputMaybe<Array<InputMaybe<UpdateByIdBestValuesFastestSectorInput>>>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdBestValuesPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<BestValues>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdBopCarBopInput = {
  EStintMax?: InputMaybe<Scalars['Float']['input']>;
  PEngineMax?: InputMaybe<Scalars['Float']['input']>;
  VFuelVolumeCapacityMax?: InputMaybe<Scalars['Float']['input']>;
  VRefuelVolumeMax?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  aCamberFmax?: InputMaybe<Scalars['Float']['input']>;
  aCamberFmin?: InputMaybe<Scalars['Float']['input']>;
  aCamberRmax?: InputMaybe<Scalars['Float']['input']>;
  aCamberRmin?: InputMaybe<Scalars['Float']['input']>;
  aRakeMax?: InputMaybe<Scalars['Float']['input']>;
  aRakeMin?: InputMaybe<Scalars['Float']['input']>;
  aWingRmax?: InputMaybe<Scalars['Float']['input']>;
  aWingRmin?: InputMaybe<Scalars['Float']['input']>;
  carSpec?: InputMaybe<Scalars['String']['input']>;
  hRideFmin?: InputMaybe<Scalars['Float']['input']>;
  hRideRmin?: InputMaybe<Scalars['Float']['input']>;
  highlightColour?: InputMaybe<Scalars['String']['input']>;
  homologation?: InputMaybe<Scalars['String']['input']>;
  mCarBallastMin?: InputMaybe<Scalars['Float']['input']>;
  mCarWeightEmptyMin?: InputMaybe<Scalars['Float']['input']>;
  mCarWeightTotalMin?: InputMaybe<Scalars['Float']['input']>;
  mFuelMassCapacityMax?: InputMaybe<Scalars['Float']['input']>;
  mRefuelMassMax?: InputMaybe<Scalars['Float']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['String']['input']>;
  nEngineMax?: InputMaybe<Scalars['Float']['input']>;
  /** A map rpm vs boost pressure */
  pEngineBoost?: InputMaybe<Scalars['JSON']['input']>;
  rLambdaMin?: InputMaybe<Scalars['Float']['input']>;
  rPowerCurveReference?: InputMaybe<Scalars['Float']['input']>;
  rPowerGainAboveRefVelocity?: InputMaybe<Scalars['Float']['input']>;
  vCarMax?: InputMaybe<Scalars['Float']['input']>;
  vPowerCurveBelowRefVelocity?: InputMaybe<Scalars['Float']['input']>;
  vPowerGainReference?: InputMaybe<Scalars['Float']['input']>;
  xAirRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  xFuelRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  xRefuelRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  zWingMin?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdBopInput = {
  bopFile?: InputMaybe<Scalars['String']['input']>;
  carBop?: InputMaybe<Array<InputMaybe<UpdateByIdBopCarBopInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sessionBop?: InputMaybe<UpdateByIdBopSessionBopInput>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdBopPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Bop>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdBopSessionBopInput = {
  EStintEnergyMax?: InputMaybe<Scalars['Float']['input']>;
  EStintEnergyRefillRateMax?: InputMaybe<Scalars['Float']['input']>;
  VRefuelRateMax?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  mRefuelRateMax?: InputMaybe<Scalars['Float']['input']>;
  pAmbientSessionOfficial?: InputMaybe<Scalars['Float']['input']>;
  tyreModel?: InputMaybe<Scalars['String']['input']>;
  xStintlengthMax?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdBrakeSystemInput = {
  BBBSEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  brakePadFManufacturer?: InputMaybe<Scalars['String']['input']>;
  brakePadFSpec?: InputMaybe<Scalars['String']['input']>;
  brakePadRManufacturer?: InputMaybe<Scalars['String']['input']>;
  brakePadRSpec?: InputMaybe<Scalars['String']['input']>;
  brakePedalPosition?: InputMaybe<Scalars['String']['input']>;
  dMasterCylinderF?: InputMaybe<Scalars['Float']['input']>;
  dMasterCylinderR?: InputMaybe<Scalars['Float']['input']>;
  kBBSSpring?: InputMaybe<Scalars['Float']['input']>;
  kKnockOffSpringF?: InputMaybe<Scalars['Float']['input']>;
  kKnockOffSpringR?: InputMaybe<Scalars['Float']['input']>;
  masterCylinderFSpec?: InputMaybe<Scalars['String']['input']>;
  masterCylinderRSpec?: InputMaybe<Scalars['String']['input']>;
  masterCylinderRodLengthF?: InputMaybe<Scalars['Float']['input']>;
  masterCylinderRodlengthR?: InputMaybe<Scalars['Float']['input']>;
  pBrakeBalanceRef?: InputMaybe<Scalars['Float']['input']>;
  rBrakeF?: InputMaybe<Scalars['Float']['input']>;
  rBrakePedal?: InputMaybe<Scalars['Float']['input']>;
  xBBSPreload?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdBuildSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** The height of the block within the grid */
  h?: InputMaybe<Scalars['Int']['input']>;
  moved?: InputMaybe<Scalars['Boolean']['input']>;
  resizing?: InputMaybe<Scalars['Boolean']['input']>;
  static?: InputMaybe<Scalars['Boolean']['input']>;
  tabs?: InputMaybe<Array<InputMaybe<UpdateByIdBuildSheetStyleTabInput>>>;
  /** The width of the block within the grid */
  w?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateByIdBuildSheetStyleInput = {
  blocks?: InputMaybe<Array<InputMaybe<UpdateByIdBuildSheetStyleBlockInput>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  targetEventType?: InputMaybe<EnumBuildSheetStyleTargetEventType>;
  targetRoles?: InputMaybe<Array<InputMaybe<EnumBuildSheetStyleTargetRoles>>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumBuildSheetStyleType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdBuildSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<BuildSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdBuildSheetStyleTabInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetGroupEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCalculationInput = {
  /** For the client to display debug information or default return values */
  debugMode?: InputMaybe<Scalars['Boolean']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  functionString?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The name of the parameter or path to a field which this calculation gives as output. */
  parameter?: InputMaybe<Scalars['String']['input']>;
  /** The names of the parameters or paths to fields which this calculation depends on. If any of these change, the calculation should be re-run. */
  trigger?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumCalculationType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCalculationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Calculation>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCanopyCredentialsInput = {
  /** Client ID for the Canopy API */
  clientID?: InputMaybe<Scalars['String']['input']>;
  /** Client secret for the Canopy API */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Password for the Canopy API */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID from the Canopy API */
  tenantID?: InputMaybe<Scalars['String']['input']>;
  /** Username for the Canopy API */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarCornerInput = {
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aFlap?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<Scalars['Float']['input']>;
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  brake?: InputMaybe<BrakeInput>;
  bumpStop?: InputMaybe<BumpStopInput>;
  damper?: InputMaybe<DamperInput>;
  droopStop?: InputMaybe<DroopStopInput>;
  externalBumpStop?: InputMaybe<ExternalBumpStopInput>;
  hRide?: InputMaybe<Scalars['Float']['input']>;
  hRideChassis?: InputMaybe<Scalars['Float']['input']>;
  hRideMeasurement?: InputMaybe<Scalars['Float']['input']>;
  hRideRegulation?: InputMaybe<Scalars['Float']['input']>;
  helperSpring?: InputMaybe<SpringInput>;
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
  reboundSpring?: InputMaybe<SpringInput>;
  spring?: InputMaybe<SpringInput>;
  suspension?: InputMaybe<SuspensionInput>;
  xToe?: InputMaybe<Scalars['Float']['input']>;
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdCarDataServiceApplicationSettingsConfigInput = {
  DriverContestantLookup?: InputMaybe<Scalars['JSON']['input']>;
  FunctionsFolder?: InputMaybe<Scalars['String']['input']>;
  PitstopTriggers?: InputMaybe<Array<InputMaybe<UpdateByIdCarDataServicePitstopTriggerInput>>>;
  ProcessedFolder?: InputMaybe<Scalars['String']['input']>;
  ResultsFolder?: InputMaybe<Scalars['String']['input']>;
  RunsheetMatching?: InputMaybe<EnumCarDataServiceApplicationSettingsConfigRunsheetMatching>;
};

export type UpdateByIdCarDataServiceConfigInput = {
  Kpi?: InputMaybe<UpdateByIdCarDataServiceKpiConfigInput>;
  ORHCalculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Object containing parameter mappings. Format is like: { vCar: [{ "name": "car_speed", "offset": 0, "gain": 3.6 }] } */
  ParameterMap?: InputMaybe<Scalars['JSON']['input']>;
  PostProcessingConfig?: InputMaybe<UpdateByIdCarDataServicePostProcessingConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarDataServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CarDataServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCarDataServiceEventConfigInput = {
  EventDescription?: InputMaybe<Scalars['String']['input']>;
  EventId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCarDataServiceKpiConfigInput = {
  KpiParameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Preconditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preconditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdCarDataServicePitstopTriggerInput = {
  ParameterId?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<EnumCarDataServicePitstopTriggerType>;
  Value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdCarDataServicePostProcessingConfigInput = {
  ApplicationSettingsConfiguration?: InputMaybe<UpdateByIdCarDataServiceApplicationSettingsConfigInput>;
  EventConfiguration?: InputMaybe<UpdateByIdCarDataServiceEventConfigInput>;
  ProcessingEnginesConfiguration?: InputMaybe<UpdateByIdCarDataServiceProcessingEnginesConfigInput>;
  QueueManagerConfiguration?: InputMaybe<UpdateByIdCarDataServiceQueueManagerConfigInput>;
  SessionManagerConfiguration?: InputMaybe<UpdateByIdCarDataServiceSessionManagerConfigInput>;
  SessionTypesConfiguration?: InputMaybe<UpdateByIdCarDataServiceSessionTypesConfigInput>;
};

export type UpdateByIdCarDataServiceProcessingEngineConfigExportersInput = {
  ATLAS10_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  JSONFILE_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  ONERACEHUB_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  PARQUETFILE_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  WINTAX_EXPORTER?: InputMaybe<UpdateByIdCarDataServiceProcessingEngineConfigExportersWintax_ExporterInput>;
};

export type UpdateByIdCarDataServiceProcessingEngineConfigExportersWintax_ExporterInput = {
  /** NAme of paremeter in the parameter map, tracking the distance of current lap. */
  DISTANCE_CHANNEL?: InputMaybe<Scalars['String']['input']>;
  /** Fuel consumption of the current lap. Could be a KPI like 'sLap.Lap.Max' or a fixed value like '2453.2'. */
  FUEL_CONSUMPTION?: InputMaybe<Scalars['String']['input']>;
  /** Fuel level of the current lap. Could be a KPI like 'ERESSRaceFIA.Lap.Last' or a fixed value like '90.3'. */
  FUEL_LEVEL?: InputMaybe<Scalars['String']['input']>;
  /** Effective distance of the current lap. COuld be a KPI like 'ELap.Lap.Integral' or a fixed valued like '10.4'. */
  LAP_DISTANCE?: InputMaybe<Scalars['String']['input']>;
  /** Contains the folder, where the exported WinTAX files are stored. */
  OUTPUT_PATH?: InputMaybe<Scalars['String']['input']>;
  SIMULATE_CALLS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contains the folder, where the TelDataZtx dll files are stored. */
  TELDATAZTX_PATH?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarDataServiceProcessingEngineConfigInput = {
  Calculations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Exporters?: InputMaybe<UpdateByIdCarDataServiceProcessingEngineConfigExportersInput>;
  Importer?: InputMaybe<EnumCarDataServiceProcessingEngineConfigImporter>;
  Instances?: InputMaybe<Scalars['Float']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  QueueName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarDataServiceProcessingEnginesConfigInput = {
  ExportersFolder?: InputMaybe<Scalars['String']['input']>;
  ImportersFolder?: InputMaybe<Scalars['String']['input']>;
  InternalCalculationsFolder?: InputMaybe<Scalars['String']['input']>;
  ORHCalculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  ParameterMapFile?: InputMaybe<Scalars['String']['input']>;
  ProcessingEngineConfiguration?: InputMaybe<Array<InputMaybe<UpdateByIdCarDataServiceProcessingEngineConfigInput>>>;
  UserCalculationsFolder?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarDataServiceQueueDefinitionInput = {
  Name?: InputMaybe<Scalars['String']['input']>;
  SessionType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarDataServiceQueueManagerConfigInput = {
  Queues?: InputMaybe<Array<InputMaybe<UpdateByIdCarDataServiceQueueDefinitionInput>>>;
};

export type UpdateByIdCarDataServiceSessionManagerConfigInput = {
  OffloadFolder?: InputMaybe<Scalars['String']['input']>;
  OffloadSessionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdCarDataServiceSessionTypeConfigInput = {
  exts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  folderUpLevel?: InputMaybe<Scalars['Int']['input']>;
  ignoreLiterals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  regExpressions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarDataServiceSessionTypesConfigInput = {
  SessionTypes?: InputMaybe<Array<InputMaybe<UpdateByIdCarDataServiceSessionTypeConfigInput>>>;
};

export type UpdateByIdCarEndInput = {
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<Scalars['Float']['input']>;
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  antiRollBar?: InputMaybe<AntiRollBarInput>;
  bumpStop?: InputMaybe<BumpStopInput>;
  damper?: InputMaybe<DamperInput>;
  droopStop?: InputMaybe<DroopStopInput>;
  externalBumpStop?: InputMaybe<ExternalBumpStopInput>;
  hRide?: InputMaybe<Scalars['Float']['input']>;
  hRideChassis?: InputMaybe<Scalars['Float']['input']>;
  /** Point where the mechanic is measuring the ride height */
  hRideMeasurement?: InputMaybe<Scalars['Float']['input']>;
  /** Baseline pushrod length, steering rack bumpsteer adjust might depend on the rough range of ride heights the car is running in. */
  hRideRange?: InputMaybe<Scalars['String']['input']>;
  /** Point where the regulation authority is measuring the ride height */
  hRideRegulation?: InputMaybe<Scalars['Float']['input']>;
  helperSpring?: InputMaybe<SpringInput>;
  kinematics?: InputMaybe<KinematicsInput>;
  kinematicsExternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  kinematicsInternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  reboundSpring?: InputMaybe<SpringInput>;
  spring?: InputMaybe<SpringInput>;
  thirdElement?: InputMaybe<ThirdElementInput>;
  xToe?: InputMaybe<Scalars['Float']['input']>;
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdCarInfoInput = {
  /** Number of changes */
  NChanges?: InputMaybe<Scalars['Float']['input']>;
  /** Number of issues */
  NIssue?: InputMaybe<Scalars['Float']['input']>;
  batteryID?: InputMaybe<Scalars['String']['input']>;
  chassisID?: InputMaybe<Scalars['String']['input']>;
  /** A map of custom IDs for this setup. Input syntax is array of key-value (string-string) tuples. */
  customIDs?: InputMaybe<Scalars['JSON']['input']>;
  driveshaftID?: InputMaybe<Scalars['String']['input']>;
  engineID?: InputMaybe<Scalars['String']['input']>;
  gearboxID?: InputMaybe<Scalars['String']['input']>;
  inverterID?: InputMaybe<Scalars['String']['input']>;
  setupComments?: InputMaybe<Scalars['String']['input']>;
  /** Tyre compound for which this setup is intended */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarMassInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Front-left mass */
  mCarFL?: InputMaybe<Scalars['Float']['input']>;
  /** Front-right mass */
  mCarFR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-left mass */
  mCarRL?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-right mass */
  mCarRR?: InputMaybe<Scalars['Float']['input']>;
  /** Driver mass */
  mDriver?: InputMaybe<Scalars['Float']['input']>;
  /** Target portion of mass in the front of the car */
  rWeightFTarget?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdCarSetupInput = {
  aero?: InputMaybe<UpdateByIdAeroInput>;
  aeroPackage?: InputMaybe<UpdateByIdAeroPackageInput>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  brakeSystem?: InputMaybe<UpdateByIdBrakeSystemInput>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecRootID?: InputMaybe<Scalars['MongoID']['input']>;
  cockpit?: InputMaybe<UpdateByIdCockpitInput>;
  custom?: InputMaybe<Scalars['JSON']['input']>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  /** Enable custom simulation payload for this setup. You as a user are responsible to have meaningful data in there. */
  customSimulationPayloadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  engineerID?: InputMaybe<Scalars['MongoID']['input']>;
  flattened?: InputMaybe<Scalars['JSON']['input']>;
  front?: InputMaybe<UpdateByIdCarEndInput>;
  frontLeft?: InputMaybe<UpdateByIdCarCornerInput>;
  frontRight?: InputMaybe<UpdateByIdCarCornerInput>;
  historyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  info?: InputMaybe<UpdateByIdCarInfoInput>;
  intendedForSession?: InputMaybe<EnumCarSetupIntendedForSession>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Map of ballast positions to their masses. Keys are names of the positions and values are the masses. Input syntax is array of key-value tuples, like `mBallasts: [["front", 10], ["rear", 20]]`. */
  mBallasts?: InputMaybe<Scalars['JSON']['input']>;
  manualEndMileage?: InputMaybe<Scalars['Float']['input']>;
  manualStartMileage?: InputMaybe<Scalars['Float']['input']>;
  /** Mass out of garage (with driver in the seat) */
  massOutOfGarage?: InputMaybe<UpdateByIdCarMassInput>;
  /** Mass at the scales of the regulatory authority */
  massRegulation?: InputMaybe<UpdateByIdCarMassInput>;
  /** Mass from car setup */
  massSetup?: InputMaybe<UpdateByIdCarMassInput>;
  /** Mass from regulation scale replica in garage (team's scales) */
  massTeam?: InputMaybe<UpdateByIdCarMassInput>;
  powertrain?: InputMaybe<UpdateByIdPowertrainInput>;
  powertrainCentral?: InputMaybe<UpdateByIdPowertrainInput>;
  powertrainFront?: InputMaybe<UpdateByIdPowertrainInput>;
  powertrainRear?: InputMaybe<UpdateByIdPowertrainInput>;
  rear?: InputMaybe<UpdateByIdCarEndInput>;
  rearLeft?: InputMaybe<UpdateByIdCarCornerInput>;
  rearRight?: InputMaybe<UpdateByIdCarCornerInput>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Small info string */
  setupInfo?: InputMaybe<Scalars['String']['input']>;
  /** Override of setup sheet style, which usually comes from the chassis. */
  setupSheetStyle?: InputMaybe<EnumCarSetupSetupSheetStyle>;
  steering?: InputMaybe<UpdateByIdSteeringInput>;
  /** Map containing systems config comments. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigComment?: InputMaybe<Scalars['JSON']['input']>;
  /** Map containing systems config NIssue data. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigNIssues?: InputMaybe<Scalars['JSON']['input']>;
  /** Map containing systems config values. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigValues?: InputMaybe<Scalars['JSON']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
  writeHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdCarSetupPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CarSetup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdChassisAssemblyMeasurementInput = {
  chassisSpecMeasurementID?: InputMaybe<Scalars['MongoID']['input']>;
  location?: InputMaybe<UpdateByIdAdjustableLocationInput>;
  orientation?: InputMaybe<UpdateByIdAdjustableOrientationInput>;
};

export type UpdateByIdChassisAssemblyTrackingSourceRecordInput = {
  sources?: InputMaybe<Array<InputMaybe<UpdateByIdChassisAssemblyTrackingSourceRecordSourcesInput>>>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdChassisAssemblyTrackingSourceRecordSourcesInput = {
  /** priority of this source. Defined on the alias but saved here for efficiency reasons */
  priority?: InputMaybe<Scalars['Float']['input']>;
  trackingSourceAliasID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdChassisInput = {
  /** Allowable keys for ballast measurements in car setups that use this chassis. */
  ballastPositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  currentlyInUse?: InputMaybe<Scalars['Boolean']['input']>;
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerPartID?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  /** Unique identifier for the chassis */
  reference?: InputMaybe<Scalars['String']['input']>;
  rootAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Map of setup sheet fields to available preset values. Keys are like `"front.kSpringF"`, and values are lists of options. Input syntax is array of key-value tuples, like `setupOptions: [["front.kSpringF", [100, 110, 120]]]`. */
  setupOptions?: InputMaybe<Scalars['JSON']['input']>;
  setupSheetStyle?: InputMaybe<EnumChassisSetupSheetStyle>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Allowable keys for systems config maps in car setups that use this chassis. */
  systemsConfigFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Car type */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdChassisMassInput = {
  /** Base mass properties of the vehicle */
  base?: InputMaybe<UpdateByIdMassPropertiesInput>;
  /** Mass properties of the driver */
  driver?: InputMaybe<UpdateByIdMassPropertiesInput>;
  setupEquip?: InputMaybe<UpdateByIdMassPropertiesInput>;
};

export type UpdateByIdChassisMeasurementInput = {
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdChassisMeasurementPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ChassisMeasurement>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdChassisMeasurementsInput = {
  /** Default angle unit to display in setup options for this chassis */
  angles?: InputMaybe<EnumAngleUnit>;
  /** Default angular compliance unit to display in setup options for this chassis */
  angularCompliances?: InputMaybe<EnumAngularComplianceUnit>;
  /** Default angular torque compliance unit to display in setup options for this chassis */
  angularTorqueCompliances?: InputMaybe<EnumAngularTorqueComplianceUnit>;
  bumpPlateMeasurementMethod?: InputMaybe<EnumBumpPlateMeasurementMethod>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefFront?: InputMaybe<Scalars['Float']['input']>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefRear?: InputMaybe<Scalars['Float']['input']>;
  /** Default compliance unit to display in setup options for this chassis */
  compliances?: InputMaybe<EnumComplianceUnit>;
  /** Default force unit to display in setup options for this chassis */
  forces?: InputMaybe<EnumForceUnit>;
  /** Default inertia unit to display in setup options for this chassis */
  inertias?: InputMaybe<EnumInertiaUnit>;
  /** If true, positive camber is top leaning in. If false, negative camber is top leaning in. */
  inverseCamber?: InputMaybe<Scalars['Boolean']['input']>;
  kinematicsExternalReadingsRequired?: InputMaybe<EnumChassisMeasurementsKinematicsExternalReadingsRequired>;
  kinematicsInternalReadingsRequired?: InputMaybe<EnumChassisMeasurementsKinematicsInternalReadingsRequired>;
  /** Default length unit to display in setup options for this chassis */
  lengths?: InputMaybe<EnumLengthUnit>;
  /** Default mass unit to display in setup options for this chassis */
  masses?: InputMaybe<EnumMassUnit>;
  /** Default power unit to display in setup options for this chassis */
  powers?: InputMaybe<EnumPowerUnit>;
  /** Default pressure unit to display in setup options for this chassis */
  pressures?: InputMaybe<EnumPressureUnit>;
  /** Default ratio unit to display in setup options for this chassis */
  ratios?: InputMaybe<EnumRatioUnit>;
  /** Function to calculate front ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcFront?: InputMaybe<Scalars['String']['input']>;
  /** Function to calculate rear ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcRear?: InputMaybe<Scalars['String']['input']>;
  /** Default spring rate unit to display in setup options for this chassis */
  springRates?: InputMaybe<EnumSpringRateUnit>;
  /** Default steering rack ratio unit to display in setup options for this chassis */
  steeringRackRatios?: InputMaybe<EnumSteeringRackRatioUnit>;
  /** Default temperature unit to display in setup options for this chassis */
  temperatures?: InputMaybe<EnumTemperatureUnit>;
  toeMeasurementMethod?: InputMaybe<EnumToeMeasurementMethod>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefFront?: InputMaybe<Scalars['Float']['input']>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefRear?: InputMaybe<Scalars['Float']['input']>;
  /** If true, toe measurement is given as total over axle. If false, toe measurement is per individual wheel. */
  toeTotal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default torque unit to display in setup options for this chassis */
  torques?: InputMaybe<EnumTorqueUnit>;
  /** Default torsion rate unit to display in setup options for this chassis */
  torsionRates?: InputMaybe<EnumTorsionRateUnit>;
  /** Default volume unit to display in setup options for this chassis */
  volumes?: InputMaybe<EnumVolumeUnit>;
  xTrackFront?: InputMaybe<Scalars['Float']['input']>;
  xTrackRear?: InputMaybe<Scalars['Float']['input']>;
  /** Wheelbase length in metres */
  xWheelbase?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdChassisPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Chassis>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdChassisPowerUnitInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdChassisPowertrainInput = {
  bevelSetSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  differentialSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  dropGearSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  gearBoxSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  gearSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  layout?: InputMaybe<EnumPowertrainLayout>;
  /** Number of gears which are expected to be in the gearbox. */
  numGears?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdChassisSocketInput = {
  /** Unique name for this socket. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCockpitInput = {
  /** Ratio of the throttle pedal */
  rThrottlePedal?: InputMaybe<Scalars['Float']['input']>;
  /** Position of the throttle pedal */
  throttlePedalPosition?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCommentInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdContestantInput = {
  /** IDs of usable chassis */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Number of the chassis for this contestant. */
  chassisNumber?: InputMaybe<Scalars['String']['input']>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** Default color to use for this contestant where applicable. */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Drivers that constitute this contestant */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Is this contestant eligible for points? */
  eligibleForPoints?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this contestant be hidden from users? */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Season that this contestant is participating in */
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyContestantID?: InputMaybe<Scalars['String']['input']>;
  /** URI to the audio stream for this contestant in Transcribble. */
  transcribbleAudioURI?: InputMaybe<Scalars['String']['input']>;
  /** Tyres assigned to this contestant for the season. */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Tyre sets assigned to this contestant for the season. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdContestantPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Contestant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCurrentInput = {
  /** A */
  amps?: InputMaybe<Scalars['Float']['input']>;
  /** mA */
  milliamps?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDamperAdjusterInput = {
  /** Maximum setting, if using min/max/step */
  maxSetting?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum setting, if using min/max/step */
  minSetting?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settingNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Increment to suggest values in, if using min/max/step */
  step?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDamperConfigInput = {
  forceTable?: InputMaybe<UpdateByIdForceTableInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Define which damper clicks are associated with this setting */
  settings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdDampingRateInput = {
  /** Nms/m */
  newtonSecondsPerMetre?: InputMaybe<Scalars['Float']['input']>;
  /** Nms/mm */
  newtonSecondsPerMillimetre?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·s/in */
  poundForceSecondsPerInch?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDashboardInput = {
  /** Dashboard reading of fuel remaining at the end of the run */
  mFuelRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Dashboard reading of fuel amount at the start of the run */
  mFuelRunStart?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDefaultFlexLayoutConfigsInput = {
  BOP?: InputMaybe<Scalars['MongoID']['input']>;
  KPI?: InputMaybe<Scalars['MongoID']['input']>;
  REPORT?: InputMaybe<Scalars['MongoID']['input']>;
  RUNSHEET?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPOVERVIEW?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPSANDBOX?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPSHEET?: InputMaybe<Scalars['MongoID']['input']>;
  SIMULATION?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdDensityInput = {
  /** kg/m³ */
  kilogramsPerCubicMetre?: InputMaybe<Scalars['Float']['input']>;
  /** kg/L */
  kilogramsPerLitre?: InputMaybe<Scalars['Float']['input']>;
  /** lb/ft³ */
  poundsPerCubicFoot?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDepartmentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdDepartmentPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Department>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdDifferentialConfigInput = {
  /** Is this differential config allowed to be selected in new car setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  frictionFaces?: InputMaybe<Scalars['String']['input']>;
  maxPreloadForce?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rampAccel?: InputMaybe<Scalars['Float']['input']>;
  rampDecel?: InputMaybe<Scalars['Float']['input']>;
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdDriverChampionshipStandingInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  points: Scalars['Int']['input'];
  /** Historical race finish positions of this driver in this season. Null values represent DNFs. Should only be used for pre-session standings data. */
  prevRacePositions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: InputMaybe<Scalars['Int']['input']>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdDynoConfigColumnsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** runSheet.tyreSetID, setup.mCar, etc. */
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  /** Tyre, Weight, etc. */
  header?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdDynoConfigInput = {
  columns?: InputMaybe<Array<InputMaybe<UpdateByIdDynoConfigColumnsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdDynoConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<DynoConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdEnergyInput = {
  /** J */
  joules?: InputMaybe<Scalars['Float']['input']>;
  /** kJ */
  kilojoules?: InputMaybe<Scalars['Float']['input']>;
  /** kWh */
  kilowattHours?: InputMaybe<Scalars['Float']['input']>;
  /** MJ */
  megajoules?: InputMaybe<Scalars['Float']['input']>;
  /** Wh */
  wattHours?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdEventContestantsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of chassis used, if different for this event. */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** IDs of drivers of this car, if different for this event. */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of tyres allocated to this contestant for this event (like during races where only tyres handed out at this very race are permitted). */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of tyre sets allocated to this contestant for this event. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdEventInput = {
  /** Density of the fuel */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Number of this event in the season */
  NEventSeason?: InputMaybe<Scalars['Float']['input']>;
  /** Default SoCRequired values to use during this event (assuming single track layout) */
  SoCRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Fuel/SoC/Energy consumptions for each track layout in this event. */
  consumptions?: InputMaybe<Array<InputMaybe<UpdateByIdLayoutConsumptionInput>>>;
  contestants?: InputMaybe<Array<InputMaybe<UpdateByIdEventContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumEventDebriefNotesMode>;
  /** Default energyRequired values to use during this event (assuming single track layout) */
  energyRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  /** Energy sweep information for Formula E */
  energySweep?: InputMaybe<Scalars['JSON']['input']>;
  enumEventType?: InputMaybe<EnumEventEnumEventType>;
  enumEventVenue?: InputMaybe<EnumEventEnumEventVenue>;
  /** e.g. Race, Test, etc. */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Default fuelRequired values to use during this event (assuming single track layout) */
  fuelRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  /** Should the iRacing service populate this event when an unknown event is encountered? */
  iRacingServiceIsNextEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of issues related to this event. */
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Reference laptimes for each track layout in this event. */
  referenceLaptimes?: InputMaybe<Array<InputMaybe<UpdateByIdEventReferenceLaptimesInput>>>;
  /** Selected authors for the event report (person reference plus a name snapshot). */
  reportAuthors?: InputMaybe<Array<InputMaybe<UpdateByIdEventReportAuthorsInput>>>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Time of event end in local time */
  tEventEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of event start in local time */
  tEventStart?: InputMaybe<Scalars['Date']['input']>;
  tLapAverage?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyEventID?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  trackID?: InputMaybe<Scalars['MongoID']['input']>;
  trackLayoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumEventType>;
  tyreDefaults?: InputMaybe<Array<InputMaybe<UpdateByIdEventTyreDefaultsSetInput>>>;
  tyreDefaultsFL?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsFR?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsRL?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsRR?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsWetFL?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsWetFR?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsWetRL?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsWetRR?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
};

export type UpdateByIdEventPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdEventReferenceLaptimesInput = {
  /** Reference Laptime for ATTACK lap */
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for COOL lap */
  COOL?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for FCY lap */
  FCY?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for IN lap */
  IN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for OUT lap */
  OUT?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for OUTIN lap */
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PITLANE lap */
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PREP lap */
  PREP?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PUSH lap */
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for QUALI lap */
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SAFETYCAR lap */
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SHAKEDOWN lap */
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SLOW lap */
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TARGET lap */
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOGRID lap */
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOPADDOCK lap */
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOPITS lap */
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for UNFINISHED lap */
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
  calculationMethod?: InputMaybe<EnumEventReferenceLaptimesCalculationMethod>;
  /** Reference Laptime when using the calculation method "RATIO" */
  referenceLaptime?: InputMaybe<Scalars['Float']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdEventReportAuthorsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdEventTyreDefaultsInput = {
  /** Suggested bare minimum tyre pressure for this event. */
  pTyreMin?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested minimum pressure at the start of a run for this event. */
  pTyreMinStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested pressure at the start of a run for this event. */
  pTyreStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested tyre pressure target for this event. */
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdEventTyreDefaultsSetInput = {
  frontLeft?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  frontRight?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  rearLeft?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  rearRight?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  /** Which compound should these defaults be applied on? */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
  /** Which tyre type should these defaults be applied on? */
  tyreType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFlexLayoutConfigGlobalXAxisInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  gain?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumFlexLayoutConfigGlobalXAxisType>;
};

export type UpdateByIdFlexLayoutConfigInput = {
  globalXAxis?: InputMaybe<UpdateByIdFlexLayoutConfigGlobalXAxisInput>;
  intendedFor?: InputMaybe<EnumFlexLayoutConfigIntendedFor>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration recognised by flexlayout-react */
  model?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** If this is non-empty, only users with one of these roles can see this config. */
  targetRoles?: InputMaybe<Array<EnumPersonRole>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFlexLayoutConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<FlexLayoutConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdForceInput = {
  /** N */
  newtons?: InputMaybe<Scalars['Float']['input']>;
  /** lbf */
  poundsForce?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdForceTableInput = {
  /** Acceleration (ddx) values */
  acceleration?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F1 */
  dampingForce?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F0 */
  force?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F2 */
  inertanceForce?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Velocity (dx) values */
  velocity?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Displacement values */
  x?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  xMax?: InputMaybe<Scalars['Float']['input']>;
  xMin?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdFrequencyInput = {
  /** Hz */
  hertz?: InputMaybe<Scalars['Float']['input']>;
  /** kHz */
  kilohertz?: InputMaybe<Scalars['Float']['input']>;
  /** MHz */
  megahertz?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdGenericRunSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  blockBackgroundColour?: InputMaybe<Scalars['String']['input']>;
  brakeFields?: InputMaybe<Array<InputMaybe<EnumBrakeBlockField>>>;
  /** A map of colorable things to colors */
  colorMap?: InputMaybe<Scalars['JSON']['input']>;
  defaultOpenState?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order in which to display visible run energy fields. */
  energyFieldOrder?: InputMaybe<Array<InputMaybe<EnumGenericRunSheetStyleBlockEnergyFieldOrder>>>;
  /** Source of the lap end energy value */
  energyLapEndSource?: InputMaybe<Scalars['String']['input']>;
  energyType?: InputMaybe<EnumEnergyType>;
  field?: InputMaybe<Scalars['String']['input']>;
  /** Field name for first comment box in a double comment block. */
  field1?: InputMaybe<Scalars['String']['input']>;
  /** Field name for second comment box in a double comment block. */
  field2?: InputMaybe<Scalars['String']['input']>;
  fuelColumns?: InputMaybe<Array<EnumFuelColumn>>;
  fuelFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The height of the block within the grid */
  height?: InputMaybe<Scalars['Int']['input']>;
  isAlwaysOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isShownWhenFolded?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Label on first comment box in a double comment block. */
  label1?: InputMaybe<Scalars['String']['input']>;
  /** Label on second comment box in a double comment block. */
  label2?: InputMaybe<Scalars['String']['input']>;
  /** Ordered columns to show in the lap table */
  lapColumns?: InputMaybe<Array<InputMaybe<UpdateByIdLapColumnInput>>>;
  lapCountBlockFieldOrder?: InputMaybe<Array<InputMaybe<UpdateByIdGenericRunSheetStyleBlockLapCountBlockFieldOrderInput>>>;
  lapFlags?: InputMaybe<UpdateByIdLapFlagLabelsInput>;
  /** Names of lapKPI fields to show */
  lapKPIs?: InputMaybe<Array<InputMaybe<UpdateByIdGenericRunSheetStyleBlockLapKpIsInput>>>;
  manualLapInputByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  mileageUnit?: InputMaybe<EnumLengthUnit>;
  pressureUnit?: InputMaybe<EnumPressureUnit>;
  rows?: InputMaybe<Scalars['Float']['input']>;
  /** Order in which to display visible run energy fields. */
  runEnergyFieldOrder?: InputMaybe<Array<EnumRunEnergyField>>;
  runEnergyFields?: InputMaybe<UpdateByIdRunEnergyFieldLabelsInput>;
  runKPIRows?: InputMaybe<Array<InputMaybe<UpdateByIdRunKpiTableRowInput>>>;
  runKPITable?: InputMaybe<Array<InputMaybe<UpdateByIdGenericRunSheetStyleBlockRunKpiTableInput>>>;
  setupSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Defines the visibility of the ambient and track condition in the weather block */
  showAmbientAndTrackCondition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the extended combustion consumption fields. */
  showExtendedConsumptionFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the fuel density input box. */
  showFuelDensityInput?: InputMaybe<Scalars['Boolean']['input']>;
  showGetPreviousRunPostPressureButton?: InputMaybe<Scalars['Boolean']['input']>;
  showGetRecommendationButton?: InputMaybe<Scalars['Boolean']['input']>;
  showLapTypeColors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the maximum amount of laps per consumption for a given fuel load fields. */
  showMaxLapsPerConsumptionFields?: InputMaybe<Scalars['Boolean']['input']>;
  showMinimumPressures?: InputMaybe<Scalars['Boolean']['input']>;
  showOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  showPostRunBrakeTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showPreRunBrakeTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showSurfaceTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showTargetPressures?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreReferencePressure?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreSelector?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreSetSelector?: InputMaybe<Scalars['Boolean']['input']>;
  staggerSettings?: InputMaybe<UpdateByIdGenericRunSheetStyleBlockStaggerSettingsInput>;
  standardTyrePressureBox?: InputMaybe<UpdateByIdGenericRunSheetStyleBlockStandardTyrePressureBoxInput>;
  standardTyreTempBox?: InputMaybe<UpdateByIdGenericRunSheetStyleBlockStandardTyreTempBoxInput>;
  style?: InputMaybe<EnumRunSheetStyleBlockStyle>;
  temperatureUnit?: InputMaybe<EnumTemperatureUnit>;
  title?: InputMaybe<Scalars['String']['input']>;
  treadDepthUnit?: InputMaybe<EnumLengthUnit>;
  type?: InputMaybe<EnumGenericRunSheetStyleBlockType>;
  tyreTableRows?: InputMaybe<Array<InputMaybe<UpdateByIdTyreTableBlockRowInput>>>;
  /** Number of tread depth measurements to allow. Use `0` or `null` to hide the input. */
  tyreTreadDepthMeasurements?: InputMaybe<Scalars['Int']['input']>;
  unitSystem?: InputMaybe<EnumUnitSystem>;
  velocityUnit?: InputMaybe<EnumVelocityUnit>;
  /** Ordered weather block fields to show */
  weatherFieldOrder?: InputMaybe<Array<EnumWeatherBlockField>>;
  /** The width of the block within the grid */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateByIdGenericRunSheetStyleBlockLapCountBlockFieldOrderInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  field?: InputMaybe<EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField>;
  show?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdGenericRunSheetStyleBlockLapKpIsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<UpdateByIdValueLimitInput>;
  upperLimit?: InputMaybe<UpdateByIdValueLimitInput>;
};

export type UpdateByIdGenericRunSheetStyleBlockRunKpiTableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  defaultEditable?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<InputMaybe<UpdateByIdGenericRunSheetStyleBlockRunKpiTableRowsInput>>>;
};

export type UpdateByIdGenericRunSheetStyleBlockRunKpiTableRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<UpdateByIdRunKpiTableRowFieldInput>>>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdGenericRunSheetStyleBlockStaggerSettingsInput = {
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumLengthUnit>;
};

export type UpdateByIdGenericRunSheetStyleBlockStandardTyrePressureBoxInput = {
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<EnumPressureOption>>>;
  unit?: InputMaybe<EnumPressureUnit>;
};

export type UpdateByIdGenericRunSheetStyleBlockStandardTyreTempBoxInput = {
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<EnumTemperatureOption>>>;
  unit?: InputMaybe<EnumTemperatureUnit>;
};

export type UpdateByIdGeoLocationInput = {
  /** [longitude, latitude] in decimal degrees */
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Only "Point" is supported */
  type?: InputMaybe<EnumGeoLocationType>;
};

export type UpdateByIdIssueInput = {
  acknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  acknowledgedByID?: InputMaybe<Scalars['MongoID']['input']>;
  area?: InputMaybe<Scalars['String']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledByID?: InputMaybe<Scalars['MongoID']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedByID?: InputMaybe<Scalars['MongoID']['input']>;
  comments?: InputMaybe<Array<InputMaybe<UpdateByIdCommentInput>>>;
  containment?: InputMaybe<Scalars['String']['input']>;
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  createdByID?: InputMaybe<Scalars['MongoID']['input']>;
  departmentID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDetails?: InputMaybe<Scalars['String']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  issueStatus?: InputMaybe<EnumIssueIssueStatus>;
  linkedIssueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTagID?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTagLabelSort?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<EnumIssuePriority>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  rootCause?: InputMaybe<Scalars['String']['input']>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  thirdPartyIssueID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdIssuePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Issue>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdJobInput = {
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  /** The id of the parent job or issue that this task is assigned to */
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdJobPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Job>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdKinematicsExternalModelInput = {
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  uprightPosition?: InputMaybe<Scalars['Float']['input']>;
  uprightPositionName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLapColumnInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<EnumLapColumnField>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<UpdateByIdValueLimitInput>;
  upperLimit?: InputMaybe<UpdateByIdValueLimitInput>;
};

export type UpdateByIdLapDataInput = {
  /** Was DRS used in this lap? */
  BDRSUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this laptime slow and should be excluded from average calculation? */
  BLapIsSlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Received a Track Limit Warning from Race Control */
  BTrackLimitWarning?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cell temperature */
  TCell?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Coded message from driver */
  driverCallout?: InputMaybe<Scalars['String']['input']>;
  /** Coded message from driver */
  driverCallout2?: InputMaybe<Scalars['String']['input']>;
  /** Map of kpi fields to their values for analysis. Input syntax is array of tuples, like `kpi: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  kpi?: InputMaybe<Scalars['JSON']['input']>;
  lapType?: InputMaybe<Scalars['String']['input']>;
  /** Fuel mass consumption in this lap */
  mFuelConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel mass remaining at the end of this lap. */
  mFuelLapEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: InputMaybe<Scalars['Float']['input']>;
  /** Energy comsumption in this lap (kWh) */
  rEnergyConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Energy remaining (kWh)  at the end of this lap. */
  rEnergyLapEnd?: InputMaybe<Scalars['Float']['input']>;
  /** SoC comsumption in this lap (%) */
  rSOCConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** SOC (%) remaining at the end of this lap. */
  rSOCLapEnd?: InputMaybe<Scalars['Float']['input']>;
  raceControlMessage?: InputMaybe<Scalars['String']['input']>;
  /** Source of the lap data */
  source?: InputMaybe<EnumLapDataSource>;
  /** Time at which this lap was completed. */
  tDay?: InputMaybe<Scalars['Date']['input']>;
  /** If this is an IN lap, indicates when the driver crossed the pit entry line. */
  tDayPitIn?: InputMaybe<Scalars['Date']['input']>;
  /** If this is an OUT lap, indicates when the driver crossed the pit exit line. */
  tDayPitOut?: InputMaybe<Scalars['Date']['input']>;
  /** Time of day of each sector. */
  tDaySectors?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** Time spent in pits if the lap started from the pit lane. */
  tInPit?: InputMaybe<Scalars['Float']['input']>;
  /** Laptime */
  tLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Sectore times. */
  tSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tSessionRemainingLapStart?: InputMaybe<Scalars['Float']['input']>;
  trackStates?: InputMaybe<Array<InputMaybe<UpdateByIdTrackStateInput>>>;
  /** Tyre compound information */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
  /** Official topspeed measurement */
  vCarLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Official speed measurements per sector */
  vCarSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** Lap flag field labels mapped to their display names. Null or unset fields are not displayed. */
export type UpdateByIdLapFlagLabelsInput = {
  ATTACK?: InputMaybe<Scalars['String']['input']>;
  COOL?: InputMaybe<Scalars['String']['input']>;
  FCY?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Scalars['String']['input']>;
  OUT?: InputMaybe<Scalars['String']['input']>;
  OUTIN?: InputMaybe<Scalars['String']['input']>;
  PITLANE?: InputMaybe<Scalars['String']['input']>;
  PREP?: InputMaybe<Scalars['String']['input']>;
  PUSH?: InputMaybe<Scalars['String']['input']>;
  QUALI?: InputMaybe<Scalars['String']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['String']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['String']['input']>;
  SLOW?: InputMaybe<Scalars['String']['input']>;
  TARGET?: InputMaybe<Scalars['String']['input']>;
  TOGRID?: InputMaybe<Scalars['String']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['String']['input']>;
  TOPITS?: InputMaybe<Scalars['String']['input']>;
  UNFINISHED?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLapInput = {
  /** Was DRS used in this lap? */
  BDRSUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this laptime slow? */
  BLapIsSlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this an IN lap? */
  BPitIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this an OUT lap? */
  BPitOut?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lap number in run from timing */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in run from car data */
  NLapRunCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in run from manual mode */
  NLapRunManual?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in session from timing */
  NLapSession?: InputMaybe<Scalars['Int']['input']>;
  /** Lap number in session from car data */
  NLapSessionCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in session from manual mode */
  NLapSessionManual?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from timing */
  NLapStint?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from car data */
  NLapStintCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from manual mode */
  NLapStintManual?: InputMaybe<Scalars['Float']['input']>;
  /** Cell temperature */
  TCell?: InputMaybe<Scalars['Float']['input']>;
  data?: InputMaybe<Array<InputMaybe<UpdateByIdLapDataInput>>>;
  /** Amount of energy (fuel/battery) at the start of this lap. */
  energyLapStart?: InputMaybe<Scalars['Float']['input']>;
  /** Energy or fuel remaining */
  energyRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** Energy or fuel remaining as data input (e.g. from telemetry) */
  energyRemainingData?: InputMaybe<Scalars['Float']['input']>;
  fuelConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Comments made by the driver */
  lapComment?: InputMaybe<Scalars['String']['input']>;
  /** Systems info generated during the lap */
  lapCommentSystems?: InputMaybe<Scalars['String']['input']>;
  /** Map of lap KPI fields to their values for car-data-related analysis. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  lapKPI?: InputMaybe<Scalars['JSON']['input']>;
  lapType?: InputMaybe<Scalars['String']['input']>;
  laptimeServiceHash?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: InputMaybe<Scalars['Float']['input']>;
  rEnergyConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  rSOCConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  raceControlMessage?: InputMaybe<Scalars['String']['input']>;
  /** The run sheet this lap belongs to. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time at which this lap was completed. */
  tDay?: InputMaybe<Scalars['Date']['input']>;
  /** Time of day of each sector, provided by a timing service. */
  tDaySectors?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** Laptime where input directly by a user. */
  tLapManual?: InputMaybe<Scalars['Float']['input']>;
  /** Laptime */
  tLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Sectore times given manually by a user. */
  tSectorsManual?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Sector times as given by an alternative official source. */
  tSectorsOfficial?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Sector times as given by a timing service. */
  tSectorsTiming?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Map of timing KPI fields to their values for timing-related analysis. Input syntax is array of tuples, like `timingKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  timingKPI?: InputMaybe<Scalars['JSON']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  trackStates?: InputMaybe<Array<InputMaybe<UpdateByIdTrackStateInput>>>;
  /** Tyre compound information from timing stream */
  tyreCompoundTiming?: InputMaybe<Scalars['String']['input']>;
  /** Official topspeed measurement */
  vCarLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Official speed measurements per sector */
  vCarSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdLapPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Lap>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdLapSequenceInput = {
  laps?: InputMaybe<Array<InputMaybe<UpdateByIdLapSequenceLapsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdLapSequenceLapsInput = {
  NLap?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lapType?: InputMaybe<EnumLapSequenceLapsLapType>;
};

export type UpdateByIdLapSequencePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<LapSequence>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdLapSequenceTemplateInput = {
  laps?: InputMaybe<Array<InputMaybe<UpdateByIdLapSequenceTemplateLapsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdLapSequenceTemplateLapsInput = {
  /** Lap number in sequence */
  NLap?: InputMaybe<Scalars['Float']['input']>;
  lapType?: InputMaybe<EnumLapSequenceTemplateLapsLapType>;
};

export type UpdateByIdLapSequenceTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<LapSequenceTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

/** Collection of tuples defining bounds to automatically classify laps. Does not apply to in/out/race control lap types. Comparisons are to be made with `<` or `>=` at aligning bounds. Minimum value is 0 and maximum value is 1000000. */
export type UpdateByIdLaptimeThresholdsInput = {
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as cool. */
  cool?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as prep. */
  prep?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as push. */
  push?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as slow. */
  slow?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as target. */
  target?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type UpdateByIdLayoutConsumptionInput = {
  SoCRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  energyRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  fuelRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdLengthInput = {
  /** cm */
  centimetres?: InputMaybe<Scalars['Float']['input']>;
  /** ft */
  feet?: InputMaybe<Scalars['Float']['input']>;
  /** in */
  inches?: InputMaybe<Scalars['Float']['input']>;
  /** km */
  kilometres?: InputMaybe<Scalars['Float']['input']>;
  /** m */
  metres?: InputMaybe<Scalars['Float']['input']>;
  /** μm */
  micrometres?: InputMaybe<Scalars['Float']['input']>;
  /** mi */
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** mm */
  millimetres?: InputMaybe<Scalars['Float']['input']>;
  /** thou */
  thou?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdLiveStandingInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  currentLocation?: InputMaybe<EnumLiveStandingCurrentLocation>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  fastestLap?: InputMaybe<UpdateByIdBestValuesFastestLapInput>;
  fastestSectors?: InputMaybe<Array<InputMaybe<UpdateByIdBestValuesFastestSectorInput>>>;
  /** Does this driver have the fastest lap in the session? Only one driver should have this true at a time. */
  hasFastestLap?: InputMaybe<Scalars['Boolean']['input']>;
  lapsCompleted?: InputMaybe<Scalars['Int']['input']>;
  /** 1-indexed rank of this driver with respect to the rest of the grid */
  position?: InputMaybe<Scalars['Int']['input']>;
  postRacePenalty?: InputMaybe<UpdateByIdLiveStandingPostRacePenaltyInput>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLiveStandingPostRacePenaltyInput = {
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  totalTimePenalty?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdLocalConnectionInput = {
  dataMapping?: InputMaybe<EnumLocalConnectionDataMapping>;
  endPoint?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  outputFolder?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Float']['input']>;
  useSSL?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdLocationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<UpdateByIdGeoLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLocationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Location>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdLogInput = {
  logLevel?: InputMaybe<EnumLogLogLevel>;
  /** A single log from the source service */
  message?: InputMaybe<Scalars['String']['input']>;
  serviceSource?: InputMaybe<EnumLogServiceSource>;
  userID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdLogPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Log>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdManufacturerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdManufacturerPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Manufacturer>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdMassInput = {
  /** g */
  grams?: InputMaybe<Scalars['Float']['input']>;
  /** kg */
  kilograms?: InputMaybe<Scalars['Float']['input']>;
  /** mg */
  milligrams?: InputMaybe<Scalars['Float']['input']>;
  /** oz */
  ounces?: InputMaybe<Scalars['Float']['input']>;
  /** lb */
  pounds?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdMassPropertiesInput = {
  COGx?: InputMaybe<Scalars['Float']['input']>;
  COGy?: InputMaybe<Scalars['Float']['input']>;
  COGz?: InputMaybe<Scalars['Float']['input']>;
  Ixx?: InputMaybe<Scalars['Float']['input']>;
  Iyy?: InputMaybe<Scalars['Float']['input']>;
  Izz?: InputMaybe<Scalars['Float']['input']>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  /** Allowable mass range, for when a set mass value doesn't apply */
  massRange?: InputMaybe<AdjustableMassInput>;
};

export type UpdateByIdMomentOfInertiaInput = {
  /** kgm² */
  kilogramMetresSquared?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/s² */
  poundForceFeetSecondSquared?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdNotificationConfigInput = {
  faultAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  faultCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  faultStatusChanged?: InputMaybe<Scalars['Boolean']['input']>;
  jobAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  jobCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  jobStatusChanged?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdOneTimingWeatherServiceConfigInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event IDs to which the weather data should be published. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Weather station's latitude from geolocation */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  logLevel?: InputMaybe<EnumOneTimingWeatherServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weather station's longitude from geolocation */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Name for this set of configuration settings. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** One Timing server port. */
  timingPort?: InputMaybe<Scalars['Int']['input']>;
  /** One Timing server address. */
  timingURL?: InputMaybe<Scalars['String']['input']>;
  /** Time interval in seconds between two API data updates. */
  updateInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdOneTimingWeatherServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<OneTimingWeatherServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPackageInput = {
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<UpdateByIdPackageItemsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  useAsCopyReference?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdPackageItemsInput = {
  /** 'setup.front.hRide' or 'spec.specID.adjustables.adjIndex.LOCATION' */
  path?: InputMaybe<Scalars['String']['input']>;
  /** string | number | null (also can 'delete' certain things from a setup) */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdPackagePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Package>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPartInput = {
  /** Can this very part be used multiple times on a car. For 'virtual parts' or other special applications. Overrides the setting of the specification. */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  eligibleEventTypes?: InputMaybe<EnumPartEligibleEventTypes>;
  /** To be used for dummy parts or at user discretion for special applications. */
  isVirtualPart?: InputMaybe<Scalars['Boolean']['input']>;
  lifetimeMileage?: InputMaybe<Scalars['Float']['input']>;
  locationID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerPartID?: InputMaybe<Scalars['String']['input']>;
  manufacturerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  partStatus?: InputMaybe<UpdateByIdPartStatusInput>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  readingLocationOverride?: InputMaybe<Array<InputMaybe<EnumPartReadingLocationOverride>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  rootAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementHistoryIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdPartInstanceInput = {
  measurements?: InputMaybe<Array<InputMaybe<UpdateByIdPartInstanceMeasurementInput>>>;
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  readingLocation?: InputMaybe<EnumReadingLocation>;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemReferenceDate?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPartInstanceMeasurementCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPartInstanceMeasurementInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<UpdateByIdPartInstanceMeasurementCoordinatesInput>;
  floatValue?: InputMaybe<Scalars['Float']['input']>;
  idx?: InputMaybe<Scalars['Float']['input']>;
  rotation?: InputMaybe<UpdateByIdPartInstanceMeasurementRotationInput>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPartInstanceMeasurementRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPartInstancePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PartInstance>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPartPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Part>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPartStatusInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  statusComment?: InputMaybe<Scalars['String']['input']>;
  userEnumPartStatusID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdPersonInput = {
  /** 3-letter acronym for drivers */
  acronym?: InputMaybe<Scalars['String']['input']>;
  behaviour?: InputMaybe<UpdateByIdBehaviourConfigInput>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  canopyCredentials?: InputMaybe<UpdateByIdCanopyCredentialsInput>;
  carUpdateMethod?: InputMaybe<EnumPersonCarUpdateMethod>;
  /** IDs of contestants visible to this person when logged in. */
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultFlexLayoutConfigs?: InputMaybe<UpdateByIdDefaultFlexLayoutConfigsInput>;
  defaultRunSheetCompareStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStylePhoneID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultTyreReferenceTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** Default string for tyre set naming, where x=Chassis, i=Info, s=SetNumber, (c=Corner or a=Axle) */
  defaultTyreSetNameFormat?: InputMaybe<Scalars['String']['input']>;
  displayColor?: InputMaybe<Scalars['String']['input']>;
  dynoConfigID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of contestants editable to this person when logged in. */
  editableContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotificationConfig?: InputMaybe<UpdateByIdNotificationConfigInput>;
  /** IDs of events visible to this person when logged in. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this user be unable to see KPIs? */
  hideKPIs?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to track his working time? */
  isTimeTracker?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to see, update and approve working times for other users? */
  isTimeTrackerAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequenceTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  localConnections?: InputMaybe<Array<InputMaybe<UpdateByIdLocalConnectionInput>>>;
  mileageUnit?: InputMaybe<EnumLengthUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  passportPicture?: InputMaybe<Scalars['String']['input']>;
  /** Collection of favourite plot page config IDs. */
  plotPageConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  privateMobile?: InputMaybe<Scalars['Float']['input']>;
  privatePhone?: InputMaybe<Scalars['Float']['input']>;
  role?: InputMaybe<EnumPersonRole>;
  /** Collection of favourite setup overview config IDs. */
  setupOverviewConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  timeTrackerApprovalByPersonID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Collection of personal setup IDs. */
  userSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userSimulationSettings?: InputMaybe<UpdateByIdUserSimulationSettingsInput>;
  username?: InputMaybe<Scalars['String']['input']>;
  viewConfig?: InputMaybe<UpdateByIdViewConfigInput>;
  /** IDs of contestants visible to this person when logged in. */
  visibleContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of events visible to this person when logged in. */
  visibleEventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of teams visible to this person when logged in. */
  visibleTeamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  workMobile?: InputMaybe<Scalars['Float']['input']>;
  workPhone?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPersonPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Person>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPlotConfigInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  xAxisType?: InputMaybe<EnumPlotConfigXAxisType>;
  xDataSource?: InputMaybe<Scalars['String']['input']>;
  xLabel?: InputMaybe<Scalars['String']['input']>;
  /** Object containing at least `label`, and optionally `color`, `lineStyle` (from `EnumLineStyle`), and `marker` (from `EnumMarkerType`) properties */
  yData?: InputMaybe<Scalars['JSON']['input']>;
  yDataSource?: InputMaybe<Scalars['String']['input']>;
  yLabel?: InputMaybe<Scalars['String']['input']>;
  yLines?: InputMaybe<Array<InputMaybe<UpdateByIdPlotConfigLineInput>>>;
};

export type UpdateByIdPlotConfigLineInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<EnumLineStyle>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPlotPageConfigInput = {
  /** Number of columns in the grid. */
  gridCols?: InputMaybe<Scalars['Int']['input']>;
  /** Number of rows in the grid. */
  gridRows?: InputMaybe<Scalars['Int']['input']>;
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  plots?: InputMaybe<Array<InputMaybe<UpdateByIdPlotConfigInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdPlotPageConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PlotPageConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPointsSystemInput = {
  /** Array of points for the fastest lap */
  laptimeDriverPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Race position cutoff for drivers eligible for points for the fastest lap. In some race series you need to be in the top 10 to get the bonus point. */
  laptimePositionCutoff?: InputMaybe<Scalars['Float']['input']>;
  /** Array of points for the fastest lap for the teams. In some race series only the driver receives points for fastest lap. */
  laptimeTeamPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** How much race distance needs to be completed to be eligible for points */
  positionalCompletionMin?: InputMaybe<Scalars['Float']['input']>;
  /** How much race distance in % needs to be completed to be eligible for points */
  positionalCompletionMinRatio?: InputMaybe<Scalars['Float']['input']>;
  /** Array of driver points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalDriverPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Array of team points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalTeamPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sessionType?: InputMaybe<EnumSessionType>;
};

export type UpdateByIdPointsSystemPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PointsSystem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPowerInput = {
  /** 1hp = 745.6998715822702W */
  horsepowerMechanical?: InputMaybe<Scalars['Float']['input']>;
  /** kW */
  kilowatts?: InputMaybe<Scalars['Float']['input']>;
  /** W */
  watts?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPowertrainInput = {
  MDiffPreloadCold?: InputMaybe<Scalars['Float']['input']>;
  MDiffPreloadHot?: InputMaybe<Scalars['Float']['input']>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are arbitrary numbers. Input syntax is array of key-value tuples, like `NEngineBlanking: [["left", 5], ["right", 9]]`. */
  NEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  NFrictionFaces?: InputMaybe<Scalars['Float']['input']>;
  PPowerLevel?: InputMaybe<Scalars['Float']['input']>;
  aDiffRampCoast?: InputMaybe<Scalars['Float']['input']>;
  aDiffRampDrive?: InputMaybe<Scalars['Float']['input']>;
  bevelSet?: InputMaybe<PowertrainGearInput>;
  /** Map of blanking fields with values. Keys are strings like `gearboxRadiatorTapes` or `hRESSBlanking`, and values are strings describing the blanking details. Input syntax is array of key-value tuples, like `blanking: [["gearboxRadiatorTapes", "5"]]`. */
  blanking?: InputMaybe<Scalars['JSON']['input']>;
  clutch?: InputMaybe<Scalars['String']['input']>;
  clutchCylinder?: InputMaybe<Scalars['String']['input']>;
  dAirRestrictor?: InputMaybe<Scalars['Float']['input']>;
  /** Name of the selected configuration from the spec. */
  differentialConfigName?: InputMaybe<Scalars['String']['input']>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  dropGear?: InputMaybe<PowertrainGearInput>;
  /** Map of extra engine blanking measurement fields to their values. Input syntax is array of key-value tuples, like `engineBlankingComments: [["louvres", "NONE"], ["other", true]]`. */
  engineBlankingDetails?: InputMaybe<Scalars['JSON']['input']>;
  frictionFaces?: InputMaybe<Scalars['String']['input']>;
  gearboxGridType?: InputMaybe<Scalars['String']['input']>;
  gears?: InputMaybe<Array<InputMaybe<PowertrainStandardGearInput>>>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hEngineBlanking: [["left", 0.003], ["right", 0.004]]`. */
  hEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hGearboxBlanking: [["left", 0.003], ["right", 0.004]]`. */
  hGearboxBlanking?: InputMaybe<Scalars['JSON']['input']>;
  rBevelSet?: InputMaybe<Scalars['Float']['input']>;
  rDropGear?: InputMaybe<Scalars['Float']['input']>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rEngineBlanking: [["left", 0.05], ["right", 0.06]]`. */
  rEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gears to their ratios. Keys are strings like `"1"` or `"R"`, and values are ratios. Input syntax is array of key-value tuples, like `rGearRatios: [["R", 0.8], ["1", 0.3]]`. */
  rGearRatios?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rGearboxBlanking: [["left", 0.05], ["right", 0.06]]`. */
  rGearboxBlanking?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdPressureInput = {
  /** bar */
  bar?: InputMaybe<Scalars['Float']['input']>;
  /** inHg */
  inchesOfMercury?: InputMaybe<Scalars['Float']['input']>;
  /** kPa */
  kilopascals?: InputMaybe<Scalars['Float']['input']>;
  /** mbar */
  millibar?: InputMaybe<Scalars['Float']['input']>;
  /** Pa */
  pascals?: InputMaybe<Scalars['Float']['input']>;
  /** psi */
  psi?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdProjectPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Project>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdQualityCheckActionInput = {
  acknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  acknowledgedByID?: InputMaybe<Scalars['MongoID']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledByID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedByID?: InputMaybe<Scalars['MongoID']['input']>;
  comments?: InputMaybe<Array<InputMaybe<UpdateByIdCommentInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdByID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<EnumQualityCheckActionPriority>;
  status?: InputMaybe<EnumQualityCheckActionStatus>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdQualityCheckActionPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<QualityCheckAction>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdQualityCheckInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  qualityCheckActionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdQualityCheckPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<QualityCheck>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdRaceSeriesInput = {
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultJobListIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  driversPerCar?: InputMaybe<EnumRaceSeriesDriversPerCar>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  lapTypeConfig?: InputMaybe<UpdateByIdRaceSeriesLapTypeConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  seasonIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  sortingIndex?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdRaceSeriesLapTypeConfigInput = {
  ATTACK?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  COOL?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  FCY?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  IN?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  OUT?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  OUTIN?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  PITLANE?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  PREP?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  PUSH?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  QUALI?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  SAFETYCAR?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  SHAKEDOWN?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  SLOW?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  TARGET?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  TOGRID?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  TOPADDOCK?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  TOPITS?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  UNFINISHED?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
};

export type UpdateByIdRaceSeriesLapTypeEntryInput = {
  displayString: Scalars['String']['input'];
  lapTypeColor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateByIdRaceSeriesPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<RaceSeries>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdRadioMessageInput = {
  /** Time at which the audio message arrived in the queue for transcribing. */
  arrivedInQueueAt?: InputMaybe<Scalars['Date']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  /** Length of the audio message in seconds. */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** Time at which the audio message was taken by a transcription service. */
  takenByTranscriberAt?: InputMaybe<Scalars['Date']['input']>;
  /** The text of the message, as transcribed by Transcribble. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Time at which this message began recording audio. */
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  /** Time at which the audio message was finished initial transcribing. */
  transcribedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdRadioMessagePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<RadioMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdRatioInput = {
  /** % */
  percent?: InputMaybe<Scalars['Float']['input']>;
  /** 0 = 0%, 1 = 100%, 1.5 = 150% */
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdRegulationSetInput = {
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  hRideFrontMin?: InputMaybe<Scalars['Float']['input']>;
  hRideRearMin?: InputMaybe<Scalars['Float']['input']>;
  massDistRunningMax?: InputMaybe<Scalars['Float']['input']>;
  massDistRunningMin?: InputMaybe<Scalars['Float']['input']>;
  massDistStaticMax?: InputMaybe<Scalars['Float']['input']>;
  massDistStaticMin?: InputMaybe<Scalars['Float']['input']>;
  massMin?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdReportTemplateAppendixInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdReportTemplateBopInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bopFileOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  layout?: InputMaybe<Scalars['JSON']['input']>;
  /** Either { source: 'current-event' } or { source: 'explicit', sessionIds: string[] } */
  selectedSessions?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdReportTemplateCarSetupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdReportTemplateExcludedNoteIDsInput = {
  pageAppendix?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageOverview?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageParts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageRunPlan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageSession?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdReportTemplateInput = {
  appendix?: InputMaybe<UpdateByIdReportTemplateAppendixInput>;
  bop?: InputMaybe<UpdateByIdReportTemplateBopInput>;
  carSetup?: InputMaybe<UpdateByIdReportTemplateCarSetupInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** File format based off a filename pattern, e.g. {raceSeries} {season} {event} */
  downloadFilenameFormat?: InputMaybe<Scalars['String']['input']>;
  excludedNoteIDs?: InputMaybe<UpdateByIdReportTemplateExcludedNoteIDsInput>;
  issues?: InputMaybe<UpdateByIdReportTemplateIssuesInput>;
  kpi?: InputMaybe<UpdateByIdReportTemplateKpiInput>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overview?: InputMaybe<UpdateByIdReportTemplateOverviewInput>;
  parts?: InputMaybe<UpdateByIdReportTemplatePartsInput>;
  reportTitle?: InputMaybe<Scalars['String']['input']>;
  runInfo?: InputMaybe<UpdateByIdReportTemplateRunInfoInput>;
  runPlan?: InputMaybe<UpdateByIdReportTemplateRunPlanInput>;
  sessions?: InputMaybe<UpdateByIdReportTemplateSessionsInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  weather?: InputMaybe<UpdateByIdReportTemplateWeatherInput>;
};

export type UpdateByIdReportTemplateIssuesColumnsInput = {
  field?: InputMaybe<EnumReportTemplateIssuesColumnsField>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdReportTemplateIssuesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<UpdateByIdReportTemplateIssuesColumnsInput>>>;
  groupBy?: InputMaybe<EnumReportTemplateIssuesGroupBy>;
};

export type UpdateByIdReportTemplateKpiInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  layout?: InputMaybe<Scalars['JSON']['input']>;
  showSessionLines?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdReportTemplateOverviewInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  showFuelConsumption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdReportTemplatePartsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  groupPartsByChassisAssemblyName?: InputMaybe<Scalars['Boolean']['input']>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  tableColumns?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type UpdateByIdReportTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ReportTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdReportTemplateRunInfoColumnsInput = {
  field?: InputMaybe<EnumReportTemplateRunInfoColumnsField>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdReportTemplateRunInfoInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<UpdateByIdReportTemplateRunInfoColumnsInput>>>;
};

export type UpdateByIdReportTemplateRunPlanInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdReportTemplateSessionsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  displayedTimeZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  showTimingOverview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdReportTemplateWeatherInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  splitDataByDays?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdRunBrakeInput = {
  /** Brake temperature after the run */
  TBrakePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Brake temperature before the run */
  TBrakePreRun?: InputMaybe<Scalars['Float']['input']>;
  hBrakeDiscPreRun?: InputMaybe<Scalars['Float']['input']>;
  /** Format is `Record<string, number>`, e.g. `{ "1FL": 1.2, "2": 1.3 }` */
  thicknessMeasurements?: InputMaybe<Scalars['JSON']['input']>;
};

/** Run energy field labels mapped to their display names. Null or unset fields are not displayed. */
export type UpdateByIdRunEnergyFieldLabelsInput = {
  ATTACK?: InputMaybe<Scalars['String']['input']>;
  COOL?: InputMaybe<Scalars['String']['input']>;
  FCY?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Scalars['String']['input']>;
  OUT?: InputMaybe<Scalars['String']['input']>;
  OUTIN?: InputMaybe<Scalars['String']['input']>;
  PITLANE?: InputMaybe<Scalars['String']['input']>;
  PREP?: InputMaybe<Scalars['String']['input']>;
  PUSH?: InputMaybe<Scalars['String']['input']>;
  QUALI?: InputMaybe<Scalars['String']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['String']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['String']['input']>;
  SLOW?: InputMaybe<Scalars['String']['input']>;
  TARGET?: InputMaybe<Scalars['String']['input']>;
  TOGRID?: InputMaybe<Scalars['String']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['String']['input']>;
  TOPITS?: InputMaybe<Scalars['String']['input']>;
  UNFINISHED?: InputMaybe<Scalars['String']['input']>;
  attackLap?: InputMaybe<Scalars['String']['input']>;
  coolLap?: InputMaybe<Scalars['String']['input']>;
  fullCourseYellowLap?: InputMaybe<Scalars['String']['input']>;
  inLap?: InputMaybe<Scalars['String']['input']>;
  outInLap?: InputMaybe<Scalars['String']['input']>;
  outLap?: InputMaybe<Scalars['String']['input']>;
  pitlaneLap?: InputMaybe<Scalars['String']['input']>;
  prepLap?: InputMaybe<Scalars['String']['input']>;
  pushLap?: InputMaybe<Scalars['String']['input']>;
  qualiLap?: InputMaybe<Scalars['String']['input']>;
  safetyCarLap?: InputMaybe<Scalars['String']['input']>;
  shakedownLap?: InputMaybe<Scalars['String']['input']>;
  slowLap?: InputMaybe<Scalars['String']['input']>;
  targetLap?: InputMaybe<Scalars['String']['input']>;
  toGridLap?: InputMaybe<Scalars['String']['input']>;
  toPitsLap?: InputMaybe<Scalars['String']['input']>;
  unfinishedLap?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdRunEnergyInput = {
  /** Fuel/Energy/SoC required for ATTACK Lap */
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for COOL Lap */
  COOL?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for FCY Lap */
  FCY?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for IN Lap */
  IN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for OUT Lap */
  OUT?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for OUTIN Lap */
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PITLANE Lap */
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PREP Lap */
  PREP?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PUSH Lap */
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for QUALI Lap */
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SAFETYCAR Lap */
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SHAKEDOWN Lap */
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SLOW Lap */
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TARGET Lap */
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOGRID Lap */
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOPADDOCK Lap */
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOPITS Lap */
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for UNFINISHED Lap */
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an attack mode lap */
  attackLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a cooldown lap */
  coolLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a full course yellow lap */
  fullCourseYellowLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an in lap */
  inLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an out-in lap */
  outInLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an out lap */
  outLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a pitlane lap */
  pitlaneLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a preparation/warmup lap */
  prepLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a push lap */
  pushLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a qualifying lap */
  qualiLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a safety car lap */
  safetyCarLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a shakedown lap */
  shakedownLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a slow lap */
  slowLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an target lap */
  targetLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a to-grid lap */
  toGridLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a to-pits lap */
  toPitsLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an unfinished lap */
  unfinishedLap?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdRunKpiTableRowFieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<UpdateByIdValueLimitInput>;
  unit?: InputMaybe<EnumDisplayUnit>;
  upperLimit?: InputMaybe<UpdateByIdValueLimitInput>;
};

export type UpdateByIdRunKpiTableRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell, an array of two numbers for a double cell, and so on. */
  gain?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Field names to try pull data from in `runKPI`, like `"vMax"`. Use an array of one key for a single cell, an array of two keys for a double cell, and so on. */
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<UpdateByIdValueLimitInput>;
  /** Text to put as a unit for values. */
  unit?: InputMaybe<Scalars['String']['input']>;
  upperLimit?: InputMaybe<UpdateByIdValueLimitInput>;
};

export type UpdateByIdRunLapTimeInput = {
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  COOL?: InputMaybe<Scalars['Float']['input']>;
  FCY?: InputMaybe<Scalars['Float']['input']>;
  IN?: InputMaybe<Scalars['Float']['input']>;
  OUT?: InputMaybe<Scalars['Float']['input']>;
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  PREP?: InputMaybe<Scalars['Float']['input']>;
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdRunPlanInput = {
  PUEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Amount of time in seconds to increment SOC by 1% at each rSOC value. Must have same length as `chargeTimeSOCValues`. */
  chargeTimeSOCIncrements?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** rSOC values to associate with each time charge time increment. Must have same length as `chargeTimeSOCIncrements` */
  chargeTimeSOCValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  fuelRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  /** Full tank fuel load */
  mFuelFullTank?: InputMaybe<Scalars['Float']['input']>;
  performanceEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  raceEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  runs?: InputMaybe<Array<InputMaybe<UpdateByIdRunPlanRunInput>>>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  systemEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tLapExpected?: InputMaybe<UpdateByIdRunLapTimeInput>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Short comment like dry run plan / wet run plan. */
  title?: InputMaybe<Scalars['String']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdRunPlanPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<RunPlan>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdRunPlanRunActionItemsPreRunInput = {
  _id: Scalars['MongoID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateByIdRunPlanRunInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  actionItemsPostRun?: InputMaybe<Array<InputMaybe<UpdateByIdRunPlanRunActionItemsPreRunInput>>>;
  actionItemsPreRun?: InputMaybe<Array<InputMaybe<UpdateByIdRunPlanRunActionItemsPreRunInput>>>;
  /** Background color for the run in run plan view. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** e.g. Baseline Run, Option A, … */
  description?: InputMaybe<Scalars['String']['input']>;
  /** True if fuel was drained before the run. */
  fuelDrainedBeforeRun?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequence?: InputMaybe<Array<InputMaybe<UpdateByIdLapSequenceLapsInput>>>;
  /** Amount of fuel to be refilled at the end of this run. */
  mFuelRefuel?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<EnumRunPlanRunPriority>;
  /** Things you need to remember to tell the driver. */
  reminder?: InputMaybe<Scalars['String']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  selectedDriverID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Setup changes anticipated. */
  setupChanges?: InputMaybe<Scalars['String']['input']>;
  /** Amount of time for refuelling at the end of this run. */
  tFuelRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Time to wait before starting the run. */
  tWaitBeforeRun?: InputMaybe<Scalars['Float']['input']>;
  tyreFLID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreFRID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreRLID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreRRID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdRunSheetInput = {
  /** Fuel density, if working in volume (overrides `DFuel` from event) */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Run number */
  NRun?: InputMaybe<Scalars['Float']['input']>;
  /** Run number for timing services */
  NRunTiming?: InputMaybe<Scalars['Float']['input']>;
  SoCRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  TCellMaxRunStart?: InputMaybe<Scalars['Float']['input']>;
  /** Volume of fuel added at the start of the run. This field will not be automatically calculated by the API, so should be set along with `tRefuel` and `qRefuel` as their product. */
  VFuelAdded?: InputMaybe<Scalars['Float']['input']>;
  associatedKpiFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brakeComment?: InputMaybe<Scalars['String']['input']>;
  brakeFL?: InputMaybe<UpdateByIdRunBrakeInput>;
  brakeFR?: InputMaybe<UpdateByIdRunBrakeInput>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  brakeRL?: InputMaybe<UpdateByIdRunBrakeInput>;
  brakeRR?: InputMaybe<UpdateByIdRunBrakeInput>;
  /** Link to a cloud storage location where raw run data is kept. */
  cloudStorageURL?: InputMaybe<Scalars['String']['input']>;
  /** Fuel/SoC/Energy consumptions for each track layout in this run sheet. Acts as an override for the consumptions from the parent event. */
  consumptions?: InputMaybe<Array<InputMaybe<UpdateByIdLayoutConsumptionInput>>>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  controlsComment?: InputMaybe<Scalars['String']['input']>;
  dashboard?: InputMaybe<UpdateByIdDashboardInput>;
  dataServiceFileNameOverride?: InputMaybe<Scalars['String']['input']>;
  dilComments?: InputMaybe<Scalars['String']['input']>;
  driverComments?: InputMaybe<Scalars['String']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Car data service run end time */
  endTimeCDS?: InputMaybe<Scalars['Date']['input']>;
  /** Laptime service run end time */
  endTimeLTS?: InputMaybe<Scalars['Date']['input']>;
  /** Manual run end time (used to override calculation in case run was cut short but don't want to delete the drafted laps */
  endTimeManual?: InputMaybe<Scalars['Date']['input']>;
  energyRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  engineerComments?: InputMaybe<Scalars['String']['input']>;
  engineerID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time by which tyre heating schedule should be finished */
  finishTyreHeatingBy?: InputMaybe<Scalars['Date']['input']>;
  /** Used for fuel calculation. If true, mFuelAdded is treated as the total fuel at run start. */
  fuelDrainedBeforeRun?: InputMaybe<Scalars['Boolean']['input']>;
  fuelRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  historyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  info?: InputMaybe<Scalars['String']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isLockedByLaptimeService?: InputMaybe<Scalars['Boolean']['input']>;
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  jobIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Used to save the file name where the kpi data is retreived from */
  kpiFileName?: InputMaybe<Scalars['String']['input']>;
  kpiStatus?: InputMaybe<EnumRunSheetKpiStatus>;
  kpiUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** `addLap`, `forceAddLap`, `updateLap`, and `removeLap` mutations are preferred unless you want to completely replace the laps with new data. */
  laps?: InputMaybe<Array<InputMaybe<UpdateByIdLapInput>>>;
  laptimeThresholds?: InputMaybe<UpdateByIdLaptimeThresholdsInput>;
  /** Fuel added at the start of the run */
  mFuelAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel removed from the catch tank after the run */
  mFuelDrainedCatchTank?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel removed from the main tank after the run */
  mFuelDrainedMainTank?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel remaining at the end of the run */
  mFuelRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel used before run start i.e. for pre-run fireup */
  mFuelUsedPreRun?: InputMaybe<Scalars['Float']['input']>;
  nextRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  performanceComments?: InputMaybe<Scalars['String']['input']>;
  prevRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  problemComments?: InputMaybe<Scalars['String']['input']>;
  /** Flow rate when refuelling at the start of the run, in m³/s */
  qRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Energy charged to this value at the start of the run */
  rEnergyAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Energy level at the end of the run */
  rEnergyRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Battery charged to this value at the start of the run */
  rSOCAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Battery state of charge at the end of the run */
  rSOCRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Short comment of the objective of the run */
  runDescription?: InputMaybe<Scalars['String']['input']>;
  /** Map of run KPI fields to their values. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  runKPI?: InputMaybe<Scalars['JSON']['input']>;
  runSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Running time in seconds */
  runTime?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the job list template used for this run */
  selectedJobListTemplateID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  setupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of the simulation results associated with this run. */
  simResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  skidComment?: InputMaybe<Scalars['String']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidMeasurement: [["left", 5], ["marker1", 6]]`. */
  skidMeasurement?: InputMaybe<Scalars['JSON']['input']>;
  skidPlateID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPostRunMeasurements: [["left", 5], ["marker1", 6]]`. */
  skidPostRunMeasurements?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPreRunMeasurements: [["left", 5], ["marker1", 6]]`. */
  skidPreRunMeasurements?: InputMaybe<Scalars['JSON']['input']>;
  startTimeCDS?: InputMaybe<Scalars['Date']['input']>;
  startTimeLTS?: InputMaybe<Scalars['Date']['input']>;
  startTimeManual?: InputMaybe<Scalars['Date']['input']>;
  /** Time at which to start tyre heating schedule */
  startTyreHeatingAt?: InputMaybe<Scalars['Date']['input']>;
  summaryComments?: InputMaybe<Scalars['String']['input']>;
  systemsComments?: InputMaybe<Scalars['String']['input']>;
  /** Time spent refuelling at the start of the run */
  tRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Override for session time remaining (in seconds) */
  tSessionRemainingOverride?: InputMaybe<Scalars['Float']['input']>;
  /** Time spent in garage before run */
  tWaitBeforeRun?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of this run in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyRunID?: InputMaybe<Scalars['String']['input']>;
  /** Should the timing service pretend that this run sheet does not exist? */
  timingServiceShouldIgnore?: InputMaybe<Scalars['Boolean']['input']>;
  tyreComments?: InputMaybe<Scalars['String']['input']>;
  /** The tyre compound used, reported by the timing service. */
  tyreCompoundTiming?: InputMaybe<Scalars['String']['input']>;
  tyreFL?: InputMaybe<UpdateByIdRunTyreInput>;
  tyreFR?: InputMaybe<UpdateByIdRunTyreInput>;
  tyrePressureSettings?: InputMaybe<UpdateByIdTyrePressureSettingsInput>;
  tyreRL?: InputMaybe<UpdateByIdRunTyreInput>;
  tyreRR?: InputMaybe<UpdateByIdRunTyreInput>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
  weather?: InputMaybe<UpdateByIdWeatherDataInput>;
  writeHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdRunSheetPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<RunSheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdRunSheetStyleInput = {
  blocks?: InputMaybe<Array<InputMaybe<UpdateByIdGenericRunSheetStyleBlockInput>>>;
  energyType?: InputMaybe<EnumEnergyType>;
  lapFlags?: InputMaybe<UpdateByIdLapFlagLabelsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdRunSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<RunSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdRunTyreInput = {
  /** Track reference temperature at which the reference pressure is given */
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre temperature */
  TTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Expected tyre temperature in parc ferme */
  TTyreParcFermeExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre temperature */
  TTyrePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure bleed at temperature */
  TTyrePostRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Pre-run tyre pressure bleed at temperature */
  TTyrePreRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre reference temperature at which the reference pressure is given */
  TTyreReference?: InputMaybe<Scalars['Float']['input']>;
  /** Set down tyre temperature (e.g. in the evening with cold tyre) */
  TTyreSetdown?: InputMaybe<Scalars['Float']['input']>;
  /** Array of manual surface temperature measurements */
  TTyreSurface?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Array of manual tyre tread depth measurements */
  hTyreTread?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Tyre pressure */
  pTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure at the start of the run */
  pTyreMinStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure */
  pTyrePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure bleed */
  pTyrePostRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Pre-run tyre pressure bleed */
  pTyrePreRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre reference pressure */
  pTyreReference?: InputMaybe<Scalars['Float']['input']>;
  /** Set down tyre pressure (e.g. in the evening with cold tyre) */
  pTyreSetDown?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre pressure at the start of the run */
  pTyreStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Target tyre pressure during running */
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
  tyreID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdSandboxUnitsInput = {
  acceleration?: InputMaybe<UpdateByIdAccelerationInput>;
  angle?: InputMaybe<UpdateByIdAngleInput>;
  angularVelocity?: InputMaybe<UpdateByIdAngularVelocityInput>;
  area?: InputMaybe<UpdateByIdAreaInput>;
  current?: InputMaybe<UpdateByIdCurrentInput>;
  dampingRate?: InputMaybe<UpdateByIdDampingRateInput>;
  density?: InputMaybe<UpdateByIdDensityInput>;
  energy?: InputMaybe<UpdateByIdEnergyInput>;
  force?: InputMaybe<UpdateByIdForceInput>;
  frequency?: InputMaybe<UpdateByIdFrequencyInput>;
  length?: InputMaybe<UpdateByIdLengthInput>;
  mass?: InputMaybe<UpdateByIdMassInput>;
  momentOfInertia?: InputMaybe<UpdateByIdMomentOfInertiaInput>;
  power?: InputMaybe<UpdateByIdPowerInput>;
  pressure?: InputMaybe<UpdateByIdPressureInput>;
  ratio?: InputMaybe<UpdateByIdRatioInput>;
  springRate?: InputMaybe<UpdateByIdSpringRateInput>;
  temperature?: InputMaybe<UpdateByIdTemperatureInput>;
  torque?: InputMaybe<UpdateByIdTorqueInput>;
  torsionRate?: InputMaybe<UpdateByIdTorsionRateInput>;
  velocity?: InputMaybe<UpdateByIdVelocityInput>;
  voltage?: InputMaybe<UpdateByIdVoltageInput>;
  volume?: InputMaybe<UpdateByIdVolumeInput>;
};

export type UpdateByIdSandboxUnitsPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SandboxUnits>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSeasonInput = {
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Position after which a driver no longer gets points for fastest lap. */
  fastestLapsPositionCutoff?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Championship points per fastest lap in a session. Example: `[1]` means fastest lap gets 1 point, then second and beyond gets nothing. */
  pointsPerFastestLap?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Whether the fastest lap points are awarded to the team or the driver. */
  pointsPerFastestLapTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Championship points per driver position in a race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPosition?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Championship points per driver position in a sprint race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPositionSprintRace?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Championship points per qualifying rank at an event. Example: `[3, 2, 1]` means first/second/third drivers get 3/2/1 points, then fourth and beyond gets nothing. */
  pointsPerQualifyingRank?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  pointsSystemQualiAlternateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemQualiDefaultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemRaceAlternateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemRaceDefaultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of all tyres which are owned by the team for this season. */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of all tyre sets which are owned by the team for this season. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdSeasonPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Season>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSessionContestantsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of the chassis used, if different for this session. */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** IDs of drivers of this car, if different for this session. */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdSessionInput = {
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bestValuesID?: InputMaybe<Scalars['MongoID']['input']>;
  bopID?: InputMaybe<Scalars['MongoID']['input']>;
  contestants?: InputMaybe<Array<InputMaybe<UpdateByIdSessionContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumSessionDebriefNotesMode>;
  disableForwardPropagation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted driver championship standings during and immediately after this session. */
  driverChampionshipStandings?: InputMaybe<Array<InputMaybe<UpdateByIdDriverChampionshipStandingInput>>>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  /** This flag is used to tell the laptime service that this session might span multiple timing sessions. */
  isLinkedSession?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this a timing test session, to be shown only to admin users? */
  isTimingTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted standings of this session, as they were last updated */
  liveStandings?: InputMaybe<Array<InputMaybe<UpdateByIdLiveStandingInput>>>;
  /** Greatest lap number processed for live standings. Use to determine if the data is current and up to date. */
  liveStandingsCurrentLap?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the next session in this event */
  nextSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFRMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRRMinSession?: InputMaybe<Scalars['Float']['input']>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemOverrideIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted driver championship standings from before the start of this session. */
  prevDriverChampionshipStandings?: InputMaybe<Array<InputMaybe<UpdateByIdDriverChampionshipStandingInput>>>;
  /** ID of the previous session in this event */
  prevSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** e.g. Test, Practice, Qualifying, Race */
  sessionType?: InputMaybe<EnumSessionType>;
  /** Short name like D1, FP2, etc. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Time of the session end in local time */
  tSessionEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of the session start in local time */
  tSessionStart?: InputMaybe<Scalars['Date']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted team championship standings during and immediately after this session. */
  teamChampionshipStandings?: InputMaybe<Array<InputMaybe<UpdateByIdTeamChampionshipStandingInput>>>;
  /** ID of this session in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartySessionID?: InputMaybe<Scalars['String']['input']>;
  /** Seconds until end of session, updated by the timing service very infrequently. Zero if session has already ended. */
  timeRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** ID of this session for Transcribble's legacy API */
  transcribbleSessionID?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateByIdSessionPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Session>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSetupOverviewConfigFieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell and an array of two numbers for a double cell. */
  gain?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Field names to pull data from in the car setup, like `"frontLeft.hRide"`. Use an array of one key for a single cell, and an array of two keys for a double cell. */
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Suffix to show as a unit for values. */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSetupOverviewConfigInput = {
  /** WARNING: this field should be deprecated after SI migrations have taken place */
  fields?: InputMaybe<Array<InputMaybe<UpdateByIdSetupOverviewConfigFieldInput>>>;
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<InputMaybe<UpdateByIdSetupOverviewConfigRowInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSetupOverviewConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SetupOverviewConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSetupOverviewConfigRowElementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Path of field in car setup, e.g. aero.aFlapF */
  field?: InputMaybe<Scalars['String']['input']>;
  /** Gain to apply to the value. */
  gain?: InputMaybe<Scalars['Float']['input']>;
  /** Suffix to put as a unit for values. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<UpdateByIdBaseTypedUnitFieldInput>;
};

export type UpdateByIdSetupOverviewConfigRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  elements?: InputMaybe<Array<InputMaybe<UpdateByIdSetupOverviewConfigRowElementInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSetupSheetGroupInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Array<UpdateByIdSetupSheetStyleRowInput>>;
};

export type UpdateByIdSetupSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** The height of the block within the grid */
  height?: InputMaybe<Scalars['Int']['input']>;
  tabs?: InputMaybe<Array<UpdateByIdSetupSheetStyleTabInput>>;
  /** The width of the block within the grid */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateByIdSetupSheetStyleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  blocks?: InputMaybe<Array<UpdateByIdSetupSheetStyleBlockInput>>;
  /** Chassis specification to use for suggesting field keys. You may need to look for more recent iterations of this spec to get up-to-date field keys. */
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  hideAddPartButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Toggle to show/hide units for the input fields */
  hideUnits?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  targetEventType?: InputMaybe<EnumSetupSheetStyleTargetEventType>;
  targetRoles?: InputMaybe<Array<EnumPersonRole>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumSetupSheetStyleType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSetupSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SetupSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSetupSheetStyleRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  items: Array<SetupSheetStyleItemInput>;
};

export type UpdateByIdSetupSheetStyleTabInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  groups?: InputMaybe<Array<UpdateByIdSetupSheetGroupInput>>;
  massConfig?: InputMaybe<UpdateByIdSetupSheetStyleTabMassConfigInput>;
  mileageConfig?: InputMaybe<UpdateByIdSetupSheetStyleTabMileageConfigInput>;
  rows?: InputMaybe<Array<UpdateByIdSetupSheetStyleRowInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumSetupSheetStyleTabType>;
};

export type UpdateByIdSetupSheetStyleTabMassConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  massOption?: InputMaybe<Scalars['String']['input']>;
  showMinWeightFromSpec?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdSetupSheetStyleTabMileageConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  showManualInput?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdSimRequestInput = {
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  relatedSimResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  requesterSlot?: InputMaybe<EnumSimRequestRequesterSlot>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  simResultID?: InputMaybe<Scalars['MongoID']['input']>;
  simType?: InputMaybe<EnumSimRequestSimType>;
  simulationService?: InputMaybe<EnumSimModelType>;
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSimRequestPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SimRequest>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSimResultDataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  /** Sampling rate of the channel in Hz, if overriding `defaultChannelTime` without `channelTime` */
  channelSamplingRate?: InputMaybe<Scalars['Float']['input']>;
  /** Use this to override `defaultChannelTime` */
  channelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Actual channel data values */
  channelValue?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  interpolationMethod?: InputMaybe<EnumSimResultDataInterpolationMethod>;
  /** Should values in this channel be treated as timestamps? */
  isTimeChannel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display unit of channel values (e.g. m/s) */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSimResultInput = {
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Array<InputMaybe<UpdateByIdSimResultDataInput>>>;
  /** Each data channel is assumed to use this unless it specifies `channelSamplingRate` or `channelTime` */
  defaultChannelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Map containing reference values from car setup. Example: aerobalance in a car manual. Input syntax is array of key-value tuples, like `refValues: [["rAeroBalF", 48.5], ["rLatBalF", 51.4]]`. */
  refValues?: InputMaybe<Scalars['JSON']['input']>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the ORH service used to generate the sim result */
  serviceVersion?: InputMaybe<Scalars['String']['input']>;
  simType?: InputMaybe<EnumSimResultSimType>;
  simulationDriveFileID?: InputMaybe<Scalars['MongoID']['input']>;
  simulationService?: InputMaybe<EnumSimModelType>;
  /** Service which generated this sim result, for example Canopy */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Reference for this sim result, to find it in the simulation service */
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSimResultPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SimResult>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSimulationDriveFileInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumSimulationDriveFileStatus>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumTypeID?: InputMaybe<Scalars['MongoID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSimulationDriveFilePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SimulationDriveFile>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSkidPlateInput = {
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  initialThickness?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdSkidPlatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SkidPlate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSpecificationACamberInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  readingsRequired?: InputMaybe<EnumSpecificationACamberReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpecificationACamberUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdSpecificationAdminInput = {
  CxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  FSpringSetup?: InputMaybe<UpdateByIdAdjustableForceInput>;
  aCamber?: InputMaybe<UpdateByIdSpecificationACamberInput>;
  aCaster?: InputMaybe<UpdateByIdSpecificationACamberInput>;
  aCasterMeasurementGain?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurementOffset?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<UpdateByIdSpecificationACamberInput>;
  adjustableProperties?: InputMaybe<Array<InputMaybe<UpdateByIdAdjustablePropertyInput>>>;
  aeroElementInterpolationMethod?: InputMaybe<EnumSpecificationAdminAeroElementInterpolationMethod>;
  aeroElementSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  aeroElementType?: InputMaybe<EnumSpecificationAdminAeroElementType>;
  aeroPackageSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  aeroPackageSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Names of sockets that this can be plugged in to. */
  allowableSockets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  antiRollBarConfigs?: InputMaybe<Array<InputMaybe<UpdateByIdAntiRollBarConfigInput>>>;
  antiRollBarDisplayLocation?: InputMaybe<EnumSpecificationAdminAntiRollBarDisplayLocation>;
  antiRollBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: InputMaybe<Array<InputMaybe<UpdateByIdAssignedGearInput>>>;
  attachable?: InputMaybe<Scalars['Boolean']['input']>;
  axle?: InputMaybe<EnumSpecificationAdminAxle>;
  bevelSetSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetVisible?: InputMaybe<Scalars['Boolean']['input']>;
  bumpRubberReference?: InputMaybe<EnumSpecificationAdminBumpRubberReference>;
  bumpRubberSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bumpStopGapMethod?: InputMaybe<EnumSpecificationAdminBumpStopGapMethod>;
  calculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: InputMaybe<Scalars['String']['input']>;
  chassisMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  copyReferencePackageID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customSimulationModels?: InputMaybe<Array<InputMaybe<UpdateByIdSpecificationCustomSimulationModelsInput>>>;
  customSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  customSpecType?: InputMaybe<Scalars['String']['input']>;
  customTables?: InputMaybe<Array<InputMaybe<UpdateByIdSpecificationCustomTablesInput>>>;
  damperAdjusters?: InputMaybe<Array<InputMaybe<UpdateByIdDamperAdjusterInput>>>;
  damperConfigs?: InputMaybe<Array<InputMaybe<UpdateByIdDamperConfigInput>>>;
  damperSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  denominator?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  differentialConfigs?: InputMaybe<Array<InputMaybe<UpdateByIdDifferentialConfigInput>>>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  drawingNumber?: InputMaybe<Scalars['String']['input']>;
  dropGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  elasticType?: InputMaybe<EnumSpecificationAdminElasticType>;
  forceTable?: InputMaybe<UpdateByIdForceTableInput>;
  gearType?: InputMaybe<EnumSpecificationAdminGearType>;
  hRide?: InputMaybe<UpdateByIdSpecificationHRideInput>;
  hasToBeInSubAssembly?: InputMaybe<Scalars['Boolean']['input']>;
  headGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  helperSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  initialChassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** If true, this gear is the head gear of the gear box, applies to standard gears only */
  isHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Spring constant of the elastic element. */
  kSpring?: InputMaybe<Scalars['Float']['input']>;
  kinematicsExternalModels?: InputMaybe<Array<InputMaybe<UpdateByIdKinematicsExternalModelInput>>>;
  kinematicsExternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  kinematicsInternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerReference?: InputMaybe<Scalars['String']['input']>;
  mass?: InputMaybe<UpdateByIdChassisMassInput>;
  massProperties?: InputMaybe<UpdateByIdMassPropertiesInput>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: InputMaybe<UpdateByIdChassisMeasurementsInput>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: InputMaybe<Array<InputMaybe<EnumSpecificationAdminModelTypes>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  numerator?: InputMaybe<Scalars['Float']['input']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  polyCxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  positionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  powerUnits?: InputMaybe<Array<InputMaybe<UpdateByIdChassisPowerUnitInput>>>;
  powertrain?: InputMaybe<UpdateByIdChassisPowertrainInput>;
  powertrainLocation?: InputMaybe<EnumSpecificationAdminPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  rBrakeBias?: InputMaybe<UpdateByIdAdjustableRatioInput>;
  /** Position of the specification on the car */
  readingsAllowable?: InputMaybe<Array<InputMaybe<EnumSpecificationAdminReadingsAllowable>>>;
  readingsRequired?: InputMaybe<EnumSpecificationAdminReadingsRequired>;
  reboundSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  regulationSets?: InputMaybe<Array<InputMaybe<UpdateByIdRegulationSetInput>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: InputMaybe<Scalars['Boolean']['input']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  setupChangesFilter?: InputMaybe<UpdateByIdSpecificationSetupChangesFilterInput>;
  setupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  /** Locations/areas that components can be installed in. */
  sockets?: InputMaybe<Array<InputMaybe<UpdateByIdChassisSocketInput>>>;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationGroupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  springReference?: InputMaybe<EnumSpecificationAdminSpringReference>;
  springSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  torsionBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumSpecificationAdminType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** User-supplied version of this specification. */
  version?: InputMaybe<Scalars['String']['input']>;
  xBumpRubberRef?: InputMaybe<Scalars['Float']['input']>;
  xBumpRubberSetup?: InputMaybe<UpdateByIdAdjustableLengthInput>;
  xBumpStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperSetupDefault?: InputMaybe<Scalars['Float']['input']>;
  xDroopStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  /** Length of the elastic element under no force */
  xFree?: InputMaybe<Scalars['Float']['input']>;
  xShaftDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xSpringPlatformOffset?: InputMaybe<Scalars['Float']['input']>;
  xSpringRef?: InputMaybe<Scalars['Float']['input']>;
  xSpringSetup?: InputMaybe<UpdateByIdAdjustableLengthInput>;
  xToe?: InputMaybe<UpdateByIdSpecificationHRideInput>;
};

export type UpdateByIdSpecificationAdminPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SpecificationAdmin>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSpecificationCustomSimulationModelsInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  dataMapping?: InputMaybe<EnumSpecificationCustomSimulationModelsDataMapping>;
  endPoint?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serverPort?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSpecificationCustomTablesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<UpdateByIdTableInput>;
};

export type UpdateByIdSpecificationGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSpecificationGroupPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SpecificationGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSpecificationHRideInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  readingsRequired?: InputMaybe<EnumSpecificationHRideReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpecificationHRideUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdSpecificationInput = {
  CxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  FSpringSetup?: InputMaybe<UpdateByIdAdjustableForceInput>;
  aCamber?: InputMaybe<UpdateByIdSpecificationACamberInput>;
  aCaster?: InputMaybe<UpdateByIdSpecificationACamberInput>;
  aCasterMeasurementGain?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurementOffset?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<UpdateByIdSpecificationACamberInput>;
  adjustableProperties?: InputMaybe<Array<InputMaybe<UpdateByIdAdjustablePropertyInput>>>;
  aeroElementInterpolationMethod?: InputMaybe<EnumAeroElementInterpolationMethod>;
  aeroElementSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  aeroElementType?: InputMaybe<EnumAeroElementType>;
  aeroPackageSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  aeroPackageSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Names of sockets that this can be plugged in to. */
  allowableSockets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  antiRollBarConfigs?: InputMaybe<Array<InputMaybe<UpdateByIdAntiRollBarConfigInput>>>;
  antiRollBarDisplayLocation?: InputMaybe<EnumAntiRollBarDisplayLocation>;
  antiRollBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: InputMaybe<Array<InputMaybe<UpdateByIdAssignedGearInput>>>;
  attachable?: InputMaybe<Scalars['Boolean']['input']>;
  axle?: InputMaybe<EnumAxle>;
  bevelSetSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetVisible?: InputMaybe<Scalars['Boolean']['input']>;
  bumpRubberReference?: InputMaybe<EnumKinematicsInternalReference>;
  bumpRubberSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bumpStopGapMethod?: InputMaybe<EnumBumpStopGapMethod>;
  calculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: InputMaybe<Scalars['String']['input']>;
  chassisMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  copyReferencePackageID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customSimulationModels?: InputMaybe<Array<InputMaybe<UpdateByIdSpecificationCustomSimulationModelsInput>>>;
  customSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  customSpecType?: InputMaybe<Scalars['String']['input']>;
  customTables?: InputMaybe<Array<InputMaybe<UpdateByIdSpecificationCustomTablesInput>>>;
  damperAdjusters?: InputMaybe<Array<InputMaybe<UpdateByIdDamperAdjusterInput>>>;
  damperConfigs?: InputMaybe<Array<InputMaybe<UpdateByIdDamperConfigInput>>>;
  damperSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  denominator?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  differentialConfigs?: InputMaybe<Array<InputMaybe<UpdateByIdDifferentialConfigInput>>>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  drawingNumber?: InputMaybe<Scalars['String']['input']>;
  dropGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  elasticType?: InputMaybe<EnumElasticType>;
  forceTable?: InputMaybe<UpdateByIdForceTableInput>;
  gearType?: InputMaybe<EnumGearType>;
  hRide?: InputMaybe<UpdateByIdSpecificationHRideInput>;
  hasToBeInSubAssembly?: InputMaybe<Scalars['Boolean']['input']>;
  headGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  helperSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  initialChassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** If true, this gear is the head gear of the gear box, applies to standard gears only */
  isHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
  /** Spring constant of the elastic element. */
  kSpring?: InputMaybe<Scalars['Float']['input']>;
  kinematicsExternalModels?: InputMaybe<Array<InputMaybe<UpdateByIdKinematicsExternalModelInput>>>;
  kinematicsExternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  kinematicsInternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerReference?: InputMaybe<Scalars['String']['input']>;
  mass?: InputMaybe<UpdateByIdChassisMassInput>;
  massProperties?: InputMaybe<UpdateByIdMassPropertiesInput>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: InputMaybe<UpdateByIdChassisMeasurementsInput>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  numerator?: InputMaybe<Scalars['Float']['input']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  polyCxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  positionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  powerUnits?: InputMaybe<Array<InputMaybe<UpdateByIdChassisPowerUnitInput>>>;
  powertrain?: InputMaybe<UpdateByIdChassisPowertrainInput>;
  powertrainLocation?: InputMaybe<EnumSpecificationPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  rBrakeBias?: InputMaybe<UpdateByIdAdjustableRatioInput>;
  /** Position of the specification on the car */
  readingsAllowable?: InputMaybe<Array<InputMaybe<EnumSpecificationReadingsAllowable>>>;
  readingsRequired?: InputMaybe<EnumSpecificationReadingsRequired>;
  reboundSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  regulationSets?: InputMaybe<Array<InputMaybe<UpdateByIdRegulationSetInput>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: InputMaybe<Scalars['Boolean']['input']>;
  setupChangesFilter?: InputMaybe<UpdateByIdSpecificationSetupChangesFilterInput>;
  setupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  /** Locations/areas that components can be installed in. */
  sockets?: InputMaybe<Array<InputMaybe<UpdateByIdChassisSocketInput>>>;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationGroupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  springReference?: InputMaybe<EnumKinematicsInternalReference>;
  springSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  torsionBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumSpecificationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** User-supplied version of this specification. */
  version?: InputMaybe<Scalars['String']['input']>;
  xBumpRubberRef?: InputMaybe<Scalars['Float']['input']>;
  xBumpRubberSetup?: InputMaybe<UpdateByIdAdjustableLengthInput>;
  xBumpStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperSetupDefault?: InputMaybe<Scalars['Float']['input']>;
  xDroopStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  /** Length of the elastic element under no force */
  xFree?: InputMaybe<Scalars['Float']['input']>;
  xShaftDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xSpringPlatformOffset?: InputMaybe<Scalars['Float']['input']>;
  xSpringRef?: InputMaybe<Scalars['Float']['input']>;
  xSpringSetup?: InputMaybe<UpdateByIdAdjustableLengthInput>;
  xToe?: InputMaybe<UpdateByIdSpecificationHRideInput>;
};

export type UpdateByIdSpecificationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Specification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSpecificationSetupChangesFilterInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of setup fields to hide */
  blackListFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** List of setup fields to show */
  whiteListFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdSpringRateInput = {
  /** N/m */
  newtonsPerMetre?: InputMaybe<Scalars['Float']['input']>;
  /** N/mm */
  newtonsPerMillimetre?: InputMaybe<Scalars['Float']['input']>;
  /** lb/in */
  poundsPerInch?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdSteeringInput = {
  rSteerF?: InputMaybe<Scalars['Float']['input']>;
  steeringArm?: InputMaybe<Scalars['String']['input']>;
  steeringPinion?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  columnNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  columnValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Table data in 1d vector. It's up to the consumer to reshape appropriately. OneRacehub internally uses row chunks. */
  data?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  decimals?: InputMaybe<Scalars['Float']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  rowNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sliceNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sliceValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<EnumTagType>;
};

export type UpdateByIdTagPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTeamChampionshipStandingInput = {
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  points?: InputMaybe<Scalars['Int']['input']>;
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: InputMaybe<Scalars['Int']['input']>;
  teamDrivers?: InputMaybe<Array<InputMaybe<UpdateByIdDriverChampionshipStandingInput>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdTeamInput = {
  /** Default color to use for this team where applicable. */
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Used only for filtering to limit which teams are displayed in a list. */
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdTeamPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Team>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTemperatureInput = {
  /** °C */
  celsius?: InputMaybe<Scalars['Float']['input']>;
  /** °F */
  fahrenheit?: InputMaybe<Scalars['Float']['input']>;
  /** °K */
  kelvin?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTemplateJobInput = {
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
};

export type UpdateByIdTemplateJobListInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  jobs?: InputMaybe<Array<InputMaybe<UpdateByIdTemplateJobInput>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTemplateJobListPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TemplateJobList>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTemplateSessionDebriefInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumTemplateSessionDebriefMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTemplateSessionDebriefPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TemplateSessionDebrief>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTimeSheetEntryInput = {
  /** Whether a person did work on this day */
  absent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notes about what was done during this time */
  description?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Clock-out time */
  tEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Clock-in time */
  tStart?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdTimeSheetEntryPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TimeSheetEntry>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTimingServiceConfigInput = {
  /** Whether the timingServiceConfig should be considered active by the service */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event ID. This finds the correct event by its _id field. */
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Use schedule-based session matching as fallback. */
  fallbackScheduleBasedSessionMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of timed sectors on track. Used as fallback in case timing data does not provide it. */
  fallbackTimedSectorsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Car numbers to follow. */
  followedCarNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Activate live standings to see the driver championship points live. Only working properly if all drivers of a given season are added as contestants. */
  liveStandingsActive?: InputMaybe<Scalars['Boolean']['input']>;
  logLevel?: InputMaybe<EnumTimingServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<EnumTimingServiceConfigMode>;
  /** Name for this set of configuration settings. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Use string equality to match timing session names in One Racehub. Otherwise default sequence matching is used. */
  strictSessionNameMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** One Timing server port. */
  timingPort?: InputMaybe<Scalars['Int']['input']>;
  /** Race series name to filter on in the timing feed when multiple series are running at an event. */
  timingRaceSeries?: InputMaybe<Scalars['String']['input']>;
  /** One Timing server address. */
  timingURL?: InputMaybe<Scalars['String']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdTimingServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TimingServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTorqueInput = {
  /** Nm */
  newtonMetres?: InputMaybe<Scalars['Float']['input']>;
  /** Nmm */
  newtonMillimetres?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft */
  poundForceFeet?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·in */
  poundForceInches?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTorsionRateInput = {
  /** Nm/° */
  newtonMetresPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** Nm/rad */
  newtonMetresPerRadian?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/° */
  poundForceFeetPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/rad */
  poundForceFeetPerRadian?: InputMaybe<Scalars['Float']['input']>;
  /** lbf-in/° */
  poundForceInchesPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** lbf-in/rad */
  poundForceInchesPerRadian?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  /** Track height above sea level. */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  cameras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  geoLocation?: InputMaybe<UpdateByIdGeoLocationInput>;
  /** IDs of the available track layouts */
  layoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Storage ID of track picture file in s3. */
  trackPicture?: InputMaybe<Scalars['String']['input']>;
  weatherStations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdTrackLayoutInput = {
  ATKModeGain?: InputMaybe<Scalars['Float']['input']>;
  ATKModeLocation?: InputMaybe<Scalars['Float']['input']>;
  ATKModePenalty?: InputMaybe<Scalars['Float']['input']>;
  FCYLapTime?: InputMaybe<Scalars['Float']['input']>;
  /** Full-course yellow probability */
  FCYProbability?: InputMaybe<Scalars['Float']['input']>;
  /** Amount of sectors the timing provides */
  NSectorsTiming?: InputMaybe<Scalars['Float']['input']>;
  SCLapTime?: InputMaybe<Scalars['Float']['input']>;
  /** Safety car probability */
  SCProbability?: InputMaybe<Scalars['Float']['input']>;
  SoCRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  acronym?: InputMaybe<Scalars['String']['input']>;
  bumpiness?: InputMaybe<Scalars['Float']['input']>;
  cameras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code60LapTime?: InputMaybe<Scalars['Float']['input']>;
  crossoverWetToSlick?: InputMaybe<Scalars['Float']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  energyRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  expectedRaceLaps?: InputMaybe<Scalars['Float']['input']>;
  firstLapOffset?: InputMaybe<Scalars['Float']['input']>;
  fuelRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  inLapTime?: InputMaybe<Scalars['Float']['input']>;
  lapLengthCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapLengthRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapZero?: InputMaybe<Scalars['Boolean']['input']>;
  lapsUntilFullRegen?: InputMaybe<Scalars['Float']['input']>;
  mapElevation?: InputMaybe<Scalars['String']['input']>;
  mapEmergencyExits?: InputMaybe<Scalars['String']['input']>;
  mapPitLane?: InputMaybe<Scalars['String']['input']>;
  mapTrack?: InputMaybe<Scalars['String']['input']>;
  mapTrackGPS?: InputMaybe<Scalars['String']['input']>;
  mapTrackLatLonCsv?: InputMaybe<Scalars['String']['input']>;
  mapTrackXyCsv?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Layout */
  name?: InputMaybe<Scalars['String']['input']>;
  outLapTime?: InputMaybe<Scalars['Float']['input']>;
  overtakingThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Whole distance from entry to exit inlcuding approach and leave */
  pitDistance?: InputMaybe<Scalars['Float']['input']>;
  /** Length of pit lane between the pit lane entry and exit loop (used for mileage calculation of pitlane lap types) */
  pitLength?: InputMaybe<Scalars['Float']['input']>;
  pitLoss?: InputMaybe<Scalars['Float']['input']>;
  pitLossDriveThrough?: InputMaybe<Scalars['Float']['input']>;
  /** Indicates whether the pole position is on the left- or right-hand side */
  polePosition?: InputMaybe<EnumTrackLayoutPolePosition>;
  prepLapTime?: InputMaybe<Scalars['Float']['input']>;
  pushLapTime?: InputMaybe<Scalars['Float']['input']>;
  sectorDistance?: InputMaybe<Scalars['Float']['input']>;
  sectorLengths?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Downforce sensitivity (seconds per 10pts) */
  sensDownforce?: InputMaybe<Scalars['Float']['input']>;
  /** Drag sensitivity (seconds per 10pts) */
  sensDrag?: InputMaybe<Scalars['Float']['input']>;
  sensEP?: InputMaybe<Scalars['Float']['input']>;
  /** Energy sensitivity (seconds per 0.1kWh) */
  sensEnergy?: InputMaybe<Scalars['Float']['input']>;
  /** Grip sensitivity (seconds per %) */
  sensGrip?: InputMaybe<Scalars['Float']['input']>;
  /** Mass sensitivity (seconds per 10kg) */
  sensMass?: InputMaybe<Scalars['Float']['input']>;
  /** Power sensitivity */
  sensPower?: InputMaybe<Scalars['Float']['input']>;
  simulationModels?: InputMaybe<Array<InputMaybe<UpdateByIdTrackLayoutSimulationModelInput>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackEvolution?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the track this layout belongs to */
  trackID?: InputMaybe<Scalars['MongoID']['input']>;
  trackLayoutType?: InputMaybe<EnumTrackLayoutTrackLayoutType>;
  trackRecordQuali?: InputMaybe<Scalars['Float']['input']>;
  trackRecordRace?: InputMaybe<Scalars['Float']['input']>;
  weatherStations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdTrackLayoutPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackLayout>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackLayoutSimulationModelInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  canopyID?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<EnumSimModelType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTrackPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Track>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackStateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  flag?: InputMaybe<EnumTrackStateFlag>;
  message?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdTrackableInput = {
  criticalValue?: InputMaybe<Scalars['Float']['input']>;
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the original version of the specifications to track. */
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  unitType?: InputMaybe<UpdateByIdBaseTypedUnitFieldInput>;
  /** Comparison to use when checking if the tracked value is in the warning/critical range. */
  warningDirection?: InputMaybe<EnumTrackableWarningDirection>;
  warningValue?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackablePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Trackable>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackingItemInput = {
  NDecimals?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  arrayElements?: InputMaybe<Scalars['Float']['input']>;
  criticalCumulativeValue?: InputMaybe<Scalars['Float']['input']>;
  criticalValue?: InputMaybe<Scalars['Float']['input']>;
  cumulativeCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  isArray?: InputMaybe<Scalars['Boolean']['input']>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  measurementImage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<EnumTrackingItemOperator>;
  resettable?: InputMaybe<Scalars['Boolean']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
  warningCumulativeValue?: InputMaybe<Scalars['Float']['input']>;
  warningValue?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackingItemPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackingItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackingMeasurementDefaultCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackingMeasurementDefaultRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackingMeasurementInput = {
  defaultCoordinates?: InputMaybe<UpdateByIdTrackingMeasurementDefaultCoordinatesInput>;
  defaultRotation?: InputMaybe<UpdateByIdTrackingMeasurementDefaultRotationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdTrackingMeasurementPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackingMeasurement>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackingMeasurementRecordCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackingMeasurementRecordInput = {
  assemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  coordinates?: InputMaybe<UpdateByIdTrackingMeasurementRecordCoordinatesInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  rotation?: InputMaybe<UpdateByIdTrackingMeasurementRecordRotationInput>;
  trackingMeasurementID?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdTrackingMeasurementRecordPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackingMeasurementRecord>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackingMeasurementRecordRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackingRecordInput = {
  arrayValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateResolved?: InputMaybe<Scalars['Date']['input']>;
  forceTable?: InputMaybe<UpdateByIdForceTableInput>;
  location?: InputMaybe<UpdateByIdLocationInput>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  qualityCheckID?: InputMaybe<Scalars['MongoID']['input']>;
  recordErrors?: InputMaybe<Scalars['String']['input']>;
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  statusEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumTrackingRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedByID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTrackingRecordPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackingRecord>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackingSourceAliasInput = {
  aliasString?: InputMaybe<Scalars['String']['input']>;
  aliasType?: InputMaybe<EnumTrackingSourceAliasAliasType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackingSourceAliasPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackingSourceAlias>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackingSourceInput = {
  NDecimals?: InputMaybe<Scalars['Float']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdTrackingSourcePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackingSource>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTyreHeatingScheduleEntryInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTyreInput = {
  /** Flag if the tyre is scrapped (no longer available for use). */
  BTyreScrapped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tyre Circumference */
  CTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Arbitrary string to sort or filter by */
  additionalSortProperty?: InputMaybe<Scalars['String']['input']>;
  axle?: InputMaybe<EnumTyreAxle>;
  barcodeManufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Barcode from the regulatory body (e.g. FIA) */
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  barcodeRim?: InputMaybe<Scalars['String']['input']>;
  barcodeTPMS?: InputMaybe<Scalars['String']['input']>;
  batteryTPMS?: InputMaybe<Scalars['String']['input']>;
  compound?: InputMaybe<Scalars['String']['input']>;
  compoundComment?: InputMaybe<Scalars['String']['input']>;
  constructionComment?: InputMaybe<Scalars['String']['input']>;
  constructionSpec?: InputMaybe<Scalars['String']['input']>;
  heatingSchedule?: InputMaybe<Array<InputMaybe<UpdateByIdTyreHeatingScheduleEntryInput>>>;
  initialCondition?: InputMaybe<EnumTyreInitialCondition>;
  /** Tyre Spring Rate */
  kTyre?: InputMaybe<Scalars['Float']['input']>;
  mTyre?: InputMaybe<Scalars['Float']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturingDate?: InputMaybe<Scalars['Date']['input']>;
  /** Tyre mold information */
  mold?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Tyre minimum pressure defined by regulation or manufacturer */
  pTyreMinRegulation?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure defined by team (i.e. chief engineer) */
  pTyreMinTeam?: InputMaybe<Scalars['Float']['input']>;
  rimPartID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Initial mileage before use in One Racehub. */
  sRunInitial?: InputMaybe<Scalars['Float']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  wearMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdTyrePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tyre>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTyrePressureSettingsInput = {
  TAirReference?: InputMaybe<Scalars['Float']['input']>;
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTyreSetInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tyreIDFL?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDFR?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDRL?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDRR?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdTyreSetPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TyreSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTyreTableBlockRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<EnumTyreTableField>;
  highlightChanges?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<UpdateByIdValueLimitInput>;
  upperLimit?: InputMaybe<UpdateByIdValueLimitInput>;
};

export type UpdateByIdTyreWearInput = {
  /** Time at which this measurement was made. */
  date?: InputMaybe<Scalars['Date']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Raw wear data formatted however the user chooses, probably from a scanner. */
  wearData?: InputMaybe<Scalars['String']['input']>;
  /** Map of marker names to wear values. Input syntax is array of key-value tuples, like `wearMarkers: [["inner", 0.8], ["1", 0.3]]`. */
  wearMarkers?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdTyreWearPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TyreWear>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdUserEnumInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserEnumType>;
};

export type UpdateByIdUserEnumPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<UserEnum>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdUserSimulationSettingsInput = {
  TAmbientPreferred?: InputMaybe<Scalars['Float']['input']>;
  pAmbientPreferred?: InputMaybe<Scalars['Float']['input']>;
  rHumidityPreferred?: InputMaybe<Scalars['Float']['input']>;
  /** User defined run sim slot colours, index corresponds to run slot number. */
  runSimSlotColours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** User defined setup sim slot colours, index corresponds to setup slot number. */
  setupSimSlotColours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** IDs of the two user defined setups */
  userDefinedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdValueLimitInput = {
  /** Background color to use if the value goes beyond this limit. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Text color to use if the value goes beyond this limit. */
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdVelocityInput = {
  /** ft/s */
  feetPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** kph */
  kilometresPerHour?: InputMaybe<Scalars['Float']['input']>;
  /** m/s */
  metresPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** mph */
  milesPerHour?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdViewConfigInput = {
  /** Should tyre mileages be highlighted according to `yellowTyreMileageThreshold` and `redTyreMileageThreshold`? */
  highlightTyreMileages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted red instead of yellow. */
  redTyreMileageThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Should the user see runsheet via scrolling or via tabs? */
  showRunSheetsAsTabs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted yellow instead of green. */
  yellowTyreMileageThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdVoltageInput = {
  /** mV */
  millivolts?: InputMaybe<Scalars['Float']['input']>;
  /** V */
  volts?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdVolumeInput = {
  /** cm³ */
  cubicCentimetres?: InputMaybe<Scalars['Float']['input']>;
  /** ft³ */
  cubicFeet?: InputMaybe<Scalars['Float']['input']>;
  /** in³ */
  cubicInches?: InputMaybe<Scalars['Float']['input']>;
  /** m³ */
  cubicMetres?: InputMaybe<Scalars['Float']['input']>;
  /** gal (US fluid) */
  gallonsUS?: InputMaybe<Scalars['Float']['input']>;
  /** L */
  litres?: InputMaybe<Scalars['Float']['input']>;
  /** mL */
  millilitres?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdWeatherDataInput = {
  /** Air temperature (mean in historical data) */
  TAir?: InputMaybe<Scalars['Float']['input']>;
  /** Predicted air temperature for given session. E.g. for tyre pressure calculation */
  TAirExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum air temperature (for use in historical data) */
  TAirMax?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum air temperature (for use in historical data) */
  TAirMin?: InputMaybe<Scalars['Float']['input']>;
  /** Air temperature from official sources (e.g. FIA) */
  TAirOfficial?: InputMaybe<Scalars['Float']['input']>;
  /** Ambient temperature */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Temperature to which air must be cooled to become saturated with water vapor */
  TDewPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Weather station internal temperature */
  TInternal?: InputMaybe<Scalars['Float']['input']>;
  /** Track temperature */
  TTrack?: InputMaybe<Scalars['Float']['input']>;
  /** Expected track temperature. E.g. for tyre pressure calculation */
  TTrackExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Track temperature from official sources (e.g. FIA) */
  TTrackOfficial?: InputMaybe<Scalars['Float']['input']>;
  /** Wind chill factor */
  TWindChill?: InputMaybe<Scalars['Float']['input']>;
  /** Weather station battery voltage */
  VBattery?: InputMaybe<Scalars['Float']['input']>;
  /** Wind direction in radians (0 = North, π/2 = East, π = South, 3π/2 = West) */
  aWind?: InputMaybe<Scalars['Float']['input']>;
  /** Main wind direction during the saving interval */
  aWindMain?: InputMaybe<Scalars['Float']['input']>;
  /** Verbal describing ambient condition like cloudy, sunny, overcast, miserable, … */
  ambientCondition?: InputMaybe<Scalars['String']['input']>;
  globalRadiation?: InputMaybe<Scalars['Float']['input']>;
  /** Ambient pressure */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Humidity ratio */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Amount of rain in m³/m² (so m) */
  rainIntensity?: InputMaybe<Scalars['Float']['input']>;
  /** Rain chance as a ratio */
  rainProbability?: InputMaybe<Scalars['Float']['input']>;
  /** Time stamp for this datum */
  time?: InputMaybe<Scalars['Date']['input']>;
  /** Verbal describing track condition like dry, damp, … */
  trackCondition?: InputMaybe<Scalars['String']['input']>;
  /** Wind velocity */
  vWind?: InputMaybe<Scalars['Float']['input']>;
  /** Average wind velocity */
  vWindAverage?: InputMaybe<Scalars['Float']['input']>;
  /** Peak wind velocity */
  vWindPeak?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdWeatherInput = {
  /** Height above sea level (for air density for example). */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  data?: InputMaybe<Array<InputMaybe<UpdateByIdWeatherDataInput>>>;
  /** References to events this weather data was made for, if applicable */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  geoLocation?: InputMaybe<UpdateByIdGeoLocationInput>;
  /** User notes for completing a forecast for a race */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Forecast/measurement source (website, weather station, timekeeping, …) */
  source?: InputMaybe<Scalars['String']['input']>;
  /** For predictions, indicates the time at which the prediction was made. For measurements, indicates the time of the first measurement in the array. */
  time?: InputMaybe<Scalars['Date']['input']>;
  /** Prediction, measurement, historical */
  type?: InputMaybe<EnumWeatherType>;
  /** Weather station ID */
  weatherStationID?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdWeatherPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Weather>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdWeatherServiceConfigInput = {
  /** API Key. Used for Open Weather Map and Wunderground */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** API Secret. Used for Weather Link */
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Password. Currently used for meteomatics */
  password?: InputMaybe<Scalars['String']['input']>;
  refreshInterval?: InputMaybe<Scalars['Float']['input']>;
  requestLocation?: InputMaybe<UpdateByIdGeoLocationInput>;
  /** Location or weather station */
  requestType?: InputMaybe<EnumWeatherServiceConfigRequestType>;
  /** Weather client to specify the source where to retrieve the data from. */
  source?: InputMaybe<EnumWeatherServiceConfigSource>;
  type?: InputMaybe<EnumWeatherServiceConfigType>;
  /** Username. Currently used for meteomatics */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Weather Station ID. Used for Weather Underground */
  weatherStationID?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdWeatherServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<WeatherServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateCarSetupResult = {
  updatedCarSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type UpdateCommentResult = {
  comment?: Maybe<Comment>;
  recordId: Scalars['MongoID']['output'];
};

export type UpdateMeInput = {
  /** 3-letter acronym for drivers */
  acronym?: InputMaybe<Scalars['String']['input']>;
  behaviour?: InputMaybe<UpdateByIdBehaviourConfigInput>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  canopyCredentials?: InputMaybe<UpdateByIdCanopyCredentialsInput>;
  carUpdateMethod?: InputMaybe<EnumMeCarUpdateMethod>;
  defaultFlexLayoutConfigs?: InputMaybe<UpdateByIdDefaultFlexLayoutConfigsInput>;
  defaultRunSheetCompareStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStylePhoneID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultTyreReferenceTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** Default string for tyre set naming, where x=Chassis, i=Info, s=SetNumber, (c=Corner or a=Axle) */
  defaultTyreSetNameFormat?: InputMaybe<Scalars['String']['input']>;
  displayColor?: InputMaybe<Scalars['String']['input']>;
  dynoConfigID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of contestants editable to this person when logged in. */
  editableContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotificationConfig?: InputMaybe<UpdateByIdNotificationConfigInput>;
  /** Should this user be able to track his working time? */
  isTimeTracker?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to see, update and approve working times for other users? */
  isTimeTrackerAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequenceTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  localConnections?: InputMaybe<Array<InputMaybe<UpdateByIdLocalConnectionInput>>>;
  mileageUnit?: InputMaybe<EnumLengthUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  passportPicture?: InputMaybe<Scalars['String']['input']>;
  /** Collection of favourite plot page config IDs. */
  plotPageConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  privateMobile?: InputMaybe<Scalars['Float']['input']>;
  privatePhone?: InputMaybe<Scalars['Float']['input']>;
  /** Collection of favourite setup overview config IDs. */
  setupOverviewConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  ssoRefs?: InputMaybe<Scalars['JSON']['input']>;
  timeTrackerApprovalByPersonID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Collection of personal setup IDs. */
  userSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userSimulationSettings?: InputMaybe<UpdateByIdUserSimulationSettingsInput>;
  viewConfig?: InputMaybe<UpdateByIdViewConfigInput>;
  /** IDs of teams visible to this person when logged in. */
  visibleTeamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  workMobile?: InputMaybe<Scalars['Float']['input']>;
  workPhone?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateMigrationsResult = {
  success: Scalars['Boolean']['output'];
};

export type UpdateRunSheetLapKpiPayload = {
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateServerSettingsResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateSetupSheetLayoutChassisSpecResult = {
  setupSheetStyle?: Maybe<SetupSheetStyle>;
  status?: Maybe<Scalars['String']['output']>;
};

export type UpdateTimingStatusResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateTrackingSourceSourceValueInAssemblyResult = {
  success?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateTyresInSetResult = {
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdatedChassisSpecVersionOnCarSetups = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpsertCarBuildResult = {
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UserEnum = UserEnumAssemblyType | UserEnumBuildSheetGroup | UserEnumPartStatus | UserEnumPartType | UserEnumRunPlannerActionItem | UserEnumSimulationDriveFileType | UserEnumTrackingSeverity;

/** Use this enum to have a custom level of filtering / sorting for your assemblies. */
export type UserEnumAssemblyType = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumAssemblyTypeType;
};

export type UserEnumBuildSheetGroup = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumBuildSheetGroupType;
};

/** List of items with pagination. */
export type UserEnumPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<UserEnum>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type UserEnumPartStatus = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumPartStatusType;
};

export type UserEnumPartType = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumPartTypeType;
};

export type UserEnumRunPlannerActionItem = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumRunPlannerActionItemType;
};

export type UserEnumSimulationDriveFileType = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumSimulationDriveFileTypeType;
};

export type UserEnumTrackingSeverity = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumTrackingSeverityType;
};

export type UserSimulationSettings = {
  TAmbientPreferred?: Maybe<Scalars['Float']['output']>;
  pAmbientPreferred?: Maybe<Scalars['Float']['output']>;
  rHumidityPreferred?: Maybe<Scalars['Float']['output']>;
  /** User defined run sim slot colours, index corresponds to run slot number. */
  runSimSlotColours?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** User defined setup sim slot colours, index corresponds to setup slot number. */
  setupSimSlotColours?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** IDs of the two user defined setups */
  userDefinedSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type UserSimulationSettingsInput = {
  TAmbientPreferred?: InputMaybe<Scalars['Float']['input']>;
  pAmbientPreferred?: InputMaybe<Scalars['Float']['input']>;
  rHumidityPreferred?: InputMaybe<Scalars['Float']['input']>;
  /** User defined run sim slot colours, index corresponds to run slot number. */
  runSimSlotColours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** User defined setup sim slot colours, index corresponds to setup slot number. */
  setupSimSlotColours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** IDs of the two user defined setups */
  userDefinedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type ValidationError = ErrorInterface & {
  /** List of validator errors */
  errors?: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']['output']>;
};

export type ValidatorError = {
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int']['output'];
  /** Validation error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']['output']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type ValueLimit = {
  /** Background color to use if the value goes beyond this limit. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Float']['output']>;
  /** Text color to use if the value goes beyond this limit. */
  textColor?: Maybe<Scalars['String']['output']>;
};

export type ValueLimitInput = {
  /** Background color to use if the value goes beyond this limit. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Text color to use if the value goes beyond this limit. */
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type Velocity = {
  /** ft/s */
  feetPerSecond: Scalars['Float']['output'];
  /** kph */
  kilometresPerHour: Scalars['Float']['output'];
  /** m/s */
  metresPerSecond: Scalars['Float']['output'];
  /** mph */
  milesPerHour: Scalars['Float']['output'];
};

export type VelocityInput = {
  /** ft/s */
  feetPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** kph */
  kilometresPerHour?: InputMaybe<Scalars['Float']['input']>;
  /** m/s */
  metresPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** mph */
  milesPerHour?: InputMaybe<Scalars['Float']['input']>;
};

export type VelocityUnitField = {
  unit: EnumVelocityUnit;
};

export type ViewConfig = {
  /** Should tyre mileages be highlighted according to `yellowTyreMileageThreshold` and `redTyreMileageThreshold`? */
  highlightTyreMileages?: Maybe<Scalars['Boolean']['output']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted red instead of yellow. */
  redTyreMileageThreshold?: Maybe<Scalars['Float']['output']>;
  /** Should the user see runsheet via scrolling or via tabs? */
  showRunSheetsAsTabs?: Maybe<Scalars['Boolean']['output']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted yellow instead of green. */
  yellowTyreMileageThreshold?: Maybe<Scalars['Float']['output']>;
};

export type ViewConfigInput = {
  /** Should tyre mileages be highlighted according to `yellowTyreMileageThreshold` and `redTyreMileageThreshold`? */
  highlightTyreMileages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted red instead of yellow. */
  redTyreMileageThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Should the user see runsheet via scrolling or via tabs? */
  showRunSheetsAsTabs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted yellow instead of green. */
  yellowTyreMileageThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type Voltage = {
  /** mV */
  millivolts: Scalars['Float']['output'];
  /** V */
  volts: Scalars['Float']['output'];
};

export type VoltageInput = {
  /** mV */
  millivolts?: InputMaybe<Scalars['Float']['input']>;
  /** V */
  volts?: InputMaybe<Scalars['Float']['input']>;
};

export type Volume = {
  /** cm³ */
  cubicCentimetres: Scalars['Float']['output'];
  /** ft³ */
  cubicFeet: Scalars['Float']['output'];
  /** in³ */
  cubicInches: Scalars['Float']['output'];
  /** m³ */
  cubicMetres: Scalars['Float']['output'];
  /** gal (US fluid) */
  gallonsUS: Scalars['Float']['output'];
  /** L */
  litres: Scalars['Float']['output'];
  /** mL */
  millilitres: Scalars['Float']['output'];
};

export type VolumeInput = {
  /** cm³ */
  cubicCentimetres?: InputMaybe<Scalars['Float']['input']>;
  /** ft³ */
  cubicFeet?: InputMaybe<Scalars['Float']['input']>;
  /** in³ */
  cubicInches?: InputMaybe<Scalars['Float']['input']>;
  /** m³ */
  cubicMetres?: InputMaybe<Scalars['Float']['input']>;
  /** gal (US fluid) */
  gallonsUS?: InputMaybe<Scalars['Float']['input']>;
  /** L */
  litres?: InputMaybe<Scalars['Float']['input']>;
  /** mL */
  millilitres?: InputMaybe<Scalars['Float']['input']>;
};

export type VolumeUnitField = {
  unit: EnumVolumeUnit;
};

export type Weather = {
  _id: Scalars['MongoID']['output'];
  /** Height above sea level (for air density for example). */
  altitude?: Maybe<Scalars['Float']['output']>;
  data: Array<Maybe<WeatherData>>;
  /** References to events this weather data was made for, if applicable */
  eventIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Events this weather data was made for, if applicable */
  events: Array<Event>;
  geoLocation?: Maybe<GeoLocation>;
  /** User notes for completing a forecast for a race */
  notes?: Maybe<Scalars['String']['output']>;
  /** Forecast/measurement source (website, weather station, timekeeping, …) */
  source?: Maybe<Scalars['String']['output']>;
  /** For predictions, indicates the time at which the prediction was made. For measurements, indicates the time of the first measurement in the array. */
  time?: Maybe<Scalars['Date']['output']>;
  /** Prediction, measurement, historical */
  type: EnumWeatherType;
  /** Weather station ID */
  weatherStationID?: Maybe<Scalars['String']['output']>;
};

export type WeatherBoxBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  pressureUnit?: Maybe<EnumPressureUnit>;
  /** Defines the visibility of the ambient and track condition in the weather block */
  showAmbientAndTrackCondition?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `weatherItems` to select what to show instead. */
  showOfficial?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use other fields to style the block instead */
  style?: Maybe<EnumRunSheetStyleBlockStyle>;
  temperatureUnit?: Maybe<EnumTemperatureUnit>;
  unitSystem?: Maybe<EnumUnitSystem>;
  /** Ordered weather block fields to show */
  weatherFieldOrder?: Maybe<Array<EnumWeatherBlockField>>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type WeatherData = {
  /** Air density */
  DAir?: Maybe<Scalars['Float']['output']>;
  /** Air temperature (mean in historical data) */
  TAir?: Maybe<Scalars['Float']['output']>;
  /** Predicted air temperature for given session. E.g. for tyre pressure calculation */
  TAirExpected?: Maybe<Scalars['Float']['output']>;
  /** Maximum air temperature (for use in historical data) */
  TAirMax?: Maybe<Scalars['Float']['output']>;
  /** Minimum air temperature (for use in historical data) */
  TAirMin?: Maybe<Scalars['Float']['output']>;
  /** Air temperature from official sources (e.g. FIA) */
  TAirOfficial?: Maybe<Scalars['Float']['output']>;
  /**
   * Ambient temperature
   * @deprecated Use TAir or TAirOfficial instead.
   */
  TAmbient?: Maybe<Scalars['Float']['output']>;
  /** Temperature to which air must be cooled to become saturated with water vapor */
  TDewPoint?: Maybe<Scalars['Float']['output']>;
  /** Weather station internal temperature */
  TInternal?: Maybe<Scalars['Float']['output']>;
  /** Track temperature */
  TTrack?: Maybe<Scalars['Float']['output']>;
  /** Expected track temperature. E.g. for tyre pressure calculation */
  TTrackExpected?: Maybe<Scalars['Float']['output']>;
  /** Track temperature from official sources (e.g. FIA) */
  TTrackOfficial?: Maybe<Scalars['Float']['output']>;
  /** Wind chill factor */
  TWindChill?: Maybe<Scalars['Float']['output']>;
  /** Weather station battery voltage */
  VBattery?: Maybe<Scalars['Float']['output']>;
  /** Wind direction in radians (0 = North, π/2 = East, π = South, 3π/2 = West) */
  aWind?: Maybe<Scalars['Float']['output']>;
  /** Main wind direction during the saving interval */
  aWindMain?: Maybe<Scalars['Float']['output']>;
  /** Verbal describing ambient condition like cloudy, sunny, overcast, miserable, … */
  ambientCondition?: Maybe<Scalars['String']['output']>;
  globalRadiation?: Maybe<Scalars['Float']['output']>;
  /** Ambient pressure */
  pAmbient?: Maybe<Scalars['Float']['output']>;
  /** Humidity ratio */
  rHumidity?: Maybe<Scalars['Float']['output']>;
  /** Amount of rain in m³/m² (so m) */
  rainIntensity?: Maybe<Scalars['Float']['output']>;
  /** Rain chance as a ratio */
  rainProbability?: Maybe<Scalars['Float']['output']>;
  /** Time stamp for this datum */
  time?: Maybe<Scalars['Date']['output']>;
  /** Verbal describing track condition like dry, damp, … */
  trackCondition?: Maybe<Scalars['String']['output']>;
  /** Wind velocity */
  vWind?: Maybe<Scalars['Float']['output']>;
  /** Average wind velocity */
  vWindAverage?: Maybe<Scalars['Float']['output']>;
  /** Peak wind velocity */
  vWindPeak?: Maybe<Scalars['Float']['output']>;
};

export type WeatherDataInput = {
  /** Air temperature (mean in historical data) */
  TAir?: InputMaybe<Scalars['Float']['input']>;
  /** Predicted air temperature for given session. E.g. for tyre pressure calculation */
  TAirExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum air temperature (for use in historical data) */
  TAirMax?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum air temperature (for use in historical data) */
  TAirMin?: InputMaybe<Scalars['Float']['input']>;
  /** Air temperature from official sources (e.g. FIA) */
  TAirOfficial?: InputMaybe<Scalars['Float']['input']>;
  /** Ambient temperature */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Temperature to which air must be cooled to become saturated with water vapor */
  TDewPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Weather station internal temperature */
  TInternal?: InputMaybe<Scalars['Float']['input']>;
  /** Track temperature */
  TTrack?: InputMaybe<Scalars['Float']['input']>;
  /** Expected track temperature. E.g. for tyre pressure calculation */
  TTrackExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Track temperature from official sources (e.g. FIA) */
  TTrackOfficial?: InputMaybe<Scalars['Float']['input']>;
  /** Wind chill factor */
  TWindChill?: InputMaybe<Scalars['Float']['input']>;
  /** Weather station battery voltage */
  VBattery?: InputMaybe<Scalars['Float']['input']>;
  /** Wind direction in radians (0 = North, π/2 = East, π = South, 3π/2 = West) */
  aWind?: InputMaybe<Scalars['Float']['input']>;
  /** Main wind direction during the saving interval */
  aWindMain?: InputMaybe<Scalars['Float']['input']>;
  /** Verbal describing ambient condition like cloudy, sunny, overcast, miserable, … */
  ambientCondition?: InputMaybe<Scalars['String']['input']>;
  globalRadiation?: InputMaybe<Scalars['Float']['input']>;
  /** Ambient pressure */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Humidity ratio */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Amount of rain in m³/m² (so m) */
  rainIntensity?: InputMaybe<Scalars['Float']['input']>;
  /** Rain chance as a ratio */
  rainProbability?: InputMaybe<Scalars['Float']['input']>;
  /** Time stamp for this datum */
  time?: InputMaybe<Scalars['Date']['input']>;
  /** Verbal describing track condition like dry, damp, … */
  trackCondition?: InputMaybe<Scalars['String']['input']>;
  /** Wind velocity */
  vWind?: InputMaybe<Scalars['Float']['input']>;
  /** Average wind velocity */
  vWindAverage?: InputMaybe<Scalars['Float']['input']>;
  /** Peak wind velocity */
  vWindPeak?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type WeatherPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Weather>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type WeatherServiceConfig = {
  _id: Scalars['MongoID']['output'];
  /** API Key. Used for Open Weather Map and Wunderground */
  apiKey?: Maybe<Scalars['String']['output']>;
  /** API Secret. Used for Weather Link */
  apiSecret?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  eventIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Events this weather data was made for, if applicable */
  events: Array<Event>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Password. Currently used for meteomatics */
  password?: Maybe<Scalars['String']['output']>;
  refreshInterval: Scalars['Float']['output'];
  requestLocation?: Maybe<GeoLocation>;
  /** Location or weather station */
  requestType: EnumWeatherServiceConfigRequestType;
  /** Weather client to specify the source where to retrieve the data from. */
  source: EnumWeatherServiceConfigSource;
  type: EnumWeatherServiceConfigType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Username. Currently used for meteomatics */
  username?: Maybe<Scalars['String']['output']>;
  /** Weather Station ID. Used for Weather Underground */
  weatherStationID?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type WeatherServiceConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<WeatherServiceConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type GetContestantListForAdminPageQueryVariables = Exact<{
  filter: FilterFindManyContestantInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyContestantInput>;
}>;


export type GetContestantListForAdminPageQuery = { contestants?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ _id: any, chassisNumber?: string | null, class?: string | null, manufacturerID?: any | null, startNumber: string, teamID?: any | null, manufacturer?: { name?: string | null } | null, season?: { name: string, raceSeries?: { name: string } | null } | null }> | null } | null };

export type GetDepartmentsForDepartmentsPageQueryVariables = Exact<{
  filter: FilterFindManyDepartmentInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDepartmentInput>;
}>;


export type GetDepartmentsForDepartmentsPageQuery = { departments?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ name: string, _id: any }> | null } | null };

export type GetDepartmentForDepartmentEditPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetDepartmentForDepartmentEditPageQuery = { department?: { name: string, _id: any } | null };

export type GetAllDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDepartmentsQuery = { departments?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetTrackLayoutsForEventEditPageQueryVariables = Exact<{
  layoutIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetTrackLayoutsForEventEditPageQuery = { trackLayouts?: { items?: Array<{ _id: any, name: string, lapLengthOfficial?: number | null, lapLengthCarData?: number | null, NSectorsTiming?: number | null, trackID: any, track?: { _id: any, name: string } | null }> | null } | null };

export type AddEventContestantMutationVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
  contestantID: Scalars['MongoID']['input'];
}>;


export type AddEventContestantMutation = { addEventContestant?: { success: boolean } | null };

export type AddEventContestantsMutationVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
  contestantIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type AddEventContestantsMutation = { addManyEventContestants?: { success: boolean } | null };

export type RemoveEventContestantMutationVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
  contestantID: Scalars['MongoID']['input'];
}>;


export type RemoveEventContestantMutation = { removeEventContestant?: { success: boolean } | null };

export type RemoveEventContestantsMutationVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
  contestantIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RemoveEventContestantsMutation = { removeManyEventContestants?: { success: boolean } | null };

export type UpdateDriversInEventContestantMutationVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
  contestantID: Scalars['MongoID']['input'];
  driverIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type UpdateDriversInEventContestantMutation = { updateDriversInEventContestant?: { contestants?: Array<{ _id: any, driverIDs?: Array<any | null> | null } | null> | null } | null };

export type Event_GetEventsQueryVariables = Exact<{
  eventName?: InputMaybe<Scalars['String']['input']>;
}>;


export type Event_GetEventsQuery = { events?: { items?: Array<{ _id: any, name: string, NEventSeason?: number | null, tEventStart?: any | null, tEventEnd?: any | null, tLapAverage?: number | null }> | null } | null };

export type GetSeriesInfoForEditPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSeriesInfoForEditPageQuery = { raceSeries?: { _id: any, groupName?: string | null, name: string, shortName?: string | null, sortingIndex?: number | null, lapTypeConfig?: LapTypeConfigVarsFragment | null } | null };

export type LapTypeConfigVarsFragment = { ATTACK?: { lapTypeColor?: string | null, displayString: string, name: string } | null, COOL?: { lapTypeColor?: string | null, displayString: string, name: string } | null, FCY?: { lapTypeColor?: string | null, displayString: string, name: string } | null, IN?: { lapTypeColor?: string | null, displayString: string, name: string } | null, OUT?: { lapTypeColor?: string | null, displayString: string, name: string } | null, OUTIN?: { lapTypeColor?: string | null, displayString: string, name: string } | null, PITLANE?: { lapTypeColor?: string | null, displayString: string, name: string } | null, PREP?: { lapTypeColor?: string | null, displayString: string, name: string } | null, PUSH?: { lapTypeColor?: string | null, displayString: string, name: string } | null, QUALI?: { lapTypeColor?: string | null, displayString: string, name: string } | null, SAFETYCAR?: { lapTypeColor?: string | null, displayString: string, name: string } | null, SHAKEDOWN?: { lapTypeColor?: string | null, displayString: string, name: string } | null, SLOW?: { lapTypeColor?: string | null, displayString: string, name: string } | null, TARGET?: { lapTypeColor?: string | null, displayString: string, name: string } | null, TOGRID?: { lapTypeColor?: string | null, displayString: string, name: string } | null, TOPADDOCK?: { lapTypeColor?: string | null, displayString: string, name: string } | null, TOPITS?: { lapTypeColor?: string | null, displayString: string, name: string } | null, UNFINISHED?: { lapTypeColor?: string | null, displayString: string, name: string } | null };

export type GetIDsForRecalculateMileagesForSeasonQueryVariables = Exact<{
  seasonID: Scalars['MongoID']['input'];
}>;


export type GetIDsForRecalculateMileagesForSeasonQuery = { season?: { contestantIDs?: Array<any | null> | null, events: Array<{ sessionIDs?: Array<any | null> | null }> } | null };

export type GetRunSheetIDsForRecalculateMileagesForSeasonQueryVariables = Exact<{
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetRunSheetIDsForRecalculateMileagesForSeasonQuery = { runSheets?: { items?: Array<{ _id: any }> | null } | null };

export type CalculateAllMileagesForSeasonMutationVariables = Exact<{
  runSheetIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CalculateAllMileagesForSeasonMutation = { calculateMileagesByRunSheetIDs: boolean };

export type GetSessionStandingsForSessionPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSessionStandingsForSessionPageQuery = { session?: { _id: any, event?: { _id: any, season?: { _id: any, contestants: Array<{ _id: any, startNumber: string }> } | null, contestants?: Array<{ _id: any } | null> | null } | null, contestants?: Array<{ _id: any } | null> | null, driverChampionshipStandings?: Array<{ startNumber?: string | null, acronym?: string | null, points: number, driverID?: any | null, prevRacePositions?: Array<number | null> | null, rank?: number | null } | null> | null, liveStandings?: Array<{ startNumber?: string | null, acronym?: string | null, driverID?: any | null, position: number } | null> | null, teamChampionshipStandings?: Array<{ teamID: any, points: number, rank?: number | null, team?: { name: string, shortName?: string | null } | null } | null> | null } | null };

export type GetSessionForEditPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSessionForEditPageQuery = { session?: { _id: any, customSimulationPayload?: any | null, debriefNotes?: string | null, disableForwardPropagation?: boolean | null, eventID: any, isLinkedSession?: boolean | null, name: string, pointsSystemOverrideIDs?: Array<any | null> | null, sessionType?: EnumSessionType | null, shortName?: string | null, timeRemaining?: number | null, timeRemainingUpdatedAt?: any | null, tSessionEnd?: any | null, tSessionStart?: any | null, contestants?: Array<{ _id: any } | null> | null, driverChampionshipStandings?: Array<{ acronym?: string | null, contestantID?: any | null, driverID?: any | null, points: number, prevRacePositions?: Array<number | null> | null, rank?: number | null, startNumber?: string | null, driver?: { acronym?: string | null } | null } | null> | null, event?: { trackLayouts: Array<{ _id: any, track?: { timeZone?: string | null } | null }>, season?: { pointsSystemQualiAlternates: Array<{ _id: any, name: string, sessionType?: EnumSessionType | null }>, pointsSystemRaceAlternates: Array<{ _id: any, name: string, sessionType?: EnumSessionType | null }> } | null, sessions: Array<{ _id: any, name: string, eventID: any, tSessionEnd?: any | null, tSessionStart?: any | null, bop?: { carBop?: Array<{ carSpec?: string | null } | null> | null } | null }> } | null, pointsSystemOverrides: Array<{ _id: any, name: string, sessionType?: EnumSessionType | null }>, teamChampionshipStandings?: Array<TeamsChampionshipStandingsVarsFragment | null> | null } | null };

export type TeamsChampionshipStandingsVarsFragment = { contestantIDs?: Array<any | null> | null, points: number, rank?: number | null, teamID: any, team?: { name: string } | null };

export type GetEventSessionsForSessionsListQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEventSessionsForSessionsListQuery = { event?: { _id: any, name: string, sessions: Array<SessionInfoForSessionsListFragment>, season?: { _id: any, name: string, raceSeries?: { _id: any, name: string } | null } | null, track?: { _id: any, name: string, timeZone?: string | null } | null } | null };

export type SessionInfoForSessionsListFragment = { _id: any, name: string, shortName?: string | null, tSessionStart?: any | null, tSessionEnd?: any | null, prevSessionID?: any | null, nextSessionID?: any | null, isLinkedSession?: boolean | null, bopID?: any | null };

export type GetLocationsForLocationListPageQueryVariables = Exact<{
  filter: FilterFindManyLocationInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLocationInput>;
}>;


export type GetLocationsForLocationListPageQuery = { locations?: { count?: number | null, pageInfo: { currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean, itemCount: number, pageCount: number, perPage?: number | null }, items?: Array<{ _id: any, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, contact?: string | null, country?: string | null, description?: string | null, email?: string | null, name: string, phone?: string | null, postcode?: string | null, region?: string | null, timeZone?: string | null }> | null } | null };

export type GetContestantsForPersonVisibleContestantTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContestantsForPersonVisibleContestantTreeQuery = { contestants?: { items?: Array<{ _id: any, startNumber: string, season?: { _id: any, name: string, raceSeries?: { _id: any, name: string } | null } | null }> | null } | null };

export type GetPersonListForAdminPageQueryVariables = Exact<{
  filter: FilterFindManyPersonInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPersonInput>;
}>;


export type GetPersonListForAdminPageQuery = { people?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<PersonVarsForAdminPageFragment> | null } | null };

export type PersonVarsForAdminPageFragment = { _id: any, acronym?: string | null, email?: string | null, isActive?: boolean | null, name: string, role?: EnumPersonRole | null, username: string };

export type GetPointsSystemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPointsSystemsQuery = { pointsSystems?: { items?: Array<{ laptimeDriverPoints?: Array<number | null> | null, laptimePositionCutoff?: number | null, laptimeTeamPoints?: Array<number | null> | null, name: string, positionalCompletionMin?: number | null, positionalCompletionMinRatio?: number | null, positionalDriverPoints?: Array<number | null> | null, positionalTeamPoints?: Array<number | null> | null, sessionType?: EnumSessionType | null, _id: any }> | null } | null };

export type GetPointsSystemByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPointsSystemByIdQuery = { pointsSystem?: { _id: any, name: string, sessionType?: EnumSessionType | null, laptimeDriverPoints?: Array<number | null> | null, laptimePositionCutoff?: number | null, laptimeTeamPoints?: Array<number | null> | null, positionalCompletionMin?: number | null, positionalCompletionMinRatio?: number | null, positionalDriverPoints?: Array<number | null> | null, positionalTeamPoints?: Array<number | null> | null } | null };

export type AddPointsSystemMutationVariables = Exact<{
  record: CreateOnePointsSystemInput;
}>;


export type AddPointsSystemMutation = { addPointsSystem?: { recordId?: any | null } | null };

export type UpdatePointsSystemMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdPointsSystemInput;
}>;


export type UpdatePointsSystemMutation = { updatePointsSystem?: { recordId?: any | null } | null };

export type RemovePointsSystemMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemovePointsSystemMutation = { removePointsSystem?: { recordId?: any | null } | null };

export type ServerSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ServerSettingsQuery = { serverSettings?: { copyAssembly?: { copyInactiveParts?: boolean | null } | null, simulationColoring?: { method?: EnumServerSettingsSimulationColoringMethod | null } | null } | null };

export type UpdateServerSettingsMutationVariables = Exact<{
  serverSettings: ServerSettingsInput;
}>;


export type UpdateServerSettingsMutation = { updateServerSettings?: { success?: boolean | null } | null };

export type GetTagsForTagsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsForTagsPageQuery = { tags?: { items?: Array<{ group?: string | null, _id: any, label: string, tagType?: EnumTagType | null }> | null } | null };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTagInput;
}>;


export type UpdateTagMutation = { updateTag?: { recordId?: any | null } | null };

export type GetTagByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTagByIdQuery = { tag?: { tagType?: EnumTagType | null, label: string, _id: any } | null };

export type RemoveTagMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTagMutation = { removeTag?: { recordId?: any | null } | null };

export type Tracks_TrackLayoutMapDataFragment = { _id: any, mapTrackXy?: { warnings: Array<string>, sectorPositions: Array<number>, keyValueData: Array<{ key: string, value: string }>, svg: { width: number, height: number, svgPath: string }, labels: Array<{ alignment: TrackLabelAlignment, name: string, x: number, y: number }>, coordinates: Array<{ distance: number, time: number, x: number, y: number }> } | null, mapTrackLatLon?: { warnings: Array<string>, sectorPositions: Array<number>, keyValueData: Array<{ key: string, value: string }>, svg: { width: number, height: number, svgPath: string }, labels: Array<{ alignment: TrackLabelAlignment, name: string, x: number, y: number }>, coordinates: Array<{ distance: number, time: number, x: number, y: number }> } | null };

export type Tracks_AddTrackMutationVariables = Exact<{
  record: CreateOneTrackInput;
}>;


export type Tracks_AddTrackMutation = { addTrack?: { recordId?: any | null } | null };

export type Tracks_GetTrackQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type Tracks_GetTrackQuery = { track?: { _id: any, acronym?: string | null, name: string, timeZone?: string | null, layouts: Array<(
      { _id: any, name: string, lapLengthOfficial?: number | null, lapLengthCarData?: number | null, NSectorsTiming?: number | null }
      & Tracks_TrackLayoutMapDataFragment
    )> } | null };

export type Tracks_AddTrackLayoutMutationVariables = Exact<{
  record: CreateOneTrackLayoutInput;
}>;


export type Tracks_AddTrackLayoutMutation = { addTrackLayout?: { record?: Tracks_TrackLayoutMapDataFragment | null } | null };

export type GetTracksPageInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTracksPageInfoQuery = { person?: { _id: any, mileageUnit?: EnumLengthUnit | null } | null, tracks?: { items?: Array<{ _id: any, altitude?: number | null, acronym?: string | null, layoutIDs?: Array<any | null> | null, name: string, timeZone?: string | null, layouts: Array<{ _id: any, acronym?: string | null, name: string, lapLengthOfficial?: number | null, NSectorsTiming?: number | null }> }> | null } | null };

export type GetUserEnumsForAdminPageQueryVariables = Exact<{
  filter: FilterFindManyUserEnumInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserEnumInput>;
}>;


export type GetUserEnumsForAdminPageQuery = { userEnums?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename: 'UserEnumAssemblyType', _id?: any | null, name: string } | { __typename: 'UserEnumBuildSheetGroup', _id?: any | null, name: string } | { __typename: 'UserEnumPartStatus', _id?: any | null, name: string, active?: boolean | null } | { __typename: 'UserEnumPartType', _id?: any | null, name: string } | { __typename: 'UserEnumRunPlannerActionItem', _id?: any | null, name: string } | { __typename: 'UserEnumSimulationDriveFileType', _id?: any | null, name: string } | { __typename: 'UserEnumTrackingSeverity', _id?: any | null, name: string }> | null } | null };

export type UpdateTrackingSourceSourceValueInAssemblyMutationVariables = Exact<{
  assemblyID: Scalars['MongoID']['input'];
  trackingSourceAliasID: Scalars['MongoID']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdateTrackingSourceSourceValueInAssemblyMutation = { updateTrackingSourceSourceValueInAssembly?: { success?: any | null } | null };

export type FixAssemblyTrackingMutationVariables = Exact<{
  chassisAssemblyIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type FixAssemblyTrackingMutation = { fixAssemblyTracking?: { deletedCount: number, insertedRecords: Array<{ _id: any }> } | null };

export type FixTrackingForAssemblyPartsMutationVariables = Exact<{
  chassisAssemblyID: Scalars['MongoID']['input'];
}>;


export type FixTrackingForAssemblyPartsMutation = { fixTrackingForAssemblyParts?: { success?: boolean | null } | null };

export type GetChassisAssemblyForEditAssemblyFixQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisAssemblyForEditAssemblyFixQuery = { assembly?: ChassisAssemblyForEditAssemblyFixFragment | {} | null };

export type ChassisAssemblyForEditAssemblyFixFragment = { __typename: 'ChassisAssembly', chassisPartID?: any | null, assemblyTemplateID?: any | null, locationID?: any | null, carSetupID?: any | null, nestedPartInstanceIDs?: Array<any | null> | null, partInstanceIDs?: Array<any | null> | null, subAssemblyIDs?: Array<any | null> | null, tagIDs?: Array<any | null> | null, location?: { _id: any } | null, carSetup?: { runSheetID?: any | null } | null, nestedPartInstances: Array<{ _id: any, readingLocation?: EnumReadingLocation | null, specificationID?: any | null, superParentID?: any | null, partID?: any | null, part?: { _id: any, reference: string, userEnumPartTypeID?: any | null, specification?: { name: string } | null } | null }>, partInstances: Array<{ _id: any, readingLocation?: EnumReadingLocation | null, specificationID?: any | null, superParentID?: any | null, partID?: any | null, part?: { _id: any, reference: string, userEnumPartTypeID?: any | null, specification?: { name: string } | null } | null }>, subAssemblies: Array<{ _id?: any | null, chassisSpecID?: any | null, name: string, reference?: string | null }>, tags: Array<{ _id: any }> };

export type FixChassisAssemblyPartInstanceArraysForAssemblyFixPageMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type FixChassisAssemblyPartInstanceArraysForAssemblyFixPageMutation = { fixPartInstanceArrays?: { success?: any | null } | null };

export type GetAssemblyPartsByParentIdQueryVariables = Exact<{
  assemblyID: Scalars['MongoID']['input'];
}>;


export type GetAssemblyPartsByParentIdQuery = { partInstances?: { items?: Array<{ _id: any, readingLocation?: EnumReadingLocation | null, part?: { _id: any, reference: string, specificationID?: any | null, specification?: { name: string } | null } | null }> | null } | null };

export type GetPartsByChassisSpecIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartsByChassisSpecIdQuery = { parts?: { items?: Array<{ _id: any, reference: string, manufacturerPartID?: string | null, rootSpecificationID?: any | null, specification?: { _id: any, chassisSpecID?: any | null, readingsRequired?: EnumSpecificationReadingsRequired | null } | null }> | null } | null };

export type GetSubAssembliesByChassisSpecIdQueryVariables = Exact<{
  chassisSpecID: Scalars['MongoID']['input'];
  parentAssemblyID: Scalars['MongoID']['input'];
}>;


export type GetSubAssembliesByChassisSpecIdQuery = { assemblies?: { items?: Array<{ _id?: any | null, name: string, reference?: string | null } | {}> | null } | null, assembly?: { subAssemblyIDs?: Array<any | null> | null } | { subAssemblyIDs?: Array<any | null> | null } | null };

export type GetSubAssembliesByParentIdQueryVariables = Exact<{
  parentAssemblyID: Scalars['MongoID']['input'];
}>;


export type GetSubAssembliesByParentIdQuery = { assembly?: { _id?: any | null, chassisSpecID?: any | null, subAssemblyIDs?: Array<any | null> | null, chassisSubAssemblies: Array<SubAssemblyTableVarsFragment> } | { _id?: any | null, chassisSpecID?: any | null, subAssemblyIDs?: Array<any | null> | null, subAssemblySubAssemblies: Array<SubAssemblyTableVarsFragment> } | null };

export type SubAssemblyTableVarsFragment = { _id?: any | null, name: string, chassisSpecID?: any | null, reference?: string | null, subAssemblies: Array<{ _id?: any | null, name: string }> };

export type GetTrackingSourceRecordsOnChassisAssemblyForAssemblyPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTrackingSourceRecordsOnChassisAssemblyForAssemblyPageQuery = { assembly?: ChassisAssemblyVarsForAssemblyPageFragment | {} | null };

export type ChassisAssemblyVarsForAssemblyPageFragment = { _id?: any | null, trackingSourceRecords?: Array<{ trackingSourceID?: any | null, value?: number | null, sources?: Array<{ trackingSourceAliasID?: any | null, value?: number | null } | null> | null, trackingSource?: { _id: any, chassisSpecID: any, displayUnit?: EnumDisplayUnit | null, isDefault?: boolean | null, name: string, NDecimals?: number | null, sourceIDs?: Array<any | null> | null, sources: Array<{ _id: any, aliasString?: string | null, aliasType?: EnumTrackingSourceAliasAliasType | null, displayUnit?: EnumDisplayUnit | null }> } | null } | null> | null };

export type GetTrackingSourcesOnChassisSpecForAssemblyPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTrackingSourcesOnChassisSpecForAssemblyPageQuery = { specification?: ChassisSpecVarsForAssemblyPageFragment | {} | null };

export type ChassisSpecVarsForAssemblyPageFragment = { trackingSourceIDs?: Array<any | null> | null, trackingSources: Array<ChassisTrackingSourceVarsForAssemblyPageFragment> };

export type ChassisTrackingSourceVarsForAssemblyPageFragment = { name: string, chassisSpecID: any, displayUnit?: EnumDisplayUnit | null, isDefault?: boolean | null, sourceIDs?: Array<any | null> | null, _id: any, sources: Array<{ aliasType?: EnumTrackingSourceAliasAliasType | null, aliasString?: string | null, displayUnit?: EnumDisplayUnit | null, _id: any }> };

export type GetDataOverviewAssembliesQueryVariables = Exact<{
  filter: FilterFindManyAssemblyInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssemblyInput>;
}>;


export type GetDataOverviewAssembliesQuery = { assemblies?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename: 'ChassisAssembly', _id?: any | null, chassisSpecID?: any | null, name: string, reference?: string | null } | { __typename: 'SubAssembly', _id?: any | null, chassisSpecID?: any | null, name: string, reference?: string | null }> | null } | null };

export type GetDataOverviewAssembliesAdvancedFilterQueryVariables = Exact<{
  filter: FilterFindManyAssemblyInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssemblyInput>;
  allPartInstancesActive?: InputMaybe<Scalars['Boolean']['input']>;
  hideAssembliesUsedInRunSheets?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDataOverviewAssembliesAdvancedFilterQuery = { assembliesAdvancedFilter?: { count: number, pageInfo?: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean } | null, items?: Array<GetDataOverviewAssembliesAdvancedFilterItemFragment | null> | null } | null };

export type GetDataOverviewAssembliesAdvancedFilterItemFragment = { __typename: 'BaseAssembly', _id: any, allPartInstanceActive?: boolean | null, chassisSpecName?: string | null, chassisSpecID?: any | null, name: string, reference?: string | null, runSheetName?: string | null, type: EnumAssemblyType, parentID?: any | null };

export type GetChassisBuildSheetsForAssemblyQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisBuildSheetsForAssemblyQuery = { specification?: { _id?: any | null, buildSheetStyleIDs?: Array<any | null> | null, buildSheetStyles: Array<{ _id: any }> } | {} | null };

export type GetChassisSetupSheetsForAssemblyQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSetupSheetsForAssemblyQuery = { assembly?: { _id?: any | null, carSetupID?: any | null } | {} | null };

export type GetAssemblyTemplatesForAssemblyEditPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssemblyTemplatesForAssemblyEditPageQuery = { assemblyTemplates?: { items?: Array<AllAssemblyTemplatesVarsFragment> | null } | null, userEnums?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetAssemblyForEditAssemblyPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetAssemblyForEditAssemblyPageQuery = { assembly?: AssemblyForAssemblyEditPageVars_ChassisAssembly_Fragment | AssemblyForAssemblyEditPageVars_SubAssembly_Fragment | null };

export type GetAssembliesForAssemblyTreeQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  perPage: Scalars['Int']['input'];
}>;


export type GetAssembliesForAssemblyTreeQuery = { assemblies?: { items?: Array<AssemblyForAssemblyEditPageVars_ChassisAssembly_Fragment | AssemblyForAssemblyEditPageVars_SubAssembly_Fragment> | null } | null };

type AssemblyForAssemblyEditPageVars_ChassisAssembly_Fragment = (
  AnyAssemblyForAssemblyEditPageVars_ChassisAssembly_Fragment
  & ChassisAssemblyForAssemblyEditPageVarsFragment
);

type AssemblyForAssemblyEditPageVars_SubAssembly_Fragment = (
  AnyAssemblyForAssemblyEditPageVars_SubAssembly_Fragment
  & SubAssemblyForAssemblyEditPageVarsFragment
);

export type AssemblyForAssemblyEditPageVarsFragment = AssemblyForAssemblyEditPageVars_ChassisAssembly_Fragment | AssemblyForAssemblyEditPageVars_SubAssembly_Fragment;

type AnyAssemblyForAssemblyEditPageVars_BaseAssembly_Fragment = { __typename: 'BaseAssembly', _id: any, assemblyTemplateID?: any | null, chassisSpecID?: any | null, current?: boolean | null, decommissioned?: boolean | null, name: string, reference?: string | null, userEnumAssemblyTypeID?: any | null };

type AnyAssemblyForAssemblyEditPageVars_ChassisAssembly_Fragment = { __typename: 'ChassisAssembly', _id?: any | null, assemblyTemplateID?: any | null, chassisSpecID?: any | null, current?: boolean | null, decommissioned?: boolean | null, name: string, reference?: string | null, userEnumAssemblyTypeID?: any | null };

type AnyAssemblyForAssemblyEditPageVars_SubAssembly_Fragment = { __typename: 'SubAssembly', _id?: any | null, assemblyTemplateID?: any | null, chassisSpecID?: any | null, current?: boolean | null, decommissioned?: boolean | null, name: string, reference?: string | null, userEnumAssemblyTypeID?: any | null };

export type AnyAssemblyForAssemblyEditPageVarsFragment = AnyAssemblyForAssemblyEditPageVars_BaseAssembly_Fragment | AnyAssemblyForAssemblyEditPageVars_ChassisAssembly_Fragment | AnyAssemblyForAssemblyEditPageVars_SubAssembly_Fragment;

export type ChassisAssemblyForAssemblyEditPageVarsFragment = { __typename: 'ChassisAssembly', chassisPartID?: any | null, assemblyTemplateID?: any | null, locationID?: any | null, carSetupID?: any | null, nestedPartInstanceIDs?: Array<any | null> | null, partInstanceIDs?: Array<any | null> | null, subAssemblyIDs?: Array<any | null> | null, tagIDs?: Array<any | null> | null, location?: { _id: any } | null, carSetup?: { runSheetID?: any | null, runSheet?: { _id: any, endTime?: any | null } | null } | null, nestedPartInstances: Array<{ _id: any, partID?: any | null, readingLocation?: EnumReadingLocation | null, specificationID?: any | null, superParentID?: any | null, part?: { _id: any, reference: string, userEnumPartTypeID?: any | null } | null, specification?: { __typename: 'AeroElementSpec', _id?: any | null, name: string } | { __typename: 'AeroPackageSpec', _id?: any | null, name: string } | { __typename: 'AntiRollBarSpec', _id?: any | null, name: string } | { __typename: 'ChassisSpec', _id?: any | null, name: string } | { __typename: 'CustomSpec', _id?: any | null, name: string } | { __typename: 'DamperSpec', _id?: any | null, name: string } | { __typename: 'DifferentialSpec', _id?: any | null, name: string } | { __typename: 'ElasticSpec', _id?: any | null, name: string } | { __typename: 'GearBoxSpec', _id?: any | null, name: string } | { __typename: 'GearSpec', _id?: any | null, name: string } | { __typename: 'KinematicsExternalSpec', _id?: any | null, name: string } | { __typename: 'KinematicsInternalSpec', _id?: any | null, name: string } | null }>, partInstances: Array<{ _id: any, readingLocation?: EnumReadingLocation | null, specificationID?: any | null, superParentID?: any | null, partID?: any | null, specification?: { __typename: 'AeroElementSpec', _id?: any | null, name: string } | { __typename: 'AeroPackageSpec', _id?: any | null, name: string } | { __typename: 'AntiRollBarSpec', _id?: any | null, name: string } | { __typename: 'ChassisSpec', _id?: any | null, name: string } | { __typename: 'CustomSpec', _id?: any | null, name: string } | { __typename: 'DamperSpec', _id?: any | null, name: string } | { __typename: 'DifferentialSpec', _id?: any | null, name: string } | { __typename: 'ElasticSpec', _id?: any | null, name: string } | { __typename: 'GearBoxSpec', _id?: any | null, name: string } | { __typename: 'GearSpec', _id?: any | null, name: string } | { __typename: 'KinematicsExternalSpec', _id?: any | null, name: string } | { __typename: 'KinematicsInternalSpec', _id?: any | null, name: string } | null, part?: { _id: any, reference: string, userEnumPartTypeID?: any | null, specification?: { name: string } | null } | null }>, subAssemblies: Array<{ _id?: any | null, chassisSpecID?: any | null, name: string, reference?: string | null, partInstanceIDs?: Array<any | null> | null, subAssemblyIDs?: Array<any | null> | null }>, tags: Array<{ _id: any }> };

export type GetPartsMileageForAssemblyPageQueryVariables = Exact<{
  partIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  perPage: Scalars['Int']['input'];
}>;


export type GetPartsMileageForAssemblyPageQuery = { parts?: { items?: Array<(
      { _id: any }
      & PartMileageTrackingForAssemblyPageVarsFragment
    )> | null } | null };

export type PartMileageTrackingForAssemblyPageVarsFragment = { tracking?: Array<{ trackingItem?: { criticalCumulativeValue?: number | null, criticalValue?: number | null, cumulativeCalculation?: boolean | null, displayUnit?: EnumDisplayUnit | null, NDecimals?: number | null, operator?: EnumTrackingItemOperator | null, warningCumulativeValue?: number | null, warningValue?: number | null } | null, history: Array<{ cumulativeValue?: number | null, dateResolved?: any | null, value?: number | null, valueString?: string | null }> } | null> | null };

export type SubAssemblyForAssemblyEditPageVarsFragment = { __typename: 'SubAssembly', assemblyTemplateID?: any | null, locationID?: any | null, parentID?: any | null, nestedPartInstanceIDs?: Array<any | null> | null, partInstanceIDs?: Array<any | null> | null, subAssemblyIDs?: Array<any | null> | null, tagIDs?: Array<any | null> | null, location?: { _id: any } | null, carSetup?: { runSheetID?: any | null, runSheet?: { _id: any, endTime?: any | null } | null } | null, nestedPartInstances: Array<{ _id: any, readingLocation?: EnumReadingLocation | null, specificationID?: any | null, superParentID?: any | null, partID?: any | null, specification?: { __typename: 'AeroElementSpec', _id?: any | null, name: string } | { __typename: 'AeroPackageSpec', _id?: any | null, name: string } | { __typename: 'AntiRollBarSpec', _id?: any | null, name: string } | { __typename: 'ChassisSpec', _id?: any | null, name: string } | { __typename: 'CustomSpec', _id?: any | null, name: string } | { __typename: 'DamperSpec', _id?: any | null, name: string } | { __typename: 'DifferentialSpec', _id?: any | null, name: string } | { __typename: 'ElasticSpec', _id?: any | null, name: string } | { __typename: 'GearBoxSpec', _id?: any | null, name: string } | { __typename: 'GearSpec', _id?: any | null, name: string } | { __typename: 'KinematicsExternalSpec', _id?: any | null, name: string } | { __typename: 'KinematicsInternalSpec', _id?: any | null, name: string } | null, part?: { _id: any, reference: string, userEnumPartTypeID?: any | null, specification?: { name: string } | null } | null }>, partInstances: Array<{ _id: any, readingLocation?: EnumReadingLocation | null, superParentID?: any | null, partID?: any | null, specificationID?: any | null, part?: { _id: any, reference: string, userEnumPartTypeID?: any | null, specification?: { name: string } | null } | null, specification?: { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | null }>, subAssemblies: Array<{ _id?: any | null, chassisSpecID?: any | null, name: string, reference?: string | null, partInstanceIDs?: Array<any | null> | null, subAssemblyIDs?: Array<any | null> | null }>, tags: Array<{ _id: any }> };

export type GetAvailablePartsForAssemblyForIssuePageQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPartInput>;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPartInput>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  userEnumPartStatusActive?: InputMaybe<Scalars['Boolean']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  partType?: InputMaybe<Scalars['MongoID']['input']>;
  partReference?: InputMaybe<Scalars['String']['input']>;
  hideDummyParts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAvailablePartsForAssemblyForIssuePageQuery = { partsAdvancedFilter?: { count: number, pageInfo?: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean } | null, items?: Array<PartForAvailablePartsForAssemblyEditPageVarsFragment | null> | null } | null };

export type GetAvailablePartsForAssemblyForAssemblyEditPageQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPartInput>;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPartInput>;
  chassisSpecID: Scalars['MongoID']['input'];
  partActive?: InputMaybe<Scalars['Boolean']['input']>;
  userEnumPartStatusID?: InputMaybe<Scalars['MongoID']['input']>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetAvailablePartsForAssemblyForAssemblyEditPageQuery = { partsForChassisSpec?: { count: number, pageInfo?: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean } | null, items?: Array<PartForAvailablePartsForAssemblyEditPageVarsFragment | null> | null } | null };

export type PartForAvailablePartsForAssemblyEditPageVarsFragment = { _id: any, partNumber?: string | null, readingLocationOverride?: Array<EnumPartReadingLocationOverride | null> | null, reference: string, rootAssemblyIDs?: Array<any | null> | null, rootSpecificationID?: any | null, specificationID?: any | null, specification?: { antiRollBarDisplayLocation?: EnumAntiRollBarDisplayLocation | null, readingsAllowable?: Array<EnumSpecificationReadingsAllowable | null> | null, readingsRequired?: EnumSpecificationReadingsRequired | null, specificationGroupID?: any | null } | null, partStatus?: { userEnumPartStatusID?: any | null, userEnumPartStatusName?: string | null } | null, userEnumPartType?: { name: string } | null };

export type GetUserEnumsForEditAssemblyPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserEnumsForEditAssemblyPageQuery = { assemblyTypeEnums?: { items?: Array<{ _id?: any | null, name: string, type: EnumUserEnumAssemblyTypeType } | {}> | null } | null };

export type GetRunSheetIdForAssemblyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCarSetupInput>;
}>;


export type GetRunSheetIdForAssemblyQuery = { carSetupsMany: Array<{ runSheet?: { _id: any, sessionID?: any | null } | null }> };

export type ForwardAddPartInstanceMutationVariables = Exact<{
  partID: Scalars['MongoID']['input'];
  sessionID: Scalars['MongoID']['input'];
  readingLocation?: InputMaybe<EnumReadingLocation>;
  chassisAssemblyID: Scalars['MongoID']['input'];
}>;


export type ForwardAddPartInstanceMutation = { forwardAddPartInstance?: { createdPartInstanceIDs?: Array<any | null> | null } | null };

export type GetParentReferenceForAssemblyEditPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetParentReferenceForAssemblyEditPageQuery = { assembly?: { reference?: string | null } | { reference?: string | null } | null };

export type GetAvailableSsoProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableSsoProvidersQuery = { ssoProviders: Array<{ name: string }> };

export type GetAllSessionsForCalendarViewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSessionsForCalendarViewQuery = { sessions?: { items?: Array<SessionVarsForCalendarViewFragment> | null } | null };

export type SessionVarsForCalendarViewFragment = { shortName?: string | null, tSessionEnd?: any | null, tSessionStart?: any | null, event?: { name: string } | null };

export type GetSeasonForContextMenuQueryVariables = Exact<{
  seasonID: Scalars['MongoID']['input'];
}>;


export type GetSeasonForContextMenuQuery = { season?: { _id: any, contestants: Array<SeasonContestantForContextMenuVarsFragment>, events: Array<{ _id: any, name: string, tEventStart?: any | null, tEventEnd?: any | null }> } | null };

export type GetEventForContextMenuQueryVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
}>;


export type GetEventForContextMenuQuery = { event?: { _id: any, name: string, sessionIDs?: Array<any | null> | null, contestants?: Array<EventContestantForContextMenuVarsFragment | null> | null, sessions: Array<{ _id: any, name: string, shortName?: string | null, sessionType?: EnumSessionType | null, tSessionStart?: any | null, tSessionEnd?: any | null }> } | null };

export type GetContestantListForContextMenuQueryVariables = Exact<{
  contestantIDs: Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>;
  perPage: Scalars['Int']['input'];
}>;


export type GetContestantListForContextMenuQuery = { contestants?: { items?: Array<{ _id: any, class?: string | null, hidden?: boolean | null, startNumber: string, teamID?: any | null }> | null } | null };

export type SeasonContestantForContextMenuVarsFragment = { _id: any, chassisNumber?: string | null, class?: string | null, driverIDs?: Array<any | null> | null, hidden?: boolean | null, startNumber: string, teamID?: any | null, drivers: Array<{ _id: any, acronym?: string | null }> };

export type EventContestantForContextMenuVarsFragment = { _id: any, class?: string | null, driverIDs?: Array<any | null> | null };

export type GetUserEnumSimulationDriveFileTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserEnumSimulationDriveFileTypeQuery = { userEnums?: { items?: Array<{ _id?: any | null, name: string, type: EnumUserEnumSimulationDriveFileTypeType } | {}> | null } | null };

export type GetCustomControlFieldsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCustomControlFieldsQuery = { person?: { localConnections?: Array<AllLocalConnectionVarsFragment | null> | null } | null, allDriveFiles?: { items?: Array<{ _id: any, name?: string | null, status?: EnumSimulationDriveFileStatus | null, userEnumTypeID?: any | null, version?: string | null, event?: { _id: any, name: string, tEventStart?: any | null, season?: { _id: any, name: string } | null } | null, userEnumType?: { name: string } | {} | null }> | null } | null };

export type GetSimulationModelsForCarSetupQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSimulationModelsForCarSetupQuery = { carSetup?: { runSheetID?: any | null, chassisSpec?: { _id?: any | null, canopyVersion?: string | null, customSimulationModels?: Array<CustomSimulationModelVarsFragment | null> | null } | null } | null };

export type CustomSimulationModelVarsFragment = { data?: any | null, dataMapping?: EnumSpecificationCustomSimulationModelsDataMapping | null, endPoint?: string | null, name: string, serverPort?: number | null, version?: string | null };

export type SetupTimingServiceStatusMutationVariables = Exact<{ [key: string]: never; }>;


export type SetupTimingServiceStatusMutation = { applyMigration?: { success: boolean } | null };

export type ResetTimingServiceStatusMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetTimingServiceStatusMutation = { updateMigrations?: { success: boolean } | null };

export type GetBopForBoostTableQueryVariables = Exact<{
  sessionIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetBopForBoostTableQuery = { sessions?: { items?: Array<{ _id: any, name: string, shortName?: string | null, tSessionStart?: any | null, bop?: { _id: any, name?: string | null, sessionID: any, session?: { _id: any, name: string, shortName?: string | null } | null, carBop?: Array<{ highlightColour?: string | null, make?: string | null, modelYear?: string | null, carSpec?: string | null, homologation?: string | null, pEngineBoost?: any | null, _id?: any | null } | null> | null, sessionBop?: { EStintEnergyMax?: number | null, EStintEnergyRefillRateMax?: number | null, fuelType?: string | null, mRefuelRateMax?: number | null, pAmbientSessionOfficial?: number | null, VRefuelRateMax?: number | null, xStintlengthMax?: number | null, _id?: any | null } | null } | null }> | null } | null };

export type GetBopForTrackerTableQueryVariables = Exact<{
  sessionIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetBopForTrackerTableQuery = { sessions?: { items?: Array<{ _id: any, name: string, shortName?: string | null, tSessionStart?: any | null, bop?: { _id: any, name?: string | null, sessionID: any, session?: { _id: any, name: string, shortName?: string | null } | null, carBop?: Array<{ highlightColour?: string | null, aCamberFmax?: number | null, aCamberFmin?: number | null, aCamberRmax?: number | null, aCamberRmin?: number | null, aRakeMax?: number | null, aRakeMin?: number | null, aWingRmax?: number | null, aWingRmin?: number | null, zWingMin?: number | null, carSpec?: string | null, homologation?: string | null, hRideFmin?: number | null, hRideRmin?: number | null, make?: string | null, mCarBallastMin?: number | null, mCarWeightEmptyMin?: number | null, mCarWeightTotalMin?: number | null, mFuelMassCapacityMax?: number | null, modelYear?: string | null, mRefuelMassMax?: number | null, nEngineMax?: number | null, pEngineBoost?: any | null, PEngineMax?: number | null, rLambdaMin?: number | null, vCarMax?: number | null, VFuelVolumeCapacityMax?: number | null, vPowerCurveBelowRefVelocity?: number | null, rPowerCurveReference?: number | null, rPowerGainAboveRefVelocity?: number | null, vPowerGainReference?: number | null, VRefuelVolumeMax?: number | null, xAirRestrictorMax?: number | null, xFuelRestrictorMax?: number | null, xRefuelRestrictorMax?: number | null, EStintMax?: number | null, _id?: any | null } | null> | null, sessionBop?: { EStintEnergyMax?: number | null, EStintEnergyRefillRateMax?: number | null, fuelType?: string | null, mRefuelRateMax?: number | null, pAmbientSessionOfficial?: number | null, tyreModel?: string | null, VRefuelRateMax?: number | null, xStintlengthMax?: number | null, _id?: any | null } | null } | null }> | null } | null };

export type ApplyPackageItemsForCopyConfirmMutationVariables = Exact<{
  packageItems?: InputMaybe<Array<InputMaybe<UpdateByIdPackageItemsInput>> | InputMaybe<UpdateByIdPackageItemsInput>>;
  carSetupIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type ApplyPackageItemsForCopyConfirmMutation = { applyPackageItems?: { success?: boolean | null } | null };

export type GetSimulationDriveFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSimulationDriveFilesQuery = { simulationDriveFiles?: { items?: Array<{ _id: any, name?: string | null, status?: EnumSimulationDriveFileStatus | null, event?: { name: string, _id: any } | null }> | null } | null };

export type RemoveSimulationDriveFileByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveSimulationDriveFileByIdMutation = { removeSimulationDriveFile?: { error?: { message?: string | null } | { message?: string | null } | { message?: string | null } | null, record?: { _id: any } | null } | null };

export type GetSimResultsForSimChannelSearchModalQueryVariables = Exact<{
  simType?: InputMaybe<EnumSimResultSimType>;
}>;


export type GetSimResultsForSimChannelSearchModalQuery = { simResults?: { items?: Array<SimResultForSimChannelSearchModalVarsFragment> | null } | null };

export type SimResultForSimChannelSearchModalVarsFragment = { _id: any, updatedAt?: any | null, data?: Array<{ channelName?: string | null } | null> | null };

export type GetLapTypeFilterNamesQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetLapTypeFilterNamesQuery = { runSheetStyle?: { lapFlags?: { ATTACK?: string | null, COOL?: string | null, FCY?: string | null, IN?: string | null, OUT?: string | null, OUTIN?: string | null, PITLANE?: string | null, PREP?: string | null, PUSH?: string | null, QUALI?: string | null, SAFETYCAR?: string | null, SHAKEDOWN?: string | null, SLOW?: string | null, TARGET?: string | null, TOGRID?: string | null, TOPADDOCK?: string | null, TOPITS?: string | null, UNFINISHED?: string | null } | null } | null };

export type GetMileageSummaryDataQueryVariables = Exact<{
  runSheetIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetMileageSummaryDataQuery = { runSheets?: { items?: Array<MileageSummaryRunSheetVarsFragment> | null } | null };

export type MileageSummaryRunSheetVarsFragment = { _id: any, fastestLap?: number | null, lapCount: number, mileage?: number | null, NRun?: number | null, contestant?: { _id: any, startNumber: string, drivers: Array<{ _id: any }> } | null, driver?: { _id: any, name: string } | null, session?: { _id: any, name: string, shortName?: string | null } | null };

export type GetRunSheetsAndSessionInfoForSessionTimelineQueryVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  sessionID: Scalars['MongoID']['input'];
}>;


export type GetRunSheetsAndSessionInfoForSessionTimelineQuery = { runSheets?: { items?: Array<{ NRun?: number | null, lapCount: number, startTime?: any | null, endTime?: any | null, runDescription?: string | null }> | null } | null, session?: { name: string, tSessionStart?: any | null, tSessionEnd?: any | null, event?: { track?: { timeZone?: string | null } | null } | null } | null, runPlans?: { items?: Array<{ runs: Array<{ NRun: number, lapSequence?: Array<{ NLap: number } | null> | null } | null> }> | null } | null };

export type GetAllCalculationsForTreeViewQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCalculationInput>;
}>;


export type GetAllCalculationsForTreeViewQuery = { calculations?: { items?: Array<{ _id: any, isActive: boolean, name?: string | null, parameter: string }> | null } | null };

export type GetCarDataServiceConfigsForSetupOverviewTableConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCarDataServiceConfigsForSetupOverviewTableConfigQuery = { carDataServiceConfigs?: { items?: Array<{ active: boolean, Kpi?: { KpiParameters?: Array<string | null> | null } | null }> | null } | null };

export type GetSimResultsForSimManagerListQueryVariables = Exact<{
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetSimResultsForSimManagerListQuery = { simResults?: { items?: Array<(
      { _id: any }
      & SimResultVarsForSimManagerListFragment
    )> | null } | null };

export type GetRunSheetInfoForSimManagerByIdQueryVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
}>;


export type GetRunSheetInfoForSimManagerByIdQuery = { runSheet?: { _id: any, NRun?: number | null, NRunTiming?: number | null, contestant?: { startNumber: string } | null, session?: { name: string, event?: { name: string, season?: { name: string, raceSeries?: { name: string } | null } | null } | null } | null } | null };

export type GetAllSimResultsPerPageQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllSimResultsPerPageQuery = { simResults?: { count?: number | null, items?: Array<(
      { _id: any }
      & SimResultVarsFragment
    )> | null } | null };

export type RemoveSimResultMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveSimResultMutation = { removeSimResult?: { recordId?: any | null } | null };

export type RemoveManySimResultsByIdMutationVariables = Exact<{
  arr?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type RemoveManySimResultsByIdMutation = { removeManySimResults?: { numAffected?: number | null } | null };

export type SimResultVarsForSimManagerListFragment = { carSetupID?: any | null, trackLayoutID?: any | null, specificationID?: any | null, runSheetID?: any | null, source?: string | null, simulationService?: EnumSimModelType | null, version?: string | null, sourceReferenceID?: string | null, simType?: EnumSimResultSimType | null, TAmbient?: number | null, pAmbient?: number | null, rHumidity?: number | null, carSetupModifiedAt?: any | null, refValues?: any | null, defaultChannelTime?: Array<number | null> | null, requesterID?: any | null, status?: EnumSimResultStatus | null, statusMessage?: string | null, _id: any, updatedAt?: any | null, createdAt?: any | null, isCarSetupChanged?: boolean | null, carSetup?: { _id: any, title: string } | null, trackLayout?: (
    { _id: any }
    & TrackLayoutVarsFragment
  ) | null, requester?: { _id: any, name: string, username: string } | null };

export type GetContestantColorsForColorSettingsQueryVariables = Exact<{
  contestantIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GetContestantColorsForColorSettingsQuery = { contestants?: { items?: Array<{ _id: any, color?: string | null, startNumber: string }> | null } | null };

export type GetEventContestantsForDashboardQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEventContestantsForDashboardQuery = { event?: { contestants?: Array<{ _id: any } | null> | null, season?: { contestants: Array<{ chassisIDs?: Array<any | null> | null, chassisNumber?: string | null, class?: string | null, color?: string | null, eligibleForPoints?: boolean | null, startNumber: string, _id: any, chassis: Array<{ reference?: string | null, type?: string | null }>, drivers: Array<{ acronym?: string | null, name: string }>, team?: { name: string, shortName?: string | null, color?: string | null, raceSeriesID?: any | null, tagIDs?: Array<any | null> | null, _id: any } | null }> } | null } | null };

export type GetSetupIdForRunSheetQueryVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
}>;


export type GetSetupIdForRunSheetQuery = { runSheet?: { setupID?: any | null } | null };

export type SplitRunSheetMutationVariables = Exact<{
  runSheetId: Scalars['MongoID']['input'];
}>;


export type SplitRunSheetMutation = { splitRunSheet?: { _id: any } | null };

export type InsertRunMutationVariables = Exact<{
  insertAfterRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  insertBeforeRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  sourceSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  sourceRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type InsertRunMutation = { insertRun?: { success?: boolean | null, message?: string | null, newRunSheetID?: any | null } | null };

export type GetEventInfoForRunInsertModalQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEventInfoForRunInsertModalQuery = { event?: { _id: any, name: string, sessionIDs?: Array<any | null> | null, trackLayoutIDs?: Array<any | null> | null, sessions: Array<{ _id: any, name: string, shortName?: string | null, tSessionStart?: any | null, tSessionEnd?: any | null }>, season?: { _id: any, contestantIDs?: Array<any | null> | null, name: string, contestants: Array<{ _id: any, startNumber: string }>, raceSeries?: { _id: any, name: string } | null } | null } | null };

export type InsertRunIntoSessionMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  sessionID: Scalars['MongoID']['input'];
  sourceRunSheetID: Scalars['MongoID']['input'];
}>;


export type InsertRunIntoSessionMutation = { insertRunIntoSession?: { success?: boolean | null, message?: string | null, newRunSheetID?: any | null } | null };

export type RequiredClientVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type RequiredClientVersionQuery = { requiredClientVersion: `${number}.${number}.${number}` };

export type GetSessionsInDateTimeRangeForTimingServiceStatusQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetSessionsInDateTimeRangeForTimingServiceStatusQuery = { sessions?: { items?: Array<{ _id: any, name: string, tSessionStart?: any | null }> | null } | null };

export type GetRunSheetAndSetupIDsBySessionsIDsQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  contestantIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetAndSetupIDsBySessionsIDsQuery = { runSheets?: { items?: Array<RunSheetForAddButtonVarsFragment> | null } | null };

export type GetDataForAddRunButtonQueryVariables = Exact<{
  personID: Scalars['MongoID']['input'];
}>;


export type GetDataForAddRunButtonQuery = { person?: { behaviour?: { carryOverJobList?: boolean | null } | null } | null };

export type GetPreviousSessionForSessionQueryVariables = Exact<{
  sessionID: Scalars['MongoID']['input'];
}>;


export type GetPreviousSessionForSessionQuery = { session?: { prevSessionID?: any | null } | null };

export type RunSheetForAddButtonVarsFragment = { _id: any, NRun?: number | null, NRunTiming?: number | null, sessionID?: any | null, selectedJobListTemplateID?: any | null };

export type GetChassisMeasurementUnitsForDisplayChangesQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisMeasurementUnitsForDisplayChangesQuery = { specification?: ChassisSpecVarsForDisplayChangesFragment | {} | null };

export type ChassisSpecVarsForDisplayChangesFragment = { __typename: 'ChassisSpec', _id?: any | null, measurements?: ChassisMeasurementVarsFragment | null };

export type GetCarSetupSearchByEventQueryVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
}>;


export type GetCarSetupSearchByEventQuery = { carSetupsMany: Array<{ _id: any, title: string, contestantID?: any | null }> };

export type GetUserSetupsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetUserSetupsQuery = { person?: { userSetups: Array<{ _id: any, title: string }> } | null };

export type GetShowMyJobsDefaultValueQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetShowMyJobsDefaultValueQuery = { person?: { behaviour?: { showMyJobsOnRunSheetDefault?: boolean | null } | null } | null };

export type GetJobForJobEditModalQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetJobForJobEditModalQuery = { job?: { assigneeIDs?: Array<any | null> | null, description: string, index?: number | null, number?: string | null, priority?: EnumJobPriority | null } | null };

export type RemoveJobCommentMutationVariables = Exact<{
  commentId: Scalars['MongoID']['input'];
  subjectId: Scalars['MongoID']['input'];
  target: EnumJobTarget;
}>;


export type RemoveJobCommentMutation = { removeComment?: { comment?: { _id?: any | null } | null } | null };

export type AddJobListToRunsheetFromTemplateMutationVariables = Exact<{
  records: Array<CreateManyJobInput> | CreateManyJobInput;
}>;


export type AddJobListToRunsheetFromTemplateMutation = { addJobsMany?: { recordIds: Array<any> } | null };

export type GetRaceSeriesLapTypeConfigQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRaceSeriesLapTypeConfigQuery = { raceSeries?: { lapTypeConfig?: LapTypeConfigVarsFragment | null } | null };

export type FlexCarSetupInfoFieldUpdatedSubscriptionVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type FlexCarSetupInfoFieldUpdatedSubscription = { carSetupUpdated?: { _id: any, setupInfo?: string | null } | null };

export type GetFlexCarSetupInfoFieldQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetFlexCarSetupInfoFieldQuery = { carSetup?: { _id: any, setupInfo?: string | null } | null };

export type GetSpecInfoForCustomSpecFieldQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSpecInfoForCustomSpecFieldQuery = { specification?: SpecInfoForMeasurementFieldVarsFragment | {} | null };

export type GetSpecDetailsForPartSelectFieldQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSpecDetailsForPartSelectFieldQuery = { specification?: { _id?: any | null, hasToBeInSubAssembly?: boolean | null } | { _id?: any | null, hasToBeInSubAssembly?: boolean | null } | { _id?: any | null, hasToBeInSubAssembly?: boolean | null } | { _id?: any | null, hasToBeInSubAssembly?: boolean | null } | { _id?: any | null, hasToBeInSubAssembly?: boolean | null } | {} | null };

export type UpdatePartInstancesFromCustomSpecFieldMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdAssemblyInput;
}>;


export type UpdatePartInstancesFromCustomSpecFieldMutation = { updateAssembly?: { record?: { partInstances: Array<{ _id: any, specificationID?: any | null, specificationGroupID?: any | null }> } | {} | null } | null };

export type PartInstanceForMeasurementFieldVarsFragment = { _id: any, specificationID?: any | null, specificationGroupID?: any | null, readingLocation?: EnumReadingLocation | null, measurements?: Array<{ idx?: number | null, value?: number | null, floatValue?: number | null, stringValue?: string | null, booleanValue?: boolean | null, coordinates?: { x?: number | null, y?: number | null, z?: number | null } | null, rotation?: { I?: number | null, J?: number | null, K?: number | null } | null } | null> | null };

export type SpecInfoForMeasurementFieldVarsFragment = { _id?: any | null, name: string, specificationGroupID?: any | null, readingsRequired?: EnumCustomSpecReadingsRequired | null, adjustableProperties?: Array<AdjustableAccelerationPropertyVarsFragment | AdjustableAnglePropertyVarsFragment | AdjustableAngularCompliancePropertyVarsFragment | AdjustableAngularTorqueCompliancePropertyVarsFragment | AdjustableBooleanPropertyVarsFragment | AdjustableCompliancePropertyVarsFragment | AdjustableForcePropertyVarsFragment | AdjustableInertiaPropertyVarsFragment | AdjustableLengthPropertyVarsFragment | AdjustableLocationPropertyVarsFragment | AdjustableMassPropertyVarsFragment | AdjustableNumberPropertyVarsFragment | AdjustableOrientationPropertyVarsFragment | AdjustablePowerPropertyVarsFragment | AdjustablePressurePropertyVarsFragment | AdjustableRatioPropertyVarsFragment | AdjustableSpringRatePropertyVarsFragment | AdjustableSteeringRackRatioPropertyVarsFragment | AdjustableStringPropertyVarsFragment | AdjustableTemperaturePropertyVarsFragment | AdjustableTorquePropertyVarsFragment | AdjustableTorsionRatePropertyVarsFragment | AdjustableVolumePropertyVarsFragment | null> | null };

export type ChassisSpecVarsForSetupSheetFlexFragment = { aeroPackageSpecIDs?: Array<any | null> | null, antiRollBarSpecIDs?: Array<any | null> | null, bumpRubberSpecIDs?: Array<any | null> | null, canopyVersion?: string | null, customSpecIDs?: Array<any | null> | null, damperSpecIDs?: Array<any | null> | null, helperSpringSpecIDs?: Array<any | null> | null, name: string, reboundSpringSpecIDs?: Array<any | null> | null, released?: boolean | null, releaseDate?: any | null, setupSheetStyleIDs?: Array<any | null> | null, simulationModels?: any | null, specificationGroupIDs?: Array<any | null> | null, springSpecIDs?: Array<any | null> | null, torsionBarSpecIDs?: Array<any | null> | null, trackingSourceIDs?: Array<any | null> | null, version?: string | null, aeroPackageSpecs: Array<{ __typename: 'AeroPackageSpec', _id?: any | null, aeroElementSpecIDs?: Array<any | null> | null, hasToBeInSubAssembly?: boolean | null, name: string, rootSpecificationID: any, aeroElementSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, hasToBeInSubAssembly?: boolean | null, name: string, rootSpecificationID: any }> }>, antiRollBarSpecs: Array<{ __typename: 'AntiRollBarSpec', _id?: any | null, antiRollBarDisplayLocation?: EnumAntiRollBarDisplayLocation | null, hasToBeInSubAssembly?: boolean | null, name: string, rootSpecificationID: any }>, buildSheetStyles: Array<{ _id: any }>, bumpRubberSpecs: Array<{ __typename: 'ElasticSpec', _id?: any | null, allowableSockets?: Array<string | null> | null, elasticType?: EnumElasticType | null, hasToBeInSubAssembly?: boolean | null, name: string, readingsAllowable?: Array<EnumReadingLocation> | null, rootSpecificationID: any }>, calculations: Array<CalculationVarsFragment>, customSimulationModels?: Array<{ name: string, version?: string | null } | null> | null, customSpecs: Array<{ __typename: 'CustomSpec', _id?: any | null, rootSpecificationID: any, specificationGroupID?: any | null, readingsRequired?: EnumCustomSpecReadingsRequired | null, hasToBeInSubAssembly?: boolean | null, name: string, adjustableProperties?: Array<(
      { __typename: 'AdjustableAccelerationProperty' }
      & AdjustableAccelerationPropertyVarsFragment
    ) | (
      { __typename: 'AdjustableAngleProperty' }
      & AdjustableAnglePropertyVarsFragment
    ) | (
      { __typename: 'AdjustableAngularComplianceProperty' }
      & AdjustableAngularCompliancePropertyVarsFragment
    ) | (
      { __typename: 'AdjustableAngularTorqueComplianceProperty' }
      & AdjustableAngularTorqueCompliancePropertyVarsFragment
    ) | (
      { __typename: 'AdjustableBooleanProperty' }
      & AdjustableBooleanPropertyVarsFragment
    ) | (
      { __typename: 'AdjustableComplianceProperty' }
      & AdjustableCompliancePropertyVarsFragment
    ) | (
      { __typename: 'AdjustableForceProperty' }
      & AdjustableForcePropertyVarsFragment
    ) | (
      { __typename: 'AdjustableInertiaProperty' }
      & AdjustableInertiaPropertyVarsFragment
    ) | (
      { __typename: 'AdjustableLengthProperty' }
      & AdjustableLengthPropertyVarsFragment
    ) | (
      { __typename: 'AdjustableLocationProperty' }
      & AdjustableLocationPropertyVarsFragment
    ) | (
      { __typename: 'AdjustableMassProperty' }
      & AdjustableMassPropertyVarsFragment
    ) | (
      { __typename: 'AdjustableNumberProperty' }
      & AdjustableNumberPropertyVarsFragment
    ) | (
      { __typename: 'AdjustableOrientationProperty' }
      & AdjustableOrientationPropertyVarsFragment
    ) | (
      { __typename: 'AdjustablePowerProperty' }
      & AdjustablePowerPropertyVarsFragment
    ) | (
      { __typename: 'AdjustablePressureProperty' }
      & AdjustablePressurePropertyVarsFragment
    ) | (
      { __typename: 'AdjustableRatioProperty' }
      & AdjustableRatioPropertyVarsFragment
    ) | (
      { __typename: 'AdjustableSpringRateProperty' }
      & AdjustableSpringRatePropertyVarsFragment
    ) | (
      { __typename: 'AdjustableSteeringRackRatioProperty' }
      & AdjustableSteeringRackRatioPropertyVarsFragment
    ) | (
      { __typename: 'AdjustableStringProperty' }
      & AdjustableStringPropertyVarsFragment
    ) | (
      { __typename: 'AdjustableTemperatureProperty' }
      & AdjustableTemperaturePropertyVarsFragment
    ) | (
      { __typename: 'AdjustableTorqueProperty' }
      & AdjustableTorquePropertyVarsFragment
    ) | (
      { __typename: 'AdjustableTorsionRateProperty' }
      & AdjustableTorsionRatePropertyVarsFragment
    ) | (
      { __typename: 'AdjustableVolumeProperty' }
      & AdjustableVolumePropertyVarsFragment
    ) | null> | null }>, damperSpecs: Array<{ __typename: 'DamperSpec', _id?: any | null, allowableSockets?: Array<string | null> | null, hasToBeInSubAssembly?: boolean | null, readingsAllowable?: Array<EnumReadingLocation> | null, rootSpecificationID: any }>, helperSpringSpecs: Array<{ __typename: 'ElasticSpec', _id?: any | null, allowableSockets?: Array<string | null> | null, elasticType?: EnumElasticType | null, hasToBeInSubAssembly?: boolean | null, name: string, readingsAllowable?: Array<EnumReadingLocation> | null, rootSpecificationID: any }>, measurements?: ChassisMeasurementVarsFragment | null, reboundSpringSpecs: Array<{ __typename: 'ElasticSpec', _id?: any | null, allowableSockets?: Array<string | null> | null, elasticType?: EnumElasticType | null, hasToBeInSubAssembly?: boolean | null, name: string, readingsAllowable?: Array<EnumReadingLocation> | null, rootSpecificationID: any }>, setupChangesFilter?: { blackListFilter?: Array<string | null> | null, whiteListFilter?: Array<string | null> | null } | null, setupSheetStyles: Array<SetupSheetStyleForFlexSetupFragment>, specificationGroups: Array<SpecificationGroupVariablesFragment>, springSpecs: Array<{ __typename: 'ElasticSpec', _id?: any | null, allowableSockets?: Array<string | null> | null, elasticType?: EnumElasticType | null, hasToBeInSubAssembly?: boolean | null, name: string, readingsAllowable?: Array<EnumReadingLocation> | null, rootSpecificationID: any }>, torsionBarSpecs: Array<{ __typename: 'ElasticSpec', _id?: any | null, allowableSockets?: Array<string | null> | null, elasticType?: EnumElasticType | null, hasToBeInSubAssembly?: boolean | null, name: string, readingsAllowable?: Array<EnumReadingLocation> | null, rootSpecificationID: any }>, trackingSources: Array<{ _id: any, name: string, sourceIDs?: Array<any | null> | null, displayUnit?: EnumDisplayUnit | null, NDecimals?: number | null, sources: Array<{ _id: any, aliasString?: string | null, aliasType?: EnumTrackingSourceAliasAliasType | null, priority?: number | null }> }> };

type PartInstanceSpecificationForSetupSheetFlexVars_AeroElementSpec_Fragment = { __typename: 'AeroElementSpec', _id?: any | null, rootSpecificationID: any };

type PartInstanceSpecificationForSetupSheetFlexVars_AeroPackageSpec_Fragment = { __typename: 'AeroPackageSpec', _id?: any | null, rootSpecificationID: any };

type PartInstanceSpecificationForSetupSheetFlexVars_AntiRollBarSpec_Fragment = { __typename: 'AntiRollBarSpec', _id?: any | null, rootSpecificationID: any };

type PartInstanceSpecificationForSetupSheetFlexVars_ChassisSpec_Fragment = { __typename: 'ChassisSpec', _id?: any | null, rootSpecificationID: any };

type PartInstanceSpecificationForSetupSheetFlexVars_CustomSpec_Fragment = { __typename: 'CustomSpec', _id?: any | null, rootSpecificationID: any, hasToBeInSubAssembly?: boolean | null, name: string, adjustableProperties?: Array<(
    { __typename: 'AdjustableAccelerationProperty' }
    & AdjustableAccelerationPropertyVarsFragment
  ) | (
    { __typename: 'AdjustableAngleProperty' }
    & AdjustableAnglePropertyVarsFragment
  ) | (
    { __typename: 'AdjustableAngularComplianceProperty' }
    & AdjustableAngularCompliancePropertyVarsFragment
  ) | (
    { __typename: 'AdjustableAngularTorqueComplianceProperty' }
    & AdjustableAngularTorqueCompliancePropertyVarsFragment
  ) | (
    { __typename: 'AdjustableBooleanProperty' }
    & AdjustableBooleanPropertyVarsFragment
  ) | (
    { __typename: 'AdjustableComplianceProperty' }
    & AdjustableCompliancePropertyVarsFragment
  ) | (
    { __typename: 'AdjustableForceProperty' }
    & AdjustableForcePropertyVarsFragment
  ) | (
    { __typename: 'AdjustableInertiaProperty' }
    & AdjustableInertiaPropertyVarsFragment
  ) | (
    { __typename: 'AdjustableLengthProperty' }
    & AdjustableLengthPropertyVarsFragment
  ) | (
    { __typename: 'AdjustableLocationProperty' }
    & AdjustableLocationPropertyVarsFragment
  ) | (
    { __typename: 'AdjustableMassProperty' }
    & AdjustableMassPropertyVarsFragment
  ) | (
    { __typename: 'AdjustableNumberProperty' }
    & AdjustableNumberPropertyVarsFragment
  ) | (
    { __typename: 'AdjustableOrientationProperty' }
    & AdjustableOrientationPropertyVarsFragment
  ) | (
    { __typename: 'AdjustablePowerProperty' }
    & AdjustablePowerPropertyVarsFragment
  ) | (
    { __typename: 'AdjustablePressureProperty' }
    & AdjustablePressurePropertyVarsFragment
  ) | (
    { __typename: 'AdjustableRatioProperty' }
    & AdjustableRatioPropertyVarsFragment
  ) | (
    { __typename: 'AdjustableSpringRateProperty' }
    & AdjustableSpringRatePropertyVarsFragment
  ) | (
    { __typename: 'AdjustableSteeringRackRatioProperty' }
    & AdjustableSteeringRackRatioPropertyVarsFragment
  ) | (
    { __typename: 'AdjustableStringProperty' }
    & AdjustableStringPropertyVarsFragment
  ) | (
    { __typename: 'AdjustableTemperatureProperty' }
    & AdjustableTemperaturePropertyVarsFragment
  ) | (
    { __typename: 'AdjustableTorqueProperty' }
    & AdjustableTorquePropertyVarsFragment
  ) | (
    { __typename: 'AdjustableTorsionRateProperty' }
    & AdjustableTorsionRatePropertyVarsFragment
  ) | (
    { __typename: 'AdjustableVolumeProperty' }
    & AdjustableVolumePropertyVarsFragment
  ) | null> | null };

type PartInstanceSpecificationForSetupSheetFlexVars_DamperSpec_Fragment = { __typename: 'DamperSpec', _id?: any | null, rootSpecificationID: any };

type PartInstanceSpecificationForSetupSheetFlexVars_DifferentialSpec_Fragment = { __typename: 'DifferentialSpec', _id?: any | null, rootSpecificationID: any };

type PartInstanceSpecificationForSetupSheetFlexVars_ElasticSpec_Fragment = { __typename: 'ElasticSpec', _id?: any | null, rootSpecificationID: any, elasticType?: EnumElasticType | null, hasToBeInSubAssembly?: boolean | null, name: string };

type PartInstanceSpecificationForSetupSheetFlexVars_GearBoxSpec_Fragment = { __typename: 'GearBoxSpec', _id?: any | null, rootSpecificationID: any };

type PartInstanceSpecificationForSetupSheetFlexVars_GearSpec_Fragment = { __typename: 'GearSpec', _id?: any | null, rootSpecificationID: any };

type PartInstanceSpecificationForSetupSheetFlexVars_KinematicsExternalSpec_Fragment = { __typename: 'KinematicsExternalSpec', _id?: any | null, rootSpecificationID: any };

type PartInstanceSpecificationForSetupSheetFlexVars_KinematicsInternalSpec_Fragment = { __typename: 'KinematicsInternalSpec', _id?: any | null, rootSpecificationID: any };

export type PartInstanceSpecificationForSetupSheetFlexVarsFragment = PartInstanceSpecificationForSetupSheetFlexVars_AeroElementSpec_Fragment | PartInstanceSpecificationForSetupSheetFlexVars_AeroPackageSpec_Fragment | PartInstanceSpecificationForSetupSheetFlexVars_AntiRollBarSpec_Fragment | PartInstanceSpecificationForSetupSheetFlexVars_ChassisSpec_Fragment | PartInstanceSpecificationForSetupSheetFlexVars_CustomSpec_Fragment | PartInstanceSpecificationForSetupSheetFlexVars_DamperSpec_Fragment | PartInstanceSpecificationForSetupSheetFlexVars_DifferentialSpec_Fragment | PartInstanceSpecificationForSetupSheetFlexVars_ElasticSpec_Fragment | PartInstanceSpecificationForSetupSheetFlexVars_GearBoxSpec_Fragment | PartInstanceSpecificationForSetupSheetFlexVars_GearSpec_Fragment | PartInstanceSpecificationForSetupSheetFlexVars_KinematicsExternalSpec_Fragment | PartInstanceSpecificationForSetupSheetFlexVars_KinematicsInternalSpec_Fragment;

export type GetPartsForSetupSheetFlexSelectQueryVariables = Exact<{
  rootSpecificationID: Scalars['MongoID']['input'];
  currentPartID: Scalars['MongoID']['input'];
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetPartsForSetupSheetFlexSelectQuery = { partsAdvancedFilter?: { items?: Array<{ _id: any, displayName?: string | null, readingLocationOverride?: Array<EnumPartReadingLocationOverride | null> | null, reference: string, rootSpecificationID?: any | null, specification?: { _id: any, hasToBeInSubAssembly?: boolean | null, name: string } | null } | null> | null } | null, part?: { _id: any, displayName?: string | null, readingLocationOverride?: Array<EnumPartReadingLocationOverride | null> | null, reference: string, rootSpecificationID?: any | null, specification?: { _id: any, hasToBeInSubAssembly?: boolean | null, name: string } | null } | null };

export type GetPartInstanceTrackingReferenceDatesQueryVariables = Exact<{
  partID: Scalars['MongoID']['input'];
}>;


export type GetPartInstanceTrackingReferenceDatesQuery = { trackingRecords?: { items?: Array<{ _id: any, date?: any | null, type?: EnumTrackingRecordType | null }> | null } | null };

export type RunInfoFieldUpdatedSubscriptionVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RunInfoFieldUpdatedSubscription = { runSheetUpdated?: { info?: string | null } | null };

export type GetEngineersForSetupSheetFlexHeaderQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEngineersForSetupSheetFlexHeaderQuery = { people?: { items?: Array<{ _id: any, name: string }> | null } | null, person?: { _id: any, name: string } | null };

export type GetSetupSheetStyleForFlexSetupSheetQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSetupSheetStyleForFlexSetupSheetQuery = { setupSheetStyle?: { _id: any, authorID?: any | null, chassisSpecID?: any | null, createdAt?: any | null, isPublic?: boolean | null, hideAddPartButton?: boolean | null, hideUnits?: boolean | null, name: string, updatedAt?: any | null, version?: string | null, author?: { username: string, name: string, _id: any } | null, blocks: Array<(
      { _id?: any | null }
      & SetupSheetStyleBlockVarsForSetupSheetFlexFragment
    )> } | null };

export type GetLocalConnectionsForFlexSetupSheetQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetLocalConnectionsForFlexSetupSheetQuery = { person?: { localConnections?: Array<AllLocalConnectionVarsFragment | null> | null } | null };

export type GetExternalKinematicsForFlexSetupSheetDropdownQueryVariables = Exact<{
  kinId: Scalars['MongoID']['input'];
  chassisId: Scalars['MongoID']['input'];
}>;


export type GetExternalKinematicsForFlexSetupSheetDropdownQuery = { kinematics?: { _id?: any | null, axle?: EnumAxle | null, aCamber?: { readingsRequired?: EnumSpecificationACamberReadingsRequired | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumSpecificationACamberUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null, aCaster?: { minValue?: number | null, maxValue?: number | null, step?: number | null, values?: Array<number | null> | null, valueNames?: Array<string | null> | null, unit?: EnumSpecificationACamberUnit | null, sign?: boolean | null, readingsRequired?: EnumSpecificationACamberReadingsRequired | null } | null, aToe?: { minValue?: number | null, maxValue?: number | null, step?: number | null, values?: Array<number | null> | null, valueNames?: Array<string | null> | null, unit?: EnumSpecificationACamberUnit | null, sign?: boolean | null, readingsRequired?: EnumSpecificationACamberReadingsRequired | null } | null } | {} | null, chassis?: { _id?: any | null, measurements?: { angles?: EnumAngleUnit | null } | null } | {} | null };

export type GetChassisAssembliesForCarSetupAssignAssemblyModalQueryVariables = Exact<{
  filter: FilterFindManyAssemblyInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssemblyInput>;
}>;


export type GetChassisAssembliesForCarSetupAssignAssemblyModalQuery = { assemblies?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<ChassisAssemblyForCarSetupAssemblyAssignmentVarsFragment | {}> | null } | null };

export type ChassisAssemblyForCarSetupAssemblyAssignmentVarsFragment = { _id?: any | null, chassisSpecID?: any | null, name: string, reference?: string | null };

export type SetupSheetStyleBlockVarsForSetupSheetFlexFragment = { _id?: any | null, backgroundColor?: string | null, borderColor?: string | null, height: number, width: number, x: number, y: number, tabs: Array<SetupSheetStyleBlockTabVarsForSetupSheetFlexFragment> };

export type CopyChassisAssemblyMutationVariables = Exact<{
  chassisAssemblyID: Scalars['MongoID']['input'];
  newCarSetupID: Scalars['MongoID']['input'];
}>;


export type CopyChassisAssemblyMutation = { copyChassisAssembly?: { newChassisAssemblyID?: any | null, newChassisAssemblyReference?: string | null, newChassisAssemblyName?: string | null } | null };

export type SetupSheetStyleBlockTabVarsForSetupSheetFlexFragment = { title: string, type?: EnumSetupSheetStyleTabType | null, groups: Array<{ header?: string | null, _id?: any | null, rows: Array<{ _id?: any | null, items: Array<{ _id?: any | null, alignment?: string | null, backgroundColor?: string | null, colSpan?: number | null, decimals?: number | null, fieldKey?: string | null, label?: string | null, restrictedToRoles: Array<EnumPersonRole>, widthRatio?: number | null, type: EnumSetupSheetStyleItemType }> }> }>, massConfig?: { massOption?: string | null, showMinWeightFromSpec?: boolean | null } | null, mileageConfig?: { showManualInput?: boolean | null } | null, rows: Array<{ _id?: any | null, items: Array<{ _id?: any | null, alignment?: string | null, backgroundColor?: string | null, colSpan?: number | null, fieldKey?: string | null, label?: string | null, restrictedToRoles: Array<EnumPersonRole>, type: EnumSetupSheetStyleItemType, widthRatio?: number | null }> }> };

export type GetCarSetupForSetupSheetFlexQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCarSetupForSetupSheetFlexQuery = { carSetup?: (
    { _id: any }
    & CarSetupVarsForSetupSheetFlexFragment
  ) | null };

export type GetCarSetupSpecForSetupSheetFlexQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCarSetupSpecForSetupSheetFlexQuery = { carSetup?: { _id: any, chassisSpec?: ChassisSpecVarsForSetupSheetFlexFragment | null } | null };

export type FlexCarSetupUpdatedSubscriptionVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type FlexCarSetupUpdatedSubscription = { carSetupUpdated?: (
    { _id: any }
    & CarSetupVarsForSetupSheetFlexFragment
  ) | null };

export type CanopyConfigsForSetupSheetFlexQueryVariables = Exact<{
  configType: EnumCanopyConfigType;
  nameFilter: Scalars['String']['input'];
}>;


export type CanopyConfigsForSetupSheetFlexQuery = { findCanopyConfigs: Array<{ canopyID: string, name: string }> };

export type RunSheetContextForSetupSheetVarsFragment = { _id: any, endTime?: any | null, info?: string | null, NRun?: number | null, prevRunSheetID?: any | null, sessionID?: any | null, setupID?: any | null, startTime?: any | null, teamID?: any | null, contestant?: { startNumber: string, chassis: Array<{ _id: any, reference?: string | null }> } | null, driver?: { acronym?: string | null } | null, session?: { _id: any, name: string, sessionType?: EnumSessionType | null, shortName?: string | null, tSessionEnd?: any | null, tSessionStart?: any | null, event?: { name: string, NEventSeason?: number | null, tEventEnd?: any | null, tEventStart?: any | null, _id: any, type?: EnumEventType | null, trackLayouts: Array<{ name: string, track?: { name: string } | null }> } | null } | null, weather?: { TAir?: number | null, TTrack?: number | null, rHumidity?: number | null, pAmbient?: number | null } | null };

export type CarSetupVarsForSetupSheetFlexFragment = { _id: any, chassisID?: any | null, chassisAssemblyID?: any | null, chassisSpecID?: any | null, chassisSpecRootID?: any | null, contestantID?: any | null, createdAt?: any | null, custom?: any | null, customSimulationPayload?: any | null, customSimulationPayloadEnabled?: boolean | null, engineerID?: any | null, isLocked?: boolean | null, manualEndMileage?: number | null, manualStartMileage?: number | null, mBallasts?: any | null, runSheetID?: any | null, setupInfo?: string | null, teamID?: any | null, title: string, time?: any | null, updatedAt?: any | null, aeroPackage?: { specificationID?: any | null, aeroElements?: Array<{ position?: number | null, positionName?: string | null, specificationID?: any | null, specification?: { name: string } | null } | null> | null } | null, chassis?: { reference?: string | null } | null, chassisAssembly?: ChassisAssemblyForFlexSetupVarsFragment | null, driver?: { acronym?: string | null } | null, engineer?: { name: string } | null, front?: EndVarsForSetupSheetFlexFragment | null, frontLeft?: CornerVarsForSetupSheetFlexFragment | null, frontRight?: CornerVarsForSetupSheetFlexFragment | null, info?: { setupComments?: string | null, tyreCompound?: string | null } | null, lastModifiedBy?: { name: string } | null, massOutOfGarage?: MassVarsFragment | null, massRegulation?: MassVarsFragment | null, massSetup?: MassVarsFragment | null, massTeam?: MassVarsFragment | null, powertrainCentral?: PowerTrainVarsForSetupSheetFlexFragment | null, powertrainFront?: PowerTrainVarsForSetupSheetFlexFragment | null, powertrainRear?: PowerTrainVarsForSetupSheetFlexFragment | null, rear?: EndVarsForSetupSheetFlexFragment | null, rearLeft?: CornerVarsForSetupSheetFlexFragment | null, rearRight?: CornerVarsForSetupSheetFlexFragment | null, runSheet?: RunSheetContextForSetupSheetVarsFragment | null };

export type ChassisAssemblyForFlexSetupVarsFragment = { _id?: any | null, chassisSpecID?: any | null, name: string, nestedPartInstanceIDs?: Array<any | null> | null, partInstanceIDs?: Array<any | null> | null, reference?: string | null, chassisMeasurements?: Array<ChassisMeasurementPointVarsFragment | null> | null, nestedPartInstances: Array<PartInstancesForSetupSheetFlexVarsFragment>, trackingSourceRecords?: Array<{ value?: number | null, trackingSourceID?: any | null, sources?: Array<{ value?: number | null, trackingSourceAliasID?: any | null } | null> | null } | null> | null };

export type SetupSheetStyleForFlexSetupFragment = { _id: any, name: string, type: EnumSetupSheetStyleType, targetRoles?: Array<EnumPersonRole> | null, targetUserIDs?: Array<any | null> | null };

export type PartInstancesForSetupSheetFlexVarsFragment = { _id: any, parentID?: any | null, partID?: any | null, readingLocation?: EnumReadingLocation | null, specificationID?: any | null, specificationGroupID?: any | null, trackingItemReferenceDate?: any | null, measurements?: Array<{ idx?: number | null, floatValue?: number | null, booleanValue?: boolean | null, stringValue?: string | null, value?: number | null, coordinates?: { x?: number | null, y?: number | null, z?: number | null } | null, rotation?: { I?: number | null, J?: number | null, K?: number | null } | null } | null> | null, part?: PartForSetupSheetFlexVarsFragment | null, specification?: { __typename: 'AeroElementSpec', _id?: any | null, rootSpecificationID: any } | { __typename: 'AeroPackageSpec', _id?: any | null, rootSpecificationID: any } | { __typename: 'AntiRollBarSpec', _id?: any | null, rootSpecificationID: any } | { __typename: 'ChassisSpec', _id?: any | null, rootSpecificationID: any } | { __typename: 'CustomSpec', _id?: any | null, rootSpecificationID: any, name: string } | { __typename: 'DamperSpec', _id?: any | null, rootSpecificationID: any } | { __typename: 'DifferentialSpec', _id?: any | null, rootSpecificationID: any } | { __typename: 'ElasticSpec', _id?: any | null, rootSpecificationID: any } | { __typename: 'GearBoxSpec', _id?: any | null, rootSpecificationID: any } | { __typename: 'GearSpec', _id?: any | null, rootSpecificationID: any } | { __typename: 'KinematicsExternalSpec', _id?: any | null, rootSpecificationID: any } | { __typename: 'KinematicsInternalSpec', _id?: any | null, rootSpecificationID: any } | null };

export type EndVarsForSetupSheetFlexFragment = { aCamber?: number | null, aCamberMeasurement?: number | null, aCaster?: number | null, aCasterMeasurement?: number | null, aToe?: number | null, aToeMeasurement?: number | null, hRide?: number | null, hRideChassis?: number | null, hRideMeasurement?: number | null, hRideRegulation?: number | null, xToe?: number | null, xToeMeasurement?: number | null, kinematicsExternalSpecID?: any | null, kinematicsInternalSpecID?: any | null, antiRollBar?: AntiRollBarVarsForSetupSheetFlexFragment | null, bumpStop?: BumpStopVarsForSetupSheetFlexFragment | null, damper?: { specificationID?: any | null, adjusters?: Array<{ _id?: any | null, name?: string | null, settingName?: string | null, value?: number | null } | null> | null, specification?: { _id?: any | null, name: string, damperAdjusters?: Array<{ name: string } | null> | null } | null } | null, droopStop?: DroopStopVarsForSetupSheetFlexFragment | null, externalBumpStop?: ExternalBumpStopVarsForSetupSheetFlexFragment | null, kinematicsExternalSpec?: KinematicsExternalSpecVarsForSetupSheetFlexFragment | null, kinematicsInternalSpec?: KinematicsInternalSpecVarsForSetupSheetFlexFragment | null, helperSpring?: SpringVarsForSetupSheetFlexFragment | null, reboundSpring?: SpringVarsForSetupSheetFlexFragment | null, spring?: SpringVarsForSetupSheetFlexFragment | null };

export type CornerVarsForSetupSheetFlexFragment = { aCamber?: number | null, aCamberMeasurement?: number | null, aCaster?: number | null, aCasterMeasurement?: number | null, aToe?: number | null, aToeMeasurement?: number | null, hRide?: number | null, hRideChassis?: number | null, hRideMeasurement?: number | null, hRideRegulation?: number | null, pTyreTarget?: number | null, xToe?: number | null, xToeMeasurement?: number | null, bumpStop?: BumpStopVarsForSetupSheetFlexFragment | null, damper?: { specificationID?: any | null, adjusters?: Array<{ _id?: any | null, name?: string | null, settingName?: string | null, value?: number | null } | null> | null, specification?: { _id?: any | null, name: string, damperAdjusters?: Array<{ name: string } | null> | null } | null } | null, droopStop?: DroopStopVarsForSetupSheetFlexFragment | null, externalBumpStop?: ExternalBumpStopVarsForSetupSheetFlexFragment | null, helperSpring?: SpringVarsForSetupSheetFlexFragment | null, reboundSpring?: SpringVarsForSetupSheetFlexFragment | null, spring?: SpringVarsForSetupSheetFlexFragment | null };

export type AntiRollBarVarsForSetupSheetFlexFragment = { kARB?: number | null, name?: string | null, position1?: string | null, position2?: string | null, specificationID?: any | null, specification?: { name: string, antiRollBarConfigs?: Array<{ position1?: string | null, position2?: string | null } | null> | null } | null };

export type BumpStopVarsForSetupSheetFlexFragment = { name?: string | null, specificationID?: any | null, xBumpStopGap?: number | null, specification?: ElasticSpecForSetupSheetFlexVarsFragment | null };

export type DroopStopVarsForSetupSheetFlexFragment = { specificationID?: any | null, xDroopStopGap?: number | null, specification?: ElasticSpecForSetupSheetFlexVarsFragment | null };

export type ExternalBumpStopVarsForSetupSheetFlexFragment = { specificationID?: any | null, xExternalBumpStopGap?: number | null, specification?: ElasticSpecForSetupSheetFlexVarsFragment | null };

export type KinematicsExternalSpecVarsForSetupSheetFlexFragment = { _id?: any | null, name: string };

export type KinematicsInternalSpecVarsForSetupSheetFlexFragment = { _id?: any | null, name: string };

export type PowerTrainVarsForSetupSheetFlexFragment = { differentialSpecID?: any | null, MDiffPreloadCold?: number | null, MDiffPreloadHot?: number | null, differentialConfigName?: string | null, bevelSet?: { specificationID?: any | null, specification?: { name: string } | null } | null, dropGear?: { specificationID?: any | null, specification?: { name: string } | null } | null, gears?: Array<{ gearNumber: string, specificationID?: any | null } | null> | null };

export type SpringVarsForSetupSheetFlexFragment = { specificationID?: any | null, xSecondSpringTransition?: number | null, xSpringPreload?: number | null, specification?: ElasticSpecForSetupSheetFlexVarsFragment | null };

export type ChassisMeasurementPointVarsFragment = { chassisSpecMeasurementID?: any | null, location?: { coordinates?: { x?: number | null, y?: number | null, z?: number | null } | null } | null, orientation?: { rotation?: { I?: number | null, J?: number | null, K?: number | null } | null } | null };

export type PartForSetupSheetFlexVarsFragment = { _id: any, chassisSpecName?: string | null, createdAt?: any | null, description?: string | null, displayName?: string | null, eligibleEventTypes?: EnumPartEligibleEventTypes | null, lifetimeMileage?: number | null, manufacturerID?: any | null, manufacturerPartID?: string | null, manufacturerSerialNumber?: string | null, notes?: string | null, partNumber?: string | null, properties?: any | null, reference: string, teamID?: any | null, updatedAt?: any | null, userEnumPartTypeID?: any | null };

export type ElasticSpecForSetupSheetFlexVarsFragment = { _id?: any | null, kSpring?: number | null, name: string, xFree?: number | null };

export type PartTrackingHistoryForSetupSheetTrackingFieldOldQueryVariables = Exact<{
  endDate?: InputMaybe<Scalars['Date']['input']>;
  partID: Scalars['MongoID']['input'];
  trackingItemID: Scalars['MongoID']['input'];
}>;


export type PartTrackingHistoryForSetupSheetTrackingFieldOldQuery = { partReturnTrackingHistoryFullandSnapshot?: { trackingSnapshot?: Array<{ cumulativeValue?: number | null, dateResolved?: any | null, limitCritical?: boolean | null, limitWarning?: boolean | null, type?: string | null, value?: number | null, valueString?: string | null, trackingItem?: { criticalCumulativeValue?: number | null, criticalValue?: number | null, cumulativeCalculation?: boolean | null, displayUnit?: EnumDisplayUnit | null, operator?: EnumTrackingItemOperator | null, warningCumulativeValue?: number | null, warningValue?: number | null } | null } | null> | null } | null };

export type PartTrackingHistoryForSetupSheetTrackingFieldQueryVariables = Exact<{
  partID: Scalars['MongoID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type PartTrackingHistoryForSetupSheetTrackingFieldQuery = { partTracking: Array<PartTrackingVarsForSetupSheetFlexFragment | null> };

export type PartTrackingVarsForSetupSheetFlexFragment = { trackingItemID: any, trackingItem?: { _id: any, name: string, description?: string | null, criticalCumulativeValue?: number | null, criticalValue?: number | null, cumulativeCalculation?: boolean | null, displayUnit?: EnumDisplayUnit | null, operator?: EnumTrackingItemOperator | null, warningCumulativeValue?: number | null, warningValue?: number | null, trackingSource?: { name: string, displayUnit?: EnumDisplayUnit | null, NDecimals?: number | null } | null } | null, snapshot?: { cumulativeValue?: number | null, dateResolved?: any | null, type?: EnumTrackingRecordType | null, value?: number | null, valueString?: string | null } | null };

export type GetChassisAeroSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisAeroSpecByIdQuery = { specification?: { _id?: any | null, aeroPackageSpecIDs?: Array<any | null> | null, aeroPackageSpecs: Array<{ _id?: any | null, name: string, aeroElementSpecIDs?: Array<any | null> | null, aeroElementSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, name: string, positions?: Array<number | null> | null, positionNames?: Array<string | null> | null }> }> } | {} | null };

export type GetChassisAntiRollBarSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisAntiRollBarSpecByIdQuery = { specification?: { _id?: any | null, antiRollBarSpecIDs?: Array<any | null> | null, antiRollBarSpecs: Array<(
      { _id?: any | null }
      & AntiRollBarVarsFragment
    )> } | {} | null };

export type GetChassisBevelSetSpecsByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisBevelSetSpecsByIdQuery = { specification?: { _id?: any | null, powertrain?: { bevelSetSpecIDs?: Array<any | null> | null, bevelSetSpecs: Array<(
        { _id?: any | null }
        & GearSpecVarsFragment
      )> } | null } | {} | null };

export type GetChassisDamperSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisDamperSpecByIdQuery = { specification?: { _id?: any | null, damperSpecIDs?: Array<any | null> | null, damperSpecs: Array<(
      { _id?: any | null }
      & DamperSpecVarsFragment
    )> } | {} | null };

export type GetChassisDifferentialSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisDifferentialSpecByIdQuery = { specification?: { _id?: any | null, powertrain?: { differentialSpecIDs?: Array<any | null> | null, differentialSpecs: Array<(
        { _id?: any | null }
        & DifferentialSpecVarsFragment
      )> } | null } | {} | null };

export type GetChassisDropGearSpecsByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisDropGearSpecsByIdQuery = { specification?: { _id?: any | null, powertrain?: { dropGearSpecIDs?: Array<any | null> | null, dropGearSpecs: Array<(
        { _id?: any | null }
        & GearSpecVarsFragment
      )> } | null } | {} | null };

export type GetChassisGearSpecsByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisGearSpecsByIdQuery = { specification?: { _id?: any | null, powertrain?: { gearSpecIDs?: Array<any | null> | null, gearSpecs: Array<(
        { _id?: any | null }
        & GearSpecVarsFragment
      )> } | null } | {} | null };

export type GetChassisKinematicExtSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisKinematicExtSpecByIdQuery = { specification?: { _id?: any | null, kinematicsExternalSpecIDs?: Array<any | null> | null, kinematicsExternalSpecs: Array<(
      { _id?: any | null }
      & ExternalKinematicSpecVarsFragment
    )> } | {} | null };

export type GetChassisKinematicIntSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisKinematicIntSpecByIdQuery = { specification?: { _id?: any | null, kinematicsInternalSpecIDs?: Array<any | null> | null, kinematicsInternalSpecs: Array<(
      { _id?: any | null }
      & InternalKinematicSpecVarsFragment
    )> } | {} | null };

export type GetChassisTorsionBarSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisTorsionBarSpecByIdQuery = { specification?: { _id?: any | null, torsionBarSpecIDs?: Array<any | null> | null, torsionBarSpecs: Array<(
      { _id?: any | null }
      & ElasticSpecVarsFragment
    )> } | {} | null };

export type GetChassisSpringSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSpringSpecByIdQuery = { specification?: { _id?: any | null, springSpecIDs?: Array<any | null> | null, springSpecs: Array<(
      { _id?: any | null }
      & ElasticSpecVarsFragment
    )> } | {} | null };

export type GetChassisHelperSpringSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisHelperSpringSpecByIdQuery = { specification?: { _id?: any | null, helperSpringSpecIDs?: Array<any | null> | null, helperSpringSpecs: Array<(
      { _id?: any | null }
      & ElasticSpecVarsFragment
    )> } | {} | null };

export type GetChassisReboundSpringSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisReboundSpringSpecByIdQuery = { specification?: { _id?: any | null, reboundSpringSpecIDs?: Array<any | null> | null, reboundSpringSpecs: Array<(
      { _id?: any | null }
      & ElasticSpecVarsFragment
    )> } | {} | null };

export type GetChassisBumpRubberSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisBumpRubberSpecByIdQuery = { specification?: { _id?: any | null, bumpRubberSpecIDs?: Array<any | null> | null, bumpRubberSpecs: Array<(
      { _id?: any | null }
      & ElasticSpecVarsFragment
    )> } | {} | null };

export type GetChassisMinWeightSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisMinWeightSpecByIdQuery = { specification?: { regulationSets?: Array<{ name: string, massMin?: number | null } | null> | null } | {} | null };

export type GetChassisSpecGroupsByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSpecGroupsByIdQuery = { specification?: { specificationGroupIDs?: Array<any | null> | null, customSpecIDs?: Array<any | null> | null, specificationGroups: Array<SpecificationGroupVariablesFragment>, customSpecs: Array<{ _id?: any | null, name: string }> } | {} | null };

export type GetChassisMeasurementPointsByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisMeasurementPointsByIdQuery = { specification?: { chassisMeasurementIDs?: Array<any | null> | null, chassisMeasurements: Array<AllChassisMeasurementSpecVarsFragment> } | {} | null };

export type GetChassisAssemblyPartInstancesByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisAssemblyPartInstancesByIdQuery = { carSetup?: { chassisAssembly?: { partInstances: Array<{ _id: any }> } | null } | null };

export type SpecificationGroupVariablesFragment = { _id: any, name: string, description?: string | null, specifications: Array<{ _id: any, name: string, readingsRequired?: EnumSpecificationReadingsRequired | null }> };

export type AddFourTyresAtOnceMutationVariables = Exact<{
  tyreFL: CreateOneTyreInput;
  tyreFR: CreateOneTyreInput;
  tyreRL: CreateOneTyreInput;
  tyreRR: CreateOneTyreInput;
}>;


export type AddFourTyresAtOnceMutation = { addTyreFL?: { recordId?: any | null } | null, addTyreFR?: { recordId?: any | null } | null, addTyreRL?: { recordId?: any | null } | null, addTyreRR?: { recordId?: any | null } | null };

export type GetRunPlansForEventTyreMileageContextQueryVariables = Exact<{
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  eventID: Scalars['MongoID']['input'];
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetRunPlansForEventTyreMileageContextQuery = { runPlans?: { items?: Array<RunPlanForEventTyreMileageContextVarsFragment> | null } | null, event?: { _id: any, contestants?: Array<{ _id: any, tyreSetIDs?: Array<any | null> | null, tyreSets: Array<TyreSetVarsFragment> } | null> | null } | null };

export type GetTyreMileagesAtSessionStartForEventTyreMileageContextQueryVariables = Exact<{
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetTyreMileagesAtSessionStartForEventTyreMileageContextQuery = { tyreMileageAtSessionStart?: { tyreSetMileages?: Array<{ tyreSetID?: any | null, sessions?: Array<TyreMileageAtSessionStartVarsFragment | null> | null } | null> | null } | null };

export type TyreMileageAtSessionStartVarsFragment = { sessionID?: any | null, startMileage?: number | null, endMileage?: number | null, runs?: Array<{ runSheetID?: any | null, startMileage?: number | null, endMileage?: number | null } | null> | null };

export type RunPlanForEventTyreMileageContextVarsFragment = { _id: any, sessionID: any, title: string, runs: Array<{ NRun: number, tyreSetID?: any | null, lapSequence?: Array<{ NLap: number, lapType: EnumLapSequenceLapsLapType } | null> | null } | null>, session?: { name: string, shortName?: string | null, event?: { name: string, season?: { name: string, raceSeries?: { name: string } | null } | null, trackLayouts: Array<{ _id: any, name: string, lapLengthInLapCarData?: number | null, lapLengthInLapOfficial?: number | null, lapLengthInLapRoulette?: number | null, lapLengthOfficial?: number | null, lapLengthCarData?: number | null, lapLengthRoulette?: number | null, lapLengthOutLapCarData?: number | null, lapLengthOutLapOfficial?: number | null, lapLengthOutLapRoulette?: number | null, pitDistance?: number | null }> } | null } | null };

export type GetRunSheetsForEventTyreMileageContextQueryVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetRunSheetsForEventTyreMileageContextQuery = { runSheets?: { items?: Array<(
      { _id: any }
      & RunPlanRunRunSheetVarsFragment
    )> | null } | null };

export type RunSheetForEventTyreMileageContextVarsFragment = { NRun?: number | null, NRunTiming?: number | null, mileage?: number | null };

export type RunSheetInSessionsAddedForRunPlannerSubscriptionVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RunSheetInSessionsAddedForRunPlannerSubscription = { runSheetInSessionsAdded?: (
    { _id: any }
    & RunPlanRunRunSheetVarsFragment
  ) | null };

export type RunSheetInSessionsRemovedForRunPlannerSubscriptionVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RunSheetInSessionsRemovedForRunPlannerSubscription = { runSheetInSessionsRemoved?: { _id?: any | null } | null };

export type RunSheetInSessionsUpdatedForRunPlannerSubscriptionVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RunSheetInSessionsUpdatedForRunPlannerSubscription = { runSheetInSessionsUpdated?: (
    { _id: any }
    & RunPlanRunRunSheetVarsFragment
  ) | null };

export type RunPlanUpdatedSubscriptionVariables = Exact<{
  runPlanID: Scalars['MongoID']['input'];
}>;


export type RunPlanUpdatedSubscription = { runPlanUpdated?: RunPlanForEventTyreMileageContextVarsFragment | null };

export type RunPlanAddedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RunPlanAddedSubscription = { runPlanAdded?: RunPlanForEventTyreMileageContextVarsFragment | null };

export type RunPlanRemovedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RunPlanRemovedSubscription = { runPlanRemoved?: RunPlanForEventTyreMileageContextVarsFragment | null };

export type AddFlattenedSimulationPayloadMutationVariables = Exact<{
  carSetupID: Scalars['MongoID']['input'];
  record?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type AddFlattenedSimulationPayloadMutation = { addFlattenedSimulationPayload?: { success?: boolean | null } | null };

export type GetFlattenedSetupForRfkCustomSimulationQueryVariables = Exact<{
  carSetupID: Scalars['MongoID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  outputFolder?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFlattenedSetupForRfkCustomSimulationQuery = { flattenedSetupForSimulation?: any | null };

export type GetVisibleContestantsForContestantHookQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetVisibleContestantsForContestantHookQuery = { person?: { visibleContestantIDs?: Array<any | null> | null } | null };

export type GetCurrentUserInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCurrentUserInfoQuery = { person?: { _id: any, acronym?: string | null, carUpdateMethod?: EnumPersonCarUpdateMethod | null, defaultRunSheetCompareStyleID?: any | null, defaultRunSheetStyleID?: any | null, defaultTyreReferenceTemperature?: number | null, defaultTyreSetNameFormat?: string | null, email?: string | null, hideKPIs?: boolean | null, isActive?: boolean | null, isTimeTracker?: boolean | null, isTimeTrackerAdmin?: boolean | null, name: string, role?: EnumPersonRole | null, teamID?: any | null, timeTrackerApprovalByPersonID?: any | null, username: string, visibleEventIDs?: Array<any | null> | null, behaviour?: { carryOverJobList?: boolean | null, showMyJobsOnRunSheetDefault?: boolean | null, timeLocale?: string | null, timezoneSelect?: EnumBehaviourConfigTimezoneSelect | null } | null, canopyCredentials?: { clientID?: string | null, clientSecret?: string | null, username?: string | null, password?: string | null, userID?: string | null, tenantID?: string | null } | null, emailNotificationConfig?: { jobAssigned?: boolean | null, jobCommentedOn?: boolean | null, jobStatusChanged?: boolean | null } | null, userSetups: Array<{ _id: any, title: string }>, viewConfig?: { showRunSheetsAsTabs?: boolean | null, yellowTyreMileageThreshold?: number | null, redTyreMileageThreshold?: number | null, highlightTyreMileages?: boolean | null } | null } | null };

export type CheckDataUpdatedAtForOverviewPageQueryVariables = Exact<{
  eventIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  runSheetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  runSheetPageSize?: InputMaybe<Scalars['Int']['input']>;
  simResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  simResultPageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CheckDataUpdatedAtForOverviewPageQuery = { sessions?: { items?: Array<{ _id: any, name: string, shortName?: string | null, eventID: any, event?: { name: string } | null }> | null } | null, runSheets?: { items?: Array<{ _id: any, updatedAt?: any | null, setup?: { _id: any, updatedAt?: any | null, chassisSpec?: { _id?: any | null, updatedAt?: any | null } | null } | null }> | null } | null, simResults?: { items?: Array<{ _id: any, updatedAt?: any | null }> | null } | null };

export type GetRunSheetIDsForSessionAndContestantQueryVariables = Exact<{
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetRunSheetIDsForSessionAndContestantQuery = { runSheets?: { items?: Array<{ _id: any }> | null } | null };

export type GetUpdatedDataForInitializationForOverviewPageQueryVariables = Exact<{
  runSheetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  runSheetPageSize?: InputMaybe<Scalars['Int']['input']>;
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  simResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  simResultPageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUpdatedDataForInitializationForOverviewPageQuery = { allowedRunSheetsForSelectedSessions?: { items?: Array<RunSheetForEventSelectionVarsFragment> | null } | null, updatedRunSheets?: { items?: Array<AllKpiRunSheetDataFragment> | null } | null, simResults?: { items?: Array<AllSimResultScalarVarsFragment> | null } | null };

export type GetSessionIDsforSelectedEventsForOverviewPageQueryVariables = Exact<{
  eventIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSessionIDsforSelectedEventsForOverviewPageQuery = { events?: { items?: Array<{ sessionIDs?: Array<any | null> | null }> | null } | null };

export type GetRunSheetListForEventSelectionForOverviewPageQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetListForEventSelectionForOverviewPageQuery = { runSheets?: { items?: Array<RunSheetForEventSelectionVarsFragment> | null } | null };

export type GetRunSheetListWithAllKpiQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  maxEntries: Scalars['Int']['input'];
}>;


export type GetRunSheetListWithAllKpiQuery = { runSheets?: { items?: Array<(
      { setup?: { chassisSpec?: (
          { customSpecs: Array<CustomSpecVarsFragment> }
          & ChassisSpecVarsForSetupSheetFlexFragment
        ) | null } | null }
      & AllKpiRunSheetDataFragment
    )> | null } | null };

export type GetSetupsForDashboardRefreshQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetSetupsForDashboardRefreshQuery = { carSetupsMany: Array<CarSetupVarsForKpiViewLiveFragment> };

export type GetRunSheetsForOverviewsWithAllKpiQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetsForOverviewsWithAllKpiQuery = { runSheets?: { items?: Array<AllKpiRunSheetDataFragment> | null } | null };

export type GetRunSheetForOverviewsWithAllKpiQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetForOverviewsWithAllKpiQuery = { runSheet?: AllKpiRunSheetDataFragment | null };

export type GetSimResultForOverviewQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSimResultForOverviewQuery = { simResult?: { _id: any, name?: string | null, refValues?: any | null, runSheetID?: any | null, simType?: EnumSimResultSimType | null, updatedAt?: any | null, data?: Array<{ _id?: any | null, channelName?: string | null, channelTime?: Array<number | null> | null, channelValue?: Array<number | null> | null } | null> | null, simulationDriveFile?: { name?: string | null } | null } | null };

export type AllKpiRunSheetDataFragment = (
  { runKPI?: any | null, laps: Array<(
    { lapKPI?: any | null }
    & LapForRunSheetOverviewVarsFragment
  )> }
  & RunSheetForOverviewFragment
);

export type RunSheetForOverviewFragment = (
  { _id: any, associatedKpiFiles?: Array<string | null> | null, brakeComment?: string | null, chassisAssemblyID?: any | null, contestantID: any, createdAt?: any | null, dataServiceFileNameOverride?: string | null, DFuel?: number | null, driverID?: any | null, engineerID?: any | null, endTime?: any | null, fastestLap?: number | null, fuelDrainedBeforeRun?: boolean | null, info?: string | null, isLocked?: boolean | null, kpiFileName?: string | null, kpiStatus?: EnumRunSheetKpiStatus | null, kpiUpdatedAt?: any | null, lapCount: number, mFuelAdded?: number | null, mFuelDrainedCatchTank?: number | null, mFuelDrainedMainTank?: number | null, mFuelRunEnd?: number | null, mFuelRunStart?: number | null, mileage?: number | null, nextRunSheetID?: any | null, NRun?: number | null, NRunTiming?: number | null, prevRunSheetID?: any | null, sessionID?: any | null, setupID?: any | null, simResultIDs?: Array<any | null> | null, startTime?: any | null, teamID?: any | null, timingServiceShouldIgnore?: boolean | null, tyreSetID?: any | null, updatedAt?: any | null, brakeFL?: BrakeForRunSheetOverviewVarsFragment | null, brakeFR?: BrakeForRunSheetOverviewVarsFragment | null, brakeRL?: BrakeForRunSheetOverviewVarsFragment | null, brakeRR?: BrakeForRunSheetOverviewVarsFragment | null, consumptions?: Array<{ trackLayoutID: any, trackLayout?: { _id: any, name: string, track?: { _id: any, name: string } | null } | null, energyRequired?: AllRunEnergyVarsFragment | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null } | null> | null, contestant?: { _id: any, color?: string | null, startNumber: string } | null, driver?: { _id: any, acronym?: string | null, name: string } | null, engineer?: { _id: any, name: string } | null, lastModifiedBy?: { _id: any, name: string } | null, session?: { _id: any, name: string, shortName?: string | null, eventID: any, tSessionEnd?: any | null, tSessionStart?: any | null, event?: { _id: any, name: string, contestants?: Array<{ _id: any, drivers: Array<{ _id: any, acronym?: string | null, name: string }> } | null> | null, season?: { name: string, raceSeries?: { _id: any, name: string } | null } | null, track?: { name: string, timeZone?: string | null } | null, trackLayouts: Array<{ _id: any, lapLengthOfficial?: number | null, name: string, NSectorsTiming?: number | null }> } | null } | null, setup?: CarSetupVarsForKpiViewLiveFragment | null, simResults: Array<SimResultForRunSheetOverviewVarsFragment>, team?: { name: string } | null, tyreFL?: RunTyreForRunSheetOverviewVarsFragment | null, tyreFR?: RunTyreForRunSheetOverviewVarsFragment | null, tyreRL?: RunTyreForRunSheetOverviewVarsFragment | null, tyreRR?: RunTyreForRunSheetOverviewVarsFragment | null, tyreSet?: { name?: string | null, number?: number | null, comment?: string | null } | null, weather?: WeatherForRunSheetOverviewVarsFragment | null }
  & BrakeMeasurementForRunSheetOverviewVarsFragment
  & RunCommentVarsFragment
);

export type SimResultForRunSheetOverviewVarsFragment = { _id: any, createdAt?: any | null, name?: string | null, refValues?: any | null, requesterID?: any | null, runSheetID?: any | null, simType?: EnumSimResultSimType | null, simulationDriveFileID?: any | null, status?: EnumSimResultStatus | null, updatedAt?: any | null, simulationDriveFile?: { name?: string | null } | null };

export type LapForRunSheetOverviewVarsFragment = (
  { _id: any, BPitIn: boolean, BPitOut: boolean, energyLapStart?: number | null, energyRemaining?: number | null, energyRemainingData?: number | null, fuelConsumptionThisLap?: number | null, lapComment?: string | null, lapCommentSystems?: string | null, laptimeServiceHash?: string | null, lapType?: EnumLapType | null, mFuelConsumptionThisLap?: number | null, mFuelLapEnd?: number | null, mFuelLapStart?: number | null, position?: number | null, powerMode?: number | null, raceControlMessage?: string | null, rEnergyConsumptionThisLap?: number | null, rEnergyLapEnd?: number | null, rEnergyLapStart?: number | null, rSOCConsumptionThisLap?: number | null, rSOCLapEnd?: number | null, rSOCLapStart?: number | null, TCell?: number | null, tDay?: any | null, tDayPitIn?: any | null, tDayPitOut?: any | null, tLapManual?: number | null, tLapMax?: number | null, trackLayoutID?: any | null, tSectorsManual?: Array<number | null> | null, tSectorsOfficial?: Array<number | null> | null, tSectorsTiming?: Array<number | null> | null, tyreCompoundTiming?: string | null, vCarLapMax?: number | null, vCarSectors?: Array<number | null> | null, data?: Array<LapDataVarsFragment | null> | null, trackLayout?: { _id: any, name: string, lapLengthOfficial?: number | null, lapLengthCarData?: number | null, lapLengthRoulette?: number | null, NSectorsTiming?: number | null } | null }
  & LapNumberVarsFragment
);

export type BrakeForRunSheetOverviewVarsFragment = { TBrakePreRun?: number | null, TBrakePostRun?: number | null, hBrakeDiscPreRun?: number | null, thicknessMeasurements?: any | null };

export type BrakeMeasurementForRunSheetOverviewVarsFragment = { brakePostRunMeasurementsFL?: any | null, brakePostRunMeasurementsFR?: any | null, brakePostRunMeasurementsRL?: any | null, brakePostRunMeasurementsRR?: any | null, brakePreRunMeasurementsFL?: any | null, brakePreRunMeasurementsFR?: any | null, brakePreRunMeasurementsRL?: any | null, brakePreRunMeasurementsRR?: any | null };

export type RunTyreForRunSheetOverviewVarsFragment = { hTyreTread?: Array<number | null> | null, mileagePreRun?: number | null, pTyre?: number | null, pTyreMinStartRun?: number | null, pTyrePostRun?: number | null, pTyrePostRunBleed?: number | null, pTyrePreRunBleed?: number | null, pTyreReference?: number | null, pTyreSetDown?: number | null, pTyreStartRun?: number | null, pTyreTarget?: number | null, TTrackReference?: number | null, TTyre?: number | null, TTyreParcFermeExpected?: number | null, TTyrePostRun?: number | null, TTyrePostRunBleed?: number | null, TTyrePreRunBleed?: number | null, TTyreReference?: number | null, TTyreSetdown?: number | null, TTyreSurface?: Array<number | null> | null, tyreID?: any | null };

export type WeatherForRunSheetOverviewVarsFragment = { time?: any | null, TAir?: number | null, TAirMin?: number | null, TAirMax?: number | null, TAirExpected?: number | null, TAmbient?: number | null, TAirOfficial?: number | null, TTrack?: number | null, TTrackExpected?: number | null, TTrackOfficial?: number | null, TWindChill?: number | null, TDewPoint?: number | null, aWind?: number | null, vWind?: number | null, vWindAverage?: number | null, vWindPeak?: number | null, rHumidity?: number | null, globalRadiation?: number | null, pAmbient?: number | null, trackCondition?: string | null, ambientCondition?: string | null, aWindMain?: number | null, TInternal?: number | null, VBattery?: number | null, rainProbability?: number | null, rainIntensity?: number | null, DAir?: number | null };

export type GetChassisSpecForOverviewQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSpecForOverviewQuery = { specification?: (
    { _id?: any | null, updatedAt?: any | null, customSpecs: Array<CustomSpecVarsFragment> }
    & ChassisSpecVarsForSetupSheetFlexFragment
  ) | {} | null };

export type CarSetupVarsForKpiViewFragment = (
  { chassisSpec?: (
    { _id?: any | null, updatedAt?: any | null, customSpecs: Array<CustomSpecVarsFragment> }
    & ChassisSpecVarsForSetupSheetFlexFragment
  ) | null }
  & CarSetupVarsForKpiViewBaseFragment
);

export type CarSetupVarsForKpiViewLiveFragment = (
  { chassisSpec?: { _id?: any | null, updatedAt?: any | null } | null }
  & CarSetupVarsForKpiViewBaseFragment
);

export type CarSetupVarsForKpiViewBaseFragment = { _id: any, chassisID?: any | null, chassisAssemblyID?: any | null, chassisSpecID?: any | null, chassisSpecRootID?: any | null, contestantID?: any | null, createdAt?: any | null, custom?: any | null, customSimulationPayload?: any | null, customSimulationPayloadEnabled?: boolean | null, driverID?: any | null, engineerID?: any | null, isLocked?: boolean | null, manualEndMileage?: number | null, manualStartMileage?: number | null, mBallasts?: any | null, runSheetID?: any | null, setupInfo?: string | null, setupSheetStyle?: EnumCarSetupSetupSheetStyle | null, systemsConfigValues?: any | null, teamID?: any | null, time?: any | null, title: string, updatedAt?: any | null, aero?: AeroVarsFragment | null, aeroPackage?: { specificationID?: any | null, aeroElements?: Array<{ position?: number | null, positionName?: string | null, specificationID?: any | null, specification?: { name: string } | null } | null> | null, specification?: { name: string } | null } | null, brakeSystem?: BrakeSystemVarsFragment | null, chassis?: { reference?: string | null, type?: string | null, rootAssemblyIDs?: Array<any | null> | null, rootSpecificationID?: any | null, specificationID?: any | null, setupSheetStyle?: EnumChassisSetupSheetStyle | null, setupOptions?: any | null, systemsConfigFields?: Array<string | null> | null, ballastPositions?: Array<string | null> | null, decommissioned?: boolean | null, concurrentUseAllowed?: boolean | null, currentlyInUse?: boolean | null, manufacturerPartID?: string | null, notes?: string | null, properties?: any | null, tagIDs?: Array<any | null> | null, _id: any } | null, chassisAssembly?: ChassisAssemblyForFlexSetupVarsFragment | null, driver?: { _id: any, acronym?: string | null } | null, engineer?: { _id: any, name: string } | null, front?: EndVarsForSetupSheetFlexFragment | null, frontLeft?: CornerVarsForSetupSheetFlexFragment | null, frontRight?: CornerVarsForSetupSheetFlexFragment | null, info?: (
    { setupComments?: string | null, tyreCompound?: string | null }
    & InfoVarsFragment
  ) | null, lastModifiedBy?: { name: string } | null, massOutOfGarage?: MassVarsFragment | null, massRegulation?: MassVarsFragment | null, massSetup?: MassVarsFragment | null, massTeam?: MassVarsFragment | null, powertrain?: PowertrainVarsFragment | null, powertrainFront?: PowertrainVarsFragment | null, powertrainCentral?: PowertrainVarsFragment | null, powertrainRear?: PowertrainVarsFragment | null, rear?: EndVarsForSetupSheetFlexFragment | null, rearLeft?: CornerVarsForSetupSheetFlexFragment | null, rearRight?: CornerVarsForSetupSheetFlexFragment | null, runSheet?: RunSheetContextForSetupSheetVarsFragment | null, steering?: SteeringVarsFragment | null };

export type Overview_RunSheetAddedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type Overview_RunSheetAddedSubscription = { runSheetAdded?: AllKpiRunSheetDataFragment | null };

export type Overview_RunSheetUpdatedSubscriptionVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type Overview_RunSheetUpdatedSubscription = { runSheetUpdated?: AllKpiRunSheetDataFragment | null };

export type Overview_RunSheetRemovedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type Overview_RunSheetRemovedSubscription = { runSheetRemoved?: { _id?: any | null } | null };

export type Overview_CarSetupUpdatedSubscriptionVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type Overview_CarSetupUpdatedSubscription = { carSetupUpdated?: CarSetupVarsForKpiViewLiveFragment | null };

export type Overview_SimResultUpdatedSubscriptionVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type Overview_SimResultUpdatedSubscription = { simResultUpdated?: SimResultInfosForStagingAreaVarsFragment | null };

export type Overview_SimResultAddedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type Overview_SimResultAddedSubscription = { simResultAdded?: AllSimResultScalarVarsFragment | null };

export type Overview_SimResultRemovedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type Overview_SimResultRemovedSubscription = { simResultRemoved?: { _id: any, runSheetID?: any | null } | null };

export type RunSheetInSessionsAddedForDashboardSubscriptionVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RunSheetInSessionsAddedForDashboardSubscription = { runSheetInSessionsAdded?: (
    { _id: any }
    & AllKpiRunSheetDataFragment
  ) | null };

export type RunSheetInSessionsRemovedForDashboardSubscriptionVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RunSheetInSessionsRemovedForDashboardSubscription = { runSheetInSessionsRemoved?: { _id?: any | null } | null };

export type RunSheetInSessionsUpdatedForDashboardSubscriptionVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RunSheetInSessionsUpdatedForDashboardSubscription = { runSheetInSessionsUpdated?: (
    { _id: any }
    & AllKpiRunSheetDataFragment
  ) | null };

export type RunInfoInSessionsForDashboardSubscriptionVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RunInfoInSessionsForDashboardSubscription = { runSheetInfoInSessionsUpdated?: { _id?: any | null, info?: string | null } | null };

export type SetupInfoInSessionsForDashboardSubscriptionVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type SetupInfoInSessionsForDashboardSubscription = { carSetupInfoInSessionsUpdated?: { _id?: any | null, setupInfo?: string | null } | null };

export type SetupChangedInSessionsForDashboardSubscriptionVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type SetupChangedInSessionsForDashboardSubscription = { carSetupChangedInSessions?: { _id?: any | null, updatedAt?: any | null } | null };

export type CheckDataUpdatedAtForSimulationPageQueryVariables = Exact<{
  eventIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  runSheetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  runSheetPageSize?: InputMaybe<Scalars['Int']['input']>;
  carSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  carSetupPageSize?: InputMaybe<Scalars['Int']['input']>;
  simResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  simResultPageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CheckDataUpdatedAtForSimulationPageQuery = { sessions?: { items?: Array<{ _id: any, name: string, shortName?: string | null, eventID: any, event?: { name: string } | null }> | null } | null, runSheets?: { items?: Array<{ _id: any, updatedAt?: any | null }> | null } | null, carSetups?: { items?: Array<{ _id: any, updatedAt?: any | null }> | null } | null, simResults?: { items?: Array<{ _id: any, updatedAt?: any | null }> | null } | null };

export type GetUpdatedDataForInitializationForSimulationPageQueryVariables = Exact<{
  runSheetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  runSheetPageSize?: InputMaybe<Scalars['Int']['input']>;
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  carSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  carSetupPageSize?: InputMaybe<Scalars['Int']['input']>;
  simResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  simResultPageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUpdatedDataForInitializationForSimulationPageQuery = { allowedRunSheetsForSelectedSessions?: { items?: Array<RunSheetForEventSelectionVarsFragment> | null } | null, updatedRunSheets?: { items?: Array<GetRunSheetInfoForStagingAreaVarsFragment> | null } | null, carSetups?: { items?: Array<CarSetupInfoForStagingAreaVarsFragment> | null } | null, simResults?: { items?: Array<SimResultInfosForStagingAreaVarsFragment> | null } | null };

export type TimingServiceStatusUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TimingServiceStatusUpdatedSubscription = { timingServiceStatusUpdated?: { _id: any, activeConfigs?: Array<{ declaredSession?: string | null, lastMessage?: any | null, sessionMatchID?: any | null, sessionMatchInfo?: string | null, timingServiceConfigID: any, sessionMatch?: { name: string } | null, timingServiceConfig?: { _id: any, active?: boolean | null, name: string } | null } | null> | null, failedConfigs?: Array<{ message?: string | null, timingServiceConfigID: any, timingServiceConfig?: { _id: any, active?: boolean | null, name: string } | null } | null> | null } | null };

export type GetTimingServiceStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimingServiceStatusQuery = { timingServiceStatus?: { activeConfigs?: Array<{ declaredSession?: string | null, sessionMatchID?: any | null, sessionMatchInfo?: string | null, timingServiceConfigID: any, timingServiceConfig?: { _id: any, active?: boolean | null, name: string } | null } | null> | null, failedConfigs?: Array<{ message?: string | null, timingServiceConfigID: any, timingServiceConfig?: { _id: any, active?: boolean | null, name: string } | null } | null> | null } | null };

export type TyreSet_AddTyreSetMutationVariables = Exact<{
  record: CreateOneTyreSetInput;
}>;


export type TyreSet_AddTyreSetMutation = { addTyreSet?: { recordId?: any | null } | null };

export type TyreSet_AddTyreMutationVariables = Exact<{
  record: CreateOneTyreInput;
}>;


export type TyreSet_AddTyreMutation = { addTyre?: { recordId?: any | null } | null };

export type TyreSet_AddTyresToContestantMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  tyreIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type TyreSet_AddTyresToContestantMutation = { addTyresToContestant?: { success?: boolean | null } | null };

export type TyreSet_AddTyreSetsToContestantMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type TyreSet_AddTyreSetsToContestantMutation = { addTyreSetsToContestant?: { success?: boolean | null } | null };

export type TyreSet_AddTyreSetsToEventContestantMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type TyreSet_AddTyreSetsToEventContestantMutation = { addTyreSetsToEventContestant?: { success?: boolean | null } | null };

export type TyrePool_ForceAddLapMutationVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
  lap: LapInput;
}>;


export type TyrePool_ForceAddLapMutation = { forceAddLap?: { _id: any } | null };

export type Helpers_CreateRaceSeriesMutationVariables = Exact<{
  record: CreateOneRaceSeriesInput;
}>;


export type Helpers_CreateRaceSeriesMutation = { addRaceSeries?: { recordId?: any | null } | null };

export type Helpers_CreateSeasonMutationVariables = Exact<{
  record: CreateOneSeasonInput;
}>;


export type Helpers_CreateSeasonMutation = { addSeason?: { recordId?: any | null } | null };

export type Helpers_CreateEventMutationVariables = Exact<{
  record: CreateOneEventInput;
}>;


export type Helpers_CreateEventMutation = { addEvent?: { recordId?: any | null } | null };

export type Helpers_UpdateEventMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdEventInput;
}>;


export type Helpers_UpdateEventMutation = { updateEvent?: { recordId?: any | null } | null };

export type Helpers_CreateSessionMutationVariables = Exact<{
  record: CreateOneSessionInput;
}>;


export type Helpers_CreateSessionMutation = { addSession?: { recordId?: any | null } | null };

export type Helpers_UpdateSessionMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdSessionInput;
}>;


export type Helpers_UpdateSessionMutation = { updateSession?: { recordId?: any | null } | null };

export type Helpers_CreateContestantMutationVariables = Exact<{
  record: CreateOneContestantInput;
}>;


export type Helpers_CreateContestantMutation = { addContestant?: { recordId?: any | null } | null };

export type Helpers_UpdateContestantMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdContestantInput;
}>;


export type Helpers_UpdateContestantMutation = { updateContestant?: { recordId?: any | null } | null };

export type Helpers_CreateRunSheetMutationVariables = Exact<{
  record: CreateOneRunSheetInput;
}>;


export type Helpers_CreateRunSheetMutation = { addRunSheet?: { recordId?: any | null } | null };

export type Helpers_UpdateRunSheetMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdRunSheetInput;
}>;


export type Helpers_UpdateRunSheetMutation = { updateRunSheet?: { recordId?: any | null } | null };

export type Helpers_CreateRunSheetStyleMutationVariables = Exact<{
  record: CreateOneRunSheetStyleInput;
}>;


export type Helpers_CreateRunSheetStyleMutation = { addRunSheetStyle?: { recordId?: any | null } | null };

export type Helpers_UpdateteRunSheetStyleMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdRunSheetStyleInput;
}>;


export type Helpers_UpdateteRunSheetStyleMutation = { updateRunSheetStyle?: { recordId?: any | null } | null };

export type Helpers_CreateTrackMutationVariables = Exact<{
  record: CreateOneTrackInput;
}>;


export type Helpers_CreateTrackMutation = { addTrack?: { recordId?: any | null } | null };

export type Helpers_CreateTrackLayoutMutationVariables = Exact<{
  record: CreateOneTrackLayoutInput;
}>;


export type Helpers_CreateTrackLayoutMutation = { addTrackLayout?: { recordId?: any | null } | null };

export type Helpers_CreateJobMutationVariables = Exact<{
  record: CreateOneJobInput;
  target: EnumJobTarget;
}>;


export type Helpers_CreateJobMutation = { addJob?: { recordId?: any | null } | null };

export type Helpers_CreateJobListTemplateMutationVariables = Exact<{
  record: CreateOneTemplateJobListInput;
}>;


export type Helpers_CreateJobListTemplateMutation = { addTemplateJobList?: { recordId?: any | null } | null };

export type Helpers_AddCommentMutationVariables = Exact<{
  target: EnumJobTarget;
  subjectID: Scalars['MongoID']['input'];
  text: Scalars['String']['input'];
}>;


export type Helpers_AddCommentMutation = { addComment?: { comment?: { _id?: any | null } | null } | null };

export type Helpers_UpdateCommentMutationVariables = Exact<{
  target: EnumJobTarget;
  subjectID: Scalars['MongoID']['input'];
  commentID: Scalars['MongoID']['input'];
  text: Scalars['String']['input'];
}>;


export type Helpers_UpdateCommentMutation = { updateComment?: { comment?: { _id?: any | null, text?: string | null } | null } | null };

export type Helpers_ManageJobMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  action: JobAction;
  target: EnumJobTarget;
}>;


export type Helpers_ManageJobMutation = { manageJob: { _id: any } };

export type Helpers_RemoveJobMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  target: EnumJobTarget;
}>;


export type Helpers_RemoveJobMutation = { removeJob?: { recordId?: any | null } | null };

export type Helpers_CreateRunPlanMutationVariables = Exact<{
  record: CreateOneRunPlanInput;
}>;


export type Helpers_CreateRunPlanMutation = { addRunPlan?: { recordId?: any | null } | null };

export type Helpers_AddRunToRunPlanMutationVariables = Exact<{
  runPlanID: Scalars['MongoID']['input'];
  runs: Array<InputMaybe<RunPlanRunInput>> | InputMaybe<RunPlanRunInput>;
}>;


export type Helpers_AddRunToRunPlanMutation = { addRunToRunPlan?: { _id: any, runs: Array<{ NRun: number } | null> } | null };

export type Helpers_CreateCarSetupMutationVariables = Exact<{
  record: CreateOneCarSetupInput;
}>;


export type Helpers_CreateCarSetupMutation = { addCarSetup?: { recordId?: any | null } | null };

export type Helpers_UpdateCarSetupMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdCarSetupInput;
}>;


export type Helpers_UpdateCarSetupMutation = { updateCarSetup?: { recordId?: any | null } | null };

export type Helpers_CreateChassisMutationVariables = Exact<{
  record: CreateOneChassisInput;
}>;


export type Helpers_CreateChassisMutation = { addChassis?: { recordId?: any | null } | null };

export type Helpers_CreateChassisSpecMutationVariables = Exact<{
  record: CreateOneSpecificationInput;
}>;


export type Helpers_CreateChassisSpecMutation = { addSpecification?: { recordId?: any | null } | null };

export type Helpers_UpdateMeMutationVariables = Exact<{
  record: UpdateMeInput;
}>;


export type Helpers_UpdateMeMutation = { updateMe?: { recordId?: any | null } | null };

export type Helpers_GetPersonQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type Helpers_GetPersonQuery = { person?: { _id: any, userSetupIDs?: Array<any | null> | null, username: string } | null };

export type Helpers_GetCurrentUserIdQueryVariables = Exact<{ [key: string]: never; }>;


export type Helpers_GetCurrentUserIdQuery = { whoami: { person: { _id: any } } };

export type Helpers_CreatePersonMutationVariables = Exact<{
  record: CreateOnePersonInput;
}>;


export type Helpers_CreatePersonMutation = { addPerson?: { recordId?: any | null } | null };

export type Helpers_CreateTestUserMutationVariables = Exact<{
  record: CreateOnePersonInput;
}>;


export type Helpers_CreateTestUserMutation = { addTestUser?: { recordId?: any | null } | null };

export type Helpers_UpdatePersonMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdPersonInput;
}>;


export type Helpers_UpdatePersonMutation = { updatePerson?: { recordId?: any | null } | null };

export type Helpers_CreateProjectMutationVariables = Exact<{
  record: CreateOneProjectInput;
}>;


export type Helpers_CreateProjectMutation = { addProject?: { recordId?: any | null } | null };

export type Helpers_CreateOneTimeSheetEntryMutationVariables = Exact<{
  record: CreateOneTimeSheetEntryInput;
}>;


export type Helpers_CreateOneTimeSheetEntryMutation = { addTimeSheetEntry?: { recordId?: any | null } | null };

export type Helpers_CreatePartMutationVariables = Exact<{
  record: CreateOnePartInput;
}>;


export type Helpers_CreatePartMutation = { addPart?: { recordId?: any | null } | null };

export type Helpers_CreatePartInstanceMutationVariables = Exact<{
  record: CreateOnePartInstanceInput;
}>;


export type Helpers_CreatePartInstanceMutation = { addPartInstance?: { recordId?: any | null } | null };

export type Helpers_CreateAssemblyMutationVariables = Exact<{
  record: CreateOneAssemblyInput;
}>;


export type Helpers_CreateAssemblyMutation = { addAssembly?: { recordId?: any | null } | null };

export type Helpers_UpdateAssemblyMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdAssemblyInput;
}>;


export type Helpers_UpdateAssemblyMutation = { updateAssembly?: { recordId?: any | null } | null };

export type Helpers_CreateSpecificationMutationVariables = Exact<{
  record: CreateOneSpecificationInput;
}>;


export type Helpers_CreateSpecificationMutation = { addSpecification?: { recordId?: any | null } | null };

export type Helpers_UpdateSpecificationMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdSpecificationInput;
  currentChassisSpecID: Scalars['MongoID']['input'];
}>;


export type Helpers_UpdateSpecificationMutation = { updateSpecification?: { recordId?: any | null } | null };

export type Helpers_UpdatePartMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdPartInput;
}>;


export type Helpers_UpdatePartMutation = { updatePart?: { recordId?: any | null } | null };

export type Helpers_CreateUserEnumMutationVariables = Exact<{
  record: CreateOneUserEnumInput;
}>;


export type Helpers_CreateUserEnumMutation = { addUserEnum?: { recordId?: any | null } | null };

export type Helpers_UpdateUserEnumMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdUserEnumInput;
}>;


export type Helpers_UpdateUserEnumMutation = { updateUserEnum?: { recordId?: any | null } | null };

export type Helpers_CreateSetupSheetStyleMutationVariables = Exact<{
  record: CreateOneSetupSheetStyleInput;
}>;


export type Helpers_CreateSetupSheetStyleMutation = { addSetupSheetStyle?: { recordId?: any | null } | null };

export type Helpers_ReleaseChassiSpecMutationVariables = Exact<{
  chassisSpecID: Scalars['MongoID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type Helpers_ReleaseChassiSpecMutation = { releaseChassisSpec?: { releasedChassisSpec?: { _id?: any | null } | null, iteratedChassisSpec?: { _id?: any | null } | null } | null };

export type Helpers_AddNewPersonMutationVariables = Exact<{
  record: CreateOnePersonInput;
}>;


export type Helpers_AddNewPersonMutation = { addPerson?: { recordId?: any | null } | null };

export type Helpers_ResetPasswordMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type Helpers_ResetPasswordMutation = { resetPassword?: { password: string } | null };

export type Helpers_SetPasswordMutationVariables = Exact<{
  username: Scalars['String']['input'];
  temporaryPassword: Scalars['String']['input'];
}>;


export type Helpers_SetPasswordMutation = { setPassword?: { success: boolean } | null };

export type Helpers_AddTimingServiceConfigMutationVariables = Exact<{
  record: CreateOneTimingServiceConfigInput;
}>;


export type Helpers_AddTimingServiceConfigMutation = { addTimingServiceConfig?: { recordId?: any | null } | null };

export type Helpers_CreatePointsSystemMutationVariables = Exact<{
  record: CreateOnePointsSystemInput;
}>;


export type Helpers_CreatePointsSystemMutation = { addPointsSystem?: { recordId?: any | null } | null };

export type Helpers_UpdatePointsSystemMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdPointsSystemInput;
}>;


export type Helpers_UpdatePointsSystemMutation = { updatePointsSystem?: { recordId?: any | null } | null };

export type Helpers_LoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type Helpers_LoginMutation = { login?: { token: string } | null };

export type Helpers_RunPlansFilterQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyRunPlanInput>;
}>;


export type Helpers_RunPlansFilterQuery = { runPlans?: { items?: Array<{ _id: any, trackLayout?: { lapLengthCarData?: number | null, lapLengthOfficial?: number | null } | null }> | null } | null };

export type Helpers_AddDepartmentMutationVariables = Exact<{
  record: CreateOneDepartmentInput;
}>;


export type Helpers_AddDepartmentMutation = { addDepartment?: { recordId?: any | null } | null };

export type Helpers_AddTagMutationVariables = Exact<{
  record: CreateOneTagInput;
}>;


export type Helpers_AddTagMutation = { addTag?: { recordId?: any | null } | null };

export type Helpers_AddIssueMutationVariables = Exact<{
  record: CreateOneIssueInput;
}>;


export type Helpers_AddIssueMutation = { addIssue?: { recordId?: any | null } | null };

export type Helpers_SetupTimingServiceStatusMutationVariables = Exact<{ [key: string]: never; }>;


export type Helpers_SetupTimingServiceStatusMutation = { applyMigration?: { success: boolean } | null };

export type Helpers_ResetTimingServiceStatusMutationVariables = Exact<{ [key: string]: never; }>;


export type Helpers_ResetTimingServiceStatusMutation = { updateMigrations?: { success: boolean } | null };

export type Helpers_AddLapSequenceMutationVariables = Exact<{
  record: CreateOneLapSequenceInput;
}>;


export type Helpers_AddLapSequenceMutation = { addLapSequence?: { recordId?: any | null } | null };

export type Helpers_CreateTeamMutationVariables = Exact<{
  record: CreateOneTeamInput;
}>;


export type Helpers_CreateTeamMutation = { addTeam?: { recordId?: any | null } | null };

export type FixPartTrackingHistoryMutationVariables = Exact<{
  partID: Scalars['MongoID']['input'];
}>;


export type FixPartTrackingHistoryMutation = { fixPartTrackingHistory?: { removedRecords?: number | null } | null };

export type SetupAssemblyLinkingQueryVariables = Exact<{ [key: string]: never; }>;


export type SetupAssemblyLinkingQuery = { carSetups?: { items?: Array<{ _id: any, chassisAssemblyID?: any | null, title: string, chassisAssembly?: { _id?: any | null, carSetupID?: any | null, reference?: string | null, name: string } | null, runSheet?: RunSheetForAssemblyLinkingVarsFragment | null }> | null } | null };

export type RunSheetForAssemblyLinkingVarsFragment = { _id: any, info?: string | null, NRunTiming?: number | null, contestant?: { startNumber: string } | null, session?: { _id: any, shortName?: string | null, event?: { _id: any, name: string, season?: { name: string, raceSeries?: { name: string } | null } | null } | null } | null };

export type ChassisAssembliesWithTrackingSourceQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChassisAssembliesWithTrackingSourceQuery = { assemblies?: { items?: Array<{ _id?: any | null, carSetupID?: any | null, chassisSpecID?: any | null, name: string, reference?: string | null, trackingSourceRecords?: Array<{ trackingSourceID?: any | null, trackingSource?: { name: string } | null } | null> | null } | {}> | null } | null };

export type GetSetupSheetMetadataForAssembyReferenceFixQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSetupSheetMetadataForAssembyReferenceFixQuery = { carSetup?: { _id: any, runSheetID?: any | null, runSheet?: { NRunTiming?: number | null, NRun?: number | null, info?: string | null, contestant?: { startNumber: string } | null, session?: { shortName?: string | null, event?: { name: string, season?: { name: string, raceSeries?: { name: string } | null } | null } | null } | null } | null } | null };

export type PartsForDataCheckPageQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PartsForDataCheckPageQuery = { parts?: { items?: Array<{ _id: any, reference: string, trackingHistoryIDs?: Array<any | null> | null, specification?: { trackingItemIDs?: Array<any | null> | null } | null, trackingHistory: Array<{ _id: any, chassisAssemblyID?: any | null, trackingItemID?: any | null, trackingItem?: { name: string } | null }> }> | null } | null };

export type GetPartInstancesForDataCheckPageQueryVariables = Exact<{
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetPartInstancesForDataCheckPageQuery = { partInstances?: { items?: Array<{ _id: any, parentID?: any | null, superParentID?: any | null, parent?: { createdAt?: any | null, name: string, reference?: string | null, updatedAt?: any | null } | { createdAt?: any | null, name: string, reference?: string | null, updatedAt?: any | null } | null }> | null } | null, trackingItems?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type FixPartInstancesMutationVariables = Exact<{
  partIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type FixPartInstancesMutation = { fixPartInstancesResolver?: { success?: boolean | null } | null };

export type GetAllTrackingHistoryEntriesForDataCheckPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTrackingHistoryEntriesForDataCheckPageQuery = { trackingRecords?: { items?: Array<{ _id: any }> | null } | null };

export type GetInconsitentChassisAssembliesForDataCheckPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInconsitentChassisAssembliesForDataCheckPageQuery = { assemblies?: { items?: Array<ChassisAssemblyForDataCheckPageVarsFragment | {}> | null } | null };

export type ChassisAssemblyForDataCheckPageVarsFragment = { _id?: any | null, reference?: string | null, carSetupID?: any | null, carSetup?: { runSheetID?: any | null, runSheet?: { chassisAssemblyID?: any | null, setupID?: any | null, NRun?: number | null, NRunTiming?: number | null, contestant?: { startNumber: string } | null, session?: { name: string, shortName?: string | null, event?: { name: string, season?: { name: string, raceSeries?: { name: string } | null } | null } | null } | null } | null } | null };

export type GetInconsitentCarSetupsForDataCheckPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInconsitentCarSetupsForDataCheckPageQuery = { carSetups?: { items?: Array<{ _id: any, runSheetID?: any | null, title: string, runSheet?: { _id: any, NRun?: number | null, NRunTiming?: number | null, setupID?: any | null, contestant?: { startNumber: string } | null, session?: { shortName?: string | null, name: string, event?: { name: string, season?: { name: string, raceSeries?: { name: string } | null } | null } | null } | null } | null }> | null } | null };

export type GetAllTeamsForImportIssueQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTeamsForImportIssueQuery = { teams?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetIssuesForIssueManagerPageQueryVariables = Exact<{
  filter: FilterFindManyIssueQueryInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIssueQueryInput>;
}>;


export type GetIssuesForIssueManagerPageQuery = { issues?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<IssuesForIssueManagerPageVarsFragment> | null } | null };

export type IssuesForIssueManagerPageVarsFragment = { _id: any, area?: string | null, carSetupID?: any | null, containment?: string | null, createdAt?: any | null, description: string, eventID?: any | null, index?: number | null, issueStatus?: EnumIssueQueryIssueStatus | null, number?: string | null, oneWordStatus: IssueStatus, priority?: EnumIssueQueryPriority | null, raceSeriesID?: any | null, rootCause?: string | null, runSheetID?: any | null, seasonID?: any | null, sessionID?: any | null, targetDate?: any | null, timeInfo?: string | null, updatedAt?: any | null, assignees: Array<{ _id: any, name: string }>, createdBy?: { name: string } | null, department?: { name: string } | null, event?: { name: string } | null, raceSeries?: { name: string } | null, season?: { name: string } | null, session?: { name: string } | null, tags: Array<{ _id: any, label: string }>, teams: Array<{ name: string }> };

export type GetIssueByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetIssueByIdQuery = { issue?: { _id: any, carSetupID?: any | null, assigneeIDs?: Array<any | null> | null, area?: string | null, category?: string | null, closedAt?: any | null, closedByID?: any | null, containment?: string | null, contestantIDs?: Array<any | null> | null, createdAt?: any | null, createdByID?: any | null, description: string, descriptionDetails?: string | null, departmentID?: any | null, eventID?: any | null, linkedIssueIDs?: Array<any | null> | null, number?: string | null, issueStatus?: EnumIssueQueryIssueStatus | null, partID?: any | null, priority?: EnumIssueQueryPriority | null, raceSeriesID?: any | null, rootCause?: string | null, runSheetID?: any | null, seasonID?: any | null, sessionID?: any | null, subTaskIDs?: Array<any | null> | null, targetDate?: any | null, tagIDs?: Array<any | null> | null, teamIDs?: Array<any | null> | null, thirdPartyIssueID?: any | null, timeInfo?: string | null, comments?: Array<{ text?: string | null, createdAt?: any | null, updatedAt?: any | null, authorID?: any | null, _id?: any | null, author?: { name: string } | null, files: Array<{ id: string, name?: string | null, mimeType: string, url: string, thumbnailUrl: string } | null> } | null> | null, subTasks: Array<JobVarsFragment> } | null };

export type GetIssueForIssuePopupQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetIssueForIssuePopupQuery = { issue?: { _id: any, containment?: string | null, description: string, number?: string | null, rootCause?: string | null, runSheet?: { info?: string | null, setup?: { chassis?: { reference?: string | null } | null } | null } | null } | null };

export type GetFilterInfosForIssueManagerPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilterInfosForIssueManagerPageQuery = { raceSeriesAll?: { items?: Array<{ _id: any, name: string, seasons: Array<{ _id: any, name: string, events: Array<{ _id: any, name: string, sessions: Array<{ _id: any, shortName?: string | null }> }> }> }> | null } | null, people?: { items?: Array<{ _id: any, name: string }> | null } | null, carSetups?: { items?: Array<{ _id: any, title: string }> | null } | null, tags?: { items?: Array<{ _id: any, label: string }> | null } | null, chassisSpecifications?: { items?: Array<{ _id?: any | null, name: string, version?: string | null } | {}> | null } | null, customSpecifications?: { items?: Array<{ _id?: any | null, chassisSpecID?: any | null, name: string } | {}> | null } | null };

export type GetPartsFilteredBySpecificationsQueryVariables = Exact<{
  specificationIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GetPartsFilteredBySpecificationsQuery = { parts?: { items?: Array<{ _id: any, reference: string }> | null } | null };

export type GetAllInfoForIssueCreateAndEditPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInfoForIssueCreateAndEditPageQuery = { raceSeriesAll?: { items?: Array<{ _id: any, name: string, seasons: Array<{ _id: any, name: string, contestants: Array<{ _id: any, startNumber: string }>, events: Array<{ _id: any, name: string, tEventStart?: any | null, sessions: Array<{ _id: any, shortName?: string | null, name: string }> }> }> }> | null } | null, teams?: { items?: Array<{ _id: any, name: string }> | null } | null, carSetups?: { items?: Array<{ _id: any, title: string }> | null } | null };

export type GetPartInfoForIssueManagerQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPartInfoForIssueManagerQuery = { part?: { userEnumPartTypeID?: any | null, manufacturerSerialNumber?: string | null, lifetimeMileage?: number | null, partNumber?: string | null, reference: string, specification?: { name: string, type: EnumSpecificationType } | null, userEnumPartType?: { _id?: any | null, name: string, type: EnumUserEnumPartTypeType } | null } | null };

export type GetRunSheetInfoForIssueManagerPageQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyRunSheetInput>;
}>;


export type GetRunSheetInfoForIssueManagerPageQuery = { runSheets?: { items?: Array<{ NRun?: number | null, _id: any, driver?: { name: string } | null, chassisAssembly?: { name: string, chassisSpecID?: any | null } | null, session?: { name: string, shortName?: string | null } | null, contestant?: { startNumber: string } | null }> | null } | null };

export type GetRunSheetByIdForIssueManagerQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetByIdForIssueManagerQuery = { runSheet?: { info?: string | null, NRun?: number | null, _id: any, driverComments?: string | null, engineerComments?: string | null, problemComments?: string | null, driver?: { name: string } | null, engineer?: { name: string } | null, chassisAssembly?: { name: string } | null, session?: { name: string, shortName?: string | null } | null, contestant?: { startNumber: string } | null, setup?: { title: string, engineer?: { name: string } | null, chassis?: { reference?: string | null } | null, chassisSpec?: { name: string } | null } | null } | null };

export type GetRunSheetChassisSpecIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetChassisSpecIdQuery = { runSheet?: { setup?: { _id: any, chassisSpecID?: any | null } | null } | null };

export type AddIssueCommentMutationVariables = Exact<{
  target: EnumJobTarget;
  subjectID: Scalars['MongoID']['input'];
  text: Scalars['String']['input'];
}>;


export type AddIssueCommentMutation = { addComment?: { comment?: { _id?: any | null } | null } | null };

export type RemoveIssueCommentMutationVariables = Exact<{
  commentId: Scalars['MongoID']['input'];
  subjectId: Scalars['MongoID']['input'];
}>;


export type RemoveIssueCommentMutation = { removeComment?: { comment?: { _id?: any | null } | null } | null };

export type GetTagsForIssuePageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsForIssuePageQuery = { tags?: { items?: Array<{ group?: string | null, _id: any, label: string, tagType?: EnumTagType | null }> | null } | null };

export type GetUserEnumsForPartTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserEnumsForPartTypeQuery = { userEnums?: { items?: Array<{ __typename: 'UserEnumPartStatus', _id?: any | null, active?: boolean | null, name: string } | { __typename: 'UserEnumPartType', _id?: any | null, name: string } | {}> | null } | null };

export type AddTagMutationVariables = Exact<{
  record: CreateOneTagInput;
}>;


export type AddTagMutation = { addTag?: { recordId?: any | null } | null };

export type GenerateIssueNumberQueryVariables = Exact<{
  raceSeriesId?: InputMaybe<Scalars['MongoID']['input']>;
  seasonId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GenerateIssueNumberQuery = { generateIssueNumber: { number?: string | null } };

export type GetTeamListForIssueManagerFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeamListForIssueManagerFilterQuery = { teams?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetPersonListForIssueManagerFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonListForIssueManagerFilterQuery = { people?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetAllJobsForAllJobsPageQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyJobInput>;
  sort?: InputMaybe<SortFindManyJobInput>;
}>;


export type GetAllJobsForAllJobsPageQuery = { jobs?: { count?: number | null, pageInfo: { currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean, pageCount: number }, items?: Array<JobForAllJobsPageVarsFragment> | null } | null };

export type JobForAllJobsPageVarsFragment = { _id: any, acknowledgedAt?: any | null, createdAt?: any | null, closedAt?: any | null, description: string, oneWordStatus: JobStatus, parentID?: any | null, priority?: EnumJobPriority | null, runSheetID?: any | null, subTaskIDs?: Array<any | null> | null, updatedAt?: any | null, acknowledgedBy?: { _id: any, name: string } | null, assignees: Array<{ name: string }>, cancelledBy?: { _id: any, name: string } | null, createdBy?: { _id: any, name: string } | null, comments?: Array<{ _id?: any | null, createdAt?: any | null, updatedAt?: any | null, text?: string | null, author?: { _id: any, name: string } | null } | null> | null, closedBy?: { _id: any, name: string } | null, parentJob?: { __typename: 'Job', _id: any } | null, parentIssue?: { __typename: 'Issue', _id: any, description: string, number?: string | null } | null, runSheet?: { _id: any, NRunTiming?: number | null, contestant?: { startNumber: string } | null, session?: { name: string, shortName?: string | null, event?: { name: string, season?: { name: string, raceSeries?: { name: string } | null } | null } | null } | null } | null, subTasks: Array<SubTaskVarsFragment> };

export type GetFilterInfosForAllJobsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilterInfosForAllJobsPageQuery = { raceSeriesAll?: { items?: Array<{ _id: any, name: string, seasons: Array<{ _id: any, name: string, contestants: Array<{ _id: any, startNumber: string }>, events: Array<{ _id: any, name: string, tEventStart?: any | null, sessions: Array<{ _id: any, shortName?: string | null, name: string }> }> }> }> | null } | null };

export type GetRunSheetIDsForAllJobsPageQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyRunSheetInput>;
}>;


export type GetRunSheetIDsForAllJobsPageQuery = { runSheets?: { items?: Array<{ _id: any }> | null } | null };

export type GetIssueJobParentIDsForIssueFilterQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyJobInput>;
}>;


export type GetIssueJobParentIDsForIssueFilterQuery = { jobs?: { items?: Array<{ _id: any, parentID?: any | null }> | null } | null };

export type GetIssuesForFilterQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyIssueQueryInput>;
}>;


export type GetIssuesForFilterQuery = { issues?: { items?: Array<{ _id: any, description: string, number?: string | null }> | null } | null };

export type GetPartInstanceByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPartInstanceByIdQuery = { partInstance?: { _id: any, superParentID?: any | null, parentID?: any | null, partID?: any | null, specificationID?: any | null, parent?: { name: string } | { name: string } | null, measurements?: Array<{ booleanValue?: boolean | null, idx?: number | null, stringValue?: string | null, value?: number | null, coordinates?: { x?: number | null, y?: number | null, z?: number | null } | null, rotation?: { I?: number | null, J?: number | null, K?: number | null } | null } | null> | null, specification?: { __typename: 'CustomSpec', _id?: any | null, updatedAt?: any | null, createdAt?: any | null, name: string, decommissioned?: boolean | null, prevIterationID?: any | null, nextIterationID?: any | null, iterationIDs?: Array<any | null> | null, allowableParentSpecIDs?: Array<any | null> | null, chassisSpecID?: any | null, initialChassisSpecID?: any | null, description?: string | null, allowableSockets?: Array<string | null> | null, readingsRequired?: EnumCustomSpecReadingsRequired | null, manufacturerID?: any | null, manufacturer: Array<{ _id: any, name?: string | null } | null>, adjustableProperties?: Array<AdjustableAccelerationPropertyVarsFragment | AdjustableAnglePropertyVarsFragment | AdjustableAngularCompliancePropertyVarsFragment | AdjustableAngularTorqueCompliancePropertyVarsFragment | AdjustableBooleanPropertyVarsFragment | AdjustableCompliancePropertyVarsFragment | AdjustableForcePropertyVarsFragment | AdjustableInertiaPropertyVarsFragment | AdjustableLengthPropertyVarsFragment | AdjustableLocationPropertyVarsFragment | AdjustableMassPropertyVarsFragment | AdjustableNumberPropertyVarsFragment | AdjustableOrientationPropertyVarsFragment | AdjustablePowerPropertyVarsFragment | AdjustablePressurePropertyVarsFragment | AdjustableRatioPropertyVarsFragment | AdjustableSpringRatePropertyVarsFragment | AdjustableSteeringRackRatioPropertyVarsFragment | AdjustableStringPropertyVarsFragment | AdjustableTemperaturePropertyVarsFragment | AdjustableTorquePropertyVarsFragment | AdjustableTorsionRatePropertyVarsFragment | AdjustableVolumePropertyVarsFragment | null> | null, massProperties?: MassPropertiesVarsFragment | null } | {} | null } | null };

export type GetTrackingSourceRecordsOnSuperParentForPartInstancePageQueryVariables = Exact<{
  assemblyID: Scalars['MongoID']['input'];
}>;


export type GetTrackingSourceRecordsOnSuperParentForPartInstancePageQuery = { assembly?: { _id?: any | null, chassisSpecID?: any | null, name: string, trackingSourceRecords?: Array<{ trackingSourceID?: any | null, value?: number | null, trackingSource?: { _id: any, chassisSpecID: any, isDefault?: boolean | null, name: string, sourceIDs?: Array<any | null> | null, sources: Array<{ _id: any, aliasString?: string | null, aliasType?: EnumTrackingSourceAliasAliasType | null, displayUnit?: EnumDisplayUnit | null }> } | null, sources?: Array<{ trackingSourceAliasID?: any | null, value?: number | null } | null> | null } | null> | null } | {} | null };

export type GetTrackingSourcesOnChassisSpecForPartInstancePageQueryVariables = Exact<{
  chassisSpecID: Scalars['MongoID']['input'];
}>;


export type GetTrackingSourcesOnChassisSpecForPartInstancePageQuery = { specification?: { name: string, trackingSourceIDs?: Array<any | null> | null, trackingSources: Array<{ _id: any, name: string }> } | {} | null };

export type GetPartInstanceParentByIdForPartInstancePageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPartInstanceParentByIdForPartInstancePageQuery = { assembly?: { _id?: any | null } | { _id?: any | null } | null };

export type GetTrackingRecordsForPartQueryVariables = Exact<{
  chassisAssemblyID: Scalars['MongoID']['input'];
  partID: Scalars['MongoID']['input'];
}>;


export type GetTrackingRecordsForPartQuery = { trackingRecords?: { items?: Array<{ _id: any, date?: any | null, createdAt?: any | null, value?: number | null, type?: EnumTrackingRecordType | null, partID?: any | null, chassisAssemblyID?: any | null, notes?: string | null, cumulativeValue?: number | null, trackingItemID?: any | null }> | null } | null };

export type GetChassisSpecsForPartDetailFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChassisSpecsForPartDetailFieldsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string, rootSpecificationID: any, prevIterationID?: any | null, version?: string | null } | {}> | null } | null };

export type GetPartSpecsForChassisSpecForPartDetailFieldsQueryVariables = Exact<{
  chassisSpecID: Scalars['MongoID']['input'];
}>;


export type GetPartSpecsForChassisSpecForPartDetailFieldsQuery = { specifications?: { items?: Array<{ __typename: 'AeroElementSpec', _id?: any | null, name: string } | { __typename: 'AeroPackageSpec', _id?: any | null, name: string } | { __typename: 'AntiRollBarSpec', _id?: any | null, name: string } | { __typename: 'ChassisSpec', _id?: any | null, name: string } | { __typename: 'CustomSpec', _id?: any | null, name: string } | { __typename: 'DamperSpec', _id?: any | null, name: string } | { __typename: 'DifferentialSpec', _id?: any | null, name: string } | { __typename: 'ElasticSpec', _id?: any | null, name: string } | { __typename: 'GearBoxSpec', _id?: any | null, name: string } | { __typename: 'GearSpec', _id?: any | null, name: string } | { __typename: 'KinematicsExternalSpec', _id?: any | null, name: string } | { __typename: 'KinematicsInternalSpec', _id?: any | null, name: string }> | null } | null };

export type GetChassisSpecForPartSpecInfoFieldQueryVariables = Exact<{
  chassisSpecID: Scalars['MongoID']['input'];
}>;


export type GetChassisSpecForPartSpecInfoFieldQuery = { specification?: { _id?: any | null, name: string, version?: string | null } | {} | null };

export type PartEditSpecificationQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PartEditSpecificationQuery = { specification?: { name: string, version?: string | null } | {} | null };

export type GetLifetimeMileageForPartQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetLifetimeMileageForPartQuery = { part?: { lifetimeMileage?: number | null } | null };

export type CopyPartFormQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CopyPartFormQuery = { part?: { __typename: 'Part', _id: any, description?: string | null, displayName?: string | null, eligibleEventTypes?: EnumPartEligibleEventTypes | null, locationID?: any | null, manufacturerID?: any | null, manufacturerPartID?: string | null, manufacturerSerialNumber?: string | null, notes?: string | null, partNumber?: string | null, properties?: any | null, reference: string, specificationID?: any | null, tagIDs?: Array<any | null> | null, teamIDs?: Array<any | null> | null, userEnumPartTypeID?: any | null, partStatus?: { userEnumPartStatusID?: any | null } | null, specification?: SpecificationVars_BaseSpecification_Fragment | null } | null };

type SpecificationVars_AeroElementSpec_Fragment = { name: string };

type SpecificationVars_AeroPackageSpec_Fragment = { name: string };

type SpecificationVars_AntiRollBarSpec_Fragment = { name: string };

type SpecificationVars_BaseSpecification_Fragment = { name: string };

type SpecificationVars_ChassisSpec_Fragment = { name: string };

type SpecificationVars_CustomSpec_Fragment = { name: string };

type SpecificationVars_DamperSpec_Fragment = { name: string };

type SpecificationVars_DifferentialSpec_Fragment = { name: string };

type SpecificationVars_ElasticSpec_Fragment = { name: string };

type SpecificationVars_GearBoxSpec_Fragment = { name: string };

type SpecificationVars_GearSpec_Fragment = { name: string };

type SpecificationVars_KinematicsExternalSpec_Fragment = { name: string };

type SpecificationVars_KinematicsInternalSpec_Fragment = { name: string };

export type SpecificationVarsFragment = SpecificationVars_AeroElementSpec_Fragment | SpecificationVars_AeroPackageSpec_Fragment | SpecificationVars_AntiRollBarSpec_Fragment | SpecificationVars_BaseSpecification_Fragment | SpecificationVars_ChassisSpec_Fragment | SpecificationVars_CustomSpec_Fragment | SpecificationVars_DamperSpec_Fragment | SpecificationVars_DifferentialSpec_Fragment | SpecificationVars_ElasticSpec_Fragment | SpecificationVars_GearBoxSpec_Fragment | SpecificationVars_GearSpec_Fragment | SpecificationVars_KinematicsExternalSpec_Fragment | SpecificationVars_KinematicsInternalSpec_Fragment;

export type GetTrackingItemNamesForPartEditPageQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetTrackingItemNamesForPartEditPageQuery = { trackingItems?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type RegenerateAssemblyTrackingMutationVariables = Exact<{
  chassisAssemblyIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RegenerateAssemblyTrackingMutation = { fixAssemblyTracking?: { deletedCount: number } | null };

export type PartFieldsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PartFieldsQuery = { specification?: PartFieldVarsFragment | {} | null };

export type PartFieldVarsFragment = { __typename: 'ChassisSpec', _id?: any | null, name: string };

export type GetPartInstancesForPartModalQueryVariables = Exact<{
  partID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetPartInstancesForPartModalQuery = { partInstances?: { items?: Array<{ _id: any, parentID?: any | null, superParentID?: any | null, parent?: { _id?: any | null, createdAt?: any | null, name: string, reference?: string | null, updatedAt?: any | null } | { _id?: any | null, createdAt?: any | null, name: string, reference?: string | null, updatedAt?: any | null } | null }> | null } | null };

export type GetAssemblyMetaInfoForPartModalQueryVariables = Exact<{
  chassisAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetAssemblyMetaInfoForPartModalQuery = { carSetups?: { items?: Array<CarSetupMetaInfosForChassisAssemblyFragment> | null } | null };

export type CarSetupMetaInfosForChassisAssemblyFragment = { _id: any, chassisAssemblyID?: any | null, title: string, runSheet?: { _id: any, NRun?: number | null, session?: { name: string, shortName?: string | null, event?: { name: string } | null } | null } | null };

export type GetUnitsForPartTrackingMeasurementRecordQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetUnitsForPartTrackingMeasurementRecordQuery = { specification?: { measurements?: { angles?: EnumAngleUnit | null, lengths?: EnumLengthUnit | null } | null } | {} | null };

export type GetPartInstancesForPartTrackingSourceRecordsPageQueryVariables = Exact<{
  partID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetPartInstancesForPartTrackingSourceRecordsPageQuery = { partInstances?: { items?: Array<{ superParentID?: any | null }> | null } | null };

export type GetChassisAssembliesForPartTrackingSourceRecordsPageQueryVariables = Exact<{
  chassisAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetChassisAssembliesForPartTrackingSourceRecordsPageQuery = { assemblies?: { items?: Array<ChassisAssemblyVarsForTrackingSourceRecordPageFragment | {}> | null } | null };

export type ChassisAssemblyVarsForTrackingSourceRecordPageFragment = { _id?: any | null, carSetupID?: any | null, name: string, reference?: string | null, carSetup?: { _id: any, title: string, runSheet?: { _id: any, startTime?: any | null, startTimeLTS?: any | null, startTimeManual?: any | null, NRun?: number | null, contestant?: { startNumber: string } | null, session?: { _id: any, shortName?: string | null, tSessionStart?: any | null, tSessionEnd?: any | null, event?: { _id: any, name: string, tEventStart?: any | null, tEventEnd?: any | null, season?: { _id: any, name: string, raceSeries?: { _id: any, name: string } | null } | null } | null } | null } | null } | null, trackingSourceRecords?: Array<{ trackingSourceID?: any | null, value?: number | null, sources?: Array<{ trackingSourceAliasID?: any | null, value?: number | null } | null> | null, trackingSource?: { _id: any, chassisSpecID: any, isDefault?: boolean | null, name: string, sourceIDs?: Array<any | null> | null, sources: Array<{ _id: any, aliasString?: string | null, aliasType?: EnumTrackingSourceAliasAliasType | null, displayUnit?: EnumDisplayUnit | null, priority?: number | null }> } | null } | null> | null };

export type GetTrackingMeasurementRecordListQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTrackingMeasurementRecordListQuery = { part?: { trackingMeasurementHistory: Array<{ _id: any, date?: any | null, trackingMeasurementID?: any | null, assembly?: { name: string } | null, coordinates?: { x?: number | null, y?: number | null, z?: number | null } | null, rotation?: { I?: number | null, J?: number | null, K?: number | null } | null, trackingMeasurement?: { _id: any, name: string, displayName?: string | null, description?: string | null, useInSimulation?: boolean | null } | null }> } | null };

export type GetTrackingRecordIdForEditTrackingRecordModalQueryVariables = Exact<{
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetTrackingRecordIdForEditTrackingRecordModalQuery = { trackingRecords?: { items?: Array<{ _id: any, chassisAssemblyID?: any | null, cumulativeValue?: number | null, dateResolved?: any | null, notes?: string | null, reset?: boolean | null, trackingItemID?: any | null, type?: EnumTrackingRecordType | null, value?: number | null, forceTable?: { acceleration?: Array<number | null> | null, dampingForce?: Array<number | null> | null, force?: Array<number | null> | null, inertanceForce?: Array<number | null> | null, velocity?: Array<number | null> | null, x?: Array<number | null> | null, xMin?: number | null, xMax?: number | null } | null }> | null } | null };

export type RegeneratePartTrackingHistoryMutationVariables = Exact<{
  partIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RegeneratePartTrackingHistoryMutation = { regeneratePartTrackingHistory?: { updatedRecords?: number | null } | null };

export type GetPartStatusUserEnumsForPartsEditQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartStatusUserEnumsForPartsEditQuery = { userEnums?: { items?: Array<PartStatusEnumForPartEditPageVarsFragment | {}> | null } | null };

export type PartStatusEnumForPartEditPageVarsFragment = { _id?: any | null, name: string };

export type SetSpecificationFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type SetSpecificationFieldsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string, version?: string | null } | {}> | null } | null };

export type GetDataOverviewPartsQueryVariables = Exact<{
  filter: FilterFindManyPartInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPartInput>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  specTypes?: InputMaybe<Array<InputMaybe<EnumSpecificationType>> | InputMaybe<EnumSpecificationType>>;
  hideDummyParts?: InputMaybe<Scalars['Boolean']['input']>;
  partReference?: InputMaybe<Scalars['String']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  partType?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturerIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  specName?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eligibleEventTypes?: InputMaybe<Array<InputMaybe<EnumPartEligibleEventTypes>> | InputMaybe<EnumPartEligibleEventTypes>>;
  userEnumPartStatusActive?: InputMaybe<Scalars['Boolean']['input']>;
  mileageMin?: InputMaybe<Scalars['Float']['input']>;
  mileageMax?: InputMaybe<Scalars['Float']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  locationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetDataOverviewPartsQuery = { partsAdvancedFilter?: { count: number, pageInfo?: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean } | null, items?: Array<PartOverviewItemFragment | null> | null } | null };

export type PartOverviewItemFragment = { _id: any, chassisSpecName?: string | null, description?: string | null, displayName?: string | null, eligibleEventTypes?: EnumPartEligibleEventTypes | null, lifetimeMileage?: number | null, manufacturerPartID?: string | null, manufacturerSerialNumber?: string | null, partNumber?: string | null, reference: string, location?: { name: string } | null, manufacturer?: { _id: any, name?: string | null } | null, partStatus?: { userEnumPartStatusName?: string | null, userEnumPartStatus?: { active?: boolean | null, name: string } | null } | null, specification?: { type: EnumSpecificationType, _id: any, name: string, chassisSpecID?: any | null } | null, team?: { name: string } | null, teams: Array<{ name: string }>, userEnumPartType?: { name: string } | null };

export type GetMileageOverviewPartQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetMileageOverviewPartQuery = { part?: { trackingHistoryIDs?: Array<any | null> | null, trackingHistory: Array<AllTrackingHistoryVarsFragment>, trackingHistoryFullAndSnapshot?: { trackingHistoryFull?: Array<AllTrackingHistoryFullAndSnapshotVarsFragment | null> | null, trackingSnapshot?: Array<AllTrackingHistoryFullAndSnapshotVarsFragment | null> | null } | null } | null };

export type GetPartByIdForPartEditPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPartByIdForPartEditPageQuery = { part?: PartForPartEditPageVarsFragment | null };

export type GetSpecInfosForPartEditPageQueryVariables = Exact<{
  partSpecID: Scalars['MongoID']['input'];
  chassisSpecID: Scalars['MongoID']['input'];
}>;


export type GetSpecInfosForPartEditPageQuery = { partSpec?: PartSpecInfoForPartEditPageVarsFragment | {} | null, chassisSpec?: ChassisSpecVarsForAssemblyPageFragment | {} | null };

export type GetTrackingItemListForPartEditPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTrackingItemListForPartEditPageQuery = { specification?: { trackingItemIDs?: Array<any | null> | null } | { trackingItemIDs?: Array<any | null> | null } | { trackingItemIDs?: Array<any | null> | null } | { trackingItemIDs?: Array<any | null> | null } | { trackingItemIDs?: Array<any | null> | null } | { trackingItemIDs?: Array<any | null> | null } | { trackingItemIDs?: Array<any | null> | null } | { trackingItemIDs?: Array<any | null> | null } | { trackingItemIDs?: Array<any | null> | null } | { trackingItemIDs?: Array<any | null> | null } | { trackingItemIDs?: Array<any | null> | null } | { trackingItemIDs?: Array<any | null> | null } | null };

export type GetTrackingItemsForTrackingItemIDsForPartsEditPageQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GetTrackingItemsForTrackingItemIDsForPartsEditPageQuery = { trackingItems?: { items?: Array<AllTrackingItemScalarVarsFragment> | null } | null };

export type PartForPartEditPageVarsFragment = { _id: any, concurrentUseAllowed?: boolean | null, currentlyInUse?: boolean | null, description?: string | null, displayName?: string | null, eligibleEventTypes?: EnumPartEligibleEventTypes | null, lifetimeMileage?: number | null, locationID?: any | null, manufacturerID?: any | null, manufacturerPartID?: string | null, manufacturerSerialNumber?: string | null, notes?: string | null, partNumber?: string | null, properties?: any | null, readingLocationOverride?: Array<EnumPartReadingLocationOverride | null> | null, reference: string, rootAssemblyIDs?: Array<any | null> | null, rootSpecificationID?: any | null, specificationID?: any | null, tagIDs?: Array<any | null> | null, teamID?: any | null, teamIDs?: Array<any | null> | null, trackingHistoryIDs?: Array<any | null> | null, trackingMeasurementHistoryIDs?: Array<any | null> | null, userEnumPartTypeID?: any | null, location?: { name: string } | null, partStatus?: { _id?: any | null, active?: boolean | null, statusComment?: string | null, userEnumPartStatusID?: any | null, userEnumPartStatus?: { active?: boolean | null, name: string } | null } | null, specification?: { __typename: 'BaseSpecification', _id: any, description?: string | null, name: string, chassisSpecID?: any | null, manufacturerID?: any | null, readingsRequired?: EnumSpecificationReadingsRequired | null, trackingItemIDs?: Array<any | null> | null, type: EnumSpecificationType, trackingMeasurements: Array<AllTrackingMeasurementScalarVarsFragment> } | null, tags?: AllTagVarsFragment | null, team?: { name: string } | null, tracking?: Array<{ trackingItem?: { name: string, criticalCumulativeValue?: number | null, criticalValue?: number | null, warningCumulativeValue?: number | null, warningValue?: number | null } | null } | null> | null };

export type GetPartTypeUserEnumsForPartEditPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartTypeUserEnumsForPartEditPageQuery = { partTypeEnums?: { items?: Array<{ _id?: any | null, name: string, type: EnumUserEnumPartTypeType } | {}> | null } | null, partStatusEnums?: { items?: Array<{ _id?: any | null, active?: boolean | null, name: string, type: EnumUserEnumPartStatusType } | {}> | null } | null };

export type GetPartStatusUserEnumsForPartEditPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartStatusUserEnumsForPartEditPageQuery = { userEnums?: { items?: Array<{ _id?: any | null, active?: boolean | null, name: string, type: EnumUserEnumPartStatusType } | {}> | null } | null };

export type GetManufacturersForPartEditPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManufacturersForPartEditPageQuery = { manufacturers?: { items?: Array<{ _id: any, name?: string | null }> | null } | null };

export type GetTeamsForPartsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeamsForPartsPageQuery = { teams?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetLocationsForPartEditPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsForPartEditPageQuery = { locations?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetUserUnitsForRunMileageDisplayQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetUserUnitsForRunMileageDisplayQuery = { person?: { mileageUnit?: EnumLengthUnit | null } | null };

export type RecalculatePartMileageByIdMutationVariables = Exact<{
  partID: Scalars['MongoID']['input'];
}>;


export type RecalculatePartMileageByIdMutation = { recalculatePartMileageByIDResolver?: { mileage?: number | null, partID?: any | null } | null };

export type GetPersonMileageUnitQueryVariables = Exact<{
  personID: Scalars['MongoID']['input'];
}>;


export type GetPersonMileageUnitQuery = { person?: { mileageUnit?: EnumLengthUnit | null } | null };

export type GetAllSpecificationsForPartsInventoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSpecificationsForPartsInventoryQuery = { specifications?: { items?: Array<{ __typename: 'AeroElementSpec', _id?: any | null, name: string, chassisSpecID?: any | null, initialChassisSpecID?: any | null } | { __typename: 'AeroPackageSpec', _id?: any | null, name: string, chassisSpecID?: any | null, initialChassisSpecID?: any | null } | { __typename: 'AntiRollBarSpec', _id?: any | null, name: string, chassisSpecID?: any | null, initialChassisSpecID?: any | null } | { __typename: 'ChassisSpec', _id?: any | null, name: string, version?: string | null } | { __typename: 'CustomSpec', _id?: any | null, name: string, chassisSpecID?: any | null, initialChassisSpecID?: any | null } | { __typename: 'DamperSpec', _id?: any | null, name: string, chassisSpecID?: any | null, initialChassisSpecID?: any | null } | { __typename: 'DifferentialSpec', _id?: any | null, name: string, chassisSpecID?: any | null, initialChassisSpecID?: any | null } | { __typename: 'ElasticSpec', _id?: any | null, name: string, allowableParentSpecIDs?: Array<any | null> | null } | { __typename: 'GearBoxSpec', _id?: any | null, name: string, chassisSpecID?: any | null, initialChassisSpecID?: any | null } | { __typename: 'GearSpec', _id?: any | null, name: string, chassisSpecID?: any | null, initialChassisSpecID?: any | null } | { __typename: 'KinematicsExternalSpec', _id?: any | null, name: string, chassisSpecID?: any | null, initialChassisSpecID?: any | null } | { __typename: 'KinematicsInternalSpec', _id?: any | null, name: string, chassisSpecID?: any | null, initialChassisSpecID?: any | null }> | null } | null };

export type PartSpecInfoForPartEditPageVarsFragment = { _id?: any | null, name: string, trackingItemIDs?: Array<any | null> | null, rootSpecificationID: any, trackingItems: Array<{ _id: any, displayUnit?: EnumDisplayUnit | null, name: string } | null> };

export type GetTrackingHistoryFullForPartEditPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTrackingHistoryFullForPartEditPageQuery = { part?: { trackingHistoryFullAndSnapshot?: { trackingHistoryFull?: Array<AllTrackingHistoryFullAndSnapshotVarsFragment | null> | null } | null } | null };

export type GetPartTrackingQueryVariables = Exact<{
  partID: Scalars['MongoID']['input'];
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetPartTrackingQuery = { partTracking: Array<PartTrackingVarsFragment | null> };

export type GetPartTrackingHistoryEntriesQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPartTrackingHistoryEntriesQuery = { part?: { trackingHistory: Array<{ _id: any }> } | null };

export type GetUserAndTeamIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAndTeamIdQuery = { whoami: { person: { _id: any, teamID?: any | null, role?: EnumPersonRole | null, team?: { _id: any, name: string } | null } } };

export type PartTrackingVarsFragment = { trackingItemID: any, history: Array<PartTrackingRecordVarsFragment>, snapshot?: PartTrackingRecordVarsFragment | null, trackingItem?: PartTrackingItemVarsFragment | null };

export type PartTrackingItemVarsFragment = { _id: any, active?: boolean | null, arrayElements?: number | null, cumulativeCalculation?: boolean | null, criticalValue?: number | null, displayUnit?: EnumDisplayUnit | null, isArray?: boolean | null, measurementImage?: string | null, name: string, NDecimals?: number | null, operator?: EnumTrackingItemOperator | null, resettable?: boolean | null, warningValue?: number | null, trackingSource?: { _id: any, name: string, sourceIDs?: Array<any | null> | null, displayUnit?: EnumDisplayUnit | null, NDecimals?: number | null } | null };

export type PartTrackingRecordVarsFragment = { _id: any, active?: boolean | null, arrayValues?: Array<number | null> | null, chassisAssemblyID?: any | null, date?: any | null, dateResolved?: any | null, cumulativeValue?: number | null, notes?: string | null, partID?: any | null, reset?: boolean | null, statusEnumID?: any | null, type?: EnumTrackingRecordType | null, trackingSourceID?: any | null, trackingItemID?: any | null, userEnumPartStatusName?: string | null, value?: number | null, valueString?: string | null, chassisAssembly?: { carSetupID?: any | null, name: string, reference?: string | null, carSetup?: { _id: any } | null } | null, statusEnum?: { type: EnumUserEnumPartStatusType, active?: boolean | null, _id?: any | null } | null };

export type GetDataForEventSelectDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDataForEventSelectDropdownQuery = { raceSeriesAll?: { items?: Array<{ _id: any, name: string, seasons: Array<{ _id: any, name: string, events: Array<{ _id: any, name: string, tEventStart?: any | null, tEventEnd?: any | null }> }> }> | null } | null };

export type GetPartsInEventForPartsEventTableQueryVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetPartsInEventForPartsEventTableQuery = { partsInEvent?: { items?: Array<{ runDistance?: number | null, serviceMileage?: number | null, part?: { _id: any, displayName?: string | null, chassisSpecName?: string | null, notes?: string | null, reference: string, partNumber?: string | null, specification?: { name: string } | null } | null, runs?: Array<{ runID?: string | null, runName?: string | null, runTime?: number | null, mileage?: number | null, contestantID?: string | null, carSetupID?: string | null, carSetupTitle?: string | null, assemblyID?: string | null, assemblyName?: string | null } | null> | null } | null> | null } | null };

export type GetRunSheetSelectionChainQueryVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
}>;


export type GetRunSheetSelectionChainQuery = { runSheet?: { _id: any, NRun?: number | null, contestantID: any, sessionID?: any | null, session?: { _id: any, eventID: any, event?: { _id: any, seasonID: any, season?: { _id: any, raceSeriesID: any } | null } | null } | null } | null };

export type RunSheetForTabStripFragment = { _id: any, info?: string | null, lapCount: number, NRun?: number | null, NRunTiming?: number | null, runDescription?: string | null, startTime?: any | null, startTimeLTS?: any | null, startTimeManual?: any | null, teamID?: any | null, driver?: { _id: any, acronym?: string | null } | null, laps: Array<{ _id: any, lapType?: EnumLapType | null, tLapManual?: number | null, tLapMax?: number | null, data?: Array<{ source: EnumLapDataSource, tDay?: any | null } | null> | null }>, setup?: { _id: any, setupInfo?: string | null } | null };

export type GetRunSheetsForTabStripQueryVariables = Exact<{
  sessionID: Scalars['MongoID']['input'];
  contestantID: Scalars['MongoID']['input'];
}>;


export type GetRunSheetsForTabStripQuery = { runSheets?: { items?: Array<RunSheetForTabStripFragment> | null } | null };

export type GetRunPlansForSessionAndDriverQueryVariables = Exact<{
  sessionID: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  contestantID: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunPlansForSessionAndDriverQuery = { runPlans?: { items?: Array<{ _id: any, title: string }> | null } | null };

export type GetRunPlannerWithSessionEventDataQueryVariables = Exact<{
  runPlanID: Scalars['MongoID']['input'];
}>;


export type GetRunPlannerWithSessionEventDataQuery = { runPlan?: RunPlanVarsFragment | null, lapSequences?: { items?: Array<LapSequenceForRunPlanVarsFragment> | null } | null, userEnums?: { items?: Array<{ _id?: any | null, name: string, type: EnumUserEnumRunPlannerActionItemType } | {}> | null } | null };

export type AddRunPlanMutationVariables = Exact<{
  record: CreateOneRunPlanInput;
}>;


export type AddRunPlanMutation = { addRunPlan?: { recordId?: any | null } | null };

export type RemoveRunPlanMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveRunPlanMutation = { removeRunPlan?: { recordId?: any | null } | null };

export type UpdateRunPlanMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdRunPlanInput;
}>;


export type UpdateRunPlanMutation = { updateRunPlan?: { recordId?: any | null } | null };

export type AddRunToRunPlanMutationVariables = Exact<{
  runPlanID: Scalars['MongoID']['input'];
  runs: Array<InputMaybe<RunPlanRunInput>> | InputMaybe<RunPlanRunInput>;
}>;


export type AddRunToRunPlanMutation = { addRunToRunPlan?: { _id: any } | null };

export type InsertRunInRunPlanMutationVariables = Exact<{
  runPlanID: Scalars['MongoID']['input'];
  run: RunPlanRunInput;
  NRun: Scalars['Int']['input'];
}>;


export type InsertRunInRunPlanMutation = { insertRunInRunPlan?: { _id: any } | null };

export type ReorderRunPlanRunsMutationVariables = Exact<{
  runPlanID: Scalars['MongoID']['input'];
  newNRunOrder?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type ReorderRunPlanRunsMutation = { reorderRunPlanRuns?: { _id: any } | null };

export type UpdateRunInRunPlanMutationVariables = Exact<{
  runPlanID: Scalars['MongoID']['input'];
  NRun: Scalars['Int']['input'];
  updatedFields: UpdateByIdRunPlanRunInput;
}>;


export type UpdateRunInRunPlanMutation = { updateRunInRunPlan?: { _id: any } | null };

export type RemoveRunFromRunPlanMutationVariables = Exact<{
  runPlanID: Scalars['MongoID']['input'];
  NRun: Scalars['Int']['input'];
}>;


export type RemoveRunFromRunPlanMutation = { removeRunFromRunPlan?: { _id: any } | null };

export type AddLapSequenceMutationVariables = Exact<{
  record: CreateOneLapSequenceInput;
}>;


export type AddLapSequenceMutation = { addLapSequence?: { recordId?: any | null } | null };

export type DraftRunSheetsMutationVariables = Exact<{
  runPlanID: Scalars['MongoID']['input'];
  runSheetIDS?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type DraftRunSheetsMutation = { draftRunSheets?: { _id: any, runs: Array<{ _id: any, NRun: number, runSheetID?: any | null } | null> } | null };

export type RunPlanVarsFragment = { _id: any, contestantID: any, createdAt?: any | null, mFuelFullTank?: number | null, sessionID: any, trackLayoutID?: any | null, title: string, updatedAt?: any | null, fuelRequired?: RunEnergyLapTypeVarsFragment | null, runs: Array<RunPlanRunVarsFragment | null>, session?: RunPlanSessionEventVarsFragment | null, contestant?: { _id: any, startNumber: string, drivers: Array<DriversForRunPlanVarsFragment> } | null, tLapExpected?: RunLapTimeLapTypeVarsFragment | null };

export type RunPlanRunVarsFragment = { _id: any, NRun: number, backgroundColor?: string | null, description?: string | null, priority?: RunPlanRunPriority | null, NLapsAttackPower?: number | null, NLapsPrep?: number | null, NLapsPush?: number | null, NLapsQualiPower?: number | null, NLapsSlow?: number | null, NLapsTarget?: number | null, tFuelRefuel?: number | null, tGarageTurnaround?: number | null, tWaitBeforeRun?: number | null, runSheetID?: any | null, selectedDriverID?: any | null, fuelDrainedBeforeRun?: boolean | null, mFuelRefuel?: number | null, reminder?: string | null, tyreFLID?: any | null, tyreFRID?: any | null, tyreRLID?: any | null, tyreRRID?: any | null, tyreSetID?: any | null, setupChanges?: string | null, actionItemsPostRun?: Array<{ _id: any, name: string } | null> | null, actionItemsPreRun?: Array<{ _id: any, name: string } | null> | null, lapSequence?: Array<LapSequenceLapsForRunPlanVarsFragment | null> | null, selectedDriver?: { _id: any, name: string, username: string, acronym?: string | null } | null, tyreFL?: { _id: any, mileage?: number | null, name?: string | null, axle?: EnumTyreAxle | null } | null, tyreFR?: { _id: any, mileage?: number | null, name?: string | null, axle?: EnumTyreAxle | null } | null, tyreRL?: { _id: any, mileage?: number | null, name?: string | null, axle?: EnumTyreAxle | null } | null, tyreRR?: { _id: any, mileage?: number | null, name?: string | null, axle?: EnumTyreAxle | null } | null, tyreSet?: { _id: any, name?: string | null, number?: number | null, tyreIDFL?: any | null, tyreIDFR?: any | null, tyreIDRL?: any | null, tyreIDRR?: any | null } | null, runSheet?: RunPlanRunRunSheetVarsFragment | null };

export type RunPlanSessionEventVarsFragment = { _id: any, eventID: any, shortName?: string | null, name: string, tSessionStart?: any | null, tSessionEnd?: any | null, event?: { _id: any, name: string, contestants?: Array<{ drivers: Array<DriversForRunPlanVarsFragment> } | null> | null, trackLayouts: Array<(
      { _id: any, name: string, track?: { _id: any, name: string, timeZone?: string | null } | null }
      & TrackLayoutLengthVarsFragment
    )>, consumptions?: Array<{ trackLayoutID: any, trackLayout?: { _id: any, name: string } | null, fuelRequired?: { ATTACK?: number | null, COOL?: number | null, FCY?: number | null, IN?: number | null, OUT?: number | null, OUTIN?: number | null, PITLANE?: number | null, PREP?: number | null, PUSH?: number | null, QUALI?: number | null, SAFETYCAR?: number | null, SHAKEDOWN?: number | null, SLOW?: number | null, TARGET?: number | null, TOGRID?: number | null, TOPADDOCK?: number | null, TOPITS?: number | null, UNFINISHED?: number | null } | null } | null> | null, referenceLaptimes?: Array<{ ATTACK?: number | null, COOL?: number | null, FCY?: number | null, IN?: number | null, OUT?: number | null, OUTIN?: number | null, PITLANE?: number | null, PREP?: number | null, PUSH?: number | null, QUALI?: number | null, SAFETYCAR?: number | null, SHAKEDOWN?: number | null, SLOW?: number | null, TARGET?: number | null, TOGRID?: number | null, TOPADDOCK?: number | null, TOPITS?: number | null, UNFINISHED?: number | null, calculationMethod?: EnumEventReferenceLaptimesCalculationMethod | null, referenceLaptime?: number | null, trackLayoutID: any } | null> | null, season?: { raceSeries?: { _id: any, lapTypeConfig?: LapTypeConfigVarsFragment | null } | null } | null } | null };

export type TrackLayoutLengthVarsFragment = { lapLengthCarData?: number | null, lapLengthInLapCarData?: number | null, lapLengthInLapOfficial?: number | null, lapLengthInLapRoulette?: number | null, lapLengthOfficial?: number | null, lapLengthOutLapCarData?: number | null, lapLengthOutLapOfficial?: number | null, lapLengthOutLapRoulette?: number | null, lapLengthRoulette?: number | null };

export type RunPlanRunRunSheetVarsFragment = { _id: any, startTime?: any | null, endTime?: any | null, mileage?: number | null, isLocked?: boolean | null, contestantID: any, driverID?: any | null, mFuelRunEnd?: number | null, mFuelRunStart?: number | null, lapCount: number, NRun?: number | null, NRunTiming?: number | null, runDescription?: string | null, setupID?: any | null, sessionID?: any | null, teamID?: any | null, tGarageTurnaround?: number | null, tWaitBeforeRun?: number | null, SoCRequired?: AllRunEnergyVarsFragment | null, driver?: { _id: any, acronym?: string | null } | null, fuelRequired?: AllRunEnergyVarsFragment | null, laps: Array<{ tLapMax?: number | null, tLapManual?: number | null, tDayPitIn?: any | null, data?: Array<{ tDayPitIn?: any | null } | null> | null }>, tyreFL?: RunSheetTyreForRunPlanVarsFragment | null, tyreFR?: RunSheetTyreForRunPlanVarsFragment | null, tyreRL?: RunSheetTyreForRunPlanVarsFragment | null, tyreRR?: RunSheetTyreForRunPlanVarsFragment | null, tyreSet?: { _id: any, name?: string | null, tyreFR?: { _id: any, name?: string | null } | null, tyreFL?: { _id: any, name?: string | null } | null, tyreRL?: { _id: any, name?: string | null } | null, tyreRR?: { _id: any, name?: string | null } | null } | null };

export type RunSheetTyreForRunPlanVarsFragment = { mileagePreRun?: number | null, pTyre?: number | null, pTyrePostRun?: number | null, pTyrePostRunBleed?: number | null, TTyre?: number | null, TTyrePostRun?: number | null, TTyrePostRunBleed?: number | null, tyreID?: any | null };

export type RunEnergyLapTypeVarsFragment = { ATTACK?: number | null, COOL?: number | null, FCY?: number | null, IN?: number | null, OUT?: number | null, OUTIN?: number | null, PITLANE?: number | null, PREP?: number | null, PUSH?: number | null, QUALI?: number | null, SAFETYCAR?: number | null, SHAKEDOWN?: number | null, SLOW?: number | null, TARGET?: number | null, TOGRID?: number | null, TOPADDOCK?: number | null, TOPITS?: number | null, UNFINISHED?: number | null };

export type RunLapTimeLapTypeVarsFragment = { ATTACK?: number | null, COOL?: number | null, FCY?: number | null, IN?: number | null, OUT?: number | null, OUTIN?: number | null, PITLANE?: number | null, PREP?: number | null, PUSH?: number | null, QUALI?: number | null, SAFETYCAR?: number | null, SHAKEDOWN?: number | null, SLOW?: number | null, TARGET?: number | null, TOGRID?: number | null, TOPADDOCK?: number | null, TOPITS?: number | null, UNFINISHED?: number | null };

export type LapSequenceForRunPlanVarsFragment = { _id: any, name: string, laps: Array<{ NLap: number, _id?: any | null, lapType: EnumLapSequenceLapsLapType } | null> };

export type LapSequenceLapsForRunPlanVarsFragment = { _id?: any | null, NLap: number, lapType: EnumLapSequenceLapsLapType };

export type DriversForRunPlanVarsFragment = { _id: any, acronym?: string | null, displayColor?: string | null, name: string };

export type RunPlansForImportModalQueryVariables = Exact<{ [key: string]: never; }>;


export type RunPlansForImportModalQuery = { runPlans?: { items?: Array<{ _id: any, title: string, session?: { _id: any, name: string, shortName?: string | null, event?: { _id: any, name: string, season?: { _id: any, name: string, raceSeries?: { _id: any, name: string } | null } | null } | null } | null }> | null } | null };

export type CloneRunPlanMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  runPlanID: Scalars['MongoID']['input'];
  sessionID: Scalars['MongoID']['input'];
}>;


export type CloneRunPlanMutation = { cloneRunPlan?: { _id: any } | null };

export type AllSessionsFromRaceSeriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSessionsFromRaceSeriesQuery = { raceSeriesAll?: { items?: Array<{ _id: any, name: string, seasons: Array<{ _id: any, name: string, events: Array<{ _id: any, name: string, sessions: Array<{ name: string, _id: any, shortName?: string | null }> }> }> }> | null } | null };

export type AllSessionsInASeriesQueryVariables = Exact<{
  seriesID: Scalars['MongoID']['input'];
}>;


export type AllSessionsInASeriesQuery = { raceSeries?: { seasons: Array<{ _id: any, name: string, raceSeries?: { _id: any } | null, events: Array<{ _id: any, name: string, sessions: Array<{ _id: any, name: string, shortName?: string | null, contestants?: Array<{ drivers: Array<{ name: string }> } | null> | null }> }> }> } | null };

export type BopReportSessionsQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type BopReportSessionsQuery = { sessions?: { items?: Array<{ _id: any, tSessionStart?: any | null, shortName?: string | null, name: string, eventID: any, bop?: { carBop?: Array<{ carSpec?: string | null } | null> | null } | null }> | null } | null };

export type GetReportTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportTemplatesQuery = { reportTemplates?: { items?: Array<AllReportTemplateVarsFragment> | null } | null };

export type GetReportNotesTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportNotesTemplatesQuery = { reportNotesTemplates: Array<{ _id: any, title: string, pageOverview?: { notes?: Array<{ _id?: any | null, index?: number | null, mode?: EnumReportNotesTemplatePageOverviewNotesMode | null, text: string, title?: string | null } | null> | null } | null, pageSession?: { notes?: Array<{ _id?: any | null, index?: number | null, mode?: EnumReportNotesTemplatePageSessionNotesMode | null, text: string, title?: string | null } | null> | null } | null, pageParts?: { notes?: Array<{ _id?: any | null, index?: number | null, mode?: EnumReportNotesTemplatePagePartsNotesMode | null, text: string, title?: string | null } | null> | null } | null, pageAppendix?: { notes?: Array<{ _id?: any | null, index?: number | null, mode?: EnumReportNotesTemplatePageAppendixNotesMode | null, text: string, title?: string | null } | null> | null } | null, pageRunPlan?: { notes?: Array<{ _id?: any | null, index?: number | null, mode?: EnumReportNotesTemplatePageRunPlanNotesMode | null, text: string, title?: string | null } | null> | null } | null }> };

export type ReportNotesPagesFragment = { _id: any, pageOverview?: { notes?: Array<{ index?: number | null, text: string, title?: string | null, mode?: EnumReportNotePageOverviewNotesMode | null, _id?: any | null } | null> | null } | null, pageSession?: { notes?: Array<{ index?: number | null, text: string, title?: string | null, mode?: EnumReportNotePageSessionNotesMode | null, _id?: any | null } | null> | null } | null, pageParts?: { notes?: Array<{ index?: number | null, text: string, title?: string | null, mode?: EnumReportNotePagePartsNotesMode | null, _id?: any | null } | null> | null } | null, pageAppendix?: { notes?: Array<{ index?: number | null, text: string, title?: string | null, mode?: EnumReportNotePageAppendixNotesMode | null, _id?: any | null } | null> | null } | null, pageRunPlan?: { notes?: Array<{ index?: number | null, text: string, title?: string | null, mode?: EnumReportNotePageRunPlanNotesMode | null, _id?: any | null } | null> | null } | null };

export type Report_NotesQueryVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
}>;


export type Report_NotesQuery = { reportNotes?: ReportNotesPagesFragment | null };

export type ReportNoteUpdatedSubscriptionVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
}>;


export type ReportNoteUpdatedSubscription = { reportNoteUpdated?: ReportNotesPagesFragment | null };

export type ReportEventUpdatedSubscriptionVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
}>;


export type ReportEventUpdatedSubscription = { eventUpdated?: { _id: any } | null };

export type SessionDebriefUpdatedSubscriptionVariables = Exact<{
  sessionID: Scalars['MongoID']['input'];
}>;


export type SessionDebriefUpdatedSubscription = { sessionUpdated?: { _id: any, debriefNotes?: string | null, debriefNotesMode?: EnumSessionDebriefNotesMode | null } | null };

export type Report_EngineersQueryVariables = Exact<{ [key: string]: never; }>;


export type Report_EngineersQuery = { people?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type Report_UpdateParticipantsMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  participantIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type Report_UpdateParticipantsMutation = { updateEvent?: { recordId?: any | null } | null };

export type Report_UpdateReportAuthorsMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  reportAuthors: Array<UpdateByIdEventReportAuthorsInput> | UpdateByIdEventReportAuthorsInput;
}>;


export type Report_UpdateReportAuthorsMutation = { updateEvent?: { recordId?: any | null } | null };

export type Report_UpdateEventDebriefNoteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  debriefNotes: Scalars['String']['input'];
  debriefNotesMode?: InputMaybe<EnumEventDebriefNotesMode>;
}>;


export type Report_UpdateEventDebriefNoteMutation = { updateEvent?: { recordId?: any | null } | null };

export type Report_UpdateSessionDebriefNoteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  debriefNotes: Scalars['String']['input'];
  debriefNotesMode?: InputMaybe<EnumSessionDebriefNotesMode>;
}>;


export type Report_UpdateSessionDebriefNoteMutation = { updateSession?: { recordId?: any | null } | null };

export type Report_AddReportNoteMutationVariables = Exact<{
  page: EnumReportPage;
  eventID: Scalars['String']['input'];
  text: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
}>;


export type Report_AddReportNoteMutation = { addReportNote?: { _id: any } | null };

export type Report_UpdateReportNoteMutationVariables = Exact<{
  noteID: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  page: EnumReportPage;
  index?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
}>;


export type Report_UpdateReportNoteMutation = { updateReportNote?: { _id: any } | null };

export type Report_RemoveReportNoteMutationVariables = Exact<{
  noteID: Scalars['String']['input'];
  page: EnumReportPage;
  eventID: Scalars['String']['input'];
}>;


export type Report_RemoveReportNoteMutation = { removeReportNote?: { _id: any } | null };

export type Report_RemoveReportNotesTemplateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type Report_RemoveReportNotesTemplateMutation = { removeReportNotesTemplate?: { recordId?: any | null } | null };

export type AllReportTemplateVarsFragment = { _id: any, name: string, logo?: string | null, downloadFilenameFormat?: string | null, reportTitle?: string | null, bop?: { active?: boolean | null, bopFileOnly?: boolean | null, layout?: any | null } | null, carSetup?: { active?: boolean | null, tableConfig?: any | null } | null, issues?: { active?: boolean | null, groupBy?: EnumReportTemplateIssuesGroupBy | null, columns?: Array<{ field: EnumReportTemplateIssuesColumnsField, label?: string | null } | null> | null } | null, kpi?: { active?: boolean | null, layout?: any | null, showSessionLines?: boolean | null } | null, overview?: { active?: boolean | null, noteTitle?: string | null, showFuelConsumption?: boolean | null } | null, parts?: { active?: boolean | null, groupPartsByChassisAssemblyName?: boolean | null, noteTitle?: string | null, tableColumns?: Array<any | null> | null } | null, weather?: { active?: boolean | null, splitDataByDays?: boolean | null } | null, appendix?: { active?: boolean | null } | null, runPlan?: { active?: boolean | null } | null, runInfo?: { active?: boolean | null, columns?: Array<{ field: EnumReportTemplateRunInfoColumnsField, label?: string | null } | null> | null } | null, sessions?: { active?: boolean | null, displayedTimeZones?: Array<string | null> | null, noteTitle?: string | null, showTimingOverview?: boolean | null } | null, excludedNoteIDs?: { pageOverview?: Array<string | null> | null, pageSession?: Array<string | null> | null, pageParts?: Array<string | null> | null, pageAppendix?: Array<string | null> | null, pageRunPlan?: Array<string | null> | null } | null };

export type UpdateReportTemplateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdReportTemplateInput;
}>;


export type UpdateReportTemplateMutation = { updateReportTemplate?: { recordId?: any | null } | null };

export type AddReportTemplateMutationVariables = Exact<{
  record: CreateOneReportTemplateInput;
}>;


export type AddReportTemplateMutation = { addReportTemplate?: { recordId?: any | null } | null };

export type RemoveReportTemplateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveReportTemplateMutation = { removeReportTemplate?: { recordId?: any | null } | null };

export type AddReportNotesTemplateMutationVariables = Exact<{
  record: CreateOneReportNotesTemplateInput;
}>;


export type AddReportNotesTemplateMutation = { addReportNotesTemplate?: { recordId?: any | null, record?: { _id: any, title: string } | null } | null };

export type DraftNotesFromTemplateMutationVariables = Exact<{
  eventID: Scalars['String']['input'];
  notesTemplateId: Scalars['MongoID']['input'];
  pages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DraftNotesFromTemplateMutation = { draftNotesFromTemplate?: { _id: any } | null };

export type TrackingItemNamesForPartsReportQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type TrackingItemNamesForPartsReportQuery = { trackingItemNamesForSessions: Array<string> };

export type GetRunSheetInfoForRunSheetLinkingQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  contestantIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetInfoForRunSheetLinkingQuery = { runSheets?: { items?: Array<RunSheetVarsForLinkingFragment> | null } | null };

export type RunSheetVarsForLinkingFragment = { _id: any, endTime?: any | null, lapCount: number, nextRunSheetID?: any | null, NRun?: number | null, NRunTiming?: number | null, prevRunSheetID?: any | null, sessionID?: any | null, startTime?: any | null, session?: { shortName?: string | null, name: string, tSessionStart?: any | null } | null };

export type GetSessionForSessionTimeRemainingQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSessionForSessionTimeRemainingQuery = { session?: { _id: any, name: string, timeRemainingUpdatedAt?: any | null, timeRemaining?: number | null } | null };

export type GetSessionForReadFromLayoutButtonQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSessionForReadFromLayoutButtonQuery = { session?: { _id: any, name: string, shortName?: string | null, tSessionStart?: any | null, tSessionEnd?: any | null, timeRemaining?: number | null, timeRemainingUpdatedAt?: any | null, eventID: any, debriefNotes?: string | null, sessionType?: EnumSessionType | null, isLinkedSession?: boolean | null, contestants?: Array<{ _id: any } | null> | null } | null };

export type GetPreviousRunSheetFuelForFuelBlockQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPreviousRunSheetFuelForFuelBlockQuery = { runSheet?: { _id: any, fuelDrainedBeforeRun?: boolean | null, mFuelAdded?: number | null, mFuelDrainedCatchTank?: number | null, mFuelDrainedMainTank?: number | null, mFuelRunEnd?: number | null, mFuelRunStart?: number | null, rEnergyAdded?: number | null, rEnergyRunEnd?: number | null, rEnergyRunStart?: number | null, rSOCAdded?: number | null, rSOCRunEnd?: number | null, rSOCRunStart?: number | null, consumptions?: Array<{ trackLayoutID: any, trackLayout?: { _id: any, name: string, track?: { _id: any, name: string } | null } | null, energyRequired?: AllRunEnergyVarsFragment | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null } | null> | null, dashboard?: { mFuelRunEnd?: number | null, mFuelRunStart?: number | null } | null } | null };

export type GetIssuesForRunSheetBlockQueryVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
}>;


export type GetIssuesForRunSheetBlockQuery = { issues?: { items?: Array<(
      { _id: any }
      & IssueVarsFragment
    )> | null } | null };

export type IssueVarsFragment = { _id: any, acknowledgedAt?: any | null, assigneeIDs?: Array<any | null> | null, carSetupID?: any | null, closedAt?: any | null, createdAt?: any | null, description: string, descriptionDetails?: string | null, number?: string | null, oneWordStatus: IssueStatus, priority?: EnumIssueQueryPriority | null, updatedAt?: any | null, acknowledgedBy?: { _id: any, name: string, username: string, role?: EnumPersonRole | null } | null, assignees: Array<{ _id: any, name: string, username: string, role?: EnumPersonRole | null }>, cancelledBy?: { _id: any, name: string, username: string, role?: EnumPersonRole | null } | null, closedBy?: { name: string, username: string, role?: EnumPersonRole | null } | null, comments?: Array<{ _id?: any | null, createdAt?: any | null, text?: string | null, author?: { _id: any, name: string, username: string, role?: EnumPersonRole | null } | null } | null> | null, createdBy?: { _id: any, name: string, username: string, role?: EnumPersonRole | null } | null };

export type DeleteIssueMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type DeleteIssueMutation = { removeIssue?: { recordId?: any | null } | null };

export type ManageIssueMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  action: IssueAction;
}>;


export type ManageIssueMutation = { manageIssue: { _id: any } };

export type UpdateIssueCommentMutationVariables = Exact<{
  target: EnumJobTarget;
  subjectID: Scalars['MongoID']['input'];
  commentID: Scalars['MongoID']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateIssueCommentMutation = { updateComment?: { comment?: { _id?: any | null, text?: string | null } | null } | null };

export type GetChassisSpecForRunSheetQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSpecForRunSheetQuery = { runSheet?: { setup?: { chassisSpecID?: any | null, _id: any } | null } | null };

export type GetShowMyIssuesDefaultValueQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetShowMyIssuesDefaultValueQuery = { person?: { behaviour?: { showMyIssuesOnRunSheetDefault?: boolean | null } | null } | null };

export type GetActiveTimingServiceConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveTimingServiceConfigsQuery = { timingServiceStatus?: { _id: any, activeConfigs?: Array<{ sessionMatchID?: any | null } | null> | null } | null };

export type InsertLapMutationVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
  lapToInsertBeforeID: Scalars['MongoID']['input'];
}>;


export type InsertLapMutation = { insertLap?: { _id: any } | null };

export type SplitRunSheetForLapTableMutationVariables = Exact<{
  runSheetId: Scalars['MongoID']['input'];
  lapId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type SplitRunSheetForLapTableMutation = { splitRunSheet?: { _id: any } | null };

export type ApplyLapSequenceToRunSheetMutationVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
  lapSequenceID?: InputMaybe<Scalars['MongoID']['input']>;
  lapType?: InputMaybe<EnumLapType>;
  lapCount?: InputMaybe<Scalars['Int']['input']>;
  lapTime?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ApplyLapSequenceToRunSheetMutation = { applyLapSequence?: { success: boolean, message: string } | null };

export type GetLapSequencesForDraftSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLapSequencesForDraftSectionQuery = { lapSequences?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetReferenceLaptimesForLapTableQueryVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
}>;


export type GetReferenceLaptimesForLapTableQuery = { event?: { _id: any, referenceLaptimes?: Array<EventReferenceLaptimeVarsFragment | null> | null } | null };

export type EventReferenceLaptimeVarsFragment = { ATTACK?: number | null, COOL?: number | null, FCY?: number | null, IN?: number | null, OUT?: number | null, OUTIN?: number | null, PITLANE?: number | null, PREP?: number | null, PUSH?: number | null, QUALI?: number | null, SAFETYCAR?: number | null, SHAKEDOWN?: number | null, SLOW?: number | null, TARGET?: number | null, TOGRID?: number | null, TOPADDOCK?: number | null, TOPITS?: number | null, UNFINISHED?: number | null, calculationMethod?: EnumEventReferenceLaptimesCalculationMethod | null, referenceLaptime?: number | null, trackLayoutID: any };

export type GetLapsWithSelectedKpiForRunSheetQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
  lapKPI?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetLapsWithSelectedKpiForRunSheetQuery = { runSheet?: { laps: Array<{ _id: any, lapKPI?: any | null }> } | null };

export type GetTyreSetInfosFromPreviousRunSheetQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTyreSetInfosFromPreviousRunSheetQuery = { runSheet?: { tyreSetID?: any | null, tyreFL?: TyreVarsForPreviousRunSheetsInfosVarsFragment | null, tyreFR?: TyreVarsForPreviousRunSheetsInfosVarsFragment | null, tyreRL?: TyreVarsForPreviousRunSheetsInfosVarsFragment | null, tyreRR?: TyreVarsForPreviousRunSheetsInfosVarsFragment | null } | null };

export type TyreVarsForPreviousRunSheetsInfosVarsFragment = { hTyreTread?: Array<number | null> | null, pTyre?: number | null, pTyrePostRun?: number | null, pTyrePostRunBleed?: number | null, pTyrePreRunBleed?: number | null, pTyreReference?: number | null, pTyreSetDown?: number | null, pTyreTarget?: number | null, pTyreMinStartRun?: number | null, pTyreStartRun?: number | null, TTyre?: number | null, TTyreParcFermeExpected?: number | null, TTyrePostRun?: number | null, TTyrePostRunBleed?: number | null, TTyrePreRunBleed?: number | null, TTyreReference?: number | null, TTyreSetdown?: number | null, TTyreSurface?: Array<number | null> | null, tyreID?: any | null };

export type GetTyreWearForExcelExportQueryVariables = Exact<{
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetTyreWearForExcelExportQuery = { tyreWears?: { items?: Array<TyreWearItemFragment> | null } | null };

export type TyreWearItemFragment = { _id: any, date?: any | null, runSheetID?: any | null, tyreID: any, wearMarkers?: any | null };

export type GetEventPressuresForTyreBlockQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEventPressuresForTyreBlockQuery = { event?: EventTyreDefaultsFragment | null };

export type EventTyreDefaultsFragment = { tyreDefaults?: Array<{ tyreType?: string | null, frontLeft?: { pTyreStartRun?: number | null, pTyreMin?: number | null, pTyreTarget?: number | null } | null, frontRight?: { pTyreStartRun?: number | null, pTyreMin?: number | null, pTyreTarget?: number | null } | null, rearLeft?: { pTyreStartRun?: number | null, pTyreMin?: number | null, pTyreTarget?: number | null } | null, rearRight?: { pTyreStartRun?: number | null, pTyreMin?: number | null, pTyreTarget?: number | null } | null } | null> | null, tyreDefaultsFL?: { pTyreMin?: number | null, pTyreStartRun?: number | null, pTyreTarget?: number | null } | null, tyreDefaultsFR?: { pTyreMin?: number | null, pTyreStartRun?: number | null, pTyreTarget?: number | null } | null, tyreDefaultsRL?: { pTyreMin?: number | null, pTyreStartRun?: number | null, pTyreTarget?: number | null } | null, tyreDefaultsRR?: { pTyreMin?: number | null, pTyreStartRun?: number | null, pTyreTarget?: number | null } | null, tyreDefaultsWetFL?: { pTyreMin?: number | null, pTyreStartRun?: number | null, pTyreTarget?: number | null } | null, tyreDefaultsWetFR?: { pTyreMin?: number | null, pTyreStartRun?: number | null, pTyreTarget?: number | null } | null, tyreDefaultsWetRL?: { pTyreMin?: number | null, pTyreStartRun?: number | null, pTyreTarget?: number | null } | null, tyreDefaultsWetRR?: { pTyreMin?: number | null, pTyreStartRun?: number | null, pTyreTarget?: number | null } | null };

export type GetTyreTypesQueryVariables = Exact<{
  tyreSetyID: Scalars['MongoID']['input'];
}>;


export type GetTyreTypesQuery = { tyreSet?: { tyreFL?: { type?: string | null } | null, tyreFR?: { type?: string | null } | null, tyreRL?: { type?: string | null } | null, tyreRR?: { type?: string | null } | null } | null };

export type GetTyreStaggerForTyreBlockQueryVariables = Exact<{
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetTyreStaggerForTyreBlockQuery = { tyres?: { items?: Array<{ _id: any, CTyre?: number | null }> | null } | null };

export type GetWeatherFromPrevRunSheetQueryVariables = Exact<{
  prevRunSheetID: Scalars['MongoID']['input'];
}>;


export type GetWeatherFromPrevRunSheetQuery = { runSheet?: { weather?: { TAir?: number | null, TTrack?: number | null, rHumidity?: number | null, pAmbient?: number | null } | null } | null };

export type GetWeatherForGetWeatherButtonQueryVariables = Exact<{
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetWeatherForGetWeatherButtonQuery = { weatherAll?: { items?: Array<{ _id: any, time?: any | null, source?: string | null, type: EnumWeatherType, eventIDs?: Array<any | null> | null }> | null } | null };

export type GetWeatherDataByWeatherDocIdQueryVariables = Exact<{
  weatherDocID: Scalars['MongoID']['input'];
}>;


export type GetWeatherDataByWeatherDocIdQuery = { weather?: { _id: any, time?: any | null, source?: string | null, type: EnumWeatherType, eventIDs?: Array<any | null> | null, data: Array<WeatherDataVarsFragment | null> } | null };

export type GetRunSheetEndTimeQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetEndTimeQuery = { runSheet?: { endTime?: any | null } | null };

export type GetSessionsInDateTimeRangeForRunSheetBurgerMenuQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetSessionsInDateTimeRangeForRunSheetBurgerMenuQuery = { sessions?: { items?: Array<{ _id: any, name: string, tSessionStart?: any | null, tSessionEnd?: any | null, event?: { _id: any, season?: { _id: any, raceSeries?: { _id: any } | null } | null } | null }> | null } | null };

export type GetUserDefaultRunSheetStyleNameQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetUserDefaultRunSheetStyleNameQuery = { person?: { defaultRunSheetStyle?: { name: string } | null } | null };

export type RunSheetToServerQueryVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
}>;


export type RunSheetToServerQuery = { runSheet?: { nextRunSheetID?: any | null, prevRunSheetID?: any | null, NRun?: number | null, associatedKpiFiles?: Array<string | null> | null, startTime?: any | null, startTimeLTS?: any | null, startTimeManual?: any | null, endTime?: any | null, endTimeLTS?: any | null, endTimeManual?: any | null, lapCount: number, laps: Array<{ _id: any, tLapMax?: number | null, tLapManual?: number | null, NLapRun: number, BPitIn: boolean, BPitOut: boolean, tDay?: any | null }>, driver?: { acronym?: string | null } | null, contestant?: { startNumber: string } | null, session?: { name: string, event?: { name: string, season?: { name: string } | null, track?: { timeZone?: string | null } | null } | null } | null } | null };

export type GetRunSheetInfoForCopySetupFromPreviousButtonQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetInfoForCopySetupFromPreviousButtonQuery = { runSheet?: { setup?: { _id: any, isLocked?: boolean | null, title: string } | null, session?: { prevSessionID?: any | null } | null } | null };

export type GetRunSheetsFromPreviousSessionForCopySetupFromPreviousButtonQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  contestantIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetsFromPreviousSessionForCopySetupFromPreviousButtonQuery = { runSheets?: { items?: Array<{ _id: any, NRunTiming?: number | null, setup?: { _id: any, isLocked?: boolean | null, title: string } | null }> | null } | null };

export type GetTyreWearForRunSheetQueryVariables = Exact<{
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetTyreWearForRunSheetQuery = { tyreWears?: { items?: Array<{ _id: any, date?: any | null, runSheetID?: any | null, tyreID: any, wearMarkers?: any | null }> | null } | null };

export type GetMileageUnitForPersonQueryVariables = Exact<{
  personID: Scalars['MongoID']['input'];
}>;


export type GetMileageUnitForPersonQuery = { person?: { mileageUnit?: EnumLengthUnit | null } | null };

export type GetAvailableCarSetupSheetStylesForCarSetupCreateModalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableCarSetupSheetStylesForCarSetupCreateModalQuery = { license: { options: { setupSheetStyles: Array<EnumChassisSetupSheetStyle> } } };

export type GetChassisSpecsForCarSetupCreateModalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChassisSpecsForCarSetupCreateModalQuery = { specifications?: { items?: Array<{ _id?: any | null, decommissioned?: boolean | null, iterationIDs?: Array<any | null> | null, name: string, iterations: Array<{ _id?: any | null, decommissioned?: boolean | null, released?: boolean | null, releaseDate?: any | null, version?: string | null }> } | {}> | null } | null };

export type GetRunSheetSetupListForCarSetupCreateModalQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetSetupListForCarSetupCreateModalQuery = { runSheets?: { items?: Array<(
      { _id: any, session?: { tSessionStart?: any | null } | null, setup?: { chassisSpec?: { decommissioned?: boolean | null } | null } | null }
      & RunSheetForEventSelectionVarsFragment
    )> | null } | null };

export type GetAllSpecificationsQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManySpecificationInput>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllSpecificationsQuery = { specifications?: { items?: Array<{ name: string, iterationIDs?: Array<any | null> | null, rootSpecificationID: any, iterations: Array<{ _id?: any | null, version?: string | null, released?: boolean | null, releaseDate?: any | null }> } | {}> | null } | null };

export type GetSetupSheetStyleForSetupSheetPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSetupSheetStyleForSetupSheetPageQuery = { carSetup?: { _id: any, setupSheetStyle?: EnumCarSetupSetupSheetStyle | null } | null };

export type CarSetupRemovedSubscriptionVariables = Exact<{
  carSetupId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type CarSetupRemovedSubscription = { carSetupRemoved?: { _id: any, runSheetID?: any | null } | null };

export type GetSimulationDriveFileQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSimulationDriveFileQuery = { simulationDriveFile?: { data?: any | null, name?: string | null, status?: EnumSimulationDriveFileStatus | null, userEnumTypeID?: any | null, eventID?: any | null, _id: any, event?: { _id: any, name: string } | null } | null };

export type GetEventsForDriveFileTreeViewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventsForDriveFileTreeViewQuery = { events?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type UpdateSimulationDriveFileMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdSimulationDriveFileInput;
}>;


export type UpdateSimulationDriveFileMutation = { updateSimulationDriveFile?: { recordId?: any | null } | null };

export type GetSimulationDriveFileListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSimulationDriveFileListQuery = { simulationDriveFiles?: { items?: Array<{ _id: any }> | null } | null };

export type GetLocalConnectionsForSimulationContextMenuQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetLocalConnectionsForSimulationContextMenuQuery = { person?: { localConnections?: Array<{ host?: string | null, endPoint?: string | null, port?: number | null, outputFolder?: string | null } | null> | null } | null };

export type GetSimResultInfosForStagingAreaQueryVariables = Exact<{
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetSimResultInfosForStagingAreaQuery = { simResults?: { items?: Array<SimResultInfosForStagingAreaVarsFragment> | null } | null };

export type GetRunSheetInfoForStagingAreaQueryVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
}>;


export type GetRunSheetInfoForStagingAreaQuery = { runSheet?: GetRunSheetInfoForStagingAreaVarsFragment | null };

export type GetSetupInfoForStagingAreaQueryVariables = Exact<{
  carSetupID: Scalars['MongoID']['input'];
}>;


export type GetSetupInfoForStagingAreaQuery = { carSetup?: CarSetupInfoForStagingAreaVarsFragment | null };

export type GetRunSheetsForInitialLoadForSimulationQueryVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
}>;


export type GetRunSheetsForInitialLoadForSimulationQuery = { runSheet?: GetRunSheetInfoForStagingAreaVarsFragment | null };

export type GetSetupsForInitialLoadForSimulationQueryVariables = Exact<{
  carSetupID: Scalars['MongoID']['input'];
}>;


export type GetSetupsForInitialLoadForSimulationQuery = { carSetup?: CarSetupInfoForStagingAreaVarsFragment | null };

export type GetPeopleForLogWrapperFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPeopleForLogWrapperFilterQuery = { people?: { items?: Array<{ _id: any, name: string, role?: EnumPersonRole | null, username: string }> | null } | null };

export type CarSetupInfoForStagingAreaVarsFragment = { _id: any, customSimulationPayloadEnabled?: boolean | null, runSheetID?: any | null, updatedAt?: any | null, chassisSpec?: { simulationModels?: any | null } | null };

export type GetRunSheetInfoForStagingAreaVarsFragment = { _id: any, info?: string | null, NRun?: number | null, NRunTiming?: number | null, setupID?: any | null, updatedAt?: any | null, contestant?: { _id: any, startNumber: string } | null, session?: { _id: any, shortName?: string | null, name: string, event?: { _id: any, name: string } | null } | null, weather?: { TAir?: number | null, pAmbient?: number | null, rHumidity?: number | null } | null };

export type SimResultInfosForStagingAreaVarsFragment = { _id: any, carSetupID?: any | null, carSetupModifiedAt?: any | null, createdAt?: any | null, defaultChannelTime?: Array<number | null> | null, isCarSetupChanged?: boolean | null, name?: string | null, pAmbient?: number | null, refValues?: any | null, requesterID?: any | null, rHumidity?: number | null, runSheetID?: any | null, simType?: EnumSimResultSimType | null, simulationDriveFileID?: any | null, simulationService?: EnumSimModelType | null, source?: string | null, sourceReferenceID?: string | null, status?: EnumSimResultStatus | null, statusMessage?: string | null, specificationID?: any | null, TAmbient?: number | null, trackLayoutID?: any | null, updatedAt?: any | null, version?: string | null, carSetup?: { _id: any, title: string } | null, data?: Array<(
    { _id?: any | null }
    & SimResultDataVarsFragment
  ) | null> | null, requester?: { _id: any, name: string, username: string } | null, simulationDriveFile?: { name?: string | null } | null, trackLayout?: (
    { _id: any }
    & TrackLayoutVarsFragment
  ) | null };

export type SimResultDataVarsFragment = { channelName?: string | null, channelSamplingRate?: number | null, channelValue?: Array<number | null> | null, channelTime?: Array<number | null> | null, interpolationMethod?: EnumSimResultDataInterpolationMethod | null, isTimeChannel?: boolean | null, unit?: string | null, _id?: any | null };

export type CarSetupUpdatedForSimulationSubscriptionVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CarSetupUpdatedForSimulationSubscription = { carSetupUpdated?: CarSetupInfoForStagingAreaVarsFragment | null };

export type SimResultAddedForSimulationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SimResultAddedForSimulationSubscription = { simResultAdded?: SimResultInfosForStagingAreaVarsFragment | null };

export type SimResultRemovedForSimulationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SimResultRemovedForSimulationSubscription = { simResultRemoved?: { _id: any } | null };

export type SimResultUpdatedForSimulationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SimResultUpdatedForSimulationSubscription = { simResultUpdated?: SimResultInfosForStagingAreaVarsFragment | null };

export type RunSheetAddedForSimulationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RunSheetAddedForSimulationSubscription = { runSheetAdded?: GetRunSheetInfoForStagingAreaVarsFragment | null };

export type RunSheetRemovedForSimulationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RunSheetRemovedForSimulationSubscription = { runSheetRemoved?: { _id?: any | null } | null };

export type RunSheetUpdatedForSimulationSubscriptionVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RunSheetUpdatedForSimulationSubscription = { runSheetUpdated?: GetRunSheetInfoForStagingAreaVarsFragment | null };

export type GetChassisSpecForChassisSpecVersionPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSpecForChassisSpecVersionPageQuery = { specification?: { _id?: any | null, name: string, rootSpecificationID: any, iterationIDs?: Array<any | null> | null, prevIterationID?: any | null, nextIterationID?: any | null, iterations: Array<ChassisSpecIterationVarsFragment> } | {} | null };

export type ChassisSpecIterationVarsFragment = { _id?: any | null, name: string, version?: string | null, releaseDate?: any | null, released?: boolean | null, createdAt?: any | null, updatedAt?: any | null, decommissioned?: boolean | null, simulationAvailable?: boolean | null, prevIterationID?: any | null, nextIterationID?: any | null, allowableParentSpecIDs?: Array<any | null> | null };

export type GetSpecificationGroupsAndCustomSpecificationsByChassisSpecIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSpecificationGroupsAndCustomSpecificationsByChassisSpecIdQuery = { specification?: SpecificationForSpecGroupsFragment | {} | null };

export type GetSpecificationGroupByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSpecificationGroupByIdQuery = { specificationGroup?: { _id: any, name: string, specifications: Array<SpecificationOnSpecificationGroupFragment> } | null };

export type GetCustomSpecificationByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCustomSpecificationByIdQuery = { specification?: CustomSpecificationItemFragment | {} | null };

export type GetChassisSpecInfoForCustomSpecPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSpecInfoForCustomSpecPageQuery = { specification?: { released?: boolean | null } | {} | null };

export type AddSpecificationOnSpecificationGroupMutationVariables = Exact<{
  record: CreateOneSpecificationInput;
}>;


export type AddSpecificationOnSpecificationGroupMutation = { addSpecification?: { recordId?: any | null } | null };

export type DeleteSpecificationOnSpecificationGroupMutationVariables = Exact<{
  specificationId: Scalars['MongoID']['input'];
}>;


export type DeleteSpecificationOnSpecificationGroupMutation = { removeSpecification?: { recordId?: any | null } | null };

export type AddSpecificationGroupMutationVariables = Exact<{
  record: CreateOneSpecificationGroupInput;
  chassisSpecID: Scalars['MongoID']['input'];
}>;


export type AddSpecificationGroupMutation = { addSpecificationGroup?: { recordId?: any | null } | null };

export type UpdateSpecificationGroupMutationVariables = Exact<{
  specificationGroupId: Scalars['MongoID']['input'];
  record: UpdateByIdSpecificationGroupInput;
}>;


export type UpdateSpecificationGroupMutation = { updateSpecificationGroup?: { recordId?: any | null } | null };

export type DeleteSpecificationGroupMutationVariables = Exact<{
  specificationGroupId: Scalars['MongoID']['input'];
}>;


export type DeleteSpecificationGroupMutation = { removeSpecificationGroup?: { recordId?: any | null } | null };

export type SpecificationForSpecGroupsFragment = { _id?: any | null, createdAt?: any | null, name: string, prevIterationID?: any | null, released?: boolean | null, specificationGroupIDs?: Array<any | null> | null, updatedAt?: any | null, customSpecs: Array<{ _id?: any | null, drawingNumber?: string | null, manufacturerReference?: string | null, name: string, reference?: string | null, specificationGroupID?: any | null }>, specificationGroups: Array<{ _id: any, name: string, specifications: Array<{ _id: any, name: string }> }> };

export type CustomSpecificationItemFragment = { _id?: any | null, buildSheetDisplayLocationID?: any | null, allowableSockets?: Array<string | null> | null, chassisSpecID?: any | null, createdAt?: any | null, decommissioned?: boolean | null, description?: string | null, drawingNumber?: string | null, manufacturerID?: any | null, manufacturerReference?: string | null, name: string, readingsRequired?: EnumCustomSpecReadingsRequired | null, reference?: string | null, rootSpecificationID: any, simulationModels?: any | null, trackingItemIDs?: Array<any | null> | null, trackingMeasurementIDs?: Array<any | null> | null, updatedAt?: any | null, adjustableProperties?: Array<AdjustableAccelerationPropertyVarsFragment | AdjustableAnglePropertyVarsFragment | AdjustableAngularCompliancePropertyVarsFragment | AdjustableAngularTorqueCompliancePropertyVarsFragment | AdjustableBooleanPropertyVarsFragment | AdjustableCompliancePropertyVarsFragment | AdjustableForcePropertyVarsFragment | AdjustableInertiaPropertyVarsFragment | AdjustableLengthPropertyVarsFragment | AdjustableLocationPropertyVarsFragment | AdjustableMassPropertyVarsFragment | AdjustableNumberPropertyVarsFragment | AdjustableOrientationPropertyVarsFragment | AdjustablePowerPropertyVarsFragment | AdjustablePressurePropertyVarsFragment | AdjustableRatioPropertyVarsFragment | AdjustableSpringRatePropertyVarsFragment | AdjustableSteeringRackRatioPropertyVarsFragment | AdjustableStringPropertyVarsFragment | AdjustableTemperaturePropertyVarsFragment | AdjustableTorquePropertyVarsFragment | AdjustableTorsionRatePropertyVarsFragment | AdjustableVolumePropertyVarsFragment | null> | null, chassisSpec?: { measurements?: ChassisMeasurementVarsFragment | null } | {} | null, customTables?: Array<{ name?: string | null, table?: AllTableVarsFragment | null } | null> | null, massProperties?: { mass?: number | null, COGx?: number | null, COGy?: number | null, COGz?: number | null, Ixx?: number | null, Iyy?: number | null, Izz?: number | null } | null, trackingItems: Array<(
    { measurementImage?: string | null, trackingSource?: TrackingSourceForGetTrackingSourcesByChassisSpecIdVarsFragment | null }
    & AllTrackingItemScalarVarsFragment
  ) | null>, trackingMeasurements: Array<AllTrackingMeasurementScalarVarsFragment> };

export type SpecificationOnSpecificationGroupFragment = { _id: any, name: string };

export type GetBuildSheetGroupEnumsQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyUserEnumInput>;
}>;


export type GetBuildSheetGroupEnumsQuery = { userEnums?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetTrackingItemByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTrackingItemByIdQuery = { trackingItem?: { _id: any, name: string, active?: boolean | null, trackingSourceID?: any | null, specificationID?: any | null, displayUnit?: EnumDisplayUnit | null, description?: string | null, resettable?: boolean | null, cumulativeCalculation?: boolean | null, defaultValue?: number | null, warningValue?: number | null, criticalCumulativeValue?: number | null, warningCumulativeValue?: number | null, criticalValue?: number | null, operator?: EnumTrackingItemOperator | null, isDefault?: boolean | null } | null };

export type GetTrackingItemByIdForTrackingItemFieldsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTrackingItemByIdForTrackingItemFieldsQuery = { trackingItem?: { measurementImage?: string | null } | null };

export type CustomSpecs_Helpers_AddChassisSpecificationMutationVariables = Exact<{
  record: CreateOneSpecificationInput;
}>;


export type CustomSpecs_Helpers_AddChassisSpecificationMutation = { addSpecification?: { recordId?: any | null } | null };

export type CustomSpecs_Helpers_AddSpecificationGroupMutationVariables = Exact<{
  record: CreateOneSpecificationGroupInput;
  chassisSpecID: Scalars['MongoID']['input'];
}>;


export type CustomSpecs_Helpers_AddSpecificationGroupMutation = { addSpecificationGroup?: { recordId?: any | null } | null };

export type CustomSpecs_Helpers_AddSpecificationMutationVariables = Exact<{
  record: CreateOneSpecificationInput;
}>;


export type CustomSpecs_Helpers_AddSpecificationMutation = { addSpecification?: { recordId?: any | null } | null };

export type CustomSpecs_Helpers_AddSpecificationOnSpecificationGroupMutationVariables = Exact<{
  record: CreateOneSpecificationInput;
}>;


export type CustomSpecs_Helpers_AddSpecificationOnSpecificationGroupMutation = { addSpecification?: { recordId?: any | null } | null };

export type UpdateCustomSimulationModelsMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  currentChassisSpecId: Scalars['MongoID']['input'];
  customSimulationModels: Array<InputMaybe<UpdateByIdSpecificationCustomSimulationModelsInput>> | InputMaybe<UpdateByIdSpecificationCustomSimulationModelsInput>;
}>;


export type UpdateCustomSimulationModelsMutation = { updateSpecification?: { recordId?: any | null } | null };

export type GetTrackingSourcesByChassisSpecIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTrackingSourcesByChassisSpecIdQuery = { specification?: ChassisSpecForGetTrackingSourcesByChassisSpecIdVarsFragment | {} | null };

export type ChassisSpecForGetTrackingSourcesByChassisSpecIdVarsFragment = { _id?: any | null, createdAt?: any | null, name: string, trackingSourceIDs?: Array<any | null> | null, released?: boolean | null, rootSpecificationID: any, updatedAt?: any | null, trackingSources: Array<TrackingSourceForGetTrackingSourcesByChassisSpecIdVarsFragment> };

export type TrackingSourceForGetTrackingSourcesByChassisSpecIdVarsFragment = { _id: any, description?: string | null, displayUnit?: EnumDisplayUnit | null, name: string, NDecimals?: number | null, sourceIDs?: Array<any | null> | null, sources: Array<{ _id: any, aliasString?: string | null, aliasType?: EnumTrackingSourceAliasAliasType | null, description?: string | null, displayUnit?: EnumDisplayUnit | null, priority?: number | null }> };

export type AddTrackingSourceMutationVariables = Exact<{
  record: CreateOneTrackingSourceInput;
}>;


export type AddTrackingSourceMutation = { addTrackingSource?: { recordId?: any | null } | null };

export type UpdateTrackingSourceMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingSourceInput;
}>;


export type UpdateTrackingSourceMutation = { updateTrackingSource?: { recordId?: any | null } | null };

export type RemoveTrackingSourceFromChassisSpecMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTrackingSourceFromChassisSpecMutation = { removeTrackingSource?: { recordId?: any | null } | null };

export type AddTrackingSourceAliasMutationVariables = Exact<{
  record: CreateOneTrackingSourceAliasInput;
}>;


export type AddTrackingSourceAliasMutation = { addTrackingSourceAlias?: { recordId?: any | null } | null };

export type UpdateTrackingSourceAliasMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingSourceAliasInput;
}>;


export type UpdateTrackingSourceAliasMutation = { updateTrackingSourceAlias?: { recordId?: any | null, record?: { aliasString?: string | null, aliasType?: EnumTrackingSourceAliasAliasType | null, description?: string | null, displayUnit?: EnumDisplayUnit | null, priority?: number | null } | null } | null };

export type RemoveTrackingSourceAliasFromChassisSpecMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTrackingSourceAliasFromChassisSpecMutation = { removeTrackingSourceAlias?: { recordId?: any | null } | null };

export type GetBuildSheetStyleListForChassisSpecQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBuildSheetStyleListForChassisSpecQuery = { buildSheetStyles?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetChassisSpecForIdPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSpecForIdPageQuery = { specification?: AllChassisSpecVarsFragment | {} | null };

export type GetReferencePackagesForChassisSpecQueryVariables = Exact<{
  chassisSpecID: Scalars['MongoID']['input'];
}>;


export type GetReferencePackagesForChassisSpecQuery = { packages?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type CompareChassisSpecsQueryVariables = Exact<{
  chassisSpecId: Scalars['MongoID']['input'];
  chassisSpecToCompareId: Scalars['MongoID']['input'];
}>;


export type CompareChassisSpecsQuery = { compareChassisSpecs: boolean };

export type GetAllSpecificationsForChassisQueryVariables = Exact<{
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetAllSpecificationsForChassisQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string }> | null } | null };

export type EnforceLatestVersionChassisSpecVersionOnCarSetupsMutationVariables = Exact<{
  rootSpecificationID: Scalars['MongoID']['input'];
  timeRangeStart?: InputMaybe<Scalars['Date']['input']>;
  timeRangeEnd?: InputMaybe<Scalars['Date']['input']>;
}>;


export type EnforceLatestVersionChassisSpecVersionOnCarSetupsMutation = { updateChassisSpecVersionOnCarSetups?: { success?: boolean | null } | null };

export type GetChassisSpecByIdForChassisSpecEditPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSpecByIdForChassisSpecEditPageQuery = { specification?: AllChassisSpecVarsFragment | {} | null };

export type GetCarDataServiceCalculationsForCarDataServiceConfigQueryVariables = Exact<{
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCalculationInput>;
  filter: FilterFindManyCalculationInput;
}>;


export type GetCarDataServiceCalculationsForCarDataServiceConfigQuery = { calculations?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<CalculationVarsForCarDataServiceCalculationPageFragment> | null } | null };

export type CalculationVarsForCarDataServiceCalculationPageFragment = { _id: any, functionString: string, isActive: boolean, name?: string | null, parameter: string };

export type GetCalculationParameterNamesForDataServiceConfigQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GetCalculationParameterNamesForDataServiceConfigQuery = { calculations?: { items?: Array<{ parameter: string }> | null } | null };

export type GetCarDataServiceConfigForDownloadButtonQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCarDataServiceConfigForDownloadButtonQuery = { carDataServiceConfig?: CarDataServiceConfigForDownloadButtonVarsFragment | null };

export type CarDataServiceConfigForDownloadButtonVarsFragment = { name: string, ORHCalculationIDs?: Array<any | null> | null, ParameterMap?: any | null, Kpi?: { KpiParameters?: Array<string | null> | null, Preconditions?: Array<string | null> | null } | null, PostProcessingConfig?: { ApplicationSettingsConfiguration?: { ProcessedFolder?: string | null, ResultsFolder?: string | null, FunctionsFolder?: string | null, RunsheetMatching?: EnumCarDataServiceApplicationSettingsConfigRunsheetMatching | null, DriverContestantLookup?: any | null, PitstopTriggers?: Array<{ ParameterId: string, Value: number, Type?: EnumCarDataServicePitstopTriggerType | null } | null> | null } | null, ProcessingEnginesConfiguration?: { ImportersFolder?: string | null, ParameterMapFile?: string | null, InternalCalculationsFolder?: string | null, UserCalculationsFolder?: string | null, ExportersFolder?: string | null, ProcessingEngineConfiguration?: Array<{ Name: string, QueueName: string, Instances: number, Importer: EnumCarDataServiceProcessingEngineConfigImporter, Calculations: Array<string | null>, Exporters?: { ATLAS10_EXPORTER?: any | null, JSONFILE_EXPORTER?: any | null, ONERACEHUB_EXPORTER?: any | null, WINTAX_EXPORTER?: { DISTANCE_CHANNEL?: string | null, FUEL_CONSUMPTION?: string | null, FUEL_LEVEL?: string | null, LAP_DISTANCE?: string | null, OUTPUT_PATH?: string | null, TELDATAZTX_PATH?: string | null } | null } | null } | null> | null } | null, EventConfiguration?: { EventId: any, EventDescription?: string | null } | null, QueueManagerConfiguration?: { Queues?: Array<{ Name: string, SessionType: string } | null> | null } | null, SessionManagerConfiguration?: { OffloadFolder: string, OffloadSessionTypes?: Array<string | null> | null } | null, SessionTypesConfiguration?: { SessionTypes?: Array<{ name: string, exts: Array<string | null>, regExpressions: Array<string | null>, folderUpLevel: number, ignoreLiterals?: Array<string | null> | null } | null> | null } | null } | null };

export type AddCarDataServiceConfigForUploadCarDataServiceConfigButtonMutationVariables = Exact<{
  record: CreateOneCarDataServiceConfigInput;
}>;


export type AddCarDataServiceConfigForUploadCarDataServiceConfigButtonMutation = { addCarDataServiceConfig?: { recordId?: any | null } | null };

export type CarDataServiceConfig_CreateNewConfigMutationVariables = Exact<{
  record: CreateOneCarDataServiceConfigInput;
}>;


export type CarDataServiceConfig_CreateNewConfigMutation = { addCarDataServiceConfig?: { record?: { _id: any } | null } | null };

export type GetTimingServiceConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimingServiceConfigsQuery = { timingServiceConfigs?: { items?: Array<{ _id: any, name: string, timingPort?: number | null, timingRaceSeries?: string | null, timingURL?: string | null, active?: boolean | null, eventID?: any | null }> | null } | null };

export type GetTimingServiceConfigForTimingServiceConfigPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTimingServiceConfigForTimingServiceConfigPageQuery = { timingServiceConfig?: { _id: any, active?: boolean | null, createdAt?: any | null, description?: string | null, eventID?: any | null, fallbackScheduleBasedSessionMatching?: boolean | null, fallbackTimedSectorsCount?: number | null, followedCarNumbers?: Array<string | null> | null, liveStandingsActive?: boolean | null, logLevel?: EnumTimingServiceConfigLogLevel | null, logStream?: boolean | null, name: string, strictSessionNameMatching?: boolean | null, timingPort?: number | null, timingRaceSeries?: string | null, timingURL?: string | null, updatedAt?: any | null, writeData?: boolean | null } | null };

export type UpdateTimingServiceConfigForMultipleEventsControllerMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTimingServiceConfigInput;
}>;


export type UpdateTimingServiceConfigForMultipleEventsControllerMutation = { updateTimingServiceConfig?: { recordId?: any | null } | null };

export type RemoveTimingServiceConfigForMultipleEventsControllerMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTimingServiceConfigForMultipleEventsControllerMutation = { removeTimingServiceConfig?: { recordId?: any | null } | null };

export type SetAllTimingServiceConfigsInactiveMutationVariables = Exact<{ [key: string]: never; }>;


export type SetAllTimingServiceConfigsInactiveMutation = { setAllTimingServiceConfigsInactive?: { modifiedCount?: number | null } | null };

export type GetSessionNamesForTimingConfigQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSessionNamesForTimingConfigQuery = { event?: { sessions: Array<SessionInfoVarsForTimingConfigPageFragment> } | null };

export type SessionInfoVarsForTimingConfigPageFragment = { _id: any, name: string, shortName?: string | null, tSessionEnd?: any | null, tSessionStart?: any | null };

export type GetEventNameForTimingConfigQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEventNameForTimingConfigQuery = { event?: { name: string } | null };

export type GetOneTimingWeatherServiceConfigQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetOneTimingWeatherServiceConfigQuery = { oneTimingWeatherServiceConfig?: OneTimingWeatherConfigVarsFragment | null };

export type GetOneTimingWeatherConfigsForAgentPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOneTimingWeatherConfigsForAgentPageQuery = { oneTimingWeatherServiceConfigs?: { items?: Array<OneTimingWeatherConfigVarsFragment> | null } | null };

export type OneTimingWeatherConfigVarsFragment = { _id: any, name: string, active?: boolean | null, eventIDs?: Array<any | null> | null, timingPort: number, timingURL: string };

export type OneTimingWeatherServiceConfigUpdatedSubscriptionVariables = Exact<{
  configID: Scalars['MongoID']['input'];
}>;


export type OneTimingWeatherServiceConfigUpdatedSubscription = { oneTimingWeatherServiceConfigUpdated?: OneTimingWeatherConfigVarsFragment | null };

export type RemoveOneTimingWeatherServiceConfigMutationVariables = Exact<{
  configID: Scalars['MongoID']['input'];
}>;


export type RemoveOneTimingWeatherServiceConfigMutation = { removeOneTimingWeatherServiceConfig?: { recordId?: any | null } | null };

export type UpdateOneTimingWeatherServiceConfigMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdOneTimingWeatherServiceConfigInput;
}>;


export type UpdateOneTimingWeatherServiceConfigMutation = { updateOneTimingWeatherServiceConfig?: { recordId?: any | null } | null };

export type AddOneTimingWeatherServiceConfigMutationVariables = Exact<{
  record: CreateOneOneTimingWeatherServiceConfigInput;
}>;


export type AddOneTimingWeatherServiceConfigMutation = { addOneTimingWeatherServiceConfig?: { recordId?: any | null } | null };

export type AddHistoricalWeatherMutationVariables = Exact<{
  weatherServiceConfigID: Scalars['MongoID']['input'];
}>;


export type AddHistoricalWeatherMutation = { addHistoricalWeather?: { _id: any } | null };

export type GetWeatherServiceConfigQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetWeatherServiceConfigQuery = { weatherServiceConfig?: WeatherServiceConfigVarsFragment | null };

export type GetWeatherServiceConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWeatherServiceConfigsQuery = { weatherServiceConfigs?: { items?: Array<(
      { events: Array<{ name: string }> }
      & WeatherServiceConfigVarsFragment
    )> | null } | null };

export type WeatherServiceConfigVarsFragment = { _id: any, apiKey?: string | null, apiSecret?: string | null, eventIDs?: Array<any | null> | null, isActive?: boolean | null, name?: string | null, refreshInterval: number, requestType: EnumWeatherServiceConfigRequestType, source: EnumWeatherServiceConfigSource, type: EnumWeatherServiceConfigType, weatherStationID?: string | null, requestLocation?: { coordinates: Array<number | null>, type: EnumGeoLocationType } | null };

export type UpdateWeatherServiceConfigMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdWeatherServiceConfigInput;
}>;


export type UpdateWeatherServiceConfigMutation = { updateWeatherServiceConfig?: { recordId?: any | null } | null };

export type WeatherServiceConfigUpdatedSubscriptionVariables = Exact<{
  weatherServiceConfigID: Scalars['MongoID']['input'];
}>;


export type WeatherServiceConfigUpdatedSubscription = { weatherServiceConfigUpdated?: { _id: any, isActive?: boolean | null } | null };

export type CreateWeatherServiceConfigMutationVariables = Exact<{
  record: CreateOneWeatherServiceConfigInput;
}>;


export type CreateWeatherServiceConfigMutation = { addWeatherServiceConfig?: { recordId?: any | null } | null };

export type RemoveWeatherServiceConfigMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveWeatherServiceConfigMutation = { removeWeatherServiceConfig?: { recordId?: any | null } | null };

export type GetDataOverviewCarSetupsQueryVariables = Exact<{
  filter: FilterFindManyCarSetupInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCarSetupInput>;
}>;


export type GetDataOverviewCarSetupsQuery = { carSetups?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ _id: any, title: string, runSheet?: { _id: any, NRun?: number | null, session?: { _id: any, name: string, event?: { _id: any, name: string } | null } | null } | null, info?: { NIssue?: number | null } | null, engineer?: { _id: any, name: string } | null }> | null } | null };

export type GetDataOverviewTyresQueryVariables = Exact<{
  filter: FilterFindManyTyreInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTyreInput>;
}>;


export type GetDataOverviewTyresQuery = { tyres?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ _id: any, name?: string | null }> | null } | null };

export type GetTyreWearsForTyrePageQueryVariables = Exact<{
  filter: FilterFindManyTyreWearInput;
}>;


export type GetTyreWearsForTyrePageQuery = { tyreWears?: { items?: Array<TyreWearItemsForTyreWearListVarsFragment> | null } | null };

export type TyreWearItemsForTyreWearListVarsFragment = { _id: any, date?: any | null, runSheetID?: any | null, wearMarkers?: any | null };

export type GetSsoProviderSetupListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSsoProviderSetupListQuery = { ssoProviders: Array<{ _id: any, name: string, clientID: string, clientSecret: string, issuerURL: string }> };

export type AddSsoProviderMutationVariables = Exact<{
  name: Scalars['String']['input'];
  issuerURL: Scalars['String']['input'];
  clientID: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
}>;


export type AddSsoProviderMutation = { addSsoProvider?: { record?: { _id: any, name: string, issuerURL: string, clientID: string, clientSecret: string } | null, error?: { message?: string | null } | { message?: string | null } | { message?: string | null } | null } | null };

export type RemoveSsoProviderMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveSsoProviderMutation = { removeSsoProvider?: { recordId?: any | null, error?: { message?: string | null } | { message?: string | null } | { message?: string | null } | null } | null };

export type GetAssemblyTemplatesForAssemblyTemplateListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssemblyTemplatesForAssemblyTemplateListQuery = { assemblyTemplates?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetAssemblyTemplateForAssemblyTemplateEditPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetAssemblyTemplateForAssemblyTemplateEditPageQuery = { assemblyTemplate?: { _id: any, description?: string | null, name: string, requiredParts?: Array<{ location?: EnumAssemblyTemplateRequiredPartsLocation | null, userEnumPartTypeID?: any | null } | null> | null } | null };

export type GetPartTypeUserEnumsForAssemblyTemplateEditPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartTypeUserEnumsForAssemblyTemplateEditPageQuery = { userEnums?: { items?: Array<{ _id?: any | null, name: string, type: EnumUserEnumPartTypeType } | {}> | null } | null };

export type GetCalculationsForCalculationManagerPageQueryVariables = Exact<{
  filter: FilterFindManyCalculationInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCalculationInput>;
}>;


export type GetCalculationsForCalculationManagerPageQuery = { calculations?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<CalculationVarsFragment> | null } | null };

export type GetLapSequenceListForTemplatePageQueryVariables = Exact<{
  filter: FilterFindManyLapSequenceInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLapSequenceInput>;
}>;


export type GetLapSequenceListForTemplatePageQuery = { lapSequences?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<LapSequenceVarsFragment> | null } | null };

export type LapSequenceVarsFragment = { _id: any, name: string, raceSeriesID?: any | null, laps: Array<{ NLap: number, lapType: EnumLapSequenceLapsLapType } | null> };

export type UpdateLapSequenceMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdLapSequenceInput;
}>;


export type UpdateLapSequenceMutation = { updateLapSequence?: { recordId?: any | null } | null };

export type RemoveLapSequenceMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveLapSequenceMutation = { removeLapSequence?: { recordId?: any | null } | null };

export type GetPackagesForApplyPackagesPageQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPackageInput>;
}>;


export type GetPackagesForApplyPackagesPageQuery = { packages?: { items?: Array<{ _id: any, chassisSpecID: any, name: string, chassisSpec?: { name: string } | null }> | null } | null };

export type GetCarSetupChassisSpecsByEventIdQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCarSetupInput>;
}>;


export type GetCarSetupChassisSpecsByEventIdQuery = { carSetupsMany: Array<{ _id: any, title: string, chassisSpec?: { _id?: any | null, name: string, version?: string | null } | null, runSheet?: { NRun?: number | null, session?: { name: string, shortName?: string | null, event?: { name: string } | null } | null } | null }> };

export type GetSessionsFromEventsForPackageApplyQueryVariables = Exact<{
  eventIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GetSessionsFromEventsForPackageApplyQuery = { sessions?: { items?: Array<{ _id: any }> | null } | null };

export type GetRunSheetsFromSessionsForPackageApplyQueryVariables = Exact<{
  sessionIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GetRunSheetsFromSessionsForPackageApplyQuery = { runSheets?: { items?: Array<{ _id: any }> | null } | null };

export type GetPackagesForPackagesPageQueryVariables = Exact<{
  filter: FilterFindManyPackageInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPackageInput>;
}>;


export type GetPackagesForPackagesPageQuery = { packages?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<PackagesForPackageManagerPageVarsFragment> | null } | null };

export type GetPackageForPackageEditPageByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPackageForPackageEditPageByIdQuery = { package?: PackagesForPackageManagerPageVarsFragment | null };

export type PackagesForPackageManagerPageVarsFragment = { _id: any, authorID?: any | null, chassisSpecID: any, isActive?: boolean | null, isPublic?: boolean | null, teamIDs?: Array<any | null> | null, name: string, useAsCopyReference?: boolean | null, author?: { name: string } | null, items?: Array<{ path?: string | null, value?: any | null } | null> | null, teams: Array<{ name: string }> };

export type GetEventDataForPackageCreateQueryVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
}>;


export type GetEventDataForPackageCreateQuery = { event?: { name: string, sessionIDs?: Array<any | null> | null, season?: { contestantIDs?: Array<any | null> | null } | null } | null };

export type GetRunSheetsForPackageCreateQueryVariables = Exact<{
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetRunSheetsForPackageCreateQuery = { runSheets?: { items?: Array<RunSheetForEventSelectionVarsFragment> | null } | null };

export type GetChassisSpecForPackageEditPageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSpecForPackageEditPageQuery = { specification?: ChassisSpecVarsForPackageEditPageVarsFragment | {} | null };

export type ChassisSpecVarsForPackageEditPageVarsFragment = { specificationGroupIDs?: Array<any | null> | null, aeroPackageSpecs: Array<{ _id?: any | null, name: string, aeroElementSpecIDs?: Array<any | null> | null, aeroElementSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, name: string }> }>, antiRollBarSpecs: Array<{ _id?: any | null, antiRollBarDisplayLocation?: EnumAntiRollBarDisplayLocation | null }>, bumpRubberSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, readingsAllowable?: Array<EnumReadingLocation> | null }>, customSpecs: Array<{ _id?: any | null, name: string, specificationGroupID?: any | null, readingsRequired?: EnumCustomSpecReadingsRequired | null, adjustableProperties?: Array<AdjustableAccelerationPropertyVarsFragment | AdjustableAnglePropertyVarsFragment | AdjustableAngularCompliancePropertyVarsFragment | AdjustableAngularTorqueCompliancePropertyVarsFragment | AdjustableBooleanPropertyVarsFragment | AdjustableCompliancePropertyVarsFragment | AdjustableForcePropertyVarsFragment | AdjustableInertiaPropertyVarsFragment | AdjustableLengthPropertyVarsFragment | AdjustableLocationPropertyVarsFragment | AdjustableMassPropertyVarsFragment | AdjustableNumberPropertyVarsFragment | AdjustableOrientationPropertyVarsFragment | AdjustablePowerPropertyVarsFragment | AdjustablePressurePropertyVarsFragment | AdjustableRatioPropertyVarsFragment | AdjustableSpringRatePropertyVarsFragment | AdjustableSteeringRackRatioPropertyVarsFragment | AdjustableStringPropertyVarsFragment | AdjustableTemperaturePropertyVarsFragment | AdjustableTorquePropertyVarsFragment | AdjustableTorsionRatePropertyVarsFragment | AdjustableVolumePropertyVarsFragment | null> | null }>, damperSpecs: Array<{ allowableSockets?: Array<string | null> | null, readingsAllowable?: Array<EnumReadingLocation> | null, _id?: any | null }>, helperSpringSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, readingsAllowable?: Array<EnumReadingLocation> | null }>, kinematicsExternalSpecs: Array<{ _id?: any | null, axle?: EnumAxle | null, aCamber?: { readingsRequired?: EnumSpecificationACamberReadingsRequired | null } | null, aCaster?: { readingsRequired?: EnumSpecificationACamberReadingsRequired | null } | null, aToe?: { readingsRequired?: EnumSpecificationACamberReadingsRequired | null } | null, hRide?: { readingsRequired?: EnumSpecificationHRideReadingsRequired | null } | null }>, kinematicsInternalSpecs: Array<{ _id?: any | null, axle?: EnumAxle | null }>, measurements?: { angles?: EnumAngleUnit | null, angularCompliances?: EnumAngularComplianceUnit | null, angularTorqueCompliances?: EnumAngularTorqueComplianceUnit | null, bumpPlateMeasurementMethod?: EnumBumpPlateMeasurementMethod | null, bumpPlateRefFront?: number | null, bumpPlateRefRear?: number | null, compliances?: EnumComplianceUnit | null, forces?: EnumForceUnit | null, inertias?: EnumInertiaUnit | null, inverseCamber?: boolean | null, kinematicsExternalReadingsRequired?: EnumChassisMeasurementsKinematicsExternalReadingsRequired | null, kinematicsInternalReadingsRequired?: EnumChassisMeasurementsKinematicsInternalReadingsRequired | null, lengths?: EnumLengthUnit | null, masses?: EnumMassUnit | null, powers?: EnumPowerUnit | null, pressures?: EnumPressureUnit | null, ratios?: EnumRatioUnit | null, rideHeightCalcFront?: string | null, rideHeightCalcRear?: string | null, springRates?: EnumSpringRateUnit | null, steeringRackRatios?: EnumSteeringRackRatioUnit | null, temperatures?: EnumTemperatureUnit | null, toeMeasurementMethod?: EnumToeMeasurementMethod | null, toeRefFront?: number | null, toeRefRear?: number | null, torques?: EnumTorqueUnit | null, torsionRates?: EnumTorsionRateUnit | null, volumes?: EnumVolumeUnit | null, xTrackFront?: number | null, xTrackRear?: number | null, xWheelbase?: number | null } | null, powertrain?: { layout?: EnumPowertrainLayout | null, numGears?: number | null, bevelSetSpecIDs?: Array<any | null> | null, differentialSpecIDs?: Array<any | null> | null, dropGearSpecIDs?: Array<any | null> | null, gearBoxSpecIDs?: Array<any | null> | null, gearSpecIDs?: Array<any | null> | null, bevelSetSpecs: Array<{ _id?: any | null }>, differentialSpecs: Array<{ _id?: any | null, powertrainLocation?: EnumSpecificationPowertrainLocation | null }>, dropGearSpecs: Array<{ _id?: any | null }>, gearBoxSpecs: Array<{ _id?: any | null }>, gearSpecs: Array<{ _id?: any | null }> } | null, reboundSpringSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, readingsAllowable?: Array<EnumReadingLocation> | null }>, specificationGroups: Array<SpecificationGroupVarsFragment>, springSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, readingsAllowable?: Array<EnumReadingLocation> | null }>, torsionBarSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, readingsAllowable?: Array<EnumReadingLocation> | null }> };

export type SpecificationGroupVarsFragment = { _id: any, name: string, specifications: Array<{ name: string, readingsRequired?: EnumSpecificationReadingsRequired | null, adjustableProperties?: Array<{ name: string, index?: number | null } | null> | null }> };

export type GetChassisSpecIdForCarSetupQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSpecIdForCarSetupQuery = { carSetup?: { chassisSpecID?: any | null } | null };

export type GetPartsBySpecIdForPackagePageQueryVariables = Exact<{
  specID: Scalars['MongoID']['input'];
}>;


export type GetPartsBySpecIdForPackagePageQuery = { partsAdvancedFilter?: { items?: Array<{ _id: any, reference: string, specification?: { _id: any, hasToBeInSubAssembly?: boolean | null, name: string } | null } | null> | null } | null };

export type ClonePackageMutationVariables = Exact<{
  packageID: Scalars['MongoID']['input'];
  name: Scalars['String']['input'];
}>;


export type ClonePackageMutation = { clonePackage?: { recordId: any } | null };

export type GetSessionDebriefTemplatesQueryVariables = Exact<{
  mode?: InputMaybe<EnumTemplateSessionDebriefMode>;
}>;


export type GetSessionDebriefTemplatesQuery = { sessionDebriefs?: { count?: number | null, items?: Array<{ _id: any, title: string, text: string, mode?: EnumTemplateSessionDebriefMode | null }> | null } | null };

export type RemoveSessionDebriefTemplateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveSessionDebriefTemplateMutation = { removeSessionDebriefTemplate?: { recordId?: any | null, error?: { message?: string | null } | { message?: string | null } | { message?: string | null } | null } | null };

export type AddSessionDebriefTemplateMutationVariables = Exact<{
  record: CreateOneTemplateSessionDebriefInput;
}>;


export type AddSessionDebriefTemplateMutation = { addSessionDebriefTemplate?: { recordId?: any | null, error?: { message?: string | null } | { message?: string | null } | { message?: string | null } | null } | null };

export type GetChassisSpecElementsForChassisSpecIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSpecElementsForChassisSpecIdQuery = { specification?: ChassisSpecVarsForChassisSpecElementsFragment | {} | null };

export type ChassisSpecVarsForChassisSpecElementsFragment = { _id?: any | null, specificationGroupIDs?: Array<any | null> | null, aeroPackageSpecs: Array<{ _id?: any | null, name: string, aeroElementSpecIDs?: Array<any | null> | null, aeroElementSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, name: string }> }>, antiRollBarSpecs: Array<{ _id?: any | null, antiRollBarDisplayLocation?: EnumAntiRollBarDisplayLocation | null, rootSpecificationID: any }>, bumpRubberSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, readingsAllowable?: Array<EnumReadingLocation> | null, rootSpecificationID: any }>, customSpecs: Array<{ _id?: any | null, name: string, readingsRequired?: EnumCustomSpecReadingsRequired | null, rootSpecificationID: any, specificationGroupID?: any | null, trackingItemIDs?: Array<any | null> | null, adjustableProperties?: Array<AdjustableAccelerationPropertyVarsFragment | AdjustableAnglePropertyVarsFragment | AdjustableAngularCompliancePropertyVarsFragment | AdjustableAngularTorqueCompliancePropertyVarsFragment | AdjustableBooleanPropertyVarsFragment | AdjustableCompliancePropertyVarsFragment | AdjustableForcePropertyVarsFragment | AdjustableInertiaPropertyVarsFragment | AdjustableLengthPropertyVarsFragment | AdjustableLocationPropertyVarsFragment | AdjustableMassPropertyVarsFragment | AdjustableNumberPropertyVarsFragment | AdjustableOrientationPropertyVarsFragment | AdjustablePowerPropertyVarsFragment | AdjustablePressurePropertyVarsFragment | AdjustableRatioPropertyVarsFragment | AdjustableSpringRatePropertyVarsFragment | AdjustableSteeringRackRatioPropertyVarsFragment | AdjustableStringPropertyVarsFragment | AdjustableTemperaturePropertyVarsFragment | AdjustableTorquePropertyVarsFragment | AdjustableTorsionRatePropertyVarsFragment | AdjustableVolumePropertyVarsFragment | null> | null }>, damperSpecs: Array<{ allowableSockets?: Array<string | null> | null, readingsAllowable?: Array<EnumReadingLocation> | null, rootSpecificationID: any, _id?: any | null }>, helperSpringSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, readingsAllowable?: Array<EnumReadingLocation> | null, rootSpecificationID: any }>, kinematicsExternalSpecs: Array<{ _id?: any | null, axle?: EnumAxle | null, aCamber?: { readingsRequired?: EnumSpecificationACamberReadingsRequired | null } | null, aCaster?: { readingsRequired?: EnumSpecificationACamberReadingsRequired | null } | null, aToe?: { readingsRequired?: EnumSpecificationACamberReadingsRequired | null } | null, hRide?: { readingsRequired?: EnumSpecificationHRideReadingsRequired | null } | null }>, kinematicsInternalSpecs: Array<{ _id?: any | null, axle?: EnumAxle | null }>, measurements?: { toeMeasurementMethod?: EnumToeMeasurementMethod | null } | null, powertrain?: { layout?: EnumPowertrainLayout | null, numGears?: number | null, bevelSetSpecIDs?: Array<any | null> | null, differentialSpecIDs?: Array<any | null> | null, dropGearSpecIDs?: Array<any | null> | null, gearBoxSpecIDs?: Array<any | null> | null, gearSpecIDs?: Array<any | null> | null, bevelSetSpecs: Array<{ _id?: any | null, rootSpecificationID: any }>, differentialSpecs: Array<{ _id?: any | null, powertrainLocation?: EnumSpecificationPowertrainLocation | null, rootSpecificationID: any }>, dropGearSpecs: Array<{ _id?: any | null, rootSpecificationID: any }>, gearBoxSpecs: Array<{ _id?: any | null, rootSpecificationID: any }>, gearSpecs: Array<{ _id?: any | null, rootSpecificationID: any }> } | null, reboundSpringSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, readingsAllowable?: Array<EnumReadingLocation> | null, rootSpecificationID: any }>, specificationGroups: Array<SpecificationGroupVarsFragment>, springSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, readingsAllowable?: Array<EnumReadingLocation> | null, rootSpecificationID: any }>, torsionBarSpecs: Array<{ _id?: any | null, allowableSockets?: Array<string | null> | null, readingsAllowable?: Array<EnumReadingLocation> | null, rootSpecificationID: any }> };

export type GetTrackingItemInfosForChassisSpecIdQueryVariables = Exact<{
  trackingItemIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GetTrackingItemInfosForChassisSpecIdQuery = { trackingItems?: { items?: Array<TrackingItemVarsForChassisSpecIdFragment> | null } | null };

export type TrackingItemVarsForChassisSpecIdFragment = { _id: any, name: string, specificationID?: any | null };

export type UpgradeChassisSpecOnSetupSheetLayoutMutationVariables = Exact<{
  setupSheetLayoutID: Scalars['MongoID']['input'];
  chassisSpecID: Scalars['MongoID']['input'];
}>;


export type UpgradeChassisSpecOnSetupSheetLayoutMutation = { updateSetupSheetLayoutChassisSpec?: { status?: string | null } | null };

export type GetTimeSheetEntriesForPersonAndProjectQueryVariables = Exact<{
  personID: Scalars['MongoID']['input'];
  projectID: Scalars['MongoID']['input'];
  tStart?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetTimeSheetEntriesForPersonAndProjectQuery = { timeSheetEntries?: { items?: Array<{ _id: any, absent?: boolean | null, approvedAt?: any | null, tEnd?: any | null, tStart: any, person?: { name: string } | null }> | null } | null };

export type GetRunSheetsForTyrePressureCalculationQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  contestantIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetsForTyrePressureCalculationQuery = { runSheets?: { items?: Array<RunSheetVarsForTyrePressureCalculationFragment> | null } | null };

export type RunSheetVarsForTyrePressureCalculationFragment = { _id: any, NRun?: number | null, NRunTiming?: number | null, sessionID?: any | null, tyreSetID?: any | null, tyreFL?: RunTyreVarsFragment | null, tyreFR?: RunTyreVarsFragment | null, tyreRL?: RunTyreVarsFragment | null, tyreRR?: RunTyreVarsFragment | null, tyreSet?: { name?: string | null } | null, weather?: { TAir?: number | null, TTrack?: number | null, pAmbient?: number | null, rHumidity?: number | null, DAir?: number | null, TAirOfficial?: number | null, TTrackOfficial?: number | null } | null, laps: Array<{ _id: any, tLapMax?: number | null }> };

export type GetTyrePressureSheetQueryVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
  contestantID: Scalars['MongoID']['input'];
}>;


export type GetTyrePressureSheetQuery = { tyrePressureSheet: TyrePressureSheetVarsFragment };

export type UpdateTyrePressureSheetMutationVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
  record: TyrePressureSheetInput;
  contestantID: Scalars['MongoID']['input'];
}>;


export type UpdateTyrePressureSheetMutation = { updateTyrePressureSheet: { _id: any } };

export type UpdateTyrePressureSheetDataMutationVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
  contestantID: Scalars['MongoID']['input'];
  sessionID: Scalars['MongoID']['input'];
  tyreSetID: Scalars['MongoID']['input'];
  record: TyreSetupDataInput;
}>;


export type UpdateTyrePressureSheetDataMutation = { updateTyrePressureSheetData: { _id: any } };

export type TyrePressureSheetVarsFragment = { eventID?: any | null, contestantID?: any | null, pressureUnit?: EnumPressureUnit | null, temperatureUnit?: EnumTemperatureUnit | null, _id: any, tyrePressureSettings: TyrePressureCalculationSettingsFragment, sessions?: Array<TyrePressureSheetSessionVarsFragment | null> | null };

export type TyrePressureSheetSessionVarsFragment = { sessionID: any, session?: { name: string } | null, tyreSetupData: Array<TyreSetupDataVarsFragment> };

export type TyreCornersFragment = { FL?: number | null, FR?: number | null, RL?: number | null, RR?: number | null };

export type TyrePressureCalculationSettingsFragment = { rTrackTempShortRun?: number | null, rTrackTempLongRun?: number | null, rRimTempTeam?: number | null, rRimTempRegulation?: number | null, rColdToHotTeam?: number | null, TRimReference?: number | null, TTrackReference?: number | null };

export type TyreSetupDataVarsFragment = { tyreSetID: any, comment?: string | null, selected: boolean, TTrackExpected?: number | null, rTrackTemperature?: number | null, tyreSet?: { name?: string | null } | null, TRimSetup: TyreCornersFragment, pTyreSetup: TyreCornersFragment, pTyreTarget: TyreCornersFragment, pTyreReference: TyreCornersFragment };

export type GetPartsForTyreBarcodeScanningQueryVariables = Exact<{
  partNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPartsForTyreBarcodeScanningQuery = { parts?: { items?: Array<{ _id: any, partNumber?: string | null }> | null } | null };

export type GetRimInfoForTyreBarcodeScanningQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRimInfoForTyreBarcodeScanningQuery = { part?: { _id: any, partNumber?: string | null, trackingHistory: Array<{ _id: any, value?: number | null, trackingItem?: { name: string } | null }> } | null };

export type GetTyreIdsForEventContestantQueryVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
}>;


export type GetTyreIdsForEventContestantQuery = { event?: { _id: any, name: string, contestants?: Array<{ _id: any, tyreIDs?: Array<any | null> | null, tyreSetIDs?: Array<any | null> | null } | null> | null } | null };

export type GetTyreInfoForEventContestantQueryVariables = Exact<{
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetTyreInfoForEventContestantQuery = { tyres?: { items?: Array<(
      { _id: any }
      & TyreVarsFragment
    )> | null } | null, tyreSets?: { items?: Array<(
      { _id: any }
      & TyreSetVarsFragment
    )> | null } | null };

export type GetExportInfoForDmsbQueryVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
}>;


export type GetExportInfoForDmsbQuery = { contestant?: { _id: any, startNumber: string } | null, event?: { _id: any, name: string } | null };

export type GetDataForEventTyreTableQueryVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
}>;


export type GetDataForEventTyreTableQuery = { event?: { _id: any, eventType?: string | null, name: string, NEventSeason?: number | null, sessionIDs?: Array<any | null> | null, tEventEnd?: any | null, tEventStart?: any | null, tLapAverage?: number | null, contestants?: Array<{ _id: any, tyreIDs?: Array<any | null> | null, tyreSetIDs?: Array<any | null> | null, tyreSets: Array<TyreSetVarsFragment> } | null> | null, sessions: Array<(
      { _id: any, sessionType?: EnumSessionType | null }
      & SessionWithTimesVarsFragment
    )>, track?: { _id: any, timeZone?: string | null } | null } | null, contestant?: { _id: any, class?: string | null, driverIDs?: Array<any | null> | null, hidden?: boolean | null, startNumber: string, drivers: Array<{ _id: any, acronym?: string | null }>, tyres: Array<(
      { _id: any }
      & TyreVarsFragment
    )> } | null };

export type GetDataForTyresForEventTyreTableQueryVariables = Exact<{
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  sessionIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GetDataForTyresForEventTyreTableQuery = { runSheets?: { items?: Array<{ _id: any, mileage?: number | null, tyreSetID?: any | null, session?: { _id: any, shortName?: string | null, event?: { _id: any, name: string } | null } | null, tyreFL?: { tyreID?: any | null } | null, tyreRL?: { tyreID?: any | null } | null, tyreRR?: { tyreID?: any | null } | null, tyreFR?: { tyreID?: any | null } | null }> | null } | null, tyres?: { items?: Array<(
      { _id: any }
      & TyreVarsFragment
    )> | null } | null, tyreSets?: { items?: Array<(
      { _id: any }
      & TyreSetVarsFragment
    )> | null } | null };

export type GetTyreMileageGraphQueryVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  personID: Scalars['MongoID']['input'];
}>;


export type GetTyreMileageGraphQuery = { tyreMileageGraph?: { eventMileages?: { tyreSets?: Array<TyreMileageGraphTyreMileageGraphEventMileageItemVarsFragment | null> | null } | null } | null, sessions?: { items?: Array<{ _id: any, name: string, shortName?: string | null }> | null } | null, person?: { mileageUnit?: EnumLengthUnit | null } | null };

export type TyreMileageGraphTyreMileageGraphEventMileageItemVarsFragment = { _id: any, name?: string | null, eventStartMileage: number, eventEndMileage: number, eventTotalMileage: number, sessionMileages?: Array<{ sessionID: any, startMileage: number, endMileage: number, totalMileage: number } | null> | null, runMileages?: Array<TyreMileageGraphRunMileageVarsFragment | null> | null };

export type TyreMileageGraphRunMileageVarsFragment = { runSheetID: any, sessionID: any, NRunConsecutive: number, NRunTiming: string, NRun: number, startMileage: number, endMileage: number, runMileage: number };

export type GetBasicTyreSetListQueryVariables = Exact<{
  filter: FilterFindManyTyreSetInput;
  perPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTyreSetInput>;
}>;


export type GetBasicTyreSetListQuery = { tyreSets?: { count?: number | null, pageInfo: { pageCount: number, currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<TyreSetForWarehouseVarsFragment> | null } | null };

export type TyreSetForWarehouseVarsFragment = { _id: any, name?: string | null, totalMileage?: number | null, assignment?: { seasons: Array<{ _id: any, name: string }>, seasonContestants: Array<{ _id: any, startNumber: string, seasonID: any }>, events: Array<{ _id: any, name: string, contestants?: Array<{ _id: any, tyreSetIDs?: Array<any | null> | null } | null> | null }>, eventContestants: Array<{ _id: any, startNumber: string }> } | null, tyreFL?: { _id: any, name?: string | null } | null, tyreFR?: { _id: any, name?: string | null } | null, tyreRL?: { _id: any, name?: string | null } | null, tyreRR?: { _id: any, name?: string | null } | null };

export type GetSeasonContestantsForWarehouseQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSeasonContestantsForWarehouseQuery = { season?: { contestants: Array<{ _id: any, startNumber: string }> } | null };

export type GetEventContestantsForWarehouseQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEventContestantsForWarehouseQuery = { event?: { contestants?: Array<{ _id: any } | null> | null, season?: { contestants: Array<{ _id: any, startNumber: string }> } | null } | null };

export type GetWeatherForWeatherPageWeatherSelectorQueryVariables = Exact<{
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetWeatherForWeatherPageWeatherSelectorQuery = { weatherAll?: { items?: Array<WeatherForWeatherPageVarsForSelectorFragment> | null } | null };

export type WeatherForWeatherPageVarsForSelectorFragment = { _id: any, eventIDs?: Array<any | null> | null, source?: string | null, time?: any | null, type: EnumWeatherType, weatherStationID?: string | null, events: Array<{ name: string, sessionIDs?: Array<any | null> | null, tEventStart?: any | null, tEventEnd?: any | null, season?: { name: string } | null, sessions: Array<{ _id: any, shortName?: string | null, tSessionStart?: any | null, tSessionEnd?: any | null }>, track?: { timeZone?: string | null } | null }> };

export type GetWeatherForWeatherPageQueryVariables = Exact<{
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetWeatherForWeatherPageQuery = { weatherAll?: { items?: Array<WeatherForWeatherPageVarsFragment> | null } | null };

export type GetWeatherForPlotPageQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GetWeatherForPlotPageQuery = { weatherAll?: { items?: Array<WeatherForWeatherPageVarsFragment> | null } | null };

export type WeatherForWeatherPageVarsFragment = { _id: any, altitude?: number | null, eventIDs?: Array<any | null> | null, notes?: string | null, source?: string | null, time?: any | null, type: EnumWeatherType, data: Array<{ ambientCondition?: string | null, aWind?: number | null, aWindMain?: number | null, DAir?: number | null, globalRadiation?: number | null, pAmbient?: number | null, rainIntensity?: number | null, rainProbability?: number | null, rHumidity?: number | null, TAir?: number | null, TAirExpected?: number | null, TAirMax?: number | null, TAirMin?: number | null, TAirOfficial?: number | null, TAmbient?: number | null, TDewPoint?: number | null, time?: any | null, TInternal?: number | null, trackCondition?: string | null, TTrack?: number | null, TTrackExpected?: number | null, TTrackOfficial?: number | null, TWindChill?: number | null, VBattery?: number | null, vWind?: number | null, vWindAverage?: number | null, vWindPeak?: number | null } | null>, events: Array<{ name: string, sessionIDs?: Array<any | null> | null, tEventStart?: any | null, tEventEnd?: any | null, season?: { name: string } | null, sessions: Array<{ _id: any, shortName?: string | null, tSessionStart?: any | null, tSessionEnd?: any | null }>, track?: { timeZone?: string | null } | null }>, geoLocation?: { coordinates: Array<number | null> } | null };

export type GetRunSheetWeatherForWeatherPageQueryVariables = Exact<{
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetRunSheetWeatherForWeatherPageQuery = { runSheets?: { items?: Array<{ startTime?: any | null, weather?: AllWeatherDataScalarVarsFragment | null }> | null } | null };

export type RemoveWeatherMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveWeatherMutation = { removeWeather?: { recordId?: any | null } | null };

export type WeatherRemovedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type WeatherRemovedSubscription = { weatherRemoved?: { _id: any } | null };

export type WeatherUpdatedSubscriptionVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type WeatherUpdatedSubscription = { weatherUpdated?: WeatherForWeatherPageVarsFragment | null };

export type GetSessionsFromEventsForWeatherPageQueryVariables = Exact<{
  eventIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GetSessionsFromEventsForWeatherPageQuery = { sessions?: { items?: Array<{ _id: any }> | null } | null };

export type GetAllBuildSheetStylesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllBuildSheetStylesQuery = { buildSheetStyles?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type BuildSheetStylePageQueryVariables = Exact<{
  buildSheetStyleID: Scalars['MongoID']['input'];
}>;


export type BuildSheetStylePageQuery = { buildSheetStyle?: { _id: any, name: string, date?: any | null, chassisSpecID?: any | null, issue?: string | null, event?: { _id: any, name: string } | null, author?: { name: string } | null, blocks?: Array<BuildSheetStylePageBlockFragment | null> | null } | null, specifications?: { items?: Array<BasicInfoChassisSpecFragment | {}> | null } | null };

export type CreateBuildSheetStyleMutationVariables = Exact<{
  record: CreateOneBuildSheetStyleInput;
}>;


export type CreateBuildSheetStyleMutation = { addBuildSheetStyle?: { recordId?: any | null } | null };

export type UpdateBuildSheetStyleMutationVariables = Exact<{
  buildSheetStyleID: Scalars['MongoID']['input'];
  record: UpdateByIdBuildSheetStyleInput;
}>;


export type UpdateBuildSheetStyleMutation = { updateBuildSheetStyle?: { recordId?: any | null } | null };

export type RemoveBuildSheetStyleByIdMutationVariables = Exact<{
  buildSheetStyleID: Scalars['MongoID']['input'];
}>;


export type RemoveBuildSheetStyleByIdMutation = { removeBuildSheetStyle?: { recordId?: any | null } | null };

export type BuildSheetStylePageTabFragment = { _id?: any | null, title: string, buildSheetGroupEnumID?: any | null };

export type BuildSheetStylePageBlockFragment = { _id?: any | null, h: number, w: number, y: number, x: number, tabs?: Array<BuildSheetStylePageTabFragment | null> | null };

export type GetAllUserEnumsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUserEnumsQuery = { assemblyUserEnums?: { items?: Array<{ _id?: any | null, name: string, type: EnumUserEnumAssemblyTypeType } | {}> | null } | null, buildSheetUserEnums?: { items?: Array<{ _id?: any | null, name: string, type: EnumUserEnumBuildSheetGroupType } | {}> | null } | null, partsUserEnums?: { items?: Array<{ _id?: any | null, active?: boolean | null, name: string, type: EnumUserEnumPartStatusType } | {}> | null } | null, trackingUserEnums?: { items?: Array<{ _id?: any | null, name: string, type: EnumUserEnumTrackingSeverityType } | {}> | null } | null, partTypeUserEnum?: { items?: Array<{ _id?: any | null, name: string, type: EnumUserEnumPartTypeType } | {}> | null } | null, RunPlannerActionItem?: { items?: Array<{ _id?: any | null, name: string, type: EnumUserEnumRunPlannerActionItemType } | {}> | null } | null, simulationDriveFileTypeEnum?: { items?: Array<{ _id?: any | null, name: string, type: EnumUserEnumSimulationDriveFileTypeType } | {}> | null } | null };

export type GetAllUserEnumsByTypeQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyUserEnumInput>;
}>;


export type GetAllUserEnumsByTypeQuery = { userEnums?: { items?: Array<UserEnumVars_UserEnumAssemblyType_Fragment | UserEnumVars_UserEnumBuildSheetGroup_Fragment | UserEnumVars_UserEnumPartStatus_Fragment | UserEnumVars_UserEnumPartType_Fragment | UserEnumVars_UserEnumRunPlannerActionItem_Fragment | UserEnumVars_UserEnumSimulationDriveFileType_Fragment | UserEnumVars_UserEnumTrackingSeverity_Fragment> | null } | null };

type UserEnumVars_UserEnumAssemblyType_Fragment = { _id?: any | null, name: string };

type UserEnumVars_UserEnumBuildSheetGroup_Fragment = { _id?: any | null, name: string };

type UserEnumVars_UserEnumPartStatus_Fragment = { _id?: any | null, name: string };

type UserEnumVars_UserEnumPartType_Fragment = { _id?: any | null, name: string };

type UserEnumVars_UserEnumRunPlannerActionItem_Fragment = { _id?: any | null, name: string };

type UserEnumVars_UserEnumSimulationDriveFileType_Fragment = { _id?: any | null, name: string };

type UserEnumVars_UserEnumTrackingSeverity_Fragment = { _id?: any | null, name: string };

export type UserEnumVarsFragment = UserEnumVars_UserEnumAssemblyType_Fragment | UserEnumVars_UserEnumBuildSheetGroup_Fragment | UserEnumVars_UserEnumPartStatus_Fragment | UserEnumVars_UserEnumPartType_Fragment | UserEnumVars_UserEnumRunPlannerActionItem_Fragment | UserEnumVars_UserEnumSimulationDriveFileType_Fragment | UserEnumVars_UserEnumTrackingSeverity_Fragment;

export type CreateUserEnumMutationVariables = Exact<{
  record: CreateOneUserEnumInput;
}>;


export type CreateUserEnumMutation = { addUserEnum?: { recordId?: any | null } | null };

export type UpdateUserEnumMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdUserEnumInput;
}>;


export type UpdateUserEnumMutation = { updateUserEnum?: { recordId?: any | null } | null };

export type RemoveUserEnumMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveUserEnumMutation = { removeUserEnum?: { recordId?: any | null } | null };

export type AdjustableAccelerationPropertyVarsFragment = { __typename: 'AdjustableAccelerationProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableAcceleration?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumAccelerationUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableAnglePropertyVarsFragment = { __typename: 'AdjustableAngleProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableAngle?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumAngleUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableAngularCompliancePropertyVarsFragment = { __typename: 'AdjustableAngularComplianceProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableAngularCompliance?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumAngularComplianceUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableAngularTorqueCompliancePropertyVarsFragment = { __typename: 'AdjustableAngularTorqueComplianceProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableAngularTorqueCompliance?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumAngularTorqueComplianceUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableBooleanPropertyVarsFragment = { __typename: 'AdjustableBooleanProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableBoolean?: { defaultValue?: boolean | null } | null };

export type AdjustableCompliancePropertyVarsFragment = { __typename: 'AdjustableComplianceProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableCompliance?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumComplianceUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableForcePropertyVarsFragment = { __typename: 'AdjustableForceProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableForce?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumForceUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableInertiaPropertyVarsFragment = { __typename: 'AdjustableInertiaProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableInertia?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumInertiaUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableLengthPropertyVarsFragment = { __typename: 'AdjustableLengthProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableLength?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumLengthUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableLocationPropertyVarsFragment = { __typename: 'AdjustableLocationProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableLocation?: { coordinates?: { x?: number | null, y?: number | null, z?: number | null } | null } | null };

export type AdjustableMassPropertyVarsFragment = { __typename: 'AdjustableMassProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableMass?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumMassUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableNumberPropertyVarsFragment = { __typename: 'AdjustableNumberProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableNumber?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: string | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableOrientationPropertyVarsFragment = { __typename: 'AdjustableOrientationProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableOrientation?: { rotation?: { I?: number | null, J?: number | null, K?: number | null } | null } | null };

export type AdjustablePowerPropertyVarsFragment = { __typename: 'AdjustablePowerProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustablePower?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumPowerUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustablePressurePropertyVarsFragment = { __typename: 'AdjustablePressureProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustablePressure?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumPressureUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableRatioPropertyVarsFragment = { __typename: 'AdjustableRatioProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableRatio?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumRatioUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableSpringRatePropertyVarsFragment = { __typename: 'AdjustableSpringRateProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableSpringRate?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumSpringRateUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableSteeringRackRatioPropertyVarsFragment = { __typename: 'AdjustableSteeringRackRatioProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableSteeringRackRatio?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumSteeringRackRatioUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableStringPropertyVarsFragment = { __typename: 'AdjustableStringProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableString?: { defaultValue?: string | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableTemperaturePropertyVarsFragment = { __typename: 'AdjustableTemperatureProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableTemperature?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumTemperatureUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableTorquePropertyVarsFragment = { __typename: 'AdjustableTorqueProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableTorque?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumTorqueUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableTorsionRatePropertyVarsFragment = { __typename: 'AdjustableTorsionRateProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableTorsionRate?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumTorsionRateUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AdjustableVolumePropertyVarsFragment = { __typename: 'AdjustableVolumeProperty', index?: number | null, name: string, description?: string | null, useInSimulation?: boolean | null, adjustableVolume?: { defaultValue?: number | null, maxValue?: number | null, minValue?: number | null, sign?: boolean | null, step?: number | null, unit?: EnumVolumeUnit | null, valueNames?: Array<string | null> | null, values?: Array<number | null> | null } | null };

export type AllAssemblyTemplatesVarsFragment = { _id: any, description?: string | null, name: string, requiredParts?: Array<{ location?: EnumAssemblyTemplateRequiredPartsLocation | null, userEnumPartTypeID?: any | null } | null> | null };

export type AllChassisMeasurementVarsFragment = { angles?: EnumAngleUnit | null, angularCompliances?: EnumAngularComplianceUnit | null, angularTorqueCompliances?: EnumAngularTorqueComplianceUnit | null, bumpPlateMeasurementMethod?: EnumBumpPlateMeasurementMethod | null, bumpPlateRefFront?: number | null, bumpPlateRefRear?: number | null, compliances?: EnumComplianceUnit | null, forces?: EnumForceUnit | null, inertias?: EnumInertiaUnit | null, inverseCamber?: boolean | null, kinematicsExternalReadingsRequired?: EnumChassisMeasurementsKinematicsExternalReadingsRequired | null, kinematicsInternalReadingsRequired?: EnumChassisMeasurementsKinematicsInternalReadingsRequired | null, lengths?: EnumLengthUnit | null, masses?: EnumMassUnit | null, powers?: EnumPowerUnit | null, pressures?: EnumPressureUnit | null, ratios?: EnumRatioUnit | null, rideHeightCalcFront?: string | null, rideHeightCalcRear?: string | null, springRates?: EnumSpringRateUnit | null, steeringRackRatios?: EnumSteeringRackRatioUnit | null, temperatures?: EnumTemperatureUnit | null, toeMeasurementMethod?: EnumToeMeasurementMethod | null, toeRefFront?: number | null, toeRefRear?: number | null, toeTotal?: boolean | null, torques?: EnumTorqueUnit | null, torsionRates?: EnumTorsionRateUnit | null, volumes?: EnumVolumeUnit | null, xTrackFront?: number | null, xTrackRear?: number | null, xWheelbase?: number | null };

export type AllContestantScalarVarsFragment = { _id: any, chassisIDs?: Array<any | null> | null, class?: string | null, color?: string | null, driverIDs?: Array<any | null> | null, eligibleForPoints?: boolean | null, hidden?: boolean | null, seasonID: any, startNumber: string, teamID?: any | null, thirdPartyContestantID?: string | null, transcribbleAudioURI?: string | null, tyreIDs?: Array<any | null> | null, tyreSetIDs?: Array<any | null> | null };

export type AllEventScalarVarsFragment = { _id: any, assignedSetupIDs?: Array<any | null> | null, DFuel?: number | null, energySweep?: any | null, eventType?: string | null, iRacingServiceIsNextEvent?: boolean | null, name: string, NEventSeason?: number | null, seasonID: any, sessionIDs?: Array<any | null> | null, tagIDs?: Array<any | null> | null, tEventEnd?: any | null, tEventStart?: any | null, thirdPartyEventID?: string | null, timeZone?: string | null, tLapAverage?: number | null, trackID?: any | null, trackLayoutIDs?: Array<any | null> | null, type?: EnumEventType | null, weatherIDs: Array<any> };

export type AllEventVarsFragment = (
  { season?: AllSeasonVarsFragment | null }
  & AllEventScalarVarsFragment
);

export type AllHistoryVarsFragment = { _id: any, createdAt?: any | null, type?: EnumHistoryType | null, updatedAt?: any | null, userID?: any | null, valuesChanged?: Array<{ field?: string | null, value?: string | null } | null> | null };

export type AllJobScalarVarsFragment = { _id: any, acknowledgedAt?: any | null, acknowledgedByID?: any | null, assigneeIDs?: Array<any | null> | null, cancelledAt?: any | null, cancelledByID?: any | null, category?: string | null, closedAt?: any | null, closedByID?: any | null, createdAt?: any | null, createdByID?: any | null, description: string, oneWordStatus: JobStatus, priority?: EnumJobPriority | null, runSheetID?: any | null, tagIDs?: Array<any | null> | null, updatedAt?: any | null };

export type AllLapFlagLabelVarsFragment = { ATTACK?: string | null, COOL?: string | null, FCY?: string | null, IN?: string | null, OUT?: string | null, OUTIN?: string | null, PITLANE?: string | null, PREP?: string | null, PUSH?: string | null, QUALI?: string | null, SAFETYCAR?: string | null, SHAKEDOWN?: string | null, SLOW?: string | null, TARGET?: string | null, TOGRID?: string | null, TOPADDOCK?: string | null, TOPITS?: string | null, UNFINISHED?: string | null };

export type AllLocalConnectionVarsFragment = { host?: string | null, outputFolder?: string | null, port?: number | null, useSSL?: boolean | null };

export type AllPartScalarVarsFragment = { _id: any, chassisSpecName?: string | null, concurrentUseAllowed?: boolean | null, createdAt?: any | null, currentlyInUse?: boolean | null, description?: string | null, eligibleEventTypes?: EnumPartEligibleEventTypes | null, lifetimeMileage?: number | null, locationID?: any | null, manufacturerID?: any | null, manufacturerPartID?: string | null, manufacturerSerialNumber?: string | null, notes?: string | null, partNumber?: string | null, properties?: any | null, reference: string, rootAssemblyIDs?: Array<any | null> | null, rootSpecificationID?: any | null, specificationID?: any | null, tagIDs?: Array<any | null> | null, teamID?: any | null, trackingHistoryIDs?: Array<any | null> | null, trackingMeasurementHistoryIDs?: Array<any | null> | null, updatedAt?: any | null, userEnumPartTypeID?: any | null };

export type AllPartInstanceScalarVarsFragment = { _id: any, parentID?: any | null, partID?: any | null, readingLocation?: EnumReadingLocation | null, specificationGroupID?: any | null, specificationID?: any | null, superParentID?: any | null };

export type AllPersonScalarVarsFragment = { _id: any, acronym?: string | null, birthday?: any | null, defaultRunSheetCompareStyleID?: any | null, defaultRunSheetStyleID?: any | null, defaultTyreReferenceTemperature?: number | null, defaultTyreSetNameFormat?: string | null, dynoConfigID?: any | null, email?: string | null, hideKPIs?: boolean | null, isActive?: boolean | null, isTimeTracker?: boolean | null, isTimeTrackerAdmin?: boolean | null, name: string, passportNumber?: string | null, passportPicture?: string | null, plotPageConfigIDs?: Array<any | null> | null, privateMobile?: number | null, privatePhone?: number | null, role?: EnumPersonRole | null, setupOverviewConfigIDs?: Array<any | null> | null, teamID?: any | null, timeTrackerApprovalByPersonID?: any | null, username: string, userSetupIDs?: Array<any | null> | null, visibleContestantIDs?: Array<any | null> | null, visibleEventIDs?: Array<any | null> | null, workMobile?: number | null, workPhone?: number | null };

export type AllRaceSeriesScalarVarsFragment = { _id: any, assignedSetupIDs?: Array<any | null> | null, defaultJobListIDs?: Array<any | null> | null, defaultRunSheetStyleID?: any | null, driversPerCar?: EnumRaceSeriesDriversPerCar | null, groupName?: string | null, name: string, seasonIDs?: Array<any | null> | null, tagIDs?: Array<any | null> | null };

export type AllRunEnergyVarsFragment = { ATTACK?: number | null, COOL?: number | null, FCY?: number | null, IN?: number | null, OUT?: number | null, OUTIN?: number | null, PITLANE?: number | null, PREP?: number | null, PUSH?: number | null, QUALI?: number | null, SAFETYCAR?: number | null, SHAKEDOWN?: number | null, SLOW?: number | null, TARGET?: number | null, TOGRID?: number | null, TOPADDOCK?: number | null, TOPITS?: number | null, UNFINISHED?: number | null, attackLap?: number | null, coolLap?: number | null, fullCourseYellowLap?: number | null, inLap?: number | null, outInLap?: number | null, outLap?: number | null, prepLap?: number | null, pushLap?: number | null, qualiLap?: number | null, safetyCarLap?: number | null, slowLap?: number | null, targetLap?: number | null, toGridLap?: number | null, toPitsLap?: number | null, unfinishedLap?: number | null };

export type AllWeatherDataScalarVarsFragment = { ambientCondition?: string | null, aWind?: number | null, aWindMain?: number | null, DAir?: number | null, globalRadiation?: number | null, pAmbient?: number | null, rainIntensity?: number | null, rainProbability?: number | null, rHumidity?: number | null, TAir?: number | null, TAirExpected?: number | null, TAirMax?: number | null, TAirMin?: number | null, TAirOfficial?: number | null, TAmbient?: number | null, TDewPoint?: number | null, time?: any | null, TInternal?: number | null, trackCondition?: string | null, TTrack?: number | null, TTrackExpected?: number | null, TTrackOfficial?: number | null, TWindChill?: number | null, VBattery?: number | null, vWind?: number | null, vWindAverage?: number | null, vWindPeak?: number | null };

export type AllSeasonScalarVarsFragment = { _id: any, assignedSetupIDs?: Array<any | null> | null, contestantIDs?: Array<any | null> | null, eventIDs?: Array<any | null> | null, fastestLapsPositionCutoff?: number | null, name: string, pointsPerFastestLap?: Array<number | null> | null, pointsPerFastestLapTeam?: boolean | null, pointsPerPosition?: Array<number | null> | null, pointsPerPositionSprintRace?: Array<number | null> | null, pointsPerQualifyingRank?: Array<number | null> | null, raceSeriesID: any, tagIDs?: Array<any | null> | null, tyreIDs?: Array<any | null> | null, tyreSetIDs?: Array<any | null> | null };

export type AllSeasonVarsFragment = (
  { raceSeries?: AllRaceSeriesScalarVarsFragment | null }
  & AllSeasonScalarVarsFragment
);

export type AllSessionScalarVarsFragment = { _id: any, assignedSetupIDs?: Array<any | null> | null, bestValuesID?: any | null, debriefNotes?: string | null, eventID: any, isLinkedSession?: boolean | null, isTimingTest?: boolean | null, liveStandingsCurrentLap?: number | null, liveStandingsUpdatedAt?: any | null, name: string, nextSessionID?: any | null, prevSessionID?: any | null, pTyreFLMinSession?: number | null, pTyreFRMinSession?: number | null, pTyreRLMinSession?: number | null, pTyreRRMinSession?: number | null, sessionType?: EnumSessionType | null, shortName?: string | null, tagIDs?: Array<any | null> | null, timeRemaining?: number | null, timeRemainingUpdatedAt?: any | null, transcribbleSessionID?: number | null, tSessionEnd?: any | null, tSessionStart?: any | null };

export type AllSessionVarsFragment = (
  { event?: AllEventScalarVarsFragment | null }
  & AllSessionScalarVarsFragment
);

export type AllSimResultScalarVarsFragment = { _id: any, carSetupID?: any | null, carSetupModifiedAt?: any | null, createdAt?: any | null, defaultChannelTime?: Array<number | null> | null, isCarSetupChanged?: boolean | null, name?: string | null, pAmbient?: number | null, refValues?: any | null, requesterID?: any | null, rHumidity?: number | null, runSheetID?: any | null, serviceVersion?: string | null, simType?: EnumSimResultSimType | null, simulationDriveFileID?: any | null, simulationService?: EnumSimModelType | null, source?: string | null, sourceReferenceID?: string | null, specificationID?: any | null, status?: EnumSimResultStatus | null, statusMessage?: string | null, tagIDs?: Array<any | null> | null, TAmbient?: number | null, trackLayoutID?: any | null, updatedAt?: any | null, version?: string | null };

export type AllTableVarsFragment = { columnNames?: Array<string | null> | null, columnValues?: Array<number | null> | null, data: Array<number | null>, decimals?: number | null, depth?: number | null, height?: number | null, rowNames?: Array<string | null> | null, sliceNames?: Array<string | null> | null, sliceValues?: Array<number | null> | null, width: number, _id?: any | null };

export type AllTagVarsFragment = { _id: any, color?: string | null, group?: string | null, label: string, tagType?: EnumTagType | null };

export type AllTeamVarsFragment = { _id: any, color?: string | null, name: string, raceSeriesID?: any | null, shortName?: string | null, tagIDs?: Array<any | null> | null, tags: Array<AllTagVarsFragment> };

export type AllTrackingHistoryVarsFragment = { _id: any, chassisAssemblyID?: any | null, createdAt?: any | null, cumulativeValue?: number | null, date?: any | null, limitCritical?: boolean | null, limitWarning?: boolean | null, mass?: number | null, notes?: string | null, partID?: any | null, qualityCheckID?: any | null, reset?: boolean | null, statusEnumID?: any | null, trackingItemID?: any | null, type?: EnumTrackingRecordType | null, updatedAt?: any | null, updatedByID?: any | null, value?: number | null, forceTable?: { acceleration?: Array<number | null> | null, dampingForce?: Array<number | null> | null, force?: Array<number | null> | null, inertanceForce?: Array<number | null> | null, velocity?: Array<number | null> | null, x?: Array<number | null> | null, xMax?: number | null, xMin?: number | null } | null };

export type AllTrackingHistoryFullAndSnapshotVarsFragment = { active?: boolean | null, chassisAssemblyID?: any | null, createdAt?: any | null, cumulativeValue?: number | null, dateResolved?: any | null, limitCritical?: boolean | null, limitWarning?: boolean | null, mass?: number | null, notes?: string | null, qualityCheckID?: any | null, recordErrors?: string | null, reset?: boolean | null, statusEnumID?: any | null, trackingItemID?: any | null, trackingRecordID?: any | null, type?: string | null, updatedAt?: any | null, userEnumPartStatusName?: string | null, value?: number | null, valueString?: string | null, trackingItem?: { _id: any, displayUnit?: EnumDisplayUnit | null, trackingSource?: { sourceIDs?: Array<any | null> | null, sources: Array<{ displayUnit?: EnumDisplayUnit | null }> } | null } | null };

export type AllTrackingItemScalarVarsFragment = { _id: any, active?: boolean | null, arrayElements?: number | null, criticalCumulativeValue?: number | null, criticalValue?: number | null, cumulativeCalculation?: boolean | null, defaultValue?: number | null, description?: string | null, displayUnit?: EnumDisplayUnit | null, isArray?: boolean | null, isDefault?: boolean | null, name: string, NDecimals?: number | null, operator?: EnumTrackingItemOperator | null, resettable?: boolean | null, specificationID?: any | null, trackingSourceID?: any | null, useInSimulation?: boolean | null, warningCumulativeValue?: number | null, warningValue?: number | null };

export type AllTrackingMeasurementScalarVarsFragment = { _id: any, description?: string | null, displayName?: string | null, name: string, specificationID?: any | null, useInSimulation?: boolean | null, defaultCoordinates?: { x?: number | null, y?: number | null, z?: number | null } | null, defaultRotation?: { I?: number | null, J?: number | null, K?: number | null } | null };

export type AllTrackingMeasurementHistoryScalarVarsFragment = { _id: any, assemblyID?: any | null, createdAt?: any | null, date?: any | null, partID?: any | null, trackingMeasurementID?: any | null, updatedAt?: any | null, coordinates?: { x?: number | null, y?: number | null, z?: number | null } | null, rotation?: { I?: number | null, J?: number | null, K?: number | null } | null };

export type AllRunTyreScalarVarsFragment = { tyreID?: any | null, pTyre?: number | null, TTyre?: number | null, pTyrePostRun?: number | null, TTyrePostRun?: number | null, pTyrePreRunBleed?: number | null, pTyrePostRunBleed?: number | null, TTyrePreRunBleed?: number | null, TTyrePostRunBleed?: number | null, TTyreSurface?: Array<number | null> | null, hTyreTread?: Array<number | null> | null, pTyreReference?: number | null, TTyreReference?: number | null, TTrackReference?: number | null, pTyreStartRun?: number | null, pTyreMinStartRun?: number | null, pTyreSetDown?: number | null, TTyreSetdown?: number | null, pTyreTarget?: number | null, TTyreParcFermeExpected?: number | null };

export type AllTyreScalarVarsFragment = { _id: any, additionalSortProperty?: string | null, axle?: EnumTyreAxle | null, barcodeManufacturer?: string | null, barcodeRegulation?: string | null, barcodeRim?: string | null, barcodeTPMS?: string | null, batteryTPMS?: string | null, BTyreScrapped?: boolean | null, compound?: string | null, compoundComment?: string | null, constructionComment?: string | null, constructionSpec?: string | null, createdAt?: any | null, CTyre?: number | null, initialCondition?: EnumTyreInitialCondition | null, kTyre?: number | null, manufacturer?: string | null, manufacturingDate?: any | null, mileage?: number | null, mold?: string | null, mTyre?: number | null, name?: string | null, pTyreMinRegulation?: number | null, pTyreMinTeam?: number | null, seasonID?: any | null, sRunInitial?: number | null, tagIDs?: Array<any | null> | null, type?: string | null, updatedAt?: any | null, wearMeasurementIDs?: Array<any | null> | null };

export type AllUserEnumPartStatusVarsFragment = { _id?: any | null, name: string, active?: boolean | null, type: EnumUserEnumPartStatusType };

export type AllChassisAssemblyVarsFragment = { _id?: any | null, assemblyTypeEnumID?: any | null, buildSheetDisplayLocationIDs?: Array<any | null> | null, buildSheetGroupEnumID?: any | null, buildSheetNestLevel?: number | null, chassisPartID?: any | null, chassisSpecID?: any | null, createdAt?: any | null, current?: boolean | null, decommissioned?: boolean | null, locationID?: any | null, name: string, nestedPartInstanceIDs?: Array<any | null> | null, partInstanceIDs?: Array<any | null> | null, properties?: any | null, reference?: string | null, subAssemblyIDs?: Array<any | null> | null, tagIDs?: Array<any | null> | null, updatedAt?: any | null };

export type BestValuesVarsFragment = { _id: any, contestantID?: any | null, fastestLap?: { driver?: string | null, time?: number | null, NLapRun?: number | null, runSheetID?: any | null } | null, fastestSectors?: Array<{ driver?: string | null, time?: number | null, NLapRun?: number | null, runSheetID?: any | null } | null> | null };

export type CalculationVarsFragment = { _id: any, debugMode?: boolean | null, displayUnit?: EnumDisplayUnit | null, functionString: string, isActive: boolean, name?: string | null, parameter: string, trigger: Array<string>, type: EnumCalculationType, version?: string | null };

export type MassVarsFragment = { mCarFL?: number | null, mCarFR?: number | null, mCarRL?: number | null, mCarRR?: number | null, mCarTotal?: number | null, rCarCross?: number | null, rWeightF?: number | null, rWeightFTarget?: number | null };

export type EndVarsFragment = (
  { aCamber?: number | null, aCamberMeasurement?: number | null, aCaster?: number | null, aCasterMeasurement?: number | null, aToe?: number | null, aToeMeasurement?: number | null, hRide?: number | null, hRideChassis?: number | null, hRideMeasurement?: number | null, hRideRegulation?: number | null, kinematicsExternalSpecID?: any | null, kinematicsInternalSpecID?: any | null, xToe?: number | null, xToeMeasurement?: number | null, antiRollBar?: AllCarSetupAntiRollBarVarsFragment | null, helperSpring?: { specificationID?: any | null, kSpring?: number | null, xSpringPreload?: number | null, xSecondSpringTransition?: number | null, specification?: { _id?: any | null, name: string, kSpring?: number | null, xFree?: number | null } | null } | null, kinematics?: { name?: string | null } | null, kinematicsExternalSpec?: { _id?: any | null, name: string } | null, kinematicsInternalSpec?: { _id?: any | null, name: string } | null, spring?: { kSpring?: number | null, kSpringLbsIn?: number | null, dSpring?: number | null, xSpringPreload?: number | null, kHelperSpring?: number | null, kHelperSpringLbsIn?: number | null, specification?: { _id?: any | null, name: string } | null } | null, thirdElement?: { kSpring?: number | null, xBumpStopGap?: number | null, hBumpStopPacker?: number | null, bumpStop?: { name?: string | null } | null } | null }
  & ElasticStuffFragment
);

export type ElasticStuffFragment = { bumpStop?: AllCarSetupBumpStopVarsFragment | null, damper?: DamperVarsFragment | null, droopStop?: AllCarSetupDroopStopVarsFragment | null, externalBumpStop?: AllCarSetupExternalBumpStopVarsFragment | null };

export type DamperVarsFragment = { gasPressure?: number | null, manufacturer?: string | null, NDamperBumpDO?: number | null, NDamperBumpDY?: number | null, NDamperBumpHS?: number | null, NDamperBumpLS?: number | null, NDamperReboundHS?: number | null, NDamperReboundLS?: number | null, spec?: string | null, specificationID?: any | null, valvingBumpSpec?: string | null, valvingReboundSpec?: string | null, xDamperMax?: number | null, adjusters?: Array<{ _id?: any | null, name?: string | null, settingName?: string | null, value?: number | null } | null> | null, specification?: { _id?: any | null, name: string, damperAdjusters?: Array<{ maxSetting?: number | null, minSetting?: number | null, name: string, settingNames?: Array<string | null> | null, settings?: Array<number | null> | null, step?: number | null } | null> | null, damperConfigs?: Array<{ name: string } | null> | null } | null };

export type SteeringVarsFragment = { rSteerF?: number | null, steeringArm?: string | null, steeringPinion?: string | null };

export type CornerVarsFragment = { aCamber?: number | null, aCamberMeasurement?: number | null, aCaster?: number | null, aCasterMeasurement?: number | null, aToe?: number | null, aToeMeasurement?: number | null, hRide?: number | null, hRideChassis?: number | null, hRideMeasurement?: number | null, hRideRegulation?: number | null, pTyreTarget?: number | null, xToe?: number | null, xToeMeasurement?: number | null, brake?: { BBrakeDuctEnabled?: boolean | null, brakeBlankingStyle?: string | null, hBrakeCaliperBlanking?: number | null, hBrakeDiscBlanking?: number | null, rBrakeDiscBlanking?: number | null } | null, bumpStop?: { name?: string | null, specificationID?: any | null, xBumpStopGap?: number | null, specification?: { _id?: any | null, name: string } | null } | null, damper?: DamperVarsFragment | null, droopStop?: { name?: string | null, specificationID?: any | null, xDroopStopGap?: number | null, specification?: { _id?: any | null, name: string } | null } | null, helperSpring?: { kSpring?: number | null, specificationID?: any | null, xSpringPreload?: number | null, xSecondSpringTransition?: number | null, specification?: { _id?: any | null, kSpring?: number | null, name: string, xFree?: number | null } | null } | null, spring?: { kSpring?: number | null, specificationID?: any | null, xSpringPreload?: number | null, xSecondSpringTransition?: number | null, specification?: { _id?: any | null, kSpring?: number | null, name: string, xFree?: number | null } | null } | null, suspension?: { aCamber?: number | null, aCamberMeasurement?: number | null, aCamberShim?: number | null, aCaster?: number | null, aCasterMeasurement?: number | null, aToe?: number | null, aToeMeasurement?: number | null, hBumpStopPacker?: number | null, hBumpStopStack?: number | null, hCamberShim?: number | null, hPushRodShim?: number | null, hToeLinkSleeveBottom?: number | null, hToeLinkSleeveTop?: number | null, hToeShim?: number | null, prouBracket?: string | null, prouPosition?: string | null, xBumpStopGap?: number | null, xCamberMeasurement?: number | null, xDroopStopGap?: number | null, xToe?: number | null, xToeMeasurement?: number | null } | null };

export type AeroVarsFragment = { aFlapF?: number | null, aFlapFL?: number | null, aFlapFR?: number | null, NFlapFL?: string | null, NFlapFR?: string | null, NFlapR?: string | null, aFlapR?: number | null, aeroPackage?: string | null, hSplitterF?: Array<number | null> | null, aSplitterF?: number | null, frontFlapType?: string | null, hGurneyF?: number | null, hGurneyR?: number | null, splitterID?: string | null, noseID?: string | null, tailID?: string | null, floorLeadingEdgeID?: string | null, floorBB?: string | null, floorGurney?: string | null, frontWheelArch?: string | null, lowerDrivePlane?: string | null, upperDrivePlane?: string | null, Z400?: string | null, rearWingGurney?: string | null, tailGurney?: string | null };

export type BrakeSystemVarsFragment = { brakePedalPosition?: string | null, rBrakePedal?: number | null, masterCylinderFSpec?: string | null, masterCylinderRSpec?: string | null, brakePadFManufacturer?: string | null, brakePadFSpec?: string | null, brakePadRManufacturer?: string | null, brakePadRSpec?: string | null, rBrakeF?: number | null };

export type PowertrainVarsFragment = { aDiffRampCoast?: number | null, aDiffRampDrive?: number | null, clutch?: string | null, clutchCylinder?: string | null, dAirRestrictor?: number | null, differentialConfigName?: string | null, differentialSpecID?: any | null, engineBlankingDetails?: any | null, frictionFaces?: string | null, gearboxGridType?: string | null, hEngineBlanking?: any | null, hGearboxBlanking?: any | null, MDiffPreloadCold?: number | null, MDiffPreloadHot?: number | null, NEngineBlanking?: any | null, NFrictionFaces?: number | null, PPowerLevel?: number | null, rBevelSet?: number | null, rDropGear?: number | null, rEngineBlanking?: any | null, rGearRatios?: any | null, bevelSet?: { specificationID?: any | null, specification?: { name: string } | null } | null, differentialSpec?: { _id?: any | null, differentialConfigs?: Array<{ decommissioned?: boolean | null, frictionFaces?: string | null, maxPreloadForce?: number | null, name: string, rampAccel?: number | null, rampDecel?: number | null } | null> | null } | null, dropGear?: { specificationID?: any | null, specification?: { name: string } | null } | null, gears?: Array<{ gearNumber: string, specificationID?: any | null, specification?: { denominator: number, name: string, numerator: number } | null } | null> | null };

export type InfoVarsFragment = { batteryID?: string | null, gearboxID?: string | null, engineID?: string | null, inverterID?: string | null, driveshaftID?: string | null, setupComments?: string | null, NIssue?: number | null, tyreCompound?: string | null, customIDs?: any | null };

export type CarSetupVarsFragment = { _id: any, title: string, teamID?: any | null, createdAt?: any | null, updatedAt?: any | null, driverID?: any | null, engineerID?: any | null, chassisID?: any | null, chassisSpecID?: any | null, chassisSpecRootID?: any | null, custom?: any | null, customSimulationPayload?: any | null, customSimulationPayloadEnabled?: boolean | null, isLocked?: boolean | null, time?: any | null, runSheetID?: any | null, setupSheetStyle?: EnumCarSetupSetupSheetStyle | null, flattened?: any | null, systemsConfigValues?: any | null, mBallasts?: any | null, driver?: { _id: any, acronym?: string | null } | null, engineer?: { _id: any, name: string } | null, chassisSpec?: { _id?: any | null, name: string, setupSheetStyleIDs?: Array<any | null> | null, otherSetupSheetStyleIDs?: Array<any | null> | null, canopyVersion?: string | null, simulationModels?: any | null, version?: string | null, calculations: Array<CalculationVarsFragment>, customSimulationModels?: Array<{ name: string, version?: string | null } | null> | null, measurements?: { xWheelbase?: number | null, xTrackFront?: number | null, xTrackRear?: number | null } | null } | null, lastModifiedBy?: { name: string } | null, runSheet?: { _id: any, NRun?: number | null, NRunTiming?: number | null, prevRunSheetID?: any | null, nextRunSheetID?: any | null, teamID?: any | null, contestantID: any, contestant?: { _id: any, chassis: Array<{ _id: any, reference?: string | null, type?: string | null }> } | null, driver?: { _id: any, acronym?: string | null } | null, weather?: { TAir?: number | null, TTrack?: number | null, pAmbient?: number | null, rHumidity?: number | null } | null, session?: { _id: any, shortName?: string | null, name: string, event?: { _id: any, name: string, trackLayouts: Array<{ _id: any, track?: { _id: any, name: string } | null }> } | null } | null } | null, frontLeft?: CornerVarsFragment | null, frontRight?: CornerVarsFragment | null, rearLeft?: CornerVarsFragment | null, rearRight?: CornerVarsFragment | null, front?: EndVarsFragment | null, rear?: EndVarsFragment | null, massTeam?: MassVarsFragment | null, massSetup?: MassVarsFragment | null, massRegulation?: MassVarsFragment | null, massOutOfGarage?: MassVarsFragment | null, aero?: AeroVarsFragment | null, brakeSystem?: BrakeSystemVarsFragment | null, steering?: SteeringVarsFragment | null, powertrainFront?: PowertrainVarsFragment | null, powertrainRear?: PowertrainVarsFragment | null, powertrain?: PowertrainVarsFragment | null, info?: InfoVarsFragment | null, chassis?: { _id: any, systemsConfigFields?: Array<string | null> | null, ballastPositions?: Array<string | null> | null } | null };

export type CarSetupExportVarsFragment = { _id: any, setupInfo?: string | null, title: string, teamID?: any | null, chassisSpecID?: any | null, chassisSpecRootID?: any | null, chassisAssemblyID?: any | null, driverID?: any | null, engineerID?: any | null, chassisID?: any | null, custom?: any | null, time?: any | null, runSheetID?: any | null, setupSheetStyle?: EnumCarSetupSetupSheetStyle | null, systemsConfigValues?: any | null, mBallasts?: any | null, chassisAssembly?: ChassisAssemblyForSetupExportVarsFragment | null, chassisSpec?: ChassisSpecVarsForSetupSheetFlexFragment | null, driver?: { _id: any, acronym?: string | null } | null, engineer?: { _id: any, name: string } | null, chassis?: { _id: any, ballastPositions?: Array<string | null> | null, reference?: string | null, systemsConfigFields?: Array<string | null> | null } | null, runSheet?: (
    { _id: any, contestant?: { _id: any, chassis: Array<{ _id: any, reference?: string | null, type?: string | null }> } | null, driver?: { _id: any, acronym?: string | null } | null, session?: { _id: any, name: string, sessionType?: EnumSessionType | null, shortName?: string | null, tSessionEnd?: any | null, tSessionStart?: any | null, event?: { name: string, NEventSeason?: number | null, tEventEnd?: any | null, tEventStart?: any | null, _id: any, type?: EnumEventType | null, trackLayouts: Array<{ name: string, track?: { name: string } | null }>, track?: { name: string } | null } | null } | null, weather?: { TAir?: number | null, TTrack?: number | null, pAmbient?: number | null, rHumidity?: number | null } | null }
    & AllRunSheetScalarVarsFragment
  ) | null, frontLeft?: CornerVarsFragment | null, frontRight?: CornerVarsFragment | null, rearLeft?: CornerVarsFragment | null, rearRight?: CornerVarsFragment | null, front?: EndVarsFragment | null, rear?: EndVarsFragment | null, massTeam?: MassVarsFragment | null, massSetup?: MassVarsFragment | null, massRegulation?: MassVarsFragment | null, massOutOfGarage?: MassVarsFragment | null, aero?: AeroVarsFragment | null, brakeSystem?: BrakeSystemVarsFragment | null, steering?: SteeringVarsFragment | null, powertrain?: (
    { differentialSpec?: { _id?: any | null, name: string } | null }
    & PowertrainVarsFragment
  ) | null, powertrainCentral?: (
    { differentialSpec?: { _id?: any | null, name: string } | null }
    & PowertrainVarsFragment
  ) | null, powertrainFront?: (
    { differentialSpec?: { _id?: any | null, name: string } | null }
    & PowertrainVarsFragment
  ) | null, powertrainRear?: (
    { differentialSpec?: { _id?: any | null, name: string } | null }
    & PowertrainVarsFragment
  ) | null, info?: InfoVarsFragment | null };

export type ChassisAssemblyForSetupExportVarsFragment = { _id?: any | null, chassisSpecID?: any | null, name: string, reference?: string | null, chassisMeasurements?: Array<ChassisMeasurementPointVarsFragment | null> | null, partInstances: Array<PartInstancesForSetupSheetFlexVarsFragment> };

export type AllCarSetupAeroVarsFragment = { NFlapF?: string | null, NFlapFL?: string | null, NFlapLowerR?: string | null, NFlapFR?: string | null, NFlapR?: string | null, NFlapRL?: string | null, NFlapRR?: string | null, aFlapF?: number | null, Z400?: string | null, frontFlapType?: string | null, aSplitterF?: number | null, hSplitterF?: Array<number | null> | null, aFlapFL?: number | null, aFlapFR?: number | null, aFlapRL?: number | null, aFlapRR?: number | null, aFlapR?: number | null, aFlapLowerR?: number | null, aeroPackage?: string | null, hGurneyF?: number | null, hGurneyR?: number | null, splitterID?: string | null, noseID?: string | null, tailID?: string | null, floorLeadingEdgeID?: string | null, floorBB?: string | null, floorGurney?: string | null, frontWheelArch?: string | null, lowerDrivePlane?: string | null, upperDrivePlane?: string | null, rearWingGurney?: string | null, tailGurney?: string | null };

export type AllCarSetupAeroSpecVarsFragment = { specificationID?: any | null, aeroElements?: Array<AllCarSetupAeroElementVarsFragment | null> | null };

export type AllCarSetupAeroElementVarsFragment = { _id?: any | null, attached?: boolean | null, position?: number | null, positionName?: string | null, specificationID?: any | null };

export type AllCarSetupAntiRollBarVarsFragment = { kARB?: number | null, name?: string | null, position?: string | null, position1?: string | null, position2?: string | null, rockerPosition?: string | null, specificationID?: any | null, specification?: AllAntiRollBarSpecVarsFragment | null };

export type AllCarSetupBrakeSystemVarsFragment = { brakePedalPosition?: string | null, rBrakePedal?: number | null, dMasterCylinderF?: number | null, masterCylinderFSpec?: string | null, dMasterCylinderR?: number | null, masterCylinderRSpec?: string | null, masterCylinderRodLengthF?: number | null, masterCylinderRodlengthR?: number | null, brakePadFManufacturer?: string | null, brakePadFSpec?: string | null, brakePadRManufacturer?: string | null, brakePadRSpec?: string | null, pBrakeBalanceRef?: number | null, rBrakeF?: number | null, BBBSEnabled?: boolean | null, xBBSPreload?: number | null, kBBSSpring?: number | null, kKnockOffSpringF?: number | null, kKnockOffSpringR?: number | null };

export type AllCarSetupBumpStopVarsFragment = { name?: string | null, specificationID?: any | null, xBumpStopGap?: number | null, specification?: ElasticSpecVarsFragment | null };

export type AllCarSetupDroopStopVarsFragment = { name?: string | null, specificationID?: any | null, xDroopStopGap?: number | null, specification?: ElasticSpecVarsFragment | null };

export type AllCarSetupExternalBumpStopVarsFragment = { name?: string | null, specificationID?: any | null, xExternalBumpStopGap?: number | null, specification?: ElasticSpecVarsFragment | null };

export type AllCarSetupCornerVarsFragment = { aCamber?: number | null, aCamberMeasurement?: number | null, aCaster?: number | null, aCasterMeasurement?: number | null, aToe?: number | null, aToeMeasurement?: number | null, hRide?: number | null, hRideChassis?: number | null, hRideMeasurement?: number | null, hRideRegulation?: number | null, pTyreTarget?: number | null, xToe?: number | null, xToeMeasurement?: number | null, bumpStop?: AllCarSetupBumpStopVarsFragment | null, damper?: AllCarSetupDamperVarsFragment | null, droopStop?: AllCarSetupDroopStopVarsFragment | null, externalBumpStop?: AllCarSetupExternalBumpStopVarsFragment | null, helperSpring?: AllCarSetupSpringVarsFragment | null, reboundSpring?: AllCarSetupSpringVarsFragment | null, spring?: AllCarSetupSpringVarsFragment | null };

export type AllCarSetupEndVarsFragment = { aCamber?: number | null, aCamberMeasurement?: number | null, aCaster?: number | null, aCasterMeasurement?: number | null, aToe?: number | null, aToeMeasurement?: number | null, hRide?: number | null, hRideChassis?: number | null, hRideMeasurement?: number | null, hRideRegulation?: number | null, kinematicsExternalSpecID?: any | null, kinematicsInternalSpecID?: any | null, xToe?: number | null, xToeMeasurement?: number | null, antiRollBar?: AllCarSetupAntiRollBarVarsFragment | null, bumpStop?: AllCarSetupBumpStopVarsFragment | null, damper?: AllCarSetupDamperVarsFragment | null, droopStop?: AllCarSetupDroopStopVarsFragment | null, externalBumpStop?: AllCarSetupExternalBumpStopVarsFragment | null, helperSpring?: AllCarSetupSpringVarsFragment | null, kinematicsExternalSpec?: ExternalKinematicSpecVarsFragment | null, kinematicsInternalSpec?: InternalKinematicSpecVarsFragment | null, reboundSpring?: AllCarSetupSpringVarsFragment | null, spring?: AllCarSetupSpringVarsFragment | null };

export type GetFullCarSetupQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetFullCarSetupQuery = { carSetup?: AllCarSetupVarsFragment | null };

export type AllCarSetupVarsFragment = { _id: any, authorID?: any | null, chassisAssemblyID?: any | null, chassisID?: any | null, chassisSpecID?: any | null, chassisSpecRootID?: any | null, contestantID?: any | null, createdAt?: any | null, custom?: any | null, customSimulationPayload?: any | null, customSimulationPayloadEnabled?: boolean | null, driverID?: any | null, engineerID?: any | null, eventID?: any | null, flattened?: any | null, flattenedValues?: any | null, historyIDs?: Array<any | null> | null, intendedForSession?: EnumCarSetupIntendedForSession | null, isPublic?: boolean | null, mBallasts?: any | null, runSheetID?: any | null, setupSheetStyle?: EnumCarSetupSetupSheetStyle | null, systemsConfigComment?: any | null, systemsConfigNIssues?: any | null, systemsConfigValues?: any | null, tagIDs?: Array<any | null> | null, teamID?: any | null, time?: any | null, title: string, updatedAt?: any | null, writeHistory?: boolean | null, aero?: AllCarSetupAeroVarsFragment | null, aeroPackage?: AllCarSetupAeroSpecVarsFragment | null, author?: AllPersonScalarVarsFragment | null, brakeSystem?: AllCarSetupBrakeSystemVarsFragment | null, chassis?: AllCarSetupChassisVarsFragment | null, chassisAssembly?: AllChassisAssemblyVarsFragment | null, chassisSpec?: AllChassisSpecVarsFragment | null, chassisSpecRoot?: AllChassisSpecVarsFragment | null, cockpit?: { rThrottlePedal?: number | null, throttlePedalPosition?: string | null } | null, driver?: AllPersonScalarVarsFragment | null, engineer?: AllPersonScalarVarsFragment | null, front?: AllCarSetupEndVarsFragment | null, frontLeft?: AllCarSetupCornerVarsFragment | null, frontRight?: AllCarSetupCornerVarsFragment | null, history: Array<AllHistoryVarsFragment>, info?: AllCarSetupInfoFragment | null, lastModifiedBy?: AllPersonScalarVarsFragment | null, massOutOfGarage?: AllCarSetupMassVarsFragment | null, massRegulation?: AllCarSetupMassVarsFragment | null, massSetup?: AllCarSetupMassVarsFragment | null, massTeam?: AllCarSetupMassVarsFragment | null, powertrainCentral?: AllCarSetupPowertrainVarsFragment | null, powertrainFront?: AllCarSetupPowertrainVarsFragment | null, powertrainRear?: AllCarSetupPowertrainVarsFragment | null, rear?: AllCarSetupEndVarsFragment | null, rearLeft?: AllCarSetupCornerVarsFragment | null, rearRight?: AllCarSetupCornerVarsFragment | null, runSheet?: AllRunSheetVarsFragment | null, steering?: AllCarSetupSteeringVarsFragment | null, tags: Array<AllTagVarsFragment>, team?: AllTeamVarsFragment | null };

export type AllCarSetupChassisVarsFragment = { _id: any, ballastPositions?: Array<string | null> | null, concurrentUseAllowed?: boolean | null, currentlyInUse?: boolean | null, decommissioned?: boolean | null, manufacturerPartID?: string | null, notes?: string | null, properties?: any | null, reference?: string | null, rootAssemblyIDs?: Array<any | null> | null, rootSpecificationID?: any | null, setupSheetStyle?: EnumChassisSetupSheetStyle | null, specificationID?: any | null, systemsConfigFields?: Array<string | null> | null, tagIDs?: Array<any | null> | null, type?: string | null };

export type AllCarSetupDamperVarsFragment = { configName?: string | null, gasPressure?: number | null, manufacturer?: string | null, NDamperBumpDO?: number | null, NDamperBumpDY?: number | null, NDamperBumpHS?: number | null, NDamperBumpIP?: number | null, NDamperBumpLS?: number | null, NDamperReboundDO?: number | null, NDamperReboundDY?: number | null, NDamperReboundHS?: number | null, NDamperReboundIP?: number | null, NDamperReboundLS?: number | null, specificationID?: any | null, valvingBumpSpec?: string | null, valvingReboundSpec?: string | null, xDamperMax?: number | null, adjusters?: Array<{ _id?: any | null, name?: string | null, settingName?: string | null, value?: number | null } | null> | null, specification?: DamperSpecVarsFragment | null };

export type AllCarSetupInfoFragment = { batteryID?: string | null, gearboxID?: string | null, NIssue?: number | null, NChanges?: number | null, inverterID?: string | null, driveshaftID?: string | null, engineID?: string | null, chassisID?: string | null, setupComments?: string | null, tyreCompound?: string | null, customIDs?: any | null };

export type AllCarSetupMassVarsFragment = { comment?: string | null, mCarFL?: number | null, mCarFR?: number | null, mCarRL?: number | null, mCarRR?: number | null, mCarTotal?: number | null, mDriver?: number | null, rCarCross?: number | null, rWeightF?: number | null, rWeightFTarget?: number | null };

export type AllCarSetupPowertrainVarsFragment = { differentialSpecID?: any | null, differentialConfigName?: string | null, aDiffRampDrive?: number | null, aDiffRampCoast?: number | null, MDiffPreloadCold?: number | null, MDiffPreloadHot?: number | null, NFrictionFaces?: number | null, frictionFaces?: string | null, dAirRestrictor?: number | null, clutch?: string | null, clutchCylinder?: string | null, gearboxGridType?: string | null, PPowerLevel?: number | null, rDropGear?: number | null, rBevelSet?: number | null, rGearRatios?: any | null, blanking?: any | null };

export type AllCarSetupSpringVarsFragment = { specificationID?: any | null, xSecondSpringTransition?: number | null, xSpringPreload?: number | null, specification?: ElasticSpecVarsFragment | null };

export type AllCarSetupSteeringVarsFragment = { steeringPinion?: string | null, steeringArm?: string | null, rSteerF?: number | null };

export type BasicContestantVarsFragment = { _id: any, startNumber: string, teamID?: any | null, class?: string | null };

export type ContestantVarsFragment = { _id: any, seasonID: any, startNumber: string, class?: string | null, chassisIDs?: Array<any | null> | null, teamID?: any | null, tyreIDs?: Array<any | null> | null, driverIDs?: Array<any | null> | null, color?: string | null, hidden?: boolean | null, manufacturerID?: any | null, chassis: Array<{ _id: any, reference?: string | null }>, tyres: Array<{ _id: any, name?: string | null }>, drivers: Array<{ _id: any, name: string }>, manufacturer?: { _id: any, name?: string | null } | null };

export type EventBaseVarsFragment = { _id: any, name: string, season?: { _id: any, name: string, raceSeries?: { _id: any, name: string } | null, contestants: Array<{ _id: any, startNumber: string }> } | null };

export type EventInSeasonVarsFragment = { _id: any, name: string, eventType?: string | null, NEventSeason?: number | null, tEventStart?: any | null, tEventEnd?: any | null, tLapAverage?: number | null, sessionIDs?: Array<any | null> | null, track?: { _id: any, timeZone?: string | null } | null, sessions: Array<(
    { _id: any, sessionType?: EnumSessionType | null }
    & SessionWithTimesVarsFragment
  )> };

export type EventTrackLayoutConsumptionVarsFragment = { _id: any, consumptions?: Array<{ trackLayoutID: any, trackLayout?: (
      { _id: any }
      & TrackLayoutVarsFragment
    ) | null, energyRequired?: AllRunEnergyVarsFragment | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null } | null> | null };

export type CommentVarsFragment = { _id?: any | null, text?: string | null, createdAt?: any | null, updatedAt?: any | null, author?: { _id: any, name: string } | null };

export type JobVarsFragment = { _id: any, number?: string | null, index?: number | null, priority?: EnumJobPriority | null, updatedAt?: any | null, createdAt?: any | null, assigneeIDs?: Array<any | null> | null, acknowledgedAt?: any | null, cancelledAt?: any | null, closedAt?: any | null, description: string, oneWordStatus: JobStatus, parentID?: any | null, runSheetID?: any | null, subTaskIDs?: Array<any | null> | null, createdBy?: { _id: any, name: string } | null, assignees: Array<{ _id: any, name: string }>, acknowledgedBy?: { _id: any, name: string } | null, cancelledBy?: { _id: any, name: string } | null, closedBy?: { _id: any, name: string } | null, comments?: Array<(
    { _id?: any | null }
    & CommentVarsFragment
  ) | null> | null, parentJob?: { __typename: 'Job', _id: any } | null, parentIssue?: { __typename: 'Issue', _id: any, description: string, number?: string | null } | null, runSheet?: { _id: any, NRun?: number | null, contestant?: { _id: any, startNumber: string } | null, session?: { _id: any, name: string, event?: { _id: any, name: string } | null } | null } | null, subTasks: Array<SubTaskVarsFragment> };

export type SubTaskVarsFragment = { _id: any, number?: string | null, index?: number | null, priority?: EnumJobPriority | null, updatedAt?: any | null, createdAt?: any | null, assigneeIDs?: Array<any | null> | null, acknowledgedAt?: any | null, cancelledAt?: any | null, closedAt?: any | null, description: string, parentID?: any | null, runSheetID?: any | null, createdBy?: { _id: any, name: string } | null, assignees: Array<{ _id: any, name: string }>, acknowledgedBy?: { _id: any, name: string } | null, cancelledBy?: { _id: any, name: string } | null, closedBy?: { _id: any, name: string } | null, comments?: Array<(
    { _id?: any | null }
    & CommentVarsFragment
  ) | null> | null };

export type JobListTemplateVarsFragment = { _id: any, index?: number | null, title: string, jobs: Array<JobListTemplateJobVarsFragment | null> };

export type JobListTemplateJobVarsFragment = { index?: number | null, description: string, priority?: EnumJobPriority | null, assigneeIDs?: Array<any | null> | null, assignees: Array<{ _id: any, name: string }> };

export type GridPlotPageConfigPlotVarsFragment = { index: number, title: string, xDataSource: string, yDataSource?: string | null, yData: any, xLabel: string, xAxisType: EnumPlotConfigXAxisType, yLabel?: string | null, yLines?: Array<{ value: number, color?: string | null } | null> | null };

export type LapVarsFragment = (
  { _id: any, BPitIn: boolean, BPitOut: boolean, energyLapStart?: number | null, energyRemaining?: number | null, energyRemainingData?: number | null, fuelConsumptionThisLap?: number | null, lapComment?: string | null, lapCommentSystems?: string | null, lapKPI?: any | null, laptimeServiceHash?: string | null, lapType?: EnumLapType | null, mFuelConsumptionThisLap?: number | null, mFuelLapEnd?: number | null, mFuelLapStart?: number | null, position?: number | null, powerMode?: number | null, raceControlMessage?: string | null, rEnergyConsumptionThisLap?: number | null, rEnergyLapEnd?: number | null, rEnergyLapStart?: number | null, rSOCConsumptionThisLap?: number | null, rSOCLapEnd?: number | null, rSOCLapStart?: number | null, TCell?: number | null, tDay?: any | null, tDayPitIn?: any | null, tDayPitOut?: any | null, tLapManual?: number | null, tLapMax?: number | null, trackLayoutID?: any | null, tSectorsManual?: Array<number | null> | null, tSectorsOfficial?: Array<number | null> | null, tSectorsTiming?: Array<number | null> | null, tyreCompoundTiming?: string | null, vCarLapMax?: number | null, vCarSectors?: Array<number | null> | null, data?: Array<LapDataVarsFragment | null> | null, trackLayout?: { _id: any, name: string, lapLengthOfficial?: number | null, lapLengthCarData?: number | null, lapLengthRoulette?: number | null, NSectorsTiming?: number | null } | null }
  & LapNumberVarsFragment
);

export type LapDataVarsFragment = { _id?: any | null, BDRSUsed?: boolean | null, BLapCancelled?: boolean | null, BLapIsSlow?: boolean | null, driverCallout?: string | null, driverCallout2?: string | null, kpi?: any | null, lapType?: EnumLapType | null, mFuelConsumptionThisLap?: number | null, mFuelLapEnd?: number | null, powerMode?: number | null, raceControlMessage?: string | null, rEnergyConsumptionThisLap?: number | null, rEnergyLapEnd?: number | null, rSOCConsumptionThisLap?: number | null, rSOCLapEnd?: number | null, source: EnumLapDataSource, TCell?: number | null, tDay?: any | null, tDayPitIn?: any | null, tDayPitOut?: any | null, tDaySectors?: Array<any | null> | null, tInPit?: number | null, tLapMax?: number | null, tSectors?: Array<number | null> | null, tSessionRemainingLapStart?: number | null, tyreCompound?: string | null, vCarLapMax?: number | null, vCarSectors?: Array<number | null> | null, trackStates?: Array<{ flag?: EnumTrackStateFlag | null, message?: string | null, timestamp?: any | null, _id?: any | null } | null> | null };

export type LapNumberVarsFragment = { NLapRun: number, NLapRunCarData?: number | null, NLapRunManual?: number | null, NLapSession?: number | null, NLapSessionCarData?: number | null, NLapSessionManual?: number | null, NLapStint?: number | null, NLapStintCarData?: number | null, NLapStintManual?: number | null };

export type RunEnergyVarsFragment = { ATTACK?: number | null, COOL?: number | null, FCY?: number | null, IN?: number | null, OUT?: number | null, OUTIN?: number | null, PITLANE?: number | null, PREP?: number | null, PUSH?: number | null, QUALI?: number | null, SAFETYCAR?: number | null, SHAKEDOWN?: number | null, SLOW?: number | null, TARGET?: number | null, TOGRID?: number | null, TOPADDOCK?: number | null, TOPITS?: number | null, UNFINISHED?: number | null, outLap?: number | null, inLap?: number | null, outInLap?: number | null, pushLap?: number | null, targetLap?: number | null, slowLap?: number | null, unfinishedLap?: number | null, coolLap?: number | null, attackLap?: number | null, qualiLap?: number | null, prepLap?: number | null, toGridLap?: number | null, toPitsLap?: number | null, fullCourseYellowLap?: number | null, safetyCarLap?: number | null, pitlaneLap?: number | null, shakedownLap?: number | null };

export type RunCommentVarsFragment = { _id: any, brakeComment?: string | null, controlsComment?: string | null, dilComments?: string | null, driverComments?: string | null, engineerComments?: string | null, problemComments?: string | null, runDescription?: string | null, skidComment?: string | null, systemsComments?: string | null, tyreComments?: string | null };

export type EnergyUsedVarsFragment = { _id: any, DFuel?: number | null, fuelDrainedBeforeRun?: boolean | null, mFuelAdded?: number | null, mFuelDrainedCatchTank?: number | null, mFuelDrainedMainTank?: number | null, mFuelRunEnd?: number | null, mFuelRunStart?: number | null, mFuelUsedPreRun?: number | null, rEnergyAdded?: number | null, rEnergyRunEnd?: number | null, rEnergyRunStart?: number | null, rSOCAdded?: number | null, rSOCRunEnd?: number | null, rSOCRunStart?: number | null };

export type RunSheetExportVarsFragment = (
  { _id: any, setup?: (
    { _id: any }
    & CarSetupVarsFragment
  ) | null }
  & RunSheetVarsFragment
  & RunSheetSessionVarsFragment
);

export type RunSheetSessionVarsFragment = { _id: any, session?: { _id: any, eventID: any, name: string, shortName?: string | null, tSessionEnd?: any | null, tSessionStart?: any | null, timeRemaining?: number | null, prevSessionID?: any | null, event?: { _id: any, name: string, DFuel?: number | null, contestants?: Array<{ _id: any, drivers: Array<{ _id: any, acronym?: string | null, displayColor?: string | null, name: string }> } | null> | null, consumptions?: Array<{ trackLayoutID: any, fuelRequired?: RunEnergyVarsFragment | null, SoCRequired?: RunEnergyVarsFragment | null, energyRequired?: RunEnergyVarsFragment | null } | null> | null, season?: { _id: any, name: string, raceSeries?: { _id: any, name: string } | null } | null, track?: { timeZone?: string | null } | null, trackLayouts: Array<{ _id: any, name: string, NSectorsTiming?: number | null, lapLengthOfficial?: number | null, trackID: any, track?: { name: string } | null }>, tyreDefaults?: Array<{ frontLeft?: { pTyreTarget?: number | null } | null, frontRight?: { pTyreTarget?: number | null } | null, rearLeft?: { pTyreTarget?: number | null } | null, rearRight?: { pTyreTarget?: number | null } | null } | null> | null, tyreDefaultsFL?: TyreDefaultFragmentFragment | null, tyreDefaultsFR?: TyreDefaultFragmentFragment | null, tyreDefaultsRL?: TyreDefaultFragmentFragment | null, tyreDefaultsRR?: TyreDefaultFragmentFragment | null, tyreDefaultsWetFL?: TyreDefaultFragmentFragment | null, tyreDefaultsWetFR?: TyreDefaultFragmentFragment | null, tyreDefaultsWetRL?: TyreDefaultFragmentFragment | null, tyreDefaultsWetRR?: TyreDefaultFragmentFragment | null } | null } | null };

export type RunSheetVarsFragment = (
  { _id: any, brakePostRunMeasurementsFL?: any | null, brakePostRunMeasurementsFR?: any | null, brakePostRunMeasurementsRL?: any | null, brakePostRunMeasurementsRR?: any | null, brakePreRunMeasurementsFL?: any | null, brakePreRunMeasurementsFR?: any | null, brakePreRunMeasurementsRL?: any | null, brakePreRunMeasurementsRR?: any | null, chassisAssemblyID?: any | null, contestantID: any, createdAt?: any | null, dataServiceFileNameOverride?: string | null, driverID?: any | null, endTime?: any | null, endTimeLTS?: any | null, endTimeManual?: any | null, info?: string | null, isLocked?: boolean | null, isLockedByLaptimeService?: boolean | null, issueIDs?: Array<any | null> | null, jobIDs?: Array<any | null> | null, kpiUpdatedAt?: any | null, mileage?: number | null, nextRunSheetID?: any | null, NRun?: number | null, NRunTiming?: number | null, prevRunSheetID?: any | null, runKPI?: any | null, selectedJobListTemplateID?: any | null, sessionID?: any | null, setupID?: any | null, skidPostRunMeasurements?: any | null, skidPreRunMeasurements?: any | null, startTime?: any | null, startTimeLTS?: any | null, startTimeManual?: any | null, TCellMaxRunStart?: number | null, teamID?: any | null, tGarageTurnaround?: number | null, timingServiceShouldIgnore?: boolean | null, tSessionRemainingOverride?: number | null, tSessionRemainingStartRun?: number | null, tWaitBeforeRun?: number | null, tyreSetID?: any | null, updatedAt?: any | null, consumptions?: Array<{ trackLayoutID: any, trackLayout?: { _id: any, name: string, track?: { _id: any, name: string } | null } | null, energyRequired?: AllRunEnergyVarsFragment | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null } | null> | null, contestant?: { _id: any, startNumber: string } | null, dashboard?: { mFuelRunEnd?: number | null, mFuelRunStart?: number | null } | null, driver?: { _id: any, acronym?: string | null, name: string } | null, fuelRequired?: AllRunEnergyVarsFragment | null, laps: Array<(
    { _id: any }
    & LapVarsFragment
  )>, laptimeThresholds?: { cool?: Array<number> | null, prep?: Array<number> | null, push?: Array<number> | null } | null, lastModifiedBy?: { _id: any, name: string } | null, setup?: { isLocked?: boolean | null, setupSheetStyle?: EnumCarSetupSetupSheetStyle | null } | null, SoCRequired?: AllRunEnergyVarsFragment | null, tyreFL?: RunTyreVarsFragment | null, tyreFR?: RunTyreVarsFragment | null, tyrePressureSettings?: { TTrackReference?: number | null } | null, tyreRL?: RunTyreVarsFragment | null, tyreRR?: RunTyreVarsFragment | null, weather?: { TAir?: number | null, TTrack?: number | null, pAmbient?: number | null, rHumidity?: number | null, DAir?: number | null, TAirOfficial?: number | null, TTrackOfficial?: number | null, ambientCondition?: string | null, trackCondition?: string | null } | null }
  & EnergyUsedVarsFragment
  & RunCommentVarsFragment
);

export type SessionDriverVarsFragment = { _id: any, endTime?: any | null, contestantID: any, NRun?: number | null, NRunTiming?: number | null, driverID?: any | null, setupID?: any | null, driver?: { _id: any, acronym?: string | null } | null, tyreSet?: { _id: any, name?: string | null, tyreFR?: { _id: any, name?: string | null } | null, tyreFL?: { _id: any, name?: string | null } | null, tyreRL?: { _id: any, name?: string | null } | null, tyreRR?: { _id: any, name?: string | null } | null } | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null, tyreFL?: { tyreID?: any | null, pTyre?: number | null, TTyre?: number | null, TTyrePostRun?: number | null, TTyrePostRunBleed?: number | null, pTyrePostRun?: number | null, pTyrePostRunBleed?: number | null } | null, tyreFR?: { tyreID?: any | null, pTyre?: number | null, TTyre?: number | null, TTyrePostRun?: number | null, TTyrePostRunBleed?: number | null, pTyrePostRun?: number | null, pTyrePostRunBleed?: number | null } | null, tyreRL?: { tyreID?: any | null, pTyre?: number | null, TTyre?: number | null, TTyrePostRun?: number | null, TTyrePostRunBleed?: number | null, pTyrePostRun?: number | null, pTyrePostRunBleed?: number | null } | null, tyreRR?: { tyreID?: any | null, pTyre?: number | null, TTyre?: number | null, TTyrePostRun?: number | null, TTyrePostRunBleed?: number | null, pTyrePostRun?: number | null, pTyrePostRunBleed?: number | null } | null, laps: Array<(
    { _id: any }
    & LapVarsFragment
  )> };

export type RunSheetForTyreVarsFragment = { _id: any, NRun?: number | null, NRunTiming?: number | null, mileage?: number | null, laps: Array<{ _id: any, NLapRun: number, trackLayoutID?: any | null }>, tyreFL?: RunTyreVarsFragment | null, tyreFR?: RunTyreVarsFragment | null, tyreRL?: RunTyreVarsFragment | null, tyreRR?: RunTyreVarsFragment | null, session?: { _id: any, name: string, event?: { _id: any, DFuel?: number | null, trackLayouts: Array<{ _id: any, lapLengthOfficial?: number | null, lapLengthCarData?: number | null, lapLengthRoulette?: number | null }> } | null } | null };

export type RunSheetForTyreMileageExportVarsFragment = { _id: any, NRun?: number | null, NRunTiming?: number | null, mileage?: number | null, session?: { _id: any, shortName?: string | null } | null };

export type RunSheetForEventSelectionVarsFragment = { _id: any, info?: string | null, NRun?: number | null, NRunTiming?: number | null, setupID?: any | null, updatedAt?: any | null, contestant?: { _id: any, hidden?: boolean | null, startNumber: string } | null, driver?: { _id: any, name: string, acronym?: string | null } | null, session?: { _id: any, name: string, shortName?: string | null, tSessionStart?: any | null, event?: { _id: any, name: string } | null } | null, setup?: { _id: any, setupInfo?: string | null, title: string, chassisSpec?: { _id?: any | null, name: string, simulationModels?: any | null } | null } | null };

export type RunSheetForEventSelectionForKpiSetupSimContextVarsFragment = { _id: any, NRun?: number | null, NRunTiming?: number | null, setupID?: any | null, contestant?: { _id: any, startNumber: string } | null, driver?: { _id: any, name: string, acronym?: string | null } | null, session?: { _id: any, name: string, shortName?: string | null, event?: { _id: any, name: string } | null } | null, setup?: { _id: any, title: string, chassisSpec?: { _id?: any | null, name: string } | null } | null };

export type AllRunSheetScalarVarsFragment = { _id: any, associatedKpiFiles?: Array<string | null> | null, brakeComment?: string | null, brakeMeasurementsFL?: any | null, brakeMeasurementsFR?: any | null, brakeMeasurementsRL?: any | null, brakeMeasurementsRR?: any | null, brakePostRunMeasurementsFL?: any | null, brakePostRunMeasurementsFR?: any | null, brakePostRunMeasurementsRL?: any | null, brakePostRunMeasurementsRR?: any | null, brakePreRunMeasurementsFL?: any | null, brakePreRunMeasurementsFR?: any | null, brakePreRunMeasurementsRL?: any | null, brakePreRunMeasurementsRR?: any | null, chassisAssemblyID?: any | null, cloudStorageURL?: string | null, contestantID: any, controlsComment?: string | null, createdAt?: any | null, DFuel?: number | null, driverComments?: string | null, driverID?: any | null, endTime?: any | null, engineerComments?: string | null, engineerID?: any | null, fastestLap?: number | null, finishTyreHeatingBy?: any | null, fuelDrainedBeforeRun?: boolean | null, jobIDs?: Array<any | null> | null, kpiFileName?: string | null, kpiStatus?: EnumRunSheetKpiStatus | null, kpiUpdatedAt?: any | null, lapCount: number, lapIDs?: Array<any | null> | null, lastModifiedByID?: any | null, mFuelAdded?: number | null, mFuelDrainedCatchTank?: number | null, mFuelDrainedMainTank?: number | null, mFuelRunEnd?: number | null, mFuelRunStart?: number | null, mileage?: number | null, nextRunSheetID?: any | null, NRun?: number | null, NRunTiming?: number | null, prevRunSheetID?: any | null, problemComments?: string | null, qRefuel?: number | null, rEnergyAdded?: number | null, rEnergyRunEnd?: number | null, rEnergyRunStart?: number | null, rSOCAdded?: number | null, rSOCRunEnd?: number | null, rSOCRunStart?: number | null, runDescription?: string | null, runSheetStyleID?: any | null, selectedJobListTemplateID?: any | null, sessionID?: any | null, setupID?: any | null, simResultIDs?: Array<any | null> | null, skidComment?: string | null, skidMeasurement?: any | null, skidPlateID?: any | null, skidPostRunMeasurements?: any | null, skidPreRunMeasurements?: any | null, startTime?: any | null, startTyreHeatingAt?: any | null, systemsComments?: string | null, TCellMaxRunStart?: number | null, teamID?: any | null, thirdPartyRunID?: string | null, timingServiceShouldIgnore?: boolean | null, tRefuel?: number | null, tyreComments?: string | null, tyreCompoundTiming?: string | null, tyreSetID?: any | null, updatedAt?: any | null, VFuelAdded?: number | null };

export type RunSheetSimulationVarsFragment = { _id: any, simResultIDs?: Array<any | null> | null, setupID?: any | null, NRun?: number | null, NRunTiming?: number | null, setup?: { _id: any, title: string, chassisSpec?: { _id?: any | null, name: string, simulationModels?: any | null } | null } | null, weather?: { TAirOfficial?: number | null, pAmbient?: number | null, rHumidity?: number | null } | null, session?: { shortName?: string | null, event?: { name: string } | null } | null, contestant?: { startNumber: string } | null };

export type AllRunSheetVarsFragment = { _id: any, associatedKpiFiles?: Array<string | null> | null, brakeComment?: string | null, brakePostRunMeasurementsFL?: any | null, brakePostRunMeasurementsFR?: any | null, brakePostRunMeasurementsRL?: any | null, brakePostRunMeasurementsRR?: any | null, brakePreRunMeasurementsFL?: any | null, brakePreRunMeasurementsFR?: any | null, brakePreRunMeasurementsRL?: any | null, brakePreRunMeasurementsRR?: any | null, chassisAssemblyID?: any | null, cloudStorageURL?: string | null, contestantID: any, controlsComment?: string | null, createdAt?: any | null, DFuel?: number | null, dilComments?: string | null, driverComments?: string | null, driverID?: any | null, endTime?: any | null, engineerComments?: string | null, engineerID?: any | null, fastestLap?: number | null, finishTyreHeatingBy?: any | null, fuelDrainedBeforeRun?: boolean | null, historyIDs?: Array<any | null> | null, isLockedByLaptimeService?: boolean | null, issueIDs?: Array<any | null> | null, jobIDs?: Array<any | null> | null, kpiFileName?: string | null, kpiStatus?: EnumRunSheetKpiStatus | null, kpiUpdatedAt?: any | null, lapCount: number, lapIDs?: Array<any | null> | null, lastModifiedByID?: any | null, mFuelAdded?: number | null, mFuelDrainedCatchTank?: number | null, mFuelDrainedMainTank?: number | null, mFuelRunEnd?: number | null, mFuelRunStart?: number | null, mileage?: number | null, nextRunSheetID?: any | null, NRun?: number | null, NRunTiming?: number | null, prevRunSheetID?: any | null, problemComments?: string | null, qRefuel?: number | null, rEnergyAdded?: number | null, rEnergyRunEnd?: number | null, rEnergyRunStart?: number | null, rSOCAdded?: number | null, rSOCRunEnd?: number | null, rSOCRunStart?: number | null, runDescription?: string | null, runSheetStyleID?: any | null, selectedJobListTemplateID?: any | null, sessionID?: any | null, setupID?: any | null, simResultIDs?: Array<any | null> | null, skidComment?: string | null, skidPlateID?: any | null, skidPostRunMeasurements?: any | null, skidPreRunMeasurements?: any | null, startTime?: any | null, startTyreHeatingAt?: any | null, systemsComments?: string | null, tagIDs?: Array<any | null> | null, TCellMaxRunStart?: number | null, teamID?: any | null, thirdPartyRunID?: string | null, timingServiceShouldIgnore?: boolean | null, tRefuel?: number | null, tyreComments?: string | null, tyreCompoundTiming?: string | null, tyreSetID?: any | null, updatedAt?: any | null, VFuelAdded?: number | null, writeHistory?: boolean | null, brakeFL?: AllRunBrakeFragment | null, brakeFR?: AllRunBrakeFragment | null, brakeRL?: AllRunBrakeFragment | null, brakeRR?: AllRunBrakeFragment | null, consumptions?: Array<AllRunSheetConsumptionVarsFragment | null> | null, contestant?: AllContestantScalarVarsFragment | null, dashboard?: { mFuelRunEnd?: number | null, mFuelRunStart?: number | null } | null, driver?: AllPersonScalarVarsFragment | null, engineer?: AllPersonScalarVarsFragment | null, history: Array<AllHistoryVarsFragment>, jobs: Array<AllJobScalarVarsFragment>, session?: AllSessionVarsFragment | null };

export type AllRunBrakeFragment = { hBrakeDiscPreRun?: number | null, TBrakePostRun?: number | null, TBrakePreRun?: number | null, thicknessMeasurements?: any | null };

export type AllRunSheetConsumptionVarsFragment = { trackLayoutID: any, energyRequired?: AllRunEnergyVarsFragment | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null };

type RunSheetStyleBlocksVars_BlankingBlock_Fragment = (
  { __typename: 'BlankingBlock' }
  & BlankingBlockVarsFragment
);

type RunSheetStyleBlocksVars_BrakesBlock_Fragment = (
  { __typename: 'BrakesBlock' }
  & BrakesBlockVarsFragment
);

type RunSheetStyleBlocksVars_CommentBlock_Fragment = (
  { __typename: 'CommentBlock' }
  & CommentBlockVarsFragment
);

type RunSheetStyleBlocksVars_DoubleCommentBlock_Fragment = (
  { __typename: 'DoubleCommentBlock' }
  & DoubleCommentBlockVarsFragment
);

type RunSheetStyleBlocksVars_FuelBlock_Fragment = (
  { __typename: 'FuelBlock' }
  & FuelBlockVarsFragment
);

type RunSheetStyleBlocksVars_IssueBlock_Fragment = (
  { __typename: 'IssueBlock' }
  & IssueBlockVarsFragment
);

type RunSheetStyleBlocksVars_JobListBlock_Fragment = (
  { __typename: 'JobListBlock' }
  & JobListBlockVarsFragment
);

type RunSheetStyleBlocksVars_LapTableBlock_Fragment = (
  { __typename: 'LapTableBlock' }
  & LapTableBlockVarsFragment
);

type RunSheetStyleBlocksVars_LapTimeThresholdsBlock_Fragment = (
  { __typename: 'LapTimeThresholdsBlock' }
  & LapTimeThresholdsBlockVarsFragment
);

type RunSheetStyleBlocksVars_LapTypeCountBlock_Fragment = (
  { __typename: 'LapTypeCountBlock' }
  & LapTypeCountBlockVarsFragment
);

type RunSheetStyleBlocksVars_MiniJobListBlock_Fragment = (
  { __typename: 'MiniJobListBlock' }
  & MiniJobListBlockVarsFragment
);

type RunSheetStyleBlocksVars_PostRunMeasurementBlock_Fragment = (
  { __typename: 'PostRunMeasurementBlock' }
  & PostRunMeasurementBlockVarsFragment
);

type RunSheetStyleBlocksVars_RunKpiTableBlock_Fragment = (
  { __typename: 'RunKPITableBlock' }
  & RunKpiTableBlockVarsFragment
);

type RunSheetStyleBlocksVars_SetupChangesBlock_Fragment = (
  { __typename: 'SetupChangesBlock' }
  & SetupChangesBlockVarsFragment
);

type RunSheetStyleBlocksVars_SetupSheetBlock_Fragment = (
  { __typename: 'SetupSheetBlock' }
  & SetupSheetBlockVarsFragment
);

type RunSheetStyleBlocksVars_TyreTableBlock_Fragment = (
  { __typename: 'TyreTableBlock' }
  & TyreTableBlockVarsFragment
);

type RunSheetStyleBlocksVars_WeatherBoxBlock_Fragment = (
  { __typename: 'WeatherBoxBlock' }
  & WeatherBoxBlockVarsFragment
);

export type RunSheetStyleBlocksVarsFragment = RunSheetStyleBlocksVars_BlankingBlock_Fragment | RunSheetStyleBlocksVars_BrakesBlock_Fragment | RunSheetStyleBlocksVars_CommentBlock_Fragment | RunSheetStyleBlocksVars_DoubleCommentBlock_Fragment | RunSheetStyleBlocksVars_FuelBlock_Fragment | RunSheetStyleBlocksVars_IssueBlock_Fragment | RunSheetStyleBlocksVars_JobListBlock_Fragment | RunSheetStyleBlocksVars_LapTableBlock_Fragment | RunSheetStyleBlocksVars_LapTimeThresholdsBlock_Fragment | RunSheetStyleBlocksVars_LapTypeCountBlock_Fragment | RunSheetStyleBlocksVars_MiniJobListBlock_Fragment | RunSheetStyleBlocksVars_PostRunMeasurementBlock_Fragment | RunSheetStyleBlocksVars_RunKpiTableBlock_Fragment | RunSheetStyleBlocksVars_SetupChangesBlock_Fragment | RunSheetStyleBlocksVars_SetupSheetBlock_Fragment | RunSheetStyleBlocksVars_TyreTableBlock_Fragment | RunSheetStyleBlocksVars_WeatherBoxBlock_Fragment;

export type BlankingBlockVarsFragment = { __typename: 'BlankingBlock', _id: any, colorMap?: any | null, defaultOpenState?: boolean | null, height?: number | null, isShownWhenFolded?: boolean | null, width?: number | null, x?: number | null, y?: number | null };

export type BrakesBlockVarsFragment = { __typename: 'BrakesBlock', _id: any, colorMap?: any | null, defaultOpenState?: boolean | null, height?: number | null, isShownWhenFolded?: boolean | null, showPostRunBrakeTemps?: boolean | null, showPreRunBrakeTemps?: boolean | null, temperatureUnit?: EnumTemperatureUnit | null, width?: number | null, x?: number | null, y?: number | null };

export type CommentBlockVarsFragment = { __typename: 'CommentBlock', _id: any, colorMap?: any | null, defaultOpenState?: boolean | null, field: EnumCommentBlockField, height?: number | null, isAlwaysOpen?: boolean | null, isShownWhenFolded?: boolean | null, rows?: number | null, title: string, width?: number | null, x?: number | null, y?: number | null };

export type DoubleCommentBlockVarsFragment = { __typename: 'DoubleCommentBlock', _id: any, colorMap?: any | null, defaultOpenState?: boolean | null, field1: string, field2: string, height?: number | null, isAlwaysOpen?: boolean | null, isShownWhenFolded?: boolean | null, label1: string, label2: string, rows?: number | null, title: string, width?: number | null, x?: number | null, y?: number | null };

export type FuelBlockVarsFragment = { __typename: 'FuelBlock', _id: any, colorMap?: any | null, defaultOpenState?: boolean | null, energyType?: EnumEnergyType | null, height?: number | null, isShownWhenFolded?: boolean | null, runEnergyFieldOrder?: Array<EnumRunEnergyField> | null, showExtendedConsumptionFields?: boolean | null, showFuelDensityInput?: boolean | null, showMaxLapsPerConsumptionFields?: boolean | null, style?: EnumRunSheetStyleBlockStyle | null, width?: number | null, x?: number | null, y?: number | null, runEnergyFields?: { attackLap?: string | null, coolLap?: string | null, fullCourseYellowLap?: string | null, inLap?: string | null, outInLap?: string | null, outLap?: string | null, prepLap?: string | null, pushLap?: string | null, qualiLap?: string | null, safetyCarLap?: string | null, slowLap?: string | null, targetLap?: string | null, toGridLap?: string | null, toPitsLap?: string | null, unfinishedLap?: string | null } | null };

export type IssueBlockVarsFragment = { __typename: 'IssueBlock', _id: any, colorMap?: any | null, defaultOpenState?: boolean | null, height?: number | null, isShownWhenFolded?: boolean | null, width?: number | null, x?: number | null, y?: number | null };

export type JobListBlockVarsFragment = { __typename: 'JobListBlock', _id: any, colorMap?: any | null, defaultOpenState?: boolean | null, height?: number | null, isShownWhenFolded?: boolean | null, width?: number | null, x?: number | null, y?: number | null };

export type LapTableBlockVarsFragment = { __typename: 'LapTableBlock', _id: any, colorMap?: any | null, defaultOpenState?: boolean | null, energyType?: EnumEnergyType | null, height?: number | null, isShownWhenFolded?: boolean | null, manualLapInputByDefault?: boolean | null, showLapTypeColors?: boolean | null, style?: EnumRunSheetStyleBlockStyle | null, width?: number | null, x?: number | null, y?: number | null, lapFlags?: { ATTACK?: string | null, COOL?: string | null, IN?: string | null, OUT?: string | null, OUTIN?: string | null, PREP?: string | null, PUSH?: string | null, QUALI?: string | null, SHAKEDOWN?: string | null, SLOW?: string | null, TARGET?: string | null, TOGRID?: string | null, TOPITS?: string | null, UNFINISHED?: string | null } | null, lapKPIs?: Array<{ _id?: any | null, field: string, label?: string | null, backgroundColor?: string | null } | null> | null, lapColumns?: Array<{ _id?: any | null, field: EnumLapColumnField, label?: string | null, backgroundColor?: string | null } | null> | null };

export type LapTimeThresholdsBlockVarsFragment = { __typename: 'LapTimeThresholdsBlock', _id: any, x?: number | null, y?: number | null, width?: number | null, height?: number | null, isShownWhenFolded?: boolean | null, defaultOpenState?: boolean | null, colorMap?: any | null };

export type LapTypeCountBlockVarsFragment = { __typename: 'LapTypeCountBlock', _id: any, blockBackgroundColour?: string | null, colorMap?: any | null, defaultOpenState?: boolean | null, height?: number | null, isShownWhenFolded?: boolean | null, width?: number | null, x?: number | null, y?: number | null, lapCountBlockFieldOrder?: Array<{ field?: EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField | null, show?: boolean | null } | null> | null };

export type MiniJobListBlockVarsFragment = { __typename: 'MiniJobListBlock', _id: any, x?: number | null, y?: number | null, width?: number | null, height?: number | null, isShownWhenFolded?: boolean | null, defaultOpenState?: boolean | null, colorMap?: any | null };

export type PostRunMeasurementBlockVarsFragment = { __typename: 'PostRunMeasurementBlock', _id: any, x?: number | null, y?: number | null, width?: number | null, height?: number | null, isShownWhenFolded?: boolean | null, defaultOpenState?: boolean | null, style?: EnumRunSheetStyleBlockStyle | null, colorMap?: any | null };

export type RunKpiTableBlockVarsFragment = { __typename: 'RunKPITableBlock', _id: any, x?: number | null, y?: number | null, width?: number | null, height?: number | null, isShownWhenFolded?: boolean | null, defaultOpenState?: boolean | null, colorMap?: any | null, runKPIRows?: Array<{ _id?: any | null, label: string, keys: Array<string | null>, unit?: string | null, decimals?: number | null, gain?: Array<number | null> | null } | null> | null };

export type SetupChangesBlockVarsFragment = { __typename: 'SetupChangesBlock', _id: any, colorMap?: any | null, defaultOpenState?: boolean | null, height?: number | null, isShownWhenFolded?: boolean | null, x?: number | null, y?: number | null, width?: number | null };

export type SetupSheetBlockVarsFragment = { __typename: 'SetupSheetBlock', _id: any, x?: number | null, y?: number | null, width?: number | null, height?: number | null, isShownWhenFolded?: boolean | null, defaultOpenState?: boolean | null, colorMap?: any | null };

export type TyreTableBlockVarsFragment = { __typename: 'TyreTableBlock', _id: any, colorMap?: any | null, defaultOpenState?: boolean | null, height?: number | null, isShownWhenFolded?: boolean | null, mileageUnit?: EnumLengthUnit | null, pressureUnit?: EnumPressureUnit | null, showGetPreviousRunPostPressureButton?: boolean | null, showGetRecommendationButton?: boolean | null, showMinimumPressures?: boolean | null, showSurfaceTemps?: boolean | null, showTargetPressures?: boolean | null, showTyreReferencePressure?: boolean | null, showTyreSelector?: boolean | null, showTyreSetSelector?: boolean | null, style?: EnumRunSheetStyleBlockStyle | null, temperatureUnit?: EnumTemperatureUnit | null, treadDepthUnit?: EnumLengthUnit | null, tyreTreadDepthMeasurements?: number | null, width?: number | null, x?: number | null, y?: number | null, staggerSettings?: { unit?: EnumLengthUnit | null, decimals?: number | null } | null, standardTyrePressureBox?: { decimalPlaces?: number | null, label?: string | null, options?: Array<EnumPressureOption | null> | null, unit?: EnumPressureUnit | null } | null, standardTyreTempBox?: { decimalPlaces?: number | null, label?: string | null, options?: Array<EnumTemperatureOption | null> | null, unit?: EnumTemperatureUnit | null } | null, tyreTableRows?: Array<{ field?: EnumTyreTableField | null, label?: string | null, backgroundColor?: string | null, highlightChanges?: boolean | null, lowerLimit?: { limit?: number | null, backgroundColor?: string | null, textColor?: string | null } | null, upperLimit?: { limit?: number | null, backgroundColor?: string | null, textColor?: string | null } | null } | null> | null };

export type WeatherBoxBlockVarsFragment = { __typename: 'WeatherBoxBlock', _id: any, colorMap?: any | null, defaultOpenState?: boolean | null, height?: number | null, isShownWhenFolded?: boolean | null, showAmbientAndTrackCondition?: boolean | null, showOfficial?: boolean | null, style?: EnumRunSheetStyleBlockStyle | null, unitSystem?: EnumUnitSystem | null, width?: number | null, x?: number | null, y?: number | null };

export type RunTyreVarsFragment = { tyreID?: any | null, pTyre?: number | null, TTyre?: number | null, pTyrePostRun?: number | null, TTyrePostRun?: number | null, pTyrePreRunBleed?: number | null, pTyrePostRunBleed?: number | null, TTyrePreRunBleed?: number | null, TTyrePostRunBleed?: number | null, TTyreSurface?: Array<number | null> | null, hTyreTread?: Array<number | null> | null, pTyreReference?: number | null, TTyreReference?: number | null, TTrackReference?: number | null, pTyreStartRun?: number | null, pTyreMinStartRun?: number | null, pTyreSetDown?: number | null, TTyreSetdown?: number | null, pTyreTarget?: number | null, TTyreParcFermeExpected?: number | null, mileagePreRun?: number | null };

export type SessionBaseVarsFragment = { _id: any, name: string, shortName?: string | null, eventID: any };

export type BasicSessionVarsFragment = { _id: any, name: string, shortName?: string | null };

export type SessionWithTimesVarsFragment = { _id: any, name: string, sessionType?: EnumSessionType | null, shortName?: string | null, tSessionStart?: any | null, tSessionEnd?: any | null };

export type SessionInRangeVarsFragment = { _id: any, name: string, shortName?: string | null, tSessionStart?: any | null, tSessionEnd?: any | null, sessionType?: EnumSessionType | null, event?: { name: string, _id: any, season?: { name: string, _id: any, raceSeries?: { name: string, _id: any } | null } | null } | null };

export type SetupOverviewConfigFieldVarsFragment = { _id?: any | null, keys: Array<string | null>, label: string, unit?: string | null, decimals?: number | null, gain?: Array<number | null> | null };

export type SetupOverviewConfigRowElementVarsFragment = { _id?: any | null, decimals?: number | null, field: string, gain?: number | null, suffix?: string | null, unitType: { angleUnit: EnumAngleUnit } | { forceUnit: EnumForceUnit } | { lengthUnit: EnumLengthUnit } | { massUnit: EnumMassUnit } | { numberUnit: EnumUntypedUnit } | { powerUnit: EnumPowerUnit } | { pressureUnit: EnumPressureUnit } | { ratioUnit: EnumRatioUnit } | { springRateUnit: EnumSpringRateUnit } | { stringUnit: EnumUntypedUnit } | { temperatureUnit: EnumTemperatureUnit } | { torqueUnit: EnumTorqueUnit } | {} };

export type SetupOverviewConfigRowVarsFragment = { _id?: any | null, title: string, elements?: Array<(
    { _id?: any | null }
    & SetupOverviewConfigRowElementVarsFragment
  ) | null> | null };

export type SetupSheetStyleBlockVarsFragment = { _id?: any | null, x: number, y: number, width: number, height: number, borderColor?: string | null, backgroundColor?: string | null, tabs: Array<{ title: string, type?: EnumSetupSheetStyleTabType | null, rows: Array<{ _id?: any | null, items: Array<{ type: EnumSetupSheetStyleItemType, label?: string | null, fieldKey?: string | null, colSpan?: number | null, widthRatio?: number | null, restrictedToRoles: Array<EnumPersonRole>, _id?: any | null }> }>, groups: Array<{ header?: string | null, _id?: any | null, rows: Array<{ _id?: any | null, items: Array<{ type: EnumSetupSheetStyleItemType, label?: string | null, fieldKey?: string | null, colSpan?: number | null, widthRatio?: number | null, restrictedToRoles: Array<EnumPersonRole>, _id?: any | null }> }> }> }> };

export type SimResultVarsFragment = { carSetupID?: any | null, trackLayoutID?: any | null, specificationID?: any | null, runSheetID?: any | null, source?: string | null, simulationService?: EnumSimModelType | null, version?: string | null, sourceReferenceID?: string | null, simType?: EnumSimResultSimType | null, TAmbient?: number | null, pAmbient?: number | null, rHumidity?: number | null, carSetupModifiedAt?: any | null, refValues?: any | null, defaultChannelTime?: Array<number | null> | null, requesterID?: any | null, status?: EnumSimResultStatus | null, statusMessage?: string | null, _id: any, updatedAt?: any | null, createdAt?: any | null, isCarSetupChanged?: boolean | null, carSetup?: (
    { _id: any, title: string }
    & CarSetupVarsFragment
  ) | null, data?: Array<(
    { _id?: any | null }
    & SimResultDataVarsFragment
  ) | null> | null, trackLayout?: (
    { _id: any }
    & TrackLayoutVarsFragment
  ) | null, requester?: { _id: any, name: string, username: string } | null };

export type SimResultCondensedVarsFragment = { _id: any, updatedAt?: any | null, createdAt?: any | null, status?: EnumSimResultStatus | null, statusMessage?: string | null, carSetupID?: any | null, specificationID?: any | null, simulationService?: EnumSimModelType | null, version?: string | null, sourceReferenceID?: string | null, simType?: EnumSimResultSimType | null, carSetupModifiedAt?: any | null, isCarSetupChanged?: boolean | null, requesterID?: any | null };

export type AeroElementVarsFragment = { __typename: 'AeroElementSpec', _id?: any | null, name: string, updatedAt?: any | null, createdAt?: any | null, decommissioned?: boolean | null, attachable?: boolean | null, allowableSockets?: Array<string | null> | null, allowableParentSpecIDs?: Array<any | null> | null, positionNames?: Array<string | null> | null, positions?: Array<number | null> | null, CzF?: Array<number | null> | null, CzR?: Array<number | null> | null, CxT?: Array<number | null> | null, aeroElementInterpolationMethod?: EnumAeroElementInterpolationMethod | null, aeroElementType?: EnumAeroElementType | null, polyCzF?: Array<number | null> | null, polyCzR?: Array<number | null> | null, polyCxT?: Array<number | null> | null, simulationModels?: any | null, prevIterationID?: any | null, nextIterationID?: any | null, iterationIDs?: Array<any | null> | null, iterations: Array<{ _id?: any | null, name: string }> };

export type AeroPackageVarsFragment = { __typename: 'AeroPackageSpec', _id?: any | null, name: string, updatedAt?: any | null, createdAt?: any | null, decommissioned?: boolean | null, prevIterationID?: any | null, nextIterationID?: any | null, aeroElementSpecIDs?: Array<any | null> | null, allowableParentSpecIDs?: Array<any | null> | null, chassisSpecID?: any | null, iterationIDs?: Array<any | null> | null, aeroElementSpecs: Array<(
    { _id?: any | null }
    & AeroElementVarsFragment
  )>, iterations: Array<{ _id?: any | null, name: string }> };

export type AntiRollBarVarsFragment = { __typename: 'AntiRollBarSpec', _id?: any | null, updatedAt?: any | null, createdAt?: any | null, name: string, decommissioned?: boolean | null, prevIterationID?: any | null, nextIterationID?: any | null, allowableParentSpecIDs?: Array<any | null> | null, chassisSpecID?: any | null, antiRollBarDisplayLocation?: EnumAntiRollBarDisplayLocation | null, iterationIDs?: Array<any | null> | null, antiRollBarConfigs?: Array<{ position1?: string | null, position2?: string | null, kARB?: number | null, simulationModels?: any | null } | null> | null, iterations: Array<{ _id?: any | null, name: string }> };

export type MassPropertiesVarsFragment = { mass?: number | null, COGx?: number | null, COGy?: number | null, COGz?: number | null, Ixx?: number | null, Iyy?: number | null, Izz?: number | null };

export type ChassisMassVarsFragment = { base?: { mass?: number | null, COGx?: number | null, COGy?: number | null, COGz?: number | null, Ixx?: number | null, Iyy?: number | null, Izz?: number | null } | null, driver?: { mass?: number | null, COGx?: number | null, COGy?: number | null, COGz?: number | null, Ixx?: number | null, Iyy?: number | null, Izz?: number | null } | null, setupEquip?: { mass?: number | null, COGx?: number | null, COGy?: number | null, COGz?: number | null, Ixx?: number | null, Iyy?: number | null, Izz?: number | null } | null };

export type ChassisRegulationSetVarsFragment = { name: string, decommissioned?: boolean | null, massMin?: number | null, hRideFrontMin?: number | null, hRideRearMin?: number | null, massDistRunningMin?: number | null, massDistRunningMax?: number | null, massDistStaticMin?: number | null, massDistStaticMax?: number | null };

export type ChassisMeasurementVarsFragment = { angles?: EnumAngleUnit | null, angularCompliances?: EnumAngularComplianceUnit | null, angularTorqueCompliances?: EnumAngularTorqueComplianceUnit | null, bumpPlateMeasurementMethod?: EnumBumpPlateMeasurementMethod | null, bumpPlateRefFront?: number | null, bumpPlateRefRear?: number | null, compliances?: EnumComplianceUnit | null, forces?: EnumForceUnit | null, inertias?: EnumInertiaUnit | null, inverseCamber?: boolean | null, kinematicsExternalReadingsRequired?: EnumChassisMeasurementsKinematicsExternalReadingsRequired | null, kinematicsInternalReadingsRequired?: EnumChassisMeasurementsKinematicsInternalReadingsRequired | null, lengths?: EnumLengthUnit | null, masses?: EnumMassUnit | null, powers?: EnumPowerUnit | null, pressures?: EnumPressureUnit | null, ratios?: EnumRatioUnit | null, rideHeightCalcFront?: string | null, rideHeightCalcRear?: string | null, springRates?: EnumSpringRateUnit | null, steeringRackRatios?: EnumSteeringRackRatioUnit | null, temperatures?: EnumTemperatureUnit | null, toeMeasurementMethod?: EnumToeMeasurementMethod | null, toeRefFront?: number | null, toeRefRear?: number | null, toeTotal?: boolean | null, torques?: EnumTorqueUnit | null, torsionRates?: EnumTorsionRateUnit | null, volumes?: EnumVolumeUnit | null, xTrackFront?: number | null, xTrackRear?: number | null, xWheelbase?: number | null };

export type ChassisPowertrainVarsFragment = { layout?: EnumPowertrainLayout | null, dropGearSpecIDs?: Array<any | null> | null, bevelSetSpecIDs?: Array<any | null> | null, gearBoxSpecIDs?: Array<any | null> | null, gearSpecIDs?: Array<any | null> | null, differentialSpecIDs?: Array<any | null> | null, numGears?: number | null, dropGearSpecs: Array<(
    { _id?: any | null }
    & GearSpecVarsFragment
  )>, bevelSetSpecs: Array<(
    { _id?: any | null }
    & GearSpecVarsFragment
  )>, gearBoxSpecs: Array<(
    { _id?: any | null }
    & GearBoxSpecVarsFragment
  )>, gearSpecs: Array<(
    { _id?: any | null }
    & GearSpecVarsFragment
  )>, differentialSpecs: Array<(
    { _id?: any | null }
    & DifferentialSpecVarsFragment
  )> };

export type ChassisBrakeBiasVarsFragment = { minValue?: number | null, maxValue?: number | null, step?: number | null, values?: Array<number | null> | null, valueNames?: Array<string | null> | null, unit?: EnumRatioUnit | null, sign?: boolean | null };

export type DamperSpecVarsFragment = { __typename: 'DamperSpec', _id?: any | null, allowableParentSpecIDs?: Array<any | null> | null, allowableSockets?: Array<string | null> | null, chassisSpecID?: any | null, createdAt?: any | null, decommissioned?: boolean | null, iterationIDs?: Array<any | null> | null, name: string, nextIterationID?: any | null, prevIterationID?: any | null, readingsAllowable?: Array<EnumReadingLocation> | null, updatedAt?: any | null, damperAdjusters?: Array<{ name: string, minSetting?: number | null, maxSetting?: number | null, step?: number | null, settings?: Array<number | null> | null, settingNames?: Array<string | null> | null } | null> | null, damperConfigs?: Array<{ name: string, simulationModels?: any | null, forceTable?: { xMin?: number | null, xMax?: number | null, x?: Array<number | null> | null, force?: Array<number | null> | null, velocity?: Array<number | null> | null, dampingForce?: Array<number | null> | null, acceleration?: Array<number | null> | null, inertanceForce?: Array<number | null> | null } | null } | null> | null, iterations: Array<{ _id?: any | null, name: string }> };

export type DifferentialSpecVarsFragment = { __typename: 'DifferentialSpec', _id?: any | null, updatedAt?: any | null, createdAt?: any | null, name: string, decommissioned?: boolean | null, prevIterationID?: any | null, nextIterationID?: any | null, allowableParentSpecIDs?: Array<any | null> | null, powertrainLocation?: EnumSpecificationPowertrainLocation | null, chassisSpecID?: any | null, iterationIDs?: Array<any | null> | null, differentialConfigs?: Array<{ name: string, decommissioned?: boolean | null, rampAccel?: number | null, rampDecel?: number | null, frictionFaces?: string | null, maxPreloadForce?: number | null, simulationModels?: any | null } | null> | null, iterations: Array<{ _id?: any | null, name: string }> };

export type ElasticSpecVarsFragment = { __typename: 'ElasticSpec', _id?: any | null, allowableParentSpecIDs?: Array<any | null> | null, allowableSockets?: Array<string | null> | null, chassisSpecID?: any | null, createdAt?: any | null, decommissioned?: boolean | null, elasticType?: EnumElasticType | null, iterationIDs?: Array<any | null> | null, kSpring?: number | null, name: string, nextIterationID?: any | null, prevIterationID?: any | null, readingsAllowable?: Array<EnumReadingLocation> | null, simulationModels?: any | null, updatedAt?: any | null, xBumpStopGapDefault?: number | null, xDamperSetupDefault?: number | null, xDroopStopGapDefault?: number | null, xFree?: number | null, forceTable?: { xMin?: number | null, xMax?: number | null, x?: Array<number | null> | null, force?: Array<number | null> | null, velocity?: Array<number | null> | null, dampingForce?: Array<number | null> | null, acceleration?: Array<number | null> | null, inertanceForce?: Array<number | null> | null } | null, iterations: Array<{ _id?: any | null, name: string }> };

export type GearSpecVarsFragment = { __typename: 'GearSpec', _id?: any | null, updatedAt?: any | null, createdAt?: any | null, name: string, decommissioned?: boolean | null, gearType?: EnumGearType | null, prevIterationID?: any | null, nextIterationID?: any | null, numerator: number, denominator: number, allowableGearNums?: Array<number | null> | null, allowableParentSpecIDs?: Array<any | null> | null, chassisSpecID?: any | null, isHeadGear?: boolean | null, iterationIDs?: Array<any | null> | null, iterations: Array<{ _id?: any | null, name: string }> };

export type GearBoxSpecVarsFragment = { __typename: 'GearBoxSpec', _id?: any | null, updatedAt?: any | null, createdAt?: any | null, name: string, dropGearSpecID?: any | null, bevelSetSpecID?: any | null, differentialSpecID?: any | null, headGearSpecID?: any | null, decommissioned?: boolean | null, prevIterationID?: any | null, nextIterationID?: any | null, allowableParentSpecIDs?: Array<any | null> | null, chassisSpecID?: any | null, iterationIDs?: Array<any | null> | null, rootSpecificationID: any, assignedGears?: Array<{ gearID: any, useHeadGear?: boolean | null, gear?: { _id?: any | null, isHeadGear?: boolean | null } | null } | null> | null, iterations: Array<{ _id?: any | null, name: string }> };

export type ExternalKinematicSpecVarsFragment = { __typename: 'KinematicsExternalSpec', _id?: any | null, updatedAt?: any | null, createdAt?: any | null, name: string, decommissioned?: boolean | null, prevIterationID?: any | null, nextIterationID?: any | null, iterationIDs?: Array<any | null> | null, allowableParentSpecIDs?: Array<any | null> | null, chassisSpecID?: any | null, initialChassisSpecID?: any | null, axle?: EnumAxle | null, aCasterMeasurementGain?: number | null, aCasterMeasurementOffset?: number | null, kinematicsExternalModels?: Array<{ aCaster?: number | null, simulationModels?: any | null, uprightPosition?: number | null, uprightPositionName?: string | null } | null> | null, hRide?: { minValue?: number | null, maxValue?: number | null, step?: number | null, values?: Array<number | null> | null, valueNames?: Array<string | null> | null, unit?: EnumSpecificationHRideUnit | null, sign?: boolean | null, readingsRequired?: EnumSpecificationHRideReadingsRequired | null } | null, aCamber?: { minValue?: number | null, maxValue?: number | null, step?: number | null, values?: Array<number | null> | null, valueNames?: Array<string | null> | null, unit?: EnumSpecificationACamberUnit | null, sign?: boolean | null, readingsRequired?: EnumSpecificationACamberReadingsRequired | null } | null, aToe?: { minValue?: number | null, maxValue?: number | null, step?: number | null, values?: Array<number | null> | null, valueNames?: Array<string | null> | null, unit?: EnumSpecificationACamberUnit | null, sign?: boolean | null, readingsRequired?: EnumSpecificationACamberReadingsRequired | null } | null, aCaster?: { minValue?: number | null, maxValue?: number | null, step?: number | null, values?: Array<number | null> | null, valueNames?: Array<string | null> | null, unit?: EnumSpecificationACamberUnit | null, sign?: boolean | null, readingsRequired?: EnumSpecificationACamberReadingsRequired | null } | null, iterations: Array<{ _id?: any | null, name: string }> };

export type InternalKinematicSpecVarsFragment = { __typename: 'KinematicsInternalSpec', _id?: any | null, updatedAt?: any | null, createdAt?: any | null, name: string, decommissioned?: boolean | null, prevIterationID?: any | null, nextIterationID?: any | null, iterationIDs?: Array<any | null> | null, allowableParentSpecIDs?: Array<any | null> | null, chassisSpecID?: any | null, initialChassisSpecID?: any | null, axle?: EnumAxle | null, springReference?: EnumKinematicsInternalReference | null, bumpRubberReference?: EnumKinematicsInternalReference | null, xSpringRef?: number | null, xBumpRubberRef?: number | null, xSpringPlatformOffset?: number | null, simulationModels?: any | null, xSpringSetup?: { minValue?: number | null, maxValue?: number | null, step?: number | null, values?: Array<number | null> | null, valueNames?: Array<string | null> | null, unit?: EnumLengthUnit | null, sign?: boolean | null } | null, xBumpRubberSetup?: { minValue?: number | null, maxValue?: number | null, step?: number | null, values?: Array<number | null> | null, valueNames?: Array<string | null> | null, unit?: EnumLengthUnit | null, sign?: boolean | null } | null, FSpringSetup?: { minValue?: number | null, maxValue?: number | null, step?: number | null, values?: Array<number | null> | null, valueNames?: Array<string | null> | null, unit?: EnumForceUnit | null, sign?: boolean | null } | null, iterations: Array<{ _id?: any | null, name: string }> };

export type CustomSpecVarsFragment = { __typename: 'CustomSpec', _id?: any | null, allowableParentSpecIDs?: Array<any | null> | null, allowableSockets?: Array<string | null> | null, chassisSpecID?: any | null, createdAt?: any | null, decommissioned?: boolean | null, description?: string | null, initialChassisSpecID?: any | null, iterationIDs?: Array<any | null> | null, manufacturerID?: any | null, name: string, nextIterationID?: any | null, prevIterationID?: any | null, readingsRequired?: EnumCustomSpecReadingsRequired | null, rootSpecificationID: any, updatedAt?: any | null, adjustableProperties?: Array<AdjustableAccelerationPropertyVarsFragment | AdjustableAnglePropertyVarsFragment | AdjustableAngularCompliancePropertyVarsFragment | AdjustableAngularTorqueCompliancePropertyVarsFragment | AdjustableBooleanPropertyVarsFragment | AdjustableCompliancePropertyVarsFragment | AdjustableForcePropertyVarsFragment | AdjustableInertiaPropertyVarsFragment | AdjustableLengthPropertyVarsFragment | AdjustableLocationPropertyVarsFragment | AdjustableMassPropertyVarsFragment | AdjustableNumberPropertyVarsFragment | AdjustableOrientationPropertyVarsFragment | AdjustablePowerPropertyVarsFragment | AdjustablePressurePropertyVarsFragment | AdjustableRatioPropertyVarsFragment | AdjustableSpringRatePropertyVarsFragment | AdjustableSteeringRackRatioPropertyVarsFragment | AdjustableStringPropertyVarsFragment | AdjustableTemperaturePropertyVarsFragment | AdjustableTorquePropertyVarsFragment | AdjustableTorsionRatePropertyVarsFragment | AdjustableVolumePropertyVarsFragment | null> | null, iterations: Array<{ _id?: any | null, name: string }>, manufacturer: Array<{ _id: any, name?: string | null } | null>, massProperties?: MassPropertiesVarsFragment | null };

export type AllAeroElementSpecVarsFragment = { _id?: any | null, aeroElementInterpolationMethod?: EnumAeroElementInterpolationMethod | null, aeroElementType?: EnumAeroElementType | null, aeroPackageSpecID?: any | null, allowableParentSpecIDs?: Array<any | null> | null, allowableSockets?: Array<string | null> | null, attachable?: boolean | null, buildSheetVisible?: boolean | null, chassisSpecID?: any | null, concurrentUseAllowed?: boolean | null, createdAt?: any | null, CxT?: Array<number | null> | null, CzF?: Array<number | null> | null, CzR?: Array<number | null> | null, decommissioned?: boolean | null, initialChassisSpecID?: any | null, iterationIDs?: Array<any | null> | null, name: string, nextIterationID?: any | null, polyCxT?: Array<number | null> | null, polyCzF?: Array<number | null> | null, polyCzR?: Array<number | null> | null, positionNames?: Array<string | null> | null, positions?: Array<number | null> | null, prevIterationID?: any | null, released?: boolean | null, rootSpecificationID: any, simulationModels?: any | null, specificationGroupID?: any | null, tagIDs?: Array<any | null> | null, trackingItemIDs?: Array<any | null> | null, updatedAt?: any | null };

export type AllAeroPackageSpecVarsFragment = { __typename: 'AeroPackageSpec', _id?: any | null, aeroElementSpecIDs?: Array<any | null> | null, allowableParentSpecIDs?: Array<any | null> | null, chassisSpecID?: any | null, createdAt?: any | null, decommissioned?: boolean | null, iterationIDs?: Array<any | null> | null, name: string, nextIterationID?: any | null, prevIterationID?: any | null, updatedAt?: any | null, aeroElementSpecs: Array<(
    { _id?: any | null }
    & AllAeroElementSpecVarsFragment
  )> };

export type AllAntiRollBarSpecVarsFragment = { __typename: 'AntiRollBarSpec', _id?: any | null, allowableParentSpecIDs?: Array<any | null> | null, antiRollBarDisplayLocation?: EnumAntiRollBarDisplayLocation | null, chassisSpecID?: any | null, createdAt?: any | null, decommissioned?: boolean | null, iterationIDs?: Array<any | null> | null, name: string, nextIterationID?: any | null, prevIterationID?: any | null, updatedAt?: any | null, antiRollBarConfigs?: Array<{ position1?: string | null, position2?: string | null, kARB?: number | null, simulationModels?: any | null } | null> | null };

export type AllChassisSpecVarsFragment = { __typename: 'ChassisSpec', _id?: any | null, aeroPackageSpecIDs?: Array<any | null> | null, allowableParentSpecIDs?: Array<any | null> | null, antiRollBarSpecIDs?: Array<any | null> | null, buildSheetStyleIDs?: Array<any | null> | null, buildSheetVisible?: boolean | null, bumpRubberSpecIDs?: Array<any | null> | null, calculationIDs?: Array<any | null> | null, canopyVersion?: string | null, chassisMeasurementIDs?: Array<any | null> | null, concurrentUseAllowed?: boolean | null, copyReferencePackageID?: any | null, createdAt?: any | null, customSpecIDs?: Array<any | null> | null, customSpecTypes: Array<string>, damperSpecIDs?: Array<any | null> | null, decommissioned?: boolean | null, flattened?: any | null, flattenedKeys?: Array<string> | null, helperSpringSpecIDs?: Array<any | null> | null, iterationIDs?: Array<any | null> | null, kinematicsExternalSpecIDs?: Array<any | null> | null, kinematicsInternalSpecIDs?: Array<any | null> | null, modelTypes?: Array<EnumSimModelType | null> | null, name: string, nextIterationID?: any | null, prevIterationID?: any | null, reboundSpringSpecIDs?: Array<any | null> | null, released?: boolean | null, releaseDate?: any | null, rootSpecificationID: any, setupSheetStyleIDs?: Array<any | null> | null, simulationAvailable?: boolean | null, simulationModels?: any | null, specificationGroupIDs?: Array<any | null> | null, springSpecIDs?: Array<any | null> | null, tagIDs?: Array<any | null> | null, torsionBarSpecIDs?: Array<any | null> | null, trackingItemIDs?: Array<any | null> | null, trackingSourceIDs?: Array<any | null> | null, updatedAt?: any | null, version?: string | null, aeroPackageSpecs: Array<(
    { _id?: any | null }
    & AeroPackageVarsFragment
  )>, antiRollBarSpecs: Array<(
    { _id?: any | null }
    & AntiRollBarVarsFragment
  )>, buildSheetStyles: Array<{ _id: any, name: string }>, bumpRubberSpecs: Array<(
    { _id?: any | null }
    & ElasticSpecVarsFragment
  )>, calculations: Array<(
    { _id: any }
    & CalculationVarsFragment
  )>, chassisMeasurements: Array<AllChassisMeasurementSpecVarsFragment>, customSpecs: Array<(
    { _id?: any | null }
    & CustomSpecVarsFragment
  )>, customSimulationModels?: Array<{ data?: any | null, dataMapping?: EnumSpecificationCustomSimulationModelsDataMapping | null, endPoint?: string | null, name: string, serverPort?: number | null, version?: string | null } | null> | null, damperSpecs: Array<(
    { _id?: any | null }
    & DamperSpecVarsFragment
  )>, helperSpringSpecs: Array<(
    { _id?: any | null }
    & ElasticSpecVarsFragment
  )>, iterations: Array<AllChassisSpecVarsIterationFragment>, kinematicsExternalSpecs: Array<(
    { _id?: any | null }
    & ExternalKinematicSpecVarsFragment
  )>, kinematicsInternalSpecs: Array<(
    { _id?: any | null }
    & InternalKinematicSpecVarsFragment
  )>, mass?: ChassisMassVarsFragment | null, measurements?: ChassisMeasurementVarsFragment | null, powertrain?: ChassisPowertrainVarsFragment | null, powerUnits?: Array<{ name: string, simulationModels?: any | null } | null> | null, rBrakeBias?: ChassisBrakeBiasVarsFragment | null, reboundSpringSpecs: Array<(
    { _id?: any | null }
    & ElasticSpecVarsFragment
  )>, regulationSets?: Array<ChassisRegulationSetVarsFragment | null> | null, setupChangesFilter?: { blackListFilter?: Array<string | null> | null, whiteListFilter?: Array<string | null> | null } | null, setupSheetStyles: Array<{ _id: any, name: string }>, sockets?: Array<{ name: string } | null> | null, specificationGroups: Array<{ _id: any, name: string }>, springSpecs: Array<(
    { _id?: any | null }
    & ElasticSpecVarsFragment
  )>, tags: Array<{ _id: any }>, torsionBarSpecs: Array<(
    { _id?: any | null }
    & ElasticSpecVarsFragment
  )>, trackingItems: Array<{ _id: any, name: string } | null>, trackingSources: Array<{ _id: any, description?: string | null, displayUnit?: EnumDisplayUnit | null, name: string, NDecimals?: number | null, sourceIDs?: Array<any | null> | null, sources: Array<{ _id: any, aliasString?: string | null, aliasType?: EnumTrackingSourceAliasAliasType | null, description?: string | null, displayUnit?: EnumDisplayUnit | null }> }> };

export type AllChassisSpecVarsIterationFragment = { _id?: any | null, name: string, version?: string | null, releaseDate?: any | null, released?: boolean | null, createdAt?: any | null, updatedAt?: any | null, decommissioned?: boolean | null, simulationAvailable?: boolean | null, prevIterationID?: any | null, nextIterationID?: any | null, allowableParentSpecIDs?: Array<any | null> | null };

export type AllChassisMeasurementSpecVarsFragment = { _id: any, description?: string | null, displayName?: string | null, name?: string | null, useInSimulation?: boolean | null };

export type TrackVarsFragment = { _id: any, altitude?: number | null, acronym?: string | null, cameras?: Array<string | null> | null, layoutIDs?: Array<any | null> | null, name: string, timeZone?: string | null, weatherStations?: Array<string | null> | null, geoLocation?: { coordinates: Array<number | null>, type: EnumGeoLocationType } | null, layouts: Array<{ _id: any, acronym?: string | null, name: string, lapLengthOfficial?: number | null }>, trackPicture?: { id: string, name?: string | null, mimeType: string, url: string, thumbnailUrl: string } | null };

export type TrackLayoutVarsFragment = { _id: any, trackID: any, name: string, NSectorsTiming?: number | null, lapLengthOfficial?: number | null, lapLengthCarData?: number | null, lapLengthRoulette?: number | null, lapLengthInLapCarData?: number | null, lapLengthInLapOfficial?: number | null, lapLengthInLapRoulette?: number | null, lapLengthOutLapCarData?: number | null, lapLengthOutLapOfficial?: number | null, lapLengthOutLapRoulette?: number | null, sectorDistance?: number | null, trackRecordQuali?: number | null, trackRecordRace?: number | null, direction?: string | null, polePosition?: EnumTrackLayoutPolePosition | null, lapZero?: boolean | null, overtakingThreshold?: number | null, bumpiness?: number | null, SCProbability?: number | null, FCYProbability?: number | null, trackEvolution?: number | null, lapsUntilFullRegen?: number | null, expectedRaceLaps?: number | null, ATKModePenalty?: number | null, ATKModeGain?: number | null, ATKModeLocation?: number | null, firstLapOffset?: number | null, outLapTime?: number | null, prepLapTime?: number | null, pushLapTime?: number | null, inLapTime?: number | null, SCLapTime?: number | null, FCYLapTime?: number | null, code60LapTime?: number | null, crossoverWetToSlick?: number | null, sensMass?: number | null, sensGrip?: number | null, sensDownforce?: number | null, sensDrag?: number | null, sensPower?: number | null, sensEnergy?: number | null, sensEP?: number | null, pitDistance?: number | null, pitLength?: number | null, pitLoss?: number | null, pitLossDriveThrough?: number | null, mapPitLane?: string | null, mapEmergencyExits?: string | null, mapElevation?: string | null, track?: { _id: any, name: string, timeZone?: string | null, trackPicture?: { id: string, name?: string | null, mimeType: string, url: string, thumbnailUrl: string } | null } | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null, energyRequired?: AllRunEnergyVarsFragment | null };

export type TyreVarsFragment = { _id: any, axle?: EnumTyreAxle | null, barcodeManufacturer?: string | null, barcodeRegulation?: string | null, barcodeRim?: string | null, barcodeTPMS?: string | null, batteryTPMS?: string | null, BTyreScrapped?: boolean | null, compound?: string | null, compoundComment?: string | null, constructionComment?: string | null, constructionSpec?: string | null, initialCondition?: EnumTyreInitialCondition | null, manufacturer?: string | null, mileage?: number | null, mTyre?: number | null, name?: string | null, pTyreMinRegulation?: number | null, pTyreMinTeam?: number | null, rimPartID?: any | null, sRunInitial?: number | null, type?: string | null, wearMeasurementIDs?: Array<any | null> | null, heatingSchedule?: Array<{ _id?: any | null, duration: number, temperature: number } | null> | null };

export type TyreDefaultFragmentFragment = { pTyreTarget?: number | null, pTyreMin?: number | null, pTyreStartRun?: number | null };

export type TyreSetVarsFragment = { _id: any, name?: string | null, comment?: string | null, number?: number | null, tyreFL?: { _id: any, name?: string | null, barcodeRim?: string | null, barcodeManufacturer?: string | null, mTyre?: number | null, pTyreMinRegulation?: number | null, sRunInitial?: number | null, BTyreScrapped?: boolean | null, manufacturer?: string | null, mileage?: number | null, initialCondition?: EnumTyreInitialCondition | null, compound?: string | null, axle?: EnumTyreAxle | null, heatingSchedule?: Array<{ _id?: any | null, temperature: number, duration: number } | null> | null } | null, tyreFR?: { _id: any, name?: string | null, barcodeRim?: string | null, barcodeManufacturer?: string | null, mTyre?: number | null, pTyreMinRegulation?: number | null, sRunInitial?: number | null, BTyreScrapped?: boolean | null, manufacturer?: string | null, mileage?: number | null, initialCondition?: EnumTyreInitialCondition | null, compound?: string | null, axle?: EnumTyreAxle | null, heatingSchedule?: Array<{ _id?: any | null, temperature: number, duration: number } | null> | null } | null, tyreRL?: { _id: any, name?: string | null, barcodeRim?: string | null, barcodeManufacturer?: string | null, mTyre?: number | null, pTyreMinRegulation?: number | null, sRunInitial?: number | null, BTyreScrapped?: boolean | null, manufacturer?: string | null, mileage?: number | null, initialCondition?: EnumTyreInitialCondition | null, compound?: string | null, axle?: EnumTyreAxle | null, heatingSchedule?: Array<{ _id?: any | null, temperature: number, duration: number } | null> | null } | null, tyreRR?: { _id: any, name?: string | null, barcodeRim?: string | null, barcodeManufacturer?: string | null, mTyre?: number | null, pTyreMinRegulation?: number | null, sRunInitial?: number | null, BTyreScrapped?: boolean | null, manufacturer?: string | null, mileage?: number | null, initialCondition?: EnumTyreInitialCondition | null, compound?: string | null, axle?: EnumTyreAxle | null, heatingSchedule?: Array<{ _id?: any | null, temperature: number, duration: number } | null> | null } | null };

export type WeatherDataVarsFragment = { time?: any | null, TAir?: number | null, TTrack?: number | null, pAmbient?: number | null, rHumidity?: number | null };

export type GetEditableContestantsForUserQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEditableContestantsForUserQuery = { person?: { editableContestantIDs?: Array<any | null> | null, visibleContestantIDs?: Array<any | null> | null } | null };

export type GetRunsForSessionByDriverQueryVariables = Exact<{
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetRunsForSessionByDriverQuery = { runSheets?: { items?: Array<(
      { _id: any }
      & RunsForSessionByDriverVarsFragment
    )> | null } | null };

export type RunsForSessionByDriverVarsFragment = { _id: any, contestantID: any, driverID?: any | null, endTime?: any | null, info?: string | null, NRun?: number | null, NRunTiming?: number | null, runDescription?: string | null, setupID?: any | null, startTime?: any | null, startTimeLTS?: any | null, startTimeManual?: any | null, teamID?: any | null, SoCRequired?: AllRunEnergyVarsFragment | null, driver?: { _id: any, acronym?: string | null, name: string } | null, fuelRequired?: AllRunEnergyVarsFragment | null, laps: Array<(
    { _id: any }
    & LapForSessionByDriverFragment
  )>, session?: { _id: any, tSessionEnd?: any | null, event?: { _id: any, track?: { _id: any, timeZone?: string | null } | null } | null } | null, setup?: { setupInfo?: string | null } | null, tyreFL?: RunTyreForSessionByDriverVarsFragment | null, tyreFR?: RunTyreForSessionByDriverVarsFragment | null, tyreRL?: RunTyreForSessionByDriverVarsFragment | null, tyreRR?: RunTyreForSessionByDriverVarsFragment | null, tyreSet?: { _id: any, name?: string | null, tyreFR?: { _id: any, name?: string | null } | null, tyreFL?: { _id: any, name?: string | null } | null, tyreRL?: { _id: any, name?: string | null } | null, tyreRR?: { _id: any, name?: string | null } | null } | null };

export type RunTyreForSessionByDriverVarsFragment = { pTyre?: number | null, pTyrePostRun?: number | null, pTyrePostRunBleed?: number | null, TTyre?: number | null, TTyrePostRun?: number | null, TTyrePostRunBleed?: number | null, tyreID?: any | null };

export type LapForSessionByDriverFragment = (
  { _id: any, lapType?: EnumLapType | null, TCell?: number | null, tDayPitIn?: any | null, tDayPitOut?: any | null, tLapManual?: number | null, tLapMax?: number | null, trackLayoutID?: any | null, tSectorsManual?: Array<number | null> | null, tSectorsOfficial?: Array<number | null> | null, tSectorsTiming?: Array<number | null> | null, tyreCompoundTiming?: string | null, vCarLapMax?: number | null, vCarSectors?: Array<number | null> | null, data?: Array<{ tDay?: any | null, source: EnumLapDataSource } | null> | null }
  & LapNumberVarsFragment
);

export type LapDataForSessionByDriversFragment = { _id?: any | null, BDRSUsed?: boolean | null, BLapCancelled?: boolean | null, BLapIsSlow?: boolean | null, driverCallout?: string | null, driverCallout2?: string | null, lapType?: EnumLapType | null, mFuelConsumptionThisLap?: number | null, mFuelLapEnd?: number | null, powerMode?: number | null, raceControlMessage?: string | null, rEnergyConsumptionThisLap?: number | null, rEnergyLapEnd?: number | null, rSOCConsumptionThisLap?: number | null, rSOCLapEnd?: number | null, source: EnumLapDataSource, TCell?: number | null, tDay?: any | null, tDayPitIn?: any | null, tDayPitOut?: any | null, tDaySectors?: Array<any | null> | null, tInPit?: number | null, tLapMax?: number | null, tSectors?: Array<number | null> | null, tSessionRemainingLapStart?: number | null, tyreCompound?: string | null, vCarLapMax?: number | null, vCarSectors?: Array<number | null> | null, trackStates?: Array<{ flag?: EnumTrackStateFlag | null, message?: string | null, timestamp?: any | null, _id?: any | null } | null> | null };

export type GetCarSetupForCustomSimulationQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCarSetupForCustomSimulationQuery = { carSetup?: (
    { _id: any }
    & CarSetupVarsForCustomSimulationFragment
  ) | null };

export type GetSimulationDriveFilesForCustomSimulationQueryVariables = Exact<{
  driveFileIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetSimulationDriveFilesForCustomSimulationQuery = { simulationDriveFiles?: { items?: Array<SimulationDriveFileVarsForCustomSimulationFragment> | null } | null };

export type SimulationDriveFileVarsForCustomSimulationFragment = { _id: any, data?: any | null, name?: string | null };

export type CarSetupVarsForCustomSimulationFragment = { _id: any, runSheetID?: any | null, chassisSpec?: { customSimulationModels?: Array<{ data?: any | null, dataMapping?: EnumSpecificationCustomSimulationModelsDataMapping | null, endPoint?: string | null, name: string, serverPort?: number | null, version?: string | null } | null> | null } | null, runSheet?: { startTime?: any | null, session?: { event?: { tEventStart?: any | null } | null } | null } | null };

export type GetRunSheetListForEventSelectionForKpiContextQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetListForEventSelectionForKpiContextQuery = { runSheets?: { items?: Array<(
      { _id: any, session?: { tSessionStart?: any | null } | null }
      & RunSheetForEventSelectionForKpiSetupSimContextVarsFragment
    )> | null } | null };

export type GetCalculationsForLapKpiQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCalculationsForLapKpiQuery = { calculations?: { items?: Array<LapCalculationFragment> | null } | null };

export type LapCalculationFragment = { _id: any, debugMode?: boolean | null, functionString: string, name?: string | null, parameter: string, trigger: Array<string>, version?: string | null };

export type GetRunSheetWithKpiForFlexLayoutByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetWithKpiForFlexLayoutByIdQuery = { runSheet?: (
    { _id: any, contestant?: { _id: any, startNumber: string } | null }
    & RunSheetVarsForFlexLayoutFragment
    & RunSheetSessionVarsFragment
  ) | null };

export type GetRunSheetWithSelectedKpiForFlexLayoutByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
  runKPI?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lapKPI?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetRunSheetWithSelectedKpiForFlexLayoutByIdQuery = { runSheet?: { runKPI?: any | null, laps: Array<{ tDay?: any | null, tLapMax?: number | null, vCarLapMax?: number | null, lapKPI?: any | null }>, contestant?: { _id: any, startNumber: string } | null, session?: { event?: { track?: { timeZone?: string | null } | null } | null } | null } | null };

export type RunSheetVarsForFlexLayoutFragment = (
  { _id: any, sessionID?: any | null, contestantID: any, chassisAssemblyID?: any | null, driverID?: any | null, teamID?: any | null, prevRunSheetID?: any | null, startTime?: any | null, endTime?: any | null, timingServiceShouldIgnore?: boolean | null, tyreSetID?: any | null, TCellMaxRunStart?: number | null, NRun?: number | null, NRunTiming?: number | null, fuelDrainedBeforeRun?: boolean | null, jobIDs?: Array<any | null> | null, selectedJobListTemplateID?: any | null, runKPI?: any | null, setupID?: any | null, brakePreRunMeasurementsFL?: any | null, brakePreRunMeasurementsFR?: any | null, brakePreRunMeasurementsRL?: any | null, brakePreRunMeasurementsRR?: any | null, brakePostRunMeasurementsFL?: any | null, brakePostRunMeasurementsFR?: any | null, brakePostRunMeasurementsRL?: any | null, brakePostRunMeasurementsRR?: any | null, skidPreRunMeasurements?: any | null, skidPostRunMeasurements?: any | null, brakeComment?: string | null, controlsComment?: string | null, skidComment?: string | null, mileage?: number | null, createdAt?: any | null, updatedAt?: any | null, fastestLap?: number | null, driver?: { _id: any, name: string } | null, contestant?: { _id: any, startNumber: string } | null, tyrePressureSettings?: { TTrackReference?: number | null } | null, tyreFL?: RunTyreVarsFragment | null, tyreFR?: RunTyreVarsFragment | null, tyreRL?: RunTyreVarsFragment | null, tyreRR?: RunTyreVarsFragment | null, consumptions?: Array<{ trackLayoutID: any, trackLayout?: { _id: any, name: string, track?: { _id: any, name: string } | null } | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null } | null> | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null, laps: Array<(
    { _id: any }
    & LapVarsForFlexLayoutFragment
  )>, weather?: { TAir?: number | null, TTrack?: number | null, pAmbient?: number | null, rHumidity?: number | null, DAir?: number | null, TAirOfficial?: number | null, TTrackOfficial?: number | null } | null, dashboard?: { mFuelRunEnd?: number | null, mFuelRunStart?: number | null } | null, laptimeThresholds?: { cool?: Array<number> | null, prep?: Array<number> | null, push?: Array<number> | null } | null, lastModifiedBy?: { _id: any, name: string } | null, session?: { event?: { track?: { name: string, timeZone?: string | null } | null } | null } | null }
  & RunCommentVarsFragment
  & EnergyUsedVarsFragment
);

export type LapVarsForFlexLayoutFragment = { tLapMax?: number | null, tLapManual?: number | null, NLapRun: number, raceControlMessage?: string | null, vCarLapMax?: number | null, tSectorsManual?: Array<number | null> | null, tSectorsOfficial?: Array<number | null> | null, tSectorsTiming?: Array<number | null> | null, lapComment?: string | null, lapCommentSystems?: string | null, TCell?: number | null, energyRemaining?: number | null, lapType?: EnumLapType | null, BPitIn: boolean, BPitOut: boolean, tDay?: any | null, lapKPI?: any | null, _id: any, tDayPitIn?: any | null, tDayPitOut?: any | null, rSOCConsumptionThisLap?: number | null, rEnergyConsumptionThisLap?: number | null, fuelConsumptionThisLap?: number | null, energyRemainingData?: number | null, mFuelLapStart?: number | null, mFuelLapEnd?: number | null, rSOCLapStart?: number | null, rSOCLapEnd?: number | null, rEnergyLapStart?: number | null, rEnergyLapEnd?: number | null, trackLayoutID?: any | null, trackLayout?: { _id: any, name: string, lapLengthOfficial?: number | null, lapLengthCarData?: number | null, lapLengthRoulette?: number | null, NSectorsTiming?: number | null } | null };

export type GetRunSheetForOverviewsWithSelectedKpiQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
  runKPI?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lapKPI?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetRunSheetForOverviewsWithSelectedKpiQuery = { runSheet?: SelectedKpiRunSheetDataFragment | null };

export type SelectedKpiRunSheetDataFragment = (
  { runKPI?: any | null, laps: Array<(
    { lapKPI?: any | null }
    & LapForRunSheetOverviewVarsFragment
  )> }
  & RunSheetForOverviewFragment
);

export type GetRunSheetSimRefValuesQueryVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
}>;


export type GetRunSheetSimRefValuesQuery = { simResults?: { items?: Array<{ _id: any, runSheetID?: any | null, refValues?: any | null, simType?: EnumSimResultSimType | null, updatedAt?: any | null }> | null } | null };

export type GetRunSheetListForEventSelectionForKpiSetupContextQueryVariables = Exact<{
  eventSessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetListForEventSelectionForKpiSetupContextQuery = { runSheets?: { items?: Array<(
      { _id: any, session?: { tSessionStart?: any | null, tSessionEnd?: any | null } | null }
      & RunSheetForEventSelectionForKpiSetupSimContextVarsFragment
      & AllRunSheetScalarVarsFragment
    )> | null } | null };

export type GetRunSheetListForEventSelectionForSimulationContextQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetListForEventSelectionForSimulationContextQuery = { runSheets?: { items?: Array<RunSheetForEventSelectionVarsFragment> | null } | null };

export type SimulationTerminalLogsSubscriptionVariables = Exact<{
  serviceSource?: InputMaybe<Scalars['String']['input']>;
}>;


export type SimulationTerminalLogsSubscription = { logAdded?: { _id: any, createdAt?: any | null, logLevel?: EnumLogLevel | null, message: string, serviceSource?: EnumLogServiceSource | null, updatedAt?: any | null, userID?: any | null } | null };

export type GetSimulationLogsQueryVariables = Exact<{
  serviceSource?: InputMaybe<EnumLogServiceSource>;
}>;


export type GetSimulationLogsQuery = { logs?: { items?: Array<{ _id: any, createdAt?: any | null, logLevel?: EnumLogLevel | null, message: string, serviceSource?: EnumLogServiceSource | null, updatedAt?: any | null, userID?: any | null }> | null } | null };

export type GetStraighLineSimResultsForStagedRunsheetByIdQueryVariables = Exact<{
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetStraighLineSimResultsForStagedRunsheetByIdQuery = { simResults?: { items?: Array<(
      { _id: any }
      & SimResultForStagedRunSimulationVarsFragment
    )> | null } | null };

export type GetLateralSimResultsForStagedRunsheetByIdQueryVariables = Exact<{
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetLateralSimResultsForStagedRunsheetByIdQuery = { simResults?: { items?: Array<(
      { _id: any }
      & SimResultForStagedRunSimulationVarsFragment
    )> | null } | null };

export type GetQuasiSimResultsForStagedRunsheetByIdQueryVariables = Exact<{
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetQuasiSimResultsForStagedRunsheetByIdQuery = { simResults?: { items?: Array<(
      { _id: any }
      & SimResultForStagedRunSimulationVarsFragment
    )> | null } | null };

export type SimResultForStagedRunSimulationVarsFragment = { carSetupID?: any | null, trackLayoutID?: any | null, specificationID?: any | null, runSheetID?: any | null, source?: string | null, simulationService?: EnumSimModelType | null, version?: string | null, sourceReferenceID?: string | null, simType?: EnumSimResultSimType | null, TAmbient?: number | null, pAmbient?: number | null, rHumidity?: number | null, carSetupModifiedAt?: any | null, refValues?: any | null, defaultChannelTime?: Array<number | null> | null, requesterID?: any | null, status?: EnumSimResultStatus | null, statusMessage?: string | null, _id: any, updatedAt?: any | null, createdAt?: any | null, isCarSetupChanged?: boolean | null, carSetup?: (
    { _id: any, title: string }
    & CarSetupVarsFragment
  ) | null, trackLayout?: (
    { _id: any }
    & TrackLayoutVarsFragment
  ) | null, requester?: { _id: any, name: string, username: string } | null };

export type AddAssemblyMutationVariables = Exact<{
  record: CreateOneAssemblyInput;
}>;


export type AddAssemblyMutation = { addAssembly?: { recordId?: any | null } | null };

export type RemoveAssemblyMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveAssemblyMutation = { removeAssembly?: { recordId?: any | null } | null };

export type UpdateAssemblyMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdAssemblyInput;
}>;


export type UpdateAssemblyMutation = { updateAssembly?: { recordId?: any | null } | null };

export type AddAssemblyTemplateMutationVariables = Exact<{
  record: CreateOneAssemblyTemplateInput;
}>;


export type AddAssemblyTemplateMutation = { addAssemblyTemplate?: { recordId?: any | null } | null };

export type AddChassisMeasurementMutationVariables = Exact<{
  record: CreateOneChassisMeasurementInput;
}>;


export type AddChassisMeasurementMutation = { addChassisMeasurement?: { recordId?: any | null } | null };

export type AddDepartmentMutationVariables = Exact<{
  record: CreateOneDepartmentInput;
}>;


export type AddDepartmentMutation = { addDepartment?: { recordId?: any | null } | null };

export type AddIssueMutationVariables = Exact<{
  record: CreateOneIssueInput;
}>;


export type AddIssueMutation = { addIssue?: { recordId?: any | null } | null };

export type AddLocationMutationVariables = Exact<{
  record: CreateOneLocationInput;
}>;


export type AddLocationMutation = { addLocation?: { recordId?: any | null } | null };

export type AddPackageMutationVariables = Exact<{
  record: CreateOnePackageInput;
}>;


export type AddPackageMutation = { addPackage?: { record?: { _id: any } | null } | null };

export type AddPartInstanceMutationVariables = Exact<{
  record: CreateOnePartInstanceInput;
}>;


export type AddPartInstanceMutation = { addPartInstance?: { record?: { _id: any } | null } | null };

export type AddSimulationMutationVariables = Exact<{
  record: CreateOneSimResultInput;
}>;


export type AddSimulationMutation = { addSimResult?: { recordId?: any | null } | null };

export type AddTrackingItemMutationVariables = Exact<{
  record: CreateOneTrackingItemInput;
}>;


export type AddTrackingItemMutation = { addTrackingItem?: { record?: { _id: any } | null } | null };

export type AddTrackingMeasurementMutationVariables = Exact<{
  record: CreateOneTrackingMeasurementInput;
}>;


export type AddTrackingMeasurementMutation = { addTrackingMeasurement?: { record?: { _id: any } | null } | null };

export type AddTrackingMeasurementRecordMutationVariables = Exact<{
  record: CreateOneTrackingMeasurementRecordInput;
}>;


export type AddTrackingMeasurementRecordMutation = { addTrackingMeasurementRecord?: { record?: { _id: any } | null } | null };

export type AddTrackingRecordMutationVariables = Exact<{
  record: CreateOneTrackingRecordInput;
}>;


export type AddTrackingRecordMutation = { addTrackingRecord?: { record?: { _id: any } | null } | null };

export type AddTrackingRecordValueMutationVariables = Exact<{
  record: CreateOneTrackingRecordValueInput;
}>;


export type AddTrackingRecordValueMutation = { addTrackingRecordValue?: { record?: { _id: any } | null } | null };

export type AddTrackingRecordGeneralMutationVariables = Exact<{
  record: CreateOneTrackingRecordGeneralInput;
}>;


export type AddTrackingRecordGeneralMutation = { addTrackingRecordGeneral?: { record?: { _id: any } | null } | null };

export type AddTrackingRecordOverrideMutationVariables = Exact<{
  record: CreateOneTrackingRecordOverrideInput;
}>;


export type AddTrackingRecordOverrideMutation = { addTrackingRecordOverride?: { record?: { _id: any } | null } | null };

export type AddTyreWearMutationVariables = Exact<{
  record: CreateOneTyreWearInput;
}>;


export type AddTyreWearMutation = { addTyreWear?: { record?: { _id: any } | null } | null };

export type AddWeatherMutationVariables = Exact<{
  record: CreateOneWeatherInput;
}>;


export type AddWeatherMutation = { addWeather?: { record?: { _id: any } | null } | null };

export type CopyAssemblyMutationVariables = Exact<{
  sourceID: Scalars['MongoID']['input'];
  newRootReference?: InputMaybe<Scalars['String']['input']>;
}>;


export type CopyAssemblyMutation = { copyAssembly?: { newAssemblyID?: any | null } | null };

export type SwapPartInstanceMutationVariables = Exact<{
  parentID: Scalars['MongoID']['input'];
  partID: Scalars['MongoID']['input'];
  specificationID: Scalars['MongoID']['input'];
  readingLocation?: InputMaybe<EnumReadingLocation>;
}>;


export type SwapPartInstanceMutation = { swapPartInstance?: { newPartInstanceID: any } | null };

export type ForwardUpdateCarSetupMutationVariables = Exact<{
  carSetupId: Scalars['MongoID']['input'];
  field: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ForwardUpdateCarSetupMutation = { forwardUpdateCarSetup?: { updatedCarSetupIDs?: Array<any | null> | null } | null };

export type ForwardUpsertPartInstanceMutationVariables = Exact<{
  chassisAssemblyId?: InputMaybe<Scalars['MongoID']['input']>;
  measurementIndex?: InputMaybe<Scalars['Int']['input']>;
  measurements?: InputMaybe<PartInstanceMeasurementInput>;
  newPartId?: InputMaybe<Scalars['MongoID']['input']>;
  readingLocation: EnumReadingLocation;
  specificationId: Scalars['MongoID']['input'];
  trackingItemReferenceDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ForwardUpsertPartInstanceMutation = { forwardUpsertPartInstance?: { updatedPartInstanceIDs?: Array<any | null> | null } | null };

export type RemoveAssemblyTemplateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveAssemblyTemplateMutation = { removeAssemblyTemplate?: { recordId?: any | null } | null };

export type RemoveIssueMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveIssueMutation = { removeIssue?: { recordId?: any | null } | null };

export type RemoveDepartmentMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveDepartmentMutation = { removeDepartment?: { recordId?: any | null } | null };

export type RemoveChassisMeasurementMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveChassisMeasurementMutation = { removeChassisMeasurement?: { recordId?: any | null } | null };

export type RemoveLapByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveLapByIdMutation = { removeLapByID?: { recordId?: any | null } | null };

export type RemoveLocationMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveLocationMutation = { removeLocation?: { recordId?: any | null } | null };

export type RemovePackageMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemovePackageMutation = { removePackage?: { recordId?: any | null } | null };

export type RemovePartInstanceMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemovePartInstanceMutation = { removePartInstance?: { recordId?: any | null } | null };

export type RemoveTrackingItemMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTrackingItemMutation = { removeTrackingItem?: { recordId?: any | null } | null };

export type RemoveTrackingMeasurementMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTrackingMeasurementMutation = { removeTrackingMeasurement?: { recordId?: any | null } | null };

export type RemoveTrackingMeasurementRecordMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTrackingMeasurementRecordMutation = { removeTrackingMeasurementRecord?: { recordId?: any | null } | null };

export type RemoveTrackingRecordMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTrackingRecordMutation = { removeTrackingRecord?: { recordId?: any | null } | null };

export type RemoveTyreWearMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTyreWearMutation = { removeTyreWear?: { recordId?: any | null } | null };

export type AppendWeatherMutationVariables = Exact<{
  weatherId: Scalars['MongoID']['input'];
  data: WeatherDataInput;
}>;


export type AppendWeatherMutation = { appendWeather?: { _id: any } | null };

export type ApplyPackageMutationVariables = Exact<{
  packageID: Scalars['MongoID']['input'];
  carSetupIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type ApplyPackageMutation = { applyPackage?: { success?: boolean | null } | null };

export type CreatePackageMutationVariables = Exact<{
  baselineSetupID: Scalars['MongoID']['input'];
  candidateSetupID: Scalars['MongoID']['input'];
  method?: InputMaybe<EnumPackageMethod>;
  name: Scalars['String']['input'];
}>;


export type CreatePackageMutation = { createPackage?: { _id: any } | null };

export type RecalculatePartMileageMutationVariables = Exact<{
  partID: Scalars['MongoID']['input'];
}>;


export type RecalculatePartMileageMutation = { recalculatePartMileageByIDResolver?: { mileage?: number | null, partID?: any | null } | null };

export type RecalculateRunSheetMileagesMutationVariables = Exact<{
  runSheetIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RecalculateRunSheetMileagesMutation = { calculateMileagesByRunSheetIDs: boolean };

export type UpdateAssemblyTemplateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdAssemblyTemplateInput;
}>;


export type UpdateAssemblyTemplateMutation = { updateAssemblyTemplate?: { recordId?: any | null } | null };

export type UpdateChassisMeasurementMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdChassisMeasurementInput;
}>;


export type UpdateChassisMeasurementMutation = { updateChassisMeasurement?: { recordId?: any | null } | null };

export type UpdateDepartmentMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdDepartmentInput;
}>;


export type UpdateDepartmentMutation = { updateDepartment?: { recordId?: any | null } | null };

export type UpdateIssueMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdIssueInput;
}>;


export type UpdateIssueMutation = { updateIssue?: { recordId?: any | null } | null };

export type UpdateLapDataByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record?: InputMaybe<UpdateByIdLapDataInput>;
  source: EnumLapDataSource;
}>;


export type UpdateLapDataByIdMutation = { updateLapDataByID?: { _id: any } | null };

export type UpdateLocationMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdLocationInput;
}>;


export type UpdateLocationMutation = { updateLocation?: { recordId?: any | null } | null };

export type UpdatePackageMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdPackageInput;
}>;


export type UpdatePackageMutation = { updatePackage?: { recordId?: any | null } | null };

export type UpdatePartInstanceMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdPartInstanceInput;
}>;


export type UpdatePartInstanceMutation = { updatePartInstance?: { recordId?: any | null } | null };

export type UpdateTrackingItemMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingItemInput;
}>;


export type UpdateTrackingItemMutation = { updateTrackingItem?: { recordId?: any | null } | null };

export type UpdateTrackingMeasurementMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingMeasurementInput;
}>;


export type UpdateTrackingMeasurementMutation = { updateTrackingMeasurement?: { recordId?: any | null } | null };

export type UpdateTrackingMeasurementRecordMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingMeasurementRecordInput;
}>;


export type UpdateTrackingMeasurementRecordMutation = { updateTrackingMeasurementRecord?: { recordId?: any | null } | null };

export type UpdateTrackingRecordMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingRecordInput;
}>;


export type UpdateTrackingRecordMutation = { updateTrackingRecord?: { recordId?: any | null } | null };

export type UpdateTyreWearMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTyreWearInput;
}>;


export type UpdateTyreWearMutation = { updateTyreWear?: { recordId?: any | null } | null };

export type UpdatePartMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdPartInput;
}>;


export type UpdatePartMutation = { updatePart?: { recordId?: any | null } | null };

export type UpsertPartInstanceMutationVariables = Exact<{
  readingLocation: EnumReadingLocation;
  parentId: Scalars['MongoID']['input'];
  measurementIndex: Scalars['Int']['input'];
  carSetupId?: InputMaybe<Scalars['MongoID']['input']>;
  specificationId: Scalars['MongoID']['input'];
  measurements?: InputMaybe<PartInstanceMeasurementInput>;
}>;


export type UpsertPartInstanceMutation = { upsertPartInstance?: { recordId?: any | null } | null };

export type UpdateWeatherMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdWeatherInput;
}>;


export type UpdateWeatherMutation = { updateWeather?: { record?: { _id: any } | null } | null };

export type AddCalculationMutationVariables = Exact<{
  record: CreateOneCalculationInput;
}>;


export type AddCalculationMutation = { addCalculation?: { recordId?: any | null } | null };

export type UpdateCalculationMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdCalculationInput;
}>;


export type UpdateCalculationMutation = { updateCalculation?: { recordId?: any | null } | null };

export type RemoveCalculationMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveCalculationMutation = { removeCalculation?: { recordId?: any | null, error?: { message?: string | null } | { message?: string | null } | { message?: string | null } | null } | null };

export type AddCarDataServiceConfigMutationVariables = Exact<{
  record: CreateOneCarDataServiceConfigInput;
}>;


export type AddCarDataServiceConfigMutation = { addCarDataServiceConfig?: { record?: { _id: any } | null } | null };

export type UpdateCarDataServiceConfigMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdCarDataServiceConfigInput;
}>;


export type UpdateCarDataServiceConfigMutation = { updateCarDataServiceConfig?: { recordId?: any | null } | null };

export type RemoveCarDataServiceConfigMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveCarDataServiceConfigMutation = { removeCarDataServiceConfig?: { recordId?: any | null } | null };

export type ActivateCarDataServiceConfigMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ActivateCarDataServiceConfigMutation = { activateCarDataServiceConfig?: { success: boolean } | null };

export type AddCarSetupMutationVariables = Exact<{
  record: CreateOneCarSetupInput;
}>;


export type AddCarSetupMutation = { addCarSetup?: { record?: { _id: any } | null } | null };

export type UpdateCarSetupMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdCarSetupInput;
}>;


export type UpdateCarSetupMutation = { updateCarSetup?: { recordId?: any | null } | null };

export type ClaimCarSetupMutationVariables = Exact<{
  carSetupID: Scalars['MongoID']['input'];
}>;


export type ClaimCarSetupMutation = { claimCarSetup?: { success: boolean } | null };

export type IncrementCarSetupMutationVariables = Exact<{
  srcID: Scalars['MongoID']['input'];
  destID: Scalars['MongoID']['input'];
}>;


export type IncrementCarSetupMutation = { incrementSetupSheet?: { newSetupID?: any | null } | null };

export type CopyCarSetupMutationVariables = Exact<{
  newAuthorID?: InputMaybe<Scalars['MongoID']['input']>;
  srcID: Scalars['MongoID']['input'];
  newTitle?: InputMaybe<Scalars['String']['input']>;
  targetRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type CopyCarSetupMutation = { copyCarSetup?: { newSetupID?: any | null } | null };

export type RemoveCarSetupMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveCarSetupMutation = { removeCarSetup?: { recordId?: any | null, error?: { message?: string | null } | { message?: string | null } | { message?: string | null } | null } | null };

export type UnclaimCarSetupMutationVariables = Exact<{
  carSetupId: Scalars['MongoID']['input'];
}>;


export type UnclaimCarSetupMutation = { unclaimCarSetup?: { success: boolean } | null };

export type AddChassisMutationVariables = Exact<{
  record: CreateOneChassisInput;
}>;


export type AddChassisMutation = { addChassis?: { recordId?: any | null } | null };

export type UpdateChassisMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdChassisInput;
}>;


export type UpdateChassisMutation = { updateChassis?: { recordId?: any | null } | null };

export type RemoveChassisMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveChassisMutation = { removeChassis?: { recordId?: any | null } | null };

export type AddContestantMutationVariables = Exact<{
  record: CreateOneContestantInput;
}>;


export type AddContestantMutation = { addContestant?: { recordId?: any | null } | null };

export type UpdateContestantMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdContestantInput;
}>;


export type UpdateContestantMutation = { updateContestant?: { recordId?: any | null } | null };

export type AddToContestantMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  target: ContestantField;
  toAdd: Scalars['MongoID']['input'];
}>;


export type AddToContestantMutation = { addToContestant?: { _id: any } | null };

export type RemoveContestantMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveContestantMutation = { removeContestant?: { recordId?: any | null } | null };

export type AddEventMutationVariables = Exact<{
  record: CreateOneEventInput;
}>;


export type AddEventMutation = { addEvent?: { recordId?: any | null, record?: { _id: any, name: string, NEventSeason?: number | null, tEventStart?: any | null, tEventEnd?: any | null, sessionIDs?: Array<any | null> | null } | null } | null };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdEventInput;
}>;


export type UpdateEventMutation = { updateEvent?: { recordId?: any | null } | null };

export type RemoveEventMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveEventMutation = { removeEvent?: { recordId?: any | null } | null };

export type CopyEventMutationVariables = Exact<{
  sourceEventID: Scalars['MongoID']['input'];
  targetSeasonID: Scalars['MongoID']['input'];
  name: Scalars['String']['input'];
  tEventStart: Scalars['Date']['input'];
  calculateSessionTimes?: InputMaybe<Scalars['Boolean']['input']>;
  overrides?: InputMaybe<CopyEventOverridesInput>;
}>;


export type CopyEventMutation = { copyEvent?: { _id: any } | null };

export type AddToEventContestantMutationVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
  contestantID: Scalars['MongoID']['input'];
  target: EventContestantField;
  toAdd: Scalars['MongoID']['input'];
}>;


export type AddToEventContestantMutation = { addToEventContestant?: { _id: any } | null };

export type RemoveFromEventContestantMutationVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
  contestantID: Scalars['MongoID']['input'];
  target: EventContestantField;
  toRemove: Scalars['MongoID']['input'];
}>;


export type RemoveFromEventContestantMutation = { removeFromEventContestant?: { _id: any } | null };

export type RemoveSingleTyreMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveSingleTyreMutation = { removeTyre?: { recordId?: any | null, error?: { message?: string | null } | { message?: string | null } | { message?: string | null } | null } | null };

export type AddFullEventMutationVariables = Exact<{
  eventRecord: CreateOneEventInput;
  sessions: Array<CreateSessionForFullEventInput> | CreateSessionForFullEventInput;
}>;


export type AddFullEventMutation = { addFullEvent?: { _id: any, name: string, sessionIDs?: Array<any | null> | null } | null };

export type AddJobMutationVariables = Exact<{
  record: CreateOneJobInput;
  target?: InputMaybe<EnumJobTarget>;
}>;


export type AddJobMutation = { addJob?: { record?: { _id: any } | null } | null };

export type UpdateJobMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdJobInput;
  target: EnumJobTarget;
}>;


export type UpdateJobMutation = { updateJob?: { recordId?: any | null } | null };

export type ManageJobMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  action: JobAction;
  target: EnumJobTarget;
}>;


export type ManageJobMutation = { manageJob: { _id: any } };

export type RemoveJobMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  target: EnumJobTarget;
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type RemoveJobMutation = { removeJob?: { recordId?: any | null } | null };

export type RemoveManyJobsMutationVariables = Exact<{
  jobIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type RemoveManyJobsMutation = { removeManyJobs?: { deletedCount: number } | null };

export type AddJobCommentMutationVariables = Exact<{
  target: EnumJobTarget;
  subjectID: Scalars['MongoID']['input'];
  text: Scalars['String']['input'];
}>;


export type AddJobCommentMutation = { addComment?: { comment?: { _id?: any | null } | null } | null };

export type UpdateJobCommentMutationVariables = Exact<{
  target: EnumJobTarget;
  subjectID: Scalars['MongoID']['input'];
  commentID: Scalars['MongoID']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateJobCommentMutation = { updateComment?: { comment?: { _id?: any | null, text?: string | null } | null } | null };

export type UpdateTemplateJobListMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTemplateJobListInput;
}>;


export type UpdateTemplateJobListMutation = { updateTemplateJobList?: { recordId?: any | null } | null };

export type AddTemplateJobListMutationVariables = Exact<{
  record: CreateOneTemplateJobListInput;
}>;


export type AddTemplateJobListMutation = { addTemplateJobList?: { record?: { _id: any } | null } | null };

export type RemoveTemplateJobListMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTemplateJobListMutation = { removeTemplateJobList?: { recordId?: any | null } | null };

export type AddManufacturerMutationVariables = Exact<{
  record: CreateOneManufacturerInput;
}>;


export type AddManufacturerMutation = { addManufacturer?: { record?: { _id: any } | null } | null };

export type UpdateManufacturerMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdManufacturerInput;
}>;


export type UpdateManufacturerMutation = { updateManufacturer?: { recordId?: any | null } | null };

export type RemoveManufacturerMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveManufacturerMutation = { removeManufacturer?: { recordId?: any | null } | null };

export type CalculateAllMileagesMutationVariables = Exact<{ [key: string]: never; }>;


export type CalculateAllMileagesMutation = { calculateAllMileages: boolean };

export type StartOneTimingWeatherServiceMutationVariables = Exact<{
  configID: Scalars['MongoID']['input'];
}>;


export type StartOneTimingWeatherServiceMutation = { oneTimingWeatherServiceStart?: { success: boolean } | null };

export type StopOneTimingWeatherServiceMutationVariables = Exact<{ [key: string]: never; }>;


export type StopOneTimingWeatherServiceMutation = { oneTimingWeatherServiceStop?: { success: boolean } | null };

export type AddPartMutationVariables = Exact<{
  record: CreateOnePartInput;
}>;


export type AddPartMutation = { addPart?: { recordId?: any | null, record?: { _id: any, reference: string } | null } | null };

export type RemovePartMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemovePartMutation = { removePart?: { recordId?: any | null } | null };

export type AddPersonMutationVariables = Exact<{
  record: CreateOnePersonInput;
}>;


export type AddPersonMutation = { addPerson?: { recordId?: any | null } | null };

export type UpdatePersonMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdPersonInput;
}>;


export type UpdatePersonMutation = { updatePerson?: { recordId?: any | null } | null };

export type UpdateMeMutationVariables = Exact<{
  record: UpdateMeInput;
}>;


export type UpdateMeMutation = { updateMe?: { recordId?: any | null } | null };

export type RemovePersonMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemovePersonMutation = { removePerson?: { recordId?: any | null, error?: { message?: string | null } | { message?: string | null } | { message?: string | null } | null } | null };

export type AddFlexLayoutConfigMutationVariables = Exact<{
  record: CreateOneFlexLayoutConfigInput;
}>;


export type AddFlexLayoutConfigMutation = { addFlexLayoutConfig?: { recordId?: any | null } | null };

export type UpdateFlexLayoutConfigMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdFlexLayoutConfigInput;
}>;


export type UpdateFlexLayoutConfigMutation = { updateFlexLayoutConfig?: { recordId?: any | null } | null };

export type RemoveFlexLayoutConfigMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveFlexLayoutConfigMutation = { removeFlexLayoutConfig?: { recordId?: any | null } | null };

export type AddProjectMutationVariables = Exact<{
  record: CreateOneProjectInput;
}>;


export type AddProjectMutation = { addProject?: { recordId?: any | null } | null };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdProjectInput;
}>;


export type UpdateProjectMutation = { updateProject?: { recordId?: any | null } | null };

export type RemoveProjectMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveProjectMutation = { removeProject?: { recordId?: any | null } | null };

export type AddRaceSeriesMutationVariables = Exact<{
  record: CreateOneRaceSeriesInput;
}>;


export type AddRaceSeriesMutation = { addRaceSeries?: { recordId?: any | null } | null };

export type UpdateRaceSeriesMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdRaceSeriesInput;
}>;


export type UpdateRaceSeriesMutation = { updateRaceSeries?: { recordId?: any | null } | null };

export type RemoveRaceSeriesMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveRaceSeriesMutation = { removeRaceSeries?: { recordId?: any | null } | null };

export type AddRunSheetMutationVariables = Exact<{
  record: CreateOneRunSheetInput;
}>;


export type AddRunSheetMutation = { addRunSheet?: { recordId?: any | null } | null };

export type UpdateRunsheetMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdRunSheetInput;
}>;


export type UpdateRunsheetMutation = { updateRunSheet?: { recordId?: any | null } | null };

export type ClaimRunsheetMutationVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
}>;


export type ClaimRunsheetMutation = { claimRunSheet?: { success: boolean } | null };

export type IncrementRunSheetMutationVariables = Exact<{
  prevRunSheetID: Scalars['MongoID']['input'];
  record?: InputMaybe<UpdateByIdRunSheetInput>;
}>;


export type IncrementRunSheetMutation = { incrementRunSheet?: { runSheet: { _id: any } } | null };

export type AddLapMutationVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
  lap: LapInput;
}>;


export type AddLapMutation = { addLap?: { _id: any } | null };

export type ForceAddLapMutationVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
  lap: LapInput;
}>;


export type ForceAddLapMutation = { forceAddLap?: { _id: any } | null };

export type UpdateLapMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  NLapRun: Scalars['Int']['input'];
  lap: UpdateByIdLapInput;
}>;


export type UpdateLapMutation = { updateLap?: { _id: any } | null };

export type UpdateLapByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdLapInput;
}>;


export type UpdateLapByIdMutation = { updateLapByID?: { record?: { _id: any } | null } | null };

export type RemoveLapMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  NLapRun: Scalars['Int']['input'];
}>;


export type RemoveLapMutation = { removeLap?: { _id: any } | null };

export type RemoveRunSheetMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveRunSheetMutation = { removeRunSheet?: { recordId?: any | null } | null };

export type UnclaimRunSheetMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type UnclaimRunSheetMutation = { unclaimRunSheet?: { success: boolean } | null };

export type AddRunSheetStyleMutationVariables = Exact<{
  record: CreateOneRunSheetStyleInput;
}>;


export type AddRunSheetStyleMutation = { addRunSheetStyle?: { recordId?: any | null } | null };

export type UpdateRunSheetStyleMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdRunSheetStyleInput;
}>;


export type UpdateRunSheetStyleMutation = { updateRunSheetStyle?: { recordId?: any | null } | null };

export type RemoveRunSheetStyleMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveRunSheetStyleMutation = { removeRunSheetStyle?: { recordId?: any | null } | null };

export type AddSeasonMutationVariables = Exact<{
  record: CreateOneSeasonInput;
}>;


export type AddSeasonMutation = { addSeason?: { recordId?: any | null, record?: { _id: any, name: string, eventIDs?: Array<any | null> | null } | null } | null };

export type UpdateSeasonMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdSeasonInput;
}>;


export type UpdateSeasonMutation = { updateSeason?: { recordId?: any | null } | null };

export type RemoveSeasonMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveSeasonMutation = { removeSeason?: { recordId?: any | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { resetPassword?: { password: string } | null };

export type SetPasswordMutationVariables = Exact<{
  username: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type SetPasswordMutation = { setPassword?: { success: boolean } | null };

export type LoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { login?: { token: string } | null };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  clientRoot: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { forgotPassword?: { result: string } | null };

export type SelfResetPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type SelfResetPasswordMutation = { selfResetPassword?: { success: boolean } | null };

export type AddSessionMutationVariables = Exact<{
  record: CreateOneSessionInput;
}>;


export type AddSessionMutation = { addSession?: { recordId?: any | null, record?: { _id: any, name: string, shortName?: string | null, tSessionStart?: any | null, tSessionEnd?: any | null } | null } | null };

export type UpdateSessionMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdSessionInput;
}>;


export type UpdateSessionMutation = { updateSession?: { recordId?: any | null } | null };

export type RemoveSessionMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveSessionMutation = { removeSession?: { recordId?: any | null } | null };

export type FullBopFragment = { _id: any, sessionID: any, name?: string | null, bopFile?: { id: string, name?: string | null, mimeType: string, url: string, thumbnailUrl: string } | null, carBop?: Array<{ highlightColour?: string | null, aCamberFmax?: number | null, aCamberFmin?: number | null, aCamberRmax?: number | null, aCamberRmin?: number | null, aRakeMax?: number | null, aRakeMin?: number | null, aWingRmax?: number | null, aWingRmin?: number | null, zWingMin?: number | null, carSpec?: string | null, homologation?: string | null, hRideFmin?: number | null, hRideRmin?: number | null, make?: string | null, mCarBallastMin?: number | null, mCarWeightEmptyMin?: number | null, mCarWeightTotalMin?: number | null, mFuelMassCapacityMax?: number | null, modelYear?: string | null, mRefuelMassMax?: number | null, nEngineMax?: number | null, pEngineBoost?: any | null, PEngineMax?: number | null, rLambdaMin?: number | null, vCarMax?: number | null, VFuelVolumeCapacityMax?: number | null, vPowerCurveBelowRefVelocity?: number | null, rPowerCurveReference?: number | null, rPowerGainAboveRefVelocity?: number | null, vPowerGainReference?: number | null, VRefuelVolumeMax?: number | null, xAirRestrictorMax?: number | null, xFuelRestrictorMax?: number | null, xRefuelRestrictorMax?: number | null, EStintMax?: number | null } | null> | null, sessionBop?: { EStintEnergyMax?: number | null, EStintEnergyRefillRateMax?: number | null, fuelType?: string | null, mRefuelRateMax?: number | null, pAmbientSessionOfficial?: number | null, tyreModel?: string | null, VRefuelRateMax?: number | null, xStintlengthMax?: number | null } | null };

export type GetBopQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetBopQuery = { bop?: FullBopFragment | null };

export type AddBopMutationVariables = Exact<{
  record: CreateOneBopInput;
}>;


export type AddBopMutation = { addBop?: { recordId?: any | null, record?: FullBopFragment | null } | null };

export type UpdateBopMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdBopInput;
}>;


export type UpdateBopMutation = { updateBop?: { recordId?: any | null, record?: FullBopFragment | null } | null };

export type RemoveBopMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveBopMutation = { removeBop?: { recordId?: any | null, record?: FullBopFragment | null } | null };

export type UpsertBopMutationVariables = Exact<{
  record: CreateOneBopInput;
  bopID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type UpsertBopMutation = { upsertBop?: FullBopFragment | null };

export type GetBopForSessionQueryVariables = Exact<{
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetBopForSessionQuery = { bops?: { items?: Array<FullBopFragment> | null } | null };

export type AddSetupOverviewConfigMutationVariables = Exact<{
  record: CreateOneSetupOverviewConfigInput;
}>;


export type AddSetupOverviewConfigMutation = { addSetupOverviewConfig?: { recordId?: any | null } | null };

export type UpdateSetupOverviewConfigMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdSetupOverviewConfigInput;
}>;


export type UpdateSetupOverviewConfigMutation = { updateSetupOverviewConfig?: { recordId?: any | null } | null };

export type RemoveSetupOverviewConfigMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveSetupOverviewConfigMutation = { removeSetupOverviewConfig?: { recordId?: any | null } | null };

export type AddSetupSheetStyleMutationVariables = Exact<{
  record: CreateOneSetupSheetStyleInput;
}>;


export type AddSetupSheetStyleMutation = { addSetupSheetStyle?: { recordId?: any | null } | null };

export type UpdateSetupSheetStyleMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdSetupSheetStyleInput;
}>;


export type UpdateSetupSheetStyleMutation = { updateSetupSheetStyle?: { recordId?: any | null } | null };

export type RemoveSetupSheetStyleMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveSetupSheetStyleMutation = { removeSetupSheetStyle?: { recordId?: any | null } | null };

export type UpdateSimResultMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdSimResultInput;
}>;


export type UpdateSimResultMutation = { updateSimResult?: { recordId?: any | null } | null };

export type AddSpecificationMutationVariables = Exact<{
  record: CreateOneSpecificationInput;
}>;


export type AddSpecificationMutation = { addSpecification?: { recordId?: any | null } | null };

export type RemoveSpecificationMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveSpecificationMutation = { removeSpecification?: { recordId?: any | null } | null };

export type UpdateSpecificationMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdSpecificationInput;
  currentChassisSpecID: Scalars['MongoID']['input'];
  confirmUpdate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateSpecificationMutation = { updateSpecification?: { recordId?: any | null } | null };

export type ReleaseChassisSpecificationMutationVariables = Exact<{
  chassisSpecID: Scalars['MongoID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReleaseChassisSpecificationMutation = { releaseChassisSpec?: { releasedChassisSpec?: { _id?: any | null } | null, iteratedChassisSpec?: { _id?: any | null } | null } | null };

export type RenameSpecificationMutationVariables = Exact<{
  specificationId: Scalars['MongoID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameSpecificationMutation = { renameSpecification?: { success: boolean } | null };

export type AddTeamMutationVariables = Exact<{
  record: CreateOneTeamInput;
}>;


export type AddTeamMutation = { addTeam?: { recordId?: any | null } | null };

export type UpdateTeamMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTeamInput;
}>;


export type UpdateTeamMutation = { updateTeam?: { recordId?: any | null } | null };

export type RemoveTeamMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTeamMutation = { removeTeam?: { recordId?: any | null, error?: { message?: string | null } | { message?: string | null } | { message?: string | null } | null } | null };

export type AssignTeamMutationVariables = Exact<{
  type: AssignableToTeam;
  objectID: Scalars['MongoID']['input'];
  teamID: Scalars['MongoID']['input'];
}>;


export type AssignTeamMutation = { assignTeam?: { success: boolean } | null };

export type AddTimeSheetEntryMutationVariables = Exact<{
  record: CreateOneTimeSheetEntryInput;
}>;


export type AddTimeSheetEntryMutation = { addTimeSheetEntry?: { recordId?: any | null } | null };

export type UpdateTimeSheetEntryMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTimeSheetEntryInput;
}>;


export type UpdateTimeSheetEntryMutation = { updateTimeSheetEntry?: { recordId?: any | null } | null };

export type RemoveTimeSheetEntryMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTimeSheetEntryMutation = { removeTimeSheetEntry?: { recordId?: any | null } | null };

export type ApproveTimeSheetEntryMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ApproveTimeSheetEntryMutation = { approveTimeSheetEntry?: { _id: any } | null };

export type ApproveTimeSheetEntriesMutationVariables = Exact<{
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  tStartAfter: Scalars['Date']['input'];
  tStartBefore: Scalars['Date']['input'];
}>;


export type ApproveTimeSheetEntriesMutation = { approveTimeSheetEntries?: boolean | null };

export type UnapproveTimeSheetEntryMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type UnapproveTimeSheetEntryMutation = { unapproveTimeSheetEntry?: { _id: any } | null };

export type UnApproveTimeSheetEntriesMutationVariables = Exact<{
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  tStartAfter: Scalars['Date']['input'];
  tStartBefore: Scalars['Date']['input'];
}>;


export type UnApproveTimeSheetEntriesMutation = { unapproveTimeSheetEntries?: boolean | null };

export type AddTimingServiceConfigMutationVariables = Exact<{
  record: CreateOneTimingServiceConfigInput;
}>;


export type AddTimingServiceConfigMutation = { addTimingServiceConfig?: { record?: { _id: any, name: string } | null } | null };

export type UpdateTimingServiceConfigMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTimingServiceConfigInput;
}>;


export type UpdateTimingServiceConfigMutation = { updateTimingServiceConfig?: { recordId?: any | null } | null };

export type AddTrackMutationVariables = Exact<{
  record: CreateOneTrackInput;
}>;


export type AddTrackMutation = { addTrack?: { recordId?: any | null } | null };

export type UpdateTrackMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackInput;
}>;


export type UpdateTrackMutation = { updateTrack?: { recordId?: any | null } | null };

export type RemoveTrackMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTrackMutation = { removeTrack?: { recordId?: any | null } | null };

export type AddTrackLayoutMutationVariables = Exact<{
  record: CreateOneTrackLayoutInput;
}>;


export type AddTrackLayoutMutation = { addTrackLayout?: { recordId?: any | null } | null };

export type UpdateTrackLayoutMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackLayoutInput;
}>;


export type UpdateTrackLayoutMutation = { updateTrackLayout?: { recordId?: any | null } | null };

export type RemoveTrackLayoutMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTrackLayoutMutation = { removeTrackLayout?: { recordId?: any | null } | null };

export type AddTyreSetMutationVariables = Exact<{
  record: CreateOneTyreSetInput;
}>;


export type AddTyreSetMutation = { addTyreSet?: { recordId?: any | null } | null };

export type UpdateTyreSetMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTyreSetInput;
}>;


export type UpdateTyreSetMutation = { updateTyreSet?: { recordId?: any | null } | null };

export type RemoveTyreSetMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTyreSetMutation = { removeTyreSet?: { recordId?: any | null } | null };

export type AddTyreSetsToContestantMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type AddTyreSetsToContestantMutation = { addTyreSetsToContestant?: { success?: boolean | null } | null };

export type RemoveTyreSetsFromContestantMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RemoveTyreSetsFromContestantMutation = { removeTyreSetsFromContestant?: { success?: boolean | null } | null };

export type AddTyreSetsToEventContestantMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type AddTyreSetsToEventContestantMutation = { addTyreSetsToEventContestant?: { success?: boolean | null, changed?: boolean | null } | null };

export type RemoveTyreSetsFromEventContestantMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RemoveTyreSetsFromEventContestantMutation = { removeTyreSetsFromEventContestant?: { success?: boolean | null, changed?: boolean | null } | null };

export type AddTyreMutationVariables = Exact<{
  record: CreateOneTyreInput;
}>;


export type AddTyreMutation = { addTyre?: { recordId?: any | null } | null };

export type CreateTyresForContestantMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  tyres?: InputMaybe<Array<CreateTyreRecordInput> | CreateTyreRecordInput>;
  sets?: InputMaybe<Array<CreateTyreSetRecordInput> | CreateTyreSetRecordInput>;
}>;


export type CreateTyresForContestantMutation = { createTyresForContestant?: { success?: boolean | null, tyreIDs?: Array<any | null> | null, tyreSetIDs?: Array<any | null> | null } | null };

export type UpdateTyreMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTyreInput;
}>;


export type UpdateTyreMutation = { updateTyre?: { recordId?: any | null } | null };

export type RemoveTyreMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RemoveTyreMutation = { removeTyre?: { recordId?: any | null } | null };

export type RemoveManyTyresMutationVariables = Exact<{
  tyreIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RemoveManyTyresMutation = { removeManyTyres?: { deletedCount: number } | null };

export type RemoveManyTyreSetsMutationVariables = Exact<{
  tyreSetIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RemoveManyTyreSetsMutation = { removeManyTyreSets?: { deletedCount: number } | null };

export type ScrapManyTyresMutationVariables = Exact<{
  tyreIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type ScrapManyTyresMutation = { scrapManyTyres?: { updatedCount: number } | null };

export type AddTyresToEventContestantMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  tyreIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type AddTyresToEventContestantMutation = { addTyresToEventContestant?: { success?: boolean | null, changed?: boolean | null } | null };

export type RemoveTyresFromEventContestantMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  tyreIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RemoveTyresFromEventContestantMutation = { removeTyresFromEventContestant?: { success?: boolean | null, changed?: boolean | null } | null };

export type AddTyresToContestantMutationVariables = Exact<{
  contestantID: Scalars['MongoID']['input'];
  tyreIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type AddTyresToContestantMutation = { addTyresToContestant?: { success?: boolean | null } | null };

export type GetPersonInfoForProfilePageQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPersonInfoForProfilePageQuery = { person?: { _id: any, acronym?: string | null, carUpdateMethod?: EnumPersonCarUpdateMethod | null, defaultTyreSetNameFormat?: string | null, defaultTyreReferenceTemperature?: number | null, defaultRunSheetStyleID?: any | null, defaultRunSheetCompareStyleID?: any | null, email?: string | null, hideKPIs?: boolean | null, isActive?: boolean | null, isTimeTracker?: boolean | null, isTimeTrackerAdmin?: boolean | null, mileageUnit?: EnumLengthUnit | null, name: string, role?: EnumPersonRole | null, teamID?: any | null, timeTrackerApprovalByPersonID?: any | null, username: string, visibleEventIDs?: Array<any | null> | null, behaviour?: { carryOverJobList?: boolean | null, showMyJobsOnRunSheetDefault?: boolean | null, timeLocale?: string | null, timezoneSelect?: EnumBehaviourConfigTimezoneSelect | null } | null, canopyCredentials?: { clientID?: string | null, clientSecret?: string | null, username?: string | null, password?: string | null, userID?: string | null, tenantID?: string | null } | null, emailNotificationConfig?: { jobAssigned?: boolean | null, jobCommentedOn?: boolean | null, jobStatusChanged?: boolean | null } | null, localConnections?: Array<{ host?: string | null, endPoint?: string | null, port?: number | null, outputFolder?: string | null, useSSL?: boolean | null } | null> | null, userSetups: Array<{ _id: any, title: string }>, viewConfig?: { showRunSheetsAsTabs?: boolean | null, yellowTyreMileageThreshold?: number | null, redTyreMileageThreshold?: number | null, highlightTyreMileages?: boolean | null } | null } | null };

export type GetAllAssembliesBasicFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAssembliesBasicFieldsQuery = { assemblies?: { items?: Array<{ __typename: 'ChassisAssembly', _id?: any | null, name: string, reference?: string | null, chassisSpecID?: any | null, tags: Array<{ _id: any }>, partInstances: Array<{ _id: any, readingLocation?: EnumReadingLocation | null, specificationID?: any | null, partID?: any | null }> } | { __typename: 'SubAssembly', _id?: any | null, name: string, reference?: string | null, chassisSpecID?: any | null, tags: Array<{ _id: any }>, partInstances: Array<{ _id: any, readingLocation?: EnumReadingLocation | null, specificationID?: any | null, partID?: any | null }> }> | null } | null };

export type GetChassisAssemblyByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisAssemblyByIdQuery = { assembly?: { _id?: any | null, name: string, decommissioned?: boolean | null, current?: boolean | null, locationID?: any | null, chassisSpecID?: any | null, tagIDs?: Array<any | null> | null, chassisPartID?: any | null, subAssemblies: Array<{ _id?: any | null }>, partInstances: Array<{ _id: any, specificationID?: any | null, partID?: any | null }>, tags: Array<{ _id: any }>, location?: { _id: any } | null } | {} | null };

export type GetAllSubAssembliesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSubAssembliesQuery = { assemblies?: { items?: Array<{ _id?: any | null, chassisSpecID?: any | null, partInstances: Array<{ _id: any }>, subAssemblies: Array<{ _id?: any | null }> } | {}> | null } | null };

export type GetSubAssemblyByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSubAssemblyByIdQuery = { assembly?: ChassisAssemblyVarsFragment | SubAssemblyVarsFragment | null };

export type SubAssemblyVarsFragment = { __typename: 'SubAssembly', _id?: any | null, buildSheetGroupEnumID?: any | null, name: string, decommissioned?: boolean | null, current?: boolean | null, reference?: string | null, nestedPartInstanceIDs?: Array<any | null> | null, partInstanceIDs?: Array<any | null> | null, locationID?: any | null, chassisSpecID?: any | null, subAssemblyIDs?: Array<any | null> | null, userEnumAssemblyTypeID?: any | null, tagIDs?: Array<any | null> | null, nestedPartInstances: Array<{ _id: any, readingLocation?: EnumReadingLocation | null, partID?: any | null, specificationID?: any | null, part?: { _id: any, reference: string, userEnumPartTypeID?: any | null } | null, specification?: { __typename: 'AeroElementSpec', _id?: any | null, name: string } | { __typename: 'AeroPackageSpec', _id?: any | null, name: string } | { __typename: 'AntiRollBarSpec', _id?: any | null, name: string } | { __typename: 'ChassisSpec', _id?: any | null, name: string } | { __typename: 'CustomSpec', _id?: any | null, name: string } | { __typename: 'DamperSpec', _id?: any | null, name: string } | { __typename: 'DifferentialSpec', _id?: any | null, name: string } | { __typename: 'ElasticSpec', _id?: any | null, name: string } | { __typename: 'GearBoxSpec', _id?: any | null, name: string } | { __typename: 'GearSpec', _id?: any | null, name: string } | { __typename: 'KinematicsExternalSpec', _id?: any | null, name: string } | { __typename: 'KinematicsInternalSpec', _id?: any | null, name: string } | null }>, partInstances: Array<{ _id: any, readingLocation?: EnumReadingLocation | null, partID?: any | null, specificationID?: any | null, part?: { _id: any, reference: string, userEnumPartTypeID?: any | null } | null, specification?: { __typename: 'AeroElementSpec', _id?: any | null, name: string } | { __typename: 'AeroPackageSpec', _id?: any | null, name: string } | { __typename: 'AntiRollBarSpec', _id?: any | null, name: string } | { __typename: 'ChassisSpec', _id?: any | null, name: string } | { __typename: 'CustomSpec', _id?: any | null, name: string } | { __typename: 'DamperSpec', _id?: any | null, name: string } | { __typename: 'DifferentialSpec', _id?: any | null, name: string } | { __typename: 'ElasticSpec', _id?: any | null, name: string } | { __typename: 'GearBoxSpec', _id?: any | null, name: string } | { __typename: 'GearSpec', _id?: any | null, name: string } | { __typename: 'KinematicsExternalSpec', _id?: any | null, name: string } | { __typename: 'KinematicsInternalSpec', _id?: any | null, name: string } | null }>, tags: Array<{ _id: any }> };

export type ChassisAssemblyVarsFragment = { __typename: 'ChassisAssembly', _id?: any | null, buildSheetGroupEnumID?: any | null, chassisSpecID?: any | null, current?: boolean | null, decommissioned?: boolean | null, locationID?: any | null, name: string, nestedPartInstanceIDs?: Array<any | null> | null, reference?: string | null, subAssemblyIDs?: Array<any | null> | null, userEnumAssemblyTypeID?: any | null, tagIDs?: Array<any | null> | null, nestedPartInstances: Array<{ _id: any, readingLocation?: EnumReadingLocation | null, partID?: any | null, specificationID?: any | null, part?: { _id: any, reference: string, userEnumPartTypeID?: any | null } | null, specification?: { __typename: 'AeroElementSpec', _id?: any | null, name: string } | { __typename: 'AeroPackageSpec', _id?: any | null, name: string } | { __typename: 'AntiRollBarSpec', _id?: any | null, name: string } | { __typename: 'ChassisSpec', _id?: any | null, name: string } | { __typename: 'CustomSpec', _id?: any | null, name: string } | { __typename: 'DamperSpec', _id?: any | null, name: string } | { __typename: 'DifferentialSpec', _id?: any | null, name: string } | { __typename: 'ElasticSpec', _id?: any | null, name: string } | { __typename: 'GearBoxSpec', _id?: any | null, name: string } | { __typename: 'GearSpec', _id?: any | null, name: string } | { __typename: 'KinematicsExternalSpec', _id?: any | null, name: string } | { __typename: 'KinematicsInternalSpec', _id?: any | null, name: string } | null }>, partInstances: Array<{ _id: any, readingLocation?: EnumReadingLocation | null, partID?: any | null, specificationID?: any | null, part?: { reference: string, userEnumPartTypeID?: any | null } | null, specification?: { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | null }>, tags: Array<{ _id: any }> };

export type BestValuesSessionQueryVariables = Exact<{
  sessionID: Scalars['MongoID']['input'];
}>;


export type BestValuesSessionQuery = { bestValuesAll?: { items?: Array<(
      { _id: any }
      & BestValuesVarsFragment
    )> | null } | null };

export type BestValuesDriverQueryVariables = Exact<{
  sessionID: Scalars['MongoID']['input'];
  contestantID: Scalars['MongoID']['input'];
}>;


export type BestValuesDriverQuery = { bestValuesAll?: { items?: Array<(
      { _id: any }
      & BestValuesVarsFragment
    )> | null } | null };

export type GetCalculationQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCalculationQuery = { calculation?: (
    { _id: any }
    & CalculationVarsFragment
  ) | null };

export type GetAllCalculationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCalculationsQuery = { calculations?: { items?: Array<(
      { _id: any }
      & CalculationVarsFragment
    )> | null } | null };

export type GetAllCalculationsByIdsQueryVariables = Exact<{
  calculationIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetAllCalculationsByIdsQuery = { calculations?: { items?: Array<(
      { _id: any }
      & CalculationVarsFragment
    )> | null } | null };

export type GetCarDataServiceConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCarDataServiceConfigsQuery = { carDataServiceConfigs?: { items?: Array<GetCarDataServiceConfigItemFragment> | null } | null };

export type GetCarDataServiceConfigItemFragment = { _id: any, name: string, version: string, active: boolean, raceSeries?: { _id: any, name: string } | null };

export type GetCarDataServiceConfigQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCarDataServiceConfigQuery = { carDataServiceConfig?: { _id: any, name: string, version: string, active: boolean, ORHCalculationIDs?: Array<any | null> | null, ParameterMap?: any | null, raceSeries?: { _id: any, name: string } | null, Kpi?: { KpiParameters?: Array<string | null> | null, Preconditions?: Array<string | null> | null } | null, PostProcessingConfig?: { ApplicationSettingsConfiguration?: { ProcessedFolder?: string | null, ResultsFolder?: string | null, FunctionsFolder?: string | null, RunsheetMatching?: EnumCarDataServiceApplicationSettingsConfigRunsheetMatching | null, DriverContestantLookup?: any | null, PitstopTriggers?: Array<{ ParameterId: string, Value: number, Type?: EnumCarDataServicePitstopTriggerType | null } | null> | null } | null, ProcessingEnginesConfiguration?: { ImportersFolder?: string | null, ParameterMapFile?: string | null, InternalCalculationsFolder?: string | null, UserCalculationsFolder?: string | null, ExportersFolder?: string | null, ProcessingEngineConfiguration?: Array<{ Name: string, QueueName: string, Instances: number, Importer: EnumCarDataServiceProcessingEngineConfigImporter, Calculations: Array<string | null>, Exporters?: { ATLAS10_EXPORTER?: any | null, JSONFILE_EXPORTER?: any | null, ONERACEHUB_EXPORTER?: any | null, WINTAX_EXPORTER?: { DISTANCE_CHANNEL?: string | null, FUEL_CONSUMPTION?: string | null, FUEL_LEVEL?: string | null, LAP_DISTANCE?: string | null, OUTPUT_PATH?: string | null, TELDATAZTX_PATH?: string | null } | null } | null } | null> | null } | null, EventConfiguration?: { EventId: any, EventDescription?: string | null } | null, QueueManagerConfiguration?: { Queues?: Array<{ Name: string, SessionType: string } | null> | null } | null, SessionManagerConfiguration?: { OffloadFolder: string, OffloadSessionTypes?: Array<string | null> | null } | null, SessionTypesConfiguration?: { SessionTypes?: Array<{ name: string, exts: Array<string | null>, regExpressions: Array<string | null>, folderUpLevel: number, ignoreLiterals?: Array<string | null> | null } | null> | null } | null } | null } | null };

export type GetBasicCarSetupListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasicCarSetupListQuery = { carSetups?: { items?: Array<{ _id: any, title: string, runSheet?: { _id: any, NRun?: number | null, session?: { _id: any, name: string, event?: { _id: any, name: string } | null } | null } | null, info?: { NIssue?: number | null } | null, engineer?: { _id: any, name: string } | null }> | null } | null };

export type GetCarSetupQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCarSetupQuery = { carSetup?: (
    { _id: any }
    & CarSetupVarsFragment
  ) | null };

export type GetCarSetupForSessionExportQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCarSetupForSessionExportQuery = { carSetup?: (
    { _id: any }
    & CarSetupExportVarsFragment
  ) | null };

export type GetCarSetupTitleQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCarSetupTitleQuery = { carSetup?: { _id: any, title: string } | null };

export type DoCarSetupSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['RegExpAsString']['input']>;
}>;


export type DoCarSetupSearchQuery = { carSetups?: { items?: Array<{ _id: any, title: string, eventID?: any | null, contestantID?: any | null, teamID?: any | null }> | null } | null };

export type GetCarSetupByEventIdQueryVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
}>;


export type GetCarSetupByEventIdQuery = { carSetupsMany: Array<{ _id: any, title: string, eventID?: any | null, contestantID?: any | null, teamID?: any | null }> };

export type GetCarSetupByEventAndContestantIDsQueryVariables = Exact<{
  eventID: Scalars['MongoID']['input'];
  contestantID: Scalars['MongoID']['input'];
}>;


export type GetCarSetupByEventAndContestantIDsQuery = { carSetupsMany: Array<{ _id: any, title: string, eventID?: any | null, contestantID?: any | null, teamID?: any | null }> };

export type DoCarSetupSearchManyQueryVariables = Exact<{
  search?: InputMaybe<Scalars['RegExpAsString']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type DoCarSetupSearchManyQuery = { carSetupsMany: Array<{ _id: any, title: string, eventID?: any | null, contestantID?: any | null, teamID?: any | null }> };

export type GetBlankingQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetBlankingQuery = { carSetup?: { _id: any, powertrain?: { hEngineBlanking?: any | null, engineBlankingDetails?: any | null } | null } | null };

export type GetCarSetupsBySessionsIDsQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  contestantIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetCarSetupsBySessionsIDsQuery = { runSheets?: { items?: Array<{ _id: any, NRunTiming?: number | null, nextRunSheetID?: any | null, contestant?: { _id: any, startNumber: string } | null, session?: { _id: any, shortName?: string | null } | null, setup?: { _id: any, title: string, driverID?: any | null, engineerID?: any | null, chassisID?: any | null, time?: any | null, setupSheetStyle?: EnumCarSetupSetupSheetStyle | null, systemsConfigValues?: any | null, mBallasts?: any | null, driver?: { _id: any, acronym?: string | null } | null, engineer?: { _id: any, name: string } | null, frontLeft?: CornerVarsFragment | null, frontRight?: CornerVarsFragment | null, rearLeft?: CornerVarsFragment | null, rearRight?: CornerVarsFragment | null, front?: EndVarsFragment | null, rear?: EndVarsFragment | null, massTeam?: MassVarsFragment | null, massSetup?: MassVarsFragment | null, massRegulation?: MassVarsFragment | null, massOutOfGarage?: MassVarsFragment | null, aero?: AeroVarsFragment | null, brakeSystem?: BrakeSystemVarsFragment | null, powertrain?: PowertrainVarsFragment | null, info?: InfoVarsFragment | null, chassis?: { _id: any, systemsConfigFields?: Array<string | null> | null, ballastPositions?: Array<string | null> | null } | null } | null }> | null } | null };

export type GetChassisAllQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChassisAllQuery = { chassisAll?: { items?: Array<{ _id: any, specificationID?: any | null, setupSheetStyle?: EnumChassisSetupSheetStyle | null, systemsConfigFields?: Array<string | null> | null, ballastPositions?: Array<string | null> | null, specification?: { _id?: any | null, name: string } | null }> | null } | null };

export type GetBasicChassisListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasicChassisListQuery = { chassisAll?: { items?: Array<{ _id: any, reference?: string | null, type?: string | null }> | null } | null };

export type GetChassisInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisInfoQuery = { chassis?: { _id: any, reference?: string | null, type?: string | null, setupSheetStyle?: EnumChassisSetupSheetStyle | null } | null };

export type GetBasicContestantsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasicContestantsListQuery = { contestants?: { items?: Array<{ _id: any, startNumber: string, teamID?: any | null, class?: string | null, team?: { _id: any, name: string } | null, season?: { _id: any, name: string } | null }> | null } | null };

export type GetContestantsWithIDsQueryVariables = Exact<{
  contestantID?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetContestantsWithIDsQuery = { contestants?: { items?: Array<{ _id: any, class?: string | null, startNumber: string, driverIDs?: Array<any | null> | null, hidden?: boolean | null, drivers: Array<{ _id: any, acronym?: string | null }> }> | null } | null };

export type GetContestantInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetContestantInfoQuery = { contestant?: (
    { _id: any }
    & ContestantVarsFragment
  ) | null };

export type GetContestantDriversQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetContestantDriversQuery = { contestant?: { _id: any, drivers: Array<{ _id: any, acronym?: string | null, displayColor?: string | null, name: string }> } | null };

export type GetContestantTyresQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetContestantTyresQuery = { contestant?: { _id: any, tyres: Array<(
      { _id: any }
      & TyreVarsFragment
    )> } | null };

export type GetContestantListQueryVariables = Exact<{
  ids: Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetContestantListQuery = { contestants?: { items?: Array<(
      { _id: any }
      & BasicContestantVarsFragment
    )> | null } | null };

export type GetContestantTyreSetsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetContestantTyreSetsQuery = { contestant?: { _id: any, tyreSets: Array<(
      { _id: any }
      & TyreSetVarsFragment
    )> } | null };

export type GetContestantColorsQueryVariables = Exact<{
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetContestantColorsQuery = { contestants?: { items?: Array<{ _id: any, startNumber: string, color?: string | null, season?: { _id: any, name: string } | null }> | null } | null };

export type GetEventQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEventQuery = { event?: (
    { _id: any, customSimulationPayload?: any | null, name: string, trackLayoutIDs?: Array<any | null> | null, seasonID: any, DFuel?: number | null, participantIDs?: Array<any | null> | null, NEventSeason?: number | null, tEventStart?: any | null, tEventEnd?: any | null, tLapAverage?: number | null, eventType?: string | null, season?: { _id: any, name: string, raceSeries?: { _id: any, name: string } | null } | null, contestants?: Array<{ _id: any, driverIDs?: Array<any | null> | null, tyreIDs?: Array<any | null> | null } | null> | null, track?: { _id: any, timeZone?: string | null } | null, trackLayouts: Array<{ _id: any, name: string, lapLengthOfficial?: number | null, lapLengthCarData?: number | null, NSectorsTiming?: number | null, trackID: any, energyRequired?: AllRunEnergyVarsFragment | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null, track?: { _id: any, name: string, timeZone?: string | null } | null }>, sessions: Array<{ _id: any, name: string }>, tyreDefaultsFL?: TyreDefaultFragmentFragment | null, tyreDefaultsFR?: TyreDefaultFragmentFragment | null, tyreDefaultsRL?: TyreDefaultFragmentFragment | null, tyreDefaultsRR?: TyreDefaultFragmentFragment | null, tyreDefaultsWetFL?: TyreDefaultFragmentFragment | null, tyreDefaultsWetFR?: TyreDefaultFragmentFragment | null, tyreDefaultsWetRL?: TyreDefaultFragmentFragment | null, tyreDefaultsWetRR?: TyreDefaultFragmentFragment | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null, referenceLaptimes?: Array<{ ATTACK?: number | null, COOL?: number | null, FCY?: number | null, IN?: number | null, OUT?: number | null, OUTIN?: number | null, PITLANE?: number | null, PREP?: number | null, PUSH?: number | null, QUALI?: number | null, SAFETYCAR?: number | null, SHAKEDOWN?: number | null, SLOW?: number | null, TARGET?: number | null, TOGRID?: number | null, TOPADDOCK?: number | null, TOPITS?: number | null, UNFINISHED?: number | null, trackLayoutID: any } | null> | null }
    & EventTrackLayoutConsumptionVarsFragment
  ) | null };

export type GetEventNameQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEventNameQuery = { event?: { _id: any, name: string } | null };

export type GetBasicEventListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasicEventListQuery = { events?: { items?: Array<{ _id: any, name: string, sessionIDs?: Array<any | null> | null, tEventStart?: any | null }> | null } | null };

export type GetSessionsFromEventQueryVariables = Exact<{
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetSessionsFromEventQuery = { sessions?: { items?: Array<{ _id: any, name: string, shortName?: string | null, sessionType?: EnumSessionType | null, tSessionStart?: any | null, tSessionEnd?: any | null }> | null } | null };

export type GetBasicEventListWithMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasicEventListWithMetadataQuery = { events?: { items?: Array<(
      { _id: any }
      & EventBaseVarsFragment
    )> | null } | null };

export type GetFullBasicEventListWithMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFullBasicEventListWithMetadataQuery = { events?: { items?: Array<(
      { _id: any }
      & EventBaseVarsFragment
    )> | null } | null };

export type GetEventsFromSeasonQueryVariables = Exact<{
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetEventsFromSeasonQuery = { events?: { items?: Array<{ _id: any, name: string, tEventEnd?: any | null }> | null } | null };

export type DoEventSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['RegExpAsString']['input']>;
}>;


export type DoEventSearchQuery = { events?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetEventInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEventInfoQuery = { event?: { _id: any, name: string, sessionIDs?: Array<any | null> | null, trackLayoutIDs?: Array<any | null> | null, trackID?: any | null, consumptions?: Array<{ trackLayoutID: any, energyRequired?: AllRunEnergyVarsFragment | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null, trackLayout?: (
        { _id: any }
        & TrackLayoutVarsFragment
      ) | null } | null> | null, sessions: Array<{ _id: any, name: string, shortName?: string | null, tSessionStart?: any | null, tSessionEnd?: any | null }>, track?: { _id: any, timeZone?: string | null } | null, trackLayouts: Array<{ _id: any, trackID: any, name: string, track?: { _id: any, name: string } | null }>, season?: { _id: any, name: string, raceSeries?: { _id: any, name: string } | null } | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null } | null };

export type GetEventDataForReportLayoutEditorQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEventDataForReportLayoutEditorQuery = { event?: { _id: any, name: string, sessionIDs?: Array<any | null> | null, season?: { _id: any, contestants: Array<{ _id: any, color?: string | null }> } | null } | null };

export type GetContestantTyreSetsAtEventQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetContestantTyreSetsAtEventQuery = { event?: { _id: any, contestants?: Array<{ _id: any, tyreSetIDs?: Array<any | null> | null, tyreSets: Array<TyreSetVarsFragment> } | null> | null } | null };

export type GetContestantTyresAtEventsQueryVariables = Exact<{
  filter: FilterFindManyEventInput;
}>;


export type GetContestantTyresAtEventsQuery = { events?: { items?: Array<{ _id: any, name: string, sessionIDs?: Array<any | null> | null, contestants?: Array<{ _id: any, tyreIDs?: Array<any | null> | null, tyreSetIDs?: Array<any | null> | null } | null> | null }> | null } | null };

export type GetContestantTyresAtEventQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetContestantTyresAtEventQuery = { event?: { _id: any, contestants?: Array<{ _id: any, tyreIDs?: Array<any | null> | null } | null> | null, tyreDefaultsFL?: TyreDefaultFragmentFragment | null, tyreDefaultsFR?: TyreDefaultFragmentFragment | null, tyreDefaultsRL?: TyreDefaultFragmentFragment | null, tyreDefaultsRR?: TyreDefaultFragmentFragment | null, tyreDefaultsWetFL?: TyreDefaultFragmentFragment | null, tyreDefaultsWetFR?: TyreDefaultFragmentFragment | null, tyreDefaultsWetRL?: TyreDefaultFragmentFragment | null, tyreDefaultsWetRR?: TyreDefaultFragmentFragment | null } | null };

export type GetEventContestantsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEventContestantsQuery = { event?: { _id: any, contestants?: Array<{ _id: any, class?: string | null, drivers: Array<{ name: string, _id: any }> } | null> | null, season?: { _id: any, contestantIDs?: Array<any | null> | null, contestants: Array<{ _id: any, startNumber: string }> } | null } | null };

export type GetSessionIDsforEventsQueryVariables = Exact<{
  eventIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetSessionIDsforEventsQuery = { sessions?: { items?: Array<{ _id: any, name: string, shortName?: string | null, event?: { name: string } | null }> | null } | null };

export type GetEventTrackLayoutWarningsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetEventTrackLayoutWarningsQuery = { event?: { _id: any, trackLayoutIDs?: Array<any | null> | null, trackLayouts: Array<{ mapTrackLatLonCsv?: string | null, mapTrackXyCsv?: string | null, mapTrackXy?: { warnings: Array<string> } | null, mapTrackLatLon?: { warnings: Array<string> } | null }> } | null };

export type GetJobQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetJobQuery = { job?: (
    { _id: any }
    & JobVarsFragment
  ) | null };

export type GetMyJobsQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type GetMyJobsQuery = { jobs?: { items?: Array<(
      { _id: any }
      & JobVarsFragment
    )> | null } | null };

export type GetAllJobsByIDsQueryVariables = Exact<{
  jobIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GetAllJobsByIDsQuery = { jobs?: { items?: Array<(
      { _id: any }
      & JobVarsFragment
    )> | null } | null };

export type GetJobsForRunSheetQueryVariables = Exact<{
  runSheetID: Scalars['MongoID']['input'];
}>;


export type GetJobsForRunSheetQuery = { jobs?: { items?: Array<(
      { _id: any }
      & JobVarsFragment
    )> | null } | null };

export type GetTemplateJobListsInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplateJobListsInfoQuery = { templateJobLists?: { items?: Array<{ _id: any, title: string }> | null } | null };

export type GetTemplateJobListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplateJobListsQuery = { templateJobLists?: { items?: Array<(
      { _id: any }
      & JobListTemplateVarsFragment
    )> | null } | null };

export type GetTemplateJobListByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTemplateJobListByIdQuery = { templateJobList?: (
    { _id: any }
    & JobListTemplateVarsFragment
  ) | null };

export type GetAvailableSetupSheetStylesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableSetupSheetStylesQuery = { license: { options: { setupSheetStyles: Array<EnumChassisSetupSheetStyle> } } };

export type LicenseExpiryQueryVariables = Exact<{ [key: string]: never; }>;


export type LicenseExpiryQuery = { license: { expired: boolean, expirationDate?: string | null } };

export type GetManufacturerByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetManufacturerByIdQuery = { manufacturer?: { _id: any, name?: string | null } | null };

export type GetAllManufacturersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllManufacturersQuery = { manufacturers?: { items?: Array<{ _id: any, name?: string | null }> | null } | null };

export type GetOneTimingWeatherServiceLogsQueryVariables = Exact<{
  numLines?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOneTimingWeatherServiceLogsQuery = { oneTimingWeatherServiceLogs?: string | null };

export type GetOneTimingWeatherServiceStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOneTimingWeatherServiceStatusQuery = { oneTimingWeatherServiceStatus: OneTimingWeatherServiceStatus };

export type DoOneTimingWeatherServiceConfigSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['RegExpAsString']['input']>;
}>;


export type DoOneTimingWeatherServiceConfigSearchQuery = { oneTimingWeatherServiceConfigs?: { items?: Array<{ _id: any, name: string, timingURL: string, timingPort: number, updateInterval?: number | null, longitude?: number | null, latitude?: number | null, writeData?: boolean | null, logLevel?: EnumOneTimingWeatherServiceConfigLogLevel | null, eventIDs?: Array<any | null> | null }> | null } | null };

export type GetAllPartsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPartsQuery = { parts?: { items?: Array<{ __typename: 'Part', manufacturerPartID?: string | null, rootSpecificationID?: any | null, specificationID?: any | null, reference: string, properties?: any | null, _id: any, concurrentUseAllowed?: boolean | null, currentlyInUse?: boolean | null, notes?: string | null, tagIDs?: Array<any | null> | null, trackingHistoryIDs?: Array<any | null> | null, specification?: { _id: any, chassisSpecID?: any | null } | null, trackingHistory: Array<{ _id: any }> }> | null } | null };

export type GetPartByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPartByIdQuery = { part?: { _id: any, concurrentUseAllowed?: boolean | null, currentlyInUse?: boolean | null, description?: string | null, manufacturerPartID?: string | null, notes?: string | null, partNumber?: string | null, properties?: any | null, reference: string, rootSpecificationID?: any | null, specificationID?: any | null, tagIDs?: Array<any | null> | null, trackingHistoryIDs?: Array<any | null> | null, specification?: { trackingItemIDs?: Array<any | null> | null } | null, tags?: AllTagVarsFragment | null, trackingHistory: Array<AllTrackingHistoryVarsFragment> } | null };

export type GetPersonNameQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPersonNameQuery = { person?: { _id: any, name: string } | null };

export type GetPersonViewConfigQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPersonViewConfigQuery = { person?: { _id: any, username: string, viewConfig?: { showRunSheetsAsTabs?: boolean | null, yellowTyreMileageThreshold?: number | null, redTyreMileageThreshold?: number | null, highlightTyreMileages?: boolean | null } | null } | null };

export type GetPersonBehaviourConfigQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPersonBehaviourConfigQuery = { person?: { _id: any, username: string, behaviour?: { carryOverJobList?: boolean | null } | null } | null };

export type GetPersonUserSimulationSettingsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPersonUserSimulationSettingsQuery = { person?: { _id: any, username: string, userSimulationSettings?: { TAmbientPreferred?: number | null, pAmbientPreferred?: number | null, rHumidityPreferred?: number | null, runSimSlotColours?: Array<string | null> | null, setupSimSlotColours?: Array<string | null> | null, userDefinedSetupIDs?: Array<any | null> | null } | null } | null };

export type GetPersonInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPersonInfoQuery = { person?: { _id: any, acronym?: string | null, defaultRunSheetCompareStyleID?: any | null, defaultRunSheetStyleID?: any | null, defaultTyreReferenceTemperature?: number | null, defaultTyreSetNameFormat?: string | null, displayColor?: string | null, editableContestantIDs?: Array<any | null> | null, email?: string | null, hideKPIs?: boolean | null, isActive?: boolean | null, isTimeTracker?: boolean | null, isTimeTrackerAdmin?: boolean | null, lapSequenceTemplateIDs?: Array<any | null> | null, name: string, role?: EnumPersonRole | null, teamID?: any | null, timeTrackerApprovalByPersonID?: any | null, username: string, visibleContestantIDs?: Array<any | null> | null, visibleEventIDs?: Array<any | null> | null, behaviour?: { carryOverJobList?: boolean | null, showMyJobsOnRunSheetDefault?: boolean | null } | null, canopyCredentials?: { clientID?: string | null, clientSecret?: string | null, username?: string | null, password?: string | null, userID?: string | null, tenantID?: string | null } | null, emailNotificationConfig?: { jobAssigned?: boolean | null, jobCommentedOn?: boolean | null, jobStatusChanged?: boolean | null } | null, userSetups: Array<{ _id: any, title: string }>, viewConfig?: { showRunSheetsAsTabs?: boolean | null, yellowTyreMileageThreshold?: number | null, redTyreMileageThreshold?: number | null, highlightTyreMileages?: boolean | null } | null } | null };

export type GetDriverNameQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetDriverNameQuery = { person?: { _id: any, acronym?: string | null, name: string } | null };

export type GetDriversWithIDsQueryVariables = Exact<{
  driverID?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetDriversWithIDsQuery = { people?: { items?: Array<{ _id: any, acronym?: string | null, name: string }> | null } | null };

export type GetEngineersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEngineersQuery = { people?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetTimeTrackerAdminsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimeTrackerAdminsQuery = { people?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetPersonsWithTimeTrackingApprovedByQueryVariables = Exact<{
  approverID: Scalars['MongoID']['input'];
}>;


export type GetPersonsWithTimeTrackingApprovedByQuery = { people?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetTimeSheetEntriesOfTimeApproveesForTimePeriodQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
  tStartAfter: Scalars['Date']['input'];
  tStartBefore: Scalars['Date']['input'];
}>;


export type GetTimeSheetEntriesOfTimeApproveesForTimePeriodQuery = { person?: { _id: any, timeApprovees: Array<{ _id: any, name: string, timeSheetEntries?: Array<TimeSheetEntryOfTimeApproveesForTimePeriodFragment | null> | null }> } | null };

export type TimeSheetEntryOfTimeApproveesForTimePeriodFragment = { _id: any, projectID?: any | null, personID: any, absent?: boolean | null, tStart: any, tEnd?: any | null, approvedAt?: any | null, approvedBy?: { _id: any, name: string } | null, project?: { _id: any, name: string } | null };

export type GetTimeSheetEntriesForTimePeriodForAllTimeApproveesQueryVariables = Exact<{
  tStartAfter: Scalars['Date']['input'];
  tStartBefore: Scalars['Date']['input'];
}>;


export type GetTimeSheetEntriesForTimePeriodForAllTimeApproveesQuery = { people?: { items?: Array<PersonWithTimeApproveesFragment> | null } | null };

export type PersonWithTimeApproveesFragment = { _id: any, timeApprovees: Array<{ _id: any, name: string, timeSheetEntries?: Array<{ _id: any, projectID?: any | null, personID: any, absent?: boolean | null, tStart: any, tEnd?: any | null, approvedAt?: any | null, approvedBy?: { _id: any, name: string } | null, project?: { _id: any, name: string } | null } | null> | null }> };

export type GetBasicPersonListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasicPersonListQuery = { people?: { items?: Array<{ _id: any, acronym?: string | null, email?: string | null, isActive?: boolean | null, name: string, role?: EnumPersonRole | null, username: string }> | null } | null };

export type GetCanopyInfoByPersonIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCanopyInfoByPersonIdQuery = { person?: { canopyCredentials?: { clientID?: string | null } | null } | null };

export type GetPersonDefaultRunSheetInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPersonDefaultRunSheetInfoQuery = { person?: { defaultRunSheetStyle?: { lapFlags?: { ATTACK?: string | null, COOL?: string | null, FCY?: string | null, IN?: string | null, OUT?: string | null, OUTIN?: string | null, PITLANE?: string | null, PREP?: string | null, PUSH?: string | null, QUALI?: string | null, SAFETYCAR?: string | null, SHAKEDOWN?: string | null, SLOW?: string | null, TARGET?: string | null, TOGRID?: string | null, TOPADDOCK?: string | null, TOPITS?: string | null, UNFINISHED?: string | null } | null } | null } | null };

export type GetPlotPageConfigByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPlotPageConfigByIdQuery = { plotPageConfig?: { _id: any, title?: string | null, authorID?: any | null, isPublic?: boolean | null, gridRows: number, gridCols: number, plots: Array<GridPlotPageConfigPlotVarsFragment | null> } | null };

export type PlotPageConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlotPageConfigsQuery = { plotPageConfigs?: { items?: Array<{ title?: string | null, _id: any }> | null } | null };

export type GetFlexLayoutConfigForIntentionQueryVariables = Exact<{
  intendedFor?: InputMaybe<EnumFlexLayoutConfigIntendedFor>;
}>;


export type GetFlexLayoutConfigForIntentionQuery = { flexLayoutConfigs?: { items?: Array<{ _id: any, authorID?: any | null, intendedFor: EnumFlexLayoutConfigIntendedFor, isPublic?: boolean | null, model?: any | null, name: string, targetUserIDs?: Array<any | null> | null, targetRoles?: Array<EnumPersonRole> | null, version?: string | null }> | null } | null };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetProjectQuery = { project?: ProjectFragment | null };

export type GetProjectsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsListQuery = { projects?: { items?: Array<ProjectFragment> | null } | null };

export type ProjectFragment = { _id: any, name: string, description?: string | null };

export type GetRaceSeriesInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRaceSeriesInfoQuery = { raceSeries?: { _id: any, name: string, shortName?: string | null, sortingIndex?: number | null, groupName?: string | null, seasonIDs?: Array<any | null> | null, seasons: Array<{ _id: any, name: string, eventIDs?: Array<any | null> | null }> } | null };

export type GetBasicRaceSeriesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasicRaceSeriesListQuery = { raceSeriesAll?: { items?: Array<{ _id: any, name: string, seasonIDs?: Array<any | null> | null, sortingIndex?: number | null }> | null } | null };

export type GetRaceSeriesListWithSeasonsAndEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRaceSeriesListWithSeasonsAndEventsQuery = { raceSeriesAll?: { items?: Array<{ _id: any, name: string, shortName?: string | null, seasons: Array<{ _id: any, name: string, eventIDs?: Array<any | null> | null, events: Array<{ _id: any, name: string, tEventStart?: any | null }> }> }> | null } | null };

export type GetRaceSeriesListWithSeasonsEventsAndSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRaceSeriesListWithSeasonsEventsAndSessionsQuery = { raceSeriesAll?: { items?: Array<{ _id: any, name: string, shortName?: string | null, seasons: Array<{ _id: any, name: string, eventIDs?: Array<any | null> | null, events: Array<{ _id: any, name: string, tEventStart?: any | null, sessions: Array<{ _id: any, name: string, tSessionStart?: any | null }> }> }> }> | null } | null };

export type DoRaceSeriesSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['RegExpAsString']['input']>;
}>;


export type DoRaceSeriesSearchQuery = { raceSeriesAll?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetSortedRunSheetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSortedRunSheetsQuery = { runSheets?: { items?: Array<{ _id: any, startTime?: any | null, setupID?: any | null, NRun?: number | null, NRunTiming?: number | null, session?: { _id: any, name: string, shortName?: string | null, event?: { _id: any, name: string, season?: { _id: any, name: string, raceSeries?: { _id: any, name: string } | null } | null } | null } | null, driver?: { _id: any, acronym?: string | null, name: string } | null, contestant?: { _id: any, startNumber: string } | null }> | null } | null };

export type GetRunSheetByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetByIdQuery = { runSheet?: (
    { _id: any }
    & RunSheetVarsFragment
    & RunSheetSessionVarsFragment
  ) | null };

export type GetRunSheetWithSetupByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetWithSetupByIdQuery = { runSheet?: (
    { _id: any, contestant?: { _id: any, startNumber: string } | null, setup?: (
      { _id: any }
      & CarSetupVarsFragment
    ) | null }
    & RunSheetVarsFragment
    & RunSheetSessionVarsFragment
  ) | null };

export type GetRunSheetWithKpiByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetWithKpiByIdQuery = { runSheet?: (
    { _id: any, contestant?: { _id: any, startNumber: string } | null }
    & RunSheetVarsFragment
    & RunSheetSessionVarsFragment
  ) | null };

export type GetRunSheetWithSelectedKpiByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
  runKPI?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lapKPI?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetRunSheetWithSelectedKpiByIdQuery = { runSheet?: { runKPI?: any | null, laps: Array<{ tLapMax?: number | null, vCarLapMax?: number | null, tDay?: any | null, lapKPI?: any | null }>, contestant?: { _id: any, startNumber: string } | null } | null };

export type GetRunSheetWithSelectedKpiAndSetupQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
  runKPI?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lapKPI?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetRunSheetWithSelectedKpiAndSetupQuery = { runSheet?: (
    { runKPI?: any | null, NRunTiming?: number | null, _id: any, sessionID?: any | null, contestantID: any, driverID?: any | null, teamID?: any | null, prevRunSheetID?: any | null, startTime?: any | null, endTime?: any | null, timingServiceShouldIgnore?: boolean | null, tyreSetID?: any | null, TCellMaxRunStart?: number | null, NRun?: number | null, fuelDrainedBeforeRun?: boolean | null, jobIDs?: Array<any | null> | null, selectedJobListTemplateID?: any | null, setupID?: any | null, brakePreRunMeasurementsFL?: any | null, brakePreRunMeasurementsFR?: any | null, brakePreRunMeasurementsRL?: any | null, brakePreRunMeasurementsRR?: any | null, brakePostRunMeasurementsFL?: any | null, brakePostRunMeasurementsFR?: any | null, brakePostRunMeasurementsRL?: any | null, brakePostRunMeasurementsRR?: any | null, skidPreRunMeasurements?: any | null, skidPostRunMeasurements?: any | null, brakeComment?: string | null, controlsComment?: string | null, skidComment?: string | null, mileage?: number | null, createdAt?: any | null, updatedAt?: any | null, laps: Array<{ tDay?: any | null, tLapMax?: number | null, vCarLapMax?: number | null, lapKPI?: any | null }>, contestant?: { _id: any, startNumber: string } | null, session?: { shortName?: string | null, tSessionStart?: any | null, tSessionEnd?: any | null } | null, setup?: (
      { chassisSpec?: { simulationModels?: any | null } | null }
      & CarSetupVarsFragment
    ) | null, driver?: { _id: any, name: string, acronym?: string | null } | null, tyrePressureSettings?: { TTrackReference?: number | null } | null, tyreFL?: RunTyreVarsFragment | null, tyreFR?: RunTyreVarsFragment | null, tyreRL?: RunTyreVarsFragment | null, tyreRR?: RunTyreVarsFragment | null, consumptions?: Array<{ trackLayoutID: any, trackLayout?: { _id: any, name: string, track?: { _id: any, name: string } | null } | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null } | null> | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null, weather?: { TAir?: number | null, TTrack?: number | null, pAmbient?: number | null, rHumidity?: number | null, DAir?: number | null, TAirOfficial?: number | null, TTrackOfficial?: number | null } | null, dashboard?: { mFuelRunEnd?: number | null, mFuelRunStart?: number | null } | null, laptimeThresholds?: { cool?: Array<number> | null, prep?: Array<number> | null, push?: Array<number> | null } | null, lastModifiedBy?: { _id: any, name: string } | null }
    & AllRunSheetScalarVarsFragment
    & RunCommentVarsFragment
    & EnergyUsedVarsFragment
  ) | null };

export type GetRunSheetWithAllKpiAndSetupQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetWithAllKpiAndSetupQuery = { runSheet?: (
    { runKPI?: any | null, NRunTiming?: number | null, _id: any, sessionID?: any | null, contestantID: any, driverID?: any | null, teamID?: any | null, prevRunSheetID?: any | null, startTime?: any | null, endTime?: any | null, timingServiceShouldIgnore?: boolean | null, tyreSetID?: any | null, TCellMaxRunStart?: number | null, NRun?: number | null, fuelDrainedBeforeRun?: boolean | null, jobIDs?: Array<any | null> | null, selectedJobListTemplateID?: any | null, setupID?: any | null, brakePreRunMeasurementsFL?: any | null, brakePreRunMeasurementsFR?: any | null, brakePreRunMeasurementsRL?: any | null, brakePreRunMeasurementsRR?: any | null, brakePostRunMeasurementsFL?: any | null, brakePostRunMeasurementsFR?: any | null, brakePostRunMeasurementsRL?: any | null, brakePostRunMeasurementsRR?: any | null, skidPreRunMeasurements?: any | null, skidPostRunMeasurements?: any | null, brakeComment?: string | null, controlsComment?: string | null, skidComment?: string | null, mileage?: number | null, createdAt?: any | null, updatedAt?: any | null, laps: Array<{ tDay?: any | null, tLapMax?: number | null, vCarLapMax?: number | null, lapKPI?: any | null }>, contestant?: { _id: any, startNumber: string } | null, session?: { shortName?: string | null, tSessionStart?: any | null, tSessionEnd?: any | null } | null, setup?: (
      { chassisSpec?: { simulationModels?: any | null } | null }
      & CarSetupVarsFragment
    ) | null, driver?: { _id: any, name: string, acronym?: string | null } | null, tyrePressureSettings?: { TTrackReference?: number | null } | null, tyreFL?: RunTyreVarsFragment | null, tyreFR?: RunTyreVarsFragment | null, tyreRL?: RunTyreVarsFragment | null, tyreRR?: RunTyreVarsFragment | null, consumptions?: Array<{ trackLayoutID: any, trackLayout?: { _id: any, name: string, track?: { _id: any, name: string } | null } | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null } | null> | null, fuelRequired?: AllRunEnergyVarsFragment | null, SoCRequired?: AllRunEnergyVarsFragment | null, weather?: { TAir?: number | null, TTrack?: number | null, pAmbient?: number | null, rHumidity?: number | null, DAir?: number | null, TAirOfficial?: number | null, TTrackOfficial?: number | null } | null, dashboard?: { mFuelRunEnd?: number | null, mFuelRunStart?: number | null } | null, laptimeThresholds?: { cool?: Array<number> | null, prep?: Array<number> | null, push?: Array<number> | null } | null, lastModifiedBy?: { _id: any, name: string } | null }
    & AllRunSheetScalarVarsFragment
    & RunCommentVarsFragment
    & EnergyUsedVarsFragment
  ) | null };

export type GetRunSheetTabInfoByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetTabInfoByIdQuery = { runSheet?: { _id: any, driverID?: any | null, info?: string | null, NRun?: number | null, NRunTiming?: number | null, runDescription?: string | null, setupID?: any | null, startTime?: any | null, startTimeLTS?: any | null, startTimeManual?: any | null, driver?: { _id: any, acronym?: string | null, name: string } | null, laps: Array<{ _id: any, tLapMax?: number | null, tLapManual?: number | null, lapType?: EnumLapType | null, data?: Array<{ tDay?: any | null, source: EnumLapDataSource } | null> | null }>, session?: { _id: any, tSessionEnd?: any | null, event?: { _id: any } | null } | null, setup?: { setupInfo?: string | null } | null } | null };

export type GetRunSheetsByIDsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetsByIDsQuery = { runSheets?: { items?: Array<(
      { _id: any }
      & RunSheetVarsFragment
    )> | null } | null };

export type GetRunSheetsBySessionsIDsQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  contestantIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetsBySessionsIDsQuery = { runSheets?: { items?: Array<(
      { _id: any }
      & RunSheetVarsFragment
      & RunSheetSessionVarsFragment
    )> | null } | null };

export type GetRunSheetIdsBySessionIdsQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  contestantIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetIdsBySessionIdsQuery = { runSheets?: { items?: Array<{ _id: any, sessionID?: any | null, contestantID: any, NRun?: number | null, NRunTiming?: number | null, runKPI?: any | null }> | null } | null };

export type GetRunSheetsBySessionIdQueryVariables = Exact<{
  sessionID?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GetRunSheetsBySessionIdQuery = { runSheets?: { items?: Array<(
      { _id: any }
      & RunSheetVarsFragment
      & RunSheetSessionVarsFragment
    )> | null } | null };

export type GetRunSheetsByContestantIDsQueryVariables = Exact<{
  contestantIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetsByContestantIDsQuery = { runSheets?: { items?: Array<(
      { _id: any }
      & RunSheetVarsFragment
      & RunSheetSessionVarsFragment
    )> | null } | null };

export type GetRunSheetsForSummaryBySessionsIDsQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  contestantIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetsForSummaryBySessionsIDsQuery = { runSheets?: { items?: Array<(
      { _id: any, sessionID?: any | null, contestantID: any, driverID?: any | null, runKPI?: any | null, laps: Array<(
        { _id: any }
        & LapVarsFragment
      )>, setup?: { _id: any, title: string, powertrain?: { hEngineBlanking?: any | null, engineBlankingDetails?: any | null } | null } | null }
      & RunCommentVarsFragment
      & EnergyUsedVarsFragment
      & RunSheetSessionVarsFragment
    )> | null } | null };

export type GetRunSheetMetadataByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetMetadataByIdQuery = { runSheet?: { _id: any, NRun?: number | null, NRunTiming?: number | null, setupID?: any | null, session?: { _id: any, shortName?: string | null, event?: { _id: any, name: string, season?: { _id: any, name: string, raceSeries?: { _id: any, name: string } | null } | null } | null } | null, contestant?: { _id: any, startNumber: string } | null, driver?: { _id: any, acronym?: string | null } | null, weather?: { TAirOfficial?: number | null, pAmbient?: number | null, rHumidity?: number | null } | null } | null };

export type GetRunSheetDataForCarSetupByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetDataForCarSetupByIdQuery = { runSheet?: { _id: any, NRun?: number | null, NRunTiming?: number | null, setupID?: any | null, session?: { _id: any, shortName?: string | null, event?: { _id: any, name: string, season?: { _id: any, name: string, raceSeries?: { _id: any, name: string } | null } | null } | null } | null, contestant?: { _id: any, startNumber: string } | null, driver?: { _id: any, acronym?: string | null } | null, tyreFL?: RunTyreVarsFragment | null, tyreFR?: RunTyreVarsFragment | null, tyreRL?: RunTyreVarsFragment | null, tyreRR?: RunTyreVarsFragment | null, weather?: { TAir?: number | null, TTrack?: number | null, pAmbient?: number | null, rHumidity?: number | null, DAir?: number | null, TAirOfficial?: number | null, TTrackOfficial?: number | null } | null } | null };

export type GetRunSheetsKpiBySessionsIDsQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetsKpiBySessionsIDsQuery = { runSheets?: { items?: Array<{ _id: any, startTime?: any | null, runKPI?: any | null }> | null } | null };

export type GetRunSheetsForSessionExportQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  contestantIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetsForSessionExportQuery = { runSheets?: { items?: Array<(
      { _id: any }
      & RunSheetExportVarsFragment
    )> | null } | null };

export type GetRunSheetListForEventSelectionContextQueryVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetRunSheetListForEventSelectionContextQuery = { runSheets?: { items?: Array<(
      { _id: any, session?: { tSessionStart?: any | null } | null }
      & RunSheetForEventSelectionVarsFragment
    )> | null } | null };

export type GetRunSheetEventInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetEventInfoQuery = { runSheet?: { _id: any, session?: { _id: any, event?: { _id: any, name: string } | null } | null } | null };

export type GetRunSheetSimulationQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetSimulationQuery = { runSheet?: RunSheetSimulationVarsFragment | null };

export type GetSessionEventInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSessionEventInfoQuery = { session?: { _id: any, tSessionStart?: any | null, tSessionEnd?: any | null, event?: { _id: any, name: string } | null } | null };

export type GetRunSheetStyleListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRunSheetStyleListQuery = { runSheetStyles?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetRunSheetStyleQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetRunSheetStyleQuery = { runSheetStyle?: RunSheetStyleVarsFragment | null };

export type RunSheetStyleVarsFragment = { _id: any, energyType?: EnumEnergyType | null, name: string, blocks?: Array<RunSheetStyleBlocksVars_BlankingBlock_Fragment | RunSheetStyleBlocksVars_BrakesBlock_Fragment | RunSheetStyleBlocksVars_CommentBlock_Fragment | RunSheetStyleBlocksVars_DoubleCommentBlock_Fragment | RunSheetStyleBlocksVars_FuelBlock_Fragment | RunSheetStyleBlocksVars_IssueBlock_Fragment | RunSheetStyleBlocksVars_JobListBlock_Fragment | RunSheetStyleBlocksVars_LapTableBlock_Fragment | RunSheetStyleBlocksVars_LapTimeThresholdsBlock_Fragment | RunSheetStyleBlocksVars_LapTypeCountBlock_Fragment | RunSheetStyleBlocksVars_MiniJobListBlock_Fragment | RunSheetStyleBlocksVars_PostRunMeasurementBlock_Fragment | RunSheetStyleBlocksVars_RunKpiTableBlock_Fragment | RunSheetStyleBlocksVars_SetupChangesBlock_Fragment | RunSheetStyleBlocksVars_SetupSheetBlock_Fragment | RunSheetStyleBlocksVars_TyreTableBlock_Fragment | RunSheetStyleBlocksVars_WeatherBoxBlock_Fragment | null> | null, lapFlags?: AllLapFlagLabelVarsFragment | null };

export type GetBasicSeasonListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasicSeasonListQuery = { seasons?: { items?: Array<{ _id: any, name: string, eventIDs?: Array<any | null> | null }> | null } | null };

export type GetSeasonNameQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSeasonNameQuery = { season?: { _id: any, name: string, raceSeriesID: any } | null };

export type DoSeasonSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['RegExpAsString']['input']>;
}>;


export type DoSeasonSearchQuery = { seasons?: { items?: Array<{ _id: any, name: string, raceSeries?: { _id: any, name: string } | null }> | null } | null };

export type GetSeasonInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSeasonInfoQuery = { season?: { _id: any, name: string, contestantIDs?: Array<any | null> | null, eventIDs?: Array<any | null> | null, raceSeriesID: any, pointsSystemQualiAlternateIDs?: Array<any | null> | null, pointsSystemQualiDefaultIDs?: Array<any | null> | null, pointsSystemRaceAlternateIDs?: Array<any | null> | null, pointsSystemRaceDefaultIDs?: Array<any | null> | null, contestants: Array<{ _id: any, class?: string | null, startNumber: string, drivers: Array<{ _id: any, name: string }>, team?: { _id: any, name: string } | null }>, events: Array<(
      { _id: any }
      & EventInSeasonVarsFragment
    )>, raceSeries?: { _id: any, name: string } | null } | null };

export type GetSeasonInfoFromContestantQueryVariables = Exact<{
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetSeasonInfoFromContestantQuery = { seasons?: { items?: Array<{ _id: any, contestants: Array<{ _id: any, season?: { _id: any, name: string, events: Array<{ _id: any, name: string }> } | null }> }> | null } | null };

export type GetSeasonsFromRaceSeriesQueryVariables = Exact<{
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetSeasonsFromRaceSeriesQuery = { seasons?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetSeasonContestantsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSeasonContestantsQuery = { season?: { _id: any, contestants: Array<{ _id: any, class?: string | null, driverIDs?: Array<any | null> | null, startNumber: string, drivers: Array<{ _id: any, acronym?: string | null, name: string, username: string }>, team?: { _id: any, name: string } | null }> } | null };

export type WhoAmIQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoAmIQuery = { whoami: { claims: any } };

export type GetLicenseStatusAndPersonInfoForAuthQueryVariables = Exact<{
  personID: Scalars['MongoID']['input'];
}>;


export type GetLicenseStatusAndPersonInfoForAuthQuery = { license: { valid: boolean, customer?: string | null, expired: boolean, expirationDate?: string | null, features: { dyno: boolean, moveServer: boolean, readOnlyAfterLicenseExpiry: boolean, sevenPost: boolean, simulation: boolean, teams: boolean, tyreSetStatistics: boolean, lightVersion: boolean }, options: { setupSheetStyles: Array<EnumChassisSetupSheetStyle>, services: { carData: boolean, chassisSimulation: boolean, oneTimingWeather: boolean, timing: boolean, weather: boolean } } }, person?: { isTimeTracker?: boolean | null, isTimeTrackerAdmin?: boolean | null, hideKPIs?: boolean | null } | null };

export type GetApiVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiVersionQuery = { version: `${number}.${number}.${number}` };

export type GetSessionsInDateTimeRangeQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetSessionsInDateTimeRangeQuery = { sessions?: { items?: Array<(
      { _id: any }
      & SessionInRangeVarsFragment
    )> | null } | null };

export type GetSessionQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSessionQuery = { session?: { _id: any, name: string, shortName?: string | null, tSessionStart?: any | null, tSessionEnd?: any | null, timeRemaining?: number | null, timeRemainingUpdatedAt?: any | null, eventID: any, debriefNotes?: string | null, sessionType?: EnumSessionType | null, isLinkedSession?: boolean | null, contestants?: Array<{ _id: any } | null> | null } | null };

export type DoSessionSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['RegExpAsString']['input']>;
}>;


export type DoSessionSearchQuery = { sessions?: { items?: Array<(
      { _id: any }
      & SessionBaseVarsFragment
    )> | null } | null };

export type GetContestantsForSessionQueryVariables = Exact<{
  sessionID: Scalars['MongoID']['input'];
}>;


export type GetContestantsForSessionQuery = { session?: { _id: any, event?: { _id: any, season?: { _id: any, contestants: Array<{ _id: any, class?: string | null }> } | null, contestants?: Array<{ _id: any } | null> | null } | null, contestants?: Array<{ _id: any } | null> | null } | null };

export type GetAllSeasonSessionsForSessionQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetAllSeasonSessionsForSessionQuery = { session?: { _id: any, event?: { _id: any, season?: { _id: any, name: string, events: Array<{ _id: any, sessions: Array<{ _id: any, tSessionStart?: any | null, name: string, sessionType?: EnumSessionType | null }> }> } | null } | null } | null };

export type GetSetupsForSessionByDriverQueryVariables = Exact<{
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetSetupsForSessionByDriverQuery = { runSheets?: { items?: Array<{ _id: any, NRun?: number | null, NRunTiming?: number | null, setupID?: any | null, session?: { _id: any, name: string } | null }> | null } | null };

export type GetSessionInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSessionInfoQuery = { session?: { _id: any, name: string, shortName?: string | null, eventID: any } | null };

export type GetBasicSessionListQueryVariables = Exact<{
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetBasicSessionListQuery = { sessions?: { items?: Array<(
      { _id: any }
      & BasicSessionVarsFragment
    )> | null } | null };

export type GetSessionListWithTimesQueryVariables = Exact<{
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetSessionListWithTimesQuery = { sessions?: { items?: Array<(
      { _id: any }
      & SessionWithTimesVarsFragment
    )> | null } | null };

export type GetDriversForSessionQueryVariables = Exact<{
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetDriversForSessionQuery = { runSheets?: { items?: Array<{ _id: any, driverID?: any | null }> | null } | null };

export type GetDownloadableSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDownloadableSessionsQuery = { raceSeriesAll?: { items?: Array<{ _id: any, name: string, seasons: Array<{ _id: any, name: string, contestants: Array<{ _id: any }>, events: Array<{ _id: any, name: string, contestants?: Array<{ _id: any } | null> | null, sessions: Array<{ _id: any, name: string, contestants?: Array<{ _id: any } | null> | null }> }> }> }> | null } | null };

export type GetSessionDriverStandingsQueryVariables = Exact<{
  sessionID: Scalars['MongoID']['input'];
}>;


export type GetSessionDriverStandingsQuery = { session?: { _id: any, event?: { _id: any, season?: { _id: any, contestants: Array<{ _id: any, startNumber: string }> } | null, contestants?: Array<{ _id: any } | null> | null } | null, contestants?: Array<{ _id: any } | null> | null, driverChampionshipStandings?: Array<{ startNumber?: string | null, acronym?: string | null, points: number, driverID?: any | null, prevRacePositions?: Array<number | null> | null, rank?: number | null } | null> | null, liveStandings?: Array<{ startNumber?: string | null, acronym?: string | null, driverID?: any | null, position: number } | null> | null } | null };

export type GetDriverStandingsForSessionsQueryVariables = Exact<{
  sessionIDs?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GetDriverStandingsForSessionsQuery = { sessions?: { items?: Array<{ _id: any, name: string, tSessionStart?: any | null, event?: { _id: any, season?: { _id: any, contestants: Array<{ _id: any, startNumber: string }> } | null, contestants?: Array<{ _id: any } | null> | null } | null, contestants?: Array<{ _id: any } | null> | null, prevDriverChampionshipStandings?: Array<{ startNumber?: string | null, acronym?: string | null, points: number, prevRacePositions?: Array<number | null> | null, driverID?: any | null } | null> | null, driverChampionshipStandings?: Array<{ startNumber?: string | null, acronym?: string | null, points: number, driverID?: any | null, prevRacePositions?: Array<number | null> | null } | null> | null, liveStandings?: Array<{ startNumber?: string | null, acronym?: string | null, driverID?: any | null } | null> | null }> | null } | null };

export type GetSetupOverviewConfigByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSetupOverviewConfigByIdQuery = { setupOverviewConfig?: { _id: any, title: string, authorID?: any | null, isPublic?: boolean | null, fields?: Array<(
      { _id?: any | null }
      & SetupOverviewConfigFieldVarsFragment
    ) | null> | null, rows?: Array<(
      { _id?: any | null }
      & SetupOverviewConfigRowVarsFragment
    ) | null> | null, author?: { _id: any, name: string } | null } | null };

export type GetSetupOverviewConfigListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSetupOverviewConfigListQuery = { setupOverviewConfigs?: { items?: Array<{ _id: any, title: string, fields?: Array<{ _id?: any | null, keys: Array<string | null>, label: string, unit?: string | null, decimals?: number | null, gain?: Array<number | null> | null } | null> | null }> | null } | null };

export type GetSetupSheetStyleListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSetupSheetStyleListQuery = { setupSheetStyles?: { items?: Array<{ _id: any, chassisSpecID?: any | null, name: string, type: EnumSetupSheetStyleType, chassisSpec?: { name: string, version?: string | null } | null }> | null } | null };

export type GetSetupSheetStyleQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSetupSheetStyleQuery = { setupSheetStyle?: { _id: any, authorID?: any | null, chassisSpecID?: any | null, createdAt?: any | null, hideAddPartButton?: boolean | null, hideUnits?: boolean | null, isPublic?: boolean | null, name: string, targetEventType?: EnumSetupSheetStyleTargetEventType | null, targetRoles?: Array<EnumPersonRole> | null, targetUserIDs?: Array<any | null> | null, type: EnumSetupSheetStyleType, updatedAt?: any | null, version?: string | null, author?: { username: string, name: string, _id: any } | null, blocks: Array<(
      { _id?: any | null }
      & SetupSheetStyleBlockVarsForSetupSheetFlexFragment
    )>, targetUsers: Array<{ _id: any, name: string }> } | null };

export type GetSimResultsForCarSetupQueryVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetSimResultsForCarSetupQuery = { simResults?: { items?: Array<(
      { _id: any }
      & SimResultVarsFragment
    )> | null } | null };

export type GetSimResultByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSimResultByIdQuery = { simResult?: (
    { _id: any }
    & SimResultVarsFragment
  ) | null };

export type GetSimResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSimResultsQuery = { simResults?: { items?: Array<(
      { _id: any }
      & SimResultCondensedVarsFragment
    )> | null } | null };

export type GetSimResultsByCarSetupIdQueryVariables = Exact<{
  setupID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetSimResultsByCarSetupIdQuery = { simResults?: { items?: Array<(
      { _id: any }
      & SimResultVarsFragment
    )> | null } | null };

export type GetSimResultsForCarSetupByTypeQueryVariables = Exact<{
  setupID?: InputMaybe<Scalars['MongoID']['input']>;
  simType?: InputMaybe<EnumSimResultSimType>;
}>;


export type GetSimResultsForCarSetupByTypeQuery = { simResults?: { items?: Array<(
      { _id: any }
      & SimResultVarsFragment
    )> | null } | null };

export type GetSimResultsByRunsheetIdQueryVariables = Exact<{
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetSimResultsByRunsheetIdQuery = { simResults?: { items?: Array<(
      { _id: any }
      & SimResultVarsFragment
    )> | null } | null };

export type GetSimResultsForRunsheetByTypeQueryVariables = Exact<{
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  simType?: InputMaybe<EnumSimResultSimType>;
}>;


export type GetSimResultsForRunsheetByTypeQuery = { simResults?: { items?: Array<(
      { _id: any }
      & SimResultVarsFragment
    )> | null } | null };

export type GetSimResultsByPersonQueryVariables = Exact<{
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetSimResultsByPersonQuery = { simResults?: { items?: Array<(
      { _id: any }
      & SimResultCondensedVarsFragment
    )> | null } | null };

export type FindCanopyConfigsQueryVariables = Exact<{
  configType: EnumCanopyConfigType;
  nameFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindCanopyConfigsQuery = { findCanopyConfigs: Array<{ canopyID: string, name: string, simVersion: string, createdAt?: any | null, updatedAt?: any | null }> };

export type GetAllChassisSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllChassisSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, prevIterationID?: any | null, nextIterationID?: any | null, name: string, version?: string | null, releaseDate?: any | null, released?: boolean | null, updatedAt?: any | null, decommissioned?: boolean | null, allowableParentSpecIDs?: Array<any | null> | null, simulationAvailable?: boolean | null } | {}> | null } | null };

export type GetAllChassisSpecsBasicInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllChassisSpecsBasicInfoQuery = { specifications?: { items?: Array<BasicInfoChassisSpecFragment | {}> | null } | null };

export type BasicInfoChassisSpecFragment = { _id?: any | null, buildSheetStyleIDs?: Array<any | null> | null, iterationIDs?: Array<any | null> | null, name: string, nextIterationID?: any | null, prevIterationID?: any | null, released?: boolean | null, releaseDate?: any | null, version?: string | null };

export type GetBasicChassisSpecListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasicChassisSpecListQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetChassisSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSpecByIdQuery = { specification?: AllChassisSpecVarsFragment | {} | null };

export type GetAllChassisSpecIterationsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetAllChassisSpecIterationsQuery = { specification?: { _id?: any | null, iterationIDs?: Array<any | null> | null, iterations: Array<{ _id?: any | null, name: string, version?: string | null, released?: boolean | null, releaseDate?: any | null, decommissioned?: boolean | null }> } | {} | null };

export type GetFlattenedFieldsOfChassisSpecificationQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetFlattenedFieldsOfChassisSpecificationQuery = { specification?: { _id?: any | null, flattened?: any | null } | {} | null };

export type GetChassisSpecificationsByTypeQueryVariables = Exact<{
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumSpecificationType>;
}>;


export type GetChassisSpecificationsByTypeQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string } | { _id?: any | null, name: string }> | null } | null };

export type GetAllAeroElementSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAeroElementSpecsQuery = { specifications?: { items?: Array<AeroElementVarsFragment | {}> | null } | null };

export type GetAeroElementSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetAeroElementSpecByIdQuery = { specification?: AeroElementVarsFragment | {} | null };

export type GetAllAeroPackageSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAeroPackageSpecsQuery = { specifications?: { items?: Array<AeroPackageVarsFragment | {}> | null } | null };

export type GetAeroPackageSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetAeroPackageSpecByIdQuery = { specification?: AeroPackageVarsFragment | {} | null };

export type GetAllElasticElementSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllElasticElementSpecsQuery = { specifications?: { items?: Array<ElasticSpecVarsFragment | {}> | null } | null };

export type GetElasticElementSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetElasticElementSpecByIdQuery = { specification?: ElasticSpecVarsFragment | {} | null };

export type GetAllTorsionBarSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTorsionBarSpecsQuery = { specifications?: { items?: Array<ElasticSpecVarsFragment | {}> | null } | null };

export type GetTorsionBarSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTorsionBarSpecByIdQuery = { specification?: ElasticSpecVarsFragment | {} | null };

export type GetAllGearBoxSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllGearBoxSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string, chassisSpecID?: any | null, updatedAt?: any | null, decommissioned?: boolean | null, bevelSetSpecID?: any | null, dropGearSpecID?: any | null, differentialSpecID?: any | null, headGearSpecID?: any | null, assignedGears?: Array<{ gearID: any, useHeadGear?: boolean | null, gear?: { _id?: any | null, isHeadGear?: boolean | null } | null } | null> | null } | {}> | null } | null };

export type GetGearBoxSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetGearBoxSpecByIdQuery = { specification?: { _id?: any | null, name: string, chassisSpecID?: any | null, updatedAt?: any | null, decommissioned?: boolean | null, bevelSetSpecID?: any | null, dropGearSpecID?: any | null, assignedGears?: Array<{ gearID: any, gear?: { _id?: any | null, isHeadGear?: boolean | null } | null } | null> | null } | {} | null };

export type GetAllDamperElementSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDamperElementSpecsQuery = { specifications?: { items?: Array<DamperSpecVarsFragment | {}> | null } | null };

export type GetDamperElementSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetDamperElementSpecByIdQuery = { specification?: DamperSpecVarsFragment | {} | null };

export type GetAllAntiRollBarElementSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAntiRollBarElementSpecsQuery = { specifications?: { items?: Array<AntiRollBarVarsFragment | {}> | null } | null };

export type GetAntiRollBarElementSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetAntiRollBarElementSpecByIdQuery = { specification?: AntiRollBarVarsFragment | {} | null };

export type GetAllDifferentialElementSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDifferentialElementSpecsQuery = { specifications?: { items?: Array<DifferentialSpecVarsFragment | {}> | null } | null };

export type GetAllDifferentialElementSpecsByChassisSpecQueryVariables = Exact<{
  chassisSpecID: Scalars['MongoID']['input'];
}>;


export type GetAllDifferentialElementSpecsByChassisSpecQuery = { specifications?: { items?: Array<DifferentialSpecVarsFragment | {}> | null } | null };

export type GetDifferentialElementSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetDifferentialElementSpecByIdQuery = { specification?: DifferentialSpecVarsFragment | {} | null };

export type GetAllGearElementSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllGearElementSpecsQuery = { specifications?: { items?: Array<GearSpecVarsFragment | {}> | null } | null };

export type GetAllGearElementSpecsByChassisSpecQueryVariables = Exact<{
  chassisSpecID: Scalars['MongoID']['input'];
}>;


export type GetAllGearElementSpecsByChassisSpecQuery = { specifications?: { items?: Array<GearSpecVarsFragment | {}> | null } | null };

export type GetGearElementSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetGearElementSpecByIdQuery = { specification?: GearSpecVarsFragment | {} | null };

export type GetAllKinematicsExternalSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllKinematicsExternalSpecsQuery = { specifications?: { items?: Array<ExternalKinematicSpecVarsFragment | {}> | null } | null };

export type GetKinematicsExternalSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetKinematicsExternalSpecByIdQuery = { specification?: ExternalKinematicSpecVarsFragment | {} | null };

export type GetAllKinematicsInternalSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllKinematicsInternalSpecsQuery = { specifications?: { items?: Array<InternalKinematicSpecVarsFragment | {}> | null } | null };

export type GetKinematicsInternalSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetKinematicsInternalSpecByIdQuery = { specification?: InternalKinematicSpecVarsFragment | {} | null };

export type GetAllCustomSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCustomSpecsQuery = { specifications?: { items?: Array<CustomSpecVarsFragment | {}> | null } | null };

export type GetCustomSpecByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetCustomSpecByIdQuery = { specification?: CustomSpecVarsFragment | {} | null };

export type GetChassisSpecMeasurementUnitsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetChassisSpecMeasurementUnitsQuery = { specification?: { measurements?: ChassisMeasurementVarsFragment | null } | {} | null };

export type GetTeamInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTeamInfoQuery = { team?: { _id: any, name: string, shortName?: string | null } | null };

export type GetTeamListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeamListQuery = { teams?: { items?: Array<{ _id: any, name: string, shortName?: string | null }> | null } | null };

export type GetTimeSheetEntriesForTimePeriodQueryVariables = Exact<{
  tStart?: InputMaybe<Scalars['Date']['input']>;
  tEnd?: InputMaybe<Scalars['Date']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type GetTimeSheetEntriesForTimePeriodQuery = { timeSheetEntries?: { items?: Array<TimeSheetEntryForTimePeriodFragment> | null } | null };

export type TimeSheetEntryForTimePeriodFragment = { _id: any, absent?: boolean | null, tStart: any, tEnd?: any | null, projectID?: any | null, approvedAt?: any | null };

export type GetAllTimeSheetEntriesForTimePeriodQueryVariables = Exact<{
  tStart?: InputMaybe<Scalars['Date']['input']>;
  tEnd?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetAllTimeSheetEntriesForTimePeriodQuery = { timeSheetEntries?: { items?: Array<{ _id: any, tStart: any, tEnd?: any | null, projectID?: any | null, approvedAt?: any | null }> | null } | null };

export type DoTimingServiceConfigSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['RegExpAsString']['input']>;
}>;


export type DoTimingServiceConfigSearchQuery = { timingServiceConfigs?: { items?: Array<{ _id: any, name: string, eventID?: any | null, followedCarNumbers?: Array<string | null> | null, timingURL?: string | null, timingPort?: number | null, timingRaceSeries?: string | null, fallbackTimedSectorsCount?: number | null, strictSessionNameMatching?: boolean | null, fallbackScheduleBasedSessionMatching?: boolean | null, logLevel?: EnumTimingServiceConfigLogLevel | null, writeData?: boolean | null, logStream?: boolean | null, updatedAt?: any | null, createdAt?: any | null }> | null } | null };

export type GetBasicTrackListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasicTrackListQuery = { tracks?: { items?: Array<(
      { _id: any }
      & TrackVarsFragment
    )> | null } | null };

export type GetTrackNameQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTrackNameQuery = { season?: { _id: any, name: string } | null };

export type DoTrackSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['RegExpAsString']['input']>;
}>;


export type DoTrackSearchQuery = { tracks?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetTrackInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTrackInfoQuery = { track?: (
    { _id: any }
    & TrackVarsFragment
  ) | null };

export type GetTrackLayoutListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrackLayoutListQuery = { trackLayouts?: { items?: Array<{ _id: any, name: string }> | null } | null };

export type GetTrackLayoutNamesWithIDsQueryVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetTrackLayoutNamesWithIDsQuery = { trackLayouts?: { items?: Array<{ _id: any, name: string, fuelRequired?: { outLap?: number | null, inLap?: number | null, outInLap?: number | null, pushLap?: number | null, coolLap?: number | null, slowLap?: number | null, prepLap?: number | null, targetLap?: number | null, unfinishedLap?: number | null, attackLap?: number | null, qualiLap?: number | null, toGridLap?: number | null, toPitsLap?: number | null, fullCourseYellowLap?: number | null, safetyCarLap?: number | null } | null }> | null } | null };

export type GetTrackLayoutInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTrackLayoutInfoQuery = { trackLayout?: (
    { _id: any }
    & TrackLayoutVarsFragment
  ) | null };

export type GetTrackLayoutWithMapQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTrackLayoutWithMapQuery = { trackLayout?: (
    { _id: any, mapTrackXyCsv?: string | null, mapTrackLatLonCsv?: string | null }
    & TrackLayoutVarsFragment
  ) | null };

export type GetTrackLayoutLapLengthsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrackLayoutLapLengthsQuery = { trackLayouts?: { items?: Array<{ _id: any, lapLengthOfficial?: number | null }> | null } | null };

export type GetTyreSetInfosByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetTyreSetInfosByIdsQuery = { tyreSets?: { items?: Array<(
      { _id: any }
      & TyreSetVarsFragment
    )> | null } | null };

export type GetTyreSetNameByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetTyreSetNameByIdsQuery = { tyreSets?: { items?: Array<{ _id: any, name?: string | null }> | null } | null };

export type GetBasicTyreListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasicTyreListQuery = { tyres?: { items?: Array<(
      { _id: any }
      & TyreVarsFragment
    )> | null } | null };

export type GetTyreNameByIdQueryVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetTyreNameByIdQuery = { tyres?: { items?: Array<{ _id: any, name?: string | null, type?: string | null, axle?: EnumTyreAxle | null }> | null } | null };

export type GetTyreInfoQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTyreInfoQuery = { tyre?: (
    { _id: any, heatingSchedule?: Array<{ _id?: any | null, duration: number, temperature: number } | null> | null }
    & AllTyreScalarVarsFragment
  ) | null };

export type GetRunsheetsForTyreIdQueryVariables = Exact<{
  tyre: Scalars['MongoID']['input'];
}>;


export type GetRunsheetsForTyreIdQuery = { runSheets?: { items?: Array<(
      { _id: any }
      & RunSheetForTyreVarsFragment
    )> | null } | null };

export type GetRunsheetsForTyreIdAndSessionsQueryVariables = Exact<{
  tyreID: Scalars['MongoID']['input'];
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetRunsheetsForTyreIdAndSessionsQuery = { runSheets?: { items?: Array<(
      { _id: any }
      & RunSheetForTyreMileageExportVarsFragment
    )> | null } | null };

export type GetRunsheetsForTyreSetIdAndSessionsQueryVariables = Exact<{
  tyreSetID: Scalars['MongoID']['input'];
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetRunsheetsForTyreSetIdAndSessionsQuery = { runSheets?: { items?: Array<(
      { _id: any }
      & RunSheetForTyreMileageExportVarsFragment
    )> | null } | null };

export type GetTyreInfosByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetTyreInfosByIdsQuery = { tyres?: { items?: Array<(
      { _id: any }
      & TyreVarsFragment
    )> | null } | null };

export type GetRunSheetInfosBySessionIDsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetRunSheetInfosBySessionIDsQuery = { runSheets?: { items?: Array<{ _id: any, mileage?: number | null, tyreSetID?: any | null, session?: { _id: any, shortName?: string | null, event?: { _id: any, name: string } | null } | null, tyreFL?: { tyreID?: any | null } | null, tyreRL?: { tyreID?: any | null } | null, tyreRR?: { tyreID?: any | null } | null, tyreFR?: { tyreID?: any | null } | null }> | null } | null };

export type GetSeasonTyresQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSeasonTyresQuery = { season?: { _id: any, name: string, events: Array<{ _id: any, name: string, sessions: Array<{ _id: any, name: string }> }>, tyres: Array<(
      { _id: any }
      & TyreVarsFragment
    )> } | null };

export type FindTyreTypeByIDsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type FindTyreTypeByIDsQuery = { tyres?: { items?: Array<{ _id: any, type?: string | null }> | null } | null };

export type CheckIfAllFourTyresExistQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CheckIfAllFourTyresExistQuery = { tyreSet?: { tyreFL?: { _id: any } | null, tyreFR?: { _id: any } | null, tyreRL?: { _id: any } | null, tyreRR?: { _id: any } | null } | null };

export type GetVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVersionQuery = { version: `${number}.${number}.${number}` };

export type GetWeatherListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWeatherListQuery = { weatherAll?: { items?: Array<{ _id: any, time?: any | null, source?: string | null, eventIDs?: Array<any | null> | null, type: EnumWeatherType, events: Array<{ _id: any, name: string, season?: { _id: any, name: string, raceSeries?: { _id: any, name: string } | null } | null }> }> | null } | null };

export type GetWeatherQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetWeatherQuery = { weather?: { _id: any, time?: any | null, source?: string | null, type: EnumWeatherType, geoLocation?: { coordinates: Array<number | null> } | null, data: Array<WeatherDataVarsFragment | null>, events: Array<{ _id: any, name: string, season?: { _id: any, name: string, raceSeries?: { _id: any, name: string } | null } | null }> } | null };

export type GetWeatherForEventQueryVariables = Exact<{
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type GetWeatherForEventQuery = { weatherAll?: { items?: Array<{ _id: any, time?: any | null, source?: string | null, type: EnumWeatherType, eventIDs?: Array<any | null> | null, data: Array<WeatherDataVarsFragment | null> }> | null } | null };

export type BasicAeroElementVarsFragment = { __typename: 'AeroElementSpec', _id?: any | null, name: string };

export type BasicAeroPackageVarsFragment = { __typename: 'AeroPackageSpec', _id?: any | null, name: string };

export type BasicAntiRollBarVarsFragment = { __typename: 'AntiRollBarSpec', _id?: any | null, name: string };

export type BasicChassisSpecVarsFragment = { __typename: 'ChassisSpec', _id?: any | null, name: string };

export type BasicCustomSpecVarsFragment = { __typename: 'CustomSpec', _id?: any | null, name: string };

export type BasicDamperSpecVarsFragment = { __typename: 'DamperSpec', _id?: any | null, name: string };

export type BasicDifferentialSpecVarsFragment = { __typename: 'DifferentialSpec', _id?: any | null, name: string };

export type BasicElasticSpecVarsFragment = { __typename: 'ElasticSpec', _id?: any | null, name: string };

export type BasicGearSpecVarsFragment = { __typename: 'GearSpec', _id?: any | null, name: string };

export type BasicGearBoxSpecVarsFragment = { __typename: 'GearBoxSpec', _id?: any | null, name: string };

export type BasicInternalKinematicSpecVarsFragment = { __typename: 'KinematicsInternalSpec', _id?: any | null, name: string };

export type BasicExternalKinematicSpecVarsFragment = { __typename: 'KinematicsExternalSpec', _id?: any | null, name: string };

export type GetSpecificationBaseForReadingLocationQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSpecificationBaseForReadingLocationQuery = { specificationBase?: { _id: any, antiRollBarDisplayLocation?: EnumAntiRollBarDisplayLocation | null, readingsAllowable?: Array<EnumSpecificationReadingsAllowable | null> | null, readingsRequired?: EnumSpecificationReadingsRequired | null } | null };

export type GetSpecificationByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetSpecificationByIdQuery = { specification?: BasicAeroElementVarsFragment | BasicAeroPackageVarsFragment | BasicAntiRollBarVarsFragment | BasicChassisSpecVarsFragment | BasicCustomSpecVarsFragment | BasicDamperSpecVarsFragment | BasicDifferentialSpecVarsFragment | BasicElasticSpecVarsFragment | BasicGearBoxSpecVarsFragment | BasicGearSpecVarsFragment | BasicExternalKinematicSpecVarsFragment | BasicInternalKinematicSpecVarsFragment | null };

export type GetAllBasicSpecificationFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllBasicSpecificationFieldsQuery = { specifications?: { items?: Array<BasicAeroElementVarsFragment | BasicAeroPackageVarsFragment | BasicAntiRollBarVarsFragment | BasicChassisSpecVarsFragment | BasicCustomSpecVarsFragment | BasicDamperSpecVarsFragment | BasicDifferentialSpecVarsFragment | BasicElasticSpecVarsFragment | BasicGearBoxSpecVarsFragment | BasicGearSpecVarsFragment | BasicExternalKinematicSpecVarsFragment | BasicInternalKinematicSpecVarsFragment> | null } | null };

export type GetAllAeroElementBasicFieldSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAeroElementBasicFieldSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetAllAeroPackageBasicFieldSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAeroPackageBasicFieldSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetAllAntiRollbarBasicFieldSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAntiRollbarBasicFieldSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetAllChassisBasicFieldSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllChassisBasicFieldSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetAllCustomBasicFieldSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCustomBasicFieldSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetAllDamperBasicFieldSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDamperBasicFieldSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetAllDifferentialBasicFieldSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDifferentialBasicFieldSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetAllElasticBasicFieldSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllElasticBasicFieldSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetAllGearBasicFieldSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllGearBasicFieldSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetAllGearBoxBasicFieldSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllGearBoxBasicFieldSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetAllKinematicsExternalBasicFieldSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllKinematicsExternalBasicFieldSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type GetAllKinematicsInternalBasicFieldSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllKinematicsInternalBasicFieldSpecsQuery = { specifications?: { items?: Array<{ _id?: any | null, name: string } | {}> | null } | null };

export type AssemblyUpdatedSubscriptionVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type AssemblyUpdatedSubscription = { assemblyUpdated?: AnyAssemblyForAssemblyEditPageVars_BaseAssembly_Fragment | null };

export type AssemblyAddedSubscriptionVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type AssemblyAddedSubscription = { assemblyAdded?: AnyAssemblyForAssemblyEditPageVars_BaseAssembly_Fragment | null };

export type AssemblyRemovedSubscriptionVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type AssemblyRemovedSubscription = { assemblyRemoved?: { _id: any } | null };

export type BestValuesAddedSessionSubscriptionVariables = Exact<{
  sessionID: Scalars['MongoID']['input'];
}>;


export type BestValuesAddedSessionSubscription = { bestValuesAdded?: (
    { _id: any }
    & BestValuesVarsFragment
  ) | null };

export type BestValuesAddedDriverSubscriptionVariables = Exact<{
  sessionID: Scalars['MongoID']['input'];
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type BestValuesAddedDriverSubscription = { bestValuesAdded?: (
    { _id: any }
    & BestValuesVarsFragment
  ) | null };

export type BestValuesUpdatedSubscriptionVariables = Exact<{
  bestValuesID: Scalars['MongoID']['input'];
}>;


export type BestValuesUpdatedSubscription = { bestValuesUpdated?: (
    { _id: any }
    & BestValuesVarsFragment
  ) | null };

export type CarSetupUpdatedSubscriptionVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CarSetupUpdatedSubscription = { carSetupUpdated?: { _id: any, title: string, teamID?: any | null, driverID?: any | null, engineerID?: any | null, chassisID?: any | null, time?: any | null, runSheetID?: any | null, setupSheetStyle?: EnumCarSetupSetupSheetStyle | null, systemsConfigValues?: any | null, mBallasts?: any | null, frontLeft?: CornerVarsFragment | null, frontRight?: CornerVarsFragment | null, rearLeft?: CornerVarsFragment | null, rearRight?: CornerVarsFragment | null, front?: EndVarsFragment | null, rear?: EndVarsFragment | null, massTeam?: MassVarsFragment | null, massSetup?: MassVarsFragment | null, massRegulation?: MassVarsFragment | null, massOutOfGarage?: MassVarsFragment | null, aero?: AeroVarsFragment | null, brakeSystem?: BrakeSystemVarsFragment | null, powertrain?: PowertrainVarsFragment | null, info?: InfoVarsFragment | null, steering?: SteeringVarsFragment | null, chassis?: { _id: any, systemsConfigFields?: Array<string | null> | null, ballastPositions?: Array<string | null> | null } | null } | null };

export type JobAddedSubscriptionVariables = Exact<{
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type JobAddedSubscription = { jobAdded?: (
    { _id: any }
    & JobVarsFragment
  ) | null };

export type JobUpdatedSubscriptionVariables = Exact<{
  jobID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type JobUpdatedSubscription = { jobUpdated?: (
    { _id: any }
    & JobVarsFragment
  ) | null };

export type JobRemovedSubscriptionVariables = Exact<{
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type JobRemovedSubscription = { jobRemoved?: { _id: any, assigneeIDs?: Array<any | null> | null } | null };

export type RunSheetUpdatedSubscriptionVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RunSheetUpdatedSubscription = { runSheetUpdated?: (
    { _id: any }
    & RunSheetVarsFragment
  ) | null };

export type RunSheetAddedSubscriptionVariables = Exact<{
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type RunSheetAddedSubscription = { runSheetAdded?: (
    { _id: any }
    & RunSheetVarsFragment
  ) | null };

export type RunSheetRemovedSubscriptionVariables = Exact<{
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type RunSheetRemovedSubscription = { runSheetRemoved?: { _id?: any | null } | null };

export type SessionDriverRunAddedSubscriptionVariables = Exact<{
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type SessionDriverRunAddedSubscription = { runSheetAdded?: { _id: any } | null };

export type SessionDriverRunUpdatedSubscriptionVariables = Exact<{
  sessionIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  contestantID: Scalars['MongoID']['input'];
}>;


export type SessionDriverRunUpdatedSubscription = { runSheetInSessionsUpdated?: { _id: any } | null };

export type SimResultAddedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SimResultAddedSubscription = { simResultAdded?: (
    { _id: any }
    & SimResultVarsFragment
  ) | null };

export type SimResultUpdatedSubscriptionVariables = Exact<{
  simResultID: Scalars['MongoID']['input'];
}>;


export type SimResultUpdatedSubscription = { simResultUpdated?: (
    { _id: any }
    & SimResultVarsFragment
  ) | null };

export type SimResultRemovedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SimResultRemovedSubscription = { simResultRemoved?: { _id: any } | null };

export type TimingServiceConfigVarsFragment = { _id: any, active?: boolean | null, createdAt?: any | null, description?: string | null, eventID?: any | null, fallbackScheduleBasedSessionMatching?: boolean | null, fallbackTimedSectorsCount?: number | null, followedCarNumbers?: Array<string | null> | null, logLevel?: EnumTimingServiceConfigLogLevel | null, logStream?: boolean | null, name: string, strictSessionNameMatching?: boolean | null, timingPort?: number | null, timingRaceSeries?: string | null, timingURL?: string | null, updatedAt?: any | null, writeData?: boolean | null };

export type TimingServiceConfigAddedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TimingServiceConfigAddedSubscription = { timingServiceConfigAdded?: (
    { _id: any }
    & TimingServiceConfigVarsFragment
  ) | null };

export type TimingServiceConfigUpdatedSubscriptionVariables = Exact<{
  timingServiceConfigID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type TimingServiceConfigUpdatedSubscription = { timingServiceConfigUpdated?: (
    { _id: any }
    & TimingServiceConfigVarsFragment
  ) | null };

export type TimingServiceConfigRemovedSubscriptionVariables = Exact<{
  timingServiceConfigID?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type TimingServiceConfigRemovedSubscription = { timingServiceConfigRemoved?: { _id: any } | null };

export type GetPartTrackingForSetupOverviewTableQueryVariables = Exact<{
  partIDs: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetPartTrackingForSetupOverviewTableQuery = { parts?: { items?: Array<{ _id: any, tracking?: Array<{ trackingItemID: any, history: Array<{ _id: any, cumulativeValue?: number | null, date?: any | null, dateResolved?: any | null, value?: number | null, valueString?: string | null }>, trackingItem?: { _id: any, criticalCumulativeValue?: number | null, criticalValue?: number | null, cumulativeCalculation?: boolean | null, displayUnit?: EnumDisplayUnit | null, NDecimals?: number | null, operator?: EnumTrackingItemOperator | null, warningCumulativeValue?: number | null, warningValue?: number | null } | null } | null> | null }> | null } | null };


export const TeamsChampionshipStandingsVarsFragmentDoc = `
    fragment teamsChampionshipStandingsVars on TeamChampionshipStanding {
  contestantIDs
  points
  rank
  team {
    name
  }
  teamID
}
    `;
export const SessionInfoForSessionsListFragmentDoc = `
    fragment SessionInfoForSessionsList on Session {
  _id
  name
  shortName
  tSessionStart
  tSessionEnd
  prevSessionID
  nextSessionID
  isLinkedSession
  bopID
}
    `;
export const PersonVarsForAdminPageFragmentDoc = `
    fragment PersonVarsForAdminPage on Person {
  _id
  acronym
  email
  isActive
  name
  role
  username
}
    `;
export const Tracks_TrackLayoutMapDataFragmentDoc = `
    fragment tracks_trackLayoutMapData on TrackLayout {
  _id
  mapTrackXy {
    warnings
    keyValueData {
      key
      value
    }
    sectorPositions
    svg {
      width
      height
      svgPath
    }
    labels {
      alignment
      name
      x
      y
    }
    coordinates {
      distance
      time
      x
      y
    }
  }
  mapTrackLatLon {
    warnings
    keyValueData {
      key
      value
    }
    sectorPositions
    svg {
      width
      height
      svgPath
    }
    labels {
      alignment
      name
      x
      y
    }
    coordinates {
      distance
      time
      x
      y
    }
  }
}
    `;
export const ChassisAssemblyForEditAssemblyFixFragmentDoc = `
    fragment ChassisAssemblyForEditAssemblyFix on ChassisAssembly {
  chassisPartID
  assemblyTemplateID
  __typename
  location {
    _id
  }
  locationID
  carSetupID
  carSetup {
    runSheetID
  }
  nestedPartInstances {
    _id
    readingLocation
    specificationID
    superParentID
    part {
      _id
      reference
      specification {
        name
      }
      userEnumPartTypeID
    }
    partID
  }
  nestedPartInstanceIDs
  partInstances {
    _id
    readingLocation
    specificationID
    superParentID
    part {
      _id
      reference
      specification {
        name
      }
      userEnumPartTypeID
    }
    partID
  }
  partInstanceIDs
  subAssemblies {
    ... on SubAssembly {
      _id
      chassisSpecID
      name
      reference
    }
  }
  subAssemblyIDs
  tagIDs
  tags {
    _id
  }
}
    `;
export const SubAssemblyTableVarsFragmentDoc = `
    fragment SubAssemblyTableVars on SubAssembly {
  _id
  name
  chassisSpecID
  reference
  subAssemblies {
    _id
    name
  }
}
    `;
export const ChassisAssemblyVarsForAssemblyPageFragmentDoc = `
    fragment ChassisAssemblyVarsForAssemblyPage on ChassisAssembly {
  _id
  trackingSourceRecords {
    sources {
      trackingSourceAliasID
      value
    }
    trackingSource {
      _id
      chassisSpecID
      displayUnit
      isDefault
      name
      NDecimals
      sourceIDs
      sources {
        _id
        aliasString
        aliasType
        displayUnit
      }
    }
    trackingSourceID
    value
  }
}
    `;
export const ChassisTrackingSourceVarsForAssemblyPageFragmentDoc = `
    fragment ChassisTrackingSourceVarsForAssemblyPage on TrackingSource {
  name
  chassisSpecID
  displayUnit
  isDefault
  sourceIDs
  _id
  sources {
    aliasType
    aliasString
    displayUnit
    _id
  }
}
    `;
export const ChassisSpecVarsForAssemblyPageFragmentDoc = `
    fragment ChassisSpecVarsForAssemblyPage on ChassisSpec {
  trackingSourceIDs
  trackingSources {
    ...ChassisTrackingSourceVarsForAssemblyPage
  }
}
    `;
export const GetDataOverviewAssembliesAdvancedFilterItemFragmentDoc = `
    fragment GetDataOverviewAssembliesAdvancedFilterItem on BaseAssembly {
  __typename
  _id
  allPartInstanceActive
  chassisSpecName
  chassisSpecID
  name
  reference
  runSheetName
  type
  parentID
}
    `;
export const AnyAssemblyForAssemblyEditPageVarsFragmentDoc = `
    fragment AnyAssemblyForAssemblyEditPageVars on AnyAssembly {
  _id
  __typename
  assemblyTemplateID
  chassisSpecID
  current
  decommissioned
  name
  reference
  userEnumAssemblyTypeID
}
    `;
export const ChassisAssemblyForAssemblyEditPageVarsFragmentDoc = `
    fragment ChassisAssemblyForAssemblyEditPageVars on ChassisAssembly {
  chassisPartID
  assemblyTemplateID
  __typename
  location {
    _id
  }
  locationID
  carSetupID
  carSetup {
    runSheetID
    runSheet {
      _id
      endTime
    }
  }
  nestedPartInstances {
    _id
    part {
      _id
      reference
      userEnumPartTypeID
    }
    partID
    readingLocation
    specification {
      ... on AnySpecification {
        __typename
        _id
        name
      }
    }
    specificationID
    superParentID
  }
  nestedPartInstanceIDs
  partInstances {
    _id
    readingLocation
    specification {
      ... on AnySpecification {
        __typename
        _id
        name
      }
    }
    specificationID
    superParentID
    part {
      _id
      reference
      specification {
        name
      }
      userEnumPartTypeID
    }
    partID
  }
  partInstanceIDs
  subAssemblies {
    ... on SubAssembly {
      _id
      chassisSpecID
      name
      reference
      partInstanceIDs
      subAssemblyIDs
    }
  }
  subAssemblyIDs
  tagIDs
  tags {
    _id
  }
}
    `;
export const SubAssemblyForAssemblyEditPageVarsFragmentDoc = `
    fragment SubAssemblyForAssemblyEditPageVars on SubAssembly {
  __typename
  assemblyTemplateID
  location {
    _id
  }
  locationID
  parentID
  carSetup {
    runSheetID
    runSheet {
      _id
      endTime
    }
  }
  nestedPartInstances {
    _id
    readingLocation
    specification {
      ... on AnySpecification {
        __typename
        _id
        name
      }
    }
    specificationID
    superParentID
    part {
      _id
      reference
      specification {
        name
      }
      userEnumPartTypeID
    }
    partID
  }
  nestedPartInstanceIDs
  partInstances {
    _id
    readingLocation
    superParentID
    part {
      _id
      reference
      specification {
        name
      }
      userEnumPartTypeID
    }
    partID
    specificationID
    specification {
      ... on AnySpecification {
        _id
        name
      }
    }
  }
  partInstanceIDs
  subAssemblies {
    ... on SubAssembly {
      _id
      chassisSpecID
      name
      reference
      partInstanceIDs
      subAssemblyIDs
    }
  }
  subAssemblyIDs
  tagIDs
  tags {
    _id
  }
}
    `;
export const AssemblyForAssemblyEditPageVarsFragmentDoc = `
    fragment AssemblyForAssemblyEditPageVars on Assembly {
  ... on AnyAssembly {
    ...AnyAssemblyForAssemblyEditPageVars
  }
  ... on ChassisAssembly {
    ...ChassisAssemblyForAssemblyEditPageVars
  }
  ... on SubAssembly {
    ...SubAssemblyForAssemblyEditPageVars
  }
}
    `;
export const PartMileageTrackingForAssemblyPageVarsFragmentDoc = `
    fragment PartMileageTrackingForAssemblyPageVars on Part {
  tracking(trackingItemNames: ["RunDistance"]) {
    trackingItem {
      criticalCumulativeValue
      criticalValue
      cumulativeCalculation
      displayUnit
      NDecimals
      operator
      warningCumulativeValue
      warningValue
    }
    history {
      cumulativeValue
      dateResolved
      value
      valueString
    }
  }
}
    `;
export const PartForAvailablePartsForAssemblyEditPageVarsFragmentDoc = `
    fragment PartForAvailablePartsForAssemblyEditPageVars on Part {
  _id
  partNumber
  readingLocationOverride
  reference
  rootAssemblyIDs
  rootSpecificationID
  specification {
    antiRollBarDisplayLocation
    readingsAllowable
    readingsRequired
    specificationGroupID
  }
  partStatus {
    userEnumPartStatusID
    userEnumPartStatusName
  }
  specificationID
  userEnumPartType {
    ... on UserEnumPartType {
      name
    }
  }
}
    `;
export const SessionVarsForCalendarViewFragmentDoc = `
    fragment SessionVarsForCalendarView on Session {
  shortName
  tSessionEnd
  tSessionStart
  event {
    name
  }
}
    `;
export const SeasonContestantForContextMenuVarsFragmentDoc = `
    fragment SeasonContestantForContextMenuVars on Contestant {
  _id
  chassisNumber
  class
  driverIDs
  drivers {
    _id
    acronym
  }
  hidden
  startNumber
  teamID
}
    `;
export const EventContestantForContextMenuVarsFragmentDoc = `
    fragment EventContestantForContextMenuVars on EventContestants {
  _id
  class
  driverIDs
}
    `;
export const CustomSimulationModelVarsFragmentDoc = `
    fragment CustomSimulationModelVars on SpecificationCustomSimulationModels {
  data
  dataMapping
  endPoint
  name
  serverPort
  version
}
    `;
export const SimResultForSimChannelSearchModalVarsFragmentDoc = `
    fragment SimResultForSimChannelSearchModalVars on SimResult {
  _id
  data {
    channelName
  }
  updatedAt
}
    `;
export const MileageSummaryRunSheetVarsFragmentDoc = `
    fragment MileageSummaryRunSheetVars on RunSheet {
  _id
  contestant {
    _id
    startNumber
    drivers {
      _id
    }
  }
  driver {
    _id
    name
  }
  fastestLap
  lapCount
  mileage
  NRun
  session {
    _id
    name
    shortName
  }
}
    `;
export const AllRunEnergyVarsFragmentDoc = `
    fragment AllRunEnergyVars on RunEnergy {
  ATTACK
  COOL
  FCY
  IN
  OUT
  OUTIN
  PITLANE
  PREP
  PUSH
  QUALI
  SAFETYCAR
  SHAKEDOWN
  SLOW
  TARGET
  TOGRID
  TOPADDOCK
  TOPITS
  UNFINISHED
  attackLap
  coolLap
  fullCourseYellowLap
  inLap
  outInLap
  outLap
  prepLap
  pushLap
  qualiLap
  safetyCarLap
  slowLap
  targetLap
  toGridLap
  toPitsLap
  unfinishedLap
}
    `;
export const TrackLayoutVarsFragmentDoc = `
    fragment TrackLayoutVars on TrackLayout {
  _id
  trackID
  name
  NSectorsTiming
  lapLengthOfficial
  lapLengthCarData
  lapLengthRoulette
  lapLengthInLapCarData
  lapLengthInLapOfficial
  lapLengthInLapRoulette
  lapLengthOutLapCarData
  lapLengthOutLapOfficial
  lapLengthOutLapRoulette
  sectorDistance
  trackRecordQuali
  trackRecordRace
  direction
  polePosition
  lapZero
  overtakingThreshold
  bumpiness
  SCProbability
  FCYProbability
  trackEvolution
  lapsUntilFullRegen
  expectedRaceLaps
  ATKModePenalty
  ATKModeGain
  ATKModeLocation
  firstLapOffset
  outLapTime
  prepLapTime
  pushLapTime
  inLapTime
  SCLapTime
  FCYLapTime
  code60LapTime
  crossoverWetToSlick
  sensMass
  sensGrip
  sensDownforce
  sensDrag
  sensPower
  sensEnergy
  sensEP
  pitDistance
  pitLength
  pitLoss
  pitLossDriveThrough
  mapPitLane
  mapEmergencyExits
  mapElevation
  track {
    _id
    name
    trackPicture {
      id
      name
      mimeType
      url
      thumbnailUrl
    }
    timeZone
  }
  fuelRequired {
    ...AllRunEnergyVars
  }
  SoCRequired {
    ...AllRunEnergyVars
  }
  energyRequired {
    ...AllRunEnergyVars
  }
}
    `;
export const SimResultVarsForSimManagerListFragmentDoc = `
    fragment SimResultVarsForSimManagerList on SimResult {
  carSetupID
  trackLayoutID
  specificationID
  runSheetID
  source
  simulationService
  version
  sourceReferenceID
  simType
  TAmbient
  pAmbient
  rHumidity
  carSetupModifiedAt
  refValues
  defaultChannelTime
  carSetup {
    _id
    title
  }
  requesterID
  status
  statusMessage
  _id
  updatedAt
  createdAt
  isCarSetupChanged
  trackLayout {
    _id
    ...TrackLayoutVars
  }
  requester {
    _id
    name
    username
  }
}
    `;
export const RunSheetForAddButtonVarsFragmentDoc = `
    fragment RunSheetForAddButtonVars on RunSheet {
  _id
  NRun
  NRunTiming
  sessionID
  selectedJobListTemplateID
}
    `;
export const ChassisMeasurementVarsFragmentDoc = `
    fragment ChassisMeasurementVars on ChassisMeasurements {
  angles
  angularCompliances
  angularTorqueCompliances
  bumpPlateMeasurementMethod
  bumpPlateRefFront
  bumpPlateRefRear
  compliances
  forces
  inertias
  inverseCamber
  kinematicsExternalReadingsRequired
  kinematicsInternalReadingsRequired
  lengths
  masses
  powers
  pressures
  ratios
  rideHeightCalcFront
  rideHeightCalcRear
  springRates
  steeringRackRatios
  temperatures
  toeMeasurementMethod
  toeRefFront
  toeRefRear
  toeTotal
  torques
  torsionRates
  volumes
  xTrackFront
  xTrackRear
  xWheelbase
}
    `;
export const ChassisSpecVarsForDisplayChangesFragmentDoc = `
    fragment ChassisSpecVarsForDisplayChanges on ChassisSpec {
  _id
  __typename
  measurements {
    ...ChassisMeasurementVars
  }
}
    `;
export const PartInstanceForMeasurementFieldVarsFragmentDoc = `
    fragment PartInstanceForMeasurementFieldVars on PartInstance {
  _id
  specificationID
  specificationGroupID
  readingLocation
  measurements {
    coordinates {
      x
      y
      z
    }
    rotation {
      I
      J
      K
    }
    idx
    value
    floatValue
    stringValue
    booleanValue
  }
}
    `;
export const AdjustableAccelerationPropertyVarsFragmentDoc = `
    fragment AdjustableAccelerationPropertyVars on AdjustableAccelerationProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableAcceleration {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableAnglePropertyVarsFragmentDoc = `
    fragment AdjustableAnglePropertyVars on AdjustableAngleProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableAngle {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableAngularCompliancePropertyVarsFragmentDoc = `
    fragment AdjustableAngularCompliancePropertyVars on AdjustableAngularComplianceProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableAngularCompliance {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc = `
    fragment AdjustableAngularTorqueCompliancePropertyVars on AdjustableAngularTorqueComplianceProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableAngularTorqueCompliance {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableBooleanPropertyVarsFragmentDoc = `
    fragment AdjustableBooleanPropertyVars on AdjustableBooleanProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableBoolean {
    defaultValue
  }
}
    `;
export const AdjustableCompliancePropertyVarsFragmentDoc = `
    fragment AdjustableCompliancePropertyVars on AdjustableComplianceProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableCompliance {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableForcePropertyVarsFragmentDoc = `
    fragment AdjustableForcePropertyVars on AdjustableForceProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableForce {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableInertiaPropertyVarsFragmentDoc = `
    fragment AdjustableInertiaPropertyVars on AdjustableInertiaProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableInertia {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableLengthPropertyVarsFragmentDoc = `
    fragment AdjustableLengthPropertyVars on AdjustableLengthProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableLength {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableLocationPropertyVarsFragmentDoc = `
    fragment AdjustableLocationPropertyVars on AdjustableLocationProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableLocation {
    coordinates {
      x
      y
      z
    }
  }
}
    `;
export const AdjustableMassPropertyVarsFragmentDoc = `
    fragment AdjustableMassPropertyVars on AdjustableMassProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableMass {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableNumberPropertyVarsFragmentDoc = `
    fragment AdjustableNumberPropertyVars on AdjustableNumberProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableNumber {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableOrientationPropertyVarsFragmentDoc = `
    fragment AdjustableOrientationPropertyVars on AdjustableOrientationProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableOrientation {
    rotation {
      I
      J
      K
    }
  }
}
    `;
export const AdjustablePowerPropertyVarsFragmentDoc = `
    fragment AdjustablePowerPropertyVars on AdjustablePowerProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustablePower {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustablePressurePropertyVarsFragmentDoc = `
    fragment AdjustablePressurePropertyVars on AdjustablePressureProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustablePressure {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableRatioPropertyVarsFragmentDoc = `
    fragment AdjustableRatioPropertyVars on AdjustableRatioProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableRatio {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableSpringRatePropertyVarsFragmentDoc = `
    fragment AdjustableSpringRatePropertyVars on AdjustableSpringRateProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableSpringRate {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableSteeringRackRatioPropertyVarsFragmentDoc = `
    fragment AdjustableSteeringRackRatioPropertyVars on AdjustableSteeringRackRatioProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableSteeringRackRatio {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableStringPropertyVarsFragmentDoc = `
    fragment AdjustableStringPropertyVars on AdjustableStringProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableString {
    defaultValue
    valueNames
    values
  }
}
    `;
export const AdjustableTemperaturePropertyVarsFragmentDoc = `
    fragment AdjustableTemperaturePropertyVars on AdjustableTemperatureProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableTemperature {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableTorquePropertyVarsFragmentDoc = `
    fragment AdjustableTorquePropertyVars on AdjustableTorqueProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableTorque {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableTorsionRatePropertyVarsFragmentDoc = `
    fragment AdjustableTorsionRatePropertyVars on AdjustableTorsionRateProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableTorsionRate {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const AdjustableVolumePropertyVarsFragmentDoc = `
    fragment AdjustableVolumePropertyVars on AdjustableVolumeProperty {
  index
  __typename
  name
  description
  useInSimulation
  adjustableVolume {
    defaultValue
    maxValue
    minValue
    sign
    step
    unit
    valueNames
    values
  }
}
    `;
export const SpecInfoForMeasurementFieldVarsFragmentDoc = `
    fragment SpecInfoForMeasurementFieldVars on CustomSpec {
  _id
  name
  adjustableProperties {
    ...AdjustableAccelerationPropertyVars
    ...AdjustableAnglePropertyVars
    ...AdjustableAngularCompliancePropertyVars
    ...AdjustableAngularTorqueCompliancePropertyVars
    ...AdjustableBooleanPropertyVars
    ...AdjustableCompliancePropertyVars
    ...AdjustableForcePropertyVars
    ...AdjustableInertiaPropertyVars
    ...AdjustableLengthPropertyVars
    ...AdjustableLocationPropertyVars
    ...AdjustableMassPropertyVars
    ...AdjustableNumberPropertyVars
    ...AdjustableOrientationPropertyVars
    ...AdjustablePowerPropertyVars
    ...AdjustablePressurePropertyVars
    ...AdjustableRatioPropertyVars
    ...AdjustableSpringRatePropertyVars
    ...AdjustableSteeringRackRatioPropertyVars
    ...AdjustableStringPropertyVars
    ...AdjustableTemperaturePropertyVars
    ...AdjustableTorquePropertyVars
    ...AdjustableTorsionRatePropertyVars
    ...AdjustableVolumePropertyVars
  }
  specificationGroupID
  readingsRequired
}
    `;
export const PartInstanceSpecificationForSetupSheetFlexVarsFragmentDoc = `
    fragment PartInstanceSpecificationForSetupSheetFlexVars on Specification {
  ... on AnySpecification {
    __typename
    _id
    rootSpecificationID
  }
  ... on ElasticSpec {
    _id
    elasticType
    hasToBeInSubAssembly
    name
    rootSpecificationID
  }
  ... on CustomSpec {
    _id
    adjustableProperties {
      __typename
      ...AdjustableAccelerationPropertyVars
      ...AdjustableAnglePropertyVars
      ...AdjustableAngularCompliancePropertyVars
      ...AdjustableAngularTorqueCompliancePropertyVars
      ...AdjustableBooleanPropertyVars
      ...AdjustableCompliancePropertyVars
      ...AdjustableForcePropertyVars
      ...AdjustableInertiaPropertyVars
      ...AdjustableLengthPropertyVars
      ...AdjustableLocationPropertyVars
      ...AdjustableMassPropertyVars
      ...AdjustableNumberPropertyVars
      ...AdjustableOrientationPropertyVars
      ...AdjustablePowerPropertyVars
      ...AdjustablePressurePropertyVars
      ...AdjustableRatioPropertyVars
      ...AdjustableSpringRatePropertyVars
      ...AdjustableSteeringRackRatioPropertyVars
      ...AdjustableStringPropertyVars
      ...AdjustableTemperaturePropertyVars
      ...AdjustableTorquePropertyVars
      ...AdjustableTorsionRatePropertyVars
      ...AdjustableVolumePropertyVars
    }
    hasToBeInSubAssembly
    name
    rootSpecificationID
  }
}
    `;
export const ChassisAssemblyForCarSetupAssemblyAssignmentVarsFragmentDoc = `
    fragment ChassisAssemblyForCarSetupAssemblyAssignmentVars on ChassisAssembly {
  _id
  chassisSpecID
  name
  reference
}
    `;
export const SetupSheetStyleBlockTabVarsForSetupSheetFlexFragmentDoc = `
    fragment SetupSheetStyleBlockTabVarsForSetupSheetFlex on SetupSheetStyleTab {
  groups {
    header
    rows {
      items {
        _id
        alignment
        backgroundColor
        colSpan
        decimals
        fieldKey
        label
        restrictedToRoles
        widthRatio
        type
      }
      _id
    }
    _id
  }
  massConfig {
    massOption
    showMinWeightFromSpec
  }
  mileageConfig {
    showManualInput
  }
  rows {
    items {
      _id
      alignment
      backgroundColor
      colSpan
      fieldKey
      label
      restrictedToRoles
      type
      widthRatio
    }
    _id
  }
  title
  type
}
    `;
export const SetupSheetStyleBlockVarsForSetupSheetFlexFragmentDoc = `
    fragment SetupSheetStyleBlockVarsForSetupSheetFlex on SetupSheetStyleBlock {
  _id
  backgroundColor
  borderColor
  height
  tabs {
    ...SetupSheetStyleBlockTabVarsForSetupSheetFlex
  }
  width
  x
  y
}
    `;
export const ChassisMeasurementPointVarsFragmentDoc = `
    fragment ChassisMeasurementPointVars on ChassisAssemblyMeasurement {
  chassisSpecMeasurementID
  location {
    coordinates {
      x
      y
      z
    }
  }
  orientation {
    rotation {
      I
      J
      K
    }
  }
}
    `;
export const PartForSetupSheetFlexVarsFragmentDoc = `
    fragment PartForSetupSheetFlexVars on Part {
  _id
  chassisSpecName
  createdAt
  description
  displayName
  eligibleEventTypes
  lifetimeMileage
  manufacturerID
  manufacturerPartID
  manufacturerSerialNumber
  notes
  partNumber
  properties
  reference
  teamID
  updatedAt
  userEnumPartTypeID
}
    `;
export const PartInstancesForSetupSheetFlexVarsFragmentDoc = `
    fragment PartInstancesForSetupSheetFlexVars on PartInstance {
  _id
  measurements {
    coordinates {
      x
      y
      z
    }
    rotation {
      I
      J
      K
    }
    idx
    floatValue
    booleanValue
    stringValue
    value
  }
  parentID
  part {
    ...PartForSetupSheetFlexVars
  }
  partID
  readingLocation
  specification {
    ... on AnySpecification {
      __typename
      _id
      rootSpecificationID
    }
    ... on CustomSpec {
      name
    }
  }
  specificationID
  specificationGroupID
  trackingItemReferenceDate
}
    `;
export const ChassisAssemblyForFlexSetupVarsFragmentDoc = `
    fragment ChassisAssemblyForFlexSetupVars on ChassisAssembly {
  _id
  chassisMeasurements {
    ...ChassisMeasurementPointVars
  }
  chassisSpecID
  name
  nestedPartInstances {
    ...PartInstancesForSetupSheetFlexVars
  }
  nestedPartInstanceIDs
  partInstanceIDs
  reference
  trackingSourceRecords {
    value
    sources {
      value
      trackingSourceAliasID
    }
    trackingSourceID
  }
}
    `;
export const AntiRollBarVarsForSetupSheetFlexFragmentDoc = `
    fragment AntiRollBarVarsForSetupSheetFlex on AntiRollBar {
  kARB
  name
  position1
  position2
  specificationID
  specification {
    name
    antiRollBarConfigs {
      position1
      position2
    }
  }
}
    `;
export const ElasticSpecForSetupSheetFlexVarsFragmentDoc = `
    fragment ElasticSpecForSetupSheetFlexVars on ElasticSpec {
  _id
  kSpring
  name
  xFree
}
    `;
export const BumpStopVarsForSetupSheetFlexFragmentDoc = `
    fragment BumpStopVarsForSetupSheetFlex on BumpStop {
  name
  specificationID
  specification {
    ...ElasticSpecForSetupSheetFlexVars
  }
  xBumpStopGap
}
    `;
export const DroopStopVarsForSetupSheetFlexFragmentDoc = `
    fragment DroopStopVarsForSetupSheetFlex on DroopStop {
  specificationID
  specification {
    ...ElasticSpecForSetupSheetFlexVars
  }
  xDroopStopGap
}
    `;
export const ExternalBumpStopVarsForSetupSheetFlexFragmentDoc = `
    fragment ExternalBumpStopVarsForSetupSheetFlex on ExternalBumpStop {
  specificationID
  specification {
    ...ElasticSpecForSetupSheetFlexVars
  }
  xExternalBumpStopGap
}
    `;
export const KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc = `
    fragment KinematicsExternalSpecVarsForSetupSheetFlex on KinematicsExternalSpec {
  _id
  name
}
    `;
export const KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc = `
    fragment KinematicsInternalSpecVarsForSetupSheetFlex on KinematicsInternalSpec {
  _id
  name
}
    `;
export const SpringVarsForSetupSheetFlexFragmentDoc = `
    fragment SpringVarsForSetupSheetFlex on Spring {
  specificationID
  xSecondSpringTransition
  xSpringPreload
  specification {
    ...ElasticSpecForSetupSheetFlexVars
  }
}
    `;
export const EndVarsForSetupSheetFlexFragmentDoc = `
    fragment EndVarsForSetupSheetFlex on CarEnd {
  aCamber
  aCamberMeasurement
  aCaster
  aCasterMeasurement
  aToe
  aToeMeasurement
  hRide
  hRideChassis
  hRideMeasurement
  hRideRegulation
  xToe
  xToeMeasurement
  antiRollBar {
    ...AntiRollBarVarsForSetupSheetFlex
  }
  bumpStop {
    ...BumpStopVarsForSetupSheetFlex
  }
  damper {
    adjusters {
      _id
      name
      settingName
      value
    }
    specification {
      _id
      name
      damperAdjusters {
        name
      }
    }
    specificationID
  }
  droopStop {
    ...DroopStopVarsForSetupSheetFlex
  }
  externalBumpStop {
    ...ExternalBumpStopVarsForSetupSheetFlex
  }
  kinematicsExternalSpec {
    ...KinematicsExternalSpecVarsForSetupSheetFlex
  }
  kinematicsExternalSpecID
  kinematicsInternalSpec {
    ...KinematicsInternalSpecVarsForSetupSheetFlex
  }
  kinematicsInternalSpecID
  helperSpring {
    ...SpringVarsForSetupSheetFlex
  }
  reboundSpring {
    ...SpringVarsForSetupSheetFlex
  }
  spring {
    ...SpringVarsForSetupSheetFlex
  }
}
    `;
export const CornerVarsForSetupSheetFlexFragmentDoc = `
    fragment CornerVarsForSetupSheetFlex on CarCorner {
  aCamber
  aCamberMeasurement
  aCaster
  aCasterMeasurement
  aToe
  aToeMeasurement
  hRide
  hRideChassis
  hRideMeasurement
  hRideRegulation
  pTyreTarget
  xToe
  xToeMeasurement
  bumpStop {
    ...BumpStopVarsForSetupSheetFlex
  }
  damper {
    adjusters {
      _id
      name
      settingName
      value
    }
    specification {
      _id
      name
      damperAdjusters {
        name
      }
    }
    specificationID
  }
  droopStop {
    ...DroopStopVarsForSetupSheetFlex
  }
  externalBumpStop {
    ...ExternalBumpStopVarsForSetupSheetFlex
  }
  helperSpring {
    ...SpringVarsForSetupSheetFlex
  }
  reboundSpring {
    ...SpringVarsForSetupSheetFlex
  }
  spring {
    ...SpringVarsForSetupSheetFlex
  }
}
    `;
export const MassVarsFragmentDoc = `
    fragment MassVars on CarMass {
  mCarFL
  mCarFR
  mCarRL
  mCarRR
  mCarTotal
  rCarCross
  rWeightF
  rWeightFTarget
}
    `;
export const PowerTrainVarsForSetupSheetFlexFragmentDoc = `
    fragment PowerTrainVarsForSetupSheetFlex on Powertrain {
  bevelSet {
    specification {
      name
    }
    specificationID
  }
  dropGear {
    specification {
      name
    }
    specificationID
  }
  differentialSpecID
  MDiffPreloadCold
  MDiffPreloadHot
  differentialConfigName
  gears {
    gearNumber
    specificationID
  }
}
    `;
export const RunSheetContextForSetupSheetVarsFragmentDoc = `
    fragment RunSheetContextForSetupSheetVars on RunSheet {
  _id
  contestant {
    chassis {
      _id
      reference
    }
    startNumber
  }
  driver {
    acronym
  }
  endTime
  info
  NRun
  prevRunSheetID
  session {
    event {
      name
      NEventSeason
      tEventEnd
      tEventStart
      trackLayouts {
        name
        track {
          name
        }
      }
      _id
      type
    }
    _id
    name
    sessionType
    shortName
    tSessionEnd
    tSessionStart
  }
  sessionID
  setupID
  startTime
  teamID
  weather {
    TAir
    TTrack
    rHumidity
    pAmbient
  }
}
    `;
export const CarSetupVarsForSetupSheetFlexFragmentDoc = `
    fragment CarSetupVarsForSetupSheetFlex on CarSetup {
  _id
  aeroPackage {
    specificationID
    aeroElements {
      position
      positionName
      specificationID
      specification {
        name
      }
    }
  }
  chassis {
    reference
  }
  chassisID
  chassisAssemblyID
  chassisAssembly {
    ...ChassisAssemblyForFlexSetupVars
  }
  chassisSpecID
  chassisSpecRootID
  contestantID
  createdAt
  custom
  customSimulationPayload
  customSimulationPayloadEnabled
  driver {
    acronym
  }
  engineer {
    name
  }
  engineerID
  front {
    ...EndVarsForSetupSheetFlex
  }
  frontLeft {
    ...CornerVarsForSetupSheetFlex
  }
  frontRight {
    ...CornerVarsForSetupSheetFlex
  }
  info {
    setupComments
    tyreCompound
  }
  lastModifiedBy {
    name
  }
  isLocked
  manualEndMileage
  manualStartMileage
  massOutOfGarage {
    ...MassVars
  }
  massRegulation {
    ...MassVars
  }
  massSetup {
    ...MassVars
  }
  massTeam {
    ...MassVars
  }
  mBallasts
  powertrainCentral {
    ...PowerTrainVarsForSetupSheetFlex
  }
  powertrainFront {
    ...PowerTrainVarsForSetupSheetFlex
  }
  powertrainRear {
    ...PowerTrainVarsForSetupSheetFlex
  }
  rear {
    ...EndVarsForSetupSheetFlex
  }
  rearLeft {
    ...CornerVarsForSetupSheetFlex
  }
  rearRight {
    ...CornerVarsForSetupSheetFlex
  }
  runSheet {
    ...RunSheetContextForSetupSheetVars
  }
  runSheetID
  setupInfo
  teamID
  title
  time
  updatedAt
}
    `;
export const PartTrackingVarsForSetupSheetFlexFragmentDoc = `
    fragment PartTrackingVarsForSetupSheetFlex on TrackingEntry {
  trackingItemID
  trackingItem {
    _id
    name
    description
    trackingSource {
      name
      displayUnit
      NDecimals
    }
    criticalCumulativeValue
    criticalValue
    cumulativeCalculation
    displayUnit
    operator
    warningCumulativeValue
    warningValue
  }
  snapshot {
    cumulativeValue
    dateResolved
    type
    value
    valueString
  }
}
    `;
export const TyreMileageAtSessionStartVarsFragmentDoc = `
    fragment TyreMileageAtSessionStartVars on TyreMileageAtSessionStartData {
  sessionID
  startMileage
  endMileage
  runs {
    runSheetID
    startMileage
    endMileage
  }
}
    `;
export const RunPlanForEventTyreMileageContextVarsFragmentDoc = `
    fragment RunPlanForEventTyreMileageContextVars on RunPlan {
  _id
  runs {
    NRun
    lapSequence {
      NLap
      lapType
    }
    tyreSetID
  }
  sessionID
  session {
    event {
      season {
        raceSeries {
          name
        }
        name
      }
      name
      trackLayouts {
        _id
        name
        lapLengthInLapCarData
        lapLengthInLapOfficial
        lapLengthInLapRoulette
        lapLengthOfficial
        lapLengthCarData
        lapLengthRoulette
        lapLengthOutLapCarData
        lapLengthOutLapOfficial
        lapLengthOutLapRoulette
        pitDistance
      }
    }
    name
    shortName
  }
  title
}
    `;
export const RunSheetForEventTyreMileageContextVarsFragmentDoc = `
    fragment RunSheetForEventTyreMileageContextVars on RunSheet {
  NRun
  NRunTiming
  mileage
}
    `;
export const BrakeForRunSheetOverviewVarsFragmentDoc = `
    fragment BrakeForRunSheetOverviewVars on RunBrake {
  TBrakePreRun
  TBrakePostRun
  hBrakeDiscPreRun
  thicknessMeasurements
}
    `;
export const BrakeMeasurementForRunSheetOverviewVarsFragmentDoc = `
    fragment BrakeMeasurementForRunSheetOverviewVars on RunSheet {
  brakePostRunMeasurementsFL
  brakePostRunMeasurementsFR
  brakePostRunMeasurementsRL
  brakePostRunMeasurementsRR
  brakePreRunMeasurementsFL
  brakePreRunMeasurementsFR
  brakePreRunMeasurementsRL
  brakePreRunMeasurementsRR
}
    `;
export const RunCommentVarsFragmentDoc = `
    fragment RunCommentVars on RunSheet {
  _id
  brakeComment
  controlsComment
  dilComments
  driverComments
  engineerComments
  problemComments
  runDescription
  skidComment
  systemsComments
  tyreComments
}
    `;
export const AeroVarsFragmentDoc = `
    fragment AeroVars on Aero {
  aFlapF
  aFlapFL
  aFlapFR
  NFlapFL
  NFlapFR
  NFlapR
  aFlapR
  aeroPackage
  hSplitterF
  aSplitterF
  frontFlapType
  hGurneyF
  hGurneyR
  splitterID
  noseID
  tailID
  floorLeadingEdgeID
  floorBB
  floorGurney
  frontWheelArch
  lowerDrivePlane
  upperDrivePlane
  Z400
  rearWingGurney
  tailGurney
}
    `;
export const BrakeSystemVarsFragmentDoc = `
    fragment BrakeSystemVars on BrakeSystem {
  brakePedalPosition
  rBrakePedal
  masterCylinderFSpec
  masterCylinderRSpec
  brakePadFManufacturer
  brakePadFSpec
  brakePadRManufacturer
  brakePadRSpec
  rBrakeF
}
    `;
export const InfoVarsFragmentDoc = `
    fragment InfoVars on CarInfo {
  batteryID
  gearboxID
  engineID
  inverterID
  driveshaftID
  setupComments
  NIssue
  tyreCompound
  customIDs
}
    `;
export const PowertrainVarsFragmentDoc = `
    fragment PowertrainVars on Powertrain {
  aDiffRampCoast
  aDiffRampDrive
  bevelSet {
    specification {
      name
    }
    specificationID
  }
  clutch
  clutchCylinder
  dAirRestrictor
  differentialConfigName
  differentialSpec {
    _id
    differentialConfigs {
      decommissioned
      frictionFaces
      maxPreloadForce
      name
      rampAccel
      rampDecel
    }
  }
  differentialSpecID
  dropGear {
    specification {
      name
    }
    specificationID
  }
  engineBlankingDetails
  frictionFaces
  gearboxGridType
  gears {
    gearNumber
    specification {
      denominator
      name
      numerator
    }
    specificationID
  }
  hEngineBlanking
  hGearboxBlanking
  MDiffPreloadCold
  MDiffPreloadHot
  NEngineBlanking
  NFrictionFaces
  PPowerLevel
  rBevelSet
  rDropGear
  rEngineBlanking
  rGearRatios
}
    `;
export const SteeringVarsFragmentDoc = `
    fragment SteeringVars on Steering {
  rSteerF
  steeringArm
  steeringPinion
}
    `;
export const CarSetupVarsForKpiViewBaseFragmentDoc = `
    fragment CarSetupVarsForKpiViewBase on CarSetup {
  _id
  aero {
    ...AeroVars
  }
  aeroPackage {
    aeroElements {
      position
      positionName
      specificationID
      specification {
        name
      }
    }
    specificationID
    specification {
      name
    }
  }
  brakeSystem {
    ...BrakeSystemVars
  }
  chassis {
    reference
    type
    rootAssemblyIDs
    rootSpecificationID
    specificationID
    setupSheetStyle
    setupOptions
    systemsConfigFields
    ballastPositions
    decommissioned
    concurrentUseAllowed
    currentlyInUse
    manufacturerPartID
    notes
    properties
    tagIDs
    _id
  }
  chassisID
  chassisAssemblyID
  chassisAssembly {
    ...ChassisAssemblyForFlexSetupVars
  }
  chassisSpecID
  chassisSpecRootID
  contestantID
  createdAt
  custom
  customSimulationPayload
  customSimulationPayloadEnabled
  driver {
    _id
    acronym
  }
  driverID
  engineer {
    _id
    name
  }
  engineerID
  front {
    ...EndVarsForSetupSheetFlex
  }
  frontLeft {
    ...CornerVarsForSetupSheetFlex
  }
  frontRight {
    ...CornerVarsForSetupSheetFlex
  }
  info {
    ...InfoVars
    setupComments
    tyreCompound
  }
  isLocked
  lastModifiedBy {
    name
  }
  manualEndMileage
  manualStartMileage
  massOutOfGarage {
    ...MassVars
  }
  massRegulation {
    ...MassVars
  }
  massSetup {
    ...MassVars
  }
  massTeam {
    ...MassVars
  }
  mBallasts
  powertrain {
    ...PowertrainVars
  }
  powertrainFront {
    ...PowertrainVars
  }
  powertrainCentral {
    ...PowertrainVars
  }
  powertrainRear {
    ...PowertrainVars
  }
  rear {
    ...EndVarsForSetupSheetFlex
  }
  rearLeft {
    ...CornerVarsForSetupSheetFlex
  }
  rearRight {
    ...CornerVarsForSetupSheetFlex
  }
  runSheet {
    ...RunSheetContextForSetupSheetVars
  }
  runSheetID
  setupInfo
  setupSheetStyle
  steering {
    ...SteeringVars
  }
  systemsConfigValues
  teamID
  time
  title
  updatedAt
}
    `;
export const CarSetupVarsForKpiViewLiveFragmentDoc = `
    fragment CarSetupVarsForKpiViewLive on CarSetup {
  ...CarSetupVarsForKpiViewBase
  chassisSpec {
    _id
    updatedAt
  }
}
    `;
export const SimResultForRunSheetOverviewVarsFragmentDoc = `
    fragment SimResultForRunSheetOverviewVars on SimResult {
  _id
  createdAt
  name
  refValues
  requesterID
  runSheetID
  simType
  simulationDriveFile {
    name
  }
  simulationDriveFileID
  status
  updatedAt
}
    `;
export const RunTyreForRunSheetOverviewVarsFragmentDoc = `
    fragment RunTyreForRunSheetOverviewVars on RunTyre {
  hTyreTread
  mileagePreRun
  pTyre
  pTyreMinStartRun
  pTyrePostRun
  pTyrePostRunBleed
  pTyrePreRunBleed
  pTyreReference
  pTyreSetDown
  pTyreStartRun
  pTyreTarget
  TTrackReference
  TTyre
  TTyreParcFermeExpected
  TTyrePostRun
  TTyrePostRunBleed
  TTyrePreRunBleed
  TTyreReference
  TTyreSetdown
  TTyreSurface
  tyreID
}
    `;
export const WeatherForRunSheetOverviewVarsFragmentDoc = `
    fragment WeatherForRunSheetOverviewVars on WeatherData {
  time
  TAir
  TAirMin
  TAirMax
  TAirExpected
  TAmbient
  TAirOfficial
  TTrack
  TTrackExpected
  TTrackOfficial
  TWindChill
  TDewPoint
  aWind
  vWind
  vWindAverage
  vWindPeak
  rHumidity
  globalRadiation
  pAmbient
  trackCondition
  ambientCondition
  aWindMain
  TInternal
  VBattery
  rainProbability
  rainIntensity
  DAir
}
    `;
export const RunSheetForOverviewFragmentDoc = `
    fragment RunSheetForOverview on RunSheet {
  _id
  associatedKpiFiles
  brakeComment
  brakeFL {
    ...BrakeForRunSheetOverviewVars
  }
  brakeFR {
    ...BrakeForRunSheetOverviewVars
  }
  brakeRL {
    ...BrakeForRunSheetOverviewVars
  }
  brakeRR {
    ...BrakeForRunSheetOverviewVars
  }
  ...BrakeMeasurementForRunSheetOverviewVars
  chassisAssemblyID
  consumptions {
    trackLayoutID
    trackLayout {
      _id
      name
      track {
        _id
        name
      }
    }
    energyRequired {
      ...AllRunEnergyVars
    }
    fuelRequired {
      ...AllRunEnergyVars
    }
    SoCRequired {
      ...AllRunEnergyVars
    }
  }
  contestantID
  contestant {
    _id
    color
    startNumber
  }
  createdAt
  dataServiceFileNameOverride
  DFuel
  driverID
  driver {
    _id
    acronym
    name
  }
  engineerID
  engineer {
    _id
    name
  }
  endTime
  fastestLap
  fuelDrainedBeforeRun
  info
  isLocked
  kpiFileName
  kpiStatus
  kpiUpdatedAt
  lapCount
  lastModifiedBy {
    _id
    name
  }
  mFuelAdded
  mFuelDrainedCatchTank
  mFuelDrainedMainTank
  mFuelRunEnd
  mFuelRunStart
  mileage
  nextRunSheetID
  NRun
  NRunTiming
  ...RunCommentVars
  prevRunSheetID
  sessionID
  session {
    _id
    name
    shortName
    event {
      _id
      contestants {
        _id
        drivers {
          _id
          acronym
          name
        }
      }
      name
      season {
        name
        raceSeries {
          _id
          name
        }
      }
      track {
        name
        timeZone
      }
      trackLayouts {
        _id
        lapLengthOfficial
        name
        NSectorsTiming
      }
    }
    eventID
    tSessionEnd
    tSessionStart
  }
  setupID
  setup {
    ...CarSetupVarsForKpiViewLive
  }
  simResultIDs
  simResults {
    ...SimResultForRunSheetOverviewVars
  }
  startTime
  team {
    name
  }
  teamID
  timingServiceShouldIgnore
  tyreFL {
    ...RunTyreForRunSheetOverviewVars
  }
  tyreFR {
    ...RunTyreForRunSheetOverviewVars
  }
  tyreRL {
    ...RunTyreForRunSheetOverviewVars
  }
  tyreRR {
    ...RunTyreForRunSheetOverviewVars
  }
  tyreSetID
  tyreSet {
    name
    number
    comment
  }
  updatedAt
  weather {
    ...WeatherForRunSheetOverviewVars
  }
}
    `;
export const LapDataVarsFragmentDoc = `
    fragment LapDataVars on LapData {
  _id
  BDRSUsed
  BLapCancelled
  BLapIsSlow
  driverCallout
  driverCallout2
  kpi
  lapType
  mFuelConsumptionThisLap
  mFuelLapEnd
  powerMode
  raceControlMessage
  rEnergyConsumptionThisLap
  rEnergyLapEnd
  rSOCConsumptionThisLap
  rSOCLapEnd
  source
  TCell
  tDay
  tDayPitIn
  tDayPitOut
  tDaySectors
  tInPit
  tLapMax
  trackStates {
    flag
    message
    timestamp
    _id
  }
  tSectors
  tSessionRemainingLapStart
  tyreCompound
  vCarLapMax
  vCarSectors
}
    `;
export const LapNumberVarsFragmentDoc = `
    fragment LapNumberVars on Lap {
  NLapRun
  NLapRunCarData
  NLapRunManual
  NLapSession
  NLapSessionCarData
  NLapSessionManual
  NLapStint
  NLapStintCarData
  NLapStintManual
}
    `;
export const LapForRunSheetOverviewVarsFragmentDoc = `
    fragment LapForRunSheetOverviewVars on Lap {
  _id
  BPitIn
  BPitOut
  data {
    ...LapDataVars
  }
  energyLapStart
  energyRemaining
  energyRemainingData
  fuelConsumptionThisLap
  lapComment
  lapCommentSystems
  ...LapNumberVars
  laptimeServiceHash
  lapType
  mFuelConsumptionThisLap
  mFuelLapEnd
  mFuelLapStart
  position
  powerMode
  raceControlMessage
  rEnergyConsumptionThisLap
  rEnergyLapEnd
  rEnergyLapStart
  rSOCConsumptionThisLap
  rSOCLapEnd
  rSOCLapStart
  TCell
  tDay
  tDayPitIn
  tDayPitOut
  tLapManual
  tLapMax
  trackLayout {
    _id
    name
    lapLengthOfficial
    lapLengthCarData
    lapLengthRoulette
    NSectorsTiming
  }
  trackLayoutID
  tSectorsManual
  tSectorsOfficial
  tSectorsTiming
  tyreCompoundTiming
  vCarLapMax
  vCarSectors
}
    `;
export const AllKpiRunSheetDataFragmentDoc = `
    fragment AllKPIRunSheetData on RunSheet {
  ...RunSheetForOverview
  runKPI
  laps {
    ...LapForRunSheetOverviewVars
    lapKPI
  }
}
    `;
export const CalculationVarsFragmentDoc = `
    fragment CalculationVars on Calculation {
  _id
  debugMode
  displayUnit
  functionString
  isActive
  name
  parameter
  trigger
  type
  version
}
    `;
export const SetupSheetStyleForFlexSetupFragmentDoc = `
    fragment SetupSheetStyleForFlexSetup on SetupSheetStyle {
  _id
  name
  type
  targetRoles
  targetUserIDs
}
    `;
export const SpecificationGroupVariablesFragmentDoc = `
    fragment SpecificationGroupVariables on SpecificationGroup {
  _id
  name
  description
  specifications {
    _id
    name
    readingsRequired
  }
}
    `;
export const ChassisSpecVarsForSetupSheetFlexFragmentDoc = `
    fragment ChassisSpecVarsForSetupSheetFlex on ChassisSpec {
  aeroPackageSpecs {
    __typename
    _id
    aeroElementSpecs {
      _id
      allowableSockets
      hasToBeInSubAssembly
      name
      rootSpecificationID
    }
    aeroElementSpecIDs
    hasToBeInSubAssembly
    name
    rootSpecificationID
  }
  aeroPackageSpecIDs
  antiRollBarSpecs {
    __typename
    _id
    antiRollBarDisplayLocation
    hasToBeInSubAssembly
    name
    rootSpecificationID
  }
  antiRollBarSpecIDs
  buildSheetStyles {
    _id
  }
  bumpRubberSpecs {
    __typename
    _id
    allowableSockets
    elasticType
    hasToBeInSubAssembly
    name
    readingsAllowable
    rootSpecificationID
  }
  bumpRubberSpecIDs
  calculations {
    ...CalculationVars
  }
  canopyVersion
  customSimulationModels {
    name
    version
  }
  customSpecs {
    __typename
    _id
    adjustableProperties {
      __typename
      ...AdjustableAccelerationPropertyVars
      ...AdjustableAnglePropertyVars
      ...AdjustableAngularCompliancePropertyVars
      ...AdjustableAngularTorqueCompliancePropertyVars
      ...AdjustableBooleanPropertyVars
      ...AdjustableCompliancePropertyVars
      ...AdjustableForcePropertyVars
      ...AdjustableInertiaPropertyVars
      ...AdjustableLengthPropertyVars
      ...AdjustableLocationPropertyVars
      ...AdjustableMassPropertyVars
      ...AdjustableNumberPropertyVars
      ...AdjustableOrientationPropertyVars
      ...AdjustablePowerPropertyVars
      ...AdjustablePressurePropertyVars
      ...AdjustableRatioPropertyVars
      ...AdjustableSpringRatePropertyVars
      ...AdjustableSteeringRackRatioPropertyVars
      ...AdjustableStringPropertyVars
      ...AdjustableTemperaturePropertyVars
      ...AdjustableTorquePropertyVars
      ...AdjustableTorsionRatePropertyVars
      ...AdjustableVolumePropertyVars
    }
    rootSpecificationID
    specificationGroupID
    readingsRequired
    hasToBeInSubAssembly
    name
  }
  customSpecIDs
  damperSpecs {
    __typename
    _id
    allowableSockets
    hasToBeInSubAssembly
    readingsAllowable
    rootSpecificationID
  }
  damperSpecIDs
  helperSpringSpecs {
    __typename
    _id
    allowableSockets
    elasticType
    hasToBeInSubAssembly
    name
    readingsAllowable
    rootSpecificationID
  }
  helperSpringSpecIDs
  measurements {
    ...ChassisMeasurementVars
  }
  name
  reboundSpringSpecs {
    __typename
    _id
    allowableSockets
    elasticType
    hasToBeInSubAssembly
    name
    readingsAllowable
    rootSpecificationID
  }
  reboundSpringSpecIDs
  released
  releaseDate
  setupChangesFilter {
    blackListFilter
    whiteListFilter
  }
  setupSheetStyleIDs
  setupSheetStyles {
    ...SetupSheetStyleForFlexSetup
  }
  simulationModels
  specificationGroups {
    ...SpecificationGroupVariables
  }
  specificationGroupIDs
  springSpecs {
    __typename
    _id
    allowableSockets
    elasticType
    hasToBeInSubAssembly
    name
    readingsAllowable
    rootSpecificationID
  }
  springSpecIDs
  torsionBarSpecs {
    __typename
    _id
    allowableSockets
    elasticType
    hasToBeInSubAssembly
    name
    readingsAllowable
    rootSpecificationID
  }
  torsionBarSpecIDs
  trackingSources {
    _id
    name
    sources {
      _id
      aliasString
      aliasType
      priority
    }
    sourceIDs
    displayUnit
    NDecimals
  }
  trackingSourceIDs
  version
}
    `;
export const MassPropertiesVarsFragmentDoc = `
    fragment MassPropertiesVars on MassProperties {
  mass
  COGx
  COGy
  COGz
  Ixx
  Iyy
  Izz
}
    `;
export const CustomSpecVarsFragmentDoc = `
    fragment CustomSpecVars on CustomSpec {
  _id
  __typename
  adjustableProperties {
    ...AdjustableAccelerationPropertyVars
    ...AdjustableAnglePropertyVars
    ...AdjustableAngularCompliancePropertyVars
    ...AdjustableAngularTorqueCompliancePropertyVars
    ...AdjustableBooleanPropertyVars
    ...AdjustableCompliancePropertyVars
    ...AdjustableForcePropertyVars
    ...AdjustableInertiaPropertyVars
    ...AdjustableLengthPropertyVars
    ...AdjustableLocationPropertyVars
    ...AdjustableMassPropertyVars
    ...AdjustableNumberPropertyVars
    ...AdjustableOrientationPropertyVars
    ...AdjustablePowerPropertyVars
    ...AdjustablePressurePropertyVars
    ...AdjustableRatioPropertyVars
    ...AdjustableSpringRatePropertyVars
    ...AdjustableSteeringRackRatioPropertyVars
    ...AdjustableStringPropertyVars
    ...AdjustableTemperaturePropertyVars
    ...AdjustableTorquePropertyVars
    ...AdjustableTorsionRatePropertyVars
    ...AdjustableVolumePropertyVars
  }
  allowableParentSpecIDs
  allowableSockets
  chassisSpecID
  createdAt
  decommissioned
  description
  initialChassisSpecID
  iterationIDs
  iterations {
    _id
    name
  }
  manufacturer {
    _id
    name
  }
  manufacturerID
  massProperties {
    ...MassPropertiesVars
  }
  name
  nextIterationID
  prevIterationID
  readingsRequired
  rootSpecificationID
  updatedAt
}
    `;
export const CarSetupVarsForKpiViewFragmentDoc = `
    fragment CarSetupVarsForKpiView on CarSetup {
  ...CarSetupVarsForKpiViewBase
  chassisSpec {
    ...ChassisSpecVarsForSetupSheetFlex
    _id
    updatedAt
    customSpecs {
      ...CustomSpecVars
    }
  }
}
    `;
export const RunSheetForAssemblyLinkingVarsFragmentDoc = `
    fragment RunSheetForAssemblyLinkingVars on RunSheet {
  _id
  contestant {
    startNumber
  }
  info
  NRunTiming
  session {
    _id
    event {
      _id
      name
      season {
        name
        raceSeries {
          name
        }
      }
    }
    shortName
  }
}
    `;
export const ChassisAssemblyForDataCheckPageVarsFragmentDoc = `
    fragment ChassisAssemblyForDataCheckPageVars on ChassisAssembly {
  _id
  reference
  carSetup {
    runSheet {
      contestant {
        startNumber
      }
      chassisAssemblyID
      setupID
      NRun
      NRunTiming
      session {
        name
        shortName
        event {
          name
          season {
            name
            raceSeries {
              name
            }
          }
        }
      }
    }
    runSheetID
  }
  carSetupID
}
    `;
export const IssuesForIssueManagerPageVarsFragmentDoc = `
    fragment IssuesForIssueManagerPageVars on IssueQuery {
  _id
  area
  assignees {
    _id
    name
  }
  carSetupID
  containment
  createdAt
  createdBy {
    name
  }
  department {
    name
  }
  description
  event {
    name
  }
  eventID
  index
  issueStatus
  number
  oneWordStatus
  priority
  raceSeries {
    name
  }
  raceSeriesID
  rootCause
  runSheetID
  season {
    name
  }
  seasonID
  session {
    name
  }
  sessionID
  tags {
    _id
    label
  }
  targetDate
  teams {
    name
  }
  timeInfo
  updatedAt
}
    `;
export const CommentVarsFragmentDoc = `
    fragment CommentVars on Comment {
  _id
  text
  author {
    _id
    name
  }
  createdAt
  updatedAt
}
    `;
export const SubTaskVarsFragmentDoc = `
    fragment SubTaskVars on Job {
  _id
  number
  index
  priority
  updatedAt
  createdAt
  createdBy {
    _id
    name
  }
  assignees {
    _id
    name
  }
  assigneeIDs
  acknowledgedAt
  acknowledgedBy {
    _id
    name
  }
  cancelledBy {
    _id
    name
  }
  cancelledAt
  closedAt
  closedBy {
    _id
    name
  }
  description
  comments {
    _id
    ...CommentVars
  }
  parentID
  runSheetID
}
    `;
export const JobForAllJobsPageVarsFragmentDoc = `
    fragment JobForAllJobsPageVars on Job {
  _id
  acknowledgedBy {
    _id
    name
  }
  acknowledgedAt
  assignees {
    name
  }
  cancelledBy {
    _id
    name
  }
  createdAt
  createdBy {
    _id
    name
  }
  comments {
    _id
    author {
      _id
      name
    }
    createdAt
    updatedAt
    text
  }
  closedAt
  closedBy {
    _id
    name
  }
  description
  oneWordStatus
  parentJob {
    _id
    __typename
  }
  parentIssue {
    _id
    __typename
    description
    number
  }
  parentID
  priority
  runSheet {
    _id
    contestant {
      startNumber
    }
    NRunTiming
    session {
      event {
        name
        season {
          name
          raceSeries {
            name
          }
        }
      }
      name
      shortName
    }
  }
  runSheetID
  subTaskIDs
  subTasks {
    ...SubTaskVars
  }
  updatedAt
}
    `;
export const SpecificationVarsFragmentDoc = `
    fragment SpecificationVars on AnySpecification {
  name
}
    `;
export const PartFieldVarsFragmentDoc = `
    fragment PartFieldVars on ChassisSpec {
  _id
  __typename
  name
}
    `;
export const CarSetupMetaInfosForChassisAssemblyFragmentDoc = `
    fragment CarSetupMetaInfosForChassisAssembly on CarSetup {
  _id
  chassisAssemblyID
  runSheet {
    _id
    NRun
    session {
      event {
        name
      }
      name
      shortName
    }
  }
  title
}
    `;
export const ChassisAssemblyVarsForTrackingSourceRecordPageFragmentDoc = `
    fragment ChassisAssemblyVarsForTrackingSourceRecordPage on ChassisAssembly {
  _id
  carSetup {
    _id
    title
    runSheet {
      _id
      startTime
      startTimeLTS
      startTimeManual
      contestant {
        startNumber
      }
      NRun
      session {
        _id
        event {
          _id
          name
          tEventStart
          tEventEnd
          season {
            _id
            name
            raceSeries {
              _id
              name
            }
          }
        }
        shortName
        tSessionStart
        tSessionEnd
      }
    }
  }
  carSetupID
  name
  reference
  trackingSourceRecords {
    sources {
      trackingSourceAliasID
      value
    }
    trackingSource {
      _id
      chassisSpecID
      isDefault
      name
      sourceIDs
      sources {
        _id
        aliasString
        aliasType
        displayUnit
        priority
      }
    }
    trackingSourceID
    value
  }
}
    `;
export const PartStatusEnumForPartEditPageVarsFragmentDoc = `
    fragment PartStatusEnumForPartEditPageVars on UserEnumPartStatus {
  _id
  name
}
    `;
export const PartOverviewItemFragmentDoc = `
    fragment PartOverviewItem on Part {
  _id
  chassisSpecName
  description
  displayName
  eligibleEventTypes
  lifetimeMileage
  location {
    name
  }
  manufacturer {
    _id
    name
  }
  manufacturerPartID
  manufacturerSerialNumber
  partNumber
  partStatus {
    userEnumPartStatus {
      active
      name
    }
    userEnumPartStatusName
  }
  reference
  specification {
    type
    _id
    name
    chassisSpecID
  }
  team {
    name
  }
  teams {
    name
  }
  userEnumPartType {
    name
  }
}
    `;
export const AllTrackingMeasurementScalarVarsFragmentDoc = `
    fragment AllTrackingMeasurementScalarVars on TrackingMeasurement {
  _id
  defaultCoordinates {
    x
    y
    z
  }
  defaultRotation {
    I
    J
    K
  }
  description
  displayName
  name
  specificationID
  useInSimulation
}
    `;
export const AllTagVarsFragmentDoc = `
    fragment AllTagVars on Tag {
  _id
  color
  group
  label
  tagType
}
    `;
export const PartForPartEditPageVarsFragmentDoc = `
    fragment PartForPartEditPageVars on Part {
  _id
  concurrentUseAllowed
  currentlyInUse
  description
  displayName
  eligibleEventTypes
  lifetimeMileage
  location {
    name
  }
  locationID
  manufacturerID
  manufacturerPartID
  manufacturerSerialNumber
  notes
  partNumber
  partStatus {
    _id
    active
    statusComment
    userEnumPartStatus {
      active
      name
    }
    userEnumPartStatusID
  }
  properties
  readingLocationOverride
  reference
  rootAssemblyIDs
  rootSpecificationID
  specification {
    __typename
    _id
    description
    name
    chassisSpecID
    manufacturerID
    readingsRequired
    trackingItemIDs
    trackingMeasurements {
      ...AllTrackingMeasurementScalarVars
    }
    type
  }
  specificationID
  tagIDs
  tags {
    ...AllTagVars
  }
  team {
    name
  }
  teamID
  teamIDs
  tracking {
    trackingItem {
      name
      criticalCumulativeValue
      criticalValue
      warningCumulativeValue
      warningValue
    }
  }
  trackingHistoryIDs
  trackingMeasurementHistoryIDs
  userEnumPartTypeID
}
    `;
export const PartSpecInfoForPartEditPageVarsFragmentDoc = `
    fragment PartSpecInfoForPartEditPageVars on CustomSpec {
  _id
  name
  trackingItems {
    _id
    displayUnit
    name
  }
  trackingItemIDs
  rootSpecificationID
}
    `;
export const PartTrackingRecordVarsFragmentDoc = `
    fragment PartTrackingRecordVars on TrackingRecord {
  _id
  active
  arrayValues
  chassisAssembly {
    carSetup {
      _id
    }
    carSetupID
    name
    reference
  }
  chassisAssemblyID
  date
  dateResolved
  cumulativeValue
  notes
  partID
  reset
  statusEnumID
  statusEnum {
    type
    active
    _id
  }
  type
  trackingSourceID
  trackingItemID
  userEnumPartStatusName
  value
  valueString
}
    `;
export const PartTrackingItemVarsFragmentDoc = `
    fragment PartTrackingItemVars on TrackingItem {
  _id
  active
  arrayElements
  cumulativeCalculation
  criticalValue
  displayUnit
  isArray
  measurementImage
  name
  NDecimals
  operator
  resettable
  trackingSource {
    _id
    name
    sourceIDs
    displayUnit
    NDecimals
  }
  warningValue
}
    `;
export const PartTrackingVarsFragmentDoc = `
    fragment PartTrackingVars on TrackingEntry {
  history {
    ...PartTrackingRecordVars
  }
  snapshot {
    ...PartTrackingRecordVars
  }
  trackingItem {
    ...PartTrackingItemVars
  }
  trackingItemID
}
    `;
export const RunSheetForTabStripFragmentDoc = `
    fragment RunSheetForTabStrip on RunSheet {
  _id
  driver {
    _id
    acronym
  }
  info
  lapCount
  laps {
    _id
    data {
      source
      tDay
    }
    lapType
    tLapManual
    tLapMax
  }
  NRun
  NRunTiming
  runDescription
  setup {
    _id
    setupInfo
  }
  startTime
  startTimeLTS
  startTimeManual
  teamID
}
    `;
export const RunEnergyLapTypeVarsFragmentDoc = `
    fragment RunEnergyLapTypeVars on RunEnergy {
  ATTACK
  COOL
  FCY
  IN
  OUT
  OUTIN
  PITLANE
  PREP
  PUSH
  QUALI
  SAFETYCAR
  SHAKEDOWN
  SLOW
  TARGET
  TOGRID
  TOPADDOCK
  TOPITS
  UNFINISHED
}
    `;
export const LapSequenceLapsForRunPlanVarsFragmentDoc = `
    fragment LapSequenceLapsForRunPlanVars on LapSequenceLaps {
  _id
  NLap
  lapType
}
    `;
export const RunSheetTyreForRunPlanVarsFragmentDoc = `
    fragment RunSheetTyreForRunPlanVars on RunTyre {
  mileagePreRun
  pTyre
  pTyrePostRun
  pTyrePostRunBleed
  TTyre
  TTyrePostRun
  TTyrePostRunBleed
  tyreID
}
    `;
export const RunPlanRunRunSheetVarsFragmentDoc = `
    fragment RunPlanRunRunSheetVars on RunSheet {
  _id
  startTime
  endTime
  mileage
  isLocked
  SoCRequired {
    ...AllRunEnergyVars
  }
  contestantID
  driver {
    _id
    acronym
  }
  driverID
  fuelRequired {
    ...AllRunEnergyVars
  }
  laps {
    tLapMax
    tLapManual
    tDayPitIn
    data {
      tDayPitIn
    }
  }
  mFuelRunEnd
  mFuelRunStart
  lapCount
  NRun
  NRunTiming
  runDescription
  setupID
  sessionID
  teamID
  tGarageTurnaround
  tWaitBeforeRun
  tyreFL {
    ...RunSheetTyreForRunPlanVars
  }
  tyreFR {
    ...RunSheetTyreForRunPlanVars
  }
  tyreRL {
    ...RunSheetTyreForRunPlanVars
  }
  tyreRR {
    ...RunSheetTyreForRunPlanVars
  }
  tyreSet {
    _id
    name
    tyreFR {
      _id
      name
    }
    tyreFL {
      _id
      name
    }
    tyreRL {
      _id
      name
    }
    tyreRR {
      _id
      name
    }
  }
}
    `;
export const RunPlanRunVarsFragmentDoc = `
    fragment RunPlanRunVars on RunPlanRun {
  _id
  NRun
  actionItemsPostRun {
    _id
    name
  }
  actionItemsPreRun {
    _id
    name
  }
  backgroundColor
  description
  lapSequence {
    ...LapSequenceLapsForRunPlanVars
  }
  priority
  NLapsAttackPower
  NLapsPrep
  NLapsPush
  NLapsQualiPower
  NLapsSlow
  NLapsTarget
  tFuelRefuel
  tGarageTurnaround
  tWaitBeforeRun
  runSheetID
  selectedDriverID
  fuelDrainedBeforeRun
  mFuelRefuel
  reminder
  selectedDriver {
    _id
    name
    username
    acronym
  }
  tyreFLID
  tyreFL {
    _id
    mileage
    name
    axle
  }
  tyreFRID
  tyreFR {
    _id
    mileage
    name
    axle
  }
  tyreRLID
  tyreRL {
    _id
    mileage
    name
    axle
  }
  tyreRRID
  tyreRR {
    _id
    mileage
    name
    axle
  }
  tyreSetID
  tyreSet {
    _id
    name
    number
    tyreIDFL
    tyreIDFR
    tyreIDRL
    tyreIDRR
  }
  runSheet {
    ...RunPlanRunRunSheetVars
  }
  setupChanges
}
    `;
export const DriversForRunPlanVarsFragmentDoc = `
    fragment DriversForRunPlanVars on Person {
  _id
  acronym
  displayColor
  name
}
    `;
export const TrackLayoutLengthVarsFragmentDoc = `
    fragment TrackLayoutLengthVars on TrackLayout {
  lapLengthCarData
  lapLengthInLapCarData
  lapLengthInLapOfficial
  lapLengthInLapRoulette
  lapLengthOfficial
  lapLengthOutLapCarData
  lapLengthOutLapOfficial
  lapLengthOutLapRoulette
  lapLengthRoulette
}
    `;
export const LapTypeConfigVarsFragmentDoc = `
    fragment LapTypeConfigVars on RaceSeriesLapTypeConfig {
  ATTACK {
    lapTypeColor
    displayString
    name
  }
  COOL {
    lapTypeColor
    displayString
    name
  }
  FCY {
    lapTypeColor
    displayString
    name
  }
  IN {
    lapTypeColor
    displayString
    name
  }
  OUT {
    lapTypeColor
    displayString
    name
  }
  OUTIN {
    lapTypeColor
    displayString
    name
  }
  PITLANE {
    lapTypeColor
    displayString
    name
  }
  PREP {
    lapTypeColor
    displayString
    name
  }
  PUSH {
    lapTypeColor
    displayString
    name
  }
  QUALI {
    lapTypeColor
    displayString
    name
  }
  SAFETYCAR {
    lapTypeColor
    displayString
    name
  }
  SHAKEDOWN {
    lapTypeColor
    displayString
    name
  }
  SLOW {
    lapTypeColor
    displayString
    name
  }
  TARGET {
    lapTypeColor
    displayString
    name
  }
  TOGRID {
    lapTypeColor
    displayString
    name
  }
  TOPADDOCK {
    lapTypeColor
    displayString
    name
  }
  TOPITS {
    lapTypeColor
    displayString
    name
  }
  UNFINISHED {
    lapTypeColor
    displayString
    name
  }
}
    `;
export const RunPlanSessionEventVarsFragmentDoc = `
    fragment RunPlanSessionEventVars on Session {
  _id
  eventID
  shortName
  name
  tSessionStart
  tSessionEnd
  event {
    _id
    contestants {
      drivers {
        ...DriversForRunPlanVars
      }
    }
    name
    trackLayouts {
      _id
      name
      ...TrackLayoutLengthVars
      track {
        _id
        name
        timeZone
      }
    }
    consumptions {
      trackLayoutID
      trackLayout {
        _id
        name
      }
      fuelRequired {
        ATTACK
        COOL
        FCY
        IN
        OUT
        OUTIN
        PITLANE
        PREP
        PUSH
        QUALI
        SAFETYCAR
        SHAKEDOWN
        SLOW
        TARGET
        TOGRID
        TOPADDOCK
        TOPITS
        UNFINISHED
      }
    }
    referenceLaptimes {
      ATTACK
      COOL
      FCY
      IN
      OUT
      OUTIN
      PITLANE
      PREP
      PUSH
      QUALI
      SAFETYCAR
      SHAKEDOWN
      SLOW
      TARGET
      TOGRID
      TOPADDOCK
      TOPITS
      UNFINISHED
      calculationMethod
      referenceLaptime
      trackLayoutID
    }
    season {
      raceSeries {
        _id
        lapTypeConfig {
          ...LapTypeConfigVars
        }
      }
    }
  }
}
    `;
export const RunLapTimeLapTypeVarsFragmentDoc = `
    fragment RunLapTimeLapTypeVars on RunLapTime {
  ATTACK
  COOL
  FCY
  IN
  OUT
  OUTIN
  PITLANE
  PREP
  PUSH
  QUALI
  SAFETYCAR
  SHAKEDOWN
  SLOW
  TARGET
  TOGRID
  TOPADDOCK
  TOPITS
  UNFINISHED
}
    `;
export const RunPlanVarsFragmentDoc = `
    fragment RunPlanVars on RunPlan {
  _id
  fuelRequired {
    ...RunEnergyLapTypeVars
  }
  runs {
    ...RunPlanRunVars
  }
  session {
    ...RunPlanSessionEventVars
  }
  contestantID
  contestant {
    _id
    startNumber
    drivers {
      ...DriversForRunPlanVars
    }
  }
  createdAt
  mFuelFullTank
  sessionID
  trackLayoutID
  title
  updatedAt
  tLapExpected {
    ...RunLapTimeLapTypeVars
  }
}
    `;
export const LapSequenceForRunPlanVarsFragmentDoc = `
    fragment LapSequenceForRunPlanVars on LapSequence {
  _id
  laps {
    NLap
    _id
    lapType
  }
  name
}
    `;
export const ReportNotesPagesFragmentDoc = `
    fragment ReportNotesPages on ReportNote {
  _id
  pageOverview {
    notes {
      index
      text
      title
      mode
      _id
    }
  }
  pageSession {
    notes {
      index
      text
      title
      mode
      _id
    }
  }
  pageParts {
    notes {
      index
      text
      title
      mode
      _id
    }
  }
  pageAppendix {
    notes {
      index
      text
      title
      mode
      _id
    }
  }
  pageRunPlan {
    notes {
      index
      text
      title
      mode
      _id
    }
  }
}
    `;
export const AllReportTemplateVarsFragmentDoc = `
    fragment AllReportTemplateVars on ReportTemplate {
  _id
  name
  logo
  downloadFilenameFormat
  bop {
    active
    bopFileOnly
    layout
  }
  carSetup {
    active
    tableConfig
  }
  issues {
    active
    columns {
      field
      label
    }
    groupBy
  }
  kpi {
    active
    layout
    showSessionLines
  }
  overview {
    active
    noteTitle
    showFuelConsumption
  }
  parts {
    active
    groupPartsByChassisAssemblyName
    noteTitle
    tableColumns
  }
  weather {
    active
    splitDataByDays
  }
  appendix {
    active
  }
  runPlan {
    active
  }
  reportTitle
  runInfo {
    active
    columns {
      field
      label
    }
  }
  sessions {
    active
    displayedTimeZones
    noteTitle
    showTimingOverview
  }
  excludedNoteIDs {
    pageOverview
    pageSession
    pageParts
    pageAppendix
    pageRunPlan
  }
}
    `;
export const RunSheetVarsForLinkingFragmentDoc = `
    fragment RunSheetVarsForLinking on RunSheet {
  _id
  endTime
  lapCount
  nextRunSheetID
  NRun
  NRunTiming
  prevRunSheetID
  session {
    shortName
    name
    tSessionStart
  }
  sessionID
  startTime
}
    `;
export const IssueVarsFragmentDoc = `
    fragment IssueVars on IssueQuery {
  _id
  acknowledgedAt
  acknowledgedBy {
    _id
    name
    username
    role
  }
  assignees {
    _id
    name
    username
    role
  }
  assigneeIDs
  carSetupID
  cancelledBy {
    _id
    name
    username
    role
  }
  closedAt
  closedBy {
    name
    username
    role
  }
  comments {
    _id
    createdAt
    author {
      _id
      name
      username
      role
    }
    text
  }
  createdAt
  createdBy {
    _id
    name
    username
    role
  }
  description
  descriptionDetails
  number
  oneWordStatus
  priority
  updatedAt
}
    `;
export const EventReferenceLaptimeVarsFragmentDoc = `
    fragment EventReferenceLaptimeVars on EventReferenceLaptimes {
  ATTACK
  COOL
  FCY
  IN
  OUT
  OUTIN
  PITLANE
  PREP
  PUSH
  QUALI
  SAFETYCAR
  SHAKEDOWN
  SLOW
  TARGET
  TOGRID
  TOPADDOCK
  TOPITS
  UNFINISHED
  calculationMethod
  referenceLaptime
  trackLayoutID
}
    `;
export const TyreVarsForPreviousRunSheetsInfosVarsFragmentDoc = `
    fragment TyreVarsForPreviousRunSheetsInfosVars on RunTyre {
  hTyreTread
  pTyre
  pTyrePostRun
  pTyrePostRunBleed
  pTyrePreRunBleed
  pTyreReference
  pTyreSetDown
  pTyreTarget
  pTyreMinStartRun
  pTyreStartRun
  TTyre
  TTyreParcFermeExpected
  TTyrePostRun
  TTyrePostRunBleed
  TTyrePreRunBleed
  TTyreReference
  TTyreSetdown
  TTyreSurface
  tyreID
}
    `;
export const TyreWearItemFragmentDoc = `
    fragment TyreWearItem on TyreWear {
  _id
  date
  runSheetID
  tyreID
  wearMarkers
}
    `;
export const EventTyreDefaultsFragmentDoc = `
    fragment EventTyreDefaults on Event {
  tyreDefaults {
    tyreType
    frontLeft {
      pTyreStartRun
      pTyreMin
      pTyreTarget
    }
    frontRight {
      pTyreStartRun
      pTyreMin
      pTyreTarget
    }
    rearLeft {
      pTyreStartRun
      pTyreMin
      pTyreTarget
    }
    rearRight {
      pTyreStartRun
      pTyreMin
      pTyreTarget
    }
  }
  tyreDefaultsFL {
    pTyreMin
    pTyreStartRun
    pTyreTarget
  }
  tyreDefaultsFR {
    pTyreMin
    pTyreStartRun
    pTyreTarget
  }
  tyreDefaultsRL {
    pTyreMin
    pTyreStartRun
    pTyreTarget
  }
  tyreDefaultsRR {
    pTyreMin
    pTyreStartRun
    pTyreTarget
  }
  tyreDefaultsWetFL {
    pTyreMin
    pTyreStartRun
    pTyreTarget
  }
  tyreDefaultsWetFR {
    pTyreMin
    pTyreStartRun
    pTyreTarget
  }
  tyreDefaultsWetRL {
    pTyreMin
    pTyreStartRun
    pTyreTarget
  }
  tyreDefaultsWetRR {
    pTyreMin
    pTyreStartRun
    pTyreTarget
  }
}
    `;
export const CarSetupInfoForStagingAreaVarsFragmentDoc = `
    fragment CarSetupInfoForStagingAreaVars on CarSetup {
  _id
  chassisSpec {
    simulationModels
  }
  customSimulationPayloadEnabled
  runSheetID
  updatedAt
}
    `;
export const GetRunSheetInfoForStagingAreaVarsFragmentDoc = `
    fragment GetRunSheetInfoForStagingAreaVars on RunSheet {
  _id
  contestant {
    _id
    startNumber
  }
  info
  NRun
  NRunTiming
  setupID
  session {
    _id
    event {
      _id
      name
    }
    shortName
    name
  }
  weather {
    TAir
    pAmbient
    rHumidity
  }
  updatedAt
}
    `;
export const SimResultDataVarsFragmentDoc = `
    fragment SimResultDataVars on SimResultData {
  channelName
  channelSamplingRate
  channelValue
  channelTime
  interpolationMethod
  isTimeChannel
  unit
  _id
}
    `;
export const SimResultInfosForStagingAreaVarsFragmentDoc = `
    fragment SimResultInfosForStagingAreaVars on SimResult {
  _id
  carSetup {
    _id
    title
  }
  carSetupID
  carSetupModifiedAt
  data {
    _id
    ...SimResultDataVars
  }
  createdAt
  defaultChannelTime
  isCarSetupChanged
  name
  pAmbient
  refValues
  requester {
    _id
    name
    username
  }
  requesterID
  rHumidity
  runSheetID
  simType
  simulationDriveFile {
    name
  }
  simulationDriveFileID
  simulationService
  source
  sourceReferenceID
  status
  statusMessage
  specificationID
  TAmbient
  trackLayout {
    _id
    ...TrackLayoutVars
  }
  trackLayoutID
  updatedAt
  version
}
    `;
export const ChassisSpecIterationVarsFragmentDoc = `
    fragment ChassisSpecIterationVars on ChassisSpec {
  _id
  name
  version
  releaseDate
  released
  createdAt
  updatedAt
  decommissioned
  simulationAvailable
  prevIterationID
  nextIterationID
  allowableParentSpecIDs
}
    `;
export const SpecificationForSpecGroupsFragmentDoc = `
    fragment SpecificationForSpecGroups on ChassisSpec {
  _id
  createdAt
  customSpecs {
    _id
    drawingNumber
    manufacturerReference
    name
    reference
    specificationGroupID
  }
  name
  prevIterationID
  released
  specificationGroupIDs
  specificationGroups {
    _id
    name
    specifications {
      _id
      name
    }
  }
  updatedAt
}
    `;
export const AllTableVarsFragmentDoc = `
    fragment AllTableVars on Table {
  columnNames
  columnValues
  data
  decimals
  depth
  height
  rowNames
  sliceNames
  sliceValues
  width
  _id
}
    `;
export const AllTrackingItemScalarVarsFragmentDoc = `
    fragment AllTrackingItemScalarVars on TrackingItem {
  _id
  active
  arrayElements
  criticalCumulativeValue
  criticalValue
  cumulativeCalculation
  defaultValue
  description
  displayUnit
  isArray
  isDefault
  name
  NDecimals
  operator
  resettable
  specificationID
  trackingSourceID
  useInSimulation
  warningCumulativeValue
  warningValue
}
    `;
export const TrackingSourceForGetTrackingSourcesByChassisSpecIdVarsFragmentDoc = `
    fragment TrackingSourceForGetTrackingSourcesByChassisSpecIdVars on TrackingSource {
  _id
  description
  displayUnit
  name
  NDecimals
  sourceIDs
  sources {
    _id
    aliasString
    aliasType
    description
    displayUnit
    priority
  }
}
    `;
export const CustomSpecificationItemFragmentDoc = `
    fragment CustomSpecificationItem on CustomSpec {
  _id
  adjustableProperties {
    ...AdjustableAccelerationPropertyVars
    ...AdjustableAnglePropertyVars
    ...AdjustableAngularCompliancePropertyVars
    ...AdjustableAngularTorqueCompliancePropertyVars
    ...AdjustableBooleanPropertyVars
    ...AdjustableCompliancePropertyVars
    ...AdjustableForcePropertyVars
    ...AdjustableInertiaPropertyVars
    ...AdjustableLengthPropertyVars
    ...AdjustableLocationPropertyVars
    ...AdjustableMassPropertyVars
    ...AdjustableNumberPropertyVars
    ...AdjustableOrientationPropertyVars
    ...AdjustablePowerPropertyVars
    ...AdjustablePressurePropertyVars
    ...AdjustableRatioPropertyVars
    ...AdjustableSpringRatePropertyVars
    ...AdjustableSteeringRackRatioPropertyVars
    ...AdjustableStringPropertyVars
    ...AdjustableTemperaturePropertyVars
    ...AdjustableTorquePropertyVars
    ...AdjustableTorsionRatePropertyVars
    ...AdjustableVolumePropertyVars
  }
  buildSheetDisplayLocationID
  allowableSockets
  chassisSpec {
    ... on ChassisSpec {
      measurements {
        ...ChassisMeasurementVars
      }
    }
  }
  chassisSpecID
  createdAt
  customTables {
    name
    table {
      ...AllTableVars
    }
  }
  decommissioned
  description
  drawingNumber
  manufacturerID
  manufacturerReference
  massProperties {
    mass
    COGx
    COGy
    COGz
    Ixx
    Iyy
    Izz
  }
  name
  readingsRequired
  reference
  rootSpecificationID
  simulationModels
  trackingItems {
    ...AllTrackingItemScalarVars
    measurementImage
    trackingSource {
      ...TrackingSourceForGetTrackingSourcesByChassisSpecIdVars
    }
  }
  trackingItemIDs
  trackingMeasurements {
    ...AllTrackingMeasurementScalarVars
  }
  trackingMeasurementIDs
  updatedAt
}
    `;
export const SpecificationOnSpecificationGroupFragmentDoc = `
    fragment SpecificationOnSpecificationGroup on BaseSpecification {
  _id
  name
}
    `;
export const ChassisSpecForGetTrackingSourcesByChassisSpecIdVarsFragmentDoc = `
    fragment ChassisSpecForGetTrackingSourcesByChassisSpecIdVars on ChassisSpec {
  _id
  createdAt
  name
  trackingSourceIDs
  released
  rootSpecificationID
  trackingSources {
    ...TrackingSourceForGetTrackingSourcesByChassisSpecIdVars
  }
  updatedAt
}
    `;
export const CalculationVarsForCarDataServiceCalculationPageFragmentDoc = `
    fragment CalculationVarsForCarDataServiceCalculationPage on Calculation {
  _id
  functionString
  isActive
  name
  parameter
}
    `;
export const CarDataServiceConfigForDownloadButtonVarsFragmentDoc = `
    fragment carDataServiceConfigForDownloadButtonVars on CarDataServiceConfig {
  Kpi {
    KpiParameters
    Preconditions
  }
  name
  ORHCalculationIDs
  ParameterMap
  PostProcessingConfig {
    ApplicationSettingsConfiguration {
      ProcessedFolder
      ResultsFolder
      FunctionsFolder
      RunsheetMatching
      PitstopTriggers {
        ParameterId
        Value
        Type
      }
      DriverContestantLookup
    }
    ProcessingEnginesConfiguration {
      ImportersFolder
      ParameterMapFile
      InternalCalculationsFolder
      UserCalculationsFolder
      ExportersFolder
      ProcessingEngineConfiguration {
        Name
        QueueName
        Instances
        Importer
        Calculations
        Exporters {
          ATLAS10_EXPORTER
          JSONFILE_EXPORTER
          ONERACEHUB_EXPORTER
          WINTAX_EXPORTER {
            DISTANCE_CHANNEL
            FUEL_CONSUMPTION
            FUEL_LEVEL
            LAP_DISTANCE
            OUTPUT_PATH
            TELDATAZTX_PATH
          }
        }
      }
    }
    EventConfiguration {
      EventId
      EventDescription
    }
    QueueManagerConfiguration {
      Queues {
        Name
        SessionType
      }
    }
    SessionManagerConfiguration {
      OffloadFolder
      OffloadSessionTypes
    }
    SessionTypesConfiguration {
      SessionTypes {
        name
        exts
        regExpressions
        folderUpLevel
        ignoreLiterals
      }
    }
  }
}
    `;
export const SessionInfoVarsForTimingConfigPageFragmentDoc = `
    fragment SessionInfoVarsForTimingConfigPage on Session {
  _id
  name
  shortName
  tSessionEnd
  tSessionStart
}
    `;
export const OneTimingWeatherConfigVarsFragmentDoc = `
    fragment OneTimingWeatherConfigVars on OneTimingWeatherServiceConfig {
  _id
  name
  active
  eventIDs
  timingPort
  timingURL
}
    `;
export const WeatherServiceConfigVarsFragmentDoc = `
    fragment WeatherServiceConfigVars on WeatherServiceConfig {
  _id
  apiKey
  apiSecret
  eventIDs
  isActive
  name
  refreshInterval
  requestLocation {
    coordinates
    type
  }
  requestType
  source
  type
  weatherStationID
}
    `;
export const TyreWearItemsForTyreWearListVarsFragmentDoc = `
    fragment TyreWearItemsForTyreWearListVars on TyreWear {
  _id
  date
  runSheetID
  wearMarkers
}
    `;
export const LapSequenceVarsFragmentDoc = `
    fragment LapSequenceVars on LapSequence {
  _id
  name
  laps {
    NLap
    lapType
  }
  raceSeriesID
}
    `;
export const PackagesForPackageManagerPageVarsFragmentDoc = `
    fragment PackagesForPackageManagerPageVars on Package {
  _id
  author {
    name
  }
  authorID
  chassisSpecID
  isActive
  isPublic
  items {
    path
    value
  }
  teams {
    name
  }
  teamIDs
  name
  useAsCopyReference
}
    `;
export const SpecificationGroupVarsFragmentDoc = `
    fragment specificationGroupVars on SpecificationGroup {
  _id
  name
  specifications {
    name
    readingsRequired
    adjustableProperties {
      name
      index
    }
  }
}
    `;
export const ChassisSpecVarsForPackageEditPageVarsFragmentDoc = `
    fragment ChassisSpecVarsForPackageEditPageVars on ChassisSpec {
  aeroPackageSpecs {
    _id
    name
    aeroElementSpecIDs
    aeroElementSpecs {
      _id
      allowableSockets
      name
    }
  }
  antiRollBarSpecs {
    _id
    antiRollBarDisplayLocation
  }
  bumpRubberSpecs {
    _id
    allowableSockets
    readingsAllowable
  }
  customSpecs {
    _id
    adjustableProperties {
      ...AdjustableAccelerationPropertyVars
      ...AdjustableAnglePropertyVars
      ...AdjustableAngularCompliancePropertyVars
      ...AdjustableAngularTorqueCompliancePropertyVars
      ...AdjustableBooleanPropertyVars
      ...AdjustableCompliancePropertyVars
      ...AdjustableForcePropertyVars
      ...AdjustableInertiaPropertyVars
      ...AdjustableLengthPropertyVars
      ...AdjustableLocationPropertyVars
      ...AdjustableMassPropertyVars
      ...AdjustableNumberPropertyVars
      ...AdjustableOrientationPropertyVars
      ...AdjustablePowerPropertyVars
      ...AdjustablePressurePropertyVars
      ...AdjustableRatioPropertyVars
      ...AdjustableSpringRatePropertyVars
      ...AdjustableSteeringRackRatioPropertyVars
      ...AdjustableStringPropertyVars
      ...AdjustableTemperaturePropertyVars
      ...AdjustableTorquePropertyVars
      ...AdjustableTorsionRatePropertyVars
      ...AdjustableVolumePropertyVars
    }
    name
    specificationGroupID
    readingsRequired
  }
  damperSpecs {
    allowableSockets
    readingsAllowable
    _id
  }
  helperSpringSpecs {
    _id
    allowableSockets
    readingsAllowable
  }
  kinematicsExternalSpecs {
    _id
    axle
    aCamber {
      readingsRequired
    }
    aCaster {
      readingsRequired
    }
    aToe {
      readingsRequired
    }
    hRide {
      readingsRequired
    }
  }
  kinematicsInternalSpecs {
    _id
    axle
  }
  measurements {
    angles
    angularCompliances
    angularTorqueCompliances
    bumpPlateMeasurementMethod
    bumpPlateRefFront
    bumpPlateRefRear
    compliances
    forces
    inertias
    inverseCamber
    kinematicsExternalReadingsRequired
    kinematicsInternalReadingsRequired
    lengths
    masses
    powers
    pressures
    ratios
    rideHeightCalcFront
    rideHeightCalcRear
    springRates
    steeringRackRatios
    temperatures
    toeMeasurementMethod
    toeRefFront
    toeRefRear
    torques
    torsionRates
    volumes
    xTrackFront
    xTrackRear
    xWheelbase
  }
  powertrain {
    layout
    numGears
    bevelSetSpecIDs
    bevelSetSpecs {
      _id
    }
    differentialSpecIDs
    differentialSpecs {
      _id
      powertrainLocation
    }
    dropGearSpecIDs
    dropGearSpecs {
      _id
    }
    gearBoxSpecIDs
    gearBoxSpecs {
      _id
    }
    gearSpecIDs
    gearSpecs {
      _id
    }
  }
  reboundSpringSpecs {
    _id
    allowableSockets
    readingsAllowable
  }
  specificationGroups {
    ...specificationGroupVars
  }
  specificationGroupIDs
  springSpecs {
    _id
    allowableSockets
    readingsAllowable
  }
  torsionBarSpecs {
    _id
    allowableSockets
    readingsAllowable
  }
}
    `;
export const ChassisSpecVarsForChassisSpecElementsFragmentDoc = `
    fragment ChassisSpecVarsForChassisSpecElements on ChassisSpec {
  _id
  aeroPackageSpecs {
    _id
    name
    aeroElementSpecIDs
    aeroElementSpecs {
      _id
      allowableSockets
      name
    }
  }
  antiRollBarSpecs {
    _id
    antiRollBarDisplayLocation
    rootSpecificationID
  }
  bumpRubberSpecs {
    _id
    allowableSockets
    readingsAllowable
    rootSpecificationID
  }
  customSpecs {
    _id
    adjustableProperties {
      ...AdjustableAccelerationPropertyVars
      ...AdjustableAnglePropertyVars
      ...AdjustableAngularCompliancePropertyVars
      ...AdjustableAngularTorqueCompliancePropertyVars
      ...AdjustableBooleanPropertyVars
      ...AdjustableCompliancePropertyVars
      ...AdjustableForcePropertyVars
      ...AdjustableInertiaPropertyVars
      ...AdjustableLengthPropertyVars
      ...AdjustableLocationPropertyVars
      ...AdjustableMassPropertyVars
      ...AdjustableNumberPropertyVars
      ...AdjustableOrientationPropertyVars
      ...AdjustablePowerPropertyVars
      ...AdjustablePressurePropertyVars
      ...AdjustableRatioPropertyVars
      ...AdjustableSpringRatePropertyVars
      ...AdjustableSteeringRackRatioPropertyVars
      ...AdjustableStringPropertyVars
      ...AdjustableTemperaturePropertyVars
      ...AdjustableTorquePropertyVars
      ...AdjustableTorsionRatePropertyVars
      ...AdjustableVolumePropertyVars
    }
    name
    readingsRequired
    rootSpecificationID
    specificationGroupID
    trackingItemIDs
  }
  damperSpecs {
    allowableSockets
    readingsAllowable
    rootSpecificationID
    _id
  }
  helperSpringSpecs {
    _id
    allowableSockets
    readingsAllowable
    rootSpecificationID
  }
  kinematicsExternalSpecs {
    _id
    axle
    aCamber {
      readingsRequired
    }
    aCaster {
      readingsRequired
    }
    aToe {
      readingsRequired
    }
    hRide {
      readingsRequired
    }
  }
  kinematicsInternalSpecs {
    _id
    axle
  }
  measurements {
    toeMeasurementMethod
  }
  powertrain {
    layout
    numGears
    bevelSetSpecIDs
    bevelSetSpecs {
      _id
      rootSpecificationID
    }
    differentialSpecIDs
    differentialSpecs {
      _id
      powertrainLocation
      rootSpecificationID
    }
    dropGearSpecIDs
    dropGearSpecs {
      _id
      rootSpecificationID
    }
    gearBoxSpecIDs
    gearBoxSpecs {
      _id
      rootSpecificationID
    }
    gearSpecIDs
    gearSpecs {
      _id
      rootSpecificationID
    }
  }
  reboundSpringSpecs {
    _id
    allowableSockets
    readingsAllowable
    rootSpecificationID
  }
  specificationGroups {
    ...specificationGroupVars
  }
  specificationGroupIDs
  springSpecs {
    _id
    allowableSockets
    readingsAllowable
    rootSpecificationID
  }
  torsionBarSpecs {
    _id
    allowableSockets
    readingsAllowable
    rootSpecificationID
  }
}
    `;
export const TrackingItemVarsForChassisSpecIdFragmentDoc = `
    fragment TrackingItemVarsForChassisSpecId on TrackingItem {
  _id
  name
  specificationID
}
    `;
export const RunTyreVarsFragmentDoc = `
    fragment RunTyreVars on RunTyre {
  tyreID
  pTyre
  TTyre
  pTyrePostRun
  TTyrePostRun
  pTyrePreRunBleed
  pTyrePostRunBleed
  TTyrePreRunBleed
  TTyrePostRunBleed
  TTyreSurface
  hTyreTread
  pTyreReference
  TTyreReference
  TTrackReference
  pTyreStartRun
  pTyreMinStartRun
  pTyreSetDown
  TTyreSetdown
  pTyreTarget
  TTyreParcFermeExpected
  mileagePreRun
}
    `;
export const RunSheetVarsForTyrePressureCalculationFragmentDoc = `
    fragment RunSheetVarsForTyrePressureCalculation on RunSheet {
  _id
  NRun
  NRunTiming
  sessionID
  tyreFL {
    ...RunTyreVars
  }
  tyreFR {
    ...RunTyreVars
  }
  tyreRL {
    ...RunTyreVars
  }
  tyreRR {
    ...RunTyreVars
  }
  tyreSetID
  tyreSet {
    name
  }
  weather {
    TAir
    TTrack
    pAmbient
    rHumidity
    DAir
    TAirOfficial
    TTrackOfficial
  }
  laps {
    _id
    tLapMax
  }
}
    `;
export const TyrePressureCalculationSettingsFragmentDoc = `
    fragment TyrePressureCalculationSettings on EventTyrePressureSettings {
  rTrackTempShortRun
  rTrackTempLongRun
  rRimTempTeam
  rRimTempRegulation
  rColdToHotTeam
  TRimReference
  TTrackReference
}
    `;
export const TyreCornersFragmentDoc = `
    fragment TyreCorners on TyreValues {
  FL
  FR
  RL
  RR
}
    `;
export const TyreSetupDataVarsFragmentDoc = `
    fragment TyreSetupDataVars on TyreSetupData {
  tyreSetID
  tyreSet {
    name
  }
  comment
  selected
  TTrackExpected
  rTrackTemperature
  TRimSetup {
    ...TyreCorners
  }
  pTyreSetup {
    ...TyreCorners
  }
  pTyreTarget {
    ...TyreCorners
  }
  pTyreReference {
    ...TyreCorners
  }
}
    `;
export const TyrePressureSheetSessionVarsFragmentDoc = `
    fragment TyrePressureSheetSessionVars on TyrePressureSheetSession {
  sessionID
  session {
    name
  }
  tyreSetupData {
    ...TyreSetupDataVars
  }
}
    `;
export const TyrePressureSheetVarsFragmentDoc = `
    fragment TyrePressureSheetVars on TyrePressureSheet {
  tyrePressureSettings {
    ...TyrePressureCalculationSettings
  }
  eventID
  contestantID
  sessions {
    ...TyrePressureSheetSessionVars
  }
  pressureUnit
  temperatureUnit
  _id
}
    `;
export const TyreMileageGraphRunMileageVarsFragmentDoc = `
    fragment TyreMileageGraphRunMileageVars on TyreMileageGraphEventMileageItemRunMileageItem {
  runSheetID
  sessionID
  NRunConsecutive
  NRunTiming
  NRun
  startMileage
  endMileage
  runMileage
}
    `;
export const TyreMileageGraphTyreMileageGraphEventMileageItemVarsFragmentDoc = `
    fragment TyreMileageGraphTyreMileageGraphEventMileageItemVars on TyreMileageGraphEventMileageItem {
  _id
  name
  eventStartMileage
  eventEndMileage
  eventTotalMileage
  sessionMileages {
    sessionID
    startMileage
    endMileage
    totalMileage
  }
  runMileages {
    ...TyreMileageGraphRunMileageVars
  }
}
    `;
export const TyreSetForWarehouseVarsFragmentDoc = `
    fragment TyreSetForWarehouseVars on TyreSet {
  _id
  name
  totalMileage
  assignment {
    seasons {
      _id
      name
    }
    seasonContestants {
      _id
      startNumber
      seasonID
    }
    events {
      _id
      name
      contestants {
        _id
        tyreSetIDs
      }
    }
    eventContestants {
      _id
      startNumber
    }
  }
  tyreFL {
    _id
    name
  }
  tyreFR {
    _id
    name
  }
  tyreRL {
    _id
    name
  }
  tyreRR {
    _id
    name
  }
}
    `;
export const WeatherForWeatherPageVarsForSelectorFragmentDoc = `
    fragment WeatherForWeatherPageVarsForSelector on Weather {
  _id
  events {
    name
    season {
      name
    }
    sessionIDs
    sessions {
      _id
      shortName
      tSessionStart
      tSessionEnd
    }
    tEventStart
    tEventEnd
    track {
      timeZone
    }
  }
  eventIDs
  source
  time
  type
  weatherStationID
}
    `;
export const WeatherForWeatherPageVarsFragmentDoc = `
    fragment WeatherForWeatherPageVars on Weather {
  _id
  altitude
  data {
    ambientCondition
    aWind
    aWindMain
    DAir
    globalRadiation
    pAmbient
    rainIntensity
    rainProbability
    rHumidity
    TAir
    TAirExpected
    TAirMax
    TAirMin
    TAirOfficial
    TAmbient
    TDewPoint
    time
    TInternal
    trackCondition
    TTrack
    TTrackExpected
    TTrackOfficial
    TWindChill
    VBattery
    vWind
    vWindAverage
    vWindPeak
  }
  events {
    name
    season {
      name
    }
    sessionIDs
    sessions {
      _id
      shortName
      tSessionStart
      tSessionEnd
    }
    tEventStart
    tEventEnd
    track {
      timeZone
    }
  }
  eventIDs
  geoLocation {
    coordinates
  }
  notes
  source
  time
  type
}
    `;
export const BuildSheetStylePageTabFragmentDoc = `
    fragment BuildSheetStylePageTab on BuildSheetStyleTab {
  _id
  title
  buildSheetGroupEnumID
}
    `;
export const BuildSheetStylePageBlockFragmentDoc = `
    fragment BuildSheetStylePageBlock on BuildSheetStyleBlock {
  _id
  h
  w
  y
  x
  tabs {
    ...BuildSheetStylePageTab
  }
}
    `;
export const UserEnumVarsFragmentDoc = `
    fragment UserEnumVars on AnyUserEnum {
  _id
  name
}
    `;
export const AllAssemblyTemplatesVarsFragmentDoc = `
    fragment AllAssemblyTemplatesVars on AssemblyTemplate {
  _id
  description
  name
  requiredParts {
    location
    userEnumPartTypeID
  }
}
    `;
export const AllChassisMeasurementVarsFragmentDoc = `
    fragment AllChassisMeasurementVars on ChassisMeasurements {
  angles
  angularCompliances
  angularTorqueCompliances
  bumpPlateMeasurementMethod
  bumpPlateRefFront
  bumpPlateRefRear
  compliances
  forces
  inertias
  inverseCamber
  kinematicsExternalReadingsRequired
  kinematicsInternalReadingsRequired
  lengths
  masses
  powers
  pressures
  ratios
  rideHeightCalcFront
  rideHeightCalcRear
  springRates
  steeringRackRatios
  temperatures
  toeMeasurementMethod
  toeRefFront
  toeRefRear
  toeTotal
  torques
  torsionRates
  volumes
  xTrackFront
  xTrackRear
  xWheelbase
}
    `;
export const AllEventScalarVarsFragmentDoc = `
    fragment AllEventScalarVars on Event {
  _id
  assignedSetupIDs
  DFuel
  energySweep
  eventType
  iRacingServiceIsNextEvent
  name
  NEventSeason
  seasonID
  sessionIDs
  tagIDs
  tEventEnd
  tEventStart
  thirdPartyEventID
  timeZone
  tLapAverage
  trackID
  trackLayoutIDs
  type
  weatherIDs
}
    `;
export const AllSeasonScalarVarsFragmentDoc = `
    fragment AllSeasonScalarVars on Season {
  _id
  assignedSetupIDs
  contestantIDs
  eventIDs
  fastestLapsPositionCutoff
  name
  pointsPerFastestLap
  pointsPerFastestLapTeam
  pointsPerPosition
  pointsPerPositionSprintRace
  pointsPerQualifyingRank
  raceSeriesID
  tagIDs
  tyreIDs
  tyreSetIDs
}
    `;
export const AllRaceSeriesScalarVarsFragmentDoc = `
    fragment AllRaceSeriesScalarVars on RaceSeries {
  _id
  assignedSetupIDs
  defaultJobListIDs
  defaultRunSheetStyleID
  driversPerCar
  groupName
  name
  seasonIDs
  tagIDs
}
    `;
export const AllSeasonVarsFragmentDoc = `
    fragment AllSeasonVars on Season {
  ...AllSeasonScalarVars
  raceSeries {
    ...AllRaceSeriesScalarVars
  }
}
    `;
export const AllEventVarsFragmentDoc = `
    fragment AllEventVars on Event {
  ...AllEventScalarVars
  season {
    ...AllSeasonVars
  }
}
    `;
export const AllLocalConnectionVarsFragmentDoc = `
    fragment AllLocalConnectionVars on LocalConnection {
  host
  outputFolder
  port
  useSSL
}
    `;
export const AllPartScalarVarsFragmentDoc = `
    fragment AllPartScalarVars on Part {
  _id
  chassisSpecName
  concurrentUseAllowed
  createdAt
  currentlyInUse
  description
  eligibleEventTypes
  lifetimeMileage
  locationID
  manufacturerID
  manufacturerPartID
  manufacturerSerialNumber
  notes
  partNumber
  properties
  reference
  rootAssemblyIDs
  rootSpecificationID
  specificationID
  tagIDs
  teamID
  trackingHistoryIDs
  trackingMeasurementHistoryIDs
  updatedAt
  userEnumPartTypeID
}
    `;
export const AllPartInstanceScalarVarsFragmentDoc = `
    fragment AllPartInstanceScalarVars on PartInstance {
  _id
  parentID
  partID
  readingLocation
  specificationGroupID
  specificationID
  superParentID
}
    `;
export const AllWeatherDataScalarVarsFragmentDoc = `
    fragment AllWeatherDataScalarVars on WeatherData {
  ambientCondition
  aWind
  aWindMain
  DAir
  globalRadiation
  pAmbient
  rainIntensity
  rainProbability
  rHumidity
  TAir
  TAirExpected
  TAirMax
  TAirMin
  TAirOfficial
  TAmbient
  TDewPoint
  time
  TInternal
  trackCondition
  TTrack
  TTrackExpected
  TTrackOfficial
  TWindChill
  VBattery
  vWind
  vWindAverage
  vWindPeak
}
    `;
export const AllSimResultScalarVarsFragmentDoc = `
    fragment AllSimResultScalarVars on SimResult {
  _id
  carSetupID
  carSetupModifiedAt
  createdAt
  defaultChannelTime
  isCarSetupChanged
  name
  pAmbient
  refValues
  requesterID
  rHumidity
  runSheetID
  serviceVersion
  simType
  simulationDriveFileID
  simulationService
  source
  sourceReferenceID
  specificationID
  status
  statusMessage
  tagIDs
  TAmbient
  trackLayoutID
  updatedAt
  version
}
    `;
export const AllTrackingHistoryVarsFragmentDoc = `
    fragment AllTrackingHistoryVars on TrackingRecord {
  _id
  chassisAssemblyID
  createdAt
  cumulativeValue
  date
  limitCritical
  limitWarning
  mass
  notes
  partID
  qualityCheckID
  reset
  statusEnumID
  trackingItemID
  type
  updatedAt
  updatedByID
  value
  forceTable {
    acceleration
    dampingForce
    force
    inertanceForce
    velocity
    x
    xMax
    xMin
  }
}
    `;
export const AllTrackingHistoryFullAndSnapshotVarsFragmentDoc = `
    fragment AllTrackingHistoryFullAndSnapshotVars on PartTrackingHistoryFullandSnapshot {
  active
  chassisAssemblyID
  createdAt
  cumulativeValue
  dateResolved
  limitCritical
  limitWarning
  mass
  notes
  qualityCheckID
  recordErrors
  reset
  statusEnumID
  trackingItem {
    _id
    displayUnit
    trackingSource {
      sourceIDs
      sources {
        displayUnit
      }
    }
  }
  trackingItemID
  trackingRecordID
  type
  updatedAt
  userEnumPartStatusName
  value
  valueString
}
    `;
export const AllTrackingMeasurementHistoryScalarVarsFragmentDoc = `
    fragment AllTrackingMeasurementHistoryScalarVars on TrackingMeasurementRecord {
  _id
  assemblyID
  coordinates {
    x
    y
    z
  }
  createdAt
  date
  partID
  rotation {
    I
    J
    K
  }
  trackingMeasurementID
  updatedAt
}
    `;
export const AllRunTyreScalarVarsFragmentDoc = `
    fragment AllRunTyreScalarVars on RunTyre {
  tyreID
  pTyre
  TTyre
  pTyrePostRun
  TTyrePostRun
  pTyrePreRunBleed
  pTyrePostRunBleed
  TTyrePreRunBleed
  TTyrePostRunBleed
  TTyreSurface
  hTyreTread
  pTyreReference
  TTyreReference
  TTrackReference
  pTyreStartRun
  pTyreMinStartRun
  pTyreSetDown
  TTyreSetdown
  pTyreTarget
  TTyreParcFermeExpected
}
    `;
export const AllTyreScalarVarsFragmentDoc = `
    fragment AllTyreScalarVars on Tyre {
  _id
  additionalSortProperty
  axle
  barcodeManufacturer
  barcodeRegulation
  barcodeRim
  barcodeTPMS
  batteryTPMS
  BTyreScrapped
  compound
  compoundComment
  constructionComment
  constructionSpec
  createdAt
  CTyre
  initialCondition
  kTyre
  manufacturer
  manufacturingDate
  mileage
  mold
  mTyre
  name
  pTyreMinRegulation
  pTyreMinTeam
  seasonID
  sRunInitial
  tagIDs
  type
  updatedAt
  wearMeasurementIDs
}
    `;
export const AllUserEnumPartStatusVarsFragmentDoc = `
    fragment AllUserEnumPartStatusVars on UserEnumPartStatus {
  _id
  name
  active
  type
}
    `;
export const BestValuesVarsFragmentDoc = `
    fragment BestValuesVars on BestValues {
  _id
  contestantID
  fastestLap {
    driver
    time
    NLapRun
    runSheetID
  }
  fastestSectors {
    driver
    time
    NLapRun
    runSheetID
  }
}
    `;
export const ChassisAssemblyForSetupExportVarsFragmentDoc = `
    fragment ChassisAssemblyForSetupExportVars on ChassisAssembly {
  _id
  chassisMeasurements {
    ...ChassisMeasurementPointVars
  }
  chassisSpecID
  name
  partInstances {
    ...PartInstancesForSetupSheetFlexVars
  }
  reference
}
    `;
export const AllRunSheetScalarVarsFragmentDoc = `
    fragment AllRunSheetScalarVars on RunSheet {
  _id
  associatedKpiFiles
  brakeComment
  brakeMeasurementsFL
  brakeMeasurementsFR
  brakeMeasurementsRL
  brakeMeasurementsRR
  brakePostRunMeasurementsFL
  brakePostRunMeasurementsFR
  brakePostRunMeasurementsRL
  brakePostRunMeasurementsRR
  brakePreRunMeasurementsFL
  brakePreRunMeasurementsFR
  brakePreRunMeasurementsRL
  brakePreRunMeasurementsRR
  chassisAssemblyID
  cloudStorageURL
  contestantID
  controlsComment
  createdAt
  DFuel
  driverComments
  driverID
  endTime
  engineerComments
  engineerID
  fastestLap
  finishTyreHeatingBy
  fuelDrainedBeforeRun
  jobIDs
  kpiFileName
  kpiStatus
  kpiUpdatedAt
  lapCount
  lapIDs
  lastModifiedByID
  mFuelAdded
  mFuelDrainedCatchTank
  mFuelDrainedMainTank
  mFuelRunEnd
  mFuelRunStart
  mileage
  nextRunSheetID
  NRun
  NRunTiming
  prevRunSheetID
  problemComments
  qRefuel
  rEnergyAdded
  rEnergyRunEnd
  rEnergyRunStart
  rSOCAdded
  rSOCRunEnd
  rSOCRunStart
  runDescription
  runSheetStyleID
  selectedJobListTemplateID
  sessionID
  setupID
  simResultIDs
  skidComment
  skidMeasurement
  skidPlateID
  skidPostRunMeasurements
  skidPreRunMeasurements
  startTime
  startTyreHeatingAt
  systemsComments
  TCellMaxRunStart
  teamID
  thirdPartyRunID
  timingServiceShouldIgnore
  tRefuel
  tyreComments
  tyreCompoundTiming
  tyreSetID
  updatedAt
  VFuelAdded
}
    `;
export const DamperVarsFragmentDoc = `
    fragment DamperVars on Damper {
  adjusters {
    _id
    name
    settingName
    value
  }
  gasPressure
  manufacturer
  NDamperBumpDO
  NDamperBumpDY
  NDamperBumpHS
  NDamperBumpLS
  NDamperReboundHS
  NDamperReboundLS
  spec
  specification {
    _id
    damperAdjusters {
      maxSetting
      minSetting
      name
      settingNames
      settings
      step
    }
    damperConfigs {
      name
    }
    name
  }
  specificationID
  valvingBumpSpec
  valvingReboundSpec
  xDamperMax
}
    `;
export const CornerVarsFragmentDoc = `
    fragment CornerVars on CarCorner {
  aCamber
  aCamberMeasurement
  aCaster
  aCasterMeasurement
  aToe
  aToeMeasurement
  brake {
    BBrakeDuctEnabled
    brakeBlankingStyle
    hBrakeCaliperBlanking
    hBrakeDiscBlanking
    rBrakeDiscBlanking
  }
  bumpStop {
    name
    specificationID
    specification {
      _id
      name
    }
    xBumpStopGap
  }
  damper {
    ...DamperVars
  }
  droopStop {
    name
    specificationID
    specification {
      _id
      name
    }
    xDroopStopGap
  }
  helperSpring {
    kSpring
    specificationID
    specification {
      _id
      kSpring
      name
      xFree
    }
    xSpringPreload
    xSecondSpringTransition
  }
  hRide
  hRideChassis
  hRideMeasurement
  hRideRegulation
  pTyreTarget
  spring {
    kSpring
    specificationID
    specification {
      _id
      kSpring
      name
      xFree
    }
    xSpringPreload
    xSecondSpringTransition
  }
  suspension {
    aCamber
    aCamberMeasurement
    aCamberShim
    aCaster
    aCasterMeasurement
    aToe
    aToeMeasurement
    hBumpStopPacker
    hBumpStopStack
    hCamberShim
    hPushRodShim
    hToeLinkSleeveBottom
    hToeLinkSleeveTop
    hToeShim
    prouBracket
    prouPosition
    xBumpStopGap
    xCamberMeasurement
    xDroopStopGap
    xToe
    xToeMeasurement
  }
  xToe
  xToeMeasurement
}
    `;
export const AllAntiRollBarSpecVarsFragmentDoc = `
    fragment AllAntiRollBarSpecVars on AntiRollBarSpec {
  __typename
  _id
  allowableParentSpecIDs
  antiRollBarDisplayLocation
  antiRollBarConfigs {
    position1
    position2
    kARB
    simulationModels
  }
  chassisSpecID
  createdAt
  decommissioned
  iterationIDs
  name
  nextIterationID
  prevIterationID
  updatedAt
}
    `;
export const AllCarSetupAntiRollBarVarsFragmentDoc = `
    fragment AllCarSetupAntiRollBarVars on AntiRollBar {
  kARB
  name
  position
  position1
  position2
  rockerPosition
  specification {
    ...AllAntiRollBarSpecVars
  }
  specificationID
}
    `;
export const ElasticSpecVarsFragmentDoc = `
    fragment ElasticSpecVars on ElasticSpec {
  __typename
  _id
  allowableParentSpecIDs
  allowableSockets
  chassisSpecID
  createdAt
  decommissioned
  elasticType
  forceTable {
    xMin
    xMax
    x
    force
    velocity
    dampingForce
    acceleration
    inertanceForce
  }
  iterationIDs
  iterations {
    _id
    name
  }
  kSpring
  name
  nextIterationID
  prevIterationID
  readingsAllowable
  simulationModels
  updatedAt
  xBumpStopGapDefault
  xDamperSetupDefault
  xDroopStopGapDefault
  xFree
}
    `;
export const AllCarSetupBumpStopVarsFragmentDoc = `
    fragment AllCarSetupBumpStopVars on BumpStop {
  name
  specification {
    ...ElasticSpecVars
  }
  specificationID
  xBumpStopGap
}
    `;
export const AllCarSetupDroopStopVarsFragmentDoc = `
    fragment AllCarSetupDroopStopVars on DroopStop {
  name
  specification {
    ...ElasticSpecVars
  }
  specificationID
  xDroopStopGap
}
    `;
export const AllCarSetupExternalBumpStopVarsFragmentDoc = `
    fragment AllCarSetupExternalBumpStopVars on ExternalBumpStop {
  name
  specification {
    ...ElasticSpecVars
  }
  specificationID
  xExternalBumpStopGap
}
    `;
export const ElasticStuffFragmentDoc = `
    fragment ElasticStuff on CarEnd {
  bumpStop {
    ...AllCarSetupBumpStopVars
  }
  damper {
    ...DamperVars
  }
  droopStop {
    ...AllCarSetupDroopStopVars
  }
  externalBumpStop {
    ...AllCarSetupExternalBumpStopVars
  }
}
    `;
export const EndVarsFragmentDoc = `
    fragment EndVars on CarEnd {
  aCamber
  aCamberMeasurement
  aCaster
  aCasterMeasurement
  antiRollBar {
    ...AllCarSetupAntiRollBarVars
  }
  aToe
  aToeMeasurement
  ...ElasticStuff
  helperSpring {
    specificationID
    kSpring
    specification {
      _id
      name
      kSpring
      xFree
    }
    xSpringPreload
    xSecondSpringTransition
  }
  hRide
  hRideChassis
  hRideMeasurement
  hRideRegulation
  kinematics {
    name
  }
  kinematicsExternalSpec {
    _id
    name
  }
  kinematicsExternalSpecID
  kinematicsInternalSpec {
    _id
    name
  }
  kinematicsInternalSpecID
  spring {
    kSpring
    kSpringLbsIn
    dSpring
    xSpringPreload
    kHelperSpring
    kHelperSpringLbsIn
    specification {
      _id
      name
    }
  }
  thirdElement {
    kSpring
    bumpStop {
      name
    }
    xBumpStopGap
    hBumpStopPacker
  }
  xToe
  xToeMeasurement
}
    `;
export const CarSetupExportVarsFragmentDoc = `
    fragment CarSetupExportVars on CarSetup {
  _id
  setupInfo
  title
  teamID
  chassisAssembly {
    ...ChassisAssemblyForSetupExportVars
  }
  chassisSpec {
    ...ChassisSpecVarsForSetupSheetFlex
  }
  chassisSpecID
  chassisSpecRootID
  chassisAssemblyID
  driver {
    _id
    acronym
  }
  driverID
  engineer {
    _id
    name
  }
  engineerID
  chassis {
    _id
    ballastPositions
    reference
    systemsConfigFields
  }
  chassisID
  custom
  time
  runSheetID
  setupSheetStyle
  runSheet {
    _id
    ...AllRunSheetScalarVars
    contestant {
      _id
      chassis {
        _id
        reference
        type
      }
    }
    driver {
      _id
      acronym
    }
    session {
      event {
        name
        NEventSeason
        tEventEnd
        tEventStart
        trackLayouts {
          name
          track {
            name
          }
        }
        track {
          name
        }
        _id
        type
      }
      _id
      name
      sessionType
      shortName
      tSessionEnd
      tSessionStart
    }
    weather {
      TAir
      TTrack
      pAmbient
      rHumidity
    }
  }
  frontLeft {
    ...CornerVars
  }
  frontRight {
    ...CornerVars
  }
  rearLeft {
    ...CornerVars
  }
  rearRight {
    ...CornerVars
  }
  front {
    ...EndVars
  }
  rear {
    ...EndVars
  }
  massTeam {
    ...MassVars
  }
  massSetup {
    ...MassVars
  }
  massRegulation {
    ...MassVars
  }
  massOutOfGarage {
    ...MassVars
  }
  systemsConfigValues
  mBallasts
  aero {
    ...AeroVars
  }
  brakeSystem {
    ...BrakeSystemVars
  }
  steering {
    ...SteeringVars
  }
  powertrain {
    ...PowertrainVars
    differentialSpec {
      _id
      name
    }
  }
  powertrainCentral {
    ...PowertrainVars
    differentialSpec {
      _id
      name
    }
  }
  powertrainFront {
    ...PowertrainVars
    differentialSpec {
      _id
      name
    }
  }
  powertrainRear {
    ...PowertrainVars
    differentialSpec {
      _id
      name
    }
  }
  info {
    ...InfoVars
  }
}
    `;
export const AllCarSetupAeroVarsFragmentDoc = `
    fragment AllCarSetupAeroVars on Aero {
  NFlapF
  NFlapFL
  NFlapLowerR
  NFlapFR
  NFlapR
  NFlapRL
  NFlapRR
  aFlapF
  Z400
  frontFlapType
  aSplitterF
  hSplitterF
  aFlapFL
  aFlapFR
  aFlapRL
  aFlapRR
  aFlapR
  aFlapLowerR
  aeroPackage
  hGurneyF
  hGurneyR
  splitterID
  noseID
  tailID
  floorLeadingEdgeID
  floorBB
  floorGurney
  frontWheelArch
  lowerDrivePlane
  upperDrivePlane
  rearWingGurney
  tailGurney
}
    `;
export const AllCarSetupAeroElementVarsFragmentDoc = `
    fragment AllCarSetupAeroElementVars on AeroElement {
  _id
  attached
  position
  positionName
  specificationID
}
    `;
export const AllCarSetupAeroSpecVarsFragmentDoc = `
    fragment AllCarSetupAeroSpecVars on AeroPackage {
  specificationID
  aeroElements {
    ...AllCarSetupAeroElementVars
  }
}
    `;
export const AllPersonScalarVarsFragmentDoc = `
    fragment AllPersonScalarVars on Person {
  _id
  acronym
  birthday
  defaultRunSheetCompareStyleID
  defaultRunSheetStyleID
  defaultTyreReferenceTemperature
  defaultTyreSetNameFormat
  dynoConfigID
  email
  hideKPIs
  isActive
  isTimeTracker
  isTimeTrackerAdmin
  name
  passportNumber
  passportPicture
  plotPageConfigIDs
  privateMobile
  privatePhone
  role
  setupOverviewConfigIDs
  teamID
  timeTrackerApprovalByPersonID
  username
  userSetupIDs
  visibleContestantIDs
  visibleEventIDs
  workMobile
  workPhone
}
    `;
export const AllCarSetupBrakeSystemVarsFragmentDoc = `
    fragment AllCarSetupBrakeSystemVars on BrakeSystem {
  brakePedalPosition
  rBrakePedal
  dMasterCylinderF
  masterCylinderFSpec
  dMasterCylinderR
  masterCylinderRSpec
  masterCylinderRodLengthF
  masterCylinderRodlengthR
  brakePadFManufacturer
  brakePadFSpec
  brakePadRManufacturer
  brakePadRSpec
  pBrakeBalanceRef
  rBrakeF
  BBBSEnabled
  xBBSPreload
  kBBSSpring
  kKnockOffSpringF
  kKnockOffSpringR
}
    `;
export const AllCarSetupChassisVarsFragmentDoc = `
    fragment AllCarSetupChassisVars on Chassis {
  _id
  ballastPositions
  concurrentUseAllowed
  currentlyInUse
  decommissioned
  manufacturerPartID
  notes
  properties
  reference
  rootAssemblyIDs
  rootSpecificationID
  setupSheetStyle
  specificationID
  systemsConfigFields
  tagIDs
  type
}
    `;
export const AllChassisAssemblyVarsFragmentDoc = `
    fragment AllChassisAssemblyVars on ChassisAssembly {
  _id
  assemblyTypeEnumID
  buildSheetDisplayLocationIDs
  buildSheetGroupEnumID
  buildSheetNestLevel
  chassisPartID
  chassisSpecID
  createdAt
  current
  decommissioned
  locationID
  name
  nestedPartInstanceIDs
  partInstanceIDs
  properties
  reference
  subAssemblyIDs
  tagIDs
  updatedAt
}
    `;
export const AeroElementVarsFragmentDoc = `
    fragment AeroElementVars on AeroElementSpec {
  _id
  __typename
  name
  updatedAt
  createdAt
  decommissioned
  attachable
  allowableSockets
  allowableParentSpecIDs
  positionNames
  positions
  CzF
  CzR
  CxT
  aeroElementInterpolationMethod
  aeroElementType
  polyCzF
  polyCzR
  polyCxT
  simulationModels
  prevIterationID
  nextIterationID
  iterationIDs
  iterations {
    _id
    name
  }
}
    `;
export const AeroPackageVarsFragmentDoc = `
    fragment AeroPackageVars on AeroPackageSpec {
  _id
  __typename
  name
  updatedAt
  createdAt
  decommissioned
  prevIterationID
  nextIterationID
  aeroElementSpecIDs
  allowableParentSpecIDs
  chassisSpecID
  aeroElementSpecs {
    _id
    ...AeroElementVars
  }
  iterationIDs
  iterations {
    _id
    name
  }
}
    `;
export const AntiRollBarVarsFragmentDoc = `
    fragment AntiRollBarVars on AntiRollBarSpec {
  _id
  __typename
  updatedAt
  createdAt
  name
  decommissioned
  prevIterationID
  nextIterationID
  allowableParentSpecIDs
  chassisSpecID
  antiRollBarDisplayLocation
  antiRollBarConfigs {
    position1
    position2
    kARB
    simulationModels
  }
  iterationIDs
  iterations {
    _id
    name
  }
}
    `;
export const AllChassisMeasurementSpecVarsFragmentDoc = `
    fragment AllChassisMeasurementSpecVars on ChassisMeasurement {
  _id
  description
  displayName
  name
  useInSimulation
}
    `;
export const DamperSpecVarsFragmentDoc = `
    fragment DamperSpecVars on DamperSpec {
  __typename
  _id
  allowableParentSpecIDs
  allowableSockets
  damperAdjusters {
    name
    minSetting
    maxSetting
    step
    settings
    settingNames
  }
  damperConfigs {
    name
    forceTable {
      xMin
      xMax
      x
      force
      velocity
      dampingForce
      acceleration
      inertanceForce
    }
    simulationModels
  }
  chassisSpecID
  createdAt
  decommissioned
  iterationIDs
  iterations {
    _id
    name
  }
  name
  nextIterationID
  prevIterationID
  readingsAllowable
  updatedAt
}
    `;
export const AllChassisSpecVarsIterationFragmentDoc = `
    fragment AllChassisSpecVarsIteration on ChassisSpec {
  _id
  name
  version
  releaseDate
  released
  createdAt
  updatedAt
  decommissioned
  simulationAvailable
  prevIterationID
  nextIterationID
  allowableParentSpecIDs
}
    `;
export const ExternalKinematicSpecVarsFragmentDoc = `
    fragment ExternalKinematicSpecVars on KinematicsExternalSpec {
  _id
  __typename
  updatedAt
  createdAt
  name
  decommissioned
  prevIterationID
  nextIterationID
  iterationIDs
  allowableParentSpecIDs
  chassisSpecID
  initialChassisSpecID
  kinematicsExternalModels {
    aCaster
    simulationModels
    uprightPosition
    uprightPositionName
  }
  axle
  hRide {
    minValue
    maxValue
    step
    values
    valueNames
    unit
    sign
    readingsRequired
  }
  aCamber {
    minValue
    maxValue
    step
    values
    valueNames
    unit
    sign
    readingsRequired
  }
  aToe {
    minValue
    maxValue
    step
    values
    valueNames
    unit
    sign
    readingsRequired
  }
  aCaster {
    minValue
    maxValue
    step
    values
    valueNames
    unit
    sign
    readingsRequired
  }
  aCasterMeasurementGain
  aCasterMeasurementOffset
  iterations {
    _id
    name
  }
}
    `;
export const InternalKinematicSpecVarsFragmentDoc = `
    fragment InternalKinematicSpecVars on KinematicsInternalSpec {
  _id
  __typename
  updatedAt
  createdAt
  name
  decommissioned
  prevIterationID
  nextIterationID
  iterationIDs
  allowableParentSpecIDs
  chassisSpecID
  initialChassisSpecID
  axle
  springReference
  bumpRubberReference
  xSpringRef
  xBumpRubberRef
  xSpringPlatformOffset
  xSpringSetup {
    minValue
    maxValue
    step
    values
    valueNames
    unit
    sign
  }
  xBumpRubberSetup {
    minValue
    maxValue
    step
    values
    valueNames
    unit
    sign
  }
  FSpringSetup {
    minValue
    maxValue
    step
    values
    valueNames
    unit
    sign
  }
  simulationModels
  iterations {
    _id
    name
  }
}
    `;
export const ChassisMassVarsFragmentDoc = `
    fragment ChassisMassVars on ChassisMass {
  base {
    mass
    COGx
    COGy
    COGz
    Ixx
    Iyy
    Izz
  }
  driver {
    mass
    COGx
    COGy
    COGz
    Ixx
    Iyy
    Izz
  }
  setupEquip {
    mass
    COGx
    COGy
    COGz
    Ixx
    Iyy
    Izz
  }
}
    `;
export const GearSpecVarsFragmentDoc = `
    fragment GearSpecVars on GearSpec {
  _id
  __typename
  updatedAt
  createdAt
  name
  decommissioned
  gearType
  prevIterationID
  nextIterationID
  numerator
  denominator
  allowableGearNums
  allowableParentSpecIDs
  chassisSpecID
  isHeadGear
  iterationIDs
  iterations {
    _id
    name
  }
}
    `;
export const GearBoxSpecVarsFragmentDoc = `
    fragment GearBoxSpecVars on GearBoxSpec {
  _id
  __typename
  updatedAt
  createdAt
  name
  assignedGears {
    gearID
    useHeadGear
    gear {
      _id
      isHeadGear
    }
  }
  dropGearSpecID
  bevelSetSpecID
  differentialSpecID
  headGearSpecID
  decommissioned
  prevIterationID
  nextIterationID
  allowableParentSpecIDs
  chassisSpecID
  iterationIDs
  iterations {
    _id
    name
  }
  rootSpecificationID
}
    `;
export const DifferentialSpecVarsFragmentDoc = `
    fragment DifferentialSpecVars on DifferentialSpec {
  _id
  __typename
  updatedAt
  createdAt
  name
  decommissioned
  prevIterationID
  nextIterationID
  allowableParentSpecIDs
  powertrainLocation
  chassisSpecID
  differentialConfigs {
    name
    decommissioned
    rampAccel
    rampDecel
    frictionFaces
    maxPreloadForce
    simulationModels
  }
  iterationIDs
  iterations {
    _id
    name
  }
}
    `;
export const ChassisPowertrainVarsFragmentDoc = `
    fragment ChassisPowertrainVars on ChassisPowertrain {
  layout
  dropGearSpecIDs
  dropGearSpecs {
    _id
    ...GearSpecVars
  }
  bevelSetSpecIDs
  bevelSetSpecs {
    _id
    ...GearSpecVars
  }
  gearBoxSpecIDs
  gearBoxSpecs {
    _id
    ...GearBoxSpecVars
  }
  gearSpecIDs
  gearSpecs {
    _id
    ...GearSpecVars
  }
  differentialSpecIDs
  differentialSpecs {
    _id
    ...DifferentialSpecVars
  }
  numGears
}
    `;
export const ChassisBrakeBiasVarsFragmentDoc = `
    fragment ChassisBrakeBiasVars on AdjustableRatio {
  minValue
  maxValue
  step
  values
  valueNames
  unit
  sign
}
    `;
export const ChassisRegulationSetVarsFragmentDoc = `
    fragment ChassisRegulationSetVars on RegulationSet {
  name
  decommissioned
  massMin
  hRideFrontMin
  hRideRearMin
  massDistRunningMin
  massDistRunningMax
  massDistStaticMin
  massDistStaticMax
}
    `;
export const AllChassisSpecVarsFragmentDoc = `
    fragment AllChassisSpecVars on ChassisSpec {
  _id
  __typename
  aeroPackageSpecIDs
  aeroPackageSpecs {
    _id
    ...AeroPackageVars
  }
  allowableParentSpecIDs
  antiRollBarSpecIDs
  antiRollBarSpecs {
    _id
    ...AntiRollBarVars
  }
  buildSheetStyleIDs
  buildSheetStyles {
    _id
    name
  }
  buildSheetVisible
  bumpRubberSpecIDs
  bumpRubberSpecs {
    _id
    ...ElasticSpecVars
  }
  calculationIDs
  calculations {
    _id
    ...CalculationVars
  }
  canopyVersion
  chassisMeasurementIDs
  chassisMeasurements {
    ...AllChassisMeasurementSpecVars
  }
  concurrentUseAllowed
  copyReferencePackageID
  createdAt
  customSpecIDs
  customSpecs {
    _id
    ...CustomSpecVars
  }
  customSpecTypes
  customSimulationModels {
    data
    dataMapping
    endPoint
    name
    serverPort
    version
  }
  damperSpecIDs
  damperSpecs {
    _id
    ...DamperSpecVars
  }
  decommissioned
  flattened
  flattenedKeys
  helperSpringSpecIDs
  helperSpringSpecs {
    _id
    ...ElasticSpecVars
  }
  iterationIDs
  iterations {
    ...AllChassisSpecVarsIteration
  }
  kinematicsExternalSpecIDs
  kinematicsExternalSpecs {
    _id
    ...ExternalKinematicSpecVars
  }
  kinematicsInternalSpecIDs
  kinematicsInternalSpecs {
    _id
    ...InternalKinematicSpecVars
  }
  mass {
    ...ChassisMassVars
  }
  measurements {
    ...ChassisMeasurementVars
  }
  modelTypes
  name
  nextIterationID
  powertrain {
    ...ChassisPowertrainVars
  }
  powerUnits {
    name
    simulationModels
  }
  prevIterationID
  rBrakeBias {
    ...ChassisBrakeBiasVars
  }
  reboundSpringSpecIDs
  reboundSpringSpecs {
    _id
    ...ElasticSpecVars
  }
  regulationSets {
    ...ChassisRegulationSetVars
  }
  released
  releaseDate
  rootSpecificationID
  setupChangesFilter {
    blackListFilter
    whiteListFilter
  }
  setupSheetStyleIDs
  setupSheetStyles {
    _id
    name
  }
  simulationAvailable
  simulationModels
  sockets {
    name
  }
  specificationGroupIDs
  specificationGroups {
    _id
    name
  }
  springSpecIDs
  springSpecs {
    _id
    ...ElasticSpecVars
  }
  tagIDs
  tags {
    _id
  }
  torsionBarSpecIDs
  torsionBarSpecs {
    _id
    ...ElasticSpecVars
  }
  trackingItemIDs
  trackingItems {
    _id
    name
  }
  trackingSourceIDs
  trackingSources {
    _id
    description
    displayUnit
    name
    NDecimals
    sourceIDs
    sources {
      _id
      aliasString
      aliasType
      description
      displayUnit
    }
  }
  updatedAt
  version
}
    `;
export const AllCarSetupDamperVarsFragmentDoc = `
    fragment AllCarSetupDamperVars on Damper {
  adjusters {
    _id
    name
    settingName
    value
  }
  configName
  gasPressure
  manufacturer
  NDamperBumpDO
  NDamperBumpDY
  NDamperBumpHS
  NDamperBumpIP
  NDamperBumpLS
  NDamperReboundDO
  NDamperReboundDY
  NDamperReboundHS
  NDamperReboundIP
  NDamperReboundLS
  specification {
    ...DamperSpecVars
  }
  specificationID
  valvingBumpSpec
  valvingReboundSpec
  xDamperMax
}
    `;
export const AllCarSetupSpringVarsFragmentDoc = `
    fragment AllCarSetupSpringVars on Spring {
  specification {
    ...ElasticSpecVars
  }
  specificationID
  xSecondSpringTransition
  xSpringPreload
}
    `;
export const AllCarSetupEndVarsFragmentDoc = `
    fragment AllCarSetupEndVars on CarEnd {
  aCamber
  aCamberMeasurement
  aCaster
  aCasterMeasurement
  aToe
  aToeMeasurement
  antiRollBar {
    ...AllCarSetupAntiRollBarVars
  }
  bumpStop {
    ...AllCarSetupBumpStopVars
  }
  damper {
    ...AllCarSetupDamperVars
  }
  droopStop {
    ...AllCarSetupDroopStopVars
  }
  externalBumpStop {
    ...AllCarSetupExternalBumpStopVars
  }
  helperSpring {
    ...AllCarSetupSpringVars
  }
  hRide
  hRideChassis
  hRideMeasurement
  hRideRegulation
  kinematicsExternalSpec {
    ...ExternalKinematicSpecVars
  }
  kinematicsExternalSpecID
  kinematicsInternalSpec {
    ...InternalKinematicSpecVars
  }
  kinematicsInternalSpecID
  reboundSpring {
    ...AllCarSetupSpringVars
  }
  spring {
    ...AllCarSetupSpringVars
  }
  xToe
  xToeMeasurement
}
    `;
export const AllCarSetupCornerVarsFragmentDoc = `
    fragment AllCarSetupCornerVars on CarCorner {
  aCamber
  aCamberMeasurement
  aCaster
  aCasterMeasurement
  aToe
  aToeMeasurement
  bumpStop {
    ...AllCarSetupBumpStopVars
  }
  damper {
    ...AllCarSetupDamperVars
  }
  droopStop {
    ...AllCarSetupDroopStopVars
  }
  externalBumpStop {
    ...AllCarSetupExternalBumpStopVars
  }
  helperSpring {
    ...AllCarSetupSpringVars
  }
  hRide
  hRideChassis
  hRideMeasurement
  hRideRegulation
  pTyreTarget
  reboundSpring {
    ...AllCarSetupSpringVars
  }
  spring {
    ...AllCarSetupSpringVars
  }
  xToe
  xToeMeasurement
}
    `;
export const AllHistoryVarsFragmentDoc = `
    fragment AllHistoryVars on History {
  _id
  createdAt
  type
  updatedAt
  userID
  valuesChanged {
    field
    value
  }
}
    `;
export const AllCarSetupInfoFragmentDoc = `
    fragment AllCarSetupInfo on CarInfo {
  batteryID
  gearboxID
  NIssue
  NChanges
  inverterID
  driveshaftID
  engineID
  chassisID
  setupComments
  tyreCompound
  customIDs
}
    `;
export const AllCarSetupMassVarsFragmentDoc = `
    fragment AllCarSetupMassVars on CarMass {
  comment
  mCarFL
  mCarFR
  mCarRL
  mCarRR
  mCarTotal
  mDriver
  rCarCross
  rWeightF
  rWeightFTarget
}
    `;
export const AllCarSetupPowertrainVarsFragmentDoc = `
    fragment AllCarSetupPowertrainVars on Powertrain {
  differentialSpecID
  differentialConfigName
  aDiffRampDrive
  aDiffRampCoast
  MDiffPreloadCold
  MDiffPreloadHot
  NFrictionFaces
  frictionFaces
  dAirRestrictor
  clutch
  clutchCylinder
  gearboxGridType
  PPowerLevel
  rDropGear
  rBevelSet
  rGearRatios
  blanking
}
    `;
export const AllRunBrakeFragmentDoc = `
    fragment AllRunBrake on RunBrake {
  hBrakeDiscPreRun
  TBrakePostRun
  TBrakePreRun
  thicknessMeasurements
}
    `;
export const AllRunSheetConsumptionVarsFragmentDoc = `
    fragment AllRunSheetConsumptionVars on LayoutConsumption {
  trackLayoutID
  energyRequired {
    ...AllRunEnergyVars
  }
  fuelRequired {
    ...AllRunEnergyVars
  }
  SoCRequired {
    ...AllRunEnergyVars
  }
}
    `;
export const AllContestantScalarVarsFragmentDoc = `
    fragment AllContestantScalarVars on Contestant {
  _id
  chassisIDs
  class
  color
  driverIDs
  eligibleForPoints
  hidden
  seasonID
  startNumber
  teamID
  thirdPartyContestantID
  transcribbleAudioURI
  tyreIDs
  tyreSetIDs
}
    `;
export const AllJobScalarVarsFragmentDoc = `
    fragment AllJobScalarVars on Job {
  _id
  acknowledgedAt
  acknowledgedByID
  assigneeIDs
  cancelledAt
  cancelledByID
  category
  closedAt
  closedByID
  createdAt
  createdByID
  description
  oneWordStatus
  priority
  runSheetID
  tagIDs
  updatedAt
}
    `;
export const AllSessionScalarVarsFragmentDoc = `
    fragment AllSessionScalarVars on Session {
  _id
  assignedSetupIDs
  bestValuesID
  debriefNotes
  eventID
  isLinkedSession
  isTimingTest
  liveStandingsCurrentLap
  liveStandingsUpdatedAt
  name
  nextSessionID
  prevSessionID
  pTyreFLMinSession
  pTyreFRMinSession
  pTyreRLMinSession
  pTyreRRMinSession
  sessionType
  shortName
  tagIDs
  timeRemaining
  timeRemainingUpdatedAt
  transcribbleSessionID
  tSessionEnd
  tSessionStart
}
    `;
export const AllSessionVarsFragmentDoc = `
    fragment AllSessionVars on Session {
  ...AllSessionScalarVars
  event {
    ...AllEventScalarVars
  }
}
    `;
export const AllRunSheetVarsFragmentDoc = `
    fragment AllRunSheetVars on RunSheet {
  _id
  associatedKpiFiles
  brakeComment
  brakeFL {
    ...AllRunBrake
  }
  brakeFR {
    ...AllRunBrake
  }
  brakeRL {
    ...AllRunBrake
  }
  brakeRR {
    ...AllRunBrake
  }
  brakePostRunMeasurementsFL
  brakePostRunMeasurementsFR
  brakePostRunMeasurementsRL
  brakePostRunMeasurementsRR
  brakePreRunMeasurementsFL
  brakePreRunMeasurementsFR
  brakePreRunMeasurementsRL
  brakePreRunMeasurementsRR
  chassisAssemblyID
  cloudStorageURL
  consumptions {
    ...AllRunSheetConsumptionVars
  }
  contestant {
    ...AllContestantScalarVars
  }
  contestantID
  controlsComment
  createdAt
  dashboard {
    mFuelRunEnd
    mFuelRunStart
  }
  DFuel
  dilComments
  driver {
    ...AllPersonScalarVars
  }
  driverComments
  driverID
  endTime
  engineer {
    ...AllPersonScalarVars
  }
  engineerComments
  engineerID
  fastestLap
  finishTyreHeatingBy
  fuelDrainedBeforeRun
  history {
    ...AllHistoryVars
  }
  historyIDs
  isLockedByLaptimeService
  jobs {
    ...AllJobScalarVars
  }
  issueIDs
  jobIDs
  kpiFileName
  kpiStatus
  kpiUpdatedAt
  lapCount
  lapIDs
  lastModifiedByID
  mFuelAdded
  mFuelDrainedCatchTank
  mFuelDrainedMainTank
  mFuelRunEnd
  mFuelRunStart
  mileage
  nextRunSheetID
  NRun
  NRunTiming
  prevRunSheetID
  problemComments
  qRefuel
  rEnergyAdded
  rEnergyRunEnd
  rEnergyRunStart
  rSOCAdded
  rSOCRunEnd
  rSOCRunStart
  runDescription
  runSheetStyleID
  selectedJobListTemplateID
  session {
    ...AllSessionVars
  }
  sessionID
  setupID
  simResultIDs
  skidComment
  skidPlateID
  skidPostRunMeasurements
  skidPreRunMeasurements
  startTime
  startTyreHeatingAt
  systemsComments
  tagIDs
  TCellMaxRunStart
  teamID
  thirdPartyRunID
  timingServiceShouldIgnore
  tRefuel
  tyreComments
  tyreCompoundTiming
  tyreSetID
  updatedAt
  VFuelAdded
  writeHistory
}
    `;
export const AllCarSetupSteeringVarsFragmentDoc = `
    fragment AllCarSetupSteeringVars on Steering {
  steeringPinion
  steeringArm
  rSteerF
}
    `;
export const AllTeamVarsFragmentDoc = `
    fragment AllTeamVars on Team {
  _id
  color
  name
  raceSeriesID
  shortName
  tagIDs
  tags {
    ...AllTagVars
  }
}
    `;
export const AllCarSetupVarsFragmentDoc = `
    fragment AllCarSetupVars on CarSetup {
  _id
  aero {
    ...AllCarSetupAeroVars
  }
  aeroPackage {
    ...AllCarSetupAeroSpecVars
  }
  author {
    ...AllPersonScalarVars
  }
  authorID
  brakeSystem {
    ...AllCarSetupBrakeSystemVars
  }
  chassis {
    ...AllCarSetupChassisVars
  }
  chassisAssembly {
    ...AllChassisAssemblyVars
  }
  chassisAssemblyID
  chassisID
  chassisSpec {
    ...AllChassisSpecVars
  }
  chassisSpecID
  chassisSpecRootID
  chassisSpecRoot {
    ...AllChassisSpecVars
  }
  cockpit {
    rThrottlePedal
    throttlePedalPosition
  }
  contestantID
  createdAt
  custom
  customSimulationPayload
  customSimulationPayloadEnabled
  driver {
    ...AllPersonScalarVars
  }
  driverID
  engineer {
    ...AllPersonScalarVars
  }
  engineerID
  eventID
  flattened
  flattenedValues
  front {
    ...AllCarSetupEndVars
  }
  frontLeft {
    ...AllCarSetupCornerVars
  }
  frontRight {
    ...AllCarSetupCornerVars
  }
  history {
    ...AllHistoryVars
  }
  historyIDs
  info {
    ...AllCarSetupInfo
  }
  intendedForSession
  isPublic
  lastModifiedBy {
    ...AllPersonScalarVars
  }
  massOutOfGarage {
    ...AllCarSetupMassVars
  }
  mBallasts
  massRegulation {
    ...AllCarSetupMassVars
  }
  massSetup {
    ...AllCarSetupMassVars
  }
  massTeam {
    ...AllCarSetupMassVars
  }
  powertrainCentral {
    ...AllCarSetupPowertrainVars
  }
  powertrainFront {
    ...AllCarSetupPowertrainVars
  }
  powertrainRear {
    ...AllCarSetupPowertrainVars
  }
  rear {
    ...AllCarSetupEndVars
  }
  rearLeft {
    ...AllCarSetupCornerVars
  }
  rearRight {
    ...AllCarSetupCornerVars
  }
  runSheet {
    ...AllRunSheetVars
  }
  runSheetID
  setupSheetStyle
  steering {
    ...AllCarSetupSteeringVars
  }
  systemsConfigComment
  systemsConfigNIssues
  systemsConfigValues
  tagIDs
  tags {
    ...AllTagVars
  }
  team {
    ...AllTeamVars
  }
  teamID
  time
  title
  updatedAt
  writeHistory
}
    `;
export const BasicContestantVarsFragmentDoc = `
    fragment BasicContestantVars on Contestant {
  _id
  startNumber
  teamID
  class
}
    `;
export const ContestantVarsFragmentDoc = `
    fragment ContestantVars on Contestant {
  _id
  seasonID
  startNumber
  class
  chassisIDs
  teamID
  chassis {
    _id
    reference
  }
  tyreIDs
  tyres {
    _id
    name
  }
  driverIDs
  drivers {
    _id
    name
  }
  color
  hidden
  manufacturerID
  manufacturer {
    _id
    name
  }
}
    `;
export const EventBaseVarsFragmentDoc = `
    fragment EventBaseVars on Event {
  _id
  name
  season {
    _id
    name
    raceSeries {
      _id
      name
    }
    contestants {
      _id
      startNumber
    }
  }
}
    `;
export const SessionWithTimesVarsFragmentDoc = `
    fragment SessionWithTimesVars on Session {
  _id
  name
  sessionType
  shortName
  tSessionStart
  tSessionEnd
}
    `;
export const EventInSeasonVarsFragmentDoc = `
    fragment EventInSeasonVars on Event {
  _id
  name
  eventType
  NEventSeason
  tEventStart
  tEventEnd
  tLapAverage
  track {
    _id
    timeZone
  }
  sessionIDs
  sessions {
    _id
    sessionType
    ...SessionWithTimesVars
  }
}
    `;
export const EventTrackLayoutConsumptionVarsFragmentDoc = `
    fragment EventTrackLayoutConsumptionVars on Event {
  _id
  consumptions {
    trackLayout {
      _id
      ...TrackLayoutVars
    }
    trackLayoutID
    energyRequired {
      ...AllRunEnergyVars
    }
    fuelRequired {
      ...AllRunEnergyVars
    }
    SoCRequired {
      ...AllRunEnergyVars
    }
  }
}
    `;
export const JobVarsFragmentDoc = `
    fragment JobVars on Job {
  _id
  number
  index
  priority
  updatedAt
  createdAt
  createdBy {
    _id
    name
  }
  assignees {
    _id
    name
  }
  assigneeIDs
  acknowledgedAt
  acknowledgedBy {
    _id
    name
  }
  cancelledBy {
    _id
    name
  }
  cancelledAt
  closedAt
  closedBy {
    _id
    name
  }
  description
  comments {
    _id
    ...CommentVars
  }
  oneWordStatus
  parentJob {
    _id
    __typename
  }
  parentIssue {
    _id
    __typename
    description
    number
  }
  parentID
  runSheetID
  runSheet {
    _id
    NRun
    contestant {
      _id
      startNumber
    }
    session {
      _id
      name
      event {
        _id
        name
      }
    }
  }
  subTaskIDs
  subTasks {
    ...SubTaskVars
  }
}
    `;
export const JobListTemplateJobVarsFragmentDoc = `
    fragment JobListTemplateJobVars on TemplateJob {
  index
  description
  priority
  assignees {
    _id
    name
  }
  assigneeIDs
}
    `;
export const JobListTemplateVarsFragmentDoc = `
    fragment JobListTemplateVars on TemplateJobList {
  _id
  index
  jobs {
    ...JobListTemplateJobVars
  }
  title
}
    `;
export const GridPlotPageConfigPlotVarsFragmentDoc = `
    fragment GridPlotPageConfigPlotVars on PlotConfig {
  index
  title
  xDataSource
  yDataSource
  yData
  xLabel
  xAxisType
  yLabel
  yLines {
    value
    color
  }
}
    `;
export const EnergyUsedVarsFragmentDoc = `
    fragment EnergyUsedVars on RunSheet {
  _id
  DFuel
  fuelDrainedBeforeRun
  mFuelAdded
  mFuelDrainedCatchTank
  mFuelDrainedMainTank
  mFuelRunEnd
  mFuelRunStart
  mFuelUsedPreRun
  rEnergyAdded
  rEnergyRunEnd
  rEnergyRunStart
  rSOCAdded
  rSOCRunEnd
  rSOCRunStart
}
    `;
export const LapVarsFragmentDoc = `
    fragment LapVars on Lap {
  _id
  BPitIn
  BPitOut
  data {
    ...LapDataVars
  }
  energyLapStart
  energyRemaining
  energyRemainingData
  fuelConsumptionThisLap
  lapComment
  lapCommentSystems
  lapKPI(fields: [])
  ...LapNumberVars
  laptimeServiceHash
  lapType
  mFuelConsumptionThisLap
  mFuelLapEnd
  mFuelLapStart
  position
  powerMode
  raceControlMessage
  rEnergyConsumptionThisLap
  rEnergyLapEnd
  rEnergyLapStart
  rSOCConsumptionThisLap
  rSOCLapEnd
  rSOCLapStart
  TCell
  tDay
  tDayPitIn
  tDayPitOut
  tLapManual
  tLapMax
  trackLayout {
    _id
    name
    lapLengthOfficial
    lapLengthCarData
    lapLengthRoulette
    NSectorsTiming
  }
  trackLayoutID
  tSectorsManual
  tSectorsOfficial
  tSectorsTiming
  tyreCompoundTiming
  vCarLapMax
  vCarSectors
}
    `;
export const RunSheetVarsFragmentDoc = `
    fragment RunSheetVars on RunSheet {
  ...EnergyUsedVars
  ...RunCommentVars
  _id
  brakePostRunMeasurementsFL
  brakePostRunMeasurementsFR
  brakePostRunMeasurementsRL
  brakePostRunMeasurementsRR
  brakePreRunMeasurementsFL
  brakePreRunMeasurementsFR
  brakePreRunMeasurementsRL
  brakePreRunMeasurementsRR
  chassisAssemblyID
  consumptions {
    trackLayoutID
    trackLayout {
      _id
      name
      track {
        _id
        name
      }
    }
    energyRequired {
      ...AllRunEnergyVars
    }
    fuelRequired {
      ...AllRunEnergyVars
    }
    SoCRequired {
      ...AllRunEnergyVars
    }
  }
  contestant {
    _id
    startNumber
  }
  contestantID
  createdAt
  dashboard {
    mFuelRunEnd
    mFuelRunStart
  }
  dataServiceFileNameOverride
  driver {
    _id
    acronym
    name
  }
  driverID
  endTime
  endTimeLTS
  endTimeManual
  fuelRequired {
    ...AllRunEnergyVars
  }
  info
  isLocked
  isLockedByLaptimeService
  issueIDs
  jobIDs
  kpiUpdatedAt
  laps {
    _id
    ...LapVars
  }
  laptimeThresholds {
    cool
    prep
    push
  }
  lastModifiedBy {
    _id
    name
  }
  mileage
  nextRunSheetID
  NRun
  NRunTiming
  prevRunSheetID
  runKPI(fields: [])
  selectedJobListTemplateID
  sessionID
  setup {
    isLocked
    setupSheetStyle
  }
  setupID
  skidPostRunMeasurements
  skidPreRunMeasurements
  SoCRequired {
    ...AllRunEnergyVars
  }
  startTime
  startTimeLTS
  startTimeManual
  TCellMaxRunStart
  teamID
  tGarageTurnaround
  timingServiceShouldIgnore
  tSessionRemainingOverride
  tSessionRemainingStartRun
  tWaitBeforeRun
  tyreFL {
    ...RunTyreVars
  }
  tyreFR {
    ...RunTyreVars
  }
  tyrePressureSettings {
    TTrackReference
  }
  tyreRL {
    ...RunTyreVars
  }
  tyreRR {
    ...RunTyreVars
  }
  tyreSetID
  updatedAt
  weather {
    TAir
    TTrack
    pAmbient
    rHumidity
    DAir
    TAirOfficial
    TTrackOfficial
    ambientCondition
    trackCondition
  }
}
    `;
export const RunEnergyVarsFragmentDoc = `
    fragment RunEnergyVars on RunEnergy {
  ATTACK
  COOL
  FCY
  IN
  OUT
  OUTIN
  PITLANE
  PREP
  PUSH
  QUALI
  SAFETYCAR
  SHAKEDOWN
  SLOW
  TARGET
  TOGRID
  TOPADDOCK
  TOPITS
  UNFINISHED
  outLap
  inLap
  outInLap
  pushLap
  targetLap
  slowLap
  unfinishedLap
  coolLap
  attackLap
  qualiLap
  prepLap
  toGridLap
  toPitsLap
  fullCourseYellowLap
  safetyCarLap
  pitlaneLap
  shakedownLap
}
    `;
export const TyreDefaultFragmentFragmentDoc = `
    fragment tyreDefaultFragment on EventTyreDefaults {
  pTyreTarget
  pTyreMin
  pTyreStartRun
}
    `;
export const RunSheetSessionVarsFragmentDoc = `
    fragment RunSheetSessionVars on RunSheet {
  _id
  session {
    _id
    eventID
    name
    shortName
    tSessionEnd
    tSessionStart
    timeRemaining
    event {
      _id
      contestants {
        _id
        drivers {
          _id
          acronym
          displayColor
          name
        }
      }
      name
      DFuel
      consumptions {
        trackLayoutID
        fuelRequired {
          ...RunEnergyVars
        }
        SoCRequired {
          ...RunEnergyVars
        }
        energyRequired {
          ...RunEnergyVars
        }
      }
      season {
        _id
        name
        raceSeries {
          _id
          name
        }
      }
      track {
        timeZone
      }
      trackLayouts {
        _id
        name
        NSectorsTiming
        lapLengthOfficial
        trackID
        track {
          name
        }
      }
      tyreDefaults {
        frontLeft {
          pTyreTarget
        }
        frontRight {
          pTyreTarget
        }
        rearLeft {
          pTyreTarget
        }
        rearRight {
          pTyreTarget
        }
      }
      tyreDefaultsFL {
        ...tyreDefaultFragment
      }
      tyreDefaultsFR {
        ...tyreDefaultFragment
      }
      tyreDefaultsRL {
        ...tyreDefaultFragment
      }
      tyreDefaultsRR {
        ...tyreDefaultFragment
      }
      tyreDefaultsWetFL {
        ...tyreDefaultFragment
      }
      tyreDefaultsWetFR {
        ...tyreDefaultFragment
      }
      tyreDefaultsWetRL {
        ...tyreDefaultFragment
      }
      tyreDefaultsWetRR {
        ...tyreDefaultFragment
      }
    }
    prevSessionID
  }
}
    `;
export const CarSetupVarsFragmentDoc = `
    fragment CarSetupVars on CarSetup {
  _id
  title
  teamID
  createdAt
  updatedAt
  driver {
    _id
    acronym
  }
  driverID
  engineer {
    _id
    name
  }
  engineerID
  chassisID
  chassisSpecID
  chassisSpec {
    _id
    name
    setupSheetStyleIDs
    otherSetupSheetStyleIDs
    canopyVersion
    calculations {
      ...CalculationVars
    }
    customSimulationModels {
      name
      version
    }
    measurements {
      xWheelbase
      xTrackFront
      xTrackRear
    }
    simulationModels
    version
  }
  chassisSpecRootID
  custom
  customSimulationPayload
  customSimulationPayloadEnabled
  isLocked
  time
  runSheetID
  setupSheetStyle
  flattened
  lastModifiedBy {
    name
  }
  runSheet {
    _id
    NRun
    NRunTiming
    prevRunSheetID
    nextRunSheetID
    teamID
    contestant {
      _id
      chassis {
        _id
        reference
        type
      }
    }
    contestantID
    driver {
      _id
      acronym
    }
    weather {
      TAir
      TTrack
      pAmbient
      rHumidity
    }
    session {
      _id
      shortName
      name
      event {
        _id
        name
        trackLayouts {
          _id
          track {
            _id
            name
          }
        }
      }
    }
  }
  frontLeft {
    ...CornerVars
  }
  frontRight {
    ...CornerVars
  }
  rearLeft {
    ...CornerVars
  }
  rearRight {
    ...CornerVars
  }
  front {
    ...EndVars
  }
  rear {
    ...EndVars
  }
  massTeam {
    ...MassVars
  }
  massSetup {
    ...MassVars
  }
  massRegulation {
    ...MassVars
  }
  massOutOfGarage {
    ...MassVars
  }
  systemsConfigValues
  mBallasts
  aero {
    ...AeroVars
  }
  brakeSystem {
    ...BrakeSystemVars
  }
  steering {
    ...SteeringVars
  }
  powertrainFront {
    ...PowertrainVars
  }
  powertrainRear {
    ...PowertrainVars
  }
  powertrain {
    ...PowertrainVars
  }
  info {
    ...InfoVars
  }
  chassis {
    _id
    systemsConfigFields
    ballastPositions
  }
}
    `;
export const RunSheetExportVarsFragmentDoc = `
    fragment RunSheetExportVars on RunSheet {
  _id
  ...RunSheetVars
  ...RunSheetSessionVars
  setup {
    _id
    ...CarSetupVars
  }
}
    `;
export const SessionDriverVarsFragmentDoc = `
    fragment SessionDriverVars on RunSheet {
  _id
  endTime
  contestantID
  NRun
  NRunTiming
  driverID
  driver {
    _id
    acronym
  }
  setupID
  tyreSet {
    _id
    name
    tyreFR {
      _id
      name
    }
    tyreFL {
      _id
      name
    }
    tyreRL {
      _id
      name
    }
    tyreRR {
      _id
      name
    }
  }
  fuelRequired {
    ...AllRunEnergyVars
  }
  SoCRequired {
    ...AllRunEnergyVars
  }
  tyreFL {
    tyreID
    pTyre
    TTyre
    TTyrePostRun
    TTyrePostRunBleed
    pTyrePostRun
    pTyrePostRunBleed
  }
  tyreFR {
    tyreID
    pTyre
    TTyre
    TTyrePostRun
    TTyrePostRunBleed
    pTyrePostRun
    pTyrePostRunBleed
  }
  tyreRL {
    tyreID
    pTyre
    TTyre
    TTyrePostRun
    TTyrePostRunBleed
    pTyrePostRun
    pTyrePostRunBleed
  }
  tyreRR {
    tyreID
    pTyre
    TTyre
    TTyrePostRun
    TTyrePostRunBleed
    pTyrePostRun
    pTyrePostRunBleed
  }
  laps {
    _id
    ...LapVars
  }
}
    `;
export const RunSheetForTyreVarsFragmentDoc = `
    fragment RunSheetForTyreVars on RunSheet {
  _id
  NRun
  NRunTiming
  laps {
    _id
    NLapRun
    trackLayoutID
  }
  tyreFL {
    ...RunTyreVars
  }
  tyreFR {
    ...RunTyreVars
  }
  tyreRL {
    ...RunTyreVars
  }
  tyreRR {
    ...RunTyreVars
  }
  session {
    _id
    name
    event {
      _id
      DFuel
      trackLayouts {
        _id
        lapLengthOfficial
        lapLengthCarData
        lapLengthRoulette
      }
    }
  }
  mileage
}
    `;
export const RunSheetForTyreMileageExportVarsFragmentDoc = `
    fragment RunSheetForTyreMileageExportVars on RunSheet {
  _id
  NRun
  NRunTiming
  mileage
  session {
    _id
    shortName
  }
}
    `;
export const RunSheetForEventSelectionVarsFragmentDoc = `
    fragment RunSheetForEventSelectionVars on RunSheet {
  _id
  info
  NRun
  NRunTiming
  contestant {
    _id
    hidden
    startNumber
  }
  driver {
    _id
    name
    acronym
  }
  session {
    _id
    name
    shortName
    tSessionStart
    event {
      _id
      name
    }
  }
  setupID
  setup {
    _id
    setupInfo
    title
    chassisSpec {
      _id
      name
      simulationModels
    }
  }
  updatedAt
}
    `;
export const RunSheetForEventSelectionForKpiSetupSimContextVarsFragmentDoc = `
    fragment RunSheetForEventSelectionForKPISetupSimContextVars on RunSheet {
  _id
  NRun
  NRunTiming
  contestant {
    _id
    startNumber
  }
  driver {
    _id
    name
    acronym
  }
  session {
    _id
    name
    shortName
    event {
      _id
      name
    }
  }
  setupID
  setup {
    _id
    title
    chassisSpec {
      _id
      name
    }
  }
}
    `;
export const RunSheetSimulationVarsFragmentDoc = `
    fragment RunSheetSimulationVars on RunSheet {
  _id
  simResultIDs
  setupID
  setup {
    _id
    title
    chassisSpec {
      _id
      name
      simulationModels
    }
  }
  weather {
    TAirOfficial
    pAmbient
    rHumidity
  }
  session {
    event {
      name
    }
    shortName
  }
  contestant {
    startNumber
  }
  NRun
  NRunTiming
}
    `;
export const SessionBaseVarsFragmentDoc = `
    fragment SessionBaseVars on Session {
  _id
  name
  shortName
  eventID
}
    `;
export const BasicSessionVarsFragmentDoc = `
    fragment BasicSessionVars on Session {
  _id
  name
  shortName
}
    `;
export const SessionInRangeVarsFragmentDoc = `
    fragment SessionInRangeVars on Session {
  _id
  name
  shortName
  tSessionStart
  tSessionEnd
  sessionType
  event {
    name
    _id
    season {
      name
      _id
      raceSeries {
        name
        _id
      }
    }
  }
}
    `;
export const SetupOverviewConfigFieldVarsFragmentDoc = `
    fragment SetupOverviewConfigFieldVars on SetupOverviewConfigField {
  _id
  keys
  label
  unit
  decimals
  gain
}
    `;
export const SetupOverviewConfigRowElementVarsFragmentDoc = `
    fragment SetupOverviewConfigRowElementVars on SetupOverviewConfigRowElement {
  _id
  decimals
  field
  gain
  suffix
  unitType {
    ... on AngleUnitField {
      angleUnit: unit
    }
    ... on PressureUnitField {
      pressureUnit: unit
    }
    ... on LengthUnitField {
      lengthUnit: unit
    }
    ... on TemperatureUnitField {
      temperatureUnit: unit
    }
    ... on MassUnitField {
      massUnit: unit
    }
    ... on SpringRateUnitField {
      springRateUnit: unit
    }
    ... on TorqueUnitField {
      torqueUnit: unit
    }
    ... on ForceUnitField {
      forceUnit: unit
    }
    ... on RatioUnitField {
      ratioUnit: unit
    }
    ... on PowerUnitField {
      powerUnit: unit
    }
    ... on NumberUnitField {
      numberUnit: unit
    }
    ... on StringUnitField {
      stringUnit: unit
    }
  }
}
    `;
export const SetupOverviewConfigRowVarsFragmentDoc = `
    fragment SetupOverviewConfigRowVars on SetupOverviewConfigRow {
  _id
  elements {
    _id
    ...SetupOverviewConfigRowElementVars
  }
  title
}
    `;
export const SetupSheetStyleBlockVarsFragmentDoc = `
    fragment SetupSheetStyleBlockVars on SetupSheetStyleBlock {
  _id
  x
  y
  width
  height
  borderColor
  backgroundColor
  tabs {
    title
    type
    rows {
      items {
        type
        label
        fieldKey
        colSpan
        widthRatio
        restrictedToRoles
        _id
      }
      _id
    }
    groups {
      header
      rows {
        items {
          type
          label
          fieldKey
          colSpan
          widthRatio
          restrictedToRoles
          _id
        }
        _id
      }
      _id
    }
  }
}
    `;
export const SimResultVarsFragmentDoc = `
    fragment SimResultVars on SimResult {
  carSetupID
  trackLayoutID
  specificationID
  runSheetID
  source
  simulationService
  version
  sourceReferenceID
  simType
  TAmbient
  pAmbient
  rHumidity
  carSetupModifiedAt
  refValues
  defaultChannelTime
  carSetup {
    _id
    title
    ...CarSetupVars
  }
  data {
    _id
    ...SimResultDataVars
  }
  requesterID
  status
  statusMessage
  _id
  updatedAt
  createdAt
  isCarSetupChanged
  trackLayout {
    _id
    ...TrackLayoutVars
  }
  requester {
    _id
    name
    username
  }
}
    `;
export const SimResultCondensedVarsFragmentDoc = `
    fragment SimResultCondensedVars on SimResult {
  _id
  updatedAt
  createdAt
  status
  statusMessage
  carSetupID
  specificationID
  simulationService
  version
  sourceReferenceID
  simType
  carSetupModifiedAt
  isCarSetupChanged
  requesterID
}
    `;
export const AllAeroElementSpecVarsFragmentDoc = `
    fragment AllAeroElementSpecVars on AeroElementSpec {
  _id
  aeroElementInterpolationMethod
  aeroElementType
  aeroPackageSpecID
  allowableParentSpecIDs
  allowableSockets
  attachable
  buildSheetVisible
  chassisSpecID
  concurrentUseAllowed
  createdAt
  CxT
  CzF
  CzR
  decommissioned
  initialChassisSpecID
  iterationIDs
  name
  nextIterationID
  polyCxT
  polyCzF
  polyCzR
  positionNames
  positions
  prevIterationID
  released
  rootSpecificationID
  simulationModels
  specificationGroupID
  tagIDs
  trackingItemIDs
  updatedAt
}
    `;
export const AllAeroPackageSpecVarsFragmentDoc = `
    fragment AllAeroPackageSpecVars on AeroPackageSpec {
  __typename
  _id
  aeroElementSpecIDs
  aeroElementSpecs {
    _id
    ...AllAeroElementSpecVars
  }
  allowableParentSpecIDs
  chassisSpecID
  createdAt
  decommissioned
  iterationIDs
  name
  nextIterationID
  prevIterationID
  updatedAt
}
    `;
export const TrackVarsFragmentDoc = `
    fragment TrackVars on Track {
  _id
  altitude
  acronym
  cameras
  geoLocation {
    coordinates
    type
  }
  layoutIDs
  layouts {
    _id
    acronym
    name
    lapLengthOfficial
  }
  name
  trackPicture {
    id
    name
    mimeType
    url
    thumbnailUrl
  }
  timeZone
  weatherStations
}
    `;
export const TyreVarsFragmentDoc = `
    fragment TyreVars on Tyre {
  _id
  axle
  barcodeManufacturer
  barcodeRegulation
  barcodeRim
  barcodeTPMS
  batteryTPMS
  BTyreScrapped
  compound
  compoundComment
  constructionComment
  constructionSpec
  heatingSchedule {
    _id
    duration
    temperature
  }
  initialCondition
  manufacturer
  mileage
  mTyre
  name
  pTyreMinRegulation
  pTyreMinTeam
  rimPartID
  sRunInitial
  type
  wearMeasurementIDs
}
    `;
export const TyreSetVarsFragmentDoc = `
    fragment tyreSetVars on TyreSet {
  _id
  name
  comment
  number
  tyreFL {
    _id
    name
    barcodeRim
    barcodeManufacturer
    mTyre
    pTyreMinRegulation
    sRunInitial
    BTyreScrapped
    manufacturer
    mileage
    initialCondition
    compound
    axle
    heatingSchedule {
      _id
      temperature
      duration
    }
  }
  tyreFR {
    _id
    name
    barcodeRim
    barcodeManufacturer
    mTyre
    pTyreMinRegulation
    sRunInitial
    BTyreScrapped
    manufacturer
    mileage
    initialCondition
    compound
    axle
    heatingSchedule {
      _id
      temperature
      duration
    }
  }
  tyreRL {
    _id
    name
    barcodeRim
    barcodeManufacturer
    mTyre
    pTyreMinRegulation
    sRunInitial
    BTyreScrapped
    manufacturer
    mileage
    initialCondition
    compound
    axle
    heatingSchedule {
      _id
      temperature
      duration
    }
  }
  tyreRR {
    _id
    name
    barcodeRim
    barcodeManufacturer
    mTyre
    pTyreMinRegulation
    sRunInitial
    BTyreScrapped
    manufacturer
    mileage
    initialCondition
    compound
    axle
    heatingSchedule {
      _id
      temperature
      duration
    }
  }
}
    `;
export const WeatherDataVarsFragmentDoc = `
    fragment WeatherDataVars on WeatherData {
  time
  TAir
  TTrack
  pAmbient
  rHumidity
}
    `;
export const LapForSessionByDriverFragmentDoc = `
    fragment LapForSessionByDriver on Lap {
  _id
  lapType
  ...LapNumberVars
  data {
    tDay
    source
  }
  TCell
  tDayPitIn
  tDayPitOut
  tLapManual
  tLapMax
  trackLayoutID
  tSectorsManual
  tSectorsOfficial
  tSectorsTiming
  tyreCompoundTiming
  vCarLapMax
  vCarSectors
}
    `;
export const RunTyreForSessionByDriverVarsFragmentDoc = `
    fragment RunTyreForSessionByDriverVars on RunTyre {
  pTyre
  pTyrePostRun
  pTyrePostRunBleed
  TTyre
  TTyrePostRun
  TTyrePostRunBleed
  tyreID
}
    `;
export const RunsForSessionByDriverVarsFragmentDoc = `
    fragment RunsForSessionByDriverVars on RunSheet {
  _id
  SoCRequired {
    ...AllRunEnergyVars
  }
  contestantID
  driver {
    _id
    acronym
    name
  }
  driverID
  endTime
  fuelRequired {
    ...AllRunEnergyVars
  }
  laps {
    _id
    ...LapForSessionByDriver
  }
  info
  NRun
  NRunTiming
  runDescription
  session {
    _id
    tSessionEnd
    event {
      _id
      track {
        _id
        timeZone
      }
    }
  }
  setupID
  setup {
    setupInfo
  }
  startTime
  startTimeLTS
  startTimeManual
  teamID
  tyreFL {
    ...RunTyreForSessionByDriverVars
  }
  tyreFR {
    ...RunTyreForSessionByDriverVars
  }
  tyreRL {
    ...RunTyreForSessionByDriverVars
  }
  tyreRR {
    ...RunTyreForSessionByDriverVars
  }
  tyreSet {
    _id
    name
    tyreFR {
      _id
      name
    }
    tyreFL {
      _id
      name
    }
    tyreRL {
      _id
      name
    }
    tyreRR {
      _id
      name
    }
  }
}
    `;
export const LapDataForSessionByDriversFragmentDoc = `
    fragment LapDataForSessionByDrivers on LapData {
  _id
  BDRSUsed
  BLapCancelled
  BLapIsSlow
  driverCallout
  driverCallout2
  lapType
  mFuelConsumptionThisLap
  mFuelLapEnd
  powerMode
  raceControlMessage
  rEnergyConsumptionThisLap
  rEnergyLapEnd
  rSOCConsumptionThisLap
  rSOCLapEnd
  source
  TCell
  tDay
  tDayPitIn
  tDayPitOut
  tDaySectors
  tInPit
  tLapMax
  trackStates {
    flag
    message
    timestamp
    _id
  }
  tSectors
  tSessionRemainingLapStart
  tyreCompound
  vCarLapMax
  vCarSectors
}
    `;
export const SimulationDriveFileVarsForCustomSimulationFragmentDoc = `
    fragment SimulationDriveFileVarsForCustomSimulation on SimulationDriveFile {
  _id
  data
  name
}
    `;
export const CarSetupVarsForCustomSimulationFragmentDoc = `
    fragment CarSetupVarsForCustomSimulation on CarSetup {
  _id
  chassisSpec {
    customSimulationModels {
      data
      dataMapping
      endPoint
      name
      serverPort
      version
    }
  }
  runSheet {
    session {
      event {
        tEventStart
      }
    }
    startTime
  }
  runSheetID
}
    `;
export const LapCalculationFragmentDoc = `
    fragment LapCalculation on Calculation {
  _id
  debugMode
  functionString
  name
  parameter
  trigger
  version
}
    `;
export const LapVarsForFlexLayoutFragmentDoc = `
    fragment LapVarsForFlexLayout on Lap {
  tLapMax
  tLapManual
  NLapRun
  raceControlMessage
  vCarLapMax
  tSectorsManual
  tSectorsOfficial
  tSectorsTiming
  lapComment
  lapCommentSystems
  TCell
  energyRemaining
  lapType
  BPitIn
  BPitOut
  tDay
  lapKPI
  _id
  tDayPitIn
  tDayPitOut
  rSOCConsumptionThisLap
  rEnergyConsumptionThisLap
  fuelConsumptionThisLap
  energyRemainingData
  mFuelLapStart
  mFuelLapEnd
  rSOCLapStart
  rSOCLapEnd
  rEnergyLapStart
  rEnergyLapEnd
  trackLayoutID
  trackLayout {
    _id
    name
    lapLengthOfficial
    lapLengthCarData
    lapLengthRoulette
    NSectorsTiming
  }
}
    `;
export const RunSheetVarsForFlexLayoutFragmentDoc = `
    fragment RunSheetVarsForFlexLayout on RunSheet {
  _id
  ...RunCommentVars
  sessionID
  contestantID
  chassisAssemblyID
  driverID
  driver {
    _id
    name
  }
  contestant {
    _id
    startNumber
  }
  teamID
  prevRunSheetID
  startTime
  endTime
  timingServiceShouldIgnore
  tyrePressureSettings {
    TTrackReference
  }
  tyreFL {
    ...RunTyreVars
  }
  tyreFR {
    ...RunTyreVars
  }
  tyreRL {
    ...RunTyreVars
  }
  tyreRR {
    ...RunTyreVars
  }
  tyreSetID
  TCellMaxRunStart
  ...EnergyUsedVars
  NRun
  NRunTiming
  fuelDrainedBeforeRun
  consumptions {
    trackLayoutID
    trackLayout {
      _id
      name
      track {
        _id
        name
      }
    }
    fuelRequired {
      ...AllRunEnergyVars
    }
    SoCRequired {
      ...AllRunEnergyVars
    }
  }
  fuelRequired {
    ...AllRunEnergyVars
  }
  SoCRequired {
    ...AllRunEnergyVars
  }
  jobIDs
  selectedJobListTemplateID
  laps {
    _id
    ...LapVarsForFlexLayout
  }
  runKPI
  weather {
    TAir
    TTrack
    pAmbient
    rHumidity
    DAir
    TAirOfficial
    TTrackOfficial
  }
  setupID
  dashboard {
    mFuelRunEnd
    mFuelRunStart
  }
  brakePreRunMeasurementsFL
  brakePreRunMeasurementsFR
  brakePreRunMeasurementsRL
  brakePreRunMeasurementsRR
  brakePostRunMeasurementsFL
  brakePostRunMeasurementsFR
  brakePostRunMeasurementsRL
  brakePostRunMeasurementsRR
  skidPreRunMeasurements
  skidPostRunMeasurements
  brakeComment
  controlsComment
  skidComment
  laptimeThresholds {
    cool
    prep
    push
  }
  mileage
  lastModifiedBy {
    _id
    name
  }
  createdAt
  updatedAt
  session {
    event {
      track {
        name
        timeZone
      }
    }
  }
  fastestLap
}
    `;
export const SelectedKpiRunSheetDataFragmentDoc = `
    fragment SelectedKPIRunSheetData on RunSheet {
  ...RunSheetForOverview
  runKPI(fields: $runKPI)
  laps {
    ...LapForRunSheetOverviewVars
    lapKPI(fields: $lapKPI)
  }
}
    `;
export const SimResultForStagedRunSimulationVarsFragmentDoc = `
    fragment SimResultForStagedRunSimulationVars on SimResult {
  carSetupID
  trackLayoutID
  specificationID
  runSheetID
  source
  simulationService
  version
  sourceReferenceID
  simType
  TAmbient
  pAmbient
  rHumidity
  carSetupModifiedAt
  refValues
  defaultChannelTime
  carSetup {
    _id
    title
    ...CarSetupVars
  }
  requesterID
  status
  statusMessage
  _id
  updatedAt
  createdAt
  isCarSetupChanged
  trackLayout {
    _id
    ...TrackLayoutVars
  }
  requester {
    _id
    name
    username
  }
}
    `;
export const FullBopFragmentDoc = `
    fragment FullBop on Bop {
  _id
  sessionID
  name
  bopFile {
    id
    name
    mimeType
    url
    thumbnailUrl
  }
  carBop {
    highlightColour
    aCamberFmax
    aCamberFmin
    aCamberRmax
    aCamberRmin
    aRakeMax
    aRakeMin
    aWingRmax
    aWingRmin
    zWingMin
    carSpec
    homologation
    hRideFmin
    hRideRmin
    make
    mCarBallastMin
    mCarWeightEmptyMin
    mCarWeightTotalMin
    mFuelMassCapacityMax
    modelYear
    mRefuelMassMax
    nEngineMax
    pEngineBoost
    PEngineMax
    rLambdaMin
    vCarMax
    VFuelVolumeCapacityMax
    vPowerCurveBelowRefVelocity
    rPowerCurveReference
    rPowerGainAboveRefVelocity
    vPowerGainReference
    VRefuelVolumeMax
    xAirRestrictorMax
    xFuelRestrictorMax
    xRefuelRestrictorMax
    EStintMax
  }
  sessionBop {
    EStintEnergyMax
    EStintEnergyRefillRateMax
    fuelType
    mRefuelRateMax
    pAmbientSessionOfficial
    tyreModel
    VRefuelRateMax
    xStintlengthMax
  }
}
    `;
export const SubAssemblyVarsFragmentDoc = `
    fragment SubAssemblyVars on SubAssembly {
  ... on SubAssembly {
    _id
    buildSheetGroupEnumID
    name
    decommissioned
    current
    reference
    nestedPartInstances {
      _id
      readingLocation
      part {
        _id
        reference
        userEnumPartTypeID
      }
      partID
      specificationID
      specification {
        ... on AnySpecification {
          __typename
          _id
          name
        }
      }
    }
    nestedPartInstanceIDs
    partInstances {
      _id
      readingLocation
      part {
        _id
        reference
        userEnumPartTypeID
      }
      partID
      specificationID
      specification {
        ... on AnySpecification {
          __typename
          _id
          name
        }
      }
    }
    partInstanceIDs
    locationID
    chassisSpecID
    subAssemblyIDs
    userEnumAssemblyTypeID
    tagIDs
    tags {
      _id
    }
    __typename
  }
}
    `;
export const ChassisAssemblyVarsFragmentDoc = `
    fragment ChassisAssemblyVars on ChassisAssembly {
  _id
  buildSheetGroupEnumID
  chassisSpecID
  current
  decommissioned
  locationID
  name
  nestedPartInstances {
    _id
    readingLocation
    part {
      _id
      reference
      userEnumPartTypeID
    }
    partID
    specificationID
    specification {
      ... on AnySpecification {
        __typename
        _id
        name
      }
    }
  }
  nestedPartInstanceIDs
  partInstances {
    _id
    readingLocation
    part {
      reference
      userEnumPartTypeID
    }
    partID
    specificationID
    specification {
      ... on AnySpecification {
        name
      }
    }
  }
  reference
  subAssemblyIDs
  userEnumAssemblyTypeID
  tagIDs
  tags {
    _id
  }
  __typename
}
    `;
export const GetCarDataServiceConfigItemFragmentDoc = `
    fragment GetCarDataServiceConfigItem on CarDataServiceConfig {
  _id
  name
  version
  active
  raceSeries {
    _id
    name
  }
}
    `;
export const TimeSheetEntryOfTimeApproveesForTimePeriodFragmentDoc = `
    fragment TimeSheetEntryOfTimeApproveesForTimePeriod on TimeSheetEntry {
  _id
  projectID
  personID
  absent
  tStart
  tEnd
  approvedAt
  approvedBy {
    _id
    name
  }
  project {
    _id
    name
  }
}
    `;
export const PersonWithTimeApproveesFragmentDoc = `
    fragment PersonWithTimeApprovees on Person {
  _id
  timeApprovees {
    _id
    name
    timeSheetEntries(tStartAfter: $tStartAfter, tStartBefore: $tStartBefore) {
      _id
      projectID
      personID
      absent
      tStart
      tEnd
      approvedAt
      approvedBy {
        _id
        name
      }
      project {
        _id
        name
      }
    }
  }
}
    `;
export const ProjectFragmentDoc = `
    fragment Project on Project {
  _id
  name
  description
}
    `;
export const BlankingBlockVarsFragmentDoc = `
    fragment BlankingBlockVars on BlankingBlock {
  __typename
  _id
  colorMap
  defaultOpenState
  height
  isShownWhenFolded
  width
  x
  y
}
    `;
export const BrakesBlockVarsFragmentDoc = `
    fragment BrakesBlockVars on BrakesBlock {
  __typename
  _id
  colorMap
  defaultOpenState
  height
  isShownWhenFolded
  showPostRunBrakeTemps
  showPreRunBrakeTemps
  temperatureUnit
  width
  x
  y
}
    `;
export const CommentBlockVarsFragmentDoc = `
    fragment CommentBlockVars on CommentBlock {
  __typename
  _id
  colorMap
  defaultOpenState
  field
  height
  isAlwaysOpen
  isShownWhenFolded
  rows
  title
  width
  x
  y
}
    `;
export const DoubleCommentBlockVarsFragmentDoc = `
    fragment DoubleCommentBlockVars on DoubleCommentBlock {
  __typename
  _id
  colorMap
  defaultOpenState
  field1
  field2
  height
  isAlwaysOpen
  isShownWhenFolded
  label1
  label2
  rows
  title
  width
  x
  y
}
    `;
export const FuelBlockVarsFragmentDoc = `
    fragment FuelBlockVars on FuelBlock {
  __typename
  _id
  colorMap
  defaultOpenState
  energyType
  height
  isShownWhenFolded
  runEnergyFieldOrder
  runEnergyFields {
    attackLap
    coolLap
    fullCourseYellowLap
    inLap
    outInLap
    outLap
    prepLap
    pushLap
    qualiLap
    safetyCarLap
    slowLap
    targetLap
    toGridLap
    toPitsLap
    unfinishedLap
  }
  showExtendedConsumptionFields
  showFuelDensityInput
  showMaxLapsPerConsumptionFields
  style
  width
  x
  y
}
    `;
export const IssueBlockVarsFragmentDoc = `
    fragment IssueBlockVars on IssueBlock {
  __typename
  _id
  colorMap
  defaultOpenState
  height
  isShownWhenFolded
  width
  x
  y
}
    `;
export const JobListBlockVarsFragmentDoc = `
    fragment JobListBlockVars on JobListBlock {
  __typename
  _id
  colorMap
  defaultOpenState
  height
  isShownWhenFolded
  width
  x
  y
}
    `;
export const LapTableBlockVarsFragmentDoc = `
    fragment LapTableBlockVars on LapTableBlock {
  __typename
  _id
  colorMap
  defaultOpenState
  energyType
  height
  isShownWhenFolded
  lapFlags {
    ATTACK
    COOL
    IN
    OUT
    OUTIN
    PREP
    PUSH
    QUALI
    SHAKEDOWN
    SLOW
    TARGET
    TOGRID
    TOPITS
    UNFINISHED
  }
  lapKPIs {
    _id
    field
    label
    backgroundColor
  }
  manualLapInputByDefault
  showLapTypeColors
  style
  width
  x
  y
  lapColumns {
    _id
    field
    label
    backgroundColor
  }
}
    `;
export const LapTimeThresholdsBlockVarsFragmentDoc = `
    fragment LapTimeThresholdsBlockVars on LapTimeThresholdsBlock {
  __typename
  _id
  x
  y
  width
  height
  isShownWhenFolded
  defaultOpenState
  colorMap
}
    `;
export const LapTypeCountBlockVarsFragmentDoc = `
    fragment LapTypeCountBlockVars on LapTypeCountBlock {
  __typename
  _id
  blockBackgroundColour
  colorMap
  defaultOpenState
  height
  isShownWhenFolded
  lapCountBlockFieldOrder {
    field
    show
  }
  width
  x
  y
}
    `;
export const MiniJobListBlockVarsFragmentDoc = `
    fragment MiniJobListBlockVars on MiniJobListBlock {
  __typename
  _id
  x
  y
  width
  height
  isShownWhenFolded
  defaultOpenState
  colorMap
}
    `;
export const PostRunMeasurementBlockVarsFragmentDoc = `
    fragment PostRunMeasurementBlockVars on PostRunMeasurementBlock {
  __typename
  _id
  x
  y
  width
  height
  isShownWhenFolded
  defaultOpenState
  style
  colorMap
}
    `;
export const RunKpiTableBlockVarsFragmentDoc = `
    fragment RunKPITableBlockVars on RunKPITableBlock {
  __typename
  _id
  x
  y
  width
  height
  isShownWhenFolded
  defaultOpenState
  colorMap
  runKPIRows {
    _id
    label
    keys
    unit
    decimals
    gain
  }
}
    `;
export const SetupChangesBlockVarsFragmentDoc = `
    fragment SetupChangesBlockVars on SetupChangesBlock {
  __typename
  _id
  colorMap
  defaultOpenState
  height
  isShownWhenFolded
  x
  y
  width
}
    `;
export const SetupSheetBlockVarsFragmentDoc = `
    fragment SetupSheetBlockVars on SetupSheetBlock {
  __typename
  _id
  x
  y
  width
  height
  isShownWhenFolded
  defaultOpenState
  colorMap
}
    `;
export const TyreTableBlockVarsFragmentDoc = `
    fragment TyreTableBlockVars on TyreTableBlock {
  __typename
  _id
  colorMap
  defaultOpenState
  height
  isShownWhenFolded
  mileageUnit
  pressureUnit
  showGetPreviousRunPostPressureButton
  showGetRecommendationButton
  showMinimumPressures
  showSurfaceTemps
  showTargetPressures
  showTyreReferencePressure
  showTyreSelector
  showTyreSetSelector
  staggerSettings {
    unit
    decimals
  }
  standardTyrePressureBox {
    decimalPlaces
    label
    options
    unit
  }
  standardTyreTempBox {
    decimalPlaces
    label
    options
    unit
  }
  style
  temperatureUnit
  treadDepthUnit
  tyreTableRows {
    field
    label
    backgroundColor
    highlightChanges
    lowerLimit {
      limit
      backgroundColor
      textColor
    }
    upperLimit {
      limit
      backgroundColor
      textColor
    }
  }
  tyreTreadDepthMeasurements
  width
  x
  y
}
    `;
export const WeatherBoxBlockVarsFragmentDoc = `
    fragment WeatherBoxBlockVars on WeatherBoxBlock {
  __typename
  _id
  colorMap
  defaultOpenState
  height
  isShownWhenFolded
  showAmbientAndTrackCondition
  showOfficial
  style
  unitSystem
  width
  x
  y
}
    `;
export const RunSheetStyleBlocksVarsFragmentDoc = `
    fragment RunSheetStyleBlocksVars on RunSheetStyleBlock {
  __typename
  ...BlankingBlockVars
  ...BrakesBlockVars
  ...CommentBlockVars
  ...DoubleCommentBlockVars
  ...FuelBlockVars
  ...IssueBlockVars
  ...JobListBlockVars
  ...LapTableBlockVars
  ...LapTimeThresholdsBlockVars
  ...LapTypeCountBlockVars
  ...MiniJobListBlockVars
  ...PostRunMeasurementBlockVars
  ...RunKPITableBlockVars
  ...SetupChangesBlockVars
  ...SetupSheetBlockVars
  ...TyreTableBlockVars
  ...WeatherBoxBlockVars
}
    `;
export const AllLapFlagLabelVarsFragmentDoc = `
    fragment AllLapFlagLabelVars on LapFlagLabels {
  ATTACK
  COOL
  FCY
  IN
  OUT
  OUTIN
  PITLANE
  PREP
  PUSH
  QUALI
  SAFETYCAR
  SHAKEDOWN
  SLOW
  TARGET
  TOGRID
  TOPADDOCK
  TOPITS
  UNFINISHED
}
    `;
export const RunSheetStyleVarsFragmentDoc = `
    fragment RunSheetStyleVars on RunSheetStyle {
  _id
  blocks {
    ...RunSheetStyleBlocksVars
  }
  energyType
  lapFlags {
    ...AllLapFlagLabelVars
  }
  name
}
    `;
export const BasicInfoChassisSpecFragmentDoc = `
    fragment BasicInfoChassisSpec on ChassisSpec {
  _id
  buildSheetStyleIDs
  iterationIDs
  name
  nextIterationID
  prevIterationID
  released
  releaseDate
  version
}
    `;
export const TimeSheetEntryForTimePeriodFragmentDoc = `
    fragment TimeSheetEntryForTimePeriod on TimeSheetEntry {
  _id
  absent
  tStart
  tEnd
  projectID
  approvedAt
}
    `;
export const BasicAeroElementVarsFragmentDoc = `
    fragment BasicAeroElementVars on AeroElementSpec {
  _id
  name
  __typename
}
    `;
export const BasicAeroPackageVarsFragmentDoc = `
    fragment BasicAeroPackageVars on AeroPackageSpec {
  _id
  name
  __typename
}
    `;
export const BasicAntiRollBarVarsFragmentDoc = `
    fragment BasicAntiRollBarVars on AntiRollBarSpec {
  _id
  name
  __typename
}
    `;
export const BasicChassisSpecVarsFragmentDoc = `
    fragment BasicChassisSpecVars on ChassisSpec {
  _id
  name
  __typename
}
    `;
export const BasicCustomSpecVarsFragmentDoc = `
    fragment BasicCustomSpecVars on CustomSpec {
  _id
  name
  __typename
}
    `;
export const BasicDamperSpecVarsFragmentDoc = `
    fragment BasicDamperSpecVars on DamperSpec {
  _id
  name
  __typename
}
    `;
export const BasicDifferentialSpecVarsFragmentDoc = `
    fragment BasicDifferentialSpecVars on DifferentialSpec {
  _id
  name
  __typename
}
    `;
export const BasicElasticSpecVarsFragmentDoc = `
    fragment BasicElasticSpecVars on ElasticSpec {
  _id
  name
  __typename
}
    `;
export const BasicGearSpecVarsFragmentDoc = `
    fragment BasicGearSpecVars on GearSpec {
  _id
  name
  __typename
}
    `;
export const BasicGearBoxSpecVarsFragmentDoc = `
    fragment BasicGearBoxSpecVars on GearBoxSpec {
  _id
  name
  __typename
}
    `;
export const BasicInternalKinematicSpecVarsFragmentDoc = `
    fragment BasicInternalKinematicSpecVars on KinematicsInternalSpec {
  _id
  name
  __typename
}
    `;
export const BasicExternalKinematicSpecVarsFragmentDoc = `
    fragment BasicExternalKinematicSpecVars on KinematicsExternalSpec {
  _id
  name
  __typename
}
    `;
export const TimingServiceConfigVarsFragmentDoc = `
    fragment TimingServiceConfigVars on TimingServiceConfig {
  _id
  active
  createdAt
  description
  eventID
  fallbackScheduleBasedSessionMatching
  fallbackTimedSectorsCount
  followedCarNumbers
  logLevel
  logStream
  name
  strictSessionNameMatching
  timingPort
  timingRaceSeries
  timingURL
  updatedAt
  writeData
}
    `;
export const GetContestantListForAdminPageDocument = `
    query GetContestantListForAdminPage($filter: FilterFindManyContestantInput!, $perPage: Int!, $page: Int, $sort: SortFindManyContestantInput) {
  contestants(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      chassisNumber
      class
      manufacturer {
        name
      }
      manufacturerID
      season {
        name
        raceSeries {
          name
        }
      }
      startNumber
      teamID
    }
  }
}
    `;

export const useGetContestantListForAdminPageQuery = <
      TData = GetContestantListForAdminPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetContestantListForAdminPageQueryVariables,
      options?: UseQueryOptions<GetContestantListForAdminPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantListForAdminPageQuery, TError, TData>(
      ['GetContestantListForAdminPage', variables],
      fetcher<GetContestantListForAdminPageQuery, GetContestantListForAdminPageQueryVariables>(GetContestantListForAdminPageDocument, variables),
      options
    )};

export const GetDepartmentsForDepartmentsPageDocument = `
    query GetDepartmentsForDepartmentsPage($filter: FilterFindManyDepartmentInput!, $perPage: Int!, $page: Int, $sort: SortFindManyDepartmentInput) {
  departments(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      name
      _id
    }
  }
}
    `;

export const useGetDepartmentsForDepartmentsPageQuery = <
      TData = GetDepartmentsForDepartmentsPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetDepartmentsForDepartmentsPageQueryVariables,
      options?: UseQueryOptions<GetDepartmentsForDepartmentsPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetDepartmentsForDepartmentsPageQuery, TError, TData>(
      ['GetDepartmentsForDepartmentsPage', variables],
      fetcher<GetDepartmentsForDepartmentsPageQuery, GetDepartmentsForDepartmentsPageQueryVariables>(GetDepartmentsForDepartmentsPageDocument, variables),
      options
    )};

export const GetDepartmentForDepartmentEditPageDocument = `
    query GetDepartmentForDepartmentEditPage($id: MongoID!) {
  department(_id: $id) {
    name
    _id
  }
}
    `;

export const useGetDepartmentForDepartmentEditPageQuery = <
      TData = GetDepartmentForDepartmentEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetDepartmentForDepartmentEditPageQueryVariables,
      options?: UseQueryOptions<GetDepartmentForDepartmentEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetDepartmentForDepartmentEditPageQuery, TError, TData>(
      ['GetDepartmentForDepartmentEditPage', variables],
      fetcher<GetDepartmentForDepartmentEditPageQuery, GetDepartmentForDepartmentEditPageQueryVariables>(GetDepartmentForDepartmentEditPageDocument, variables),
      options
    )};

export const GetAllDepartmentsDocument = `
    query GetAllDepartments {
  departments(perPage: 1000, sort: NAME_ASC) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetAllDepartmentsQuery = <
      TData = GetAllDepartmentsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllDepartmentsQueryVariables,
      options?: UseQueryOptions<GetAllDepartmentsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllDepartmentsQuery, TError, TData>(
      variables === undefined ? ['GetAllDepartments'] : ['GetAllDepartments', variables],
      fetcher<GetAllDepartmentsQuery, GetAllDepartmentsQueryVariables>(GetAllDepartmentsDocument, variables),
      options
    )};

export const GetTrackLayoutsForEventEditPageDocument = `
    query GetTrackLayoutsForEventEditPage($layoutIDs: [MongoID!]!) {
  trackLayouts(filter: {_operators: {_id: {in: $layoutIDs}}}) {
    items {
      _id
      name
      lapLengthOfficial
      lapLengthCarData
      NSectorsTiming
      trackID
      track {
        _id
        name
      }
    }
  }
}
    `;

export const useGetTrackLayoutsForEventEditPageQuery = <
      TData = GetTrackLayoutsForEventEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackLayoutsForEventEditPageQueryVariables,
      options?: UseQueryOptions<GetTrackLayoutsForEventEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackLayoutsForEventEditPageQuery, TError, TData>(
      ['GetTrackLayoutsForEventEditPage', variables],
      fetcher<GetTrackLayoutsForEventEditPageQuery, GetTrackLayoutsForEventEditPageQueryVariables>(GetTrackLayoutsForEventEditPageDocument, variables),
      options
    )};

export const AddEventContestantDocument = `
    mutation AddEventContestant($eventID: MongoID!, $contestantID: MongoID!) {
  addEventContestant(eventID: $eventID, contestantID: $contestantID) {
    success
  }
}
    `;

export const useAddEventContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddEventContestantMutation, TError, AddEventContestantMutationVariables, TContext>) => {
    
    return useMutation<AddEventContestantMutation, TError, AddEventContestantMutationVariables, TContext>(
      ['AddEventContestant'],
      (variables?: AddEventContestantMutationVariables) => fetcher<AddEventContestantMutation, AddEventContestantMutationVariables>(AddEventContestantDocument, variables)(),
      options
    )};

export const AddEventContestantsDocument = `
    mutation AddEventContestants($eventID: MongoID!, $contestantIDs: [MongoID!]!) {
  addManyEventContestants(eventID: $eventID, contestantIDs: $contestantIDs) {
    success
  }
}
    `;

export const useAddEventContestantsMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddEventContestantsMutation, TError, AddEventContestantsMutationVariables, TContext>) => {
    
    return useMutation<AddEventContestantsMutation, TError, AddEventContestantsMutationVariables, TContext>(
      ['AddEventContestants'],
      (variables?: AddEventContestantsMutationVariables) => fetcher<AddEventContestantsMutation, AddEventContestantsMutationVariables>(AddEventContestantsDocument, variables)(),
      options
    )};

export const RemoveEventContestantDocument = `
    mutation RemoveEventContestant($eventID: MongoID!, $contestantID: MongoID!) {
  removeEventContestant(eventID: $eventID, contestantID: $contestantID) {
    success
  }
}
    `;

export const useRemoveEventContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveEventContestantMutation, TError, RemoveEventContestantMutationVariables, TContext>) => {
    
    return useMutation<RemoveEventContestantMutation, TError, RemoveEventContestantMutationVariables, TContext>(
      ['RemoveEventContestant'],
      (variables?: RemoveEventContestantMutationVariables) => fetcher<RemoveEventContestantMutation, RemoveEventContestantMutationVariables>(RemoveEventContestantDocument, variables)(),
      options
    )};

export const RemoveEventContestantsDocument = `
    mutation RemoveEventContestants($eventID: MongoID!, $contestantIDs: [MongoID!]!) {
  removeManyEventContestants(eventID: $eventID, contestantIDs: $contestantIDs) {
    success
  }
}
    `;

export const useRemoveEventContestantsMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveEventContestantsMutation, TError, RemoveEventContestantsMutationVariables, TContext>) => {
    
    return useMutation<RemoveEventContestantsMutation, TError, RemoveEventContestantsMutationVariables, TContext>(
      ['RemoveEventContestants'],
      (variables?: RemoveEventContestantsMutationVariables) => fetcher<RemoveEventContestantsMutation, RemoveEventContestantsMutationVariables>(RemoveEventContestantsDocument, variables)(),
      options
    )};

export const UpdateDriversInEventContestantDocument = `
    mutation UpdateDriversInEventContestant($eventID: MongoID!, $contestantID: MongoID!, $driverIDs: [MongoID!]!) {
  updateDriversInEventContestant(
    eventID: $eventID
    contestantID: $contestantID
    driverIDs: $driverIDs
  ) {
    contestants {
      _id
      driverIDs
    }
  }
}
    `;

export const useUpdateDriversInEventContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDriversInEventContestantMutation, TError, UpdateDriversInEventContestantMutationVariables, TContext>) => {
    
    return useMutation<UpdateDriversInEventContestantMutation, TError, UpdateDriversInEventContestantMutationVariables, TContext>(
      ['UpdateDriversInEventContestant'],
      (variables?: UpdateDriversInEventContestantMutationVariables) => fetcher<UpdateDriversInEventContestantMutation, UpdateDriversInEventContestantMutationVariables>(UpdateDriversInEventContestantDocument, variables)(),
      options
    )};

export const Event_GetEventsDocument = `
    query event_getEvents($eventName: String) {
  events(filter: {name: $eventName}) {
    items {
      _id
      name
      NEventSeason
      tEventStart
      tEventEnd
      tLapAverage
    }
  }
}
    `;

export const useEvent_GetEventsQuery = <
      TData = Event_GetEventsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: Event_GetEventsQueryVariables,
      options?: UseQueryOptions<Event_GetEventsQuery, TError, TData>
    ) => {
    
    return useQuery<Event_GetEventsQuery, TError, TData>(
      variables === undefined ? ['event_getEvents'] : ['event_getEvents', variables],
      fetcher<Event_GetEventsQuery, Event_GetEventsQueryVariables>(Event_GetEventsDocument, variables),
      options
    )};

export const GetSeriesInfoForEditPageDocument = `
    query GetSeriesInfoForEditPage($id: MongoID!) {
  raceSeries(_id: $id) {
    _id
    groupName
    name
    shortName
    sortingIndex
    lapTypeConfig {
      ...LapTypeConfigVars
    }
  }
}
    ${LapTypeConfigVarsFragmentDoc}`;

export const useGetSeriesInfoForEditPageQuery = <
      TData = GetSeriesInfoForEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSeriesInfoForEditPageQueryVariables,
      options?: UseQueryOptions<GetSeriesInfoForEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetSeriesInfoForEditPageQuery, TError, TData>(
      ['GetSeriesInfoForEditPage', variables],
      fetcher<GetSeriesInfoForEditPageQuery, GetSeriesInfoForEditPageQueryVariables>(GetSeriesInfoForEditPageDocument, variables),
      options
    )};

export const GetIDsForRecalculateMileagesForSeasonDocument = `
    query GetIDsForRecalculateMileagesForSeason($seasonID: MongoID!) {
  season(_id: $seasonID) {
    contestantIDs
    events {
      sessionIDs
    }
  }
}
    `;

export const useGetIDsForRecalculateMileagesForSeasonQuery = <
      TData = GetIDsForRecalculateMileagesForSeasonQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetIDsForRecalculateMileagesForSeasonQueryVariables,
      options?: UseQueryOptions<GetIDsForRecalculateMileagesForSeasonQuery, TError, TData>
    ) => {
    
    return useQuery<GetIDsForRecalculateMileagesForSeasonQuery, TError, TData>(
      ['GetIDsForRecalculateMileagesForSeason', variables],
      fetcher<GetIDsForRecalculateMileagesForSeasonQuery, GetIDsForRecalculateMileagesForSeasonQueryVariables>(GetIDsForRecalculateMileagesForSeasonDocument, variables),
      options
    )};

export const GetRunSheetIDsForRecalculateMileagesForSeasonDocument = `
    query GetRunSheetIDsForRecalculateMileagesForSeason($contestantIDs: [MongoID], $sessionIDs: [MongoID]) {
  runSheets(
    filter: {_operators: {contestantID: {in: $contestantIDs}, sessionID: {in: $sessionIDs}}}
    perPage: 1000000
  ) {
    items {
      _id
    }
  }
}
    `;

export const useGetRunSheetIDsForRecalculateMileagesForSeasonQuery = <
      TData = GetRunSheetIDsForRecalculateMileagesForSeasonQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRunSheetIDsForRecalculateMileagesForSeasonQueryVariables,
      options?: UseQueryOptions<GetRunSheetIDsForRecalculateMileagesForSeasonQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetIDsForRecalculateMileagesForSeasonQuery, TError, TData>(
      variables === undefined ? ['GetRunSheetIDsForRecalculateMileagesForSeason'] : ['GetRunSheetIDsForRecalculateMileagesForSeason', variables],
      fetcher<GetRunSheetIDsForRecalculateMileagesForSeasonQuery, GetRunSheetIDsForRecalculateMileagesForSeasonQueryVariables>(GetRunSheetIDsForRecalculateMileagesForSeasonDocument, variables),
      options
    )};

export const CalculateAllMileagesForSeasonDocument = `
    mutation CalculateAllMileagesForSeason($runSheetIDs: [MongoID!]!, $forceUpdate: Boolean) {
  calculateMileagesByRunSheetIDs(
    runSheetIDs: $runSheetIDs
    forceUpdate: $forceUpdate
  )
}
    `;

export const useCalculateAllMileagesForSeasonMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CalculateAllMileagesForSeasonMutation, TError, CalculateAllMileagesForSeasonMutationVariables, TContext>) => {
    
    return useMutation<CalculateAllMileagesForSeasonMutation, TError, CalculateAllMileagesForSeasonMutationVariables, TContext>(
      ['CalculateAllMileagesForSeason'],
      (variables?: CalculateAllMileagesForSeasonMutationVariables) => fetcher<CalculateAllMileagesForSeasonMutation, CalculateAllMileagesForSeasonMutationVariables>(CalculateAllMileagesForSeasonDocument, variables)(),
      options
    )};

export const GetSessionStandingsForSessionPageDocument = `
    query GetSessionStandingsForSessionPage($id: MongoID!) {
  session(_id: $id) {
    _id
    event {
      _id
      season {
        _id
        contestants {
          _id
          startNumber
        }
      }
      contestants {
        _id
      }
    }
    contestants {
      _id
    }
    driverChampionshipStandings {
      startNumber
      acronym
      points
      driverID
      prevRacePositions
      rank
    }
    liveStandings {
      startNumber
      acronym
      driverID
      position
    }
    teamChampionshipStandings {
      teamID
      points
      rank
      team {
        name
        shortName
      }
    }
  }
}
    `;

export const useGetSessionStandingsForSessionPageQuery = <
      TData = GetSessionStandingsForSessionPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSessionStandingsForSessionPageQueryVariables,
      options?: UseQueryOptions<GetSessionStandingsForSessionPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionStandingsForSessionPageQuery, TError, TData>(
      ['GetSessionStandingsForSessionPage', variables],
      fetcher<GetSessionStandingsForSessionPageQuery, GetSessionStandingsForSessionPageQueryVariables>(GetSessionStandingsForSessionPageDocument, variables),
      options
    )};

export const GetSessionForEditPageDocument = `
    query GetSessionForEditPage($id: MongoID!) {
  session(_id: $id) {
    _id
    contestants {
      _id
    }
    customSimulationPayload
    debriefNotes
    disableForwardPropagation
    driverChampionshipStandings {
      acronym
      contestantID
      driver {
        acronym
      }
      driverID
      points
      prevRacePositions
      rank
      startNumber
    }
    event {
      trackLayouts {
        _id
        track {
          timeZone
        }
      }
      season {
        pointsSystemQualiAlternates {
          _id
          name
          sessionType
        }
        pointsSystemRaceAlternates {
          _id
          name
          sessionType
        }
      }
      sessions {
        _id
        name
        eventID
        tSessionEnd
        tSessionStart
        bop {
          carBop {
            carSpec
          }
        }
      }
    }
    eventID
    isLinkedSession
    name
    pointsSystemOverrideIDs
    pointsSystemOverrides {
      _id
      name
      sessionType
    }
    sessionType
    shortName
    teamChampionshipStandings {
      ...teamsChampionshipStandingsVars
    }
    timeRemaining
    timeRemainingUpdatedAt
    tSessionEnd
    tSessionStart
  }
}
    ${TeamsChampionshipStandingsVarsFragmentDoc}`;

export const useGetSessionForEditPageQuery = <
      TData = GetSessionForEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSessionForEditPageQueryVariables,
      options?: UseQueryOptions<GetSessionForEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionForEditPageQuery, TError, TData>(
      ['GetSessionForEditPage', variables],
      fetcher<GetSessionForEditPageQuery, GetSessionForEditPageQueryVariables>(GetSessionForEditPageDocument, variables),
      options
    )};

export const GetEventSessionsForSessionsListDocument = `
    query GetEventSessionsForSessionsList($id: MongoID!) {
  event(_id: $id) {
    _id
    name
    sessions {
      ...SessionInfoForSessionsList
    }
    season {
      _id
      name
      raceSeries {
        _id
        name
      }
    }
    track {
      _id
      name
      timeZone
    }
  }
}
    ${SessionInfoForSessionsListFragmentDoc}`;

export const useGetEventSessionsForSessionsListQuery = <
      TData = GetEventSessionsForSessionsListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventSessionsForSessionsListQueryVariables,
      options?: UseQueryOptions<GetEventSessionsForSessionsListQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventSessionsForSessionsListQuery, TError, TData>(
      ['GetEventSessionsForSessionsList', variables],
      fetcher<GetEventSessionsForSessionsListQuery, GetEventSessionsForSessionsListQueryVariables>(GetEventSessionsForSessionsListDocument, variables),
      options
    )};

export const GetLocationsForLocationListPageDocument = `
    query GetLocationsForLocationListPage($filter: FilterFindManyLocationInput!, $perPage: Int!, $page: Int, $sort: SortFindManyLocationInput) {
  locations(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
      perPage
    }
    items {
      _id
      addressLine1
      addressLine2
      city
      contact
      country
      description
      email
      name
      phone
      postcode
      region
      timeZone
    }
  }
}
    `;

export const useGetLocationsForLocationListPageQuery = <
      TData = GetLocationsForLocationListPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetLocationsForLocationListPageQueryVariables,
      options?: UseQueryOptions<GetLocationsForLocationListPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetLocationsForLocationListPageQuery, TError, TData>(
      ['GetLocationsForLocationListPage', variables],
      fetcher<GetLocationsForLocationListPageQuery, GetLocationsForLocationListPageQueryVariables>(GetLocationsForLocationListPageDocument, variables),
      options
    )};

export const GetContestantsForPersonVisibleContestantTreeDocument = `
    query GetContestantsForPersonVisibleContestantTree {
  contestants(perPage: 20000) {
    items {
      _id
      season {
        _id
        name
        raceSeries {
          _id
          name
        }
      }
      startNumber
    }
  }
}
    `;

export const useGetContestantsForPersonVisibleContestantTreeQuery = <
      TData = GetContestantsForPersonVisibleContestantTreeQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetContestantsForPersonVisibleContestantTreeQueryVariables,
      options?: UseQueryOptions<GetContestantsForPersonVisibleContestantTreeQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantsForPersonVisibleContestantTreeQuery, TError, TData>(
      variables === undefined ? ['GetContestantsForPersonVisibleContestantTree'] : ['GetContestantsForPersonVisibleContestantTree', variables],
      fetcher<GetContestantsForPersonVisibleContestantTreeQuery, GetContestantsForPersonVisibleContestantTreeQueryVariables>(GetContestantsForPersonVisibleContestantTreeDocument, variables),
      options
    )};

export const GetPersonListForAdminPageDocument = `
    query GetPersonListForAdminPage($filter: FilterFindManyPersonInput!, $perPage: Int!, $page: Int, $sort: SortFindManyPersonInput) {
  people(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ...PersonVarsForAdminPage
    }
  }
}
    ${PersonVarsForAdminPageFragmentDoc}`;

export const useGetPersonListForAdminPageQuery = <
      TData = GetPersonListForAdminPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPersonListForAdminPageQueryVariables,
      options?: UseQueryOptions<GetPersonListForAdminPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetPersonListForAdminPageQuery, TError, TData>(
      ['GetPersonListForAdminPage', variables],
      fetcher<GetPersonListForAdminPageQuery, GetPersonListForAdminPageQueryVariables>(GetPersonListForAdminPageDocument, variables),
      options
    )};

export const GetPointsSystemsDocument = `
    query GetPointsSystems {
  pointsSystems {
    items {
      laptimeDriverPoints
      laptimePositionCutoff
      laptimeTeamPoints
      name
      positionalCompletionMin
      positionalCompletionMinRatio
      positionalDriverPoints
      positionalTeamPoints
      sessionType
      _id
    }
  }
}
    `;

export const useGetPointsSystemsQuery = <
      TData = GetPointsSystemsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPointsSystemsQueryVariables,
      options?: UseQueryOptions<GetPointsSystemsQuery, TError, TData>
    ) => {
    
    return useQuery<GetPointsSystemsQuery, TError, TData>(
      variables === undefined ? ['GetPointsSystems'] : ['GetPointsSystems', variables],
      fetcher<GetPointsSystemsQuery, GetPointsSystemsQueryVariables>(GetPointsSystemsDocument, variables),
      options
    )};

export const GetPointsSystemByIdDocument = `
    query GetPointsSystemByID($id: MongoID!) {
  pointsSystem(_id: $id) {
    _id
    name
    sessionType
    laptimeDriverPoints
    laptimePositionCutoff
    laptimeTeamPoints
    positionalCompletionMin
    positionalCompletionMinRatio
    positionalDriverPoints
    positionalTeamPoints
  }
}
    `;

export const useGetPointsSystemByIdQuery = <
      TData = GetPointsSystemByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPointsSystemByIdQueryVariables,
      options?: UseQueryOptions<GetPointsSystemByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetPointsSystemByIdQuery, TError, TData>(
      ['GetPointsSystemByID', variables],
      fetcher<GetPointsSystemByIdQuery, GetPointsSystemByIdQueryVariables>(GetPointsSystemByIdDocument, variables),
      options
    )};

export const AddPointsSystemDocument = `
    mutation AddPointsSystem($record: CreateOnePointsSystemInput!) {
  addPointsSystem(record: $record) {
    recordId
  }
}
    `;

export const useAddPointsSystemMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddPointsSystemMutation, TError, AddPointsSystemMutationVariables, TContext>) => {
    
    return useMutation<AddPointsSystemMutation, TError, AddPointsSystemMutationVariables, TContext>(
      ['AddPointsSystem'],
      (variables?: AddPointsSystemMutationVariables) => fetcher<AddPointsSystemMutation, AddPointsSystemMutationVariables>(AddPointsSystemDocument, variables)(),
      options
    )};

export const UpdatePointsSystemDocument = `
    mutation UpdatePointsSystem($id: MongoID!, $record: UpdateByIdPointsSystemInput!) {
  updatePointsSystem(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdatePointsSystemMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePointsSystemMutation, TError, UpdatePointsSystemMutationVariables, TContext>) => {
    
    return useMutation<UpdatePointsSystemMutation, TError, UpdatePointsSystemMutationVariables, TContext>(
      ['UpdatePointsSystem'],
      (variables?: UpdatePointsSystemMutationVariables) => fetcher<UpdatePointsSystemMutation, UpdatePointsSystemMutationVariables>(UpdatePointsSystemDocument, variables)(),
      options
    )};

export const RemovePointsSystemDocument = `
    mutation RemovePointsSystem($id: MongoID!) {
  removePointsSystem(_id: $id) {
    recordId
  }
}
    `;

export const useRemovePointsSystemMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemovePointsSystemMutation, TError, RemovePointsSystemMutationVariables, TContext>) => {
    
    return useMutation<RemovePointsSystemMutation, TError, RemovePointsSystemMutationVariables, TContext>(
      ['RemovePointsSystem'],
      (variables?: RemovePointsSystemMutationVariables) => fetcher<RemovePointsSystemMutation, RemovePointsSystemMutationVariables>(RemovePointsSystemDocument, variables)(),
      options
    )};

export const ServerSettingsDocument = `
    query ServerSettings {
  serverSettings {
    copyAssembly {
      copyInactiveParts
    }
    simulationColoring {
      method
    }
  }
}
    `;

export const useServerSettingsQuery = <
      TData = ServerSettingsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: ServerSettingsQueryVariables,
      options?: UseQueryOptions<ServerSettingsQuery, TError, TData>
    ) => {
    
    return useQuery<ServerSettingsQuery, TError, TData>(
      variables === undefined ? ['ServerSettings'] : ['ServerSettings', variables],
      fetcher<ServerSettingsQuery, ServerSettingsQueryVariables>(ServerSettingsDocument, variables),
      options
    )};

export const UpdateServerSettingsDocument = `
    mutation UpdateServerSettings($serverSettings: ServerSettingsInput!) {
  updateServerSettings(serverSettings: $serverSettings) {
    success
  }
}
    `;

export const useUpdateServerSettingsMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateServerSettingsMutation, TError, UpdateServerSettingsMutationVariables, TContext>) => {
    
    return useMutation<UpdateServerSettingsMutation, TError, UpdateServerSettingsMutationVariables, TContext>(
      ['UpdateServerSettings'],
      (variables?: UpdateServerSettingsMutationVariables) => fetcher<UpdateServerSettingsMutation, UpdateServerSettingsMutationVariables>(UpdateServerSettingsDocument, variables)(),
      options
    )};

export const GetTagsForTagsPageDocument = `
    query GetTagsForTagsPage {
  tags {
    items {
      group
      _id
      label
      tagType
    }
  }
}
    `;

export const useGetTagsForTagsPageQuery = <
      TData = GetTagsForTagsPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTagsForTagsPageQueryVariables,
      options?: UseQueryOptions<GetTagsForTagsPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTagsForTagsPageQuery, TError, TData>(
      variables === undefined ? ['GetTagsForTagsPage'] : ['GetTagsForTagsPage', variables],
      fetcher<GetTagsForTagsPageQuery, GetTagsForTagsPageQueryVariables>(GetTagsForTagsPageDocument, variables),
      options
    )};

export const UpdateTagDocument = `
    mutation UpdateTag($id: MongoID!, $record: UpdateByIdTagInput!) {
  updateTag(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTagMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTagMutation, TError, UpdateTagMutationVariables, TContext>) => {
    
    return useMutation<UpdateTagMutation, TError, UpdateTagMutationVariables, TContext>(
      ['UpdateTag'],
      (variables?: UpdateTagMutationVariables) => fetcher<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, variables)(),
      options
    )};

export const GetTagByIdDocument = `
    query GetTagByID($id: MongoID!) {
  tag(_id: $id) {
    tagType
    label
    _id
  }
}
    `;

export const useGetTagByIdQuery = <
      TData = GetTagByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTagByIdQueryVariables,
      options?: UseQueryOptions<GetTagByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetTagByIdQuery, TError, TData>(
      ['GetTagByID', variables],
      fetcher<GetTagByIdQuery, GetTagByIdQueryVariables>(GetTagByIdDocument, variables),
      options
    )};

export const RemoveTagDocument = `
    mutation RemoveTag($id: MongoID!) {
  removeTag(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTagMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTagMutation, TError, RemoveTagMutationVariables, TContext>) => {
    
    return useMutation<RemoveTagMutation, TError, RemoveTagMutationVariables, TContext>(
      ['RemoveTag'],
      (variables?: RemoveTagMutationVariables) => fetcher<RemoveTagMutation, RemoveTagMutationVariables>(RemoveTagDocument, variables)(),
      options
    )};

export const Tracks_AddTrackDocument = `
    mutation tracks_addTrack($record: CreateOneTrackInput!) {
  addTrack(record: $record) {
    recordId
  }
}
    `;

export const useTracks_AddTrackMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Tracks_AddTrackMutation, TError, Tracks_AddTrackMutationVariables, TContext>) => {
    
    return useMutation<Tracks_AddTrackMutation, TError, Tracks_AddTrackMutationVariables, TContext>(
      ['tracks_addTrack'],
      (variables?: Tracks_AddTrackMutationVariables) => fetcher<Tracks_AddTrackMutation, Tracks_AddTrackMutationVariables>(Tracks_AddTrackDocument, variables)(),
      options
    )};

export const Tracks_GetTrackDocument = `
    query tracks_getTrack($id: MongoID!) {
  track(_id: $id) {
    _id
    acronym
    name
    timeZone
    layouts {
      _id
      name
      lapLengthOfficial
      lapLengthCarData
      NSectorsTiming
      ...tracks_trackLayoutMapData
    }
  }
}
    ${Tracks_TrackLayoutMapDataFragmentDoc}`;

export const useTracks_GetTrackQuery = <
      TData = Tracks_GetTrackQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: Tracks_GetTrackQueryVariables,
      options?: UseQueryOptions<Tracks_GetTrackQuery, TError, TData>
    ) => {
    
    return useQuery<Tracks_GetTrackQuery, TError, TData>(
      ['tracks_getTrack', variables],
      fetcher<Tracks_GetTrackQuery, Tracks_GetTrackQueryVariables>(Tracks_GetTrackDocument, variables),
      options
    )};

export const Tracks_AddTrackLayoutDocument = `
    mutation tracks_addTrackLayout($record: CreateOneTrackLayoutInput!) {
  addTrackLayout(record: $record) {
    record {
      ...tracks_trackLayoutMapData
    }
  }
}
    ${Tracks_TrackLayoutMapDataFragmentDoc}`;

export const useTracks_AddTrackLayoutMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Tracks_AddTrackLayoutMutation, TError, Tracks_AddTrackLayoutMutationVariables, TContext>) => {
    
    return useMutation<Tracks_AddTrackLayoutMutation, TError, Tracks_AddTrackLayoutMutationVariables, TContext>(
      ['tracks_addTrackLayout'],
      (variables?: Tracks_AddTrackLayoutMutationVariables) => fetcher<Tracks_AddTrackLayoutMutation, Tracks_AddTrackLayoutMutationVariables>(Tracks_AddTrackLayoutDocument, variables)(),
      options
    )};

export const GetTracksPageInfoDocument = `
    query GetTracksPageInfo($id: MongoID!) {
  person(_id: $id) {
    _id
    mileageUnit
  }
  tracks(perPage: 20000) {
    items {
      _id
      altitude
      acronym
      layoutIDs
      layouts {
        _id
        acronym
        name
        lapLengthOfficial
        NSectorsTiming
      }
      name
      timeZone
    }
  }
}
    `;

export const useGetTracksPageInfoQuery = <
      TData = GetTracksPageInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTracksPageInfoQueryVariables,
      options?: UseQueryOptions<GetTracksPageInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetTracksPageInfoQuery, TError, TData>(
      ['GetTracksPageInfo', variables],
      fetcher<GetTracksPageInfoQuery, GetTracksPageInfoQueryVariables>(GetTracksPageInfoDocument, variables),
      options
    )};

export const GetUserEnumsForAdminPageDocument = `
    query GetUserEnumsForAdminPage($filter: FilterFindManyUserEnumInput!, $perPage: Int!, $page: Int, $sort: SortFindManyUserEnumInput) {
  userEnums(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ... on UserEnumAssemblyType {
        _id
        name
        __typename
      }
      ... on UserEnumBuildSheetGroup {
        _id
        name
        __typename
      }
      ... on UserEnumPartStatus {
        _id
        name
        active
        __typename
      }
      ... on UserEnumTrackingSeverity {
        _id
        name
        __typename
      }
      ... on UserEnumPartType {
        _id
        name
        __typename
      }
      ... on UserEnumSimulationDriveFileType {
        _id
        name
        __typename
      }
      ... on UserEnumRunPlannerActionItem {
        _id
        name
        __typename
      }
    }
  }
}
    `;

export const useGetUserEnumsForAdminPageQuery = <
      TData = GetUserEnumsForAdminPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetUserEnumsForAdminPageQueryVariables,
      options?: UseQueryOptions<GetUserEnumsForAdminPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetUserEnumsForAdminPageQuery, TError, TData>(
      ['GetUserEnumsForAdminPage', variables],
      fetcher<GetUserEnumsForAdminPageQuery, GetUserEnumsForAdminPageQueryVariables>(GetUserEnumsForAdminPageDocument, variables),
      options
    )};

export const UpdateTrackingSourceSourceValueInAssemblyDocument = `
    mutation UpdateTrackingSourceSourceValueInAssembly($assemblyID: MongoID!, $trackingSourceAliasID: MongoID!, $value: Float) {
  updateTrackingSourceSourceValueInAssembly(
    assemblyID: $assemblyID
    trackingSourceAliasID: $trackingSourceAliasID
    value: $value
  ) {
    success
  }
}
    `;

export const useUpdateTrackingSourceSourceValueInAssemblyMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTrackingSourceSourceValueInAssemblyMutation, TError, UpdateTrackingSourceSourceValueInAssemblyMutationVariables, TContext>) => {
    
    return useMutation<UpdateTrackingSourceSourceValueInAssemblyMutation, TError, UpdateTrackingSourceSourceValueInAssemblyMutationVariables, TContext>(
      ['UpdateTrackingSourceSourceValueInAssembly'],
      (variables?: UpdateTrackingSourceSourceValueInAssemblyMutationVariables) => fetcher<UpdateTrackingSourceSourceValueInAssemblyMutation, UpdateTrackingSourceSourceValueInAssemblyMutationVariables>(UpdateTrackingSourceSourceValueInAssemblyDocument, variables)(),
      options
    )};

export const FixAssemblyTrackingDocument = `
    mutation FixAssemblyTracking($chassisAssemblyIDs: [MongoID!]!) {
  fixAssemblyTracking(chassisAssemblyIDs: $chassisAssemblyIDs) {
    deletedCount
    insertedRecords {
      _id
    }
  }
}
    `;

export const useFixAssemblyTrackingMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<FixAssemblyTrackingMutation, TError, FixAssemblyTrackingMutationVariables, TContext>) => {
    
    return useMutation<FixAssemblyTrackingMutation, TError, FixAssemblyTrackingMutationVariables, TContext>(
      ['FixAssemblyTracking'],
      (variables?: FixAssemblyTrackingMutationVariables) => fetcher<FixAssemblyTrackingMutation, FixAssemblyTrackingMutationVariables>(FixAssemblyTrackingDocument, variables)(),
      options
    )};

export const FixTrackingForAssemblyPartsDocument = `
    mutation FixTrackingForAssemblyParts($chassisAssemblyID: MongoID!) {
  fixTrackingForAssemblyParts(chassisAssemblyID: $chassisAssemblyID) {
    success
  }
}
    `;

export const useFixTrackingForAssemblyPartsMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<FixTrackingForAssemblyPartsMutation, TError, FixTrackingForAssemblyPartsMutationVariables, TContext>) => {
    
    return useMutation<FixTrackingForAssemblyPartsMutation, TError, FixTrackingForAssemblyPartsMutationVariables, TContext>(
      ['FixTrackingForAssemblyParts'],
      (variables?: FixTrackingForAssemblyPartsMutationVariables) => fetcher<FixTrackingForAssemblyPartsMutation, FixTrackingForAssemblyPartsMutationVariables>(FixTrackingForAssemblyPartsDocument, variables)(),
      options
    )};

export const GetChassisAssemblyForEditAssemblyFixDocument = `
    query GetChassisAssemblyForEditAssemblyFix($id: MongoID!) {
  assembly(_id: $id) {
    ...ChassisAssemblyForEditAssemblyFix
  }
}
    ${ChassisAssemblyForEditAssemblyFixFragmentDoc}`;

export const useGetChassisAssemblyForEditAssemblyFixQuery = <
      TData = GetChassisAssemblyForEditAssemblyFixQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisAssemblyForEditAssemblyFixQueryVariables,
      options?: UseQueryOptions<GetChassisAssemblyForEditAssemblyFixQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisAssemblyForEditAssemblyFixQuery, TError, TData>(
      ['GetChassisAssemblyForEditAssemblyFix', variables],
      fetcher<GetChassisAssemblyForEditAssemblyFixQuery, GetChassisAssemblyForEditAssemblyFixQueryVariables>(GetChassisAssemblyForEditAssemblyFixDocument, variables),
      options
    )};

export const FixChassisAssemblyPartInstanceArraysForAssemblyFixPageDocument = `
    mutation FixChassisAssemblyPartInstanceArraysForAssemblyFixPage($id: MongoID!) {
  fixPartInstanceArrays(assemblyID: $id) {
    success
  }
}
    `;

export const useFixChassisAssemblyPartInstanceArraysForAssemblyFixPageMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<FixChassisAssemblyPartInstanceArraysForAssemblyFixPageMutation, TError, FixChassisAssemblyPartInstanceArraysForAssemblyFixPageMutationVariables, TContext>) => {
    
    return useMutation<FixChassisAssemblyPartInstanceArraysForAssemblyFixPageMutation, TError, FixChassisAssemblyPartInstanceArraysForAssemblyFixPageMutationVariables, TContext>(
      ['FixChassisAssemblyPartInstanceArraysForAssemblyFixPage'],
      (variables?: FixChassisAssemblyPartInstanceArraysForAssemblyFixPageMutationVariables) => fetcher<FixChassisAssemblyPartInstanceArraysForAssemblyFixPageMutation, FixChassisAssemblyPartInstanceArraysForAssemblyFixPageMutationVariables>(FixChassisAssemblyPartInstanceArraysForAssemblyFixPageDocument, variables)(),
      options
    )};

export const GetAssemblyPartsByParentIdDocument = `
    query GetAssemblyPartsByParentID($assemblyID: MongoID!) {
  partInstances(perPage: 10000, filter: {parentID: $assemblyID}) {
    items {
      _id
      readingLocation
      part {
        _id
        reference
        specification {
          ... on AnySpecification {
            name
          }
        }
        specificationID
      }
    }
  }
}
    `;

export const useGetAssemblyPartsByParentIdQuery = <
      TData = GetAssemblyPartsByParentIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAssemblyPartsByParentIdQueryVariables,
      options?: UseQueryOptions<GetAssemblyPartsByParentIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetAssemblyPartsByParentIdQuery, TError, TData>(
      ['GetAssemblyPartsByParentID', variables],
      fetcher<GetAssemblyPartsByParentIdQuery, GetAssemblyPartsByParentIdQueryVariables>(GetAssemblyPartsByParentIdDocument, variables),
      options
    )};

export const GetPartsByChassisSpecIdDocument = `
    query GetPartsByChassisSpecID {
  parts(perPage: 10000) {
    items {
      _id
      reference
      manufacturerPartID
      specification {
        _id
        chassisSpecID
        readingsRequired
      }
      rootSpecificationID
    }
  }
}
    `;

export const useGetPartsByChassisSpecIdQuery = <
      TData = GetPartsByChassisSpecIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPartsByChassisSpecIdQueryVariables,
      options?: UseQueryOptions<GetPartsByChassisSpecIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartsByChassisSpecIdQuery, TError, TData>(
      variables === undefined ? ['GetPartsByChassisSpecID'] : ['GetPartsByChassisSpecID', variables],
      fetcher<GetPartsByChassisSpecIdQuery, GetPartsByChassisSpecIdQueryVariables>(GetPartsByChassisSpecIdDocument, variables),
      options
    )};

export const GetSubAssembliesByChassisSpecIdDocument = `
    query GetSubAssembliesByChassisSpecID($chassisSpecID: MongoID!, $parentAssemblyID: MongoID!) {
  assemblies(perPage: 1000, filter: {chassisSpecID: $chassisSpecID}) {
    items {
      ... on SubAssembly {
        _id
        name
        reference
      }
    }
  }
  assembly(_id: $parentAssemblyID) {
    ... on AnyAssembly {
      subAssemblyIDs
    }
    ... on AnySubAssembly {
      subAssemblyIDs
    }
    ... on SubAssembly {
      subAssemblyIDs
    }
  }
}
    `;

export const useGetSubAssembliesByChassisSpecIdQuery = <
      TData = GetSubAssembliesByChassisSpecIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSubAssembliesByChassisSpecIdQueryVariables,
      options?: UseQueryOptions<GetSubAssembliesByChassisSpecIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetSubAssembliesByChassisSpecIdQuery, TError, TData>(
      ['GetSubAssembliesByChassisSpecID', variables],
      fetcher<GetSubAssembliesByChassisSpecIdQuery, GetSubAssembliesByChassisSpecIdQueryVariables>(GetSubAssembliesByChassisSpecIdDocument, variables),
      options
    )};

export const GetSubAssembliesByParentIdDocument = `
    query GetSubAssembliesByParentID($parentAssemblyID: MongoID!) {
  assembly(_id: $parentAssemblyID) {
    ... on AnyAssembly {
      _id
      chassisSpecID
      subAssemblyIDs
    }
    ... on ChassisAssembly {
      chassisSubAssemblies: subAssemblies {
        ...SubAssemblyTableVars
      }
    }
    ... on SubAssembly {
      subAssemblySubAssemblies: subAssemblies {
        ...SubAssemblyTableVars
      }
    }
  }
}
    ${SubAssemblyTableVarsFragmentDoc}`;

export const useGetSubAssembliesByParentIdQuery = <
      TData = GetSubAssembliesByParentIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSubAssembliesByParentIdQueryVariables,
      options?: UseQueryOptions<GetSubAssembliesByParentIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetSubAssembliesByParentIdQuery, TError, TData>(
      ['GetSubAssembliesByParentID', variables],
      fetcher<GetSubAssembliesByParentIdQuery, GetSubAssembliesByParentIdQueryVariables>(GetSubAssembliesByParentIdDocument, variables),
      options
    )};

export const GetTrackingSourceRecordsOnChassisAssemblyForAssemblyPageDocument = `
    query GetTrackingSourceRecordsOnChassisAssemblyForAssemblyPage($id: MongoID!) {
  assembly(_id: $id) {
    ... on ChassisAssembly {
      ...ChassisAssemblyVarsForAssemblyPage
    }
  }
}
    ${ChassisAssemblyVarsForAssemblyPageFragmentDoc}`;

export const useGetTrackingSourceRecordsOnChassisAssemblyForAssemblyPageQuery = <
      TData = GetTrackingSourceRecordsOnChassisAssemblyForAssemblyPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackingSourceRecordsOnChassisAssemblyForAssemblyPageQueryVariables,
      options?: UseQueryOptions<GetTrackingSourceRecordsOnChassisAssemblyForAssemblyPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingSourceRecordsOnChassisAssemblyForAssemblyPageQuery, TError, TData>(
      ['GetTrackingSourceRecordsOnChassisAssemblyForAssemblyPage', variables],
      fetcher<GetTrackingSourceRecordsOnChassisAssemblyForAssemblyPageQuery, GetTrackingSourceRecordsOnChassisAssemblyForAssemblyPageQueryVariables>(GetTrackingSourceRecordsOnChassisAssemblyForAssemblyPageDocument, variables),
      options
    )};

export const GetTrackingSourcesOnChassisSpecForAssemblyPageDocument = `
    query GetTrackingSourcesOnChassisSpecForAssemblyPage($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      ...ChassisSpecVarsForAssemblyPage
    }
  }
}
    ${ChassisSpecVarsForAssemblyPageFragmentDoc}
${ChassisTrackingSourceVarsForAssemblyPageFragmentDoc}`;

export const useGetTrackingSourcesOnChassisSpecForAssemblyPageQuery = <
      TData = GetTrackingSourcesOnChassisSpecForAssemblyPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackingSourcesOnChassisSpecForAssemblyPageQueryVariables,
      options?: UseQueryOptions<GetTrackingSourcesOnChassisSpecForAssemblyPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingSourcesOnChassisSpecForAssemblyPageQuery, TError, TData>(
      ['GetTrackingSourcesOnChassisSpecForAssemblyPage', variables],
      fetcher<GetTrackingSourcesOnChassisSpecForAssemblyPageQuery, GetTrackingSourcesOnChassisSpecForAssemblyPageQueryVariables>(GetTrackingSourcesOnChassisSpecForAssemblyPageDocument, variables),
      options
    )};

export const GetDataOverviewAssembliesDocument = `
    query GetDataOverviewAssemblies($filter: FilterFindManyAssemblyInput!, $perPage: Int!, $page: Int, $sort: SortFindManyAssemblyInput) {
  assemblies(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ... on ChassisAssembly {
        __typename
        _id
        chassisSpecID
        name
        reference
      }
      ... on SubAssembly {
        __typename
        _id
        chassisSpecID
        name
        reference
      }
    }
  }
}
    `;

export const useGetDataOverviewAssembliesQuery = <
      TData = GetDataOverviewAssembliesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetDataOverviewAssembliesQueryVariables,
      options?: UseQueryOptions<GetDataOverviewAssembliesQuery, TError, TData>
    ) => {
    
    return useQuery<GetDataOverviewAssembliesQuery, TError, TData>(
      ['GetDataOverviewAssemblies', variables],
      fetcher<GetDataOverviewAssembliesQuery, GetDataOverviewAssembliesQueryVariables>(GetDataOverviewAssembliesDocument, variables),
      options
    )};

export const GetDataOverviewAssembliesAdvancedFilterDocument = `
    query GetDataOverviewAssembliesAdvancedFilter($filter: FilterFindManyAssemblyInput!, $perPage: Int!, $page: Int, $sort: SortFindManyAssemblyInput, $allPartInstancesActive: Boolean, $hideAssembliesUsedInRunSheets: Boolean) {
  assembliesAdvancedFilter(
    perPage: $perPage
    sort: $sort
    filter: $filter
    page: $page
    allPartInstancesActive: $allPartInstancesActive
    hideAssembliesUsedInRunSheets: $hideAssembliesUsedInRunSheets
  ) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ...GetDataOverviewAssembliesAdvancedFilterItem
    }
  }
}
    ${GetDataOverviewAssembliesAdvancedFilterItemFragmentDoc}`;

export const useGetDataOverviewAssembliesAdvancedFilterQuery = <
      TData = GetDataOverviewAssembliesAdvancedFilterQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetDataOverviewAssembliesAdvancedFilterQueryVariables,
      options?: UseQueryOptions<GetDataOverviewAssembliesAdvancedFilterQuery, TError, TData>
    ) => {
    
    return useQuery<GetDataOverviewAssembliesAdvancedFilterQuery, TError, TData>(
      ['GetDataOverviewAssembliesAdvancedFilter', variables],
      fetcher<GetDataOverviewAssembliesAdvancedFilterQuery, GetDataOverviewAssembliesAdvancedFilterQueryVariables>(GetDataOverviewAssembliesAdvancedFilterDocument, variables),
      options
    )};

export const GetChassisBuildSheetsForAssemblyDocument = `
    query GetChassisBuildSheetsForAssembly($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      buildSheetStyles {
        _id
      }
      buildSheetStyleIDs
    }
  }
}
    `;

export const useGetChassisBuildSheetsForAssemblyQuery = <
      TData = GetChassisBuildSheetsForAssemblyQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisBuildSheetsForAssemblyQueryVariables,
      options?: UseQueryOptions<GetChassisBuildSheetsForAssemblyQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisBuildSheetsForAssemblyQuery, TError, TData>(
      ['GetChassisBuildSheetsForAssembly', variables],
      fetcher<GetChassisBuildSheetsForAssemblyQuery, GetChassisBuildSheetsForAssemblyQueryVariables>(GetChassisBuildSheetsForAssemblyDocument, variables),
      options
    )};

export const GetChassisSetupSheetsForAssemblyDocument = `
    query GetChassisSetupSheetsForAssembly($id: MongoID!) {
  assembly(_id: $id) {
    ... on ChassisAssembly {
      _id
      carSetupID
    }
  }
}
    `;

export const useGetChassisSetupSheetsForAssemblyQuery = <
      TData = GetChassisSetupSheetsForAssemblyQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSetupSheetsForAssemblyQueryVariables,
      options?: UseQueryOptions<GetChassisSetupSheetsForAssemblyQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSetupSheetsForAssemblyQuery, TError, TData>(
      ['GetChassisSetupSheetsForAssembly', variables],
      fetcher<GetChassisSetupSheetsForAssemblyQuery, GetChassisSetupSheetsForAssemblyQueryVariables>(GetChassisSetupSheetsForAssemblyDocument, variables),
      options
    )};

export const GetAssemblyTemplatesForAssemblyEditPageDocument = `
    query GetAssemblyTemplatesForAssemblyEditPage {
  assemblyTemplates {
    items {
      ...AllAssemblyTemplatesVars
    }
  }
  userEnums(filter: {type: USER_ENUM_PART_TYPE}) {
    items {
      ... on UserEnumPartType {
        _id
        name
      }
    }
  }
}
    ${AllAssemblyTemplatesVarsFragmentDoc}`;

export const useGetAssemblyTemplatesForAssemblyEditPageQuery = <
      TData = GetAssemblyTemplatesForAssemblyEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAssemblyTemplatesForAssemblyEditPageQueryVariables,
      options?: UseQueryOptions<GetAssemblyTemplatesForAssemblyEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetAssemblyTemplatesForAssemblyEditPageQuery, TError, TData>(
      variables === undefined ? ['GetAssemblyTemplatesForAssemblyEditPage'] : ['GetAssemblyTemplatesForAssemblyEditPage', variables],
      fetcher<GetAssemblyTemplatesForAssemblyEditPageQuery, GetAssemblyTemplatesForAssemblyEditPageQueryVariables>(GetAssemblyTemplatesForAssemblyEditPageDocument, variables),
      options
    )};

export const GetAssemblyForEditAssemblyPageDocument = `
    query GetAssemblyForEditAssemblyPage($id: MongoID!) {
  assembly(_id: $id) {
    ...AssemblyForAssemblyEditPageVars
  }
}
    ${AssemblyForAssemblyEditPageVarsFragmentDoc}
${AnyAssemblyForAssemblyEditPageVarsFragmentDoc}
${ChassisAssemblyForAssemblyEditPageVarsFragmentDoc}
${SubAssemblyForAssemblyEditPageVarsFragmentDoc}`;

export const useGetAssemblyForEditAssemblyPageQuery = <
      TData = GetAssemblyForEditAssemblyPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAssemblyForEditAssemblyPageQueryVariables,
      options?: UseQueryOptions<GetAssemblyForEditAssemblyPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetAssemblyForEditAssemblyPageQuery, TError, TData>(
      ['GetAssemblyForEditAssemblyPage', variables],
      fetcher<GetAssemblyForEditAssemblyPageQuery, GetAssemblyForEditAssemblyPageQueryVariables>(GetAssemblyForEditAssemblyPageDocument, variables),
      options
    )};

export const GetAssembliesForAssemblyTreeDocument = `
    query GetAssembliesForAssemblyTree($ids: [MongoID], $perPage: Int!) {
  assemblies(filter: {_operators: {_id: {in: $ids}}}, perPage: $perPage) {
    items {
      ...AssemblyForAssemblyEditPageVars
    }
  }
}
    ${AssemblyForAssemblyEditPageVarsFragmentDoc}
${AnyAssemblyForAssemblyEditPageVarsFragmentDoc}
${ChassisAssemblyForAssemblyEditPageVarsFragmentDoc}
${SubAssemblyForAssemblyEditPageVarsFragmentDoc}`;

export const useGetAssembliesForAssemblyTreeQuery = <
      TData = GetAssembliesForAssemblyTreeQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAssembliesForAssemblyTreeQueryVariables,
      options?: UseQueryOptions<GetAssembliesForAssemblyTreeQuery, TError, TData>
    ) => {
    
    return useQuery<GetAssembliesForAssemblyTreeQuery, TError, TData>(
      ['GetAssembliesForAssemblyTree', variables],
      fetcher<GetAssembliesForAssemblyTreeQuery, GetAssembliesForAssemblyTreeQueryVariables>(GetAssembliesForAssemblyTreeDocument, variables),
      options
    )};

export const GetPartsMileageForAssemblyPageDocument = `
    query GetPartsMileageForAssemblyPage($partIDs: [MongoID], $perPage: Int!) {
  parts(filter: {_operators: {_id: {in: $partIDs}}}, perPage: $perPage) {
    items {
      _id
      ...PartMileageTrackingForAssemblyPageVars
    }
  }
}
    ${PartMileageTrackingForAssemblyPageVarsFragmentDoc}`;

export const useGetPartsMileageForAssemblyPageQuery = <
      TData = GetPartsMileageForAssemblyPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartsMileageForAssemblyPageQueryVariables,
      options?: UseQueryOptions<GetPartsMileageForAssemblyPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartsMileageForAssemblyPageQuery, TError, TData>(
      ['GetPartsMileageForAssemblyPage', variables],
      fetcher<GetPartsMileageForAssemblyPageQuery, GetPartsMileageForAssemblyPageQueryVariables>(GetPartsMileageForAssemblyPageDocument, variables),
      options
    )};

export const GetAvailablePartsForAssemblyForIssuePageDocument = `
    query GetAvailablePartsForAssemblyForIssuePage($filter: FilterFindManyPartInput, $perPage: Int!, $page: Int, $sort: SortFindManyPartInput, $chassisSpecID: MongoID, $userEnumPartStatusActive: Boolean, $partNumber: String, $partType: MongoID, $partReference: String, $hideDummyParts: Boolean) {
  partsAdvancedFilter(
    filter: $filter
    page: $page
    perPage: $perPage
    sort: $sort
    chassisSpecID: $chassisSpecID
    userEnumPartStatusActive: $userEnumPartStatusActive
    partNumber: $partNumber
    partType: $partType
    partReference: $partReference
    hideDummyParts: $hideDummyParts
  ) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ...PartForAvailablePartsForAssemblyEditPageVars
    }
  }
}
    ${PartForAvailablePartsForAssemblyEditPageVarsFragmentDoc}`;

export const useGetAvailablePartsForAssemblyForIssuePageQuery = <
      TData = GetAvailablePartsForAssemblyForIssuePageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAvailablePartsForAssemblyForIssuePageQueryVariables,
      options?: UseQueryOptions<GetAvailablePartsForAssemblyForIssuePageQuery, TError, TData>
    ) => {
    
    return useQuery<GetAvailablePartsForAssemblyForIssuePageQuery, TError, TData>(
      ['GetAvailablePartsForAssemblyForIssuePage', variables],
      fetcher<GetAvailablePartsForAssemblyForIssuePageQuery, GetAvailablePartsForAssemblyForIssuePageQueryVariables>(GetAvailablePartsForAssemblyForIssuePageDocument, variables),
      options
    )};

export const GetAvailablePartsForAssemblyForAssemblyEditPageDocument = `
    query GetAvailablePartsForAssemblyForAssemblyEditPage($filter: FilterFindManyPartInput, $perPage: Int!, $page: Int, $sort: SortFindManyPartInput, $chassisSpecID: MongoID!, $partActive: Boolean, $userEnumPartStatusID: MongoID, $userEnumPartTypeID: MongoID) {
  partsForChassisSpec(
    filter: $filter
    page: $page
    perPage: $perPage
    sort: $sort
    chassisSpecID: $chassisSpecID
    partActive: $partActive
    userEnumPartStatusID: $userEnumPartStatusID
    userEnumPartTypeID: $userEnumPartTypeID
  ) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ...PartForAvailablePartsForAssemblyEditPageVars
    }
  }
}
    ${PartForAvailablePartsForAssemblyEditPageVarsFragmentDoc}`;

export const useGetAvailablePartsForAssemblyForAssemblyEditPageQuery = <
      TData = GetAvailablePartsForAssemblyForAssemblyEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAvailablePartsForAssemblyForAssemblyEditPageQueryVariables,
      options?: UseQueryOptions<GetAvailablePartsForAssemblyForAssemblyEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetAvailablePartsForAssemblyForAssemblyEditPageQuery, TError, TData>(
      ['GetAvailablePartsForAssemblyForAssemblyEditPage', variables],
      fetcher<GetAvailablePartsForAssemblyForAssemblyEditPageQuery, GetAvailablePartsForAssemblyForAssemblyEditPageQueryVariables>(GetAvailablePartsForAssemblyForAssemblyEditPageDocument, variables),
      options
    )};

export const GetUserEnumsForEditAssemblyPageDocument = `
    query GetUserEnumsForEditAssemblyPage {
  assemblyTypeEnums: userEnums(
    perPage: 2000
    filter: {type: USER_ENUM_ASSEMBLY_TYPE}
  ) {
    items {
      ... on UserEnumAssemblyType {
        _id
        name
        type
      }
    }
  }
}
    `;

export const useGetUserEnumsForEditAssemblyPageQuery = <
      TData = GetUserEnumsForEditAssemblyPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetUserEnumsForEditAssemblyPageQueryVariables,
      options?: UseQueryOptions<GetUserEnumsForEditAssemblyPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetUserEnumsForEditAssemblyPageQuery, TError, TData>(
      variables === undefined ? ['GetUserEnumsForEditAssemblyPage'] : ['GetUserEnumsForEditAssemblyPage', variables],
      fetcher<GetUserEnumsForEditAssemblyPageQuery, GetUserEnumsForEditAssemblyPageQueryVariables>(GetUserEnumsForEditAssemblyPageDocument, variables),
      options
    )};

export const GetRunSheetIdForAssemblyDocument = `
    query GetRunSheetIDForAssembly($filter: FilterFindManyCarSetupInput) {
  carSetupsMany(filter: $filter, limit: 1) {
    runSheet {
      _id
      sessionID
    }
  }
}
    `;

export const useGetRunSheetIdForAssemblyQuery = <
      TData = GetRunSheetIdForAssemblyQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRunSheetIdForAssemblyQueryVariables,
      options?: UseQueryOptions<GetRunSheetIdForAssemblyQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetIdForAssemblyQuery, TError, TData>(
      variables === undefined ? ['GetRunSheetIDForAssembly'] : ['GetRunSheetIDForAssembly', variables],
      fetcher<GetRunSheetIdForAssemblyQuery, GetRunSheetIdForAssemblyQueryVariables>(GetRunSheetIdForAssemblyDocument, variables),
      options
    )};

export const ForwardAddPartInstanceDocument = `
    mutation ForwardAddPartInstance($partID: MongoID!, $sessionID: MongoID!, $readingLocation: EnumReadingLocation, $chassisAssemblyID: MongoID!) {
  forwardAddPartInstance(
    partID: $partID
    sessionID: $sessionID
    readingLocation: $readingLocation
    chassisAssemblyID: $chassisAssemblyID
  ) {
    createdPartInstanceIDs
  }
}
    `;

export const useForwardAddPartInstanceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ForwardAddPartInstanceMutation, TError, ForwardAddPartInstanceMutationVariables, TContext>) => {
    
    return useMutation<ForwardAddPartInstanceMutation, TError, ForwardAddPartInstanceMutationVariables, TContext>(
      ['ForwardAddPartInstance'],
      (variables?: ForwardAddPartInstanceMutationVariables) => fetcher<ForwardAddPartInstanceMutation, ForwardAddPartInstanceMutationVariables>(ForwardAddPartInstanceDocument, variables)(),
      options
    )};

export const GetParentReferenceForAssemblyEditPageDocument = `
    query GetParentReferenceForAssemblyEditPage($id: MongoID!) {
  assembly(_id: $id) {
    ... on AnyAssembly {
      reference
    }
  }
}
    `;

export const useGetParentReferenceForAssemblyEditPageQuery = <
      TData = GetParentReferenceForAssemblyEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetParentReferenceForAssemblyEditPageQueryVariables,
      options?: UseQueryOptions<GetParentReferenceForAssemblyEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetParentReferenceForAssemblyEditPageQuery, TError, TData>(
      ['GetParentReferenceForAssemblyEditPage', variables],
      fetcher<GetParentReferenceForAssemblyEditPageQuery, GetParentReferenceForAssemblyEditPageQueryVariables>(GetParentReferenceForAssemblyEditPageDocument, variables),
      options
    )};

export const GetAvailableSsoProvidersDocument = `
    query GetAvailableSsoProviders {
  ssoProviders {
    name
  }
}
    `;

export const useGetAvailableSsoProvidersQuery = <
      TData = GetAvailableSsoProvidersQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAvailableSsoProvidersQueryVariables,
      options?: UseQueryOptions<GetAvailableSsoProvidersQuery, TError, TData>
    ) => {
    
    return useQuery<GetAvailableSsoProvidersQuery, TError, TData>(
      variables === undefined ? ['GetAvailableSsoProviders'] : ['GetAvailableSsoProviders', variables],
      fetcher<GetAvailableSsoProvidersQuery, GetAvailableSsoProvidersQueryVariables>(GetAvailableSsoProvidersDocument, variables),
      options
    )};

export const GetAllSessionsForCalendarViewDocument = `
    query GetAllSessionsForCalendarView {
  sessions(perPage: 20000) {
    items {
      ...SessionVarsForCalendarView
    }
  }
}
    ${SessionVarsForCalendarViewFragmentDoc}`;

export const useGetAllSessionsForCalendarViewQuery = <
      TData = GetAllSessionsForCalendarViewQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllSessionsForCalendarViewQueryVariables,
      options?: UseQueryOptions<GetAllSessionsForCalendarViewQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllSessionsForCalendarViewQuery, TError, TData>(
      variables === undefined ? ['GetAllSessionsForCalendarView'] : ['GetAllSessionsForCalendarView', variables],
      fetcher<GetAllSessionsForCalendarViewQuery, GetAllSessionsForCalendarViewQueryVariables>(GetAllSessionsForCalendarViewDocument, variables),
      options
    )};

export const GetSeasonForContextMenuDocument = `
    query GetSeasonForContextMenu($seasonID: MongoID!) {
  season(_id: $seasonID) {
    _id
    contestants {
      ...SeasonContestantForContextMenuVars
    }
    events {
      _id
      name
      tEventStart
      tEventEnd
    }
  }
}
    ${SeasonContestantForContextMenuVarsFragmentDoc}`;

export const useGetSeasonForContextMenuQuery = <
      TData = GetSeasonForContextMenuQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSeasonForContextMenuQueryVariables,
      options?: UseQueryOptions<GetSeasonForContextMenuQuery, TError, TData>
    ) => {
    
    return useQuery<GetSeasonForContextMenuQuery, TError, TData>(
      ['GetSeasonForContextMenu', variables],
      fetcher<GetSeasonForContextMenuQuery, GetSeasonForContextMenuQueryVariables>(GetSeasonForContextMenuDocument, variables),
      options
    )};

export const GetEventForContextMenuDocument = `
    query GetEventForContextMenu($eventID: MongoID!) {
  event(_id: $eventID) {
    _id
    name
    contestants {
      ...EventContestantForContextMenuVars
    }
    sessionIDs
    sessions {
      _id
      name
      shortName
      sessionType
      tSessionStart
      tSessionEnd
    }
  }
}
    ${EventContestantForContextMenuVarsFragmentDoc}`;

export const useGetEventForContextMenuQuery = <
      TData = GetEventForContextMenuQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventForContextMenuQueryVariables,
      options?: UseQueryOptions<GetEventForContextMenuQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventForContextMenuQuery, TError, TData>(
      ['GetEventForContextMenu', variables],
      fetcher<GetEventForContextMenuQuery, GetEventForContextMenuQueryVariables>(GetEventForContextMenuDocument, variables),
      options
    )};

export const GetContestantListForContextMenuDocument = `
    query GetContestantListForContextMenu($contestantIDs: [MongoID]!, $perPage: Int!) {
  contestants(
    filter: {_operators: {_id: {in: $contestantIDs}}}
    perPage: $perPage
    sort: STARTNUMBER_ASC
  ) {
    items {
      _id
      class
      hidden
      startNumber
      teamID
    }
  }
}
    `;

export const useGetContestantListForContextMenuQuery = <
      TData = GetContestantListForContextMenuQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetContestantListForContextMenuQueryVariables,
      options?: UseQueryOptions<GetContestantListForContextMenuQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantListForContextMenuQuery, TError, TData>(
      ['GetContestantListForContextMenu', variables],
      fetcher<GetContestantListForContextMenuQuery, GetContestantListForContextMenuQueryVariables>(GetContestantListForContextMenuDocument, variables),
      options
    )};

export const GetUserEnumSimulationDriveFileTypeDocument = `
    query GetUserEnumSimulationDriveFileType {
  userEnums(filter: {type: USER_ENUM_SIMULATION_DRIVE_FILE_TYPE}, perPage: 2000) {
    items {
      ... on UserEnumSimulationDriveFileType {
        _id
        name
        type
      }
    }
  }
}
    `;

export const useGetUserEnumSimulationDriveFileTypeQuery = <
      TData = GetUserEnumSimulationDriveFileTypeQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetUserEnumSimulationDriveFileTypeQueryVariables,
      options?: UseQueryOptions<GetUserEnumSimulationDriveFileTypeQuery, TError, TData>
    ) => {
    
    return useQuery<GetUserEnumSimulationDriveFileTypeQuery, TError, TData>(
      variables === undefined ? ['GetUserEnumSimulationDriveFileType'] : ['GetUserEnumSimulationDriveFileType', variables],
      fetcher<GetUserEnumSimulationDriveFileTypeQuery, GetUserEnumSimulationDriveFileTypeQueryVariables>(GetUserEnumSimulationDriveFileTypeDocument, variables),
      options
    )};

export const GetCustomControlFieldsDocument = `
    query GetCustomControlFields($id: MongoID!) {
  person(_id: $id) {
    localConnections {
      ...AllLocalConnectionVars
    }
  }
  allDriveFiles: simulationDriveFiles(
    perPage: 20000
    filter: {_operators: {status: {nin: [ARCHIVED]}}}
  ) {
    items {
      _id
      event {
        _id
        name
        season {
          _id
          name
        }
        tEventStart
      }
      name
      status
      userEnumType {
        ... on UserEnumSimulationDriveFileType {
          name
        }
      }
      userEnumTypeID
      version
    }
  }
}
    ${AllLocalConnectionVarsFragmentDoc}`;

export const useGetCustomControlFieldsQuery = <
      TData = GetCustomControlFieldsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCustomControlFieldsQueryVariables,
      options?: UseQueryOptions<GetCustomControlFieldsQuery, TError, TData>
    ) => {
    
    return useQuery<GetCustomControlFieldsQuery, TError, TData>(
      ['GetCustomControlFields', variables],
      fetcher<GetCustomControlFieldsQuery, GetCustomControlFieldsQueryVariables>(GetCustomControlFieldsDocument, variables),
      options
    )};

export const GetSimulationModelsForCarSetupDocument = `
    query GetSimulationModelsForCarSetup($id: MongoID!) {
  carSetup(_id: $id) {
    chassisSpec {
      _id
      canopyVersion
      customSimulationModels {
        ...CustomSimulationModelVars
      }
    }
    runSheetID
  }
}
    ${CustomSimulationModelVarsFragmentDoc}`;

export const useGetSimulationModelsForCarSetupQuery = <
      TData = GetSimulationModelsForCarSetupQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSimulationModelsForCarSetupQueryVariables,
      options?: UseQueryOptions<GetSimulationModelsForCarSetupQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimulationModelsForCarSetupQuery, TError, TData>(
      ['GetSimulationModelsForCarSetup', variables],
      fetcher<GetSimulationModelsForCarSetupQuery, GetSimulationModelsForCarSetupQueryVariables>(GetSimulationModelsForCarSetupDocument, variables),
      options
    )};

export const SetupTimingServiceStatusDocument = `
    mutation SetupTimingServiceStatus {
  applyMigration(migration: setupTimingServiceStatus) {
    success
  }
}
    `;

export const useSetupTimingServiceStatusMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<SetupTimingServiceStatusMutation, TError, SetupTimingServiceStatusMutationVariables, TContext>) => {
    
    return useMutation<SetupTimingServiceStatusMutation, TError, SetupTimingServiceStatusMutationVariables, TContext>(
      ['SetupTimingServiceStatus'],
      (variables?: SetupTimingServiceStatusMutationVariables) => fetcher<SetupTimingServiceStatusMutation, SetupTimingServiceStatusMutationVariables>(SetupTimingServiceStatusDocument, variables)(),
      options
    )};

export const ResetTimingServiceStatusDocument = `
    mutation ResetTimingServiceStatus {
  updateMigrations(record: {setupTimingServiceStatus: false}) {
    success
  }
}
    `;

export const useResetTimingServiceStatusMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ResetTimingServiceStatusMutation, TError, ResetTimingServiceStatusMutationVariables, TContext>) => {
    
    return useMutation<ResetTimingServiceStatusMutation, TError, ResetTimingServiceStatusMutationVariables, TContext>(
      ['ResetTimingServiceStatus'],
      (variables?: ResetTimingServiceStatusMutationVariables) => fetcher<ResetTimingServiceStatusMutation, ResetTimingServiceStatusMutationVariables>(ResetTimingServiceStatusDocument, variables)(),
      options
    )};

export const GetBopForBoostTableDocument = `
    query GetBopForBoostTable($sessionIds: [MongoID!]!) {
  sessions(
    filter: {_operators: {_id: {in: $sessionIds}}}
    sort: TSESSIONSTART_ASC
    perPage: 1000
  ) {
    items {
      _id
      name
      shortName
      tSessionStart
      bop {
        _id
        name
        sessionID
        session {
          _id
          name
          shortName
        }
        carBop {
          highlightColour
          make
          modelYear
          carSpec
          homologation
          pEngineBoost
          _id
        }
        sessionBop {
          EStintEnergyMax
          EStintEnergyRefillRateMax
          fuelType
          mRefuelRateMax
          pAmbientSessionOfficial
          VRefuelRateMax
          xStintlengthMax
          _id
        }
      }
    }
  }
}
    `;

export const useGetBopForBoostTableQuery = <
      TData = GetBopForBoostTableQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetBopForBoostTableQueryVariables,
      options?: UseQueryOptions<GetBopForBoostTableQuery, TError, TData>
    ) => {
    
    return useQuery<GetBopForBoostTableQuery, TError, TData>(
      ['GetBopForBoostTable', variables],
      fetcher<GetBopForBoostTableQuery, GetBopForBoostTableQueryVariables>(GetBopForBoostTableDocument, variables),
      options
    )};

export const GetBopForTrackerTableDocument = `
    query GetBopForTrackerTable($sessionIds: [MongoID!]!) {
  sessions(
    filter: {_operators: {_id: {in: $sessionIds}}}
    sort: TSESSIONSTART_ASC
    perPage: 1000
  ) {
    items {
      _id
      name
      shortName
      tSessionStart
      bop {
        _id
        name
        sessionID
        session {
          _id
          name
          shortName
        }
        carBop {
          highlightColour
          aCamberFmax
          aCamberFmin
          aCamberRmax
          aCamberRmin
          aRakeMax
          aRakeMin
          aWingRmax
          aWingRmin
          zWingMin
          carSpec
          homologation
          hRideFmin
          hRideRmin
          make
          mCarBallastMin
          mCarWeightEmptyMin
          mCarWeightTotalMin
          mFuelMassCapacityMax
          modelYear
          mRefuelMassMax
          nEngineMax
          pEngineBoost
          PEngineMax
          rLambdaMin
          vCarMax
          VFuelVolumeCapacityMax
          vPowerCurveBelowRefVelocity
          rPowerCurveReference
          rPowerGainAboveRefVelocity
          vPowerGainReference
          VRefuelVolumeMax
          xAirRestrictorMax
          xFuelRestrictorMax
          xRefuelRestrictorMax
          EStintMax
          _id
        }
        sessionBop {
          EStintEnergyMax
          EStintEnergyRefillRateMax
          fuelType
          mRefuelRateMax
          pAmbientSessionOfficial
          tyreModel
          VRefuelRateMax
          xStintlengthMax
          _id
        }
      }
    }
  }
}
    `;

export const useGetBopForTrackerTableQuery = <
      TData = GetBopForTrackerTableQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetBopForTrackerTableQueryVariables,
      options?: UseQueryOptions<GetBopForTrackerTableQuery, TError, TData>
    ) => {
    
    return useQuery<GetBopForTrackerTableQuery, TError, TData>(
      ['GetBopForTrackerTable', variables],
      fetcher<GetBopForTrackerTableQuery, GetBopForTrackerTableQueryVariables>(GetBopForTrackerTableDocument, variables),
      options
    )};

export const ApplyPackageItemsForCopyConfirmDocument = `
    mutation ApplyPackageItemsForCopyConfirm($packageItems: [UpdateByIdPackageItemsInput], $carSetupIDs: [MongoID!]) {
  applyPackageItems(packageItems: $packageItems, carSetupIDs: $carSetupIDs) {
    success
  }
}
    `;

export const useApplyPackageItemsForCopyConfirmMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ApplyPackageItemsForCopyConfirmMutation, TError, ApplyPackageItemsForCopyConfirmMutationVariables, TContext>) => {
    
    return useMutation<ApplyPackageItemsForCopyConfirmMutation, TError, ApplyPackageItemsForCopyConfirmMutationVariables, TContext>(
      ['ApplyPackageItemsForCopyConfirm'],
      (variables?: ApplyPackageItemsForCopyConfirmMutationVariables) => fetcher<ApplyPackageItemsForCopyConfirmMutation, ApplyPackageItemsForCopyConfirmMutationVariables>(ApplyPackageItemsForCopyConfirmDocument, variables)(),
      options
    )};

export const GetSimulationDriveFilesDocument = `
    query GetSimulationDriveFiles {
  simulationDriveFiles(perPage: 2000) {
    items {
      _id
      event {
        name
        _id
      }
      name
      status
    }
  }
}
    `;

export const useGetSimulationDriveFilesQuery = <
      TData = GetSimulationDriveFilesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimulationDriveFilesQueryVariables,
      options?: UseQueryOptions<GetSimulationDriveFilesQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimulationDriveFilesQuery, TError, TData>(
      variables === undefined ? ['GetSimulationDriveFiles'] : ['GetSimulationDriveFiles', variables],
      fetcher<GetSimulationDriveFilesQuery, GetSimulationDriveFilesQueryVariables>(GetSimulationDriveFilesDocument, variables),
      options
    )};

export const RemoveSimulationDriveFileByIdDocument = `
    mutation RemoveSimulationDriveFileById($id: MongoID!) {
  removeSimulationDriveFile(_id: $id) {
    error {
      message
    }
    record {
      _id
    }
  }
}
    `;

export const useRemoveSimulationDriveFileByIdMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSimulationDriveFileByIdMutation, TError, RemoveSimulationDriveFileByIdMutationVariables, TContext>) => {
    
    return useMutation<RemoveSimulationDriveFileByIdMutation, TError, RemoveSimulationDriveFileByIdMutationVariables, TContext>(
      ['RemoveSimulationDriveFileById'],
      (variables?: RemoveSimulationDriveFileByIdMutationVariables) => fetcher<RemoveSimulationDriveFileByIdMutation, RemoveSimulationDriveFileByIdMutationVariables>(RemoveSimulationDriveFileByIdDocument, variables)(),
      options
    )};

export const GetSimResultsForSimChannelSearchModalDocument = `
    query GetSimResultsForSimChannelSearchModal($simType: EnumSimResultSimType) {
  simResults(sort: UPDATEDAT_DESC, filter: {simType: $simType}, perPage: 5) {
    items {
      ...SimResultForSimChannelSearchModalVars
    }
  }
}
    ${SimResultForSimChannelSearchModalVarsFragmentDoc}`;

export const useGetSimResultsForSimChannelSearchModalQuery = <
      TData = GetSimResultsForSimChannelSearchModalQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimResultsForSimChannelSearchModalQueryVariables,
      options?: UseQueryOptions<GetSimResultsForSimChannelSearchModalQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimResultsForSimChannelSearchModalQuery, TError, TData>(
      variables === undefined ? ['GetSimResultsForSimChannelSearchModal'] : ['GetSimResultsForSimChannelSearchModal', variables],
      fetcher<GetSimResultsForSimChannelSearchModalQuery, GetSimResultsForSimChannelSearchModalQueryVariables>(GetSimResultsForSimChannelSearchModalDocument, variables),
      options
    )};

export const GetLapTypeFilterNamesDocument = `
    query GetLapTypeFilterNames($id: MongoID!) {
  runSheetStyle(_id: $id) {
    lapFlags {
      ATTACK
      COOL
      FCY
      IN
      OUT
      OUTIN
      PITLANE
      PREP
      PUSH
      QUALI
      SAFETYCAR
      SHAKEDOWN
      SLOW
      TARGET
      TOGRID
      TOPADDOCK
      TOPITS
      UNFINISHED
    }
  }
}
    `;

export const useGetLapTypeFilterNamesQuery = <
      TData = GetLapTypeFilterNamesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetLapTypeFilterNamesQueryVariables,
      options?: UseQueryOptions<GetLapTypeFilterNamesQuery, TError, TData>
    ) => {
    
    return useQuery<GetLapTypeFilterNamesQuery, TError, TData>(
      ['GetLapTypeFilterNames', variables],
      fetcher<GetLapTypeFilterNamesQuery, GetLapTypeFilterNamesQueryVariables>(GetLapTypeFilterNamesDocument, variables),
      options
    )};

export const GetMileageSummaryDataDocument = `
    query GetMileageSummaryData($runSheetIDs: [MongoID!]!) {
  runSheets(filter: {_operators: {_id: {in: $runSheetIDs}}}, perPage: 20000) {
    items {
      ...MileageSummaryRunSheetVars
    }
  }
}
    ${MileageSummaryRunSheetVarsFragmentDoc}`;

export const useGetMileageSummaryDataQuery = <
      TData = GetMileageSummaryDataQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetMileageSummaryDataQueryVariables,
      options?: UseQueryOptions<GetMileageSummaryDataQuery, TError, TData>
    ) => {
    
    return useQuery<GetMileageSummaryDataQuery, TError, TData>(
      ['GetMileageSummaryData', variables],
      fetcher<GetMileageSummaryDataQuery, GetMileageSummaryDataQueryVariables>(GetMileageSummaryDataDocument, variables),
      options
    )};

export const GetRunSheetsAndSessionInfoForSessionTimelineDocument = `
    query GetRunSheetsAndSessionInfoForSessionTimeline($contestantID: MongoID!, $sessionID: MongoID!) {
  runSheets(
    filter: {contestantID: $contestantID, sessionID: $sessionID}
    perPage: 20000
  ) {
    items {
      NRun
      lapCount
      startTime
      endTime
      runDescription
    }
  }
  session(_id: $sessionID) {
    name
    tSessionStart
    tSessionEnd
    event {
      track {
        timeZone
      }
    }
  }
  runPlans(filter: {contestantID: $contestantID, sessionID: $sessionID}) {
    items {
      runs {
        NRun
        lapSequence {
          NLap
        }
      }
    }
  }
}
    `;

export const useGetRunSheetsAndSessionInfoForSessionTimelineQuery = <
      TData = GetRunSheetsAndSessionInfoForSessionTimelineQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetsAndSessionInfoForSessionTimelineQueryVariables,
      options?: UseQueryOptions<GetRunSheetsAndSessionInfoForSessionTimelineQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsAndSessionInfoForSessionTimelineQuery, TError, TData>(
      ['GetRunSheetsAndSessionInfoForSessionTimeline', variables],
      fetcher<GetRunSheetsAndSessionInfoForSessionTimelineQuery, GetRunSheetsAndSessionInfoForSessionTimelineQueryVariables>(GetRunSheetsAndSessionInfoForSessionTimelineDocument, variables),
      options
    )};

export const GetAllCalculationsForTreeViewDocument = `
    query GetAllCalculationsForTreeView($filter: FilterFindManyCalculationInput) {
  calculations(perPage: 20000, filter: $filter) {
    items {
      _id
      isActive
      name
      parameter
    }
  }
}
    `;

export const useGetAllCalculationsForTreeViewQuery = <
      TData = GetAllCalculationsForTreeViewQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllCalculationsForTreeViewQueryVariables,
      options?: UseQueryOptions<GetAllCalculationsForTreeViewQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllCalculationsForTreeViewQuery, TError, TData>(
      variables === undefined ? ['GetAllCalculationsForTreeView'] : ['GetAllCalculationsForTreeView', variables],
      fetcher<GetAllCalculationsForTreeViewQuery, GetAllCalculationsForTreeViewQueryVariables>(GetAllCalculationsForTreeViewDocument, variables),
      options
    )};

export const GetCarDataServiceConfigsForSetupOverviewTableConfigDocument = `
    query GetCarDataServiceConfigsForSetupOverviewTableConfig {
  carDataServiceConfigs {
    items {
      active
      Kpi {
        KpiParameters
      }
    }
  }
}
    `;

export const useGetCarDataServiceConfigsForSetupOverviewTableConfigQuery = <
      TData = GetCarDataServiceConfigsForSetupOverviewTableConfigQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetCarDataServiceConfigsForSetupOverviewTableConfigQueryVariables,
      options?: UseQueryOptions<GetCarDataServiceConfigsForSetupOverviewTableConfigQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarDataServiceConfigsForSetupOverviewTableConfigQuery, TError, TData>(
      variables === undefined ? ['GetCarDataServiceConfigsForSetupOverviewTableConfig'] : ['GetCarDataServiceConfigsForSetupOverviewTableConfig', variables],
      fetcher<GetCarDataServiceConfigsForSetupOverviewTableConfigQuery, GetCarDataServiceConfigsForSetupOverviewTableConfigQueryVariables>(GetCarDataServiceConfigsForSetupOverviewTableConfigDocument, variables),
      options
    )};

export const GetSimResultsForSimManagerListDocument = `
    query GetSimResultsForSimManagerList($runSheetID: MongoID) {
  simResults(filter: {runSheetID: $runSheetID}, perPage: 200) {
    items {
      _id
      ...SimResultVarsForSimManagerList
    }
  }
}
    ${SimResultVarsForSimManagerListFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetSimResultsForSimManagerListQuery = <
      TData = GetSimResultsForSimManagerListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimResultsForSimManagerListQueryVariables,
      options?: UseQueryOptions<GetSimResultsForSimManagerListQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimResultsForSimManagerListQuery, TError, TData>(
      variables === undefined ? ['GetSimResultsForSimManagerList'] : ['GetSimResultsForSimManagerList', variables],
      fetcher<GetSimResultsForSimManagerListQuery, GetSimResultsForSimManagerListQueryVariables>(GetSimResultsForSimManagerListDocument, variables),
      options
    )};

export const GetRunSheetInfoForSimManagerByIdDocument = `
    query GetRunSheetInfoForSimManagerById($runSheetID: MongoID!) {
  runSheet(_id: $runSheetID) {
    _id
    NRun
    NRunTiming
    contestant {
      startNumber
    }
    session {
      name
      event {
        name
        season {
          name
          raceSeries {
            name
          }
        }
      }
    }
  }
}
    `;

export const useGetRunSheetInfoForSimManagerByIdQuery = <
      TData = GetRunSheetInfoForSimManagerByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetInfoForSimManagerByIdQueryVariables,
      options?: UseQueryOptions<GetRunSheetInfoForSimManagerByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetInfoForSimManagerByIdQuery, TError, TData>(
      ['GetRunSheetInfoForSimManagerById', variables],
      fetcher<GetRunSheetInfoForSimManagerByIdQuery, GetRunSheetInfoForSimManagerByIdQueryVariables>(GetRunSheetInfoForSimManagerByIdDocument, variables),
      options
    )};

export const GetAllSimResultsPerPageDocument = `
    query GetAllSimResultsPerPage($page: Int) {
  simResults(page: $page) {
    count
    items {
      _id
      ...SimResultVars
    }
  }
}
    ${SimResultVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetAllSimResultsPerPageQuery = <
      TData = GetAllSimResultsPerPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllSimResultsPerPageQueryVariables,
      options?: UseQueryOptions<GetAllSimResultsPerPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllSimResultsPerPageQuery, TError, TData>(
      variables === undefined ? ['GetAllSimResultsPerPage'] : ['GetAllSimResultsPerPage', variables],
      fetcher<GetAllSimResultsPerPageQuery, GetAllSimResultsPerPageQueryVariables>(GetAllSimResultsPerPageDocument, variables),
      options
    )};

export const RemoveSimResultDocument = `
    mutation RemoveSimResult($id: MongoID!) {
  removeSimResult(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveSimResultMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSimResultMutation, TError, RemoveSimResultMutationVariables, TContext>) => {
    
    return useMutation<RemoveSimResultMutation, TError, RemoveSimResultMutationVariables, TContext>(
      ['RemoveSimResult'],
      (variables?: RemoveSimResultMutationVariables) => fetcher<RemoveSimResultMutation, RemoveSimResultMutationVariables>(RemoveSimResultDocument, variables)(),
      options
    )};

export const RemoveManySimResultsByIdDocument = `
    mutation RemoveManySimResultsByID($arr: [MongoID!]) {
  removeManySimResults(filter: {_operators: {_id: {in: $arr}}}) {
    numAffected
  }
}
    `;

export const useRemoveManySimResultsByIdMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveManySimResultsByIdMutation, TError, RemoveManySimResultsByIdMutationVariables, TContext>) => {
    
    return useMutation<RemoveManySimResultsByIdMutation, TError, RemoveManySimResultsByIdMutationVariables, TContext>(
      ['RemoveManySimResultsByID'],
      (variables?: RemoveManySimResultsByIdMutationVariables) => fetcher<RemoveManySimResultsByIdMutation, RemoveManySimResultsByIdMutationVariables>(RemoveManySimResultsByIdDocument, variables)(),
      options
    )};

export const GetContestantColorsForColorSettingsDocument = `
    query GetContestantColorsForColorSettings($contestantIDs: [MongoID!]) {
  contestants(filter: {_operators: {_id: {in: $contestantIDs}}}) {
    items {
      _id
      color
      startNumber
    }
  }
}
    `;

export const useGetContestantColorsForColorSettingsQuery = <
      TData = GetContestantColorsForColorSettingsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetContestantColorsForColorSettingsQueryVariables,
      options?: UseQueryOptions<GetContestantColorsForColorSettingsQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantColorsForColorSettingsQuery, TError, TData>(
      variables === undefined ? ['GetContestantColorsForColorSettings'] : ['GetContestantColorsForColorSettings', variables],
      fetcher<GetContestantColorsForColorSettingsQuery, GetContestantColorsForColorSettingsQueryVariables>(GetContestantColorsForColorSettingsDocument, variables),
      options
    )};

export const GetEventContestantsForDashboardDocument = `
    query GetEventContestantsForDashboard($id: MongoID!) {
  event(_id: $id) {
    contestants {
      _id
    }
    season {
      contestants {
        chassisIDs
        chassisNumber
        class
        color
        eligibleForPoints
        startNumber
        _id
        chassis {
          reference
          type
        }
        drivers {
          acronym
          name
        }
        team {
          name
          shortName
          color
          raceSeriesID
          tagIDs
          _id
        }
      }
    }
  }
}
    `;

export const useGetEventContestantsForDashboardQuery = <
      TData = GetEventContestantsForDashboardQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventContestantsForDashboardQueryVariables,
      options?: UseQueryOptions<GetEventContestantsForDashboardQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventContestantsForDashboardQuery, TError, TData>(
      ['GetEventContestantsForDashboard', variables],
      fetcher<GetEventContestantsForDashboardQuery, GetEventContestantsForDashboardQueryVariables>(GetEventContestantsForDashboardDocument, variables),
      options
    )};

export const GetSetupIdForRunSheetDocument = `
    query GetSetupIdForRunSheet($runSheetID: MongoID!) {
  runSheet(_id: $runSheetID) {
    setupID
  }
}
    `;

export const useGetSetupIdForRunSheetQuery = <
      TData = GetSetupIdForRunSheetQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSetupIdForRunSheetQueryVariables,
      options?: UseQueryOptions<GetSetupIdForRunSheetQuery, TError, TData>
    ) => {
    
    return useQuery<GetSetupIdForRunSheetQuery, TError, TData>(
      ['GetSetupIdForRunSheet', variables],
      fetcher<GetSetupIdForRunSheetQuery, GetSetupIdForRunSheetQueryVariables>(GetSetupIdForRunSheetDocument, variables),
      options
    )};

export const SplitRunSheetDocument = `
    mutation SplitRunSheet($runSheetId: MongoID!) {
  splitRunSheet(runSheetID: $runSheetId) {
    _id
  }
}
    `;

export const useSplitRunSheetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<SplitRunSheetMutation, TError, SplitRunSheetMutationVariables, TContext>) => {
    
    return useMutation<SplitRunSheetMutation, TError, SplitRunSheetMutationVariables, TContext>(
      ['SplitRunSheet'],
      (variables?: SplitRunSheetMutationVariables) => fetcher<SplitRunSheetMutation, SplitRunSheetMutationVariables>(SplitRunSheetDocument, variables)(),
      options
    )};

export const InsertRunDocument = `
    mutation InsertRun($insertAfterRunSheetID: MongoID, $insertBeforeRunSheetID: MongoID, $sourceSetupID: MongoID, $sourceRunSheetID: MongoID) {
  insertRun(
    insertAfterRunSheetID: $insertAfterRunSheetID
    insertBeforeRunSheetID: $insertBeforeRunSheetID
    sourceSetupID: $sourceSetupID
    sourceRunSheetID: $sourceRunSheetID
  ) {
    success
    message
    newRunSheetID
  }
}
    `;

export const useInsertRunMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<InsertRunMutation, TError, InsertRunMutationVariables, TContext>) => {
    
    return useMutation<InsertRunMutation, TError, InsertRunMutationVariables, TContext>(
      ['InsertRun'],
      (variables?: InsertRunMutationVariables) => fetcher<InsertRunMutation, InsertRunMutationVariables>(InsertRunDocument, variables)(),
      options
    )};

export const GetEventInfoForRunInsertModalDocument = `
    query GetEventInfoForRunInsertModal($id: MongoID!) {
  event(_id: $id) {
    _id
    name
    sessionIDs
    trackLayoutIDs
    sessions {
      _id
      name
      shortName
      tSessionStart
      tSessionEnd
    }
    season {
      _id
      contestants {
        _id
        startNumber
      }
      contestantIDs
      name
      raceSeries {
        _id
        name
      }
    }
  }
}
    `;

export const useGetEventInfoForRunInsertModalQuery = <
      TData = GetEventInfoForRunInsertModalQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventInfoForRunInsertModalQueryVariables,
      options?: UseQueryOptions<GetEventInfoForRunInsertModalQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventInfoForRunInsertModalQuery, TError, TData>(
      ['GetEventInfoForRunInsertModal', variables],
      fetcher<GetEventInfoForRunInsertModalQuery, GetEventInfoForRunInsertModalQueryVariables>(GetEventInfoForRunInsertModalDocument, variables),
      options
    )};

export const InsertRunIntoSessionDocument = `
    mutation InsertRunIntoSession($contestantID: MongoID!, $sessionID: MongoID!, $sourceRunSheetID: MongoID!) {
  insertRunIntoSession(
    contestantID: $contestantID
    sessionID: $sessionID
    sourceRunSheetID: $sourceRunSheetID
  ) {
    success
    message
    newRunSheetID
  }
}
    `;

export const useInsertRunIntoSessionMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<InsertRunIntoSessionMutation, TError, InsertRunIntoSessionMutationVariables, TContext>) => {
    
    return useMutation<InsertRunIntoSessionMutation, TError, InsertRunIntoSessionMutationVariables, TContext>(
      ['InsertRunIntoSession'],
      (variables?: InsertRunIntoSessionMutationVariables) => fetcher<InsertRunIntoSessionMutation, InsertRunIntoSessionMutationVariables>(InsertRunIntoSessionDocument, variables)(),
      options
    )};

export const RequiredClientVersionDocument = `
    query RequiredClientVersion {
  requiredClientVersion
}
    `;

export const useRequiredClientVersionQuery = <
      TData = RequiredClientVersionQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: RequiredClientVersionQueryVariables,
      options?: UseQueryOptions<RequiredClientVersionQuery, TError, TData>
    ) => {
    
    return useQuery<RequiredClientVersionQuery, TError, TData>(
      variables === undefined ? ['RequiredClientVersion'] : ['RequiredClientVersion', variables],
      fetcher<RequiredClientVersionQuery, RequiredClientVersionQueryVariables>(RequiredClientVersionDocument, variables),
      options
    )};

export const GetSessionsInDateTimeRangeForTimingServiceStatusDocument = `
    query GetSessionsInDateTimeRangeForTimingServiceStatus($startDate: Date, $endDate: Date) {
  sessions(
    filter: {AND: [{_operators: {tSessionStart: {gte: $startDate}}}, {_operators: {tSessionStart: {lte: $endDate}}}]}
    sort: TSESSIONSTART_DESC
    perPage: 500
  ) {
    items {
      _id
      name
      tSessionStart
    }
  }
}
    `;

export const useGetSessionsInDateTimeRangeForTimingServiceStatusQuery = <
      TData = GetSessionsInDateTimeRangeForTimingServiceStatusQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSessionsInDateTimeRangeForTimingServiceStatusQueryVariables,
      options?: UseQueryOptions<GetSessionsInDateTimeRangeForTimingServiceStatusQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionsInDateTimeRangeForTimingServiceStatusQuery, TError, TData>(
      variables === undefined ? ['GetSessionsInDateTimeRangeForTimingServiceStatus'] : ['GetSessionsInDateTimeRangeForTimingServiceStatus', variables],
      fetcher<GetSessionsInDateTimeRangeForTimingServiceStatusQuery, GetSessionsInDateTimeRangeForTimingServiceStatusQueryVariables>(GetSessionsInDateTimeRangeForTimingServiceStatusDocument, variables),
      options
    )};

export const GetRunSheetAndSetupIDsBySessionsIDsDocument = `
    query GetRunSheetAndSetupIDsBySessionsIDs($sessionIDs: [MongoID!]!, $contestantIDs: [MongoID!]!) {
  runSheets(
    perPage: 1
    filter: {_operators: {sessionID: {in: $sessionIDs}, contestantID: {in: $contestantIDs}}}
    sort: NRUNTIMING_DESC
  ) {
    items {
      ...RunSheetForAddButtonVars
    }
  }
}
    ${RunSheetForAddButtonVarsFragmentDoc}`;

export const useGetRunSheetAndSetupIDsBySessionsIDsQuery = <
      TData = GetRunSheetAndSetupIDsBySessionsIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetAndSetupIDsBySessionsIDsQueryVariables,
      options?: UseQueryOptions<GetRunSheetAndSetupIDsBySessionsIDsQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetAndSetupIDsBySessionsIDsQuery, TError, TData>(
      ['GetRunSheetAndSetupIDsBySessionsIDs', variables],
      fetcher<GetRunSheetAndSetupIDsBySessionsIDsQuery, GetRunSheetAndSetupIDsBySessionsIDsQueryVariables>(GetRunSheetAndSetupIDsBySessionsIDsDocument, variables),
      options
    )};

export const GetDataForAddRunButtonDocument = `
    query GetDataForAddRunButton($personID: MongoID!) {
  person(_id: $personID) {
    behaviour {
      carryOverJobList
    }
  }
}
    `;

export const useGetDataForAddRunButtonQuery = <
      TData = GetDataForAddRunButtonQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetDataForAddRunButtonQueryVariables,
      options?: UseQueryOptions<GetDataForAddRunButtonQuery, TError, TData>
    ) => {
    
    return useQuery<GetDataForAddRunButtonQuery, TError, TData>(
      ['GetDataForAddRunButton', variables],
      fetcher<GetDataForAddRunButtonQuery, GetDataForAddRunButtonQueryVariables>(GetDataForAddRunButtonDocument, variables),
      options
    )};

export const GetPreviousSessionForSessionDocument = `
    query GetPreviousSessionForSession($sessionID: MongoID!) {
  session(_id: $sessionID) {
    prevSessionID
  }
}
    `;

export const useGetPreviousSessionForSessionQuery = <
      TData = GetPreviousSessionForSessionQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPreviousSessionForSessionQueryVariables,
      options?: UseQueryOptions<GetPreviousSessionForSessionQuery, TError, TData>
    ) => {
    
    return useQuery<GetPreviousSessionForSessionQuery, TError, TData>(
      ['GetPreviousSessionForSession', variables],
      fetcher<GetPreviousSessionForSessionQuery, GetPreviousSessionForSessionQueryVariables>(GetPreviousSessionForSessionDocument, variables),
      options
    )};

export const GetChassisMeasurementUnitsForDisplayChangesDocument = `
    query GetChassisMeasurementUnitsForDisplayChanges($id: MongoID!) {
  specification(_id: $id) {
    ...ChassisSpecVarsForDisplayChanges
  }
}
    ${ChassisSpecVarsForDisplayChangesFragmentDoc}
${ChassisMeasurementVarsFragmentDoc}`;

export const useGetChassisMeasurementUnitsForDisplayChangesQuery = <
      TData = GetChassisMeasurementUnitsForDisplayChangesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisMeasurementUnitsForDisplayChangesQueryVariables,
      options?: UseQueryOptions<GetChassisMeasurementUnitsForDisplayChangesQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisMeasurementUnitsForDisplayChangesQuery, TError, TData>(
      ['GetChassisMeasurementUnitsForDisplayChanges', variables],
      fetcher<GetChassisMeasurementUnitsForDisplayChangesQuery, GetChassisMeasurementUnitsForDisplayChangesQueryVariables>(GetChassisMeasurementUnitsForDisplayChangesDocument, variables),
      options
    )};

export const GetCarSetupSearchByEventDocument = `
    query GetCarSetupSearchByEvent($eventID: MongoID!) {
  carSetupsMany(filter: {eventID: $eventID}, limit: 2000) {
    _id
    title
    contestantID
  }
}
    `;

export const useGetCarSetupSearchByEventQuery = <
      TData = GetCarSetupSearchByEventQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCarSetupSearchByEventQueryVariables,
      options?: UseQueryOptions<GetCarSetupSearchByEventQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarSetupSearchByEventQuery, TError, TData>(
      ['GetCarSetupSearchByEvent', variables],
      fetcher<GetCarSetupSearchByEventQuery, GetCarSetupSearchByEventQueryVariables>(GetCarSetupSearchByEventDocument, variables),
      options
    )};

export const GetUserSetupsDocument = `
    query GetUserSetups($id: MongoID!) {
  person(_id: $id) {
    userSetups {
      _id
      title
    }
  }
}
    `;

export const useGetUserSetupsQuery = <
      TData = GetUserSetupsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetUserSetupsQueryVariables,
      options?: UseQueryOptions<GetUserSetupsQuery, TError, TData>
    ) => {
    
    return useQuery<GetUserSetupsQuery, TError, TData>(
      ['GetUserSetups', variables],
      fetcher<GetUserSetupsQuery, GetUserSetupsQueryVariables>(GetUserSetupsDocument, variables),
      options
    )};

export const GetShowMyJobsDefaultValueDocument = `
    query GetShowMyJobsDefaultValue($id: MongoID!) {
  person(_id: $id) {
    behaviour {
      showMyJobsOnRunSheetDefault
    }
  }
}
    `;

export const useGetShowMyJobsDefaultValueQuery = <
      TData = GetShowMyJobsDefaultValueQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetShowMyJobsDefaultValueQueryVariables,
      options?: UseQueryOptions<GetShowMyJobsDefaultValueQuery, TError, TData>
    ) => {
    
    return useQuery<GetShowMyJobsDefaultValueQuery, TError, TData>(
      ['GetShowMyJobsDefaultValue', variables],
      fetcher<GetShowMyJobsDefaultValueQuery, GetShowMyJobsDefaultValueQueryVariables>(GetShowMyJobsDefaultValueDocument, variables),
      options
    )};

export const GetJobForJobEditModalDocument = `
    query GetJobForJobEditModal($id: MongoID!) {
  job(_id: $id) {
    assigneeIDs
    description
    index
    number
    priority
  }
}
    `;

export const useGetJobForJobEditModalQuery = <
      TData = GetJobForJobEditModalQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetJobForJobEditModalQueryVariables,
      options?: UseQueryOptions<GetJobForJobEditModalQuery, TError, TData>
    ) => {
    
    return useQuery<GetJobForJobEditModalQuery, TError, TData>(
      ['GetJobForJobEditModal', variables],
      fetcher<GetJobForJobEditModalQuery, GetJobForJobEditModalQueryVariables>(GetJobForJobEditModalDocument, variables),
      options
    )};

export const RemoveJobCommentDocument = `
    mutation RemoveJobComment($commentId: MongoID!, $subjectId: MongoID!, $target: EnumJobTarget!) {
  removeComment(commentID: $commentId, subjectID: $subjectId, target: $target) {
    comment {
      _id
    }
  }
}
    `;

export const useRemoveJobCommentMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveJobCommentMutation, TError, RemoveJobCommentMutationVariables, TContext>) => {
    
    return useMutation<RemoveJobCommentMutation, TError, RemoveJobCommentMutationVariables, TContext>(
      ['RemoveJobComment'],
      (variables?: RemoveJobCommentMutationVariables) => fetcher<RemoveJobCommentMutation, RemoveJobCommentMutationVariables>(RemoveJobCommentDocument, variables)(),
      options
    )};

export const AddJobListToRunsheetFromTemplateDocument = `
    mutation AddJobListToRunsheetFromTemplate($records: [CreateManyJobInput!]!) {
  addJobsMany(records: $records) {
    recordIds
  }
}
    `;

export const useAddJobListToRunsheetFromTemplateMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddJobListToRunsheetFromTemplateMutation, TError, AddJobListToRunsheetFromTemplateMutationVariables, TContext>) => {
    
    return useMutation<AddJobListToRunsheetFromTemplateMutation, TError, AddJobListToRunsheetFromTemplateMutationVariables, TContext>(
      ['AddJobListToRunsheetFromTemplate'],
      (variables?: AddJobListToRunsheetFromTemplateMutationVariables) => fetcher<AddJobListToRunsheetFromTemplateMutation, AddJobListToRunsheetFromTemplateMutationVariables>(AddJobListToRunsheetFromTemplateDocument, variables)(),
      options
    )};

export const GetRaceSeriesLapTypeConfigDocument = `
    query GetRaceSeriesLapTypeConfig($id: MongoID!) {
  raceSeries(_id: $id) {
    lapTypeConfig {
      ...LapTypeConfigVars
    }
  }
}
    ${LapTypeConfigVarsFragmentDoc}`;

export const useGetRaceSeriesLapTypeConfigQuery = <
      TData = GetRaceSeriesLapTypeConfigQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRaceSeriesLapTypeConfigQueryVariables,
      options?: UseQueryOptions<GetRaceSeriesLapTypeConfigQuery, TError, TData>
    ) => {
    
    return useQuery<GetRaceSeriesLapTypeConfigQuery, TError, TData>(
      ['GetRaceSeriesLapTypeConfig', variables],
      fetcher<GetRaceSeriesLapTypeConfigQuery, GetRaceSeriesLapTypeConfigQueryVariables>(GetRaceSeriesLapTypeConfigDocument, variables),
      options
    )};

export const FlexCarSetupInfoFieldUpdatedDocument = `
    subscription FlexCarSetupInfoFieldUpdated($id: MongoID!) {
  carSetupUpdated(carSetupID: $id) {
    _id
    setupInfo
  }
}
    `;
export const GetFlexCarSetupInfoFieldDocument = `
    query GetFlexCarSetupInfoField($id: MongoID!) {
  carSetup(_id: $id) {
    _id
    setupInfo
  }
}
    `;

export const useGetFlexCarSetupInfoFieldQuery = <
      TData = GetFlexCarSetupInfoFieldQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetFlexCarSetupInfoFieldQueryVariables,
      options?: UseQueryOptions<GetFlexCarSetupInfoFieldQuery, TError, TData>
    ) => {
    
    return useQuery<GetFlexCarSetupInfoFieldQuery, TError, TData>(
      ['GetFlexCarSetupInfoField', variables],
      fetcher<GetFlexCarSetupInfoFieldQuery, GetFlexCarSetupInfoFieldQueryVariables>(GetFlexCarSetupInfoFieldDocument, variables),
      options
    )};

export const GetSpecInfoForCustomSpecFieldDocument = `
    query GetSpecInfoForCustomSpecField($id: MongoID!) {
  specification(_id: $id) {
    ...SpecInfoForMeasurementFieldVars
  }
}
    ${SpecInfoForMeasurementFieldVarsFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}`;

export const useGetSpecInfoForCustomSpecFieldQuery = <
      TData = GetSpecInfoForCustomSpecFieldQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSpecInfoForCustomSpecFieldQueryVariables,
      options?: UseQueryOptions<GetSpecInfoForCustomSpecFieldQuery, TError, TData>
    ) => {
    
    return useQuery<GetSpecInfoForCustomSpecFieldQuery, TError, TData>(
      ['GetSpecInfoForCustomSpecField', variables],
      fetcher<GetSpecInfoForCustomSpecFieldQuery, GetSpecInfoForCustomSpecFieldQueryVariables>(GetSpecInfoForCustomSpecFieldDocument, variables),
      options
    )};

export const GetSpecDetailsForPartSelectFieldDocument = `
    query GetSpecDetailsForPartSelectField($id: MongoID!) {
  specification(_id: $id) {
    ... on AeroElementSpec {
      _id
      hasToBeInSubAssembly
    }
    ... on AntiRollBarSpec {
      _id
      hasToBeInSubAssembly
    }
    ... on CustomSpec {
      _id
      hasToBeInSubAssembly
    }
    ... on DamperSpec {
      _id
      hasToBeInSubAssembly
    }
    ... on ElasticSpec {
      _id
      hasToBeInSubAssembly
    }
  }
}
    `;

export const useGetSpecDetailsForPartSelectFieldQuery = <
      TData = GetSpecDetailsForPartSelectFieldQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSpecDetailsForPartSelectFieldQueryVariables,
      options?: UseQueryOptions<GetSpecDetailsForPartSelectFieldQuery, TError, TData>
    ) => {
    
    return useQuery<GetSpecDetailsForPartSelectFieldQuery, TError, TData>(
      ['GetSpecDetailsForPartSelectField', variables],
      fetcher<GetSpecDetailsForPartSelectFieldQuery, GetSpecDetailsForPartSelectFieldQueryVariables>(GetSpecDetailsForPartSelectFieldDocument, variables),
      options
    )};

export const UpdatePartInstancesFromCustomSpecFieldDocument = `
    mutation UpdatePartInstancesFromCustomSpecField($id: MongoID!, $record: UpdateByIdAssemblyInput!) {
  updateAssembly(_id: $id, record: $record) {
    record {
      ... on ChassisAssembly {
        partInstances {
          _id
          specificationID
          specificationGroupID
        }
      }
    }
  }
}
    `;

export const useUpdatePartInstancesFromCustomSpecFieldMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePartInstancesFromCustomSpecFieldMutation, TError, UpdatePartInstancesFromCustomSpecFieldMutationVariables, TContext>) => {
    
    return useMutation<UpdatePartInstancesFromCustomSpecFieldMutation, TError, UpdatePartInstancesFromCustomSpecFieldMutationVariables, TContext>(
      ['UpdatePartInstancesFromCustomSpecField'],
      (variables?: UpdatePartInstancesFromCustomSpecFieldMutationVariables) => fetcher<UpdatePartInstancesFromCustomSpecFieldMutation, UpdatePartInstancesFromCustomSpecFieldMutationVariables>(UpdatePartInstancesFromCustomSpecFieldDocument, variables)(),
      options
    )};

export const GetPartsForSetupSheetFlexSelectDocument = `
    query GetPartsForSetupSheetFlexSelect($rootSpecificationID: MongoID!, $currentPartID: MongoID!, $teamIDs: [MongoID]) {
  partsAdvancedFilter(
    perPage: 20000
    rootSpecificationID: $rootSpecificationID
    teamIDs: $teamIDs
    userEnumPartStatusActive: true
    sort: REFERENCE_ASC
  ) {
    items {
      _id
      displayName
      readingLocationOverride
      reference
      rootSpecificationID
      specification {
        _id
        hasToBeInSubAssembly
        name
      }
    }
  }
  part(_id: $currentPartID) {
    _id
    displayName
    readingLocationOverride
    reference
    rootSpecificationID
    specification {
      _id
      hasToBeInSubAssembly
      name
    }
  }
}
    `;

export const useGetPartsForSetupSheetFlexSelectQuery = <
      TData = GetPartsForSetupSheetFlexSelectQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartsForSetupSheetFlexSelectQueryVariables,
      options?: UseQueryOptions<GetPartsForSetupSheetFlexSelectQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartsForSetupSheetFlexSelectQuery, TError, TData>(
      ['GetPartsForSetupSheetFlexSelect', variables],
      fetcher<GetPartsForSetupSheetFlexSelectQuery, GetPartsForSetupSheetFlexSelectQueryVariables>(GetPartsForSetupSheetFlexSelectDocument, variables),
      options
    )};

export const GetPartInstanceTrackingReferenceDatesDocument = `
    query GetPartInstanceTrackingReferenceDates($partID: MongoID!) {
  trackingRecords(filter: {partID: $partID, type: VALUE}, perPage: 200) {
    items {
      _id
      date
      type
    }
  }
}
    `;

export const useGetPartInstanceTrackingReferenceDatesQuery = <
      TData = GetPartInstanceTrackingReferenceDatesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartInstanceTrackingReferenceDatesQueryVariables,
      options?: UseQueryOptions<GetPartInstanceTrackingReferenceDatesQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartInstanceTrackingReferenceDatesQuery, TError, TData>(
      ['GetPartInstanceTrackingReferenceDates', variables],
      fetcher<GetPartInstanceTrackingReferenceDatesQuery, GetPartInstanceTrackingReferenceDatesQueryVariables>(GetPartInstanceTrackingReferenceDatesDocument, variables),
      options
    )};

export const RunInfoFieldUpdatedDocument = `
    subscription RunInfoFieldUpdated($id: MongoID!) {
  runSheetUpdated(runSheetID: $id) {
    info
  }
}
    `;
export const GetEngineersForSetupSheetFlexHeaderDocument = `
    query GetEngineersForSetupSheetFlexHeader($id: MongoID!) {
  people(
    filter: {OR: [{role: CAR_ENGINEER}, {role: CHIEF_ENGINEER}, {role: ADMIN}], isActive: true}
    perPage: 50
    sort: NAME_ASC
  ) {
    items {
      _id
      name
    }
  }
  person(_id: $id) {
    _id
    name
  }
}
    `;

export const useGetEngineersForSetupSheetFlexHeaderQuery = <
      TData = GetEngineersForSetupSheetFlexHeaderQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEngineersForSetupSheetFlexHeaderQueryVariables,
      options?: UseQueryOptions<GetEngineersForSetupSheetFlexHeaderQuery, TError, TData>
    ) => {
    
    return useQuery<GetEngineersForSetupSheetFlexHeaderQuery, TError, TData>(
      ['GetEngineersForSetupSheetFlexHeader', variables],
      fetcher<GetEngineersForSetupSheetFlexHeaderQuery, GetEngineersForSetupSheetFlexHeaderQueryVariables>(GetEngineersForSetupSheetFlexHeaderDocument, variables),
      options
    )};

export const GetSetupSheetStyleForFlexSetupSheetDocument = `
    query GetSetupSheetStyleForFlexSetupSheet($id: MongoID!) {
  setupSheetStyle(_id: $id) {
    _id
    author {
      username
      name
      _id
    }
    authorID
    blocks {
      _id
      ...SetupSheetStyleBlockVarsForSetupSheetFlex
    }
    chassisSpecID
    createdAt
    isPublic
    hideAddPartButton
    hideUnits
    name
    updatedAt
    version
  }
}
    ${SetupSheetStyleBlockVarsForSetupSheetFlexFragmentDoc}
${SetupSheetStyleBlockTabVarsForSetupSheetFlexFragmentDoc}`;

export const useGetSetupSheetStyleForFlexSetupSheetQuery = <
      TData = GetSetupSheetStyleForFlexSetupSheetQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSetupSheetStyleForFlexSetupSheetQueryVariables,
      options?: UseQueryOptions<GetSetupSheetStyleForFlexSetupSheetQuery, TError, TData>
    ) => {
    
    return useQuery<GetSetupSheetStyleForFlexSetupSheetQuery, TError, TData>(
      ['GetSetupSheetStyleForFlexSetupSheet', variables],
      fetcher<GetSetupSheetStyleForFlexSetupSheetQuery, GetSetupSheetStyleForFlexSetupSheetQueryVariables>(GetSetupSheetStyleForFlexSetupSheetDocument, variables),
      options
    )};

export const GetLocalConnectionsForFlexSetupSheetDocument = `
    query GetLocalConnectionsForFlexSetupSheet($id: MongoID!) {
  person(_id: $id) {
    localConnections {
      ...AllLocalConnectionVars
    }
  }
}
    ${AllLocalConnectionVarsFragmentDoc}`;

export const useGetLocalConnectionsForFlexSetupSheetQuery = <
      TData = GetLocalConnectionsForFlexSetupSheetQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetLocalConnectionsForFlexSetupSheetQueryVariables,
      options?: UseQueryOptions<GetLocalConnectionsForFlexSetupSheetQuery, TError, TData>
    ) => {
    
    return useQuery<GetLocalConnectionsForFlexSetupSheetQuery, TError, TData>(
      ['GetLocalConnectionsForFlexSetupSheet', variables],
      fetcher<GetLocalConnectionsForFlexSetupSheetQuery, GetLocalConnectionsForFlexSetupSheetQueryVariables>(GetLocalConnectionsForFlexSetupSheetDocument, variables),
      options
    )};

export const GetExternalKinematicsForFlexSetupSheetDropdownDocument = `
    query GetExternalKinematicsForFlexSetupSheetDropdown($kinId: MongoID!, $chassisId: MongoID!) {
  kinematics: specification(_id: $kinId) {
    ... on KinematicsExternalSpec {
      _id
      axle
      aCamber {
        readingsRequired
        maxValue
        minValue
        sign
        step
        unit
        valueNames
        values
      }
      aCaster {
        minValue
        maxValue
        step
        values
        valueNames
        unit
        sign
        readingsRequired
      }
      aToe {
        minValue
        maxValue
        step
        values
        valueNames
        unit
        sign
        readingsRequired
      }
    }
  }
  chassis: specification(_id: $chassisId) {
    ... on ChassisSpec {
      _id
      measurements {
        angles
      }
    }
  }
}
    `;

export const useGetExternalKinematicsForFlexSetupSheetDropdownQuery = <
      TData = GetExternalKinematicsForFlexSetupSheetDropdownQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetExternalKinematicsForFlexSetupSheetDropdownQueryVariables,
      options?: UseQueryOptions<GetExternalKinematicsForFlexSetupSheetDropdownQuery, TError, TData>
    ) => {
    
    return useQuery<GetExternalKinematicsForFlexSetupSheetDropdownQuery, TError, TData>(
      ['GetExternalKinematicsForFlexSetupSheetDropdown', variables],
      fetcher<GetExternalKinematicsForFlexSetupSheetDropdownQuery, GetExternalKinematicsForFlexSetupSheetDropdownQueryVariables>(GetExternalKinematicsForFlexSetupSheetDropdownDocument, variables),
      options
    )};

export const GetChassisAssembliesForCarSetupAssignAssemblyModalDocument = `
    query GetChassisAssembliesForCarSetupAssignAssemblyModal($filter: FilterFindManyAssemblyInput!, $perPage: Int!, $page: Int, $sort: SortFindManyAssemblyInput) {
  assemblies(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ... on ChassisAssembly {
        ...ChassisAssemblyForCarSetupAssemblyAssignmentVars
      }
    }
  }
}
    ${ChassisAssemblyForCarSetupAssemblyAssignmentVarsFragmentDoc}`;

export const useGetChassisAssembliesForCarSetupAssignAssemblyModalQuery = <
      TData = GetChassisAssembliesForCarSetupAssignAssemblyModalQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisAssembliesForCarSetupAssignAssemblyModalQueryVariables,
      options?: UseQueryOptions<GetChassisAssembliesForCarSetupAssignAssemblyModalQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisAssembliesForCarSetupAssignAssemblyModalQuery, TError, TData>(
      ['GetChassisAssembliesForCarSetupAssignAssemblyModal', variables],
      fetcher<GetChassisAssembliesForCarSetupAssignAssemblyModalQuery, GetChassisAssembliesForCarSetupAssignAssemblyModalQueryVariables>(GetChassisAssembliesForCarSetupAssignAssemblyModalDocument, variables),
      options
    )};

export const CopyChassisAssemblyDocument = `
    mutation CopyChassisAssembly($chassisAssemblyID: MongoID!, $newCarSetupID: MongoID!) {
  copyChassisAssembly(
    chassisAssemblyID: $chassisAssemblyID
    newCarSetupID: $newCarSetupID
  ) {
    newChassisAssemblyID
    newChassisAssemblyReference
    newChassisAssemblyName
  }
}
    `;

export const useCopyChassisAssemblyMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CopyChassisAssemblyMutation, TError, CopyChassisAssemblyMutationVariables, TContext>) => {
    
    return useMutation<CopyChassisAssemblyMutation, TError, CopyChassisAssemblyMutationVariables, TContext>(
      ['CopyChassisAssembly'],
      (variables?: CopyChassisAssemblyMutationVariables) => fetcher<CopyChassisAssemblyMutation, CopyChassisAssemblyMutationVariables>(CopyChassisAssemblyDocument, variables)(),
      options
    )};

export const GetCarSetupForSetupSheetFlexDocument = `
    query GetCarSetupForSetupSheetFlex($id: MongoID!) {
  carSetup(_id: $id) {
    _id
    ...CarSetupVarsForSetupSheetFlex
  }
}
    ${CarSetupVarsForSetupSheetFlexFragmentDoc}
${ChassisAssemblyForFlexSetupVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${EndVarsForSetupSheetFlexFragmentDoc}
${AntiRollBarVarsForSetupSheetFlexFragmentDoc}
${BumpStopVarsForSetupSheetFlexFragmentDoc}
${ElasticSpecForSetupSheetFlexVarsFragmentDoc}
${DroopStopVarsForSetupSheetFlexFragmentDoc}
${ExternalBumpStopVarsForSetupSheetFlexFragmentDoc}
${KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc}
${KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc}
${SpringVarsForSetupSheetFlexFragmentDoc}
${CornerVarsForSetupSheetFlexFragmentDoc}
${MassVarsFragmentDoc}
${PowerTrainVarsForSetupSheetFlexFragmentDoc}
${RunSheetContextForSetupSheetVarsFragmentDoc}`;

export const useGetCarSetupForSetupSheetFlexQuery = <
      TData = GetCarSetupForSetupSheetFlexQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCarSetupForSetupSheetFlexQueryVariables,
      options?: UseQueryOptions<GetCarSetupForSetupSheetFlexQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarSetupForSetupSheetFlexQuery, TError, TData>(
      ['GetCarSetupForSetupSheetFlex', variables],
      fetcher<GetCarSetupForSetupSheetFlexQuery, GetCarSetupForSetupSheetFlexQueryVariables>(GetCarSetupForSetupSheetFlexDocument, variables),
      options
    )};

export const GetCarSetupSpecForSetupSheetFlexDocument = `
    query GetCarSetupSpecForSetupSheetFlex($id: MongoID!) {
  carSetup(_id: $id) {
    _id
    chassisSpec {
      ...ChassisSpecVarsForSetupSheetFlex
    }
  }
}
    ${ChassisSpecVarsForSetupSheetFlexFragmentDoc}
${CalculationVarsFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${ChassisMeasurementVarsFragmentDoc}
${SetupSheetStyleForFlexSetupFragmentDoc}
${SpecificationGroupVariablesFragmentDoc}`;

export const useGetCarSetupSpecForSetupSheetFlexQuery = <
      TData = GetCarSetupSpecForSetupSheetFlexQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCarSetupSpecForSetupSheetFlexQueryVariables,
      options?: UseQueryOptions<GetCarSetupSpecForSetupSheetFlexQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarSetupSpecForSetupSheetFlexQuery, TError, TData>(
      ['GetCarSetupSpecForSetupSheetFlex', variables],
      fetcher<GetCarSetupSpecForSetupSheetFlexQuery, GetCarSetupSpecForSetupSheetFlexQueryVariables>(GetCarSetupSpecForSetupSheetFlexDocument, variables),
      options
    )};

export const FlexCarSetupUpdatedDocument = `
    subscription FlexCarSetupUpdated($id: MongoID!) {
  carSetupUpdated(carSetupID: $id) {
    _id
    ...CarSetupVarsForSetupSheetFlex
  }
}
    ${CarSetupVarsForSetupSheetFlexFragmentDoc}
${ChassisAssemblyForFlexSetupVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${EndVarsForSetupSheetFlexFragmentDoc}
${AntiRollBarVarsForSetupSheetFlexFragmentDoc}
${BumpStopVarsForSetupSheetFlexFragmentDoc}
${ElasticSpecForSetupSheetFlexVarsFragmentDoc}
${DroopStopVarsForSetupSheetFlexFragmentDoc}
${ExternalBumpStopVarsForSetupSheetFlexFragmentDoc}
${KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc}
${KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc}
${SpringVarsForSetupSheetFlexFragmentDoc}
${CornerVarsForSetupSheetFlexFragmentDoc}
${MassVarsFragmentDoc}
${PowerTrainVarsForSetupSheetFlexFragmentDoc}
${RunSheetContextForSetupSheetVarsFragmentDoc}`;
export const CanopyConfigsForSetupSheetFlexDocument = `
    query CanopyConfigsForSetupSheetFlex($configType: EnumCanopyConfigType!, $nameFilter: String!) {
  findCanopyConfigs(configType: $configType, nameFilter: $nameFilter) {
    canopyID
    name
  }
}
    `;

export const useCanopyConfigsForSetupSheetFlexQuery = <
      TData = CanopyConfigsForSetupSheetFlexQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: CanopyConfigsForSetupSheetFlexQueryVariables,
      options?: UseQueryOptions<CanopyConfigsForSetupSheetFlexQuery, TError, TData>
    ) => {
    
    return useQuery<CanopyConfigsForSetupSheetFlexQuery, TError, TData>(
      ['CanopyConfigsForSetupSheetFlex', variables],
      fetcher<CanopyConfigsForSetupSheetFlexQuery, CanopyConfigsForSetupSheetFlexQueryVariables>(CanopyConfigsForSetupSheetFlexDocument, variables),
      options
    )};

export const PartTrackingHistoryForSetupSheetTrackingFieldOldDocument = `
    query PartTrackingHistoryForSetupSheetTrackingFieldOLD($endDate: Date, $partID: MongoID!, $trackingItemID: MongoID!) {
  partReturnTrackingHistoryFullandSnapshot(
    endDate: $endDate
    partID: $partID
    trackingItemIDs: [$trackingItemID]
  ) {
    trackingSnapshot {
      cumulativeValue
      dateResolved
      limitCritical
      limitWarning
      trackingItem {
        criticalCumulativeValue
        criticalValue
        cumulativeCalculation
        displayUnit
        operator
        warningCumulativeValue
        warningValue
      }
      type
      value
      valueString
    }
  }
}
    `;

export const usePartTrackingHistoryForSetupSheetTrackingFieldOldQuery = <
      TData = PartTrackingHistoryForSetupSheetTrackingFieldOldQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: PartTrackingHistoryForSetupSheetTrackingFieldOldQueryVariables,
      options?: UseQueryOptions<PartTrackingHistoryForSetupSheetTrackingFieldOldQuery, TError, TData>
    ) => {
    
    return useQuery<PartTrackingHistoryForSetupSheetTrackingFieldOldQuery, TError, TData>(
      ['PartTrackingHistoryForSetupSheetTrackingFieldOLD', variables],
      fetcher<PartTrackingHistoryForSetupSheetTrackingFieldOldQuery, PartTrackingHistoryForSetupSheetTrackingFieldOldQueryVariables>(PartTrackingHistoryForSetupSheetTrackingFieldOldDocument, variables),
      options
    )};

export const PartTrackingHistoryForSetupSheetTrackingFieldDocument = `
    query PartTrackingHistoryForSetupSheetTrackingField($partID: MongoID!, $endDate: Date, $trackingItemIDs: [MongoID]) {
  partTracking(
    partID: $partID
    endDate: $endDate
    trackingItemIDs: $trackingItemIDs
  ) {
    ...PartTrackingVarsForSetupSheetFlex
  }
}
    ${PartTrackingVarsForSetupSheetFlexFragmentDoc}`;

export const usePartTrackingHistoryForSetupSheetTrackingFieldQuery = <
      TData = PartTrackingHistoryForSetupSheetTrackingFieldQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: PartTrackingHistoryForSetupSheetTrackingFieldQueryVariables,
      options?: UseQueryOptions<PartTrackingHistoryForSetupSheetTrackingFieldQuery, TError, TData>
    ) => {
    
    return useQuery<PartTrackingHistoryForSetupSheetTrackingFieldQuery, TError, TData>(
      ['PartTrackingHistoryForSetupSheetTrackingField', variables],
      fetcher<PartTrackingHistoryForSetupSheetTrackingFieldQuery, PartTrackingHistoryForSetupSheetTrackingFieldQueryVariables>(PartTrackingHistoryForSetupSheetTrackingFieldDocument, variables),
      options
    )};

export const GetChassisAeroSpecByIdDocument = `
    query GetChassisAeroSpecById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      aeroPackageSpecIDs
      aeroPackageSpecs {
        _id
        name
        aeroElementSpecIDs
        aeroElementSpecs {
          _id
          allowableSockets
          name
          positions
          positionNames
        }
      }
    }
  }
}
    `;

export const useGetChassisAeroSpecByIdQuery = <
      TData = GetChassisAeroSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisAeroSpecByIdQueryVariables,
      options?: UseQueryOptions<GetChassisAeroSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisAeroSpecByIdQuery, TError, TData>(
      ['GetChassisAeroSpecById', variables],
      fetcher<GetChassisAeroSpecByIdQuery, GetChassisAeroSpecByIdQueryVariables>(GetChassisAeroSpecByIdDocument, variables),
      options
    )};

export const GetChassisAntiRollBarSpecByIdDocument = `
    query GetChassisAntiRollBarSpecById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      antiRollBarSpecIDs
      antiRollBarSpecs {
        _id
        ...AntiRollBarVars
      }
    }
  }
}
    ${AntiRollBarVarsFragmentDoc}`;

export const useGetChassisAntiRollBarSpecByIdQuery = <
      TData = GetChassisAntiRollBarSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisAntiRollBarSpecByIdQueryVariables,
      options?: UseQueryOptions<GetChassisAntiRollBarSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisAntiRollBarSpecByIdQuery, TError, TData>(
      ['GetChassisAntiRollBarSpecById', variables],
      fetcher<GetChassisAntiRollBarSpecByIdQuery, GetChassisAntiRollBarSpecByIdQueryVariables>(GetChassisAntiRollBarSpecByIdDocument, variables),
      options
    )};

export const GetChassisBevelSetSpecsByIdDocument = `
    query GetChassisBevelSetSpecsById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      powertrain {
        bevelSetSpecIDs
        bevelSetSpecs {
          _id
          ...GearSpecVars
        }
      }
    }
  }
}
    ${GearSpecVarsFragmentDoc}`;

export const useGetChassisBevelSetSpecsByIdQuery = <
      TData = GetChassisBevelSetSpecsByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisBevelSetSpecsByIdQueryVariables,
      options?: UseQueryOptions<GetChassisBevelSetSpecsByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisBevelSetSpecsByIdQuery, TError, TData>(
      ['GetChassisBevelSetSpecsById', variables],
      fetcher<GetChassisBevelSetSpecsByIdQuery, GetChassisBevelSetSpecsByIdQueryVariables>(GetChassisBevelSetSpecsByIdDocument, variables),
      options
    )};

export const GetChassisDamperSpecByIdDocument = `
    query GetChassisDamperSpecById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      damperSpecIDs
      damperSpecs {
        _id
        ...DamperSpecVars
      }
    }
  }
}
    ${DamperSpecVarsFragmentDoc}`;

export const useGetChassisDamperSpecByIdQuery = <
      TData = GetChassisDamperSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisDamperSpecByIdQueryVariables,
      options?: UseQueryOptions<GetChassisDamperSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisDamperSpecByIdQuery, TError, TData>(
      ['GetChassisDamperSpecById', variables],
      fetcher<GetChassisDamperSpecByIdQuery, GetChassisDamperSpecByIdQueryVariables>(GetChassisDamperSpecByIdDocument, variables),
      options
    )};

export const GetChassisDifferentialSpecByIdDocument = `
    query GetChassisDifferentialSpecById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      powertrain {
        differentialSpecIDs
        differentialSpecs {
          _id
          ...DifferentialSpecVars
        }
      }
    }
  }
}
    ${DifferentialSpecVarsFragmentDoc}`;

export const useGetChassisDifferentialSpecByIdQuery = <
      TData = GetChassisDifferentialSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisDifferentialSpecByIdQueryVariables,
      options?: UseQueryOptions<GetChassisDifferentialSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisDifferentialSpecByIdQuery, TError, TData>(
      ['GetChassisDifferentialSpecById', variables],
      fetcher<GetChassisDifferentialSpecByIdQuery, GetChassisDifferentialSpecByIdQueryVariables>(GetChassisDifferentialSpecByIdDocument, variables),
      options
    )};

export const GetChassisDropGearSpecsByIdDocument = `
    query GetChassisDropGearSpecsById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      powertrain {
        dropGearSpecIDs
        dropGearSpecs {
          _id
          ...GearSpecVars
        }
      }
    }
  }
}
    ${GearSpecVarsFragmentDoc}`;

export const useGetChassisDropGearSpecsByIdQuery = <
      TData = GetChassisDropGearSpecsByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisDropGearSpecsByIdQueryVariables,
      options?: UseQueryOptions<GetChassisDropGearSpecsByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisDropGearSpecsByIdQuery, TError, TData>(
      ['GetChassisDropGearSpecsById', variables],
      fetcher<GetChassisDropGearSpecsByIdQuery, GetChassisDropGearSpecsByIdQueryVariables>(GetChassisDropGearSpecsByIdDocument, variables),
      options
    )};

export const GetChassisGearSpecsByIdDocument = `
    query GetChassisGearSpecsById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      powertrain {
        gearSpecIDs
        gearSpecs {
          _id
          ...GearSpecVars
        }
      }
    }
  }
}
    ${GearSpecVarsFragmentDoc}`;

export const useGetChassisGearSpecsByIdQuery = <
      TData = GetChassisGearSpecsByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisGearSpecsByIdQueryVariables,
      options?: UseQueryOptions<GetChassisGearSpecsByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisGearSpecsByIdQuery, TError, TData>(
      ['GetChassisGearSpecsById', variables],
      fetcher<GetChassisGearSpecsByIdQuery, GetChassisGearSpecsByIdQueryVariables>(GetChassisGearSpecsByIdDocument, variables),
      options
    )};

export const GetChassisKinematicExtSpecByIdDocument = `
    query GetChassisKinematicExtSpecById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      kinematicsExternalSpecIDs
      kinematicsExternalSpecs {
        _id
        ...ExternalKinematicSpecVars
      }
    }
  }
}
    ${ExternalKinematicSpecVarsFragmentDoc}`;

export const useGetChassisKinematicExtSpecByIdQuery = <
      TData = GetChassisKinematicExtSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisKinematicExtSpecByIdQueryVariables,
      options?: UseQueryOptions<GetChassisKinematicExtSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisKinematicExtSpecByIdQuery, TError, TData>(
      ['GetChassisKinematicExtSpecById', variables],
      fetcher<GetChassisKinematicExtSpecByIdQuery, GetChassisKinematicExtSpecByIdQueryVariables>(GetChassisKinematicExtSpecByIdDocument, variables),
      options
    )};

export const GetChassisKinematicIntSpecByIdDocument = `
    query GetChassisKinematicIntSpecById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      kinematicsInternalSpecIDs
      kinematicsInternalSpecs {
        _id
        ...InternalKinematicSpecVars
      }
    }
  }
}
    ${InternalKinematicSpecVarsFragmentDoc}`;

export const useGetChassisKinematicIntSpecByIdQuery = <
      TData = GetChassisKinematicIntSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisKinematicIntSpecByIdQueryVariables,
      options?: UseQueryOptions<GetChassisKinematicIntSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisKinematicIntSpecByIdQuery, TError, TData>(
      ['GetChassisKinematicIntSpecById', variables],
      fetcher<GetChassisKinematicIntSpecByIdQuery, GetChassisKinematicIntSpecByIdQueryVariables>(GetChassisKinematicIntSpecByIdDocument, variables),
      options
    )};

export const GetChassisTorsionBarSpecByIdDocument = `
    query GetChassisTorsionBarSpecById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      torsionBarSpecIDs
      torsionBarSpecs {
        _id
        ...ElasticSpecVars
      }
    }
  }
}
    ${ElasticSpecVarsFragmentDoc}`;

export const useGetChassisTorsionBarSpecByIdQuery = <
      TData = GetChassisTorsionBarSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisTorsionBarSpecByIdQueryVariables,
      options?: UseQueryOptions<GetChassisTorsionBarSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisTorsionBarSpecByIdQuery, TError, TData>(
      ['GetChassisTorsionBarSpecById', variables],
      fetcher<GetChassisTorsionBarSpecByIdQuery, GetChassisTorsionBarSpecByIdQueryVariables>(GetChassisTorsionBarSpecByIdDocument, variables),
      options
    )};

export const GetChassisSpringSpecByIdDocument = `
    query GetChassisSpringSpecById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      springSpecIDs
      springSpecs {
        _id
        ...ElasticSpecVars
      }
    }
  }
}
    ${ElasticSpecVarsFragmentDoc}`;

export const useGetChassisSpringSpecByIdQuery = <
      TData = GetChassisSpringSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpringSpecByIdQueryVariables,
      options?: UseQueryOptions<GetChassisSpringSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpringSpecByIdQuery, TError, TData>(
      ['GetChassisSpringSpecById', variables],
      fetcher<GetChassisSpringSpecByIdQuery, GetChassisSpringSpecByIdQueryVariables>(GetChassisSpringSpecByIdDocument, variables),
      options
    )};

export const GetChassisHelperSpringSpecByIdDocument = `
    query GetChassisHelperSpringSpecById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      helperSpringSpecIDs
      helperSpringSpecs {
        _id
        ...ElasticSpecVars
      }
    }
  }
}
    ${ElasticSpecVarsFragmentDoc}`;

export const useGetChassisHelperSpringSpecByIdQuery = <
      TData = GetChassisHelperSpringSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisHelperSpringSpecByIdQueryVariables,
      options?: UseQueryOptions<GetChassisHelperSpringSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisHelperSpringSpecByIdQuery, TError, TData>(
      ['GetChassisHelperSpringSpecById', variables],
      fetcher<GetChassisHelperSpringSpecByIdQuery, GetChassisHelperSpringSpecByIdQueryVariables>(GetChassisHelperSpringSpecByIdDocument, variables),
      options
    )};

export const GetChassisReboundSpringSpecByIdDocument = `
    query GetChassisReboundSpringSpecById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      reboundSpringSpecIDs
      reboundSpringSpecs {
        _id
        ...ElasticSpecVars
      }
    }
  }
}
    ${ElasticSpecVarsFragmentDoc}`;

export const useGetChassisReboundSpringSpecByIdQuery = <
      TData = GetChassisReboundSpringSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisReboundSpringSpecByIdQueryVariables,
      options?: UseQueryOptions<GetChassisReboundSpringSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisReboundSpringSpecByIdQuery, TError, TData>(
      ['GetChassisReboundSpringSpecById', variables],
      fetcher<GetChassisReboundSpringSpecByIdQuery, GetChassisReboundSpringSpecByIdQueryVariables>(GetChassisReboundSpringSpecByIdDocument, variables),
      options
    )};

export const GetChassisBumpRubberSpecByIdDocument = `
    query GetChassisBumpRubberSpecById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      bumpRubberSpecIDs
      bumpRubberSpecs {
        _id
        ...ElasticSpecVars
      }
    }
  }
}
    ${ElasticSpecVarsFragmentDoc}`;

export const useGetChassisBumpRubberSpecByIdQuery = <
      TData = GetChassisBumpRubberSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisBumpRubberSpecByIdQueryVariables,
      options?: UseQueryOptions<GetChassisBumpRubberSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisBumpRubberSpecByIdQuery, TError, TData>(
      ['GetChassisBumpRubberSpecById', variables],
      fetcher<GetChassisBumpRubberSpecByIdQuery, GetChassisBumpRubberSpecByIdQueryVariables>(GetChassisBumpRubberSpecByIdDocument, variables),
      options
    )};

export const GetChassisMinWeightSpecByIdDocument = `
    query GetChassisMinWeightSpecById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      regulationSets {
        name
        massMin
      }
    }
  }
}
    `;

export const useGetChassisMinWeightSpecByIdQuery = <
      TData = GetChassisMinWeightSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisMinWeightSpecByIdQueryVariables,
      options?: UseQueryOptions<GetChassisMinWeightSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisMinWeightSpecByIdQuery, TError, TData>(
      ['GetChassisMinWeightSpecById', variables],
      fetcher<GetChassisMinWeightSpecByIdQuery, GetChassisMinWeightSpecByIdQueryVariables>(GetChassisMinWeightSpecByIdDocument, variables),
      options
    )};

export const GetChassisSpecGroupsByIdDocument = `
    query GetChassisSpecGroupsById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      specificationGroups {
        ...SpecificationGroupVariables
      }
      specificationGroupIDs
      customSpecs {
        _id
        name
      }
      customSpecIDs
    }
  }
}
    ${SpecificationGroupVariablesFragmentDoc}`;

export const useGetChassisSpecGroupsByIdQuery = <
      TData = GetChassisSpecGroupsByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpecGroupsByIdQueryVariables,
      options?: UseQueryOptions<GetChassisSpecGroupsByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecGroupsByIdQuery, TError, TData>(
      ['GetChassisSpecGroupsById', variables],
      fetcher<GetChassisSpecGroupsByIdQuery, GetChassisSpecGroupsByIdQueryVariables>(GetChassisSpecGroupsByIdDocument, variables),
      options
    )};

export const GetChassisMeasurementPointsByIdDocument = `
    query GetChassisMeasurementPointsById($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      chassisMeasurementIDs
      chassisMeasurements {
        ...AllChassisMeasurementSpecVars
      }
    }
  }
}
    ${AllChassisMeasurementSpecVarsFragmentDoc}`;

export const useGetChassisMeasurementPointsByIdQuery = <
      TData = GetChassisMeasurementPointsByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisMeasurementPointsByIdQueryVariables,
      options?: UseQueryOptions<GetChassisMeasurementPointsByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisMeasurementPointsByIdQuery, TError, TData>(
      ['GetChassisMeasurementPointsById', variables],
      fetcher<GetChassisMeasurementPointsByIdQuery, GetChassisMeasurementPointsByIdQueryVariables>(GetChassisMeasurementPointsByIdDocument, variables),
      options
    )};

export const GetChassisAssemblyPartInstancesByIdDocument = `
    query GetChassisAssemblyPartInstancesById($id: MongoID!) {
  carSetup(_id: $id) {
    chassisAssembly {
      partInstances {
        _id
      }
    }
  }
}
    `;

export const useGetChassisAssemblyPartInstancesByIdQuery = <
      TData = GetChassisAssemblyPartInstancesByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisAssemblyPartInstancesByIdQueryVariables,
      options?: UseQueryOptions<GetChassisAssemblyPartInstancesByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisAssemblyPartInstancesByIdQuery, TError, TData>(
      ['GetChassisAssemblyPartInstancesById', variables],
      fetcher<GetChassisAssemblyPartInstancesByIdQuery, GetChassisAssemblyPartInstancesByIdQueryVariables>(GetChassisAssemblyPartInstancesByIdDocument, variables),
      options
    )};

export const AddFourTyresAtOnceDocument = `
    mutation AddFourTyresAtOnce($tyreFL: CreateOneTyreInput!, $tyreFR: CreateOneTyreInput!, $tyreRL: CreateOneTyreInput!, $tyreRR: CreateOneTyreInput!) {
  addTyreFL: addTyre(record: $tyreFL) {
    recordId
  }
  addTyreFR: addTyre(record: $tyreFR) {
    recordId
  }
  addTyreRL: addTyre(record: $tyreRL) {
    recordId
  }
  addTyreRR: addTyre(record: $tyreRR) {
    recordId
  }
}
    `;

export const useAddFourTyresAtOnceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddFourTyresAtOnceMutation, TError, AddFourTyresAtOnceMutationVariables, TContext>) => {
    
    return useMutation<AddFourTyresAtOnceMutation, TError, AddFourTyresAtOnceMutationVariables, TContext>(
      ['AddFourTyresAtOnce'],
      (variables?: AddFourTyresAtOnceMutationVariables) => fetcher<AddFourTyresAtOnceMutation, AddFourTyresAtOnceMutationVariables>(AddFourTyresAtOnceDocument, variables)(),
      options
    )};

export const GetRunPlansForEventTyreMileageContextDocument = `
    query GetRunPlansForEventTyreMileageContext($contestantID: MongoID, $eventID: MongoID!, $sessionIDs: [MongoID]) {
  runPlans(
    filter: {AND: [{_operators: {sessionID: {in: $sessionIDs}}}, {contestantID: $contestantID}]}
  ) {
    items {
      ...RunPlanForEventTyreMileageContextVars
    }
  }
  event(_id: $eventID) {
    _id
    contestants {
      _id
      tyreSets {
        ...tyreSetVars
      }
      tyreSetIDs
    }
  }
}
    ${RunPlanForEventTyreMileageContextVarsFragmentDoc}
${TyreSetVarsFragmentDoc}`;

export const useGetRunPlansForEventTyreMileageContextQuery = <
      TData = GetRunPlansForEventTyreMileageContextQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunPlansForEventTyreMileageContextQueryVariables,
      options?: UseQueryOptions<GetRunPlansForEventTyreMileageContextQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunPlansForEventTyreMileageContextQuery, TError, TData>(
      ['GetRunPlansForEventTyreMileageContext', variables],
      fetcher<GetRunPlansForEventTyreMileageContextQuery, GetRunPlansForEventTyreMileageContextQueryVariables>(GetRunPlansForEventTyreMileageContextDocument, variables),
      options
    )};

export const GetTyreMileagesAtSessionStartForEventTyreMileageContextDocument = `
    query GetTyreMileagesAtSessionStartForEventTyreMileageContext($tyreSetIDs: [MongoID]) {
  tyreMileageAtSessionStart(tyreSetIDs: $tyreSetIDs) {
    tyreSetMileages {
      tyreSetID
      sessions {
        ...TyreMileageAtSessionStartVars
      }
    }
  }
}
    ${TyreMileageAtSessionStartVarsFragmentDoc}`;

export const useGetTyreMileagesAtSessionStartForEventTyreMileageContextQuery = <
      TData = GetTyreMileagesAtSessionStartForEventTyreMileageContextQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTyreMileagesAtSessionStartForEventTyreMileageContextQueryVariables,
      options?: UseQueryOptions<GetTyreMileagesAtSessionStartForEventTyreMileageContextQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreMileagesAtSessionStartForEventTyreMileageContextQuery, TError, TData>(
      variables === undefined ? ['GetTyreMileagesAtSessionStartForEventTyreMileageContext'] : ['GetTyreMileagesAtSessionStartForEventTyreMileageContext', variables],
      fetcher<GetTyreMileagesAtSessionStartForEventTyreMileageContextQuery, GetTyreMileagesAtSessionStartForEventTyreMileageContextQueryVariables>(GetTyreMileagesAtSessionStartForEventTyreMileageContextDocument, variables),
      options
    )};

export const GetRunSheetsForEventTyreMileageContextDocument = `
    query GetRunSheetsForEventTyreMileageContext($contestantID: MongoID!, $sessionIDs: [MongoID]) {
  runSheets(
    perPage: 1000
    filter: {_operators: {sessionID: {in: $sessionIDs}}, contestantID: $contestantID}
    sort: NRUNTIMING_ASC
  ) {
    items {
      _id
      ...RunPlanRunRunSheetVars
    }
  }
}
    ${RunPlanRunRunSheetVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${RunSheetTyreForRunPlanVarsFragmentDoc}`;

export const useGetRunSheetsForEventTyreMileageContextQuery = <
      TData = GetRunSheetsForEventTyreMileageContextQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetsForEventTyreMileageContextQueryVariables,
      options?: UseQueryOptions<GetRunSheetsForEventTyreMileageContextQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsForEventTyreMileageContextQuery, TError, TData>(
      ['GetRunSheetsForEventTyreMileageContext', variables],
      fetcher<GetRunSheetsForEventTyreMileageContextQuery, GetRunSheetsForEventTyreMileageContextQueryVariables>(GetRunSheetsForEventTyreMileageContextDocument, variables),
      options
    )};

export const RunSheetInSessionsAddedForRunPlannerDocument = `
    subscription RunSheetInSessionsAddedForRunPlanner($contestantID: MongoID!, $sessionIDs: [MongoID!]!) {
  runSheetInSessionsAdded(sessionIDs: $sessionIDs, contestantID: $contestantID) {
    _id
    ...RunPlanRunRunSheetVars
  }
}
    ${RunPlanRunRunSheetVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${RunSheetTyreForRunPlanVarsFragmentDoc}`;
export const RunSheetInSessionsRemovedForRunPlannerDocument = `
    subscription RunSheetInSessionsRemovedForRunPlanner($contestantID: MongoID!, $sessionIDs: [MongoID!]!) {
  runSheetInSessionsRemoved(sessionIDs: $sessionIDs, contestantID: $contestantID) {
    _id
  }
}
    `;
export const RunSheetInSessionsUpdatedForRunPlannerDocument = `
    subscription RunSheetInSessionsUpdatedForRunPlanner($contestantID: MongoID!, $sessionIDs: [MongoID!]!) {
  runSheetInSessionsUpdated(sessionIDs: $sessionIDs, contestantID: $contestantID) {
    _id
    ...RunPlanRunRunSheetVars
  }
}
    ${RunPlanRunRunSheetVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${RunSheetTyreForRunPlanVarsFragmentDoc}`;
export const RunPlanUpdatedDocument = `
    subscription RunPlanUpdated($runPlanID: MongoID!) {
  runPlanUpdated(runPlanID: $runPlanID) {
    ...RunPlanForEventTyreMileageContextVars
  }
}
    ${RunPlanForEventTyreMileageContextVarsFragmentDoc}`;
export const RunPlanAddedDocument = `
    subscription RunPlanAdded {
  runPlanAdded {
    ...RunPlanForEventTyreMileageContextVars
  }
}
    ${RunPlanForEventTyreMileageContextVarsFragmentDoc}`;
export const RunPlanRemovedDocument = `
    subscription RunPlanRemoved {
  runPlanRemoved {
    ...RunPlanForEventTyreMileageContextVars
  }
}
    ${RunPlanForEventTyreMileageContextVarsFragmentDoc}`;
export const AddFlattenedSimulationPayloadDocument = `
    mutation AddFlattenedSimulationPayload($carSetupID: MongoID!, $record: JSON) {
  addFlattenedSimulationPayload(carSetupID: $carSetupID, record: $record) {
    success
  }
}
    `;

export const useAddFlattenedSimulationPayloadMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddFlattenedSimulationPayloadMutation, TError, AddFlattenedSimulationPayloadMutationVariables, TContext>) => {
    
    return useMutation<AddFlattenedSimulationPayloadMutation, TError, AddFlattenedSimulationPayloadMutationVariables, TContext>(
      ['AddFlattenedSimulationPayload'],
      (variables?: AddFlattenedSimulationPayloadMutationVariables) => fetcher<AddFlattenedSimulationPayloadMutation, AddFlattenedSimulationPayloadMutationVariables>(AddFlattenedSimulationPayloadDocument, variables)(),
      options
    )};

export const GetFlattenedSetupForRfkCustomSimulationDocument = `
    query GetFlattenedSetupForRfkCustomSimulation($carSetupID: MongoID!, $date: Date, $outputFolder: String) {
  flattenedSetupForSimulation(
    carSetupID: $carSetupID
    date: $date
    outputFolder: $outputFolder
  )
}
    `;

export const useGetFlattenedSetupForRfkCustomSimulationQuery = <
      TData = GetFlattenedSetupForRfkCustomSimulationQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetFlattenedSetupForRfkCustomSimulationQueryVariables,
      options?: UseQueryOptions<GetFlattenedSetupForRfkCustomSimulationQuery, TError, TData>
    ) => {
    
    return useQuery<GetFlattenedSetupForRfkCustomSimulationQuery, TError, TData>(
      ['GetFlattenedSetupForRfkCustomSimulation', variables],
      fetcher<GetFlattenedSetupForRfkCustomSimulationQuery, GetFlattenedSetupForRfkCustomSimulationQueryVariables>(GetFlattenedSetupForRfkCustomSimulationDocument, variables),
      options
    )};

export const GetVisibleContestantsForContestantHookDocument = `
    query GetVisibleContestantsForContestantHook($id: MongoID!) {
  person(_id: $id) {
    visibleContestantIDs
  }
}
    `;

export const useGetVisibleContestantsForContestantHookQuery = <
      TData = GetVisibleContestantsForContestantHookQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetVisibleContestantsForContestantHookQueryVariables,
      options?: UseQueryOptions<GetVisibleContestantsForContestantHookQuery, TError, TData>
    ) => {
    
    return useQuery<GetVisibleContestantsForContestantHookQuery, TError, TData>(
      ['GetVisibleContestantsForContestantHook', variables],
      fetcher<GetVisibleContestantsForContestantHookQuery, GetVisibleContestantsForContestantHookQueryVariables>(GetVisibleContestantsForContestantHookDocument, variables),
      options
    )};

export const GetCurrentUserInfoDocument = `
    query GetCurrentUserInfo($id: MongoID!) {
  person(_id: $id) {
    _id
    acronym
    behaviour {
      carryOverJobList
      showMyJobsOnRunSheetDefault
      timeLocale
      timezoneSelect
    }
    carUpdateMethod
    canopyCredentials {
      clientID
      clientSecret
      username
      password
      userID
      tenantID
    }
    defaultRunSheetCompareStyleID
    defaultRunSheetStyleID
    defaultTyreReferenceTemperature
    defaultTyreSetNameFormat
    email
    emailNotificationConfig {
      jobAssigned
      jobCommentedOn
      jobStatusChanged
    }
    hideKPIs
    isActive
    isTimeTracker
    isTimeTrackerAdmin
    name
    role
    teamID
    timeTrackerApprovalByPersonID
    username
    userSetups {
      _id
      title
    }
    viewConfig {
      showRunSheetsAsTabs
      yellowTyreMileageThreshold
      redTyreMileageThreshold
      highlightTyreMileages
    }
    visibleEventIDs
  }
}
    `;

export const useGetCurrentUserInfoQuery = <
      TData = GetCurrentUserInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCurrentUserInfoQueryVariables,
      options?: UseQueryOptions<GetCurrentUserInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetCurrentUserInfoQuery, TError, TData>(
      ['GetCurrentUserInfo', variables],
      fetcher<GetCurrentUserInfoQuery, GetCurrentUserInfoQueryVariables>(GetCurrentUserInfoDocument, variables),
      options
    )};

export const CheckDataUpdatedAtForOverviewPageDocument = `
    query CheckDataUpdatedAtForOverviewPage($eventIDs: [MongoID!], $runSheetIDs: [MongoID], $runSheetPageSize: Int, $simResultIDs: [MongoID], $simResultPageSize: Int) {
  sessions(perPage: 2000, filter: {_operators: {eventID: {in: $eventIDs}}}) {
    items {
      _id
      name
      shortName
      event {
        name
      }
      eventID
    }
  }
  runSheets(
    perPage: $runSheetPageSize
    filter: {_operators: {_id: {in: $runSheetIDs}}}
  ) {
    items {
      _id
      setup {
        _id
        updatedAt
        chassisSpec {
          _id
          updatedAt
        }
      }
      updatedAt
    }
  }
  simResults(
    perPage: $simResultPageSize
    filter: {_operators: {_id: {in: $simResultIDs}}}
  ) {
    items {
      _id
      updatedAt
    }
  }
}
    `;

export const useCheckDataUpdatedAtForOverviewPageQuery = <
      TData = CheckDataUpdatedAtForOverviewPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: CheckDataUpdatedAtForOverviewPageQueryVariables,
      options?: UseQueryOptions<CheckDataUpdatedAtForOverviewPageQuery, TError, TData>
    ) => {
    
    return useQuery<CheckDataUpdatedAtForOverviewPageQuery, TError, TData>(
      variables === undefined ? ['CheckDataUpdatedAtForOverviewPage'] : ['CheckDataUpdatedAtForOverviewPage', variables],
      fetcher<CheckDataUpdatedAtForOverviewPageQuery, CheckDataUpdatedAtForOverviewPageQueryVariables>(CheckDataUpdatedAtForOverviewPageDocument, variables),
      options
    )};

export const GetRunSheetIDsForSessionAndContestantDocument = `
    query GetRunSheetIDsForSessionAndContestant($sessionID: MongoID, $contestantID: MongoID) {
  runSheets(
    perPage: 1000
    filter: {sessionID: $sessionID, contestantID: $contestantID}
    sort: NRUNTIMING_ASC
  ) {
    items {
      _id
    }
  }
}
    `;

export const useGetRunSheetIDsForSessionAndContestantQuery = <
      TData = GetRunSheetIDsForSessionAndContestantQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRunSheetIDsForSessionAndContestantQueryVariables,
      options?: UseQueryOptions<GetRunSheetIDsForSessionAndContestantQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetIDsForSessionAndContestantQuery, TError, TData>(
      variables === undefined ? ['GetRunSheetIDsForSessionAndContestant'] : ['GetRunSheetIDsForSessionAndContestant', variables],
      fetcher<GetRunSheetIDsForSessionAndContestantQuery, GetRunSheetIDsForSessionAndContestantQueryVariables>(GetRunSheetIDsForSessionAndContestantDocument, variables),
      options
    )};

export const GetUpdatedDataForInitializationForOverviewPageDocument = `
    query GetUpdatedDataForInitializationForOverviewPage($runSheetIDs: [MongoID], $runSheetPageSize: Int, $sessionIDs: [MongoID], $simResultIDs: [MongoID], $simResultPageSize: Int) {
  allowedRunSheetsForSelectedSessions: runSheets(
    perPage: 5000
    filter: {_operators: {sessionID: {in: $sessionIDs}}}
  ) {
    items {
      ...RunSheetForEventSelectionVars
    }
  }
  updatedRunSheets: runSheets(
    perPage: $runSheetPageSize
    filter: {_operators: {_id: {in: $runSheetIDs}}}
  ) {
    items {
      ...AllKPIRunSheetData
    }
  }
  simResults(
    perPage: $simResultPageSize
    filter: {_operators: {_id: {in: $simResultIDs}}}
  ) {
    items {
      ...AllSimResultScalarVars
    }
  }
}
    ${RunSheetForEventSelectionVarsFragmentDoc}
${AllKpiRunSheetDataFragmentDoc}
${RunSheetForOverviewFragmentDoc}
${BrakeForRunSheetOverviewVarsFragmentDoc}
${BrakeMeasurementForRunSheetOverviewVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${CarSetupVarsForKpiViewLiveFragmentDoc}
${CarSetupVarsForKpiViewBaseFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${ChassisAssemblyForFlexSetupVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${EndVarsForSetupSheetFlexFragmentDoc}
${AntiRollBarVarsForSetupSheetFlexFragmentDoc}
${BumpStopVarsForSetupSheetFlexFragmentDoc}
${ElasticSpecForSetupSheetFlexVarsFragmentDoc}
${DroopStopVarsForSetupSheetFlexFragmentDoc}
${ExternalBumpStopVarsForSetupSheetFlexFragmentDoc}
${KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc}
${KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc}
${SpringVarsForSetupSheetFlexFragmentDoc}
${CornerVarsForSetupSheetFlexFragmentDoc}
${InfoVarsFragmentDoc}
${MassVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${RunSheetContextForSetupSheetVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${SimResultForRunSheetOverviewVarsFragmentDoc}
${RunTyreForRunSheetOverviewVarsFragmentDoc}
${WeatherForRunSheetOverviewVarsFragmentDoc}
${LapForRunSheetOverviewVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}
${AllSimResultScalarVarsFragmentDoc}`;

export const useGetUpdatedDataForInitializationForOverviewPageQuery = <
      TData = GetUpdatedDataForInitializationForOverviewPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetUpdatedDataForInitializationForOverviewPageQueryVariables,
      options?: UseQueryOptions<GetUpdatedDataForInitializationForOverviewPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetUpdatedDataForInitializationForOverviewPageQuery, TError, TData>(
      variables === undefined ? ['GetUpdatedDataForInitializationForOverviewPage'] : ['GetUpdatedDataForInitializationForOverviewPage', variables],
      fetcher<GetUpdatedDataForInitializationForOverviewPageQuery, GetUpdatedDataForInitializationForOverviewPageQueryVariables>(GetUpdatedDataForInitializationForOverviewPageDocument, variables),
      options
    )};

export const GetSessionIDsforSelectedEventsForOverviewPageDocument = `
    query GetSessionIDsforSelectedEventsForOverviewPage($eventIDs: [MongoID!]!, $perPage: Int) {
  events(filter: {_operators: {_id: {in: $eventIDs}}}, perPage: $perPage) {
    items {
      sessionIDs
    }
  }
}
    `;

export const useGetSessionIDsforSelectedEventsForOverviewPageQuery = <
      TData = GetSessionIDsforSelectedEventsForOverviewPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSessionIDsforSelectedEventsForOverviewPageQueryVariables,
      options?: UseQueryOptions<GetSessionIDsforSelectedEventsForOverviewPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionIDsforSelectedEventsForOverviewPageQuery, TError, TData>(
      ['GetSessionIDsforSelectedEventsForOverviewPage', variables],
      fetcher<GetSessionIDsforSelectedEventsForOverviewPageQuery, GetSessionIDsforSelectedEventsForOverviewPageQueryVariables>(GetSessionIDsforSelectedEventsForOverviewPageDocument, variables),
      options
    )};

export const GetRunSheetListForEventSelectionForOverviewPageDocument = `
    query GetRunSheetListForEventSelectionForOverviewPage($sessionIDs: [MongoID!]!) {
  runSheets(perPage: 10000, filter: {_operators: {sessionID: {in: $sessionIDs}}}) {
    items {
      ...RunSheetForEventSelectionVars
    }
  }
}
    ${RunSheetForEventSelectionVarsFragmentDoc}`;

export const useGetRunSheetListForEventSelectionForOverviewPageQuery = <
      TData = GetRunSheetListForEventSelectionForOverviewPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetListForEventSelectionForOverviewPageQueryVariables,
      options?: UseQueryOptions<GetRunSheetListForEventSelectionForOverviewPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetListForEventSelectionForOverviewPageQuery, TError, TData>(
      ['GetRunSheetListForEventSelectionForOverviewPage', variables],
      fetcher<GetRunSheetListForEventSelectionForOverviewPageQuery, GetRunSheetListForEventSelectionForOverviewPageQueryVariables>(GetRunSheetListForEventSelectionForOverviewPageDocument, variables),
      options
    )};

export const GetRunSheetListWithAllKpiDocument = `
    query GetRunSheetListWithAllKpi($sessionIDs: [MongoID!]!, $maxEntries: Int!) {
  runSheets(
    perPage: $maxEntries
    filter: {_operators: {sessionID: {in: $sessionIDs}}}
  ) {
    items {
      ...AllKPIRunSheetData
      setup {
        chassisSpec {
          ...ChassisSpecVarsForSetupSheetFlex
          customSpecs {
            ...CustomSpecVars
          }
        }
      }
    }
  }
}
    ${AllKpiRunSheetDataFragmentDoc}
${RunSheetForOverviewFragmentDoc}
${BrakeForRunSheetOverviewVarsFragmentDoc}
${BrakeMeasurementForRunSheetOverviewVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${CarSetupVarsForKpiViewLiveFragmentDoc}
${CarSetupVarsForKpiViewBaseFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${ChassisAssemblyForFlexSetupVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${EndVarsForSetupSheetFlexFragmentDoc}
${AntiRollBarVarsForSetupSheetFlexFragmentDoc}
${BumpStopVarsForSetupSheetFlexFragmentDoc}
${ElasticSpecForSetupSheetFlexVarsFragmentDoc}
${DroopStopVarsForSetupSheetFlexFragmentDoc}
${ExternalBumpStopVarsForSetupSheetFlexFragmentDoc}
${KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc}
${KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc}
${SpringVarsForSetupSheetFlexFragmentDoc}
${CornerVarsForSetupSheetFlexFragmentDoc}
${InfoVarsFragmentDoc}
${MassVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${RunSheetContextForSetupSheetVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${SimResultForRunSheetOverviewVarsFragmentDoc}
${RunTyreForRunSheetOverviewVarsFragmentDoc}
${WeatherForRunSheetOverviewVarsFragmentDoc}
${LapForRunSheetOverviewVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}
${ChassisSpecVarsForSetupSheetFlexFragmentDoc}
${CalculationVarsFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${ChassisMeasurementVarsFragmentDoc}
${SetupSheetStyleForFlexSetupFragmentDoc}
${SpecificationGroupVariablesFragmentDoc}
${CustomSpecVarsFragmentDoc}
${MassPropertiesVarsFragmentDoc}`;

export const useGetRunSheetListWithAllKpiQuery = <
      TData = GetRunSheetListWithAllKpiQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetListWithAllKpiQueryVariables,
      options?: UseQueryOptions<GetRunSheetListWithAllKpiQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetListWithAllKpiQuery, TError, TData>(
      ['GetRunSheetListWithAllKpi', variables],
      fetcher<GetRunSheetListWithAllKpiQuery, GetRunSheetListWithAllKpiQueryVariables>(GetRunSheetListWithAllKpiDocument, variables),
      options
    )};

export const GetSetupsForDashboardRefreshDocument = `
    query GetSetupsForDashboardRefresh($ids: [MongoID!]!) {
  carSetupsMany(limit: 10000, filter: {_operators: {_id: {in: $ids}}}) {
    ...CarSetupVarsForKpiViewLive
  }
}
    ${CarSetupVarsForKpiViewLiveFragmentDoc}
${CarSetupVarsForKpiViewBaseFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${ChassisAssemblyForFlexSetupVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${EndVarsForSetupSheetFlexFragmentDoc}
${AntiRollBarVarsForSetupSheetFlexFragmentDoc}
${BumpStopVarsForSetupSheetFlexFragmentDoc}
${ElasticSpecForSetupSheetFlexVarsFragmentDoc}
${DroopStopVarsForSetupSheetFlexFragmentDoc}
${ExternalBumpStopVarsForSetupSheetFlexFragmentDoc}
${KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc}
${KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc}
${SpringVarsForSetupSheetFlexFragmentDoc}
${CornerVarsForSetupSheetFlexFragmentDoc}
${InfoVarsFragmentDoc}
${MassVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${RunSheetContextForSetupSheetVarsFragmentDoc}
${SteeringVarsFragmentDoc}`;

export const useGetSetupsForDashboardRefreshQuery = <
      TData = GetSetupsForDashboardRefreshQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSetupsForDashboardRefreshQueryVariables,
      options?: UseQueryOptions<GetSetupsForDashboardRefreshQuery, TError, TData>
    ) => {
    
    return useQuery<GetSetupsForDashboardRefreshQuery, TError, TData>(
      ['GetSetupsForDashboardRefresh', variables],
      fetcher<GetSetupsForDashboardRefreshQuery, GetSetupsForDashboardRefreshQueryVariables>(GetSetupsForDashboardRefreshDocument, variables),
      options
    )};

export const GetRunSheetsForOverviewsWithAllKpiDocument = `
    query GetRunSheetsForOverviewsWithAllKpi($ids: [MongoID!]!) {
  runSheets(perPage: 10000, filter: {_operators: {_id: {in: $ids}}}) {
    items {
      ...AllKPIRunSheetData
    }
  }
}
    ${AllKpiRunSheetDataFragmentDoc}
${RunSheetForOverviewFragmentDoc}
${BrakeForRunSheetOverviewVarsFragmentDoc}
${BrakeMeasurementForRunSheetOverviewVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${CarSetupVarsForKpiViewLiveFragmentDoc}
${CarSetupVarsForKpiViewBaseFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${ChassisAssemblyForFlexSetupVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${EndVarsForSetupSheetFlexFragmentDoc}
${AntiRollBarVarsForSetupSheetFlexFragmentDoc}
${BumpStopVarsForSetupSheetFlexFragmentDoc}
${ElasticSpecForSetupSheetFlexVarsFragmentDoc}
${DroopStopVarsForSetupSheetFlexFragmentDoc}
${ExternalBumpStopVarsForSetupSheetFlexFragmentDoc}
${KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc}
${KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc}
${SpringVarsForSetupSheetFlexFragmentDoc}
${CornerVarsForSetupSheetFlexFragmentDoc}
${InfoVarsFragmentDoc}
${MassVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${RunSheetContextForSetupSheetVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${SimResultForRunSheetOverviewVarsFragmentDoc}
${RunTyreForRunSheetOverviewVarsFragmentDoc}
${WeatherForRunSheetOverviewVarsFragmentDoc}
${LapForRunSheetOverviewVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}`;

export const useGetRunSheetsForOverviewsWithAllKpiQuery = <
      TData = GetRunSheetsForOverviewsWithAllKpiQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetsForOverviewsWithAllKpiQueryVariables,
      options?: UseQueryOptions<GetRunSheetsForOverviewsWithAllKpiQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsForOverviewsWithAllKpiQuery, TError, TData>(
      ['GetRunSheetsForOverviewsWithAllKpi', variables],
      fetcher<GetRunSheetsForOverviewsWithAllKpiQuery, GetRunSheetsForOverviewsWithAllKpiQueryVariables>(GetRunSheetsForOverviewsWithAllKpiDocument, variables),
      options
    )};

export const GetRunSheetForOverviewsWithAllKpiDocument = `
    query GetRunSheetForOverviewsWithAllKpi($id: MongoID!) {
  runSheet(_id: $id) {
    ...AllKPIRunSheetData
  }
}
    ${AllKpiRunSheetDataFragmentDoc}
${RunSheetForOverviewFragmentDoc}
${BrakeForRunSheetOverviewVarsFragmentDoc}
${BrakeMeasurementForRunSheetOverviewVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${CarSetupVarsForKpiViewLiveFragmentDoc}
${CarSetupVarsForKpiViewBaseFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${ChassisAssemblyForFlexSetupVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${EndVarsForSetupSheetFlexFragmentDoc}
${AntiRollBarVarsForSetupSheetFlexFragmentDoc}
${BumpStopVarsForSetupSheetFlexFragmentDoc}
${ElasticSpecForSetupSheetFlexVarsFragmentDoc}
${DroopStopVarsForSetupSheetFlexFragmentDoc}
${ExternalBumpStopVarsForSetupSheetFlexFragmentDoc}
${KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc}
${KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc}
${SpringVarsForSetupSheetFlexFragmentDoc}
${CornerVarsForSetupSheetFlexFragmentDoc}
${InfoVarsFragmentDoc}
${MassVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${RunSheetContextForSetupSheetVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${SimResultForRunSheetOverviewVarsFragmentDoc}
${RunTyreForRunSheetOverviewVarsFragmentDoc}
${WeatherForRunSheetOverviewVarsFragmentDoc}
${LapForRunSheetOverviewVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}`;

export const useGetRunSheetForOverviewsWithAllKpiQuery = <
      TData = GetRunSheetForOverviewsWithAllKpiQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetForOverviewsWithAllKpiQueryVariables,
      options?: UseQueryOptions<GetRunSheetForOverviewsWithAllKpiQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetForOverviewsWithAllKpiQuery, TError, TData>(
      ['GetRunSheetForOverviewsWithAllKpi', variables],
      fetcher<GetRunSheetForOverviewsWithAllKpiQuery, GetRunSheetForOverviewsWithAllKpiQueryVariables>(GetRunSheetForOverviewsWithAllKpiDocument, variables),
      options
    )};

export const GetSimResultForOverviewDocument = `
    query GetSimResultForOverview($id: MongoID!) {
  simResult(_id: $id) {
    _id
    data {
      _id
      channelName
      channelTime
      channelValue
    }
    name
    refValues
    runSheetID
    simulationDriveFile {
      name
    }
    simType
    updatedAt
  }
}
    `;

export const useGetSimResultForOverviewQuery = <
      TData = GetSimResultForOverviewQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSimResultForOverviewQueryVariables,
      options?: UseQueryOptions<GetSimResultForOverviewQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimResultForOverviewQuery, TError, TData>(
      ['GetSimResultForOverview', variables],
      fetcher<GetSimResultForOverviewQuery, GetSimResultForOverviewQueryVariables>(GetSimResultForOverviewDocument, variables),
      options
    )};

export const GetChassisSpecForOverviewDocument = `
    query GetChassisSpecForOverview($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      ...ChassisSpecVarsForSetupSheetFlex
      _id
      updatedAt
      customSpecs {
        ...CustomSpecVars
      }
    }
  }
}
    ${ChassisSpecVarsForSetupSheetFlexFragmentDoc}
${CalculationVarsFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${ChassisMeasurementVarsFragmentDoc}
${SetupSheetStyleForFlexSetupFragmentDoc}
${SpecificationGroupVariablesFragmentDoc}
${CustomSpecVarsFragmentDoc}
${MassPropertiesVarsFragmentDoc}`;

export const useGetChassisSpecForOverviewQuery = <
      TData = GetChassisSpecForOverviewQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpecForOverviewQueryVariables,
      options?: UseQueryOptions<GetChassisSpecForOverviewQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecForOverviewQuery, TError, TData>(
      ['GetChassisSpecForOverview', variables],
      fetcher<GetChassisSpecForOverviewQuery, GetChassisSpecForOverviewQueryVariables>(GetChassisSpecForOverviewDocument, variables),
      options
    )};

export const Overview_RunSheetAddedDocument = `
    subscription Overview_RunSheetAdded {
  runSheetAdded {
    ...AllKPIRunSheetData
  }
}
    ${AllKpiRunSheetDataFragmentDoc}
${RunSheetForOverviewFragmentDoc}
${BrakeForRunSheetOverviewVarsFragmentDoc}
${BrakeMeasurementForRunSheetOverviewVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${CarSetupVarsForKpiViewLiveFragmentDoc}
${CarSetupVarsForKpiViewBaseFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${ChassisAssemblyForFlexSetupVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${EndVarsForSetupSheetFlexFragmentDoc}
${AntiRollBarVarsForSetupSheetFlexFragmentDoc}
${BumpStopVarsForSetupSheetFlexFragmentDoc}
${ElasticSpecForSetupSheetFlexVarsFragmentDoc}
${DroopStopVarsForSetupSheetFlexFragmentDoc}
${ExternalBumpStopVarsForSetupSheetFlexFragmentDoc}
${KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc}
${KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc}
${SpringVarsForSetupSheetFlexFragmentDoc}
${CornerVarsForSetupSheetFlexFragmentDoc}
${InfoVarsFragmentDoc}
${MassVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${RunSheetContextForSetupSheetVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${SimResultForRunSheetOverviewVarsFragmentDoc}
${RunTyreForRunSheetOverviewVarsFragmentDoc}
${WeatherForRunSheetOverviewVarsFragmentDoc}
${LapForRunSheetOverviewVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}`;
export const Overview_RunSheetUpdatedDocument = `
    subscription Overview_RunSheetUpdated($id: MongoID!) {
  runSheetUpdated(runSheetID: $id) {
    ...AllKPIRunSheetData
  }
}
    ${AllKpiRunSheetDataFragmentDoc}
${RunSheetForOverviewFragmentDoc}
${BrakeForRunSheetOverviewVarsFragmentDoc}
${BrakeMeasurementForRunSheetOverviewVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${CarSetupVarsForKpiViewLiveFragmentDoc}
${CarSetupVarsForKpiViewBaseFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${ChassisAssemblyForFlexSetupVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${EndVarsForSetupSheetFlexFragmentDoc}
${AntiRollBarVarsForSetupSheetFlexFragmentDoc}
${BumpStopVarsForSetupSheetFlexFragmentDoc}
${ElasticSpecForSetupSheetFlexVarsFragmentDoc}
${DroopStopVarsForSetupSheetFlexFragmentDoc}
${ExternalBumpStopVarsForSetupSheetFlexFragmentDoc}
${KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc}
${KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc}
${SpringVarsForSetupSheetFlexFragmentDoc}
${CornerVarsForSetupSheetFlexFragmentDoc}
${InfoVarsFragmentDoc}
${MassVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${RunSheetContextForSetupSheetVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${SimResultForRunSheetOverviewVarsFragmentDoc}
${RunTyreForRunSheetOverviewVarsFragmentDoc}
${WeatherForRunSheetOverviewVarsFragmentDoc}
${LapForRunSheetOverviewVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}`;
export const Overview_RunSheetRemovedDocument = `
    subscription Overview_RunSheetRemoved {
  runSheetRemoved {
    _id
  }
}
    `;
export const Overview_CarSetupUpdatedDocument = `
    subscription Overview_CarSetupUpdated($id: MongoID!) {
  carSetupUpdated(carSetupID: $id) {
    ...CarSetupVarsForKpiViewLive
  }
}
    ${CarSetupVarsForKpiViewLiveFragmentDoc}
${CarSetupVarsForKpiViewBaseFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${ChassisAssemblyForFlexSetupVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${EndVarsForSetupSheetFlexFragmentDoc}
${AntiRollBarVarsForSetupSheetFlexFragmentDoc}
${BumpStopVarsForSetupSheetFlexFragmentDoc}
${ElasticSpecForSetupSheetFlexVarsFragmentDoc}
${DroopStopVarsForSetupSheetFlexFragmentDoc}
${ExternalBumpStopVarsForSetupSheetFlexFragmentDoc}
${KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc}
${KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc}
${SpringVarsForSetupSheetFlexFragmentDoc}
${CornerVarsForSetupSheetFlexFragmentDoc}
${InfoVarsFragmentDoc}
${MassVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${RunSheetContextForSetupSheetVarsFragmentDoc}
${SteeringVarsFragmentDoc}`;
export const Overview_SimResultUpdatedDocument = `
    subscription Overview_SimResultUpdated($id: MongoID) {
  simResultUpdated(simResultID: $id) {
    ...SimResultInfosForStagingAreaVars
  }
}
    ${SimResultInfosForStagingAreaVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;
export const Overview_SimResultAddedDocument = `
    subscription Overview_SimResultAdded {
  simResultAdded {
    ...AllSimResultScalarVars
  }
}
    ${AllSimResultScalarVarsFragmentDoc}`;
export const Overview_SimResultRemovedDocument = `
    subscription Overview_SimResultRemoved {
  simResultRemoved {
    _id
    runSheetID
  }
}
    `;
export const RunSheetInSessionsAddedForDashboardDocument = `
    subscription RunSheetInSessionsAddedForDashboard($contestantID: MongoID!, $sessionIDs: [MongoID!]!) {
  runSheetInSessionsAdded(sessionIDs: $sessionIDs, contestantID: $contestantID) {
    _id
    ...AllKPIRunSheetData
  }
}
    ${AllKpiRunSheetDataFragmentDoc}
${RunSheetForOverviewFragmentDoc}
${BrakeForRunSheetOverviewVarsFragmentDoc}
${BrakeMeasurementForRunSheetOverviewVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${CarSetupVarsForKpiViewLiveFragmentDoc}
${CarSetupVarsForKpiViewBaseFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${ChassisAssemblyForFlexSetupVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${EndVarsForSetupSheetFlexFragmentDoc}
${AntiRollBarVarsForSetupSheetFlexFragmentDoc}
${BumpStopVarsForSetupSheetFlexFragmentDoc}
${ElasticSpecForSetupSheetFlexVarsFragmentDoc}
${DroopStopVarsForSetupSheetFlexFragmentDoc}
${ExternalBumpStopVarsForSetupSheetFlexFragmentDoc}
${KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc}
${KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc}
${SpringVarsForSetupSheetFlexFragmentDoc}
${CornerVarsForSetupSheetFlexFragmentDoc}
${InfoVarsFragmentDoc}
${MassVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${RunSheetContextForSetupSheetVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${SimResultForRunSheetOverviewVarsFragmentDoc}
${RunTyreForRunSheetOverviewVarsFragmentDoc}
${WeatherForRunSheetOverviewVarsFragmentDoc}
${LapForRunSheetOverviewVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}`;
export const RunSheetInSessionsRemovedForDashboardDocument = `
    subscription RunSheetInSessionsRemovedForDashboard($contestantID: MongoID!, $sessionIDs: [MongoID!]!) {
  runSheetInSessionsRemoved(sessionIDs: $sessionIDs, contestantID: $contestantID) {
    _id
  }
}
    `;
export const RunSheetInSessionsUpdatedForDashboardDocument = `
    subscription RunSheetInSessionsUpdatedForDashboard($contestantID: MongoID!, $sessionIDs: [MongoID!]!) {
  runSheetInSessionsUpdated(sessionIDs: $sessionIDs, contestantID: $contestantID) {
    _id
    ...AllKPIRunSheetData
  }
}
    ${AllKpiRunSheetDataFragmentDoc}
${RunSheetForOverviewFragmentDoc}
${BrakeForRunSheetOverviewVarsFragmentDoc}
${BrakeMeasurementForRunSheetOverviewVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${CarSetupVarsForKpiViewLiveFragmentDoc}
${CarSetupVarsForKpiViewBaseFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${ChassisAssemblyForFlexSetupVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${EndVarsForSetupSheetFlexFragmentDoc}
${AntiRollBarVarsForSetupSheetFlexFragmentDoc}
${BumpStopVarsForSetupSheetFlexFragmentDoc}
${ElasticSpecForSetupSheetFlexVarsFragmentDoc}
${DroopStopVarsForSetupSheetFlexFragmentDoc}
${ExternalBumpStopVarsForSetupSheetFlexFragmentDoc}
${KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc}
${KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc}
${SpringVarsForSetupSheetFlexFragmentDoc}
${CornerVarsForSetupSheetFlexFragmentDoc}
${InfoVarsFragmentDoc}
${MassVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${RunSheetContextForSetupSheetVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${SimResultForRunSheetOverviewVarsFragmentDoc}
${RunTyreForRunSheetOverviewVarsFragmentDoc}
${WeatherForRunSheetOverviewVarsFragmentDoc}
${LapForRunSheetOverviewVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}`;
export const RunInfoInSessionsForDashboardDocument = `
    subscription RunInfoInSessionsForDashboard($contestantID: MongoID!, $sessionIDs: [MongoID!]!) {
  runSheetInfoInSessionsUpdated(
    sessionIDs: $sessionIDs
    contestantID: $contestantID
  ) {
    _id
    info
  }
}
    `;
export const SetupInfoInSessionsForDashboardDocument = `
    subscription SetupInfoInSessionsForDashboard($contestantID: MongoID!, $sessionIDs: [MongoID!]!) {
  carSetupInfoInSessionsUpdated(
    sessionIDs: $sessionIDs
    contestantID: $contestantID
  ) {
    _id
    setupInfo
  }
}
    `;
export const SetupChangedInSessionsForDashboardDocument = `
    subscription SetupChangedInSessionsForDashboard($contestantID: MongoID!, $sessionIDs: [MongoID!]!) {
  carSetupChangedInSessions(sessionIDs: $sessionIDs, contestantID: $contestantID) {
    _id
    updatedAt
  }
}
    `;
export const CheckDataUpdatedAtForSimulationPageDocument = `
    query CheckDataUpdatedAtForSimulationPage($eventIDs: [MongoID!], $runSheetIDs: [MongoID], $runSheetPageSize: Int, $carSetupIDs: [MongoID], $carSetupPageSize: Int, $simResultIDs: [MongoID], $simResultPageSize: Int) {
  sessions(perPage: 2000, filter: {_operators: {eventID: {in: $eventIDs}}}) {
    items {
      _id
      name
      shortName
      event {
        name
      }
      eventID
    }
  }
  runSheets(
    perPage: $runSheetPageSize
    filter: {_operators: {_id: {in: $runSheetIDs}}}
  ) {
    items {
      _id
      updatedAt
    }
  }
  carSetups(
    perPage: $carSetupPageSize
    filter: {_operators: {_id: {in: $carSetupIDs}}}
  ) {
    items {
      _id
      updatedAt
    }
  }
  simResults(
    perPage: $simResultPageSize
    filter: {_operators: {_id: {in: $simResultIDs}}}
  ) {
    items {
      _id
      updatedAt
    }
  }
}
    `;

export const useCheckDataUpdatedAtForSimulationPageQuery = <
      TData = CheckDataUpdatedAtForSimulationPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: CheckDataUpdatedAtForSimulationPageQueryVariables,
      options?: UseQueryOptions<CheckDataUpdatedAtForSimulationPageQuery, TError, TData>
    ) => {
    
    return useQuery<CheckDataUpdatedAtForSimulationPageQuery, TError, TData>(
      variables === undefined ? ['CheckDataUpdatedAtForSimulationPage'] : ['CheckDataUpdatedAtForSimulationPage', variables],
      fetcher<CheckDataUpdatedAtForSimulationPageQuery, CheckDataUpdatedAtForSimulationPageQueryVariables>(CheckDataUpdatedAtForSimulationPageDocument, variables),
      options
    )};

export const GetUpdatedDataForInitializationForSimulationPageDocument = `
    query GetUpdatedDataForInitializationForSimulationPage($runSheetIDs: [MongoID], $runSheetPageSize: Int, $sessionIDs: [MongoID], $carSetupIDs: [MongoID], $carSetupPageSize: Int, $simResultIDs: [MongoID], $simResultPageSize: Int) {
  allowedRunSheetsForSelectedSessions: runSheets(
    perPage: 5000
    filter: {_operators: {sessionID: {in: $sessionIDs}}}
  ) {
    items {
      ...RunSheetForEventSelectionVars
    }
  }
  updatedRunSheets: runSheets(
    perPage: $runSheetPageSize
    filter: {_operators: {_id: {in: $runSheetIDs}}}
  ) {
    items {
      ...GetRunSheetInfoForStagingAreaVars
    }
  }
  carSetups(
    perPage: $carSetupPageSize
    filter: {_operators: {_id: {in: $carSetupIDs}}}
  ) {
    items {
      ...CarSetupInfoForStagingAreaVars
    }
  }
  simResults(
    perPage: $simResultPageSize
    filter: {_operators: {_id: {in: $simResultIDs}}}
  ) {
    items {
      ...SimResultInfosForStagingAreaVars
    }
  }
}
    ${RunSheetForEventSelectionVarsFragmentDoc}
${GetRunSheetInfoForStagingAreaVarsFragmentDoc}
${CarSetupInfoForStagingAreaVarsFragmentDoc}
${SimResultInfosForStagingAreaVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetUpdatedDataForInitializationForSimulationPageQuery = <
      TData = GetUpdatedDataForInitializationForSimulationPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetUpdatedDataForInitializationForSimulationPageQueryVariables,
      options?: UseQueryOptions<GetUpdatedDataForInitializationForSimulationPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetUpdatedDataForInitializationForSimulationPageQuery, TError, TData>(
      variables === undefined ? ['GetUpdatedDataForInitializationForSimulationPage'] : ['GetUpdatedDataForInitializationForSimulationPage', variables],
      fetcher<GetUpdatedDataForInitializationForSimulationPageQuery, GetUpdatedDataForInitializationForSimulationPageQueryVariables>(GetUpdatedDataForInitializationForSimulationPageDocument, variables),
      options
    )};

export const TimingServiceStatusUpdatedDocument = `
    subscription TimingServiceStatusUpdated {
  timingServiceStatusUpdated {
    _id
    activeConfigs {
      declaredSession
      lastMessage
      sessionMatch {
        name
      }
      sessionMatchID
      sessionMatchInfo
      timingServiceConfig {
        _id
        active
        name
      }
      timingServiceConfigID
    }
    failedConfigs {
      message
      timingServiceConfig {
        _id
        active
        name
      }
      timingServiceConfigID
    }
  }
}
    `;
export const GetTimingServiceStatusDocument = `
    query GetTimingServiceStatus {
  timingServiceStatus {
    activeConfigs {
      declaredSession
      sessionMatchID
      sessionMatchInfo
      timingServiceConfig {
        _id
        active
        name
      }
      timingServiceConfigID
    }
    failedConfigs {
      message
      timingServiceConfig {
        _id
        active
        name
      }
      timingServiceConfigID
    }
  }
}
    `;

export const useGetTimingServiceStatusQuery = <
      TData = GetTimingServiceStatusQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTimingServiceStatusQueryVariables,
      options?: UseQueryOptions<GetTimingServiceStatusQuery, TError, TData>
    ) => {
    
    return useQuery<GetTimingServiceStatusQuery, TError, TData>(
      variables === undefined ? ['GetTimingServiceStatus'] : ['GetTimingServiceStatus', variables],
      fetcher<GetTimingServiceStatusQuery, GetTimingServiceStatusQueryVariables>(GetTimingServiceStatusDocument, variables),
      options
    )};

export const TyreSet_AddTyreSetDocument = `
    mutation tyreSet_AddTyreSet($record: CreateOneTyreSetInput!) {
  addTyreSet(record: $record) {
    recordId
  }
}
    `;

export const useTyreSet_AddTyreSetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<TyreSet_AddTyreSetMutation, TError, TyreSet_AddTyreSetMutationVariables, TContext>) => {
    
    return useMutation<TyreSet_AddTyreSetMutation, TError, TyreSet_AddTyreSetMutationVariables, TContext>(
      ['tyreSet_AddTyreSet'],
      (variables?: TyreSet_AddTyreSetMutationVariables) => fetcher<TyreSet_AddTyreSetMutation, TyreSet_AddTyreSetMutationVariables>(TyreSet_AddTyreSetDocument, variables)(),
      options
    )};

export const TyreSet_AddTyreDocument = `
    mutation tyreSet_AddTyre($record: CreateOneTyreInput!) {
  addTyre(record: $record) {
    recordId
  }
}
    `;

export const useTyreSet_AddTyreMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<TyreSet_AddTyreMutation, TError, TyreSet_AddTyreMutationVariables, TContext>) => {
    
    return useMutation<TyreSet_AddTyreMutation, TError, TyreSet_AddTyreMutationVariables, TContext>(
      ['tyreSet_AddTyre'],
      (variables?: TyreSet_AddTyreMutationVariables) => fetcher<TyreSet_AddTyreMutation, TyreSet_AddTyreMutationVariables>(TyreSet_AddTyreDocument, variables)(),
      options
    )};

export const TyreSet_AddTyresToContestantDocument = `
    mutation tyreSet_AddTyresToContestant($contestantID: MongoID!, $tyreIDs: [MongoID!]!) {
  addTyresToContestant(contestantID: $contestantID, tyreIDs: $tyreIDs) {
    success
  }
}
    `;

export const useTyreSet_AddTyresToContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<TyreSet_AddTyresToContestantMutation, TError, TyreSet_AddTyresToContestantMutationVariables, TContext>) => {
    
    return useMutation<TyreSet_AddTyresToContestantMutation, TError, TyreSet_AddTyresToContestantMutationVariables, TContext>(
      ['tyreSet_AddTyresToContestant'],
      (variables?: TyreSet_AddTyresToContestantMutationVariables) => fetcher<TyreSet_AddTyresToContestantMutation, TyreSet_AddTyresToContestantMutationVariables>(TyreSet_AddTyresToContestantDocument, variables)(),
      options
    )};

export const TyreSet_AddTyreSetsToContestantDocument = `
    mutation tyreSet_AddTyreSetsToContestant($contestantID: MongoID!, $tyreSetIDs: [MongoID!]!) {
  addTyreSetsToContestant(contestantID: $contestantID, tyreSetIDs: $tyreSetIDs) {
    success
  }
}
    `;

export const useTyreSet_AddTyreSetsToContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<TyreSet_AddTyreSetsToContestantMutation, TError, TyreSet_AddTyreSetsToContestantMutationVariables, TContext>) => {
    
    return useMutation<TyreSet_AddTyreSetsToContestantMutation, TError, TyreSet_AddTyreSetsToContestantMutationVariables, TContext>(
      ['tyreSet_AddTyreSetsToContestant'],
      (variables?: TyreSet_AddTyreSetsToContestantMutationVariables) => fetcher<TyreSet_AddTyreSetsToContestantMutation, TyreSet_AddTyreSetsToContestantMutationVariables>(TyreSet_AddTyreSetsToContestantDocument, variables)(),
      options
    )};

export const TyreSet_AddTyreSetsToEventContestantDocument = `
    mutation tyreSet_AddTyreSetsToEventContestant($contestantID: MongoID!, $eventID: MongoID!, $tyreSetIDs: [MongoID!]!) {
  addTyreSetsToEventContestant(
    contestantID: $contestantID
    eventID: $eventID
    tyreSetIDs: $tyreSetIDs
  ) {
    success
  }
}
    `;

export const useTyreSet_AddTyreSetsToEventContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<TyreSet_AddTyreSetsToEventContestantMutation, TError, TyreSet_AddTyreSetsToEventContestantMutationVariables, TContext>) => {
    
    return useMutation<TyreSet_AddTyreSetsToEventContestantMutation, TError, TyreSet_AddTyreSetsToEventContestantMutationVariables, TContext>(
      ['tyreSet_AddTyreSetsToEventContestant'],
      (variables?: TyreSet_AddTyreSetsToEventContestantMutationVariables) => fetcher<TyreSet_AddTyreSetsToEventContestantMutation, TyreSet_AddTyreSetsToEventContestantMutationVariables>(TyreSet_AddTyreSetsToEventContestantDocument, variables)(),
      options
    )};

export const TyrePool_ForceAddLapDocument = `
    mutation tyrePool_ForceAddLap($runSheetID: MongoID!, $lap: LapInput!) {
  forceAddLap(runSheetID: $runSheetID, lap: $lap) {
    _id
  }
}
    `;

export const useTyrePool_ForceAddLapMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<TyrePool_ForceAddLapMutation, TError, TyrePool_ForceAddLapMutationVariables, TContext>) => {
    
    return useMutation<TyrePool_ForceAddLapMutation, TError, TyrePool_ForceAddLapMutationVariables, TContext>(
      ['tyrePool_ForceAddLap'],
      (variables?: TyrePool_ForceAddLapMutationVariables) => fetcher<TyrePool_ForceAddLapMutation, TyrePool_ForceAddLapMutationVariables>(TyrePool_ForceAddLapDocument, variables)(),
      options
    )};

export const Helpers_CreateRaceSeriesDocument = `
    mutation helpers_createRaceSeries($record: CreateOneRaceSeriesInput!) {
  addRaceSeries(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateRaceSeriesMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateRaceSeriesMutation, TError, Helpers_CreateRaceSeriesMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateRaceSeriesMutation, TError, Helpers_CreateRaceSeriesMutationVariables, TContext>(
      ['helpers_createRaceSeries'],
      (variables?: Helpers_CreateRaceSeriesMutationVariables) => fetcher<Helpers_CreateRaceSeriesMutation, Helpers_CreateRaceSeriesMutationVariables>(Helpers_CreateRaceSeriesDocument, variables)(),
      options
    )};

export const Helpers_CreateSeasonDocument = `
    mutation helpers_createSeason($record: CreateOneSeasonInput!) {
  addSeason(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateSeasonMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateSeasonMutation, TError, Helpers_CreateSeasonMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateSeasonMutation, TError, Helpers_CreateSeasonMutationVariables, TContext>(
      ['helpers_createSeason'],
      (variables?: Helpers_CreateSeasonMutationVariables) => fetcher<Helpers_CreateSeasonMutation, Helpers_CreateSeasonMutationVariables>(Helpers_CreateSeasonDocument, variables)(),
      options
    )};

export const Helpers_CreateEventDocument = `
    mutation helpers_createEvent($record: CreateOneEventInput!) {
  addEvent(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateEventMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateEventMutation, TError, Helpers_CreateEventMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateEventMutation, TError, Helpers_CreateEventMutationVariables, TContext>(
      ['helpers_createEvent'],
      (variables?: Helpers_CreateEventMutationVariables) => fetcher<Helpers_CreateEventMutation, Helpers_CreateEventMutationVariables>(Helpers_CreateEventDocument, variables)(),
      options
    )};

export const Helpers_UpdateEventDocument = `
    mutation helpers_updateEvent($id: MongoID!, $record: UpdateByIdEventInput!) {
  updateEvent(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useHelpers_UpdateEventMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdateEventMutation, TError, Helpers_UpdateEventMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdateEventMutation, TError, Helpers_UpdateEventMutationVariables, TContext>(
      ['helpers_updateEvent'],
      (variables?: Helpers_UpdateEventMutationVariables) => fetcher<Helpers_UpdateEventMutation, Helpers_UpdateEventMutationVariables>(Helpers_UpdateEventDocument, variables)(),
      options
    )};

export const Helpers_CreateSessionDocument = `
    mutation helpers_createSession($record: CreateOneSessionInput!) {
  addSession(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateSessionMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateSessionMutation, TError, Helpers_CreateSessionMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateSessionMutation, TError, Helpers_CreateSessionMutationVariables, TContext>(
      ['helpers_createSession'],
      (variables?: Helpers_CreateSessionMutationVariables) => fetcher<Helpers_CreateSessionMutation, Helpers_CreateSessionMutationVariables>(Helpers_CreateSessionDocument, variables)(),
      options
    )};

export const Helpers_UpdateSessionDocument = `
    mutation helpers_updateSession($id: MongoID!, $record: UpdateByIdSessionInput!) {
  updateSession(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useHelpers_UpdateSessionMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdateSessionMutation, TError, Helpers_UpdateSessionMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdateSessionMutation, TError, Helpers_UpdateSessionMutationVariables, TContext>(
      ['helpers_updateSession'],
      (variables?: Helpers_UpdateSessionMutationVariables) => fetcher<Helpers_UpdateSessionMutation, Helpers_UpdateSessionMutationVariables>(Helpers_UpdateSessionDocument, variables)(),
      options
    )};

export const Helpers_CreateContestantDocument = `
    mutation helpers_createContestant($record: CreateOneContestantInput!) {
  addContestant(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateContestantMutation, TError, Helpers_CreateContestantMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateContestantMutation, TError, Helpers_CreateContestantMutationVariables, TContext>(
      ['helpers_createContestant'],
      (variables?: Helpers_CreateContestantMutationVariables) => fetcher<Helpers_CreateContestantMutation, Helpers_CreateContestantMutationVariables>(Helpers_CreateContestantDocument, variables)(),
      options
    )};

export const Helpers_UpdateContestantDocument = `
    mutation helpers_updateContestant($id: MongoID!, $record: UpdateByIdContestantInput!) {
  updateContestant(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useHelpers_UpdateContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdateContestantMutation, TError, Helpers_UpdateContestantMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdateContestantMutation, TError, Helpers_UpdateContestantMutationVariables, TContext>(
      ['helpers_updateContestant'],
      (variables?: Helpers_UpdateContestantMutationVariables) => fetcher<Helpers_UpdateContestantMutation, Helpers_UpdateContestantMutationVariables>(Helpers_UpdateContestantDocument, variables)(),
      options
    )};

export const Helpers_CreateRunSheetDocument = `
    mutation helpers_createRunSheet($record: CreateOneRunSheetInput!) {
  addRunSheet(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateRunSheetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateRunSheetMutation, TError, Helpers_CreateRunSheetMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateRunSheetMutation, TError, Helpers_CreateRunSheetMutationVariables, TContext>(
      ['helpers_createRunSheet'],
      (variables?: Helpers_CreateRunSheetMutationVariables) => fetcher<Helpers_CreateRunSheetMutation, Helpers_CreateRunSheetMutationVariables>(Helpers_CreateRunSheetDocument, variables)(),
      options
    )};

export const Helpers_UpdateRunSheetDocument = `
    mutation helpers_updateRunSheet($id: MongoID!, $record: UpdateByIdRunSheetInput!) {
  updateRunSheet(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useHelpers_UpdateRunSheetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdateRunSheetMutation, TError, Helpers_UpdateRunSheetMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdateRunSheetMutation, TError, Helpers_UpdateRunSheetMutationVariables, TContext>(
      ['helpers_updateRunSheet'],
      (variables?: Helpers_UpdateRunSheetMutationVariables) => fetcher<Helpers_UpdateRunSheetMutation, Helpers_UpdateRunSheetMutationVariables>(Helpers_UpdateRunSheetDocument, variables)(),
      options
    )};

export const Helpers_CreateRunSheetStyleDocument = `
    mutation helpers_createRunSheetStyle($record: CreateOneRunSheetStyleInput!) {
  addRunSheetStyle(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateRunSheetStyleMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateRunSheetStyleMutation, TError, Helpers_CreateRunSheetStyleMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateRunSheetStyleMutation, TError, Helpers_CreateRunSheetStyleMutationVariables, TContext>(
      ['helpers_createRunSheetStyle'],
      (variables?: Helpers_CreateRunSheetStyleMutationVariables) => fetcher<Helpers_CreateRunSheetStyleMutation, Helpers_CreateRunSheetStyleMutationVariables>(Helpers_CreateRunSheetStyleDocument, variables)(),
      options
    )};

export const Helpers_UpdateteRunSheetStyleDocument = `
    mutation helpers_updateteRunSheetStyle($id: MongoID!, $record: UpdateByIdRunSheetStyleInput!) {
  updateRunSheetStyle(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useHelpers_UpdateteRunSheetStyleMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdateteRunSheetStyleMutation, TError, Helpers_UpdateteRunSheetStyleMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdateteRunSheetStyleMutation, TError, Helpers_UpdateteRunSheetStyleMutationVariables, TContext>(
      ['helpers_updateteRunSheetStyle'],
      (variables?: Helpers_UpdateteRunSheetStyleMutationVariables) => fetcher<Helpers_UpdateteRunSheetStyleMutation, Helpers_UpdateteRunSheetStyleMutationVariables>(Helpers_UpdateteRunSheetStyleDocument, variables)(),
      options
    )};

export const Helpers_CreateTrackDocument = `
    mutation helpers_createTrack($record: CreateOneTrackInput!) {
  addTrack(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateTrackMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateTrackMutation, TError, Helpers_CreateTrackMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateTrackMutation, TError, Helpers_CreateTrackMutationVariables, TContext>(
      ['helpers_createTrack'],
      (variables?: Helpers_CreateTrackMutationVariables) => fetcher<Helpers_CreateTrackMutation, Helpers_CreateTrackMutationVariables>(Helpers_CreateTrackDocument, variables)(),
      options
    )};

export const Helpers_CreateTrackLayoutDocument = `
    mutation helpers_createTrackLayout($record: CreateOneTrackLayoutInput!) {
  addTrackLayout(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateTrackLayoutMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateTrackLayoutMutation, TError, Helpers_CreateTrackLayoutMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateTrackLayoutMutation, TError, Helpers_CreateTrackLayoutMutationVariables, TContext>(
      ['helpers_createTrackLayout'],
      (variables?: Helpers_CreateTrackLayoutMutationVariables) => fetcher<Helpers_CreateTrackLayoutMutation, Helpers_CreateTrackLayoutMutationVariables>(Helpers_CreateTrackLayoutDocument, variables)(),
      options
    )};

export const Helpers_CreateJobDocument = `
    mutation helpers_createJob($record: CreateOneJobInput!, $target: EnumJobTarget!) {
  addJob(record: $record, target: $target) {
    recordId
  }
}
    `;

export const useHelpers_CreateJobMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateJobMutation, TError, Helpers_CreateJobMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateJobMutation, TError, Helpers_CreateJobMutationVariables, TContext>(
      ['helpers_createJob'],
      (variables?: Helpers_CreateJobMutationVariables) => fetcher<Helpers_CreateJobMutation, Helpers_CreateJobMutationVariables>(Helpers_CreateJobDocument, variables)(),
      options
    )};

export const Helpers_CreateJobListTemplateDocument = `
    mutation helpers_createJobListTemplate($record: CreateOneTemplateJobListInput!) {
  addTemplateJobList(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateJobListTemplateMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateJobListTemplateMutation, TError, Helpers_CreateJobListTemplateMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateJobListTemplateMutation, TError, Helpers_CreateJobListTemplateMutationVariables, TContext>(
      ['helpers_createJobListTemplate'],
      (variables?: Helpers_CreateJobListTemplateMutationVariables) => fetcher<Helpers_CreateJobListTemplateMutation, Helpers_CreateJobListTemplateMutationVariables>(Helpers_CreateJobListTemplateDocument, variables)(),
      options
    )};

export const Helpers_AddCommentDocument = `
    mutation helpers_addComment($target: EnumJobTarget!, $subjectID: MongoID!, $text: String!) {
  addComment(target: $target, subjectID: $subjectID, text: $text) {
    comment {
      _id
    }
  }
}
    `;

export const useHelpers_AddCommentMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_AddCommentMutation, TError, Helpers_AddCommentMutationVariables, TContext>) => {
    
    return useMutation<Helpers_AddCommentMutation, TError, Helpers_AddCommentMutationVariables, TContext>(
      ['helpers_addComment'],
      (variables?: Helpers_AddCommentMutationVariables) => fetcher<Helpers_AddCommentMutation, Helpers_AddCommentMutationVariables>(Helpers_AddCommentDocument, variables)(),
      options
    )};

export const Helpers_UpdateCommentDocument = `
    mutation helpers_updateComment($target: EnumJobTarget!, $subjectID: MongoID!, $commentID: MongoID!, $text: String!) {
  updateComment(
    target: $target
    commentID: $commentID
    text: $text
    subjectID: $subjectID
  ) {
    comment {
      _id
      text
    }
  }
}
    `;

export const useHelpers_UpdateCommentMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdateCommentMutation, TError, Helpers_UpdateCommentMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdateCommentMutation, TError, Helpers_UpdateCommentMutationVariables, TContext>(
      ['helpers_updateComment'],
      (variables?: Helpers_UpdateCommentMutationVariables) => fetcher<Helpers_UpdateCommentMutation, Helpers_UpdateCommentMutationVariables>(Helpers_UpdateCommentDocument, variables)(),
      options
    )};

export const Helpers_ManageJobDocument = `
    mutation helpers_manageJob($id: MongoID!, $action: JobAction!, $target: EnumJobTarget!) {
  manageJob(jobID: $id, action: $action, target: $target) {
    _id
  }
}
    `;

export const useHelpers_ManageJobMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_ManageJobMutation, TError, Helpers_ManageJobMutationVariables, TContext>) => {
    
    return useMutation<Helpers_ManageJobMutation, TError, Helpers_ManageJobMutationVariables, TContext>(
      ['helpers_manageJob'],
      (variables?: Helpers_ManageJobMutationVariables) => fetcher<Helpers_ManageJobMutation, Helpers_ManageJobMutationVariables>(Helpers_ManageJobDocument, variables)(),
      options
    )};

export const Helpers_RemoveJobDocument = `
    mutation helpers_removeJob($id: MongoID!, $target: EnumJobTarget!) {
  removeJob(_id: $id, target: $target) {
    recordId
  }
}
    `;

export const useHelpers_RemoveJobMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_RemoveJobMutation, TError, Helpers_RemoveJobMutationVariables, TContext>) => {
    
    return useMutation<Helpers_RemoveJobMutation, TError, Helpers_RemoveJobMutationVariables, TContext>(
      ['helpers_removeJob'],
      (variables?: Helpers_RemoveJobMutationVariables) => fetcher<Helpers_RemoveJobMutation, Helpers_RemoveJobMutationVariables>(Helpers_RemoveJobDocument, variables)(),
      options
    )};

export const Helpers_CreateRunPlanDocument = `
    mutation helpers_createRunPlan($record: CreateOneRunPlanInput!) {
  addRunPlan(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateRunPlanMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateRunPlanMutation, TError, Helpers_CreateRunPlanMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateRunPlanMutation, TError, Helpers_CreateRunPlanMutationVariables, TContext>(
      ['helpers_createRunPlan'],
      (variables?: Helpers_CreateRunPlanMutationVariables) => fetcher<Helpers_CreateRunPlanMutation, Helpers_CreateRunPlanMutationVariables>(Helpers_CreateRunPlanDocument, variables)(),
      options
    )};

export const Helpers_AddRunToRunPlanDocument = `
    mutation helpers_addRunToRunPlan($runPlanID: MongoID!, $runs: [RunPlanRunInput]!) {
  addRunToRunPlan(runPlanID: $runPlanID, runs: $runs) {
    _id
    runs {
      NRun
    }
  }
}
    `;

export const useHelpers_AddRunToRunPlanMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_AddRunToRunPlanMutation, TError, Helpers_AddRunToRunPlanMutationVariables, TContext>) => {
    
    return useMutation<Helpers_AddRunToRunPlanMutation, TError, Helpers_AddRunToRunPlanMutationVariables, TContext>(
      ['helpers_addRunToRunPlan'],
      (variables?: Helpers_AddRunToRunPlanMutationVariables) => fetcher<Helpers_AddRunToRunPlanMutation, Helpers_AddRunToRunPlanMutationVariables>(Helpers_AddRunToRunPlanDocument, variables)(),
      options
    )};

export const Helpers_CreateCarSetupDocument = `
    mutation helpers_createCarSetup($record: CreateOneCarSetupInput!) {
  addCarSetup(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateCarSetupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateCarSetupMutation, TError, Helpers_CreateCarSetupMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateCarSetupMutation, TError, Helpers_CreateCarSetupMutationVariables, TContext>(
      ['helpers_createCarSetup'],
      (variables?: Helpers_CreateCarSetupMutationVariables) => fetcher<Helpers_CreateCarSetupMutation, Helpers_CreateCarSetupMutationVariables>(Helpers_CreateCarSetupDocument, variables)(),
      options
    )};

export const Helpers_UpdateCarSetupDocument = `
    mutation helpers_updateCarSetup($id: MongoID!, $record: UpdateByIdCarSetupInput!) {
  updateCarSetup(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useHelpers_UpdateCarSetupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdateCarSetupMutation, TError, Helpers_UpdateCarSetupMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdateCarSetupMutation, TError, Helpers_UpdateCarSetupMutationVariables, TContext>(
      ['helpers_updateCarSetup'],
      (variables?: Helpers_UpdateCarSetupMutationVariables) => fetcher<Helpers_UpdateCarSetupMutation, Helpers_UpdateCarSetupMutationVariables>(Helpers_UpdateCarSetupDocument, variables)(),
      options
    )};

export const Helpers_CreateChassisDocument = `
    mutation helpers_createChassis($record: CreateOneChassisInput!) {
  addChassis(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateChassisMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateChassisMutation, TError, Helpers_CreateChassisMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateChassisMutation, TError, Helpers_CreateChassisMutationVariables, TContext>(
      ['helpers_createChassis'],
      (variables?: Helpers_CreateChassisMutationVariables) => fetcher<Helpers_CreateChassisMutation, Helpers_CreateChassisMutationVariables>(Helpers_CreateChassisDocument, variables)(),
      options
    )};

export const Helpers_CreateChassisSpecDocument = `
    mutation helpers_createChassisSpec($record: CreateOneSpecificationInput!) {
  addSpecification(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateChassisSpecMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateChassisSpecMutation, TError, Helpers_CreateChassisSpecMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateChassisSpecMutation, TError, Helpers_CreateChassisSpecMutationVariables, TContext>(
      ['helpers_createChassisSpec'],
      (variables?: Helpers_CreateChassisSpecMutationVariables) => fetcher<Helpers_CreateChassisSpecMutation, Helpers_CreateChassisSpecMutationVariables>(Helpers_CreateChassisSpecDocument, variables)(),
      options
    )};

export const Helpers_UpdateMeDocument = `
    mutation helpers_updateMe($record: UpdateMeInput!) {
  updateMe(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_UpdateMeMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdateMeMutation, TError, Helpers_UpdateMeMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdateMeMutation, TError, Helpers_UpdateMeMutationVariables, TContext>(
      ['helpers_updateMe'],
      (variables?: Helpers_UpdateMeMutationVariables) => fetcher<Helpers_UpdateMeMutation, Helpers_UpdateMeMutationVariables>(Helpers_UpdateMeDocument, variables)(),
      options
    )};

export const Helpers_GetPersonDocument = `
    query helpers_getPerson($id: MongoID!) {
  person(_id: $id) {
    _id
    userSetupIDs
    username
  }
}
    `;

export const useHelpers_GetPersonQuery = <
      TData = Helpers_GetPersonQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: Helpers_GetPersonQueryVariables,
      options?: UseQueryOptions<Helpers_GetPersonQuery, TError, TData>
    ) => {
    
    return useQuery<Helpers_GetPersonQuery, TError, TData>(
      ['helpers_getPerson', variables],
      fetcher<Helpers_GetPersonQuery, Helpers_GetPersonQueryVariables>(Helpers_GetPersonDocument, variables),
      options
    )};

export const Helpers_GetCurrentUserIdDocument = `
    query helpers_getCurrentUserID {
  whoami {
    person {
      _id
    }
  }
}
    `;

export const useHelpers_GetCurrentUserIdQuery = <
      TData = Helpers_GetCurrentUserIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: Helpers_GetCurrentUserIdQueryVariables,
      options?: UseQueryOptions<Helpers_GetCurrentUserIdQuery, TError, TData>
    ) => {
    
    return useQuery<Helpers_GetCurrentUserIdQuery, TError, TData>(
      variables === undefined ? ['helpers_getCurrentUserID'] : ['helpers_getCurrentUserID', variables],
      fetcher<Helpers_GetCurrentUserIdQuery, Helpers_GetCurrentUserIdQueryVariables>(Helpers_GetCurrentUserIdDocument, variables),
      options
    )};

export const Helpers_CreatePersonDocument = `
    mutation helpers_createPerson($record: CreateOnePersonInput!) {
  addPerson(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreatePersonMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreatePersonMutation, TError, Helpers_CreatePersonMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreatePersonMutation, TError, Helpers_CreatePersonMutationVariables, TContext>(
      ['helpers_createPerson'],
      (variables?: Helpers_CreatePersonMutationVariables) => fetcher<Helpers_CreatePersonMutation, Helpers_CreatePersonMutationVariables>(Helpers_CreatePersonDocument, variables)(),
      options
    )};

export const Helpers_CreateTestUserDocument = `
    mutation helpers_createTestUser($record: CreateOnePersonInput!) {
  addTestUser(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateTestUserMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateTestUserMutation, TError, Helpers_CreateTestUserMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateTestUserMutation, TError, Helpers_CreateTestUserMutationVariables, TContext>(
      ['helpers_createTestUser'],
      (variables?: Helpers_CreateTestUserMutationVariables) => fetcher<Helpers_CreateTestUserMutation, Helpers_CreateTestUserMutationVariables>(Helpers_CreateTestUserDocument, variables)(),
      options
    )};

export const Helpers_UpdatePersonDocument = `
    mutation helpers_updatePerson($id: MongoID!, $record: UpdateByIdPersonInput!) {
  updatePerson(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useHelpers_UpdatePersonMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdatePersonMutation, TError, Helpers_UpdatePersonMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdatePersonMutation, TError, Helpers_UpdatePersonMutationVariables, TContext>(
      ['helpers_updatePerson'],
      (variables?: Helpers_UpdatePersonMutationVariables) => fetcher<Helpers_UpdatePersonMutation, Helpers_UpdatePersonMutationVariables>(Helpers_UpdatePersonDocument, variables)(),
      options
    )};

export const Helpers_CreateProjectDocument = `
    mutation helpers_createProject($record: CreateOneProjectInput!) {
  addProject(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateProjectMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateProjectMutation, TError, Helpers_CreateProjectMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateProjectMutation, TError, Helpers_CreateProjectMutationVariables, TContext>(
      ['helpers_createProject'],
      (variables?: Helpers_CreateProjectMutationVariables) => fetcher<Helpers_CreateProjectMutation, Helpers_CreateProjectMutationVariables>(Helpers_CreateProjectDocument, variables)(),
      options
    )};

export const Helpers_CreateOneTimeSheetEntryDocument = `
    mutation helpers_createOneTimeSheetEntry($record: CreateOneTimeSheetEntryInput!) {
  addTimeSheetEntry(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateOneTimeSheetEntryMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateOneTimeSheetEntryMutation, TError, Helpers_CreateOneTimeSheetEntryMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateOneTimeSheetEntryMutation, TError, Helpers_CreateOneTimeSheetEntryMutationVariables, TContext>(
      ['helpers_createOneTimeSheetEntry'],
      (variables?: Helpers_CreateOneTimeSheetEntryMutationVariables) => fetcher<Helpers_CreateOneTimeSheetEntryMutation, Helpers_CreateOneTimeSheetEntryMutationVariables>(Helpers_CreateOneTimeSheetEntryDocument, variables)(),
      options
    )};

export const Helpers_CreatePartDocument = `
    mutation helpers_createPart($record: CreateOnePartInput!) {
  addPart(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreatePartMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreatePartMutation, TError, Helpers_CreatePartMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreatePartMutation, TError, Helpers_CreatePartMutationVariables, TContext>(
      ['helpers_createPart'],
      (variables?: Helpers_CreatePartMutationVariables) => fetcher<Helpers_CreatePartMutation, Helpers_CreatePartMutationVariables>(Helpers_CreatePartDocument, variables)(),
      options
    )};

export const Helpers_CreatePartInstanceDocument = `
    mutation helpers_createPartInstance($record: CreateOnePartInstanceInput!) {
  addPartInstance(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreatePartInstanceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreatePartInstanceMutation, TError, Helpers_CreatePartInstanceMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreatePartInstanceMutation, TError, Helpers_CreatePartInstanceMutationVariables, TContext>(
      ['helpers_createPartInstance'],
      (variables?: Helpers_CreatePartInstanceMutationVariables) => fetcher<Helpers_CreatePartInstanceMutation, Helpers_CreatePartInstanceMutationVariables>(Helpers_CreatePartInstanceDocument, variables)(),
      options
    )};

export const Helpers_CreateAssemblyDocument = `
    mutation helpers_createAssembly($record: CreateOneAssemblyInput!) {
  addAssembly(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateAssemblyMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateAssemblyMutation, TError, Helpers_CreateAssemblyMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateAssemblyMutation, TError, Helpers_CreateAssemblyMutationVariables, TContext>(
      ['helpers_createAssembly'],
      (variables?: Helpers_CreateAssemblyMutationVariables) => fetcher<Helpers_CreateAssemblyMutation, Helpers_CreateAssemblyMutationVariables>(Helpers_CreateAssemblyDocument, variables)(),
      options
    )};

export const Helpers_UpdateAssemblyDocument = `
    mutation helpers_updateAssembly($id: MongoID!, $record: UpdateByIdAssemblyInput!) {
  updateAssembly(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useHelpers_UpdateAssemblyMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdateAssemblyMutation, TError, Helpers_UpdateAssemblyMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdateAssemblyMutation, TError, Helpers_UpdateAssemblyMutationVariables, TContext>(
      ['helpers_updateAssembly'],
      (variables?: Helpers_UpdateAssemblyMutationVariables) => fetcher<Helpers_UpdateAssemblyMutation, Helpers_UpdateAssemblyMutationVariables>(Helpers_UpdateAssemblyDocument, variables)(),
      options
    )};

export const Helpers_CreateSpecificationDocument = `
    mutation helpers_createSpecification($record: CreateOneSpecificationInput!) {
  addSpecification(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateSpecificationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateSpecificationMutation, TError, Helpers_CreateSpecificationMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateSpecificationMutation, TError, Helpers_CreateSpecificationMutationVariables, TContext>(
      ['helpers_createSpecification'],
      (variables?: Helpers_CreateSpecificationMutationVariables) => fetcher<Helpers_CreateSpecificationMutation, Helpers_CreateSpecificationMutationVariables>(Helpers_CreateSpecificationDocument, variables)(),
      options
    )};

export const Helpers_UpdateSpecificationDocument = `
    mutation helpers_updateSpecification($id: MongoID!, $record: UpdateByIdSpecificationInput!, $currentChassisSpecID: MongoID!) {
  updateSpecification(
    _id: $id
    record: $record
    currentChassisSpecID: $currentChassisSpecID
  ) {
    recordId
  }
}
    `;

export const useHelpers_UpdateSpecificationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdateSpecificationMutation, TError, Helpers_UpdateSpecificationMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdateSpecificationMutation, TError, Helpers_UpdateSpecificationMutationVariables, TContext>(
      ['helpers_updateSpecification'],
      (variables?: Helpers_UpdateSpecificationMutationVariables) => fetcher<Helpers_UpdateSpecificationMutation, Helpers_UpdateSpecificationMutationVariables>(Helpers_UpdateSpecificationDocument, variables)(),
      options
    )};

export const Helpers_UpdatePartDocument = `
    mutation helpers_updatePart($id: MongoID!, $record: UpdateByIdPartInput!) {
  updatePart(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useHelpers_UpdatePartMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdatePartMutation, TError, Helpers_UpdatePartMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdatePartMutation, TError, Helpers_UpdatePartMutationVariables, TContext>(
      ['helpers_updatePart'],
      (variables?: Helpers_UpdatePartMutationVariables) => fetcher<Helpers_UpdatePartMutation, Helpers_UpdatePartMutationVariables>(Helpers_UpdatePartDocument, variables)(),
      options
    )};

export const Helpers_CreateUserEnumDocument = `
    mutation helpers_createUserEnum($record: CreateOneUserEnumInput!) {
  addUserEnum(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateUserEnumMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateUserEnumMutation, TError, Helpers_CreateUserEnumMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateUserEnumMutation, TError, Helpers_CreateUserEnumMutationVariables, TContext>(
      ['helpers_createUserEnum'],
      (variables?: Helpers_CreateUserEnumMutationVariables) => fetcher<Helpers_CreateUserEnumMutation, Helpers_CreateUserEnumMutationVariables>(Helpers_CreateUserEnumDocument, variables)(),
      options
    )};

export const Helpers_UpdateUserEnumDocument = `
    mutation helpers_updateUserEnum($id: MongoID!, $record: UpdateByIdUserEnumInput!) {
  updateUserEnum(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useHelpers_UpdateUserEnumMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdateUserEnumMutation, TError, Helpers_UpdateUserEnumMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdateUserEnumMutation, TError, Helpers_UpdateUserEnumMutationVariables, TContext>(
      ['helpers_updateUserEnum'],
      (variables?: Helpers_UpdateUserEnumMutationVariables) => fetcher<Helpers_UpdateUserEnumMutation, Helpers_UpdateUserEnumMutationVariables>(Helpers_UpdateUserEnumDocument, variables)(),
      options
    )};

export const Helpers_CreateSetupSheetStyleDocument = `
    mutation helpers_createSetupSheetStyle($record: CreateOneSetupSheetStyleInput!) {
  addSetupSheetStyle(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateSetupSheetStyleMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateSetupSheetStyleMutation, TError, Helpers_CreateSetupSheetStyleMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateSetupSheetStyleMutation, TError, Helpers_CreateSetupSheetStyleMutationVariables, TContext>(
      ['helpers_createSetupSheetStyle'],
      (variables?: Helpers_CreateSetupSheetStyleMutationVariables) => fetcher<Helpers_CreateSetupSheetStyleMutation, Helpers_CreateSetupSheetStyleMutationVariables>(Helpers_CreateSetupSheetStyleDocument, variables)(),
      options
    )};

export const Helpers_ReleaseChassiSpecDocument = `
    mutation helpers_releaseChassiSpec($chassisSpecID: MongoID!, $version: String) {
  releaseChassisSpec(chassisSpecID: $chassisSpecID, version: $version) {
    releasedChassisSpec {
      _id
    }
    iteratedChassisSpec {
      _id
    }
  }
}
    `;

export const useHelpers_ReleaseChassiSpecMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_ReleaseChassiSpecMutation, TError, Helpers_ReleaseChassiSpecMutationVariables, TContext>) => {
    
    return useMutation<Helpers_ReleaseChassiSpecMutation, TError, Helpers_ReleaseChassiSpecMutationVariables, TContext>(
      ['helpers_releaseChassiSpec'],
      (variables?: Helpers_ReleaseChassiSpecMutationVariables) => fetcher<Helpers_ReleaseChassiSpecMutation, Helpers_ReleaseChassiSpecMutationVariables>(Helpers_ReleaseChassiSpecDocument, variables)(),
      options
    )};

export const Helpers_AddNewPersonDocument = `
    mutation helpers_addNewPerson($record: CreateOnePersonInput!) {
  addPerson(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_AddNewPersonMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_AddNewPersonMutation, TError, Helpers_AddNewPersonMutationVariables, TContext>) => {
    
    return useMutation<Helpers_AddNewPersonMutation, TError, Helpers_AddNewPersonMutationVariables, TContext>(
      ['helpers_addNewPerson'],
      (variables?: Helpers_AddNewPersonMutationVariables) => fetcher<Helpers_AddNewPersonMutation, Helpers_AddNewPersonMutationVariables>(Helpers_AddNewPersonDocument, variables)(),
      options
    )};

export const Helpers_ResetPasswordDocument = `
    mutation helpers_resetPassword($username: String!) {
  resetPassword(username: $username) {
    password
  }
}
    `;

export const useHelpers_ResetPasswordMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_ResetPasswordMutation, TError, Helpers_ResetPasswordMutationVariables, TContext>) => {
    
    return useMutation<Helpers_ResetPasswordMutation, TError, Helpers_ResetPasswordMutationVariables, TContext>(
      ['helpers_resetPassword'],
      (variables?: Helpers_ResetPasswordMutationVariables) => fetcher<Helpers_ResetPasswordMutation, Helpers_ResetPasswordMutationVariables>(Helpers_ResetPasswordDocument, variables)(),
      options
    )};

export const Helpers_SetPasswordDocument = `
    mutation helpers_setPassword($username: String!, $temporaryPassword: String!) {
  setPassword(
    username: $username
    oldPassword: $temporaryPassword
    newPassword: "password"
  ) {
    success
  }
}
    `;

export const useHelpers_SetPasswordMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_SetPasswordMutation, TError, Helpers_SetPasswordMutationVariables, TContext>) => {
    
    return useMutation<Helpers_SetPasswordMutation, TError, Helpers_SetPasswordMutationVariables, TContext>(
      ['helpers_setPassword'],
      (variables?: Helpers_SetPasswordMutationVariables) => fetcher<Helpers_SetPasswordMutation, Helpers_SetPasswordMutationVariables>(Helpers_SetPasswordDocument, variables)(),
      options
    )};

export const Helpers_AddTimingServiceConfigDocument = `
    mutation helpers_addTimingServiceConfig($record: CreateOneTimingServiceConfigInput!) {
  addTimingServiceConfig(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_AddTimingServiceConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_AddTimingServiceConfigMutation, TError, Helpers_AddTimingServiceConfigMutationVariables, TContext>) => {
    
    return useMutation<Helpers_AddTimingServiceConfigMutation, TError, Helpers_AddTimingServiceConfigMutationVariables, TContext>(
      ['helpers_addTimingServiceConfig'],
      (variables?: Helpers_AddTimingServiceConfigMutationVariables) => fetcher<Helpers_AddTimingServiceConfigMutation, Helpers_AddTimingServiceConfigMutationVariables>(Helpers_AddTimingServiceConfigDocument, variables)(),
      options
    )};

export const Helpers_CreatePointsSystemDocument = `
    mutation helpers_createPointsSystem($record: CreateOnePointsSystemInput!) {
  addPointsSystem(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreatePointsSystemMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreatePointsSystemMutation, TError, Helpers_CreatePointsSystemMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreatePointsSystemMutation, TError, Helpers_CreatePointsSystemMutationVariables, TContext>(
      ['helpers_createPointsSystem'],
      (variables?: Helpers_CreatePointsSystemMutationVariables) => fetcher<Helpers_CreatePointsSystemMutation, Helpers_CreatePointsSystemMutationVariables>(Helpers_CreatePointsSystemDocument, variables)(),
      options
    )};

export const Helpers_UpdatePointsSystemDocument = `
    mutation helpers_updatePointsSystem($id: MongoID!, $record: UpdateByIdPointsSystemInput!) {
  updatePointsSystem(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useHelpers_UpdatePointsSystemMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_UpdatePointsSystemMutation, TError, Helpers_UpdatePointsSystemMutationVariables, TContext>) => {
    
    return useMutation<Helpers_UpdatePointsSystemMutation, TError, Helpers_UpdatePointsSystemMutationVariables, TContext>(
      ['helpers_updatePointsSystem'],
      (variables?: Helpers_UpdatePointsSystemMutationVariables) => fetcher<Helpers_UpdatePointsSystemMutation, Helpers_UpdatePointsSystemMutationVariables>(Helpers_UpdatePointsSystemDocument, variables)(),
      options
    )};

export const Helpers_LoginDocument = `
    mutation helpers_login($username: String!, $password: String!) {
  login(username: $username, password: $password) {
    token
  }
}
    `;

export const useHelpers_LoginMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_LoginMutation, TError, Helpers_LoginMutationVariables, TContext>) => {
    
    return useMutation<Helpers_LoginMutation, TError, Helpers_LoginMutationVariables, TContext>(
      ['helpers_login'],
      (variables?: Helpers_LoginMutationVariables) => fetcher<Helpers_LoginMutation, Helpers_LoginMutationVariables>(Helpers_LoginDocument, variables)(),
      options
    )};

export const Helpers_RunPlansFilterDocument = `
    query helpers_runPlansFilter($filter: FilterFindManyRunPlanInput) {
  runPlans(filter: $filter) {
    items {
      _id
      trackLayout {
        lapLengthCarData
        lapLengthOfficial
      }
    }
  }
}
    `;

export const useHelpers_RunPlansFilterQuery = <
      TData = Helpers_RunPlansFilterQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: Helpers_RunPlansFilterQueryVariables,
      options?: UseQueryOptions<Helpers_RunPlansFilterQuery, TError, TData>
    ) => {
    
    return useQuery<Helpers_RunPlansFilterQuery, TError, TData>(
      variables === undefined ? ['helpers_runPlansFilter'] : ['helpers_runPlansFilter', variables],
      fetcher<Helpers_RunPlansFilterQuery, Helpers_RunPlansFilterQueryVariables>(Helpers_RunPlansFilterDocument, variables),
      options
    )};

export const Helpers_AddDepartmentDocument = `
    mutation helpers_addDepartment($record: CreateOneDepartmentInput!) {
  addDepartment(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_AddDepartmentMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_AddDepartmentMutation, TError, Helpers_AddDepartmentMutationVariables, TContext>) => {
    
    return useMutation<Helpers_AddDepartmentMutation, TError, Helpers_AddDepartmentMutationVariables, TContext>(
      ['helpers_addDepartment'],
      (variables?: Helpers_AddDepartmentMutationVariables) => fetcher<Helpers_AddDepartmentMutation, Helpers_AddDepartmentMutationVariables>(Helpers_AddDepartmentDocument, variables)(),
      options
    )};

export const Helpers_AddTagDocument = `
    mutation helpers_addTag($record: CreateOneTagInput!) {
  addTag(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_AddTagMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_AddTagMutation, TError, Helpers_AddTagMutationVariables, TContext>) => {
    
    return useMutation<Helpers_AddTagMutation, TError, Helpers_AddTagMutationVariables, TContext>(
      ['helpers_addTag'],
      (variables?: Helpers_AddTagMutationVariables) => fetcher<Helpers_AddTagMutation, Helpers_AddTagMutationVariables>(Helpers_AddTagDocument, variables)(),
      options
    )};

export const Helpers_AddIssueDocument = `
    mutation helpers_addIssue($record: CreateOneIssueInput!) {
  addIssue(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_AddIssueMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_AddIssueMutation, TError, Helpers_AddIssueMutationVariables, TContext>) => {
    
    return useMutation<Helpers_AddIssueMutation, TError, Helpers_AddIssueMutationVariables, TContext>(
      ['helpers_addIssue'],
      (variables?: Helpers_AddIssueMutationVariables) => fetcher<Helpers_AddIssueMutation, Helpers_AddIssueMutationVariables>(Helpers_AddIssueDocument, variables)(),
      options
    )};

export const Helpers_SetupTimingServiceStatusDocument = `
    mutation helpers_setupTimingServiceStatus {
  applyMigration(migration: setupTimingServiceStatus) {
    success
  }
}
    `;

export const useHelpers_SetupTimingServiceStatusMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_SetupTimingServiceStatusMutation, TError, Helpers_SetupTimingServiceStatusMutationVariables, TContext>) => {
    
    return useMutation<Helpers_SetupTimingServiceStatusMutation, TError, Helpers_SetupTimingServiceStatusMutationVariables, TContext>(
      ['helpers_setupTimingServiceStatus'],
      (variables?: Helpers_SetupTimingServiceStatusMutationVariables) => fetcher<Helpers_SetupTimingServiceStatusMutation, Helpers_SetupTimingServiceStatusMutationVariables>(Helpers_SetupTimingServiceStatusDocument, variables)(),
      options
    )};

export const Helpers_ResetTimingServiceStatusDocument = `
    mutation helpers_resetTimingServiceStatus {
  updateMigrations(record: {setupTimingServiceStatus: false}) {
    success
  }
}
    `;

export const useHelpers_ResetTimingServiceStatusMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_ResetTimingServiceStatusMutation, TError, Helpers_ResetTimingServiceStatusMutationVariables, TContext>) => {
    
    return useMutation<Helpers_ResetTimingServiceStatusMutation, TError, Helpers_ResetTimingServiceStatusMutationVariables, TContext>(
      ['helpers_resetTimingServiceStatus'],
      (variables?: Helpers_ResetTimingServiceStatusMutationVariables) => fetcher<Helpers_ResetTimingServiceStatusMutation, Helpers_ResetTimingServiceStatusMutationVariables>(Helpers_ResetTimingServiceStatusDocument, variables)(),
      options
    )};

export const Helpers_AddLapSequenceDocument = `
    mutation helpers_addLapSequence($record: CreateOneLapSequenceInput!) {
  addLapSequence(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_AddLapSequenceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_AddLapSequenceMutation, TError, Helpers_AddLapSequenceMutationVariables, TContext>) => {
    
    return useMutation<Helpers_AddLapSequenceMutation, TError, Helpers_AddLapSequenceMutationVariables, TContext>(
      ['helpers_addLapSequence'],
      (variables?: Helpers_AddLapSequenceMutationVariables) => fetcher<Helpers_AddLapSequenceMutation, Helpers_AddLapSequenceMutationVariables>(Helpers_AddLapSequenceDocument, variables)(),
      options
    )};

export const Helpers_CreateTeamDocument = `
    mutation helpers_createTeam($record: CreateOneTeamInput!) {
  addTeam(record: $record) {
    recordId
  }
}
    `;

export const useHelpers_CreateTeamMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Helpers_CreateTeamMutation, TError, Helpers_CreateTeamMutationVariables, TContext>) => {
    
    return useMutation<Helpers_CreateTeamMutation, TError, Helpers_CreateTeamMutationVariables, TContext>(
      ['helpers_createTeam'],
      (variables?: Helpers_CreateTeamMutationVariables) => fetcher<Helpers_CreateTeamMutation, Helpers_CreateTeamMutationVariables>(Helpers_CreateTeamDocument, variables)(),
      options
    )};

export const FixPartTrackingHistoryDocument = `
    mutation FixPartTrackingHistory($partID: MongoID!) {
  fixPartTrackingHistory(partID: $partID) {
    removedRecords
  }
}
    `;

export const useFixPartTrackingHistoryMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<FixPartTrackingHistoryMutation, TError, FixPartTrackingHistoryMutationVariables, TContext>) => {
    
    return useMutation<FixPartTrackingHistoryMutation, TError, FixPartTrackingHistoryMutationVariables, TContext>(
      ['FixPartTrackingHistory'],
      (variables?: FixPartTrackingHistoryMutationVariables) => fetcher<FixPartTrackingHistoryMutation, FixPartTrackingHistoryMutationVariables>(FixPartTrackingHistoryDocument, variables)(),
      options
    )};

export const SetupAssemblyLinkingDocument = `
    query SetupAssemblyLinking {
  carSetups(perPage: 20000) {
    items {
      _id
      chassisAssembly {
        ... on ChassisAssembly {
          _id
          carSetupID
          reference
          name
        }
      }
      chassisAssemblyID
      runSheet {
        ...RunSheetForAssemblyLinkingVars
      }
      title
    }
  }
}
    ${RunSheetForAssemblyLinkingVarsFragmentDoc}`;

export const useSetupAssemblyLinkingQuery = <
      TData = SetupAssemblyLinkingQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: SetupAssemblyLinkingQueryVariables,
      options?: UseQueryOptions<SetupAssemblyLinkingQuery, TError, TData>
    ) => {
    
    return useQuery<SetupAssemblyLinkingQuery, TError, TData>(
      variables === undefined ? ['SetupAssemblyLinking'] : ['SetupAssemblyLinking', variables],
      fetcher<SetupAssemblyLinkingQuery, SetupAssemblyLinkingQueryVariables>(SetupAssemblyLinkingDocument, variables),
      options
    )};

export const ChassisAssembliesWithTrackingSourceDocument = `
    query ChassisAssembliesWithTrackingSource($page: Int, $perPage: Int) {
  assemblies(page: $page, perPage: $perPage, filter: {type: CHASSIS}) {
    items {
      ... on ChassisAssembly {
        _id
        carSetupID
        chassisSpecID
        name
        reference
        trackingSourceRecords {
          trackingSource {
            name
          }
          trackingSourceID
        }
      }
    }
  }
}
    `;

export const useChassisAssembliesWithTrackingSourceQuery = <
      TData = ChassisAssembliesWithTrackingSourceQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: ChassisAssembliesWithTrackingSourceQueryVariables,
      options?: UseQueryOptions<ChassisAssembliesWithTrackingSourceQuery, TError, TData>
    ) => {
    
    return useQuery<ChassisAssembliesWithTrackingSourceQuery, TError, TData>(
      variables === undefined ? ['ChassisAssembliesWithTrackingSource'] : ['ChassisAssembliesWithTrackingSource', variables],
      fetcher<ChassisAssembliesWithTrackingSourceQuery, ChassisAssembliesWithTrackingSourceQueryVariables>(ChassisAssembliesWithTrackingSourceDocument, variables),
      options
    )};

export const GetSetupSheetMetadataForAssembyReferenceFixDocument = `
    query GetSetupSheetMetadataForAssembyReferenceFix($id: MongoID!) {
  carSetup(_id: $id) {
    _id
    runSheetID
    runSheet {
      contestant {
        startNumber
      }
      NRunTiming
      NRun
      info
      session {
        shortName
        event {
          name
          season {
            name
            raceSeries {
              name
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetSetupSheetMetadataForAssembyReferenceFixQuery = <
      TData = GetSetupSheetMetadataForAssembyReferenceFixQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSetupSheetMetadataForAssembyReferenceFixQueryVariables,
      options?: UseQueryOptions<GetSetupSheetMetadataForAssembyReferenceFixQuery, TError, TData>
    ) => {
    
    return useQuery<GetSetupSheetMetadataForAssembyReferenceFixQuery, TError, TData>(
      ['GetSetupSheetMetadataForAssembyReferenceFix', variables],
      fetcher<GetSetupSheetMetadataForAssembyReferenceFixQuery, GetSetupSheetMetadataForAssembyReferenceFixQueryVariables>(GetSetupSheetMetadataForAssembyReferenceFixDocument, variables),
      options
    )};

export const PartsForDataCheckPageDocument = `
    query PartsForDataCheckPage($page: Int, $perPage: Int) {
  parts(
    page: $page
    perPage: $perPage
    filter: {_operators: {reference: {ne: "_dummyPartORH"}}}
  ) {
    items {
      _id
      reference
      specification {
        trackingItemIDs
      }
      trackingHistory {
        _id
        chassisAssemblyID
        trackingItem {
          name
        }
        trackingItemID
      }
      trackingHistoryIDs
    }
  }
}
    `;

export const usePartsForDataCheckPageQuery = <
      TData = PartsForDataCheckPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: PartsForDataCheckPageQueryVariables,
      options?: UseQueryOptions<PartsForDataCheckPageQuery, TError, TData>
    ) => {
    
    return useQuery<PartsForDataCheckPageQuery, TError, TData>(
      variables === undefined ? ['PartsForDataCheckPage'] : ['PartsForDataCheckPage', variables],
      fetcher<PartsForDataCheckPageQuery, PartsForDataCheckPageQueryVariables>(PartsForDataCheckPageDocument, variables),
      options
    )};

export const GetPartInstancesForDataCheckPageDocument = `
    query GetPartInstancesForDataCheckPage($partID: MongoID, $trackingItemIDs: [MongoID]) {
  partInstances(filter: {partID: $partID}, perPage: 2000) {
    items {
      _id
      parent {
        ... on AnyAssembly {
          createdAt
          name
          reference
          updatedAt
        }
      }
      parentID
      superParentID
    }
  }
  trackingItems(filter: {_operators: {_id: {in: $trackingItemIDs}}}) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetPartInstancesForDataCheckPageQuery = <
      TData = GetPartInstancesForDataCheckPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPartInstancesForDataCheckPageQueryVariables,
      options?: UseQueryOptions<GetPartInstancesForDataCheckPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartInstancesForDataCheckPageQuery, TError, TData>(
      variables === undefined ? ['GetPartInstancesForDataCheckPage'] : ['GetPartInstancesForDataCheckPage', variables],
      fetcher<GetPartInstancesForDataCheckPageQuery, GetPartInstancesForDataCheckPageQueryVariables>(GetPartInstancesForDataCheckPageDocument, variables),
      options
    )};

export const FixPartInstancesDocument = `
    mutation FixPartInstances($partIDs: [MongoID!]!) {
  fixPartInstancesResolver(partIDs: $partIDs) {
    success
  }
}
    `;

export const useFixPartInstancesMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<FixPartInstancesMutation, TError, FixPartInstancesMutationVariables, TContext>) => {
    
    return useMutation<FixPartInstancesMutation, TError, FixPartInstancesMutationVariables, TContext>(
      ['FixPartInstances'],
      (variables?: FixPartInstancesMutationVariables) => fetcher<FixPartInstancesMutation, FixPartInstancesMutationVariables>(FixPartInstancesDocument, variables)(),
      options
    )};

export const GetAllTrackingHistoryEntriesForDataCheckPageDocument = `
    query GetAllTrackingHistoryEntriesForDataCheckPage {
  trackingRecords(perPage: 20000) {
    items {
      _id
    }
  }
}
    `;

export const useGetAllTrackingHistoryEntriesForDataCheckPageQuery = <
      TData = GetAllTrackingHistoryEntriesForDataCheckPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllTrackingHistoryEntriesForDataCheckPageQueryVariables,
      options?: UseQueryOptions<GetAllTrackingHistoryEntriesForDataCheckPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllTrackingHistoryEntriesForDataCheckPageQuery, TError, TData>(
      variables === undefined ? ['GetAllTrackingHistoryEntriesForDataCheckPage'] : ['GetAllTrackingHistoryEntriesForDataCheckPage', variables],
      fetcher<GetAllTrackingHistoryEntriesForDataCheckPageQuery, GetAllTrackingHistoryEntriesForDataCheckPageQueryVariables>(GetAllTrackingHistoryEntriesForDataCheckPageDocument, variables),
      options
    )};

export const GetInconsitentChassisAssembliesForDataCheckPageDocument = `
    query GetInconsitentChassisAssembliesForDataCheckPage {
  assemblies(perPage: 2000, filter: {type: CHASSIS}) {
    items {
      ... on ChassisAssembly {
        ...ChassisAssemblyForDataCheckPageVars
      }
    }
  }
}
    ${ChassisAssemblyForDataCheckPageVarsFragmentDoc}`;

export const useGetInconsitentChassisAssembliesForDataCheckPageQuery = <
      TData = GetInconsitentChassisAssembliesForDataCheckPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetInconsitentChassisAssembliesForDataCheckPageQueryVariables,
      options?: UseQueryOptions<GetInconsitentChassisAssembliesForDataCheckPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetInconsitentChassisAssembliesForDataCheckPageQuery, TError, TData>(
      variables === undefined ? ['GetInconsitentChassisAssembliesForDataCheckPage'] : ['GetInconsitentChassisAssembliesForDataCheckPage', variables],
      fetcher<GetInconsitentChassisAssembliesForDataCheckPageQuery, GetInconsitentChassisAssembliesForDataCheckPageQueryVariables>(GetInconsitentChassisAssembliesForDataCheckPageDocument, variables),
      options
    )};

export const GetInconsitentCarSetupsForDataCheckPageDocument = `
    query GetInconsitentCarSetupsForDataCheckPage {
  carSetups(perPage: 20000) {
    items {
      _id
      runSheet {
        _id
        contestant {
          startNumber
        }
        NRun
        NRunTiming
        setupID
        session {
          shortName
          name
          event {
            name
            season {
              name
              raceSeries {
                name
              }
            }
          }
        }
      }
      runSheetID
      title
    }
  }
}
    `;

export const useGetInconsitentCarSetupsForDataCheckPageQuery = <
      TData = GetInconsitentCarSetupsForDataCheckPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetInconsitentCarSetupsForDataCheckPageQueryVariables,
      options?: UseQueryOptions<GetInconsitentCarSetupsForDataCheckPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetInconsitentCarSetupsForDataCheckPageQuery, TError, TData>(
      variables === undefined ? ['GetInconsitentCarSetupsForDataCheckPage'] : ['GetInconsitentCarSetupsForDataCheckPage', variables],
      fetcher<GetInconsitentCarSetupsForDataCheckPageQuery, GetInconsitentCarSetupsForDataCheckPageQueryVariables>(GetInconsitentCarSetupsForDataCheckPageDocument, variables),
      options
    )};

export const GetAllTeamsForImportIssueDocument = `
    query GetAllTeamsForImportIssue {
  teams(perPage: 20000) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetAllTeamsForImportIssueQuery = <
      TData = GetAllTeamsForImportIssueQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllTeamsForImportIssueQueryVariables,
      options?: UseQueryOptions<GetAllTeamsForImportIssueQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllTeamsForImportIssueQuery, TError, TData>(
      variables === undefined ? ['GetAllTeamsForImportIssue'] : ['GetAllTeamsForImportIssue', variables],
      fetcher<GetAllTeamsForImportIssueQuery, GetAllTeamsForImportIssueQueryVariables>(GetAllTeamsForImportIssueDocument, variables),
      options
    )};

export const GetIssuesForIssueManagerPageDocument = `
    query GetIssuesForIssueManagerPage($filter: FilterFindManyIssueQueryInput!, $perPage: Int!, $page: Int, $sort: SortFindManyIssueQueryInput) {
  issues(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ...IssuesForIssueManagerPageVars
    }
  }
}
    ${IssuesForIssueManagerPageVarsFragmentDoc}`;

export const useGetIssuesForIssueManagerPageQuery = <
      TData = GetIssuesForIssueManagerPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetIssuesForIssueManagerPageQueryVariables,
      options?: UseQueryOptions<GetIssuesForIssueManagerPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetIssuesForIssueManagerPageQuery, TError, TData>(
      ['GetIssuesForIssueManagerPage', variables],
      fetcher<GetIssuesForIssueManagerPageQuery, GetIssuesForIssueManagerPageQueryVariables>(GetIssuesForIssueManagerPageDocument, variables),
      options
    )};

export const GetIssueByIdDocument = `
    query GetIssueByID($id: MongoID!) {
  issue(_id: $id) {
    _id
    carSetupID
    assigneeIDs
    area
    category
    closedAt
    closedByID
    comments {
      text
      createdAt
      updatedAt
      authorID
      _id
      author {
        name
      }
      files {
        id
        name
        mimeType
        url
        thumbnailUrl
      }
    }
    containment
    contestantIDs
    createdAt
    createdByID
    description
    descriptionDetails
    departmentID
    eventID
    linkedIssueIDs
    number
    issueStatus
    partID
    priority
    raceSeriesID
    rootCause
    runSheetID
    seasonID
    sessionID
    subTaskIDs
    subTasks {
      ...JobVars
    }
    targetDate
    tagIDs
    teamIDs
    thirdPartyIssueID
    timeInfo
  }
}
    ${JobVarsFragmentDoc}
${CommentVarsFragmentDoc}
${SubTaskVarsFragmentDoc}`;

export const useGetIssueByIdQuery = <
      TData = GetIssueByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetIssueByIdQueryVariables,
      options?: UseQueryOptions<GetIssueByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetIssueByIdQuery, TError, TData>(
      ['GetIssueByID', variables],
      fetcher<GetIssueByIdQuery, GetIssueByIdQueryVariables>(GetIssueByIdDocument, variables),
      options
    )};

export const GetIssueForIssuePopupDocument = `
    query GetIssueForIssuePopup($id: MongoID!) {
  issue(_id: $id) {
    _id
    containment
    description
    number
    rootCause
    runSheet {
      info
      setup {
        chassis {
          reference
        }
      }
    }
  }
}
    `;

export const useGetIssueForIssuePopupQuery = <
      TData = GetIssueForIssuePopupQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetIssueForIssuePopupQueryVariables,
      options?: UseQueryOptions<GetIssueForIssuePopupQuery, TError, TData>
    ) => {
    
    return useQuery<GetIssueForIssuePopupQuery, TError, TData>(
      ['GetIssueForIssuePopup', variables],
      fetcher<GetIssueForIssuePopupQuery, GetIssueForIssuePopupQueryVariables>(GetIssueForIssuePopupDocument, variables),
      options
    )};

export const GetFilterInfosForIssueManagerPageDocument = `
    query GetFilterInfosForIssueManagerPage {
  raceSeriesAll(perPage: 200) {
    items {
      _id
      name
      seasons {
        _id
        name
        events {
          _id
          name
          sessions {
            _id
            shortName
          }
        }
      }
    }
  }
  people(perPage: 2000) {
    items {
      _id
      name
    }
  }
  carSetups(perPage: 2000) {
    items {
      _id
      title
    }
  }
  tags(perPage: 2000) {
    items {
      _id
      label
    }
  }
  chassisSpecifications: specifications(filter: {type: CHASSIS}, perPage: 2000) {
    items {
      ... on ChassisSpec {
        _id
        name
        version
      }
    }
  }
  customSpecifications: specifications(filter: {type: CUSTOM}, perPage: 2000) {
    items {
      ... on CustomSpec {
        _id
        chassisSpecID
        name
      }
    }
  }
}
    `;

export const useGetFilterInfosForIssueManagerPageQuery = <
      TData = GetFilterInfosForIssueManagerPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetFilterInfosForIssueManagerPageQueryVariables,
      options?: UseQueryOptions<GetFilterInfosForIssueManagerPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetFilterInfosForIssueManagerPageQuery, TError, TData>(
      variables === undefined ? ['GetFilterInfosForIssueManagerPage'] : ['GetFilterInfosForIssueManagerPage', variables],
      fetcher<GetFilterInfosForIssueManagerPageQuery, GetFilterInfosForIssueManagerPageQueryVariables>(GetFilterInfosForIssueManagerPageDocument, variables),
      options
    )};

export const GetPartsFilteredBySpecificationsDocument = `
    query GetPartsFilteredBySpecifications($specificationIDs: [MongoID!]) {
  parts(
    filter: {OR: [{_operators: {specificationID: {in: $specificationIDs}}}, {_operators: {rootSpecificationID: {in: $specificationIDs}}}]}
    perPage: 2000
  ) {
    items {
      _id
      reference
    }
  }
}
    `;

export const useGetPartsFilteredBySpecificationsQuery = <
      TData = GetPartsFilteredBySpecificationsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPartsFilteredBySpecificationsQueryVariables,
      options?: UseQueryOptions<GetPartsFilteredBySpecificationsQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartsFilteredBySpecificationsQuery, TError, TData>(
      variables === undefined ? ['GetPartsFilteredBySpecifications'] : ['GetPartsFilteredBySpecifications', variables],
      fetcher<GetPartsFilteredBySpecificationsQuery, GetPartsFilteredBySpecificationsQueryVariables>(GetPartsFilteredBySpecificationsDocument, variables),
      options
    )};

export const GetAllInfoForIssueCreateAndEditPageDocument = `
    query getAllInfoForIssueCreateAndEditPage {
  raceSeriesAll(perPage: 2000000) {
    items {
      _id
      name
      seasons {
        _id
        contestants {
          _id
          startNumber
        }
        name
        events {
          _id
          name
          tEventStart
          sessions {
            _id
            shortName
            name
          }
        }
      }
    }
  }
  teams(perPage: 20000) {
    items {
      _id
      name
    }
  }
  carSetups(perPage: 20000) {
    items {
      _id
      title
    }
  }
}
    `;

export const useGetAllInfoForIssueCreateAndEditPageQuery = <
      TData = GetAllInfoForIssueCreateAndEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllInfoForIssueCreateAndEditPageQueryVariables,
      options?: UseQueryOptions<GetAllInfoForIssueCreateAndEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllInfoForIssueCreateAndEditPageQuery, TError, TData>(
      variables === undefined ? ['getAllInfoForIssueCreateAndEditPage'] : ['getAllInfoForIssueCreateAndEditPage', variables],
      fetcher<GetAllInfoForIssueCreateAndEditPageQuery, GetAllInfoForIssueCreateAndEditPageQueryVariables>(GetAllInfoForIssueCreateAndEditPageDocument, variables),
      options
    )};

export const GetPartInfoForIssueManagerDocument = `
    query GetPartInfoForIssueManager($id: MongoID!) {
  part(_id: $id) {
    specification {
      name
      type
    }
    userEnumPartTypeID
    userEnumPartType {
      _id
      name
      type
    }
    manufacturerSerialNumber
    lifetimeMileage
    partNumber
    reference
  }
}
    `;

export const useGetPartInfoForIssueManagerQuery = <
      TData = GetPartInfoForIssueManagerQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartInfoForIssueManagerQueryVariables,
      options?: UseQueryOptions<GetPartInfoForIssueManagerQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartInfoForIssueManagerQuery, TError, TData>(
      ['GetPartInfoForIssueManager', variables],
      fetcher<GetPartInfoForIssueManagerQuery, GetPartInfoForIssueManagerQueryVariables>(GetPartInfoForIssueManagerDocument, variables),
      options
    )};

export const GetRunSheetInfoForIssueManagerPageDocument = `
    query GetRunSheetInfoForIssueManagerPage($filter: FilterFindManyRunSheetInput) {
  runSheets(filter: $filter) {
    items {
      driver {
        name
      }
      chassisAssembly {
        name
        chassisSpecID
      }
      session {
        name
        shortName
      }
      NRun
      _id
      contestant {
        startNumber
      }
    }
  }
}
    `;

export const useGetRunSheetInfoForIssueManagerPageQuery = <
      TData = GetRunSheetInfoForIssueManagerPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRunSheetInfoForIssueManagerPageQueryVariables,
      options?: UseQueryOptions<GetRunSheetInfoForIssueManagerPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetInfoForIssueManagerPageQuery, TError, TData>(
      variables === undefined ? ['GetRunSheetInfoForIssueManagerPage'] : ['GetRunSheetInfoForIssueManagerPage', variables],
      fetcher<GetRunSheetInfoForIssueManagerPageQuery, GetRunSheetInfoForIssueManagerPageQueryVariables>(GetRunSheetInfoForIssueManagerPageDocument, variables),
      options
    )};

export const GetRunSheetByIdForIssueManagerDocument = `
    query GetRunSheetByIDForIssueManager($id: MongoID!) {
  runSheet(_id: $id) {
    driver {
      name
    }
    engineer {
      name
    }
    chassisAssembly {
      name
    }
    info
    session {
      name
      shortName
    }
    NRun
    _id
    contestant {
      startNumber
    }
    setup {
      title
      engineer {
        name
      }
      chassis {
        reference
      }
      chassisSpec {
        name
      }
    }
    driverComments
    engineerComments
    problemComments
  }
}
    `;

export const useGetRunSheetByIdForIssueManagerQuery = <
      TData = GetRunSheetByIdForIssueManagerQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetByIdForIssueManagerQueryVariables,
      options?: UseQueryOptions<GetRunSheetByIdForIssueManagerQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetByIdForIssueManagerQuery, TError, TData>(
      ['GetRunSheetByIDForIssueManager', variables],
      fetcher<GetRunSheetByIdForIssueManagerQuery, GetRunSheetByIdForIssueManagerQueryVariables>(GetRunSheetByIdForIssueManagerDocument, variables),
      options
    )};

export const GetRunSheetChassisSpecIdDocument = `
    query GetRunSheetChassisSpecID($id: MongoID!) {
  runSheet(_id: $id) {
    setup {
      _id
      chassisSpecID
    }
  }
}
    `;

export const useGetRunSheetChassisSpecIdQuery = <
      TData = GetRunSheetChassisSpecIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetChassisSpecIdQueryVariables,
      options?: UseQueryOptions<GetRunSheetChassisSpecIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetChassisSpecIdQuery, TError, TData>(
      ['GetRunSheetChassisSpecID', variables],
      fetcher<GetRunSheetChassisSpecIdQuery, GetRunSheetChassisSpecIdQueryVariables>(GetRunSheetChassisSpecIdDocument, variables),
      options
    )};

export const AddIssueCommentDocument = `
    mutation AddIssueComment($target: EnumJobTarget!, $subjectID: MongoID!, $text: String!) {
  addComment(target: $target, subjectID: $subjectID, text: $text) {
    comment {
      _id
    }
  }
}
    `;

export const useAddIssueCommentMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddIssueCommentMutation, TError, AddIssueCommentMutationVariables, TContext>) => {
    
    return useMutation<AddIssueCommentMutation, TError, AddIssueCommentMutationVariables, TContext>(
      ['AddIssueComment'],
      (variables?: AddIssueCommentMutationVariables) => fetcher<AddIssueCommentMutation, AddIssueCommentMutationVariables>(AddIssueCommentDocument, variables)(),
      options
    )};

export const RemoveIssueCommentDocument = `
    mutation RemoveIssueComment($commentId: MongoID!, $subjectId: MongoID!) {
  removeComment(commentID: $commentId, target: ISSUE, subjectID: $subjectId) {
    comment {
      _id
    }
  }
}
    `;

export const useRemoveIssueCommentMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveIssueCommentMutation, TError, RemoveIssueCommentMutationVariables, TContext>) => {
    
    return useMutation<RemoveIssueCommentMutation, TError, RemoveIssueCommentMutationVariables, TContext>(
      ['RemoveIssueComment'],
      (variables?: RemoveIssueCommentMutationVariables) => fetcher<RemoveIssueCommentMutation, RemoveIssueCommentMutationVariables>(RemoveIssueCommentDocument, variables)(),
      options
    )};

export const GetTagsForIssuePageDocument = `
    query GetTagsForIssuePage {
  tags(filter: {tagType: ISSUE}) {
    items {
      group
      _id
      label
      tagType
    }
  }
}
    `;

export const useGetTagsForIssuePageQuery = <
      TData = GetTagsForIssuePageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTagsForIssuePageQueryVariables,
      options?: UseQueryOptions<GetTagsForIssuePageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTagsForIssuePageQuery, TError, TData>(
      variables === undefined ? ['GetTagsForIssuePage'] : ['GetTagsForIssuePage', variables],
      fetcher<GetTagsForIssuePageQuery, GetTagsForIssuePageQueryVariables>(GetTagsForIssuePageDocument, variables),
      options
    )};

export const GetUserEnumsForPartTypeDocument = `
    query GetUserEnumsForPartType {
  userEnums(
    filter: {OR: [{type: USER_ENUM_PART_STATUS}, {type: USER_ENUM_PART_TYPE}]}
  ) {
    items {
      ... on UserEnumPartType {
        _id
        name
        __typename
      }
      ... on UserEnumPartStatus {
        _id
        active
        name
        __typename
      }
    }
  }
}
    `;

export const useGetUserEnumsForPartTypeQuery = <
      TData = GetUserEnumsForPartTypeQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetUserEnumsForPartTypeQueryVariables,
      options?: UseQueryOptions<GetUserEnumsForPartTypeQuery, TError, TData>
    ) => {
    
    return useQuery<GetUserEnumsForPartTypeQuery, TError, TData>(
      variables === undefined ? ['GetUserEnumsForPartType'] : ['GetUserEnumsForPartType', variables],
      fetcher<GetUserEnumsForPartTypeQuery, GetUserEnumsForPartTypeQueryVariables>(GetUserEnumsForPartTypeDocument, variables),
      options
    )};

export const AddTagDocument = `
    mutation AddTag($record: CreateOneTagInput!) {
  addTag(record: $record) {
    recordId
  }
}
    `;

export const useAddTagMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTagMutation, TError, AddTagMutationVariables, TContext>) => {
    
    return useMutation<AddTagMutation, TError, AddTagMutationVariables, TContext>(
      ['AddTag'],
      (variables?: AddTagMutationVariables) => fetcher<AddTagMutation, AddTagMutationVariables>(AddTagDocument, variables)(),
      options
    )};

export const GenerateIssueNumberDocument = `
    query GenerateIssueNumber($raceSeriesId: MongoID, $seasonId: MongoID) {
  generateIssueNumber(raceSeriesID: $raceSeriesId, seasonID: $seasonId) {
    number
  }
}
    `;

export const useGenerateIssueNumberQuery = <
      TData = GenerateIssueNumberQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GenerateIssueNumberQueryVariables,
      options?: UseQueryOptions<GenerateIssueNumberQuery, TError, TData>
    ) => {
    
    return useQuery<GenerateIssueNumberQuery, TError, TData>(
      variables === undefined ? ['GenerateIssueNumber'] : ['GenerateIssueNumber', variables],
      fetcher<GenerateIssueNumberQuery, GenerateIssueNumberQueryVariables>(GenerateIssueNumberDocument, variables),
      options
    )};

export const GetTeamListForIssueManagerFilterDocument = `
    query GetTeamListForIssueManagerFilter {
  teams(perPage: 20000) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetTeamListForIssueManagerFilterQuery = <
      TData = GetTeamListForIssueManagerFilterQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTeamListForIssueManagerFilterQueryVariables,
      options?: UseQueryOptions<GetTeamListForIssueManagerFilterQuery, TError, TData>
    ) => {
    
    return useQuery<GetTeamListForIssueManagerFilterQuery, TError, TData>(
      variables === undefined ? ['GetTeamListForIssueManagerFilter'] : ['GetTeamListForIssueManagerFilter', variables],
      fetcher<GetTeamListForIssueManagerFilterQuery, GetTeamListForIssueManagerFilterQueryVariables>(GetTeamListForIssueManagerFilterDocument, variables),
      options
    )};

export const GetPersonListForIssueManagerFilterDocument = `
    query GetPersonListForIssueManagerFilter {
  people(perPage: 20000) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetPersonListForIssueManagerFilterQuery = <
      TData = GetPersonListForIssueManagerFilterQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPersonListForIssueManagerFilterQueryVariables,
      options?: UseQueryOptions<GetPersonListForIssueManagerFilterQuery, TError, TData>
    ) => {
    
    return useQuery<GetPersonListForIssueManagerFilterQuery, TError, TData>(
      variables === undefined ? ['GetPersonListForIssueManagerFilter'] : ['GetPersonListForIssueManagerFilter', variables],
      fetcher<GetPersonListForIssueManagerFilterQuery, GetPersonListForIssueManagerFilterQueryVariables>(GetPersonListForIssueManagerFilterDocument, variables),
      options
    )};

export const GetAllJobsForAllJobsPageDocument = `
    query GetAllJobsForAllJobsPage($filter: FilterFindManyJobInput, $sort: SortFindManyJobInput) {
  jobs(perPage: 20000, filter: $filter, sort: $sort) {
    count
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      pageCount
    }
    items {
      ...JobForAllJobsPageVars
    }
  }
}
    ${JobForAllJobsPageVarsFragmentDoc}
${SubTaskVarsFragmentDoc}
${CommentVarsFragmentDoc}`;

export const useGetAllJobsForAllJobsPageQuery = <
      TData = GetAllJobsForAllJobsPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllJobsForAllJobsPageQueryVariables,
      options?: UseQueryOptions<GetAllJobsForAllJobsPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllJobsForAllJobsPageQuery, TError, TData>(
      variables === undefined ? ['GetAllJobsForAllJobsPage'] : ['GetAllJobsForAllJobsPage', variables],
      fetcher<GetAllJobsForAllJobsPageQuery, GetAllJobsForAllJobsPageQueryVariables>(GetAllJobsForAllJobsPageDocument, variables),
      options
    )};

export const GetFilterInfosForAllJobsPageDocument = `
    query GetFilterInfosForAllJobsPage {
  raceSeriesAll(perPage: 200) {
    items {
      _id
      name
      seasons {
        _id
        contestants {
          _id
          startNumber
        }
        name
        events {
          _id
          name
          sessions {
            _id
            shortName
            name
          }
          tEventStart
        }
      }
    }
  }
}
    `;

export const useGetFilterInfosForAllJobsPageQuery = <
      TData = GetFilterInfosForAllJobsPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetFilterInfosForAllJobsPageQueryVariables,
      options?: UseQueryOptions<GetFilterInfosForAllJobsPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetFilterInfosForAllJobsPageQuery, TError, TData>(
      variables === undefined ? ['GetFilterInfosForAllJobsPage'] : ['GetFilterInfosForAllJobsPage', variables],
      fetcher<GetFilterInfosForAllJobsPageQuery, GetFilterInfosForAllJobsPageQueryVariables>(GetFilterInfosForAllJobsPageDocument, variables),
      options
    )};

export const GetRunSheetIDsForAllJobsPageDocument = `
    query GetRunSheetIDsForAllJobsPage($filter: FilterFindManyRunSheetInput) {
  runSheets(filter: $filter, perPage: 1000000000) {
    items {
      _id
    }
  }
}
    `;

export const useGetRunSheetIDsForAllJobsPageQuery = <
      TData = GetRunSheetIDsForAllJobsPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRunSheetIDsForAllJobsPageQueryVariables,
      options?: UseQueryOptions<GetRunSheetIDsForAllJobsPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetIDsForAllJobsPageQuery, TError, TData>(
      variables === undefined ? ['GetRunSheetIDsForAllJobsPage'] : ['GetRunSheetIDsForAllJobsPage', variables],
      fetcher<GetRunSheetIDsForAllJobsPageQuery, GetRunSheetIDsForAllJobsPageQueryVariables>(GetRunSheetIDsForAllJobsPageDocument, variables),
      options
    )};

export const GetIssueJobParentIDsForIssueFilterDocument = `
    query GetIssueJobParentIDsForIssueFilter($filter: FilterFindManyJobInput) {
  jobs(filter: $filter) {
    items {
      _id
      parentID
    }
  }
}
    `;

export const useGetIssueJobParentIDsForIssueFilterQuery = <
      TData = GetIssueJobParentIDsForIssueFilterQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetIssueJobParentIDsForIssueFilterQueryVariables,
      options?: UseQueryOptions<GetIssueJobParentIDsForIssueFilterQuery, TError, TData>
    ) => {
    
    return useQuery<GetIssueJobParentIDsForIssueFilterQuery, TError, TData>(
      variables === undefined ? ['GetIssueJobParentIDsForIssueFilter'] : ['GetIssueJobParentIDsForIssueFilter', variables],
      fetcher<GetIssueJobParentIDsForIssueFilterQuery, GetIssueJobParentIDsForIssueFilterQueryVariables>(GetIssueJobParentIDsForIssueFilterDocument, variables),
      options
    )};

export const GetIssuesForFilterDocument = `
    query GetIssuesForFilter($filter: FilterFindManyIssueQueryInput) {
  issues(filter: $filter) {
    items {
      _id
      description
      number
    }
  }
}
    `;

export const useGetIssuesForFilterQuery = <
      TData = GetIssuesForFilterQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetIssuesForFilterQueryVariables,
      options?: UseQueryOptions<GetIssuesForFilterQuery, TError, TData>
    ) => {
    
    return useQuery<GetIssuesForFilterQuery, TError, TData>(
      variables === undefined ? ['GetIssuesForFilter'] : ['GetIssuesForFilter', variables],
      fetcher<GetIssuesForFilterQuery, GetIssuesForFilterQueryVariables>(GetIssuesForFilterDocument, variables),
      options
    )};

export const GetPartInstanceByIdDocument = `
    query GetPartInstanceById($id: MongoID!) {
  partInstance(_id: $id) {
    _id
    superParentID
    parentID
    parent {
      ... on AnyAssembly {
        name
      }
    }
    partID
    measurements {
      booleanValue
      coordinates {
        x
        y
        z
      }
      idx
      rotation {
        I
        J
        K
      }
      stringValue
      value
    }
    specificationID
    specification {
      ... on CustomSpec {
        _id
        __typename
        updatedAt
        createdAt
        name
        decommissioned
        prevIterationID
        nextIterationID
        iterationIDs
        allowableParentSpecIDs
        chassisSpecID
        initialChassisSpecID
        description
        allowableSockets
        readingsRequired
        manufacturerID
        manufacturer {
          _id
          name
        }
        adjustableProperties {
          ...AdjustableAccelerationPropertyVars
          ...AdjustableAnglePropertyVars
          ...AdjustableAngularCompliancePropertyVars
          ...AdjustableAngularTorqueCompliancePropertyVars
          ...AdjustableBooleanPropertyVars
          ...AdjustableCompliancePropertyVars
          ...AdjustableForcePropertyVars
          ...AdjustableInertiaPropertyVars
          ...AdjustableLengthPropertyVars
          ...AdjustableLocationPropertyVars
          ...AdjustableMassPropertyVars
          ...AdjustableNumberPropertyVars
          ...AdjustableOrientationPropertyVars
          ...AdjustablePowerPropertyVars
          ...AdjustablePressurePropertyVars
          ...AdjustableRatioPropertyVars
          ...AdjustableSpringRatePropertyVars
          ...AdjustableSteeringRackRatioPropertyVars
          ...AdjustableStringPropertyVars
          ...AdjustableTemperaturePropertyVars
          ...AdjustableTorquePropertyVars
          ...AdjustableTorsionRatePropertyVars
          ...AdjustableVolumePropertyVars
        }
        massProperties {
          ...MassPropertiesVars
        }
      }
    }
  }
}
    ${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${MassPropertiesVarsFragmentDoc}`;

export const useGetPartInstanceByIdQuery = <
      TData = GetPartInstanceByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartInstanceByIdQueryVariables,
      options?: UseQueryOptions<GetPartInstanceByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartInstanceByIdQuery, TError, TData>(
      ['GetPartInstanceById', variables],
      fetcher<GetPartInstanceByIdQuery, GetPartInstanceByIdQueryVariables>(GetPartInstanceByIdDocument, variables),
      options
    )};

export const GetTrackingSourceRecordsOnSuperParentForPartInstancePageDocument = `
    query GetTrackingSourceRecordsOnSuperParentForPartInstancePage($assemblyID: MongoID!) {
  assembly(_id: $assemblyID) {
    ... on ChassisAssembly {
      _id
      chassisSpecID
      name
      trackingSourceRecords {
        trackingSourceID
        value
        trackingSource {
          _id
          chassisSpecID
          isDefault
          name
          sourceIDs
          sources {
            _id
            aliasString
            aliasType
            displayUnit
          }
        }
        sources {
          trackingSourceAliasID
          value
        }
      }
    }
  }
}
    `;

export const useGetTrackingSourceRecordsOnSuperParentForPartInstancePageQuery = <
      TData = GetTrackingSourceRecordsOnSuperParentForPartInstancePageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackingSourceRecordsOnSuperParentForPartInstancePageQueryVariables,
      options?: UseQueryOptions<GetTrackingSourceRecordsOnSuperParentForPartInstancePageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingSourceRecordsOnSuperParentForPartInstancePageQuery, TError, TData>(
      ['GetTrackingSourceRecordsOnSuperParentForPartInstancePage', variables],
      fetcher<GetTrackingSourceRecordsOnSuperParentForPartInstancePageQuery, GetTrackingSourceRecordsOnSuperParentForPartInstancePageQueryVariables>(GetTrackingSourceRecordsOnSuperParentForPartInstancePageDocument, variables),
      options
    )};

export const GetTrackingSourcesOnChassisSpecForPartInstancePageDocument = `
    query GetTrackingSourcesOnChassisSpecForPartInstancePage($chassisSpecID: MongoID!) {
  specification(_id: $chassisSpecID) {
    ... on ChassisSpec {
      name
      trackingSourceIDs
      trackingSources {
        _id
        name
      }
    }
  }
}
    `;

export const useGetTrackingSourcesOnChassisSpecForPartInstancePageQuery = <
      TData = GetTrackingSourcesOnChassisSpecForPartInstancePageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackingSourcesOnChassisSpecForPartInstancePageQueryVariables,
      options?: UseQueryOptions<GetTrackingSourcesOnChassisSpecForPartInstancePageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingSourcesOnChassisSpecForPartInstancePageQuery, TError, TData>(
      ['GetTrackingSourcesOnChassisSpecForPartInstancePage', variables],
      fetcher<GetTrackingSourcesOnChassisSpecForPartInstancePageQuery, GetTrackingSourcesOnChassisSpecForPartInstancePageQueryVariables>(GetTrackingSourcesOnChassisSpecForPartInstancePageDocument, variables),
      options
    )};

export const GetPartInstanceParentByIdForPartInstancePageDocument = `
    query GetPartInstanceParentByIdForPartInstancePage($id: MongoID!) {
  assembly(_id: $id) {
    ... on AnyAssembly {
      _id
    }
  }
}
    `;

export const useGetPartInstanceParentByIdForPartInstancePageQuery = <
      TData = GetPartInstanceParentByIdForPartInstancePageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartInstanceParentByIdForPartInstancePageQueryVariables,
      options?: UseQueryOptions<GetPartInstanceParentByIdForPartInstancePageQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartInstanceParentByIdForPartInstancePageQuery, TError, TData>(
      ['GetPartInstanceParentByIdForPartInstancePage', variables],
      fetcher<GetPartInstanceParentByIdForPartInstancePageQuery, GetPartInstanceParentByIdForPartInstancePageQueryVariables>(GetPartInstanceParentByIdForPartInstancePageDocument, variables),
      options
    )};

export const GetTrackingRecordsForPartDocument = `
    query GetTrackingRecordsForPart($chassisAssemblyID: MongoID!, $partID: MongoID!) {
  trackingRecords(
    filter: {chassisAssemblyID: $chassisAssemblyID, partID: $partID}
  ) {
    items {
      _id
      date
      createdAt
      value
      type
      partID
      chassisAssemblyID
      notes
      cumulativeValue
      trackingItemID
    }
  }
}
    `;

export const useGetTrackingRecordsForPartQuery = <
      TData = GetTrackingRecordsForPartQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackingRecordsForPartQueryVariables,
      options?: UseQueryOptions<GetTrackingRecordsForPartQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingRecordsForPartQuery, TError, TData>(
      ['GetTrackingRecordsForPart', variables],
      fetcher<GetTrackingRecordsForPartQuery, GetTrackingRecordsForPartQueryVariables>(GetTrackingRecordsForPartDocument, variables),
      options
    )};

export const GetChassisSpecsForPartDetailFieldsDocument = `
    query GetChassisSpecsForPartDetailFields {
  specifications(perPage: 20000, filter: {type: CHASSIS}) {
    items {
      ... on ChassisSpec {
        _id
        name
        rootSpecificationID
        prevIterationID
        version
      }
    }
  }
}
    `;

export const useGetChassisSpecsForPartDetailFieldsQuery = <
      TData = GetChassisSpecsForPartDetailFieldsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetChassisSpecsForPartDetailFieldsQueryVariables,
      options?: UseQueryOptions<GetChassisSpecsForPartDetailFieldsQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecsForPartDetailFieldsQuery, TError, TData>(
      variables === undefined ? ['GetChassisSpecsForPartDetailFields'] : ['GetChassisSpecsForPartDetailFields', variables],
      fetcher<GetChassisSpecsForPartDetailFieldsQuery, GetChassisSpecsForPartDetailFieldsQueryVariables>(GetChassisSpecsForPartDetailFieldsDocument, variables),
      options
    )};

export const GetPartSpecsForChassisSpecForPartDetailFieldsDocument = `
    query GetPartSpecsForChassisSpecForPartDetailFields($chassisSpecID: MongoID!) {
  specifications(perPage: 20000, filter: {chassisSpecID: $chassisSpecID}) {
    items {
      ... on AnySpecification {
        __typename
        _id
        name
      }
    }
  }
}
    `;

export const useGetPartSpecsForChassisSpecForPartDetailFieldsQuery = <
      TData = GetPartSpecsForChassisSpecForPartDetailFieldsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartSpecsForChassisSpecForPartDetailFieldsQueryVariables,
      options?: UseQueryOptions<GetPartSpecsForChassisSpecForPartDetailFieldsQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartSpecsForChassisSpecForPartDetailFieldsQuery, TError, TData>(
      ['GetPartSpecsForChassisSpecForPartDetailFields', variables],
      fetcher<GetPartSpecsForChassisSpecForPartDetailFieldsQuery, GetPartSpecsForChassisSpecForPartDetailFieldsQueryVariables>(GetPartSpecsForChassisSpecForPartDetailFieldsDocument, variables),
      options
    )};

export const GetChassisSpecForPartSpecInfoFieldDocument = `
    query GetChassisSpecForPartSpecInfoField($chassisSpecID: MongoID!) {
  specification(_id: $chassisSpecID) {
    ... on ChassisSpec {
      _id
      name
      version
    }
  }
}
    `;

export const useGetChassisSpecForPartSpecInfoFieldQuery = <
      TData = GetChassisSpecForPartSpecInfoFieldQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpecForPartSpecInfoFieldQueryVariables,
      options?: UseQueryOptions<GetChassisSpecForPartSpecInfoFieldQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecForPartSpecInfoFieldQuery, TError, TData>(
      ['GetChassisSpecForPartSpecInfoField', variables],
      fetcher<GetChassisSpecForPartSpecInfoFieldQuery, GetChassisSpecForPartSpecInfoFieldQueryVariables>(GetChassisSpecForPartSpecInfoFieldDocument, variables),
      options
    )};

export const PartEditSpecificationDocument = `
    query PartEditSpecification($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      name
      version
    }
  }
}
    `;

export const usePartEditSpecificationQuery = <
      TData = PartEditSpecificationQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: PartEditSpecificationQueryVariables,
      options?: UseQueryOptions<PartEditSpecificationQuery, TError, TData>
    ) => {
    
    return useQuery<PartEditSpecificationQuery, TError, TData>(
      ['PartEditSpecification', variables],
      fetcher<PartEditSpecificationQuery, PartEditSpecificationQueryVariables>(PartEditSpecificationDocument, variables),
      options
    )};

export const GetLifetimeMileageForPartDocument = `
    query GetLifetimeMileageForPart($id: MongoID!) {
  part(_id: $id) {
    lifetimeMileage
  }
}
    `;

export const useGetLifetimeMileageForPartQuery = <
      TData = GetLifetimeMileageForPartQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetLifetimeMileageForPartQueryVariables,
      options?: UseQueryOptions<GetLifetimeMileageForPartQuery, TError, TData>
    ) => {
    
    return useQuery<GetLifetimeMileageForPartQuery, TError, TData>(
      ['GetLifetimeMileageForPart', variables],
      fetcher<GetLifetimeMileageForPartQuery, GetLifetimeMileageForPartQueryVariables>(GetLifetimeMileageForPartDocument, variables),
      options
    )};

export const CopyPartFormDocument = `
    query CopyPartForm($id: MongoID!) {
  part(_id: $id) {
    _id
    __typename
    description
    displayName
    eligibleEventTypes
    locationID
    manufacturerID
    manufacturerPartID
    manufacturerSerialNumber
    notes
    partNumber
    partStatus {
      userEnumPartStatusID
    }
    properties
    reference
    specificationID
    specification {
      ...SpecificationVars
    }
    tagIDs
    teamIDs
    userEnumPartTypeID
  }
}
    ${SpecificationVarsFragmentDoc}`;

export const useCopyPartFormQuery = <
      TData = CopyPartFormQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: CopyPartFormQueryVariables,
      options?: UseQueryOptions<CopyPartFormQuery, TError, TData>
    ) => {
    
    return useQuery<CopyPartFormQuery, TError, TData>(
      ['CopyPartForm', variables],
      fetcher<CopyPartFormQuery, CopyPartFormQueryVariables>(CopyPartFormDocument, variables),
      options
    )};

export const GetTrackingItemNamesForPartEditPageDocument = `
    query GetTrackingItemNamesForPartEditPage($ids: [MongoID]) {
  trackingItems(filter: {_operators: {_id: {in: $ids}}}) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetTrackingItemNamesForPartEditPageQuery = <
      TData = GetTrackingItemNamesForPartEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTrackingItemNamesForPartEditPageQueryVariables,
      options?: UseQueryOptions<GetTrackingItemNamesForPartEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingItemNamesForPartEditPageQuery, TError, TData>(
      variables === undefined ? ['GetTrackingItemNamesForPartEditPage'] : ['GetTrackingItemNamesForPartEditPage', variables],
      fetcher<GetTrackingItemNamesForPartEditPageQuery, GetTrackingItemNamesForPartEditPageQueryVariables>(GetTrackingItemNamesForPartEditPageDocument, variables),
      options
    )};

export const RegenerateAssemblyTrackingDocument = `
    mutation RegenerateAssemblyTracking($chassisAssemblyIDs: [MongoID!]!) {
  fixAssemblyTracking(chassisAssemblyIDs: $chassisAssemblyIDs) {
    deletedCount
  }
}
    `;

export const useRegenerateAssemblyTrackingMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RegenerateAssemblyTrackingMutation, TError, RegenerateAssemblyTrackingMutationVariables, TContext>) => {
    
    return useMutation<RegenerateAssemblyTrackingMutation, TError, RegenerateAssemblyTrackingMutationVariables, TContext>(
      ['RegenerateAssemblyTracking'],
      (variables?: RegenerateAssemblyTrackingMutationVariables) => fetcher<RegenerateAssemblyTrackingMutation, RegenerateAssemblyTrackingMutationVariables>(RegenerateAssemblyTrackingDocument, variables)(),
      options
    )};

export const PartFieldsDocument = `
    query PartFields($id: MongoID!) {
  specification(_id: $id) {
    ...PartFieldVars
  }
}
    ${PartFieldVarsFragmentDoc}`;

export const usePartFieldsQuery = <
      TData = PartFieldsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: PartFieldsQueryVariables,
      options?: UseQueryOptions<PartFieldsQuery, TError, TData>
    ) => {
    
    return useQuery<PartFieldsQuery, TError, TData>(
      ['PartFields', variables],
      fetcher<PartFieldsQuery, PartFieldsQueryVariables>(PartFieldsDocument, variables),
      options
    )};

export const GetPartInstancesForPartModalDocument = `
    query GetPartInstancesForPartModal($partID: MongoID) {
  partInstances(filter: {partID: $partID}, perPage: 2000) {
    items {
      _id
      parent {
        ... on AnyAssembly {
          _id
          createdAt
          name
          reference
          updatedAt
        }
      }
      parentID
      superParentID
    }
  }
}
    `;

export const useGetPartInstancesForPartModalQuery = <
      TData = GetPartInstancesForPartModalQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPartInstancesForPartModalQueryVariables,
      options?: UseQueryOptions<GetPartInstancesForPartModalQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartInstancesForPartModalQuery, TError, TData>(
      variables === undefined ? ['GetPartInstancesForPartModal'] : ['GetPartInstancesForPartModal', variables],
      fetcher<GetPartInstancesForPartModalQuery, GetPartInstancesForPartModalQueryVariables>(GetPartInstancesForPartModalDocument, variables),
      options
    )};

export const GetAssemblyMetaInfoForPartModalDocument = `
    query GetAssemblyMetaInfoForPartModal($chassisAssemblyIDs: [MongoID]) {
  carSetups(
    filter: {_operators: {chassisAssemblyID: {in: $chassisAssemblyIDs}}}
    perPage: 2000
  ) {
    items {
      ...CarSetupMetaInfosForChassisAssembly
    }
  }
}
    ${CarSetupMetaInfosForChassisAssemblyFragmentDoc}`;

export const useGetAssemblyMetaInfoForPartModalQuery = <
      TData = GetAssemblyMetaInfoForPartModalQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAssemblyMetaInfoForPartModalQueryVariables,
      options?: UseQueryOptions<GetAssemblyMetaInfoForPartModalQuery, TError, TData>
    ) => {
    
    return useQuery<GetAssemblyMetaInfoForPartModalQuery, TError, TData>(
      variables === undefined ? ['GetAssemblyMetaInfoForPartModal'] : ['GetAssemblyMetaInfoForPartModal', variables],
      fetcher<GetAssemblyMetaInfoForPartModalQuery, GetAssemblyMetaInfoForPartModalQueryVariables>(GetAssemblyMetaInfoForPartModalDocument, variables),
      options
    )};

export const GetUnitsForPartTrackingMeasurementRecordDocument = `
    query GetUnitsForPartTrackingMeasurementRecord($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      measurements {
        angles
        lengths
      }
    }
  }
}
    `;

export const useGetUnitsForPartTrackingMeasurementRecordQuery = <
      TData = GetUnitsForPartTrackingMeasurementRecordQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetUnitsForPartTrackingMeasurementRecordQueryVariables,
      options?: UseQueryOptions<GetUnitsForPartTrackingMeasurementRecordQuery, TError, TData>
    ) => {
    
    return useQuery<GetUnitsForPartTrackingMeasurementRecordQuery, TError, TData>(
      ['GetUnitsForPartTrackingMeasurementRecord', variables],
      fetcher<GetUnitsForPartTrackingMeasurementRecordQuery, GetUnitsForPartTrackingMeasurementRecordQueryVariables>(GetUnitsForPartTrackingMeasurementRecordDocument, variables),
      options
    )};

export const GetPartInstancesForPartTrackingSourceRecordsPageDocument = `
    query GetPartInstancesForPartTrackingSourceRecordsPage($partID: MongoID) {
  partInstances(filter: {partID: $partID}, perPage: 20000) {
    items {
      superParentID
    }
  }
}
    `;

export const useGetPartInstancesForPartTrackingSourceRecordsPageQuery = <
      TData = GetPartInstancesForPartTrackingSourceRecordsPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPartInstancesForPartTrackingSourceRecordsPageQueryVariables,
      options?: UseQueryOptions<GetPartInstancesForPartTrackingSourceRecordsPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartInstancesForPartTrackingSourceRecordsPageQuery, TError, TData>(
      variables === undefined ? ['GetPartInstancesForPartTrackingSourceRecordsPage'] : ['GetPartInstancesForPartTrackingSourceRecordsPage', variables],
      fetcher<GetPartInstancesForPartTrackingSourceRecordsPageQuery, GetPartInstancesForPartTrackingSourceRecordsPageQueryVariables>(GetPartInstancesForPartTrackingSourceRecordsPageDocument, variables),
      options
    )};

export const GetChassisAssembliesForPartTrackingSourceRecordsPageDocument = `
    query GetChassisAssembliesForPartTrackingSourceRecordsPage($chassisAssemblyIDs: [MongoID]) {
  assemblies(
    filter: {_operators: {_id: {in: $chassisAssemblyIDs}}}
    perPage: 20000
  ) {
    items {
      ... on ChassisAssembly {
        ...ChassisAssemblyVarsForTrackingSourceRecordPage
      }
    }
  }
}
    ${ChassisAssemblyVarsForTrackingSourceRecordPageFragmentDoc}`;

export const useGetChassisAssembliesForPartTrackingSourceRecordsPageQuery = <
      TData = GetChassisAssembliesForPartTrackingSourceRecordsPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetChassisAssembliesForPartTrackingSourceRecordsPageQueryVariables,
      options?: UseQueryOptions<GetChassisAssembliesForPartTrackingSourceRecordsPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisAssembliesForPartTrackingSourceRecordsPageQuery, TError, TData>(
      variables === undefined ? ['GetChassisAssembliesForPartTrackingSourceRecordsPage'] : ['GetChassisAssembliesForPartTrackingSourceRecordsPage', variables],
      fetcher<GetChassisAssembliesForPartTrackingSourceRecordsPageQuery, GetChassisAssembliesForPartTrackingSourceRecordsPageQueryVariables>(GetChassisAssembliesForPartTrackingSourceRecordsPageDocument, variables),
      options
    )};

export const GetTrackingMeasurementRecordListDocument = `
    query GetTrackingMeasurementRecordList($id: MongoID!) {
  part(_id: $id) {
    trackingMeasurementHistory {
      _id
      date
      assembly {
        name
      }
      coordinates {
        x
        y
        z
      }
      rotation {
        I
        J
        K
      }
      trackingMeasurementID
      trackingMeasurement {
        _id
        name
        displayName
        description
        useInSimulation
      }
    }
  }
}
    `;

export const useGetTrackingMeasurementRecordListQuery = <
      TData = GetTrackingMeasurementRecordListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackingMeasurementRecordListQueryVariables,
      options?: UseQueryOptions<GetTrackingMeasurementRecordListQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingMeasurementRecordListQuery, TError, TData>(
      ['GetTrackingMeasurementRecordList', variables],
      fetcher<GetTrackingMeasurementRecordListQuery, GetTrackingMeasurementRecordListQueryVariables>(GetTrackingMeasurementRecordListDocument, variables),
      options
    )};

export const GetTrackingRecordIdForEditTrackingRecordModalDocument = `
    query GetTrackingRecordIdForEditTrackingRecordModal($chassisAssemblyID: MongoID, $trackingItemID: MongoID) {
  trackingRecords(
    filter: {chassisAssemblyID: $chassisAssemblyID, trackingItemID: $trackingItemID}
  ) {
    items {
      _id
      chassisAssemblyID
      cumulativeValue
      dateResolved
      forceTable {
        acceleration
        dampingForce
        force
        inertanceForce
        velocity
        x
        xMin
        xMax
      }
      notes
      reset
      trackingItemID
      type
      value
    }
  }
}
    `;

export const useGetTrackingRecordIdForEditTrackingRecordModalQuery = <
      TData = GetTrackingRecordIdForEditTrackingRecordModalQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTrackingRecordIdForEditTrackingRecordModalQueryVariables,
      options?: UseQueryOptions<GetTrackingRecordIdForEditTrackingRecordModalQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingRecordIdForEditTrackingRecordModalQuery, TError, TData>(
      variables === undefined ? ['GetTrackingRecordIdForEditTrackingRecordModal'] : ['GetTrackingRecordIdForEditTrackingRecordModal', variables],
      fetcher<GetTrackingRecordIdForEditTrackingRecordModalQuery, GetTrackingRecordIdForEditTrackingRecordModalQueryVariables>(GetTrackingRecordIdForEditTrackingRecordModalDocument, variables),
      options
    )};

export const RegeneratePartTrackingHistoryDocument = `
    mutation RegeneratePartTrackingHistory($partIDs: [MongoID!]!) {
  regeneratePartTrackingHistory(partIDs: $partIDs) {
    updatedRecords
  }
}
    `;

export const useRegeneratePartTrackingHistoryMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RegeneratePartTrackingHistoryMutation, TError, RegeneratePartTrackingHistoryMutationVariables, TContext>) => {
    
    return useMutation<RegeneratePartTrackingHistoryMutation, TError, RegeneratePartTrackingHistoryMutationVariables, TContext>(
      ['RegeneratePartTrackingHistory'],
      (variables?: RegeneratePartTrackingHistoryMutationVariables) => fetcher<RegeneratePartTrackingHistoryMutation, RegeneratePartTrackingHistoryMutationVariables>(RegeneratePartTrackingHistoryDocument, variables)(),
      options
    )};

export const GetPartStatusUserEnumsForPartsEditDocument = `
    query GetPartStatusUserEnumsForPartsEdit {
  userEnums(filter: {type: USER_ENUM_PART_STATUS}) {
    items {
      ... on UserEnumPartStatus {
        ...PartStatusEnumForPartEditPageVars
      }
    }
  }
}
    ${PartStatusEnumForPartEditPageVarsFragmentDoc}`;

export const useGetPartStatusUserEnumsForPartsEditQuery = <
      TData = GetPartStatusUserEnumsForPartsEditQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPartStatusUserEnumsForPartsEditQueryVariables,
      options?: UseQueryOptions<GetPartStatusUserEnumsForPartsEditQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartStatusUserEnumsForPartsEditQuery, TError, TData>(
      variables === undefined ? ['GetPartStatusUserEnumsForPartsEdit'] : ['GetPartStatusUserEnumsForPartsEdit', variables],
      fetcher<GetPartStatusUserEnumsForPartsEditQuery, GetPartStatusUserEnumsForPartsEditQueryVariables>(GetPartStatusUserEnumsForPartsEditDocument, variables),
      options
    )};

export const SetSpecificationFieldsDocument = `
    query SetSpecificationFields {
  specifications(perPage: 1000, filter: {type: CHASSIS}) {
    items {
      ... on ChassisSpec {
        _id
        name
        version
      }
    }
  }
}
    `;

export const useSetSpecificationFieldsQuery = <
      TData = SetSpecificationFieldsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: SetSpecificationFieldsQueryVariables,
      options?: UseQueryOptions<SetSpecificationFieldsQuery, TError, TData>
    ) => {
    
    return useQuery<SetSpecificationFieldsQuery, TError, TData>(
      variables === undefined ? ['SetSpecificationFields'] : ['SetSpecificationFields', variables],
      fetcher<SetSpecificationFieldsQuery, SetSpecificationFieldsQueryVariables>(SetSpecificationFieldsDocument, variables),
      options
    )};

export const GetDataOverviewPartsDocument = `
    query GetDataOverviewParts($filter: FilterFindManyPartInput!, $perPage: Int!, $page: Int, $sort: SortFindManyPartInput, $chassisSpecID: MongoID, $specTypes: [EnumSpecificationType], $hideDummyParts: Boolean, $partReference: String, $partNumber: String, $partType: MongoID, $manufacturerSerialNumber: String, $manufacturerIDs: [String], $specName: String, $specificationID: MongoID, $description: String, $eligibleEventTypes: [EnumPartEligibleEventTypes], $userEnumPartStatusActive: Boolean, $mileageMin: Float, $mileageMax: Float, $teamIDs: [MongoID], $locationIDs: [MongoID]) {
  partsAdvancedFilter(
    perPage: $perPage
    sort: $sort
    filter: $filter
    page: $page
    chassisSpecID: $chassisSpecID
    specTypes: $specTypes
    hideDummyParts: $hideDummyParts
    partReference: $partReference
    partNumber: $partNumber
    partType: $partType
    manufacturerSerialNumber: $manufacturerSerialNumber
    manufacturerIDs: $manufacturerIDs
    specName: $specName
    specificationID: $specificationID
    description: $description
    eligibleEventTypes: $eligibleEventTypes
    userEnumPartStatusActive: $userEnumPartStatusActive
    mileageMin: $mileageMin
    mileageMax: $mileageMax
    teamIDs: $teamIDs
    locationIDs: $locationIDs
  ) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ...PartOverviewItem
    }
  }
}
    ${PartOverviewItemFragmentDoc}`;

export const useGetDataOverviewPartsQuery = <
      TData = GetDataOverviewPartsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetDataOverviewPartsQueryVariables,
      options?: UseQueryOptions<GetDataOverviewPartsQuery, TError, TData>
    ) => {
    
    return useQuery<GetDataOverviewPartsQuery, TError, TData>(
      ['GetDataOverviewParts', variables],
      fetcher<GetDataOverviewPartsQuery, GetDataOverviewPartsQueryVariables>(GetDataOverviewPartsDocument, variables),
      options
    )};

export const GetMileageOverviewPartDocument = `
    query GetMileageOverviewPart($id: MongoID!) {
  part(_id: $id) {
    trackingHistory {
      ...AllTrackingHistoryVars
    }
    trackingHistoryIDs
    trackingHistoryFullAndSnapshot {
      trackingHistoryFull {
        ...AllTrackingHistoryFullAndSnapshotVars
      }
      trackingSnapshot {
        ...AllTrackingHistoryFullAndSnapshotVars
      }
    }
  }
}
    ${AllTrackingHistoryVarsFragmentDoc}
${AllTrackingHistoryFullAndSnapshotVarsFragmentDoc}`;

export const useGetMileageOverviewPartQuery = <
      TData = GetMileageOverviewPartQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetMileageOverviewPartQueryVariables,
      options?: UseQueryOptions<GetMileageOverviewPartQuery, TError, TData>
    ) => {
    
    return useQuery<GetMileageOverviewPartQuery, TError, TData>(
      ['GetMileageOverviewPart', variables],
      fetcher<GetMileageOverviewPartQuery, GetMileageOverviewPartQueryVariables>(GetMileageOverviewPartDocument, variables),
      options
    )};

export const GetPartByIdForPartEditPageDocument = `
    query GetPartByIdForPartEditPage($id: MongoID!) {
  part(_id: $id) {
    ...PartForPartEditPageVars
  }
}
    ${PartForPartEditPageVarsFragmentDoc}
${AllTrackingMeasurementScalarVarsFragmentDoc}
${AllTagVarsFragmentDoc}`;

export const useGetPartByIdForPartEditPageQuery = <
      TData = GetPartByIdForPartEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartByIdForPartEditPageQueryVariables,
      options?: UseQueryOptions<GetPartByIdForPartEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartByIdForPartEditPageQuery, TError, TData>(
      ['GetPartByIdForPartEditPage', variables],
      fetcher<GetPartByIdForPartEditPageQuery, GetPartByIdForPartEditPageQueryVariables>(GetPartByIdForPartEditPageDocument, variables),
      options
    )};

export const GetSpecInfosForPartEditPageDocument = `
    query GetSpecInfosForPartEditPage($partSpecID: MongoID!, $chassisSpecID: MongoID!) {
  partSpec: specification(_id: $partSpecID) {
    ... on CustomSpec {
      ...PartSpecInfoForPartEditPageVars
    }
  }
  chassisSpec: specification(_id: $chassisSpecID) {
    ... on ChassisSpec {
      ...ChassisSpecVarsForAssemblyPage
    }
  }
}
    ${PartSpecInfoForPartEditPageVarsFragmentDoc}
${ChassisSpecVarsForAssemblyPageFragmentDoc}
${ChassisTrackingSourceVarsForAssemblyPageFragmentDoc}`;

export const useGetSpecInfosForPartEditPageQuery = <
      TData = GetSpecInfosForPartEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSpecInfosForPartEditPageQueryVariables,
      options?: UseQueryOptions<GetSpecInfosForPartEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetSpecInfosForPartEditPageQuery, TError, TData>(
      ['GetSpecInfosForPartEditPage', variables],
      fetcher<GetSpecInfosForPartEditPageQuery, GetSpecInfosForPartEditPageQueryVariables>(GetSpecInfosForPartEditPageDocument, variables),
      options
    )};

export const GetTrackingItemListForPartEditPageDocument = `
    query GetTrackingItemListForPartEditPage($id: MongoID!) {
  specification(_id: $id) {
    ... on AnySpecification {
      trackingItemIDs
    }
  }
}
    `;

export const useGetTrackingItemListForPartEditPageQuery = <
      TData = GetTrackingItemListForPartEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackingItemListForPartEditPageQueryVariables,
      options?: UseQueryOptions<GetTrackingItemListForPartEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingItemListForPartEditPageQuery, TError, TData>(
      ['GetTrackingItemListForPartEditPage', variables],
      fetcher<GetTrackingItemListForPartEditPageQuery, GetTrackingItemListForPartEditPageQueryVariables>(GetTrackingItemListForPartEditPageDocument, variables),
      options
    )};

export const GetTrackingItemsForTrackingItemIDsForPartsEditPageDocument = `
    query GetTrackingItemsForTrackingItemIDsForPartsEditPage($ids: [MongoID!]) {
  trackingItems(filter: {_operators: {_id: {in: $ids}}}) {
    items {
      ...AllTrackingItemScalarVars
    }
  }
}
    ${AllTrackingItemScalarVarsFragmentDoc}`;

export const useGetTrackingItemsForTrackingItemIDsForPartsEditPageQuery = <
      TData = GetTrackingItemsForTrackingItemIDsForPartsEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTrackingItemsForTrackingItemIDsForPartsEditPageQueryVariables,
      options?: UseQueryOptions<GetTrackingItemsForTrackingItemIDsForPartsEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingItemsForTrackingItemIDsForPartsEditPageQuery, TError, TData>(
      variables === undefined ? ['GetTrackingItemsForTrackingItemIDsForPartsEditPage'] : ['GetTrackingItemsForTrackingItemIDsForPartsEditPage', variables],
      fetcher<GetTrackingItemsForTrackingItemIDsForPartsEditPageQuery, GetTrackingItemsForTrackingItemIDsForPartsEditPageQueryVariables>(GetTrackingItemsForTrackingItemIDsForPartsEditPageDocument, variables),
      options
    )};

export const GetPartTypeUserEnumsForPartEditPageDocument = `
    query GetPartTypeUserEnumsForPartEditPage {
  partTypeEnums: userEnums(
    perPage: 2000
    sort: NAME_ASC
    filter: {type: USER_ENUM_PART_TYPE}
  ) {
    items {
      ... on UserEnumPartType {
        _id
        name
        type
      }
    }
  }
  partStatusEnums: userEnums(
    perPage: 2000
    sort: NAME_ASC
    filter: {type: USER_ENUM_PART_STATUS}
  ) {
    items {
      ... on UserEnumPartStatus {
        _id
        active
        name
        type
      }
    }
  }
}
    `;

export const useGetPartTypeUserEnumsForPartEditPageQuery = <
      TData = GetPartTypeUserEnumsForPartEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPartTypeUserEnumsForPartEditPageQueryVariables,
      options?: UseQueryOptions<GetPartTypeUserEnumsForPartEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartTypeUserEnumsForPartEditPageQuery, TError, TData>(
      variables === undefined ? ['GetPartTypeUserEnumsForPartEditPage'] : ['GetPartTypeUserEnumsForPartEditPage', variables],
      fetcher<GetPartTypeUserEnumsForPartEditPageQuery, GetPartTypeUserEnumsForPartEditPageQueryVariables>(GetPartTypeUserEnumsForPartEditPageDocument, variables),
      options
    )};

export const GetPartStatusUserEnumsForPartEditPageDocument = `
    query GetPartStatusUserEnumsForPartEditPage {
  userEnums(perPage: 2000, sort: NAME_ASC, filter: {type: USER_ENUM_PART_STATUS}) {
    items {
      ... on UserEnumPartStatus {
        _id
        active
        name
        type
      }
    }
  }
}
    `;

export const useGetPartStatusUserEnumsForPartEditPageQuery = <
      TData = GetPartStatusUserEnumsForPartEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPartStatusUserEnumsForPartEditPageQueryVariables,
      options?: UseQueryOptions<GetPartStatusUserEnumsForPartEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartStatusUserEnumsForPartEditPageQuery, TError, TData>(
      variables === undefined ? ['GetPartStatusUserEnumsForPartEditPage'] : ['GetPartStatusUserEnumsForPartEditPage', variables],
      fetcher<GetPartStatusUserEnumsForPartEditPageQuery, GetPartStatusUserEnumsForPartEditPageQueryVariables>(GetPartStatusUserEnumsForPartEditPageDocument, variables),
      options
    )};

export const GetManufacturersForPartEditPageDocument = `
    query GetManufacturersForPartEditPage {
  manufacturers(perPage: 2000, sort: NAME_ASC) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetManufacturersForPartEditPageQuery = <
      TData = GetManufacturersForPartEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetManufacturersForPartEditPageQueryVariables,
      options?: UseQueryOptions<GetManufacturersForPartEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetManufacturersForPartEditPageQuery, TError, TData>(
      variables === undefined ? ['GetManufacturersForPartEditPage'] : ['GetManufacturersForPartEditPage', variables],
      fetcher<GetManufacturersForPartEditPageQuery, GetManufacturersForPartEditPageQueryVariables>(GetManufacturersForPartEditPageDocument, variables),
      options
    )};

export const GetTeamsForPartsPageDocument = `
    query GetTeamsForPartsPage {
  teams(perPage: 2000, sort: NAME_ASC) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetTeamsForPartsPageQuery = <
      TData = GetTeamsForPartsPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTeamsForPartsPageQueryVariables,
      options?: UseQueryOptions<GetTeamsForPartsPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTeamsForPartsPageQuery, TError, TData>(
      variables === undefined ? ['GetTeamsForPartsPage'] : ['GetTeamsForPartsPage', variables],
      fetcher<GetTeamsForPartsPageQuery, GetTeamsForPartsPageQueryVariables>(GetTeamsForPartsPageDocument, variables),
      options
    )};

export const GetLocationsForPartEditPageDocument = `
    query GetLocationsForPartEditPage {
  locations(perPage: 2000, sort: NAME_ASC) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetLocationsForPartEditPageQuery = <
      TData = GetLocationsForPartEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetLocationsForPartEditPageQueryVariables,
      options?: UseQueryOptions<GetLocationsForPartEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetLocationsForPartEditPageQuery, TError, TData>(
      variables === undefined ? ['GetLocationsForPartEditPage'] : ['GetLocationsForPartEditPage', variables],
      fetcher<GetLocationsForPartEditPageQuery, GetLocationsForPartEditPageQueryVariables>(GetLocationsForPartEditPageDocument, variables),
      options
    )};

export const GetUserUnitsForRunMileageDisplayDocument = `
    query GetUserUnitsForRunMileageDisplay($id: MongoID!) {
  person(_id: $id) {
    mileageUnit
  }
}
    `;

export const useGetUserUnitsForRunMileageDisplayQuery = <
      TData = GetUserUnitsForRunMileageDisplayQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetUserUnitsForRunMileageDisplayQueryVariables,
      options?: UseQueryOptions<GetUserUnitsForRunMileageDisplayQuery, TError, TData>
    ) => {
    
    return useQuery<GetUserUnitsForRunMileageDisplayQuery, TError, TData>(
      ['GetUserUnitsForRunMileageDisplay', variables],
      fetcher<GetUserUnitsForRunMileageDisplayQuery, GetUserUnitsForRunMileageDisplayQueryVariables>(GetUserUnitsForRunMileageDisplayDocument, variables),
      options
    )};

export const RecalculatePartMileageByIdDocument = `
    mutation RecalculatePartMileageByID($partID: MongoID!) {
  recalculatePartMileageByIDResolver(partID: $partID) {
    mileage
    partID
  }
}
    `;

export const useRecalculatePartMileageByIdMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RecalculatePartMileageByIdMutation, TError, RecalculatePartMileageByIdMutationVariables, TContext>) => {
    
    return useMutation<RecalculatePartMileageByIdMutation, TError, RecalculatePartMileageByIdMutationVariables, TContext>(
      ['RecalculatePartMileageByID'],
      (variables?: RecalculatePartMileageByIdMutationVariables) => fetcher<RecalculatePartMileageByIdMutation, RecalculatePartMileageByIdMutationVariables>(RecalculatePartMileageByIdDocument, variables)(),
      options
    )};

export const GetPersonMileageUnitDocument = `
    query GetPersonMileageUnit($personID: MongoID!) {
  person(_id: $personID) {
    mileageUnit
  }
}
    `;

export const useGetPersonMileageUnitQuery = <
      TData = GetPersonMileageUnitQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPersonMileageUnitQueryVariables,
      options?: UseQueryOptions<GetPersonMileageUnitQuery, TError, TData>
    ) => {
    
    return useQuery<GetPersonMileageUnitQuery, TError, TData>(
      ['GetPersonMileageUnit', variables],
      fetcher<GetPersonMileageUnitQuery, GetPersonMileageUnitQueryVariables>(GetPersonMileageUnitDocument, variables),
      options
    )};

export const GetAllSpecificationsForPartsInventoryDocument = `
    query GetAllSpecificationsForPartsInventory {
  specifications(perPage: 10000) {
    items {
      ... on AnySpecification {
        __typename
        _id
        name
      }
      ... on NonChassisSpec {
        chassisSpecID
        initialChassisSpecID
      }
      ... on ElasticSpec {
        allowableParentSpecIDs
      }
      ... on ChassisSpec {
        version
      }
    }
  }
}
    `;

export const useGetAllSpecificationsForPartsInventoryQuery = <
      TData = GetAllSpecificationsForPartsInventoryQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllSpecificationsForPartsInventoryQueryVariables,
      options?: UseQueryOptions<GetAllSpecificationsForPartsInventoryQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllSpecificationsForPartsInventoryQuery, TError, TData>(
      variables === undefined ? ['GetAllSpecificationsForPartsInventory'] : ['GetAllSpecificationsForPartsInventory', variables],
      fetcher<GetAllSpecificationsForPartsInventoryQuery, GetAllSpecificationsForPartsInventoryQueryVariables>(GetAllSpecificationsForPartsInventoryDocument, variables),
      options
    )};

export const GetTrackingHistoryFullForPartEditPageDocument = `
    query GetTrackingHistoryFullForPartEditPage($id: MongoID!) {
  part(_id: $id) {
    trackingHistoryFullAndSnapshot {
      trackingHistoryFull {
        ...AllTrackingHistoryFullAndSnapshotVars
      }
    }
  }
}
    ${AllTrackingHistoryFullAndSnapshotVarsFragmentDoc}`;

export const useGetTrackingHistoryFullForPartEditPageQuery = <
      TData = GetTrackingHistoryFullForPartEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackingHistoryFullForPartEditPageQueryVariables,
      options?: UseQueryOptions<GetTrackingHistoryFullForPartEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingHistoryFullForPartEditPageQuery, TError, TData>(
      ['GetTrackingHistoryFullForPartEditPage', variables],
      fetcher<GetTrackingHistoryFullForPartEditPageQuery, GetTrackingHistoryFullForPartEditPageQueryVariables>(GetTrackingHistoryFullForPartEditPageDocument, variables),
      options
    )};

export const GetPartTrackingDocument = `
    query GetPartTracking($partID: MongoID!, $trackingItemIDs: [MongoID]) {
  partTracking(partID: $partID, trackingItemIDs: $trackingItemIDs) {
    ...PartTrackingVars
  }
}
    ${PartTrackingVarsFragmentDoc}
${PartTrackingRecordVarsFragmentDoc}
${PartTrackingItemVarsFragmentDoc}`;

export const useGetPartTrackingQuery = <
      TData = GetPartTrackingQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartTrackingQueryVariables,
      options?: UseQueryOptions<GetPartTrackingQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartTrackingQuery, TError, TData>(
      ['GetPartTracking', variables],
      fetcher<GetPartTrackingQuery, GetPartTrackingQueryVariables>(GetPartTrackingDocument, variables),
      options
    )};

export const GetPartTrackingHistoryEntriesDocument = `
    query GetPartTrackingHistoryEntries($id: MongoID!) {
  part(_id: $id) {
    trackingHistory {
      _id
    }
  }
}
    `;

export const useGetPartTrackingHistoryEntriesQuery = <
      TData = GetPartTrackingHistoryEntriesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartTrackingHistoryEntriesQueryVariables,
      options?: UseQueryOptions<GetPartTrackingHistoryEntriesQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartTrackingHistoryEntriesQuery, TError, TData>(
      ['GetPartTrackingHistoryEntries', variables],
      fetcher<GetPartTrackingHistoryEntriesQuery, GetPartTrackingHistoryEntriesQueryVariables>(GetPartTrackingHistoryEntriesDocument, variables),
      options
    )};

export const GetUserAndTeamIdDocument = `
    query GetUserAndTeamID {
  whoami {
    person {
      _id
      teamID
      role
      team {
        _id
        name
      }
    }
  }
}
    `;

export const useGetUserAndTeamIdQuery = <
      TData = GetUserAndTeamIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetUserAndTeamIdQueryVariables,
      options?: UseQueryOptions<GetUserAndTeamIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetUserAndTeamIdQuery, TError, TData>(
      variables === undefined ? ['GetUserAndTeamID'] : ['GetUserAndTeamID', variables],
      fetcher<GetUserAndTeamIdQuery, GetUserAndTeamIdQueryVariables>(GetUserAndTeamIdDocument, variables),
      options
    )};

export const GetDataForEventSelectDropdownDocument = `
    query GetDataForEventSelectDropdown {
  raceSeriesAll {
    items {
      _id
      name
      seasons {
        _id
        name
        events {
          _id
          name
          tEventStart
          tEventEnd
        }
      }
    }
  }
}
    `;

export const useGetDataForEventSelectDropdownQuery = <
      TData = GetDataForEventSelectDropdownQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetDataForEventSelectDropdownQueryVariables,
      options?: UseQueryOptions<GetDataForEventSelectDropdownQuery, TError, TData>
    ) => {
    
    return useQuery<GetDataForEventSelectDropdownQuery, TError, TData>(
      variables === undefined ? ['GetDataForEventSelectDropdown'] : ['GetDataForEventSelectDropdown', variables],
      fetcher<GetDataForEventSelectDropdownQuery, GetDataForEventSelectDropdownQueryVariables>(GetDataForEventSelectDropdownDocument, variables),
      options
    )};

export const GetPartsInEventForPartsEventTableDocument = `
    query GetPartsInEventForPartsEventTable($eventID: MongoID!, $contestantID: MongoID) {
  partsInEvent(eventID: $eventID, contestantID: $contestantID) {
    items {
      runDistance
      serviceMileage
      part {
        _id
        displayName
        chassisSpecName
        notes
        reference
        partNumber
        specification {
          name
        }
      }
      runs {
        runID
        runName
        runTime
        mileage
        contestantID
        carSetupID
        carSetupTitle
        assemblyID
        assemblyName
      }
    }
  }
}
    `;

export const useGetPartsInEventForPartsEventTableQuery = <
      TData = GetPartsInEventForPartsEventTableQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartsInEventForPartsEventTableQueryVariables,
      options?: UseQueryOptions<GetPartsInEventForPartsEventTableQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartsInEventForPartsEventTableQuery, TError, TData>(
      ['GetPartsInEventForPartsEventTable', variables],
      fetcher<GetPartsInEventForPartsEventTableQuery, GetPartsInEventForPartsEventTableQueryVariables>(GetPartsInEventForPartsEventTableDocument, variables),
      options
    )};

export const GetRunSheetSelectionChainDocument = `
    query GetRunSheetSelectionChain($runSheetID: MongoID!) {
  runSheet(_id: $runSheetID) {
    _id
    NRun
    contestantID
    sessionID
    session {
      _id
      eventID
      event {
        _id
        seasonID
        season {
          _id
          raceSeriesID
        }
      }
    }
  }
}
    `;

export const useGetRunSheetSelectionChainQuery = <
      TData = GetRunSheetSelectionChainQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetSelectionChainQueryVariables,
      options?: UseQueryOptions<GetRunSheetSelectionChainQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetSelectionChainQuery, TError, TData>(
      ['GetRunSheetSelectionChain', variables],
      fetcher<GetRunSheetSelectionChainQuery, GetRunSheetSelectionChainQueryVariables>(GetRunSheetSelectionChainDocument, variables),
      options
    )};

export const GetRunSheetsForTabStripDocument = `
    query GetRunSheetsForTabStrip($sessionID: MongoID!, $contestantID: MongoID!) {
  runSheets(
    perPage: 1000
    filter: {sessionID: $sessionID, contestantID: $contestantID}
    sort: NRUNTIMING_ASC
  ) {
    items {
      ...RunSheetForTabStrip
    }
  }
}
    ${RunSheetForTabStripFragmentDoc}`;

export const useGetRunSheetsForTabStripQuery = <
      TData = GetRunSheetsForTabStripQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetsForTabStripQueryVariables,
      options?: UseQueryOptions<GetRunSheetsForTabStripQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsForTabStripQuery, TError, TData>(
      ['GetRunSheetsForTabStrip', variables],
      fetcher<GetRunSheetsForTabStripQuery, GetRunSheetsForTabStripQueryVariables>(GetRunSheetsForTabStripDocument, variables),
      options
    )};

export const GetRunPlansForSessionAndDriverDocument = `
    query GetRunPlansForSessionAndDriver($sessionID: [MongoID!]!, $contestantID: [MongoID!]!) {
  runPlans(
    filter: {_operators: {sessionID: {in: $sessionID}, contestantID: {in: $contestantID}}}
  ) {
    items {
      _id
      title
    }
  }
}
    `;

export const useGetRunPlansForSessionAndDriverQuery = <
      TData = GetRunPlansForSessionAndDriverQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunPlansForSessionAndDriverQueryVariables,
      options?: UseQueryOptions<GetRunPlansForSessionAndDriverQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunPlansForSessionAndDriverQuery, TError, TData>(
      ['GetRunPlansForSessionAndDriver', variables],
      fetcher<GetRunPlansForSessionAndDriverQuery, GetRunPlansForSessionAndDriverQueryVariables>(GetRunPlansForSessionAndDriverDocument, variables),
      options
    )};

export const GetRunPlannerWithSessionEventDataDocument = `
    query GetRunPlannerWithSessionEventData($runPlanID: MongoID!) {
  runPlan(_id: $runPlanID) {
    ...RunPlanVars
  }
  lapSequences {
    items {
      ...LapSequenceForRunPlanVars
    }
  }
  userEnums(filter: {type: USER_ENUM_RUN_PLANNER_ACTION_ITEM}) {
    items {
      ... on UserEnumRunPlannerActionItem {
        _id
        name
        type
      }
    }
  }
}
    ${RunPlanVarsFragmentDoc}
${RunEnergyLapTypeVarsFragmentDoc}
${RunPlanRunVarsFragmentDoc}
${LapSequenceLapsForRunPlanVarsFragmentDoc}
${RunPlanRunRunSheetVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${RunSheetTyreForRunPlanVarsFragmentDoc}
${RunPlanSessionEventVarsFragmentDoc}
${DriversForRunPlanVarsFragmentDoc}
${TrackLayoutLengthVarsFragmentDoc}
${LapTypeConfigVarsFragmentDoc}
${RunLapTimeLapTypeVarsFragmentDoc}
${LapSequenceForRunPlanVarsFragmentDoc}`;

export const useGetRunPlannerWithSessionEventDataQuery = <
      TData = GetRunPlannerWithSessionEventDataQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunPlannerWithSessionEventDataQueryVariables,
      options?: UseQueryOptions<GetRunPlannerWithSessionEventDataQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunPlannerWithSessionEventDataQuery, TError, TData>(
      ['GetRunPlannerWithSessionEventData', variables],
      fetcher<GetRunPlannerWithSessionEventDataQuery, GetRunPlannerWithSessionEventDataQueryVariables>(GetRunPlannerWithSessionEventDataDocument, variables),
      options
    )};

export const AddRunPlanDocument = `
    mutation AddRunPlan($record: CreateOneRunPlanInput!) {
  addRunPlan(record: $record) {
    recordId
  }
}
    `;

export const useAddRunPlanMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddRunPlanMutation, TError, AddRunPlanMutationVariables, TContext>) => {
    
    return useMutation<AddRunPlanMutation, TError, AddRunPlanMutationVariables, TContext>(
      ['AddRunPlan'],
      (variables?: AddRunPlanMutationVariables) => fetcher<AddRunPlanMutation, AddRunPlanMutationVariables>(AddRunPlanDocument, variables)(),
      options
    )};

export const RemoveRunPlanDocument = `
    mutation RemoveRunPlan($id: MongoID!) {
  removeRunPlan(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveRunPlanMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveRunPlanMutation, TError, RemoveRunPlanMutationVariables, TContext>) => {
    
    return useMutation<RemoveRunPlanMutation, TError, RemoveRunPlanMutationVariables, TContext>(
      ['RemoveRunPlan'],
      (variables?: RemoveRunPlanMutationVariables) => fetcher<RemoveRunPlanMutation, RemoveRunPlanMutationVariables>(RemoveRunPlanDocument, variables)(),
      options
    )};

export const UpdateRunPlanDocument = `
    mutation UpdateRunPlan($id: MongoID!, $record: UpdateByIdRunPlanInput!) {
  updateRunPlan(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateRunPlanMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateRunPlanMutation, TError, UpdateRunPlanMutationVariables, TContext>) => {
    
    return useMutation<UpdateRunPlanMutation, TError, UpdateRunPlanMutationVariables, TContext>(
      ['UpdateRunPlan'],
      (variables?: UpdateRunPlanMutationVariables) => fetcher<UpdateRunPlanMutation, UpdateRunPlanMutationVariables>(UpdateRunPlanDocument, variables)(),
      options
    )};

export const AddRunToRunPlanDocument = `
    mutation AddRunToRunPlan($runPlanID: MongoID!, $runs: [RunPlanRunInput]!) {
  addRunToRunPlan(runPlanID: $runPlanID, runs: $runs) {
    _id
  }
}
    `;

export const useAddRunToRunPlanMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddRunToRunPlanMutation, TError, AddRunToRunPlanMutationVariables, TContext>) => {
    
    return useMutation<AddRunToRunPlanMutation, TError, AddRunToRunPlanMutationVariables, TContext>(
      ['AddRunToRunPlan'],
      (variables?: AddRunToRunPlanMutationVariables) => fetcher<AddRunToRunPlanMutation, AddRunToRunPlanMutationVariables>(AddRunToRunPlanDocument, variables)(),
      options
    )};

export const InsertRunInRunPlanDocument = `
    mutation InsertRunInRunPlan($runPlanID: MongoID!, $run: RunPlanRunInput!, $NRun: Int!) {
  insertRunInRunPlan(runPlanID: $runPlanID, run: $run, NRun: $NRun) {
    _id
  }
}
    `;

export const useInsertRunInRunPlanMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<InsertRunInRunPlanMutation, TError, InsertRunInRunPlanMutationVariables, TContext>) => {
    
    return useMutation<InsertRunInRunPlanMutation, TError, InsertRunInRunPlanMutationVariables, TContext>(
      ['InsertRunInRunPlan'],
      (variables?: InsertRunInRunPlanMutationVariables) => fetcher<InsertRunInRunPlanMutation, InsertRunInRunPlanMutationVariables>(InsertRunInRunPlanDocument, variables)(),
      options
    )};

export const ReorderRunPlanRunsDocument = `
    mutation ReorderRunPlanRuns($runPlanID: MongoID!, $newNRunOrder: [Int!]) {
  reorderRunPlanRuns(runPlanID: $runPlanID, newNRunOrder: $newNRunOrder) {
    _id
  }
}
    `;

export const useReorderRunPlanRunsMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ReorderRunPlanRunsMutation, TError, ReorderRunPlanRunsMutationVariables, TContext>) => {
    
    return useMutation<ReorderRunPlanRunsMutation, TError, ReorderRunPlanRunsMutationVariables, TContext>(
      ['ReorderRunPlanRuns'],
      (variables?: ReorderRunPlanRunsMutationVariables) => fetcher<ReorderRunPlanRunsMutation, ReorderRunPlanRunsMutationVariables>(ReorderRunPlanRunsDocument, variables)(),
      options
    )};

export const UpdateRunInRunPlanDocument = `
    mutation UpdateRunInRunPlan($runPlanID: MongoID!, $NRun: Int!, $updatedFields: UpdateByIdRunPlanRunInput!) {
  updateRunInRunPlan(
    runPlanID: $runPlanID
    NRun: $NRun
    updatedFields: $updatedFields
  ) {
    _id
  }
}
    `;

export const useUpdateRunInRunPlanMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateRunInRunPlanMutation, TError, UpdateRunInRunPlanMutationVariables, TContext>) => {
    
    return useMutation<UpdateRunInRunPlanMutation, TError, UpdateRunInRunPlanMutationVariables, TContext>(
      ['UpdateRunInRunPlan'],
      (variables?: UpdateRunInRunPlanMutationVariables) => fetcher<UpdateRunInRunPlanMutation, UpdateRunInRunPlanMutationVariables>(UpdateRunInRunPlanDocument, variables)(),
      options
    )};

export const RemoveRunFromRunPlanDocument = `
    mutation RemoveRunFromRunPlan($runPlanID: MongoID!, $NRun: Int!) {
  removeRunFromRunPlan(runPlanID: $runPlanID, NRun: $NRun) {
    _id
  }
}
    `;

export const useRemoveRunFromRunPlanMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveRunFromRunPlanMutation, TError, RemoveRunFromRunPlanMutationVariables, TContext>) => {
    
    return useMutation<RemoveRunFromRunPlanMutation, TError, RemoveRunFromRunPlanMutationVariables, TContext>(
      ['RemoveRunFromRunPlan'],
      (variables?: RemoveRunFromRunPlanMutationVariables) => fetcher<RemoveRunFromRunPlanMutation, RemoveRunFromRunPlanMutationVariables>(RemoveRunFromRunPlanDocument, variables)(),
      options
    )};

export const AddLapSequenceDocument = `
    mutation AddLapSequence($record: CreateOneLapSequenceInput!) {
  addLapSequence(record: $record) {
    recordId
  }
}
    `;

export const useAddLapSequenceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddLapSequenceMutation, TError, AddLapSequenceMutationVariables, TContext>) => {
    
    return useMutation<AddLapSequenceMutation, TError, AddLapSequenceMutationVariables, TContext>(
      ['AddLapSequence'],
      (variables?: AddLapSequenceMutationVariables) => fetcher<AddLapSequenceMutation, AddLapSequenceMutationVariables>(AddLapSequenceDocument, variables)(),
      options
    )};

export const DraftRunSheetsDocument = `
    mutation DraftRunSheets($runPlanID: MongoID!, $runSheetIDS: [MongoID!]) {
  draftRunSheets(runPlanID: $runPlanID, runSheetIDS: $runSheetIDS) {
    _id
    runs {
      _id
      NRun
      runSheetID
    }
  }
}
    `;

export const useDraftRunSheetsMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<DraftRunSheetsMutation, TError, DraftRunSheetsMutationVariables, TContext>) => {
    
    return useMutation<DraftRunSheetsMutation, TError, DraftRunSheetsMutationVariables, TContext>(
      ['DraftRunSheets'],
      (variables?: DraftRunSheetsMutationVariables) => fetcher<DraftRunSheetsMutation, DraftRunSheetsMutationVariables>(DraftRunSheetsDocument, variables)(),
      options
    )};

export const RunPlansForImportModalDocument = `
    query RunPlansForImportModal {
  runPlans(perPage: 20000) {
    items {
      _id
      title
      session {
        _id
        name
        shortName
        event {
          _id
          name
          season {
            _id
            name
            raceSeries {
              _id
              name
            }
          }
        }
      }
    }
  }
}
    `;

export const useRunPlansForImportModalQuery = <
      TData = RunPlansForImportModalQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: RunPlansForImportModalQueryVariables,
      options?: UseQueryOptions<RunPlansForImportModalQuery, TError, TData>
    ) => {
    
    return useQuery<RunPlansForImportModalQuery, TError, TData>(
      variables === undefined ? ['RunPlansForImportModal'] : ['RunPlansForImportModal', variables],
      fetcher<RunPlansForImportModalQuery, RunPlansForImportModalQueryVariables>(RunPlansForImportModalDocument, variables),
      options
    )};

export const CloneRunPlanDocument = `
    mutation CloneRunPlan($contestantID: MongoID!, $runPlanID: MongoID!, $sessionID: MongoID!) {
  cloneRunPlan(
    contestantID: $contestantID
    runPlanID: $runPlanID
    sessionID: $sessionID
  ) {
    _id
  }
}
    `;

export const useCloneRunPlanMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CloneRunPlanMutation, TError, CloneRunPlanMutationVariables, TContext>) => {
    
    return useMutation<CloneRunPlanMutation, TError, CloneRunPlanMutationVariables, TContext>(
      ['CloneRunPlan'],
      (variables?: CloneRunPlanMutationVariables) => fetcher<CloneRunPlanMutation, CloneRunPlanMutationVariables>(CloneRunPlanDocument, variables)(),
      options
    )};

export const AllSessionsFromRaceSeriesDocument = `
    query AllSessionsFromRaceSeries {
  raceSeriesAll {
    items {
      _id
      name
      seasons {
        _id
        events {
          _id
          name
          sessions {
            name
            _id
            shortName
          }
        }
        name
      }
    }
  }
}
    `;

export const useAllSessionsFromRaceSeriesQuery = <
      TData = AllSessionsFromRaceSeriesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: AllSessionsFromRaceSeriesQueryVariables,
      options?: UseQueryOptions<AllSessionsFromRaceSeriesQuery, TError, TData>
    ) => {
    
    return useQuery<AllSessionsFromRaceSeriesQuery, TError, TData>(
      variables === undefined ? ['AllSessionsFromRaceSeries'] : ['AllSessionsFromRaceSeries', variables],
      fetcher<AllSessionsFromRaceSeriesQuery, AllSessionsFromRaceSeriesQueryVariables>(AllSessionsFromRaceSeriesDocument, variables),
      options
    )};

export const AllSessionsInASeriesDocument = `
    query AllSessionsInASeries($seriesID: MongoID!) {
  raceSeries(_id: $seriesID) {
    seasons {
      _id
      name
      raceSeries {
        _id
      }
      events {
        _id
        name
        sessions {
          _id
          name
          shortName
          contestants {
            drivers {
              name
            }
          }
        }
      }
    }
  }
}
    `;

export const useAllSessionsInASeriesQuery = <
      TData = AllSessionsInASeriesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: AllSessionsInASeriesQueryVariables,
      options?: UseQueryOptions<AllSessionsInASeriesQuery, TError, TData>
    ) => {
    
    return useQuery<AllSessionsInASeriesQuery, TError, TData>(
      ['AllSessionsInASeries', variables],
      fetcher<AllSessionsInASeriesQuery, AllSessionsInASeriesQueryVariables>(AllSessionsInASeriesDocument, variables),
      options
    )};

export const BopReportSessionsDocument = `
    query BopReportSessions($sessionIDs: [MongoID!]!) {
  sessions(filter: {_operators: {_id: {in: $sessionIDs}}}) {
    items {
      _id
      tSessionStart
      shortName
      name
      eventID
      bop {
        carBop {
          carSpec
        }
      }
    }
  }
}
    `;

export const useBopReportSessionsQuery = <
      TData = BopReportSessionsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: BopReportSessionsQueryVariables,
      options?: UseQueryOptions<BopReportSessionsQuery, TError, TData>
    ) => {
    
    return useQuery<BopReportSessionsQuery, TError, TData>(
      ['BopReportSessions', variables],
      fetcher<BopReportSessionsQuery, BopReportSessionsQueryVariables>(BopReportSessionsDocument, variables),
      options
    )};

export const GetReportTemplatesDocument = `
    query GetReportTemplates {
  reportTemplates {
    items {
      ...AllReportTemplateVars
    }
  }
}
    ${AllReportTemplateVarsFragmentDoc}`;

export const useGetReportTemplatesQuery = <
      TData = GetReportTemplatesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetReportTemplatesQueryVariables,
      options?: UseQueryOptions<GetReportTemplatesQuery, TError, TData>
    ) => {
    
    return useQuery<GetReportTemplatesQuery, TError, TData>(
      variables === undefined ? ['GetReportTemplates'] : ['GetReportTemplates', variables],
      fetcher<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>(GetReportTemplatesDocument, variables),
      options
    )};

export const GetReportNotesTemplatesDocument = `
    query GetReportNotesTemplates {
  reportNotesTemplates {
    _id
    title
    pageOverview {
      notes {
        _id
        index
        mode
        text
        title
      }
    }
    pageSession {
      notes {
        _id
        index
        mode
        text
        title
      }
    }
    pageParts {
      notes {
        _id
        index
        mode
        text
        title
      }
    }
    pageAppendix {
      notes {
        _id
        index
        mode
        text
        title
      }
    }
    pageRunPlan {
      notes {
        _id
        index
        mode
        text
        title
      }
    }
  }
}
    `;

export const useGetReportNotesTemplatesQuery = <
      TData = GetReportNotesTemplatesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetReportNotesTemplatesQueryVariables,
      options?: UseQueryOptions<GetReportNotesTemplatesQuery, TError, TData>
    ) => {
    
    return useQuery<GetReportNotesTemplatesQuery, TError, TData>(
      variables === undefined ? ['GetReportNotesTemplates'] : ['GetReportNotesTemplates', variables],
      fetcher<GetReportNotesTemplatesQuery, GetReportNotesTemplatesQueryVariables>(GetReportNotesTemplatesDocument, variables),
      options
    )};

export const Report_NotesDocument = `
    query report_notes($eventID: MongoID!) {
  reportNotes(eventID: $eventID) {
    ...ReportNotesPages
  }
}
    ${ReportNotesPagesFragmentDoc}`;

export const useReport_NotesQuery = <
      TData = Report_NotesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: Report_NotesQueryVariables,
      options?: UseQueryOptions<Report_NotesQuery, TError, TData>
    ) => {
    
    return useQuery<Report_NotesQuery, TError, TData>(
      ['report_notes', variables],
      fetcher<Report_NotesQuery, Report_NotesQueryVariables>(Report_NotesDocument, variables),
      options
    )};

export const ReportNoteUpdatedDocument = `
    subscription reportNoteUpdated($eventID: MongoID!) {
  reportNoteUpdated(eventID: $eventID) {
    ...ReportNotesPages
  }
}
    ${ReportNotesPagesFragmentDoc}`;
export const ReportEventUpdatedDocument = `
    subscription reportEventUpdated($eventID: MongoID!) {
  eventUpdated(eventID: $eventID) {
    _id
  }
}
    `;
export const SessionDebriefUpdatedDocument = `
    subscription sessionDebriefUpdated($sessionID: MongoID!) {
  sessionUpdated(sessionID: $sessionID) {
    _id
    debriefNotes
    debriefNotesMode
  }
}
    `;
export const Report_EngineersDocument = `
    query report_engineers {
  people(
    filter: {_operators: {role: {in: [ADMIN, MECHANIC, CAR_ENGINEER, TYRE_ENGINEER, CHIEF_ENGINEER]}}}
    perPage: 200
  ) {
    items {
      _id
      name
    }
  }
}
    `;

export const useReport_EngineersQuery = <
      TData = Report_EngineersQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: Report_EngineersQueryVariables,
      options?: UseQueryOptions<Report_EngineersQuery, TError, TData>
    ) => {
    
    return useQuery<Report_EngineersQuery, TError, TData>(
      variables === undefined ? ['report_engineers'] : ['report_engineers', variables],
      fetcher<Report_EngineersQuery, Report_EngineersQueryVariables>(Report_EngineersDocument, variables),
      options
    )};

export const Report_UpdateParticipantsDocument = `
    mutation report_updateParticipants($id: MongoID!, $participantIDs: [MongoID!]!) {
  updateEvent(_id: $id, record: {participantIDs: $participantIDs}) {
    recordId
  }
}
    `;

export const useReport_UpdateParticipantsMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Report_UpdateParticipantsMutation, TError, Report_UpdateParticipantsMutationVariables, TContext>) => {
    
    return useMutation<Report_UpdateParticipantsMutation, TError, Report_UpdateParticipantsMutationVariables, TContext>(
      ['report_updateParticipants'],
      (variables?: Report_UpdateParticipantsMutationVariables) => fetcher<Report_UpdateParticipantsMutation, Report_UpdateParticipantsMutationVariables>(Report_UpdateParticipantsDocument, variables)(),
      options
    )};

export const Report_UpdateReportAuthorsDocument = `
    mutation report_updateReportAuthors($id: MongoID!, $reportAuthors: [UpdateByIdEventReportAuthorsInput!]!) {
  updateEvent(_id: $id, record: {reportAuthors: $reportAuthors}) {
    recordId
  }
}
    `;

export const useReport_UpdateReportAuthorsMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Report_UpdateReportAuthorsMutation, TError, Report_UpdateReportAuthorsMutationVariables, TContext>) => {
    
    return useMutation<Report_UpdateReportAuthorsMutation, TError, Report_UpdateReportAuthorsMutationVariables, TContext>(
      ['report_updateReportAuthors'],
      (variables?: Report_UpdateReportAuthorsMutationVariables) => fetcher<Report_UpdateReportAuthorsMutation, Report_UpdateReportAuthorsMutationVariables>(Report_UpdateReportAuthorsDocument, variables)(),
      options
    )};

export const Report_UpdateEventDebriefNoteDocument = `
    mutation report_updateEventDebriefNote($id: MongoID!, $debriefNotes: String!, $debriefNotesMode: EnumEventDebriefNotesMode) {
  updateEvent(
    _id: $id
    record: {debriefNotes: $debriefNotes, debriefNotesMode: $debriefNotesMode}
  ) {
    recordId
  }
}
    `;

export const useReport_UpdateEventDebriefNoteMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Report_UpdateEventDebriefNoteMutation, TError, Report_UpdateEventDebriefNoteMutationVariables, TContext>) => {
    
    return useMutation<Report_UpdateEventDebriefNoteMutation, TError, Report_UpdateEventDebriefNoteMutationVariables, TContext>(
      ['report_updateEventDebriefNote'],
      (variables?: Report_UpdateEventDebriefNoteMutationVariables) => fetcher<Report_UpdateEventDebriefNoteMutation, Report_UpdateEventDebriefNoteMutationVariables>(Report_UpdateEventDebriefNoteDocument, variables)(),
      options
    )};

export const Report_UpdateSessionDebriefNoteDocument = `
    mutation report_updateSessionDebriefNote($id: MongoID!, $debriefNotes: String!, $debriefNotesMode: EnumSessionDebriefNotesMode) {
  updateSession(
    _id: $id
    record: {debriefNotes: $debriefNotes, debriefNotesMode: $debriefNotesMode}
  ) {
    recordId
  }
}
    `;

export const useReport_UpdateSessionDebriefNoteMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Report_UpdateSessionDebriefNoteMutation, TError, Report_UpdateSessionDebriefNoteMutationVariables, TContext>) => {
    
    return useMutation<Report_UpdateSessionDebriefNoteMutation, TError, Report_UpdateSessionDebriefNoteMutationVariables, TContext>(
      ['report_updateSessionDebriefNote'],
      (variables?: Report_UpdateSessionDebriefNoteMutationVariables) => fetcher<Report_UpdateSessionDebriefNoteMutation, Report_UpdateSessionDebriefNoteMutationVariables>(Report_UpdateSessionDebriefNoteDocument, variables)(),
      options
    )};

export const Report_AddReportNoteDocument = `
    mutation report_addReportNote($page: EnumReportPage!, $eventID: String!, $text: String!, $index: Int, $title: String, $mode: String) {
  addReportNote(
    page: $page
    eventID: $eventID
    text: $text
    index: $index
    title: $title
    mode: $mode
  ) {
    _id
  }
}
    `;

export const useReport_AddReportNoteMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Report_AddReportNoteMutation, TError, Report_AddReportNoteMutationVariables, TContext>) => {
    
    return useMutation<Report_AddReportNoteMutation, TError, Report_AddReportNoteMutationVariables, TContext>(
      ['report_addReportNote'],
      (variables?: Report_AddReportNoteMutationVariables) => fetcher<Report_AddReportNoteMutation, Report_AddReportNoteMutationVariables>(Report_AddReportNoteDocument, variables)(),
      options
    )};

export const Report_UpdateReportNoteDocument = `
    mutation report_updateReportNote($noteID: String!, $eventId: String!, $page: EnumReportPage!, $index: Int, $title: String, $text: String, $mode: String) {
  updateReportNote(
    noteID: $noteID
    eventID: $eventId
    page: $page
    index: $index
    title: $title
    text: $text
    mode: $mode
  ) {
    _id
  }
}
    `;

export const useReport_UpdateReportNoteMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Report_UpdateReportNoteMutation, TError, Report_UpdateReportNoteMutationVariables, TContext>) => {
    
    return useMutation<Report_UpdateReportNoteMutation, TError, Report_UpdateReportNoteMutationVariables, TContext>(
      ['report_updateReportNote'],
      (variables?: Report_UpdateReportNoteMutationVariables) => fetcher<Report_UpdateReportNoteMutation, Report_UpdateReportNoteMutationVariables>(Report_UpdateReportNoteDocument, variables)(),
      options
    )};

export const Report_RemoveReportNoteDocument = `
    mutation report_removeReportNote($noteID: String!, $page: EnumReportPage!, $eventID: String!) {
  removeReportNote(noteID: $noteID, page: $page, eventID: $eventID) {
    _id
  }
}
    `;

export const useReport_RemoveReportNoteMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Report_RemoveReportNoteMutation, TError, Report_RemoveReportNoteMutationVariables, TContext>) => {
    
    return useMutation<Report_RemoveReportNoteMutation, TError, Report_RemoveReportNoteMutationVariables, TContext>(
      ['report_removeReportNote'],
      (variables?: Report_RemoveReportNoteMutationVariables) => fetcher<Report_RemoveReportNoteMutation, Report_RemoveReportNoteMutationVariables>(Report_RemoveReportNoteDocument, variables)(),
      options
    )};

export const Report_RemoveReportNotesTemplateDocument = `
    mutation report_removeReportNotesTemplate($id: MongoID!) {
  removeReportNotesTemplate(_id: $id) {
    recordId
  }
}
    `;

export const useReport_RemoveReportNotesTemplateMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<Report_RemoveReportNotesTemplateMutation, TError, Report_RemoveReportNotesTemplateMutationVariables, TContext>) => {
    
    return useMutation<Report_RemoveReportNotesTemplateMutation, TError, Report_RemoveReportNotesTemplateMutationVariables, TContext>(
      ['report_removeReportNotesTemplate'],
      (variables?: Report_RemoveReportNotesTemplateMutationVariables) => fetcher<Report_RemoveReportNotesTemplateMutation, Report_RemoveReportNotesTemplateMutationVariables>(Report_RemoveReportNotesTemplateDocument, variables)(),
      options
    )};

export const UpdateReportTemplateDocument = `
    mutation UpdateReportTemplate($id: MongoID!, $record: UpdateByIdReportTemplateInput!) {
  updateReportTemplate(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateReportTemplateMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReportTemplateMutation, TError, UpdateReportTemplateMutationVariables, TContext>) => {
    
    return useMutation<UpdateReportTemplateMutation, TError, UpdateReportTemplateMutationVariables, TContext>(
      ['UpdateReportTemplate'],
      (variables?: UpdateReportTemplateMutationVariables) => fetcher<UpdateReportTemplateMutation, UpdateReportTemplateMutationVariables>(UpdateReportTemplateDocument, variables)(),
      options
    )};

export const AddReportTemplateDocument = `
    mutation AddReportTemplate($record: CreateOneReportTemplateInput!) {
  addReportTemplate(record: $record) {
    recordId
  }
}
    `;

export const useAddReportTemplateMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddReportTemplateMutation, TError, AddReportTemplateMutationVariables, TContext>) => {
    
    return useMutation<AddReportTemplateMutation, TError, AddReportTemplateMutationVariables, TContext>(
      ['AddReportTemplate'],
      (variables?: AddReportTemplateMutationVariables) => fetcher<AddReportTemplateMutation, AddReportTemplateMutationVariables>(AddReportTemplateDocument, variables)(),
      options
    )};

export const RemoveReportTemplateDocument = `
    mutation RemoveReportTemplate($id: MongoID!) {
  removeReportTemplate(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveReportTemplateMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveReportTemplateMutation, TError, RemoveReportTemplateMutationVariables, TContext>) => {
    
    return useMutation<RemoveReportTemplateMutation, TError, RemoveReportTemplateMutationVariables, TContext>(
      ['RemoveReportTemplate'],
      (variables?: RemoveReportTemplateMutationVariables) => fetcher<RemoveReportTemplateMutation, RemoveReportTemplateMutationVariables>(RemoveReportTemplateDocument, variables)(),
      options
    )};

export const AddReportNotesTemplateDocument = `
    mutation AddReportNotesTemplate($record: CreateOneReportNotesTemplateInput!) {
  addReportNotesTemplate(record: $record) {
    recordId
    record {
      _id
      title
    }
  }
}
    `;

export const useAddReportNotesTemplateMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddReportNotesTemplateMutation, TError, AddReportNotesTemplateMutationVariables, TContext>) => {
    
    return useMutation<AddReportNotesTemplateMutation, TError, AddReportNotesTemplateMutationVariables, TContext>(
      ['AddReportNotesTemplate'],
      (variables?: AddReportNotesTemplateMutationVariables) => fetcher<AddReportNotesTemplateMutation, AddReportNotesTemplateMutationVariables>(AddReportNotesTemplateDocument, variables)(),
      options
    )};

export const DraftNotesFromTemplateDocument = `
    mutation DraftNotesFromTemplate($eventID: String!, $notesTemplateId: MongoID!, $pages: [String]) {
  draftNotesFromTemplate(
    eventID: $eventID
    notesTemplateId: $notesTemplateId
    pages: $pages
  ) {
    _id
  }
}
    `;

export const useDraftNotesFromTemplateMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<DraftNotesFromTemplateMutation, TError, DraftNotesFromTemplateMutationVariables, TContext>) => {
    
    return useMutation<DraftNotesFromTemplateMutation, TError, DraftNotesFromTemplateMutationVariables, TContext>(
      ['DraftNotesFromTemplate'],
      (variables?: DraftNotesFromTemplateMutationVariables) => fetcher<DraftNotesFromTemplateMutation, DraftNotesFromTemplateMutationVariables>(DraftNotesFromTemplateDocument, variables)(),
      options
    )};

export const TrackingItemNamesForPartsReportDocument = `
    query trackingItemNamesForPartsReport($sessionIDs: [MongoID!]!) {
  trackingItemNamesForSessions(sessionIDs: $sessionIDs)
}
    `;

export const useTrackingItemNamesForPartsReportQuery = <
      TData = TrackingItemNamesForPartsReportQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: TrackingItemNamesForPartsReportQueryVariables,
      options?: UseQueryOptions<TrackingItemNamesForPartsReportQuery, TError, TData>
    ) => {
    
    return useQuery<TrackingItemNamesForPartsReportQuery, TError, TData>(
      ['trackingItemNamesForPartsReport', variables],
      fetcher<TrackingItemNamesForPartsReportQuery, TrackingItemNamesForPartsReportQueryVariables>(TrackingItemNamesForPartsReportDocument, variables),
      options
    )};

export const GetRunSheetInfoForRunSheetLinkingDocument = `
    query GetRunSheetInfoForRunSheetLinking($sessionIDs: [MongoID!]!, $contestantIDs: [MongoID!]!) {
  runSheets(
    perPage: 1000
    filter: {_operators: {sessionID: {in: $sessionIDs}, contestantID: {in: $contestantIDs}}}
  ) {
    items {
      ...RunSheetVarsForLinking
    }
  }
}
    ${RunSheetVarsForLinkingFragmentDoc}`;

export const useGetRunSheetInfoForRunSheetLinkingQuery = <
      TData = GetRunSheetInfoForRunSheetLinkingQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetInfoForRunSheetLinkingQueryVariables,
      options?: UseQueryOptions<GetRunSheetInfoForRunSheetLinkingQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetInfoForRunSheetLinkingQuery, TError, TData>(
      ['GetRunSheetInfoForRunSheetLinking', variables],
      fetcher<GetRunSheetInfoForRunSheetLinkingQuery, GetRunSheetInfoForRunSheetLinkingQueryVariables>(GetRunSheetInfoForRunSheetLinkingDocument, variables),
      options
    )};

export const GetSessionForSessionTimeRemainingDocument = `
    query GetSessionForSessionTimeRemaining($id: MongoID!) {
  session(_id: $id) {
    _id
    name
    timeRemainingUpdatedAt
    timeRemaining
  }
}
    `;

export const useGetSessionForSessionTimeRemainingQuery = <
      TData = GetSessionForSessionTimeRemainingQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSessionForSessionTimeRemainingQueryVariables,
      options?: UseQueryOptions<GetSessionForSessionTimeRemainingQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionForSessionTimeRemainingQuery, TError, TData>(
      ['GetSessionForSessionTimeRemaining', variables],
      fetcher<GetSessionForSessionTimeRemainingQuery, GetSessionForSessionTimeRemainingQueryVariables>(GetSessionForSessionTimeRemainingDocument, variables),
      options
    )};

export const GetSessionForReadFromLayoutButtonDocument = `
    query GetSessionForReadFromLayoutButton($id: MongoID!) {
  session(_id: $id) {
    _id
    name
    shortName
    tSessionStart
    tSessionEnd
    timeRemaining
    timeRemainingUpdatedAt
    eventID
    debriefNotes
    sessionType
    isLinkedSession
    contestants {
      _id
    }
  }
}
    `;

export const useGetSessionForReadFromLayoutButtonQuery = <
      TData = GetSessionForReadFromLayoutButtonQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSessionForReadFromLayoutButtonQueryVariables,
      options?: UseQueryOptions<GetSessionForReadFromLayoutButtonQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionForReadFromLayoutButtonQuery, TError, TData>(
      ['GetSessionForReadFromLayoutButton', variables],
      fetcher<GetSessionForReadFromLayoutButtonQuery, GetSessionForReadFromLayoutButtonQueryVariables>(GetSessionForReadFromLayoutButtonDocument, variables),
      options
    )};

export const GetPreviousRunSheetFuelForFuelBlockDocument = `
    query GetPreviousRunSheetFuelForFuelBlock($id: MongoID!) {
  runSheet(_id: $id) {
    _id
    consumptions {
      trackLayoutID
      trackLayout {
        _id
        name
        track {
          _id
          name
        }
      }
      energyRequired {
        ...AllRunEnergyVars
      }
      fuelRequired {
        ...AllRunEnergyVars
      }
      SoCRequired {
        ...AllRunEnergyVars
      }
    }
    dashboard {
      mFuelRunEnd
      mFuelRunStart
    }
    fuelDrainedBeforeRun
    mFuelAdded
    mFuelDrainedCatchTank
    mFuelDrainedMainTank
    mFuelRunEnd
    mFuelRunStart
    rEnergyAdded
    rEnergyRunEnd
    rEnergyRunStart
    rSOCAdded
    rSOCRunEnd
    rSOCRunStart
  }
}
    ${AllRunEnergyVarsFragmentDoc}`;

export const useGetPreviousRunSheetFuelForFuelBlockQuery = <
      TData = GetPreviousRunSheetFuelForFuelBlockQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPreviousRunSheetFuelForFuelBlockQueryVariables,
      options?: UseQueryOptions<GetPreviousRunSheetFuelForFuelBlockQuery, TError, TData>
    ) => {
    
    return useQuery<GetPreviousRunSheetFuelForFuelBlockQuery, TError, TData>(
      ['GetPreviousRunSheetFuelForFuelBlock', variables],
      fetcher<GetPreviousRunSheetFuelForFuelBlockQuery, GetPreviousRunSheetFuelForFuelBlockQueryVariables>(GetPreviousRunSheetFuelForFuelBlockDocument, variables),
      options
    )};

export const GetIssuesForRunSheetBlockDocument = `
    query GetIssuesForRunSheetBlock($runSheetID: MongoID!) {
  issues(filter: {runSheetID: $runSheetID}, perPage: 200) {
    items {
      _id
      ...IssueVars
    }
  }
}
    ${IssueVarsFragmentDoc}`;

export const useGetIssuesForRunSheetBlockQuery = <
      TData = GetIssuesForRunSheetBlockQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetIssuesForRunSheetBlockQueryVariables,
      options?: UseQueryOptions<GetIssuesForRunSheetBlockQuery, TError, TData>
    ) => {
    
    return useQuery<GetIssuesForRunSheetBlockQuery, TError, TData>(
      ['GetIssuesForRunSheetBlock', variables],
      fetcher<GetIssuesForRunSheetBlockQuery, GetIssuesForRunSheetBlockQueryVariables>(GetIssuesForRunSheetBlockDocument, variables),
      options
    )};

export const DeleteIssueDocument = `
    mutation DeleteIssue($id: MongoID!) {
  removeIssue(_id: $id) {
    recordId
  }
}
    `;

export const useDeleteIssueMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<DeleteIssueMutation, TError, DeleteIssueMutationVariables, TContext>) => {
    
    return useMutation<DeleteIssueMutation, TError, DeleteIssueMutationVariables, TContext>(
      ['DeleteIssue'],
      (variables?: DeleteIssueMutationVariables) => fetcher<DeleteIssueMutation, DeleteIssueMutationVariables>(DeleteIssueDocument, variables)(),
      options
    )};

export const ManageIssueDocument = `
    mutation ManageIssue($id: MongoID!, $action: IssueAction!) {
  manageIssue(issueID: $id, action: $action) {
    _id
  }
}
    `;

export const useManageIssueMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ManageIssueMutation, TError, ManageIssueMutationVariables, TContext>) => {
    
    return useMutation<ManageIssueMutation, TError, ManageIssueMutationVariables, TContext>(
      ['ManageIssue'],
      (variables?: ManageIssueMutationVariables) => fetcher<ManageIssueMutation, ManageIssueMutationVariables>(ManageIssueDocument, variables)(),
      options
    )};

export const UpdateIssueCommentDocument = `
    mutation UpdateIssueComment($target: EnumJobTarget!, $subjectID: MongoID!, $commentID: MongoID!, $text: String!) {
  updateComment(
    target: $target
    commentID: $commentID
    text: $text
    subjectID: $subjectID
  ) {
    comment {
      _id
      text
    }
  }
}
    `;

export const useUpdateIssueCommentMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateIssueCommentMutation, TError, UpdateIssueCommentMutationVariables, TContext>) => {
    
    return useMutation<UpdateIssueCommentMutation, TError, UpdateIssueCommentMutationVariables, TContext>(
      ['UpdateIssueComment'],
      (variables?: UpdateIssueCommentMutationVariables) => fetcher<UpdateIssueCommentMutation, UpdateIssueCommentMutationVariables>(UpdateIssueCommentDocument, variables)(),
      options
    )};

export const GetChassisSpecForRunSheetDocument = `
    query GetChassisSpecForRunSheet($id: MongoID!) {
  runSheet(_id: $id) {
    setup {
      chassisSpecID
      _id
    }
  }
}
    `;

export const useGetChassisSpecForRunSheetQuery = <
      TData = GetChassisSpecForRunSheetQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpecForRunSheetQueryVariables,
      options?: UseQueryOptions<GetChassisSpecForRunSheetQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecForRunSheetQuery, TError, TData>(
      ['GetChassisSpecForRunSheet', variables],
      fetcher<GetChassisSpecForRunSheetQuery, GetChassisSpecForRunSheetQueryVariables>(GetChassisSpecForRunSheetDocument, variables),
      options
    )};

export const GetShowMyIssuesDefaultValueDocument = `
    query GetShowMyIssuesDefaultValue($id: MongoID!) {
  person(_id: $id) {
    behaviour {
      showMyIssuesOnRunSheetDefault
    }
  }
}
    `;

export const useGetShowMyIssuesDefaultValueQuery = <
      TData = GetShowMyIssuesDefaultValueQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetShowMyIssuesDefaultValueQueryVariables,
      options?: UseQueryOptions<GetShowMyIssuesDefaultValueQuery, TError, TData>
    ) => {
    
    return useQuery<GetShowMyIssuesDefaultValueQuery, TError, TData>(
      ['GetShowMyIssuesDefaultValue', variables],
      fetcher<GetShowMyIssuesDefaultValueQuery, GetShowMyIssuesDefaultValueQueryVariables>(GetShowMyIssuesDefaultValueDocument, variables),
      options
    )};

export const GetActiveTimingServiceConfigsDocument = `
    query GetActiveTimingServiceConfigs {
  timingServiceStatus {
    _id
    activeConfigs {
      sessionMatchID
    }
  }
}
    `;

export const useGetActiveTimingServiceConfigsQuery = <
      TData = GetActiveTimingServiceConfigsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetActiveTimingServiceConfigsQueryVariables,
      options?: UseQueryOptions<GetActiveTimingServiceConfigsQuery, TError, TData>
    ) => {
    
    return useQuery<GetActiveTimingServiceConfigsQuery, TError, TData>(
      variables === undefined ? ['GetActiveTimingServiceConfigs'] : ['GetActiveTimingServiceConfigs', variables],
      fetcher<GetActiveTimingServiceConfigsQuery, GetActiveTimingServiceConfigsQueryVariables>(GetActiveTimingServiceConfigsDocument, variables),
      options
    )};

export const InsertLapDocument = `
    mutation insertLap($runSheetID: MongoID!, $lapToInsertBeforeID: MongoID!) {
  insertLap(runSheetID: $runSheetID, lapToInsertBeforeID: $lapToInsertBeforeID) {
    _id
  }
}
    `;

export const useInsertLapMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<InsertLapMutation, TError, InsertLapMutationVariables, TContext>) => {
    
    return useMutation<InsertLapMutation, TError, InsertLapMutationVariables, TContext>(
      ['insertLap'],
      (variables?: InsertLapMutationVariables) => fetcher<InsertLapMutation, InsertLapMutationVariables>(InsertLapDocument, variables)(),
      options
    )};

export const SplitRunSheetForLapTableDocument = `
    mutation SplitRunSheetForLapTable($runSheetId: MongoID!, $lapId: MongoID) {
  splitRunSheet(runSheetID: $runSheetId, lapID: $lapId) {
    _id
  }
}
    `;

export const useSplitRunSheetForLapTableMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<SplitRunSheetForLapTableMutation, TError, SplitRunSheetForLapTableMutationVariables, TContext>) => {
    
    return useMutation<SplitRunSheetForLapTableMutation, TError, SplitRunSheetForLapTableMutationVariables, TContext>(
      ['SplitRunSheetForLapTable'],
      (variables?: SplitRunSheetForLapTableMutationVariables) => fetcher<SplitRunSheetForLapTableMutation, SplitRunSheetForLapTableMutationVariables>(SplitRunSheetForLapTableDocument, variables)(),
      options
    )};

export const ApplyLapSequenceToRunSheetDocument = `
    mutation ApplyLapSequenceToRunSheet($runSheetID: MongoID!, $lapSequenceID: MongoID, $lapType: EnumLapType, $lapCount: Int, $lapTime: Float) {
  applyLapSequence(
    runSheetID: $runSheetID
    lapSequenceID: $lapSequenceID
    lapType: $lapType
    lapCount: $lapCount
    lapTime: $lapTime
  ) {
    success
    message
  }
}
    `;

export const useApplyLapSequenceToRunSheetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ApplyLapSequenceToRunSheetMutation, TError, ApplyLapSequenceToRunSheetMutationVariables, TContext>) => {
    
    return useMutation<ApplyLapSequenceToRunSheetMutation, TError, ApplyLapSequenceToRunSheetMutationVariables, TContext>(
      ['ApplyLapSequenceToRunSheet'],
      (variables?: ApplyLapSequenceToRunSheetMutationVariables) => fetcher<ApplyLapSequenceToRunSheetMutation, ApplyLapSequenceToRunSheetMutationVariables>(ApplyLapSequenceToRunSheetDocument, variables)(),
      options
    )};

export const GetLapSequencesForDraftSectionDocument = `
    query GetLapSequencesForDraftSection {
  lapSequences {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetLapSequencesForDraftSectionQuery = <
      TData = GetLapSequencesForDraftSectionQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetLapSequencesForDraftSectionQueryVariables,
      options?: UseQueryOptions<GetLapSequencesForDraftSectionQuery, TError, TData>
    ) => {
    
    return useQuery<GetLapSequencesForDraftSectionQuery, TError, TData>(
      variables === undefined ? ['GetLapSequencesForDraftSection'] : ['GetLapSequencesForDraftSection', variables],
      fetcher<GetLapSequencesForDraftSectionQuery, GetLapSequencesForDraftSectionQueryVariables>(GetLapSequencesForDraftSectionDocument, variables),
      options
    )};

export const GetReferenceLaptimesForLapTableDocument = `
    query GetReferenceLaptimesForLapTable($eventID: MongoID!) {
  event(_id: $eventID) {
    _id
    referenceLaptimes {
      ...EventReferenceLaptimeVars
    }
  }
}
    ${EventReferenceLaptimeVarsFragmentDoc}`;

export const useGetReferenceLaptimesForLapTableQuery = <
      TData = GetReferenceLaptimesForLapTableQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetReferenceLaptimesForLapTableQueryVariables,
      options?: UseQueryOptions<GetReferenceLaptimesForLapTableQuery, TError, TData>
    ) => {
    
    return useQuery<GetReferenceLaptimesForLapTableQuery, TError, TData>(
      ['GetReferenceLaptimesForLapTable', variables],
      fetcher<GetReferenceLaptimesForLapTableQuery, GetReferenceLaptimesForLapTableQueryVariables>(GetReferenceLaptimesForLapTableDocument, variables),
      options
    )};

export const GetLapsWithSelectedKpiForRunSheetDocument = `
    query GetLapsWithSelectedKpiForRunSheet($id: MongoID!, $lapKPI: [String!]) {
  runSheet(_id: $id) {
    laps {
      _id
      lapKPI(fields: $lapKPI)
    }
  }
}
    `;

export const useGetLapsWithSelectedKpiForRunSheetQuery = <
      TData = GetLapsWithSelectedKpiForRunSheetQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetLapsWithSelectedKpiForRunSheetQueryVariables,
      options?: UseQueryOptions<GetLapsWithSelectedKpiForRunSheetQuery, TError, TData>
    ) => {
    
    return useQuery<GetLapsWithSelectedKpiForRunSheetQuery, TError, TData>(
      ['GetLapsWithSelectedKpiForRunSheet', variables],
      fetcher<GetLapsWithSelectedKpiForRunSheetQuery, GetLapsWithSelectedKpiForRunSheetQueryVariables>(GetLapsWithSelectedKpiForRunSheetDocument, variables),
      options
    )};

export const GetTyreSetInfosFromPreviousRunSheetDocument = `
    query GetTyreSetInfosFromPreviousRunSheet($id: MongoID!) {
  runSheet(_id: $id) {
    tyreSetID
    tyreFL {
      ...TyreVarsForPreviousRunSheetsInfosVars
    }
    tyreFR {
      ...TyreVarsForPreviousRunSheetsInfosVars
    }
    tyreRL {
      ...TyreVarsForPreviousRunSheetsInfosVars
    }
    tyreRR {
      ...TyreVarsForPreviousRunSheetsInfosVars
    }
  }
}
    ${TyreVarsForPreviousRunSheetsInfosVarsFragmentDoc}`;

export const useGetTyreSetInfosFromPreviousRunSheetQuery = <
      TData = GetTyreSetInfosFromPreviousRunSheetQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTyreSetInfosFromPreviousRunSheetQueryVariables,
      options?: UseQueryOptions<GetTyreSetInfosFromPreviousRunSheetQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreSetInfosFromPreviousRunSheetQuery, TError, TData>(
      ['GetTyreSetInfosFromPreviousRunSheet', variables],
      fetcher<GetTyreSetInfosFromPreviousRunSheetQuery, GetTyreSetInfosFromPreviousRunSheetQueryVariables>(GetTyreSetInfosFromPreviousRunSheetDocument, variables),
      options
    )};

export const GetTyreWearForExcelExportDocument = `
    query GetTyreWearForExcelExport($tyreIDs: [MongoID]) {
  tyreWears(filter: {_operators: {tyreID: {in: $tyreIDs}}}) {
    items {
      ...TyreWearItem
    }
  }
}
    ${TyreWearItemFragmentDoc}`;

export const useGetTyreWearForExcelExportQuery = <
      TData = GetTyreWearForExcelExportQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTyreWearForExcelExportQueryVariables,
      options?: UseQueryOptions<GetTyreWearForExcelExportQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreWearForExcelExportQuery, TError, TData>(
      variables === undefined ? ['GetTyreWearForExcelExport'] : ['GetTyreWearForExcelExport', variables],
      fetcher<GetTyreWearForExcelExportQuery, GetTyreWearForExcelExportQueryVariables>(GetTyreWearForExcelExportDocument, variables),
      options
    )};

export const GetEventPressuresForTyreBlockDocument = `
    query GetEventPressuresForTyreBlock($id: MongoID!) {
  event(_id: $id) {
    ...EventTyreDefaults
  }
}
    ${EventTyreDefaultsFragmentDoc}`;

export const useGetEventPressuresForTyreBlockQuery = <
      TData = GetEventPressuresForTyreBlockQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventPressuresForTyreBlockQueryVariables,
      options?: UseQueryOptions<GetEventPressuresForTyreBlockQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventPressuresForTyreBlockQuery, TError, TData>(
      ['GetEventPressuresForTyreBlock', variables],
      fetcher<GetEventPressuresForTyreBlockQuery, GetEventPressuresForTyreBlockQueryVariables>(GetEventPressuresForTyreBlockDocument, variables),
      options
    )};

export const GetTyreTypesDocument = `
    query GetTyreTypes($tyreSetyID: MongoID!) {
  tyreSet(_id: $tyreSetyID) {
    tyreFL {
      type
    }
    tyreFR {
      type
    }
    tyreRL {
      type
    }
    tyreRR {
      type
    }
  }
}
    `;

export const useGetTyreTypesQuery = <
      TData = GetTyreTypesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTyreTypesQueryVariables,
      options?: UseQueryOptions<GetTyreTypesQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreTypesQuery, TError, TData>(
      ['GetTyreTypes', variables],
      fetcher<GetTyreTypesQuery, GetTyreTypesQueryVariables>(GetTyreTypesDocument, variables),
      options
    )};

export const GetTyreStaggerForTyreBlockDocument = `
    query GetTyreStaggerForTyreBlock($tyreIDs: [MongoID]) {
  tyres(filter: {_operators: {_id: {in: $tyreIDs}}}) {
    items {
      _id
      CTyre
    }
  }
}
    `;

export const useGetTyreStaggerForTyreBlockQuery = <
      TData = GetTyreStaggerForTyreBlockQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTyreStaggerForTyreBlockQueryVariables,
      options?: UseQueryOptions<GetTyreStaggerForTyreBlockQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreStaggerForTyreBlockQuery, TError, TData>(
      variables === undefined ? ['GetTyreStaggerForTyreBlock'] : ['GetTyreStaggerForTyreBlock', variables],
      fetcher<GetTyreStaggerForTyreBlockQuery, GetTyreStaggerForTyreBlockQueryVariables>(GetTyreStaggerForTyreBlockDocument, variables),
      options
    )};

export const GetWeatherFromPrevRunSheetDocument = `
    query GetWeatherFromPrevRunSheet($prevRunSheetID: MongoID!) {
  runSheet(_id: $prevRunSheetID) {
    weather {
      TAir
      TTrack
      rHumidity
      pAmbient
    }
  }
}
    `;

export const useGetWeatherFromPrevRunSheetQuery = <
      TData = GetWeatherFromPrevRunSheetQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetWeatherFromPrevRunSheetQueryVariables,
      options?: UseQueryOptions<GetWeatherFromPrevRunSheetQuery, TError, TData>
    ) => {
    
    return useQuery<GetWeatherFromPrevRunSheetQuery, TError, TData>(
      ['GetWeatherFromPrevRunSheet', variables],
      fetcher<GetWeatherFromPrevRunSheetQuery, GetWeatherFromPrevRunSheetQueryVariables>(GetWeatherFromPrevRunSheetDocument, variables),
      options
    )};

export const GetWeatherForGetWeatherButtonDocument = `
    query GetWeatherForGetWeatherButton($eventIDs: [MongoID]) {
  weatherAll(filter: {_operators: {eventIDs: {in: $eventIDs}}}) {
    items {
      _id
      time
      source
      type
      eventIDs
    }
  }
}
    `;

export const useGetWeatherForGetWeatherButtonQuery = <
      TData = GetWeatherForGetWeatherButtonQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetWeatherForGetWeatherButtonQueryVariables,
      options?: UseQueryOptions<GetWeatherForGetWeatherButtonQuery, TError, TData>
    ) => {
    
    return useQuery<GetWeatherForGetWeatherButtonQuery, TError, TData>(
      variables === undefined ? ['GetWeatherForGetWeatherButton'] : ['GetWeatherForGetWeatherButton', variables],
      fetcher<GetWeatherForGetWeatherButtonQuery, GetWeatherForGetWeatherButtonQueryVariables>(GetWeatherForGetWeatherButtonDocument, variables),
      options
    )};

export const GetWeatherDataByWeatherDocIdDocument = `
    query GetWeatherDataByWeatherDocID($weatherDocID: MongoID!) {
  weather(_id: $weatherDocID) {
    _id
    time
    source
    type
    eventIDs
    data {
      ...WeatherDataVars
    }
  }
}
    ${WeatherDataVarsFragmentDoc}`;

export const useGetWeatherDataByWeatherDocIdQuery = <
      TData = GetWeatherDataByWeatherDocIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetWeatherDataByWeatherDocIdQueryVariables,
      options?: UseQueryOptions<GetWeatherDataByWeatherDocIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetWeatherDataByWeatherDocIdQuery, TError, TData>(
      ['GetWeatherDataByWeatherDocID', variables],
      fetcher<GetWeatherDataByWeatherDocIdQuery, GetWeatherDataByWeatherDocIdQueryVariables>(GetWeatherDataByWeatherDocIdDocument, variables),
      options
    )};

export const GetRunSheetEndTimeDocument = `
    query GetRunSheetEndTime($id: MongoID!) {
  runSheet(_id: $id) {
    endTime
  }
}
    `;

export const useGetRunSheetEndTimeQuery = <
      TData = GetRunSheetEndTimeQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetEndTimeQueryVariables,
      options?: UseQueryOptions<GetRunSheetEndTimeQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetEndTimeQuery, TError, TData>(
      ['GetRunSheetEndTime', variables],
      fetcher<GetRunSheetEndTimeQuery, GetRunSheetEndTimeQueryVariables>(GetRunSheetEndTimeDocument, variables),
      options
    )};

export const GetSessionsInDateTimeRangeForRunSheetBurgerMenuDocument = `
    query GetSessionsInDateTimeRangeForRunSheetBurgerMenu($startDate: Date, $endDate: Date) {
  sessions(
    filter: {AND: [{_operators: {tSessionStart: {gte: $startDate}}}, {_operators: {tSessionStart: {lte: $endDate}}}]}
    sort: TSESSIONSTART_DESC
    perPage: 500
  ) {
    items {
      _id
      name
      tSessionStart
      tSessionEnd
      event {
        _id
        season {
          _id
          raceSeries {
            _id
          }
        }
      }
    }
  }
}
    `;

export const useGetSessionsInDateTimeRangeForRunSheetBurgerMenuQuery = <
      TData = GetSessionsInDateTimeRangeForRunSheetBurgerMenuQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSessionsInDateTimeRangeForRunSheetBurgerMenuQueryVariables,
      options?: UseQueryOptions<GetSessionsInDateTimeRangeForRunSheetBurgerMenuQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionsInDateTimeRangeForRunSheetBurgerMenuQuery, TError, TData>(
      variables === undefined ? ['GetSessionsInDateTimeRangeForRunSheetBurgerMenu'] : ['GetSessionsInDateTimeRangeForRunSheetBurgerMenu', variables],
      fetcher<GetSessionsInDateTimeRangeForRunSheetBurgerMenuQuery, GetSessionsInDateTimeRangeForRunSheetBurgerMenuQueryVariables>(GetSessionsInDateTimeRangeForRunSheetBurgerMenuDocument, variables),
      options
    )};

export const GetUserDefaultRunSheetStyleNameDocument = `
    query GetUserDefaultRunSheetStyleName($id: MongoID!) {
  person(_id: $id) {
    defaultRunSheetStyle {
      name
    }
  }
}
    `;

export const useGetUserDefaultRunSheetStyleNameQuery = <
      TData = GetUserDefaultRunSheetStyleNameQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetUserDefaultRunSheetStyleNameQueryVariables,
      options?: UseQueryOptions<GetUserDefaultRunSheetStyleNameQuery, TError, TData>
    ) => {
    
    return useQuery<GetUserDefaultRunSheetStyleNameQuery, TError, TData>(
      ['GetUserDefaultRunSheetStyleName', variables],
      fetcher<GetUserDefaultRunSheetStyleNameQuery, GetUserDefaultRunSheetStyleNameQueryVariables>(GetUserDefaultRunSheetStyleNameDocument, variables),
      options
    )};

export const RunSheetToServerDocument = `
    query RunSheetToServer($runSheetID: MongoID!) {
  runSheet(_id: $runSheetID) {
    nextRunSheetID
    prevRunSheetID
    laps {
      _id
      tLapMax
      tLapManual
      NLapRun
      BPitIn
      BPitOut
      tDay
    }
    NRun
    associatedKpiFiles
    driver {
      acronym
    }
    contestant {
      startNumber
    }
    startTime
    startTimeLTS
    startTimeManual
    endTime
    endTimeLTS
    endTimeManual
    lapCount
    session {
      name
      event {
        name
        season {
          name
        }
        track {
          timeZone
        }
      }
    }
  }
}
    `;

export const useRunSheetToServerQuery = <
      TData = RunSheetToServerQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: RunSheetToServerQueryVariables,
      options?: UseQueryOptions<RunSheetToServerQuery, TError, TData>
    ) => {
    
    return useQuery<RunSheetToServerQuery, TError, TData>(
      ['RunSheetToServer', variables],
      fetcher<RunSheetToServerQuery, RunSheetToServerQueryVariables>(RunSheetToServerDocument, variables),
      options
    )};

export const GetRunSheetInfoForCopySetupFromPreviousButtonDocument = `
    query GetRunSheetInfoForCopySetupFromPreviousButton($id: MongoID!) {
  runSheet(_id: $id) {
    setup {
      _id
      isLocked
      title
    }
    session {
      prevSessionID
    }
  }
}
    `;

export const useGetRunSheetInfoForCopySetupFromPreviousButtonQuery = <
      TData = GetRunSheetInfoForCopySetupFromPreviousButtonQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetInfoForCopySetupFromPreviousButtonQueryVariables,
      options?: UseQueryOptions<GetRunSheetInfoForCopySetupFromPreviousButtonQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetInfoForCopySetupFromPreviousButtonQuery, TError, TData>(
      ['GetRunSheetInfoForCopySetupFromPreviousButton', variables],
      fetcher<GetRunSheetInfoForCopySetupFromPreviousButtonQuery, GetRunSheetInfoForCopySetupFromPreviousButtonQueryVariables>(GetRunSheetInfoForCopySetupFromPreviousButtonDocument, variables),
      options
    )};

export const GetRunSheetsFromPreviousSessionForCopySetupFromPreviousButtonDocument = `
    query GetRunSheetsFromPreviousSessionForCopySetupFromPreviousButton($sessionIDs: [MongoID!]!, $contestantIDs: [MongoID!]!) {
  runSheets(
    perPage: 100
    filter: {_operators: {sessionID: {in: $sessionIDs}, contestantID: {in: $contestantIDs}}}
  ) {
    items {
      _id
      setup {
        _id
        isLocked
        title
      }
      NRunTiming
    }
  }
}
    `;

export const useGetRunSheetsFromPreviousSessionForCopySetupFromPreviousButtonQuery = <
      TData = GetRunSheetsFromPreviousSessionForCopySetupFromPreviousButtonQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetsFromPreviousSessionForCopySetupFromPreviousButtonQueryVariables,
      options?: UseQueryOptions<GetRunSheetsFromPreviousSessionForCopySetupFromPreviousButtonQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsFromPreviousSessionForCopySetupFromPreviousButtonQuery, TError, TData>(
      ['GetRunSheetsFromPreviousSessionForCopySetupFromPreviousButton', variables],
      fetcher<GetRunSheetsFromPreviousSessionForCopySetupFromPreviousButtonQuery, GetRunSheetsFromPreviousSessionForCopySetupFromPreviousButtonQueryVariables>(GetRunSheetsFromPreviousSessionForCopySetupFromPreviousButtonDocument, variables),
      options
    )};

export const GetTyreWearForRunSheetDocument = `
    query GetTyreWearForRunSheet($tyreIDs: [MongoID]) {
  tyreWears(filter: {_operators: {tyreID: {in: $tyreIDs}}}) {
    items {
      _id
      date
      runSheetID
      tyreID
      wearMarkers
    }
  }
}
    `;

export const useGetTyreWearForRunSheetQuery = <
      TData = GetTyreWearForRunSheetQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTyreWearForRunSheetQueryVariables,
      options?: UseQueryOptions<GetTyreWearForRunSheetQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreWearForRunSheetQuery, TError, TData>(
      variables === undefined ? ['GetTyreWearForRunSheet'] : ['GetTyreWearForRunSheet', variables],
      fetcher<GetTyreWearForRunSheetQuery, GetTyreWearForRunSheetQueryVariables>(GetTyreWearForRunSheetDocument, variables),
      options
    )};

export const GetMileageUnitForPersonDocument = `
    query GetMileageUnitForPerson($personID: MongoID!) {
  person(_id: $personID) {
    mileageUnit
  }
}
    `;

export const useGetMileageUnitForPersonQuery = <
      TData = GetMileageUnitForPersonQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetMileageUnitForPersonQueryVariables,
      options?: UseQueryOptions<GetMileageUnitForPersonQuery, TError, TData>
    ) => {
    
    return useQuery<GetMileageUnitForPersonQuery, TError, TData>(
      ['GetMileageUnitForPerson', variables],
      fetcher<GetMileageUnitForPersonQuery, GetMileageUnitForPersonQueryVariables>(GetMileageUnitForPersonDocument, variables),
      options
    )};

export const GetAvailableCarSetupSheetStylesForCarSetupCreateModalDocument = `
    query GetAvailableCarSetupSheetStylesForCarSetupCreateModal {
  license {
    options {
      setupSheetStyles
    }
  }
}
    `;

export const useGetAvailableCarSetupSheetStylesForCarSetupCreateModalQuery = <
      TData = GetAvailableCarSetupSheetStylesForCarSetupCreateModalQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAvailableCarSetupSheetStylesForCarSetupCreateModalQueryVariables,
      options?: UseQueryOptions<GetAvailableCarSetupSheetStylesForCarSetupCreateModalQuery, TError, TData>
    ) => {
    
    return useQuery<GetAvailableCarSetupSheetStylesForCarSetupCreateModalQuery, TError, TData>(
      variables === undefined ? ['GetAvailableCarSetupSheetStylesForCarSetupCreateModal'] : ['GetAvailableCarSetupSheetStylesForCarSetupCreateModal', variables],
      fetcher<GetAvailableCarSetupSheetStylesForCarSetupCreateModalQuery, GetAvailableCarSetupSheetStylesForCarSetupCreateModalQueryVariables>(GetAvailableCarSetupSheetStylesForCarSetupCreateModalDocument, variables),
      options
    )};

export const GetChassisSpecsForCarSetupCreateModalDocument = `
    query GetChassisSpecsForCarSetupCreateModal {
  specifications(filter: {nextIterationID: null, type: CHASSIS}, perPage: 100) {
    items {
      ... on ChassisSpec {
        _id
        decommissioned
        iterationIDs
        iterations {
          _id
          decommissioned
          released
          releaseDate
          version
        }
        name
      }
    }
  }
}
    `;

export const useGetChassisSpecsForCarSetupCreateModalQuery = <
      TData = GetChassisSpecsForCarSetupCreateModalQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetChassisSpecsForCarSetupCreateModalQueryVariables,
      options?: UseQueryOptions<GetChassisSpecsForCarSetupCreateModalQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecsForCarSetupCreateModalQuery, TError, TData>(
      variables === undefined ? ['GetChassisSpecsForCarSetupCreateModal'] : ['GetChassisSpecsForCarSetupCreateModal', variables],
      fetcher<GetChassisSpecsForCarSetupCreateModalQuery, GetChassisSpecsForCarSetupCreateModalQueryVariables>(GetChassisSpecsForCarSetupCreateModalDocument, variables),
      options
    )};

export const GetRunSheetSetupListForCarSetupCreateModalDocument = `
    query GetRunSheetSetupListForCarSetupCreateModal($sessionIDs: [MongoID!]!) {
  runSheets(perPage: 10000, filter: {_operators: {sessionID: {in: $sessionIDs}}}) {
    items {
      _id
      ...RunSheetForEventSelectionVars
      session {
        tSessionStart
      }
      setup {
        chassisSpec {
          decommissioned
        }
      }
    }
  }
}
    ${RunSheetForEventSelectionVarsFragmentDoc}`;

export const useGetRunSheetSetupListForCarSetupCreateModalQuery = <
      TData = GetRunSheetSetupListForCarSetupCreateModalQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetSetupListForCarSetupCreateModalQueryVariables,
      options?: UseQueryOptions<GetRunSheetSetupListForCarSetupCreateModalQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetSetupListForCarSetupCreateModalQuery, TError, TData>(
      ['GetRunSheetSetupListForCarSetupCreateModal', variables],
      fetcher<GetRunSheetSetupListForCarSetupCreateModalQuery, GetRunSheetSetupListForCarSetupCreateModalQueryVariables>(GetRunSheetSetupListForCarSetupCreateModalDocument, variables),
      options
    )};

export const GetAllSpecificationsDocument = `
    query getAllSpecifications($filter: FilterFindManySpecificationInput, $perPage: Int) {
  specifications(filter: $filter, perPage: $perPage) {
    items {
      ... on ChassisSpec {
        name
        iterationIDs
        rootSpecificationID
        iterations {
          _id
          version
          released
          releaseDate
        }
      }
    }
  }
}
    `;

export const useGetAllSpecificationsQuery = <
      TData = GetAllSpecificationsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllSpecificationsQueryVariables,
      options?: UseQueryOptions<GetAllSpecificationsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllSpecificationsQuery, TError, TData>(
      variables === undefined ? ['getAllSpecifications'] : ['getAllSpecifications', variables],
      fetcher<GetAllSpecificationsQuery, GetAllSpecificationsQueryVariables>(GetAllSpecificationsDocument, variables),
      options
    )};

export const GetSetupSheetStyleForSetupSheetPageDocument = `
    query GetSetupSheetStyleForSetupSheetPage($id: MongoID!) {
  carSetup(_id: $id) {
    _id
    setupSheetStyle
  }
}
    `;

export const useGetSetupSheetStyleForSetupSheetPageQuery = <
      TData = GetSetupSheetStyleForSetupSheetPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSetupSheetStyleForSetupSheetPageQueryVariables,
      options?: UseQueryOptions<GetSetupSheetStyleForSetupSheetPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetSetupSheetStyleForSetupSheetPageQuery, TError, TData>(
      ['GetSetupSheetStyleForSetupSheetPage', variables],
      fetcher<GetSetupSheetStyleForSetupSheetPageQuery, GetSetupSheetStyleForSetupSheetPageQueryVariables>(GetSetupSheetStyleForSetupSheetPageDocument, variables),
      options
    )};

export const CarSetupRemovedDocument = `
    subscription CarSetupRemoved($carSetupId: MongoID) {
  carSetupRemoved(carSetupID: $carSetupId) {
    _id
    runSheetID
  }
}
    `;
export const GetSimulationDriveFileDocument = `
    query GetSimulationDriveFile($id: MongoID!) {
  simulationDriveFile(_id: $id) {
    data
    name
    status
    userEnumTypeID
    eventID
    _id
    event {
      _id
      name
    }
  }
}
    `;

export const useGetSimulationDriveFileQuery = <
      TData = GetSimulationDriveFileQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSimulationDriveFileQueryVariables,
      options?: UseQueryOptions<GetSimulationDriveFileQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimulationDriveFileQuery, TError, TData>(
      ['GetSimulationDriveFile', variables],
      fetcher<GetSimulationDriveFileQuery, GetSimulationDriveFileQueryVariables>(GetSimulationDriveFileDocument, variables),
      options
    )};

export const GetEventsForDriveFileTreeViewDocument = `
    query getEventsForDriveFileTreeView {
  events {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetEventsForDriveFileTreeViewQuery = <
      TData = GetEventsForDriveFileTreeViewQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetEventsForDriveFileTreeViewQueryVariables,
      options?: UseQueryOptions<GetEventsForDriveFileTreeViewQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventsForDriveFileTreeViewQuery, TError, TData>(
      variables === undefined ? ['getEventsForDriveFileTreeView'] : ['getEventsForDriveFileTreeView', variables],
      fetcher<GetEventsForDriveFileTreeViewQuery, GetEventsForDriveFileTreeViewQueryVariables>(GetEventsForDriveFileTreeViewDocument, variables),
      options
    )};

export const UpdateSimulationDriveFileDocument = `
    mutation UpdateSimulationDriveFile($id: MongoID!, $record: UpdateByIdSimulationDriveFileInput!) {
  updateSimulationDriveFile(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateSimulationDriveFileMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSimulationDriveFileMutation, TError, UpdateSimulationDriveFileMutationVariables, TContext>) => {
    
    return useMutation<UpdateSimulationDriveFileMutation, TError, UpdateSimulationDriveFileMutationVariables, TContext>(
      ['UpdateSimulationDriveFile'],
      (variables?: UpdateSimulationDriveFileMutationVariables) => fetcher<UpdateSimulationDriveFileMutation, UpdateSimulationDriveFileMutationVariables>(UpdateSimulationDriveFileDocument, variables)(),
      options
    )};

export const GetSimulationDriveFileListDocument = `
    query GetSimulationDriveFileList {
  simulationDriveFiles {
    items {
      _id
    }
  }
}
    `;

export const useGetSimulationDriveFileListQuery = <
      TData = GetSimulationDriveFileListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimulationDriveFileListQueryVariables,
      options?: UseQueryOptions<GetSimulationDriveFileListQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimulationDriveFileListQuery, TError, TData>(
      variables === undefined ? ['GetSimulationDriveFileList'] : ['GetSimulationDriveFileList', variables],
      fetcher<GetSimulationDriveFileListQuery, GetSimulationDriveFileListQueryVariables>(GetSimulationDriveFileListDocument, variables),
      options
    )};

export const GetLocalConnectionsForSimulationContextMenuDocument = `
    query GetLocalConnectionsForSimulationContextMenu($id: MongoID!) {
  person(_id: $id) {
    localConnections {
      host
      endPoint
      port
      outputFolder
    }
  }
}
    `;

export const useGetLocalConnectionsForSimulationContextMenuQuery = <
      TData = GetLocalConnectionsForSimulationContextMenuQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetLocalConnectionsForSimulationContextMenuQueryVariables,
      options?: UseQueryOptions<GetLocalConnectionsForSimulationContextMenuQuery, TError, TData>
    ) => {
    
    return useQuery<GetLocalConnectionsForSimulationContextMenuQuery, TError, TData>(
      ['GetLocalConnectionsForSimulationContextMenu', variables],
      fetcher<GetLocalConnectionsForSimulationContextMenuQuery, GetLocalConnectionsForSimulationContextMenuQueryVariables>(GetLocalConnectionsForSimulationContextMenuDocument, variables),
      options
    )};

export const GetSimResultInfosForStagingAreaDocument = `
    query GetSimResultInfosForStagingArea($carSetupID: MongoID) {
  simResults(filter: {carSetupID: $carSetupID, status: COMPLETE}, perPage: 200) {
    items {
      ...SimResultInfosForStagingAreaVars
    }
  }
}
    ${SimResultInfosForStagingAreaVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetSimResultInfosForStagingAreaQuery = <
      TData = GetSimResultInfosForStagingAreaQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimResultInfosForStagingAreaQueryVariables,
      options?: UseQueryOptions<GetSimResultInfosForStagingAreaQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimResultInfosForStagingAreaQuery, TError, TData>(
      variables === undefined ? ['GetSimResultInfosForStagingArea'] : ['GetSimResultInfosForStagingArea', variables],
      fetcher<GetSimResultInfosForStagingAreaQuery, GetSimResultInfosForStagingAreaQueryVariables>(GetSimResultInfosForStagingAreaDocument, variables),
      options
    )};

export const GetRunSheetInfoForStagingAreaDocument = `
    query GetRunSheetInfoForStagingArea($runSheetID: MongoID!) {
  runSheet(_id: $runSheetID) {
    ...GetRunSheetInfoForStagingAreaVars
  }
}
    ${GetRunSheetInfoForStagingAreaVarsFragmentDoc}`;

export const useGetRunSheetInfoForStagingAreaQuery = <
      TData = GetRunSheetInfoForStagingAreaQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetInfoForStagingAreaQueryVariables,
      options?: UseQueryOptions<GetRunSheetInfoForStagingAreaQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetInfoForStagingAreaQuery, TError, TData>(
      ['GetRunSheetInfoForStagingArea', variables],
      fetcher<GetRunSheetInfoForStagingAreaQuery, GetRunSheetInfoForStagingAreaQueryVariables>(GetRunSheetInfoForStagingAreaDocument, variables),
      options
    )};

export const GetSetupInfoForStagingAreaDocument = `
    query GetSetupInfoForStagingArea($carSetupID: MongoID!) {
  carSetup(_id: $carSetupID) {
    ...CarSetupInfoForStagingAreaVars
  }
}
    ${CarSetupInfoForStagingAreaVarsFragmentDoc}`;

export const useGetSetupInfoForStagingAreaQuery = <
      TData = GetSetupInfoForStagingAreaQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSetupInfoForStagingAreaQueryVariables,
      options?: UseQueryOptions<GetSetupInfoForStagingAreaQuery, TError, TData>
    ) => {
    
    return useQuery<GetSetupInfoForStagingAreaQuery, TError, TData>(
      ['GetSetupInfoForStagingArea', variables],
      fetcher<GetSetupInfoForStagingAreaQuery, GetSetupInfoForStagingAreaQueryVariables>(GetSetupInfoForStagingAreaDocument, variables),
      options
    )};

export const GetRunSheetsForInitialLoadForSimulationDocument = `
    query GetRunSheetsForInitialLoadForSimulation($runSheetID: MongoID!) {
  runSheet(_id: $runSheetID) {
    ...GetRunSheetInfoForStagingAreaVars
  }
}
    ${GetRunSheetInfoForStagingAreaVarsFragmentDoc}`;

export const useGetRunSheetsForInitialLoadForSimulationQuery = <
      TData = GetRunSheetsForInitialLoadForSimulationQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetsForInitialLoadForSimulationQueryVariables,
      options?: UseQueryOptions<GetRunSheetsForInitialLoadForSimulationQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsForInitialLoadForSimulationQuery, TError, TData>(
      ['GetRunSheetsForInitialLoadForSimulation', variables],
      fetcher<GetRunSheetsForInitialLoadForSimulationQuery, GetRunSheetsForInitialLoadForSimulationQueryVariables>(GetRunSheetsForInitialLoadForSimulationDocument, variables),
      options
    )};

export const GetSetupsForInitialLoadForSimulationDocument = `
    query GetSetupsForInitialLoadForSimulation($carSetupID: MongoID!) {
  carSetup(_id: $carSetupID) {
    ...CarSetupInfoForStagingAreaVars
  }
}
    ${CarSetupInfoForStagingAreaVarsFragmentDoc}`;

export const useGetSetupsForInitialLoadForSimulationQuery = <
      TData = GetSetupsForInitialLoadForSimulationQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSetupsForInitialLoadForSimulationQueryVariables,
      options?: UseQueryOptions<GetSetupsForInitialLoadForSimulationQuery, TError, TData>
    ) => {
    
    return useQuery<GetSetupsForInitialLoadForSimulationQuery, TError, TData>(
      ['GetSetupsForInitialLoadForSimulation', variables],
      fetcher<GetSetupsForInitialLoadForSimulationQuery, GetSetupsForInitialLoadForSimulationQueryVariables>(GetSetupsForInitialLoadForSimulationDocument, variables),
      options
    )};

export const GetPeopleForLogWrapperFilterDocument = `
    query GetPeopleForLogWrapperFilter {
  people(
    perPage: 5000
    filter: {AND: [{isActive: true, _operators: {role: {ne: DRIVER}}}]}
    sort: USERNAME_ASC
  ) {
    items {
      _id
      name
      role
      username
    }
  }
}
    `;

export const useGetPeopleForLogWrapperFilterQuery = <
      TData = GetPeopleForLogWrapperFilterQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPeopleForLogWrapperFilterQueryVariables,
      options?: UseQueryOptions<GetPeopleForLogWrapperFilterQuery, TError, TData>
    ) => {
    
    return useQuery<GetPeopleForLogWrapperFilterQuery, TError, TData>(
      variables === undefined ? ['GetPeopleForLogWrapperFilter'] : ['GetPeopleForLogWrapperFilter', variables],
      fetcher<GetPeopleForLogWrapperFilterQuery, GetPeopleForLogWrapperFilterQueryVariables>(GetPeopleForLogWrapperFilterDocument, variables),
      options
    )};

export const CarSetupUpdatedForSimulationDocument = `
    subscription CarSetupUpdatedForSimulation($id: MongoID!) {
  carSetupUpdated(carSetupID: $id) {
    ...CarSetupInfoForStagingAreaVars
  }
}
    ${CarSetupInfoForStagingAreaVarsFragmentDoc}`;
export const SimResultAddedForSimulationDocument = `
    subscription SimResultAddedForSimulation {
  simResultAdded {
    ...SimResultInfosForStagingAreaVars
  }
}
    ${SimResultInfosForStagingAreaVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;
export const SimResultRemovedForSimulationDocument = `
    subscription SimResultRemovedForSimulation {
  simResultRemoved {
    _id
  }
}
    `;
export const SimResultUpdatedForSimulationDocument = `
    subscription SimResultUpdatedForSimulation {
  simResultUpdated {
    ...SimResultInfosForStagingAreaVars
  }
}
    ${SimResultInfosForStagingAreaVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;
export const RunSheetAddedForSimulationDocument = `
    subscription RunSheetAddedForSimulation {
  runSheetAdded {
    ...GetRunSheetInfoForStagingAreaVars
  }
}
    ${GetRunSheetInfoForStagingAreaVarsFragmentDoc}`;
export const RunSheetRemovedForSimulationDocument = `
    subscription RunSheetRemovedForSimulation {
  runSheetRemoved {
    _id
  }
}
    `;
export const RunSheetUpdatedForSimulationDocument = `
    subscription RunSheetUpdatedForSimulation($id: MongoID!) {
  runSheetUpdated(runSheetID: $id) {
    ...GetRunSheetInfoForStagingAreaVars
  }
}
    ${GetRunSheetInfoForStagingAreaVarsFragmentDoc}`;
export const GetChassisSpecForChassisSpecVersionPageDocument = `
    query GetChassisSpecForChassisSpecVersionPage($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      name
      rootSpecificationID
      iterationIDs
      iterations {
        ...ChassisSpecIterationVars
      }
      prevIterationID
      nextIterationID
    }
  }
}
    ${ChassisSpecIterationVarsFragmentDoc}`;

export const useGetChassisSpecForChassisSpecVersionPageQuery = <
      TData = GetChassisSpecForChassisSpecVersionPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpecForChassisSpecVersionPageQueryVariables,
      options?: UseQueryOptions<GetChassisSpecForChassisSpecVersionPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecForChassisSpecVersionPageQuery, TError, TData>(
      ['GetChassisSpecForChassisSpecVersionPage', variables],
      fetcher<GetChassisSpecForChassisSpecVersionPageQuery, GetChassisSpecForChassisSpecVersionPageQueryVariables>(GetChassisSpecForChassisSpecVersionPageDocument, variables),
      options
    )};

export const GetSpecificationGroupsAndCustomSpecificationsByChassisSpecIdDocument = `
    query GetSpecificationGroupsAndCustomSpecificationsByChassisSpecId($id: MongoID!) {
  specification(_id: $id) {
    ...SpecificationForSpecGroups
  }
}
    ${SpecificationForSpecGroupsFragmentDoc}`;

export const useGetSpecificationGroupsAndCustomSpecificationsByChassisSpecIdQuery = <
      TData = GetSpecificationGroupsAndCustomSpecificationsByChassisSpecIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSpecificationGroupsAndCustomSpecificationsByChassisSpecIdQueryVariables,
      options?: UseQueryOptions<GetSpecificationGroupsAndCustomSpecificationsByChassisSpecIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetSpecificationGroupsAndCustomSpecificationsByChassisSpecIdQuery, TError, TData>(
      ['GetSpecificationGroupsAndCustomSpecificationsByChassisSpecId', variables],
      fetcher<GetSpecificationGroupsAndCustomSpecificationsByChassisSpecIdQuery, GetSpecificationGroupsAndCustomSpecificationsByChassisSpecIdQueryVariables>(GetSpecificationGroupsAndCustomSpecificationsByChassisSpecIdDocument, variables),
      options
    )};

export const GetSpecificationGroupByIdDocument = `
    query GetSpecificationGroupById($id: MongoID!) {
  specificationGroup(_id: $id) {
    _id
    name
    specifications {
      ...SpecificationOnSpecificationGroup
    }
  }
}
    ${SpecificationOnSpecificationGroupFragmentDoc}`;

export const useGetSpecificationGroupByIdQuery = <
      TData = GetSpecificationGroupByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSpecificationGroupByIdQueryVariables,
      options?: UseQueryOptions<GetSpecificationGroupByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetSpecificationGroupByIdQuery, TError, TData>(
      ['GetSpecificationGroupById', variables],
      fetcher<GetSpecificationGroupByIdQuery, GetSpecificationGroupByIdQueryVariables>(GetSpecificationGroupByIdDocument, variables),
      options
    )};

export const GetCustomSpecificationByIdDocument = `
    query GetCustomSpecificationById($id: MongoID!) {
  specification(_id: $id) {
    ...CustomSpecificationItem
  }
}
    ${CustomSpecificationItemFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${ChassisMeasurementVarsFragmentDoc}
${AllTableVarsFragmentDoc}
${AllTrackingItemScalarVarsFragmentDoc}
${TrackingSourceForGetTrackingSourcesByChassisSpecIdVarsFragmentDoc}
${AllTrackingMeasurementScalarVarsFragmentDoc}`;

export const useGetCustomSpecificationByIdQuery = <
      TData = GetCustomSpecificationByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCustomSpecificationByIdQueryVariables,
      options?: UseQueryOptions<GetCustomSpecificationByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetCustomSpecificationByIdQuery, TError, TData>(
      ['GetCustomSpecificationById', variables],
      fetcher<GetCustomSpecificationByIdQuery, GetCustomSpecificationByIdQueryVariables>(GetCustomSpecificationByIdDocument, variables),
      options
    )};

export const GetChassisSpecInfoForCustomSpecPageDocument = `
    query GetChassisSpecInfoForCustomSpecPage($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      released
    }
  }
}
    `;

export const useGetChassisSpecInfoForCustomSpecPageQuery = <
      TData = GetChassisSpecInfoForCustomSpecPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpecInfoForCustomSpecPageQueryVariables,
      options?: UseQueryOptions<GetChassisSpecInfoForCustomSpecPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecInfoForCustomSpecPageQuery, TError, TData>(
      ['GetChassisSpecInfoForCustomSpecPage', variables],
      fetcher<GetChassisSpecInfoForCustomSpecPageQuery, GetChassisSpecInfoForCustomSpecPageQueryVariables>(GetChassisSpecInfoForCustomSpecPageDocument, variables),
      options
    )};

export const AddSpecificationOnSpecificationGroupDocument = `
    mutation AddSpecificationOnSpecificationGroup($record: CreateOneSpecificationInput!) {
  addSpecification(record: $record) {
    recordId
  }
}
    `;

export const useAddSpecificationOnSpecificationGroupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddSpecificationOnSpecificationGroupMutation, TError, AddSpecificationOnSpecificationGroupMutationVariables, TContext>) => {
    
    return useMutation<AddSpecificationOnSpecificationGroupMutation, TError, AddSpecificationOnSpecificationGroupMutationVariables, TContext>(
      ['AddSpecificationOnSpecificationGroup'],
      (variables?: AddSpecificationOnSpecificationGroupMutationVariables) => fetcher<AddSpecificationOnSpecificationGroupMutation, AddSpecificationOnSpecificationGroupMutationVariables>(AddSpecificationOnSpecificationGroupDocument, variables)(),
      options
    )};

export const DeleteSpecificationOnSpecificationGroupDocument = `
    mutation DeleteSpecificationOnSpecificationGroup($specificationId: MongoID!) {
  removeSpecification(_id: $specificationId) {
    recordId
  }
}
    `;

export const useDeleteSpecificationOnSpecificationGroupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSpecificationOnSpecificationGroupMutation, TError, DeleteSpecificationOnSpecificationGroupMutationVariables, TContext>) => {
    
    return useMutation<DeleteSpecificationOnSpecificationGroupMutation, TError, DeleteSpecificationOnSpecificationGroupMutationVariables, TContext>(
      ['DeleteSpecificationOnSpecificationGroup'],
      (variables?: DeleteSpecificationOnSpecificationGroupMutationVariables) => fetcher<DeleteSpecificationOnSpecificationGroupMutation, DeleteSpecificationOnSpecificationGroupMutationVariables>(DeleteSpecificationOnSpecificationGroupDocument, variables)(),
      options
    )};

export const AddSpecificationGroupDocument = `
    mutation AddSpecificationGroup($record: CreateOneSpecificationGroupInput!, $chassisSpecID: MongoID!) {
  addSpecificationGroup(record: $record, chassisSpecID: $chassisSpecID) {
    recordId
  }
}
    `;

export const useAddSpecificationGroupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddSpecificationGroupMutation, TError, AddSpecificationGroupMutationVariables, TContext>) => {
    
    return useMutation<AddSpecificationGroupMutation, TError, AddSpecificationGroupMutationVariables, TContext>(
      ['AddSpecificationGroup'],
      (variables?: AddSpecificationGroupMutationVariables) => fetcher<AddSpecificationGroupMutation, AddSpecificationGroupMutationVariables>(AddSpecificationGroupDocument, variables)(),
      options
    )};

export const UpdateSpecificationGroupDocument = `
    mutation UpdateSpecificationGroup($specificationGroupId: MongoID!, $record: UpdateByIdSpecificationGroupInput!) {
  updateSpecificationGroup(_id: $specificationGroupId, record: $record) {
    recordId
  }
}
    `;

export const useUpdateSpecificationGroupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSpecificationGroupMutation, TError, UpdateSpecificationGroupMutationVariables, TContext>) => {
    
    return useMutation<UpdateSpecificationGroupMutation, TError, UpdateSpecificationGroupMutationVariables, TContext>(
      ['UpdateSpecificationGroup'],
      (variables?: UpdateSpecificationGroupMutationVariables) => fetcher<UpdateSpecificationGroupMutation, UpdateSpecificationGroupMutationVariables>(UpdateSpecificationGroupDocument, variables)(),
      options
    )};

export const DeleteSpecificationGroupDocument = `
    mutation DeleteSpecificationGroup($specificationGroupId: MongoID!) {
  removeSpecificationGroup(_id: $specificationGroupId) {
    recordId
  }
}
    `;

export const useDeleteSpecificationGroupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSpecificationGroupMutation, TError, DeleteSpecificationGroupMutationVariables, TContext>) => {
    
    return useMutation<DeleteSpecificationGroupMutation, TError, DeleteSpecificationGroupMutationVariables, TContext>(
      ['DeleteSpecificationGroup'],
      (variables?: DeleteSpecificationGroupMutationVariables) => fetcher<DeleteSpecificationGroupMutation, DeleteSpecificationGroupMutationVariables>(DeleteSpecificationGroupDocument, variables)(),
      options
    )};

export const GetBuildSheetGroupEnumsDocument = `
    query GetBuildSheetGroupEnums($filter: FilterFindManyUserEnumInput) {
  userEnums(filter: $filter) {
    items {
      ... on UserEnumBuildSheetGroup {
        _id
        name
      }
    }
  }
}
    `;

export const useGetBuildSheetGroupEnumsQuery = <
      TData = GetBuildSheetGroupEnumsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBuildSheetGroupEnumsQueryVariables,
      options?: UseQueryOptions<GetBuildSheetGroupEnumsQuery, TError, TData>
    ) => {
    
    return useQuery<GetBuildSheetGroupEnumsQuery, TError, TData>(
      variables === undefined ? ['GetBuildSheetGroupEnums'] : ['GetBuildSheetGroupEnums', variables],
      fetcher<GetBuildSheetGroupEnumsQuery, GetBuildSheetGroupEnumsQueryVariables>(GetBuildSheetGroupEnumsDocument, variables),
      options
    )};

export const GetTrackingItemByIdDocument = `
    query GetTrackingItemByID($id: MongoID!) {
  trackingItem(_id: $id) {
    _id
    name
    active
    trackingSourceID
    specificationID
    displayUnit
    description
    resettable
    cumulativeCalculation
    defaultValue
    warningValue
    criticalCumulativeValue
    warningCumulativeValue
    criticalValue
    operator
    isDefault
  }
}
    `;

export const useGetTrackingItemByIdQuery = <
      TData = GetTrackingItemByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackingItemByIdQueryVariables,
      options?: UseQueryOptions<GetTrackingItemByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingItemByIdQuery, TError, TData>(
      ['GetTrackingItemByID', variables],
      fetcher<GetTrackingItemByIdQuery, GetTrackingItemByIdQueryVariables>(GetTrackingItemByIdDocument, variables),
      options
    )};

export const GetTrackingItemByIdForTrackingItemFieldsDocument = `
    query GetTrackingItemByIDForTrackingItemFields($id: MongoID!) {
  trackingItem(_id: $id) {
    measurementImage
  }
}
    `;

export const useGetTrackingItemByIdForTrackingItemFieldsQuery = <
      TData = GetTrackingItemByIdForTrackingItemFieldsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackingItemByIdForTrackingItemFieldsQueryVariables,
      options?: UseQueryOptions<GetTrackingItemByIdForTrackingItemFieldsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingItemByIdForTrackingItemFieldsQuery, TError, TData>(
      ['GetTrackingItemByIDForTrackingItemFields', variables],
      fetcher<GetTrackingItemByIdForTrackingItemFieldsQuery, GetTrackingItemByIdForTrackingItemFieldsQueryVariables>(GetTrackingItemByIdForTrackingItemFieldsDocument, variables),
      options
    )};

export const CustomSpecs_Helpers_AddChassisSpecificationDocument = `
    mutation CustomSpecs_helpers_AddChassisSpecification($record: CreateOneSpecificationInput!) {
  addSpecification(record: $record) {
    recordId
  }
}
    `;

export const useCustomSpecs_Helpers_AddChassisSpecificationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CustomSpecs_Helpers_AddChassisSpecificationMutation, TError, CustomSpecs_Helpers_AddChassisSpecificationMutationVariables, TContext>) => {
    
    return useMutation<CustomSpecs_Helpers_AddChassisSpecificationMutation, TError, CustomSpecs_Helpers_AddChassisSpecificationMutationVariables, TContext>(
      ['CustomSpecs_helpers_AddChassisSpecification'],
      (variables?: CustomSpecs_Helpers_AddChassisSpecificationMutationVariables) => fetcher<CustomSpecs_Helpers_AddChassisSpecificationMutation, CustomSpecs_Helpers_AddChassisSpecificationMutationVariables>(CustomSpecs_Helpers_AddChassisSpecificationDocument, variables)(),
      options
    )};

export const CustomSpecs_Helpers_AddSpecificationGroupDocument = `
    mutation CustomSpecs_helpers_AddSpecificationGroup($record: CreateOneSpecificationGroupInput!, $chassisSpecID: MongoID!) {
  addSpecificationGroup(record: $record, chassisSpecID: $chassisSpecID) {
    recordId
  }
}
    `;

export const useCustomSpecs_Helpers_AddSpecificationGroupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CustomSpecs_Helpers_AddSpecificationGroupMutation, TError, CustomSpecs_Helpers_AddSpecificationGroupMutationVariables, TContext>) => {
    
    return useMutation<CustomSpecs_Helpers_AddSpecificationGroupMutation, TError, CustomSpecs_Helpers_AddSpecificationGroupMutationVariables, TContext>(
      ['CustomSpecs_helpers_AddSpecificationGroup'],
      (variables?: CustomSpecs_Helpers_AddSpecificationGroupMutationVariables) => fetcher<CustomSpecs_Helpers_AddSpecificationGroupMutation, CustomSpecs_Helpers_AddSpecificationGroupMutationVariables>(CustomSpecs_Helpers_AddSpecificationGroupDocument, variables)(),
      options
    )};

export const CustomSpecs_Helpers_AddSpecificationDocument = `
    mutation CustomSpecs_helpers_AddSpecification($record: CreateOneSpecificationInput!) {
  addSpecification(record: $record) {
    recordId
  }
}
    `;

export const useCustomSpecs_Helpers_AddSpecificationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CustomSpecs_Helpers_AddSpecificationMutation, TError, CustomSpecs_Helpers_AddSpecificationMutationVariables, TContext>) => {
    
    return useMutation<CustomSpecs_Helpers_AddSpecificationMutation, TError, CustomSpecs_Helpers_AddSpecificationMutationVariables, TContext>(
      ['CustomSpecs_helpers_AddSpecification'],
      (variables?: CustomSpecs_Helpers_AddSpecificationMutationVariables) => fetcher<CustomSpecs_Helpers_AddSpecificationMutation, CustomSpecs_Helpers_AddSpecificationMutationVariables>(CustomSpecs_Helpers_AddSpecificationDocument, variables)(),
      options
    )};

export const CustomSpecs_Helpers_AddSpecificationOnSpecificationGroupDocument = `
    mutation CustomSpecs_helpers_AddSpecificationOnSpecificationGroup($record: CreateOneSpecificationInput!) {
  addSpecification(record: $record) {
    recordId
  }
}
    `;

export const useCustomSpecs_Helpers_AddSpecificationOnSpecificationGroupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CustomSpecs_Helpers_AddSpecificationOnSpecificationGroupMutation, TError, CustomSpecs_Helpers_AddSpecificationOnSpecificationGroupMutationVariables, TContext>) => {
    
    return useMutation<CustomSpecs_Helpers_AddSpecificationOnSpecificationGroupMutation, TError, CustomSpecs_Helpers_AddSpecificationOnSpecificationGroupMutationVariables, TContext>(
      ['CustomSpecs_helpers_AddSpecificationOnSpecificationGroup'],
      (variables?: CustomSpecs_Helpers_AddSpecificationOnSpecificationGroupMutationVariables) => fetcher<CustomSpecs_Helpers_AddSpecificationOnSpecificationGroupMutation, CustomSpecs_Helpers_AddSpecificationOnSpecificationGroupMutationVariables>(CustomSpecs_Helpers_AddSpecificationOnSpecificationGroupDocument, variables)(),
      options
    )};

export const UpdateCustomSimulationModelsDocument = `
    mutation UpdateCustomSimulationModels($id: MongoID!, $currentChassisSpecId: MongoID!, $customSimulationModels: [UpdateByIdSpecificationCustomSimulationModelsInput]!) {
  updateSpecification(
    _id: $id
    currentChassisSpecID: $currentChassisSpecId
    record: {customSimulationModels: $customSimulationModels}
  ) {
    recordId
  }
}
    `;

export const useUpdateCustomSimulationModelsMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCustomSimulationModelsMutation, TError, UpdateCustomSimulationModelsMutationVariables, TContext>) => {
    
    return useMutation<UpdateCustomSimulationModelsMutation, TError, UpdateCustomSimulationModelsMutationVariables, TContext>(
      ['UpdateCustomSimulationModels'],
      (variables?: UpdateCustomSimulationModelsMutationVariables) => fetcher<UpdateCustomSimulationModelsMutation, UpdateCustomSimulationModelsMutationVariables>(UpdateCustomSimulationModelsDocument, variables)(),
      options
    )};

export const GetTrackingSourcesByChassisSpecIdDocument = `
    query GetTrackingSourcesByChassisSpecId($id: MongoID!) {
  specification(_id: $id) {
    ...ChassisSpecForGetTrackingSourcesByChassisSpecIdVars
  }
}
    ${ChassisSpecForGetTrackingSourcesByChassisSpecIdVarsFragmentDoc}
${TrackingSourceForGetTrackingSourcesByChassisSpecIdVarsFragmentDoc}`;

export const useGetTrackingSourcesByChassisSpecIdQuery = <
      TData = GetTrackingSourcesByChassisSpecIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackingSourcesByChassisSpecIdQueryVariables,
      options?: UseQueryOptions<GetTrackingSourcesByChassisSpecIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingSourcesByChassisSpecIdQuery, TError, TData>(
      ['GetTrackingSourcesByChassisSpecId', variables],
      fetcher<GetTrackingSourcesByChassisSpecIdQuery, GetTrackingSourcesByChassisSpecIdQueryVariables>(GetTrackingSourcesByChassisSpecIdDocument, variables),
      options
    )};

export const AddTrackingSourceDocument = `
    mutation AddTrackingSource($record: CreateOneTrackingSourceInput!) {
  addTrackingSource(record: $record) {
    recordId
  }
}
    `;

export const useAddTrackingSourceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTrackingSourceMutation, TError, AddTrackingSourceMutationVariables, TContext>) => {
    
    return useMutation<AddTrackingSourceMutation, TError, AddTrackingSourceMutationVariables, TContext>(
      ['AddTrackingSource'],
      (variables?: AddTrackingSourceMutationVariables) => fetcher<AddTrackingSourceMutation, AddTrackingSourceMutationVariables>(AddTrackingSourceDocument, variables)(),
      options
    )};

export const UpdateTrackingSourceDocument = `
    mutation UpdateTrackingSource($id: MongoID!, $record: UpdateByIdTrackingSourceInput!) {
  updateTrackingSource(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTrackingSourceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTrackingSourceMutation, TError, UpdateTrackingSourceMutationVariables, TContext>) => {
    
    return useMutation<UpdateTrackingSourceMutation, TError, UpdateTrackingSourceMutationVariables, TContext>(
      ['UpdateTrackingSource'],
      (variables?: UpdateTrackingSourceMutationVariables) => fetcher<UpdateTrackingSourceMutation, UpdateTrackingSourceMutationVariables>(UpdateTrackingSourceDocument, variables)(),
      options
    )};

export const RemoveTrackingSourceFromChassisSpecDocument = `
    mutation RemoveTrackingSourceFromChassisSpec($id: MongoID!) {
  removeTrackingSource(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTrackingSourceFromChassisSpecMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTrackingSourceFromChassisSpecMutation, TError, RemoveTrackingSourceFromChassisSpecMutationVariables, TContext>) => {
    
    return useMutation<RemoveTrackingSourceFromChassisSpecMutation, TError, RemoveTrackingSourceFromChassisSpecMutationVariables, TContext>(
      ['RemoveTrackingSourceFromChassisSpec'],
      (variables?: RemoveTrackingSourceFromChassisSpecMutationVariables) => fetcher<RemoveTrackingSourceFromChassisSpecMutation, RemoveTrackingSourceFromChassisSpecMutationVariables>(RemoveTrackingSourceFromChassisSpecDocument, variables)(),
      options
    )};

export const AddTrackingSourceAliasDocument = `
    mutation AddTrackingSourceAlias($record: CreateOneTrackingSourceAliasInput!) {
  addTrackingSourceAlias(record: $record) {
    recordId
  }
}
    `;

export const useAddTrackingSourceAliasMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTrackingSourceAliasMutation, TError, AddTrackingSourceAliasMutationVariables, TContext>) => {
    
    return useMutation<AddTrackingSourceAliasMutation, TError, AddTrackingSourceAliasMutationVariables, TContext>(
      ['AddTrackingSourceAlias'],
      (variables?: AddTrackingSourceAliasMutationVariables) => fetcher<AddTrackingSourceAliasMutation, AddTrackingSourceAliasMutationVariables>(AddTrackingSourceAliasDocument, variables)(),
      options
    )};

export const UpdateTrackingSourceAliasDocument = `
    mutation UpdateTrackingSourceAlias($id: MongoID!, $record: UpdateByIdTrackingSourceAliasInput!) {
  updateTrackingSourceAlias(_id: $id, record: $record) {
    recordId
    record {
      aliasString
      aliasType
      description
      displayUnit
      priority
    }
  }
}
    `;

export const useUpdateTrackingSourceAliasMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTrackingSourceAliasMutation, TError, UpdateTrackingSourceAliasMutationVariables, TContext>) => {
    
    return useMutation<UpdateTrackingSourceAliasMutation, TError, UpdateTrackingSourceAliasMutationVariables, TContext>(
      ['UpdateTrackingSourceAlias'],
      (variables?: UpdateTrackingSourceAliasMutationVariables) => fetcher<UpdateTrackingSourceAliasMutation, UpdateTrackingSourceAliasMutationVariables>(UpdateTrackingSourceAliasDocument, variables)(),
      options
    )};

export const RemoveTrackingSourceAliasFromChassisSpecDocument = `
    mutation RemoveTrackingSourceAliasFromChassisSpec($id: MongoID!) {
  removeTrackingSourceAlias(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTrackingSourceAliasFromChassisSpecMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTrackingSourceAliasFromChassisSpecMutation, TError, RemoveTrackingSourceAliasFromChassisSpecMutationVariables, TContext>) => {
    
    return useMutation<RemoveTrackingSourceAliasFromChassisSpecMutation, TError, RemoveTrackingSourceAliasFromChassisSpecMutationVariables, TContext>(
      ['RemoveTrackingSourceAliasFromChassisSpec'],
      (variables?: RemoveTrackingSourceAliasFromChassisSpecMutationVariables) => fetcher<RemoveTrackingSourceAliasFromChassisSpecMutation, RemoveTrackingSourceAliasFromChassisSpecMutationVariables>(RemoveTrackingSourceAliasFromChassisSpecDocument, variables)(),
      options
    )};

export const GetBuildSheetStyleListForChassisSpecDocument = `
    query GetBuildSheetStyleListForChassisSpec {
  buildSheetStyles(perPage: 1000) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetBuildSheetStyleListForChassisSpecQuery = <
      TData = GetBuildSheetStyleListForChassisSpecQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBuildSheetStyleListForChassisSpecQueryVariables,
      options?: UseQueryOptions<GetBuildSheetStyleListForChassisSpecQuery, TError, TData>
    ) => {
    
    return useQuery<GetBuildSheetStyleListForChassisSpecQuery, TError, TData>(
      variables === undefined ? ['GetBuildSheetStyleListForChassisSpec'] : ['GetBuildSheetStyleListForChassisSpec', variables],
      fetcher<GetBuildSheetStyleListForChassisSpecQuery, GetBuildSheetStyleListForChassisSpecQueryVariables>(GetBuildSheetStyleListForChassisSpecDocument, variables),
      options
    )};

export const GetChassisSpecForIdPageDocument = `
    query GetChassisSpecForIdPage($id: MongoID!) {
  specification(_id: $id) {
    ...AllChassisSpecVars
  }
}
    ${AllChassisSpecVarsFragmentDoc}
${AeroPackageVarsFragmentDoc}
${AeroElementVarsFragmentDoc}
${AntiRollBarVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${AllChassisMeasurementSpecVarsFragmentDoc}
${CustomSpecVarsFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${MassPropertiesVarsFragmentDoc}
${DamperSpecVarsFragmentDoc}
${AllChassisSpecVarsIterationFragmentDoc}
${ExternalKinematicSpecVarsFragmentDoc}
${InternalKinematicSpecVarsFragmentDoc}
${ChassisMassVarsFragmentDoc}
${ChassisMeasurementVarsFragmentDoc}
${ChassisPowertrainVarsFragmentDoc}
${GearSpecVarsFragmentDoc}
${GearBoxSpecVarsFragmentDoc}
${DifferentialSpecVarsFragmentDoc}
${ChassisBrakeBiasVarsFragmentDoc}
${ChassisRegulationSetVarsFragmentDoc}`;

export const useGetChassisSpecForIdPageQuery = <
      TData = GetChassisSpecForIdPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpecForIdPageQueryVariables,
      options?: UseQueryOptions<GetChassisSpecForIdPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecForIdPageQuery, TError, TData>(
      ['GetChassisSpecForIdPage', variables],
      fetcher<GetChassisSpecForIdPageQuery, GetChassisSpecForIdPageQueryVariables>(GetChassisSpecForIdPageDocument, variables),
      options
    )};

export const GetReferencePackagesForChassisSpecDocument = `
    query GetReferencePackagesForChassisSpec($chassisSpecID: MongoID!) {
  packages(filter: {chassisSpecID: $chassisSpecID, useAsCopyReference: true}) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetReferencePackagesForChassisSpecQuery = <
      TData = GetReferencePackagesForChassisSpecQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetReferencePackagesForChassisSpecQueryVariables,
      options?: UseQueryOptions<GetReferencePackagesForChassisSpecQuery, TError, TData>
    ) => {
    
    return useQuery<GetReferencePackagesForChassisSpecQuery, TError, TData>(
      ['GetReferencePackagesForChassisSpec', variables],
      fetcher<GetReferencePackagesForChassisSpecQuery, GetReferencePackagesForChassisSpecQueryVariables>(GetReferencePackagesForChassisSpecDocument, variables),
      options
    )};

export const CompareChassisSpecsDocument = `
    query CompareChassisSpecs($chassisSpecId: MongoID!, $chassisSpecToCompareId: MongoID!) {
  compareChassisSpecs(
    chassisSpecID: $chassisSpecId
    chassisSpecToCompareID: $chassisSpecToCompareId
  )
}
    `;

export const useCompareChassisSpecsQuery = <
      TData = CompareChassisSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: CompareChassisSpecsQueryVariables,
      options?: UseQueryOptions<CompareChassisSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<CompareChassisSpecsQuery, TError, TData>(
      ['CompareChassisSpecs', variables],
      fetcher<CompareChassisSpecsQuery, CompareChassisSpecsQueryVariables>(CompareChassisSpecsDocument, variables),
      options
    )};

export const GetAllSpecificationsForChassisDocument = `
    query GetAllSpecificationsForChassis($chassisSpecID: MongoID) {
  specifications(filter: {chassisSpecID: $chassisSpecID}, perPage: 20000) {
    items {
      ... on AnySpecification {
        _id
        name
      }
    }
  }
}
    `;

export const useGetAllSpecificationsForChassisQuery = <
      TData = GetAllSpecificationsForChassisQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllSpecificationsForChassisQueryVariables,
      options?: UseQueryOptions<GetAllSpecificationsForChassisQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllSpecificationsForChassisQuery, TError, TData>(
      variables === undefined ? ['GetAllSpecificationsForChassis'] : ['GetAllSpecificationsForChassis', variables],
      fetcher<GetAllSpecificationsForChassisQuery, GetAllSpecificationsForChassisQueryVariables>(GetAllSpecificationsForChassisDocument, variables),
      options
    )};

export const EnforceLatestVersionChassisSpecVersionOnCarSetupsDocument = `
    mutation EnforceLatestVersionChassisSpecVersionOnCarSetups($rootSpecificationID: MongoID!, $timeRangeStart: Date, $timeRangeEnd: Date) {
  updateChassisSpecVersionOnCarSetups(
    rootSpecificationID: $rootSpecificationID
    timeRangeStart: $timeRangeStart
    timeRangeEnd: $timeRangeEnd
  ) {
    success
  }
}
    `;

export const useEnforceLatestVersionChassisSpecVersionOnCarSetupsMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<EnforceLatestVersionChassisSpecVersionOnCarSetupsMutation, TError, EnforceLatestVersionChassisSpecVersionOnCarSetupsMutationVariables, TContext>) => {
    
    return useMutation<EnforceLatestVersionChassisSpecVersionOnCarSetupsMutation, TError, EnforceLatestVersionChassisSpecVersionOnCarSetupsMutationVariables, TContext>(
      ['EnforceLatestVersionChassisSpecVersionOnCarSetups'],
      (variables?: EnforceLatestVersionChassisSpecVersionOnCarSetupsMutationVariables) => fetcher<EnforceLatestVersionChassisSpecVersionOnCarSetupsMutation, EnforceLatestVersionChassisSpecVersionOnCarSetupsMutationVariables>(EnforceLatestVersionChassisSpecVersionOnCarSetupsDocument, variables)(),
      options
    )};

export const GetChassisSpecByIdForChassisSpecEditPageDocument = `
    query GetChassisSpecByIdForChassisSpecEditPage($id: MongoID!) {
  specification(_id: $id) {
    ...AllChassisSpecVars
  }
}
    ${AllChassisSpecVarsFragmentDoc}
${AeroPackageVarsFragmentDoc}
${AeroElementVarsFragmentDoc}
${AntiRollBarVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${AllChassisMeasurementSpecVarsFragmentDoc}
${CustomSpecVarsFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${MassPropertiesVarsFragmentDoc}
${DamperSpecVarsFragmentDoc}
${AllChassisSpecVarsIterationFragmentDoc}
${ExternalKinematicSpecVarsFragmentDoc}
${InternalKinematicSpecVarsFragmentDoc}
${ChassisMassVarsFragmentDoc}
${ChassisMeasurementVarsFragmentDoc}
${ChassisPowertrainVarsFragmentDoc}
${GearSpecVarsFragmentDoc}
${GearBoxSpecVarsFragmentDoc}
${DifferentialSpecVarsFragmentDoc}
${ChassisBrakeBiasVarsFragmentDoc}
${ChassisRegulationSetVarsFragmentDoc}`;

export const useGetChassisSpecByIdForChassisSpecEditPageQuery = <
      TData = GetChassisSpecByIdForChassisSpecEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpecByIdForChassisSpecEditPageQueryVariables,
      options?: UseQueryOptions<GetChassisSpecByIdForChassisSpecEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecByIdForChassisSpecEditPageQuery, TError, TData>(
      ['GetChassisSpecByIdForChassisSpecEditPage', variables],
      fetcher<GetChassisSpecByIdForChassisSpecEditPageQuery, GetChassisSpecByIdForChassisSpecEditPageQueryVariables>(GetChassisSpecByIdForChassisSpecEditPageDocument, variables),
      options
    )};

export const GetCarDataServiceCalculationsForCarDataServiceConfigDocument = `
    query GetCarDataServiceCalculationsForCarDataServiceConfig($perPage: Int!, $page: Int, $sort: SortFindManyCalculationInput, $filter: FilterFindManyCalculationInput!) {
  calculations(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ...CalculationVarsForCarDataServiceCalculationPage
    }
  }
}
    ${CalculationVarsForCarDataServiceCalculationPageFragmentDoc}`;

export const useGetCarDataServiceCalculationsForCarDataServiceConfigQuery = <
      TData = GetCarDataServiceCalculationsForCarDataServiceConfigQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCarDataServiceCalculationsForCarDataServiceConfigQueryVariables,
      options?: UseQueryOptions<GetCarDataServiceCalculationsForCarDataServiceConfigQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarDataServiceCalculationsForCarDataServiceConfigQuery, TError, TData>(
      ['GetCarDataServiceCalculationsForCarDataServiceConfig', variables],
      fetcher<GetCarDataServiceCalculationsForCarDataServiceConfigQuery, GetCarDataServiceCalculationsForCarDataServiceConfigQueryVariables>(GetCarDataServiceCalculationsForCarDataServiceConfigDocument, variables),
      options
    )};

export const GetCalculationParameterNamesForDataServiceConfigDocument = `
    query GetCalculationParameterNamesForDataServiceConfig($ids: [MongoID!]) {
  calculations(filter: {_operators: {_id: {in: $ids}}}, perPage: 20000) {
    items {
      parameter
    }
  }
}
    `;

export const useGetCalculationParameterNamesForDataServiceConfigQuery = <
      TData = GetCalculationParameterNamesForDataServiceConfigQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetCalculationParameterNamesForDataServiceConfigQueryVariables,
      options?: UseQueryOptions<GetCalculationParameterNamesForDataServiceConfigQuery, TError, TData>
    ) => {
    
    return useQuery<GetCalculationParameterNamesForDataServiceConfigQuery, TError, TData>(
      variables === undefined ? ['GetCalculationParameterNamesForDataServiceConfig'] : ['GetCalculationParameterNamesForDataServiceConfig', variables],
      fetcher<GetCalculationParameterNamesForDataServiceConfigQuery, GetCalculationParameterNamesForDataServiceConfigQueryVariables>(GetCalculationParameterNamesForDataServiceConfigDocument, variables),
      options
    )};

export const GetCarDataServiceConfigForDownloadButtonDocument = `
    query GetCarDataServiceConfigForDownloadButton($id: MongoID!) {
  carDataServiceConfig(_id: $id) {
    ...carDataServiceConfigForDownloadButtonVars
  }
}
    ${CarDataServiceConfigForDownloadButtonVarsFragmentDoc}`;

export const useGetCarDataServiceConfigForDownloadButtonQuery = <
      TData = GetCarDataServiceConfigForDownloadButtonQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCarDataServiceConfigForDownloadButtonQueryVariables,
      options?: UseQueryOptions<GetCarDataServiceConfigForDownloadButtonQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarDataServiceConfigForDownloadButtonQuery, TError, TData>(
      ['GetCarDataServiceConfigForDownloadButton', variables],
      fetcher<GetCarDataServiceConfigForDownloadButtonQuery, GetCarDataServiceConfigForDownloadButtonQueryVariables>(GetCarDataServiceConfigForDownloadButtonDocument, variables),
      options
    )};

export const AddCarDataServiceConfigForUploadCarDataServiceConfigButtonDocument = `
    mutation AddCarDataServiceConfigForUploadCarDataServiceConfigButton($record: CreateOneCarDataServiceConfigInput!) {
  addCarDataServiceConfig(record: $record) {
    recordId
  }
}
    `;

export const useAddCarDataServiceConfigForUploadCarDataServiceConfigButtonMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddCarDataServiceConfigForUploadCarDataServiceConfigButtonMutation, TError, AddCarDataServiceConfigForUploadCarDataServiceConfigButtonMutationVariables, TContext>) => {
    
    return useMutation<AddCarDataServiceConfigForUploadCarDataServiceConfigButtonMutation, TError, AddCarDataServiceConfigForUploadCarDataServiceConfigButtonMutationVariables, TContext>(
      ['AddCarDataServiceConfigForUploadCarDataServiceConfigButton'],
      (variables?: AddCarDataServiceConfigForUploadCarDataServiceConfigButtonMutationVariables) => fetcher<AddCarDataServiceConfigForUploadCarDataServiceConfigButtonMutation, AddCarDataServiceConfigForUploadCarDataServiceConfigButtonMutationVariables>(AddCarDataServiceConfigForUploadCarDataServiceConfigButtonDocument, variables)(),
      options
    )};

export const CarDataServiceConfig_CreateNewConfigDocument = `
    mutation carDataServiceConfig_createNewConfig($record: CreateOneCarDataServiceConfigInput!) {
  addCarDataServiceConfig(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useCarDataServiceConfig_CreateNewConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CarDataServiceConfig_CreateNewConfigMutation, TError, CarDataServiceConfig_CreateNewConfigMutationVariables, TContext>) => {
    
    return useMutation<CarDataServiceConfig_CreateNewConfigMutation, TError, CarDataServiceConfig_CreateNewConfigMutationVariables, TContext>(
      ['carDataServiceConfig_createNewConfig'],
      (variables?: CarDataServiceConfig_CreateNewConfigMutationVariables) => fetcher<CarDataServiceConfig_CreateNewConfigMutation, CarDataServiceConfig_CreateNewConfigMutationVariables>(CarDataServiceConfig_CreateNewConfigDocument, variables)(),
      options
    )};

export const GetTimingServiceConfigsDocument = `
    query GetTimingServiceConfigs {
  timingServiceConfigs {
    items {
      _id
      name
      timingPort
      timingRaceSeries
      timingURL
      active
      eventID
    }
  }
}
    `;

export const useGetTimingServiceConfigsQuery = <
      TData = GetTimingServiceConfigsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTimingServiceConfigsQueryVariables,
      options?: UseQueryOptions<GetTimingServiceConfigsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTimingServiceConfigsQuery, TError, TData>(
      variables === undefined ? ['GetTimingServiceConfigs'] : ['GetTimingServiceConfigs', variables],
      fetcher<GetTimingServiceConfigsQuery, GetTimingServiceConfigsQueryVariables>(GetTimingServiceConfigsDocument, variables),
      options
    )};

export const GetTimingServiceConfigForTimingServiceConfigPageDocument = `
    query GetTimingServiceConfigForTimingServiceConfigPage($id: MongoID!) {
  timingServiceConfig(_id: $id) {
    _id
    active
    createdAt
    description
    eventID
    fallbackScheduleBasedSessionMatching
    fallbackTimedSectorsCount
    followedCarNumbers
    liveStandingsActive
    logLevel
    logStream
    name
    strictSessionNameMatching
    timingPort
    timingRaceSeries
    timingURL
    updatedAt
    writeData
  }
}
    `;

export const useGetTimingServiceConfigForTimingServiceConfigPageQuery = <
      TData = GetTimingServiceConfigForTimingServiceConfigPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTimingServiceConfigForTimingServiceConfigPageQueryVariables,
      options?: UseQueryOptions<GetTimingServiceConfigForTimingServiceConfigPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTimingServiceConfigForTimingServiceConfigPageQuery, TError, TData>(
      ['GetTimingServiceConfigForTimingServiceConfigPage', variables],
      fetcher<GetTimingServiceConfigForTimingServiceConfigPageQuery, GetTimingServiceConfigForTimingServiceConfigPageQueryVariables>(GetTimingServiceConfigForTimingServiceConfigPageDocument, variables),
      options
    )};

export const UpdateTimingServiceConfigForMultipleEventsControllerDocument = `
    mutation UpdateTimingServiceConfigForMultipleEventsController($id: MongoID!, $record: UpdateByIdTimingServiceConfigInput!) {
  updateTimingServiceConfig(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTimingServiceConfigForMultipleEventsControllerMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTimingServiceConfigForMultipleEventsControllerMutation, TError, UpdateTimingServiceConfigForMultipleEventsControllerMutationVariables, TContext>) => {
    
    return useMutation<UpdateTimingServiceConfigForMultipleEventsControllerMutation, TError, UpdateTimingServiceConfigForMultipleEventsControllerMutationVariables, TContext>(
      ['UpdateTimingServiceConfigForMultipleEventsController'],
      (variables?: UpdateTimingServiceConfigForMultipleEventsControllerMutationVariables) => fetcher<UpdateTimingServiceConfigForMultipleEventsControllerMutation, UpdateTimingServiceConfigForMultipleEventsControllerMutationVariables>(UpdateTimingServiceConfigForMultipleEventsControllerDocument, variables)(),
      options
    )};

export const RemoveTimingServiceConfigForMultipleEventsControllerDocument = `
    mutation RemoveTimingServiceConfigForMultipleEventsController($id: MongoID!) {
  removeTimingServiceConfig(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTimingServiceConfigForMultipleEventsControllerMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTimingServiceConfigForMultipleEventsControllerMutation, TError, RemoveTimingServiceConfigForMultipleEventsControllerMutationVariables, TContext>) => {
    
    return useMutation<RemoveTimingServiceConfigForMultipleEventsControllerMutation, TError, RemoveTimingServiceConfigForMultipleEventsControllerMutationVariables, TContext>(
      ['RemoveTimingServiceConfigForMultipleEventsController'],
      (variables?: RemoveTimingServiceConfigForMultipleEventsControllerMutationVariables) => fetcher<RemoveTimingServiceConfigForMultipleEventsControllerMutation, RemoveTimingServiceConfigForMultipleEventsControllerMutationVariables>(RemoveTimingServiceConfigForMultipleEventsControllerDocument, variables)(),
      options
    )};

export const SetAllTimingServiceConfigsInactiveDocument = `
    mutation SetAllTimingServiceConfigsInactive {
  setAllTimingServiceConfigsInactive {
    modifiedCount
  }
}
    `;

export const useSetAllTimingServiceConfigsInactiveMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<SetAllTimingServiceConfigsInactiveMutation, TError, SetAllTimingServiceConfigsInactiveMutationVariables, TContext>) => {
    
    return useMutation<SetAllTimingServiceConfigsInactiveMutation, TError, SetAllTimingServiceConfigsInactiveMutationVariables, TContext>(
      ['SetAllTimingServiceConfigsInactive'],
      (variables?: SetAllTimingServiceConfigsInactiveMutationVariables) => fetcher<SetAllTimingServiceConfigsInactiveMutation, SetAllTimingServiceConfigsInactiveMutationVariables>(SetAllTimingServiceConfigsInactiveDocument, variables)(),
      options
    )};

export const GetSessionNamesForTimingConfigDocument = `
    query GetSessionNamesForTimingConfig($id: MongoID!) {
  event(_id: $id) {
    sessions {
      ...SessionInfoVarsForTimingConfigPage
    }
  }
}
    ${SessionInfoVarsForTimingConfigPageFragmentDoc}`;

export const useGetSessionNamesForTimingConfigQuery = <
      TData = GetSessionNamesForTimingConfigQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSessionNamesForTimingConfigQueryVariables,
      options?: UseQueryOptions<GetSessionNamesForTimingConfigQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionNamesForTimingConfigQuery, TError, TData>(
      ['GetSessionNamesForTimingConfig', variables],
      fetcher<GetSessionNamesForTimingConfigQuery, GetSessionNamesForTimingConfigQueryVariables>(GetSessionNamesForTimingConfigDocument, variables),
      options
    )};

export const GetEventNameForTimingConfigDocument = `
    query GetEventNameForTimingConfig($id: MongoID!) {
  event(_id: $id) {
    name
  }
}
    `;

export const useGetEventNameForTimingConfigQuery = <
      TData = GetEventNameForTimingConfigQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventNameForTimingConfigQueryVariables,
      options?: UseQueryOptions<GetEventNameForTimingConfigQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventNameForTimingConfigQuery, TError, TData>(
      ['GetEventNameForTimingConfig', variables],
      fetcher<GetEventNameForTimingConfigQuery, GetEventNameForTimingConfigQueryVariables>(GetEventNameForTimingConfigDocument, variables),
      options
    )};

export const GetOneTimingWeatherServiceConfigDocument = `
    query GetOneTimingWeatherServiceConfig($id: MongoID!) {
  oneTimingWeatherServiceConfig(_id: $id) {
    ...OneTimingWeatherConfigVars
  }
}
    ${OneTimingWeatherConfigVarsFragmentDoc}`;

export const useGetOneTimingWeatherServiceConfigQuery = <
      TData = GetOneTimingWeatherServiceConfigQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetOneTimingWeatherServiceConfigQueryVariables,
      options?: UseQueryOptions<GetOneTimingWeatherServiceConfigQuery, TError, TData>
    ) => {
    
    return useQuery<GetOneTimingWeatherServiceConfigQuery, TError, TData>(
      ['GetOneTimingWeatherServiceConfig', variables],
      fetcher<GetOneTimingWeatherServiceConfigQuery, GetOneTimingWeatherServiceConfigQueryVariables>(GetOneTimingWeatherServiceConfigDocument, variables),
      options
    )};

export const GetOneTimingWeatherConfigsForAgentPageDocument = `
    query GetOneTimingWeatherConfigsForAgentPage {
  oneTimingWeatherServiceConfigs {
    items {
      ...OneTimingWeatherConfigVars
    }
  }
}
    ${OneTimingWeatherConfigVarsFragmentDoc}`;

export const useGetOneTimingWeatherConfigsForAgentPageQuery = <
      TData = GetOneTimingWeatherConfigsForAgentPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetOneTimingWeatherConfigsForAgentPageQueryVariables,
      options?: UseQueryOptions<GetOneTimingWeatherConfigsForAgentPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetOneTimingWeatherConfigsForAgentPageQuery, TError, TData>(
      variables === undefined ? ['GetOneTimingWeatherConfigsForAgentPage'] : ['GetOneTimingWeatherConfigsForAgentPage', variables],
      fetcher<GetOneTimingWeatherConfigsForAgentPageQuery, GetOneTimingWeatherConfigsForAgentPageQueryVariables>(GetOneTimingWeatherConfigsForAgentPageDocument, variables),
      options
    )};

export const OneTimingWeatherServiceConfigUpdatedDocument = `
    subscription OneTimingWeatherServiceConfigUpdated($configID: MongoID!) {
  oneTimingWeatherServiceConfigUpdated(weatherServiceConfigID: $configID) {
    ...OneTimingWeatherConfigVars
  }
}
    ${OneTimingWeatherConfigVarsFragmentDoc}`;
export const RemoveOneTimingWeatherServiceConfigDocument = `
    mutation RemoveOneTimingWeatherServiceConfig($configID: MongoID!) {
  removeOneTimingWeatherServiceConfig(_id: $configID) {
    recordId
  }
}
    `;

export const useRemoveOneTimingWeatherServiceConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveOneTimingWeatherServiceConfigMutation, TError, RemoveOneTimingWeatherServiceConfigMutationVariables, TContext>) => {
    
    return useMutation<RemoveOneTimingWeatherServiceConfigMutation, TError, RemoveOneTimingWeatherServiceConfigMutationVariables, TContext>(
      ['RemoveOneTimingWeatherServiceConfig'],
      (variables?: RemoveOneTimingWeatherServiceConfigMutationVariables) => fetcher<RemoveOneTimingWeatherServiceConfigMutation, RemoveOneTimingWeatherServiceConfigMutationVariables>(RemoveOneTimingWeatherServiceConfigDocument, variables)(),
      options
    )};

export const UpdateOneTimingWeatherServiceConfigDocument = `
    mutation UpdateOneTimingWeatherServiceConfig($id: MongoID!, $record: UpdateByIdOneTimingWeatherServiceConfigInput!) {
  updateOneTimingWeatherServiceConfig(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateOneTimingWeatherServiceConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOneTimingWeatherServiceConfigMutation, TError, UpdateOneTimingWeatherServiceConfigMutationVariables, TContext>) => {
    
    return useMutation<UpdateOneTimingWeatherServiceConfigMutation, TError, UpdateOneTimingWeatherServiceConfigMutationVariables, TContext>(
      ['UpdateOneTimingWeatherServiceConfig'],
      (variables?: UpdateOneTimingWeatherServiceConfigMutationVariables) => fetcher<UpdateOneTimingWeatherServiceConfigMutation, UpdateOneTimingWeatherServiceConfigMutationVariables>(UpdateOneTimingWeatherServiceConfigDocument, variables)(),
      options
    )};

export const AddOneTimingWeatherServiceConfigDocument = `
    mutation AddOneTimingWeatherServiceConfig($record: CreateOneOneTimingWeatherServiceConfigInput!) {
  addOneTimingWeatherServiceConfig(record: $record) {
    recordId
  }
}
    `;

export const useAddOneTimingWeatherServiceConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddOneTimingWeatherServiceConfigMutation, TError, AddOneTimingWeatherServiceConfigMutationVariables, TContext>) => {
    
    return useMutation<AddOneTimingWeatherServiceConfigMutation, TError, AddOneTimingWeatherServiceConfigMutationVariables, TContext>(
      ['AddOneTimingWeatherServiceConfig'],
      (variables?: AddOneTimingWeatherServiceConfigMutationVariables) => fetcher<AddOneTimingWeatherServiceConfigMutation, AddOneTimingWeatherServiceConfigMutationVariables>(AddOneTimingWeatherServiceConfigDocument, variables)(),
      options
    )};

export const AddHistoricalWeatherDocument = `
    mutation AddHistoricalWeather($weatherServiceConfigID: MongoID!) {
  addHistoricalWeather(weatherServiceConfigID: $weatherServiceConfigID) {
    _id
  }
}
    `;

export const useAddHistoricalWeatherMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddHistoricalWeatherMutation, TError, AddHistoricalWeatherMutationVariables, TContext>) => {
    
    return useMutation<AddHistoricalWeatherMutation, TError, AddHistoricalWeatherMutationVariables, TContext>(
      ['AddHistoricalWeather'],
      (variables?: AddHistoricalWeatherMutationVariables) => fetcher<AddHistoricalWeatherMutation, AddHistoricalWeatherMutationVariables>(AddHistoricalWeatherDocument, variables)(),
      options
    )};

export const GetWeatherServiceConfigDocument = `
    query GetWeatherServiceConfig($id: MongoID!) {
  weatherServiceConfig(_id: $id) {
    ...WeatherServiceConfigVars
  }
}
    ${WeatherServiceConfigVarsFragmentDoc}`;

export const useGetWeatherServiceConfigQuery = <
      TData = GetWeatherServiceConfigQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetWeatherServiceConfigQueryVariables,
      options?: UseQueryOptions<GetWeatherServiceConfigQuery, TError, TData>
    ) => {
    
    return useQuery<GetWeatherServiceConfigQuery, TError, TData>(
      ['GetWeatherServiceConfig', variables],
      fetcher<GetWeatherServiceConfigQuery, GetWeatherServiceConfigQueryVariables>(GetWeatherServiceConfigDocument, variables),
      options
    )};

export const GetWeatherServiceConfigsDocument = `
    query GetWeatherServiceConfigs {
  weatherServiceConfigs {
    items {
      ...WeatherServiceConfigVars
      events {
        name
      }
    }
  }
}
    ${WeatherServiceConfigVarsFragmentDoc}`;

export const useGetWeatherServiceConfigsQuery = <
      TData = GetWeatherServiceConfigsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetWeatherServiceConfigsQueryVariables,
      options?: UseQueryOptions<GetWeatherServiceConfigsQuery, TError, TData>
    ) => {
    
    return useQuery<GetWeatherServiceConfigsQuery, TError, TData>(
      variables === undefined ? ['GetWeatherServiceConfigs'] : ['GetWeatherServiceConfigs', variables],
      fetcher<GetWeatherServiceConfigsQuery, GetWeatherServiceConfigsQueryVariables>(GetWeatherServiceConfigsDocument, variables),
      options
    )};

export const UpdateWeatherServiceConfigDocument = `
    mutation UpdateWeatherServiceConfig($id: MongoID!, $record: UpdateByIdWeatherServiceConfigInput!) {
  updateWeatherServiceConfig(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateWeatherServiceConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWeatherServiceConfigMutation, TError, UpdateWeatherServiceConfigMutationVariables, TContext>) => {
    
    return useMutation<UpdateWeatherServiceConfigMutation, TError, UpdateWeatherServiceConfigMutationVariables, TContext>(
      ['UpdateWeatherServiceConfig'],
      (variables?: UpdateWeatherServiceConfigMutationVariables) => fetcher<UpdateWeatherServiceConfigMutation, UpdateWeatherServiceConfigMutationVariables>(UpdateWeatherServiceConfigDocument, variables)(),
      options
    )};

export const WeatherServiceConfigUpdatedDocument = `
    subscription WeatherServiceConfigUpdated($weatherServiceConfigID: MongoID!) {
  weatherServiceConfigUpdated(weatherServiceConfigID: $weatherServiceConfigID) {
    _id
    isActive
  }
}
    `;
export const CreateWeatherServiceConfigDocument = `
    mutation CreateWeatherServiceConfig($record: CreateOneWeatherServiceConfigInput!) {
  addWeatherServiceConfig(record: $record) {
    recordId
  }
}
    `;

export const useCreateWeatherServiceConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CreateWeatherServiceConfigMutation, TError, CreateWeatherServiceConfigMutationVariables, TContext>) => {
    
    return useMutation<CreateWeatherServiceConfigMutation, TError, CreateWeatherServiceConfigMutationVariables, TContext>(
      ['CreateWeatherServiceConfig'],
      (variables?: CreateWeatherServiceConfigMutationVariables) => fetcher<CreateWeatherServiceConfigMutation, CreateWeatherServiceConfigMutationVariables>(CreateWeatherServiceConfigDocument, variables)(),
      options
    )};

export const RemoveWeatherServiceConfigDocument = `
    mutation RemoveWeatherServiceConfig($id: MongoID!) {
  removeWeatherServiceConfig(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveWeatherServiceConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveWeatherServiceConfigMutation, TError, RemoveWeatherServiceConfigMutationVariables, TContext>) => {
    
    return useMutation<RemoveWeatherServiceConfigMutation, TError, RemoveWeatherServiceConfigMutationVariables, TContext>(
      ['RemoveWeatherServiceConfig'],
      (variables?: RemoveWeatherServiceConfigMutationVariables) => fetcher<RemoveWeatherServiceConfigMutation, RemoveWeatherServiceConfigMutationVariables>(RemoveWeatherServiceConfigDocument, variables)(),
      options
    )};

export const GetDataOverviewCarSetupsDocument = `
    query GetDataOverviewCarSetups($filter: FilterFindManyCarSetupInput!, $perPage: Int!, $page: Int, $sort: SortFindManyCarSetupInput) {
  carSetups(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      title
      runSheet {
        _id
        NRun
        session {
          _id
          name
          event {
            _id
            name
          }
        }
      }
      info {
        NIssue
      }
      engineer {
        _id
        name
      }
    }
  }
}
    `;

export const useGetDataOverviewCarSetupsQuery = <
      TData = GetDataOverviewCarSetupsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetDataOverviewCarSetupsQueryVariables,
      options?: UseQueryOptions<GetDataOverviewCarSetupsQuery, TError, TData>
    ) => {
    
    return useQuery<GetDataOverviewCarSetupsQuery, TError, TData>(
      ['GetDataOverviewCarSetups', variables],
      fetcher<GetDataOverviewCarSetupsQuery, GetDataOverviewCarSetupsQueryVariables>(GetDataOverviewCarSetupsDocument, variables),
      options
    )};

export const GetDataOverviewTyresDocument = `
    query GetDataOverviewTyres($filter: FilterFindManyTyreInput!, $perPage: Int!, $page: Int, $sort: SortFindManyTyreInput) {
  tyres(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      name
    }
  }
}
    `;

export const useGetDataOverviewTyresQuery = <
      TData = GetDataOverviewTyresQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetDataOverviewTyresQueryVariables,
      options?: UseQueryOptions<GetDataOverviewTyresQuery, TError, TData>
    ) => {
    
    return useQuery<GetDataOverviewTyresQuery, TError, TData>(
      ['GetDataOverviewTyres', variables],
      fetcher<GetDataOverviewTyresQuery, GetDataOverviewTyresQueryVariables>(GetDataOverviewTyresDocument, variables),
      options
    )};

export const GetTyreWearsForTyrePageDocument = `
    query GetTyreWearsForTyrePage($filter: FilterFindManyTyreWearInput!) {
  tyreWears(filter: $filter) {
    items {
      ...TyreWearItemsForTyreWearListVars
    }
  }
}
    ${TyreWearItemsForTyreWearListVarsFragmentDoc}`;

export const useGetTyreWearsForTyrePageQuery = <
      TData = GetTyreWearsForTyrePageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTyreWearsForTyrePageQueryVariables,
      options?: UseQueryOptions<GetTyreWearsForTyrePageQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreWearsForTyrePageQuery, TError, TData>(
      ['GetTyreWearsForTyrePage', variables],
      fetcher<GetTyreWearsForTyrePageQuery, GetTyreWearsForTyrePageQueryVariables>(GetTyreWearsForTyrePageDocument, variables),
      options
    )};

export const GetSsoProviderSetupListDocument = `
    query GetSsoProviderSetupList {
  ssoProviders {
    _id
    name
    clientID
    clientSecret
    issuerURL
  }
}
    `;

export const useGetSsoProviderSetupListQuery = <
      TData = GetSsoProviderSetupListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSsoProviderSetupListQueryVariables,
      options?: UseQueryOptions<GetSsoProviderSetupListQuery, TError, TData>
    ) => {
    
    return useQuery<GetSsoProviderSetupListQuery, TError, TData>(
      variables === undefined ? ['GetSsoProviderSetupList'] : ['GetSsoProviderSetupList', variables],
      fetcher<GetSsoProviderSetupListQuery, GetSsoProviderSetupListQueryVariables>(GetSsoProviderSetupListDocument, variables),
      options
    )};

export const AddSsoProviderDocument = `
    mutation AddSsoProvider($name: String!, $issuerURL: String!, $clientID: String!, $clientSecret: String!) {
  addSsoProvider(
    record: {name: $name, issuerURL: $issuerURL, clientID: $clientID, clientSecret: $clientSecret}
  ) {
    record {
      _id
      name
      issuerURL
      clientID
      clientSecret
    }
    error {
      message
    }
  }
}
    `;

export const useAddSsoProviderMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddSsoProviderMutation, TError, AddSsoProviderMutationVariables, TContext>) => {
    
    return useMutation<AddSsoProviderMutation, TError, AddSsoProviderMutationVariables, TContext>(
      ['AddSsoProvider'],
      (variables?: AddSsoProviderMutationVariables) => fetcher<AddSsoProviderMutation, AddSsoProviderMutationVariables>(AddSsoProviderDocument, variables)(),
      options
    )};

export const RemoveSsoProviderDocument = `
    mutation RemoveSsoProvider($id: MongoID!) {
  removeSsoProvider(_id: $id) {
    recordId
    error {
      message
    }
  }
}
    `;

export const useRemoveSsoProviderMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSsoProviderMutation, TError, RemoveSsoProviderMutationVariables, TContext>) => {
    
    return useMutation<RemoveSsoProviderMutation, TError, RemoveSsoProviderMutationVariables, TContext>(
      ['RemoveSsoProvider'],
      (variables?: RemoveSsoProviderMutationVariables) => fetcher<RemoveSsoProviderMutation, RemoveSsoProviderMutationVariables>(RemoveSsoProviderDocument, variables)(),
      options
    )};

export const GetAssemblyTemplatesForAssemblyTemplateListDocument = `
    query GetAssemblyTemplatesForAssemblyTemplateList {
  assemblyTemplates {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetAssemblyTemplatesForAssemblyTemplateListQuery = <
      TData = GetAssemblyTemplatesForAssemblyTemplateListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAssemblyTemplatesForAssemblyTemplateListQueryVariables,
      options?: UseQueryOptions<GetAssemblyTemplatesForAssemblyTemplateListQuery, TError, TData>
    ) => {
    
    return useQuery<GetAssemblyTemplatesForAssemblyTemplateListQuery, TError, TData>(
      variables === undefined ? ['GetAssemblyTemplatesForAssemblyTemplateList'] : ['GetAssemblyTemplatesForAssemblyTemplateList', variables],
      fetcher<GetAssemblyTemplatesForAssemblyTemplateListQuery, GetAssemblyTemplatesForAssemblyTemplateListQueryVariables>(GetAssemblyTemplatesForAssemblyTemplateListDocument, variables),
      options
    )};

export const GetAssemblyTemplateForAssemblyTemplateEditPageDocument = `
    query GetAssemblyTemplateForAssemblyTemplateEditPage($id: MongoID!) {
  assemblyTemplate(_id: $id) {
    _id
    description
    name
    requiredParts {
      location
      userEnumPartTypeID
    }
  }
}
    `;

export const useGetAssemblyTemplateForAssemblyTemplateEditPageQuery = <
      TData = GetAssemblyTemplateForAssemblyTemplateEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAssemblyTemplateForAssemblyTemplateEditPageQueryVariables,
      options?: UseQueryOptions<GetAssemblyTemplateForAssemblyTemplateEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetAssemblyTemplateForAssemblyTemplateEditPageQuery, TError, TData>(
      ['GetAssemblyTemplateForAssemblyTemplateEditPage', variables],
      fetcher<GetAssemblyTemplateForAssemblyTemplateEditPageQuery, GetAssemblyTemplateForAssemblyTemplateEditPageQueryVariables>(GetAssemblyTemplateForAssemblyTemplateEditPageDocument, variables),
      options
    )};

export const GetPartTypeUserEnumsForAssemblyTemplateEditPageDocument = `
    query GetPartTypeUserEnumsForAssemblyTemplateEditPage {
  userEnums(perPage: 2000, filter: {type: USER_ENUM_PART_TYPE}) {
    items {
      ... on UserEnumPartType {
        _id
        name
        type
      }
    }
  }
}
    `;

export const useGetPartTypeUserEnumsForAssemblyTemplateEditPageQuery = <
      TData = GetPartTypeUserEnumsForAssemblyTemplateEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPartTypeUserEnumsForAssemblyTemplateEditPageQueryVariables,
      options?: UseQueryOptions<GetPartTypeUserEnumsForAssemblyTemplateEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartTypeUserEnumsForAssemblyTemplateEditPageQuery, TError, TData>(
      variables === undefined ? ['GetPartTypeUserEnumsForAssemblyTemplateEditPage'] : ['GetPartTypeUserEnumsForAssemblyTemplateEditPage', variables],
      fetcher<GetPartTypeUserEnumsForAssemblyTemplateEditPageQuery, GetPartTypeUserEnumsForAssemblyTemplateEditPageQueryVariables>(GetPartTypeUserEnumsForAssemblyTemplateEditPageDocument, variables),
      options
    )};

export const GetCalculationsForCalculationManagerPageDocument = `
    query GetCalculationsForCalculationManagerPage($filter: FilterFindManyCalculationInput!, $perPage: Int!, $page: Int, $sort: SortFindManyCalculationInput) {
  calculations(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ...CalculationVars
    }
  }
}
    ${CalculationVarsFragmentDoc}`;

export const useGetCalculationsForCalculationManagerPageQuery = <
      TData = GetCalculationsForCalculationManagerPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCalculationsForCalculationManagerPageQueryVariables,
      options?: UseQueryOptions<GetCalculationsForCalculationManagerPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetCalculationsForCalculationManagerPageQuery, TError, TData>(
      ['GetCalculationsForCalculationManagerPage', variables],
      fetcher<GetCalculationsForCalculationManagerPageQuery, GetCalculationsForCalculationManagerPageQueryVariables>(GetCalculationsForCalculationManagerPageDocument, variables),
      options
    )};

export const GetLapSequenceListForTemplatePageDocument = `
    query GetLapSequenceListForTemplatePage($filter: FilterFindManyLapSequenceInput!, $perPage: Int!, $page: Int, $sort: SortFindManyLapSequenceInput) {
  lapSequences(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ...LapSequenceVars
    }
  }
}
    ${LapSequenceVarsFragmentDoc}`;

export const useGetLapSequenceListForTemplatePageQuery = <
      TData = GetLapSequenceListForTemplatePageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetLapSequenceListForTemplatePageQueryVariables,
      options?: UseQueryOptions<GetLapSequenceListForTemplatePageQuery, TError, TData>
    ) => {
    
    return useQuery<GetLapSequenceListForTemplatePageQuery, TError, TData>(
      ['GetLapSequenceListForTemplatePage', variables],
      fetcher<GetLapSequenceListForTemplatePageQuery, GetLapSequenceListForTemplatePageQueryVariables>(GetLapSequenceListForTemplatePageDocument, variables),
      options
    )};

export const UpdateLapSequenceDocument = `
    mutation UpdateLapSequence($id: MongoID!, $record: UpdateByIdLapSequenceInput!) {
  updateLapSequence(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateLapSequenceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLapSequenceMutation, TError, UpdateLapSequenceMutationVariables, TContext>) => {
    
    return useMutation<UpdateLapSequenceMutation, TError, UpdateLapSequenceMutationVariables, TContext>(
      ['UpdateLapSequence'],
      (variables?: UpdateLapSequenceMutationVariables) => fetcher<UpdateLapSequenceMutation, UpdateLapSequenceMutationVariables>(UpdateLapSequenceDocument, variables)(),
      options
    )};

export const RemoveLapSequenceDocument = `
    mutation RemoveLapSequence($id: MongoID!) {
  removeLapSequence(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveLapSequenceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveLapSequenceMutation, TError, RemoveLapSequenceMutationVariables, TContext>) => {
    
    return useMutation<RemoveLapSequenceMutation, TError, RemoveLapSequenceMutationVariables, TContext>(
      ['RemoveLapSequence'],
      (variables?: RemoveLapSequenceMutationVariables) => fetcher<RemoveLapSequenceMutation, RemoveLapSequenceMutationVariables>(RemoveLapSequenceDocument, variables)(),
      options
    )};

export const GetPackagesForApplyPackagesPageDocument = `
    query GetPackagesForApplyPackagesPage($filter: FilterFindManyPackageInput) {
  packages(filter: $filter) {
    items {
      _id
      chassisSpecID
      name
      chassisSpec {
        name
      }
    }
  }
}
    `;

export const useGetPackagesForApplyPackagesPageQuery = <
      TData = GetPackagesForApplyPackagesPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPackagesForApplyPackagesPageQueryVariables,
      options?: UseQueryOptions<GetPackagesForApplyPackagesPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetPackagesForApplyPackagesPageQuery, TError, TData>(
      variables === undefined ? ['GetPackagesForApplyPackagesPage'] : ['GetPackagesForApplyPackagesPage', variables],
      fetcher<GetPackagesForApplyPackagesPageQuery, GetPackagesForApplyPackagesPageQueryVariables>(GetPackagesForApplyPackagesPageDocument, variables),
      options
    )};

export const GetCarSetupChassisSpecsByEventIdDocument = `
    query GetCarSetupChassisSpecsByEventID($filter: FilterFindManyCarSetupInput) {
  carSetupsMany(filter: $filter) {
    _id
    title
    chassisSpec {
      _id
      name
      version
    }
    runSheet {
      NRun
      session {
        name
        shortName
        event {
          name
        }
      }
    }
  }
}
    `;

export const useGetCarSetupChassisSpecsByEventIdQuery = <
      TData = GetCarSetupChassisSpecsByEventIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetCarSetupChassisSpecsByEventIdQueryVariables,
      options?: UseQueryOptions<GetCarSetupChassisSpecsByEventIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarSetupChassisSpecsByEventIdQuery, TError, TData>(
      variables === undefined ? ['GetCarSetupChassisSpecsByEventID'] : ['GetCarSetupChassisSpecsByEventID', variables],
      fetcher<GetCarSetupChassisSpecsByEventIdQuery, GetCarSetupChassisSpecsByEventIdQueryVariables>(GetCarSetupChassisSpecsByEventIdDocument, variables),
      options
    )};

export const GetSessionsFromEventsForPackageApplyDocument = `
    query GetSessionsFromEventsForPackageApply($eventIDs: [MongoID!]) {
  sessions(filter: {_operators: {eventID: {in: $eventIDs}}}) {
    items {
      _id
    }
  }
}
    `;

export const useGetSessionsFromEventsForPackageApplyQuery = <
      TData = GetSessionsFromEventsForPackageApplyQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSessionsFromEventsForPackageApplyQueryVariables,
      options?: UseQueryOptions<GetSessionsFromEventsForPackageApplyQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionsFromEventsForPackageApplyQuery, TError, TData>(
      variables === undefined ? ['GetSessionsFromEventsForPackageApply'] : ['GetSessionsFromEventsForPackageApply', variables],
      fetcher<GetSessionsFromEventsForPackageApplyQuery, GetSessionsFromEventsForPackageApplyQueryVariables>(GetSessionsFromEventsForPackageApplyDocument, variables),
      options
    )};

export const GetRunSheetsFromSessionsForPackageApplyDocument = `
    query GetRunSheetsFromSessionsForPackageApply($sessionIDs: [MongoID!]) {
  runSheets(filter: {_operators: {sessionID: {in: $sessionIDs}}}) {
    items {
      _id
    }
  }
}
    `;

export const useGetRunSheetsFromSessionsForPackageApplyQuery = <
      TData = GetRunSheetsFromSessionsForPackageApplyQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRunSheetsFromSessionsForPackageApplyQueryVariables,
      options?: UseQueryOptions<GetRunSheetsFromSessionsForPackageApplyQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsFromSessionsForPackageApplyQuery, TError, TData>(
      variables === undefined ? ['GetRunSheetsFromSessionsForPackageApply'] : ['GetRunSheetsFromSessionsForPackageApply', variables],
      fetcher<GetRunSheetsFromSessionsForPackageApplyQuery, GetRunSheetsFromSessionsForPackageApplyQueryVariables>(GetRunSheetsFromSessionsForPackageApplyDocument, variables),
      options
    )};

export const GetPackagesForPackagesPageDocument = `
    query GetPackagesForPackagesPage($filter: FilterFindManyPackageInput!, $perPage: Int!, $page: Int, $sort: SortFindManyPackageInput) {
  packages(perPage: $perPage, sort: $sort, filter: $filter, page: $page) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ...PackagesForPackageManagerPageVars
    }
  }
}
    ${PackagesForPackageManagerPageVarsFragmentDoc}`;

export const useGetPackagesForPackagesPageQuery = <
      TData = GetPackagesForPackagesPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPackagesForPackagesPageQueryVariables,
      options?: UseQueryOptions<GetPackagesForPackagesPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetPackagesForPackagesPageQuery, TError, TData>(
      ['GetPackagesForPackagesPage', variables],
      fetcher<GetPackagesForPackagesPageQuery, GetPackagesForPackagesPageQueryVariables>(GetPackagesForPackagesPageDocument, variables),
      options
    )};

export const GetPackageForPackageEditPageByIdDocument = `
    query GetPackageForPackageEditPageById($id: MongoID!) {
  package(_id: $id) {
    ...PackagesForPackageManagerPageVars
  }
}
    ${PackagesForPackageManagerPageVarsFragmentDoc}`;

export const useGetPackageForPackageEditPageByIdQuery = <
      TData = GetPackageForPackageEditPageByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPackageForPackageEditPageByIdQueryVariables,
      options?: UseQueryOptions<GetPackageForPackageEditPageByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetPackageForPackageEditPageByIdQuery, TError, TData>(
      ['GetPackageForPackageEditPageById', variables],
      fetcher<GetPackageForPackageEditPageByIdQuery, GetPackageForPackageEditPageByIdQueryVariables>(GetPackageForPackageEditPageByIdDocument, variables),
      options
    )};

export const GetEventDataForPackageCreateDocument = `
    query GetEventDataForPackageCreate($eventID: MongoID!) {
  event(_id: $eventID) {
    name
    season {
      contestantIDs
    }
    sessionIDs
  }
}
    `;

export const useGetEventDataForPackageCreateQuery = <
      TData = GetEventDataForPackageCreateQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventDataForPackageCreateQueryVariables,
      options?: UseQueryOptions<GetEventDataForPackageCreateQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventDataForPackageCreateQuery, TError, TData>(
      ['GetEventDataForPackageCreate', variables],
      fetcher<GetEventDataForPackageCreateQuery, GetEventDataForPackageCreateQueryVariables>(GetEventDataForPackageCreateDocument, variables),
      options
    )};

export const GetRunSheetsForPackageCreateDocument = `
    query GetRunSheetsForPackageCreate($contestantIDs: [MongoID], $sessionIDs: [MongoID]) {
  runSheets(
    filter: {AND: [{_operators: {contestantID: {in: $contestantIDs}}}, {_operators: {sessionID: {in: $sessionIDs}}}]}
    perPage: 20000
  ) {
    items {
      ...RunSheetForEventSelectionVars
    }
  }
}
    ${RunSheetForEventSelectionVarsFragmentDoc}`;

export const useGetRunSheetsForPackageCreateQuery = <
      TData = GetRunSheetsForPackageCreateQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRunSheetsForPackageCreateQueryVariables,
      options?: UseQueryOptions<GetRunSheetsForPackageCreateQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsForPackageCreateQuery, TError, TData>(
      variables === undefined ? ['GetRunSheetsForPackageCreate'] : ['GetRunSheetsForPackageCreate', variables],
      fetcher<GetRunSheetsForPackageCreateQuery, GetRunSheetsForPackageCreateQueryVariables>(GetRunSheetsForPackageCreateDocument, variables),
      options
    )};

export const GetChassisSpecForPackageEditPageDocument = `
    query GetChassisSpecForPackageEditPage($id: MongoID!) {
  specification(_id: $id) {
    ...ChassisSpecVarsForPackageEditPageVars
  }
}
    ${ChassisSpecVarsForPackageEditPageVarsFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${SpecificationGroupVarsFragmentDoc}`;

export const useGetChassisSpecForPackageEditPageQuery = <
      TData = GetChassisSpecForPackageEditPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpecForPackageEditPageQueryVariables,
      options?: UseQueryOptions<GetChassisSpecForPackageEditPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecForPackageEditPageQuery, TError, TData>(
      ['GetChassisSpecForPackageEditPage', variables],
      fetcher<GetChassisSpecForPackageEditPageQuery, GetChassisSpecForPackageEditPageQueryVariables>(GetChassisSpecForPackageEditPageDocument, variables),
      options
    )};

export const GetChassisSpecIdForCarSetupDocument = `
    query GetChassisSpecIDForCarSetup($id: MongoID!) {
  carSetup(_id: $id) {
    chassisSpecID
  }
}
    `;

export const useGetChassisSpecIdForCarSetupQuery = <
      TData = GetChassisSpecIdForCarSetupQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpecIdForCarSetupQueryVariables,
      options?: UseQueryOptions<GetChassisSpecIdForCarSetupQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecIdForCarSetupQuery, TError, TData>(
      ['GetChassisSpecIDForCarSetup', variables],
      fetcher<GetChassisSpecIdForCarSetupQuery, GetChassisSpecIdForCarSetupQueryVariables>(GetChassisSpecIdForCarSetupDocument, variables),
      options
    )};

export const GetPartsBySpecIdForPackagePageDocument = `
    query GetPartsBySpecIdForPackagePage($specID: MongoID!) {
  partsAdvancedFilter(
    perPage: 20000
    specificationID: $specID
    userEnumPartStatusActive: true
    sort: REFERENCE_ASC
  ) {
    items {
      _id
      reference
      specification {
        _id
        hasToBeInSubAssembly
        name
      }
    }
  }
}
    `;

export const useGetPartsBySpecIdForPackagePageQuery = <
      TData = GetPartsBySpecIdForPackagePageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartsBySpecIdForPackagePageQueryVariables,
      options?: UseQueryOptions<GetPartsBySpecIdForPackagePageQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartsBySpecIdForPackagePageQuery, TError, TData>(
      ['GetPartsBySpecIdForPackagePage', variables],
      fetcher<GetPartsBySpecIdForPackagePageQuery, GetPartsBySpecIdForPackagePageQueryVariables>(GetPartsBySpecIdForPackagePageDocument, variables),
      options
    )};

export const ClonePackageDocument = `
    mutation ClonePackage($packageID: MongoID!, $name: String!) {
  clonePackage(packageID: $packageID, name: $name) {
    recordId
  }
}
    `;

export const useClonePackageMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ClonePackageMutation, TError, ClonePackageMutationVariables, TContext>) => {
    
    return useMutation<ClonePackageMutation, TError, ClonePackageMutationVariables, TContext>(
      ['ClonePackage'],
      (variables?: ClonePackageMutationVariables) => fetcher<ClonePackageMutation, ClonePackageMutationVariables>(ClonePackageDocument, variables)(),
      options
    )};

export const GetSessionDebriefTemplatesDocument = `
    query GetSessionDebriefTemplates($mode: EnumTemplateSessionDebriefMode) {
  sessionDebriefs(filter: {mode: $mode}) {
    count
    items {
      _id
      title
      text
      mode
    }
  }
}
    `;

export const useGetSessionDebriefTemplatesQuery = <
      TData = GetSessionDebriefTemplatesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSessionDebriefTemplatesQueryVariables,
      options?: UseQueryOptions<GetSessionDebriefTemplatesQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionDebriefTemplatesQuery, TError, TData>(
      variables === undefined ? ['GetSessionDebriefTemplates'] : ['GetSessionDebriefTemplates', variables],
      fetcher<GetSessionDebriefTemplatesQuery, GetSessionDebriefTemplatesQueryVariables>(GetSessionDebriefTemplatesDocument, variables),
      options
    )};

export const RemoveSessionDebriefTemplateDocument = `
    mutation RemoveSessionDebriefTemplate($id: MongoID!) {
  removeSessionDebriefTemplate(_id: $id) {
    error {
      message
    }
    recordId
  }
}
    `;

export const useRemoveSessionDebriefTemplateMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSessionDebriefTemplateMutation, TError, RemoveSessionDebriefTemplateMutationVariables, TContext>) => {
    
    return useMutation<RemoveSessionDebriefTemplateMutation, TError, RemoveSessionDebriefTemplateMutationVariables, TContext>(
      ['RemoveSessionDebriefTemplate'],
      (variables?: RemoveSessionDebriefTemplateMutationVariables) => fetcher<RemoveSessionDebriefTemplateMutation, RemoveSessionDebriefTemplateMutationVariables>(RemoveSessionDebriefTemplateDocument, variables)(),
      options
    )};

export const AddSessionDebriefTemplateDocument = `
    mutation AddSessionDebriefTemplate($record: CreateOneTemplateSessionDebriefInput!) {
  addSessionDebriefTemplate(record: $record) {
    error {
      message
    }
    recordId
  }
}
    `;

export const useAddSessionDebriefTemplateMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddSessionDebriefTemplateMutation, TError, AddSessionDebriefTemplateMutationVariables, TContext>) => {
    
    return useMutation<AddSessionDebriefTemplateMutation, TError, AddSessionDebriefTemplateMutationVariables, TContext>(
      ['AddSessionDebriefTemplate'],
      (variables?: AddSessionDebriefTemplateMutationVariables) => fetcher<AddSessionDebriefTemplateMutation, AddSessionDebriefTemplateMutationVariables>(AddSessionDebriefTemplateDocument, variables)(),
      options
    )};

export const GetChassisSpecElementsForChassisSpecIdDocument = `
    query GetChassisSpecElementsForChassisSpecId($id: MongoID!) {
  specification(_id: $id) {
    ...ChassisSpecVarsForChassisSpecElements
  }
}
    ${ChassisSpecVarsForChassisSpecElementsFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${SpecificationGroupVarsFragmentDoc}`;

export const useGetChassisSpecElementsForChassisSpecIdQuery = <
      TData = GetChassisSpecElementsForChassisSpecIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpecElementsForChassisSpecIdQueryVariables,
      options?: UseQueryOptions<GetChassisSpecElementsForChassisSpecIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecElementsForChassisSpecIdQuery, TError, TData>(
      ['GetChassisSpecElementsForChassisSpecId', variables],
      fetcher<GetChassisSpecElementsForChassisSpecIdQuery, GetChassisSpecElementsForChassisSpecIdQueryVariables>(GetChassisSpecElementsForChassisSpecIdDocument, variables),
      options
    )};

export const GetTrackingItemInfosForChassisSpecIdDocument = `
    query GetTrackingItemInfosForChassisSpecId($trackingItemIDs: [MongoID!]) {
  trackingItems(
    filter: {_operators: {_id: {in: $trackingItemIDs}}}
    perPage: 200000
  ) {
    items {
      ...TrackingItemVarsForChassisSpecId
    }
  }
}
    ${TrackingItemVarsForChassisSpecIdFragmentDoc}`;

export const useGetTrackingItemInfosForChassisSpecIdQuery = <
      TData = GetTrackingItemInfosForChassisSpecIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTrackingItemInfosForChassisSpecIdQueryVariables,
      options?: UseQueryOptions<GetTrackingItemInfosForChassisSpecIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackingItemInfosForChassisSpecIdQuery, TError, TData>(
      variables === undefined ? ['GetTrackingItemInfosForChassisSpecId'] : ['GetTrackingItemInfosForChassisSpecId', variables],
      fetcher<GetTrackingItemInfosForChassisSpecIdQuery, GetTrackingItemInfosForChassisSpecIdQueryVariables>(GetTrackingItemInfosForChassisSpecIdDocument, variables),
      options
    )};

export const UpgradeChassisSpecOnSetupSheetLayoutDocument = `
    mutation UpgradeChassisSpecOnSetupSheetLayout($setupSheetLayoutID: MongoID!, $chassisSpecID: MongoID!) {
  updateSetupSheetLayoutChassisSpec(
    setupSheetLayoutID: $setupSheetLayoutID
    chassisSpecID: $chassisSpecID
  ) {
    status
  }
}
    `;

export const useUpgradeChassisSpecOnSetupSheetLayoutMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpgradeChassisSpecOnSetupSheetLayoutMutation, TError, UpgradeChassisSpecOnSetupSheetLayoutMutationVariables, TContext>) => {
    
    return useMutation<UpgradeChassisSpecOnSetupSheetLayoutMutation, TError, UpgradeChassisSpecOnSetupSheetLayoutMutationVariables, TContext>(
      ['UpgradeChassisSpecOnSetupSheetLayout'],
      (variables?: UpgradeChassisSpecOnSetupSheetLayoutMutationVariables) => fetcher<UpgradeChassisSpecOnSetupSheetLayoutMutation, UpgradeChassisSpecOnSetupSheetLayoutMutationVariables>(UpgradeChassisSpecOnSetupSheetLayoutDocument, variables)(),
      options
    )};

export const GetTimeSheetEntriesForPersonAndProjectDocument = `
    query GetTimeSheetEntriesForPersonAndProject($personID: MongoID!, $projectID: MongoID!, $tStart: Date) {
  timeSheetEntries(
    filter: {personID: $personID, projectID: $projectID, tStart: $tStart}
  ) {
    items {
      _id
      absent
      approvedAt
      person {
        name
      }
      tEnd
      tStart
    }
  }
}
    `;

export const useGetTimeSheetEntriesForPersonAndProjectQuery = <
      TData = GetTimeSheetEntriesForPersonAndProjectQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTimeSheetEntriesForPersonAndProjectQueryVariables,
      options?: UseQueryOptions<GetTimeSheetEntriesForPersonAndProjectQuery, TError, TData>
    ) => {
    
    return useQuery<GetTimeSheetEntriesForPersonAndProjectQuery, TError, TData>(
      ['GetTimeSheetEntriesForPersonAndProject', variables],
      fetcher<GetTimeSheetEntriesForPersonAndProjectQuery, GetTimeSheetEntriesForPersonAndProjectQueryVariables>(GetTimeSheetEntriesForPersonAndProjectDocument, variables),
      options
    )};

export const GetRunSheetsForTyrePressureCalculationDocument = `
    query GetRunSheetsForTyrePressureCalculation($sessionIDs: [MongoID!]!, $contestantIDs: [MongoID!]!) {
  runSheets(
    perPage: 1000
    filter: {_operators: {sessionID: {in: $sessionIDs}, contestantID: {in: $contestantIDs}}}
  ) {
    items {
      ...RunSheetVarsForTyrePressureCalculation
    }
  }
}
    ${RunSheetVarsForTyrePressureCalculationFragmentDoc}
${RunTyreVarsFragmentDoc}`;

export const useGetRunSheetsForTyrePressureCalculationQuery = <
      TData = GetRunSheetsForTyrePressureCalculationQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetsForTyrePressureCalculationQueryVariables,
      options?: UseQueryOptions<GetRunSheetsForTyrePressureCalculationQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsForTyrePressureCalculationQuery, TError, TData>(
      ['GetRunSheetsForTyrePressureCalculation', variables],
      fetcher<GetRunSheetsForTyrePressureCalculationQuery, GetRunSheetsForTyrePressureCalculationQueryVariables>(GetRunSheetsForTyrePressureCalculationDocument, variables),
      options
    )};

export const GetTyrePressureSheetDocument = `
    query GetTyrePressureSheet($eventID: MongoID!, $contestantID: MongoID!) {
  tyrePressureSheet(eventID: $eventID, contestantID: $contestantID) {
    ...TyrePressureSheetVars
  }
}
    ${TyrePressureSheetVarsFragmentDoc}
${TyrePressureCalculationSettingsFragmentDoc}
${TyrePressureSheetSessionVarsFragmentDoc}
${TyreSetupDataVarsFragmentDoc}
${TyreCornersFragmentDoc}`;

export const useGetTyrePressureSheetQuery = <
      TData = GetTyrePressureSheetQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTyrePressureSheetQueryVariables,
      options?: UseQueryOptions<GetTyrePressureSheetQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyrePressureSheetQuery, TError, TData>(
      ['GetTyrePressureSheet', variables],
      fetcher<GetTyrePressureSheetQuery, GetTyrePressureSheetQueryVariables>(GetTyrePressureSheetDocument, variables),
      options
    )};

export const UpdateTyrePressureSheetDocument = `
    mutation UpdateTyrePressureSheet($eventID: MongoID!, $record: TyrePressureSheetInput!, $contestantID: MongoID!) {
  updateTyrePressureSheet(
    eventID: $eventID
    record: $record
    contestantID: $contestantID
  ) {
    _id
  }
}
    `;

export const useUpdateTyrePressureSheetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTyrePressureSheetMutation, TError, UpdateTyrePressureSheetMutationVariables, TContext>) => {
    
    return useMutation<UpdateTyrePressureSheetMutation, TError, UpdateTyrePressureSheetMutationVariables, TContext>(
      ['UpdateTyrePressureSheet'],
      (variables?: UpdateTyrePressureSheetMutationVariables) => fetcher<UpdateTyrePressureSheetMutation, UpdateTyrePressureSheetMutationVariables>(UpdateTyrePressureSheetDocument, variables)(),
      options
    )};

export const UpdateTyrePressureSheetDataDocument = `
    mutation UpdateTyrePressureSheetData($eventID: MongoID!, $contestantID: MongoID!, $sessionID: MongoID!, $tyreSetID: MongoID!, $record: TyreSetupDataInput!) {
  updateTyrePressureSheetData(
    eventID: $eventID
    contestantID: $contestantID
    sessionID: $sessionID
    tyreSetID: $tyreSetID
    record: $record
  ) {
    _id
  }
}
    `;

export const useUpdateTyrePressureSheetDataMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTyrePressureSheetDataMutation, TError, UpdateTyrePressureSheetDataMutationVariables, TContext>) => {
    
    return useMutation<UpdateTyrePressureSheetDataMutation, TError, UpdateTyrePressureSheetDataMutationVariables, TContext>(
      ['UpdateTyrePressureSheetData'],
      (variables?: UpdateTyrePressureSheetDataMutationVariables) => fetcher<UpdateTyrePressureSheetDataMutation, UpdateTyrePressureSheetDataMutationVariables>(UpdateTyrePressureSheetDataDocument, variables)(),
      options
    )};

export const GetPartsForTyreBarcodeScanningDocument = `
    query GetPartsForTyreBarcodeScanning($partNumber: String) {
  parts(filter: {partNumber: $partNumber}) {
    items {
      _id
      partNumber
    }
  }
}
    `;

export const useGetPartsForTyreBarcodeScanningQuery = <
      TData = GetPartsForTyreBarcodeScanningQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetPartsForTyreBarcodeScanningQueryVariables,
      options?: UseQueryOptions<GetPartsForTyreBarcodeScanningQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartsForTyreBarcodeScanningQuery, TError, TData>(
      variables === undefined ? ['GetPartsForTyreBarcodeScanning'] : ['GetPartsForTyreBarcodeScanning', variables],
      fetcher<GetPartsForTyreBarcodeScanningQuery, GetPartsForTyreBarcodeScanningQueryVariables>(GetPartsForTyreBarcodeScanningDocument, variables),
      options
    )};

export const GetRimInfoForTyreBarcodeScanningDocument = `
    query GetRimInfoForTyreBarcodeScanning($id: MongoID!) {
  part(_id: $id) {
    _id
    partNumber
    trackingHistory {
      _id
      trackingItem {
        name
      }
      value
    }
  }
}
    `;

export const useGetRimInfoForTyreBarcodeScanningQuery = <
      TData = GetRimInfoForTyreBarcodeScanningQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRimInfoForTyreBarcodeScanningQueryVariables,
      options?: UseQueryOptions<GetRimInfoForTyreBarcodeScanningQuery, TError, TData>
    ) => {
    
    return useQuery<GetRimInfoForTyreBarcodeScanningQuery, TError, TData>(
      ['GetRimInfoForTyreBarcodeScanning', variables],
      fetcher<GetRimInfoForTyreBarcodeScanningQuery, GetRimInfoForTyreBarcodeScanningQueryVariables>(GetRimInfoForTyreBarcodeScanningDocument, variables),
      options
    )};

export const GetTyreIdsForEventContestantDocument = `
    query GetTyreIdsForEventContestant($eventID: MongoID!) {
  event(_id: $eventID) {
    _id
    contestants {
      _id
      tyreIDs
      tyreSetIDs
    }
    name
  }
}
    `;

export const useGetTyreIdsForEventContestantQuery = <
      TData = GetTyreIdsForEventContestantQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTyreIdsForEventContestantQueryVariables,
      options?: UseQueryOptions<GetTyreIdsForEventContestantQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreIdsForEventContestantQuery, TError, TData>(
      ['GetTyreIdsForEventContestant', variables],
      fetcher<GetTyreIdsForEventContestantQuery, GetTyreIdsForEventContestantQueryVariables>(GetTyreIdsForEventContestantDocument, variables),
      options
    )};

export const GetTyreInfoForEventContestantDocument = `
    query GetTyreInfoForEventContestant($tyreIDs: [MongoID], $tyreSetIDs: [MongoID]) {
  tyres(perPage: 200, filter: {_operators: {_id: {in: $tyreIDs}}}) {
    items {
      _id
      ...TyreVars
    }
  }
  tyreSets(perPage: 200, filter: {_operators: {_id: {in: $tyreSetIDs}}}) {
    items {
      _id
      ...tyreSetVars
    }
  }
}
    ${TyreVarsFragmentDoc}
${TyreSetVarsFragmentDoc}`;

export const useGetTyreInfoForEventContestantQuery = <
      TData = GetTyreInfoForEventContestantQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTyreInfoForEventContestantQueryVariables,
      options?: UseQueryOptions<GetTyreInfoForEventContestantQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreInfoForEventContestantQuery, TError, TData>(
      variables === undefined ? ['GetTyreInfoForEventContestant'] : ['GetTyreInfoForEventContestant', variables],
      fetcher<GetTyreInfoForEventContestantQuery, GetTyreInfoForEventContestantQueryVariables>(GetTyreInfoForEventContestantDocument, variables),
      options
    )};

export const GetExportInfoForDmsbDocument = `
    query GetExportInfoForDMSB($contestantID: MongoID!, $eventID: MongoID!) {
  contestant(_id: $contestantID) {
    _id
    startNumber
  }
  event(_id: $eventID) {
    _id
    name
  }
}
    `;

export const useGetExportInfoForDmsbQuery = <
      TData = GetExportInfoForDmsbQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetExportInfoForDmsbQueryVariables,
      options?: UseQueryOptions<GetExportInfoForDmsbQuery, TError, TData>
    ) => {
    
    return useQuery<GetExportInfoForDmsbQuery, TError, TData>(
      ['GetExportInfoForDMSB', variables],
      fetcher<GetExportInfoForDmsbQuery, GetExportInfoForDmsbQueryVariables>(GetExportInfoForDmsbDocument, variables),
      options
    )};

export const GetDataForEventTyreTableDocument = `
    query GetDataForEventTyreTable($contestantID: MongoID!, $eventID: MongoID!) {
  event(_id: $eventID) {
    _id
    contestants {
      _id
      tyreIDs
      tyreSets {
        ...tyreSetVars
      }
      tyreSetIDs
    }
    eventType
    name
    NEventSeason
    sessionIDs
    sessions {
      _id
      sessionType
      ...SessionWithTimesVars
    }
    tEventEnd
    tEventStart
    tLapAverage
    track {
      _id
      timeZone
    }
  }
  contestant(_id: $contestantID) {
    _id
    class
    driverIDs
    drivers {
      _id
      acronym
    }
    hidden
    startNumber
    tyres {
      _id
      ...TyreVars
    }
  }
}
    ${TyreSetVarsFragmentDoc}
${SessionWithTimesVarsFragmentDoc}
${TyreVarsFragmentDoc}`;

export const useGetDataForEventTyreTableQuery = <
      TData = GetDataForEventTyreTableQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetDataForEventTyreTableQueryVariables,
      options?: UseQueryOptions<GetDataForEventTyreTableQuery, TError, TData>
    ) => {
    
    return useQuery<GetDataForEventTyreTableQuery, TError, TData>(
      ['GetDataForEventTyreTable', variables],
      fetcher<GetDataForEventTyreTableQuery, GetDataForEventTyreTableQueryVariables>(GetDataForEventTyreTableDocument, variables),
      options
    )};

export const GetDataForTyresForEventTyreTableDocument = `
    query GetDataForTyresForEventTyreTable($tyreIDs: [MongoID], $tyreSetIDs: [MongoID], $sessionIDs: [MongoID!]) {
  runSheets(
    perPage: 1000000000
    filter: {OR: [{_operators: {sessionID: {in: $sessionIDs}}}]}
  ) {
    items {
      _id
      mileage
      session {
        _id
        shortName
        event {
          _id
          name
        }
      }
      tyreSetID
      tyreFL {
        tyreID
      }
      tyreRL {
        tyreID
      }
      tyreRR {
        tyreID
      }
      tyreFR {
        tyreID
      }
    }
  }
  tyres(perPage: 400, filter: {_operators: {_id: {in: $tyreIDs}}}) {
    items {
      _id
      ...TyreVars
    }
  }
  tyreSets(perPage: 400, filter: {_operators: {_id: {in: $tyreSetIDs}}}) {
    items {
      _id
      ...tyreSetVars
    }
  }
}
    ${TyreVarsFragmentDoc}
${TyreSetVarsFragmentDoc}`;

export const useGetDataForTyresForEventTyreTableQuery = <
      TData = GetDataForTyresForEventTyreTableQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetDataForTyresForEventTyreTableQueryVariables,
      options?: UseQueryOptions<GetDataForTyresForEventTyreTableQuery, TError, TData>
    ) => {
    
    return useQuery<GetDataForTyresForEventTyreTableQuery, TError, TData>(
      variables === undefined ? ['GetDataForTyresForEventTyreTable'] : ['GetDataForTyresForEventTyreTable', variables],
      fetcher<GetDataForTyresForEventTyreTableQuery, GetDataForTyresForEventTyreTableQueryVariables>(GetDataForTyresForEventTyreTableDocument, variables),
      options
    )};

export const GetTyreMileageGraphDocument = `
    query GetTyreMileageGraph($contestantID: MongoID!, $eventID: MongoID!, $personID: MongoID!) {
  tyreMileageGraph(contestantID: $contestantID, eventID: $eventID) {
    eventMileages {
      tyreSets {
        ...TyreMileageGraphTyreMileageGraphEventMileageItemVars
      }
    }
  }
  sessions(filter: {eventID: $eventID}) {
    items {
      _id
      name
      shortName
    }
  }
  person(_id: $personID) {
    mileageUnit
  }
}
    ${TyreMileageGraphTyreMileageGraphEventMileageItemVarsFragmentDoc}
${TyreMileageGraphRunMileageVarsFragmentDoc}`;

export const useGetTyreMileageGraphQuery = <
      TData = GetTyreMileageGraphQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTyreMileageGraphQueryVariables,
      options?: UseQueryOptions<GetTyreMileageGraphQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreMileageGraphQuery, TError, TData>(
      ['GetTyreMileageGraph', variables],
      fetcher<GetTyreMileageGraphQuery, GetTyreMileageGraphQueryVariables>(GetTyreMileageGraphDocument, variables),
      options
    )};

export const GetBasicTyreSetListDocument = `
    query GetBasicTyreSetList($filter: FilterFindManyTyreSetInput!, $perPage: Int!, $page: Int, $sort: SortFindManyTyreSetInput) {
  tyreSets(sort: $sort, perPage: $perPage, page: $page, filter: $filter) {
    count
    pageInfo {
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      ...TyreSetForWarehouseVars
    }
  }
}
    ${TyreSetForWarehouseVarsFragmentDoc}`;

export const useGetBasicTyreSetListQuery = <
      TData = GetBasicTyreSetListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetBasicTyreSetListQueryVariables,
      options?: UseQueryOptions<GetBasicTyreSetListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicTyreSetListQuery, TError, TData>(
      ['GetBasicTyreSetList', variables],
      fetcher<GetBasicTyreSetListQuery, GetBasicTyreSetListQueryVariables>(GetBasicTyreSetListDocument, variables),
      options
    )};

export const GetSeasonContestantsForWarehouseDocument = `
    query GetSeasonContestantsForWarehouse($id: MongoID!) {
  season(_id: $id) {
    contestants {
      _id
      startNumber
    }
  }
}
    `;

export const useGetSeasonContestantsForWarehouseQuery = <
      TData = GetSeasonContestantsForWarehouseQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSeasonContestantsForWarehouseQueryVariables,
      options?: UseQueryOptions<GetSeasonContestantsForWarehouseQuery, TError, TData>
    ) => {
    
    return useQuery<GetSeasonContestantsForWarehouseQuery, TError, TData>(
      ['GetSeasonContestantsForWarehouse', variables],
      fetcher<GetSeasonContestantsForWarehouseQuery, GetSeasonContestantsForWarehouseQueryVariables>(GetSeasonContestantsForWarehouseDocument, variables),
      options
    )};

export const GetEventContestantsForWarehouseDocument = `
    query GetEventContestantsForWarehouse($id: MongoID!) {
  event(_id: $id) {
    contestants {
      _id
    }
    season {
      contestants {
        _id
        startNumber
      }
    }
  }
}
    `;

export const useGetEventContestantsForWarehouseQuery = <
      TData = GetEventContestantsForWarehouseQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventContestantsForWarehouseQueryVariables,
      options?: UseQueryOptions<GetEventContestantsForWarehouseQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventContestantsForWarehouseQuery, TError, TData>(
      ['GetEventContestantsForWarehouse', variables],
      fetcher<GetEventContestantsForWarehouseQuery, GetEventContestantsForWarehouseQueryVariables>(GetEventContestantsForWarehouseDocument, variables),
      options
    )};

export const GetWeatherForWeatherPageWeatherSelectorDocument = `
    query GetWeatherForWeatherPageWeatherSelector($eventIDs: [MongoID]) {
  weatherAll(filter: {_operators: {eventIDs: {in: $eventIDs}}}) {
    items {
      ...WeatherForWeatherPageVarsForSelector
    }
  }
}
    ${WeatherForWeatherPageVarsForSelectorFragmentDoc}`;

export const useGetWeatherForWeatherPageWeatherSelectorQuery = <
      TData = GetWeatherForWeatherPageWeatherSelectorQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetWeatherForWeatherPageWeatherSelectorQueryVariables,
      options?: UseQueryOptions<GetWeatherForWeatherPageWeatherSelectorQuery, TError, TData>
    ) => {
    
    return useQuery<GetWeatherForWeatherPageWeatherSelectorQuery, TError, TData>(
      variables === undefined ? ['GetWeatherForWeatherPageWeatherSelector'] : ['GetWeatherForWeatherPageWeatherSelector', variables],
      fetcher<GetWeatherForWeatherPageWeatherSelectorQuery, GetWeatherForWeatherPageWeatherSelectorQueryVariables>(GetWeatherForWeatherPageWeatherSelectorDocument, variables),
      options
    )};

export const GetWeatherForWeatherPageDocument = `
    query GetWeatherForWeatherPage($eventIDs: [MongoID]) {
  weatherAll(filter: {_operators: {eventIDs: {in: $eventIDs}}}) {
    items {
      ...WeatherForWeatherPageVars
    }
  }
}
    ${WeatherForWeatherPageVarsFragmentDoc}`;

export const useGetWeatherForWeatherPageQuery = <
      TData = GetWeatherForWeatherPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetWeatherForWeatherPageQueryVariables,
      options?: UseQueryOptions<GetWeatherForWeatherPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetWeatherForWeatherPageQuery, TError, TData>(
      variables === undefined ? ['GetWeatherForWeatherPage'] : ['GetWeatherForWeatherPage', variables],
      fetcher<GetWeatherForWeatherPageQuery, GetWeatherForWeatherPageQueryVariables>(GetWeatherForWeatherPageDocument, variables),
      options
    )};

export const GetWeatherForPlotPageDocument = `
    query GetWeatherForPlotPage($ids: [MongoID!]) {
  weatherAll(filter: {_operators: {_id: {in: $ids}}}) {
    items {
      ...WeatherForWeatherPageVars
    }
  }
}
    ${WeatherForWeatherPageVarsFragmentDoc}`;

export const useGetWeatherForPlotPageQuery = <
      TData = GetWeatherForPlotPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetWeatherForPlotPageQueryVariables,
      options?: UseQueryOptions<GetWeatherForPlotPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetWeatherForPlotPageQuery, TError, TData>(
      variables === undefined ? ['GetWeatherForPlotPage'] : ['GetWeatherForPlotPage', variables],
      fetcher<GetWeatherForPlotPageQuery, GetWeatherForPlotPageQueryVariables>(GetWeatherForPlotPageDocument, variables),
      options
    )};

export const GetRunSheetWeatherForWeatherPageDocument = `
    query GetRunSheetWeatherForWeatherPage($sessionIDs: [MongoID]) {
  runSheets(filter: {_operators: {sessionID: {in: $sessionIDs}}}, perPage: 2000) {
    items {
      startTime
      weather {
        ...AllWeatherDataScalarVars
      }
    }
  }
}
    ${AllWeatherDataScalarVarsFragmentDoc}`;

export const useGetRunSheetWeatherForWeatherPageQuery = <
      TData = GetRunSheetWeatherForWeatherPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRunSheetWeatherForWeatherPageQueryVariables,
      options?: UseQueryOptions<GetRunSheetWeatherForWeatherPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetWeatherForWeatherPageQuery, TError, TData>(
      variables === undefined ? ['GetRunSheetWeatherForWeatherPage'] : ['GetRunSheetWeatherForWeatherPage', variables],
      fetcher<GetRunSheetWeatherForWeatherPageQuery, GetRunSheetWeatherForWeatherPageQueryVariables>(GetRunSheetWeatherForWeatherPageDocument, variables),
      options
    )};

export const RemoveWeatherDocument = `
    mutation RemoveWeather($id: MongoID!) {
  removeWeather(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveWeatherMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveWeatherMutation, TError, RemoveWeatherMutationVariables, TContext>) => {
    
    return useMutation<RemoveWeatherMutation, TError, RemoveWeatherMutationVariables, TContext>(
      ['RemoveWeather'],
      (variables?: RemoveWeatherMutationVariables) => fetcher<RemoveWeatherMutation, RemoveWeatherMutationVariables>(RemoveWeatherDocument, variables)(),
      options
    )};

export const WeatherRemovedDocument = `
    subscription WeatherRemoved {
  weatherRemoved {
    _id
  }
}
    `;
export const WeatherUpdatedDocument = `
    subscription WeatherUpdated($id: MongoID!) {
  weatherUpdated(weatherID: $id) {
    ...WeatherForWeatherPageVars
  }
}
    ${WeatherForWeatherPageVarsFragmentDoc}`;
export const GetSessionsFromEventsForWeatherPageDocument = `
    query GetSessionsFromEventsForWeatherPage($eventIDs: [MongoID!]) {
  sessions(filter: {_operators: {eventID: {in: $eventIDs}}}) {
    items {
      _id
    }
  }
}
    `;

export const useGetSessionsFromEventsForWeatherPageQuery = <
      TData = GetSessionsFromEventsForWeatherPageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSessionsFromEventsForWeatherPageQueryVariables,
      options?: UseQueryOptions<GetSessionsFromEventsForWeatherPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionsFromEventsForWeatherPageQuery, TError, TData>(
      variables === undefined ? ['GetSessionsFromEventsForWeatherPage'] : ['GetSessionsFromEventsForWeatherPage', variables],
      fetcher<GetSessionsFromEventsForWeatherPageQuery, GetSessionsFromEventsForWeatherPageQueryVariables>(GetSessionsFromEventsForWeatherPageDocument, variables),
      options
    )};

export const GetAllBuildSheetStylesDocument = `
    query GetAllBuildSheetStyles {
  buildSheetStyles {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetAllBuildSheetStylesQuery = <
      TData = GetAllBuildSheetStylesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllBuildSheetStylesQueryVariables,
      options?: UseQueryOptions<GetAllBuildSheetStylesQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllBuildSheetStylesQuery, TError, TData>(
      variables === undefined ? ['GetAllBuildSheetStyles'] : ['GetAllBuildSheetStyles', variables],
      fetcher<GetAllBuildSheetStylesQuery, GetAllBuildSheetStylesQueryVariables>(GetAllBuildSheetStylesDocument, variables),
      options
    )};

export const BuildSheetStylePageDocument = `
    query BuildSheetStylePage($buildSheetStyleID: MongoID!) {
  buildSheetStyle(_id: $buildSheetStyleID) {
    _id
    name
    event {
      _id
      name
    }
    date
    chassisSpecID
    author {
      name
    }
    issue
    blocks {
      ...BuildSheetStylePageBlock
    }
  }
  specifications(perPage: 1000, filter: {type: CHASSIS}) {
    items {
      ...BasicInfoChassisSpec
    }
  }
}
    ${BuildSheetStylePageBlockFragmentDoc}
${BuildSheetStylePageTabFragmentDoc}
${BasicInfoChassisSpecFragmentDoc}`;

export const useBuildSheetStylePageQuery = <
      TData = BuildSheetStylePageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: BuildSheetStylePageQueryVariables,
      options?: UseQueryOptions<BuildSheetStylePageQuery, TError, TData>
    ) => {
    
    return useQuery<BuildSheetStylePageQuery, TError, TData>(
      ['BuildSheetStylePage', variables],
      fetcher<BuildSheetStylePageQuery, BuildSheetStylePageQueryVariables>(BuildSheetStylePageDocument, variables),
      options
    )};

export const CreateBuildSheetStyleDocument = `
    mutation CreateBuildSheetStyle($record: CreateOneBuildSheetStyleInput!) {
  addBuildSheetStyle(record: $record) {
    recordId
  }
}
    `;

export const useCreateBuildSheetStyleMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CreateBuildSheetStyleMutation, TError, CreateBuildSheetStyleMutationVariables, TContext>) => {
    
    return useMutation<CreateBuildSheetStyleMutation, TError, CreateBuildSheetStyleMutationVariables, TContext>(
      ['CreateBuildSheetStyle'],
      (variables?: CreateBuildSheetStyleMutationVariables) => fetcher<CreateBuildSheetStyleMutation, CreateBuildSheetStyleMutationVariables>(CreateBuildSheetStyleDocument, variables)(),
      options
    )};

export const UpdateBuildSheetStyleDocument = `
    mutation UpdateBuildSheetStyle($buildSheetStyleID: MongoID!, $record: UpdateByIdBuildSheetStyleInput!) {
  updateBuildSheetStyle(_id: $buildSheetStyleID, record: $record) {
    recordId
  }
}
    `;

export const useUpdateBuildSheetStyleMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBuildSheetStyleMutation, TError, UpdateBuildSheetStyleMutationVariables, TContext>) => {
    
    return useMutation<UpdateBuildSheetStyleMutation, TError, UpdateBuildSheetStyleMutationVariables, TContext>(
      ['UpdateBuildSheetStyle'],
      (variables?: UpdateBuildSheetStyleMutationVariables) => fetcher<UpdateBuildSheetStyleMutation, UpdateBuildSheetStyleMutationVariables>(UpdateBuildSheetStyleDocument, variables)(),
      options
    )};

export const RemoveBuildSheetStyleByIdDocument = `
    mutation RemoveBuildSheetStyleByID($buildSheetStyleID: MongoID!) {
  removeBuildSheetStyle(_id: $buildSheetStyleID) {
    recordId
  }
}
    `;

export const useRemoveBuildSheetStyleByIdMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveBuildSheetStyleByIdMutation, TError, RemoveBuildSheetStyleByIdMutationVariables, TContext>) => {
    
    return useMutation<RemoveBuildSheetStyleByIdMutation, TError, RemoveBuildSheetStyleByIdMutationVariables, TContext>(
      ['RemoveBuildSheetStyleByID'],
      (variables?: RemoveBuildSheetStyleByIdMutationVariables) => fetcher<RemoveBuildSheetStyleByIdMutation, RemoveBuildSheetStyleByIdMutationVariables>(RemoveBuildSheetStyleByIdDocument, variables)(),
      options
    )};

export const GetAllUserEnumsDocument = `
    query GetAllUserEnums {
  assemblyUserEnums: userEnums(perPage: 2000) {
    items {
      ... on UserEnumAssemblyType {
        _id
        name
        type
      }
    }
  }
  buildSheetUserEnums: userEnums(perPage: 2000) {
    items {
      ... on UserEnumBuildSheetGroup {
        _id
        name
        type
      }
    }
  }
  partsUserEnums: userEnums(perPage: 2000) {
    items {
      ... on UserEnumPartStatus {
        _id
        active
        name
        type
      }
    }
  }
  trackingUserEnums: userEnums(perPage: 2000) {
    items {
      ... on UserEnumTrackingSeverity {
        _id
        name
        type
      }
    }
  }
  partTypeUserEnum: userEnums(perPage: 2000) {
    items {
      ... on UserEnumPartType {
        _id
        name
        type
      }
    }
  }
  RunPlannerActionItem: userEnums(perPage: 2000) {
    items {
      ... on UserEnumRunPlannerActionItem {
        _id
        name
        type
      }
    }
  }
  simulationDriveFileTypeEnum: userEnums(perPage: 2000) {
    items {
      ... on UserEnumSimulationDriveFileType {
        _id
        name
        type
      }
    }
  }
}
    `;

export const useGetAllUserEnumsQuery = <
      TData = GetAllUserEnumsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllUserEnumsQueryVariables,
      options?: UseQueryOptions<GetAllUserEnumsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllUserEnumsQuery, TError, TData>(
      variables === undefined ? ['GetAllUserEnums'] : ['GetAllUserEnums', variables],
      fetcher<GetAllUserEnumsQuery, GetAllUserEnumsQueryVariables>(GetAllUserEnumsDocument, variables),
      options
    )};

export const GetAllUserEnumsByTypeDocument = `
    query GetAllUserEnumsByType($filter: FilterFindManyUserEnumInput) {
  userEnums(filter: $filter, perPage: 2000) {
    items {
      ...UserEnumVars
    }
  }
}
    ${UserEnumVarsFragmentDoc}`;

export const useGetAllUserEnumsByTypeQuery = <
      TData = GetAllUserEnumsByTypeQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllUserEnumsByTypeQueryVariables,
      options?: UseQueryOptions<GetAllUserEnumsByTypeQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllUserEnumsByTypeQuery, TError, TData>(
      variables === undefined ? ['GetAllUserEnumsByType'] : ['GetAllUserEnumsByType', variables],
      fetcher<GetAllUserEnumsByTypeQuery, GetAllUserEnumsByTypeQueryVariables>(GetAllUserEnumsByTypeDocument, variables),
      options
    )};

export const CreateUserEnumDocument = `
    mutation CreateUserEnum($record: CreateOneUserEnumInput!) {
  addUserEnum(record: $record) {
    recordId
  }
}
    `;

export const useCreateUserEnumMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CreateUserEnumMutation, TError, CreateUserEnumMutationVariables, TContext>) => {
    
    return useMutation<CreateUserEnumMutation, TError, CreateUserEnumMutationVariables, TContext>(
      ['CreateUserEnum'],
      (variables?: CreateUserEnumMutationVariables) => fetcher<CreateUserEnumMutation, CreateUserEnumMutationVariables>(CreateUserEnumDocument, variables)(),
      options
    )};

export const UpdateUserEnumDocument = `
    mutation UpdateUserEnum($id: MongoID!, $record: UpdateByIdUserEnumInput!) {
  updateUserEnum(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateUserEnumMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserEnumMutation, TError, UpdateUserEnumMutationVariables, TContext>) => {
    
    return useMutation<UpdateUserEnumMutation, TError, UpdateUserEnumMutationVariables, TContext>(
      ['UpdateUserEnum'],
      (variables?: UpdateUserEnumMutationVariables) => fetcher<UpdateUserEnumMutation, UpdateUserEnumMutationVariables>(UpdateUserEnumDocument, variables)(),
      options
    )};

export const RemoveUserEnumDocument = `
    mutation RemoveUserEnum($id: MongoID!) {
  removeUserEnum(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveUserEnumMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveUserEnumMutation, TError, RemoveUserEnumMutationVariables, TContext>) => {
    
    return useMutation<RemoveUserEnumMutation, TError, RemoveUserEnumMutationVariables, TContext>(
      ['RemoveUserEnum'],
      (variables?: RemoveUserEnumMutationVariables) => fetcher<RemoveUserEnumMutation, RemoveUserEnumMutationVariables>(RemoveUserEnumDocument, variables)(),
      options
    )};

export const GetFullCarSetupDocument = `
    query GetFullCarSetup($id: MongoID!) {
  carSetup(_id: $id) {
    ...AllCarSetupVars
  }
}
    ${AllCarSetupVarsFragmentDoc}
${AllCarSetupAeroVarsFragmentDoc}
${AllCarSetupAeroSpecVarsFragmentDoc}
${AllCarSetupAeroElementVarsFragmentDoc}
${AllPersonScalarVarsFragmentDoc}
${AllCarSetupBrakeSystemVarsFragmentDoc}
${AllCarSetupChassisVarsFragmentDoc}
${AllChassisAssemblyVarsFragmentDoc}
${AllChassisSpecVarsFragmentDoc}
${AeroPackageVarsFragmentDoc}
${AeroElementVarsFragmentDoc}
${AntiRollBarVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${AllChassisMeasurementSpecVarsFragmentDoc}
${CustomSpecVarsFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${MassPropertiesVarsFragmentDoc}
${DamperSpecVarsFragmentDoc}
${AllChassisSpecVarsIterationFragmentDoc}
${ExternalKinematicSpecVarsFragmentDoc}
${InternalKinematicSpecVarsFragmentDoc}
${ChassisMassVarsFragmentDoc}
${ChassisMeasurementVarsFragmentDoc}
${ChassisPowertrainVarsFragmentDoc}
${GearSpecVarsFragmentDoc}
${GearBoxSpecVarsFragmentDoc}
${DifferentialSpecVarsFragmentDoc}
${ChassisBrakeBiasVarsFragmentDoc}
${ChassisRegulationSetVarsFragmentDoc}
${AllCarSetupEndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${AllCarSetupDamperVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${AllCarSetupSpringVarsFragmentDoc}
${AllCarSetupCornerVarsFragmentDoc}
${AllHistoryVarsFragmentDoc}
${AllCarSetupInfoFragmentDoc}
${AllCarSetupMassVarsFragmentDoc}
${AllCarSetupPowertrainVarsFragmentDoc}
${AllRunSheetVarsFragmentDoc}
${AllRunBrakeFragmentDoc}
${AllRunSheetConsumptionVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${AllContestantScalarVarsFragmentDoc}
${AllJobScalarVarsFragmentDoc}
${AllSessionVarsFragmentDoc}
${AllSessionScalarVarsFragmentDoc}
${AllEventScalarVarsFragmentDoc}
${AllCarSetupSteeringVarsFragmentDoc}
${AllTagVarsFragmentDoc}
${AllTeamVarsFragmentDoc}`;

export const useGetFullCarSetupQuery = <
      TData = GetFullCarSetupQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetFullCarSetupQueryVariables,
      options?: UseQueryOptions<GetFullCarSetupQuery, TError, TData>
    ) => {
    
    return useQuery<GetFullCarSetupQuery, TError, TData>(
      ['GetFullCarSetup', variables],
      fetcher<GetFullCarSetupQuery, GetFullCarSetupQueryVariables>(GetFullCarSetupDocument, variables),
      options
    )};

export const GetEditableContestantsForUserDocument = `
    query GetEditableContestantsForUser($id: MongoID!) {
  person(_id: $id) {
    editableContestantIDs
    visibleContestantIDs
  }
}
    `;

export const useGetEditableContestantsForUserQuery = <
      TData = GetEditableContestantsForUserQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEditableContestantsForUserQueryVariables,
      options?: UseQueryOptions<GetEditableContestantsForUserQuery, TError, TData>
    ) => {
    
    return useQuery<GetEditableContestantsForUserQuery, TError, TData>(
      ['GetEditableContestantsForUser', variables],
      fetcher<GetEditableContestantsForUserQuery, GetEditableContestantsForUserQueryVariables>(GetEditableContestantsForUserDocument, variables),
      options
    )};

export const GetRunsForSessionByDriverDocument = `
    query GetRunsForSessionByDriver($sessionID: MongoID, $contestantID: MongoID) {
  runSheets(
    perPage: 1000
    filter: {sessionID: $sessionID, contestantID: $contestantID}
    sort: NRUNTIMING_ASC
  ) {
    items {
      _id
      ...RunsForSessionByDriverVars
    }
  }
}
    ${RunsForSessionByDriverVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${LapForSessionByDriverFragmentDoc}
${LapNumberVarsFragmentDoc}
${RunTyreForSessionByDriverVarsFragmentDoc}`;

export const useGetRunsForSessionByDriverQuery = <
      TData = GetRunsForSessionByDriverQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRunsForSessionByDriverQueryVariables,
      options?: UseQueryOptions<GetRunsForSessionByDriverQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunsForSessionByDriverQuery, TError, TData>(
      variables === undefined ? ['GetRunsForSessionByDriver'] : ['GetRunsForSessionByDriver', variables],
      fetcher<GetRunsForSessionByDriverQuery, GetRunsForSessionByDriverQueryVariables>(GetRunsForSessionByDriverDocument, variables),
      options
    )};

export const GetCarSetupForCustomSimulationDocument = `
    query GetCarSetupForCustomSimulation($id: MongoID!) {
  carSetup(_id: $id) {
    _id
    ...CarSetupVarsForCustomSimulation
  }
}
    ${CarSetupVarsForCustomSimulationFragmentDoc}`;

export const useGetCarSetupForCustomSimulationQuery = <
      TData = GetCarSetupForCustomSimulationQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCarSetupForCustomSimulationQueryVariables,
      options?: UseQueryOptions<GetCarSetupForCustomSimulationQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarSetupForCustomSimulationQuery, TError, TData>(
      ['GetCarSetupForCustomSimulation', variables],
      fetcher<GetCarSetupForCustomSimulationQuery, GetCarSetupForCustomSimulationQueryVariables>(GetCarSetupForCustomSimulationDocument, variables),
      options
    )};

export const GetSimulationDriveFilesForCustomSimulationDocument = `
    query GetSimulationDriveFilesForCustomSimulation($driveFileIDs: [MongoID]) {
  simulationDriveFiles(filter: {_operators: {_id: {in: $driveFileIDs}}}) {
    items {
      ...SimulationDriveFileVarsForCustomSimulation
    }
  }
}
    ${SimulationDriveFileVarsForCustomSimulationFragmentDoc}`;

export const useGetSimulationDriveFilesForCustomSimulationQuery = <
      TData = GetSimulationDriveFilesForCustomSimulationQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimulationDriveFilesForCustomSimulationQueryVariables,
      options?: UseQueryOptions<GetSimulationDriveFilesForCustomSimulationQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimulationDriveFilesForCustomSimulationQuery, TError, TData>(
      variables === undefined ? ['GetSimulationDriveFilesForCustomSimulation'] : ['GetSimulationDriveFilesForCustomSimulation', variables],
      fetcher<GetSimulationDriveFilesForCustomSimulationQuery, GetSimulationDriveFilesForCustomSimulationQueryVariables>(GetSimulationDriveFilesForCustomSimulationDocument, variables),
      options
    )};

export const GetRunSheetListForEventSelectionForKpiContextDocument = `
    query GetRunSheetListForEventSelectionForKPIContext($sessionIDs: [MongoID!]!) {
  runSheets(perPage: 10000, filter: {_operators: {sessionID: {in: $sessionIDs}}}) {
    items {
      _id
      ...RunSheetForEventSelectionForKPISetupSimContextVars
      session {
        tSessionStart
      }
    }
  }
}
    ${RunSheetForEventSelectionForKpiSetupSimContextVarsFragmentDoc}`;

export const useGetRunSheetListForEventSelectionForKpiContextQuery = <
      TData = GetRunSheetListForEventSelectionForKpiContextQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetListForEventSelectionForKpiContextQueryVariables,
      options?: UseQueryOptions<GetRunSheetListForEventSelectionForKpiContextQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetListForEventSelectionForKpiContextQuery, TError, TData>(
      ['GetRunSheetListForEventSelectionForKPIContext', variables],
      fetcher<GetRunSheetListForEventSelectionForKpiContextQuery, GetRunSheetListForEventSelectionForKpiContextQueryVariables>(GetRunSheetListForEventSelectionForKpiContextDocument, variables),
      options
    )};

export const GetCalculationsForLapKpiDocument = `
    query GetCalculationsForLapKPI {
  calculations(filter: {type: LAP, isActive: true}) {
    items {
      ...LapCalculation
    }
  }
}
    ${LapCalculationFragmentDoc}`;

export const useGetCalculationsForLapKpiQuery = <
      TData = GetCalculationsForLapKpiQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetCalculationsForLapKpiQueryVariables,
      options?: UseQueryOptions<GetCalculationsForLapKpiQuery, TError, TData>
    ) => {
    
    return useQuery<GetCalculationsForLapKpiQuery, TError, TData>(
      variables === undefined ? ['GetCalculationsForLapKPI'] : ['GetCalculationsForLapKPI', variables],
      fetcher<GetCalculationsForLapKpiQuery, GetCalculationsForLapKpiQueryVariables>(GetCalculationsForLapKpiDocument, variables),
      options
    )};

export const GetRunSheetWithKpiForFlexLayoutByIdDocument = `
    query GetRunSheetWithKpiForFlexLayoutByID($id: MongoID!) {
  runSheet(_id: $id) {
    _id
    ...RunSheetVarsForFlexLayout
    ...RunSheetSessionVars
    contestant {
      _id
      startNumber
    }
  }
}
    ${RunSheetVarsForFlexLayoutFragmentDoc}
${RunCommentVarsFragmentDoc}
${RunTyreVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${LapVarsForFlexLayoutFragmentDoc}
${RunSheetSessionVarsFragmentDoc}
${RunEnergyVarsFragmentDoc}
${TyreDefaultFragmentFragmentDoc}`;

export const useGetRunSheetWithKpiForFlexLayoutByIdQuery = <
      TData = GetRunSheetWithKpiForFlexLayoutByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetWithKpiForFlexLayoutByIdQueryVariables,
      options?: UseQueryOptions<GetRunSheetWithKpiForFlexLayoutByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetWithKpiForFlexLayoutByIdQuery, TError, TData>(
      ['GetRunSheetWithKpiForFlexLayoutByID', variables],
      fetcher<GetRunSheetWithKpiForFlexLayoutByIdQuery, GetRunSheetWithKpiForFlexLayoutByIdQueryVariables>(GetRunSheetWithKpiForFlexLayoutByIdDocument, variables),
      options
    )};

export const GetRunSheetWithSelectedKpiForFlexLayoutByIdDocument = `
    query GetRunSheetWithSelectedKpiForFlexLayoutByID($id: MongoID!, $runKPI: [String!], $lapKPI: [String!]) {
  runSheet(_id: $id) {
    runKPI(fields: $runKPI)
    laps {
      tDay
      tLapMax
      vCarLapMax
      lapKPI(fields: $lapKPI)
    }
    contestant {
      _id
      startNumber
    }
    session {
      event {
        track {
          timeZone
        }
      }
    }
  }
}
    `;

export const useGetRunSheetWithSelectedKpiForFlexLayoutByIdQuery = <
      TData = GetRunSheetWithSelectedKpiForFlexLayoutByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetWithSelectedKpiForFlexLayoutByIdQueryVariables,
      options?: UseQueryOptions<GetRunSheetWithSelectedKpiForFlexLayoutByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetWithSelectedKpiForFlexLayoutByIdQuery, TError, TData>(
      ['GetRunSheetWithSelectedKpiForFlexLayoutByID', variables],
      fetcher<GetRunSheetWithSelectedKpiForFlexLayoutByIdQuery, GetRunSheetWithSelectedKpiForFlexLayoutByIdQueryVariables>(GetRunSheetWithSelectedKpiForFlexLayoutByIdDocument, variables),
      options
    )};

export const GetRunSheetForOverviewsWithSelectedKpiDocument = `
    query GetRunSheetForOverviewsWithSelectedKpi($id: MongoID!, $runKPI: [String!], $lapKPI: [String!]) {
  runSheet(_id: $id) {
    ...SelectedKPIRunSheetData
  }
}
    ${SelectedKpiRunSheetDataFragmentDoc}
${RunSheetForOverviewFragmentDoc}
${BrakeForRunSheetOverviewVarsFragmentDoc}
${BrakeMeasurementForRunSheetOverviewVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${CarSetupVarsForKpiViewLiveFragmentDoc}
${CarSetupVarsForKpiViewBaseFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${ChassisAssemblyForFlexSetupVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${EndVarsForSetupSheetFlexFragmentDoc}
${AntiRollBarVarsForSetupSheetFlexFragmentDoc}
${BumpStopVarsForSetupSheetFlexFragmentDoc}
${ElasticSpecForSetupSheetFlexVarsFragmentDoc}
${DroopStopVarsForSetupSheetFlexFragmentDoc}
${ExternalBumpStopVarsForSetupSheetFlexFragmentDoc}
${KinematicsExternalSpecVarsForSetupSheetFlexFragmentDoc}
${KinematicsInternalSpecVarsForSetupSheetFlexFragmentDoc}
${SpringVarsForSetupSheetFlexFragmentDoc}
${CornerVarsForSetupSheetFlexFragmentDoc}
${InfoVarsFragmentDoc}
${MassVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${RunSheetContextForSetupSheetVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${SimResultForRunSheetOverviewVarsFragmentDoc}
${RunTyreForRunSheetOverviewVarsFragmentDoc}
${WeatherForRunSheetOverviewVarsFragmentDoc}
${LapForRunSheetOverviewVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}`;

export const useGetRunSheetForOverviewsWithSelectedKpiQuery = <
      TData = GetRunSheetForOverviewsWithSelectedKpiQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetForOverviewsWithSelectedKpiQueryVariables,
      options?: UseQueryOptions<GetRunSheetForOverviewsWithSelectedKpiQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetForOverviewsWithSelectedKpiQuery, TError, TData>(
      ['GetRunSheetForOverviewsWithSelectedKpi', variables],
      fetcher<GetRunSheetForOverviewsWithSelectedKpiQuery, GetRunSheetForOverviewsWithSelectedKpiQueryVariables>(GetRunSheetForOverviewsWithSelectedKpiDocument, variables),
      options
    )};

export const GetRunSheetSimRefValuesDocument = `
    query GetRunSheetSimRefValues($runSheetID: MongoID!) {
  simResults(perPage: 1000, filter: {runSheetID: $runSheetID, status: COMPLETE}) {
    items {
      _id
      runSheetID
      refValues
      simType
      updatedAt
    }
  }
}
    `;

export const useGetRunSheetSimRefValuesQuery = <
      TData = GetRunSheetSimRefValuesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetSimRefValuesQueryVariables,
      options?: UseQueryOptions<GetRunSheetSimRefValuesQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetSimRefValuesQuery, TError, TData>(
      ['GetRunSheetSimRefValues', variables],
      fetcher<GetRunSheetSimRefValuesQuery, GetRunSheetSimRefValuesQueryVariables>(GetRunSheetSimRefValuesDocument, variables),
      options
    )};

export const GetRunSheetListForEventSelectionForKpiSetupContextDocument = `
    query GetRunSheetListForEventSelectionForKPISetupContext($eventSessionIDs: [MongoID!]!) {
  runSheets(
    perPage: 10000
    filter: {_operators: {sessionID: {in: $eventSessionIDs}}}
  ) {
    items {
      _id
      ...RunSheetForEventSelectionForKPISetupSimContextVars
      ...AllRunSheetScalarVars
      session {
        tSessionStart
        tSessionEnd
      }
    }
  }
}
    ${RunSheetForEventSelectionForKpiSetupSimContextVarsFragmentDoc}
${AllRunSheetScalarVarsFragmentDoc}`;

export const useGetRunSheetListForEventSelectionForKpiSetupContextQuery = <
      TData = GetRunSheetListForEventSelectionForKpiSetupContextQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetListForEventSelectionForKpiSetupContextQueryVariables,
      options?: UseQueryOptions<GetRunSheetListForEventSelectionForKpiSetupContextQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetListForEventSelectionForKpiSetupContextQuery, TError, TData>(
      ['GetRunSheetListForEventSelectionForKPISetupContext', variables],
      fetcher<GetRunSheetListForEventSelectionForKpiSetupContextQuery, GetRunSheetListForEventSelectionForKpiSetupContextQueryVariables>(GetRunSheetListForEventSelectionForKpiSetupContextDocument, variables),
      options
    )};

export const GetRunSheetListForEventSelectionForSimulationContextDocument = `
    query GetRunSheetListForEventSelectionForSimulationContext($sessionIDs: [MongoID!]!) {
  runSheets(perPage: 10000, filter: {_operators: {sessionID: {in: $sessionIDs}}}) {
    items {
      ...RunSheetForEventSelectionVars
    }
  }
}
    ${RunSheetForEventSelectionVarsFragmentDoc}`;

export const useGetRunSheetListForEventSelectionForSimulationContextQuery = <
      TData = GetRunSheetListForEventSelectionForSimulationContextQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetListForEventSelectionForSimulationContextQueryVariables,
      options?: UseQueryOptions<GetRunSheetListForEventSelectionForSimulationContextQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetListForEventSelectionForSimulationContextQuery, TError, TData>(
      ['GetRunSheetListForEventSelectionForSimulationContext', variables],
      fetcher<GetRunSheetListForEventSelectionForSimulationContextQuery, GetRunSheetListForEventSelectionForSimulationContextQueryVariables>(GetRunSheetListForEventSelectionForSimulationContextDocument, variables),
      options
    )};

export const SimulationTerminalLogsDocument = `
    subscription SimulationTerminalLogs($serviceSource: String) {
  logAdded(serviceSource: $serviceSource) {
    _id
    createdAt
    logLevel
    message
    serviceSource
    updatedAt
    userID
  }
}
    `;
export const GetSimulationLogsDocument = `
    query GetSimulationLogs($serviceSource: EnumLogServiceSource) {
  logs(filter: {serviceSource: $serviceSource}, perPage: 50, sort: CREATEDAT_DESC) {
    items {
      _id
      createdAt
      logLevel
      message
      serviceSource
      updatedAt
      userID
    }
  }
}
    `;

export const useGetSimulationLogsQuery = <
      TData = GetSimulationLogsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimulationLogsQueryVariables,
      options?: UseQueryOptions<GetSimulationLogsQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimulationLogsQuery, TError, TData>(
      variables === undefined ? ['GetSimulationLogs'] : ['GetSimulationLogs', variables],
      fetcher<GetSimulationLogsQuery, GetSimulationLogsQueryVariables>(GetSimulationLogsDocument, variables),
      options
    )};

export const GetStraighLineSimResultsForStagedRunsheetByIdDocument = `
    query GetStraighLineSimResultsForStagedRunsheetById($runSheetID: MongoID) {
  simResults(
    filter: {runSheetID: $runSheetID, status: COMPLETE, simType: STEADY_STATE_STRAIGHT_LINE}
    sort: UPDATEDAT_DESC
    perPage: 1
  ) {
    items {
      _id
      ...SimResultForStagedRunSimulationVars
    }
  }
}
    ${SimResultForStagedRunSimulationVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetStraighLineSimResultsForStagedRunsheetByIdQuery = <
      TData = GetStraighLineSimResultsForStagedRunsheetByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetStraighLineSimResultsForStagedRunsheetByIdQueryVariables,
      options?: UseQueryOptions<GetStraighLineSimResultsForStagedRunsheetByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetStraighLineSimResultsForStagedRunsheetByIdQuery, TError, TData>(
      variables === undefined ? ['GetStraighLineSimResultsForStagedRunsheetById'] : ['GetStraighLineSimResultsForStagedRunsheetById', variables],
      fetcher<GetStraighLineSimResultsForStagedRunsheetByIdQuery, GetStraighLineSimResultsForStagedRunsheetByIdQueryVariables>(GetStraighLineSimResultsForStagedRunsheetByIdDocument, variables),
      options
    )};

export const GetLateralSimResultsForStagedRunsheetByIdDocument = `
    query GetLateralSimResultsForStagedRunsheetById($runSheetID: MongoID) {
  simResults(
    filter: {runSheetID: $runSheetID, status: COMPLETE, simType: STEADY_STATE_LATERAL}
    sort: UPDATEDAT_DESC
    perPage: 1
  ) {
    items {
      _id
      ...SimResultForStagedRunSimulationVars
    }
  }
}
    ${SimResultForStagedRunSimulationVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetLateralSimResultsForStagedRunsheetByIdQuery = <
      TData = GetLateralSimResultsForStagedRunsheetByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetLateralSimResultsForStagedRunsheetByIdQueryVariables,
      options?: UseQueryOptions<GetLateralSimResultsForStagedRunsheetByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetLateralSimResultsForStagedRunsheetByIdQuery, TError, TData>(
      variables === undefined ? ['GetLateralSimResultsForStagedRunsheetById'] : ['GetLateralSimResultsForStagedRunsheetById', variables],
      fetcher<GetLateralSimResultsForStagedRunsheetByIdQuery, GetLateralSimResultsForStagedRunsheetByIdQueryVariables>(GetLateralSimResultsForStagedRunsheetByIdDocument, variables),
      options
    )};

export const GetQuasiSimResultsForStagedRunsheetByIdDocument = `
    query GetQuasiSimResultsForStagedRunsheetById($runSheetID: MongoID) {
  simResults(
    filter: {runSheetID: $runSheetID, status: COMPLETE, simType: QUASI_STATIC_LAP}
    sort: UPDATEDAT_DESC
    perPage: 1
  ) {
    items {
      _id
      ...SimResultForStagedRunSimulationVars
    }
  }
}
    ${SimResultForStagedRunSimulationVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetQuasiSimResultsForStagedRunsheetByIdQuery = <
      TData = GetQuasiSimResultsForStagedRunsheetByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetQuasiSimResultsForStagedRunsheetByIdQueryVariables,
      options?: UseQueryOptions<GetQuasiSimResultsForStagedRunsheetByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetQuasiSimResultsForStagedRunsheetByIdQuery, TError, TData>(
      variables === undefined ? ['GetQuasiSimResultsForStagedRunsheetById'] : ['GetQuasiSimResultsForStagedRunsheetById', variables],
      fetcher<GetQuasiSimResultsForStagedRunsheetByIdQuery, GetQuasiSimResultsForStagedRunsheetByIdQueryVariables>(GetQuasiSimResultsForStagedRunsheetByIdDocument, variables),
      options
    )};

export const AddAssemblyDocument = `
    mutation AddAssembly($record: CreateOneAssemblyInput!) {
  addAssembly(record: $record) {
    recordId
  }
}
    `;

export const useAddAssemblyMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddAssemblyMutation, TError, AddAssemblyMutationVariables, TContext>) => {
    
    return useMutation<AddAssemblyMutation, TError, AddAssemblyMutationVariables, TContext>(
      ['AddAssembly'],
      (variables?: AddAssemblyMutationVariables) => fetcher<AddAssemblyMutation, AddAssemblyMutationVariables>(AddAssemblyDocument, variables)(),
      options
    )};

export const RemoveAssemblyDocument = `
    mutation RemoveAssembly($id: MongoID!) {
  removeAssembly(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveAssemblyMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveAssemblyMutation, TError, RemoveAssemblyMutationVariables, TContext>) => {
    
    return useMutation<RemoveAssemblyMutation, TError, RemoveAssemblyMutationVariables, TContext>(
      ['RemoveAssembly'],
      (variables?: RemoveAssemblyMutationVariables) => fetcher<RemoveAssemblyMutation, RemoveAssemblyMutationVariables>(RemoveAssemblyDocument, variables)(),
      options
    )};

export const UpdateAssemblyDocument = `
    mutation UpdateAssembly($id: MongoID!, $record: UpdateByIdAssemblyInput!) {
  updateAssembly(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateAssemblyMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAssemblyMutation, TError, UpdateAssemblyMutationVariables, TContext>) => {
    
    return useMutation<UpdateAssemblyMutation, TError, UpdateAssemblyMutationVariables, TContext>(
      ['UpdateAssembly'],
      (variables?: UpdateAssemblyMutationVariables) => fetcher<UpdateAssemblyMutation, UpdateAssemblyMutationVariables>(UpdateAssemblyDocument, variables)(),
      options
    )};

export const AddAssemblyTemplateDocument = `
    mutation AddAssemblyTemplate($record: CreateOneAssemblyTemplateInput!) {
  addAssemblyTemplate(record: $record) {
    recordId
  }
}
    `;

export const useAddAssemblyTemplateMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddAssemblyTemplateMutation, TError, AddAssemblyTemplateMutationVariables, TContext>) => {
    
    return useMutation<AddAssemblyTemplateMutation, TError, AddAssemblyTemplateMutationVariables, TContext>(
      ['AddAssemblyTemplate'],
      (variables?: AddAssemblyTemplateMutationVariables) => fetcher<AddAssemblyTemplateMutation, AddAssemblyTemplateMutationVariables>(AddAssemblyTemplateDocument, variables)(),
      options
    )};

export const AddChassisMeasurementDocument = `
    mutation AddChassisMeasurement($record: CreateOneChassisMeasurementInput!) {
  addChassisMeasurement(record: $record) {
    recordId
  }
}
    `;

export const useAddChassisMeasurementMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddChassisMeasurementMutation, TError, AddChassisMeasurementMutationVariables, TContext>) => {
    
    return useMutation<AddChassisMeasurementMutation, TError, AddChassisMeasurementMutationVariables, TContext>(
      ['AddChassisMeasurement'],
      (variables?: AddChassisMeasurementMutationVariables) => fetcher<AddChassisMeasurementMutation, AddChassisMeasurementMutationVariables>(AddChassisMeasurementDocument, variables)(),
      options
    )};

export const AddDepartmentDocument = `
    mutation AddDepartment($record: CreateOneDepartmentInput!) {
  addDepartment(record: $record) {
    recordId
  }
}
    `;

export const useAddDepartmentMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddDepartmentMutation, TError, AddDepartmentMutationVariables, TContext>) => {
    
    return useMutation<AddDepartmentMutation, TError, AddDepartmentMutationVariables, TContext>(
      ['AddDepartment'],
      (variables?: AddDepartmentMutationVariables) => fetcher<AddDepartmentMutation, AddDepartmentMutationVariables>(AddDepartmentDocument, variables)(),
      options
    )};

export const AddIssueDocument = `
    mutation AddIssue($record: CreateOneIssueInput!) {
  addIssue(record: $record) {
    recordId
  }
}
    `;

export const useAddIssueMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddIssueMutation, TError, AddIssueMutationVariables, TContext>) => {
    
    return useMutation<AddIssueMutation, TError, AddIssueMutationVariables, TContext>(
      ['AddIssue'],
      (variables?: AddIssueMutationVariables) => fetcher<AddIssueMutation, AddIssueMutationVariables>(AddIssueDocument, variables)(),
      options
    )};

export const AddLocationDocument = `
    mutation AddLocation($record: CreateOneLocationInput!) {
  addLocation(record: $record) {
    recordId
  }
}
    `;

export const useAddLocationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddLocationMutation, TError, AddLocationMutationVariables, TContext>) => {
    
    return useMutation<AddLocationMutation, TError, AddLocationMutationVariables, TContext>(
      ['AddLocation'],
      (variables?: AddLocationMutationVariables) => fetcher<AddLocationMutation, AddLocationMutationVariables>(AddLocationDocument, variables)(),
      options
    )};

export const AddPackageDocument = `
    mutation AddPackage($record: CreateOnePackageInput!) {
  addPackage(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddPackageMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddPackageMutation, TError, AddPackageMutationVariables, TContext>) => {
    
    return useMutation<AddPackageMutation, TError, AddPackageMutationVariables, TContext>(
      ['AddPackage'],
      (variables?: AddPackageMutationVariables) => fetcher<AddPackageMutation, AddPackageMutationVariables>(AddPackageDocument, variables)(),
      options
    )};

export const AddPartInstanceDocument = `
    mutation AddPartInstance($record: CreateOnePartInstanceInput!) {
  addPartInstance(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddPartInstanceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddPartInstanceMutation, TError, AddPartInstanceMutationVariables, TContext>) => {
    
    return useMutation<AddPartInstanceMutation, TError, AddPartInstanceMutationVariables, TContext>(
      ['AddPartInstance'],
      (variables?: AddPartInstanceMutationVariables) => fetcher<AddPartInstanceMutation, AddPartInstanceMutationVariables>(AddPartInstanceDocument, variables)(),
      options
    )};

export const AddSimulationDocument = `
    mutation AddSimulation($record: CreateOneSimResultInput!) {
  addSimResult(record: $record) {
    recordId
  }
}
    `;

export const useAddSimulationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddSimulationMutation, TError, AddSimulationMutationVariables, TContext>) => {
    
    return useMutation<AddSimulationMutation, TError, AddSimulationMutationVariables, TContext>(
      ['AddSimulation'],
      (variables?: AddSimulationMutationVariables) => fetcher<AddSimulationMutation, AddSimulationMutationVariables>(AddSimulationDocument, variables)(),
      options
    )};

export const AddTrackingItemDocument = `
    mutation AddTrackingItem($record: CreateOneTrackingItemInput!) {
  addTrackingItem(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddTrackingItemMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTrackingItemMutation, TError, AddTrackingItemMutationVariables, TContext>) => {
    
    return useMutation<AddTrackingItemMutation, TError, AddTrackingItemMutationVariables, TContext>(
      ['AddTrackingItem'],
      (variables?: AddTrackingItemMutationVariables) => fetcher<AddTrackingItemMutation, AddTrackingItemMutationVariables>(AddTrackingItemDocument, variables)(),
      options
    )};

export const AddTrackingMeasurementDocument = `
    mutation AddTrackingMeasurement($record: CreateOneTrackingMeasurementInput!) {
  addTrackingMeasurement(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddTrackingMeasurementMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTrackingMeasurementMutation, TError, AddTrackingMeasurementMutationVariables, TContext>) => {
    
    return useMutation<AddTrackingMeasurementMutation, TError, AddTrackingMeasurementMutationVariables, TContext>(
      ['AddTrackingMeasurement'],
      (variables?: AddTrackingMeasurementMutationVariables) => fetcher<AddTrackingMeasurementMutation, AddTrackingMeasurementMutationVariables>(AddTrackingMeasurementDocument, variables)(),
      options
    )};

export const AddTrackingMeasurementRecordDocument = `
    mutation AddTrackingMeasurementRecord($record: CreateOneTrackingMeasurementRecordInput!) {
  addTrackingMeasurementRecord(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddTrackingMeasurementRecordMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTrackingMeasurementRecordMutation, TError, AddTrackingMeasurementRecordMutationVariables, TContext>) => {
    
    return useMutation<AddTrackingMeasurementRecordMutation, TError, AddTrackingMeasurementRecordMutationVariables, TContext>(
      ['AddTrackingMeasurementRecord'],
      (variables?: AddTrackingMeasurementRecordMutationVariables) => fetcher<AddTrackingMeasurementRecordMutation, AddTrackingMeasurementRecordMutationVariables>(AddTrackingMeasurementRecordDocument, variables)(),
      options
    )};

export const AddTrackingRecordDocument = `
    mutation AddTrackingRecord($record: CreateOneTrackingRecordInput!) {
  addTrackingRecord(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddTrackingRecordMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTrackingRecordMutation, TError, AddTrackingRecordMutationVariables, TContext>) => {
    
    return useMutation<AddTrackingRecordMutation, TError, AddTrackingRecordMutationVariables, TContext>(
      ['AddTrackingRecord'],
      (variables?: AddTrackingRecordMutationVariables) => fetcher<AddTrackingRecordMutation, AddTrackingRecordMutationVariables>(AddTrackingRecordDocument, variables)(),
      options
    )};

export const AddTrackingRecordValueDocument = `
    mutation AddTrackingRecordValue($record: CreateOneTrackingRecordValueInput!) {
  addTrackingRecordValue(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddTrackingRecordValueMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTrackingRecordValueMutation, TError, AddTrackingRecordValueMutationVariables, TContext>) => {
    
    return useMutation<AddTrackingRecordValueMutation, TError, AddTrackingRecordValueMutationVariables, TContext>(
      ['AddTrackingRecordValue'],
      (variables?: AddTrackingRecordValueMutationVariables) => fetcher<AddTrackingRecordValueMutation, AddTrackingRecordValueMutationVariables>(AddTrackingRecordValueDocument, variables)(),
      options
    )};

export const AddTrackingRecordGeneralDocument = `
    mutation AddTrackingRecordGeneral($record: CreateOneTrackingRecordGeneralInput!) {
  addTrackingRecordGeneral(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddTrackingRecordGeneralMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTrackingRecordGeneralMutation, TError, AddTrackingRecordGeneralMutationVariables, TContext>) => {
    
    return useMutation<AddTrackingRecordGeneralMutation, TError, AddTrackingRecordGeneralMutationVariables, TContext>(
      ['AddTrackingRecordGeneral'],
      (variables?: AddTrackingRecordGeneralMutationVariables) => fetcher<AddTrackingRecordGeneralMutation, AddTrackingRecordGeneralMutationVariables>(AddTrackingRecordGeneralDocument, variables)(),
      options
    )};

export const AddTrackingRecordOverrideDocument = `
    mutation AddTrackingRecordOverride($record: CreateOneTrackingRecordOverrideInput!) {
  addTrackingRecordOverride(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddTrackingRecordOverrideMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTrackingRecordOverrideMutation, TError, AddTrackingRecordOverrideMutationVariables, TContext>) => {
    
    return useMutation<AddTrackingRecordOverrideMutation, TError, AddTrackingRecordOverrideMutationVariables, TContext>(
      ['AddTrackingRecordOverride'],
      (variables?: AddTrackingRecordOverrideMutationVariables) => fetcher<AddTrackingRecordOverrideMutation, AddTrackingRecordOverrideMutationVariables>(AddTrackingRecordOverrideDocument, variables)(),
      options
    )};

export const AddTyreWearDocument = `
    mutation AddTyreWear($record: CreateOneTyreWearInput!) {
  addTyreWear(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddTyreWearMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTyreWearMutation, TError, AddTyreWearMutationVariables, TContext>) => {
    
    return useMutation<AddTyreWearMutation, TError, AddTyreWearMutationVariables, TContext>(
      ['AddTyreWear'],
      (variables?: AddTyreWearMutationVariables) => fetcher<AddTyreWearMutation, AddTyreWearMutationVariables>(AddTyreWearDocument, variables)(),
      options
    )};

export const AddWeatherDocument = `
    mutation AddWeather($record: CreateOneWeatherInput!) {
  addWeather(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddWeatherMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddWeatherMutation, TError, AddWeatherMutationVariables, TContext>) => {
    
    return useMutation<AddWeatherMutation, TError, AddWeatherMutationVariables, TContext>(
      ['AddWeather'],
      (variables?: AddWeatherMutationVariables) => fetcher<AddWeatherMutation, AddWeatherMutationVariables>(AddWeatherDocument, variables)(),
      options
    )};

export const CopyAssemblyDocument = `
    mutation CopyAssembly($sourceID: MongoID!, $newRootReference: String) {
  copyAssembly(assemblyToCopyID: $sourceID, newRootReference: $newRootReference) {
    newAssemblyID
  }
}
    `;

export const useCopyAssemblyMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CopyAssemblyMutation, TError, CopyAssemblyMutationVariables, TContext>) => {
    
    return useMutation<CopyAssemblyMutation, TError, CopyAssemblyMutationVariables, TContext>(
      ['CopyAssembly'],
      (variables?: CopyAssemblyMutationVariables) => fetcher<CopyAssemblyMutation, CopyAssemblyMutationVariables>(CopyAssemblyDocument, variables)(),
      options
    )};

export const SwapPartInstanceDocument = `
    mutation SwapPartInstance($parentID: MongoID!, $partID: MongoID!, $specificationID: MongoID!, $readingLocation: EnumReadingLocation) {
  swapPartInstance(
    parentID: $parentID
    partID: $partID
    specificationID: $specificationID
    readingLocation: $readingLocation
  ) {
    newPartInstanceID
  }
}
    `;

export const useSwapPartInstanceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<SwapPartInstanceMutation, TError, SwapPartInstanceMutationVariables, TContext>) => {
    
    return useMutation<SwapPartInstanceMutation, TError, SwapPartInstanceMutationVariables, TContext>(
      ['SwapPartInstance'],
      (variables?: SwapPartInstanceMutationVariables) => fetcher<SwapPartInstanceMutation, SwapPartInstanceMutationVariables>(SwapPartInstanceDocument, variables)(),
      options
    )};

export const ForwardUpdateCarSetupDocument = `
    mutation ForwardUpdateCarSetup($carSetupId: MongoID!, $field: String!, $value: Float, $stringValue: String, $booleanValue: Boolean) {
  forwardUpdateCarSetup(
    carSetupID: $carSetupId
    field: $field
    value: $value
    stringValue: $stringValue
    booleanValue: $booleanValue
  ) {
    updatedCarSetupIDs
  }
}
    `;

export const useForwardUpdateCarSetupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ForwardUpdateCarSetupMutation, TError, ForwardUpdateCarSetupMutationVariables, TContext>) => {
    
    return useMutation<ForwardUpdateCarSetupMutation, TError, ForwardUpdateCarSetupMutationVariables, TContext>(
      ['ForwardUpdateCarSetup'],
      (variables?: ForwardUpdateCarSetupMutationVariables) => fetcher<ForwardUpdateCarSetupMutation, ForwardUpdateCarSetupMutationVariables>(ForwardUpdateCarSetupDocument, variables)(),
      options
    )};

export const ForwardUpsertPartInstanceDocument = `
    mutation ForwardUpsertPartInstance($chassisAssemblyId: MongoID, $measurementIndex: Int, $measurements: PartInstanceMeasurementInput, $newPartId: MongoID, $readingLocation: EnumReadingLocation!, $specificationId: MongoID!, $trackingItemReferenceDate: Date) {
  forwardUpsertPartInstance(
    chassisAssemblyID: $chassisAssemblyId
    measurementIndex: $measurementIndex
    measurements: $measurements
    newPartID: $newPartId
    readingLocation: $readingLocation
    specificationID: $specificationId
    trackingItemReferenceDate: $trackingItemReferenceDate
  ) {
    updatedPartInstanceIDs
  }
}
    `;

export const useForwardUpsertPartInstanceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ForwardUpsertPartInstanceMutation, TError, ForwardUpsertPartInstanceMutationVariables, TContext>) => {
    
    return useMutation<ForwardUpsertPartInstanceMutation, TError, ForwardUpsertPartInstanceMutationVariables, TContext>(
      ['ForwardUpsertPartInstance'],
      (variables?: ForwardUpsertPartInstanceMutationVariables) => fetcher<ForwardUpsertPartInstanceMutation, ForwardUpsertPartInstanceMutationVariables>(ForwardUpsertPartInstanceDocument, variables)(),
      options
    )};

export const RemoveAssemblyTemplateDocument = `
    mutation RemoveAssemblyTemplate($id: MongoID!) {
  removeAssemblyTemplate(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveAssemblyTemplateMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveAssemblyTemplateMutation, TError, RemoveAssemblyTemplateMutationVariables, TContext>) => {
    
    return useMutation<RemoveAssemblyTemplateMutation, TError, RemoveAssemblyTemplateMutationVariables, TContext>(
      ['RemoveAssemblyTemplate'],
      (variables?: RemoveAssemblyTemplateMutationVariables) => fetcher<RemoveAssemblyTemplateMutation, RemoveAssemblyTemplateMutationVariables>(RemoveAssemblyTemplateDocument, variables)(),
      options
    )};

export const RemoveIssueDocument = `
    mutation RemoveIssue($id: MongoID!) {
  removeIssue(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveIssueMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveIssueMutation, TError, RemoveIssueMutationVariables, TContext>) => {
    
    return useMutation<RemoveIssueMutation, TError, RemoveIssueMutationVariables, TContext>(
      ['RemoveIssue'],
      (variables?: RemoveIssueMutationVariables) => fetcher<RemoveIssueMutation, RemoveIssueMutationVariables>(RemoveIssueDocument, variables)(),
      options
    )};

export const RemoveDepartmentDocument = `
    mutation RemoveDepartment($id: MongoID!) {
  removeDepartment(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveDepartmentMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveDepartmentMutation, TError, RemoveDepartmentMutationVariables, TContext>) => {
    
    return useMutation<RemoveDepartmentMutation, TError, RemoveDepartmentMutationVariables, TContext>(
      ['RemoveDepartment'],
      (variables?: RemoveDepartmentMutationVariables) => fetcher<RemoveDepartmentMutation, RemoveDepartmentMutationVariables>(RemoveDepartmentDocument, variables)(),
      options
    )};

export const RemoveChassisMeasurementDocument = `
    mutation RemoveChassisMeasurement($id: MongoID!) {
  removeChassisMeasurement(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveChassisMeasurementMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveChassisMeasurementMutation, TError, RemoveChassisMeasurementMutationVariables, TContext>) => {
    
    return useMutation<RemoveChassisMeasurementMutation, TError, RemoveChassisMeasurementMutationVariables, TContext>(
      ['RemoveChassisMeasurement'],
      (variables?: RemoveChassisMeasurementMutationVariables) => fetcher<RemoveChassisMeasurementMutation, RemoveChassisMeasurementMutationVariables>(RemoveChassisMeasurementDocument, variables)(),
      options
    )};

export const RemoveLapByIdDocument = `
    mutation RemoveLapById($id: MongoID!) {
  removeLapByID(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveLapByIdMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveLapByIdMutation, TError, RemoveLapByIdMutationVariables, TContext>) => {
    
    return useMutation<RemoveLapByIdMutation, TError, RemoveLapByIdMutationVariables, TContext>(
      ['RemoveLapById'],
      (variables?: RemoveLapByIdMutationVariables) => fetcher<RemoveLapByIdMutation, RemoveLapByIdMutationVariables>(RemoveLapByIdDocument, variables)(),
      options
    )};

export const RemoveLocationDocument = `
    mutation RemoveLocation($id: MongoID!) {
  removeLocation(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveLocationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveLocationMutation, TError, RemoveLocationMutationVariables, TContext>) => {
    
    return useMutation<RemoveLocationMutation, TError, RemoveLocationMutationVariables, TContext>(
      ['RemoveLocation'],
      (variables?: RemoveLocationMutationVariables) => fetcher<RemoveLocationMutation, RemoveLocationMutationVariables>(RemoveLocationDocument, variables)(),
      options
    )};

export const RemovePackageDocument = `
    mutation RemovePackage($id: MongoID!) {
  removePackage(_id: $id) {
    recordId
  }
}
    `;

export const useRemovePackageMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemovePackageMutation, TError, RemovePackageMutationVariables, TContext>) => {
    
    return useMutation<RemovePackageMutation, TError, RemovePackageMutationVariables, TContext>(
      ['RemovePackage'],
      (variables?: RemovePackageMutationVariables) => fetcher<RemovePackageMutation, RemovePackageMutationVariables>(RemovePackageDocument, variables)(),
      options
    )};

export const RemovePartInstanceDocument = `
    mutation RemovePartInstance($id: MongoID!) {
  removePartInstance(_id: $id) {
    recordId
  }
}
    `;

export const useRemovePartInstanceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemovePartInstanceMutation, TError, RemovePartInstanceMutationVariables, TContext>) => {
    
    return useMutation<RemovePartInstanceMutation, TError, RemovePartInstanceMutationVariables, TContext>(
      ['RemovePartInstance'],
      (variables?: RemovePartInstanceMutationVariables) => fetcher<RemovePartInstanceMutation, RemovePartInstanceMutationVariables>(RemovePartInstanceDocument, variables)(),
      options
    )};

export const RemoveTrackingItemDocument = `
    mutation RemoveTrackingItem($id: MongoID!) {
  removeTrackingItem(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTrackingItemMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTrackingItemMutation, TError, RemoveTrackingItemMutationVariables, TContext>) => {
    
    return useMutation<RemoveTrackingItemMutation, TError, RemoveTrackingItemMutationVariables, TContext>(
      ['RemoveTrackingItem'],
      (variables?: RemoveTrackingItemMutationVariables) => fetcher<RemoveTrackingItemMutation, RemoveTrackingItemMutationVariables>(RemoveTrackingItemDocument, variables)(),
      options
    )};

export const RemoveTrackingMeasurementDocument = `
    mutation RemoveTrackingMeasurement($id: MongoID!) {
  removeTrackingMeasurement(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTrackingMeasurementMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTrackingMeasurementMutation, TError, RemoveTrackingMeasurementMutationVariables, TContext>) => {
    
    return useMutation<RemoveTrackingMeasurementMutation, TError, RemoveTrackingMeasurementMutationVariables, TContext>(
      ['RemoveTrackingMeasurement'],
      (variables?: RemoveTrackingMeasurementMutationVariables) => fetcher<RemoveTrackingMeasurementMutation, RemoveTrackingMeasurementMutationVariables>(RemoveTrackingMeasurementDocument, variables)(),
      options
    )};

export const RemoveTrackingMeasurementRecordDocument = `
    mutation RemoveTrackingMeasurementRecord($id: MongoID!) {
  removeTrackingMeasurementRecord(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTrackingMeasurementRecordMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTrackingMeasurementRecordMutation, TError, RemoveTrackingMeasurementRecordMutationVariables, TContext>) => {
    
    return useMutation<RemoveTrackingMeasurementRecordMutation, TError, RemoveTrackingMeasurementRecordMutationVariables, TContext>(
      ['RemoveTrackingMeasurementRecord'],
      (variables?: RemoveTrackingMeasurementRecordMutationVariables) => fetcher<RemoveTrackingMeasurementRecordMutation, RemoveTrackingMeasurementRecordMutationVariables>(RemoveTrackingMeasurementRecordDocument, variables)(),
      options
    )};

export const RemoveTrackingRecordDocument = `
    mutation RemoveTrackingRecord($id: MongoID!) {
  removeTrackingRecord(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTrackingRecordMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTrackingRecordMutation, TError, RemoveTrackingRecordMutationVariables, TContext>) => {
    
    return useMutation<RemoveTrackingRecordMutation, TError, RemoveTrackingRecordMutationVariables, TContext>(
      ['RemoveTrackingRecord'],
      (variables?: RemoveTrackingRecordMutationVariables) => fetcher<RemoveTrackingRecordMutation, RemoveTrackingRecordMutationVariables>(RemoveTrackingRecordDocument, variables)(),
      options
    )};

export const RemoveTyreWearDocument = `
    mutation RemoveTyreWear($id: MongoID!) {
  removeTyreWear(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTyreWearMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTyreWearMutation, TError, RemoveTyreWearMutationVariables, TContext>) => {
    
    return useMutation<RemoveTyreWearMutation, TError, RemoveTyreWearMutationVariables, TContext>(
      ['RemoveTyreWear'],
      (variables?: RemoveTyreWearMutationVariables) => fetcher<RemoveTyreWearMutation, RemoveTyreWearMutationVariables>(RemoveTyreWearDocument, variables)(),
      options
    )};

export const AppendWeatherDocument = `
    mutation AppendWeather($weatherId: MongoID!, $data: WeatherDataInput!) {
  appendWeather(weatherID: $weatherId, data: $data) {
    _id
  }
}
    `;

export const useAppendWeatherMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AppendWeatherMutation, TError, AppendWeatherMutationVariables, TContext>) => {
    
    return useMutation<AppendWeatherMutation, TError, AppendWeatherMutationVariables, TContext>(
      ['AppendWeather'],
      (variables?: AppendWeatherMutationVariables) => fetcher<AppendWeatherMutation, AppendWeatherMutationVariables>(AppendWeatherDocument, variables)(),
      options
    )};

export const ApplyPackageDocument = `
    mutation ApplyPackage($packageID: MongoID!, $carSetupIDs: [MongoID!]) {
  applyPackage(packageID: $packageID, carSetupIDs: $carSetupIDs) {
    success
  }
}
    `;

export const useApplyPackageMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ApplyPackageMutation, TError, ApplyPackageMutationVariables, TContext>) => {
    
    return useMutation<ApplyPackageMutation, TError, ApplyPackageMutationVariables, TContext>(
      ['ApplyPackage'],
      (variables?: ApplyPackageMutationVariables) => fetcher<ApplyPackageMutation, ApplyPackageMutationVariables>(ApplyPackageDocument, variables)(),
      options
    )};

export const CreatePackageDocument = `
    mutation CreatePackage($baselineSetupID: MongoID!, $candidateSetupID: MongoID!, $method: EnumPackageMethod, $name: String!) {
  createPackage(
    baselineSetupID: $baselineSetupID
    candidateSetupID: $candidateSetupID
    method: $method
    name: $name
  ) {
    _id
  }
}
    `;

export const useCreatePackageMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CreatePackageMutation, TError, CreatePackageMutationVariables, TContext>) => {
    
    return useMutation<CreatePackageMutation, TError, CreatePackageMutationVariables, TContext>(
      ['CreatePackage'],
      (variables?: CreatePackageMutationVariables) => fetcher<CreatePackageMutation, CreatePackageMutationVariables>(CreatePackageDocument, variables)(),
      options
    )};

export const RecalculatePartMileageDocument = `
    mutation RecalculatePartMileage($partID: MongoID!) {
  recalculatePartMileageByIDResolver(partID: $partID) {
    mileage
    partID
  }
}
    `;

export const useRecalculatePartMileageMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RecalculatePartMileageMutation, TError, RecalculatePartMileageMutationVariables, TContext>) => {
    
    return useMutation<RecalculatePartMileageMutation, TError, RecalculatePartMileageMutationVariables, TContext>(
      ['RecalculatePartMileage'],
      (variables?: RecalculatePartMileageMutationVariables) => fetcher<RecalculatePartMileageMutation, RecalculatePartMileageMutationVariables>(RecalculatePartMileageDocument, variables)(),
      options
    )};

export const RecalculateRunSheetMileagesDocument = `
    mutation RecalculateRunSheetMileages($runSheetIDs: [MongoID!]!) {
  calculateMileagesByRunSheetIDs(runSheetIDs: $runSheetIDs, forceUpdate: true)
}
    `;

export const useRecalculateRunSheetMileagesMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RecalculateRunSheetMileagesMutation, TError, RecalculateRunSheetMileagesMutationVariables, TContext>) => {
    
    return useMutation<RecalculateRunSheetMileagesMutation, TError, RecalculateRunSheetMileagesMutationVariables, TContext>(
      ['RecalculateRunSheetMileages'],
      (variables?: RecalculateRunSheetMileagesMutationVariables) => fetcher<RecalculateRunSheetMileagesMutation, RecalculateRunSheetMileagesMutationVariables>(RecalculateRunSheetMileagesDocument, variables)(),
      options
    )};

export const UpdateAssemblyTemplateDocument = `
    mutation UpdateAssemblyTemplate($id: MongoID!, $record: UpdateByIdAssemblyTemplateInput!) {
  updateAssemblyTemplate(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateAssemblyTemplateMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAssemblyTemplateMutation, TError, UpdateAssemblyTemplateMutationVariables, TContext>) => {
    
    return useMutation<UpdateAssemblyTemplateMutation, TError, UpdateAssemblyTemplateMutationVariables, TContext>(
      ['UpdateAssemblyTemplate'],
      (variables?: UpdateAssemblyTemplateMutationVariables) => fetcher<UpdateAssemblyTemplateMutation, UpdateAssemblyTemplateMutationVariables>(UpdateAssemblyTemplateDocument, variables)(),
      options
    )};

export const UpdateChassisMeasurementDocument = `
    mutation UpdateChassisMeasurement($id: MongoID!, $record: UpdateByIdChassisMeasurementInput!) {
  updateChassisMeasurement(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateChassisMeasurementMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateChassisMeasurementMutation, TError, UpdateChassisMeasurementMutationVariables, TContext>) => {
    
    return useMutation<UpdateChassisMeasurementMutation, TError, UpdateChassisMeasurementMutationVariables, TContext>(
      ['UpdateChassisMeasurement'],
      (variables?: UpdateChassisMeasurementMutationVariables) => fetcher<UpdateChassisMeasurementMutation, UpdateChassisMeasurementMutationVariables>(UpdateChassisMeasurementDocument, variables)(),
      options
    )};

export const UpdateDepartmentDocument = `
    mutation UpdateDepartment($id: MongoID!, $record: UpdateByIdDepartmentInput!) {
  updateDepartment(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateDepartmentMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDepartmentMutation, TError, UpdateDepartmentMutationVariables, TContext>) => {
    
    return useMutation<UpdateDepartmentMutation, TError, UpdateDepartmentMutationVariables, TContext>(
      ['UpdateDepartment'],
      (variables?: UpdateDepartmentMutationVariables) => fetcher<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>(UpdateDepartmentDocument, variables)(),
      options
    )};

export const UpdateIssueDocument = `
    mutation UpdateIssue($id: MongoID!, $record: UpdateByIdIssueInput!) {
  updateIssue(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateIssueMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateIssueMutation, TError, UpdateIssueMutationVariables, TContext>) => {
    
    return useMutation<UpdateIssueMutation, TError, UpdateIssueMutationVariables, TContext>(
      ['UpdateIssue'],
      (variables?: UpdateIssueMutationVariables) => fetcher<UpdateIssueMutation, UpdateIssueMutationVariables>(UpdateIssueDocument, variables)(),
      options
    )};

export const UpdateLapDataByIdDocument = `
    mutation UpdateLapDataById($id: MongoID!, $record: UpdateByIdLapDataInput, $source: EnumLapDataSource!) {
  updateLapDataByID(_id: $id, data: $record, source: $source) {
    _id
  }
}
    `;

export const useUpdateLapDataByIdMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLapDataByIdMutation, TError, UpdateLapDataByIdMutationVariables, TContext>) => {
    
    return useMutation<UpdateLapDataByIdMutation, TError, UpdateLapDataByIdMutationVariables, TContext>(
      ['UpdateLapDataById'],
      (variables?: UpdateLapDataByIdMutationVariables) => fetcher<UpdateLapDataByIdMutation, UpdateLapDataByIdMutationVariables>(UpdateLapDataByIdDocument, variables)(),
      options
    )};

export const UpdateLocationDocument = `
    mutation UpdateLocation($id: MongoID!, $record: UpdateByIdLocationInput!) {
  updateLocation(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateLocationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLocationMutation, TError, UpdateLocationMutationVariables, TContext>) => {
    
    return useMutation<UpdateLocationMutation, TError, UpdateLocationMutationVariables, TContext>(
      ['UpdateLocation'],
      (variables?: UpdateLocationMutationVariables) => fetcher<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, variables)(),
      options
    )};

export const UpdatePackageDocument = `
    mutation UpdatePackage($id: MongoID!, $record: UpdateByIdPackageInput!) {
  updatePackage(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdatePackageMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePackageMutation, TError, UpdatePackageMutationVariables, TContext>) => {
    
    return useMutation<UpdatePackageMutation, TError, UpdatePackageMutationVariables, TContext>(
      ['UpdatePackage'],
      (variables?: UpdatePackageMutationVariables) => fetcher<UpdatePackageMutation, UpdatePackageMutationVariables>(UpdatePackageDocument, variables)(),
      options
    )};

export const UpdatePartInstanceDocument = `
    mutation UpdatePartInstance($id: MongoID!, $record: UpdateByIdPartInstanceInput!) {
  updatePartInstance(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdatePartInstanceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePartInstanceMutation, TError, UpdatePartInstanceMutationVariables, TContext>) => {
    
    return useMutation<UpdatePartInstanceMutation, TError, UpdatePartInstanceMutationVariables, TContext>(
      ['UpdatePartInstance'],
      (variables?: UpdatePartInstanceMutationVariables) => fetcher<UpdatePartInstanceMutation, UpdatePartInstanceMutationVariables>(UpdatePartInstanceDocument, variables)(),
      options
    )};

export const UpdateTrackingItemDocument = `
    mutation UpdateTrackingItem($id: MongoID!, $record: UpdateByIdTrackingItemInput!) {
  updateTrackingItem(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTrackingItemMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTrackingItemMutation, TError, UpdateTrackingItemMutationVariables, TContext>) => {
    
    return useMutation<UpdateTrackingItemMutation, TError, UpdateTrackingItemMutationVariables, TContext>(
      ['UpdateTrackingItem'],
      (variables?: UpdateTrackingItemMutationVariables) => fetcher<UpdateTrackingItemMutation, UpdateTrackingItemMutationVariables>(UpdateTrackingItemDocument, variables)(),
      options
    )};

export const UpdateTrackingMeasurementDocument = `
    mutation UpdateTrackingMeasurement($id: MongoID!, $record: UpdateByIdTrackingMeasurementInput!) {
  updateTrackingMeasurement(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTrackingMeasurementMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTrackingMeasurementMutation, TError, UpdateTrackingMeasurementMutationVariables, TContext>) => {
    
    return useMutation<UpdateTrackingMeasurementMutation, TError, UpdateTrackingMeasurementMutationVariables, TContext>(
      ['UpdateTrackingMeasurement'],
      (variables?: UpdateTrackingMeasurementMutationVariables) => fetcher<UpdateTrackingMeasurementMutation, UpdateTrackingMeasurementMutationVariables>(UpdateTrackingMeasurementDocument, variables)(),
      options
    )};

export const UpdateTrackingMeasurementRecordDocument = `
    mutation UpdateTrackingMeasurementRecord($id: MongoID!, $record: UpdateByIdTrackingMeasurementRecordInput!) {
  updateTrackingMeasurementRecord(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTrackingMeasurementRecordMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTrackingMeasurementRecordMutation, TError, UpdateTrackingMeasurementRecordMutationVariables, TContext>) => {
    
    return useMutation<UpdateTrackingMeasurementRecordMutation, TError, UpdateTrackingMeasurementRecordMutationVariables, TContext>(
      ['UpdateTrackingMeasurementRecord'],
      (variables?: UpdateTrackingMeasurementRecordMutationVariables) => fetcher<UpdateTrackingMeasurementRecordMutation, UpdateTrackingMeasurementRecordMutationVariables>(UpdateTrackingMeasurementRecordDocument, variables)(),
      options
    )};

export const UpdateTrackingRecordDocument = `
    mutation UpdateTrackingRecord($id: MongoID!, $record: UpdateByIdTrackingRecordInput!) {
  updateTrackingRecord(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTrackingRecordMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTrackingRecordMutation, TError, UpdateTrackingRecordMutationVariables, TContext>) => {
    
    return useMutation<UpdateTrackingRecordMutation, TError, UpdateTrackingRecordMutationVariables, TContext>(
      ['UpdateTrackingRecord'],
      (variables?: UpdateTrackingRecordMutationVariables) => fetcher<UpdateTrackingRecordMutation, UpdateTrackingRecordMutationVariables>(UpdateTrackingRecordDocument, variables)(),
      options
    )};

export const UpdateTyreWearDocument = `
    mutation UpdateTyreWear($id: MongoID!, $record: UpdateByIdTyreWearInput!) {
  updateTyreWear(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTyreWearMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTyreWearMutation, TError, UpdateTyreWearMutationVariables, TContext>) => {
    
    return useMutation<UpdateTyreWearMutation, TError, UpdateTyreWearMutationVariables, TContext>(
      ['UpdateTyreWear'],
      (variables?: UpdateTyreWearMutationVariables) => fetcher<UpdateTyreWearMutation, UpdateTyreWearMutationVariables>(UpdateTyreWearDocument, variables)(),
      options
    )};

export const UpdatePartDocument = `
    mutation UpdatePart($id: MongoID!, $record: UpdateByIdPartInput!) {
  updatePart(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdatePartMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePartMutation, TError, UpdatePartMutationVariables, TContext>) => {
    
    return useMutation<UpdatePartMutation, TError, UpdatePartMutationVariables, TContext>(
      ['UpdatePart'],
      (variables?: UpdatePartMutationVariables) => fetcher<UpdatePartMutation, UpdatePartMutationVariables>(UpdatePartDocument, variables)(),
      options
    )};

export const UpsertPartInstanceDocument = `
    mutation UpsertPartInstance($readingLocation: EnumReadingLocation!, $parentId: MongoID!, $measurementIndex: Int!, $carSetupId: MongoID, $specificationId: MongoID!, $measurements: PartInstanceMeasurementInput) {
  upsertPartInstance(
    readingLocation: $readingLocation
    parentID: $parentId
    measurementIndex: $measurementIndex
    carSetupID: $carSetupId
    specificationID: $specificationId
    measurements: $measurements
  ) {
    recordId
  }
}
    `;

export const useUpsertPartInstanceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpsertPartInstanceMutation, TError, UpsertPartInstanceMutationVariables, TContext>) => {
    
    return useMutation<UpsertPartInstanceMutation, TError, UpsertPartInstanceMutationVariables, TContext>(
      ['UpsertPartInstance'],
      (variables?: UpsertPartInstanceMutationVariables) => fetcher<UpsertPartInstanceMutation, UpsertPartInstanceMutationVariables>(UpsertPartInstanceDocument, variables)(),
      options
    )};

export const UpdateWeatherDocument = `
    mutation UpdateWeather($id: MongoID!, $record: UpdateByIdWeatherInput!) {
  updateWeather(_id: $id, record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useUpdateWeatherMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWeatherMutation, TError, UpdateWeatherMutationVariables, TContext>) => {
    
    return useMutation<UpdateWeatherMutation, TError, UpdateWeatherMutationVariables, TContext>(
      ['UpdateWeather'],
      (variables?: UpdateWeatherMutationVariables) => fetcher<UpdateWeatherMutation, UpdateWeatherMutationVariables>(UpdateWeatherDocument, variables)(),
      options
    )};

export const AddCalculationDocument = `
    mutation AddCalculation($record: CreateOneCalculationInput!) {
  addCalculation(record: $record) {
    recordId
  }
}
    `;

export const useAddCalculationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddCalculationMutation, TError, AddCalculationMutationVariables, TContext>) => {
    
    return useMutation<AddCalculationMutation, TError, AddCalculationMutationVariables, TContext>(
      ['AddCalculation'],
      (variables?: AddCalculationMutationVariables) => fetcher<AddCalculationMutation, AddCalculationMutationVariables>(AddCalculationDocument, variables)(),
      options
    )};

export const UpdateCalculationDocument = `
    mutation UpdateCalculation($id: MongoID!, $record: UpdateByIdCalculationInput!) {
  updateCalculation(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateCalculationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCalculationMutation, TError, UpdateCalculationMutationVariables, TContext>) => {
    
    return useMutation<UpdateCalculationMutation, TError, UpdateCalculationMutationVariables, TContext>(
      ['UpdateCalculation'],
      (variables?: UpdateCalculationMutationVariables) => fetcher<UpdateCalculationMutation, UpdateCalculationMutationVariables>(UpdateCalculationDocument, variables)(),
      options
    )};

export const RemoveCalculationDocument = `
    mutation RemoveCalculation($id: MongoID!) {
  removeCalculation(_id: $id) {
    recordId
    error {
      message
    }
  }
}
    `;

export const useRemoveCalculationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCalculationMutation, TError, RemoveCalculationMutationVariables, TContext>) => {
    
    return useMutation<RemoveCalculationMutation, TError, RemoveCalculationMutationVariables, TContext>(
      ['RemoveCalculation'],
      (variables?: RemoveCalculationMutationVariables) => fetcher<RemoveCalculationMutation, RemoveCalculationMutationVariables>(RemoveCalculationDocument, variables)(),
      options
    )};

export const AddCarDataServiceConfigDocument = `
    mutation AddCarDataServiceConfig($record: CreateOneCarDataServiceConfigInput!) {
  addCarDataServiceConfig(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddCarDataServiceConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddCarDataServiceConfigMutation, TError, AddCarDataServiceConfigMutationVariables, TContext>) => {
    
    return useMutation<AddCarDataServiceConfigMutation, TError, AddCarDataServiceConfigMutationVariables, TContext>(
      ['AddCarDataServiceConfig'],
      (variables?: AddCarDataServiceConfigMutationVariables) => fetcher<AddCarDataServiceConfigMutation, AddCarDataServiceConfigMutationVariables>(AddCarDataServiceConfigDocument, variables)(),
      options
    )};

export const UpdateCarDataServiceConfigDocument = `
    mutation UpdateCarDataServiceConfig($id: MongoID!, $record: UpdateByIdCarDataServiceConfigInput!) {
  updateCarDataServiceConfig(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateCarDataServiceConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCarDataServiceConfigMutation, TError, UpdateCarDataServiceConfigMutationVariables, TContext>) => {
    
    return useMutation<UpdateCarDataServiceConfigMutation, TError, UpdateCarDataServiceConfigMutationVariables, TContext>(
      ['UpdateCarDataServiceConfig'],
      (variables?: UpdateCarDataServiceConfigMutationVariables) => fetcher<UpdateCarDataServiceConfigMutation, UpdateCarDataServiceConfigMutationVariables>(UpdateCarDataServiceConfigDocument, variables)(),
      options
    )};

export const RemoveCarDataServiceConfigDocument = `
    mutation RemoveCarDataServiceConfig($id: MongoID!) {
  removeCarDataServiceConfig(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveCarDataServiceConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCarDataServiceConfigMutation, TError, RemoveCarDataServiceConfigMutationVariables, TContext>) => {
    
    return useMutation<RemoveCarDataServiceConfigMutation, TError, RemoveCarDataServiceConfigMutationVariables, TContext>(
      ['RemoveCarDataServiceConfig'],
      (variables?: RemoveCarDataServiceConfigMutationVariables) => fetcher<RemoveCarDataServiceConfigMutation, RemoveCarDataServiceConfigMutationVariables>(RemoveCarDataServiceConfigDocument, variables)(),
      options
    )};

export const ActivateCarDataServiceConfigDocument = `
    mutation ActivateCarDataServiceConfig($id: MongoID!) {
  activateCarDataServiceConfig(carDataServiceConfigID: $id) {
    success
  }
}
    `;

export const useActivateCarDataServiceConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ActivateCarDataServiceConfigMutation, TError, ActivateCarDataServiceConfigMutationVariables, TContext>) => {
    
    return useMutation<ActivateCarDataServiceConfigMutation, TError, ActivateCarDataServiceConfigMutationVariables, TContext>(
      ['ActivateCarDataServiceConfig'],
      (variables?: ActivateCarDataServiceConfigMutationVariables) => fetcher<ActivateCarDataServiceConfigMutation, ActivateCarDataServiceConfigMutationVariables>(ActivateCarDataServiceConfigDocument, variables)(),
      options
    )};

export const AddCarSetupDocument = `
    mutation AddCarSetup($record: CreateOneCarSetupInput!) {
  addCarSetup(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddCarSetupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddCarSetupMutation, TError, AddCarSetupMutationVariables, TContext>) => {
    
    return useMutation<AddCarSetupMutation, TError, AddCarSetupMutationVariables, TContext>(
      ['AddCarSetup'],
      (variables?: AddCarSetupMutationVariables) => fetcher<AddCarSetupMutation, AddCarSetupMutationVariables>(AddCarSetupDocument, variables)(),
      options
    )};

export const UpdateCarSetupDocument = `
    mutation UpdateCarSetup($id: MongoID!, $record: UpdateByIdCarSetupInput!) {
  updateCarSetup(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateCarSetupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCarSetupMutation, TError, UpdateCarSetupMutationVariables, TContext>) => {
    
    return useMutation<UpdateCarSetupMutation, TError, UpdateCarSetupMutationVariables, TContext>(
      ['UpdateCarSetup'],
      (variables?: UpdateCarSetupMutationVariables) => fetcher<UpdateCarSetupMutation, UpdateCarSetupMutationVariables>(UpdateCarSetupDocument, variables)(),
      options
    )};

export const ClaimCarSetupDocument = `
    mutation ClaimCarSetup($carSetupID: MongoID!) {
  claimCarSetup(carSetupID: $carSetupID) {
    success
  }
}
    `;

export const useClaimCarSetupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ClaimCarSetupMutation, TError, ClaimCarSetupMutationVariables, TContext>) => {
    
    return useMutation<ClaimCarSetupMutation, TError, ClaimCarSetupMutationVariables, TContext>(
      ['ClaimCarSetup'],
      (variables?: ClaimCarSetupMutationVariables) => fetcher<ClaimCarSetupMutation, ClaimCarSetupMutationVariables>(ClaimCarSetupDocument, variables)(),
      options
    )};

export const IncrementCarSetupDocument = `
    mutation IncrementCarSetup($srcID: MongoID!, $destID: MongoID!) {
  incrementSetupSheet(sourceRunSheetID: $srcID, destRunSheetID: $destID) {
    newSetupID
  }
}
    `;

export const useIncrementCarSetupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<IncrementCarSetupMutation, TError, IncrementCarSetupMutationVariables, TContext>) => {
    
    return useMutation<IncrementCarSetupMutation, TError, IncrementCarSetupMutationVariables, TContext>(
      ['IncrementCarSetup'],
      (variables?: IncrementCarSetupMutationVariables) => fetcher<IncrementCarSetupMutation, IncrementCarSetupMutationVariables>(IncrementCarSetupDocument, variables)(),
      options
    )};

export const CopyCarSetupDocument = `
    mutation CopyCarSetup($newAuthorID: MongoID, $srcID: MongoID!, $newTitle: String, $targetRunSheetID: MongoID) {
  copyCarSetup(
    newAuthorID: $newAuthorID
    sourceSetupID: $srcID
    newTitle: $newTitle
    targetRunSheetID: $targetRunSheetID
  ) {
    newSetupID
  }
}
    `;

export const useCopyCarSetupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CopyCarSetupMutation, TError, CopyCarSetupMutationVariables, TContext>) => {
    
    return useMutation<CopyCarSetupMutation, TError, CopyCarSetupMutationVariables, TContext>(
      ['CopyCarSetup'],
      (variables?: CopyCarSetupMutationVariables) => fetcher<CopyCarSetupMutation, CopyCarSetupMutationVariables>(CopyCarSetupDocument, variables)(),
      options
    )};

export const RemoveCarSetupDocument = `
    mutation RemoveCarSetup($id: MongoID!) {
  removeCarSetup(_id: $id) {
    recordId
    error {
      message
    }
  }
}
    `;

export const useRemoveCarSetupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCarSetupMutation, TError, RemoveCarSetupMutationVariables, TContext>) => {
    
    return useMutation<RemoveCarSetupMutation, TError, RemoveCarSetupMutationVariables, TContext>(
      ['RemoveCarSetup'],
      (variables?: RemoveCarSetupMutationVariables) => fetcher<RemoveCarSetupMutation, RemoveCarSetupMutationVariables>(RemoveCarSetupDocument, variables)(),
      options
    )};

export const UnclaimCarSetupDocument = `
    mutation UnclaimCarSetup($carSetupId: MongoID!) {
  unclaimCarSetup(carSetupID: $carSetupId) {
    success
  }
}
    `;

export const useUnclaimCarSetupMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UnclaimCarSetupMutation, TError, UnclaimCarSetupMutationVariables, TContext>) => {
    
    return useMutation<UnclaimCarSetupMutation, TError, UnclaimCarSetupMutationVariables, TContext>(
      ['UnclaimCarSetup'],
      (variables?: UnclaimCarSetupMutationVariables) => fetcher<UnclaimCarSetupMutation, UnclaimCarSetupMutationVariables>(UnclaimCarSetupDocument, variables)(),
      options
    )};

export const AddChassisDocument = `
    mutation AddChassis($record: CreateOneChassisInput!) {
  addChassis(record: $record) {
    recordId
  }
}
    `;

export const useAddChassisMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddChassisMutation, TError, AddChassisMutationVariables, TContext>) => {
    
    return useMutation<AddChassisMutation, TError, AddChassisMutationVariables, TContext>(
      ['AddChassis'],
      (variables?: AddChassisMutationVariables) => fetcher<AddChassisMutation, AddChassisMutationVariables>(AddChassisDocument, variables)(),
      options
    )};

export const UpdateChassisDocument = `
    mutation UpdateChassis($id: MongoID!, $record: UpdateByIdChassisInput!) {
  updateChassis(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateChassisMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateChassisMutation, TError, UpdateChassisMutationVariables, TContext>) => {
    
    return useMutation<UpdateChassisMutation, TError, UpdateChassisMutationVariables, TContext>(
      ['UpdateChassis'],
      (variables?: UpdateChassisMutationVariables) => fetcher<UpdateChassisMutation, UpdateChassisMutationVariables>(UpdateChassisDocument, variables)(),
      options
    )};

export const RemoveChassisDocument = `
    mutation RemoveChassis($id: MongoID!) {
  removeChassis(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveChassisMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveChassisMutation, TError, RemoveChassisMutationVariables, TContext>) => {
    
    return useMutation<RemoveChassisMutation, TError, RemoveChassisMutationVariables, TContext>(
      ['RemoveChassis'],
      (variables?: RemoveChassisMutationVariables) => fetcher<RemoveChassisMutation, RemoveChassisMutationVariables>(RemoveChassisDocument, variables)(),
      options
    )};

export const AddContestantDocument = `
    mutation AddContestant($record: CreateOneContestantInput!) {
  addContestant(record: $record) {
    recordId
  }
}
    `;

export const useAddContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddContestantMutation, TError, AddContestantMutationVariables, TContext>) => {
    
    return useMutation<AddContestantMutation, TError, AddContestantMutationVariables, TContext>(
      ['AddContestant'],
      (variables?: AddContestantMutationVariables) => fetcher<AddContestantMutation, AddContestantMutationVariables>(AddContestantDocument, variables)(),
      options
    )};

export const UpdateContestantDocument = `
    mutation UpdateContestant($id: MongoID!, $record: UpdateByIdContestantInput!) {
  updateContestant(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateContestantMutation, TError, UpdateContestantMutationVariables, TContext>) => {
    
    return useMutation<UpdateContestantMutation, TError, UpdateContestantMutationVariables, TContext>(
      ['UpdateContestant'],
      (variables?: UpdateContestantMutationVariables) => fetcher<UpdateContestantMutation, UpdateContestantMutationVariables>(UpdateContestantDocument, variables)(),
      options
    )};

export const AddToContestantDocument = `
    mutation AddToContestant($contestantID: MongoID!, $target: ContestantField!, $toAdd: MongoID!) {
  addToContestant(contestantID: $contestantID, target: $target, toAdd: $toAdd) {
    _id
  }
}
    `;

export const useAddToContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddToContestantMutation, TError, AddToContestantMutationVariables, TContext>) => {
    
    return useMutation<AddToContestantMutation, TError, AddToContestantMutationVariables, TContext>(
      ['AddToContestant'],
      (variables?: AddToContestantMutationVariables) => fetcher<AddToContestantMutation, AddToContestantMutationVariables>(AddToContestantDocument, variables)(),
      options
    )};

export const RemoveContestantDocument = `
    mutation RemoveContestant($id: MongoID!) {
  removeContestant(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveContestantMutation, TError, RemoveContestantMutationVariables, TContext>) => {
    
    return useMutation<RemoveContestantMutation, TError, RemoveContestantMutationVariables, TContext>(
      ['RemoveContestant'],
      (variables?: RemoveContestantMutationVariables) => fetcher<RemoveContestantMutation, RemoveContestantMutationVariables>(RemoveContestantDocument, variables)(),
      options
    )};

export const AddEventDocument = `
    mutation AddEvent($record: CreateOneEventInput!) {
  addEvent(record: $record) {
    recordId
    record {
      _id
      name
      NEventSeason
      tEventStart
      tEventEnd
      sessionIDs
    }
  }
}
    `;

export const useAddEventMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddEventMutation, TError, AddEventMutationVariables, TContext>) => {
    
    return useMutation<AddEventMutation, TError, AddEventMutationVariables, TContext>(
      ['AddEvent'],
      (variables?: AddEventMutationVariables) => fetcher<AddEventMutation, AddEventMutationVariables>(AddEventDocument, variables)(),
      options
    )};

export const UpdateEventDocument = `
    mutation UpdateEvent($id: MongoID!, $record: UpdateByIdEventInput!) {
  updateEvent(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateEventMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateEventMutation, TError, UpdateEventMutationVariables, TContext>) => {
    
    return useMutation<UpdateEventMutation, TError, UpdateEventMutationVariables, TContext>(
      ['UpdateEvent'],
      (variables?: UpdateEventMutationVariables) => fetcher<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, variables)(),
      options
    )};

export const RemoveEventDocument = `
    mutation RemoveEvent($id: MongoID!) {
  removeEvent(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveEventMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveEventMutation, TError, RemoveEventMutationVariables, TContext>) => {
    
    return useMutation<RemoveEventMutation, TError, RemoveEventMutationVariables, TContext>(
      ['RemoveEvent'],
      (variables?: RemoveEventMutationVariables) => fetcher<RemoveEventMutation, RemoveEventMutationVariables>(RemoveEventDocument, variables)(),
      options
    )};

export const CopyEventDocument = `
    mutation CopyEvent($sourceEventID: MongoID!, $targetSeasonID: MongoID!, $name: String!, $tEventStart: Date!, $calculateSessionTimes: Boolean, $overrides: CopyEventOverridesInput) {
  copyEvent(
    sourceEventID: $sourceEventID
    targetSeasonID: $targetSeasonID
    name: $name
    tEventStart: $tEventStart
    calculateSessionTimes: $calculateSessionTimes
    overrides: $overrides
  ) {
    _id
  }
}
    `;

export const useCopyEventMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CopyEventMutation, TError, CopyEventMutationVariables, TContext>) => {
    
    return useMutation<CopyEventMutation, TError, CopyEventMutationVariables, TContext>(
      ['CopyEvent'],
      (variables?: CopyEventMutationVariables) => fetcher<CopyEventMutation, CopyEventMutationVariables>(CopyEventDocument, variables)(),
      options
    )};

export const AddToEventContestantDocument = `
    mutation AddToEventContestant($eventID: MongoID!, $contestantID: MongoID!, $target: EventContestantField!, $toAdd: MongoID!) {
  addToEventContestant(
    eventID: $eventID
    contestantID: $contestantID
    target: $target
    toAdd: $toAdd
  ) {
    _id
  }
}
    `;

export const useAddToEventContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddToEventContestantMutation, TError, AddToEventContestantMutationVariables, TContext>) => {
    
    return useMutation<AddToEventContestantMutation, TError, AddToEventContestantMutationVariables, TContext>(
      ['AddToEventContestant'],
      (variables?: AddToEventContestantMutationVariables) => fetcher<AddToEventContestantMutation, AddToEventContestantMutationVariables>(AddToEventContestantDocument, variables)(),
      options
    )};

export const RemoveFromEventContestantDocument = `
    mutation RemoveFromEventContestant($eventID: MongoID!, $contestantID: MongoID!, $target: EventContestantField!, $toRemove: MongoID!) {
  removeFromEventContestant(
    eventID: $eventID
    contestantID: $contestantID
    target: $target
    toRemove: $toRemove
  ) {
    _id
  }
}
    `;

export const useRemoveFromEventContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveFromEventContestantMutation, TError, RemoveFromEventContestantMutationVariables, TContext>) => {
    
    return useMutation<RemoveFromEventContestantMutation, TError, RemoveFromEventContestantMutationVariables, TContext>(
      ['RemoveFromEventContestant'],
      (variables?: RemoveFromEventContestantMutationVariables) => fetcher<RemoveFromEventContestantMutation, RemoveFromEventContestantMutationVariables>(RemoveFromEventContestantDocument, variables)(),
      options
    )};

export const RemoveSingleTyreDocument = `
    mutation removeSingleTyre($id: MongoID!) {
  removeTyre(_id: $id) {
    error {
      message
    }
    recordId
  }
}
    `;

export const useRemoveSingleTyreMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSingleTyreMutation, TError, RemoveSingleTyreMutationVariables, TContext>) => {
    
    return useMutation<RemoveSingleTyreMutation, TError, RemoveSingleTyreMutationVariables, TContext>(
      ['removeSingleTyre'],
      (variables?: RemoveSingleTyreMutationVariables) => fetcher<RemoveSingleTyreMutation, RemoveSingleTyreMutationVariables>(RemoveSingleTyreDocument, variables)(),
      options
    )};

export const AddFullEventDocument = `
    mutation AddFullEvent($eventRecord: CreateOneEventInput!, $sessions: [CreateSessionForFullEventInput!]!) {
  addFullEvent(eventRecord: $eventRecord, sessions: $sessions) {
    _id
    name
    sessionIDs
  }
}
    `;

export const useAddFullEventMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddFullEventMutation, TError, AddFullEventMutationVariables, TContext>) => {
    
    return useMutation<AddFullEventMutation, TError, AddFullEventMutationVariables, TContext>(
      ['AddFullEvent'],
      (variables?: AddFullEventMutationVariables) => fetcher<AddFullEventMutation, AddFullEventMutationVariables>(AddFullEventDocument, variables)(),
      options
    )};

export const AddJobDocument = `
    mutation AddJob($record: CreateOneJobInput!, $target: EnumJobTarget) {
  addJob(record: $record, target: $target) {
    record {
      _id
    }
  }
}
    `;

export const useAddJobMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddJobMutation, TError, AddJobMutationVariables, TContext>) => {
    
    return useMutation<AddJobMutation, TError, AddJobMutationVariables, TContext>(
      ['AddJob'],
      (variables?: AddJobMutationVariables) => fetcher<AddJobMutation, AddJobMutationVariables>(AddJobDocument, variables)(),
      options
    )};

export const UpdateJobDocument = `
    mutation UpdateJob($id: MongoID!, $record: UpdateByIdJobInput!, $target: EnumJobTarget!) {
  updateJob(_id: $id, record: $record, target: $target) {
    recordId
  }
}
    `;

export const useUpdateJobMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateJobMutation, TError, UpdateJobMutationVariables, TContext>) => {
    
    return useMutation<UpdateJobMutation, TError, UpdateJobMutationVariables, TContext>(
      ['UpdateJob'],
      (variables?: UpdateJobMutationVariables) => fetcher<UpdateJobMutation, UpdateJobMutationVariables>(UpdateJobDocument, variables)(),
      options
    )};

export const ManageJobDocument = `
    mutation ManageJob($id: MongoID!, $action: JobAction!, $target: EnumJobTarget!) {
  manageJob(jobID: $id, action: $action, target: $target) {
    _id
  }
}
    `;

export const useManageJobMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ManageJobMutation, TError, ManageJobMutationVariables, TContext>) => {
    
    return useMutation<ManageJobMutation, TError, ManageJobMutationVariables, TContext>(
      ['ManageJob'],
      (variables?: ManageJobMutationVariables) => fetcher<ManageJobMutation, ManageJobMutationVariables>(ManageJobDocument, variables)(),
      options
    )};

export const RemoveJobDocument = `
    mutation RemoveJob($id: MongoID!, $target: EnumJobTarget!, $parentID: MongoID) {
  removeJob(_id: $id, target: $target, parentID: $parentID) {
    recordId
  }
}
    `;

export const useRemoveJobMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveJobMutation, TError, RemoveJobMutationVariables, TContext>) => {
    
    return useMutation<RemoveJobMutation, TError, RemoveJobMutationVariables, TContext>(
      ['RemoveJob'],
      (variables?: RemoveJobMutationVariables) => fetcher<RemoveJobMutation, RemoveJobMutationVariables>(RemoveJobDocument, variables)(),
      options
    )};

export const RemoveManyJobsDocument = `
    mutation RemoveManyJobs($jobIDs: [MongoID!]) {
  removeManyJobs(jobIDs: $jobIDs) {
    deletedCount
  }
}
    `;

export const useRemoveManyJobsMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveManyJobsMutation, TError, RemoveManyJobsMutationVariables, TContext>) => {
    
    return useMutation<RemoveManyJobsMutation, TError, RemoveManyJobsMutationVariables, TContext>(
      ['RemoveManyJobs'],
      (variables?: RemoveManyJobsMutationVariables) => fetcher<RemoveManyJobsMutation, RemoveManyJobsMutationVariables>(RemoveManyJobsDocument, variables)(),
      options
    )};

export const AddJobCommentDocument = `
    mutation AddJobComment($target: EnumJobTarget!, $subjectID: MongoID!, $text: String!) {
  addComment(target: $target, subjectID: $subjectID, text: $text) {
    comment {
      _id
    }
  }
}
    `;

export const useAddJobCommentMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddJobCommentMutation, TError, AddJobCommentMutationVariables, TContext>) => {
    
    return useMutation<AddJobCommentMutation, TError, AddJobCommentMutationVariables, TContext>(
      ['AddJobComment'],
      (variables?: AddJobCommentMutationVariables) => fetcher<AddJobCommentMutation, AddJobCommentMutationVariables>(AddJobCommentDocument, variables)(),
      options
    )};

export const UpdateJobCommentDocument = `
    mutation UpdateJobComment($target: EnumJobTarget!, $subjectID: MongoID!, $commentID: MongoID!, $text: String!) {
  updateComment(
    target: $target
    commentID: $commentID
    text: $text
    subjectID: $subjectID
  ) {
    comment {
      _id
      text
    }
  }
}
    `;

export const useUpdateJobCommentMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateJobCommentMutation, TError, UpdateJobCommentMutationVariables, TContext>) => {
    
    return useMutation<UpdateJobCommentMutation, TError, UpdateJobCommentMutationVariables, TContext>(
      ['UpdateJobComment'],
      (variables?: UpdateJobCommentMutationVariables) => fetcher<UpdateJobCommentMutation, UpdateJobCommentMutationVariables>(UpdateJobCommentDocument, variables)(),
      options
    )};

export const UpdateTemplateJobListDocument = `
    mutation UpdateTemplateJobList($id: MongoID!, $record: UpdateByIdTemplateJobListInput!) {
  updateTemplateJobList(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTemplateJobListMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTemplateJobListMutation, TError, UpdateTemplateJobListMutationVariables, TContext>) => {
    
    return useMutation<UpdateTemplateJobListMutation, TError, UpdateTemplateJobListMutationVariables, TContext>(
      ['UpdateTemplateJobList'],
      (variables?: UpdateTemplateJobListMutationVariables) => fetcher<UpdateTemplateJobListMutation, UpdateTemplateJobListMutationVariables>(UpdateTemplateJobListDocument, variables)(),
      options
    )};

export const AddTemplateJobListDocument = `
    mutation AddTemplateJobList($record: CreateOneTemplateJobListInput!) {
  addTemplateJobList(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddTemplateJobListMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTemplateJobListMutation, TError, AddTemplateJobListMutationVariables, TContext>) => {
    
    return useMutation<AddTemplateJobListMutation, TError, AddTemplateJobListMutationVariables, TContext>(
      ['AddTemplateJobList'],
      (variables?: AddTemplateJobListMutationVariables) => fetcher<AddTemplateJobListMutation, AddTemplateJobListMutationVariables>(AddTemplateJobListDocument, variables)(),
      options
    )};

export const RemoveTemplateJobListDocument = `
    mutation RemoveTemplateJobList($id: MongoID!) {
  removeTemplateJobList(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTemplateJobListMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTemplateJobListMutation, TError, RemoveTemplateJobListMutationVariables, TContext>) => {
    
    return useMutation<RemoveTemplateJobListMutation, TError, RemoveTemplateJobListMutationVariables, TContext>(
      ['RemoveTemplateJobList'],
      (variables?: RemoveTemplateJobListMutationVariables) => fetcher<RemoveTemplateJobListMutation, RemoveTemplateJobListMutationVariables>(RemoveTemplateJobListDocument, variables)(),
      options
    )};

export const AddManufacturerDocument = `
    mutation AddManufacturer($record: CreateOneManufacturerInput!) {
  addManufacturer(record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useAddManufacturerMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddManufacturerMutation, TError, AddManufacturerMutationVariables, TContext>) => {
    
    return useMutation<AddManufacturerMutation, TError, AddManufacturerMutationVariables, TContext>(
      ['AddManufacturer'],
      (variables?: AddManufacturerMutationVariables) => fetcher<AddManufacturerMutation, AddManufacturerMutationVariables>(AddManufacturerDocument, variables)(),
      options
    )};

export const UpdateManufacturerDocument = `
    mutation UpdateManufacturer($id: MongoID!, $record: UpdateByIdManufacturerInput!) {
  updateManufacturer(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateManufacturerMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateManufacturerMutation, TError, UpdateManufacturerMutationVariables, TContext>) => {
    
    return useMutation<UpdateManufacturerMutation, TError, UpdateManufacturerMutationVariables, TContext>(
      ['UpdateManufacturer'],
      (variables?: UpdateManufacturerMutationVariables) => fetcher<UpdateManufacturerMutation, UpdateManufacturerMutationVariables>(UpdateManufacturerDocument, variables)(),
      options
    )};

export const RemoveManufacturerDocument = `
    mutation RemoveManufacturer($id: MongoID!) {
  removeManufacturer(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveManufacturerMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveManufacturerMutation, TError, RemoveManufacturerMutationVariables, TContext>) => {
    
    return useMutation<RemoveManufacturerMutation, TError, RemoveManufacturerMutationVariables, TContext>(
      ['RemoveManufacturer'],
      (variables?: RemoveManufacturerMutationVariables) => fetcher<RemoveManufacturerMutation, RemoveManufacturerMutationVariables>(RemoveManufacturerDocument, variables)(),
      options
    )};

export const CalculateAllMileagesDocument = `
    mutation CalculateAllMileages {
  calculateAllMileages
}
    `;

export const useCalculateAllMileagesMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CalculateAllMileagesMutation, TError, CalculateAllMileagesMutationVariables, TContext>) => {
    
    return useMutation<CalculateAllMileagesMutation, TError, CalculateAllMileagesMutationVariables, TContext>(
      ['CalculateAllMileages'],
      (variables?: CalculateAllMileagesMutationVariables) => fetcher<CalculateAllMileagesMutation, CalculateAllMileagesMutationVariables>(CalculateAllMileagesDocument, variables)(),
      options
    )};

export const StartOneTimingWeatherServiceDocument = `
    mutation StartOneTimingWeatherService($configID: MongoID!) {
  oneTimingWeatherServiceStart(configID: $configID) {
    success
  }
}
    `;

export const useStartOneTimingWeatherServiceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<StartOneTimingWeatherServiceMutation, TError, StartOneTimingWeatherServiceMutationVariables, TContext>) => {
    
    return useMutation<StartOneTimingWeatherServiceMutation, TError, StartOneTimingWeatherServiceMutationVariables, TContext>(
      ['StartOneTimingWeatherService'],
      (variables?: StartOneTimingWeatherServiceMutationVariables) => fetcher<StartOneTimingWeatherServiceMutation, StartOneTimingWeatherServiceMutationVariables>(StartOneTimingWeatherServiceDocument, variables)(),
      options
    )};

export const StopOneTimingWeatherServiceDocument = `
    mutation StopOneTimingWeatherService {
  oneTimingWeatherServiceStop {
    success
  }
}
    `;

export const useStopOneTimingWeatherServiceMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<StopOneTimingWeatherServiceMutation, TError, StopOneTimingWeatherServiceMutationVariables, TContext>) => {
    
    return useMutation<StopOneTimingWeatherServiceMutation, TError, StopOneTimingWeatherServiceMutationVariables, TContext>(
      ['StopOneTimingWeatherService'],
      (variables?: StopOneTimingWeatherServiceMutationVariables) => fetcher<StopOneTimingWeatherServiceMutation, StopOneTimingWeatherServiceMutationVariables>(StopOneTimingWeatherServiceDocument, variables)(),
      options
    )};

export const AddPartDocument = `
    mutation AddPart($record: CreateOnePartInput!) {
  addPart(record: $record) {
    recordId
    record {
      _id
      reference
    }
  }
}
    `;

export const useAddPartMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddPartMutation, TError, AddPartMutationVariables, TContext>) => {
    
    return useMutation<AddPartMutation, TError, AddPartMutationVariables, TContext>(
      ['AddPart'],
      (variables?: AddPartMutationVariables) => fetcher<AddPartMutation, AddPartMutationVariables>(AddPartDocument, variables)(),
      options
    )};

export const RemovePartDocument = `
    mutation RemovePart($id: MongoID!) {
  removePart(_id: $id) {
    recordId
  }
}
    `;

export const useRemovePartMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemovePartMutation, TError, RemovePartMutationVariables, TContext>) => {
    
    return useMutation<RemovePartMutation, TError, RemovePartMutationVariables, TContext>(
      ['RemovePart'],
      (variables?: RemovePartMutationVariables) => fetcher<RemovePartMutation, RemovePartMutationVariables>(RemovePartDocument, variables)(),
      options
    )};

export const AddPersonDocument = `
    mutation AddPerson($record: CreateOnePersonInput!) {
  addPerson(record: $record) {
    recordId
  }
}
    `;

export const useAddPersonMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddPersonMutation, TError, AddPersonMutationVariables, TContext>) => {
    
    return useMutation<AddPersonMutation, TError, AddPersonMutationVariables, TContext>(
      ['AddPerson'],
      (variables?: AddPersonMutationVariables) => fetcher<AddPersonMutation, AddPersonMutationVariables>(AddPersonDocument, variables)(),
      options
    )};

export const UpdatePersonDocument = `
    mutation UpdatePerson($id: MongoID!, $record: UpdateByIdPersonInput!) {
  updatePerson(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdatePersonMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePersonMutation, TError, UpdatePersonMutationVariables, TContext>) => {
    
    return useMutation<UpdatePersonMutation, TError, UpdatePersonMutationVariables, TContext>(
      ['UpdatePerson'],
      (variables?: UpdatePersonMutationVariables) => fetcher<UpdatePersonMutation, UpdatePersonMutationVariables>(UpdatePersonDocument, variables)(),
      options
    )};

export const UpdateMeDocument = `
    mutation UpdateMe($record: UpdateMeInput!) {
  updateMe(record: $record) {
    recordId
  }
}
    `;

export const useUpdateMeMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMeMutation, TError, UpdateMeMutationVariables, TContext>) => {
    
    return useMutation<UpdateMeMutation, TError, UpdateMeMutationVariables, TContext>(
      ['UpdateMe'],
      (variables?: UpdateMeMutationVariables) => fetcher<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, variables)(),
      options
    )};

export const RemovePersonDocument = `
    mutation RemovePerson($id: MongoID!) {
  removePerson(_id: $id) {
    recordId
    error {
      message
    }
  }
}
    `;

export const useRemovePersonMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemovePersonMutation, TError, RemovePersonMutationVariables, TContext>) => {
    
    return useMutation<RemovePersonMutation, TError, RemovePersonMutationVariables, TContext>(
      ['RemovePerson'],
      (variables?: RemovePersonMutationVariables) => fetcher<RemovePersonMutation, RemovePersonMutationVariables>(RemovePersonDocument, variables)(),
      options
    )};

export const AddFlexLayoutConfigDocument = `
    mutation AddFlexLayoutConfig($record: CreateOneFlexLayoutConfigInput!) {
  addFlexLayoutConfig(record: $record) {
    recordId
  }
}
    `;

export const useAddFlexLayoutConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddFlexLayoutConfigMutation, TError, AddFlexLayoutConfigMutationVariables, TContext>) => {
    
    return useMutation<AddFlexLayoutConfigMutation, TError, AddFlexLayoutConfigMutationVariables, TContext>(
      ['AddFlexLayoutConfig'],
      (variables?: AddFlexLayoutConfigMutationVariables) => fetcher<AddFlexLayoutConfigMutation, AddFlexLayoutConfigMutationVariables>(AddFlexLayoutConfigDocument, variables)(),
      options
    )};

export const UpdateFlexLayoutConfigDocument = `
    mutation UpdateFlexLayoutConfig($id: MongoID!, $record: UpdateByIdFlexLayoutConfigInput!) {
  updateFlexLayoutConfig(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateFlexLayoutConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateFlexLayoutConfigMutation, TError, UpdateFlexLayoutConfigMutationVariables, TContext>) => {
    
    return useMutation<UpdateFlexLayoutConfigMutation, TError, UpdateFlexLayoutConfigMutationVariables, TContext>(
      ['UpdateFlexLayoutConfig'],
      (variables?: UpdateFlexLayoutConfigMutationVariables) => fetcher<UpdateFlexLayoutConfigMutation, UpdateFlexLayoutConfigMutationVariables>(UpdateFlexLayoutConfigDocument, variables)(),
      options
    )};

export const RemoveFlexLayoutConfigDocument = `
    mutation RemoveFlexLayoutConfig($id: MongoID!) {
  removeFlexLayoutConfig(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveFlexLayoutConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveFlexLayoutConfigMutation, TError, RemoveFlexLayoutConfigMutationVariables, TContext>) => {
    
    return useMutation<RemoveFlexLayoutConfigMutation, TError, RemoveFlexLayoutConfigMutationVariables, TContext>(
      ['RemoveFlexLayoutConfig'],
      (variables?: RemoveFlexLayoutConfigMutationVariables) => fetcher<RemoveFlexLayoutConfigMutation, RemoveFlexLayoutConfigMutationVariables>(RemoveFlexLayoutConfigDocument, variables)(),
      options
    )};

export const AddProjectDocument = `
    mutation AddProject($record: CreateOneProjectInput!) {
  addProject(record: $record) {
    recordId
  }
}
    `;

export const useAddProjectMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddProjectMutation, TError, AddProjectMutationVariables, TContext>) => {
    
    return useMutation<AddProjectMutation, TError, AddProjectMutationVariables, TContext>(
      ['AddProject'],
      (variables?: AddProjectMutationVariables) => fetcher<AddProjectMutation, AddProjectMutationVariables>(AddProjectDocument, variables)(),
      options
    )};

export const UpdateProjectDocument = `
    mutation UpdateProject($id: MongoID!, $record: UpdateByIdProjectInput!) {
  updateProject(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateProjectMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProjectMutation, TError, UpdateProjectMutationVariables, TContext>) => {
    
    return useMutation<UpdateProjectMutation, TError, UpdateProjectMutationVariables, TContext>(
      ['UpdateProject'],
      (variables?: UpdateProjectMutationVariables) => fetcher<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, variables)(),
      options
    )};

export const RemoveProjectDocument = `
    mutation RemoveProject($id: MongoID!) {
  removeProject(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveProjectMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProjectMutation, TError, RemoveProjectMutationVariables, TContext>) => {
    
    return useMutation<RemoveProjectMutation, TError, RemoveProjectMutationVariables, TContext>(
      ['RemoveProject'],
      (variables?: RemoveProjectMutationVariables) => fetcher<RemoveProjectMutation, RemoveProjectMutationVariables>(RemoveProjectDocument, variables)(),
      options
    )};

export const AddRaceSeriesDocument = `
    mutation AddRaceSeries($record: CreateOneRaceSeriesInput!) {
  addRaceSeries(record: $record) {
    recordId
  }
}
    `;

export const useAddRaceSeriesMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddRaceSeriesMutation, TError, AddRaceSeriesMutationVariables, TContext>) => {
    
    return useMutation<AddRaceSeriesMutation, TError, AddRaceSeriesMutationVariables, TContext>(
      ['AddRaceSeries'],
      (variables?: AddRaceSeriesMutationVariables) => fetcher<AddRaceSeriesMutation, AddRaceSeriesMutationVariables>(AddRaceSeriesDocument, variables)(),
      options
    )};

export const UpdateRaceSeriesDocument = `
    mutation UpdateRaceSeries($id: MongoID!, $record: UpdateByIdRaceSeriesInput!) {
  updateRaceSeries(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateRaceSeriesMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateRaceSeriesMutation, TError, UpdateRaceSeriesMutationVariables, TContext>) => {
    
    return useMutation<UpdateRaceSeriesMutation, TError, UpdateRaceSeriesMutationVariables, TContext>(
      ['UpdateRaceSeries'],
      (variables?: UpdateRaceSeriesMutationVariables) => fetcher<UpdateRaceSeriesMutation, UpdateRaceSeriesMutationVariables>(UpdateRaceSeriesDocument, variables)(),
      options
    )};

export const RemoveRaceSeriesDocument = `
    mutation RemoveRaceSeries($id: MongoID!) {
  removeRaceSeries(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveRaceSeriesMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveRaceSeriesMutation, TError, RemoveRaceSeriesMutationVariables, TContext>) => {
    
    return useMutation<RemoveRaceSeriesMutation, TError, RemoveRaceSeriesMutationVariables, TContext>(
      ['RemoveRaceSeries'],
      (variables?: RemoveRaceSeriesMutationVariables) => fetcher<RemoveRaceSeriesMutation, RemoveRaceSeriesMutationVariables>(RemoveRaceSeriesDocument, variables)(),
      options
    )};

export const AddRunSheetDocument = `
    mutation AddRunSheet($record: CreateOneRunSheetInput!) {
  addRunSheet(record: $record) {
    recordId
  }
}
    `;

export const useAddRunSheetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddRunSheetMutation, TError, AddRunSheetMutationVariables, TContext>) => {
    
    return useMutation<AddRunSheetMutation, TError, AddRunSheetMutationVariables, TContext>(
      ['AddRunSheet'],
      (variables?: AddRunSheetMutationVariables) => fetcher<AddRunSheetMutation, AddRunSheetMutationVariables>(AddRunSheetDocument, variables)(),
      options
    )};

export const UpdateRunsheetDocument = `
    mutation UpdateRunsheet($id: MongoID!, $record: UpdateByIdRunSheetInput!) {
  updateRunSheet(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateRunsheetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateRunsheetMutation, TError, UpdateRunsheetMutationVariables, TContext>) => {
    
    return useMutation<UpdateRunsheetMutation, TError, UpdateRunsheetMutationVariables, TContext>(
      ['UpdateRunsheet'],
      (variables?: UpdateRunsheetMutationVariables) => fetcher<UpdateRunsheetMutation, UpdateRunsheetMutationVariables>(UpdateRunsheetDocument, variables)(),
      options
    )};

export const ClaimRunsheetDocument = `
    mutation ClaimRunsheet($runSheetID: MongoID!) {
  claimRunSheet(runSheetID: $runSheetID) {
    success
  }
}
    `;

export const useClaimRunsheetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ClaimRunsheetMutation, TError, ClaimRunsheetMutationVariables, TContext>) => {
    
    return useMutation<ClaimRunsheetMutation, TError, ClaimRunsheetMutationVariables, TContext>(
      ['ClaimRunsheet'],
      (variables?: ClaimRunsheetMutationVariables) => fetcher<ClaimRunsheetMutation, ClaimRunsheetMutationVariables>(ClaimRunsheetDocument, variables)(),
      options
    )};

export const IncrementRunSheetDocument = `
    mutation IncrementRunSheet($prevRunSheetID: MongoID!, $record: UpdateByIdRunSheetInput) {
  incrementRunSheet(prevRunSheetID: $prevRunSheetID, record: $record) {
    runSheet {
      _id
    }
  }
}
    `;

export const useIncrementRunSheetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<IncrementRunSheetMutation, TError, IncrementRunSheetMutationVariables, TContext>) => {
    
    return useMutation<IncrementRunSheetMutation, TError, IncrementRunSheetMutationVariables, TContext>(
      ['IncrementRunSheet'],
      (variables?: IncrementRunSheetMutationVariables) => fetcher<IncrementRunSheetMutation, IncrementRunSheetMutationVariables>(IncrementRunSheetDocument, variables)(),
      options
    )};

export const AddLapDocument = `
    mutation AddLap($runSheetID: MongoID!, $lap: LapInput!) {
  addLap(runSheetID: $runSheetID, lap: $lap) {
    _id
  }
}
    `;

export const useAddLapMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddLapMutation, TError, AddLapMutationVariables, TContext>) => {
    
    return useMutation<AddLapMutation, TError, AddLapMutationVariables, TContext>(
      ['AddLap'],
      (variables?: AddLapMutationVariables) => fetcher<AddLapMutation, AddLapMutationVariables>(AddLapDocument, variables)(),
      options
    )};

export const ForceAddLapDocument = `
    mutation ForceAddLap($runSheetID: MongoID!, $lap: LapInput!) {
  forceAddLap(runSheetID: $runSheetID, lap: $lap) {
    _id
  }
}
    `;

export const useForceAddLapMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ForceAddLapMutation, TError, ForceAddLapMutationVariables, TContext>) => {
    
    return useMutation<ForceAddLapMutation, TError, ForceAddLapMutationVariables, TContext>(
      ['ForceAddLap'],
      (variables?: ForceAddLapMutationVariables) => fetcher<ForceAddLapMutation, ForceAddLapMutationVariables>(ForceAddLapDocument, variables)(),
      options
    )};

export const UpdateLapDocument = `
    mutation UpdateLap($id: MongoID!, $NLapRun: Int!, $lap: UpdateByIdLapInput!) {
  updateLap(runSheetID: $id, NLapRun: $NLapRun, lap: $lap) {
    _id
  }
}
    `;

export const useUpdateLapMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLapMutation, TError, UpdateLapMutationVariables, TContext>) => {
    
    return useMutation<UpdateLapMutation, TError, UpdateLapMutationVariables, TContext>(
      ['UpdateLap'],
      (variables?: UpdateLapMutationVariables) => fetcher<UpdateLapMutation, UpdateLapMutationVariables>(UpdateLapDocument, variables)(),
      options
    )};

export const UpdateLapByIdDocument = `
    mutation UpdateLapById($id: MongoID!, $record: UpdateByIdLapInput!) {
  updateLapByID(_id: $id, record: $record) {
    record {
      _id
    }
  }
}
    `;

export const useUpdateLapByIdMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLapByIdMutation, TError, UpdateLapByIdMutationVariables, TContext>) => {
    
    return useMutation<UpdateLapByIdMutation, TError, UpdateLapByIdMutationVariables, TContext>(
      ['UpdateLapById'],
      (variables?: UpdateLapByIdMutationVariables) => fetcher<UpdateLapByIdMutation, UpdateLapByIdMutationVariables>(UpdateLapByIdDocument, variables)(),
      options
    )};

export const RemoveLapDocument = `
    mutation RemoveLap($id: MongoID!, $NLapRun: Int!) {
  removeLap(runSheetID: $id, NLapRun: $NLapRun) {
    _id
  }
}
    `;

export const useRemoveLapMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveLapMutation, TError, RemoveLapMutationVariables, TContext>) => {
    
    return useMutation<RemoveLapMutation, TError, RemoveLapMutationVariables, TContext>(
      ['RemoveLap'],
      (variables?: RemoveLapMutationVariables) => fetcher<RemoveLapMutation, RemoveLapMutationVariables>(RemoveLapDocument, variables)(),
      options
    )};

export const RemoveRunSheetDocument = `
    mutation RemoveRunSheet($id: MongoID!) {
  removeRunSheet(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveRunSheetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveRunSheetMutation, TError, RemoveRunSheetMutationVariables, TContext>) => {
    
    return useMutation<RemoveRunSheetMutation, TError, RemoveRunSheetMutationVariables, TContext>(
      ['RemoveRunSheet'],
      (variables?: RemoveRunSheetMutationVariables) => fetcher<RemoveRunSheetMutation, RemoveRunSheetMutationVariables>(RemoveRunSheetDocument, variables)(),
      options
    )};

export const UnclaimRunSheetDocument = `
    mutation unclaimRunSheet($id: MongoID!) {
  unclaimRunSheet(runSheetID: $id) {
    success
  }
}
    `;

export const useUnclaimRunSheetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UnclaimRunSheetMutation, TError, UnclaimRunSheetMutationVariables, TContext>) => {
    
    return useMutation<UnclaimRunSheetMutation, TError, UnclaimRunSheetMutationVariables, TContext>(
      ['unclaimRunSheet'],
      (variables?: UnclaimRunSheetMutationVariables) => fetcher<UnclaimRunSheetMutation, UnclaimRunSheetMutationVariables>(UnclaimRunSheetDocument, variables)(),
      options
    )};

export const AddRunSheetStyleDocument = `
    mutation AddRunSheetStyle($record: CreateOneRunSheetStyleInput!) {
  addRunSheetStyle(record: $record) {
    recordId
  }
}
    `;

export const useAddRunSheetStyleMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddRunSheetStyleMutation, TError, AddRunSheetStyleMutationVariables, TContext>) => {
    
    return useMutation<AddRunSheetStyleMutation, TError, AddRunSheetStyleMutationVariables, TContext>(
      ['AddRunSheetStyle'],
      (variables?: AddRunSheetStyleMutationVariables) => fetcher<AddRunSheetStyleMutation, AddRunSheetStyleMutationVariables>(AddRunSheetStyleDocument, variables)(),
      options
    )};

export const UpdateRunSheetStyleDocument = `
    mutation UpdateRunSheetStyle($id: MongoID!, $record: UpdateByIdRunSheetStyleInput!) {
  updateRunSheetStyle(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateRunSheetStyleMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateRunSheetStyleMutation, TError, UpdateRunSheetStyleMutationVariables, TContext>) => {
    
    return useMutation<UpdateRunSheetStyleMutation, TError, UpdateRunSheetStyleMutationVariables, TContext>(
      ['UpdateRunSheetStyle'],
      (variables?: UpdateRunSheetStyleMutationVariables) => fetcher<UpdateRunSheetStyleMutation, UpdateRunSheetStyleMutationVariables>(UpdateRunSheetStyleDocument, variables)(),
      options
    )};

export const RemoveRunSheetStyleDocument = `
    mutation removeRunSheetStyle($id: MongoID!) {
  removeRunSheetStyle(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveRunSheetStyleMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveRunSheetStyleMutation, TError, RemoveRunSheetStyleMutationVariables, TContext>) => {
    
    return useMutation<RemoveRunSheetStyleMutation, TError, RemoveRunSheetStyleMutationVariables, TContext>(
      ['removeRunSheetStyle'],
      (variables?: RemoveRunSheetStyleMutationVariables) => fetcher<RemoveRunSheetStyleMutation, RemoveRunSheetStyleMutationVariables>(RemoveRunSheetStyleDocument, variables)(),
      options
    )};

export const AddSeasonDocument = `
    mutation AddSeason($record: CreateOneSeasonInput!) {
  addSeason(record: $record) {
    recordId
    record {
      _id
      name
      eventIDs
    }
  }
}
    `;

export const useAddSeasonMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddSeasonMutation, TError, AddSeasonMutationVariables, TContext>) => {
    
    return useMutation<AddSeasonMutation, TError, AddSeasonMutationVariables, TContext>(
      ['AddSeason'],
      (variables?: AddSeasonMutationVariables) => fetcher<AddSeasonMutation, AddSeasonMutationVariables>(AddSeasonDocument, variables)(),
      options
    )};

export const UpdateSeasonDocument = `
    mutation UpdateSeason($id: MongoID!, $record: UpdateByIdSeasonInput!) {
  updateSeason(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateSeasonMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSeasonMutation, TError, UpdateSeasonMutationVariables, TContext>) => {
    
    return useMutation<UpdateSeasonMutation, TError, UpdateSeasonMutationVariables, TContext>(
      ['UpdateSeason'],
      (variables?: UpdateSeasonMutationVariables) => fetcher<UpdateSeasonMutation, UpdateSeasonMutationVariables>(UpdateSeasonDocument, variables)(),
      options
    )};

export const RemoveSeasonDocument = `
    mutation RemoveSeason($id: MongoID!) {
  removeSeason(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveSeasonMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSeasonMutation, TError, RemoveSeasonMutationVariables, TContext>) => {
    
    return useMutation<RemoveSeasonMutation, TError, RemoveSeasonMutationVariables, TContext>(
      ['RemoveSeason'],
      (variables?: RemoveSeasonMutationVariables) => fetcher<RemoveSeasonMutation, RemoveSeasonMutationVariables>(RemoveSeasonDocument, variables)(),
      options
    )};

export const ResetPasswordDocument = `
    mutation ResetPassword($username: String!) {
  resetPassword(username: $username) {
    password
  }
}
    `;

export const useResetPasswordMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>) => {
    
    return useMutation<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>(
      ['ResetPassword'],
      (variables?: ResetPasswordMutationVariables) => fetcher<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, variables)(),
      options
    )};

export const SetPasswordDocument = `
    mutation SetPassword($username: String!, $oldPassword: String!, $newPassword: String!) {
  setPassword(
    username: $username
    oldPassword: $oldPassword
    newPassword: $newPassword
  ) {
    success
  }
}
    `;

export const useSetPasswordMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<SetPasswordMutation, TError, SetPasswordMutationVariables, TContext>) => {
    
    return useMutation<SetPasswordMutation, TError, SetPasswordMutationVariables, TContext>(
      ['SetPassword'],
      (variables?: SetPasswordMutationVariables) => fetcher<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, variables)(),
      options
    )};

export const LoginDocument = `
    mutation Login($username: String!, $password: String!) {
  login(username: $username, password: $password) {
    token
  }
}
    `;

export const useLoginMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<LoginMutation, TError, LoginMutationVariables, TContext>) => {
    
    return useMutation<LoginMutation, TError, LoginMutationVariables, TContext>(
      ['Login'],
      (variables?: LoginMutationVariables) => fetcher<LoginMutation, LoginMutationVariables>(LoginDocument, variables)(),
      options
    )};

export const ForgotPasswordDocument = `
    mutation ForgotPassword($email: String!, $clientRoot: String!) {
  forgotPassword(email: $email, clientRoot: $clientRoot) {
    result
  }
}
    `;

export const useForgotPasswordMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ForgotPasswordMutation, TError, ForgotPasswordMutationVariables, TContext>) => {
    
    return useMutation<ForgotPasswordMutation, TError, ForgotPasswordMutationVariables, TContext>(
      ['ForgotPassword'],
      (variables?: ForgotPasswordMutationVariables) => fetcher<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, variables)(),
      options
    )};

export const SelfResetPasswordDocument = `
    mutation SelfResetPassword($token: String!, $newPassword: String!) {
  selfResetPassword(token: $token, newPassword: $newPassword) {
    success
  }
}
    `;

export const useSelfResetPasswordMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<SelfResetPasswordMutation, TError, SelfResetPasswordMutationVariables, TContext>) => {
    
    return useMutation<SelfResetPasswordMutation, TError, SelfResetPasswordMutationVariables, TContext>(
      ['SelfResetPassword'],
      (variables?: SelfResetPasswordMutationVariables) => fetcher<SelfResetPasswordMutation, SelfResetPasswordMutationVariables>(SelfResetPasswordDocument, variables)(),
      options
    )};

export const AddSessionDocument = `
    mutation AddSession($record: CreateOneSessionInput!) {
  addSession(record: $record) {
    recordId
    record {
      _id
      name
      shortName
      tSessionStart
      tSessionEnd
    }
  }
}
    `;

export const useAddSessionMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddSessionMutation, TError, AddSessionMutationVariables, TContext>) => {
    
    return useMutation<AddSessionMutation, TError, AddSessionMutationVariables, TContext>(
      ['AddSession'],
      (variables?: AddSessionMutationVariables) => fetcher<AddSessionMutation, AddSessionMutationVariables>(AddSessionDocument, variables)(),
      options
    )};

export const UpdateSessionDocument = `
    mutation UpdateSession($id: MongoID!, $record: UpdateByIdSessionInput!) {
  updateSession(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateSessionMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSessionMutation, TError, UpdateSessionMutationVariables, TContext>) => {
    
    return useMutation<UpdateSessionMutation, TError, UpdateSessionMutationVariables, TContext>(
      ['UpdateSession'],
      (variables?: UpdateSessionMutationVariables) => fetcher<UpdateSessionMutation, UpdateSessionMutationVariables>(UpdateSessionDocument, variables)(),
      options
    )};

export const RemoveSessionDocument = `
    mutation RemoveSession($id: MongoID!) {
  removeSession(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveSessionMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSessionMutation, TError, RemoveSessionMutationVariables, TContext>) => {
    
    return useMutation<RemoveSessionMutation, TError, RemoveSessionMutationVariables, TContext>(
      ['RemoveSession'],
      (variables?: RemoveSessionMutationVariables) => fetcher<RemoveSessionMutation, RemoveSessionMutationVariables>(RemoveSessionDocument, variables)(),
      options
    )};

export const GetBopDocument = `
    query GetBop($id: MongoID!) {
  bop(_id: $id) {
    ...FullBop
  }
}
    ${FullBopFragmentDoc}`;

export const useGetBopQuery = <
      TData = GetBopQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetBopQueryVariables,
      options?: UseQueryOptions<GetBopQuery, TError, TData>
    ) => {
    
    return useQuery<GetBopQuery, TError, TData>(
      ['GetBop', variables],
      fetcher<GetBopQuery, GetBopQueryVariables>(GetBopDocument, variables),
      options
    )};

export const AddBopDocument = `
    mutation AddBop($record: CreateOneBopInput!) {
  addBop(record: $record) {
    recordId
    record {
      ...FullBop
    }
  }
}
    ${FullBopFragmentDoc}`;

export const useAddBopMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddBopMutation, TError, AddBopMutationVariables, TContext>) => {
    
    return useMutation<AddBopMutation, TError, AddBopMutationVariables, TContext>(
      ['AddBop'],
      (variables?: AddBopMutationVariables) => fetcher<AddBopMutation, AddBopMutationVariables>(AddBopDocument, variables)(),
      options
    )};

export const UpdateBopDocument = `
    mutation UpdateBop($id: MongoID!, $record: UpdateByIdBopInput!) {
  updateBop(_id: $id, record: $record) {
    recordId
    record {
      ...FullBop
    }
  }
}
    ${FullBopFragmentDoc}`;

export const useUpdateBopMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBopMutation, TError, UpdateBopMutationVariables, TContext>) => {
    
    return useMutation<UpdateBopMutation, TError, UpdateBopMutationVariables, TContext>(
      ['UpdateBop'],
      (variables?: UpdateBopMutationVariables) => fetcher<UpdateBopMutation, UpdateBopMutationVariables>(UpdateBopDocument, variables)(),
      options
    )};

export const RemoveBopDocument = `
    mutation RemoveBop($id: MongoID!) {
  removeBop(_id: $id) {
    recordId
    record {
      ...FullBop
    }
  }
}
    ${FullBopFragmentDoc}`;

export const useRemoveBopMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveBopMutation, TError, RemoveBopMutationVariables, TContext>) => {
    
    return useMutation<RemoveBopMutation, TError, RemoveBopMutationVariables, TContext>(
      ['RemoveBop'],
      (variables?: RemoveBopMutationVariables) => fetcher<RemoveBopMutation, RemoveBopMutationVariables>(RemoveBopDocument, variables)(),
      options
    )};

export const UpsertBopDocument = `
    mutation UpsertBop($record: CreateOneBopInput!, $bopID: MongoID, $sessionID: MongoID) {
  upsertBop(record: $record, bopID: $bopID, sessionID: $sessionID) {
    ...FullBop
  }
}
    ${FullBopFragmentDoc}`;

export const useUpsertBopMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpsertBopMutation, TError, UpsertBopMutationVariables, TContext>) => {
    
    return useMutation<UpsertBopMutation, TError, UpsertBopMutationVariables, TContext>(
      ['UpsertBop'],
      (variables?: UpsertBopMutationVariables) => fetcher<UpsertBopMutation, UpsertBopMutationVariables>(UpsertBopDocument, variables)(),
      options
    )};

export const GetBopForSessionDocument = `
    query GetBopForSession($sessionID: MongoID) {
  bops(perPage: 1, filter: {sessionID: $sessionID}) {
    items {
      ...FullBop
    }
  }
}
    ${FullBopFragmentDoc}`;

export const useGetBopForSessionQuery = <
      TData = GetBopForSessionQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBopForSessionQueryVariables,
      options?: UseQueryOptions<GetBopForSessionQuery, TError, TData>
    ) => {
    
    return useQuery<GetBopForSessionQuery, TError, TData>(
      variables === undefined ? ['GetBopForSession'] : ['GetBopForSession', variables],
      fetcher<GetBopForSessionQuery, GetBopForSessionQueryVariables>(GetBopForSessionDocument, variables),
      options
    )};

export const AddSetupOverviewConfigDocument = `
    mutation AddSetupOverviewConfig($record: CreateOneSetupOverviewConfigInput!) {
  addSetupOverviewConfig(record: $record) {
    recordId
  }
}
    `;

export const useAddSetupOverviewConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddSetupOverviewConfigMutation, TError, AddSetupOverviewConfigMutationVariables, TContext>) => {
    
    return useMutation<AddSetupOverviewConfigMutation, TError, AddSetupOverviewConfigMutationVariables, TContext>(
      ['AddSetupOverviewConfig'],
      (variables?: AddSetupOverviewConfigMutationVariables) => fetcher<AddSetupOverviewConfigMutation, AddSetupOverviewConfigMutationVariables>(AddSetupOverviewConfigDocument, variables)(),
      options
    )};

export const UpdateSetupOverviewConfigDocument = `
    mutation UpdateSetupOverviewConfig($id: MongoID!, $record: UpdateByIdSetupOverviewConfigInput!) {
  updateSetupOverviewConfig(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateSetupOverviewConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSetupOverviewConfigMutation, TError, UpdateSetupOverviewConfigMutationVariables, TContext>) => {
    
    return useMutation<UpdateSetupOverviewConfigMutation, TError, UpdateSetupOverviewConfigMutationVariables, TContext>(
      ['UpdateSetupOverviewConfig'],
      (variables?: UpdateSetupOverviewConfigMutationVariables) => fetcher<UpdateSetupOverviewConfigMutation, UpdateSetupOverviewConfigMutationVariables>(UpdateSetupOverviewConfigDocument, variables)(),
      options
    )};

export const RemoveSetupOverviewConfigDocument = `
    mutation RemoveSetupOverviewConfig($id: MongoID!) {
  removeSetupOverviewConfig(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveSetupOverviewConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSetupOverviewConfigMutation, TError, RemoveSetupOverviewConfigMutationVariables, TContext>) => {
    
    return useMutation<RemoveSetupOverviewConfigMutation, TError, RemoveSetupOverviewConfigMutationVariables, TContext>(
      ['RemoveSetupOverviewConfig'],
      (variables?: RemoveSetupOverviewConfigMutationVariables) => fetcher<RemoveSetupOverviewConfigMutation, RemoveSetupOverviewConfigMutationVariables>(RemoveSetupOverviewConfigDocument, variables)(),
      options
    )};

export const AddSetupSheetStyleDocument = `
    mutation AddSetupSheetStyle($record: CreateOneSetupSheetStyleInput!) {
  addSetupSheetStyle(record: $record) {
    recordId
  }
}
    `;

export const useAddSetupSheetStyleMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddSetupSheetStyleMutation, TError, AddSetupSheetStyleMutationVariables, TContext>) => {
    
    return useMutation<AddSetupSheetStyleMutation, TError, AddSetupSheetStyleMutationVariables, TContext>(
      ['AddSetupSheetStyle'],
      (variables?: AddSetupSheetStyleMutationVariables) => fetcher<AddSetupSheetStyleMutation, AddSetupSheetStyleMutationVariables>(AddSetupSheetStyleDocument, variables)(),
      options
    )};

export const UpdateSetupSheetStyleDocument = `
    mutation UpdateSetupSheetStyle($id: MongoID!, $record: UpdateByIdSetupSheetStyleInput!) {
  updateSetupSheetStyle(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateSetupSheetStyleMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSetupSheetStyleMutation, TError, UpdateSetupSheetStyleMutationVariables, TContext>) => {
    
    return useMutation<UpdateSetupSheetStyleMutation, TError, UpdateSetupSheetStyleMutationVariables, TContext>(
      ['UpdateSetupSheetStyle'],
      (variables?: UpdateSetupSheetStyleMutationVariables) => fetcher<UpdateSetupSheetStyleMutation, UpdateSetupSheetStyleMutationVariables>(UpdateSetupSheetStyleDocument, variables)(),
      options
    )};

export const RemoveSetupSheetStyleDocument = `
    mutation removeSetupSheetStyle($id: MongoID!) {
  removeSetupSheetStyle(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveSetupSheetStyleMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSetupSheetStyleMutation, TError, RemoveSetupSheetStyleMutationVariables, TContext>) => {
    
    return useMutation<RemoveSetupSheetStyleMutation, TError, RemoveSetupSheetStyleMutationVariables, TContext>(
      ['removeSetupSheetStyle'],
      (variables?: RemoveSetupSheetStyleMutationVariables) => fetcher<RemoveSetupSheetStyleMutation, RemoveSetupSheetStyleMutationVariables>(RemoveSetupSheetStyleDocument, variables)(),
      options
    )};

export const UpdateSimResultDocument = `
    mutation UpdateSimResult($id: MongoID!, $record: UpdateByIdSimResultInput!) {
  updateSimResult(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateSimResultMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSimResultMutation, TError, UpdateSimResultMutationVariables, TContext>) => {
    
    return useMutation<UpdateSimResultMutation, TError, UpdateSimResultMutationVariables, TContext>(
      ['UpdateSimResult'],
      (variables?: UpdateSimResultMutationVariables) => fetcher<UpdateSimResultMutation, UpdateSimResultMutationVariables>(UpdateSimResultDocument, variables)(),
      options
    )};

export const AddSpecificationDocument = `
    mutation AddSpecification($record: CreateOneSpecificationInput!) {
  addSpecification(record: $record) {
    recordId
  }
}
    `;

export const useAddSpecificationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddSpecificationMutation, TError, AddSpecificationMutationVariables, TContext>) => {
    
    return useMutation<AddSpecificationMutation, TError, AddSpecificationMutationVariables, TContext>(
      ['AddSpecification'],
      (variables?: AddSpecificationMutationVariables) => fetcher<AddSpecificationMutation, AddSpecificationMutationVariables>(AddSpecificationDocument, variables)(),
      options
    )};

export const RemoveSpecificationDocument = `
    mutation RemoveSpecification($id: MongoID!) {
  removeSpecification(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveSpecificationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSpecificationMutation, TError, RemoveSpecificationMutationVariables, TContext>) => {
    
    return useMutation<RemoveSpecificationMutation, TError, RemoveSpecificationMutationVariables, TContext>(
      ['RemoveSpecification'],
      (variables?: RemoveSpecificationMutationVariables) => fetcher<RemoveSpecificationMutation, RemoveSpecificationMutationVariables>(RemoveSpecificationDocument, variables)(),
      options
    )};

export const UpdateSpecificationDocument = `
    mutation UpdateSpecification($id: MongoID!, $record: UpdateByIdSpecificationInput!, $currentChassisSpecID: MongoID!, $confirmUpdate: Boolean) {
  updateSpecification(
    _id: $id
    record: $record
    currentChassisSpecID: $currentChassisSpecID
    confirmUpdate: $confirmUpdate
  ) {
    recordId
  }
}
    `;

export const useUpdateSpecificationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSpecificationMutation, TError, UpdateSpecificationMutationVariables, TContext>) => {
    
    return useMutation<UpdateSpecificationMutation, TError, UpdateSpecificationMutationVariables, TContext>(
      ['UpdateSpecification'],
      (variables?: UpdateSpecificationMutationVariables) => fetcher<UpdateSpecificationMutation, UpdateSpecificationMutationVariables>(UpdateSpecificationDocument, variables)(),
      options
    )};

export const ReleaseChassisSpecificationDocument = `
    mutation ReleaseChassisSpecification($chassisSpecID: MongoID!, $version: String) {
  releaseChassisSpec(chassisSpecID: $chassisSpecID, version: $version) {
    releasedChassisSpec {
      _id
    }
    iteratedChassisSpec {
      _id
    }
  }
}
    `;

export const useReleaseChassisSpecificationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ReleaseChassisSpecificationMutation, TError, ReleaseChassisSpecificationMutationVariables, TContext>) => {
    
    return useMutation<ReleaseChassisSpecificationMutation, TError, ReleaseChassisSpecificationMutationVariables, TContext>(
      ['ReleaseChassisSpecification'],
      (variables?: ReleaseChassisSpecificationMutationVariables) => fetcher<ReleaseChassisSpecificationMutation, ReleaseChassisSpecificationMutationVariables>(ReleaseChassisSpecificationDocument, variables)(),
      options
    )};

export const RenameSpecificationDocument = `
    mutation RenameSpecification($specificationId: MongoID!, $name: String!) {
  renameSpecification(specificationID: $specificationId, name: $name) {
    success
  }
}
    `;

export const useRenameSpecificationMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RenameSpecificationMutation, TError, RenameSpecificationMutationVariables, TContext>) => {
    
    return useMutation<RenameSpecificationMutation, TError, RenameSpecificationMutationVariables, TContext>(
      ['RenameSpecification'],
      (variables?: RenameSpecificationMutationVariables) => fetcher<RenameSpecificationMutation, RenameSpecificationMutationVariables>(RenameSpecificationDocument, variables)(),
      options
    )};

export const AddTeamDocument = `
    mutation AddTeam($record: CreateOneTeamInput!) {
  addTeam(record: $record) {
    recordId
  }
}
    `;

export const useAddTeamMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTeamMutation, TError, AddTeamMutationVariables, TContext>) => {
    
    return useMutation<AddTeamMutation, TError, AddTeamMutationVariables, TContext>(
      ['AddTeam'],
      (variables?: AddTeamMutationVariables) => fetcher<AddTeamMutation, AddTeamMutationVariables>(AddTeamDocument, variables)(),
      options
    )};

export const UpdateTeamDocument = `
    mutation UpdateTeam($id: MongoID!, $record: UpdateByIdTeamInput!) {
  updateTeam(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTeamMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTeamMutation, TError, UpdateTeamMutationVariables, TContext>) => {
    
    return useMutation<UpdateTeamMutation, TError, UpdateTeamMutationVariables, TContext>(
      ['UpdateTeam'],
      (variables?: UpdateTeamMutationVariables) => fetcher<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, variables)(),
      options
    )};

export const RemoveTeamDocument = `
    mutation RemoveTeam($id: MongoID!) {
  removeTeam(_id: $id) {
    recordId
    error {
      message
    }
  }
}
    `;

export const useRemoveTeamMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTeamMutation, TError, RemoveTeamMutationVariables, TContext>) => {
    
    return useMutation<RemoveTeamMutation, TError, RemoveTeamMutationVariables, TContext>(
      ['RemoveTeam'],
      (variables?: RemoveTeamMutationVariables) => fetcher<RemoveTeamMutation, RemoveTeamMutationVariables>(RemoveTeamDocument, variables)(),
      options
    )};

export const AssignTeamDocument = `
    mutation AssignTeam($type: AssignableToTeam!, $objectID: MongoID!, $teamID: MongoID!) {
  assignTeam(type: $type, objectID: $objectID, teamID: $teamID) {
    success
  }
}
    `;

export const useAssignTeamMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AssignTeamMutation, TError, AssignTeamMutationVariables, TContext>) => {
    
    return useMutation<AssignTeamMutation, TError, AssignTeamMutationVariables, TContext>(
      ['AssignTeam'],
      (variables?: AssignTeamMutationVariables) => fetcher<AssignTeamMutation, AssignTeamMutationVariables>(AssignTeamDocument, variables)(),
      options
    )};

export const AddTimeSheetEntryDocument = `
    mutation AddTimeSheetEntry($record: CreateOneTimeSheetEntryInput!) {
  addTimeSheetEntry(record: $record) {
    recordId
  }
}
    `;

export const useAddTimeSheetEntryMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTimeSheetEntryMutation, TError, AddTimeSheetEntryMutationVariables, TContext>) => {
    
    return useMutation<AddTimeSheetEntryMutation, TError, AddTimeSheetEntryMutationVariables, TContext>(
      ['AddTimeSheetEntry'],
      (variables?: AddTimeSheetEntryMutationVariables) => fetcher<AddTimeSheetEntryMutation, AddTimeSheetEntryMutationVariables>(AddTimeSheetEntryDocument, variables)(),
      options
    )};

export const UpdateTimeSheetEntryDocument = `
    mutation UpdateTimeSheetEntry($id: MongoID!, $record: UpdateByIdTimeSheetEntryInput!) {
  updateTimeSheetEntry(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTimeSheetEntryMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTimeSheetEntryMutation, TError, UpdateTimeSheetEntryMutationVariables, TContext>) => {
    
    return useMutation<UpdateTimeSheetEntryMutation, TError, UpdateTimeSheetEntryMutationVariables, TContext>(
      ['UpdateTimeSheetEntry'],
      (variables?: UpdateTimeSheetEntryMutationVariables) => fetcher<UpdateTimeSheetEntryMutation, UpdateTimeSheetEntryMutationVariables>(UpdateTimeSheetEntryDocument, variables)(),
      options
    )};

export const RemoveTimeSheetEntryDocument = `
    mutation RemoveTimeSheetEntry($id: MongoID!) {
  removeTimeSheetEntry(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTimeSheetEntryMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTimeSheetEntryMutation, TError, RemoveTimeSheetEntryMutationVariables, TContext>) => {
    
    return useMutation<RemoveTimeSheetEntryMutation, TError, RemoveTimeSheetEntryMutationVariables, TContext>(
      ['RemoveTimeSheetEntry'],
      (variables?: RemoveTimeSheetEntryMutationVariables) => fetcher<RemoveTimeSheetEntryMutation, RemoveTimeSheetEntryMutationVariables>(RemoveTimeSheetEntryDocument, variables)(),
      options
    )};

export const ApproveTimeSheetEntryDocument = `
    mutation ApproveTimeSheetEntry($id: MongoID!) {
  approveTimeSheetEntry(_id: $id) {
    _id
  }
}
    `;

export const useApproveTimeSheetEntryMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ApproveTimeSheetEntryMutation, TError, ApproveTimeSheetEntryMutationVariables, TContext>) => {
    
    return useMutation<ApproveTimeSheetEntryMutation, TError, ApproveTimeSheetEntryMutationVariables, TContext>(
      ['ApproveTimeSheetEntry'],
      (variables?: ApproveTimeSheetEntryMutationVariables) => fetcher<ApproveTimeSheetEntryMutation, ApproveTimeSheetEntryMutationVariables>(ApproveTimeSheetEntryDocument, variables)(),
      options
    )};

export const ApproveTimeSheetEntriesDocument = `
    mutation ApproveTimeSheetEntries($personID: MongoID, $projectID: MongoID, $tStartAfter: Date!, $tStartBefore: Date!) {
  approveTimeSheetEntries(
    personID: $personID
    projectID: $projectID
    tStartAfter: $tStartAfter
    tStartBefore: $tStartBefore
  )
}
    `;

export const useApproveTimeSheetEntriesMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ApproveTimeSheetEntriesMutation, TError, ApproveTimeSheetEntriesMutationVariables, TContext>) => {
    
    return useMutation<ApproveTimeSheetEntriesMutation, TError, ApproveTimeSheetEntriesMutationVariables, TContext>(
      ['ApproveTimeSheetEntries'],
      (variables?: ApproveTimeSheetEntriesMutationVariables) => fetcher<ApproveTimeSheetEntriesMutation, ApproveTimeSheetEntriesMutationVariables>(ApproveTimeSheetEntriesDocument, variables)(),
      options
    )};

export const UnapproveTimeSheetEntryDocument = `
    mutation UnapproveTimeSheetEntry($id: MongoID!) {
  unapproveTimeSheetEntry(_id: $id) {
    _id
  }
}
    `;

export const useUnapproveTimeSheetEntryMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UnapproveTimeSheetEntryMutation, TError, UnapproveTimeSheetEntryMutationVariables, TContext>) => {
    
    return useMutation<UnapproveTimeSheetEntryMutation, TError, UnapproveTimeSheetEntryMutationVariables, TContext>(
      ['UnapproveTimeSheetEntry'],
      (variables?: UnapproveTimeSheetEntryMutationVariables) => fetcher<UnapproveTimeSheetEntryMutation, UnapproveTimeSheetEntryMutationVariables>(UnapproveTimeSheetEntryDocument, variables)(),
      options
    )};

export const UnApproveTimeSheetEntriesDocument = `
    mutation UnApproveTimeSheetEntries($personID: MongoID, $projectID: MongoID, $tStartAfter: Date!, $tStartBefore: Date!) {
  unapproveTimeSheetEntries(
    personID: $personID
    projectID: $projectID
    tStartAfter: $tStartAfter
    tStartBefore: $tStartBefore
  )
}
    `;

export const useUnApproveTimeSheetEntriesMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UnApproveTimeSheetEntriesMutation, TError, UnApproveTimeSheetEntriesMutationVariables, TContext>) => {
    
    return useMutation<UnApproveTimeSheetEntriesMutation, TError, UnApproveTimeSheetEntriesMutationVariables, TContext>(
      ['UnApproveTimeSheetEntries'],
      (variables?: UnApproveTimeSheetEntriesMutationVariables) => fetcher<UnApproveTimeSheetEntriesMutation, UnApproveTimeSheetEntriesMutationVariables>(UnApproveTimeSheetEntriesDocument, variables)(),
      options
    )};

export const AddTimingServiceConfigDocument = `
    mutation AddTimingServiceConfig($record: CreateOneTimingServiceConfigInput!) {
  addTimingServiceConfig(record: $record) {
    record {
      _id
      name
    }
  }
}
    `;

export const useAddTimingServiceConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTimingServiceConfigMutation, TError, AddTimingServiceConfigMutationVariables, TContext>) => {
    
    return useMutation<AddTimingServiceConfigMutation, TError, AddTimingServiceConfigMutationVariables, TContext>(
      ['AddTimingServiceConfig'],
      (variables?: AddTimingServiceConfigMutationVariables) => fetcher<AddTimingServiceConfigMutation, AddTimingServiceConfigMutationVariables>(AddTimingServiceConfigDocument, variables)(),
      options
    )};

export const UpdateTimingServiceConfigDocument = `
    mutation UpdateTimingServiceConfig($id: MongoID!, $record: UpdateByIdTimingServiceConfigInput!) {
  updateTimingServiceConfig(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTimingServiceConfigMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTimingServiceConfigMutation, TError, UpdateTimingServiceConfigMutationVariables, TContext>) => {
    
    return useMutation<UpdateTimingServiceConfigMutation, TError, UpdateTimingServiceConfigMutationVariables, TContext>(
      ['UpdateTimingServiceConfig'],
      (variables?: UpdateTimingServiceConfigMutationVariables) => fetcher<UpdateTimingServiceConfigMutation, UpdateTimingServiceConfigMutationVariables>(UpdateTimingServiceConfigDocument, variables)(),
      options
    )};

export const AddTrackDocument = `
    mutation AddTrack($record: CreateOneTrackInput!) {
  addTrack(record: $record) {
    recordId
  }
}
    `;

export const useAddTrackMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTrackMutation, TError, AddTrackMutationVariables, TContext>) => {
    
    return useMutation<AddTrackMutation, TError, AddTrackMutationVariables, TContext>(
      ['AddTrack'],
      (variables?: AddTrackMutationVariables) => fetcher<AddTrackMutation, AddTrackMutationVariables>(AddTrackDocument, variables)(),
      options
    )};

export const UpdateTrackDocument = `
    mutation UpdateTrack($id: MongoID!, $record: UpdateByIdTrackInput!) {
  updateTrack(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTrackMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTrackMutation, TError, UpdateTrackMutationVariables, TContext>) => {
    
    return useMutation<UpdateTrackMutation, TError, UpdateTrackMutationVariables, TContext>(
      ['UpdateTrack'],
      (variables?: UpdateTrackMutationVariables) => fetcher<UpdateTrackMutation, UpdateTrackMutationVariables>(UpdateTrackDocument, variables)(),
      options
    )};

export const RemoveTrackDocument = `
    mutation RemoveTrack($id: MongoID!) {
  removeTrack(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTrackMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTrackMutation, TError, RemoveTrackMutationVariables, TContext>) => {
    
    return useMutation<RemoveTrackMutation, TError, RemoveTrackMutationVariables, TContext>(
      ['RemoveTrack'],
      (variables?: RemoveTrackMutationVariables) => fetcher<RemoveTrackMutation, RemoveTrackMutationVariables>(RemoveTrackDocument, variables)(),
      options
    )};

export const AddTrackLayoutDocument = `
    mutation AddTrackLayout($record: CreateOneTrackLayoutInput!) {
  addTrackLayout(record: $record) {
    recordId
  }
}
    `;

export const useAddTrackLayoutMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTrackLayoutMutation, TError, AddTrackLayoutMutationVariables, TContext>) => {
    
    return useMutation<AddTrackLayoutMutation, TError, AddTrackLayoutMutationVariables, TContext>(
      ['AddTrackLayout'],
      (variables?: AddTrackLayoutMutationVariables) => fetcher<AddTrackLayoutMutation, AddTrackLayoutMutationVariables>(AddTrackLayoutDocument, variables)(),
      options
    )};

export const UpdateTrackLayoutDocument = `
    mutation UpdateTrackLayout($id: MongoID!, $record: UpdateByIdTrackLayoutInput!) {
  updateTrackLayout(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTrackLayoutMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTrackLayoutMutation, TError, UpdateTrackLayoutMutationVariables, TContext>) => {
    
    return useMutation<UpdateTrackLayoutMutation, TError, UpdateTrackLayoutMutationVariables, TContext>(
      ['UpdateTrackLayout'],
      (variables?: UpdateTrackLayoutMutationVariables) => fetcher<UpdateTrackLayoutMutation, UpdateTrackLayoutMutationVariables>(UpdateTrackLayoutDocument, variables)(),
      options
    )};

export const RemoveTrackLayoutDocument = `
    mutation RemoveTrackLayout($id: MongoID!) {
  removeTrackLayout(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTrackLayoutMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTrackLayoutMutation, TError, RemoveTrackLayoutMutationVariables, TContext>) => {
    
    return useMutation<RemoveTrackLayoutMutation, TError, RemoveTrackLayoutMutationVariables, TContext>(
      ['RemoveTrackLayout'],
      (variables?: RemoveTrackLayoutMutationVariables) => fetcher<RemoveTrackLayoutMutation, RemoveTrackLayoutMutationVariables>(RemoveTrackLayoutDocument, variables)(),
      options
    )};

export const AddTyreSetDocument = `
    mutation AddTyreSet($record: CreateOneTyreSetInput!) {
  addTyreSet(record: $record) {
    recordId
  }
}
    `;

export const useAddTyreSetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTyreSetMutation, TError, AddTyreSetMutationVariables, TContext>) => {
    
    return useMutation<AddTyreSetMutation, TError, AddTyreSetMutationVariables, TContext>(
      ['AddTyreSet'],
      (variables?: AddTyreSetMutationVariables) => fetcher<AddTyreSetMutation, AddTyreSetMutationVariables>(AddTyreSetDocument, variables)(),
      options
    )};

export const UpdateTyreSetDocument = `
    mutation UpdateTyreSet($id: MongoID!, $record: UpdateByIdTyreSetInput!) {
  updateTyreSet(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTyreSetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTyreSetMutation, TError, UpdateTyreSetMutationVariables, TContext>) => {
    
    return useMutation<UpdateTyreSetMutation, TError, UpdateTyreSetMutationVariables, TContext>(
      ['UpdateTyreSet'],
      (variables?: UpdateTyreSetMutationVariables) => fetcher<UpdateTyreSetMutation, UpdateTyreSetMutationVariables>(UpdateTyreSetDocument, variables)(),
      options
    )};

export const RemoveTyreSetDocument = `
    mutation RemoveTyreSet($id: MongoID!) {
  removeTyreSet(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTyreSetMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTyreSetMutation, TError, RemoveTyreSetMutationVariables, TContext>) => {
    
    return useMutation<RemoveTyreSetMutation, TError, RemoveTyreSetMutationVariables, TContext>(
      ['RemoveTyreSet'],
      (variables?: RemoveTyreSetMutationVariables) => fetcher<RemoveTyreSetMutation, RemoveTyreSetMutationVariables>(RemoveTyreSetDocument, variables)(),
      options
    )};

export const AddTyreSetsToContestantDocument = `
    mutation AddTyreSetsToContestant($contestantID: MongoID!, $tyreSetIDs: [MongoID!]!) {
  addTyreSetsToContestant(contestantID: $contestantID, tyreSetIDs: $tyreSetIDs) {
    success
  }
}
    `;

export const useAddTyreSetsToContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTyreSetsToContestantMutation, TError, AddTyreSetsToContestantMutationVariables, TContext>) => {
    
    return useMutation<AddTyreSetsToContestantMutation, TError, AddTyreSetsToContestantMutationVariables, TContext>(
      ['AddTyreSetsToContestant'],
      (variables?: AddTyreSetsToContestantMutationVariables) => fetcher<AddTyreSetsToContestantMutation, AddTyreSetsToContestantMutationVariables>(AddTyreSetsToContestantDocument, variables)(),
      options
    )};

export const RemoveTyreSetsFromContestantDocument = `
    mutation RemoveTyreSetsFromContestant($contestantID: MongoID!, $tyreSetIDs: [MongoID!]!) {
  removeTyreSetsFromContestant(
    contestantID: $contestantID
    tyreSetIDs: $tyreSetIDs
  ) {
    success
  }
}
    `;

export const useRemoveTyreSetsFromContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTyreSetsFromContestantMutation, TError, RemoveTyreSetsFromContestantMutationVariables, TContext>) => {
    
    return useMutation<RemoveTyreSetsFromContestantMutation, TError, RemoveTyreSetsFromContestantMutationVariables, TContext>(
      ['RemoveTyreSetsFromContestant'],
      (variables?: RemoveTyreSetsFromContestantMutationVariables) => fetcher<RemoveTyreSetsFromContestantMutation, RemoveTyreSetsFromContestantMutationVariables>(RemoveTyreSetsFromContestantDocument, variables)(),
      options
    )};

export const AddTyreSetsToEventContestantDocument = `
    mutation AddTyreSetsToEventContestant($contestantID: MongoID!, $eventID: MongoID!, $tyreSetIDs: [MongoID!]!) {
  addTyreSetsToEventContestant(
    contestantID: $contestantID
    eventID: $eventID
    tyreSetIDs: $tyreSetIDs
  ) {
    success
    changed
  }
}
    `;

export const useAddTyreSetsToEventContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTyreSetsToEventContestantMutation, TError, AddTyreSetsToEventContestantMutationVariables, TContext>) => {
    
    return useMutation<AddTyreSetsToEventContestantMutation, TError, AddTyreSetsToEventContestantMutationVariables, TContext>(
      ['AddTyreSetsToEventContestant'],
      (variables?: AddTyreSetsToEventContestantMutationVariables) => fetcher<AddTyreSetsToEventContestantMutation, AddTyreSetsToEventContestantMutationVariables>(AddTyreSetsToEventContestantDocument, variables)(),
      options
    )};

export const RemoveTyreSetsFromEventContestantDocument = `
    mutation RemoveTyreSetsFromEventContestant($contestantID: MongoID!, $eventID: MongoID!, $tyreSetIDs: [MongoID!]!) {
  removeTyreSetsFromEventContestant(
    contestantID: $contestantID
    eventID: $eventID
    tyreSetIDs: $tyreSetIDs
  ) {
    success
    changed
  }
}
    `;

export const useRemoveTyreSetsFromEventContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTyreSetsFromEventContestantMutation, TError, RemoveTyreSetsFromEventContestantMutationVariables, TContext>) => {
    
    return useMutation<RemoveTyreSetsFromEventContestantMutation, TError, RemoveTyreSetsFromEventContestantMutationVariables, TContext>(
      ['RemoveTyreSetsFromEventContestant'],
      (variables?: RemoveTyreSetsFromEventContestantMutationVariables) => fetcher<RemoveTyreSetsFromEventContestantMutation, RemoveTyreSetsFromEventContestantMutationVariables>(RemoveTyreSetsFromEventContestantDocument, variables)(),
      options
    )};

export const AddTyreDocument = `
    mutation AddTyre($record: CreateOneTyreInput!) {
  addTyre(record: $record) {
    recordId
  }
}
    `;

export const useAddTyreMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTyreMutation, TError, AddTyreMutationVariables, TContext>) => {
    
    return useMutation<AddTyreMutation, TError, AddTyreMutationVariables, TContext>(
      ['AddTyre'],
      (variables?: AddTyreMutationVariables) => fetcher<AddTyreMutation, AddTyreMutationVariables>(AddTyreDocument, variables)(),
      options
    )};

export const CreateTyresForContestantDocument = `
    mutation CreateTyresForContestant($contestantID: MongoID!, $eventID: MongoID, $tyres: [CreateTyreRecordInput!], $sets: [CreateTyreSetRecordInput!]) {
  createTyresForContestant(
    contestantID: $contestantID
    eventID: $eventID
    tyres: $tyres
    sets: $sets
  ) {
    success
    tyreIDs
    tyreSetIDs
  }
}
    `;

export const useCreateTyresForContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<CreateTyresForContestantMutation, TError, CreateTyresForContestantMutationVariables, TContext>) => {
    
    return useMutation<CreateTyresForContestantMutation, TError, CreateTyresForContestantMutationVariables, TContext>(
      ['CreateTyresForContestant'],
      (variables?: CreateTyresForContestantMutationVariables) => fetcher<CreateTyresForContestantMutation, CreateTyresForContestantMutationVariables>(CreateTyresForContestantDocument, variables)(),
      options
    )};

export const UpdateTyreDocument = `
    mutation UpdateTyre($id: MongoID!, $record: UpdateByIdTyreInput!) {
  updateTyre(_id: $id, record: $record) {
    recordId
  }
}
    `;

export const useUpdateTyreMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTyreMutation, TError, UpdateTyreMutationVariables, TContext>) => {
    
    return useMutation<UpdateTyreMutation, TError, UpdateTyreMutationVariables, TContext>(
      ['UpdateTyre'],
      (variables?: UpdateTyreMutationVariables) => fetcher<UpdateTyreMutation, UpdateTyreMutationVariables>(UpdateTyreDocument, variables)(),
      options
    )};

export const RemoveTyreDocument = `
    mutation RemoveTyre($id: MongoID!) {
  removeTyre(_id: $id) {
    recordId
  }
}
    `;

export const useRemoveTyreMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTyreMutation, TError, RemoveTyreMutationVariables, TContext>) => {
    
    return useMutation<RemoveTyreMutation, TError, RemoveTyreMutationVariables, TContext>(
      ['RemoveTyre'],
      (variables?: RemoveTyreMutationVariables) => fetcher<RemoveTyreMutation, RemoveTyreMutationVariables>(RemoveTyreDocument, variables)(),
      options
    )};

export const RemoveManyTyresDocument = `
    mutation RemoveManyTyres($tyreIDs: [MongoID!]!) {
  removeManyTyres(tyreIDs: $tyreIDs) {
    deletedCount
  }
}
    `;

export const useRemoveManyTyresMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveManyTyresMutation, TError, RemoveManyTyresMutationVariables, TContext>) => {
    
    return useMutation<RemoveManyTyresMutation, TError, RemoveManyTyresMutationVariables, TContext>(
      ['RemoveManyTyres'],
      (variables?: RemoveManyTyresMutationVariables) => fetcher<RemoveManyTyresMutation, RemoveManyTyresMutationVariables>(RemoveManyTyresDocument, variables)(),
      options
    )};

export const RemoveManyTyreSetsDocument = `
    mutation RemoveManyTyreSets($tyreSetIDs: [MongoID!]!) {
  removeManyTyreSets(tyreSetIDs: $tyreSetIDs) {
    deletedCount
  }
}
    `;

export const useRemoveManyTyreSetsMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveManyTyreSetsMutation, TError, RemoveManyTyreSetsMutationVariables, TContext>) => {
    
    return useMutation<RemoveManyTyreSetsMutation, TError, RemoveManyTyreSetsMutationVariables, TContext>(
      ['RemoveManyTyreSets'],
      (variables?: RemoveManyTyreSetsMutationVariables) => fetcher<RemoveManyTyreSetsMutation, RemoveManyTyreSetsMutationVariables>(RemoveManyTyreSetsDocument, variables)(),
      options
    )};

export const ScrapManyTyresDocument = `
    mutation ScrapManyTyres($tyreIDs: [MongoID!]!) {
  scrapManyTyres(tyreIDs: $tyreIDs) {
    updatedCount
  }
}
    `;

export const useScrapManyTyresMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<ScrapManyTyresMutation, TError, ScrapManyTyresMutationVariables, TContext>) => {
    
    return useMutation<ScrapManyTyresMutation, TError, ScrapManyTyresMutationVariables, TContext>(
      ['ScrapManyTyres'],
      (variables?: ScrapManyTyresMutationVariables) => fetcher<ScrapManyTyresMutation, ScrapManyTyresMutationVariables>(ScrapManyTyresDocument, variables)(),
      options
    )};

export const AddTyresToEventContestantDocument = `
    mutation AddTyresToEventContestant($contestantID: MongoID!, $eventID: MongoID!, $tyreIDs: [MongoID!]!) {
  addTyresToEventContestant(
    contestantID: $contestantID
    eventID: $eventID
    tyreIDs: $tyreIDs
  ) {
    success
    changed
  }
}
    `;

export const useAddTyresToEventContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTyresToEventContestantMutation, TError, AddTyresToEventContestantMutationVariables, TContext>) => {
    
    return useMutation<AddTyresToEventContestantMutation, TError, AddTyresToEventContestantMutationVariables, TContext>(
      ['AddTyresToEventContestant'],
      (variables?: AddTyresToEventContestantMutationVariables) => fetcher<AddTyresToEventContestantMutation, AddTyresToEventContestantMutationVariables>(AddTyresToEventContestantDocument, variables)(),
      options
    )};

export const RemoveTyresFromEventContestantDocument = `
    mutation RemoveTyresFromEventContestant($contestantID: MongoID!, $eventID: MongoID!, $tyreIDs: [MongoID!]!) {
  removeTyresFromEventContestant(
    contestantID: $contestantID
    eventID: $eventID
    tyreIDs: $tyreIDs
  ) {
    success
    changed
  }
}
    `;

export const useRemoveTyresFromEventContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTyresFromEventContestantMutation, TError, RemoveTyresFromEventContestantMutationVariables, TContext>) => {
    
    return useMutation<RemoveTyresFromEventContestantMutation, TError, RemoveTyresFromEventContestantMutationVariables, TContext>(
      ['RemoveTyresFromEventContestant'],
      (variables?: RemoveTyresFromEventContestantMutationVariables) => fetcher<RemoveTyresFromEventContestantMutation, RemoveTyresFromEventContestantMutationVariables>(RemoveTyresFromEventContestantDocument, variables)(),
      options
    )};

export const AddTyresToContestantDocument = `
    mutation AddTyresToContestant($contestantID: MongoID!, $tyreIDs: [MongoID!]!) {
  addTyresToContestant(contestantID: $contestantID, tyreIDs: $tyreIDs) {
    success
  }
}
    `;

export const useAddTyresToContestantMutation = <
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } },
      TContext = unknown
    >(options?: UseMutationOptions<AddTyresToContestantMutation, TError, AddTyresToContestantMutationVariables, TContext>) => {
    
    return useMutation<AddTyresToContestantMutation, TError, AddTyresToContestantMutationVariables, TContext>(
      ['AddTyresToContestant'],
      (variables?: AddTyresToContestantMutationVariables) => fetcher<AddTyresToContestantMutation, AddTyresToContestantMutationVariables>(AddTyresToContestantDocument, variables)(),
      options
    )};

export const GetPersonInfoForProfilePageDocument = `
    query GetPersonInfoForProfilePage($id: MongoID!) {
  person(_id: $id) {
    _id
    acronym
    behaviour {
      carryOverJobList
      showMyJobsOnRunSheetDefault
      timeLocale
      timezoneSelect
    }
    canopyCredentials {
      clientID
      clientSecret
      username
      password
      userID
      tenantID
    }
    carUpdateMethod
    defaultTyreSetNameFormat
    defaultTyreReferenceTemperature
    defaultRunSheetStyleID
    defaultRunSheetCompareStyleID
    email
    emailNotificationConfig {
      jobAssigned
      jobCommentedOn
      jobStatusChanged
    }
    hideKPIs
    isActive
    isTimeTracker
    isTimeTrackerAdmin
    localConnections {
      host
      endPoint
      port
      outputFolder
      useSSL
    }
    mileageUnit
    name
    role
    teamID
    timeTrackerApprovalByPersonID
    userSetups {
      _id
      title
    }
    username
    viewConfig {
      showRunSheetsAsTabs
      yellowTyreMileageThreshold
      redTyreMileageThreshold
      highlightTyreMileages
    }
    visibleEventIDs
  }
}
    `;

export const useGetPersonInfoForProfilePageQuery = <
      TData = GetPersonInfoForProfilePageQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPersonInfoForProfilePageQueryVariables,
      options?: UseQueryOptions<GetPersonInfoForProfilePageQuery, TError, TData>
    ) => {
    
    return useQuery<GetPersonInfoForProfilePageQuery, TError, TData>(
      ['GetPersonInfoForProfilePage', variables],
      fetcher<GetPersonInfoForProfilePageQuery, GetPersonInfoForProfilePageQueryVariables>(GetPersonInfoForProfilePageDocument, variables),
      options
    )};

export const GetAllAssembliesBasicFieldsDocument = `
    query GetAllAssembliesBasicFields {
  assemblies(perPage: 10000) {
    items {
      ... on ChassisAssembly {
        _id
        name
        reference
        tags {
          _id
        }
        chassisSpecID
        partInstances {
          _id
          readingLocation
          specificationID
          partID
        }
        __typename
      }
      ... on SubAssembly {
        _id
        name
        reference
        chassisSpecID
        tags {
          _id
        }
        partInstances {
          _id
          readingLocation
          specificationID
          partID
        }
        __typename
      }
    }
  }
}
    `;

export const useGetAllAssembliesBasicFieldsQuery = <
      TData = GetAllAssembliesBasicFieldsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllAssembliesBasicFieldsQueryVariables,
      options?: UseQueryOptions<GetAllAssembliesBasicFieldsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllAssembliesBasicFieldsQuery, TError, TData>(
      variables === undefined ? ['GetAllAssembliesBasicFields'] : ['GetAllAssembliesBasicFields', variables],
      fetcher<GetAllAssembliesBasicFieldsQuery, GetAllAssembliesBasicFieldsQueryVariables>(GetAllAssembliesBasicFieldsDocument, variables),
      options
    )};

export const GetChassisAssemblyByIdDocument = `
    query GetChassisAssemblyById($id: MongoID!) {
  assembly(_id: $id) {
    ... on ChassisAssembly {
      _id
      name
      decommissioned
      current
      subAssemblies {
        ... on SubAssembly {
          _id
        }
      }
      partInstances {
        _id
        specificationID
        partID
      }
      locationID
      chassisSpecID
      tagIDs
      chassisPartID
      tags {
        _id
      }
      location {
        _id
      }
    }
  }
}
    `;

export const useGetChassisAssemblyByIdQuery = <
      TData = GetChassisAssemblyByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisAssemblyByIdQueryVariables,
      options?: UseQueryOptions<GetChassisAssemblyByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisAssemblyByIdQuery, TError, TData>(
      ['GetChassisAssemblyById', variables],
      fetcher<GetChassisAssemblyByIdQuery, GetChassisAssemblyByIdQueryVariables>(GetChassisAssemblyByIdDocument, variables),
      options
    )};

export const GetAllSubAssembliesDocument = `
    query GetAllSubAssemblies {
  assemblies(perPage: 100000) {
    items {
      ... on SubAssembly {
        _id
        chassisSpecID
        partInstances {
          _id
        }
        subAssemblies {
          ... on SubAssembly {
            _id
          }
        }
      }
    }
  }
}
    `;

export const useGetAllSubAssembliesQuery = <
      TData = GetAllSubAssembliesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllSubAssembliesQueryVariables,
      options?: UseQueryOptions<GetAllSubAssembliesQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllSubAssembliesQuery, TError, TData>(
      variables === undefined ? ['GetAllSubAssemblies'] : ['GetAllSubAssemblies', variables],
      fetcher<GetAllSubAssembliesQuery, GetAllSubAssembliesQueryVariables>(GetAllSubAssembliesDocument, variables),
      options
    )};

export const GetSubAssemblyByIdDocument = `
    query GetSubAssemblyById($id: MongoID!) {
  assembly(_id: $id) {
    ...SubAssemblyVars
    ...ChassisAssemblyVars
  }
}
    ${SubAssemblyVarsFragmentDoc}
${ChassisAssemblyVarsFragmentDoc}`;

export const useGetSubAssemblyByIdQuery = <
      TData = GetSubAssemblyByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSubAssemblyByIdQueryVariables,
      options?: UseQueryOptions<GetSubAssemblyByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetSubAssemblyByIdQuery, TError, TData>(
      ['GetSubAssemblyById', variables],
      fetcher<GetSubAssemblyByIdQuery, GetSubAssemblyByIdQueryVariables>(GetSubAssemblyByIdDocument, variables),
      options
    )};

export const BestValuesSessionDocument = `
    query BestValuesSession($sessionID: MongoID!) {
  bestValuesAll(
    filter: {sessionID: $sessionID, contestantID: null, driverID: null}
    perPage: 1
  ) {
    items {
      _id
      ...BestValuesVars
    }
  }
}
    ${BestValuesVarsFragmentDoc}`;

export const useBestValuesSessionQuery = <
      TData = BestValuesSessionQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: BestValuesSessionQueryVariables,
      options?: UseQueryOptions<BestValuesSessionQuery, TError, TData>
    ) => {
    
    return useQuery<BestValuesSessionQuery, TError, TData>(
      ['BestValuesSession', variables],
      fetcher<BestValuesSessionQuery, BestValuesSessionQueryVariables>(BestValuesSessionDocument, variables),
      options
    )};

export const BestValuesDriverDocument = `
    query BestValuesDriver($sessionID: MongoID!, $contestantID: MongoID!) {
  bestValuesAll(
    filter: {sessionID: $sessionID, contestantID: $contestantID}
    perPage: 1
  ) {
    items {
      _id
      ...BestValuesVars
    }
  }
}
    ${BestValuesVarsFragmentDoc}`;

export const useBestValuesDriverQuery = <
      TData = BestValuesDriverQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: BestValuesDriverQueryVariables,
      options?: UseQueryOptions<BestValuesDriverQuery, TError, TData>
    ) => {
    
    return useQuery<BestValuesDriverQuery, TError, TData>(
      ['BestValuesDriver', variables],
      fetcher<BestValuesDriverQuery, BestValuesDriverQueryVariables>(BestValuesDriverDocument, variables),
      options
    )};

export const GetCalculationDocument = `
    query GetCalculation($id: MongoID!) {
  calculation(_id: $id) {
    _id
    ...CalculationVars
  }
}
    ${CalculationVarsFragmentDoc}`;

export const useGetCalculationQuery = <
      TData = GetCalculationQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCalculationQueryVariables,
      options?: UseQueryOptions<GetCalculationQuery, TError, TData>
    ) => {
    
    return useQuery<GetCalculationQuery, TError, TData>(
      ['GetCalculation', variables],
      fetcher<GetCalculationQuery, GetCalculationQueryVariables>(GetCalculationDocument, variables),
      options
    )};

export const GetAllCalculationsDocument = `
    query GetAllCalculations {
  calculations(perPage: 2000) {
    items {
      _id
      ...CalculationVars
    }
  }
}
    ${CalculationVarsFragmentDoc}`;

export const useGetAllCalculationsQuery = <
      TData = GetAllCalculationsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllCalculationsQueryVariables,
      options?: UseQueryOptions<GetAllCalculationsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllCalculationsQuery, TError, TData>(
      variables === undefined ? ['GetAllCalculations'] : ['GetAllCalculations', variables],
      fetcher<GetAllCalculationsQuery, GetAllCalculationsQueryVariables>(GetAllCalculationsDocument, variables),
      options
    )};

export const GetAllCalculationsByIdsDocument = `
    query GetAllCalculationsByIds($calculationIDs: [MongoID!]!) {
  calculations(perPage: 1000, filter: {_operators: {_id: {in: $calculationIDs}}}) {
    items {
      _id
      ...CalculationVars
    }
  }
}
    ${CalculationVarsFragmentDoc}`;

export const useGetAllCalculationsByIdsQuery = <
      TData = GetAllCalculationsByIdsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAllCalculationsByIdsQueryVariables,
      options?: UseQueryOptions<GetAllCalculationsByIdsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllCalculationsByIdsQuery, TError, TData>(
      ['GetAllCalculationsByIds', variables],
      fetcher<GetAllCalculationsByIdsQuery, GetAllCalculationsByIdsQueryVariables>(GetAllCalculationsByIdsDocument, variables),
      options
    )};

export const GetCarDataServiceConfigsDocument = `
    query GetCarDataServiceConfigs {
  carDataServiceConfigs(perPage: 1000, sort: _ID_DESC) {
    items {
      ...GetCarDataServiceConfigItem
    }
  }
}
    ${GetCarDataServiceConfigItemFragmentDoc}`;

export const useGetCarDataServiceConfigsQuery = <
      TData = GetCarDataServiceConfigsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetCarDataServiceConfigsQueryVariables,
      options?: UseQueryOptions<GetCarDataServiceConfigsQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarDataServiceConfigsQuery, TError, TData>(
      variables === undefined ? ['GetCarDataServiceConfigs'] : ['GetCarDataServiceConfigs', variables],
      fetcher<GetCarDataServiceConfigsQuery, GetCarDataServiceConfigsQueryVariables>(GetCarDataServiceConfigsDocument, variables),
      options
    )};

export const GetCarDataServiceConfigDocument = `
    query GetCarDataServiceConfig($id: MongoID!) {
  carDataServiceConfig(_id: $id) {
    _id
    name
    version
    active
    ORHCalculationIDs
    raceSeries {
      _id
      name
    }
    ParameterMap
    Kpi {
      KpiParameters
      Preconditions
    }
    PostProcessingConfig {
      ApplicationSettingsConfiguration {
        ProcessedFolder
        ResultsFolder
        FunctionsFolder
        RunsheetMatching
        PitstopTriggers {
          ParameterId
          Value
          Type
        }
        DriverContestantLookup
      }
      ProcessingEnginesConfiguration {
        ImportersFolder
        ParameterMapFile
        InternalCalculationsFolder
        UserCalculationsFolder
        ExportersFolder
        ProcessingEngineConfiguration {
          Name
          QueueName
          Instances
          Importer
          Calculations
          Exporters {
            ATLAS10_EXPORTER
            JSONFILE_EXPORTER
            ONERACEHUB_EXPORTER
            WINTAX_EXPORTER {
              DISTANCE_CHANNEL
              FUEL_CONSUMPTION
              FUEL_LEVEL
              LAP_DISTANCE
              OUTPUT_PATH
              TELDATAZTX_PATH
            }
          }
        }
      }
      EventConfiguration {
        EventId
        EventDescription
      }
      QueueManagerConfiguration {
        Queues {
          Name
          SessionType
        }
      }
      SessionManagerConfiguration {
        OffloadFolder
        OffloadSessionTypes
      }
      SessionTypesConfiguration {
        SessionTypes {
          name
          exts
          regExpressions
          folderUpLevel
          ignoreLiterals
        }
      }
    }
  }
}
    `;

export const useGetCarDataServiceConfigQuery = <
      TData = GetCarDataServiceConfigQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCarDataServiceConfigQueryVariables,
      options?: UseQueryOptions<GetCarDataServiceConfigQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarDataServiceConfigQuery, TError, TData>(
      ['GetCarDataServiceConfig', variables],
      fetcher<GetCarDataServiceConfigQuery, GetCarDataServiceConfigQueryVariables>(GetCarDataServiceConfigDocument, variables),
      options
    )};

export const GetBasicCarSetupListDocument = `
    query GetBasicCarSetupList {
  carSetups(perPage: 1000, sort: _ID_DESC) {
    items {
      _id
      title
      runSheet {
        _id
        NRun
        session {
          _id
          name
          event {
            _id
            name
          }
        }
      }
      info {
        NIssue
      }
      engineer {
        _id
        name
      }
    }
  }
}
    `;

export const useGetBasicCarSetupListQuery = <
      TData = GetBasicCarSetupListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBasicCarSetupListQueryVariables,
      options?: UseQueryOptions<GetBasicCarSetupListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicCarSetupListQuery, TError, TData>(
      variables === undefined ? ['GetBasicCarSetupList'] : ['GetBasicCarSetupList', variables],
      fetcher<GetBasicCarSetupListQuery, GetBasicCarSetupListQueryVariables>(GetBasicCarSetupListDocument, variables),
      options
    )};

export const GetCarSetupDocument = `
    query GetCarSetup($id: MongoID!) {
  carSetup(_id: $id) {
    _id
    ...CarSetupVars
  }
}
    ${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}`;

export const useGetCarSetupQuery = <
      TData = GetCarSetupQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCarSetupQueryVariables,
      options?: UseQueryOptions<GetCarSetupQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarSetupQuery, TError, TData>(
      ['GetCarSetup', variables],
      fetcher<GetCarSetupQuery, GetCarSetupQueryVariables>(GetCarSetupDocument, variables),
      options
    )};

export const GetCarSetupForSessionExportDocument = `
    query GetCarSetupForSessionExport($id: MongoID!) {
  carSetup(_id: $id) {
    _id
    ...CarSetupExportVars
  }
}
    ${CarSetupExportVarsFragmentDoc}
${ChassisAssemblyForSetupExportVarsFragmentDoc}
${ChassisMeasurementPointVarsFragmentDoc}
${PartInstancesForSetupSheetFlexVarsFragmentDoc}
${PartForSetupSheetFlexVarsFragmentDoc}
${ChassisSpecVarsForSetupSheetFlexFragmentDoc}
${CalculationVarsFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${ChassisMeasurementVarsFragmentDoc}
${SetupSheetStyleForFlexSetupFragmentDoc}
${SpecificationGroupVariablesFragmentDoc}
${AllRunSheetScalarVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}`;

export const useGetCarSetupForSessionExportQuery = <
      TData = GetCarSetupForSessionExportQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCarSetupForSessionExportQueryVariables,
      options?: UseQueryOptions<GetCarSetupForSessionExportQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarSetupForSessionExportQuery, TError, TData>(
      ['GetCarSetupForSessionExport', variables],
      fetcher<GetCarSetupForSessionExportQuery, GetCarSetupForSessionExportQueryVariables>(GetCarSetupForSessionExportDocument, variables),
      options
    )};

export const GetCarSetupTitleDocument = `
    query GetCarSetupTitle($id: MongoID!) {
  carSetup(_id: $id) {
    _id
    title
  }
}
    `;

export const useGetCarSetupTitleQuery = <
      TData = GetCarSetupTitleQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCarSetupTitleQueryVariables,
      options?: UseQueryOptions<GetCarSetupTitleQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarSetupTitleQuery, TError, TData>(
      ['GetCarSetupTitle', variables],
      fetcher<GetCarSetupTitleQuery, GetCarSetupTitleQueryVariables>(GetCarSetupTitleDocument, variables),
      options
    )};

export const DoCarSetupSearchDocument = `
    query DoCarSetupSearch($search: RegExpAsString) {
  carSetups(filter: {_operators: {title: {regex: $search}}}, perPage: 2000) {
    items {
      _id
      title
      eventID
      contestantID
      teamID
    }
  }
}
    `;

export const useDoCarSetupSearchQuery = <
      TData = DoCarSetupSearchQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: DoCarSetupSearchQueryVariables,
      options?: UseQueryOptions<DoCarSetupSearchQuery, TError, TData>
    ) => {
    
    return useQuery<DoCarSetupSearchQuery, TError, TData>(
      variables === undefined ? ['DoCarSetupSearch'] : ['DoCarSetupSearch', variables],
      fetcher<DoCarSetupSearchQuery, DoCarSetupSearchQueryVariables>(DoCarSetupSearchDocument, variables),
      options
    )};

export const GetCarSetupByEventIdDocument = `
    query GetCarSetupByEventID($eventID: MongoID!) {
  carSetupsMany(filter: {eventID: $eventID}, limit: 2000) {
    _id
    title
    eventID
    contestantID
    teamID
  }
}
    `;

export const useGetCarSetupByEventIdQuery = <
      TData = GetCarSetupByEventIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCarSetupByEventIdQueryVariables,
      options?: UseQueryOptions<GetCarSetupByEventIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarSetupByEventIdQuery, TError, TData>(
      ['GetCarSetupByEventID', variables],
      fetcher<GetCarSetupByEventIdQuery, GetCarSetupByEventIdQueryVariables>(GetCarSetupByEventIdDocument, variables),
      options
    )};

export const GetCarSetupByEventAndContestantIDsDocument = `
    query GetCarSetupByEventAndContestantIDs($eventID: MongoID!, $contestantID: MongoID!) {
  carSetupsMany(
    filter: {eventID: $eventID, contestantID: $contestantID}
    limit: 2000
  ) {
    _id
    title
    eventID
    contestantID
    teamID
  }
}
    `;

export const useGetCarSetupByEventAndContestantIDsQuery = <
      TData = GetCarSetupByEventAndContestantIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCarSetupByEventAndContestantIDsQueryVariables,
      options?: UseQueryOptions<GetCarSetupByEventAndContestantIDsQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarSetupByEventAndContestantIDsQuery, TError, TData>(
      ['GetCarSetupByEventAndContestantIDs', variables],
      fetcher<GetCarSetupByEventAndContestantIDsQuery, GetCarSetupByEventAndContestantIDsQueryVariables>(GetCarSetupByEventAndContestantIDsDocument, variables),
      options
    )};

export const DoCarSetupSearchManyDocument = `
    query DoCarSetupSearchMany($search: RegExpAsString, $eventID: MongoID, $contestantID: MongoID) {
  carSetupsMany(
    filter: {_operators: {title: {regex: $search}}, eventID: $eventID, contestantID: $contestantID}
    limit: 2000
  ) {
    _id
    title
    eventID
    contestantID
    teamID
  }
}
    `;

export const useDoCarSetupSearchManyQuery = <
      TData = DoCarSetupSearchManyQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: DoCarSetupSearchManyQueryVariables,
      options?: UseQueryOptions<DoCarSetupSearchManyQuery, TError, TData>
    ) => {
    
    return useQuery<DoCarSetupSearchManyQuery, TError, TData>(
      variables === undefined ? ['DoCarSetupSearchMany'] : ['DoCarSetupSearchMany', variables],
      fetcher<DoCarSetupSearchManyQuery, DoCarSetupSearchManyQueryVariables>(DoCarSetupSearchManyDocument, variables),
      options
    )};

export const GetBlankingDocument = `
    query GetBlanking($id: MongoID!) {
  carSetup(_id: $id) {
    _id
    powertrain {
      hEngineBlanking
      engineBlankingDetails
    }
  }
}
    `;

export const useGetBlankingQuery = <
      TData = GetBlankingQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetBlankingQueryVariables,
      options?: UseQueryOptions<GetBlankingQuery, TError, TData>
    ) => {
    
    return useQuery<GetBlankingQuery, TError, TData>(
      ['GetBlanking', variables],
      fetcher<GetBlankingQuery, GetBlankingQueryVariables>(GetBlankingDocument, variables),
      options
    )};

export const GetCarSetupsBySessionsIDsDocument = `
    query GetCarSetupsBySessionsIDs($sessionIDs: [MongoID!]!, $contestantIDs: [MongoID!]!) {
  runSheets(
    perPage: 1000
    filter: {_operators: {sessionID: {in: $sessionIDs}, contestantID: {in: $contestantIDs}}}
  ) {
    items {
      _id
      NRunTiming
      nextRunSheetID
      contestant {
        _id
        startNumber
      }
      session {
        _id
        shortName
      }
      setup {
        _id
        title
        driver {
          _id
          acronym
        }
        driverID
        engineer {
          _id
          name
        }
        engineerID
        chassisID
        time
        setupSheetStyle
        frontLeft {
          ...CornerVars
        }
        frontRight {
          ...CornerVars
        }
        rearLeft {
          ...CornerVars
        }
        rearRight {
          ...CornerVars
        }
        front {
          ...EndVars
        }
        rear {
          ...EndVars
        }
        massTeam {
          ...MassVars
        }
        massSetup {
          ...MassVars
        }
        massRegulation {
          ...MassVars
        }
        massOutOfGarage {
          ...MassVars
        }
        systemsConfigValues
        mBallasts
        aero {
          ...AeroVars
        }
        brakeSystem {
          ...BrakeSystemVars
        }
        powertrain {
          ...PowertrainVars
        }
        info {
          ...InfoVars
        }
        chassis {
          _id
          systemsConfigFields
          ballastPositions
        }
      }
    }
  }
}
    ${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}`;

export const useGetCarSetupsBySessionsIDsQuery = <
      TData = GetCarSetupsBySessionsIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCarSetupsBySessionsIDsQueryVariables,
      options?: UseQueryOptions<GetCarSetupsBySessionsIDsQuery, TError, TData>
    ) => {
    
    return useQuery<GetCarSetupsBySessionsIDsQuery, TError, TData>(
      ['GetCarSetupsBySessionsIDs', variables],
      fetcher<GetCarSetupsBySessionsIDsQuery, GetCarSetupsBySessionsIDsQueryVariables>(GetCarSetupsBySessionsIDsDocument, variables),
      options
    )};

export const GetChassisAllDocument = `
    query GetChassisAll {
  chassisAll {
    items {
      _id
      specification {
        _id
        name
      }
      specificationID
      setupSheetStyle
      systemsConfigFields
      ballastPositions
    }
  }
}
    `;

export const useGetChassisAllQuery = <
      TData = GetChassisAllQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetChassisAllQueryVariables,
      options?: UseQueryOptions<GetChassisAllQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisAllQuery, TError, TData>(
      variables === undefined ? ['GetChassisAll'] : ['GetChassisAll', variables],
      fetcher<GetChassisAllQuery, GetChassisAllQueryVariables>(GetChassisAllDocument, variables),
      options
    )};

export const GetBasicChassisListDocument = `
    query GetBasicChassisList {
  chassisAll(perPage: 65536, sort: _ID_DESC) {
    items {
      _id
      reference
      type
    }
  }
}
    `;

export const useGetBasicChassisListQuery = <
      TData = GetBasicChassisListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBasicChassisListQueryVariables,
      options?: UseQueryOptions<GetBasicChassisListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicChassisListQuery, TError, TData>(
      variables === undefined ? ['GetBasicChassisList'] : ['GetBasicChassisList', variables],
      fetcher<GetBasicChassisListQuery, GetBasicChassisListQueryVariables>(GetBasicChassisListDocument, variables),
      options
    )};

export const GetChassisInfoDocument = `
    query GetChassisInfo($id: MongoID!) {
  chassis(_id: $id) {
    _id
    reference
    type
    setupSheetStyle
  }
}
    `;

export const useGetChassisInfoQuery = <
      TData = GetChassisInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisInfoQueryVariables,
      options?: UseQueryOptions<GetChassisInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisInfoQuery, TError, TData>(
      ['GetChassisInfo', variables],
      fetcher<GetChassisInfoQuery, GetChassisInfoQueryVariables>(GetChassisInfoDocument, variables),
      options
    )};

export const GetBasicContestantsListDocument = `
    query GetBasicContestantsList {
  contestants(perPage: 2147483647, sort: STARTNUMBER_ASC) {
    items {
      _id
      startNumber
      teamID
      team {
        _id
        name
      }
      class
      season {
        _id
        name
      }
    }
  }
}
    `;

export const useGetBasicContestantsListQuery = <
      TData = GetBasicContestantsListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBasicContestantsListQueryVariables,
      options?: UseQueryOptions<GetBasicContestantsListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicContestantsListQuery, TError, TData>(
      variables === undefined ? ['GetBasicContestantsList'] : ['GetBasicContestantsList', variables],
      fetcher<GetBasicContestantsListQuery, GetBasicContestantsListQueryVariables>(GetBasicContestantsListDocument, variables),
      options
    )};

export const GetContestantsWithIDsDocument = `
    query GetContestantsWithIDs($contestantID: [MongoID]) {
  contestants(
    filter: {_operators: {_id: {in: $contestantID}}}
    perPage: 1000
    sort: STARTNUMBER_ASC
  ) {
    items {
      _id
      class
      startNumber
      driverIDs
      drivers {
        _id
        acronym
      }
      hidden
    }
  }
}
    `;

export const useGetContestantsWithIDsQuery = <
      TData = GetContestantsWithIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetContestantsWithIDsQueryVariables,
      options?: UseQueryOptions<GetContestantsWithIDsQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantsWithIDsQuery, TError, TData>(
      variables === undefined ? ['GetContestantsWithIDs'] : ['GetContestantsWithIDs', variables],
      fetcher<GetContestantsWithIDsQuery, GetContestantsWithIDsQueryVariables>(GetContestantsWithIDsDocument, variables),
      options
    )};

export const GetContestantInfoDocument = `
    query GetContestantInfo($id: MongoID!) {
  contestant(_id: $id) {
    _id
    ...ContestantVars
  }
}
    ${ContestantVarsFragmentDoc}`;

export const useGetContestantInfoQuery = <
      TData = GetContestantInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetContestantInfoQueryVariables,
      options?: UseQueryOptions<GetContestantInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantInfoQuery, TError, TData>(
      ['GetContestantInfo', variables],
      fetcher<GetContestantInfoQuery, GetContestantInfoQueryVariables>(GetContestantInfoDocument, variables),
      options
    )};

export const GetContestantDriversDocument = `
    query GetContestantDrivers($id: MongoID!) {
  contestant(_id: $id) {
    _id
    drivers {
      _id
      acronym
      displayColor
      name
    }
  }
}
    `;

export const useGetContestantDriversQuery = <
      TData = GetContestantDriversQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetContestantDriversQueryVariables,
      options?: UseQueryOptions<GetContestantDriversQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantDriversQuery, TError, TData>(
      ['GetContestantDrivers', variables],
      fetcher<GetContestantDriversQuery, GetContestantDriversQueryVariables>(GetContestantDriversDocument, variables),
      options
    )};

export const GetContestantTyresDocument = `
    query GetContestantTyres($id: MongoID!) {
  contestant(_id: $id) {
    _id
    tyres {
      _id
      ...TyreVars
    }
  }
}
    ${TyreVarsFragmentDoc}`;

export const useGetContestantTyresQuery = <
      TData = GetContestantTyresQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetContestantTyresQueryVariables,
      options?: UseQueryOptions<GetContestantTyresQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantTyresQuery, TError, TData>(
      ['GetContestantTyres', variables],
      fetcher<GetContestantTyresQuery, GetContestantTyresQueryVariables>(GetContestantTyresDocument, variables),
      options
    )};

export const GetContestantListDocument = `
    query GetContestantList($ids: [MongoID]!) {
  contestants(
    perPage: 100000
    filter: {_operators: {_id: {in: $ids}}}
    sort: STARTNUMBER_ASC
  ) {
    items {
      _id
      ...BasicContestantVars
    }
  }
}
    ${BasicContestantVarsFragmentDoc}`;

export const useGetContestantListQuery = <
      TData = GetContestantListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetContestantListQueryVariables,
      options?: UseQueryOptions<GetContestantListQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantListQuery, TError, TData>(
      ['GetContestantList', variables],
      fetcher<GetContestantListQuery, GetContestantListQueryVariables>(GetContestantListDocument, variables),
      options
    )};

export const GetContestantTyreSetsDocument = `
    query GetContestantTyreSets($id: MongoID!) {
  contestant(_id: $id) {
    _id
    tyreSets {
      _id
      ...tyreSetVars
    }
  }
}
    ${TyreSetVarsFragmentDoc}`;

export const useGetContestantTyreSetsQuery = <
      TData = GetContestantTyreSetsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetContestantTyreSetsQueryVariables,
      options?: UseQueryOptions<GetContestantTyreSetsQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantTyreSetsQuery, TError, TData>(
      ['GetContestantTyreSets', variables],
      fetcher<GetContestantTyreSetsQuery, GetContestantTyreSetsQueryVariables>(GetContestantTyreSetsDocument, variables),
      options
    )};

export const GetContestantColorsDocument = `
    query GetContestantColors($contestantIDs: [MongoID]) {
  contestants(
    filter: {_operators: {_id: {in: $contestantIDs}}}
    perPage: 1000
    sort: STARTNUMBER_ASC
  ) {
    items {
      _id
      startNumber
      color
      season {
        _id
        name
      }
    }
  }
}
    `;

export const useGetContestantColorsQuery = <
      TData = GetContestantColorsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetContestantColorsQueryVariables,
      options?: UseQueryOptions<GetContestantColorsQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantColorsQuery, TError, TData>(
      variables === undefined ? ['GetContestantColors'] : ['GetContestantColors', variables],
      fetcher<GetContestantColorsQuery, GetContestantColorsQueryVariables>(GetContestantColorsDocument, variables),
      options
    )};

export const GetEventDocument = `
    query GetEvent($id: MongoID!) {
  event(_id: $id) {
    _id
    customSimulationPayload
    name
    trackLayoutIDs
    seasonID
    season {
      _id
      name
      raceSeries {
        _id
        name
      }
    }
    contestants {
      _id
      driverIDs
      tyreIDs
    }
    DFuel
    participantIDs
    NEventSeason
    tEventStart
    tEventEnd
    tLapAverage
    track {
      _id
      timeZone
    }
    ...EventTrackLayoutConsumptionVars
    trackLayouts {
      _id
      name
      lapLengthOfficial
      lapLengthCarData
      NSectorsTiming
      energyRequired {
        ...AllRunEnergyVars
      }
      fuelRequired {
        ...AllRunEnergyVars
      }
      SoCRequired {
        ...AllRunEnergyVars
      }
      trackID
      track {
        _id
        name
        timeZone
      }
    }
    eventType
    sessions {
      _id
      name
    }
    tyreDefaultsFL {
      ...tyreDefaultFragment
    }
    tyreDefaultsFR {
      ...tyreDefaultFragment
    }
    tyreDefaultsRL {
      ...tyreDefaultFragment
    }
    tyreDefaultsRR {
      ...tyreDefaultFragment
    }
    tyreDefaultsWetFL {
      ...tyreDefaultFragment
    }
    tyreDefaultsWetFR {
      ...tyreDefaultFragment
    }
    tyreDefaultsWetRL {
      ...tyreDefaultFragment
    }
    tyreDefaultsWetRR {
      ...tyreDefaultFragment
    }
    fuelRequired {
      ...AllRunEnergyVars
    }
    SoCRequired {
      ...AllRunEnergyVars
    }
    referenceLaptimes {
      ATTACK
      COOL
      FCY
      IN
      OUT
      OUTIN
      PITLANE
      PREP
      PUSH
      QUALI
      SAFETYCAR
      SHAKEDOWN
      SLOW
      TARGET
      TOGRID
      TOPADDOCK
      TOPITS
      UNFINISHED
      trackLayoutID
    }
  }
}
    ${EventTrackLayoutConsumptionVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${TyreDefaultFragmentFragmentDoc}`;

export const useGetEventQuery = <
      TData = GetEventQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventQueryVariables,
      options?: UseQueryOptions<GetEventQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventQuery, TError, TData>(
      ['GetEvent', variables],
      fetcher<GetEventQuery, GetEventQueryVariables>(GetEventDocument, variables),
      options
    )};

export const GetEventNameDocument = `
    query GetEventName($id: MongoID!) {
  event(_id: $id) {
    _id
    name
  }
}
    `;

export const useGetEventNameQuery = <
      TData = GetEventNameQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventNameQueryVariables,
      options?: UseQueryOptions<GetEventNameQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventNameQuery, TError, TData>(
      ['GetEventName', variables],
      fetcher<GetEventNameQuery, GetEventNameQueryVariables>(GetEventNameDocument, variables),
      options
    )};

export const GetBasicEventListDocument = `
    query GetBasicEventList {
  events(perPage: 1000, sort: TEVENTSTART_ASC) {
    items {
      _id
      name
      sessionIDs
      tEventStart
    }
  }
}
    `;

export const useGetBasicEventListQuery = <
      TData = GetBasicEventListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBasicEventListQueryVariables,
      options?: UseQueryOptions<GetBasicEventListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicEventListQuery, TError, TData>(
      variables === undefined ? ['GetBasicEventList'] : ['GetBasicEventList', variables],
      fetcher<GetBasicEventListQuery, GetBasicEventListQueryVariables>(GetBasicEventListDocument, variables),
      options
    )};

export const GetSessionsFromEventDocument = `
    query GetSessionsFromEvent($eventID: MongoID) {
  sessions(filter: {eventID: $eventID}, sort: TSESSIONSTART_ASC, perPage: 200) {
    items {
      _id
      name
      shortName
      sessionType
      tSessionStart
      tSessionEnd
    }
  }
}
    `;

export const useGetSessionsFromEventQuery = <
      TData = GetSessionsFromEventQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSessionsFromEventQueryVariables,
      options?: UseQueryOptions<GetSessionsFromEventQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionsFromEventQuery, TError, TData>(
      variables === undefined ? ['GetSessionsFromEvent'] : ['GetSessionsFromEvent', variables],
      fetcher<GetSessionsFromEventQuery, GetSessionsFromEventQueryVariables>(GetSessionsFromEventDocument, variables),
      options
    )};

export const GetBasicEventListWithMetadataDocument = `
    query GetBasicEventListWithMetadata {
  events(sort: TEVENTSTART_ASC, perPage: 10000) {
    items {
      _id
      ...EventBaseVars
    }
  }
}
    ${EventBaseVarsFragmentDoc}`;

export const useGetBasicEventListWithMetadataQuery = <
      TData = GetBasicEventListWithMetadataQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBasicEventListWithMetadataQueryVariables,
      options?: UseQueryOptions<GetBasicEventListWithMetadataQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicEventListWithMetadataQuery, TError, TData>(
      variables === undefined ? ['GetBasicEventListWithMetadata'] : ['GetBasicEventListWithMetadata', variables],
      fetcher<GetBasicEventListWithMetadataQuery, GetBasicEventListWithMetadataQueryVariables>(GetBasicEventListWithMetadataDocument, variables),
      options
    )};

export const GetFullBasicEventListWithMetadataDocument = `
    query GetFullBasicEventListWithMetadata {
  events(sort: TEVENTSTART_ASC, perPage: 2147483647) {
    items {
      _id
      ...EventBaseVars
    }
  }
}
    ${EventBaseVarsFragmentDoc}`;

export const useGetFullBasicEventListWithMetadataQuery = <
      TData = GetFullBasicEventListWithMetadataQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetFullBasicEventListWithMetadataQueryVariables,
      options?: UseQueryOptions<GetFullBasicEventListWithMetadataQuery, TError, TData>
    ) => {
    
    return useQuery<GetFullBasicEventListWithMetadataQuery, TError, TData>(
      variables === undefined ? ['GetFullBasicEventListWithMetadata'] : ['GetFullBasicEventListWithMetadata', variables],
      fetcher<GetFullBasicEventListWithMetadataQuery, GetFullBasicEventListWithMetadataQueryVariables>(GetFullBasicEventListWithMetadataDocument, variables),
      options
    )};

export const GetEventsFromSeasonDocument = `
    query GetEventsFromSeason($seasonID: MongoID) {
  events(filter: {seasonID: $seasonID}, sort: TEVENTSTART_ASC, perPage: 200) {
    items {
      _id
      name
      tEventEnd
    }
  }
}
    `;

export const useGetEventsFromSeasonQuery = <
      TData = GetEventsFromSeasonQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetEventsFromSeasonQueryVariables,
      options?: UseQueryOptions<GetEventsFromSeasonQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventsFromSeasonQuery, TError, TData>(
      variables === undefined ? ['GetEventsFromSeason'] : ['GetEventsFromSeason', variables],
      fetcher<GetEventsFromSeasonQuery, GetEventsFromSeasonQueryVariables>(GetEventsFromSeasonDocument, variables),
      options
    )};

export const DoEventSearchDocument = `
    query DoEventSearch($search: RegExpAsString) {
  events(filter: {_operators: {name: {regex: $search}}}) {
    items {
      _id
      name
    }
  }
}
    `;

export const useDoEventSearchQuery = <
      TData = DoEventSearchQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: DoEventSearchQueryVariables,
      options?: UseQueryOptions<DoEventSearchQuery, TError, TData>
    ) => {
    
    return useQuery<DoEventSearchQuery, TError, TData>(
      variables === undefined ? ['DoEventSearch'] : ['DoEventSearch', variables],
      fetcher<DoEventSearchQuery, DoEventSearchQueryVariables>(DoEventSearchDocument, variables),
      options
    )};

export const GetEventInfoDocument = `
    query GetEventInfo($id: MongoID!) {
  event(_id: $id) {
    _id
    name
    sessionIDs
    trackLayoutIDs
    consumptions {
      energyRequired {
        ...AllRunEnergyVars
      }
      fuelRequired {
        ...AllRunEnergyVars
      }
      SoCRequired {
        ...AllRunEnergyVars
      }
      trackLayout {
        _id
        ...TrackLayoutVars
      }
      trackLayoutID
    }
    sessions {
      _id
      name
      shortName
      tSessionStart
      tSessionEnd
    }
    trackID
    track {
      _id
      timeZone
    }
    trackLayouts {
      _id
      trackID
      name
      track {
        _id
        name
      }
    }
    season {
      _id
      name
      raceSeries {
        _id
        name
      }
    }
    fuelRequired {
      ...AllRunEnergyVars
    }
    SoCRequired {
      ...AllRunEnergyVars
    }
  }
}
    ${AllRunEnergyVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}`;

export const useGetEventInfoQuery = <
      TData = GetEventInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventInfoQueryVariables,
      options?: UseQueryOptions<GetEventInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventInfoQuery, TError, TData>(
      ['GetEventInfo', variables],
      fetcher<GetEventInfoQuery, GetEventInfoQueryVariables>(GetEventInfoDocument, variables),
      options
    )};

export const GetEventDataForReportLayoutEditorDocument = `
    query GetEventDataForReportLayoutEditor($id: MongoID!) {
  event(_id: $id) {
    _id
    name
    sessionIDs
    season {
      _id
      contestants {
        _id
        color
      }
    }
  }
}
    `;

export const useGetEventDataForReportLayoutEditorQuery = <
      TData = GetEventDataForReportLayoutEditorQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventDataForReportLayoutEditorQueryVariables,
      options?: UseQueryOptions<GetEventDataForReportLayoutEditorQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventDataForReportLayoutEditorQuery, TError, TData>(
      ['GetEventDataForReportLayoutEditor', variables],
      fetcher<GetEventDataForReportLayoutEditorQuery, GetEventDataForReportLayoutEditorQueryVariables>(GetEventDataForReportLayoutEditorDocument, variables),
      options
    )};

export const GetContestantTyreSetsAtEventDocument = `
    query GetContestantTyreSetsAtEvent($id: MongoID!) {
  event(_id: $id) {
    _id
    contestants {
      _id
      tyreSets {
        ...tyreSetVars
      }
      tyreSetIDs
    }
  }
}
    ${TyreSetVarsFragmentDoc}`;

export const useGetContestantTyreSetsAtEventQuery = <
      TData = GetContestantTyreSetsAtEventQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetContestantTyreSetsAtEventQueryVariables,
      options?: UseQueryOptions<GetContestantTyreSetsAtEventQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantTyreSetsAtEventQuery, TError, TData>(
      ['GetContestantTyreSetsAtEvent', variables],
      fetcher<GetContestantTyreSetsAtEventQuery, GetContestantTyreSetsAtEventQueryVariables>(GetContestantTyreSetsAtEventDocument, variables),
      options
    )};

export const GetContestantTyresAtEventsDocument = `
    query GetContestantTyresAtEvents($filter: FilterFindManyEventInput!) {
  events(filter: $filter) {
    items {
      _id
      name
      contestants {
        _id
        tyreIDs
        tyreSetIDs
      }
      sessionIDs
    }
  }
}
    `;

export const useGetContestantTyresAtEventsQuery = <
      TData = GetContestantTyresAtEventsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetContestantTyresAtEventsQueryVariables,
      options?: UseQueryOptions<GetContestantTyresAtEventsQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantTyresAtEventsQuery, TError, TData>(
      ['GetContestantTyresAtEvents', variables],
      fetcher<GetContestantTyresAtEventsQuery, GetContestantTyresAtEventsQueryVariables>(GetContestantTyresAtEventsDocument, variables),
      options
    )};

export const GetContestantTyresAtEventDocument = `
    query GetContestantTyresAtEvent($id: MongoID!) {
  event(_id: $id) {
    _id
    contestants {
      _id
      tyreIDs
    }
    tyreDefaultsFL {
      ...tyreDefaultFragment
    }
    tyreDefaultsFR {
      ...tyreDefaultFragment
    }
    tyreDefaultsRL {
      ...tyreDefaultFragment
    }
    tyreDefaultsRR {
      ...tyreDefaultFragment
    }
    tyreDefaultsWetFL {
      ...tyreDefaultFragment
    }
    tyreDefaultsWetFR {
      ...tyreDefaultFragment
    }
    tyreDefaultsWetRL {
      ...tyreDefaultFragment
    }
    tyreDefaultsWetRR {
      ...tyreDefaultFragment
    }
  }
}
    ${TyreDefaultFragmentFragmentDoc}`;

export const useGetContestantTyresAtEventQuery = <
      TData = GetContestantTyresAtEventQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetContestantTyresAtEventQueryVariables,
      options?: UseQueryOptions<GetContestantTyresAtEventQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantTyresAtEventQuery, TError, TData>(
      ['GetContestantTyresAtEvent', variables],
      fetcher<GetContestantTyresAtEventQuery, GetContestantTyresAtEventQueryVariables>(GetContestantTyresAtEventDocument, variables),
      options
    )};

export const GetEventContestantsDocument = `
    query GetEventContestants($id: MongoID!) {
  event(_id: $id) {
    _id
    contestants {
      _id
      class
      drivers {
        name
        _id
      }
    }
    season {
      _id
      contestantIDs
      contestants {
        _id
        startNumber
      }
    }
  }
}
    `;

export const useGetEventContestantsQuery = <
      TData = GetEventContestantsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventContestantsQueryVariables,
      options?: UseQueryOptions<GetEventContestantsQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventContestantsQuery, TError, TData>(
      ['GetEventContestants', variables],
      fetcher<GetEventContestantsQuery, GetEventContestantsQueryVariables>(GetEventContestantsDocument, variables),
      options
    )};

export const GetSessionIDsforEventsDocument = `
    query GetSessionIDsforEvents($eventIDs: [MongoID!]!) {
  sessions(perPage: 10000, filter: {_operators: {eventID: {in: $eventIDs}}}) {
    items {
      _id
      name
      shortName
      event {
        name
      }
    }
  }
}
    `;

export const useGetSessionIDsforEventsQuery = <
      TData = GetSessionIDsforEventsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSessionIDsforEventsQueryVariables,
      options?: UseQueryOptions<GetSessionIDsforEventsQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionIDsforEventsQuery, TError, TData>(
      ['GetSessionIDsforEvents', variables],
      fetcher<GetSessionIDsforEventsQuery, GetSessionIDsforEventsQueryVariables>(GetSessionIDsforEventsDocument, variables),
      options
    )};

export const GetEventTrackLayoutWarningsDocument = `
    query GetEventTrackLayoutWarnings($id: MongoID!) {
  event(_id: $id) {
    _id
    trackLayoutIDs
    trackLayouts {
      mapTrackXy {
        warnings
      }
      mapTrackLatLon {
        warnings
      }
      mapTrackLatLonCsv
      mapTrackXyCsv
    }
  }
}
    `;

export const useGetEventTrackLayoutWarningsQuery = <
      TData = GetEventTrackLayoutWarningsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetEventTrackLayoutWarningsQueryVariables,
      options?: UseQueryOptions<GetEventTrackLayoutWarningsQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventTrackLayoutWarningsQuery, TError, TData>(
      ['GetEventTrackLayoutWarnings', variables],
      fetcher<GetEventTrackLayoutWarningsQuery, GetEventTrackLayoutWarningsQueryVariables>(GetEventTrackLayoutWarningsDocument, variables),
      options
    )};

export const GetJobDocument = `
    query GetJob($id: MongoID!) {
  job(_id: $id) {
    _id
    ...JobVars
  }
}
    ${JobVarsFragmentDoc}
${CommentVarsFragmentDoc}
${SubTaskVarsFragmentDoc}`;

export const useGetJobQuery = <
      TData = GetJobQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetJobQueryVariables,
      options?: UseQueryOptions<GetJobQuery, TError, TData>
    ) => {
    
    return useQuery<GetJobQuery, TError, TData>(
      ['GetJob', variables],
      fetcher<GetJobQuery, GetJobQueryVariables>(GetJobDocument, variables),
      options
    )};

export const GetMyJobsDocument = `
    query GetMyJobs($userId: MongoID!) {
  jobs(filter: {_operators: {assigneeIDs: {in: [$userId]}}}) {
    items {
      _id
      ...JobVars
    }
  }
}
    ${JobVarsFragmentDoc}
${CommentVarsFragmentDoc}
${SubTaskVarsFragmentDoc}`;

export const useGetMyJobsQuery = <
      TData = GetMyJobsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetMyJobsQueryVariables,
      options?: UseQueryOptions<GetMyJobsQuery, TError, TData>
    ) => {
    
    return useQuery<GetMyJobsQuery, TError, TData>(
      ['GetMyJobs', variables],
      fetcher<GetMyJobsQuery, GetMyJobsQueryVariables>(GetMyJobsDocument, variables),
      options
    )};

export const GetAllJobsByIDsDocument = `
    query GetAllJobsByIDs($jobIDs: [MongoID!]) {
  jobs(perPage: 65535, filter: {_operators: {_id: {in: $jobIDs}}}) {
    items {
      _id
      ...JobVars
    }
  }
}
    ${JobVarsFragmentDoc}
${CommentVarsFragmentDoc}
${SubTaskVarsFragmentDoc}`;

export const useGetAllJobsByIDsQuery = <
      TData = GetAllJobsByIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllJobsByIDsQueryVariables,
      options?: UseQueryOptions<GetAllJobsByIDsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllJobsByIDsQuery, TError, TData>(
      variables === undefined ? ['GetAllJobsByIDs'] : ['GetAllJobsByIDs', variables],
      fetcher<GetAllJobsByIDsQuery, GetAllJobsByIDsQueryVariables>(GetAllJobsByIDsDocument, variables),
      options
    )};

export const GetJobsForRunSheetDocument = `
    query GetJobsForRunSheet($runSheetID: MongoID!) {
  jobs(perPage: 1000, filter: {runSheetID: $runSheetID}) {
    items {
      _id
      ...JobVars
    }
  }
}
    ${JobVarsFragmentDoc}
${CommentVarsFragmentDoc}
${SubTaskVarsFragmentDoc}`;

export const useGetJobsForRunSheetQuery = <
      TData = GetJobsForRunSheetQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetJobsForRunSheetQueryVariables,
      options?: UseQueryOptions<GetJobsForRunSheetQuery, TError, TData>
    ) => {
    
    return useQuery<GetJobsForRunSheetQuery, TError, TData>(
      ['GetJobsForRunSheet', variables],
      fetcher<GetJobsForRunSheetQuery, GetJobsForRunSheetQueryVariables>(GetJobsForRunSheetDocument, variables),
      options
    )};

export const GetTemplateJobListsInfoDocument = `
    query GetTemplateJobListsInfo {
  templateJobLists(perPage: 2000, sort: INDEX_ASC) {
    items {
      _id
      title
    }
  }
}
    `;

export const useGetTemplateJobListsInfoQuery = <
      TData = GetTemplateJobListsInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTemplateJobListsInfoQueryVariables,
      options?: UseQueryOptions<GetTemplateJobListsInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetTemplateJobListsInfoQuery, TError, TData>(
      variables === undefined ? ['GetTemplateJobListsInfo'] : ['GetTemplateJobListsInfo', variables],
      fetcher<GetTemplateJobListsInfoQuery, GetTemplateJobListsInfoQueryVariables>(GetTemplateJobListsInfoDocument, variables),
      options
    )};

export const GetTemplateJobListsDocument = `
    query GetTemplateJobLists {
  templateJobLists(perPage: 2000, sort: INDEX_ASC) {
    items {
      _id
      ...JobListTemplateVars
    }
  }
}
    ${JobListTemplateVarsFragmentDoc}
${JobListTemplateJobVarsFragmentDoc}`;

export const useGetTemplateJobListsQuery = <
      TData = GetTemplateJobListsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTemplateJobListsQueryVariables,
      options?: UseQueryOptions<GetTemplateJobListsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTemplateJobListsQuery, TError, TData>(
      variables === undefined ? ['GetTemplateJobLists'] : ['GetTemplateJobLists', variables],
      fetcher<GetTemplateJobListsQuery, GetTemplateJobListsQueryVariables>(GetTemplateJobListsDocument, variables),
      options
    )};

export const GetTemplateJobListByIdDocument = `
    query GetTemplateJobListByID($id: MongoID!) {
  templateJobList(_id: $id) {
    _id
    ...JobListTemplateVars
  }
}
    ${JobListTemplateVarsFragmentDoc}
${JobListTemplateJobVarsFragmentDoc}`;

export const useGetTemplateJobListByIdQuery = <
      TData = GetTemplateJobListByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTemplateJobListByIdQueryVariables,
      options?: UseQueryOptions<GetTemplateJobListByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetTemplateJobListByIdQuery, TError, TData>(
      ['GetTemplateJobListByID', variables],
      fetcher<GetTemplateJobListByIdQuery, GetTemplateJobListByIdQueryVariables>(GetTemplateJobListByIdDocument, variables),
      options
    )};

export const GetAvailableSetupSheetStylesDocument = `
    query GetAvailableSetupSheetStyles {
  license {
    options {
      setupSheetStyles
    }
  }
}
    `;

export const useGetAvailableSetupSheetStylesQuery = <
      TData = GetAvailableSetupSheetStylesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAvailableSetupSheetStylesQueryVariables,
      options?: UseQueryOptions<GetAvailableSetupSheetStylesQuery, TError, TData>
    ) => {
    
    return useQuery<GetAvailableSetupSheetStylesQuery, TError, TData>(
      variables === undefined ? ['GetAvailableSetupSheetStyles'] : ['GetAvailableSetupSheetStyles', variables],
      fetcher<GetAvailableSetupSheetStylesQuery, GetAvailableSetupSheetStylesQueryVariables>(GetAvailableSetupSheetStylesDocument, variables),
      options
    )};

export const LicenseExpiryDocument = `
    query LicenseExpiry {
  license {
    expired
    expirationDate
  }
}
    `;

export const useLicenseExpiryQuery = <
      TData = LicenseExpiryQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: LicenseExpiryQueryVariables,
      options?: UseQueryOptions<LicenseExpiryQuery, TError, TData>
    ) => {
    
    return useQuery<LicenseExpiryQuery, TError, TData>(
      variables === undefined ? ['LicenseExpiry'] : ['LicenseExpiry', variables],
      fetcher<LicenseExpiryQuery, LicenseExpiryQueryVariables>(LicenseExpiryDocument, variables),
      options
    )};

export const GetManufacturerByIdDocument = `
    query GetManufacturerById($id: MongoID!) {
  manufacturer(_id: $id) {
    _id
    name
  }
}
    `;

export const useGetManufacturerByIdQuery = <
      TData = GetManufacturerByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetManufacturerByIdQueryVariables,
      options?: UseQueryOptions<GetManufacturerByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetManufacturerByIdQuery, TError, TData>(
      ['GetManufacturerById', variables],
      fetcher<GetManufacturerByIdQuery, GetManufacturerByIdQueryVariables>(GetManufacturerByIdDocument, variables),
      options
    )};

export const GetAllManufacturersDocument = `
    query GetAllManufacturers {
  manufacturers(perPage: 2000) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetAllManufacturersQuery = <
      TData = GetAllManufacturersQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllManufacturersQueryVariables,
      options?: UseQueryOptions<GetAllManufacturersQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllManufacturersQuery, TError, TData>(
      variables === undefined ? ['GetAllManufacturers'] : ['GetAllManufacturers', variables],
      fetcher<GetAllManufacturersQuery, GetAllManufacturersQueryVariables>(GetAllManufacturersDocument, variables),
      options
    )};

export const GetOneTimingWeatherServiceLogsDocument = `
    query GetOneTimingWeatherServiceLogs($numLines: Int) {
  oneTimingWeatherServiceLogs(numLines: $numLines)
}
    `;

export const useGetOneTimingWeatherServiceLogsQuery = <
      TData = GetOneTimingWeatherServiceLogsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetOneTimingWeatherServiceLogsQueryVariables,
      options?: UseQueryOptions<GetOneTimingWeatherServiceLogsQuery, TError, TData>
    ) => {
    
    return useQuery<GetOneTimingWeatherServiceLogsQuery, TError, TData>(
      variables === undefined ? ['GetOneTimingWeatherServiceLogs'] : ['GetOneTimingWeatherServiceLogs', variables],
      fetcher<GetOneTimingWeatherServiceLogsQuery, GetOneTimingWeatherServiceLogsQueryVariables>(GetOneTimingWeatherServiceLogsDocument, variables),
      options
    )};

export const GetOneTimingWeatherServiceStatusDocument = `
    query GetOneTimingWeatherServiceStatus {
  oneTimingWeatherServiceStatus
}
    `;

export const useGetOneTimingWeatherServiceStatusQuery = <
      TData = GetOneTimingWeatherServiceStatusQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetOneTimingWeatherServiceStatusQueryVariables,
      options?: UseQueryOptions<GetOneTimingWeatherServiceStatusQuery, TError, TData>
    ) => {
    
    return useQuery<GetOneTimingWeatherServiceStatusQuery, TError, TData>(
      variables === undefined ? ['GetOneTimingWeatherServiceStatus'] : ['GetOneTimingWeatherServiceStatus', variables],
      fetcher<GetOneTimingWeatherServiceStatusQuery, GetOneTimingWeatherServiceStatusQueryVariables>(GetOneTimingWeatherServiceStatusDocument, variables),
      options
    )};

export const DoOneTimingWeatherServiceConfigSearchDocument = `
    query DoOneTimingWeatherServiceConfigSearch($search: RegExpAsString) {
  oneTimingWeatherServiceConfigs(filter: {_operators: {name: {regex: $search}}}) {
    items {
      _id
      name
      timingURL
      timingPort
      updateInterval
      longitude
      latitude
      writeData
      logLevel
      eventIDs
    }
  }
}
    `;

export const useDoOneTimingWeatherServiceConfigSearchQuery = <
      TData = DoOneTimingWeatherServiceConfigSearchQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: DoOneTimingWeatherServiceConfigSearchQueryVariables,
      options?: UseQueryOptions<DoOneTimingWeatherServiceConfigSearchQuery, TError, TData>
    ) => {
    
    return useQuery<DoOneTimingWeatherServiceConfigSearchQuery, TError, TData>(
      variables === undefined ? ['DoOneTimingWeatherServiceConfigSearch'] : ['DoOneTimingWeatherServiceConfigSearch', variables],
      fetcher<DoOneTimingWeatherServiceConfigSearchQuery, DoOneTimingWeatherServiceConfigSearchQueryVariables>(DoOneTimingWeatherServiceConfigSearchDocument, variables),
      options
    )};

export const GetAllPartsDocument = `
    query GetAllParts {
  parts(perPage: 10000) {
    items {
      __typename
      manufacturerPartID
      rootSpecificationID
      specificationID
      specification {
        _id
        chassisSpecID
      }
      reference
      properties
      _id
      concurrentUseAllowed
      currentlyInUse
      notes
      tagIDs
      trackingHistoryIDs
      trackingHistory {
        _id
      }
    }
  }
}
    `;

export const useGetAllPartsQuery = <
      TData = GetAllPartsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllPartsQueryVariables,
      options?: UseQueryOptions<GetAllPartsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllPartsQuery, TError, TData>(
      variables === undefined ? ['GetAllParts'] : ['GetAllParts', variables],
      fetcher<GetAllPartsQuery, GetAllPartsQueryVariables>(GetAllPartsDocument, variables),
      options
    )};

export const GetPartByIdDocument = `
    query GetPartById($id: MongoID!) {
  part(_id: $id) {
    _id
    concurrentUseAllowed
    currentlyInUse
    description
    manufacturerPartID
    notes
    partNumber
    properties
    reference
    rootSpecificationID
    specification {
      trackingItemIDs
    }
    specificationID
    tagIDs
    tags {
      ...AllTagVars
    }
    trackingHistoryIDs
    trackingHistory {
      ...AllTrackingHistoryVars
    }
  }
}
    ${AllTagVarsFragmentDoc}
${AllTrackingHistoryVarsFragmentDoc}`;

export const useGetPartByIdQuery = <
      TData = GetPartByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartByIdQueryVariables,
      options?: UseQueryOptions<GetPartByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartByIdQuery, TError, TData>(
      ['GetPartById', variables],
      fetcher<GetPartByIdQuery, GetPartByIdQueryVariables>(GetPartByIdDocument, variables),
      options
    )};

export const GetPersonNameDocument = `
    query GetPersonName($id: MongoID!) {
  person(_id: $id) {
    _id
    name
  }
}
    `;

export const useGetPersonNameQuery = <
      TData = GetPersonNameQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPersonNameQueryVariables,
      options?: UseQueryOptions<GetPersonNameQuery, TError, TData>
    ) => {
    
    return useQuery<GetPersonNameQuery, TError, TData>(
      ['GetPersonName', variables],
      fetcher<GetPersonNameQuery, GetPersonNameQueryVariables>(GetPersonNameDocument, variables),
      options
    )};

export const GetPersonViewConfigDocument = `
    query GetPersonViewConfig($id: MongoID!) {
  person(_id: $id) {
    _id
    username
    viewConfig {
      showRunSheetsAsTabs
      yellowTyreMileageThreshold
      redTyreMileageThreshold
      highlightTyreMileages
    }
  }
}
    `;

export const useGetPersonViewConfigQuery = <
      TData = GetPersonViewConfigQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPersonViewConfigQueryVariables,
      options?: UseQueryOptions<GetPersonViewConfigQuery, TError, TData>
    ) => {
    
    return useQuery<GetPersonViewConfigQuery, TError, TData>(
      ['GetPersonViewConfig', variables],
      fetcher<GetPersonViewConfigQuery, GetPersonViewConfigQueryVariables>(GetPersonViewConfigDocument, variables),
      options
    )};

export const GetPersonBehaviourConfigDocument = `
    query GetPersonBehaviourConfig($id: MongoID!) {
  person(_id: $id) {
    _id
    username
    behaviour {
      carryOverJobList
    }
  }
}
    `;

export const useGetPersonBehaviourConfigQuery = <
      TData = GetPersonBehaviourConfigQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPersonBehaviourConfigQueryVariables,
      options?: UseQueryOptions<GetPersonBehaviourConfigQuery, TError, TData>
    ) => {
    
    return useQuery<GetPersonBehaviourConfigQuery, TError, TData>(
      ['GetPersonBehaviourConfig', variables],
      fetcher<GetPersonBehaviourConfigQuery, GetPersonBehaviourConfigQueryVariables>(GetPersonBehaviourConfigDocument, variables),
      options
    )};

export const GetPersonUserSimulationSettingsDocument = `
    query GetPersonUserSimulationSettings($id: MongoID!) {
  person(_id: $id) {
    _id
    username
    userSimulationSettings {
      TAmbientPreferred
      pAmbientPreferred
      rHumidityPreferred
      runSimSlotColours
      setupSimSlotColours
      userDefinedSetupIDs
    }
  }
}
    `;

export const useGetPersonUserSimulationSettingsQuery = <
      TData = GetPersonUserSimulationSettingsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPersonUserSimulationSettingsQueryVariables,
      options?: UseQueryOptions<GetPersonUserSimulationSettingsQuery, TError, TData>
    ) => {
    
    return useQuery<GetPersonUserSimulationSettingsQuery, TError, TData>(
      ['GetPersonUserSimulationSettings', variables],
      fetcher<GetPersonUserSimulationSettingsQuery, GetPersonUserSimulationSettingsQueryVariables>(GetPersonUserSimulationSettingsDocument, variables),
      options
    )};

export const GetPersonInfoDocument = `
    query GetPersonInfo($id: MongoID!) {
  person(_id: $id) {
    _id
    acronym
    behaviour {
      carryOverJobList
      showMyJobsOnRunSheetDefault
    }
    canopyCredentials {
      clientID
      clientSecret
      username
      password
      userID
      tenantID
    }
    defaultRunSheetCompareStyleID
    defaultRunSheetStyleID
    defaultTyreReferenceTemperature
    defaultTyreSetNameFormat
    displayColor
    editableContestantIDs
    email
    emailNotificationConfig {
      jobAssigned
      jobCommentedOn
      jobStatusChanged
    }
    hideKPIs
    isActive
    isTimeTracker
    isTimeTrackerAdmin
    lapSequenceTemplateIDs
    name
    role
    teamID
    timeTrackerApprovalByPersonID
    username
    userSetups {
      _id
      title
    }
    viewConfig {
      showRunSheetsAsTabs
      yellowTyreMileageThreshold
      redTyreMileageThreshold
      highlightTyreMileages
    }
    visibleContestantIDs
    visibleEventIDs
  }
}
    `;

export const useGetPersonInfoQuery = <
      TData = GetPersonInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPersonInfoQueryVariables,
      options?: UseQueryOptions<GetPersonInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetPersonInfoQuery, TError, TData>(
      ['GetPersonInfo', variables],
      fetcher<GetPersonInfoQuery, GetPersonInfoQueryVariables>(GetPersonInfoDocument, variables),
      options
    )};

export const GetDriverNameDocument = `
    query GetDriverName($id: MongoID!) {
  person(_id: $id) {
    _id
    acronym
    name
  }
}
    `;

export const useGetDriverNameQuery = <
      TData = GetDriverNameQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetDriverNameQueryVariables,
      options?: UseQueryOptions<GetDriverNameQuery, TError, TData>
    ) => {
    
    return useQuery<GetDriverNameQuery, TError, TData>(
      ['GetDriverName', variables],
      fetcher<GetDriverNameQuery, GetDriverNameQueryVariables>(GetDriverNameDocument, variables),
      options
    )};

export const GetDriversWithIDsDocument = `
    query GetDriversWithIDs($driverID: [MongoID]) {
  people(filter: {_operators: {_id: {in: $driverID}}}) {
    items {
      _id
      acronym
      name
    }
  }
}
    `;

export const useGetDriversWithIDsQuery = <
      TData = GetDriversWithIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetDriversWithIDsQueryVariables,
      options?: UseQueryOptions<GetDriversWithIDsQuery, TError, TData>
    ) => {
    
    return useQuery<GetDriversWithIDsQuery, TError, TData>(
      variables === undefined ? ['GetDriversWithIDs'] : ['GetDriversWithIDs', variables],
      fetcher<GetDriversWithIDsQuery, GetDriversWithIDsQueryVariables>(GetDriversWithIDsDocument, variables),
      options
    )};

export const GetEngineersDocument = `
    query GetEngineers {
  people(
    filter: {OR: [{role: CAR_ENGINEER}, {role: CHIEF_ENGINEER}, {role: ADMIN}]}
    perPage: 50
    sort: NAME_ASC
  ) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetEngineersQuery = <
      TData = GetEngineersQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetEngineersQueryVariables,
      options?: UseQueryOptions<GetEngineersQuery, TError, TData>
    ) => {
    
    return useQuery<GetEngineersQuery, TError, TData>(
      variables === undefined ? ['GetEngineers'] : ['GetEngineers', variables],
      fetcher<GetEngineersQuery, GetEngineersQueryVariables>(GetEngineersDocument, variables),
      options
    )};

export const GetTimeTrackerAdminsDocument = `
    query GetTimeTrackerAdmins {
  people(filter: {isTimeTrackerAdmin: true}) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetTimeTrackerAdminsQuery = <
      TData = GetTimeTrackerAdminsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTimeTrackerAdminsQueryVariables,
      options?: UseQueryOptions<GetTimeTrackerAdminsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTimeTrackerAdminsQuery, TError, TData>(
      variables === undefined ? ['GetTimeTrackerAdmins'] : ['GetTimeTrackerAdmins', variables],
      fetcher<GetTimeTrackerAdminsQuery, GetTimeTrackerAdminsQueryVariables>(GetTimeTrackerAdminsDocument, variables),
      options
    )};

export const GetPersonsWithTimeTrackingApprovedByDocument = `
    query GetPersonsWithTimeTrackingApprovedBy($approverID: MongoID!) {
  people(filter: {timeTrackerApprovalByPersonID: $approverID}) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetPersonsWithTimeTrackingApprovedByQuery = <
      TData = GetPersonsWithTimeTrackingApprovedByQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPersonsWithTimeTrackingApprovedByQueryVariables,
      options?: UseQueryOptions<GetPersonsWithTimeTrackingApprovedByQuery, TError, TData>
    ) => {
    
    return useQuery<GetPersonsWithTimeTrackingApprovedByQuery, TError, TData>(
      ['GetPersonsWithTimeTrackingApprovedBy', variables],
      fetcher<GetPersonsWithTimeTrackingApprovedByQuery, GetPersonsWithTimeTrackingApprovedByQueryVariables>(GetPersonsWithTimeTrackingApprovedByDocument, variables),
      options
    )};

export const GetTimeSheetEntriesOfTimeApproveesForTimePeriodDocument = `
    query GetTimeSheetEntriesOfTimeApproveesForTimePeriod($id: MongoID!, $tStartAfter: Date!, $tStartBefore: Date!) {
  person(_id: $id) {
    _id
    timeApprovees {
      _id
      name
      timeSheetEntries(tStartAfter: $tStartAfter, tStartBefore: $tStartBefore) {
        ...TimeSheetEntryOfTimeApproveesForTimePeriod
      }
    }
  }
}
    ${TimeSheetEntryOfTimeApproveesForTimePeriodFragmentDoc}`;

export const useGetTimeSheetEntriesOfTimeApproveesForTimePeriodQuery = <
      TData = GetTimeSheetEntriesOfTimeApproveesForTimePeriodQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTimeSheetEntriesOfTimeApproveesForTimePeriodQueryVariables,
      options?: UseQueryOptions<GetTimeSheetEntriesOfTimeApproveesForTimePeriodQuery, TError, TData>
    ) => {
    
    return useQuery<GetTimeSheetEntriesOfTimeApproveesForTimePeriodQuery, TError, TData>(
      ['GetTimeSheetEntriesOfTimeApproveesForTimePeriod', variables],
      fetcher<GetTimeSheetEntriesOfTimeApproveesForTimePeriodQuery, GetTimeSheetEntriesOfTimeApproveesForTimePeriodQueryVariables>(GetTimeSheetEntriesOfTimeApproveesForTimePeriodDocument, variables),
      options
    )};

export const GetTimeSheetEntriesForTimePeriodForAllTimeApproveesDocument = `
    query GetTimeSheetEntriesForTimePeriodForAllTimeApprovees($tStartAfter: Date!, $tStartBefore: Date!) {
  people(perPage: 10000) {
    items {
      ...PersonWithTimeApprovees
    }
  }
}
    ${PersonWithTimeApproveesFragmentDoc}`;

export const useGetTimeSheetEntriesForTimePeriodForAllTimeApproveesQuery = <
      TData = GetTimeSheetEntriesForTimePeriodForAllTimeApproveesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTimeSheetEntriesForTimePeriodForAllTimeApproveesQueryVariables,
      options?: UseQueryOptions<GetTimeSheetEntriesForTimePeriodForAllTimeApproveesQuery, TError, TData>
    ) => {
    
    return useQuery<GetTimeSheetEntriesForTimePeriodForAllTimeApproveesQuery, TError, TData>(
      ['GetTimeSheetEntriesForTimePeriodForAllTimeApprovees', variables],
      fetcher<GetTimeSheetEntriesForTimePeriodForAllTimeApproveesQuery, GetTimeSheetEntriesForTimePeriodForAllTimeApproveesQueryVariables>(GetTimeSheetEntriesForTimePeriodForAllTimeApproveesDocument, variables),
      options
    )};

export const GetBasicPersonListDocument = `
    query GetBasicPersonList {
  people(perPage: 11000, sort: NAME_ASC) {
    items {
      _id
      acronym
      email
      isActive
      name
      role
      username
    }
  }
}
    `;

export const useGetBasicPersonListQuery = <
      TData = GetBasicPersonListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBasicPersonListQueryVariables,
      options?: UseQueryOptions<GetBasicPersonListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicPersonListQuery, TError, TData>(
      variables === undefined ? ['GetBasicPersonList'] : ['GetBasicPersonList', variables],
      fetcher<GetBasicPersonListQuery, GetBasicPersonListQueryVariables>(GetBasicPersonListDocument, variables),
      options
    )};

export const GetCanopyInfoByPersonIdDocument = `
    query GetCanopyInfoByPersonId($id: MongoID!) {
  person(_id: $id) {
    canopyCredentials {
      clientID
    }
  }
}
    `;

export const useGetCanopyInfoByPersonIdQuery = <
      TData = GetCanopyInfoByPersonIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCanopyInfoByPersonIdQueryVariables,
      options?: UseQueryOptions<GetCanopyInfoByPersonIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetCanopyInfoByPersonIdQuery, TError, TData>(
      ['GetCanopyInfoByPersonId', variables],
      fetcher<GetCanopyInfoByPersonIdQuery, GetCanopyInfoByPersonIdQueryVariables>(GetCanopyInfoByPersonIdDocument, variables),
      options
    )};

export const GetPersonDefaultRunSheetInfoDocument = `
    query GetPersonDefaultRunSheetInfo($id: MongoID!) {
  person(_id: $id) {
    defaultRunSheetStyle {
      lapFlags {
        ATTACK
        COOL
        FCY
        IN
        OUT
        OUTIN
        PITLANE
        PREP
        PUSH
        QUALI
        SAFETYCAR
        SHAKEDOWN
        SLOW
        TARGET
        TOGRID
        TOPADDOCK
        TOPITS
        UNFINISHED
      }
    }
  }
}
    `;

export const useGetPersonDefaultRunSheetInfoQuery = <
      TData = GetPersonDefaultRunSheetInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPersonDefaultRunSheetInfoQueryVariables,
      options?: UseQueryOptions<GetPersonDefaultRunSheetInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetPersonDefaultRunSheetInfoQuery, TError, TData>(
      ['GetPersonDefaultRunSheetInfo', variables],
      fetcher<GetPersonDefaultRunSheetInfoQuery, GetPersonDefaultRunSheetInfoQueryVariables>(GetPersonDefaultRunSheetInfoDocument, variables),
      options
    )};

export const GetPlotPageConfigByIdDocument = `
    query GetPlotPageConfigByID($id: MongoID!) {
  plotPageConfig(_id: $id) {
    _id
    title
    authorID
    isPublic
    gridRows
    gridCols
    plots {
      ...GridPlotPageConfigPlotVars
    }
  }
}
    ${GridPlotPageConfigPlotVarsFragmentDoc}`;

export const useGetPlotPageConfigByIdQuery = <
      TData = GetPlotPageConfigByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPlotPageConfigByIdQueryVariables,
      options?: UseQueryOptions<GetPlotPageConfigByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetPlotPageConfigByIdQuery, TError, TData>(
      ['GetPlotPageConfigByID', variables],
      fetcher<GetPlotPageConfigByIdQuery, GetPlotPageConfigByIdQueryVariables>(GetPlotPageConfigByIdDocument, variables),
      options
    )};

export const PlotPageConfigsDocument = `
    query PlotPageConfigs {
  plotPageConfigs {
    items {
      title
      _id
    }
  }
}
    `;

export const usePlotPageConfigsQuery = <
      TData = PlotPageConfigsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: PlotPageConfigsQueryVariables,
      options?: UseQueryOptions<PlotPageConfigsQuery, TError, TData>
    ) => {
    
    return useQuery<PlotPageConfigsQuery, TError, TData>(
      variables === undefined ? ['PlotPageConfigs'] : ['PlotPageConfigs', variables],
      fetcher<PlotPageConfigsQuery, PlotPageConfigsQueryVariables>(PlotPageConfigsDocument, variables),
      options
    )};

export const GetFlexLayoutConfigForIntentionDocument = `
    query GetFlexLayoutConfigForIntention($intendedFor: EnumFlexLayoutConfigIntendedFor) {
  flexLayoutConfigs(filter: {intendedFor: $intendedFor}) {
    items {
      _id
      authorID
      intendedFor
      isPublic
      model
      name
      targetUserIDs
      targetRoles
      version
    }
  }
}
    `;

export const useGetFlexLayoutConfigForIntentionQuery = <
      TData = GetFlexLayoutConfigForIntentionQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetFlexLayoutConfigForIntentionQueryVariables,
      options?: UseQueryOptions<GetFlexLayoutConfigForIntentionQuery, TError, TData>
    ) => {
    
    return useQuery<GetFlexLayoutConfigForIntentionQuery, TError, TData>(
      variables === undefined ? ['GetFlexLayoutConfigForIntention'] : ['GetFlexLayoutConfigForIntention', variables],
      fetcher<GetFlexLayoutConfigForIntentionQuery, GetFlexLayoutConfigForIntentionQueryVariables>(GetFlexLayoutConfigForIntentionDocument, variables),
      options
    )};

export const GetProjectDocument = `
    query GetProject($id: MongoID!) {
  project(_id: $id) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;

export const useGetProjectQuery = <
      TData = GetProjectQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetProjectQueryVariables,
      options?: UseQueryOptions<GetProjectQuery, TError, TData>
    ) => {
    
    return useQuery<GetProjectQuery, TError, TData>(
      ['GetProject', variables],
      fetcher<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, variables),
      options
    )};

export const GetProjectsListDocument = `
    query GetProjectsList {
  projects(perPage: 10000) {
    items {
      ...Project
    }
  }
}
    ${ProjectFragmentDoc}`;

export const useGetProjectsListQuery = <
      TData = GetProjectsListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetProjectsListQueryVariables,
      options?: UseQueryOptions<GetProjectsListQuery, TError, TData>
    ) => {
    
    return useQuery<GetProjectsListQuery, TError, TData>(
      variables === undefined ? ['GetProjectsList'] : ['GetProjectsList', variables],
      fetcher<GetProjectsListQuery, GetProjectsListQueryVariables>(GetProjectsListDocument, variables),
      options
    )};

export const GetRaceSeriesInfoDocument = `
    query GetRaceSeriesInfo($id: MongoID!) {
  raceSeries(_id: $id) {
    _id
    name
    shortName
    sortingIndex
    groupName
    seasonIDs
    seasons {
      _id
      name
      eventIDs
    }
  }
}
    `;

export const useGetRaceSeriesInfoQuery = <
      TData = GetRaceSeriesInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRaceSeriesInfoQueryVariables,
      options?: UseQueryOptions<GetRaceSeriesInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetRaceSeriesInfoQuery, TError, TData>(
      ['GetRaceSeriesInfo', variables],
      fetcher<GetRaceSeriesInfoQuery, GetRaceSeriesInfoQueryVariables>(GetRaceSeriesInfoDocument, variables),
      options
    )};

export const GetBasicRaceSeriesListDocument = `
    query GetBasicRaceSeriesList {
  raceSeriesAll(perPage: 1000) {
    items {
      _id
      name
      seasonIDs
      sortingIndex
    }
  }
}
    `;

export const useGetBasicRaceSeriesListQuery = <
      TData = GetBasicRaceSeriesListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBasicRaceSeriesListQueryVariables,
      options?: UseQueryOptions<GetBasicRaceSeriesListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicRaceSeriesListQuery, TError, TData>(
      variables === undefined ? ['GetBasicRaceSeriesList'] : ['GetBasicRaceSeriesList', variables],
      fetcher<GetBasicRaceSeriesListQuery, GetBasicRaceSeriesListQueryVariables>(GetBasicRaceSeriesListDocument, variables),
      options
    )};

export const GetRaceSeriesListWithSeasonsAndEventsDocument = `
    query GetRaceSeriesListWithSeasonsAndEvents {
  raceSeriesAll(perPage: 1000) {
    items {
      _id
      name
      shortName
      seasons {
        _id
        name
        eventIDs
        events {
          _id
          name
          tEventStart
        }
      }
    }
  }
}
    `;

export const useGetRaceSeriesListWithSeasonsAndEventsQuery = <
      TData = GetRaceSeriesListWithSeasonsAndEventsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRaceSeriesListWithSeasonsAndEventsQueryVariables,
      options?: UseQueryOptions<GetRaceSeriesListWithSeasonsAndEventsQuery, TError, TData>
    ) => {
    
    return useQuery<GetRaceSeriesListWithSeasonsAndEventsQuery, TError, TData>(
      variables === undefined ? ['GetRaceSeriesListWithSeasonsAndEvents'] : ['GetRaceSeriesListWithSeasonsAndEvents', variables],
      fetcher<GetRaceSeriesListWithSeasonsAndEventsQuery, GetRaceSeriesListWithSeasonsAndEventsQueryVariables>(GetRaceSeriesListWithSeasonsAndEventsDocument, variables),
      options
    )};

export const GetRaceSeriesListWithSeasonsEventsAndSessionsDocument = `
    query GetRaceSeriesListWithSeasonsEventsAndSessions {
  raceSeriesAll(perPage: 1000) {
    items {
      _id
      name
      shortName
      seasons {
        _id
        name
        eventIDs
        events {
          _id
          name
          tEventStart
          sessions {
            _id
            name
            tSessionStart
          }
        }
      }
    }
  }
}
    `;

export const useGetRaceSeriesListWithSeasonsEventsAndSessionsQuery = <
      TData = GetRaceSeriesListWithSeasonsEventsAndSessionsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRaceSeriesListWithSeasonsEventsAndSessionsQueryVariables,
      options?: UseQueryOptions<GetRaceSeriesListWithSeasonsEventsAndSessionsQuery, TError, TData>
    ) => {
    
    return useQuery<GetRaceSeriesListWithSeasonsEventsAndSessionsQuery, TError, TData>(
      variables === undefined ? ['GetRaceSeriesListWithSeasonsEventsAndSessions'] : ['GetRaceSeriesListWithSeasonsEventsAndSessions', variables],
      fetcher<GetRaceSeriesListWithSeasonsEventsAndSessionsQuery, GetRaceSeriesListWithSeasonsEventsAndSessionsQueryVariables>(GetRaceSeriesListWithSeasonsEventsAndSessionsDocument, variables),
      options
    )};

export const DoRaceSeriesSearchDocument = `
    query DoRaceSeriesSearch($search: RegExpAsString) {
  raceSeriesAll(filter: {_operators: {name: {regex: $search}}}) {
    items {
      _id
      name
    }
  }
}
    `;

export const useDoRaceSeriesSearchQuery = <
      TData = DoRaceSeriesSearchQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: DoRaceSeriesSearchQueryVariables,
      options?: UseQueryOptions<DoRaceSeriesSearchQuery, TError, TData>
    ) => {
    
    return useQuery<DoRaceSeriesSearchQuery, TError, TData>(
      variables === undefined ? ['DoRaceSeriesSearch'] : ['DoRaceSeriesSearch', variables],
      fetcher<DoRaceSeriesSearchQuery, DoRaceSeriesSearchQueryVariables>(DoRaceSeriesSearchDocument, variables),
      options
    )};

export const GetSortedRunSheetsDocument = `
    query GetSortedRunSheets {
  runSheets(perPage: 1000, sort: STARTTIMELTS_DESC) {
    items {
      _id
      startTime
      session {
        _id
        name
        shortName
        event {
          _id
          name
          season {
            _id
            name
            raceSeries {
              _id
              name
            }
          }
        }
      }
      driver {
        _id
        acronym
        name
      }
      contestant {
        _id
        startNumber
      }
      setupID
      NRun
      NRunTiming
    }
  }
}
    `;

export const useGetSortedRunSheetsQuery = <
      TData = GetSortedRunSheetsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSortedRunSheetsQueryVariables,
      options?: UseQueryOptions<GetSortedRunSheetsQuery, TError, TData>
    ) => {
    
    return useQuery<GetSortedRunSheetsQuery, TError, TData>(
      variables === undefined ? ['GetSortedRunSheets'] : ['GetSortedRunSheets', variables],
      fetcher<GetSortedRunSheetsQuery, GetSortedRunSheetsQueryVariables>(GetSortedRunSheetsDocument, variables),
      options
    )};

export const GetRunSheetByIdDocument = `
    query GetRunSheetByID($id: MongoID!) {
  runSheet(_id: $id) {
    _id
    ...RunSheetVars
    ...RunSheetSessionVars
  }
}
    ${RunSheetVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${LapVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}
${RunTyreVarsFragmentDoc}
${RunSheetSessionVarsFragmentDoc}
${RunEnergyVarsFragmentDoc}
${TyreDefaultFragmentFragmentDoc}`;

export const useGetRunSheetByIdQuery = <
      TData = GetRunSheetByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetByIdQueryVariables,
      options?: UseQueryOptions<GetRunSheetByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetByIdQuery, TError, TData>(
      ['GetRunSheetByID', variables],
      fetcher<GetRunSheetByIdQuery, GetRunSheetByIdQueryVariables>(GetRunSheetByIdDocument, variables),
      options
    )};

export const GetRunSheetWithSetupByIdDocument = `
    query GetRunSheetWithSetupByID($id: MongoID!) {
  runSheet(_id: $id) {
    _id
    ...RunSheetVars
    ...RunSheetSessionVars
    contestant {
      _id
      startNumber
    }
    setup {
      _id
      ...CarSetupVars
    }
  }
}
    ${RunSheetVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${LapVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}
${RunTyreVarsFragmentDoc}
${RunSheetSessionVarsFragmentDoc}
${RunEnergyVarsFragmentDoc}
${TyreDefaultFragmentFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}`;

export const useGetRunSheetWithSetupByIdQuery = <
      TData = GetRunSheetWithSetupByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetWithSetupByIdQueryVariables,
      options?: UseQueryOptions<GetRunSheetWithSetupByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetWithSetupByIdQuery, TError, TData>(
      ['GetRunSheetWithSetupByID', variables],
      fetcher<GetRunSheetWithSetupByIdQuery, GetRunSheetWithSetupByIdQueryVariables>(GetRunSheetWithSetupByIdDocument, variables),
      options
    )};

export const GetRunSheetWithKpiByIdDocument = `
    query GetRunSheetWithKpiByID($id: MongoID!) {
  runSheet(_id: $id) {
    _id
    ...RunSheetVars
    ...RunSheetSessionVars
    contestant {
      _id
      startNumber
    }
  }
}
    ${RunSheetVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${LapVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}
${RunTyreVarsFragmentDoc}
${RunSheetSessionVarsFragmentDoc}
${RunEnergyVarsFragmentDoc}
${TyreDefaultFragmentFragmentDoc}`;

export const useGetRunSheetWithKpiByIdQuery = <
      TData = GetRunSheetWithKpiByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetWithKpiByIdQueryVariables,
      options?: UseQueryOptions<GetRunSheetWithKpiByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetWithKpiByIdQuery, TError, TData>(
      ['GetRunSheetWithKpiByID', variables],
      fetcher<GetRunSheetWithKpiByIdQuery, GetRunSheetWithKpiByIdQueryVariables>(GetRunSheetWithKpiByIdDocument, variables),
      options
    )};

export const GetRunSheetWithSelectedKpiByIdDocument = `
    query GetRunSheetWithSelectedKpiByID($id: MongoID!, $runKPI: [String!], $lapKPI: [String!]) {
  runSheet(_id: $id) {
    runKPI(fields: $runKPI)
    laps {
      tLapMax
      vCarLapMax
      tDay
      lapKPI(fields: $lapKPI)
    }
    contestant {
      _id
      startNumber
    }
  }
}
    `;

export const useGetRunSheetWithSelectedKpiByIdQuery = <
      TData = GetRunSheetWithSelectedKpiByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetWithSelectedKpiByIdQueryVariables,
      options?: UseQueryOptions<GetRunSheetWithSelectedKpiByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetWithSelectedKpiByIdQuery, TError, TData>(
      ['GetRunSheetWithSelectedKpiByID', variables],
      fetcher<GetRunSheetWithSelectedKpiByIdQuery, GetRunSheetWithSelectedKpiByIdQueryVariables>(GetRunSheetWithSelectedKpiByIdDocument, variables),
      options
    )};

export const GetRunSheetWithSelectedKpiAndSetupDocument = `
    query GetRunSheetWithSelectedKpiAndSetup($id: MongoID!, $runKPI: [String!], $lapKPI: [String!]) {
  runSheet(_id: $id) {
    ...AllRunSheetScalarVars
    runKPI(fields: $runKPI)
    laps {
      tDay
      tLapMax
      vCarLapMax
      lapKPI(fields: $lapKPI)
    }
    contestant {
      _id
      startNumber
    }
    session {
      shortName
      tSessionStart
      tSessionEnd
    }
    NRunTiming
    setup {
      ...CarSetupVars
      chassisSpec {
        simulationModels
      }
    }
    _id
    ...RunCommentVars
    sessionID
    contestantID
    driverID
    driver {
      _id
      name
      acronym
    }
    teamID
    prevRunSheetID
    startTime
    endTime
    timingServiceShouldIgnore
    tyrePressureSettings {
      TTrackReference
    }
    tyreFL {
      ...RunTyreVars
    }
    tyreFR {
      ...RunTyreVars
    }
    tyreRL {
      ...RunTyreVars
    }
    tyreRR {
      ...RunTyreVars
    }
    tyreSetID
    TCellMaxRunStart
    ...EnergyUsedVars
    NRun
    fuelDrainedBeforeRun
    consumptions {
      trackLayoutID
      trackLayout {
        _id
        name
        track {
          _id
          name
        }
      }
      fuelRequired {
        ...AllRunEnergyVars
      }
      SoCRequired {
        ...AllRunEnergyVars
      }
    }
    fuelRequired {
      ...AllRunEnergyVars
    }
    SoCRequired {
      ...AllRunEnergyVars
    }
    jobIDs
    selectedJobListTemplateID
    weather {
      TAir
      TTrack
      pAmbient
      rHumidity
      DAir
      TAirOfficial
      TTrackOfficial
    }
    setupID
    dashboard {
      mFuelRunEnd
      mFuelRunStart
    }
    brakePreRunMeasurementsFL
    brakePreRunMeasurementsFR
    brakePreRunMeasurementsRL
    brakePreRunMeasurementsRR
    brakePostRunMeasurementsFL
    brakePostRunMeasurementsFR
    brakePostRunMeasurementsRL
    brakePostRunMeasurementsRR
    skidPreRunMeasurements
    skidPostRunMeasurements
    brakeComment
    controlsComment
    skidComment
    laptimeThresholds {
      cool
      prep
      push
    }
    mileage
    lastModifiedBy {
      _id
      name
    }
    createdAt
    updatedAt
  }
}
    ${AllRunSheetScalarVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${RunTyreVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetRunSheetWithSelectedKpiAndSetupQuery = <
      TData = GetRunSheetWithSelectedKpiAndSetupQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetWithSelectedKpiAndSetupQueryVariables,
      options?: UseQueryOptions<GetRunSheetWithSelectedKpiAndSetupQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetWithSelectedKpiAndSetupQuery, TError, TData>(
      ['GetRunSheetWithSelectedKpiAndSetup', variables],
      fetcher<GetRunSheetWithSelectedKpiAndSetupQuery, GetRunSheetWithSelectedKpiAndSetupQueryVariables>(GetRunSheetWithSelectedKpiAndSetupDocument, variables),
      options
    )};

export const GetRunSheetWithAllKpiAndSetupDocument = `
    query GetRunSheetWithAllKpiAndSetup($id: MongoID!) {
  runSheet(_id: $id) {
    ...AllRunSheetScalarVars
    runKPI
    laps {
      tDay
      tLapMax
      vCarLapMax
      lapKPI
    }
    contestant {
      _id
      startNumber
    }
    session {
      shortName
      tSessionStart
      tSessionEnd
    }
    NRunTiming
    setup {
      chassisSpec {
        simulationModels
      }
      ...CarSetupVars
    }
    _id
    ...RunCommentVars
    sessionID
    contestantID
    driverID
    driver {
      _id
      name
      acronym
    }
    teamID
    prevRunSheetID
    startTime
    endTime
    timingServiceShouldIgnore
    tyrePressureSettings {
      TTrackReference
    }
    tyreFL {
      ...RunTyreVars
    }
    tyreFR {
      ...RunTyreVars
    }
    tyreRL {
      ...RunTyreVars
    }
    tyreRR {
      ...RunTyreVars
    }
    tyreSetID
    TCellMaxRunStart
    ...EnergyUsedVars
    NRun
    fuelDrainedBeforeRun
    consumptions {
      trackLayoutID
      trackLayout {
        _id
        name
        track {
          _id
          name
        }
      }
      fuelRequired {
        ...AllRunEnergyVars
      }
      SoCRequired {
        ...AllRunEnergyVars
      }
    }
    fuelRequired {
      ...AllRunEnergyVars
    }
    SoCRequired {
      ...AllRunEnergyVars
    }
    jobIDs
    selectedJobListTemplateID
    weather {
      TAir
      TTrack
      pAmbient
      rHumidity
      DAir
      TAirOfficial
      TTrackOfficial
    }
    setupID
    dashboard {
      mFuelRunEnd
      mFuelRunStart
    }
    brakePreRunMeasurementsFL
    brakePreRunMeasurementsFR
    brakePreRunMeasurementsRL
    brakePreRunMeasurementsRR
    brakePostRunMeasurementsFL
    brakePostRunMeasurementsFR
    brakePostRunMeasurementsRL
    brakePostRunMeasurementsRR
    skidPreRunMeasurements
    skidPostRunMeasurements
    brakeComment
    controlsComment
    skidComment
    laptimeThresholds {
      cool
      prep
      push
    }
    mileage
    lastModifiedBy {
      _id
      name
    }
    createdAt
    updatedAt
  }
}
    ${AllRunSheetScalarVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${RunTyreVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetRunSheetWithAllKpiAndSetupQuery = <
      TData = GetRunSheetWithAllKpiAndSetupQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetWithAllKpiAndSetupQueryVariables,
      options?: UseQueryOptions<GetRunSheetWithAllKpiAndSetupQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetWithAllKpiAndSetupQuery, TError, TData>(
      ['GetRunSheetWithAllKpiAndSetup', variables],
      fetcher<GetRunSheetWithAllKpiAndSetupQuery, GetRunSheetWithAllKpiAndSetupQueryVariables>(GetRunSheetWithAllKpiAndSetupDocument, variables),
      options
    )};

export const GetRunSheetTabInfoByIdDocument = `
    query GetRunSheetTabInfoByID($id: MongoID!) {
  runSheet(_id: $id) {
    _id
    driverID
    driver {
      _id
      acronym
      name
    }
    info
    laps {
      _id
      data {
        tDay
        source
      }
      tLapMax
      tLapManual
      lapType
    }
    NRun
    NRunTiming
    runDescription
    session {
      _id
      tSessionEnd
      event {
        _id
      }
    }
    setup {
      setupInfo
    }
    setupID
    startTime
    startTimeLTS
    startTimeManual
  }
}
    `;

export const useGetRunSheetTabInfoByIdQuery = <
      TData = GetRunSheetTabInfoByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetTabInfoByIdQueryVariables,
      options?: UseQueryOptions<GetRunSheetTabInfoByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetTabInfoByIdQuery, TError, TData>(
      ['GetRunSheetTabInfoByID', variables],
      fetcher<GetRunSheetTabInfoByIdQuery, GetRunSheetTabInfoByIdQueryVariables>(GetRunSheetTabInfoByIdDocument, variables),
      options
    )};

export const GetRunSheetsByIDsDocument = `
    query GetRunSheetsByIDs($ids: [MongoID!]!) {
  runSheets(perPage: 1000, filter: {_operators: {_id: {in: $ids}}}) {
    items {
      _id
      ...RunSheetVars
    }
  }
}
    ${RunSheetVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${LapVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}
${RunTyreVarsFragmentDoc}`;

export const useGetRunSheetsByIDsQuery = <
      TData = GetRunSheetsByIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetsByIDsQueryVariables,
      options?: UseQueryOptions<GetRunSheetsByIDsQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsByIDsQuery, TError, TData>(
      ['GetRunSheetsByIDs', variables],
      fetcher<GetRunSheetsByIDsQuery, GetRunSheetsByIDsQueryVariables>(GetRunSheetsByIDsDocument, variables),
      options
    )};

export const GetRunSheetsBySessionsIDsDocument = `
    query GetRunSheetsBySessionsIDs($sessionIDs: [MongoID!]!, $contestantIDs: [MongoID!]!) {
  runSheets(
    perPage: 1000
    filter: {_operators: {sessionID: {in: $sessionIDs}, contestantID: {in: $contestantIDs}}}
  ) {
    items {
      _id
      ...RunSheetVars
      ...RunSheetSessionVars
    }
  }
}
    ${RunSheetVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${LapVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}
${RunTyreVarsFragmentDoc}
${RunSheetSessionVarsFragmentDoc}
${RunEnergyVarsFragmentDoc}
${TyreDefaultFragmentFragmentDoc}`;

export const useGetRunSheetsBySessionsIDsQuery = <
      TData = GetRunSheetsBySessionsIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetsBySessionsIDsQueryVariables,
      options?: UseQueryOptions<GetRunSheetsBySessionsIDsQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsBySessionsIDsQuery, TError, TData>(
      ['GetRunSheetsBySessionsIDs', variables],
      fetcher<GetRunSheetsBySessionsIDsQuery, GetRunSheetsBySessionsIDsQueryVariables>(GetRunSheetsBySessionsIDsDocument, variables),
      options
    )};

export const GetRunSheetIdsBySessionIdsDocument = `
    query GetRunSheetIdsBySessionIds($sessionIDs: [MongoID!]!, $contestantIDs: [MongoID!]!) {
  runSheets(
    perPage: 1000
    filter: {_operators: {sessionID: {in: $sessionIDs}, contestantID: {in: $contestantIDs}}}
  ) {
    items {
      _id
      sessionID
      contestantID
      NRun
      NRunTiming
      runKPI
    }
  }
}
    `;

export const useGetRunSheetIdsBySessionIdsQuery = <
      TData = GetRunSheetIdsBySessionIdsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetIdsBySessionIdsQueryVariables,
      options?: UseQueryOptions<GetRunSheetIdsBySessionIdsQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetIdsBySessionIdsQuery, TError, TData>(
      ['GetRunSheetIdsBySessionIds', variables],
      fetcher<GetRunSheetIdsBySessionIdsQuery, GetRunSheetIdsBySessionIdsQueryVariables>(GetRunSheetIdsBySessionIdsDocument, variables),
      options
    )};

export const GetRunSheetsBySessionIdDocument = `
    query GetRunSheetsBySessionID($sessionID: [MongoID!]) {
  runSheets(perPage: 1000, filter: {_operators: {sessionID: {in: $sessionID}}}) {
    items {
      _id
      ...RunSheetVars
      ...RunSheetSessionVars
    }
  }
}
    ${RunSheetVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${LapVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}
${RunTyreVarsFragmentDoc}
${RunSheetSessionVarsFragmentDoc}
${RunEnergyVarsFragmentDoc}
${TyreDefaultFragmentFragmentDoc}`;

export const useGetRunSheetsBySessionIdQuery = <
      TData = GetRunSheetsBySessionIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRunSheetsBySessionIdQueryVariables,
      options?: UseQueryOptions<GetRunSheetsBySessionIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsBySessionIdQuery, TError, TData>(
      variables === undefined ? ['GetRunSheetsBySessionID'] : ['GetRunSheetsBySessionID', variables],
      fetcher<GetRunSheetsBySessionIdQuery, GetRunSheetsBySessionIdQueryVariables>(GetRunSheetsBySessionIdDocument, variables),
      options
    )};

export const GetRunSheetsByContestantIDsDocument = `
    query GetRunSheetsByContestantIDs($contestantIDs: [MongoID!]!) {
  runSheets(
    perPage: 1000
    filter: {_operators: {contestantID: {in: $contestantIDs}}}
  ) {
    items {
      _id
      ...RunSheetVars
      ...RunSheetSessionVars
    }
  }
}
    ${RunSheetVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${LapVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}
${RunTyreVarsFragmentDoc}
${RunSheetSessionVarsFragmentDoc}
${RunEnergyVarsFragmentDoc}
${TyreDefaultFragmentFragmentDoc}`;

export const useGetRunSheetsByContestantIDsQuery = <
      TData = GetRunSheetsByContestantIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetsByContestantIDsQueryVariables,
      options?: UseQueryOptions<GetRunSheetsByContestantIDsQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsByContestantIDsQuery, TError, TData>(
      ['GetRunSheetsByContestantIDs', variables],
      fetcher<GetRunSheetsByContestantIDsQuery, GetRunSheetsByContestantIDsQueryVariables>(GetRunSheetsByContestantIDsDocument, variables),
      options
    )};

export const GetRunSheetsForSummaryBySessionsIDsDocument = `
    query GetRunSheetsForSummaryBySessionsIDs($sessionIDs: [MongoID!]!, $contestantIDs: [MongoID!]!) {
  runSheets(
    perPage: 1000
    filter: {_operators: {sessionID: {in: $sessionIDs}, contestantID: {in: $contestantIDs}}}
  ) {
    items {
      _id
      ...RunCommentVars
      ...EnergyUsedVars
      ...RunSheetSessionVars
      sessionID
      contestantID
      driverID
      runKPI
      laps {
        _id
        ...LapVars
      }
      setup {
        _id
        title
        powertrain {
          hEngineBlanking
          engineBlankingDetails
        }
      }
    }
  }
}
    ${RunCommentVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${RunSheetSessionVarsFragmentDoc}
${RunEnergyVarsFragmentDoc}
${TyreDefaultFragmentFragmentDoc}
${LapVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}`;

export const useGetRunSheetsForSummaryBySessionsIDsQuery = <
      TData = GetRunSheetsForSummaryBySessionsIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetsForSummaryBySessionsIDsQueryVariables,
      options?: UseQueryOptions<GetRunSheetsForSummaryBySessionsIDsQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsForSummaryBySessionsIDsQuery, TError, TData>(
      ['GetRunSheetsForSummaryBySessionsIDs', variables],
      fetcher<GetRunSheetsForSummaryBySessionsIDsQuery, GetRunSheetsForSummaryBySessionsIDsQueryVariables>(GetRunSheetsForSummaryBySessionsIDsDocument, variables),
      options
    )};

export const GetRunSheetMetadataByIdDocument = `
    query GetRunSheetMetadataById($id: MongoID!) {
  runSheet(_id: $id) {
    _id
    NRun
    NRunTiming
    session {
      _id
      shortName
      event {
        _id
        name
        season {
          _id
          name
          raceSeries {
            _id
            name
          }
        }
      }
    }
    contestant {
      _id
      startNumber
    }
    driver {
      _id
      acronym
    }
    setupID
    weather {
      TAirOfficial
      pAmbient
      rHumidity
    }
  }
}
    `;

export const useGetRunSheetMetadataByIdQuery = <
      TData = GetRunSheetMetadataByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetMetadataByIdQueryVariables,
      options?: UseQueryOptions<GetRunSheetMetadataByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetMetadataByIdQuery, TError, TData>(
      ['GetRunSheetMetadataById', variables],
      fetcher<GetRunSheetMetadataByIdQuery, GetRunSheetMetadataByIdQueryVariables>(GetRunSheetMetadataByIdDocument, variables),
      options
    )};

export const GetRunSheetDataForCarSetupByIdDocument = `
    query GetRunSheetDataForCarSetupById($id: MongoID!) {
  runSheet(_id: $id) {
    _id
    NRun
    NRunTiming
    session {
      _id
      shortName
      event {
        _id
        name
        season {
          _id
          name
          raceSeries {
            _id
            name
          }
        }
      }
    }
    contestant {
      _id
      startNumber
    }
    driver {
      _id
      acronym
    }
    setupID
    tyreFL {
      ...RunTyreVars
    }
    tyreFR {
      ...RunTyreVars
    }
    tyreRL {
      ...RunTyreVars
    }
    tyreRR {
      ...RunTyreVars
    }
    weather {
      TAir
      TTrack
      pAmbient
      rHumidity
      DAir
      TAirOfficial
      TTrackOfficial
    }
  }
}
    ${RunTyreVarsFragmentDoc}`;

export const useGetRunSheetDataForCarSetupByIdQuery = <
      TData = GetRunSheetDataForCarSetupByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetDataForCarSetupByIdQueryVariables,
      options?: UseQueryOptions<GetRunSheetDataForCarSetupByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetDataForCarSetupByIdQuery, TError, TData>(
      ['GetRunSheetDataForCarSetupById', variables],
      fetcher<GetRunSheetDataForCarSetupByIdQuery, GetRunSheetDataForCarSetupByIdQueryVariables>(GetRunSheetDataForCarSetupByIdDocument, variables),
      options
    )};

export const GetRunSheetsKpiBySessionsIDsDocument = `
    query GetRunSheetsKPIBySessionsIDs($sessionIDs: [MongoID!]!) {
  runSheets(perPage: 1000, filter: {_operators: {sessionID: {in: $sessionIDs}}}) {
    items {
      _id
      startTime
      runKPI
    }
  }
}
    `;

export const useGetRunSheetsKpiBySessionsIDsQuery = <
      TData = GetRunSheetsKpiBySessionsIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetsKpiBySessionsIDsQueryVariables,
      options?: UseQueryOptions<GetRunSheetsKpiBySessionsIDsQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsKpiBySessionsIDsQuery, TError, TData>(
      ['GetRunSheetsKPIBySessionsIDs', variables],
      fetcher<GetRunSheetsKpiBySessionsIDsQuery, GetRunSheetsKpiBySessionsIDsQueryVariables>(GetRunSheetsKpiBySessionsIDsDocument, variables),
      options
    )};

export const GetRunSheetsForSessionExportDocument = `
    query GetRunSheetsForSessionExport($sessionIDs: [MongoID!]!, $contestantIDs: [MongoID!]!) {
  runSheets(
    perPage: 2147483647
    filter: {_operators: {sessionID: {in: $sessionIDs}, contestantID: {in: $contestantIDs}}}
  ) {
    items {
      _id
      ...RunSheetExportVars
    }
  }
}
    ${RunSheetExportVarsFragmentDoc}
${RunSheetVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${LapVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}
${RunTyreVarsFragmentDoc}
${RunSheetSessionVarsFragmentDoc}
${RunEnergyVarsFragmentDoc}
${TyreDefaultFragmentFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}`;

export const useGetRunSheetsForSessionExportQuery = <
      TData = GetRunSheetsForSessionExportQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetsForSessionExportQueryVariables,
      options?: UseQueryOptions<GetRunSheetsForSessionExportQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetsForSessionExportQuery, TError, TData>(
      ['GetRunSheetsForSessionExport', variables],
      fetcher<GetRunSheetsForSessionExportQuery, GetRunSheetsForSessionExportQueryVariables>(GetRunSheetsForSessionExportDocument, variables),
      options
    )};

export const GetRunSheetListForEventSelectionContextDocument = `
    query GetRunSheetListForEventSelectionContext($sessionIDs: [MongoID!]!) {
  runSheets(perPage: 10000, filter: {_operators: {sessionID: {in: $sessionIDs}}}) {
    items {
      _id
      ...RunSheetForEventSelectionVars
      session {
        tSessionStart
      }
    }
  }
}
    ${RunSheetForEventSelectionVarsFragmentDoc}`;

export const useGetRunSheetListForEventSelectionContextQuery = <
      TData = GetRunSheetListForEventSelectionContextQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetListForEventSelectionContextQueryVariables,
      options?: UseQueryOptions<GetRunSheetListForEventSelectionContextQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetListForEventSelectionContextQuery, TError, TData>(
      ['GetRunSheetListForEventSelectionContext', variables],
      fetcher<GetRunSheetListForEventSelectionContextQuery, GetRunSheetListForEventSelectionContextQueryVariables>(GetRunSheetListForEventSelectionContextDocument, variables),
      options
    )};

export const GetRunSheetEventInfoDocument = `
    query GetRunSheetEventInfo($id: MongoID!) {
  runSheet(_id: $id) {
    _id
    session {
      _id
      event {
        _id
        name
      }
    }
  }
}
    `;

export const useGetRunSheetEventInfoQuery = <
      TData = GetRunSheetEventInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetEventInfoQueryVariables,
      options?: UseQueryOptions<GetRunSheetEventInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetEventInfoQuery, TError, TData>(
      ['GetRunSheetEventInfo', variables],
      fetcher<GetRunSheetEventInfoQuery, GetRunSheetEventInfoQueryVariables>(GetRunSheetEventInfoDocument, variables),
      options
    )};

export const GetRunSheetSimulationDocument = `
    query GetRunSheetSimulation($id: MongoID!) {
  runSheet(_id: $id) {
    ...RunSheetSimulationVars
  }
}
    ${RunSheetSimulationVarsFragmentDoc}`;

export const useGetRunSheetSimulationQuery = <
      TData = GetRunSheetSimulationQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetSimulationQueryVariables,
      options?: UseQueryOptions<GetRunSheetSimulationQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetSimulationQuery, TError, TData>(
      ['GetRunSheetSimulation', variables],
      fetcher<GetRunSheetSimulationQuery, GetRunSheetSimulationQueryVariables>(GetRunSheetSimulationDocument, variables),
      options
    )};

export const GetSessionEventInfoDocument = `
    query GetSessionEventInfo($id: MongoID!) {
  session(_id: $id) {
    _id
    event {
      _id
      name
    }
    tSessionStart
    tSessionEnd
  }
}
    `;

export const useGetSessionEventInfoQuery = <
      TData = GetSessionEventInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSessionEventInfoQueryVariables,
      options?: UseQueryOptions<GetSessionEventInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionEventInfoQuery, TError, TData>(
      ['GetSessionEventInfo', variables],
      fetcher<GetSessionEventInfoQuery, GetSessionEventInfoQueryVariables>(GetSessionEventInfoDocument, variables),
      options
    )};

export const GetRunSheetStyleListDocument = `
    query GetRunSheetStyleList {
  runSheetStyles(perPage: 1000) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetRunSheetStyleListQuery = <
      TData = GetRunSheetStyleListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRunSheetStyleListQueryVariables,
      options?: UseQueryOptions<GetRunSheetStyleListQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetStyleListQuery, TError, TData>(
      variables === undefined ? ['GetRunSheetStyleList'] : ['GetRunSheetStyleList', variables],
      fetcher<GetRunSheetStyleListQuery, GetRunSheetStyleListQueryVariables>(GetRunSheetStyleListDocument, variables),
      options
    )};

export const GetRunSheetStyleDocument = `
    query GetRunSheetStyle($id: MongoID!) {
  runSheetStyle(_id: $id) {
    ...RunSheetStyleVars
  }
}
    ${RunSheetStyleVarsFragmentDoc}
${RunSheetStyleBlocksVarsFragmentDoc}
${BlankingBlockVarsFragmentDoc}
${BrakesBlockVarsFragmentDoc}
${CommentBlockVarsFragmentDoc}
${DoubleCommentBlockVarsFragmentDoc}
${FuelBlockVarsFragmentDoc}
${IssueBlockVarsFragmentDoc}
${JobListBlockVarsFragmentDoc}
${LapTableBlockVarsFragmentDoc}
${LapTimeThresholdsBlockVarsFragmentDoc}
${LapTypeCountBlockVarsFragmentDoc}
${MiniJobListBlockVarsFragmentDoc}
${PostRunMeasurementBlockVarsFragmentDoc}
${RunKpiTableBlockVarsFragmentDoc}
${SetupChangesBlockVarsFragmentDoc}
${SetupSheetBlockVarsFragmentDoc}
${TyreTableBlockVarsFragmentDoc}
${WeatherBoxBlockVarsFragmentDoc}
${AllLapFlagLabelVarsFragmentDoc}`;

export const useGetRunSheetStyleQuery = <
      TData = GetRunSheetStyleQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunSheetStyleQueryVariables,
      options?: UseQueryOptions<GetRunSheetStyleQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetStyleQuery, TError, TData>(
      ['GetRunSheetStyle', variables],
      fetcher<GetRunSheetStyleQuery, GetRunSheetStyleQueryVariables>(GetRunSheetStyleDocument, variables),
      options
    )};

export const GetBasicSeasonListDocument = `
    query GetBasicSeasonList {
  seasons(perPage: 1000) {
    items {
      _id
      name
      eventIDs
    }
  }
}
    `;

export const useGetBasicSeasonListQuery = <
      TData = GetBasicSeasonListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBasicSeasonListQueryVariables,
      options?: UseQueryOptions<GetBasicSeasonListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicSeasonListQuery, TError, TData>(
      variables === undefined ? ['GetBasicSeasonList'] : ['GetBasicSeasonList', variables],
      fetcher<GetBasicSeasonListQuery, GetBasicSeasonListQueryVariables>(GetBasicSeasonListDocument, variables),
      options
    )};

export const GetSeasonNameDocument = `
    query GetSeasonName($id: MongoID!) {
  season(_id: $id) {
    _id
    name
    raceSeriesID
  }
}
    `;

export const useGetSeasonNameQuery = <
      TData = GetSeasonNameQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSeasonNameQueryVariables,
      options?: UseQueryOptions<GetSeasonNameQuery, TError, TData>
    ) => {
    
    return useQuery<GetSeasonNameQuery, TError, TData>(
      ['GetSeasonName', variables],
      fetcher<GetSeasonNameQuery, GetSeasonNameQueryVariables>(GetSeasonNameDocument, variables),
      options
    )};

export const DoSeasonSearchDocument = `
    query DoSeasonSearch($search: RegExpAsString) {
  seasons(filter: {_operators: {name: {regex: $search}}}) {
    items {
      _id
      name
      raceSeries {
        _id
        name
      }
    }
  }
}
    `;

export const useDoSeasonSearchQuery = <
      TData = DoSeasonSearchQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: DoSeasonSearchQueryVariables,
      options?: UseQueryOptions<DoSeasonSearchQuery, TError, TData>
    ) => {
    
    return useQuery<DoSeasonSearchQuery, TError, TData>(
      variables === undefined ? ['DoSeasonSearch'] : ['DoSeasonSearch', variables],
      fetcher<DoSeasonSearchQuery, DoSeasonSearchQueryVariables>(DoSeasonSearchDocument, variables),
      options
    )};

export const GetSeasonInfoDocument = `
    query GetSeasonInfo($id: MongoID!) {
  season(_id: $id) {
    _id
    name
    contestantIDs
    contestants {
      _id
      class
      startNumber
      drivers {
        _id
        name
      }
      team {
        _id
        name
      }
    }
    eventIDs
    events {
      _id
      ...EventInSeasonVars
    }
    raceSeriesID
    raceSeries {
      _id
      name
    }
    pointsSystemQualiAlternateIDs
    pointsSystemQualiDefaultIDs
    pointsSystemRaceAlternateIDs
    pointsSystemRaceDefaultIDs
  }
}
    ${EventInSeasonVarsFragmentDoc}
${SessionWithTimesVarsFragmentDoc}`;

export const useGetSeasonInfoQuery = <
      TData = GetSeasonInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSeasonInfoQueryVariables,
      options?: UseQueryOptions<GetSeasonInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetSeasonInfoQuery, TError, TData>(
      ['GetSeasonInfo', variables],
      fetcher<GetSeasonInfoQuery, GetSeasonInfoQueryVariables>(GetSeasonInfoDocument, variables),
      options
    )};

export const GetSeasonInfoFromContestantDocument = `
    query GetSeasonInfoFromContestant($contestantIDs: [MongoID]) {
  seasons(filter: {contestantIDs: $contestantIDs}) {
    items {
      _id
      contestants {
        _id
        season {
          _id
          name
          events {
            _id
            name
          }
        }
      }
    }
  }
}
    `;

export const useGetSeasonInfoFromContestantQuery = <
      TData = GetSeasonInfoFromContestantQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSeasonInfoFromContestantQueryVariables,
      options?: UseQueryOptions<GetSeasonInfoFromContestantQuery, TError, TData>
    ) => {
    
    return useQuery<GetSeasonInfoFromContestantQuery, TError, TData>(
      variables === undefined ? ['GetSeasonInfoFromContestant'] : ['GetSeasonInfoFromContestant', variables],
      fetcher<GetSeasonInfoFromContestantQuery, GetSeasonInfoFromContestantQueryVariables>(GetSeasonInfoFromContestantDocument, variables),
      options
    )};

export const GetSeasonsFromRaceSeriesDocument = `
    query GetSeasonsFromRaceSeries($raceSeriesID: MongoID) {
  seasons(filter: {raceSeriesID: $raceSeriesID}, sort: NAME_ASC, perPage: 200) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetSeasonsFromRaceSeriesQuery = <
      TData = GetSeasonsFromRaceSeriesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSeasonsFromRaceSeriesQueryVariables,
      options?: UseQueryOptions<GetSeasonsFromRaceSeriesQuery, TError, TData>
    ) => {
    
    return useQuery<GetSeasonsFromRaceSeriesQuery, TError, TData>(
      variables === undefined ? ['GetSeasonsFromRaceSeries'] : ['GetSeasonsFromRaceSeries', variables],
      fetcher<GetSeasonsFromRaceSeriesQuery, GetSeasonsFromRaceSeriesQueryVariables>(GetSeasonsFromRaceSeriesDocument, variables),
      options
    )};

export const GetSeasonContestantsDocument = `
    query GetSeasonContestants($id: MongoID!) {
  season(_id: $id) {
    _id
    contestants {
      _id
      class
      drivers {
        _id
        acronym
        name
        username
      }
      driverIDs
      startNumber
      team {
        _id
        name
      }
    }
  }
}
    `;

export const useGetSeasonContestantsQuery = <
      TData = GetSeasonContestantsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSeasonContestantsQueryVariables,
      options?: UseQueryOptions<GetSeasonContestantsQuery, TError, TData>
    ) => {
    
    return useQuery<GetSeasonContestantsQuery, TError, TData>(
      ['GetSeasonContestants', variables],
      fetcher<GetSeasonContestantsQuery, GetSeasonContestantsQueryVariables>(GetSeasonContestantsDocument, variables),
      options
    )};

export const WhoAmIDocument = `
    query WhoAmI {
  whoami {
    claims
  }
}
    `;

export const useWhoAmIQuery = <
      TData = WhoAmIQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: WhoAmIQueryVariables,
      options?: UseQueryOptions<WhoAmIQuery, TError, TData>
    ) => {
    
    return useQuery<WhoAmIQuery, TError, TData>(
      variables === undefined ? ['WhoAmI'] : ['WhoAmI', variables],
      fetcher<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, variables),
      options
    )};

export const GetLicenseStatusAndPersonInfoForAuthDocument = `
    query GetLicenseStatusAndPersonInfoForAuth($personID: MongoID!) {
  license {
    valid
    customer
    features {
      dyno
      moveServer
      readOnlyAfterLicenseExpiry
      sevenPost
      simulation
      teams
      tyreSetStatistics
      lightVersion
    }
    options {
      services {
        carData
        chassisSimulation
        oneTimingWeather
        timing
        weather
      }
      setupSheetStyles
    }
    expired
    expirationDate
  }
  person(_id: $personID) {
    isTimeTracker
    isTimeTrackerAdmin
    hideKPIs
  }
}
    `;

export const useGetLicenseStatusAndPersonInfoForAuthQuery = <
      TData = GetLicenseStatusAndPersonInfoForAuthQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetLicenseStatusAndPersonInfoForAuthQueryVariables,
      options?: UseQueryOptions<GetLicenseStatusAndPersonInfoForAuthQuery, TError, TData>
    ) => {
    
    return useQuery<GetLicenseStatusAndPersonInfoForAuthQuery, TError, TData>(
      ['GetLicenseStatusAndPersonInfoForAuth', variables],
      fetcher<GetLicenseStatusAndPersonInfoForAuthQuery, GetLicenseStatusAndPersonInfoForAuthQueryVariables>(GetLicenseStatusAndPersonInfoForAuthDocument, variables),
      options
    )};

export const GetApiVersionDocument = `
    query getApiVersion {
  version
}
    `;

export const useGetApiVersionQuery = <
      TData = GetApiVersionQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetApiVersionQueryVariables,
      options?: UseQueryOptions<GetApiVersionQuery, TError, TData>
    ) => {
    
    return useQuery<GetApiVersionQuery, TError, TData>(
      variables === undefined ? ['getApiVersion'] : ['getApiVersion', variables],
      fetcher<GetApiVersionQuery, GetApiVersionQueryVariables>(GetApiVersionDocument, variables),
      options
    )};

export const GetSessionsInDateTimeRangeDocument = `
    query GetSessionsInDateTimeRange($startDate: Date, $endDate: Date) {
  sessions(
    filter: {AND: [{_operators: {tSessionStart: {gte: $startDate}}}, {_operators: {tSessionStart: {lte: $endDate}}}]}
    sort: TSESSIONSTART_DESC
    perPage: 500
  ) {
    items {
      _id
      ...SessionInRangeVars
    }
  }
}
    ${SessionInRangeVarsFragmentDoc}`;

export const useGetSessionsInDateTimeRangeQuery = <
      TData = GetSessionsInDateTimeRangeQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSessionsInDateTimeRangeQueryVariables,
      options?: UseQueryOptions<GetSessionsInDateTimeRangeQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionsInDateTimeRangeQuery, TError, TData>(
      variables === undefined ? ['GetSessionsInDateTimeRange'] : ['GetSessionsInDateTimeRange', variables],
      fetcher<GetSessionsInDateTimeRangeQuery, GetSessionsInDateTimeRangeQueryVariables>(GetSessionsInDateTimeRangeDocument, variables),
      options
    )};

export const GetSessionDocument = `
    query GetSession($id: MongoID!) {
  session(_id: $id) {
    _id
    name
    shortName
    tSessionStart
    tSessionEnd
    timeRemaining
    timeRemainingUpdatedAt
    eventID
    debriefNotes
    sessionType
    isLinkedSession
    contestants {
      _id
    }
  }
}
    `;

export const useGetSessionQuery = <
      TData = GetSessionQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSessionQueryVariables,
      options?: UseQueryOptions<GetSessionQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionQuery, TError, TData>(
      ['GetSession', variables],
      fetcher<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, variables),
      options
    )};

export const DoSessionSearchDocument = `
    query DoSessionSearch($search: RegExpAsString) {
  sessions(
    filter: {OR: [{_operators: {name: {regex: $search}}}, {_operators: {shortName: {regex: $search}}}]}
    sort: TSESSIONSTART_DESC
    perPage: 1000
  ) {
    items {
      _id
      ...SessionBaseVars
    }
  }
}
    ${SessionBaseVarsFragmentDoc}`;

export const useDoSessionSearchQuery = <
      TData = DoSessionSearchQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: DoSessionSearchQueryVariables,
      options?: UseQueryOptions<DoSessionSearchQuery, TError, TData>
    ) => {
    
    return useQuery<DoSessionSearchQuery, TError, TData>(
      variables === undefined ? ['DoSessionSearch'] : ['DoSessionSearch', variables],
      fetcher<DoSessionSearchQuery, DoSessionSearchQueryVariables>(DoSessionSearchDocument, variables),
      options
    )};

export const GetContestantsForSessionDocument = `
    query GetContestantsForSession($sessionID: MongoID!) {
  session(_id: $sessionID) {
    _id
    event {
      _id
      season {
        _id
        contestants {
          _id
          class
        }
      }
      contestants {
        _id
      }
    }
    contestants {
      _id
    }
  }
}
    `;

export const useGetContestantsForSessionQuery = <
      TData = GetContestantsForSessionQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetContestantsForSessionQueryVariables,
      options?: UseQueryOptions<GetContestantsForSessionQuery, TError, TData>
    ) => {
    
    return useQuery<GetContestantsForSessionQuery, TError, TData>(
      ['GetContestantsForSession', variables],
      fetcher<GetContestantsForSessionQuery, GetContestantsForSessionQueryVariables>(GetContestantsForSessionDocument, variables),
      options
    )};

export const GetAllSeasonSessionsForSessionDocument = `
    query GetAllSeasonSessionsForSession($id: MongoID!) {
  session(_id: $id) {
    _id
    event {
      _id
      season {
        _id
        name
        events {
          _id
          sessions {
            _id
            tSessionStart
            name
            sessionType
          }
        }
      }
    }
  }
}
    `;

export const useGetAllSeasonSessionsForSessionQuery = <
      TData = GetAllSeasonSessionsForSessionQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAllSeasonSessionsForSessionQueryVariables,
      options?: UseQueryOptions<GetAllSeasonSessionsForSessionQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllSeasonSessionsForSessionQuery, TError, TData>(
      ['GetAllSeasonSessionsForSession', variables],
      fetcher<GetAllSeasonSessionsForSessionQuery, GetAllSeasonSessionsForSessionQueryVariables>(GetAllSeasonSessionsForSessionDocument, variables),
      options
    )};

export const GetSetupsForSessionByDriverDocument = `
    query GetSetupsForSessionByDriver($sessionID: MongoID, $driverID: MongoID) {
  runSheets(filter: {sessionID: $sessionID, driverID: $driverID}, perPage: 1000) {
    items {
      _id
      session {
        _id
        name
      }
      NRun
      NRunTiming
      setupID
    }
  }
}
    `;

export const useGetSetupsForSessionByDriverQuery = <
      TData = GetSetupsForSessionByDriverQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSetupsForSessionByDriverQueryVariables,
      options?: UseQueryOptions<GetSetupsForSessionByDriverQuery, TError, TData>
    ) => {
    
    return useQuery<GetSetupsForSessionByDriverQuery, TError, TData>(
      variables === undefined ? ['GetSetupsForSessionByDriver'] : ['GetSetupsForSessionByDriver', variables],
      fetcher<GetSetupsForSessionByDriverQuery, GetSetupsForSessionByDriverQueryVariables>(GetSetupsForSessionByDriverDocument, variables),
      options
    )};

export const GetSessionInfoDocument = `
    query GetSessionInfo($id: MongoID!) {
  session(_id: $id) {
    _id
    name
    shortName
    eventID
  }
}
    `;

export const useGetSessionInfoQuery = <
      TData = GetSessionInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSessionInfoQueryVariables,
      options?: UseQueryOptions<GetSessionInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionInfoQuery, TError, TData>(
      ['GetSessionInfo', variables],
      fetcher<GetSessionInfoQuery, GetSessionInfoQueryVariables>(GetSessionInfoDocument, variables),
      options
    )};

export const GetBasicSessionListDocument = `
    query GetBasicSessionList($eventID: MongoID) {
  sessions(filter: {eventID: $eventID}, sort: TSESSIONSTART_ASC, perPage: 1000) {
    items {
      _id
      ...BasicSessionVars
    }
  }
}
    ${BasicSessionVarsFragmentDoc}`;

export const useGetBasicSessionListQuery = <
      TData = GetBasicSessionListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBasicSessionListQueryVariables,
      options?: UseQueryOptions<GetBasicSessionListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicSessionListQuery, TError, TData>(
      variables === undefined ? ['GetBasicSessionList'] : ['GetBasicSessionList', variables],
      fetcher<GetBasicSessionListQuery, GetBasicSessionListQueryVariables>(GetBasicSessionListDocument, variables),
      options
    )};

export const GetSessionListWithTimesDocument = `
    query GetSessionListWithTimes($eventID: MongoID) {
  sessions(filter: {eventID: $eventID}, sort: TSESSIONSTART_ASC, perPage: 1000) {
    items {
      _id
      ...SessionWithTimesVars
    }
  }
}
    ${SessionWithTimesVarsFragmentDoc}`;

export const useGetSessionListWithTimesQuery = <
      TData = GetSessionListWithTimesQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSessionListWithTimesQueryVariables,
      options?: UseQueryOptions<GetSessionListWithTimesQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionListWithTimesQuery, TError, TData>(
      variables === undefined ? ['GetSessionListWithTimes'] : ['GetSessionListWithTimes', variables],
      fetcher<GetSessionListWithTimesQuery, GetSessionListWithTimesQueryVariables>(GetSessionListWithTimesDocument, variables),
      options
    )};

export const GetDriversForSessionDocument = `
    query GetDriversForSession($sessionID: MongoID) {
  runSheets(perPage: 1000, filter: {sessionID: $sessionID}) {
    items {
      _id
      driverID
    }
  }
}
    `;

export const useGetDriversForSessionQuery = <
      TData = GetDriversForSessionQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetDriversForSessionQueryVariables,
      options?: UseQueryOptions<GetDriversForSessionQuery, TError, TData>
    ) => {
    
    return useQuery<GetDriversForSessionQuery, TError, TData>(
      variables === undefined ? ['GetDriversForSession'] : ['GetDriversForSession', variables],
      fetcher<GetDriversForSessionQuery, GetDriversForSessionQueryVariables>(GetDriversForSessionDocument, variables),
      options
    )};

export const GetDownloadableSessionsDocument = `
    query GetDownloadableSessions {
  raceSeriesAll {
    items {
      _id
      name
      seasons {
        _id
        name
        contestants {
          _id
        }
        events {
          _id
          name
          contestants {
            _id
          }
          sessions {
            _id
            name
            contestants {
              _id
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetDownloadableSessionsQuery = <
      TData = GetDownloadableSessionsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetDownloadableSessionsQueryVariables,
      options?: UseQueryOptions<GetDownloadableSessionsQuery, TError, TData>
    ) => {
    
    return useQuery<GetDownloadableSessionsQuery, TError, TData>(
      variables === undefined ? ['GetDownloadableSessions'] : ['GetDownloadableSessions', variables],
      fetcher<GetDownloadableSessionsQuery, GetDownloadableSessionsQueryVariables>(GetDownloadableSessionsDocument, variables),
      options
    )};

export const GetSessionDriverStandingsDocument = `
    query GetSessionDriverStandings($sessionID: MongoID!) {
  session(_id: $sessionID) {
    _id
    event {
      _id
      season {
        _id
        contestants {
          _id
          startNumber
        }
      }
      contestants {
        _id
      }
    }
    contestants {
      _id
    }
    driverChampionshipStandings {
      startNumber
      acronym
      points
      driverID
      prevRacePositions
      rank
    }
    liveStandings {
      startNumber
      acronym
      driverID
      position
    }
  }
}
    `;

export const useGetSessionDriverStandingsQuery = <
      TData = GetSessionDriverStandingsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSessionDriverStandingsQueryVariables,
      options?: UseQueryOptions<GetSessionDriverStandingsQuery, TError, TData>
    ) => {
    
    return useQuery<GetSessionDriverStandingsQuery, TError, TData>(
      ['GetSessionDriverStandings', variables],
      fetcher<GetSessionDriverStandingsQuery, GetSessionDriverStandingsQueryVariables>(GetSessionDriverStandingsDocument, variables),
      options
    )};

export const GetDriverStandingsForSessionsDocument = `
    query GetDriverStandingsForSessions($sessionIDs: [MongoID!]) {
  sessions(
    perPage: 200
    filter: {_operators: {_id: {in: $sessionIDs}}}
    sort: TSESSIONSTART_DESC
  ) {
    items {
      _id
      name
      tSessionStart
      event {
        _id
        season {
          _id
          contestants {
            _id
            startNumber
          }
        }
        contestants {
          _id
        }
      }
      contestants {
        _id
      }
      prevDriverChampionshipStandings {
        startNumber
        acronym
        points
        prevRacePositions
        driverID
      }
      driverChampionshipStandings {
        startNumber
        acronym
        points
        driverID
        prevRacePositions
      }
      liveStandings {
        startNumber
        acronym
        driverID
      }
    }
  }
}
    `;

export const useGetDriverStandingsForSessionsQuery = <
      TData = GetDriverStandingsForSessionsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetDriverStandingsForSessionsQueryVariables,
      options?: UseQueryOptions<GetDriverStandingsForSessionsQuery, TError, TData>
    ) => {
    
    return useQuery<GetDriverStandingsForSessionsQuery, TError, TData>(
      variables === undefined ? ['GetDriverStandingsForSessions'] : ['GetDriverStandingsForSessions', variables],
      fetcher<GetDriverStandingsForSessionsQuery, GetDriverStandingsForSessionsQueryVariables>(GetDriverStandingsForSessionsDocument, variables),
      options
    )};

export const GetSetupOverviewConfigByIdDocument = `
    query GetSetupOverviewConfigById($id: MongoID!) {
  setupOverviewConfig(_id: $id) {
    _id
    title
    authorID
    isPublic
    fields {
      _id
      ...SetupOverviewConfigFieldVars
    }
    rows {
      _id
      ...SetupOverviewConfigRowVars
    }
    author {
      _id
      name
    }
  }
}
    ${SetupOverviewConfigFieldVarsFragmentDoc}
${SetupOverviewConfigRowVarsFragmentDoc}
${SetupOverviewConfigRowElementVarsFragmentDoc}`;

export const useGetSetupOverviewConfigByIdQuery = <
      TData = GetSetupOverviewConfigByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSetupOverviewConfigByIdQueryVariables,
      options?: UseQueryOptions<GetSetupOverviewConfigByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetSetupOverviewConfigByIdQuery, TError, TData>(
      ['GetSetupOverviewConfigById', variables],
      fetcher<GetSetupOverviewConfigByIdQuery, GetSetupOverviewConfigByIdQueryVariables>(GetSetupOverviewConfigByIdDocument, variables),
      options
    )};

export const GetSetupOverviewConfigListDocument = `
    query GetSetupOverviewConfigList {
  setupOverviewConfigs(perPage: 1000, sort: _ID_DESC) {
    items {
      _id
      title
      fields {
        _id
        keys
        label
        unit
        decimals
        gain
      }
    }
  }
}
    `;

export const useGetSetupOverviewConfigListQuery = <
      TData = GetSetupOverviewConfigListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSetupOverviewConfigListQueryVariables,
      options?: UseQueryOptions<GetSetupOverviewConfigListQuery, TError, TData>
    ) => {
    
    return useQuery<GetSetupOverviewConfigListQuery, TError, TData>(
      variables === undefined ? ['GetSetupOverviewConfigList'] : ['GetSetupOverviewConfigList', variables],
      fetcher<GetSetupOverviewConfigListQuery, GetSetupOverviewConfigListQueryVariables>(GetSetupOverviewConfigListDocument, variables),
      options
    )};

export const GetSetupSheetStyleListDocument = `
    query GetSetupSheetStyleList {
  setupSheetStyles(perPage: 1000) {
    items {
      _id
      chassisSpec {
        name
        version
      }
      chassisSpecID
      name
      type
    }
  }
}
    `;

export const useGetSetupSheetStyleListQuery = <
      TData = GetSetupSheetStyleListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSetupSheetStyleListQueryVariables,
      options?: UseQueryOptions<GetSetupSheetStyleListQuery, TError, TData>
    ) => {
    
    return useQuery<GetSetupSheetStyleListQuery, TError, TData>(
      variables === undefined ? ['GetSetupSheetStyleList'] : ['GetSetupSheetStyleList', variables],
      fetcher<GetSetupSheetStyleListQuery, GetSetupSheetStyleListQueryVariables>(GetSetupSheetStyleListDocument, variables),
      options
    )};

export const GetSetupSheetStyleDocument = `
    query GetSetupSheetStyle($id: MongoID!) {
  setupSheetStyle(_id: $id) {
    _id
    author {
      username
      name
      _id
    }
    authorID
    blocks {
      _id
      ...SetupSheetStyleBlockVarsForSetupSheetFlex
    }
    chassisSpecID
    createdAt
    hideAddPartButton
    hideUnits
    isPublic
    name
    targetEventType
    targetRoles
    targetUserIDs
    targetUsers {
      _id
      name
    }
    type
    updatedAt
    version
  }
}
    ${SetupSheetStyleBlockVarsForSetupSheetFlexFragmentDoc}
${SetupSheetStyleBlockTabVarsForSetupSheetFlexFragmentDoc}`;

export const useGetSetupSheetStyleQuery = <
      TData = GetSetupSheetStyleQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSetupSheetStyleQueryVariables,
      options?: UseQueryOptions<GetSetupSheetStyleQuery, TError, TData>
    ) => {
    
    return useQuery<GetSetupSheetStyleQuery, TError, TData>(
      ['GetSetupSheetStyle', variables],
      fetcher<GetSetupSheetStyleQuery, GetSetupSheetStyleQueryVariables>(GetSetupSheetStyleDocument, variables),
      options
    )};

export const GetSimResultsForCarSetupDocument = `
    query GetSimResultsForCarSetup($id: MongoID) {
  simResults(filter: {carSetupID: $id}) {
    items {
      _id
      ...SimResultVars
    }
  }
}
    ${SimResultVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetSimResultsForCarSetupQuery = <
      TData = GetSimResultsForCarSetupQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimResultsForCarSetupQueryVariables,
      options?: UseQueryOptions<GetSimResultsForCarSetupQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimResultsForCarSetupQuery, TError, TData>(
      variables === undefined ? ['GetSimResultsForCarSetup'] : ['GetSimResultsForCarSetup', variables],
      fetcher<GetSimResultsForCarSetupQuery, GetSimResultsForCarSetupQueryVariables>(GetSimResultsForCarSetupDocument, variables),
      options
    )};

export const GetSimResultByIdDocument = `
    query GetSimResultById($id: MongoID!) {
  simResult(_id: $id) {
    _id
    ...SimResultVars
  }
}
    ${SimResultVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetSimResultByIdQuery = <
      TData = GetSimResultByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSimResultByIdQueryVariables,
      options?: UseQueryOptions<GetSimResultByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimResultByIdQuery, TError, TData>(
      ['GetSimResultById', variables],
      fetcher<GetSimResultByIdQuery, GetSimResultByIdQueryVariables>(GetSimResultByIdDocument, variables),
      options
    )};

export const GetSimResultsDocument = `
    query GetSimResults {
  simResults(perPage: 10000000) {
    items {
      _id
      ...SimResultCondensedVars
    }
  }
}
    ${SimResultCondensedVarsFragmentDoc}`;

export const useGetSimResultsQuery = <
      TData = GetSimResultsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimResultsQueryVariables,
      options?: UseQueryOptions<GetSimResultsQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimResultsQuery, TError, TData>(
      variables === undefined ? ['GetSimResults'] : ['GetSimResults', variables],
      fetcher<GetSimResultsQuery, GetSimResultsQueryVariables>(GetSimResultsDocument, variables),
      options
    )};

export const GetSimResultsByCarSetupIdDocument = `
    query GetSimResultsByCarSetupId($setupID: MongoID) {
  simResults(filter: {carSetupID: $setupID}) {
    items {
      _id
      ...SimResultVars
    }
  }
}
    ${SimResultVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetSimResultsByCarSetupIdQuery = <
      TData = GetSimResultsByCarSetupIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimResultsByCarSetupIdQueryVariables,
      options?: UseQueryOptions<GetSimResultsByCarSetupIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimResultsByCarSetupIdQuery, TError, TData>(
      variables === undefined ? ['GetSimResultsByCarSetupId'] : ['GetSimResultsByCarSetupId', variables],
      fetcher<GetSimResultsByCarSetupIdQuery, GetSimResultsByCarSetupIdQueryVariables>(GetSimResultsByCarSetupIdDocument, variables),
      options
    )};

export const GetSimResultsForCarSetupByTypeDocument = `
    query GetSimResultsForCarSetupByType($setupID: MongoID, $simType: EnumSimResultSimType) {
  simResults(filter: {carSetupID: $setupID, simType: $simType}) {
    items {
      _id
      ...SimResultVars
    }
  }
}
    ${SimResultVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetSimResultsForCarSetupByTypeQuery = <
      TData = GetSimResultsForCarSetupByTypeQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimResultsForCarSetupByTypeQueryVariables,
      options?: UseQueryOptions<GetSimResultsForCarSetupByTypeQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimResultsForCarSetupByTypeQuery, TError, TData>(
      variables === undefined ? ['GetSimResultsForCarSetupByType'] : ['GetSimResultsForCarSetupByType', variables],
      fetcher<GetSimResultsForCarSetupByTypeQuery, GetSimResultsForCarSetupByTypeQueryVariables>(GetSimResultsForCarSetupByTypeDocument, variables),
      options
    )};

export const GetSimResultsByRunsheetIdDocument = `
    query GetSimResultsByRunsheetId($runSheetID: MongoID) {
  simResults(filter: {runSheetID: $runSheetID}, perPage: 40) {
    items {
      _id
      ...SimResultVars
    }
  }
}
    ${SimResultVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetSimResultsByRunsheetIdQuery = <
      TData = GetSimResultsByRunsheetIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimResultsByRunsheetIdQueryVariables,
      options?: UseQueryOptions<GetSimResultsByRunsheetIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimResultsByRunsheetIdQuery, TError, TData>(
      variables === undefined ? ['GetSimResultsByRunsheetId'] : ['GetSimResultsByRunsheetId', variables],
      fetcher<GetSimResultsByRunsheetIdQuery, GetSimResultsByRunsheetIdQueryVariables>(GetSimResultsByRunsheetIdDocument, variables),
      options
    )};

export const GetSimResultsForRunsheetByTypeDocument = `
    query GetSimResultsForRunsheetByType($runSheetID: MongoID, $simType: EnumSimResultSimType) {
  simResults(filter: {runSheetID: $runSheetID, simType: $simType}) {
    items {
      _id
      ...SimResultVars
    }
  }
}
    ${SimResultVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetSimResultsForRunsheetByTypeQuery = <
      TData = GetSimResultsForRunsheetByTypeQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimResultsForRunsheetByTypeQueryVariables,
      options?: UseQueryOptions<GetSimResultsForRunsheetByTypeQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimResultsForRunsheetByTypeQuery, TError, TData>(
      variables === undefined ? ['GetSimResultsForRunsheetByType'] : ['GetSimResultsForRunsheetByType', variables],
      fetcher<GetSimResultsForRunsheetByTypeQuery, GetSimResultsForRunsheetByTypeQueryVariables>(GetSimResultsForRunsheetByTypeDocument, variables),
      options
    )};

export const GetSimResultsByPersonDocument = `
    query GetSimResultsByPerson($requesterID: MongoID) {
  simResults(perPage: 10000, filter: {requesterID: $requesterID}) {
    items {
      _id
      ...SimResultCondensedVars
    }
  }
}
    ${SimResultCondensedVarsFragmentDoc}`;

export const useGetSimResultsByPersonQuery = <
      TData = GetSimResultsByPersonQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetSimResultsByPersonQueryVariables,
      options?: UseQueryOptions<GetSimResultsByPersonQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimResultsByPersonQuery, TError, TData>(
      variables === undefined ? ['GetSimResultsByPerson'] : ['GetSimResultsByPerson', variables],
      fetcher<GetSimResultsByPersonQuery, GetSimResultsByPersonQueryVariables>(GetSimResultsByPersonDocument, variables),
      options
    )};

export const FindCanopyConfigsDocument = `
    query FindCanopyConfigs($configType: EnumCanopyConfigType!, $nameFilter: String) {
  findCanopyConfigs(configType: $configType, nameFilter: $nameFilter) {
    canopyID
    name
    simVersion
    createdAt
    updatedAt
  }
}
    `;

export const useFindCanopyConfigsQuery = <
      TData = FindCanopyConfigsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: FindCanopyConfigsQueryVariables,
      options?: UseQueryOptions<FindCanopyConfigsQuery, TError, TData>
    ) => {
    
    return useQuery<FindCanopyConfigsQuery, TError, TData>(
      ['FindCanopyConfigs', variables],
      fetcher<FindCanopyConfigsQuery, FindCanopyConfigsQueryVariables>(FindCanopyConfigsDocument, variables),
      options
    )};

export const GetAllChassisSpecsDocument = `
    query GetAllChassisSpecs {
  specifications(perPage: 1000, filter: {type: CHASSIS}) {
    items {
      ... on ChassisSpec {
        _id
        prevIterationID
        nextIterationID
        name
        version
        releaseDate
        released
        updatedAt
        decommissioned
        allowableParentSpecIDs
        simulationAvailable
      }
    }
  }
}
    `;

export const useGetAllChassisSpecsQuery = <
      TData = GetAllChassisSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllChassisSpecsQueryVariables,
      options?: UseQueryOptions<GetAllChassisSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllChassisSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllChassisSpecs'] : ['GetAllChassisSpecs', variables],
      fetcher<GetAllChassisSpecsQuery, GetAllChassisSpecsQueryVariables>(GetAllChassisSpecsDocument, variables),
      options
    )};

export const GetAllChassisSpecsBasicInfoDocument = `
    query GetAllChassisSpecsBasicInfo {
  specifications(perPage: 1000, filter: {type: CHASSIS}) {
    items {
      ...BasicInfoChassisSpec
    }
  }
}
    ${BasicInfoChassisSpecFragmentDoc}`;

export const useGetAllChassisSpecsBasicInfoQuery = <
      TData = GetAllChassisSpecsBasicInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllChassisSpecsBasicInfoQueryVariables,
      options?: UseQueryOptions<GetAllChassisSpecsBasicInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllChassisSpecsBasicInfoQuery, TError, TData>(
      variables === undefined ? ['GetAllChassisSpecsBasicInfo'] : ['GetAllChassisSpecsBasicInfo', variables],
      fetcher<GetAllChassisSpecsBasicInfoQuery, GetAllChassisSpecsBasicInfoQueryVariables>(GetAllChassisSpecsBasicInfoDocument, variables),
      options
    )};

export const GetBasicChassisSpecListDocument = `
    query GetBasicChassisSpecList {
  specifications(perPage: 1000, filter: {type: CHASSIS}) {
    items {
      ... on ChassisSpec {
        _id
        name
      }
    }
  }
}
    `;

export const useGetBasicChassisSpecListQuery = <
      TData = GetBasicChassisSpecListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBasicChassisSpecListQueryVariables,
      options?: UseQueryOptions<GetBasicChassisSpecListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicChassisSpecListQuery, TError, TData>(
      variables === undefined ? ['GetBasicChassisSpecList'] : ['GetBasicChassisSpecList', variables],
      fetcher<GetBasicChassisSpecListQuery, GetBasicChassisSpecListQueryVariables>(GetBasicChassisSpecListDocument, variables),
      options
    )};

export const GetChassisSpecByIdDocument = `
    query GetChassisSpecById($id: MongoID!) {
  specification(_id: $id) {
    ...AllChassisSpecVars
  }
}
    ${AllChassisSpecVarsFragmentDoc}
${AeroPackageVarsFragmentDoc}
${AeroElementVarsFragmentDoc}
${AntiRollBarVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${AllChassisMeasurementSpecVarsFragmentDoc}
${CustomSpecVarsFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${MassPropertiesVarsFragmentDoc}
${DamperSpecVarsFragmentDoc}
${AllChassisSpecVarsIterationFragmentDoc}
${ExternalKinematicSpecVarsFragmentDoc}
${InternalKinematicSpecVarsFragmentDoc}
${ChassisMassVarsFragmentDoc}
${ChassisMeasurementVarsFragmentDoc}
${ChassisPowertrainVarsFragmentDoc}
${GearSpecVarsFragmentDoc}
${GearBoxSpecVarsFragmentDoc}
${DifferentialSpecVarsFragmentDoc}
${ChassisBrakeBiasVarsFragmentDoc}
${ChassisRegulationSetVarsFragmentDoc}`;

export const useGetChassisSpecByIdQuery = <
      TData = GetChassisSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpecByIdQueryVariables,
      options?: UseQueryOptions<GetChassisSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecByIdQuery, TError, TData>(
      ['GetChassisSpecById', variables],
      fetcher<GetChassisSpecByIdQuery, GetChassisSpecByIdQueryVariables>(GetChassisSpecByIdDocument, variables),
      options
    )};

export const GetAllChassisSpecIterationsDocument = `
    query GetAllChassisSpecIterations($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      iterationIDs
      iterations {
        _id
        name
        version
        released
        releaseDate
        decommissioned
      }
    }
  }
}
    `;

export const useGetAllChassisSpecIterationsQuery = <
      TData = GetAllChassisSpecIterationsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAllChassisSpecIterationsQueryVariables,
      options?: UseQueryOptions<GetAllChassisSpecIterationsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllChassisSpecIterationsQuery, TError, TData>(
      ['GetAllChassisSpecIterations', variables],
      fetcher<GetAllChassisSpecIterationsQuery, GetAllChassisSpecIterationsQueryVariables>(GetAllChassisSpecIterationsDocument, variables),
      options
    )};

export const GetFlattenedFieldsOfChassisSpecificationDocument = `
    query GetFlattenedFieldsOfChassisSpecification($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      _id
      flattened
    }
  }
}
    `;

export const useGetFlattenedFieldsOfChassisSpecificationQuery = <
      TData = GetFlattenedFieldsOfChassisSpecificationQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetFlattenedFieldsOfChassisSpecificationQueryVariables,
      options?: UseQueryOptions<GetFlattenedFieldsOfChassisSpecificationQuery, TError, TData>
    ) => {
    
    return useQuery<GetFlattenedFieldsOfChassisSpecificationQuery, TError, TData>(
      ['GetFlattenedFieldsOfChassisSpecification', variables],
      fetcher<GetFlattenedFieldsOfChassisSpecificationQuery, GetFlattenedFieldsOfChassisSpecificationQueryVariables>(GetFlattenedFieldsOfChassisSpecificationDocument, variables),
      options
    )};

export const GetChassisSpecificationsByTypeDocument = `
    query GetChassisSpecificationsByType($chassisSpecID: MongoID, $type: EnumSpecificationType) {
  specifications(
    perPage: 1000
    filter: {chassisSpecID: $chassisSpecID, type: $type}
  ) {
    items {
      ... on AnySpecification {
        _id
        name
      }
    }
  }
}
    `;

export const useGetChassisSpecificationsByTypeQuery = <
      TData = GetChassisSpecificationsByTypeQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetChassisSpecificationsByTypeQueryVariables,
      options?: UseQueryOptions<GetChassisSpecificationsByTypeQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecificationsByTypeQuery, TError, TData>(
      variables === undefined ? ['GetChassisSpecificationsByType'] : ['GetChassisSpecificationsByType', variables],
      fetcher<GetChassisSpecificationsByTypeQuery, GetChassisSpecificationsByTypeQueryVariables>(GetChassisSpecificationsByTypeDocument, variables),
      options
    )};

export const GetAllAeroElementSpecsDocument = `
    query GetAllAeroElementSpecs {
  specifications(perPage: 1000, filter: {type: AERO_ELEMENT}) {
    items {
      ...AeroElementVars
    }
  }
}
    ${AeroElementVarsFragmentDoc}`;

export const useGetAllAeroElementSpecsQuery = <
      TData = GetAllAeroElementSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllAeroElementSpecsQueryVariables,
      options?: UseQueryOptions<GetAllAeroElementSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllAeroElementSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllAeroElementSpecs'] : ['GetAllAeroElementSpecs', variables],
      fetcher<GetAllAeroElementSpecsQuery, GetAllAeroElementSpecsQueryVariables>(GetAllAeroElementSpecsDocument, variables),
      options
    )};

export const GetAeroElementSpecByIdDocument = `
    query GetAeroElementSpecById($id: MongoID!) {
  specification(_id: $id) {
    ...AeroElementVars
  }
}
    ${AeroElementVarsFragmentDoc}`;

export const useGetAeroElementSpecByIdQuery = <
      TData = GetAeroElementSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAeroElementSpecByIdQueryVariables,
      options?: UseQueryOptions<GetAeroElementSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetAeroElementSpecByIdQuery, TError, TData>(
      ['GetAeroElementSpecById', variables],
      fetcher<GetAeroElementSpecByIdQuery, GetAeroElementSpecByIdQueryVariables>(GetAeroElementSpecByIdDocument, variables),
      options
    )};

export const GetAllAeroPackageSpecsDocument = `
    query GetAllAeroPackageSpecs {
  specifications(perPage: 1000, filter: {type: AERO_PACKAGE}) {
    items {
      ...AeroPackageVars
    }
  }
}
    ${AeroPackageVarsFragmentDoc}
${AeroElementVarsFragmentDoc}`;

export const useGetAllAeroPackageSpecsQuery = <
      TData = GetAllAeroPackageSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllAeroPackageSpecsQueryVariables,
      options?: UseQueryOptions<GetAllAeroPackageSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllAeroPackageSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllAeroPackageSpecs'] : ['GetAllAeroPackageSpecs', variables],
      fetcher<GetAllAeroPackageSpecsQuery, GetAllAeroPackageSpecsQueryVariables>(GetAllAeroPackageSpecsDocument, variables),
      options
    )};

export const GetAeroPackageSpecByIdDocument = `
    query GetAeroPackageSpecById($id: MongoID!) {
  specification(_id: $id) {
    ...AeroPackageVars
  }
}
    ${AeroPackageVarsFragmentDoc}
${AeroElementVarsFragmentDoc}`;

export const useGetAeroPackageSpecByIdQuery = <
      TData = GetAeroPackageSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAeroPackageSpecByIdQueryVariables,
      options?: UseQueryOptions<GetAeroPackageSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetAeroPackageSpecByIdQuery, TError, TData>(
      ['GetAeroPackageSpecById', variables],
      fetcher<GetAeroPackageSpecByIdQuery, GetAeroPackageSpecByIdQueryVariables>(GetAeroPackageSpecByIdDocument, variables),
      options
    )};

export const GetAllElasticElementSpecsDocument = `
    query GetAllElasticElementSpecs {
  specifications(perPage: 1000, filter: {type: ELASTIC}) {
    items {
      ...ElasticSpecVars
    }
  }
}
    ${ElasticSpecVarsFragmentDoc}`;

export const useGetAllElasticElementSpecsQuery = <
      TData = GetAllElasticElementSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllElasticElementSpecsQueryVariables,
      options?: UseQueryOptions<GetAllElasticElementSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllElasticElementSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllElasticElementSpecs'] : ['GetAllElasticElementSpecs', variables],
      fetcher<GetAllElasticElementSpecsQuery, GetAllElasticElementSpecsQueryVariables>(GetAllElasticElementSpecsDocument, variables),
      options
    )};

export const GetElasticElementSpecByIdDocument = `
    query GetElasticElementSpecById($id: MongoID!) {
  specification(_id: $id) {
    ...ElasticSpecVars
  }
}
    ${ElasticSpecVarsFragmentDoc}`;

export const useGetElasticElementSpecByIdQuery = <
      TData = GetElasticElementSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetElasticElementSpecByIdQueryVariables,
      options?: UseQueryOptions<GetElasticElementSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetElasticElementSpecByIdQuery, TError, TData>(
      ['GetElasticElementSpecById', variables],
      fetcher<GetElasticElementSpecByIdQuery, GetElasticElementSpecByIdQueryVariables>(GetElasticElementSpecByIdDocument, variables),
      options
    )};

export const GetAllTorsionBarSpecsDocument = `
    query GetAllTorsionBarSpecs {
  specifications(perPage: 1000, filter: {elasticType: TORSION_BAR}) {
    items {
      ...ElasticSpecVars
    }
  }
}
    ${ElasticSpecVarsFragmentDoc}`;

export const useGetAllTorsionBarSpecsQuery = <
      TData = GetAllTorsionBarSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllTorsionBarSpecsQueryVariables,
      options?: UseQueryOptions<GetAllTorsionBarSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllTorsionBarSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllTorsionBarSpecs'] : ['GetAllTorsionBarSpecs', variables],
      fetcher<GetAllTorsionBarSpecsQuery, GetAllTorsionBarSpecsQueryVariables>(GetAllTorsionBarSpecsDocument, variables),
      options
    )};

export const GetTorsionBarSpecByIdDocument = `
    query GetTorsionBarSpecById($id: MongoID!) {
  specification(_id: $id) {
    ...ElasticSpecVars
  }
}
    ${ElasticSpecVarsFragmentDoc}`;

export const useGetTorsionBarSpecByIdQuery = <
      TData = GetTorsionBarSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTorsionBarSpecByIdQueryVariables,
      options?: UseQueryOptions<GetTorsionBarSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetTorsionBarSpecByIdQuery, TError, TData>(
      ['GetTorsionBarSpecById', variables],
      fetcher<GetTorsionBarSpecByIdQuery, GetTorsionBarSpecByIdQueryVariables>(GetTorsionBarSpecByIdDocument, variables),
      options
    )};

export const GetAllGearBoxSpecsDocument = `
    query GetAllGearBoxSpecs {
  specifications(perPage: 1000, filter: {type: GEAR_BOX}) {
    items {
      ... on GearBoxSpec {
        _id
        name
        chassisSpecID
        updatedAt
        decommissioned
        assignedGears {
          gearID
          useHeadGear
          gear {
            _id
            isHeadGear
          }
        }
        bevelSetSpecID
        dropGearSpecID
        differentialSpecID
        headGearSpecID
      }
    }
  }
}
    `;

export const useGetAllGearBoxSpecsQuery = <
      TData = GetAllGearBoxSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllGearBoxSpecsQueryVariables,
      options?: UseQueryOptions<GetAllGearBoxSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllGearBoxSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllGearBoxSpecs'] : ['GetAllGearBoxSpecs', variables],
      fetcher<GetAllGearBoxSpecsQuery, GetAllGearBoxSpecsQueryVariables>(GetAllGearBoxSpecsDocument, variables),
      options
    )};

export const GetGearBoxSpecByIdDocument = `
    query GetGearBoxSpecById($id: MongoID!) {
  specification(_id: $id) {
    ... on GearBoxSpec {
      _id
      name
      chassisSpecID
      updatedAt
      decommissioned
      assignedGears {
        gearID
        gear {
          _id
          isHeadGear
        }
      }
      bevelSetSpecID
      dropGearSpecID
    }
  }
}
    `;

export const useGetGearBoxSpecByIdQuery = <
      TData = GetGearBoxSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetGearBoxSpecByIdQueryVariables,
      options?: UseQueryOptions<GetGearBoxSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetGearBoxSpecByIdQuery, TError, TData>(
      ['GetGearBoxSpecById', variables],
      fetcher<GetGearBoxSpecByIdQuery, GetGearBoxSpecByIdQueryVariables>(GetGearBoxSpecByIdDocument, variables),
      options
    )};

export const GetAllDamperElementSpecsDocument = `
    query GetAllDamperElementSpecs {
  specifications(perPage: 1000, filter: {type: DAMPER}) {
    items {
      ...DamperSpecVars
    }
  }
}
    ${DamperSpecVarsFragmentDoc}`;

export const useGetAllDamperElementSpecsQuery = <
      TData = GetAllDamperElementSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllDamperElementSpecsQueryVariables,
      options?: UseQueryOptions<GetAllDamperElementSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllDamperElementSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllDamperElementSpecs'] : ['GetAllDamperElementSpecs', variables],
      fetcher<GetAllDamperElementSpecsQuery, GetAllDamperElementSpecsQueryVariables>(GetAllDamperElementSpecsDocument, variables),
      options
    )};

export const GetDamperElementSpecByIdDocument = `
    query GetDamperElementSpecById($id: MongoID!) {
  specification(_id: $id) {
    ...DamperSpecVars
  }
}
    ${DamperSpecVarsFragmentDoc}`;

export const useGetDamperElementSpecByIdQuery = <
      TData = GetDamperElementSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetDamperElementSpecByIdQueryVariables,
      options?: UseQueryOptions<GetDamperElementSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetDamperElementSpecByIdQuery, TError, TData>(
      ['GetDamperElementSpecById', variables],
      fetcher<GetDamperElementSpecByIdQuery, GetDamperElementSpecByIdQueryVariables>(GetDamperElementSpecByIdDocument, variables),
      options
    )};

export const GetAllAntiRollBarElementSpecsDocument = `
    query GetAllAntiRollBarElementSpecs {
  specifications(perPage: 1000, filter: {type: ANTI_ROLL_BAR}) {
    items {
      ...AntiRollBarVars
    }
  }
}
    ${AntiRollBarVarsFragmentDoc}`;

export const useGetAllAntiRollBarElementSpecsQuery = <
      TData = GetAllAntiRollBarElementSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllAntiRollBarElementSpecsQueryVariables,
      options?: UseQueryOptions<GetAllAntiRollBarElementSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllAntiRollBarElementSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllAntiRollBarElementSpecs'] : ['GetAllAntiRollBarElementSpecs', variables],
      fetcher<GetAllAntiRollBarElementSpecsQuery, GetAllAntiRollBarElementSpecsQueryVariables>(GetAllAntiRollBarElementSpecsDocument, variables),
      options
    )};

export const GetAntiRollBarElementSpecByIdDocument = `
    query GetAntiRollBarElementSpecById($id: MongoID!) {
  specification(_id: $id) {
    ...AntiRollBarVars
  }
}
    ${AntiRollBarVarsFragmentDoc}`;

export const useGetAntiRollBarElementSpecByIdQuery = <
      TData = GetAntiRollBarElementSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAntiRollBarElementSpecByIdQueryVariables,
      options?: UseQueryOptions<GetAntiRollBarElementSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetAntiRollBarElementSpecByIdQuery, TError, TData>(
      ['GetAntiRollBarElementSpecById', variables],
      fetcher<GetAntiRollBarElementSpecByIdQuery, GetAntiRollBarElementSpecByIdQueryVariables>(GetAntiRollBarElementSpecByIdDocument, variables),
      options
    )};

export const GetAllDifferentialElementSpecsDocument = `
    query GetAllDifferentialElementSpecs {
  specifications(perPage: 1000, filter: {type: DIFFERENTIAL}) {
    items {
      ...DifferentialSpecVars
    }
  }
}
    ${DifferentialSpecVarsFragmentDoc}`;

export const useGetAllDifferentialElementSpecsQuery = <
      TData = GetAllDifferentialElementSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllDifferentialElementSpecsQueryVariables,
      options?: UseQueryOptions<GetAllDifferentialElementSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllDifferentialElementSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllDifferentialElementSpecs'] : ['GetAllDifferentialElementSpecs', variables],
      fetcher<GetAllDifferentialElementSpecsQuery, GetAllDifferentialElementSpecsQueryVariables>(GetAllDifferentialElementSpecsDocument, variables),
      options
    )};

export const GetAllDifferentialElementSpecsByChassisSpecDocument = `
    query GetAllDifferentialElementSpecsByChassisSpec($chassisSpecID: MongoID!) {
  specifications(
    perPage: 1000
    filter: {type: DIFFERENTIAL, chassisSpecID: $chassisSpecID}
  ) {
    items {
      ...DifferentialSpecVars
    }
  }
}
    ${DifferentialSpecVarsFragmentDoc}`;

export const useGetAllDifferentialElementSpecsByChassisSpecQuery = <
      TData = GetAllDifferentialElementSpecsByChassisSpecQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAllDifferentialElementSpecsByChassisSpecQueryVariables,
      options?: UseQueryOptions<GetAllDifferentialElementSpecsByChassisSpecQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllDifferentialElementSpecsByChassisSpecQuery, TError, TData>(
      ['GetAllDifferentialElementSpecsByChassisSpec', variables],
      fetcher<GetAllDifferentialElementSpecsByChassisSpecQuery, GetAllDifferentialElementSpecsByChassisSpecQueryVariables>(GetAllDifferentialElementSpecsByChassisSpecDocument, variables),
      options
    )};

export const GetDifferentialElementSpecByIdDocument = `
    query GetDifferentialElementSpecById($id: MongoID!) {
  specification(_id: $id) {
    ...DifferentialSpecVars
  }
}
    ${DifferentialSpecVarsFragmentDoc}`;

export const useGetDifferentialElementSpecByIdQuery = <
      TData = GetDifferentialElementSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetDifferentialElementSpecByIdQueryVariables,
      options?: UseQueryOptions<GetDifferentialElementSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetDifferentialElementSpecByIdQuery, TError, TData>(
      ['GetDifferentialElementSpecById', variables],
      fetcher<GetDifferentialElementSpecByIdQuery, GetDifferentialElementSpecByIdQueryVariables>(GetDifferentialElementSpecByIdDocument, variables),
      options
    )};

export const GetAllGearElementSpecsDocument = `
    query GetAllGearElementSpecs {
  specifications(perPage: 1000, filter: {type: GEAR}) {
    items {
      ...GearSpecVars
    }
  }
}
    ${GearSpecVarsFragmentDoc}`;

export const useGetAllGearElementSpecsQuery = <
      TData = GetAllGearElementSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllGearElementSpecsQueryVariables,
      options?: UseQueryOptions<GetAllGearElementSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllGearElementSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllGearElementSpecs'] : ['GetAllGearElementSpecs', variables],
      fetcher<GetAllGearElementSpecsQuery, GetAllGearElementSpecsQueryVariables>(GetAllGearElementSpecsDocument, variables),
      options
    )};

export const GetAllGearElementSpecsByChassisSpecDocument = `
    query GetAllGearElementSpecsByChassisSpec($chassisSpecID: MongoID!) {
  specifications(
    perPage: 1000
    filter: {type: GEAR, chassisSpecID: $chassisSpecID}
  ) {
    items {
      ...GearSpecVars
    }
  }
}
    ${GearSpecVarsFragmentDoc}`;

export const useGetAllGearElementSpecsByChassisSpecQuery = <
      TData = GetAllGearElementSpecsByChassisSpecQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetAllGearElementSpecsByChassisSpecQueryVariables,
      options?: UseQueryOptions<GetAllGearElementSpecsByChassisSpecQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllGearElementSpecsByChassisSpecQuery, TError, TData>(
      ['GetAllGearElementSpecsByChassisSpec', variables],
      fetcher<GetAllGearElementSpecsByChassisSpecQuery, GetAllGearElementSpecsByChassisSpecQueryVariables>(GetAllGearElementSpecsByChassisSpecDocument, variables),
      options
    )};

export const GetGearElementSpecByIdDocument = `
    query GetGearElementSpecById($id: MongoID!) {
  specification(_id: $id) {
    ...GearSpecVars
  }
}
    ${GearSpecVarsFragmentDoc}`;

export const useGetGearElementSpecByIdQuery = <
      TData = GetGearElementSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetGearElementSpecByIdQueryVariables,
      options?: UseQueryOptions<GetGearElementSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetGearElementSpecByIdQuery, TError, TData>(
      ['GetGearElementSpecById', variables],
      fetcher<GetGearElementSpecByIdQuery, GetGearElementSpecByIdQueryVariables>(GetGearElementSpecByIdDocument, variables),
      options
    )};

export const GetAllKinematicsExternalSpecsDocument = `
    query GetAllKinematicsExternalSpecs {
  specifications(perPage: 1000, filter: {type: KINEMATICS_EXTERNAL}) {
    items {
      ...ExternalKinematicSpecVars
    }
  }
}
    ${ExternalKinematicSpecVarsFragmentDoc}`;

export const useGetAllKinematicsExternalSpecsQuery = <
      TData = GetAllKinematicsExternalSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllKinematicsExternalSpecsQueryVariables,
      options?: UseQueryOptions<GetAllKinematicsExternalSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllKinematicsExternalSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllKinematicsExternalSpecs'] : ['GetAllKinematicsExternalSpecs', variables],
      fetcher<GetAllKinematicsExternalSpecsQuery, GetAllKinematicsExternalSpecsQueryVariables>(GetAllKinematicsExternalSpecsDocument, variables),
      options
    )};

export const GetKinematicsExternalSpecByIdDocument = `
    query GetKinematicsExternalSpecById($id: MongoID!) {
  specification(_id: $id) {
    ...ExternalKinematicSpecVars
  }
}
    ${ExternalKinematicSpecVarsFragmentDoc}`;

export const useGetKinematicsExternalSpecByIdQuery = <
      TData = GetKinematicsExternalSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetKinematicsExternalSpecByIdQueryVariables,
      options?: UseQueryOptions<GetKinematicsExternalSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetKinematicsExternalSpecByIdQuery, TError, TData>(
      ['GetKinematicsExternalSpecById', variables],
      fetcher<GetKinematicsExternalSpecByIdQuery, GetKinematicsExternalSpecByIdQueryVariables>(GetKinematicsExternalSpecByIdDocument, variables),
      options
    )};

export const GetAllKinematicsInternalSpecsDocument = `
    query GetAllKinematicsInternalSpecs {
  specifications(perPage: 1000, filter: {type: KINEMATICS_INTERNAL}) {
    items {
      ...InternalKinematicSpecVars
    }
  }
}
    ${InternalKinematicSpecVarsFragmentDoc}`;

export const useGetAllKinematicsInternalSpecsQuery = <
      TData = GetAllKinematicsInternalSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllKinematicsInternalSpecsQueryVariables,
      options?: UseQueryOptions<GetAllKinematicsInternalSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllKinematicsInternalSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllKinematicsInternalSpecs'] : ['GetAllKinematicsInternalSpecs', variables],
      fetcher<GetAllKinematicsInternalSpecsQuery, GetAllKinematicsInternalSpecsQueryVariables>(GetAllKinematicsInternalSpecsDocument, variables),
      options
    )};

export const GetKinematicsInternalSpecByIdDocument = `
    query GetKinematicsInternalSpecById($id: MongoID!) {
  specification(_id: $id) {
    ...InternalKinematicSpecVars
  }
}
    ${InternalKinematicSpecVarsFragmentDoc}`;

export const useGetKinematicsInternalSpecByIdQuery = <
      TData = GetKinematicsInternalSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetKinematicsInternalSpecByIdQueryVariables,
      options?: UseQueryOptions<GetKinematicsInternalSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetKinematicsInternalSpecByIdQuery, TError, TData>(
      ['GetKinematicsInternalSpecById', variables],
      fetcher<GetKinematicsInternalSpecByIdQuery, GetKinematicsInternalSpecByIdQueryVariables>(GetKinematicsInternalSpecByIdDocument, variables),
      options
    )};

export const GetAllCustomSpecsDocument = `
    query GetAllCustomSpecs {
  specifications(perPage: 1000, filter: {type: CUSTOM}) {
    items {
      ...CustomSpecVars
    }
  }
}
    ${CustomSpecVarsFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${MassPropertiesVarsFragmentDoc}`;

export const useGetAllCustomSpecsQuery = <
      TData = GetAllCustomSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllCustomSpecsQueryVariables,
      options?: UseQueryOptions<GetAllCustomSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllCustomSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllCustomSpecs'] : ['GetAllCustomSpecs', variables],
      fetcher<GetAllCustomSpecsQuery, GetAllCustomSpecsQueryVariables>(GetAllCustomSpecsDocument, variables),
      options
    )};

export const GetCustomSpecByIdDocument = `
    query GetCustomSpecById($id: MongoID!) {
  specification(_id: $id) {
    ...CustomSpecVars
  }
}
    ${CustomSpecVarsFragmentDoc}
${AdjustableAccelerationPropertyVarsFragmentDoc}
${AdjustableAnglePropertyVarsFragmentDoc}
${AdjustableAngularCompliancePropertyVarsFragmentDoc}
${AdjustableAngularTorqueCompliancePropertyVarsFragmentDoc}
${AdjustableBooleanPropertyVarsFragmentDoc}
${AdjustableCompliancePropertyVarsFragmentDoc}
${AdjustableForcePropertyVarsFragmentDoc}
${AdjustableInertiaPropertyVarsFragmentDoc}
${AdjustableLengthPropertyVarsFragmentDoc}
${AdjustableLocationPropertyVarsFragmentDoc}
${AdjustableMassPropertyVarsFragmentDoc}
${AdjustableNumberPropertyVarsFragmentDoc}
${AdjustableOrientationPropertyVarsFragmentDoc}
${AdjustablePowerPropertyVarsFragmentDoc}
${AdjustablePressurePropertyVarsFragmentDoc}
${AdjustableRatioPropertyVarsFragmentDoc}
${AdjustableSpringRatePropertyVarsFragmentDoc}
${AdjustableSteeringRackRatioPropertyVarsFragmentDoc}
${AdjustableStringPropertyVarsFragmentDoc}
${AdjustableTemperaturePropertyVarsFragmentDoc}
${AdjustableTorquePropertyVarsFragmentDoc}
${AdjustableTorsionRatePropertyVarsFragmentDoc}
${AdjustableVolumePropertyVarsFragmentDoc}
${MassPropertiesVarsFragmentDoc}`;

export const useGetCustomSpecByIdQuery = <
      TData = GetCustomSpecByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetCustomSpecByIdQueryVariables,
      options?: UseQueryOptions<GetCustomSpecByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetCustomSpecByIdQuery, TError, TData>(
      ['GetCustomSpecById', variables],
      fetcher<GetCustomSpecByIdQuery, GetCustomSpecByIdQueryVariables>(GetCustomSpecByIdDocument, variables),
      options
    )};

export const GetChassisSpecMeasurementUnitsDocument = `
    query GetChassisSpecMeasurementUnits($id: MongoID!) {
  specification(_id: $id) {
    ... on ChassisSpec {
      measurements {
        ...ChassisMeasurementVars
      }
    }
  }
}
    ${ChassisMeasurementVarsFragmentDoc}`;

export const useGetChassisSpecMeasurementUnitsQuery = <
      TData = GetChassisSpecMeasurementUnitsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetChassisSpecMeasurementUnitsQueryVariables,
      options?: UseQueryOptions<GetChassisSpecMeasurementUnitsQuery, TError, TData>
    ) => {
    
    return useQuery<GetChassisSpecMeasurementUnitsQuery, TError, TData>(
      ['GetChassisSpecMeasurementUnits', variables],
      fetcher<GetChassisSpecMeasurementUnitsQuery, GetChassisSpecMeasurementUnitsQueryVariables>(GetChassisSpecMeasurementUnitsDocument, variables),
      options
    )};

export const GetTeamInfoDocument = `
    query GetTeamInfo($id: MongoID!) {
  team(_id: $id) {
    _id
    name
    shortName
  }
}
    `;

export const useGetTeamInfoQuery = <
      TData = GetTeamInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTeamInfoQueryVariables,
      options?: UseQueryOptions<GetTeamInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetTeamInfoQuery, TError, TData>(
      ['GetTeamInfo', variables],
      fetcher<GetTeamInfoQuery, GetTeamInfoQueryVariables>(GetTeamInfoDocument, variables),
      options
    )};

export const GetTeamListDocument = `
    query GetTeamList {
  teams(perPage: 1000, sort: NAME_ASC) {
    items {
      _id
      name
      shortName
    }
  }
}
    `;

export const useGetTeamListQuery = <
      TData = GetTeamListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTeamListQueryVariables,
      options?: UseQueryOptions<GetTeamListQuery, TError, TData>
    ) => {
    
    return useQuery<GetTeamListQuery, TError, TData>(
      variables === undefined ? ['GetTeamList'] : ['GetTeamList', variables],
      fetcher<GetTeamListQuery, GetTeamListQueryVariables>(GetTeamListDocument, variables),
      options
    )};

export const GetTimeSheetEntriesForTimePeriodDocument = `
    query GetTimeSheetEntriesForTimePeriod($tStart: Date, $tEnd: Date, $personID: MongoID) {
  timeSheetEntries(
    perPage: 200
    filter: {AND: [{personID: $personID}, {_operators: {tStart: {gte: $tStart}}}, {_operators: {tStart: {lte: $tEnd}}}]}
  ) {
    items {
      ...TimeSheetEntryForTimePeriod
    }
  }
}
    ${TimeSheetEntryForTimePeriodFragmentDoc}`;

export const useGetTimeSheetEntriesForTimePeriodQuery = <
      TData = GetTimeSheetEntriesForTimePeriodQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTimeSheetEntriesForTimePeriodQueryVariables,
      options?: UseQueryOptions<GetTimeSheetEntriesForTimePeriodQuery, TError, TData>
    ) => {
    
    return useQuery<GetTimeSheetEntriesForTimePeriodQuery, TError, TData>(
      variables === undefined ? ['GetTimeSheetEntriesForTimePeriod'] : ['GetTimeSheetEntriesForTimePeriod', variables],
      fetcher<GetTimeSheetEntriesForTimePeriodQuery, GetTimeSheetEntriesForTimePeriodQueryVariables>(GetTimeSheetEntriesForTimePeriodDocument, variables),
      options
    )};

export const GetAllTimeSheetEntriesForTimePeriodDocument = `
    query GetAllTimeSheetEntriesForTimePeriod($tStart: Date, $tEnd: Date) {
  timeSheetEntries(
    perPage: 10000
    filter: {AND: [{_operators: {tStart: {gte: $tStart}}}, {_operators: {tStart: {lte: $tEnd}}}]}
  ) {
    items {
      _id
      tStart
      tEnd
      projectID
      approvedAt
    }
  }
}
    `;

export const useGetAllTimeSheetEntriesForTimePeriodQuery = <
      TData = GetAllTimeSheetEntriesForTimePeriodQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllTimeSheetEntriesForTimePeriodQueryVariables,
      options?: UseQueryOptions<GetAllTimeSheetEntriesForTimePeriodQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllTimeSheetEntriesForTimePeriodQuery, TError, TData>(
      variables === undefined ? ['GetAllTimeSheetEntriesForTimePeriod'] : ['GetAllTimeSheetEntriesForTimePeriod', variables],
      fetcher<GetAllTimeSheetEntriesForTimePeriodQuery, GetAllTimeSheetEntriesForTimePeriodQueryVariables>(GetAllTimeSheetEntriesForTimePeriodDocument, variables),
      options
    )};

export const DoTimingServiceConfigSearchDocument = `
    query DoTimingServiceConfigSearch($search: RegExpAsString) {
  timingServiceConfigs(
    filter: {_operators: {name: {regex: $search}}}
    sort: UPDATEDAT_DESC
  ) {
    items {
      _id
      name
      eventID
      followedCarNumbers
      timingURL
      timingPort
      timingRaceSeries
      fallbackTimedSectorsCount
      strictSessionNameMatching
      fallbackScheduleBasedSessionMatching
      logLevel
      writeData
      logStream
      updatedAt
      createdAt
    }
  }
}
    `;

export const useDoTimingServiceConfigSearchQuery = <
      TData = DoTimingServiceConfigSearchQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: DoTimingServiceConfigSearchQueryVariables,
      options?: UseQueryOptions<DoTimingServiceConfigSearchQuery, TError, TData>
    ) => {
    
    return useQuery<DoTimingServiceConfigSearchQuery, TError, TData>(
      variables === undefined ? ['DoTimingServiceConfigSearch'] : ['DoTimingServiceConfigSearch', variables],
      fetcher<DoTimingServiceConfigSearchQuery, DoTimingServiceConfigSearchQueryVariables>(DoTimingServiceConfigSearchDocument, variables),
      options
    )};

export const GetBasicTrackListDocument = `
    query GetBasicTrackList {
  tracks(perPage: 20000) {
    items {
      _id
      ...TrackVars
    }
  }
}
    ${TrackVarsFragmentDoc}`;

export const useGetBasicTrackListQuery = <
      TData = GetBasicTrackListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBasicTrackListQueryVariables,
      options?: UseQueryOptions<GetBasicTrackListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicTrackListQuery, TError, TData>(
      variables === undefined ? ['GetBasicTrackList'] : ['GetBasicTrackList', variables],
      fetcher<GetBasicTrackListQuery, GetBasicTrackListQueryVariables>(GetBasicTrackListDocument, variables),
      options
    )};

export const GetTrackNameDocument = `
    query GetTrackName($id: MongoID!) {
  season(_id: $id) {
    _id
    name
  }
}
    `;

export const useGetTrackNameQuery = <
      TData = GetTrackNameQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackNameQueryVariables,
      options?: UseQueryOptions<GetTrackNameQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackNameQuery, TError, TData>(
      ['GetTrackName', variables],
      fetcher<GetTrackNameQuery, GetTrackNameQueryVariables>(GetTrackNameDocument, variables),
      options
    )};

export const DoTrackSearchDocument = `
    query DoTrackSearch($search: RegExpAsString) {
  tracks(
    filter: {OR: [{_operators: {acronym: {regex: $search}}}, {_operators: {name: {regex: $search}}}]}
  ) {
    items {
      _id
      name
    }
  }
}
    `;

export const useDoTrackSearchQuery = <
      TData = DoTrackSearchQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: DoTrackSearchQueryVariables,
      options?: UseQueryOptions<DoTrackSearchQuery, TError, TData>
    ) => {
    
    return useQuery<DoTrackSearchQuery, TError, TData>(
      variables === undefined ? ['DoTrackSearch'] : ['DoTrackSearch', variables],
      fetcher<DoTrackSearchQuery, DoTrackSearchQueryVariables>(DoTrackSearchDocument, variables),
      options
    )};

export const GetTrackInfoDocument = `
    query GetTrackInfo($id: MongoID!) {
  track(_id: $id) {
    _id
    ...TrackVars
  }
}
    ${TrackVarsFragmentDoc}`;

export const useGetTrackInfoQuery = <
      TData = GetTrackInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackInfoQueryVariables,
      options?: UseQueryOptions<GetTrackInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackInfoQuery, TError, TData>(
      ['GetTrackInfo', variables],
      fetcher<GetTrackInfoQuery, GetTrackInfoQueryVariables>(GetTrackInfoDocument, variables),
      options
    )};

export const GetTrackLayoutListDocument = `
    query GetTrackLayoutList {
  trackLayouts(sort: _ID_DESC) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetTrackLayoutListQuery = <
      TData = GetTrackLayoutListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTrackLayoutListQueryVariables,
      options?: UseQueryOptions<GetTrackLayoutListQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackLayoutListQuery, TError, TData>(
      variables === undefined ? ['GetTrackLayoutList'] : ['GetTrackLayoutList', variables],
      fetcher<GetTrackLayoutListQuery, GetTrackLayoutListQueryVariables>(GetTrackLayoutListDocument, variables),
      options
    )};

export const GetTrackLayoutNamesWithIDsDocument = `
    query GetTrackLayoutNamesWithIDs($id: [MongoID]) {
  trackLayouts(filter: {_operators: {_id: {in: $id}}}) {
    items {
      _id
      name
      fuelRequired {
        outLap
        inLap
        outInLap
        pushLap
        coolLap
        slowLap
        prepLap
        targetLap
        unfinishedLap
        attackLap
        qualiLap
        toGridLap
        toPitsLap
        fullCourseYellowLap
        safetyCarLap
      }
    }
  }
}
    `;

export const useGetTrackLayoutNamesWithIDsQuery = <
      TData = GetTrackLayoutNamesWithIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTrackLayoutNamesWithIDsQueryVariables,
      options?: UseQueryOptions<GetTrackLayoutNamesWithIDsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackLayoutNamesWithIDsQuery, TError, TData>(
      variables === undefined ? ['GetTrackLayoutNamesWithIDs'] : ['GetTrackLayoutNamesWithIDs', variables],
      fetcher<GetTrackLayoutNamesWithIDsQuery, GetTrackLayoutNamesWithIDsQueryVariables>(GetTrackLayoutNamesWithIDsDocument, variables),
      options
    )};

export const GetTrackLayoutInfoDocument = `
    query GetTrackLayoutInfo($id: MongoID!) {
  trackLayout(_id: $id) {
    _id
    ...TrackLayoutVars
  }
}
    ${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetTrackLayoutInfoQuery = <
      TData = GetTrackLayoutInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackLayoutInfoQueryVariables,
      options?: UseQueryOptions<GetTrackLayoutInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackLayoutInfoQuery, TError, TData>(
      ['GetTrackLayoutInfo', variables],
      fetcher<GetTrackLayoutInfoQuery, GetTrackLayoutInfoQueryVariables>(GetTrackLayoutInfoDocument, variables),
      options
    )};

export const GetTrackLayoutWithMapDocument = `
    query GetTrackLayoutWithMap($id: MongoID!) {
  trackLayout(_id: $id) {
    _id
    ...TrackLayoutVars
    mapTrackXyCsv
    mapTrackLatLonCsv
  }
}
    ${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;

export const useGetTrackLayoutWithMapQuery = <
      TData = GetTrackLayoutWithMapQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTrackLayoutWithMapQueryVariables,
      options?: UseQueryOptions<GetTrackLayoutWithMapQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackLayoutWithMapQuery, TError, TData>(
      ['GetTrackLayoutWithMap', variables],
      fetcher<GetTrackLayoutWithMapQuery, GetTrackLayoutWithMapQueryVariables>(GetTrackLayoutWithMapDocument, variables),
      options
    )};

export const GetTrackLayoutLapLengthsDocument = `
    query GetTrackLayoutLapLengths {
  trackLayouts(perPage: 1000) {
    items {
      _id
      lapLengthOfficial
    }
  }
}
    `;

export const useGetTrackLayoutLapLengthsQuery = <
      TData = GetTrackLayoutLapLengthsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTrackLayoutLapLengthsQueryVariables,
      options?: UseQueryOptions<GetTrackLayoutLapLengthsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTrackLayoutLapLengthsQuery, TError, TData>(
      variables === undefined ? ['GetTrackLayoutLapLengths'] : ['GetTrackLayoutLapLengths', variables],
      fetcher<GetTrackLayoutLapLengthsQuery, GetTrackLayoutLapLengthsQueryVariables>(GetTrackLayoutLapLengthsDocument, variables),
      options
    )};

export const GetTyreSetInfosByIdsDocument = `
    query GetTyreSetInfosByIds($ids: [MongoID]) {
  tyreSets(perPage: 200, filter: {_operators: {_id: {in: $ids}}}) {
    items {
      _id
      ...tyreSetVars
    }
  }
}
    ${TyreSetVarsFragmentDoc}`;

export const useGetTyreSetInfosByIdsQuery = <
      TData = GetTyreSetInfosByIdsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTyreSetInfosByIdsQueryVariables,
      options?: UseQueryOptions<GetTyreSetInfosByIdsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreSetInfosByIdsQuery, TError, TData>(
      variables === undefined ? ['GetTyreSetInfosByIds'] : ['GetTyreSetInfosByIds', variables],
      fetcher<GetTyreSetInfosByIdsQuery, GetTyreSetInfosByIdsQueryVariables>(GetTyreSetInfosByIdsDocument, variables),
      options
    )};

export const GetTyreSetNameByIdsDocument = `
    query GetTyreSetNameByIds($ids: [MongoID]) {
  tyreSets(perPage: 200, filter: {_operators: {_id: {in: $ids}}}) {
    items {
      _id
      name
    }
  }
}
    `;

export const useGetTyreSetNameByIdsQuery = <
      TData = GetTyreSetNameByIdsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTyreSetNameByIdsQueryVariables,
      options?: UseQueryOptions<GetTyreSetNameByIdsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreSetNameByIdsQuery, TError, TData>(
      variables === undefined ? ['GetTyreSetNameByIds'] : ['GetTyreSetNameByIds', variables],
      fetcher<GetTyreSetNameByIdsQuery, GetTyreSetNameByIdsQueryVariables>(GetTyreSetNameByIdsDocument, variables),
      options
    )};

export const GetBasicTyreListDocument = `
    query GetBasicTyreList {
  tyres(perPage: 1000, sort: NAME_ASC) {
    items {
      _id
      ...TyreVars
    }
  }
}
    ${TyreVarsFragmentDoc}`;

export const useGetBasicTyreListQuery = <
      TData = GetBasicTyreListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetBasicTyreListQueryVariables,
      options?: UseQueryOptions<GetBasicTyreListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicTyreListQuery, TError, TData>(
      variables === undefined ? ['GetBasicTyreList'] : ['GetBasicTyreList', variables],
      fetcher<GetBasicTyreListQuery, GetBasicTyreListQueryVariables>(GetBasicTyreListDocument, variables),
      options
    )};

export const GetTyreNameByIdDocument = `
    query GetTyreNameById($id: [MongoID]) {
  tyres(perPage: 200, filter: {_operators: {_id: {in: $id}}}, sort: NAME_ASC) {
    items {
      _id
      name
      type
      axle
    }
  }
}
    `;

export const useGetTyreNameByIdQuery = <
      TData = GetTyreNameByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTyreNameByIdQueryVariables,
      options?: UseQueryOptions<GetTyreNameByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreNameByIdQuery, TError, TData>(
      variables === undefined ? ['GetTyreNameById'] : ['GetTyreNameById', variables],
      fetcher<GetTyreNameByIdQuery, GetTyreNameByIdQueryVariables>(GetTyreNameByIdDocument, variables),
      options
    )};

export const GetTyreInfoDocument = `
    query GetTyreInfo($id: MongoID!) {
  tyre(_id: $id) {
    _id
    ...AllTyreScalarVars
    heatingSchedule {
      _id
      duration
      temperature
    }
  }
}
    ${AllTyreScalarVarsFragmentDoc}`;

export const useGetTyreInfoQuery = <
      TData = GetTyreInfoQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetTyreInfoQueryVariables,
      options?: UseQueryOptions<GetTyreInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreInfoQuery, TError, TData>(
      ['GetTyreInfo', variables],
      fetcher<GetTyreInfoQuery, GetTyreInfoQueryVariables>(GetTyreInfoDocument, variables),
      options
    )};

export const GetRunsheetsForTyreIdDocument = `
    query GetRunsheetsForTyreID($tyre: MongoID!) {
  runSheets(
    perPage: 1000000000
    filter: {OR: [{tyreFL: {tyreID: $tyre}}, {tyreFR: {tyreID: $tyre}}, {tyreRL: {tyreID: $tyre}}, {tyreRR: {tyreID: $tyre}}]}
  ) {
    items {
      _id
      ...RunSheetForTyreVars
    }
  }
}
    ${RunSheetForTyreVarsFragmentDoc}
${RunTyreVarsFragmentDoc}`;

export const useGetRunsheetsForTyreIdQuery = <
      TData = GetRunsheetsForTyreIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunsheetsForTyreIdQueryVariables,
      options?: UseQueryOptions<GetRunsheetsForTyreIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunsheetsForTyreIdQuery, TError, TData>(
      ['GetRunsheetsForTyreID', variables],
      fetcher<GetRunsheetsForTyreIdQuery, GetRunsheetsForTyreIdQueryVariables>(GetRunsheetsForTyreIdDocument, variables),
      options
    )};

export const GetRunsheetsForTyreIdAndSessionsDocument = `
    query GetRunsheetsForTyreIDAndSessions($tyreID: MongoID!, $sessionIDs: [MongoID]) {
  runSheets(
    perPage: 1000000000
    filter: {OR: [{tyreFL: {tyreID: $tyreID}}, {tyreFR: {tyreID: $tyreID}}, {tyreRL: {tyreID: $tyreID}}, {tyreRR: {tyreID: $tyreID}}], _operators: {sessionID: {in: $sessionIDs}}}
  ) {
    items {
      _id
      ...RunSheetForTyreMileageExportVars
    }
  }
}
    ${RunSheetForTyreMileageExportVarsFragmentDoc}`;

export const useGetRunsheetsForTyreIdAndSessionsQuery = <
      TData = GetRunsheetsForTyreIdAndSessionsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunsheetsForTyreIdAndSessionsQueryVariables,
      options?: UseQueryOptions<GetRunsheetsForTyreIdAndSessionsQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunsheetsForTyreIdAndSessionsQuery, TError, TData>(
      ['GetRunsheetsForTyreIDAndSessions', variables],
      fetcher<GetRunsheetsForTyreIdAndSessionsQuery, GetRunsheetsForTyreIdAndSessionsQueryVariables>(GetRunsheetsForTyreIdAndSessionsDocument, variables),
      options
    )};

export const GetRunsheetsForTyreSetIdAndSessionsDocument = `
    query GetRunsheetsForTyreSetIDAndSessions($tyreSetID: MongoID!, $sessionIDs: [MongoID]) {
  runSheets(
    perPage: 1000000000
    filter: {tyreSetID: $tyreSetID, _operators: {sessionID: {in: $sessionIDs}}}
  ) {
    items {
      _id
      ...RunSheetForTyreMileageExportVars
    }
  }
}
    ${RunSheetForTyreMileageExportVarsFragmentDoc}`;

export const useGetRunsheetsForTyreSetIdAndSessionsQuery = <
      TData = GetRunsheetsForTyreSetIdAndSessionsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetRunsheetsForTyreSetIdAndSessionsQueryVariables,
      options?: UseQueryOptions<GetRunsheetsForTyreSetIdAndSessionsQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunsheetsForTyreSetIdAndSessionsQuery, TError, TData>(
      ['GetRunsheetsForTyreSetIDAndSessions', variables],
      fetcher<GetRunsheetsForTyreSetIdAndSessionsQuery, GetRunsheetsForTyreSetIdAndSessionsQueryVariables>(GetRunsheetsForTyreSetIdAndSessionsDocument, variables),
      options
    )};

export const GetTyreInfosByIdsDocument = `
    query GetTyreInfosByIds($ids: [MongoID]) {
  tyres(perPage: 200, filter: {_operators: {_id: {in: $ids}}}) {
    items {
      _id
      ...TyreVars
    }
  }
}
    ${TyreVarsFragmentDoc}`;

export const useGetTyreInfosByIdsQuery = <
      TData = GetTyreInfosByIdsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetTyreInfosByIdsQueryVariables,
      options?: UseQueryOptions<GetTyreInfosByIdsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTyreInfosByIdsQuery, TError, TData>(
      variables === undefined ? ['GetTyreInfosByIds'] : ['GetTyreInfosByIds', variables],
      fetcher<GetTyreInfosByIdsQuery, GetTyreInfosByIdsQueryVariables>(GetTyreInfosByIdsDocument, variables),
      options
    )};

export const GetRunSheetInfosBySessionIDsDocument = `
    query GetRunSheetInfosBySessionIDs($ids: [MongoID]) {
  runSheets(
    perPage: 1000000000
    filter: {OR: [{_operators: {sessionID: {in: $ids}}}]}
  ) {
    items {
      _id
      mileage
      session {
        _id
        shortName
        event {
          _id
          name
        }
      }
      tyreSetID
      tyreFL {
        tyreID
      }
      tyreRL {
        tyreID
      }
      tyreRR {
        tyreID
      }
      tyreFR {
        tyreID
      }
    }
  }
}
    `;

export const useGetRunSheetInfosBySessionIDsQuery = <
      TData = GetRunSheetInfosBySessionIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetRunSheetInfosBySessionIDsQueryVariables,
      options?: UseQueryOptions<GetRunSheetInfosBySessionIDsQuery, TError, TData>
    ) => {
    
    return useQuery<GetRunSheetInfosBySessionIDsQuery, TError, TData>(
      variables === undefined ? ['GetRunSheetInfosBySessionIDs'] : ['GetRunSheetInfosBySessionIDs', variables],
      fetcher<GetRunSheetInfosBySessionIDsQuery, GetRunSheetInfosBySessionIDsQueryVariables>(GetRunSheetInfosBySessionIDsDocument, variables),
      options
    )};

export const GetSeasonTyresDocument = `
    query GetSeasonTyres($id: MongoID!) {
  season(_id: $id) {
    _id
    name
    events {
      _id
      name
      sessions {
        _id
        name
      }
    }
    tyres {
      _id
      ...TyreVars
    }
  }
}
    ${TyreVarsFragmentDoc}`;

export const useGetSeasonTyresQuery = <
      TData = GetSeasonTyresQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSeasonTyresQueryVariables,
      options?: UseQueryOptions<GetSeasonTyresQuery, TError, TData>
    ) => {
    
    return useQuery<GetSeasonTyresQuery, TError, TData>(
      ['GetSeasonTyres', variables],
      fetcher<GetSeasonTyresQuery, GetSeasonTyresQueryVariables>(GetSeasonTyresDocument, variables),
      options
    )};

export const FindTyreTypeByIDsDocument = `
    query FindTyreTypeByIDs($ids: [MongoID]) {
  tyres(filter: {_operators: {_id: {in: $ids}}}) {
    items {
      _id
      type
    }
  }
}
    `;

export const useFindTyreTypeByIDsQuery = <
      TData = FindTyreTypeByIDsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: FindTyreTypeByIDsQueryVariables,
      options?: UseQueryOptions<FindTyreTypeByIDsQuery, TError, TData>
    ) => {
    
    return useQuery<FindTyreTypeByIDsQuery, TError, TData>(
      variables === undefined ? ['FindTyreTypeByIDs'] : ['FindTyreTypeByIDs', variables],
      fetcher<FindTyreTypeByIDsQuery, FindTyreTypeByIDsQueryVariables>(FindTyreTypeByIDsDocument, variables),
      options
    )};

export const CheckIfAllFourTyresExistDocument = `
    query CheckIfAllFourTyresExist($id: MongoID!) {
  tyreSet(_id: $id) {
    tyreFL {
      _id
    }
    tyreFR {
      _id
    }
    tyreRL {
      _id
    }
    tyreRR {
      _id
    }
  }
}
    `;

export const useCheckIfAllFourTyresExistQuery = <
      TData = CheckIfAllFourTyresExistQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: CheckIfAllFourTyresExistQueryVariables,
      options?: UseQueryOptions<CheckIfAllFourTyresExistQuery, TError, TData>
    ) => {
    
    return useQuery<CheckIfAllFourTyresExistQuery, TError, TData>(
      ['CheckIfAllFourTyresExist', variables],
      fetcher<CheckIfAllFourTyresExistQuery, CheckIfAllFourTyresExistQueryVariables>(CheckIfAllFourTyresExistDocument, variables),
      options
    )};

export const GetVersionDocument = `
    query GetVersion {
  version
}
    `;

export const useGetVersionQuery = <
      TData = GetVersionQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetVersionQueryVariables,
      options?: UseQueryOptions<GetVersionQuery, TError, TData>
    ) => {
    
    return useQuery<GetVersionQuery, TError, TData>(
      variables === undefined ? ['GetVersion'] : ['GetVersion', variables],
      fetcher<GetVersionQuery, GetVersionQueryVariables>(GetVersionDocument, variables),
      options
    )};

export const GetWeatherListDocument = `
    query GetWeatherList {
  weatherAll {
    items {
      _id
      time
      source
      eventIDs
      type
      events {
        _id
        name
        season {
          _id
          name
          raceSeries {
            _id
            name
          }
        }
      }
    }
  }
}
    `;

export const useGetWeatherListQuery = <
      TData = GetWeatherListQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetWeatherListQueryVariables,
      options?: UseQueryOptions<GetWeatherListQuery, TError, TData>
    ) => {
    
    return useQuery<GetWeatherListQuery, TError, TData>(
      variables === undefined ? ['GetWeatherList'] : ['GetWeatherList', variables],
      fetcher<GetWeatherListQuery, GetWeatherListQueryVariables>(GetWeatherListDocument, variables),
      options
    )};

export const GetWeatherDocument = `
    query GetWeather($id: MongoID!) {
  weather(_id: $id) {
    _id
    time
    source
    type
    geoLocation {
      coordinates
    }
    data {
      ...WeatherDataVars
    }
    events {
      _id
      name
      season {
        _id
        name
        raceSeries {
          _id
          name
        }
      }
    }
  }
}
    ${WeatherDataVarsFragmentDoc}`;

export const useGetWeatherQuery = <
      TData = GetWeatherQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetWeatherQueryVariables,
      options?: UseQueryOptions<GetWeatherQuery, TError, TData>
    ) => {
    
    return useQuery<GetWeatherQuery, TError, TData>(
      ['GetWeather', variables],
      fetcher<GetWeatherQuery, GetWeatherQueryVariables>(GetWeatherDocument, variables),
      options
    )};

export const GetWeatherForEventDocument = `
    query GetWeatherForEvent($eventIDs: [MongoID]) {
  weatherAll(filter: {eventIDs: $eventIDs}) {
    items {
      _id
      time
      source
      type
      eventIDs
      data {
        ...WeatherDataVars
      }
    }
  }
}
    ${WeatherDataVarsFragmentDoc}`;

export const useGetWeatherForEventQuery = <
      TData = GetWeatherForEventQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetWeatherForEventQueryVariables,
      options?: UseQueryOptions<GetWeatherForEventQuery, TError, TData>
    ) => {
    
    return useQuery<GetWeatherForEventQuery, TError, TData>(
      variables === undefined ? ['GetWeatherForEvent'] : ['GetWeatherForEvent', variables],
      fetcher<GetWeatherForEventQuery, GetWeatherForEventQueryVariables>(GetWeatherForEventDocument, variables),
      options
    )};

export const GetSpecificationBaseForReadingLocationDocument = `
    query GetSpecificationBaseForReadingLocation($id: MongoID!) {
  specificationBase(_id: $id) {
    _id
    antiRollBarDisplayLocation
    readingsAllowable
    readingsRequired
  }
}
    `;

export const useGetSpecificationBaseForReadingLocationQuery = <
      TData = GetSpecificationBaseForReadingLocationQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSpecificationBaseForReadingLocationQueryVariables,
      options?: UseQueryOptions<GetSpecificationBaseForReadingLocationQuery, TError, TData>
    ) => {
    
    return useQuery<GetSpecificationBaseForReadingLocationQuery, TError, TData>(
      ['GetSpecificationBaseForReadingLocation', variables],
      fetcher<GetSpecificationBaseForReadingLocationQuery, GetSpecificationBaseForReadingLocationQueryVariables>(GetSpecificationBaseForReadingLocationDocument, variables),
      options
    )};

export const GetSpecificationByIdDocument = `
    query GetSpecificationById($id: MongoID!) {
  specification(_id: $id) {
    ...BasicAeroElementVars
    ...BasicAeroPackageVars
    ...BasicAntiRollBarVars
    ...BasicChassisSpecVars
    ...BasicCustomSpecVars
    ...BasicDamperSpecVars
    ...BasicDifferentialSpecVars
    ...BasicElasticSpecVars
    ...BasicGearSpecVars
    ...BasicGearBoxSpecVars
    ...BasicExternalKinematicSpecVars
    ...BasicInternalKinematicSpecVars
  }
}
    ${BasicAeroElementVarsFragmentDoc}
${BasicAeroPackageVarsFragmentDoc}
${BasicAntiRollBarVarsFragmentDoc}
${BasicChassisSpecVarsFragmentDoc}
${BasicCustomSpecVarsFragmentDoc}
${BasicDamperSpecVarsFragmentDoc}
${BasicDifferentialSpecVarsFragmentDoc}
${BasicElasticSpecVarsFragmentDoc}
${BasicGearSpecVarsFragmentDoc}
${BasicGearBoxSpecVarsFragmentDoc}
${BasicExternalKinematicSpecVarsFragmentDoc}
${BasicInternalKinematicSpecVarsFragmentDoc}`;

export const useGetSpecificationByIdQuery = <
      TData = GetSpecificationByIdQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetSpecificationByIdQueryVariables,
      options?: UseQueryOptions<GetSpecificationByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetSpecificationByIdQuery, TError, TData>(
      ['GetSpecificationById', variables],
      fetcher<GetSpecificationByIdQuery, GetSpecificationByIdQueryVariables>(GetSpecificationByIdDocument, variables),
      options
    )};

export const GetAllBasicSpecificationFieldsDocument = `
    query GetAllBasicSpecificationFields {
  specifications(perPage: 1000) {
    items {
      ...BasicAeroElementVars
      ...BasicAeroPackageVars
      ...BasicAntiRollBarVars
      ...BasicChassisSpecVars
      ...BasicCustomSpecVars
      ...BasicDamperSpecVars
      ...BasicDifferentialSpecVars
      ...BasicElasticSpecVars
      ...BasicGearSpecVars
      ...BasicGearBoxSpecVars
      ...BasicExternalKinematicSpecVars
      ...BasicInternalKinematicSpecVars
    }
  }
}
    ${BasicAeroElementVarsFragmentDoc}
${BasicAeroPackageVarsFragmentDoc}
${BasicAntiRollBarVarsFragmentDoc}
${BasicChassisSpecVarsFragmentDoc}
${BasicCustomSpecVarsFragmentDoc}
${BasicDamperSpecVarsFragmentDoc}
${BasicDifferentialSpecVarsFragmentDoc}
${BasicElasticSpecVarsFragmentDoc}
${BasicGearSpecVarsFragmentDoc}
${BasicGearBoxSpecVarsFragmentDoc}
${BasicExternalKinematicSpecVarsFragmentDoc}
${BasicInternalKinematicSpecVarsFragmentDoc}`;

export const useGetAllBasicSpecificationFieldsQuery = <
      TData = GetAllBasicSpecificationFieldsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllBasicSpecificationFieldsQueryVariables,
      options?: UseQueryOptions<GetAllBasicSpecificationFieldsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllBasicSpecificationFieldsQuery, TError, TData>(
      variables === undefined ? ['GetAllBasicSpecificationFields'] : ['GetAllBasicSpecificationFields', variables],
      fetcher<GetAllBasicSpecificationFieldsQuery, GetAllBasicSpecificationFieldsQueryVariables>(GetAllBasicSpecificationFieldsDocument, variables),
      options
    )};

export const GetAllAeroElementBasicFieldSpecsDocument = `
    query GetAllAeroElementBasicFieldSpecs {
  specifications(perPage: 1000, filter: {type: AERO_ELEMENT}) {
    items {
      ... on AeroElementSpec {
        _id
        name
      }
    }
  }
}
    `;

export const useGetAllAeroElementBasicFieldSpecsQuery = <
      TData = GetAllAeroElementBasicFieldSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllAeroElementBasicFieldSpecsQueryVariables,
      options?: UseQueryOptions<GetAllAeroElementBasicFieldSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllAeroElementBasicFieldSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllAeroElementBasicFieldSpecs'] : ['GetAllAeroElementBasicFieldSpecs', variables],
      fetcher<GetAllAeroElementBasicFieldSpecsQuery, GetAllAeroElementBasicFieldSpecsQueryVariables>(GetAllAeroElementBasicFieldSpecsDocument, variables),
      options
    )};

export const GetAllAeroPackageBasicFieldSpecsDocument = `
    query GetAllAeroPackageBasicFieldSpecs {
  specifications(perPage: 1000, filter: {type: AERO_PACKAGE}) {
    items {
      ... on AeroPackageSpec {
        _id
        name
      }
    }
  }
}
    `;

export const useGetAllAeroPackageBasicFieldSpecsQuery = <
      TData = GetAllAeroPackageBasicFieldSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllAeroPackageBasicFieldSpecsQueryVariables,
      options?: UseQueryOptions<GetAllAeroPackageBasicFieldSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllAeroPackageBasicFieldSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllAeroPackageBasicFieldSpecs'] : ['GetAllAeroPackageBasicFieldSpecs', variables],
      fetcher<GetAllAeroPackageBasicFieldSpecsQuery, GetAllAeroPackageBasicFieldSpecsQueryVariables>(GetAllAeroPackageBasicFieldSpecsDocument, variables),
      options
    )};

export const GetAllAntiRollbarBasicFieldSpecsDocument = `
    query GetAllAntiRollbarBasicFieldSpecs {
  specifications(perPage: 1000, filter: {type: ANTI_ROLL_BAR}) {
    items {
      ... on AntiRollBarSpec {
        _id
        name
      }
    }
  }
}
    `;

export const useGetAllAntiRollbarBasicFieldSpecsQuery = <
      TData = GetAllAntiRollbarBasicFieldSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllAntiRollbarBasicFieldSpecsQueryVariables,
      options?: UseQueryOptions<GetAllAntiRollbarBasicFieldSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllAntiRollbarBasicFieldSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllAntiRollbarBasicFieldSpecs'] : ['GetAllAntiRollbarBasicFieldSpecs', variables],
      fetcher<GetAllAntiRollbarBasicFieldSpecsQuery, GetAllAntiRollbarBasicFieldSpecsQueryVariables>(GetAllAntiRollbarBasicFieldSpecsDocument, variables),
      options
    )};

export const GetAllChassisBasicFieldSpecsDocument = `
    query GetAllChassisBasicFieldSpecs {
  specifications(perPage: 1000, filter: {type: CHASSIS}) {
    items {
      ... on ChassisSpec {
        _id
        name
      }
    }
  }
}
    `;

export const useGetAllChassisBasicFieldSpecsQuery = <
      TData = GetAllChassisBasicFieldSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllChassisBasicFieldSpecsQueryVariables,
      options?: UseQueryOptions<GetAllChassisBasicFieldSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllChassisBasicFieldSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllChassisBasicFieldSpecs'] : ['GetAllChassisBasicFieldSpecs', variables],
      fetcher<GetAllChassisBasicFieldSpecsQuery, GetAllChassisBasicFieldSpecsQueryVariables>(GetAllChassisBasicFieldSpecsDocument, variables),
      options
    )};

export const GetAllCustomBasicFieldSpecsDocument = `
    query GetAllCustomBasicFieldSpecs {
  specifications(perPage: 1000, filter: {type: CUSTOM}) {
    items {
      ... on CustomSpec {
        _id
        name
      }
    }
  }
}
    `;

export const useGetAllCustomBasicFieldSpecsQuery = <
      TData = GetAllCustomBasicFieldSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllCustomBasicFieldSpecsQueryVariables,
      options?: UseQueryOptions<GetAllCustomBasicFieldSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllCustomBasicFieldSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllCustomBasicFieldSpecs'] : ['GetAllCustomBasicFieldSpecs', variables],
      fetcher<GetAllCustomBasicFieldSpecsQuery, GetAllCustomBasicFieldSpecsQueryVariables>(GetAllCustomBasicFieldSpecsDocument, variables),
      options
    )};

export const GetAllDamperBasicFieldSpecsDocument = `
    query GetAllDamperBasicFieldSpecs {
  specifications(perPage: 1000, filter: {type: DAMPER}) {
    items {
      ... on DamperSpec {
        _id
        name
      }
    }
  }
}
    `;

export const useGetAllDamperBasicFieldSpecsQuery = <
      TData = GetAllDamperBasicFieldSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllDamperBasicFieldSpecsQueryVariables,
      options?: UseQueryOptions<GetAllDamperBasicFieldSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllDamperBasicFieldSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllDamperBasicFieldSpecs'] : ['GetAllDamperBasicFieldSpecs', variables],
      fetcher<GetAllDamperBasicFieldSpecsQuery, GetAllDamperBasicFieldSpecsQueryVariables>(GetAllDamperBasicFieldSpecsDocument, variables),
      options
    )};

export const GetAllDifferentialBasicFieldSpecsDocument = `
    query GetAllDifferentialBasicFieldSpecs {
  specifications(perPage: 1000, filter: {type: DIFFERENTIAL}) {
    items {
      ... on DifferentialSpec {
        _id
        name
      }
    }
  }
}
    `;

export const useGetAllDifferentialBasicFieldSpecsQuery = <
      TData = GetAllDifferentialBasicFieldSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllDifferentialBasicFieldSpecsQueryVariables,
      options?: UseQueryOptions<GetAllDifferentialBasicFieldSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllDifferentialBasicFieldSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllDifferentialBasicFieldSpecs'] : ['GetAllDifferentialBasicFieldSpecs', variables],
      fetcher<GetAllDifferentialBasicFieldSpecsQuery, GetAllDifferentialBasicFieldSpecsQueryVariables>(GetAllDifferentialBasicFieldSpecsDocument, variables),
      options
    )};

export const GetAllElasticBasicFieldSpecsDocument = `
    query GetAllElasticBasicFieldSpecs {
  specifications(perPage: 1000, filter: {type: ELASTIC}) {
    items {
      ... on ElasticSpec {
        _id
        name
      }
    }
  }
}
    `;

export const useGetAllElasticBasicFieldSpecsQuery = <
      TData = GetAllElasticBasicFieldSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllElasticBasicFieldSpecsQueryVariables,
      options?: UseQueryOptions<GetAllElasticBasicFieldSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllElasticBasicFieldSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllElasticBasicFieldSpecs'] : ['GetAllElasticBasicFieldSpecs', variables],
      fetcher<GetAllElasticBasicFieldSpecsQuery, GetAllElasticBasicFieldSpecsQueryVariables>(GetAllElasticBasicFieldSpecsDocument, variables),
      options
    )};

export const GetAllGearBasicFieldSpecsDocument = `
    query GetAllGearBasicFieldSpecs {
  specifications(perPage: 1000, filter: {type: GEAR}) {
    items {
      ... on GearSpec {
        _id
        name
      }
    }
  }
}
    `;

export const useGetAllGearBasicFieldSpecsQuery = <
      TData = GetAllGearBasicFieldSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllGearBasicFieldSpecsQueryVariables,
      options?: UseQueryOptions<GetAllGearBasicFieldSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllGearBasicFieldSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllGearBasicFieldSpecs'] : ['GetAllGearBasicFieldSpecs', variables],
      fetcher<GetAllGearBasicFieldSpecsQuery, GetAllGearBasicFieldSpecsQueryVariables>(GetAllGearBasicFieldSpecsDocument, variables),
      options
    )};

export const GetAllGearBoxBasicFieldSpecsDocument = `
    query GetAllGearBoxBasicFieldSpecs {
  specifications(perPage: 1000, filter: {type: GEAR_BOX}) {
    items {
      ... on GearBoxSpec {
        _id
        name
      }
    }
  }
}
    `;

export const useGetAllGearBoxBasicFieldSpecsQuery = <
      TData = GetAllGearBoxBasicFieldSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllGearBoxBasicFieldSpecsQueryVariables,
      options?: UseQueryOptions<GetAllGearBoxBasicFieldSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllGearBoxBasicFieldSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllGearBoxBasicFieldSpecs'] : ['GetAllGearBoxBasicFieldSpecs', variables],
      fetcher<GetAllGearBoxBasicFieldSpecsQuery, GetAllGearBoxBasicFieldSpecsQueryVariables>(GetAllGearBoxBasicFieldSpecsDocument, variables),
      options
    )};

export const GetAllKinematicsExternalBasicFieldSpecsDocument = `
    query GetAllKinematicsExternalBasicFieldSpecs {
  specifications(perPage: 1000, filter: {type: KINEMATICS_EXTERNAL}) {
    items {
      ... on KinematicsExternalSpec {
        _id
        name
      }
    }
  }
}
    `;

export const useGetAllKinematicsExternalBasicFieldSpecsQuery = <
      TData = GetAllKinematicsExternalBasicFieldSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllKinematicsExternalBasicFieldSpecsQueryVariables,
      options?: UseQueryOptions<GetAllKinematicsExternalBasicFieldSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllKinematicsExternalBasicFieldSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllKinematicsExternalBasicFieldSpecs'] : ['GetAllKinematicsExternalBasicFieldSpecs', variables],
      fetcher<GetAllKinematicsExternalBasicFieldSpecsQuery, GetAllKinematicsExternalBasicFieldSpecsQueryVariables>(GetAllKinematicsExternalBasicFieldSpecsDocument, variables),
      options
    )};

export const GetAllKinematicsInternalBasicFieldSpecsDocument = `
    query GetAllKinematicsInternalBasicFieldSpecs {
  specifications(perPage: 1000, filter: {type: KINEMATICS_INTERNAL}) {
    items {
      ... on KinematicsInternalSpec {
        _id
        name
      }
    }
  }
}
    `;

export const useGetAllKinematicsInternalBasicFieldSpecsQuery = <
      TData = GetAllKinematicsInternalBasicFieldSpecsQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables?: GetAllKinematicsInternalBasicFieldSpecsQueryVariables,
      options?: UseQueryOptions<GetAllKinematicsInternalBasicFieldSpecsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllKinematicsInternalBasicFieldSpecsQuery, TError, TData>(
      variables === undefined ? ['GetAllKinematicsInternalBasicFieldSpecs'] : ['GetAllKinematicsInternalBasicFieldSpecs', variables],
      fetcher<GetAllKinematicsInternalBasicFieldSpecsQuery, GetAllKinematicsInternalBasicFieldSpecsQueryVariables>(GetAllKinematicsInternalBasicFieldSpecsDocument, variables),
      options
    )};

export const AssemblyUpdatedDocument = `
    subscription AssemblyUpdated($id: MongoID!) {
  assemblyUpdated(assemblyID: $id) {
    ... on BaseAssembly {
      ...AnyAssemblyForAssemblyEditPageVars
    }
  }
}
    ${AnyAssemblyForAssemblyEditPageVarsFragmentDoc}`;
export const AssemblyAddedDocument = `
    subscription AssemblyAdded($id: MongoID!) {
  assemblyAdded(assemblyID: $id) {
    ... on BaseAssembly {
      ...AnyAssemblyForAssemblyEditPageVars
    }
  }
}
    ${AnyAssemblyForAssemblyEditPageVarsFragmentDoc}`;
export const AssemblyRemovedDocument = `
    subscription AssemblyRemoved($id: MongoID!) {
  assemblyRemoved(assemblyID: $id) {
    _id
  }
}
    `;
export const BestValuesAddedSessionDocument = `
    subscription BestValuesAddedSession($sessionID: MongoID!) {
  bestValuesAdded(sessionID: $sessionID) {
    _id
    ...BestValuesVars
  }
}
    ${BestValuesVarsFragmentDoc}`;
export const BestValuesAddedDriverDocument = `
    subscription BestValuesAddedDriver($sessionID: MongoID!, $contestantID: MongoID) {
  bestValuesAdded(sessionID: $sessionID, contestantID: $contestantID) {
    _id
    ...BestValuesVars
  }
}
    ${BestValuesVarsFragmentDoc}`;
export const BestValuesUpdatedDocument = `
    subscription BestValuesUpdated($bestValuesID: MongoID!) {
  bestValuesUpdated(bestValuesID: $bestValuesID) {
    _id
    ...BestValuesVars
  }
}
    ${BestValuesVarsFragmentDoc}`;
export const CarSetupUpdatedDocument = `
    subscription CarSetupUpdated($id: MongoID!) {
  carSetupUpdated(carSetupID: $id) {
    _id
    title
    teamID
    driverID
    engineerID
    chassisID
    time
    runSheetID
    setupSheetStyle
    frontLeft {
      ...CornerVars
    }
    frontRight {
      ...CornerVars
    }
    rearLeft {
      ...CornerVars
    }
    rearRight {
      ...CornerVars
    }
    front {
      ...EndVars
    }
    rear {
      ...EndVars
    }
    massTeam {
      ...MassVars
    }
    massSetup {
      ...MassVars
    }
    massRegulation {
      ...MassVars
    }
    massOutOfGarage {
      ...MassVars
    }
    systemsConfigValues
    mBallasts
    aero {
      ...AeroVars
    }
    brakeSystem {
      ...BrakeSystemVars
    }
    powertrain {
      ...PowertrainVars
    }
    info {
      ...InfoVars
    }
    steering {
      ...SteeringVars
    }
    chassis {
      _id
      systemsConfigFields
      ballastPositions
    }
  }
}
    ${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${SteeringVarsFragmentDoc}`;
export const JobAddedDocument = `
    subscription JobAdded($runSheetID: MongoID) {
  jobAdded(runSheetID: $runSheetID) {
    _id
    ...JobVars
  }
}
    ${JobVarsFragmentDoc}
${CommentVarsFragmentDoc}
${SubTaskVarsFragmentDoc}`;
export const JobUpdatedDocument = `
    subscription JobUpdated($jobID: MongoID, $runSheetID: MongoID) {
  jobUpdated(jobID: $jobID, runSheetID: $runSheetID) {
    _id
    ...JobVars
  }
}
    ${JobVarsFragmentDoc}
${CommentVarsFragmentDoc}
${SubTaskVarsFragmentDoc}`;
export const JobRemovedDocument = `
    subscription JobRemoved($runSheetID: MongoID) {
  jobRemoved(runSheetID: $runSheetID) {
    _id
    assigneeIDs
  }
}
    `;
export const RunSheetUpdatedDocument = `
    subscription RunSheetUpdated($id: MongoID!) {
  runSheetUpdated(runSheetID: $id) {
    _id
    ...RunSheetVars
  }
}
    ${RunSheetVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${LapVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}
${RunTyreVarsFragmentDoc}`;
export const RunSheetAddedDocument = `
    subscription RunSheetAdded($sessionID: MongoID, $contestantID: MongoID) {
  runSheetAdded(sessionID: $sessionID, contestantID: $contestantID) {
    _id
    ...RunSheetVars
  }
}
    ${RunSheetVarsFragmentDoc}
${EnergyUsedVarsFragmentDoc}
${RunCommentVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}
${LapVarsFragmentDoc}
${LapDataVarsFragmentDoc}
${LapNumberVarsFragmentDoc}
${RunTyreVarsFragmentDoc}`;
export const RunSheetRemovedDocument = `
    subscription RunSheetRemoved($sessionID: MongoID, $contestantID: MongoID) {
  runSheetRemoved(sessionID: $sessionID, contestantID: $contestantID) {
    _id
  }
}
    `;
export const SessionDriverRunAddedDocument = `
    subscription SessionDriverRunAdded($sessionID: MongoID, $contestantID: MongoID) {
  runSheetAdded(sessionID: $sessionID, contestantID: $contestantID) {
    _id
  }
}
    `;
export const SessionDriverRunUpdatedDocument = `
    subscription SessionDriverRunUpdated($sessionIDs: [MongoID!]!, $contestantID: MongoID!) {
  runSheetInSessionsUpdated(sessionIDs: $sessionIDs, contestantID: $contestantID) {
    _id
  }
}
    `;
export const SimResultAddedDocument = `
    subscription simResultAdded {
  simResultAdded {
    _id
    ...SimResultVars
  }
}
    ${SimResultVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;
export const SimResultUpdatedDocument = `
    subscription simResultUpdated($simResultID: MongoID!) {
  simResultUpdated(simResultID: $simResultID) {
    _id
    ...SimResultVars
  }
}
    ${SimResultVarsFragmentDoc}
${CarSetupVarsFragmentDoc}
${CalculationVarsFragmentDoc}
${CornerVarsFragmentDoc}
${DamperVarsFragmentDoc}
${EndVarsFragmentDoc}
${AllCarSetupAntiRollBarVarsFragmentDoc}
${AllAntiRollBarSpecVarsFragmentDoc}
${ElasticStuffFragmentDoc}
${AllCarSetupBumpStopVarsFragmentDoc}
${ElasticSpecVarsFragmentDoc}
${AllCarSetupDroopStopVarsFragmentDoc}
${AllCarSetupExternalBumpStopVarsFragmentDoc}
${MassVarsFragmentDoc}
${AeroVarsFragmentDoc}
${BrakeSystemVarsFragmentDoc}
${SteeringVarsFragmentDoc}
${PowertrainVarsFragmentDoc}
${InfoVarsFragmentDoc}
${SimResultDataVarsFragmentDoc}
${TrackLayoutVarsFragmentDoc}
${AllRunEnergyVarsFragmentDoc}`;
export const SimResultRemovedDocument = `
    subscription simResultRemoved {
  simResultRemoved {
    _id
  }
}
    `;
export const TimingServiceConfigAddedDocument = `
    subscription TimingServiceConfigAdded {
  timingServiceConfigAdded {
    _id
    ...TimingServiceConfigVars
  }
}
    ${TimingServiceConfigVarsFragmentDoc}`;
export const TimingServiceConfigUpdatedDocument = `
    subscription TimingServiceConfigUpdated($timingServiceConfigID: MongoID) {
  timingServiceConfigUpdated(timingServiceConfigID: $timingServiceConfigID) {
    _id
    ...TimingServiceConfigVars
  }
}
    ${TimingServiceConfigVarsFragmentDoc}`;
export const TimingServiceConfigRemovedDocument = `
    subscription TimingServiceConfigRemoved($timingServiceConfigID: MongoID) {
  timingServiceConfigRemoved(timingServiceConfigID: $timingServiceConfigID) {
    _id
  }
}
    `;
export const GetPartTrackingForSetupOverviewTableDocument = `
    query GetPartTrackingForSetupOverviewTable($partIDs: [MongoID!]!, $perPage: Int, $trackingItemIDs: [MongoID], $endDate: Date) {
  parts(filter: {_operators: {_id: {in: $partIDs}}}, perPage: $perPage) {
    items {
      _id
      tracking(trackingItemIDs: $trackingItemIDs, endDate: $endDate) {
        history {
          _id
          cumulativeValue
          date
          dateResolved
          value
          valueString
        }
        trackingItem {
          _id
          criticalCumulativeValue
          criticalValue
          cumulativeCalculation
          displayUnit
          NDecimals
          operator
          warningCumulativeValue
          warningValue
        }
        trackingItemID
      }
    }
  }
}
    `;

export const useGetPartTrackingForSetupOverviewTableQuery = <
      TData = GetPartTrackingForSetupOverviewTableQuery,
      TError = { message: string; path?: string; extensions?: { code?: string; name?: string; errors?: Array<{ path: string; message: string; value: string }> } }
    >(
      variables: GetPartTrackingForSetupOverviewTableQueryVariables,
      options?: UseQueryOptions<GetPartTrackingForSetupOverviewTableQuery, TError, TData>
    ) => {
    
    return useQuery<GetPartTrackingForSetupOverviewTableQuery, TError, TData>(
      ['GetPartTrackingForSetupOverviewTable', variables],
      fetcher<GetPartTrackingForSetupOverviewTableQuery, GetPartTrackingForSetupOverviewTableQueryVariables>(GetPartTrackingForSetupOverviewTableDocument, variables),
      options
    )};
